var Qf = Object.defineProperty;
var Af = (Bi) => {
  throw TypeError(Bi);
};
var Jf = (Bi, e, Zi) => e in Bi ? Qf(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Zi }) : Bi[e] = Zi;
var cd = (Bi, e, Zi) => Jf(Bi, typeof e != "symbol" ? e + "" : e, Zi), Gd = (Bi, e, Zi) => e.has(Bi) || Af("Cannot " + Zi);
var Hl = (Bi, e, Zi) => (Gd(Bi, e, "read from private field"), Zi ? Zi.call(Bi) : e.get(Bi)), oc = (Bi, e, Zi) => e.has(Bi) ? Af("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(Bi) : e.set(Bi, Zi), sc = (Bi, e, Zi, Qi) => (Gd(Bi, e, "write to private field"), Qi ? Qi.call(Bi, Zi) : e.set(Bi, Zi), Zi), nc = (Bi, e, Zi) => (Gd(Bi, e, "access private method"), Zi);
var Yd = (Bi, e, Zi, Qi) => ({
  set _(ea) {
    sc(Bi, e, ea, Zi);
  },
  get _() {
    return Hl(Bi, e, Qi);
  }
});
import * as a$8 from "react";
import a__default, { useState, createContext, useContext, useLayoutEffect, useEffect, useRef, useCallback, useMemo, forwardRef, createElement as createElement$1, cloneElement, Children, isValidElement, Component, memo, PureComponent, useReducer, useImperativeHandle, Fragment } from "react";
import $4AOtR$reactdom, { flushSync as flushSync$1, createPortal, unstable_batchedUpdates } from "react-dom";
import styled, { keyframes as keyframes$2 } from "styled-components";
import { toast } from "react-toastify";
import { useQuery, useMutation } from "@tanstack/react-query";
import { useField } from "formik";
import { Link } from "react-router-dom";
import { Outlet } from "react-router";
import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
function getDefaultExportFromCjs(Bi) {
  return Bi && Bi.__esModule && Object.prototype.hasOwnProperty.call(Bi, "default") ? Bi.default : Bi;
}
function getAugmentedNamespace(Bi) {
  if (Object.prototype.hasOwnProperty.call(Bi, "__esModule")) return Bi;
  var e = Bi.default;
  if (typeof e == "function") {
    var Zi = function Qi() {
      return this instanceof Qi ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    Zi.prototype = e.prototype;
  } else Zi = {};
  return Object.defineProperty(Zi, "__esModule", { value: !0 }), Object.keys(Bi).forEach(function(Qi) {
    var ea = Object.getOwnPropertyDescriptor(Bi, Qi);
    Object.defineProperty(Zi, Qi, ea.get ? ea : {
      enumerable: !0,
      get: function() {
        return Bi[Qi];
      }
    });
  }), Zi;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var Bi = a__default, e = Symbol.for("react.element"), Zi = Symbol.for("react.fragment"), Qi = Object.prototype.hasOwnProperty, ea = Bi.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, ra = { key: !0, ref: !0, __self: !0, __source: !0 };
  function na(ia, fa, La) {
    var Va, to = {}, ro = null, no = null;
    La !== void 0 && (ro = "" + La), fa.key !== void 0 && (ro = "" + fa.key), fa.ref !== void 0 && (no = fa.ref);
    for (Va in fa) Qi.call(fa, Va) && !ra.hasOwnProperty(Va) && (to[Va] = fa[Va]);
    if (ia && ia.defaultProps) for (Va in fa = ia.defaultProps, fa) to[Va] === void 0 && (to[Va] = fa[Va]);
    return { $$typeof: e, type: ia, key: ro, ref: no, props: to, _owner: ea.current };
  }
  return reactJsxRuntime_production_min.Fragment = Zi, reactJsxRuntime_production_min.jsx = na, reactJsxRuntime_production_min.jsxs = na, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    var Bi = a__default, e = Symbol.for("react.element"), Zi = Symbol.for("react.portal"), Qi = Symbol.for("react.fragment"), ea = Symbol.for("react.strict_mode"), ra = Symbol.for("react.profiler"), na = Symbol.for("react.provider"), ia = Symbol.for("react.context"), fa = Symbol.for("react.forward_ref"), La = Symbol.for("react.suspense"), Va = Symbol.for("react.suspense_list"), to = Symbol.for("react.memo"), ro = Symbol.for("react.lazy"), no = Symbol.for("react.offscreen"), eo = Symbol.iterator, ao = "@@iterator";
    function io(Gl) {
      if (Gl === null || typeof Gl != "object")
        return null;
      var ic = eo && Gl[eo] || Gl[ao];
      return typeof ic == "function" ? ic : null;
    }
    var xs = Bi.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Ts(Gl) {
      {
        for (var ic = arguments.length, su = new Array(ic > 1 ? ic - 1 : 0), Ku = 1; Ku < ic; Ku++)
          su[Ku - 1] = arguments[Ku];
        qs("error", Gl, su);
      }
    }
    function qs(Gl, ic, su) {
      {
        var Ku = xs.ReactDebugCurrentFrame, nd = Ku.getStackAddendum();
        nd !== "" && (ic += "%s", su = su.concat([nd]));
        var fd = su.map(function(ad) {
          return String(ad);
        });
        fd.unshift("Warning: " + ic), Function.prototype.apply.call(console[Gl], console, fd);
      }
    }
    var Fs = !1, Do = !1, ys = !1, Io = !1, so = !1, os;
    os = Symbol.for("react.module.reference");
    function Xs(Gl) {
      return !!(typeof Gl == "string" || typeof Gl == "function" || Gl === Qi || Gl === ra || so || Gl === ea || Gl === La || Gl === Va || Io || Gl === no || Fs || Do || ys || typeof Gl == "object" && Gl !== null && (Gl.$$typeof === ro || Gl.$$typeof === to || Gl.$$typeof === na || Gl.$$typeof === ia || Gl.$$typeof === fa || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Gl.$$typeof === os || Gl.getModuleId !== void 0));
    }
    function gl(Gl, ic, su) {
      var Ku = Gl.displayName;
      if (Ku)
        return Ku;
      var nd = ic.displayName || ic.name || "";
      return nd !== "" ? su + "(" + nd + ")" : su;
    }
    function Sl(Gl) {
      return Gl.displayName || "Context";
    }
    function El(Gl) {
      if (Gl == null)
        return null;
      if (typeof Gl.tag == "number" && Ts("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Gl == "function")
        return Gl.displayName || Gl.name || null;
      if (typeof Gl == "string")
        return Gl;
      switch (Gl) {
        case Qi:
          return "Fragment";
        case Zi:
          return "Portal";
        case ra:
          return "Profiler";
        case ea:
          return "StrictMode";
        case La:
          return "Suspense";
        case Va:
          return "SuspenseList";
      }
      if (typeof Gl == "object")
        switch (Gl.$$typeof) {
          case ia:
            var ic = Gl;
            return Sl(ic) + ".Consumer";
          case na:
            var su = Gl;
            return Sl(su._context) + ".Provider";
          case fa:
            return gl(Gl, Gl.render, "ForwardRef");
          case to:
            var Ku = Gl.displayName || null;
            return Ku !== null ? Ku : El(Gl.type) || "Memo";
          case ro: {
            var nd = Gl, fd = nd._payload, ad = nd._init;
            try {
              return El(ad(fd));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var wl = Object.assign, jl = 0, kl, Fl, Ml, ql, Kl, Zl, Il;
    function xl() {
    }
    xl.__reactDisabledLog = !0;
    function bl() {
      {
        if (jl === 0) {
          kl = console.log, Fl = console.info, Ml = console.warn, ql = console.error, Kl = console.group, Zl = console.groupCollapsed, Il = console.groupEnd;
          var Gl = {
            configurable: !0,
            enumerable: !0,
            value: xl,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Gl,
            log: Gl,
            warn: Gl,
            error: Gl,
            group: Gl,
            groupCollapsed: Gl,
            groupEnd: Gl
          });
        }
        jl++;
      }
    }
    function Pl() {
      {
        if (jl--, jl === 0) {
          var Gl = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: wl({}, Gl, {
              value: kl
            }),
            info: wl({}, Gl, {
              value: Fl
            }),
            warn: wl({}, Gl, {
              value: Ml
            }),
            error: wl({}, Gl, {
              value: ql
            }),
            group: wl({}, Gl, {
              value: Kl
            }),
            groupCollapsed: wl({}, Gl, {
              value: Zl
            }),
            groupEnd: wl({}, Gl, {
              value: Il
            })
          });
        }
        jl < 0 && Ts("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Nl = xs.ReactCurrentDispatcher, Bl;
    function Ol(Gl, ic, su) {
      {
        if (Bl === void 0)
          try {
            throw Error();
          } catch (nd) {
            var Ku = nd.stack.trim().match(/\n( *(at )?)/);
            Bl = Ku && Ku[1] || "";
          }
        return `
` + Bl + Gl;
      }
    }
    var To = !1, Os;
    {
      var $l = typeof WeakMap == "function" ? WeakMap : Map;
      Os = new $l();
    }
    function _l(Gl, ic) {
      if (!Gl || To)
        return "";
      {
        var su = Os.get(Gl);
        if (su !== void 0)
          return su;
      }
      var Ku;
      To = !0;
      var nd = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var fd;
      fd = Nl.current, Nl.current = null, bl();
      try {
        if (ic) {
          var ad = function() {
            throw Error();
          };
          if (Object.defineProperty(ad.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ad, []);
            } catch (Cd) {
              Ku = Cd;
            }
            Reflect.construct(Gl, [], ad);
          } else {
            try {
              ad.call();
            } catch (Cd) {
              Ku = Cd;
            }
            Gl.call(ad.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Cd) {
            Ku = Cd;
          }
          Gl();
        }
      } catch (Cd) {
        if (Cd && Ku && typeof Cd.stack == "string") {
          for (var rd = Cd.stack.split(`
`), gd = Ku.stack.split(`
`), pd = rd.length - 1, md = gd.length - 1; pd >= 1 && md >= 0 && rd[pd] !== gd[md]; )
            md--;
          for (; pd >= 1 && md >= 0; pd--, md--)
            if (rd[pd] !== gd[md]) {
              if (pd !== 1 || md !== 1)
                do
                  if (pd--, md--, md < 0 || rd[pd] !== gd[md]) {
                    var xd = `
` + rd[pd].replace(" at new ", " at ");
                    return Gl.displayName && xd.includes("<anonymous>") && (xd = xd.replace("<anonymous>", Gl.displayName)), typeof Gl == "function" && Os.set(Gl, xd), xd;
                  }
                while (pd >= 1 && md >= 0);
              break;
            }
        }
      } finally {
        To = !1, Nl.current = fd, Pl(), Error.prepareStackTrace = nd;
      }
      var Id = Gl ? Gl.displayName || Gl.name : "", wf = Id ? Ol(Id) : "";
      return typeof Gl == "function" && Os.set(Gl, wf), wf;
    }
    function Al(Gl, ic, su) {
      return _l(Gl, !1);
    }
    function Rl(Gl) {
      var ic = Gl.prototype;
      return !!(ic && ic.isReactComponent);
    }
    function Cl(Gl, ic, su) {
      if (Gl == null)
        return "";
      if (typeof Gl == "function")
        return _l(Gl, Rl(Gl));
      if (typeof Gl == "string")
        return Ol(Gl);
      switch (Gl) {
        case La:
          return Ol("Suspense");
        case Va:
          return Ol("SuspenseList");
      }
      if (typeof Gl == "object")
        switch (Gl.$$typeof) {
          case fa:
            return Al(Gl.render);
          case to:
            return Cl(Gl.type, ic, su);
          case ro: {
            var Ku = Gl, nd = Ku._payload, fd = Ku._init;
            try {
              return Cl(fd(nd), ic, su);
            } catch {
            }
          }
        }
      return "";
    }
    var ml = Object.prototype.hasOwnProperty, Tl = {}, Ll = xs.ReactDebugCurrentFrame;
    function Vl(Gl) {
      if (Gl) {
        var ic = Gl._owner, su = Cl(Gl.type, Gl._source, ic ? ic.type : null);
        Ll.setExtraStackFrame(su);
      } else
        Ll.setExtraStackFrame(null);
    }
    function zl(Gl, ic, su, Ku, nd) {
      {
        var fd = Function.call.bind(ml);
        for (var ad in Gl)
          if (fd(Gl, ad)) {
            var rd = void 0;
            try {
              if (typeof Gl[ad] != "function") {
                var gd = Error((Ku || "React class") + ": " + su + " type `" + ad + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Gl[ad] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw gd.name = "Invariant Violation", gd;
              }
              rd = Gl[ad](ic, ad, Ku, su, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (pd) {
              rd = pd;
            }
            rd && !(rd instanceof Error) && (Vl(nd), Ts("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ku || "React class", su, ad, typeof rd), Vl(null)), rd instanceof Error && !(rd.message in Tl) && (Tl[rd.message] = !0, Vl(nd), Ts("Failed %s type: %s", su, rd.message), Vl(null));
          }
      }
    }
    var Ul = Array.isArray;
    function Yl(Gl) {
      return Ul(Gl);
    }
    function Jl(Gl) {
      {
        var ic = typeof Symbol == "function" && Symbol.toStringTag, su = ic && Gl[Symbol.toStringTag] || Gl.constructor.name || "Object";
        return su;
      }
    }
    function Wl(Gl) {
      try {
        return rc(Gl), !1;
      } catch {
        return !0;
      }
    }
    function rc(Gl) {
      return "" + Gl;
    }
    function uc(Gl) {
      if (Wl(Gl))
        return Ts("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Jl(Gl)), rc(Gl);
    }
    var ac = xs.ReactCurrentOwner, zu = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Xu, ed;
    function td(Gl) {
      if (ml.call(Gl, "ref")) {
        var ic = Object.getOwnPropertyDescriptor(Gl, "ref").get;
        if (ic && ic.isReactWarning)
          return !1;
      }
      return Gl.ref !== void 0;
    }
    function od(Gl) {
      if (ml.call(Gl, "key")) {
        var ic = Object.getOwnPropertyDescriptor(Gl, "key").get;
        if (ic && ic.isReactWarning)
          return !1;
      }
      return Gl.key !== void 0;
    }
    function ld(Gl, ic) {
      typeof Gl.ref == "string" && ac.current;
    }
    function sd(Gl, ic) {
      {
        var su = function() {
          Xu || (Xu = !0, Ts("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ic));
        };
        su.isReactWarning = !0, Object.defineProperty(Gl, "key", {
          get: su,
          configurable: !0
        });
      }
    }
    function bd(Gl, ic) {
      {
        var su = function() {
          ed || (ed = !0, Ts("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ic));
        };
        su.isReactWarning = !0, Object.defineProperty(Gl, "ref", {
          get: su,
          configurable: !0
        });
      }
    }
    var $d = function(Gl, ic, su, Ku, nd, fd, ad) {
      var rd = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: Gl,
        key: ic,
        ref: su,
        props: ad,
        // Record the component responsible for creating this element.
        _owner: fd
      };
      return rd._store = {}, Object.defineProperty(rd._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(rd, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ku
      }), Object.defineProperty(rd, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: nd
      }), Object.freeze && (Object.freeze(rd.props), Object.freeze(rd)), rd;
    };
    function _d(Gl, ic, su, Ku, nd) {
      {
        var fd, ad = {}, rd = null, gd = null;
        su !== void 0 && (uc(su), rd = "" + su), od(ic) && (uc(ic.key), rd = "" + ic.key), td(ic) && (gd = ic.ref, ld(ic, nd));
        for (fd in ic)
          ml.call(ic, fd) && !zu.hasOwnProperty(fd) && (ad[fd] = ic[fd]);
        if (Gl && Gl.defaultProps) {
          var pd = Gl.defaultProps;
          for (fd in pd)
            ad[fd] === void 0 && (ad[fd] = pd[fd]);
        }
        if (rd || gd) {
          var md = typeof Gl == "function" ? Gl.displayName || Gl.name || "Unknown" : Gl;
          rd && sd(ad, md), gd && bd(ad, md);
        }
        return $d(Gl, rd, gd, nd, Ku, ac.current, ad);
      }
    }
    var tc = xs.ReactCurrentOwner, Xl = xs.ReactDebugCurrentFrame;
    function Ql(Gl) {
      if (Gl) {
        var ic = Gl._owner, su = Cl(Gl.type, Gl._source, ic ? ic.type : null);
        Xl.setExtraStackFrame(su);
      } else
        Xl.setExtraStackFrame(null);
    }
    var $u;
    $u = !1;
    function Yu(Gl) {
      return typeof Gl == "object" && Gl !== null && Gl.$$typeof === e;
    }
    function ud() {
      {
        if (tc.current) {
          var Gl = El(tc.current.type);
          if (Gl)
            return `

Check the render method of \`` + Gl + "`.";
        }
        return "";
      }
    }
    function dd(Gl) {
      return "";
    }
    var Ed = {};
    function Od(Gl) {
      {
        var ic = ud();
        if (!ic) {
          var su = typeof Gl == "string" ? Gl : Gl.displayName || Gl.name;
          su && (ic = `

Check the top-level render call using <` + su + ">.");
        }
        return ic;
      }
    }
    function wd(Gl, ic) {
      {
        if (!Gl._store || Gl._store.validated || Gl.key != null)
          return;
        Gl._store.validated = !0;
        var su = Od(ic);
        if (Ed[su])
          return;
        Ed[su] = !0;
        var Ku = "";
        Gl && Gl._owner && Gl._owner !== tc.current && (Ku = " It was passed a child from " + El(Gl._owner.type) + "."), Ql(Gl), Ts('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', su, Ku), Ql(null);
      }
    }
    function vd(Gl, ic) {
      {
        if (typeof Gl != "object")
          return;
        if (Yl(Gl))
          for (var su = 0; su < Gl.length; su++) {
            var Ku = Gl[su];
            Yu(Ku) && wd(Ku, ic);
          }
        else if (Yu(Gl))
          Gl._store && (Gl._store.validated = !0);
        else if (Gl) {
          var nd = io(Gl);
          if (typeof nd == "function" && nd !== Gl.entries)
            for (var fd = nd.call(Gl), ad; !(ad = fd.next()).done; )
              Yu(ad.value) && wd(ad.value, ic);
        }
      }
    }
    function Pd(Gl) {
      {
        var ic = Gl.type;
        if (ic == null || typeof ic == "string")
          return;
        var su;
        if (typeof ic == "function")
          su = ic.propTypes;
        else if (typeof ic == "object" && (ic.$$typeof === fa || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ic.$$typeof === to))
          su = ic.propTypes;
        else
          return;
        if (su) {
          var Ku = El(ic);
          zl(su, Gl.props, "prop", Ku, Gl);
        } else if (ic.PropTypes !== void 0 && !$u) {
          $u = !0;
          var nd = El(ic);
          Ts("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", nd || "Unknown");
        }
        typeof ic.getDefaultProps == "function" && !ic.getDefaultProps.isReactClassApproved && Ts("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ad(Gl) {
      {
        for (var ic = Object.keys(Gl.props), su = 0; su < ic.length; su++) {
          var Ku = ic[su];
          if (Ku !== "children" && Ku !== "key") {
            Ql(Gl), Ts("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ku), Ql(null);
            break;
          }
        }
        Gl.ref !== null && (Ql(Gl), Ts("Invalid attribute `ref` supplied to `React.Fragment`."), Ql(null));
      }
    }
    function kd(Gl, ic, su, Ku, nd, fd) {
      {
        var ad = Xs(Gl);
        if (!ad) {
          var rd = "";
          (Gl === void 0 || typeof Gl == "object" && Gl !== null && Object.keys(Gl).length === 0) && (rd += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var gd = dd();
          gd ? rd += gd : rd += ud();
          var pd;
          Gl === null ? pd = "null" : Yl(Gl) ? pd = "array" : Gl !== void 0 && Gl.$$typeof === e ? (pd = "<" + (El(Gl.type) || "Unknown") + " />", rd = " Did you accidentally export a JSX literal instead of a component?") : pd = typeof Gl, Ts("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", pd, rd);
        }
        var md = _d(Gl, ic, su, nd, fd);
        if (md == null)
          return md;
        if (ad) {
          var xd = ic.children;
          if (xd !== void 0)
            if (Ku)
              if (Yl(xd)) {
                for (var Id = 0; Id < xd.length; Id++)
                  vd(xd[Id], Gl);
                Object.freeze && Object.freeze(xd);
              } else
                Ts("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vd(xd, Gl);
        }
        return Gl === Qi ? Ad(md) : Pd(md), md;
      }
    }
    function hd(Gl, ic, su) {
      return kd(Gl, ic, su, !0);
    }
    function Dd(Gl, ic, su) {
      return kd(Gl, ic, su, !1);
    }
    var Rd = Dd, jd = hd;
    reactJsxRuntime_development.Fragment = Qi, reactJsxRuntime_development.jsx = Rd, reactJsxRuntime_development.jsxs = jd;
  }()), reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  return hasRequiredJsxRuntime || (hasRequiredJsxRuntime = 1, process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development()), jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
const FlexBox = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...Bi });
function r$3(Bi) {
  var e, Zi, Qi = "";
  if (typeof Bi == "string" || typeof Bi == "number") Qi += Bi;
  else if (typeof Bi == "object") if (Array.isArray(Bi)) {
    var ea = Bi.length;
    for (e = 0; e < ea; e++) Bi[e] && (Zi = r$3(Bi[e])) && (Qi && (Qi += " "), Qi += Zi);
  } else for (Zi in Bi) Bi[Zi] && (Qi && (Qi += " "), Qi += Zi);
  return Qi;
}
function clsx() {
  for (var Bi, e, Zi = 0, Qi = "", ea = arguments.length; Zi < ea; Zi++) (Bi = arguments[Zi]) && (e = r$3(Bi)) && (Qi && (Qi += " "), Qi += e);
  return Qi;
}
const falsyToString = (Bi) => typeof Bi == "boolean" ? "".concat(Bi) : Bi === 0 ? "0" : Bi, cx = clsx, cva = (Bi, e) => (Zi) => {
  var Qi;
  if (e?.variants == null) return cx(Bi, Zi?.class, Zi?.className);
  const { variants: ea, defaultVariants: ra } = e, na = Object.keys(ea).map((La) => {
    const Va = Zi?.[La], to = ra?.[La];
    if (Va === null) return null;
    const ro = falsyToString(Va) || falsyToString(to);
    return ea[La][ro];
  }), ia = Zi && Object.entries(Zi).reduce((La, Va) => {
    let [to, ro] = Va;
    return ro === void 0 || (La[to] = ro), La;
  }, {}), fa = e == null || (Qi = e.compoundVariants) === null || Qi === void 0 ? void 0 : Qi.reduce((La, Va) => {
    let { class: to, className: ro, ...no } = Va;
    return Object.entries(no).every((eo) => {
      let [ao, io] = eo;
      return Array.isArray(io) ? io.includes({
        ...ra,
        ...ia
      }[ao]) : {
        ...ra,
        ...ia
      }[ao] === io;
    }) ? [
      ...La,
      to,
      ro
    ] : La;
  }, []);
  return cx(Bi, na, fa, Zi?.class, Zi?.className);
};
function twJoin() {
  for (var Bi = 0, e, Zi, Qi = ""; Bi < arguments.length; )
    (e = arguments[Bi++]) && (Zi = toValue(e)) && (Qi && (Qi += " "), Qi += Zi);
  return Qi;
}
function toValue(Bi) {
  if (typeof Bi == "string")
    return Bi;
  for (var e, Zi = "", Qi = 0; Qi < Bi.length; Qi++)
    Bi[Qi] && (e = toValue(Bi[Qi])) && (Zi && (Zi += " "), Zi += e);
  return Zi;
}
var CLASS_PART_SEPARATOR = "-";
function createClassUtils(Bi) {
  var e = createClassMap(Bi), Zi = Bi.conflictingClassGroups, Qi = Bi.conflictingClassGroupModifiers, ea = Qi === void 0 ? {} : Qi;
  function ra(ia) {
    var fa = ia.split(CLASS_PART_SEPARATOR);
    return fa[0] === "" && fa.length !== 1 && fa.shift(), getGroupRecursive(fa, e) || getGroupIdForArbitraryProperty(ia);
  }
  function na(ia, fa) {
    var La = Zi[ia] || [];
    return fa && ea[ia] ? [].concat(La, ea[ia]) : La;
  }
  return {
    getClassGroupId: ra,
    getConflictingClassGroupIds: na
  };
}
function getGroupRecursive(Bi, e) {
  if (Bi.length === 0)
    return e.classGroupId;
  var Zi = Bi[0], Qi = e.nextPart.get(Zi), ea = Qi ? getGroupRecursive(Bi.slice(1), Qi) : void 0;
  if (ea)
    return ea;
  if (e.validators.length !== 0) {
    var ra = Bi.join(CLASS_PART_SEPARATOR);
    return e.validators.find(function(na) {
      var ia = na.validator;
      return ia(ra);
    })?.classGroupId;
  }
}
var arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(Bi) {
  if (arbitraryPropertyRegex.test(Bi)) {
    var e = arbitraryPropertyRegex.exec(Bi)[1], Zi = e?.substring(0, e.indexOf(":"));
    if (Zi)
      return "arbitrary.." + Zi;
  }
}
function createClassMap(Bi) {
  var e = Bi.theme, Zi = Bi.prefix, Qi = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, ea = getPrefixedClassGroupEntries(Object.entries(Bi.classGroups), Zi);
  return ea.forEach(function(ra) {
    var na = ra[0], ia = ra[1];
    processClassesRecursively(ia, Qi, na, e);
  }), Qi;
}
function processClassesRecursively(Bi, e, Zi, Qi) {
  Bi.forEach(function(ea) {
    if (typeof ea == "string") {
      var ra = ea === "" ? e : getPart(e, ea);
      ra.classGroupId = Zi;
      return;
    }
    if (typeof ea == "function") {
      if (isThemeGetter(ea)) {
        processClassesRecursively(ea(Qi), e, Zi, Qi);
        return;
      }
      e.validators.push({
        validator: ea,
        classGroupId: Zi
      });
      return;
    }
    Object.entries(ea).forEach(function(na) {
      var ia = na[0], fa = na[1];
      processClassesRecursively(fa, getPart(e, ia), Zi, Qi);
    });
  });
}
function getPart(Bi, e) {
  var Zi = Bi;
  return e.split(CLASS_PART_SEPARATOR).forEach(function(Qi) {
    Zi.nextPart.has(Qi) || Zi.nextPart.set(Qi, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), Zi = Zi.nextPart.get(Qi);
  }), Zi;
}
function isThemeGetter(Bi) {
  return Bi.isThemeGetter;
}
function getPrefixedClassGroupEntries(Bi, e) {
  return e ? Bi.map(function(Zi) {
    var Qi = Zi[0], ea = Zi[1], ra = ea.map(function(na) {
      return typeof na == "string" ? e + na : typeof na == "object" ? Object.fromEntries(Object.entries(na).map(function(ia) {
        var fa = ia[0], La = ia[1];
        return [e + fa, La];
      })) : na;
    });
    return [Qi, ra];
  }) : Bi;
}
function createLruCache(Bi) {
  if (Bi < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var e = 0, Zi = /* @__PURE__ */ new Map(), Qi = /* @__PURE__ */ new Map();
  function ea(ra, na) {
    Zi.set(ra, na), e++, e > Bi && (e = 0, Qi = Zi, Zi = /* @__PURE__ */ new Map());
  }
  return {
    get: function(na) {
      var ia = Zi.get(na);
      if (ia !== void 0)
        return ia;
      if ((ia = Qi.get(na)) !== void 0)
        return ea(na, ia), ia;
    },
    set: function(na, ia) {
      Zi.has(na) ? Zi.set(na, ia) : ea(na, ia);
    }
  };
}
var IMPORTANT_MODIFIER = "!";
function createSplitModifiers(Bi) {
  var e = Bi.separator || ":", Zi = e.length === 1, Qi = e[0], ea = e.length;
  return function(na) {
    for (var ia = [], fa = 0, La = 0, Va, to = 0; to < na.length; to++) {
      var ro = na[to];
      if (fa === 0) {
        if (ro === Qi && (Zi || na.slice(to, to + ea) === e)) {
          ia.push(na.slice(La, to)), La = to + ea;
          continue;
        }
        if (ro === "/") {
          Va = to;
          continue;
        }
      }
      ro === "[" ? fa++ : ro === "]" && fa--;
    }
    var no = ia.length === 0 ? na : na.substring(La), eo = no.startsWith(IMPORTANT_MODIFIER), ao = eo ? no.substring(1) : no, io = Va && Va > La ? Va - La : void 0;
    return {
      modifiers: ia,
      hasImportantModifier: eo,
      baseClassName: ao,
      maybePostfixModifierPosition: io
    };
  };
}
function sortModifiers(Bi) {
  if (Bi.length <= 1)
    return Bi;
  var e = [], Zi = [];
  return Bi.forEach(function(Qi) {
    var ea = Qi[0] === "[";
    ea ? (e.push.apply(e, Zi.sort().concat([Qi])), Zi = []) : Zi.push(Qi);
  }), e.push.apply(e, Zi.sort()), e;
}
function createConfigUtils(Bi) {
  return {
    cache: createLruCache(Bi.cacheSize),
    splitModifiers: createSplitModifiers(Bi),
    ...createClassUtils(Bi)
  };
}
var SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(Bi, e) {
  var Zi = e.splitModifiers, Qi = e.getClassGroupId, ea = e.getConflictingClassGroupIds, ra = /* @__PURE__ */ new Set();
  return Bi.trim().split(SPLIT_CLASSES_REGEX).map(function(na) {
    var ia = Zi(na), fa = ia.modifiers, La = ia.hasImportantModifier, Va = ia.baseClassName, to = ia.maybePostfixModifierPosition, ro = Qi(to ? Va.substring(0, to) : Va), no = !!to;
    if (!ro) {
      if (!to)
        return {
          isTailwindClass: !1,
          originalClassName: na
        };
      if (ro = Qi(Va), !ro)
        return {
          isTailwindClass: !1,
          originalClassName: na
        };
      no = !1;
    }
    var eo = sortModifiers(fa).join(":"), ao = La ? eo + IMPORTANT_MODIFIER : eo;
    return {
      isTailwindClass: !0,
      modifierId: ao,
      classGroupId: ro,
      originalClassName: na,
      hasPostfixModifier: no
    };
  }).reverse().filter(function(na) {
    if (!na.isTailwindClass)
      return !0;
    var ia = na.modifierId, fa = na.classGroupId, La = na.hasPostfixModifier, Va = ia + fa;
    return ra.has(Va) ? !1 : (ra.add(Va), ea(fa, La).forEach(function(to) {
      return ra.add(ia + to);
    }), !0);
  }).reverse().map(function(na) {
    return na.originalClassName;
  }).join(" ");
}
function createTailwindMerge() {
  for (var Bi = arguments.length, e = new Array(Bi), Zi = 0; Zi < Bi; Zi++)
    e[Zi] = arguments[Zi];
  var Qi, ea, ra, na = ia;
  function ia(La) {
    var Va = e[0], to = e.slice(1), ro = to.reduce(function(no, eo) {
      return eo(no);
    }, Va());
    return Qi = createConfigUtils(ro), ea = Qi.cache.get, ra = Qi.cache.set, na = fa, fa(La);
  }
  function fa(La) {
    var Va = ea(La);
    if (Va)
      return Va;
    var to = mergeClassList(La, Qi);
    return ra(La, to), to;
  }
  return function() {
    return na(twJoin.apply(null, arguments));
  };
}
function fromTheme(Bi) {
  var e = function(Qi) {
    return Qi[Bi] || [];
  };
  return e.isThemeGetter = !0, e;
}
var arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i, fractionRegex = /^\d+\/\d+$/, stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]), tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|^0$/, shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function isLength(Bi) {
  return isNumber(Bi) || stringLengths.has(Bi) || fractionRegex.test(Bi) || isArbitraryLength(Bi);
}
function isArbitraryLength(Bi) {
  return getIsArbitraryValue(Bi, "length", isLengthOnly);
}
function isArbitrarySize(Bi) {
  return getIsArbitraryValue(Bi, "size", isNever);
}
function isArbitraryPosition(Bi) {
  return getIsArbitraryValue(Bi, "position", isNever);
}
function isArbitraryUrl(Bi) {
  return getIsArbitraryValue(Bi, "url", isUrl);
}
function isArbitraryNumber(Bi) {
  return getIsArbitraryValue(Bi, "number", isNumber);
}
function isNumber(Bi) {
  return !Number.isNaN(Number(Bi));
}
function isPercent(Bi) {
  return Bi.endsWith("%") && isNumber(Bi.slice(0, -1));
}
function isInteger(Bi) {
  return isIntegerOnly(Bi) || getIsArbitraryValue(Bi, "number", isIntegerOnly);
}
function isArbitraryValue(Bi) {
  return arbitraryValueRegex.test(Bi);
}
function isAny() {
  return !0;
}
function isTshirtSize(Bi) {
  return tshirtUnitRegex.test(Bi);
}
function isArbitraryShadow(Bi) {
  return getIsArbitraryValue(Bi, "", isShadow);
}
function getIsArbitraryValue(Bi, e, Zi) {
  var Qi = arbitraryValueRegex.exec(Bi);
  return Qi ? Qi[1] ? Qi[1] === e : Zi(Qi[2]) : !1;
}
function isLengthOnly(Bi) {
  return lengthUnitRegex.test(Bi);
}
function isNever() {
  return !1;
}
function isUrl(Bi) {
  return Bi.startsWith("url(");
}
function isIntegerOnly(Bi) {
  return Number.isInteger(Number(Bi));
}
function isShadow(Bi) {
  return shadowRegex.test(Bi);
}
function getDefaultConfig() {
  var Bi = fromTheme("colors"), e = fromTheme("spacing"), Zi = fromTheme("blur"), Qi = fromTheme("brightness"), ea = fromTheme("borderColor"), ra = fromTheme("borderRadius"), na = fromTheme("borderSpacing"), ia = fromTheme("borderWidth"), fa = fromTheme("contrast"), La = fromTheme("grayscale"), Va = fromTheme("hueRotate"), to = fromTheme("invert"), ro = fromTheme("gap"), no = fromTheme("gradientColorStops"), eo = fromTheme("gradientColorStopPositions"), ao = fromTheme("inset"), io = fromTheme("margin"), xs = fromTheme("opacity"), Ts = fromTheme("padding"), qs = fromTheme("saturate"), Fs = fromTheme("scale"), Do = fromTheme("sepia"), ys = fromTheme("skew"), Io = fromTheme("space"), so = fromTheme("translate"), os = function() {
    return ["auto", "contain", "none"];
  }, Xs = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, gl = function() {
    return ["auto", e];
  }, Sl = function() {
    return ["", isLength];
  }, El = function() {
    return ["auto", isNumber, isArbitraryValue];
  }, wl = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, jl = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, kl = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, Fl = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, Ml = function() {
    return ["", "0", isArbitraryValue];
  }, ql = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, Kl = function() {
    return [isNumber, isArbitraryNumber];
  }, Zl = function() {
    return [isNumber, isArbitraryValue];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [isAny],
      spacing: [isLength],
      blur: ["none", "", isTshirtSize, isArbitraryLength],
      brightness: Kl(),
      borderColor: [Bi],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryLength],
      borderSpacing: [e],
      borderWidth: Sl(),
      contrast: Kl(),
      grayscale: Ml(),
      hueRotate: Zl(),
      invert: Ml(),
      gap: [e],
      gradientColorStops: [Bi],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: gl(),
      margin: gl(),
      opacity: Kl(),
      padding: [e],
      saturate: Kl(),
      scale: Kl(),
      sepia: Ml(),
      skew: Zl(),
      space: [e],
      translate: [e]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": ql()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": ql()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(wl(), [isArbitraryValue])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: Xs()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": Xs()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": Xs()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: os()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": os()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": os()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [ao]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [ao]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [ao]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [ao]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [ao]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [ao]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [ao]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [ao]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [ao]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: gl()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Ml()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Ml()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": El()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": El()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": El()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": El()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [ro]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [ro]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [ro]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(Fl())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(Fl(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(Fl(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [Ts]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [Ts]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [Ts]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [Ts]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [Ts]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [Ts]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [Ts]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [Ts]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [Ts]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [io]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [io]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [io]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [io]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [io]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [io]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [io]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [io]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [io]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [Io]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [Io]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", isLength]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize, isArbitraryLength]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [e, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", isLength]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [e, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryLength]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [Bi]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [xs]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [Bi]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [xs]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(jl(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [Bi]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [e]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryLength]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [xs]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(wl(), [isArbitraryPosition])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryUrl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [Bi]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [eo]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [eo]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [eo]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [no]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [no]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [no]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [ra]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [ra]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [ra]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [ra]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [ra]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [ra]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [ra]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [ra]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [ra]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [ra]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [ra]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [ra]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [ra]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [ra]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [ra]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [ia]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [ia]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [ia]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [ia]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [ia]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [ia]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [ia]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [ia]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [ia]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [xs]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(jl(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [ia]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [ia]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [xs]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: jl()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [ea]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [ea]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [ea]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [ea]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [ea]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [ea]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [ea]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [ea]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(jl())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isLength]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [Bi]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: Sl()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [Bi]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [xs]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [Bi]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [xs]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": kl()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": kl()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [Zi]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Qi]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [fa]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [La]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Va]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [to]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [qs]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [Do]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [Zi]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Qi]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [fa]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [La]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Va]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [to]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [xs]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [qs]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [Do]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [na]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [na]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [na]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Zl()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Zl()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [Fs]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [Fs]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [Fs]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [so]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [so]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [ys]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [ys]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", Bi]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [Bi]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [e]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [e]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [e]
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": [e]
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": [e]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [e]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [e]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [e]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [e]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [e]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [e]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [e]
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": [e]
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": [e]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [e]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [e]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [e]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [e]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [Bi, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [Bi, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
const buttonVariants = cva(
  [
    "z-0",
    "flex-grow-0",
    "px-4",
    "py-2",
    "text-sm",
    "text-white",
    "transition-all",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-opacity-75",
    "disabled:opacity-50",
    "disabled:cursor-default"
  ],
  {
    variants: {
      variant: {
        green: "bg-green-400 focus:ring-green-400 hover:bg-green-500 disabled:bg-green-400",
        blue: "bg-blue-400",
        red: "bg-red-400 focus:ring-red-400 hover:bg-red-500 disabled:bg-red-400",
        gray: "text-black bg-neutral-200 focus:ring-gray-200 hover:bg-neutral-300 disabled:bg-neutral-200",
        black: "bg-black focus:ring-neutral-800 hover:bg-neutral-800 disabled:bg-neutral-800"
      }
    }
  }
), Button = ({
  variant: Bi = "black",
  className: e,
  ...Zi
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "button",
  {
    ...Zi,
    className: twMerge(buttonVariants({ variant: Bi }), e)
  }
);
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const faBars = {
  prefix: "fas",
  iconName: "bars",
  icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"]
}, faChevronUp = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, faClipboard = {
  prefix: "fas",
  iconName: "clipboard",
  icon: [384, 512, [128203], "f328", "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, faUserGear = {
  prefix: "fas",
  iconName: "user-gear",
  icon: [640, 512, ["user-cog"], "f4fe", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
}, faUserCog = faUserGear, faChevronDown = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, faX = {
  prefix: "fas",
  iconName: "x",
  icon: [384, 512, [120], "58", "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"]
};
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function _defineProperty$8(Bi, e, Zi) {
  return (e = _toPropertyKey$1(e)) in Bi ? Object.defineProperty(Bi, e, {
    value: Zi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Zi, Bi;
}
function ownKeys$4(Bi, e) {
  var Zi = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Qi = Object.getOwnPropertySymbols(Bi);
    e && (Qi = Qi.filter(function(ea) {
      return Object.getOwnPropertyDescriptor(Bi, ea).enumerable;
    })), Zi.push.apply(Zi, Qi);
  }
  return Zi;
}
function _objectSpread2$1(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Zi = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys$4(Object(Zi), !0).forEach(function(Qi) {
      _defineProperty$8(Bi, Qi, Zi[Qi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(Zi)) : ownKeys$4(Object(Zi)).forEach(function(Qi) {
      Object.defineProperty(Bi, Qi, Object.getOwnPropertyDescriptor(Zi, Qi));
    });
  }
  return Bi;
}
function _toPrimitive$1(Bi, e) {
  if (typeof Bi != "object" || !Bi) return Bi;
  var Zi = Bi[Symbol.toPrimitive];
  if (Zi !== void 0) {
    var Qi = Zi.call(Bi, e);
    if (typeof Qi != "object") return Qi;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(Bi);
}
function _toPropertyKey$1(Bi) {
  var e = _toPrimitive$1(Bi, "string");
  return typeof e == "symbol" ? e : e + "";
}
const noop$2 = () => {
};
let _WINDOW = {}, _DOCUMENT = {}, _MUTATION_OBSERVER = null, _PERFORMANCE = {
  mark: noop$2,
  measure: noop$2
};
try {
  typeof window < "u" && (_WINDOW = window), typeof document < "u" && (_DOCUMENT = document), typeof MutationObserver < "u" && (_MUTATION_OBSERVER = MutationObserver), typeof performance < "u" && (_PERFORMANCE = performance);
} catch {
}
const {
  userAgent = ""
} = _WINDOW.navigator || {}, WINDOW = _WINDOW, DOCUMENT = _DOCUMENT, MUTATION_OBSERVER = _MUTATION_OBSERVER, PERFORMANCE = _PERFORMANCE;
WINDOW.document;
const IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener == "function" && typeof DOCUMENT.createElement == "function", IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
var p$4 = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, g$4 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, S$2 = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, A$3 = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, P$4 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], s$5 = "classic", t$7 = "duotone", r$2 = "sharp", o$1 = "sharp-duotone", L$3 = [s$5, t$7, r$2, o$1], G$3 = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, lt$3 = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, pt$3 = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), xt$3 = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, Ft$3 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], St$3 = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, At$3 = ["kit"], Ct$3 = {
  kit: {
    "fa-kit": "fak"
  }
}, Lt$3 = ["fak", "fakd"], Wt$3 = {
  kit: {
    fak: "fa-kit"
  }
}, Et$3 = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, t$1$1 = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, r$1$1 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], bt$1$1 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], Yt$3 = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, ua$1 = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, I$1$1 = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, ga$1 = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, x$3 = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], Ia$1 = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...r$1$1, ...x$3], m$1$1 = ["solid", "regular", "light", "thin", "duotone", "brands"], c$1$1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], F$1$1 = c$1$1.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), ma$1 = [...Object.keys(I$1$1), ...m$1$1, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", t$1$1.GROUP, t$1$1.SWAP_OPACITY, t$1$1.PRIMARY, t$1$1.SECONDARY].concat(c$1$1.map((Bi) => "".concat(Bi, "x"))).concat(F$1$1.map((Bi) => "w-".concat(Bi))), wa$1 = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const NAMESPACE_IDENTIFIER = "___FONT_AWESOME___", UNITS_IN_GRID = 16, DEFAULT_CSS_PREFIX = "fa", DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa", DATA_FA_I2SVG = "data-fa-i2svg", DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element", DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending", DATA_PREFIX = "data-prefix", DATA_ICON = "data-icon", HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg", MUTATION_APPROACH_ASYNC = "async", TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ["HTML", "HEAD", "STYLE", "SCRIPT"], PRODUCTION$1 = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function familyProxy(Bi) {
  return new Proxy(Bi, {
    get(e, Zi) {
      return Zi in e ? e[Zi] : e[s$5];
    }
  });
}
const _PREFIX_TO_STYLE = _objectSpread2$1({}, S$2);
_PREFIX_TO_STYLE[s$5] = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, {
  "fa-duotone": "duotone"
}), S$2[s$5]), St$3.kit), St$3["kit-duotone"]);
const PREFIX_TO_STYLE = familyProxy(_PREFIX_TO_STYLE), _STYLE_TO_PREFIX = _objectSpread2$1({}, xt$3);
_STYLE_TO_PREFIX[s$5] = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, {
  duotone: "fad"
}), _STYLE_TO_PREFIX[s$5]), Et$3.kit), Et$3["kit-duotone"]);
const STYLE_TO_PREFIX = familyProxy(_STYLE_TO_PREFIX), _PREFIX_TO_LONG_STYLE = _objectSpread2$1({}, ga$1);
_PREFIX_TO_LONG_STYLE[s$5] = _objectSpread2$1(_objectSpread2$1({}, _PREFIX_TO_LONG_STYLE[s$5]), Wt$3.kit);
const PREFIX_TO_LONG_STYLE = familyProxy(_PREFIX_TO_LONG_STYLE), _LONG_STYLE_TO_PREFIX = _objectSpread2$1({}, ua$1);
_LONG_STYLE_TO_PREFIX[s$5] = _objectSpread2$1(_objectSpread2$1({}, _LONG_STYLE_TO_PREFIX[s$5]), Ct$3.kit);
familyProxy(_LONG_STYLE_TO_PREFIX);
const ICON_SELECTION_SYNTAX_PATTERN = p$4, LAYERS_TEXT_CLASSNAME = "fa-layers-text", FONT_FAMILY_PATTERN = g$4, _FONT_WEIGHT_TO_PREFIX = _objectSpread2$1({}, G$3);
familyProxy(_FONT_WEIGHT_TO_PREFIX);
const ATTRIBUTES_WATCHED_FOR_MUTATION = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], DUOTONE_CLASSES = A$3, RESERVED_CLASSES = [...At$3, ...ma$1], initial$1 = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(Bi) {
  var e = DOCUMENT.querySelector("script[" + Bi + "]");
  if (e)
    return e.getAttribute(Bi);
}
function coerce(Bi) {
  return Bi === "" ? !0 : Bi === "false" ? !1 : Bi === "true" ? !0 : Bi;
}
DOCUMENT && typeof DOCUMENT.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((e) => {
  let [Zi, Qi] = e;
  const ea = coerce(getAttrConfig(Zi));
  ea != null && (initial$1[Qi] = ea);
});
const _default = {
  styleDefault: "solid",
  familyDefault: s$5,
  cssPrefix: DEFAULT_CSS_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
initial$1.familyPrefix && (initial$1.cssPrefix = initial$1.familyPrefix);
const _config = _objectSpread2$1(_objectSpread2$1({}, _default), initial$1);
_config.autoReplaceSvg || (_config.observeMutations = !1);
const config = {};
Object.keys(_default).forEach((Bi) => {
  Object.defineProperty(config, Bi, {
    enumerable: !0,
    set: function(e) {
      _config[Bi] = e, _onChangeCb.forEach((Zi) => Zi(config));
    },
    get: function() {
      return _config[Bi];
    }
  });
});
Object.defineProperty(config, "familyPrefix", {
  enumerable: !0,
  set: function(Bi) {
    _config.cssPrefix = Bi, _onChangeCb.forEach((e) => e(config));
  },
  get: function() {
    return _config.cssPrefix;
  }
});
WINDOW.FontAwesomeConfig = config;
const _onChangeCb = [];
function onChange(Bi) {
  return _onChangeCb.push(Bi), () => {
    _onChangeCb.splice(_onChangeCb.indexOf(Bi), 1);
  };
}
const d$2$1 = UNITS_IN_GRID, meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function insertCss(Bi) {
  if (!Bi || !IS_DOM)
    return;
  const e = DOCUMENT.createElement("style");
  e.setAttribute("type", "text/css"), e.innerHTML = Bi;
  const Zi = DOCUMENT.head.childNodes;
  let Qi = null;
  for (let ea = Zi.length - 1; ea > -1; ea--) {
    const ra = Zi[ea], na = (ra.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(na) > -1 && (Qi = ra);
  }
  return DOCUMENT.head.insertBefore(e, Qi), Bi;
}
const idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId$1() {
  let Bi = 12, e = "";
  for (; Bi-- > 0; )
    e += idPool[Math.random() * 62 | 0];
  return e;
}
function toArray(Bi) {
  const e = [];
  for (let Zi = (Bi || []).length >>> 0; Zi--; )
    e[Zi] = Bi[Zi];
  return e;
}
function classArray(Bi) {
  return Bi.classList ? toArray(Bi.classList) : (Bi.getAttribute("class") || "").split(" ").filter((e) => e);
}
function htmlEscape(Bi) {
  return "".concat(Bi).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(Bi) {
  return Object.keys(Bi || {}).reduce((e, Zi) => e + "".concat(Zi, '="').concat(htmlEscape(Bi[Zi]), '" '), "").trim();
}
function joinStyles(Bi) {
  return Object.keys(Bi || {}).reduce((e, Zi) => e + "".concat(Zi, ": ").concat(Bi[Zi].trim(), ";"), "");
}
function transformIsMeaningful(Bi) {
  return Bi.size !== meaninglessTransform.size || Bi.x !== meaninglessTransform.x || Bi.y !== meaninglessTransform.y || Bi.rotate !== meaninglessTransform.rotate || Bi.flipX || Bi.flipY;
}
function transformForSvg(Bi) {
  let {
    transform: e,
    containerWidth: Zi,
    iconWidth: Qi
  } = Bi;
  const ea = {
    transform: "translate(".concat(Zi / 2, " 256)")
  }, ra = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), na = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), ia = "rotate(".concat(e.rotate, " 0 0)"), fa = {
    transform: "".concat(ra, " ").concat(na, " ").concat(ia)
  }, La = {
    transform: "translate(".concat(Qi / 2 * -1, " -256)")
  };
  return {
    outer: ea,
    inner: fa,
    path: La
  };
}
function transformForCss(Bi) {
  let {
    transform: e,
    width: Zi = UNITS_IN_GRID,
    height: Qi = UNITS_IN_GRID,
    startCentered: ea = !1
  } = Bi, ra = "";
  return ea && IS_IE ? ra += "translate(".concat(e.x / d$2$1 - Zi / 2, "em, ").concat(e.y / d$2$1 - Qi / 2, "em) ") : ea ? ra += "translate(calc(-50% + ".concat(e.x / d$2$1, "em), calc(-50% + ").concat(e.y / d$2$1, "em)) ") : ra += "translate(".concat(e.x / d$2$1, "em, ").concat(e.y / d$2$1, "em) "), ra += "scale(".concat(e.size / d$2$1 * (e.flipX ? -1 : 1), ", ").concat(e.size / d$2$1 * (e.flipY ? -1 : 1), ") "), ra += "rotate(".concat(e.rotate, "deg) "), ra;
}
var baseStyles = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function css() {
  const Bi = DEFAULT_CSS_PREFIX, e = DEFAULT_REPLACEMENT_CLASS, Zi = config.cssPrefix, Qi = config.replacementClass;
  let ea = baseStyles;
  if (Zi !== Bi || Qi !== e) {
    const ra = new RegExp("\\.".concat(Bi, "\\-"), "g"), na = new RegExp("\\--".concat(Bi, "\\-"), "g"), ia = new RegExp("\\.".concat(e), "g");
    ea = ea.replace(ra, ".".concat(Zi, "-")).replace(na, "--".concat(Zi, "-")).replace(ia, ".".concat(Qi));
  }
  return ea;
}
let _cssInserted = !1;
function ensureCss() {
  config.autoAddCss && !_cssInserted && (insertCss(css()), _cssInserted = !0);
}
var InjectCSS = {
  mixout() {
    return {
      dom: {
        css,
        insertCss: ensureCss
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg() {
        ensureCss();
      }
    };
  }
};
const w$3 = WINDOW || {};
w$3[NAMESPACE_IDENTIFIER] || (w$3[NAMESPACE_IDENTIFIER] = {});
w$3[NAMESPACE_IDENTIFIER].styles || (w$3[NAMESPACE_IDENTIFIER].styles = {});
w$3[NAMESPACE_IDENTIFIER].hooks || (w$3[NAMESPACE_IDENTIFIER].hooks = {});
w$3[NAMESPACE_IDENTIFIER].shims || (w$3[NAMESPACE_IDENTIFIER].shims = []);
var namespace = w$3[NAMESPACE_IDENTIFIER];
const functions = [], listener = function() {
  DOCUMENT.removeEventListener("DOMContentLoaded", listener), loaded = 1, functions.map((Bi) => Bi());
};
let loaded = !1;
IS_DOM && (loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState), loaded || DOCUMENT.addEventListener("DOMContentLoaded", listener));
function domready(Bi) {
  IS_DOM && (loaded ? setTimeout(Bi, 0) : functions.push(Bi));
}
function toHtml(Bi) {
  const {
    tag: e,
    attributes: Zi = {},
    children: Qi = []
  } = Bi;
  return typeof Bi == "string" ? htmlEscape(Bi) : "<".concat(e, " ").concat(joinAttributes(Zi), ">").concat(Qi.map(toHtml).join(""), "</").concat(e, ">");
}
function iconFromMapping(Bi, e, Zi) {
  if (Bi && Bi[e] && Bi[e][Zi])
    return {
      prefix: e,
      iconName: Zi,
      icon: Bi[e][Zi]
    };
}
var reduce$6 = function(e, Zi, Qi, ea) {
  var ra = Object.keys(e), na = ra.length, ia = Zi, fa, La, Va;
  for (Qi === void 0 ? (fa = 1, Va = e[ra[0]]) : (fa = 0, Va = Qi); fa < na; fa++)
    La = ra[fa], Va = ia(Va, e[La], La, e);
  return Va;
};
function ucs2decode(Bi) {
  const e = [];
  let Zi = 0;
  const Qi = Bi.length;
  for (; Zi < Qi; ) {
    const ea = Bi.charCodeAt(Zi++);
    if (ea >= 55296 && ea <= 56319 && Zi < Qi) {
      const ra = Bi.charCodeAt(Zi++);
      (ra & 64512) == 56320 ? e.push(((ea & 1023) << 10) + (ra & 1023) + 65536) : (e.push(ea), Zi--);
    } else
      e.push(ea);
  }
  return e;
}
function toHex(Bi) {
  const e = ucs2decode(Bi);
  return e.length === 1 ? e[0].toString(16) : null;
}
function codePointAt(Bi, e) {
  const Zi = Bi.length;
  let Qi = Bi.charCodeAt(e), ea;
  return Qi >= 55296 && Qi <= 56319 && Zi > e + 1 && (ea = Bi.charCodeAt(e + 1), ea >= 56320 && ea <= 57343) ? (Qi - 55296) * 1024 + ea - 56320 + 65536 : Qi;
}
function normalizeIcons(Bi) {
  return Object.keys(Bi).reduce((e, Zi) => {
    const Qi = Bi[Zi];
    return !!Qi.icon ? e[Qi.iconName] = Qi.icon : e[Zi] = Qi, e;
  }, {});
}
function defineIcons(Bi, e) {
  let Zi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: Qi = !1
  } = Zi, ea = normalizeIcons(e);
  typeof namespace.hooks.addPack == "function" && !Qi ? namespace.hooks.addPack(Bi, normalizeIcons(e)) : namespace.styles[Bi] = _objectSpread2$1(_objectSpread2$1({}, namespace.styles[Bi] || {}), ea), Bi === "fas" && defineIcons("fa", e);
}
const {
  styles: styles$1,
  shims
} = namespace, FAMILY_NAMES = Object.keys(PREFIX_TO_LONG_STYLE), PREFIXES_FOR_FAMILY = FAMILY_NAMES.reduce((Bi, e) => (Bi[e] = Object.keys(PREFIX_TO_LONG_STYLE[e]), Bi), {});
let _defaultUsablePrefix = null, _byUnicode = {}, _byLigature = {}, _byOldName = {}, _byOldUnicode = {}, _byAlias = {};
function isReserved(Bi) {
  return ~RESERVED_CLASSES.indexOf(Bi);
}
function getIconName(Bi, e) {
  const Zi = e.split("-"), Qi = Zi[0], ea = Zi.slice(1).join("-");
  return Qi === Bi && ea !== "" && !isReserved(ea) ? ea : null;
}
const build = () => {
  const Bi = (Qi) => reduce$6(styles$1, (ea, ra, na) => (ea[na] = reduce$6(ra, Qi, {}), ea), {});
  _byUnicode = Bi((Qi, ea, ra) => (ea[3] && (Qi[ea[3]] = ra), ea[2] && ea[2].filter((ia) => typeof ia == "number").forEach((ia) => {
    Qi[ia.toString(16)] = ra;
  }), Qi)), _byLigature = Bi((Qi, ea, ra) => (Qi[ra] = ra, ea[2] && ea[2].filter((ia) => typeof ia == "string").forEach((ia) => {
    Qi[ia] = ra;
  }), Qi)), _byAlias = Bi((Qi, ea, ra) => {
    const na = ea[2];
    return Qi[ra] = ra, na.forEach((ia) => {
      Qi[ia] = ra;
    }), Qi;
  });
  const e = "far" in styles$1 || config.autoFetchSvg, Zi = reduce$6(shims, (Qi, ea) => {
    const ra = ea[0];
    let na = ea[1];
    const ia = ea[2];
    return na === "far" && !e && (na = "fas"), typeof ra == "string" && (Qi.names[ra] = {
      prefix: na,
      iconName: ia
    }), typeof ra == "number" && (Qi.unicodes[ra.toString(16)] = {
      prefix: na,
      iconName: ia
    }), Qi;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = Zi.names, _byOldUnicode = Zi.unicodes, _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
    family: config.familyDefault
  });
};
onChange((Bi) => {
  _defaultUsablePrefix = getCanonicalPrefix(Bi.styleDefault, {
    family: config.familyDefault
  });
});
build();
function byUnicode(Bi, e) {
  return (_byUnicode[Bi] || {})[e];
}
function byLigature(Bi, e) {
  return (_byLigature[Bi] || {})[e];
}
function byAlias(Bi, e) {
  return (_byAlias[Bi] || {})[e];
}
function byOldName(Bi) {
  return _byOldName[Bi] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(Bi) {
  const e = _byOldUnicode[Bi], Zi = byUnicode("fas", Bi);
  return e || (Zi ? {
    prefix: "fas",
    iconName: Zi
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
const emptyCanonicalIcon = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function getFamilyId(Bi) {
  let e = s$5;
  const Zi = FAMILY_NAMES.reduce((Qi, ea) => (Qi[ea] = "".concat(config.cssPrefix, "-").concat(ea), Qi), {});
  return L$3.forEach((Qi) => {
    (Bi.includes(Zi[Qi]) || Bi.some((ea) => PREFIXES_FOR_FAMILY[Qi].includes(ea))) && (e = Qi);
  }), e;
}
function getCanonicalPrefix(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: Zi = s$5
  } = e, Qi = PREFIX_TO_STYLE[Zi][Bi];
  if (Zi === t$7 && !Bi)
    return "fad";
  const ea = STYLE_TO_PREFIX[Zi][Bi] || STYLE_TO_PREFIX[Zi][Qi], ra = Bi in namespace.styles ? Bi : null;
  return ea || ra || null;
}
function moveNonFaClassesToRest(Bi) {
  let e = [], Zi = null;
  return Bi.forEach((Qi) => {
    const ea = getIconName(config.cssPrefix, Qi);
    ea ? Zi = ea : Qi && e.push(Qi);
  }), {
    iconName: Zi,
    rest: e
  };
}
function sortedUniqueValues(Bi) {
  return Bi.sort().filter((e, Zi, Qi) => Qi.indexOf(e) === Zi);
}
function getCanonicalIcon(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: Zi = !1
  } = e;
  let Qi = null;
  const ea = Ia$1.concat(bt$1$1), ra = sortedUniqueValues(Bi.filter((to) => ea.includes(to))), na = sortedUniqueValues(Bi.filter((to) => !Ia$1.includes(to))), ia = ra.filter((to) => (Qi = to, !P$4.includes(to))), [fa = null] = ia, La = getFamilyId(ra), Va = _objectSpread2$1(_objectSpread2$1({}, moveNonFaClassesToRest(na)), {}, {
    prefix: getCanonicalPrefix(fa, {
      family: La
    })
  });
  return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, Va), getDefaultCanonicalPrefix({
    values: Bi,
    family: La,
    styles: styles$1,
    config,
    canonical: Va,
    givenPrefix: Qi
  })), applyShimAndAlias(Zi, Qi, Va));
}
function applyShimAndAlias(Bi, e, Zi) {
  let {
    prefix: Qi,
    iconName: ea
  } = Zi;
  if (Bi || !Qi || !ea)
    return {
      prefix: Qi,
      iconName: ea
    };
  const ra = e === "fa" ? byOldName(ea) : {}, na = byAlias(Qi, ea);
  return ea = ra.iconName || na || ea, Qi = ra.prefix || Qi, Qi === "far" && !styles$1.far && styles$1.fas && !config.autoFetchSvg && (Qi = "fas"), {
    prefix: Qi,
    iconName: ea
  };
}
const newCanonicalFamilies = L$3.filter((Bi) => Bi !== s$5 || Bi !== t$7), newCanonicalStyles = Object.keys(ga$1).filter((Bi) => Bi !== s$5).map((Bi) => Object.keys(ga$1[Bi])).flat();
function getDefaultCanonicalPrefix(Bi) {
  const {
    values: e,
    family: Zi,
    canonical: Qi,
    givenPrefix: ea = "",
    styles: ra = {},
    config: na = {}
  } = Bi, ia = Zi === t$7, fa = e.includes("fa-duotone") || e.includes("fad"), La = na.familyDefault === "duotone", Va = Qi.prefix === "fad" || Qi.prefix === "fa-duotone";
  if (!ia && (fa || La || Va) && (Qi.prefix = "fad"), (e.includes("fa-brands") || e.includes("fab")) && (Qi.prefix = "fab"), !Qi.prefix && newCanonicalFamilies.includes(Zi) && (Object.keys(ra).find((ro) => newCanonicalStyles.includes(ro)) || na.autoFetchSvg)) {
    const ro = pt$3.get(Zi).defaultShortPrefixId;
    Qi.prefix = ro, Qi.iconName = byAlias(Qi.prefix, Qi.iconName) || Qi.iconName;
  }
  return (Qi.prefix === "fa" || ea === "fa") && (Qi.prefix = getDefaultUsablePrefix() || "fas"), Qi;
}
class Library {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var e = arguments.length, Zi = new Array(e), Qi = 0; Qi < e; Qi++)
      Zi[Qi] = arguments[Qi];
    const ea = Zi.reduce(this._pullDefinitions, {});
    Object.keys(ea).forEach((ra) => {
      this.definitions[ra] = _objectSpread2$1(_objectSpread2$1({}, this.definitions[ra] || {}), ea[ra]), defineIcons(ra, ea[ra]);
      const na = PREFIX_TO_LONG_STYLE[s$5][ra];
      na && defineIcons(na, ea[ra]), build();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(e, Zi) {
    const Qi = Zi.prefix && Zi.iconName && Zi.icon ? {
      0: Zi
    } : Zi;
    return Object.keys(Qi).map((ea) => {
      const {
        prefix: ra,
        iconName: na,
        icon: ia
      } = Qi[ea], fa = ia[2];
      e[ra] || (e[ra] = {}), fa.length > 0 && fa.forEach((La) => {
        typeof La == "string" && (e[ra][La] = ia);
      }), e[ra][na] = ia;
    }), e;
  }
}
let _plugins = [], _hooks = {};
const providers = {}, defaultProviderKeys = Object.keys(providers);
function registerPlugins(Bi, e) {
  let {
    mixoutsTo: Zi
  } = e;
  return _plugins = Bi, _hooks = {}, Object.keys(providers).forEach((Qi) => {
    defaultProviderKeys.indexOf(Qi) === -1 && delete providers[Qi];
  }), _plugins.forEach((Qi) => {
    const ea = Qi.mixout ? Qi.mixout() : {};
    if (Object.keys(ea).forEach((ra) => {
      typeof ea[ra] == "function" && (Zi[ra] = ea[ra]), typeof ea[ra] == "object" && Object.keys(ea[ra]).forEach((na) => {
        Zi[ra] || (Zi[ra] = {}), Zi[ra][na] = ea[ra][na];
      });
    }), Qi.hooks) {
      const ra = Qi.hooks();
      Object.keys(ra).forEach((na) => {
        _hooks[na] || (_hooks[na] = []), _hooks[na].push(ra[na]);
      });
    }
    Qi.provides && Qi.provides(providers);
  }), Zi;
}
function chainHooks(Bi, e) {
  for (var Zi = arguments.length, Qi = new Array(Zi > 2 ? Zi - 2 : 0), ea = 2; ea < Zi; ea++)
    Qi[ea - 2] = arguments[ea];
  return (_hooks[Bi] || []).forEach((na) => {
    e = na.apply(null, [e, ...Qi]);
  }), e;
}
function callHooks(Bi) {
  for (var e = arguments.length, Zi = new Array(e > 1 ? e - 1 : 0), Qi = 1; Qi < e; Qi++)
    Zi[Qi - 1] = arguments[Qi];
  (_hooks[Bi] || []).forEach((ra) => {
    ra.apply(null, Zi);
  });
}
function callProvided() {
  const Bi = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return providers[Bi] ? providers[Bi].apply(null, e) : void 0;
}
function findIconDefinition(Bi) {
  Bi.prefix === "fa" && (Bi.prefix = "fas");
  let {
    iconName: e
  } = Bi;
  const Zi = Bi.prefix || getDefaultUsablePrefix();
  if (e)
    return e = byAlias(Zi, e) || e, iconFromMapping(library.definitions, Zi, e) || iconFromMapping(namespace.styles, Zi, e);
}
const library = new Library(), noAuto = () => {
  config.autoReplaceSvg = !1, config.observeMutations = !1, callHooks("noAuto");
}, dom = {
  i2svg: function() {
    let Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return IS_DOM ? (callHooks("beforeI2svg", Bi), callProvided("pseudoElements2svg", Bi), callProvided("i2svg", Bi)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: e
    } = Bi;
    config.autoReplaceSvg === !1 && (config.autoReplaceSvg = !0), config.observeMutations = !0, domready(() => {
      autoReplace({
        autoReplaceSvgRoot: e
      }), callHooks("watch", Bi);
    });
  }
}, parse$1 = {
  icon: (Bi) => {
    if (Bi === null)
      return null;
    if (typeof Bi == "object" && Bi.prefix && Bi.iconName)
      return {
        prefix: Bi.prefix,
        iconName: byAlias(Bi.prefix, Bi.iconName) || Bi.iconName
      };
    if (Array.isArray(Bi) && Bi.length === 2) {
      const e = Bi[1].indexOf("fa-") === 0 ? Bi[1].slice(3) : Bi[1], Zi = getCanonicalPrefix(Bi[0]);
      return {
        prefix: Zi,
        iconName: byAlias(Zi, e) || e
      };
    }
    if (typeof Bi == "string" && (Bi.indexOf("".concat(config.cssPrefix, "-")) > -1 || Bi.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      const e = getCanonicalIcon(Bi.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: e.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(e.prefix, e.iconName) || e.iconName
      };
    }
    if (typeof Bi == "string") {
      const e = getDefaultUsablePrefix();
      return {
        prefix: e,
        iconName: byAlias(e, Bi) || Bi
      };
    }
  }
}, api = {
  noAuto,
  config,
  dom,
  parse: parse$1,
  library,
  findIconDefinition,
  toHtml
}, autoReplace = function() {
  let Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: e = DOCUMENT
  } = Bi;
  (Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg && api.dom.i2svg({
    node: e
  });
};
function domVariants(Bi, e) {
  return Object.defineProperty(Bi, "abstract", {
    get: e
  }), Object.defineProperty(Bi, "html", {
    get: function() {
      return Bi.abstract.map((Zi) => toHtml(Zi));
    }
  }), Object.defineProperty(Bi, "node", {
    get: function() {
      if (!IS_DOM) return;
      const Zi = DOCUMENT.createElement("div");
      return Zi.innerHTML = Bi.html, Zi.children;
    }
  }), Bi;
}
function asIcon(Bi) {
  let {
    children: e,
    main: Zi,
    mask: Qi,
    attributes: ea,
    styles: ra,
    transform: na
  } = Bi;
  if (transformIsMeaningful(na) && Zi.found && !Qi.found) {
    const {
      width: ia,
      height: fa
    } = Zi, La = {
      x: ia / fa / 2,
      y: 0.5
    };
    ea.style = joinStyles(_objectSpread2$1(_objectSpread2$1({}, ra), {}, {
      "transform-origin": "".concat(La.x + na.x / 16, "em ").concat(La.y + na.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: ea,
    children: e
  }];
}
function asSymbol(Bi) {
  let {
    prefix: e,
    iconName: Zi,
    children: Qi,
    attributes: ea,
    symbol: ra
  } = Bi;
  const na = ra === !0 ? "".concat(e, "-").concat(config.cssPrefix, "-").concat(Zi) : ra;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: _objectSpread2$1(_objectSpread2$1({}, ea), {}, {
        id: na
      }),
      children: Qi
    }]
  }];
}
function makeInlineSvgAbstract(Bi) {
  const {
    icons: {
      main: e,
      mask: Zi
    },
    prefix: Qi,
    iconName: ea,
    transform: ra,
    symbol: na,
    title: ia,
    maskId: fa,
    titleId: La,
    extra: Va,
    watchable: to = !1
  } = Bi, {
    width: ro,
    height: no
  } = Zi.found ? Zi : e, eo = Lt$3.includes(Qi), ao = [config.replacementClass, ea ? "".concat(config.cssPrefix, "-").concat(ea) : ""].filter((Do) => Va.classes.indexOf(Do) === -1).filter((Do) => Do !== "" || !!Do).concat(Va.classes).join(" ");
  let io = {
    children: [],
    attributes: _objectSpread2$1(_objectSpread2$1({}, Va.attributes), {}, {
      "data-prefix": Qi,
      "data-icon": ea,
      class: ao,
      role: Va.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(ro, " ").concat(no)
    })
  };
  const xs = eo && !~Va.classes.indexOf("fa-fw") ? {
    width: "".concat(ro / no * 16 * 0.0625, "em")
  } : {};
  to && (io.attributes[DATA_FA_I2SVG] = ""), ia && (io.children.push({
    tag: "title",
    attributes: {
      id: io.attributes["aria-labelledby"] || "title-".concat(La || nextUniqueId$1())
    },
    children: [ia]
  }), delete io.attributes.title);
  const Ts = _objectSpread2$1(_objectSpread2$1({}, io), {}, {
    prefix: Qi,
    iconName: ea,
    main: e,
    mask: Zi,
    maskId: fa,
    transform: ra,
    symbol: na,
    styles: _objectSpread2$1(_objectSpread2$1({}, xs), Va.styles)
  }), {
    children: qs,
    attributes: Fs
  } = Zi.found && e.found ? callProvided("generateAbstractMask", Ts) || {
    children: [],
    attributes: {}
  } : callProvided("generateAbstractIcon", Ts) || {
    children: [],
    attributes: {}
  };
  return Ts.children = qs, Ts.attributes = Fs, na ? asSymbol(Ts) : asIcon(Ts);
}
function makeLayersTextAbstract(Bi) {
  const {
    content: e,
    width: Zi,
    height: Qi,
    transform: ea,
    title: ra,
    extra: na,
    watchable: ia = !1
  } = Bi, fa = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, na.attributes), ra ? {
    title: ra
  } : {}), {}, {
    class: na.classes.join(" ")
  });
  ia && (fa[DATA_FA_I2SVG] = "");
  const La = _objectSpread2$1({}, na.styles);
  transformIsMeaningful(ea) && (La.transform = transformForCss({
    transform: ea,
    startCentered: !0,
    width: Zi,
    height: Qi
  }), La["-webkit-transform"] = La.transform);
  const Va = joinStyles(La);
  Va.length > 0 && (fa.style = Va);
  const to = [];
  return to.push({
    tag: "span",
    attributes: fa,
    children: [e]
  }), ra && to.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [ra]
  }), to;
}
function makeLayersCounterAbstract(Bi) {
  const {
    content: e,
    title: Zi,
    extra: Qi
  } = Bi, ea = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, Qi.attributes), Zi ? {
    title: Zi
  } : {}), {}, {
    class: Qi.classes.join(" ")
  }), ra = joinStyles(Qi.styles);
  ra.length > 0 && (ea.style = ra);
  const na = [];
  return na.push({
    tag: "span",
    attributes: ea,
    children: [e]
  }), Zi && na.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [Zi]
  }), na;
}
const {
  styles: styles$1$1
} = namespace;
function asFoundIcon(Bi) {
  const e = Bi[0], Zi = Bi[1], [Qi] = Bi.slice(4);
  let ea = null;
  return Array.isArray(Qi) ? ea = {
    tag: "g",
    attributes: {
      class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
        fill: "currentColor",
        d: Qi[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
        fill: "currentColor",
        d: Qi[1]
      }
    }]
  } : ea = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: Qi
    }
  }, {
    found: !0,
    width: e,
    height: Zi,
    icon: ea
  };
}
const missingIconResolutionMixin = {
  found: !1,
  width: 512,
  height: 512
};
function maybeNotifyMissing(Bi, e) {
  !PRODUCTION$1 && !config.showMissingIcons && Bi && console.error('Icon with name "'.concat(Bi, '" and prefix "').concat(e, '" is missing.'));
}
function findIcon(Bi, e) {
  let Zi = e;
  return e === "fa" && config.styleDefault !== null && (e = getDefaultUsablePrefix()), new Promise((Qi, ea) => {
    if (Zi === "fa") {
      const ra = byOldName(Bi) || {};
      Bi = ra.iconName || Bi, e = ra.prefix || e;
    }
    if (Bi && e && styles$1$1[e] && styles$1$1[e][Bi]) {
      const ra = styles$1$1[e][Bi];
      return Qi(asFoundIcon(ra));
    }
    maybeNotifyMissing(Bi, e), Qi(_objectSpread2$1(_objectSpread2$1({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && Bi ? callProvided("missingIconAbstract") || {} : {}
    }));
  });
}
const noop$1$1 = () => {
}, p$2$1 = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1$1,
  measure: noop$1$1
}, preamble = 'FA "6.7.2"', begin = (Bi) => (p$2$1.mark("".concat(preamble, " ").concat(Bi, " begins")), () => end(Bi)), end = (Bi) => {
  p$2$1.mark("".concat(preamble, " ").concat(Bi, " ends")), p$2$1.measure("".concat(preamble, " ").concat(Bi), "".concat(preamble, " ").concat(Bi, " begins"), "".concat(preamble, " ").concat(Bi, " ends"));
};
var perf = {
  begin,
  end
};
const noop$2$1 = () => {
};
function isWatched$1(Bi) {
  return typeof (Bi.getAttribute ? Bi.getAttribute(DATA_FA_I2SVG) : null) == "string";
}
function hasPrefixAndIcon(Bi) {
  const e = Bi.getAttribute ? Bi.getAttribute(DATA_PREFIX) : null, Zi = Bi.getAttribute ? Bi.getAttribute(DATA_ICON) : null;
  return e && Zi;
}
function hasBeenReplaced(Bi) {
  return Bi && Bi.classList && Bi.classList.contains && Bi.classList.contains(config.replacementClass);
}
function getMutator() {
  return config.autoReplaceSvg === !0 ? mutators.replace : mutators[config.autoReplaceSvg] || mutators.replace;
}
function createElementNS(Bi) {
  return DOCUMENT.createElementNS("http://www.w3.org/2000/svg", Bi);
}
function createElement(Bi) {
  return DOCUMENT.createElement(Bi);
}
function convertSVG(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: Zi = Bi.tag === "svg" ? createElementNS : createElement
  } = e;
  if (typeof Bi == "string")
    return DOCUMENT.createTextNode(Bi);
  const Qi = Zi(Bi.tag);
  return Object.keys(Bi.attributes || []).forEach(function(ra) {
    Qi.setAttribute(ra, Bi.attributes[ra]);
  }), (Bi.children || []).forEach(function(ra) {
    Qi.appendChild(convertSVG(ra, {
      ceFn: Zi
    }));
  }), Qi;
}
function nodeAsComment(Bi) {
  let e = " ".concat(Bi.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
const mutators = {
  replace: function(Bi) {
    const e = Bi[0];
    if (e.parentNode)
      if (Bi[1].forEach((Zi) => {
        e.parentNode.insertBefore(convertSVG(Zi), e);
      }), e.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        let Zi = DOCUMENT.createComment(nodeAsComment(e));
        e.parentNode.replaceChild(Zi, e);
      } else
        e.remove();
  },
  nest: function(Bi) {
    const e = Bi[0], Zi = Bi[1];
    if (~classArray(e).indexOf(config.replacementClass))
      return mutators.replace(Bi);
    const Qi = new RegExp("".concat(config.cssPrefix, "-.*"));
    if (delete Zi[0].attributes.id, Zi[0].attributes.class) {
      const ra = Zi[0].attributes.class.split(" ").reduce((na, ia) => (ia === config.replacementClass || ia.match(Qi) ? na.toSvg.push(ia) : na.toNode.push(ia), na), {
        toNode: [],
        toSvg: []
      });
      Zi[0].attributes.class = ra.toSvg.join(" "), ra.toNode.length === 0 ? e.removeAttribute("class") : e.setAttribute("class", ra.toNode.join(" "));
    }
    const ea = Zi.map((ra) => toHtml(ra)).join(`
`);
    e.setAttribute(DATA_FA_I2SVG, ""), e.innerHTML = ea;
  }
};
function performOperationSync(Bi) {
  Bi();
}
function perform(Bi, e) {
  const Zi = typeof e == "function" ? e : noop$2$1;
  if (Bi.length === 0)
    Zi();
  else {
    let Qi = performOperationSync;
    config.mutateApproach === MUTATION_APPROACH_ASYNC && (Qi = WINDOW.requestAnimationFrame || performOperationSync), Qi(() => {
      const ea = getMutator(), ra = perf.begin("mutate");
      Bi.map(ea), ra(), Zi();
    });
  }
}
let disabled = !1;
function disableObservation() {
  disabled = !0;
}
function enableObservation() {
  disabled = !1;
}
let mo$1 = null;
function observe(Bi) {
  if (!MUTATION_OBSERVER || !config.observeMutations)
    return;
  const {
    treeCallback: e = noop$2$1,
    nodeCallback: Zi = noop$2$1,
    pseudoElementsCallback: Qi = noop$2$1,
    observeMutationsRoot: ea = DOCUMENT
  } = Bi;
  mo$1 = new MUTATION_OBSERVER((ra) => {
    if (disabled) return;
    const na = getDefaultUsablePrefix();
    toArray(ra).forEach((ia) => {
      if (ia.type === "childList" && ia.addedNodes.length > 0 && !isWatched$1(ia.addedNodes[0]) && (config.searchPseudoElements && Qi(ia.target), e(ia.target)), ia.type === "attributes" && ia.target.parentNode && config.searchPseudoElements && Qi(ia.target.parentNode), ia.type === "attributes" && isWatched$1(ia.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(ia.attributeName))
        if (ia.attributeName === "class" && hasPrefixAndIcon(ia.target)) {
          const {
            prefix: fa,
            iconName: La
          } = getCanonicalIcon(classArray(ia.target));
          ia.target.setAttribute(DATA_PREFIX, fa || na), La && ia.target.setAttribute(DATA_ICON, La);
        } else hasBeenReplaced(ia.target) && Zi(ia.target);
    });
  }), IS_DOM && mo$1.observe(ea, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function disconnect() {
  mo$1 && mo$1.disconnect();
}
function styleParser(Bi) {
  const e = Bi.getAttribute("style");
  let Zi = [];
  return e && (Zi = e.split(";").reduce((Qi, ea) => {
    const ra = ea.split(":"), na = ra[0], ia = ra.slice(1);
    return na && ia.length > 0 && (Qi[na] = ia.join(":").trim()), Qi;
  }, {})), Zi;
}
function classParser(Bi) {
  const e = Bi.getAttribute("data-prefix"), Zi = Bi.getAttribute("data-icon"), Qi = Bi.innerText !== void 0 ? Bi.innerText.trim() : "";
  let ea = getCanonicalIcon(classArray(Bi));
  return ea.prefix || (ea.prefix = getDefaultUsablePrefix()), e && Zi && (ea.prefix = e, ea.iconName = Zi), ea.iconName && ea.prefix || (ea.prefix && Qi.length > 0 && (ea.iconName = byLigature(ea.prefix, Bi.innerText) || byUnicode(ea.prefix, toHex(Bi.innerText))), !ea.iconName && config.autoFetchSvg && Bi.firstChild && Bi.firstChild.nodeType === Node.TEXT_NODE && (ea.iconName = Bi.firstChild.data)), ea;
}
function attributesParser(Bi) {
  const e = toArray(Bi.attributes).reduce((ea, ra) => (ea.name !== "class" && ea.name !== "style" && (ea[ra.name] = ra.value), ea), {}), Zi = Bi.getAttribute("title"), Qi = Bi.getAttribute("data-fa-title-id");
  return config.autoA11y && (Zi ? e["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(Qi || nextUniqueId$1()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: Zi,
    prefix: Qi,
    rest: ea
  } = classParser(Bi), ra = attributesParser(Bi), na = chainHooks("parseNodeAttributes", {}, Bi);
  let ia = e.styleParser ? styleParser(Bi) : [];
  return _objectSpread2$1({
    iconName: Zi,
    title: Bi.getAttribute("title"),
    titleId: Bi.getAttribute("data-fa-title-id"),
    prefix: Qi,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: ea,
      styles: ia,
      attributes: ra
    }
  }, na);
}
const {
  styles: styles$2
} = namespace;
function generateMutation(Bi) {
  const e = config.autoReplaceSvg === "nest" ? parseMeta(Bi, {
    styleParser: !1
  }) : parseMeta(Bi);
  return ~e.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME) ? callProvided("generateLayersText", Bi, e) : callProvided("generateSvgReplacementMutation", Bi, e);
}
function getKnownPrefixes() {
  return [...Ft$3, ...Ia$1];
}
function onTree(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  const Zi = DOCUMENT.documentElement.classList, Qi = (Va) => Zi.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(Va)), ea = (Va) => Zi.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(Va)), ra = config.autoFetchSvg ? getKnownPrefixes() : P$4.concat(Object.keys(styles$2));
  ra.includes("fa") || ra.push("fa");
  const na = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(ra.map((Va) => ".".concat(Va, ":not([").concat(DATA_FA_I2SVG, "])"))).join(", ");
  if (na.length === 0)
    return Promise.resolve();
  let ia = [];
  try {
    ia = toArray(Bi.querySelectorAll(na));
  } catch {
  }
  if (ia.length > 0)
    Qi("pending"), ea("complete");
  else
    return Promise.resolve();
  const fa = perf.begin("onTree"), La = ia.reduce((Va, to) => {
    try {
      const ro = generateMutation(to);
      ro && Va.push(ro);
    } catch (ro) {
      PRODUCTION$1 || ro.name === "MissingIcon" && console.error(ro);
    }
    return Va;
  }, []);
  return new Promise((Va, to) => {
    Promise.all(La).then((ro) => {
      perform(ro, () => {
        Qi("active"), Qi("complete"), ea("pending"), typeof e == "function" && e(), fa(), Va();
      });
    }).catch((ro) => {
      fa(), to(ro);
    });
  });
}
function onNode(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  generateMutation(Bi).then((Zi) => {
    Zi && perform([Zi], e);
  });
}
function resolveIcons(Bi) {
  return function(e) {
    let Zi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const Qi = (e || {}).icon ? e : findIconDefinition(e || {});
    let {
      mask: ea
    } = Zi;
    return ea && (ea = (ea || {}).icon ? ea : findIconDefinition(ea || {})), Bi(Qi, _objectSpread2$1(_objectSpread2$1({}, Zi), {}, {
      mask: ea
    }));
  };
}
const render = function(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: Zi = meaninglessTransform,
    symbol: Qi = !1,
    mask: ea = null,
    maskId: ra = null,
    title: na = null,
    titleId: ia = null,
    classes: fa = [],
    attributes: La = {},
    styles: Va = {}
  } = e;
  if (!Bi) return;
  const {
    prefix: to,
    iconName: ro,
    icon: no
  } = Bi;
  return domVariants(_objectSpread2$1({
    type: "icon"
  }, Bi), () => (callHooks("beforeDOMElementCreation", {
    iconDefinition: Bi,
    params: e
  }), config.autoA11y && (na ? La["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(ia || nextUniqueId$1()) : (La["aria-hidden"] = "true", La.focusable = "false")), makeInlineSvgAbstract({
    icons: {
      main: asFoundIcon(no),
      mask: ea ? asFoundIcon(ea.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: to,
    iconName: ro,
    transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), Zi),
    symbol: Qi,
    title: na,
    maskId: ra,
    titleId: ia,
    extra: {
      attributes: La,
      styles: Va,
      classes: fa
    }
  })));
};
var ReplaceElements = {
  mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(Bi) {
        return Bi.treeCallback = onTree, Bi.nodeCallback = onNode, Bi;
      }
    };
  },
  provides(Bi) {
    Bi.i2svg = function(e) {
      const {
        node: Zi = DOCUMENT,
        callback: Qi = () => {
        }
      } = e;
      return onTree(Zi, Qi);
    }, Bi.generateSvgReplacementMutation = function(e, Zi) {
      const {
        iconName: Qi,
        title: ea,
        titleId: ra,
        prefix: na,
        transform: ia,
        symbol: fa,
        mask: La,
        maskId: Va,
        extra: to
      } = Zi;
      return new Promise((ro, no) => {
        Promise.all([findIcon(Qi, na), La.iconName ? findIcon(La.iconName, La.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((eo) => {
          let [ao, io] = eo;
          ro([e, makeInlineSvgAbstract({
            icons: {
              main: ao,
              mask: io
            },
            prefix: na,
            iconName: Qi,
            transform: ia,
            symbol: fa,
            maskId: Va,
            title: ea,
            titleId: ra,
            extra: to,
            watchable: !0
          })]);
        }).catch(no);
      });
    }, Bi.generateAbstractIcon = function(e) {
      let {
        children: Zi,
        attributes: Qi,
        main: ea,
        transform: ra,
        styles: na
      } = e;
      const ia = joinStyles(na);
      ia.length > 0 && (Qi.style = ia);
      let fa;
      return transformIsMeaningful(ra) && (fa = callProvided("generateAbstractTransformGrouping", {
        main: ea,
        transform: ra,
        containerWidth: ea.width,
        iconWidth: ea.width
      })), Zi.push(fa || ea.icon), {
        children: Zi,
        attributes: Qi
      };
    };
  }
}, Layers = {
  mixout() {
    return {
      layer(Bi) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: Zi = []
        } = e;
        return domVariants({
          type: "layer"
        }, () => {
          callHooks("beforeDOMElementCreation", {
            assembler: Bi,
            params: e
          });
          let Qi = [];
          return Bi((ea) => {
            Array.isArray(ea) ? ea.map((ra) => {
              Qi = Qi.concat(ra.abstract);
            }) : Qi = Qi.concat(ea.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(config.cssPrefix, "-layers"), ...Zi].join(" ")
            },
            children: Qi
          }];
        });
      }
    };
  }
}, LayersCounter = {
  mixout() {
    return {
      counter(Bi) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: Zi = null,
          classes: Qi = [],
          attributes: ea = {},
          styles: ra = {}
        } = e;
        return domVariants({
          type: "counter",
          content: Bi
        }, () => (callHooks("beforeDOMElementCreation", {
          content: Bi,
          params: e
        }), makeLayersCounterAbstract({
          content: Bi.toString(),
          title: Zi,
          extra: {
            attributes: ea,
            styles: ra,
            classes: ["".concat(config.cssPrefix, "-layers-counter"), ...Qi]
          }
        })));
      }
    };
  }
}, LayersText = {
  mixout() {
    return {
      text(Bi) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: Zi = meaninglessTransform,
          title: Qi = null,
          classes: ea = [],
          attributes: ra = {},
          styles: na = {}
        } = e;
        return domVariants({
          type: "text",
          content: Bi
        }, () => (callHooks("beforeDOMElementCreation", {
          content: Bi,
          params: e
        }), makeLayersTextAbstract({
          content: Bi,
          transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), Zi),
          title: Qi,
          extra: {
            attributes: ra,
            styles: na,
            classes: ["".concat(config.cssPrefix, "-layers-text"), ...ea]
          }
        })));
      }
    };
  },
  provides(Bi) {
    Bi.generateLayersText = function(e, Zi) {
      const {
        title: Qi,
        transform: ea,
        extra: ra
      } = Zi;
      let na = null, ia = null;
      if (IS_IE) {
        const fa = parseInt(getComputedStyle(e).fontSize, 10), La = e.getBoundingClientRect();
        na = La.width / fa, ia = La.height / fa;
      }
      return config.autoA11y && !Qi && (ra.attributes["aria-hidden"] = "true"), Promise.resolve([e, makeLayersTextAbstract({
        content: e.innerHTML,
        width: na,
        height: ia,
        transform: ea,
        title: Qi,
        extra: ra,
        watchable: !0
      })]);
    };
  }
};
const CLEAN_CONTENT_PATTERN = new RegExp('"', "ug"), SECONDARY_UNICODE_RANGE = [1105920, 1112319], _FONT_FAMILY_WEIGHT_TO_PREFIX = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), lt$3), wa$1), Yt$3), FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys(_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((Bi, e) => (Bi[e.toLowerCase()] = _FONT_FAMILY_WEIGHT_TO_PREFIX[e], Bi), {}), FONT_FAMILY_WEIGHT_FALLBACK = Object.keys(FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((Bi, e) => {
  const Zi = FONT_FAMILY_WEIGHT_TO_PREFIX[e];
  return Bi[e] = Zi[900] || [...Object.entries(Zi)][0][1], Bi;
}, {});
function hexValueFromContent(Bi) {
  const e = Bi.replace(CLEAN_CONTENT_PATTERN, ""), Zi = codePointAt(e, 0), Qi = Zi >= SECONDARY_UNICODE_RANGE[0] && Zi <= SECONDARY_UNICODE_RANGE[1], ea = e.length === 2 ? e[0] === e[1] : !1;
  return {
    value: toHex(ea ? e[0] : e),
    isSecondary: Qi || ea
  };
}
function getPrefix(Bi, e) {
  const Zi = Bi.replace(/^['"]|['"]$/g, "").toLowerCase(), Qi = parseInt(e), ea = isNaN(Qi) ? "normal" : Qi;
  return (FONT_FAMILY_WEIGHT_TO_PREFIX[Zi] || {})[ea] || FONT_FAMILY_WEIGHT_FALLBACK[Zi];
}
function replaceForPosition(Bi, e) {
  const Zi = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(e.replace(":", "-"));
  return new Promise((Qi, ea) => {
    if (Bi.getAttribute(Zi) !== null)
      return Qi();
    const na = toArray(Bi.children).filter((ro) => ro.getAttribute(DATA_FA_PSEUDO_ELEMENT) === e)[0], ia = WINDOW.getComputedStyle(Bi, e), fa = ia.getPropertyValue("font-family"), La = fa.match(FONT_FAMILY_PATTERN), Va = ia.getPropertyValue("font-weight"), to = ia.getPropertyValue("content");
    if (na && !La)
      return Bi.removeChild(na), Qi();
    if (La && to !== "none" && to !== "") {
      const ro = ia.getPropertyValue("content");
      let no = getPrefix(fa, Va);
      const {
        value: eo,
        isSecondary: ao
      } = hexValueFromContent(ro), io = La[0].startsWith("FontAwesome");
      let xs = byUnicode(no, eo), Ts = xs;
      if (io) {
        const qs = byOldUnicode(eo);
        qs.iconName && qs.prefix && (xs = qs.iconName, no = qs.prefix);
      }
      if (xs && !ao && (!na || na.getAttribute(DATA_PREFIX) !== no || na.getAttribute(DATA_ICON) !== Ts)) {
        Bi.setAttribute(Zi, Ts), na && Bi.removeChild(na);
        const qs = blankMeta(), {
          extra: Fs
        } = qs;
        Fs.attributes[DATA_FA_PSEUDO_ELEMENT] = e, findIcon(xs, no).then((Do) => {
          const ys = makeInlineSvgAbstract(_objectSpread2$1(_objectSpread2$1({}, qs), {}, {
            icons: {
              main: Do,
              mask: emptyCanonicalIcon()
            },
            prefix: no,
            iconName: Ts,
            extra: Fs,
            watchable: !0
          })), Io = DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
          e === "::before" ? Bi.insertBefore(Io, Bi.firstChild) : Bi.appendChild(Io), Io.outerHTML = ys.map((so) => toHtml(so)).join(`
`), Bi.removeAttribute(Zi), Qi();
        }).catch(ea);
      } else
        Qi();
    } else
      Qi();
  });
}
function replace(Bi) {
  return Promise.all([replaceForPosition(Bi, "::before"), replaceForPosition(Bi, "::after")]);
}
function processable(Bi) {
  return Bi.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(Bi.tagName.toUpperCase()) && !Bi.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!Bi.parentNode || Bi.parentNode.tagName !== "svg");
}
function searchPseudoElements(Bi) {
  if (IS_DOM)
    return new Promise((e, Zi) => {
      const Qi = toArray(Bi.querySelectorAll("*")).filter(processable).map(replace), ea = perf.begin("searchPseudoElements");
      disableObservation(), Promise.all(Qi).then(() => {
        ea(), enableObservation(), e();
      }).catch(() => {
        ea(), enableObservation(), Zi();
      });
    });
}
var PseudoElements = {
  hooks() {
    return {
      mutationObserverCallbacks(Bi) {
        return Bi.pseudoElementsCallback = searchPseudoElements, Bi;
      }
    };
  },
  provides(Bi) {
    Bi.pseudoElements2svg = function(e) {
      const {
        node: Zi = DOCUMENT
      } = e;
      config.searchPseudoElements && searchPseudoElements(Zi);
    };
  }
};
let _unwatched = !1;
var MutationObserver$1 = {
  mixout() {
    return {
      dom: {
        unwatch() {
          disableObservation(), _unwatched = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        observe(chainHooks("mutationObserverCallbacks", {}));
      },
      noAuto() {
        disconnect();
      },
      watch(Bi) {
        const {
          observeMutationsRoot: e
        } = Bi;
        _unwatched ? enableObservation() : observe(chainHooks("mutationObserverCallbacks", {
          observeMutationsRoot: e
        }));
      }
    };
  }
};
const parseTransformString = (Bi) => {
  let e = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return Bi.toLowerCase().split(" ").reduce((Zi, Qi) => {
    const ea = Qi.toLowerCase().split("-"), ra = ea[0];
    let na = ea.slice(1).join("-");
    if (ra && na === "h")
      return Zi.flipX = !0, Zi;
    if (ra && na === "v")
      return Zi.flipY = !0, Zi;
    if (na = parseFloat(na), isNaN(na))
      return Zi;
    switch (ra) {
      case "grow":
        Zi.size = Zi.size + na;
        break;
      case "shrink":
        Zi.size = Zi.size - na;
        break;
      case "left":
        Zi.x = Zi.x - na;
        break;
      case "right":
        Zi.x = Zi.x + na;
        break;
      case "up":
        Zi.y = Zi.y - na;
        break;
      case "down":
        Zi.y = Zi.y + na;
        break;
      case "rotate":
        Zi.rotate = Zi.rotate + na;
        break;
    }
    return Zi;
  }, e);
};
var PowerTransforms = {
  mixout() {
    return {
      parse: {
        transform: (Bi) => parseTransformString(Bi)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(Bi, e) {
        const Zi = e.getAttribute("data-fa-transform");
        return Zi && (Bi.transform = parseTransformString(Zi)), Bi;
      }
    };
  },
  provides(Bi) {
    Bi.generateAbstractTransformGrouping = function(e) {
      let {
        main: Zi,
        transform: Qi,
        containerWidth: ea,
        iconWidth: ra
      } = e;
      const na = {
        transform: "translate(".concat(ea / 2, " 256)")
      }, ia = "translate(".concat(Qi.x * 32, ", ").concat(Qi.y * 32, ") "), fa = "scale(".concat(Qi.size / 16 * (Qi.flipX ? -1 : 1), ", ").concat(Qi.size / 16 * (Qi.flipY ? -1 : 1), ") "), La = "rotate(".concat(Qi.rotate, " 0 0)"), Va = {
        transform: "".concat(ia, " ").concat(fa, " ").concat(La)
      }, to = {
        transform: "translate(".concat(ra / 2 * -1, " -256)")
      }, ro = {
        outer: na,
        inner: Va,
        path: to
      };
      return {
        tag: "g",
        attributes: _objectSpread2$1({}, ro.outer),
        children: [{
          tag: "g",
          attributes: _objectSpread2$1({}, ro.inner),
          children: [{
            tag: Zi.icon.tag,
            children: Zi.icon.children,
            attributes: _objectSpread2$1(_objectSpread2$1({}, Zi.icon.attributes), ro.path)
          }]
        }]
      };
    };
  }
};
const ALL_SPACE = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function fillBlack(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return Bi.attributes && (Bi.attributes.fill || e) && (Bi.attributes.fill = "black"), Bi;
}
function deGroup(Bi) {
  return Bi.tag === "g" ? Bi.children : [Bi];
}
var Masks = {
  hooks() {
    return {
      parseNodeAttributes(Bi, e) {
        const Zi = e.getAttribute("data-fa-mask"), Qi = Zi ? getCanonicalIcon(Zi.split(" ").map((ea) => ea.trim())) : emptyCanonicalIcon();
        return Qi.prefix || (Qi.prefix = getDefaultUsablePrefix()), Bi.mask = Qi, Bi.maskId = e.getAttribute("data-fa-mask-id"), Bi;
      }
    };
  },
  provides(Bi) {
    Bi.generateAbstractMask = function(e) {
      let {
        children: Zi,
        attributes: Qi,
        main: ea,
        mask: ra,
        maskId: na,
        transform: ia
      } = e;
      const {
        width: fa,
        icon: La
      } = ea, {
        width: Va,
        icon: to
      } = ra, ro = transformForSvg({
        transform: ia,
        containerWidth: Va,
        iconWidth: fa
      }), no = {
        tag: "rect",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          fill: "white"
        })
      }, eo = La.children ? {
        children: La.children.map(fillBlack)
      } : {}, ao = {
        tag: "g",
        attributes: _objectSpread2$1({}, ro.inner),
        children: [fillBlack(_objectSpread2$1({
          tag: La.tag,
          attributes: _objectSpread2$1(_objectSpread2$1({}, La.attributes), ro.path)
        }, eo))]
      }, io = {
        tag: "g",
        attributes: _objectSpread2$1({}, ro.outer),
        children: [ao]
      }, xs = "mask-".concat(na || nextUniqueId$1()), Ts = "clip-".concat(na || nextUniqueId$1()), qs = {
        tag: "mask",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          id: xs,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [no, io]
      }, Fs = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: Ts
          },
          children: deGroup(to)
        }, qs]
      };
      return Zi.push(Fs, {
        tag: "rect",
        attributes: _objectSpread2$1({
          fill: "currentColor",
          "clip-path": "url(#".concat(Ts, ")"),
          mask: "url(#".concat(xs, ")")
        }, ALL_SPACE)
      }), {
        children: Zi,
        attributes: Qi
      };
    };
  }
}, MissingIconIndicator = {
  provides(Bi) {
    let e = !1;
    WINDOW.matchMedia && (e = WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches), Bi.missingIconAbstract = function() {
      const Zi = [], Qi = {
        fill: "currentColor"
      }, ea = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      Zi.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Qi), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const ra = _objectSpread2$1(_objectSpread2$1({}, ea), {}, {
        attributeName: "opacity"
      }), na = {
        tag: "circle",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Qi), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return e || na.children.push({
        tag: "animate",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ea), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ra), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), Zi.push(na), Zi.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Qi), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: e ? [] : [{
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, ra), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), e || Zi.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Qi), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, ra), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: Zi
      };
    };
  }
}, SvgSymbols = {
  hooks() {
    return {
      parseNodeAttributes(Bi, e) {
        const Zi = e.getAttribute("data-fa-symbol"), Qi = Zi === null ? !1 : Zi === "" ? !0 : Zi;
        return Bi.symbol = Qi, Bi;
      }
    };
  }
}, plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];
registerPlugins(plugins, {
  mixoutsTo: api
});
api.noAuto;
api.config;
api.library;
api.dom;
const parse$1$1 = api.parse;
api.findIconDefinition;
api.toHtml;
const icon = api.icon;
api.layer;
api.text;
api.counter;
var propTypes = { exports: {} }, reactIs = { exports: {} }, reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var Bi = typeof Symbol == "function" && Symbol.for, e = Bi ? Symbol.for("react.element") : 60103, Zi = Bi ? Symbol.for("react.portal") : 60106, Qi = Bi ? Symbol.for("react.fragment") : 60107, ea = Bi ? Symbol.for("react.strict_mode") : 60108, ra = Bi ? Symbol.for("react.profiler") : 60114, na = Bi ? Symbol.for("react.provider") : 60109, ia = Bi ? Symbol.for("react.context") : 60110, fa = Bi ? Symbol.for("react.async_mode") : 60111, La = Bi ? Symbol.for("react.concurrent_mode") : 60111, Va = Bi ? Symbol.for("react.forward_ref") : 60112, to = Bi ? Symbol.for("react.suspense") : 60113, ro = Bi ? Symbol.for("react.suspense_list") : 60120, no = Bi ? Symbol.for("react.memo") : 60115, eo = Bi ? Symbol.for("react.lazy") : 60116, ao = Bi ? Symbol.for("react.block") : 60121, io = Bi ? Symbol.for("react.fundamental") : 60117, xs = Bi ? Symbol.for("react.responder") : 60118, Ts = Bi ? Symbol.for("react.scope") : 60119;
  function qs(Do) {
    if (typeof Do == "object" && Do !== null) {
      var ys = Do.$$typeof;
      switch (ys) {
        case e:
          switch (Do = Do.type, Do) {
            case fa:
            case La:
            case Qi:
            case ra:
            case ea:
            case to:
              return Do;
            default:
              switch (Do = Do && Do.$$typeof, Do) {
                case ia:
                case Va:
                case eo:
                case no:
                case na:
                  return Do;
                default:
                  return ys;
              }
          }
        case Zi:
          return ys;
      }
    }
  }
  function Fs(Do) {
    return qs(Do) === La;
  }
  return reactIs_production_min.AsyncMode = fa, reactIs_production_min.ConcurrentMode = La, reactIs_production_min.ContextConsumer = ia, reactIs_production_min.ContextProvider = na, reactIs_production_min.Element = e, reactIs_production_min.ForwardRef = Va, reactIs_production_min.Fragment = Qi, reactIs_production_min.Lazy = eo, reactIs_production_min.Memo = no, reactIs_production_min.Portal = Zi, reactIs_production_min.Profiler = ra, reactIs_production_min.StrictMode = ea, reactIs_production_min.Suspense = to, reactIs_production_min.isAsyncMode = function(Do) {
    return Fs(Do) || qs(Do) === fa;
  }, reactIs_production_min.isConcurrentMode = Fs, reactIs_production_min.isContextConsumer = function(Do) {
    return qs(Do) === ia;
  }, reactIs_production_min.isContextProvider = function(Do) {
    return qs(Do) === na;
  }, reactIs_production_min.isElement = function(Do) {
    return typeof Do == "object" && Do !== null && Do.$$typeof === e;
  }, reactIs_production_min.isForwardRef = function(Do) {
    return qs(Do) === Va;
  }, reactIs_production_min.isFragment = function(Do) {
    return qs(Do) === Qi;
  }, reactIs_production_min.isLazy = function(Do) {
    return qs(Do) === eo;
  }, reactIs_production_min.isMemo = function(Do) {
    return qs(Do) === no;
  }, reactIs_production_min.isPortal = function(Do) {
    return qs(Do) === Zi;
  }, reactIs_production_min.isProfiler = function(Do) {
    return qs(Do) === ra;
  }, reactIs_production_min.isStrictMode = function(Do) {
    return qs(Do) === ea;
  }, reactIs_production_min.isSuspense = function(Do) {
    return qs(Do) === to;
  }, reactIs_production_min.isValidElementType = function(Do) {
    return typeof Do == "string" || typeof Do == "function" || Do === Qi || Do === La || Do === ra || Do === ea || Do === to || Do === ro || typeof Do == "object" && Do !== null && (Do.$$typeof === eo || Do.$$typeof === no || Do.$$typeof === na || Do.$$typeof === ia || Do.$$typeof === Va || Do.$$typeof === io || Do.$$typeof === xs || Do.$$typeof === Ts || Do.$$typeof === ao);
  }, reactIs_production_min.typeOf = qs, reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var Bi = typeof Symbol == "function" && Symbol.for, e = Bi ? Symbol.for("react.element") : 60103, Zi = Bi ? Symbol.for("react.portal") : 60106, Qi = Bi ? Symbol.for("react.fragment") : 60107, ea = Bi ? Symbol.for("react.strict_mode") : 60108, ra = Bi ? Symbol.for("react.profiler") : 60114, na = Bi ? Symbol.for("react.provider") : 60109, ia = Bi ? Symbol.for("react.context") : 60110, fa = Bi ? Symbol.for("react.async_mode") : 60111, La = Bi ? Symbol.for("react.concurrent_mode") : 60111, Va = Bi ? Symbol.for("react.forward_ref") : 60112, to = Bi ? Symbol.for("react.suspense") : 60113, ro = Bi ? Symbol.for("react.suspense_list") : 60120, no = Bi ? Symbol.for("react.memo") : 60115, eo = Bi ? Symbol.for("react.lazy") : 60116, ao = Bi ? Symbol.for("react.block") : 60121, io = Bi ? Symbol.for("react.fundamental") : 60117, xs = Bi ? Symbol.for("react.responder") : 60118, Ts = Bi ? Symbol.for("react.scope") : 60119;
    function qs(_l) {
      return typeof _l == "string" || typeof _l == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      _l === Qi || _l === La || _l === ra || _l === ea || _l === to || _l === ro || typeof _l == "object" && _l !== null && (_l.$$typeof === eo || _l.$$typeof === no || _l.$$typeof === na || _l.$$typeof === ia || _l.$$typeof === Va || _l.$$typeof === io || _l.$$typeof === xs || _l.$$typeof === Ts || _l.$$typeof === ao);
    }
    function Fs(_l) {
      if (typeof _l == "object" && _l !== null) {
        var Al = _l.$$typeof;
        switch (Al) {
          case e:
            var Rl = _l.type;
            switch (Rl) {
              case fa:
              case La:
              case Qi:
              case ra:
              case ea:
              case to:
                return Rl;
              default:
                var Cl = Rl && Rl.$$typeof;
                switch (Cl) {
                  case ia:
                  case Va:
                  case eo:
                  case no:
                  case na:
                    return Cl;
                  default:
                    return Al;
                }
            }
          case Zi:
            return Al;
        }
      }
    }
    var Do = fa, ys = La, Io = ia, so = na, os = e, Xs = Va, gl = Qi, Sl = eo, El = no, wl = Zi, jl = ra, kl = ea, Fl = to, Ml = !1;
    function ql(_l) {
      return Ml || (Ml = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Kl(_l) || Fs(_l) === fa;
    }
    function Kl(_l) {
      return Fs(_l) === La;
    }
    function Zl(_l) {
      return Fs(_l) === ia;
    }
    function Il(_l) {
      return Fs(_l) === na;
    }
    function xl(_l) {
      return typeof _l == "object" && _l !== null && _l.$$typeof === e;
    }
    function bl(_l) {
      return Fs(_l) === Va;
    }
    function Pl(_l) {
      return Fs(_l) === Qi;
    }
    function Nl(_l) {
      return Fs(_l) === eo;
    }
    function Bl(_l) {
      return Fs(_l) === no;
    }
    function Ol(_l) {
      return Fs(_l) === Zi;
    }
    function To(_l) {
      return Fs(_l) === ra;
    }
    function Os(_l) {
      return Fs(_l) === ea;
    }
    function $l(_l) {
      return Fs(_l) === to;
    }
    reactIs_development.AsyncMode = Do, reactIs_development.ConcurrentMode = ys, reactIs_development.ContextConsumer = Io, reactIs_development.ContextProvider = so, reactIs_development.Element = os, reactIs_development.ForwardRef = Xs, reactIs_development.Fragment = gl, reactIs_development.Lazy = Sl, reactIs_development.Memo = El, reactIs_development.Portal = wl, reactIs_development.Profiler = jl, reactIs_development.StrictMode = kl, reactIs_development.Suspense = Fl, reactIs_development.isAsyncMode = ql, reactIs_development.isConcurrentMode = Kl, reactIs_development.isContextConsumer = Zl, reactIs_development.isContextProvider = Il, reactIs_development.isElement = xl, reactIs_development.isForwardRef = bl, reactIs_development.isFragment = Pl, reactIs_development.isLazy = Nl, reactIs_development.isMemo = Bl, reactIs_development.isPortal = Ol, reactIs_development.isProfiler = To, reactIs_development.isStrictMode = Os, reactIs_development.isSuspense = $l, reactIs_development.isValidElementType = qs, reactIs_development.typeOf = Fs;
  }()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var Bi = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, Zi = Object.prototype.propertyIsEnumerable;
  function Qi(ra) {
    if (ra == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(ra);
  }
  function ea() {
    try {
      if (!Object.assign)
        return !1;
      var ra = new String("abc");
      if (ra[5] = "de", Object.getOwnPropertyNames(ra)[0] === "5")
        return !1;
      for (var na = {}, ia = 0; ia < 10; ia++)
        na["_" + String.fromCharCode(ia)] = ia;
      var fa = Object.getOwnPropertyNames(na).map(function(Va) {
        return na[Va];
      });
      if (fa.join("") !== "0123456789")
        return !1;
      var La = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(Va) {
        La[Va] = Va;
      }), Object.keys(Object.assign({}, La)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = ea() ? Object.assign : function(ra, na) {
    for (var ia, fa = Qi(ra), La, Va = 1; Va < arguments.length; Va++) {
      ia = Object(arguments[Va]);
      for (var to in ia)
        e.call(ia, to) && (fa[to] = ia[to]);
      if (Bi) {
        La = Bi(ia);
        for (var ro = 0; ro < La.length; ro++)
          Zi.call(ia, La[ro]) && (fa[La[ro]] = ia[La[ro]]);
      }
    }
    return fa;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var Bi = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = Bi, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var Bi = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ requireReactPropTypesSecret(), Zi = {}, Qi = /* @__PURE__ */ requireHas();
    Bi = function(ra) {
      var na = "Warning: " + ra;
      typeof console < "u" && console.error(na);
      try {
        throw new Error(na);
      } catch {
      }
    };
  }
  function ea(ra, na, ia, fa, La) {
    if (process.env.NODE_ENV !== "production") {
      for (var Va in ra)
        if (Qi(ra, Va)) {
          var to;
          try {
            if (typeof ra[Va] != "function") {
              var ro = Error(
                (fa || "React class") + ": " + ia + " type `" + Va + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ra[Va] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw ro.name = "Invariant Violation", ro;
            }
            to = ra[Va](na, Va, fa, ia, null, e);
          } catch (eo) {
            to = eo;
          }
          if (to && !(to instanceof Error) && Bi(
            (fa || "React class") + ": type specification of " + ia + " `" + Va + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof to + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), to instanceof Error && !(to.message in Zi)) {
            Zi[to.message] = !0;
            var no = La ? La() : "";
            Bi(
              "Failed " + ia + " type: " + to.message + (no ?? "")
            );
          }
        }
    }
  }
  return ea.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (Zi = {});
  }, checkPropTypes_1 = ea, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var Bi = requireReactIs(), e = requireObjectAssign(), Zi = /* @__PURE__ */ requireReactPropTypesSecret(), Qi = /* @__PURE__ */ requireHas(), ea = /* @__PURE__ */ requireCheckPropTypes(), ra = function() {
  };
  process.env.NODE_ENV !== "production" && (ra = function(ia) {
    var fa = "Warning: " + ia;
    typeof console < "u" && console.error(fa);
    try {
      throw new Error(fa);
    } catch {
    }
  });
  function na() {
    return null;
  }
  return factoryWithTypeCheckers = function(ia, fa) {
    var La = typeof Symbol == "function" && Symbol.iterator, Va = "@@iterator";
    function to(Kl) {
      var Zl = Kl && (La && Kl[La] || Kl[Va]);
      if (typeof Zl == "function")
        return Zl;
    }
    var ro = "<<anonymous>>", no = {
      array: xs("array"),
      bigint: xs("bigint"),
      bool: xs("boolean"),
      func: xs("function"),
      number: xs("number"),
      object: xs("object"),
      string: xs("string"),
      symbol: xs("symbol"),
      any: Ts(),
      arrayOf: qs,
      element: Fs(),
      elementType: Do(),
      instanceOf: ys,
      node: Xs(),
      objectOf: so,
      oneOf: Io,
      oneOfType: os,
      shape: Sl,
      exact: El
    };
    function eo(Kl, Zl) {
      return Kl === Zl ? Kl !== 0 || 1 / Kl === 1 / Zl : Kl !== Kl && Zl !== Zl;
    }
    function ao(Kl, Zl) {
      this.message = Kl, this.data = Zl && typeof Zl == "object" ? Zl : {}, this.stack = "";
    }
    ao.prototype = Error.prototype;
    function io(Kl) {
      if (process.env.NODE_ENV !== "production")
        var Zl = {}, Il = 0;
      function xl(Pl, Nl, Bl, Ol, To, Os, $l) {
        if (Ol = Ol || ro, Os = Os || Bl, $l !== Zi) {
          if (fa) {
            var _l = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw _l.name = "Invariant Violation", _l;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Al = Ol + ":" + Bl;
            !Zl[Al] && // Avoid spamming the console because they are often not actionable except for lib authors
            Il < 3 && (ra(
              "You are manually calling a React.PropTypes validation function for the `" + Os + "` prop on `" + Ol + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Zl[Al] = !0, Il++);
          }
        }
        return Nl[Bl] == null ? Pl ? Nl[Bl] === null ? new ao("The " + To + " `" + Os + "` is marked as required " + ("in `" + Ol + "`, but its value is `null`.")) : new ao("The " + To + " `" + Os + "` is marked as required in " + ("`" + Ol + "`, but its value is `undefined`.")) : null : Kl(Nl, Bl, Ol, To, Os);
      }
      var bl = xl.bind(null, !1);
      return bl.isRequired = xl.bind(null, !0), bl;
    }
    function xs(Kl) {
      function Zl(Il, xl, bl, Pl, Nl, Bl) {
        var Ol = Il[xl], To = kl(Ol);
        if (To !== Kl) {
          var Os = Fl(Ol);
          return new ao(
            "Invalid " + Pl + " `" + Nl + "` of type " + ("`" + Os + "` supplied to `" + bl + "`, expected ") + ("`" + Kl + "`."),
            { expectedType: Kl }
          );
        }
        return null;
      }
      return io(Zl);
    }
    function Ts() {
      return io(na);
    }
    function qs(Kl) {
      function Zl(Il, xl, bl, Pl, Nl) {
        if (typeof Kl != "function")
          return new ao("Property `" + Nl + "` of component `" + bl + "` has invalid PropType notation inside arrayOf.");
        var Bl = Il[xl];
        if (!Array.isArray(Bl)) {
          var Ol = kl(Bl);
          return new ao("Invalid " + Pl + " `" + Nl + "` of type " + ("`" + Ol + "` supplied to `" + bl + "`, expected an array."));
        }
        for (var To = 0; To < Bl.length; To++) {
          var Os = Kl(Bl, To, bl, Pl, Nl + "[" + To + "]", Zi);
          if (Os instanceof Error)
            return Os;
        }
        return null;
      }
      return io(Zl);
    }
    function Fs() {
      function Kl(Zl, Il, xl, bl, Pl) {
        var Nl = Zl[Il];
        if (!ia(Nl)) {
          var Bl = kl(Nl);
          return new ao("Invalid " + bl + " `" + Pl + "` of type " + ("`" + Bl + "` supplied to `" + xl + "`, expected a single ReactElement."));
        }
        return null;
      }
      return io(Kl);
    }
    function Do() {
      function Kl(Zl, Il, xl, bl, Pl) {
        var Nl = Zl[Il];
        if (!Bi.isValidElementType(Nl)) {
          var Bl = kl(Nl);
          return new ao("Invalid " + bl + " `" + Pl + "` of type " + ("`" + Bl + "` supplied to `" + xl + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return io(Kl);
    }
    function ys(Kl) {
      function Zl(Il, xl, bl, Pl, Nl) {
        if (!(Il[xl] instanceof Kl)) {
          var Bl = Kl.name || ro, Ol = ql(Il[xl]);
          return new ao("Invalid " + Pl + " `" + Nl + "` of type " + ("`" + Ol + "` supplied to `" + bl + "`, expected ") + ("instance of `" + Bl + "`."));
        }
        return null;
      }
      return io(Zl);
    }
    function Io(Kl) {
      if (!Array.isArray(Kl))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? ra(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : ra("Invalid argument supplied to oneOf, expected an array.")), na;
      function Zl(Il, xl, bl, Pl, Nl) {
        for (var Bl = Il[xl], Ol = 0; Ol < Kl.length; Ol++)
          if (eo(Bl, Kl[Ol]))
            return null;
        var To = JSON.stringify(Kl, function($l, _l) {
          var Al = Fl(_l);
          return Al === "symbol" ? String(_l) : _l;
        });
        return new ao("Invalid " + Pl + " `" + Nl + "` of value `" + String(Bl) + "` " + ("supplied to `" + bl + "`, expected one of " + To + "."));
      }
      return io(Zl);
    }
    function so(Kl) {
      function Zl(Il, xl, bl, Pl, Nl) {
        if (typeof Kl != "function")
          return new ao("Property `" + Nl + "` of component `" + bl + "` has invalid PropType notation inside objectOf.");
        var Bl = Il[xl], Ol = kl(Bl);
        if (Ol !== "object")
          return new ao("Invalid " + Pl + " `" + Nl + "` of type " + ("`" + Ol + "` supplied to `" + bl + "`, expected an object."));
        for (var To in Bl)
          if (Qi(Bl, To)) {
            var Os = Kl(Bl, To, bl, Pl, Nl + "." + To, Zi);
            if (Os instanceof Error)
              return Os;
          }
        return null;
      }
      return io(Zl);
    }
    function os(Kl) {
      if (!Array.isArray(Kl))
        return process.env.NODE_ENV !== "production" && ra("Invalid argument supplied to oneOfType, expected an instance of array."), na;
      for (var Zl = 0; Zl < Kl.length; Zl++) {
        var Il = Kl[Zl];
        if (typeof Il != "function")
          return ra(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Ml(Il) + " at index " + Zl + "."
          ), na;
      }
      function xl(bl, Pl, Nl, Bl, Ol) {
        for (var To = [], Os = 0; Os < Kl.length; Os++) {
          var $l = Kl[Os], _l = $l(bl, Pl, Nl, Bl, Ol, Zi);
          if (_l == null)
            return null;
          _l.data && Qi(_l.data, "expectedType") && To.push(_l.data.expectedType);
        }
        var Al = To.length > 0 ? ", expected one of type [" + To.join(", ") + "]" : "";
        return new ao("Invalid " + Bl + " `" + Ol + "` supplied to " + ("`" + Nl + "`" + Al + "."));
      }
      return io(xl);
    }
    function Xs() {
      function Kl(Zl, Il, xl, bl, Pl) {
        return wl(Zl[Il]) ? null : new ao("Invalid " + bl + " `" + Pl + "` supplied to " + ("`" + xl + "`, expected a ReactNode."));
      }
      return io(Kl);
    }
    function gl(Kl, Zl, Il, xl, bl) {
      return new ao(
        (Kl || "React class") + ": " + Zl + " type `" + Il + "." + xl + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + bl + "`."
      );
    }
    function Sl(Kl) {
      function Zl(Il, xl, bl, Pl, Nl) {
        var Bl = Il[xl], Ol = kl(Bl);
        if (Ol !== "object")
          return new ao("Invalid " + Pl + " `" + Nl + "` of type `" + Ol + "` " + ("supplied to `" + bl + "`, expected `object`."));
        for (var To in Kl) {
          var Os = Kl[To];
          if (typeof Os != "function")
            return gl(bl, Pl, Nl, To, Fl(Os));
          var $l = Os(Bl, To, bl, Pl, Nl + "." + To, Zi);
          if ($l)
            return $l;
        }
        return null;
      }
      return io(Zl);
    }
    function El(Kl) {
      function Zl(Il, xl, bl, Pl, Nl) {
        var Bl = Il[xl], Ol = kl(Bl);
        if (Ol !== "object")
          return new ao("Invalid " + Pl + " `" + Nl + "` of type `" + Ol + "` " + ("supplied to `" + bl + "`, expected `object`."));
        var To = e({}, Il[xl], Kl);
        for (var Os in To) {
          var $l = Kl[Os];
          if (Qi(Kl, Os) && typeof $l != "function")
            return gl(bl, Pl, Nl, Os, Fl($l));
          if (!$l)
            return new ao(
              "Invalid " + Pl + " `" + Nl + "` key `" + Os + "` supplied to `" + bl + "`.\nBad object: " + JSON.stringify(Il[xl], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Kl), null, "  ")
            );
          var _l = $l(Bl, Os, bl, Pl, Nl + "." + Os, Zi);
          if (_l)
            return _l;
        }
        return null;
      }
      return io(Zl);
    }
    function wl(Kl) {
      switch (typeof Kl) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !Kl;
        case "object":
          if (Array.isArray(Kl))
            return Kl.every(wl);
          if (Kl === null || ia(Kl))
            return !0;
          var Zl = to(Kl);
          if (Zl) {
            var Il = Zl.call(Kl), xl;
            if (Zl !== Kl.entries) {
              for (; !(xl = Il.next()).done; )
                if (!wl(xl.value))
                  return !1;
            } else
              for (; !(xl = Il.next()).done; ) {
                var bl = xl.value;
                if (bl && !wl(bl[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function jl(Kl, Zl) {
      return Kl === "symbol" ? !0 : Zl ? Zl["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Zl instanceof Symbol : !1;
    }
    function kl(Kl) {
      var Zl = typeof Kl;
      return Array.isArray(Kl) ? "array" : Kl instanceof RegExp ? "object" : jl(Zl, Kl) ? "symbol" : Zl;
    }
    function Fl(Kl) {
      if (typeof Kl > "u" || Kl === null)
        return "" + Kl;
      var Zl = kl(Kl);
      if (Zl === "object") {
        if (Kl instanceof Date)
          return "date";
        if (Kl instanceof RegExp)
          return "regexp";
      }
      return Zl;
    }
    function Ml(Kl) {
      var Zl = Fl(Kl);
      switch (Zl) {
        case "array":
        case "object":
          return "an " + Zl;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Zl;
        default:
          return Zl;
      }
    }
    function ql(Kl) {
      return !Kl.constructor || !Kl.constructor.name ? ro : Kl.constructor.name;
    }
    return no.checkPropTypes = ea, no.resetWarningCache = ea.resetWarningCache, no.PropTypes = no, no;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var Bi = /* @__PURE__ */ requireReactPropTypesSecret();
  function e() {
  }
  function Zi() {
  }
  return Zi.resetWarningCache = e, factoryWithThrowingShims = function() {
    function Qi(na, ia, fa, La, Va, to) {
      if (to !== Bi) {
        var ro = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw ro.name = "Invariant Violation", ro;
      }
    }
    Qi.isRequired = Qi;
    function ea() {
      return Qi;
    }
    var ra = {
      array: Qi,
      bigint: Qi,
      bool: Qi,
      func: Qi,
      number: Qi,
      object: Qi,
      string: Qi,
      symbol: Qi,
      any: Qi,
      arrayOf: ea,
      element: Qi,
      elementType: Qi,
      instanceOf: ea,
      node: Qi,
      objectOf: ea,
      oneOf: ea,
      oneOfType: ea,
      shape: ea,
      exact: ea,
      checkPropTypes: Zi,
      resetWarningCache: e
    };
    return ra.PropTypes = ra, ra;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  if (hasRequiredPropTypes = 1, process.env.NODE_ENV !== "production") {
    var Bi = requireReactIs(), e = !0;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(Bi.isElement, e);
  } else
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function ownKeys$3(Bi, e) {
  var Zi = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Qi = Object.getOwnPropertySymbols(Bi);
    e && (Qi = Qi.filter(function(ea) {
      return Object.getOwnPropertyDescriptor(Bi, ea).enumerable;
    })), Zi.push.apply(Zi, Qi);
  }
  return Zi;
}
function _objectSpread2(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Zi = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys$3(Object(Zi), !0).forEach(function(Qi) {
      _defineProperty$7(Bi, Qi, Zi[Qi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(Zi)) : ownKeys$3(Object(Zi)).forEach(function(Qi) {
      Object.defineProperty(Bi, Qi, Object.getOwnPropertyDescriptor(Zi, Qi));
    });
  }
  return Bi;
}
function _typeof(Bi) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _typeof(Bi);
}
function _defineProperty$7(Bi, e, Zi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Zi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Zi, Bi;
}
function _objectWithoutPropertiesLoose$2(Bi, e) {
  if (Bi == null) return {};
  var Zi = {}, Qi = Object.keys(Bi), ea, ra;
  for (ra = 0; ra < Qi.length; ra++)
    ea = Qi[ra], !(e.indexOf(ea) >= 0) && (Zi[ea] = Bi[ea]);
  return Zi;
}
function _objectWithoutProperties$2(Bi, e) {
  if (Bi == null) return {};
  var Zi = _objectWithoutPropertiesLoose$2(Bi, e), Qi, ea;
  if (Object.getOwnPropertySymbols) {
    var ra = Object.getOwnPropertySymbols(Bi);
    for (ea = 0; ea < ra.length; ea++)
      Qi = ra[ea], !(e.indexOf(Qi) >= 0) && Object.prototype.propertyIsEnumerable.call(Bi, Qi) && (Zi[Qi] = Bi[Qi]);
  }
  return Zi;
}
function _toConsumableArray$2(Bi) {
  return _arrayWithoutHoles$2(Bi) || _iterableToArray$2(Bi) || _unsupportedIterableToArray$3(Bi) || _nonIterableSpread$2();
}
function _arrayWithoutHoles$2(Bi) {
  if (Array.isArray(Bi)) return _arrayLikeToArray$3(Bi);
}
function _iterableToArray$2(Bi) {
  if (typeof Symbol < "u" && Bi[Symbol.iterator] != null || Bi["@@iterator"] != null) return Array.from(Bi);
}
function _unsupportedIterableToArray$3(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray$3(Bi, e);
    var Zi = Object.prototype.toString.call(Bi).slice(8, -1);
    if (Zi === "Object" && Bi.constructor && (Zi = Bi.constructor.name), Zi === "Map" || Zi === "Set") return Array.from(Bi);
    if (Zi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Zi)) return _arrayLikeToArray$3(Bi, e);
  }
}
function _arrayLikeToArray$3(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var Zi = 0, Qi = new Array(e); Zi < e; Zi++) Qi[Zi] = Bi[Zi];
  return Qi;
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function classList(Bi) {
  var e, Zi = Bi.beat, Qi = Bi.fade, ea = Bi.beatFade, ra = Bi.bounce, na = Bi.shake, ia = Bi.flash, fa = Bi.spin, La = Bi.spinPulse, Va = Bi.spinReverse, to = Bi.pulse, ro = Bi.fixedWidth, no = Bi.inverse, eo = Bi.border, ao = Bi.listItem, io = Bi.flip, xs = Bi.size, Ts = Bi.rotation, qs = Bi.pull, Fs = (e = {
    "fa-beat": Zi,
    "fa-fade": Qi,
    "fa-beat-fade": ea,
    "fa-bounce": ra,
    "fa-shake": na,
    "fa-flash": ia,
    "fa-spin": fa,
    "fa-spin-reverse": Va,
    "fa-spin-pulse": La,
    "fa-pulse": to,
    "fa-fw": ro,
    "fa-inverse": no,
    "fa-border": eo,
    "fa-li": ao,
    "fa-flip-horizontal": io === "horizontal" || io === "both",
    "fa-flip-vertical": io === "vertical" || io === "both"
  }, _defineProperty$7(e, "fa-".concat(xs), typeof xs < "u" && xs !== null), _defineProperty$7(e, "fa-rotate-".concat(Ts), typeof Ts < "u" && Ts !== null && Ts !== 0), _defineProperty$7(e, "fa-pull-".concat(qs), typeof qs < "u" && qs !== null), _defineProperty$7(e, "fa-swap-opacity", Bi.swapOpacity), e);
  return Object.keys(Fs).map(function(Do) {
    return Fs[Do] ? Do : null;
  }).filter(function(Do) {
    return Do;
  });
}
function _isNumerical(Bi) {
  return Bi = Bi - 0, Bi === Bi;
}
function camelize(Bi) {
  return _isNumerical(Bi) ? Bi : (Bi = Bi.replace(/[\-_\s]+(.)?/g, function(e, Zi) {
    return Zi ? Zi.toUpperCase() : "";
  }), Bi.substr(0, 1).toLowerCase() + Bi.substr(1));
}
var _excluded$1 = ["style"];
function capitalize(Bi) {
  return Bi.charAt(0).toUpperCase() + Bi.slice(1);
}
function styleToObject(Bi) {
  return Bi.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, Zi) {
    var Qi = Zi.indexOf(":"), ea = camelize(Zi.slice(0, Qi)), ra = Zi.slice(Qi + 1).trim();
    return ea.startsWith("webkit") ? e[capitalize(ea)] = ra : e[ea] = ra, e;
  }, {});
}
function convert(Bi, e) {
  var Zi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof e == "string")
    return e;
  var Qi = (e.children || []).map(function(fa) {
    return convert(Bi, fa);
  }), ea = Object.keys(e.attributes || {}).reduce(function(fa, La) {
    var Va = e.attributes[La];
    switch (La) {
      case "class":
        fa.attrs.className = Va, delete e.attributes.class;
        break;
      case "style":
        fa.attrs.style = styleToObject(Va);
        break;
      default:
        La.indexOf("aria-") === 0 || La.indexOf("data-") === 0 ? fa.attrs[La.toLowerCase()] = Va : fa.attrs[camelize(La)] = Va;
    }
    return fa;
  }, {
    attrs: {}
  }), ra = Zi.style, na = ra === void 0 ? {} : ra, ia = _objectWithoutProperties$2(Zi, _excluded$1);
  return ea.attrs.style = _objectSpread2(_objectSpread2({}, ea.attrs.style), na), Bi.apply(void 0, [e.tag, _objectSpread2(_objectSpread2({}, ea.attrs), ia)].concat(_toConsumableArray$2(Qi)));
}
var PRODUCTION = !1;
try {
  PRODUCTION = process.env.NODE_ENV === "production";
} catch {
}
function log() {
  if (!PRODUCTION && console && typeof console.error == "function") {
    var Bi;
    (Bi = console).error.apply(Bi, arguments);
  }
}
function normalizeIconArgs(Bi) {
  if (Bi && _typeof(Bi) === "object" && Bi.prefix && Bi.iconName && Bi.icon)
    return Bi;
  if (parse$1$1.icon)
    return parse$1$1.icon(Bi);
  if (Bi === null)
    return null;
  if (Bi && _typeof(Bi) === "object" && Bi.prefix && Bi.iconName)
    return Bi;
  if (Array.isArray(Bi) && Bi.length === 2)
    return {
      prefix: Bi[0],
      iconName: Bi[1]
    };
  if (typeof Bi == "string")
    return {
      prefix: "fas",
      iconName: Bi
    };
}
function objectWithKey(Bi, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? _defineProperty$7({}, Bi, e) : {};
}
var _excluded$2 = ["forwardedRef"];
function FontAwesomeIcon(Bi) {
  var e = Bi.forwardedRef, Zi = _objectWithoutProperties$2(Bi, _excluded$2), Qi = Zi.icon, ea = Zi.mask, ra = Zi.symbol, na = Zi.className, ia = Zi.title, fa = Zi.titleId, La = Zi.maskId, Va = normalizeIconArgs(Qi), to = objectWithKey("classes", [].concat(_toConsumableArray$2(classList(Zi)), _toConsumableArray$2(na.split(" ")))), ro = objectWithKey("transform", typeof Zi.transform == "string" ? parse$1$1.transform(Zi.transform) : Zi.transform), no = objectWithKey("mask", normalizeIconArgs(ea)), eo = icon(Va, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, to), ro), no), {}, {
    symbol: ra,
    title: ia,
    titleId: fa,
    maskId: La
  }));
  if (!eo)
    return log("Could not find icon", Va), null;
  var ao = eo.abstract, io = {
    ref: e
  };
  return Object.keys(Zi).forEach(function(xs) {
    FontAwesomeIcon.defaultProps.hasOwnProperty(xs) || (io[xs] = Zi[xs]);
  }), convertCurry(ao[0], io);
}
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
  beat: PropTypes.bool,
  border: PropTypes.bool,
  bounce: PropTypes.bool,
  className: PropTypes.string,
  fade: PropTypes.bool,
  flash: PropTypes.bool,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  maskId: PropTypes.string,
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf(["horizontal", "vertical", "both"]),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(["right", "left"]),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  shake: PropTypes.bool,
  size: PropTypes.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: PropTypes.bool,
  spinPulse: PropTypes.bool,
  spinReverse: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  titleId: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
FontAwesomeIcon.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: null,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var convertCurry = convert.bind(null, a__default.createElement);
const copiedMessageStyles = cva(
  [
    "absolute",
    "p-1",
    "text-sm",
    "-translate-y-1/2",
    "top-1/2",
    "left-full",
    "text-neutral-800",
    "dark:text-neutral-100",
    "z-[9999]",
    "transition-opacity"
  ],
  {
    variants: {
      visible: {
        true: "opacity-100",
        false: "opacity-0"
      }
    }
  }
), CopiedMessage = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: copiedMessageStyles({ visible: Bi.visible }), children: "Copied!" }), CopyButton = ({
  text: Bi,
  onCopy: e,
  element: Zi,
  copyElement: Qi,
  disabled: ea = !1,
  className: ra = ""
}) => {
  const [na, ia] = useState(!1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "button",
    {
      disabled: ea,
      className: `${ra} relative w-3 h-3`,
      onClick: () => {
        e?.(Bi), navigator.clipboard.writeText(Bi), ia(!0), setTimeout(() => ia(!1), 1500);
      },
      children: [
        Zi || /* @__PURE__ */ jsxRuntimeExports.jsx(
          FontAwesomeIcon,
          {
            className: "w-full h-full p-1 cursor-pointer place-items-center aspect-square",
            icon: faClipboard
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(CopiedMessage, { visible: na, children: Qi || "Copied!" })
      ]
    }
  );
};
var extendStatics = function(Bi, e) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zi, Qi) {
    Zi.__proto__ = Qi;
  } || function(Zi, Qi) {
    for (var ea in Qi) Object.prototype.hasOwnProperty.call(Qi, ea) && (Zi[ea] = Qi[ea]);
  }, extendStatics(Bi, e);
};
function __extends(Bi, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  extendStatics(Bi, e);
  function Zi() {
    this.constructor = Bi;
  }
  Bi.prototype = e === null ? Object.create(e) : (Zi.prototype = e.prototype, new Zi());
}
var __assign = function() {
  return __assign = Object.assign || function(e) {
    for (var Zi, Qi = 1, ea = arguments.length; Qi < ea; Qi++) {
      Zi = arguments[Qi];
      for (var ra in Zi) Object.prototype.hasOwnProperty.call(Zi, ra) && (e[ra] = Zi[ra]);
    }
    return e;
  }, __assign.apply(this, arguments);
};
function __rest$1(Bi, e) {
  var Zi = {};
  for (var Qi in Bi) Object.prototype.hasOwnProperty.call(Bi, Qi) && e.indexOf(Qi) < 0 && (Zi[Qi] = Bi[Qi]);
  if (Bi != null && typeof Object.getOwnPropertySymbols == "function")
    for (var ea = 0, Qi = Object.getOwnPropertySymbols(Bi); ea < Qi.length; ea++)
      e.indexOf(Qi[ea]) < 0 && Object.prototype.propertyIsEnumerable.call(Bi, Qi[ea]) && (Zi[Qi[ea]] = Bi[Qi[ea]]);
  return Zi;
}
function __values(Bi) {
  var e = typeof Symbol == "function" && Symbol.iterator, Zi = e && Bi[e], Qi = 0;
  if (Zi) return Zi.call(Bi);
  if (Bi && typeof Bi.length == "number") return {
    next: function() {
      return Bi && Qi >= Bi.length && (Bi = void 0), { value: Bi && Bi[Qi++], done: !Bi };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(Bi, e) {
  var Zi = typeof Symbol == "function" && Bi[Symbol.iterator];
  if (!Zi) return Bi;
  var Qi = Zi.call(Bi), ea, ra = [], na;
  try {
    for (; (e === void 0 || e-- > 0) && !(ea = Qi.next()).done; ) ra.push(ea.value);
  } catch (ia) {
    na = { error: ia };
  } finally {
    try {
      ea && !ea.done && (Zi = Qi.return) && Zi.call(Qi);
    } finally {
      if (na) throw na.error;
    }
  }
  return ra;
}
function __spreadArray(Bi, e, Zi) {
  if (Zi || arguments.length === 2) for (var Qi = 0, ea = e.length, ra; Qi < ea; Qi++)
    (ra || !(Qi in e)) && (ra || (ra = Array.prototype.slice.call(e, 0, Qi)), ra[Qi] = e[Qi]);
  return Bi.concat(ra || Array.prototype.slice.call(e));
}
typeof SuppressedError == "function" && SuppressedError;
var defaultEnvironment = "production", env = typeof process > "u" || process.env === void 0 ? defaultEnvironment : process.env.NODE_ENV || defaultEnvironment, createDefinition$1 = function(Bi) {
  return {
    isEnabled: function(e) {
      return Bi.some(function(Zi) {
        return !!e[Zi];
      });
    }
  };
}, featureDefinitions = {
  measureLayout: createDefinition$1(["layout", "layoutId", "drag"]),
  animation: createDefinition$1([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: createDefinition$1(["exit"]),
  drag: createDefinition$1(["drag", "dragControls"]),
  focus: createDefinition$1(["whileFocus"]),
  hover: createDefinition$1(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: createDefinition$1(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: createDefinition$1([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: createDefinition$1([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function loadFeatures(Bi) {
  for (var e in Bi)
    Bi[e] !== null && (e === "projectionNodeConstructor" ? featureDefinitions.projectionNodeConstructor = Bi[e] : featureDefinitions[e].Component = Bi[e]);
}
var warning$1 = function() {
}, invariant$1 = function() {
};
process.env.NODE_ENV !== "production" && (warning$1 = function(Bi, e) {
  !Bi && typeof console < "u" && console.warn(e);
}, invariant$1 = function(Bi, e) {
  if (!Bi)
    throw new Error(e);
});
var LazyContext = createContext({ strict: !1 }), featureNames = Object.keys(featureDefinitions), numFeatures = featureNames.length;
function useFeatures(Bi, e, Zi) {
  var Qi = [], ea = useContext(LazyContext);
  if (!e)
    return null;
  env !== "production" && Zi && ea.strict && invariant$1(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var ra = 0; ra < numFeatures; ra++) {
    var na = featureNames[ra], ia = featureDefinitions[na], fa = ia.isEnabled, La = ia.Component;
    fa(Bi) && La && Qi.push(a$8.createElement(La, __assign({ key: na }, Bi, { visualElement: e })));
  }
  return Qi;
}
var MotionConfigContext = createContext({
  transformPagePoint: function(Bi) {
    return Bi;
  },
  isStatic: !1,
  reducedMotion: "never"
}), MotionContext = createContext({});
function useVisualElementContext() {
  return useContext(MotionContext).visualElement;
}
var PresenceContext = createContext(null), isBrowser = typeof document < "u", useIsomorphicLayoutEffect$1 = isBrowser ? useLayoutEffect : useEffect, prefersReducedMotion = { current: null }, hasDetected = !1;
function initPrefersReducedMotion() {
  if (hasDetected = !0, !!isBrowser)
    if (window.matchMedia) {
      var Bi = window.matchMedia("(prefers-reduced-motion)"), e = function() {
        return prefersReducedMotion.current = Bi.matches;
      };
      Bi.addListener(e), e();
    } else
      prefersReducedMotion.current = !1;
}
function useReducedMotion() {
  !hasDetected && initPrefersReducedMotion();
  var Bi = __read(useState(prefersReducedMotion.current), 1), e = Bi[0];
  return e;
}
function useReducedMotionConfig() {
  var Bi = useReducedMotion(), e = useContext(MotionConfigContext).reducedMotion;
  return e === "never" ? !1 : e === "always" ? !0 : Bi;
}
function useVisualElement(Bi, e, Zi, Qi) {
  var ea = useContext(LazyContext), ra = useVisualElementContext(), na = useContext(PresenceContext), ia = useReducedMotionConfig(), fa = useRef(void 0);
  Qi || (Qi = ea.renderer), !fa.current && Qi && (fa.current = Qi(Bi, {
    visualState: e,
    parent: ra,
    props: Zi,
    presenceId: na?.id,
    blockInitialAnimation: na?.initial === !1,
    shouldReduceMotion: ia
  }));
  var La = fa.current;
  return useIsomorphicLayoutEffect$1(function() {
    La?.syncRender();
  }), useEffect(function() {
    var Va;
    (Va = La?.animationState) === null || Va === void 0 || Va.animateChanges();
  }), useIsomorphicLayoutEffect$1(function() {
    return function() {
      return La?.notifyUnmount();
    };
  }, []), La;
}
function isRefObject(Bi) {
  return typeof Bi == "object" && Object.prototype.hasOwnProperty.call(Bi, "current");
}
function useMotionRef(Bi, e, Zi) {
  return useCallback(
    function(Qi) {
      var ea;
      Qi && ((ea = Bi.mount) === null || ea === void 0 || ea.call(Bi, Qi)), e && (Qi ? e.mount(Qi) : e.unmount()), Zi && (typeof Zi == "function" ? Zi(Qi) : isRefObject(Zi) && (Zi.current = Qi));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
function isVariantLabels(Bi) {
  return Array.isArray(Bi);
}
function isVariantLabel(Bi) {
  return typeof Bi == "string" || isVariantLabels(Bi);
}
function getCurrent(Bi) {
  var e = {};
  return Bi.forEachValue(function(Zi, Qi) {
    return e[Qi] = Zi.get();
  }), e;
}
function getVelocity$1(Bi) {
  var e = {};
  return Bi.forEachValue(function(Zi, Qi) {
    return e[Qi] = Zi.getVelocity();
  }), e;
}
function resolveVariantFromProps(Bi, e, Zi, Qi, ea) {
  var ra;
  return Qi === void 0 && (Qi = {}), ea === void 0 && (ea = {}), typeof e == "function" && (e = e(Zi ?? Bi.custom, Qi, ea)), typeof e == "string" && (e = (ra = Bi.variants) === null || ra === void 0 ? void 0 : ra[e]), typeof e == "function" && (e = e(Zi ?? Bi.custom, Qi, ea)), e;
}
function resolveVariant(Bi, e, Zi) {
  var Qi = Bi.getProps();
  return resolveVariantFromProps(Qi, e, Zi ?? Qi.custom, getCurrent(Bi), getVelocity$1(Bi));
}
function checkIfControllingVariants(Bi) {
  var e;
  return typeof ((e = Bi.animate) === null || e === void 0 ? void 0 : e.start) == "function" || isVariantLabel(Bi.initial) || isVariantLabel(Bi.animate) || isVariantLabel(Bi.whileHover) || isVariantLabel(Bi.whileDrag) || isVariantLabel(Bi.whileTap) || isVariantLabel(Bi.whileFocus) || isVariantLabel(Bi.exit);
}
function checkIfVariantNode(Bi) {
  return !!(checkIfControllingVariants(Bi) || Bi.variants);
}
function getCurrentTreeVariants(Bi, e) {
  if (checkIfControllingVariants(Bi)) {
    var Zi = Bi.initial, Qi = Bi.animate;
    return {
      initial: Zi === !1 || isVariantLabel(Zi) ? Zi : void 0,
      animate: isVariantLabel(Qi) ? Qi : void 0
    };
  }
  return Bi.inherit !== !1 ? e : {};
}
function useCreateMotionContext(Bi) {
  var e = getCurrentTreeVariants(Bi, useContext(MotionContext)), Zi = e.initial, Qi = e.animate;
  return useMemo(function() {
    return { initial: Zi, animate: Qi };
  }, [variantLabelsAsDependency(Zi), variantLabelsAsDependency(Qi)]);
}
function variantLabelsAsDependency(Bi) {
  return Array.isArray(Bi) ? Bi.join(" ") : Bi;
}
function useConstant(Bi) {
  var e = useRef(null);
  return e.current === null && (e.current = Bi()), e.current;
}
var globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, id$1 = 1;
function useProjectionId() {
  return useConstant(function() {
    if (globalProjectionState.hasEverUpdated)
      return id$1++;
  });
}
var LayoutGroupContext = createContext({}), SwitchLayoutGroupContext = createContext({});
function useProjection(Bi, e, Zi, Qi) {
  var ea, ra = e.layoutId, na = e.layout, ia = e.drag, fa = e.dragConstraints, La = e.layoutScroll, Va = useContext(SwitchLayoutGroupContext);
  !Qi || !Zi || Zi?.projection || (Zi.projection = new Qi(Bi, Zi.getLatestValues(), (ea = Zi.parent) === null || ea === void 0 ? void 0 : ea.projection), Zi.projection.setOptions({
    layoutId: ra,
    layout: na,
    alwaysMeasureLayout: !!ia || fa && isRefObject(fa),
    visualElement: Zi,
    scheduleRender: function() {
      return Zi.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof na == "string" ? na : "both",
    initialPromotionConfig: Va,
    layoutScroll: La
  }));
}
var VisualElementHandler = (
  /** @class */
  function(Bi) {
    __extends(e, Bi);
    function e() {
      return Bi !== null && Bi.apply(this, arguments) || this;
    }
    return e.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, e.prototype.componentDidUpdate = function() {
    }, e.prototype.updateProps = function() {
      var Zi = this.props, Qi = Zi.visualElement, ea = Zi.props;
      Qi && Qi.setProps(ea);
    }, e.prototype.render = function() {
      return this.props.children;
    }, e;
  }(a__default.Component)
);
function createMotionComponent(Bi) {
  var e = Bi.preloadedFeatures, Zi = Bi.createVisualElement, Qi = Bi.projectionNodeConstructor, ea = Bi.useRender, ra = Bi.useVisualState, na = Bi.Component;
  e && loadFeatures(e);
  function ia(fa, La) {
    var Va = useLayoutId(fa);
    fa = __assign(__assign({}, fa), { layoutId: Va });
    var to = useContext(MotionConfigContext), ro = null, no = useCreateMotionContext(fa), eo = to.isStatic ? void 0 : useProjectionId(), ao = ra(fa, to.isStatic);
    return !to.isStatic && isBrowser && (no.visualElement = useVisualElement(na, ao, __assign(__assign({}, to), fa), Zi), useProjection(eo, fa, no.visualElement, Qi || featureDefinitions.projectionNodeConstructor), ro = useFeatures(fa, no.visualElement, e)), a$8.createElement(
      VisualElementHandler,
      { visualElement: no.visualElement, props: __assign(__assign({}, to), fa) },
      ro,
      a$8.createElement(MotionContext.Provider, { value: no }, ea(na, fa, eo, useMotionRef(ao, no.visualElement, La), ao, to.isStatic, no.visualElement))
    );
  }
  return forwardRef(ia);
}
function useLayoutId(Bi) {
  var e, Zi = Bi.layoutId, Qi = (e = useContext(LayoutGroupContext)) === null || e === void 0 ? void 0 : e.id;
  return Qi && Zi !== void 0 ? Qi + "-" + Zi : Zi;
}
function createMotionProxy(Bi) {
  function e(Qi, ea) {
    return ea === void 0 && (ea = {}), createMotionComponent(Bi(Qi, ea));
  }
  if (typeof Proxy > "u")
    return e;
  var Zi = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(Qi, ea) {
      return Zi.has(ea) || Zi.set(ea, e(ea)), Zi.get(ea);
    }
  });
}
var lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function isSVGComponent(Bi) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Bi != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    Bi.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(lowercaseSVGElements.indexOf(Bi) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(Bi))
    )
  );
}
var scaleCorrectors = {};
function addScaleCorrector(Bi) {
  Object.assign(scaleCorrectors, Bi);
}
var transformAxes = ["", "X", "Y", "Z"], order = ["translate", "scale", "rotate", "skew"], transformProps = ["transformPerspective", "x", "y", "z"];
order.forEach(function(Bi) {
  return transformAxes.forEach(function(e) {
    return transformProps.push(Bi + e);
  });
});
function sortTransformProps(Bi, e) {
  return transformProps.indexOf(Bi) - transformProps.indexOf(e);
}
var transformPropSet = new Set(transformProps);
function isTransformProp(Bi) {
  return transformPropSet.has(Bi);
}
var transformOriginProps = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(Bi) {
  return transformOriginProps.has(Bi);
}
function isForcedMotionValue(Bi, e) {
  var Zi = e.layout, Qi = e.layoutId;
  return isTransformProp(Bi) || isTransformOriginProp(Bi) || (Zi || Qi !== void 0) && (!!scaleCorrectors[Bi] || Bi === "opacity");
}
var isMotionValue = function(Bi) {
  return !!(Bi !== null && typeof Bi == "object" && Bi.getVelocity);
}, translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function buildTransform(Bi, e, Zi, Qi) {
  var ea = Bi.transform, ra = Bi.transformKeys, na = e.enableHardwareAcceleration, ia = na === void 0 ? !0 : na, fa = e.allowTransformNone, La = fa === void 0 ? !0 : fa, Va = "";
  ra.sort(sortTransformProps);
  for (var to = !1, ro = ra.length, no = 0; no < ro; no++) {
    var eo = ra[no];
    Va += "".concat(translateAlias[eo] || eo, "(").concat(ea[eo], ") "), eo === "z" && (to = !0);
  }
  return !to && ia ? Va += "translateZ(0)" : Va = Va.trim(), Qi ? Va = Qi(ea, Zi ? "" : Va) : La && Zi && (Va = "none"), Va;
}
function buildTransformOrigin(Bi) {
  var e = Bi.originX, Zi = e === void 0 ? "50%" : e, Qi = Bi.originY, ea = Qi === void 0 ? "50%" : Qi, ra = Bi.originZ, na = ra === void 0 ? 0 : ra;
  return "".concat(Zi, " ").concat(ea, " ").concat(na);
}
function isCSSVariable$1(Bi) {
  return Bi.startsWith("--");
}
var getValueAsType = function(Bi, e) {
  return e && typeof Bi == "number" ? e.transform(Bi) : Bi;
};
const clamp$1 = (Bi, e) => (Zi) => Math.max(Math.min(Zi, e), Bi), sanitize = (Bi) => Bi % 1 ? Number(Bi.toFixed(5)) : Bi, floatRegex = /(-)?([\d]*\.?[\d])+/g, colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString$1(Bi) {
  return typeof Bi == "string";
}
const number = {
  test: (Bi) => typeof Bi == "number",
  parse: parseFloat,
  transform: (Bi) => Bi
}, alpha = Object.assign(Object.assign({}, number), { transform: clamp$1(0, 1) }), scale = Object.assign(Object.assign({}, number), { default: 1 }), createUnitType = (Bi) => ({
  test: (e) => isString$1(e) && e.endsWith(Bi) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${Bi}`
}), degrees = createUnitType("deg"), percent = createUnitType("%"), px = createUnitType("px"), vh = createUnitType("vh"), vw = createUnitType("vw"), progressPercentage = Object.assign(Object.assign({}, percent), { parse: (Bi) => percent.parse(Bi) / 100, transform: (Bi) => percent.transform(Bi * 100) }), isColorString = (Bi, e) => (Zi) => !!(isString$1(Zi) && singleColorRegex.test(Zi) && Zi.startsWith(Bi) || e && Object.prototype.hasOwnProperty.call(Zi, e)), splitColor = (Bi, e, Zi) => (Qi) => {
  if (!isString$1(Qi))
    return Qi;
  const [ea, ra, na, ia] = Qi.match(floatRegex);
  return {
    [Bi]: parseFloat(ea),
    [e]: parseFloat(ra),
    [Zi]: parseFloat(na),
    alpha: ia !== void 0 ? parseFloat(ia) : 1
  };
}, hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: ({ hue: Bi, saturation: e, lightness: Zi, alpha: Qi = 1 }) => "hsla(" + Math.round(Bi) + ", " + percent.transform(sanitize(e)) + ", " + percent.transform(sanitize(Zi)) + ", " + sanitize(alpha.transform(Qi)) + ")"
}, clampRgbUnit = clamp$1(0, 255), rgbUnit = Object.assign(Object.assign({}, number), { transform: (Bi) => Math.round(clampRgbUnit(Bi)) }), rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: ({ red: Bi, green: e, blue: Zi, alpha: Qi = 1 }) => "rgba(" + rgbUnit.transform(Bi) + ", " + rgbUnit.transform(e) + ", " + rgbUnit.transform(Zi) + ", " + sanitize(alpha.transform(Qi)) + ")"
};
function parseHex(Bi) {
  let e = "", Zi = "", Qi = "", ea = "";
  return Bi.length > 5 ? (e = Bi.substr(1, 2), Zi = Bi.substr(3, 2), Qi = Bi.substr(5, 2), ea = Bi.substr(7, 2)) : (e = Bi.substr(1, 1), Zi = Bi.substr(2, 1), Qi = Bi.substr(3, 1), ea = Bi.substr(4, 1), e += e, Zi += Zi, Qi += Qi, ea += ea), {
    red: parseInt(e, 16),
    green: parseInt(Zi, 16),
    blue: parseInt(Qi, 16),
    alpha: ea ? parseInt(ea, 16) / 255 : 1
  };
}
const hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
}, color = {
  test: (Bi) => rgba.test(Bi) || hex.test(Bi) || hsla.test(Bi),
  parse: (Bi) => rgba.test(Bi) ? rgba.parse(Bi) : hsla.test(Bi) ? hsla.parse(Bi) : hex.parse(Bi),
  transform: (Bi) => isString$1(Bi) ? Bi : Bi.hasOwnProperty("red") ? rgba.transform(Bi) : hsla.transform(Bi)
}, colorToken = "${c}", numberToken = "${n}";
function test(Bi) {
  var e, Zi, Qi, ea;
  return isNaN(Bi) && isString$1(Bi) && ((Zi = (e = Bi.match(floatRegex)) === null || e === void 0 ? void 0 : e.length) !== null && Zi !== void 0 ? Zi : 0) + ((ea = (Qi = Bi.match(colorRegex)) === null || Qi === void 0 ? void 0 : Qi.length) !== null && ea !== void 0 ? ea : 0) > 0;
}
function analyse$1(Bi) {
  typeof Bi == "number" && (Bi = `${Bi}`);
  const e = [];
  let Zi = 0;
  const Qi = Bi.match(colorRegex);
  Qi && (Zi = Qi.length, Bi = Bi.replace(colorRegex, colorToken), e.push(...Qi.map(color.parse)));
  const ea = Bi.match(floatRegex);
  return ea && (Bi = Bi.replace(floatRegex, numberToken), e.push(...ea.map(number.parse))), { values: e, numColors: Zi, tokenised: Bi };
}
function parse(Bi) {
  return analyse$1(Bi).values;
}
function createTransformer(Bi) {
  const { values: e, numColors: Zi, tokenised: Qi } = analyse$1(Bi), ea = e.length;
  return (ra) => {
    let na = Qi;
    for (let ia = 0; ia < ea; ia++)
      na = na.replace(ia < Zi ? colorToken : numberToken, ia < Zi ? color.transform(ra[ia]) : sanitize(ra[ia]));
    return na;
  };
}
const convertNumbersToZero = (Bi) => typeof Bi == "number" ? 0 : Bi;
function getAnimatableNone$1(Bi) {
  const e = parse(Bi);
  return createTransformer(Bi)(e.map(convertNumbersToZero));
}
const complex = { test, parse, createTransformer, getAnimatableNone: getAnimatableNone$1 }, maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(Bi) {
  let [e, Zi] = Bi.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return Bi;
  const [Qi] = Zi.match(floatRegex) || [];
  if (!Qi)
    return Bi;
  const ea = Zi.replace(Qi, "");
  let ra = maxDefaults.has(e) ? 1 : 0;
  return Qi !== Zi && (ra *= 100), e + "(" + ra + ea + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g, filter = Object.assign(Object.assign({}, complex), { getAnimatableNone: (Bi) => {
  const e = Bi.match(functionRegex);
  return e ? e.map(applyDefaultFilter).join(" ") : Bi;
} });
var int = __assign(__assign({}, number), { transform: Math.round }), numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};
function buildHTMLStyles(Bi, e, Zi, Qi) {
  var ea, ra = Bi.style, na = Bi.vars, ia = Bi.transform, fa = Bi.transformKeys, La = Bi.transformOrigin;
  fa.length = 0;
  var Va = !1, to = !1, ro = !0;
  for (var no in e) {
    var eo = e[no];
    if (isCSSVariable$1(no)) {
      na[no] = eo;
      continue;
    }
    var ao = numberValueTypes[no], io = getValueAsType(eo, ao);
    if (isTransformProp(no)) {
      if (Va = !0, ia[no] = io, fa.push(no), !ro)
        continue;
      eo !== ((ea = ao.default) !== null && ea !== void 0 ? ea : 0) && (ro = !1);
    } else isTransformOriginProp(no) ? (La[no] = io, to = !0) : ra[no] = io;
  }
  Va ? ra.transform = buildTransform(Bi, Zi, ro, Qi) : Qi ? ra.transform = Qi({}, "") : !e.transform && ra.transform && (ra.transform = "none"), to && (ra.transformOrigin = buildTransformOrigin(La));
}
var createHtmlRenderState = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function copyRawValuesOnly(Bi, e, Zi) {
  for (var Qi in e)
    !isMotionValue(e[Qi]) && !isForcedMotionValue(Qi, Zi) && (Bi[Qi] = e[Qi]);
}
function useInitialMotionValues(Bi, e, Zi) {
  var Qi = Bi.transformTemplate;
  return useMemo(function() {
    var ea = createHtmlRenderState();
    buildHTMLStyles(ea, e, { enableHardwareAcceleration: !Zi }, Qi);
    var ra = ea.vars, na = ea.style;
    return __assign(__assign({}, ra), na);
  }, [e]);
}
function useStyle(Bi, e, Zi) {
  var Qi = Bi.style || {}, ea = {};
  return copyRawValuesOnly(ea, Qi, Bi), Object.assign(ea, useInitialMotionValues(Bi, e, Zi)), Bi.transformValues && (ea = Bi.transformValues(ea)), ea;
}
function useHTMLProps(Bi, e, Zi) {
  var Qi = {}, ea = useStyle(Bi, e, Zi);
  return Bi.drag && Bi.dragListener !== !1 && (Qi.draggable = !1, ea.userSelect = ea.WebkitUserSelect = ea.WebkitTouchCallout = "none", ea.touchAction = Bi.drag === !0 ? "none" : "pan-".concat(Bi.drag === "x" ? "y" : "x")), Qi.style = ea, Qi;
}
var validMotionProps = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function isValidMotionProp(Bi) {
  return validMotionProps.has(Bi);
}
var shouldForward = function(Bi) {
  return !isValidMotionProp(Bi);
};
function loadExternalIsValidProp(Bi) {
  Bi && (shouldForward = function(e) {
    return e.startsWith("on") ? !isValidMotionProp(e) : Bi(e);
  });
}
try {
  loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
} catch {
}
function filterProps(Bi, e, Zi) {
  var Qi = {};
  for (var ea in Bi)
    (shouldForward(ea) || Zi === !0 && isValidMotionProp(ea) || !e && !isValidMotionProp(ea) || // If trying to use native HTML drag events, forward drag listeners
    Bi.draggable && ea.startsWith("onDrag")) && (Qi[ea] = Bi[ea]);
  return Qi;
}
function calcOrigin$1(Bi, e, Zi) {
  return typeof Bi == "string" ? Bi : px.transform(e + Zi * Bi);
}
function calcSVGTransformOrigin(Bi, e, Zi) {
  var Qi = calcOrigin$1(e, Bi.x, Bi.width), ea = calcOrigin$1(Zi, Bi.y, Bi.height);
  return "".concat(Qi, " ").concat(ea);
}
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(Bi, e, Zi, Qi, ea) {
  Zi === void 0 && (Zi = 1), Qi === void 0 && (Qi = 0), Bi.pathLength = 1;
  var ra = camelKeys;
  Bi[ra.offset] = px.transform(-Qi);
  var na = px.transform(e), ia = px.transform(Zi);
  Bi[ra.array] = "".concat(na, " ").concat(ia);
}
function buildSVGAttrs(Bi, e, Zi, Qi) {
  var ea = e.attrX, ra = e.attrY, na = e.originX, ia = e.originY, fa = e.pathLength, La = e.pathSpacing, Va = La === void 0 ? 1 : La, to = e.pathOffset, ro = to === void 0 ? 0 : to, no = __rest$1(e, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  buildHTMLStyles(Bi, no, Zi, Qi), Bi.attrs = Bi.style, Bi.style = {};
  var eo = Bi.attrs, ao = Bi.style, io = Bi.dimensions;
  eo.transform && (io && (ao.transform = eo.transform), delete eo.transform), io && (na !== void 0 || ia !== void 0 || ao.transform) && (ao.transformOrigin = calcSVGTransformOrigin(io, na !== void 0 ? na : 0.5, ia !== void 0 ? ia : 0.5)), ea !== void 0 && (eo.x = ea), ra !== void 0 && (eo.y = ra), fa !== void 0 && buildSVGPath(eo, fa, Va, ro);
}
var createSvgRenderState = function() {
  return __assign(__assign({}, createHtmlRenderState()), { attrs: {} });
};
function useSVGProps(Bi, e) {
  var Zi = useMemo(function() {
    var ea = createSvgRenderState();
    return buildSVGAttrs(ea, e, { enableHardwareAcceleration: !1 }, Bi.transformTemplate), __assign(__assign({}, ea.attrs), { style: __assign({}, ea.style) });
  }, [e]);
  if (Bi.style) {
    var Qi = {};
    copyRawValuesOnly(Qi, Bi.style, Bi), Zi.style = __assign(__assign({}, Qi), Zi.style);
  }
  return Zi;
}
function createUseRender(Bi) {
  Bi === void 0 && (Bi = !1);
  var e = function(Zi, Qi, ea, ra, na, ia) {
    var fa = na.latestValues, La = isSVGComponent(Zi) ? useSVGProps : useHTMLProps, Va = La(Qi, fa, ia), to = filterProps(Qi, typeof Zi == "string", Bi), ro = __assign(__assign(__assign({}, to), Va), { ref: ra });
    return ea && (ro["data-projection-id"] = ea), createElement$1(Zi, ro);
  };
  return e;
}
var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g, REPLACE_TEMPLATE = "$1-$2", camelToDash = function(Bi) {
  return Bi.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};
function renderHTML(Bi, e, Zi, Qi) {
  var ea = e.style, ra = e.vars;
  Object.assign(Bi.style, ea, Qi && Qi.getProjectionStyles(Zi));
  for (var na in ra)
    Bi.style.setProperty(na, ra[na]);
}
var camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function renderSVG(Bi, e, Zi, Qi) {
  renderHTML(Bi, e, void 0, Qi);
  for (var ea in e.attrs)
    Bi.setAttribute(camelCaseAttributes.has(ea) ? ea : camelToDash(ea), e.attrs[ea]);
}
function scrapeMotionValuesFromProps$1(Bi) {
  var e = Bi.style, Zi = {};
  for (var Qi in e)
    (isMotionValue(e[Qi]) || isForcedMotionValue(Qi, Bi)) && (Zi[Qi] = e[Qi]);
  return Zi;
}
function scrapeMotionValuesFromProps(Bi) {
  var e = scrapeMotionValuesFromProps$1(Bi);
  for (var Zi in Bi)
    if (isMotionValue(Bi[Zi])) {
      var Qi = Zi === "x" || Zi === "y" ? "attr" + Zi.toUpperCase() : Zi;
      e[Qi] = Bi[Zi];
    }
  return e;
}
function isAnimationControls(Bi) {
  return typeof Bi == "object" && typeof Bi.start == "function";
}
var isKeyframesTarget = function(Bi) {
  return Array.isArray(Bi);
}, isCustomValue = function(Bi) {
  return !!(Bi && typeof Bi == "object" && Bi.mix && Bi.toValue);
}, resolveFinalValueInKeyframes = function(Bi) {
  return isKeyframesTarget(Bi) ? Bi[Bi.length - 1] || 0 : Bi;
};
function resolveMotionValue(Bi) {
  var e = isMotionValue(Bi) ? Bi.get() : Bi;
  return isCustomValue(e) ? e.toValue() : e;
}
function makeState(Bi, e, Zi, Qi) {
  var ea = Bi.scrapeMotionValuesFromProps, ra = Bi.createRenderState, na = Bi.onMount, ia = {
    latestValues: makeLatestValues(e, Zi, Qi, ea),
    renderState: ra()
  };
  return na && (ia.mount = function(fa) {
    return na(e, fa, ia);
  }), ia;
}
var makeUseVisualState = function(Bi) {
  return function(e, Zi) {
    var Qi = useContext(MotionContext), ea = useContext(PresenceContext);
    return Zi ? makeState(Bi, e, Qi, ea) : useConstant(function() {
      return makeState(Bi, e, Qi, ea);
    });
  };
};
function makeLatestValues(Bi, e, Zi, Qi) {
  var ea = {}, ra = Zi?.initial === !1, na = Qi(Bi);
  for (var ia in na)
    ea[ia] = resolveMotionValue(na[ia]);
  var fa = Bi.initial, La = Bi.animate, Va = checkIfControllingVariants(Bi), to = checkIfVariantNode(Bi);
  e && to && !Va && Bi.inherit !== !1 && (fa ?? (fa = e.initial), La ?? (La = e.animate));
  var ro = ra || fa === !1, no = ro ? La : fa;
  if (no && typeof no != "boolean" && !isAnimationControls(no)) {
    var eo = Array.isArray(no) ? no : [no];
    eo.forEach(function(ao) {
      var io = resolveVariantFromProps(Bi, ao);
      if (io) {
        var xs = io.transitionEnd;
        io.transition;
        var Ts = __rest$1(io, ["transitionEnd", "transition"]);
        for (var qs in Ts) {
          var Fs = Ts[qs];
          if (Array.isArray(Fs)) {
            var Do = ro ? Fs.length - 1 : 0;
            Fs = Fs[Do];
          }
          Fs !== null && (ea[qs] = Fs);
        }
        for (var qs in xs)
          ea[qs] = xs[qs];
      }
    });
  }
  return ea;
}
var svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createSvgRenderState,
    onMount: function(Bi, e, Zi) {
      var Qi = Zi.renderState, ea = Zi.latestValues;
      try {
        Qi.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
      } catch {
        Qi.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      buildSVGAttrs(Qi, ea, { enableHardwareAcceleration: !1 }, Bi.transformTemplate), renderSVG(e, Qi);
    }
  })
}, htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    createRenderState: createHtmlRenderState
  })
};
function createDomMotionConfig(Bi, e, Zi, Qi, ea) {
  var ra = e.forwardMotionProps, na = ra === void 0 ? !1 : ra, ia = isSVGComponent(Bi) ? svgMotionConfig : htmlMotionConfig;
  return __assign(__assign({}, ia), { preloadedFeatures: Zi, useRender: createUseRender(na), createVisualElement: Qi, projectionNodeConstructor: ea, Component: Bi });
}
var AnimationType;
(function(Bi) {
  Bi.Animate = "animate", Bi.Hover = "whileHover", Bi.Tap = "whileTap", Bi.Drag = "whileDrag", Bi.Focus = "whileFocus", Bi.InView = "whileInView", Bi.Exit = "exit";
})(AnimationType || (AnimationType = {}));
function addDomEvent(Bi, e, Zi, Qi) {
  return Qi === void 0 && (Qi = { passive: !0 }), Bi.addEventListener(e, Zi, Qi), function() {
    return Bi.removeEventListener(e, Zi);
  };
}
function useDomEvent(Bi, e, Zi, Qi) {
  useEffect(function() {
    var ea = Bi.current;
    if (Zi && ea)
      return addDomEvent(ea, e, Zi, Qi);
  }, [Bi, e, Zi, Qi]);
}
function useFocusGesture(Bi) {
  var e = Bi.whileFocus, Zi = Bi.visualElement, Qi = function() {
    var ra;
    (ra = Zi.animationState) === null || ra === void 0 || ra.setActive(AnimationType.Focus, !0);
  }, ea = function() {
    var ra;
    (ra = Zi.animationState) === null || ra === void 0 || ra.setActive(AnimationType.Focus, !1);
  };
  useDomEvent(Zi, "focus", e ? Qi : void 0), useDomEvent(Zi, "blur", e ? ea : void 0);
}
function isMouseEvent(Bi) {
  return typeof PointerEvent < "u" && Bi instanceof PointerEvent ? Bi.pointerType === "mouse" : Bi instanceof MouseEvent;
}
function isTouchEvent(Bi) {
  var e = !!Bi.touches;
  return e;
}
function filterPrimaryPointer(Bi) {
  return function(e) {
    var Zi = e instanceof MouseEvent, Qi = !Zi || Zi && e.button === 0;
    Qi && Bi(e);
  };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(Bi, e) {
  e === void 0 && (e = "page");
  var Zi = Bi.touches[0] || Bi.changedTouches[0], Qi = Zi || defaultPagePoint;
  return {
    x: Qi[e + "X"],
    y: Qi[e + "Y"]
  };
}
function pointFromMouse(Bi, e) {
  return e === void 0 && (e = "page"), {
    x: Bi[e + "X"],
    y: Bi[e + "Y"]
  };
}
function extractEventInfo(Bi, e) {
  return e === void 0 && (e = "page"), {
    point: isTouchEvent(Bi) ? pointFromTouch(Bi, e) : pointFromMouse(Bi, e)
  };
}
var wrapHandler = function(Bi, e) {
  e === void 0 && (e = !1);
  var Zi = function(Qi) {
    return Bi(Qi, extractEventInfo(Qi));
  };
  return e ? filterPrimaryPointer(Zi) : Zi;
}, supportsPointerEvents = function() {
  return isBrowser && window.onpointerdown === null;
}, supportsTouchEvents = function() {
  return isBrowser && window.ontouchstart === null;
}, supportsMouseEvents = function() {
  return isBrowser && window.onmousedown === null;
}, mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(Bi) {
  return supportsPointerEvents() ? Bi : supportsTouchEvents() ? touchEventNames[Bi] : supportsMouseEvents() ? mouseEventNames[Bi] : Bi;
}
function addPointerEvent(Bi, e, Zi, Qi) {
  return addDomEvent(Bi, getPointerEventName(e), wrapHandler(Zi, e === "pointerdown"), Qi);
}
function usePointerEvent(Bi, e, Zi, Qi) {
  return useDomEvent(Bi, getPointerEventName(e), Zi && wrapHandler(Zi, e === "pointerdown"), Qi);
}
function createLock(Bi) {
  var e = null;
  return function() {
    var Zi = function() {
      e = null;
    };
    return e === null ? (e = Bi, Zi) : !1;
  };
}
var globalHorizontalLock = createLock("dragHorizontal"), globalVerticalLock = createLock("dragVertical");
function getGlobalLock(Bi) {
  var e = !1;
  if (Bi === "y")
    e = globalVerticalLock();
  else if (Bi === "x")
    e = globalHorizontalLock();
  else {
    var Zi = globalHorizontalLock(), Qi = globalVerticalLock();
    Zi && Qi ? e = function() {
      Zi(), Qi();
    } : (Zi && Zi(), Qi && Qi());
  }
  return e;
}
function isDragActive() {
  var Bi = getGlobalLock(!0);
  return Bi ? (Bi(), !1) : !0;
}
function createHoverEvent(Bi, e, Zi) {
  return function(Qi, ea) {
    var ra;
    !isMouseEvent(Qi) || isDragActive() || ((ra = Bi.animationState) === null || ra === void 0 || ra.setActive(AnimationType.Hover, e), Zi?.(Qi, ea));
  };
}
function useHoverGesture(Bi) {
  var e = Bi.onHoverStart, Zi = Bi.onHoverEnd, Qi = Bi.whileHover, ea = Bi.visualElement;
  usePointerEvent(ea, "pointerenter", e || Qi ? createHoverEvent(ea, !0, e) : void 0, { passive: !e }), usePointerEvent(ea, "pointerleave", Zi || Qi ? createHoverEvent(ea, !1, Zi) : void 0, { passive: !Zi });
}
var isNodeOrChild = function(Bi, e) {
  return e ? Bi === e ? !0 : isNodeOrChild(Bi, e.parentElement) : !1;
};
function useUnmountEffect(Bi) {
  return useEffect(function() {
    return function() {
      return Bi();
    };
  }, []);
}
function __rest(Bi, e) {
  var Zi = {};
  for (var Qi in Bi) Object.prototype.hasOwnProperty.call(Bi, Qi) && e.indexOf(Qi) < 0 && (Zi[Qi] = Bi[Qi]);
  if (Bi != null && typeof Object.getOwnPropertySymbols == "function")
    for (var ea = 0, Qi = Object.getOwnPropertySymbols(Bi); ea < Qi.length; ea++)
      e.indexOf(Qi[ea]) < 0 && Object.prototype.propertyIsEnumerable.call(Bi, Qi[ea]) && (Zi[Qi[ea]] = Bi[Qi[ea]]);
  return Zi;
}
function __awaiter(Bi, e, Zi, Qi) {
  function ea(ra) {
    return ra instanceof Zi ? ra : new Zi(function(na) {
      na(ra);
    });
  }
  return new (Zi || (Zi = Promise))(function(ra, na) {
    function ia(Va) {
      try {
        La(Qi.next(Va));
      } catch (to) {
        na(to);
      }
    }
    function fa(Va) {
      try {
        La(Qi.throw(Va));
      } catch (to) {
        na(to);
      }
    }
    function La(Va) {
      Va.done ? ra(Va.value) : ea(Va.value).then(ia, fa);
    }
    La((Qi = Qi.apply(Bi, e || [])).next());
  });
}
typeof SuppressedError == "function" && SuppressedError;
const clamp = (Bi, e, Zi) => Math.min(Math.max(Zi, Bi), e), safeMin = 1e-3, minDuration = 0.01, maxDuration = 10, minDamping = 0.05, maxDamping = 1;
function findSpring({ duration: Bi = 800, bounce: e = 0.25, velocity: Zi = 0, mass: Qi = 1 }) {
  let ea, ra;
  warning$1(Bi <= maxDuration * 1e3, "Spring duration must be 10 seconds or less");
  let na = 1 - e;
  na = clamp(minDamping, maxDamping, na), Bi = clamp(minDuration, maxDuration, Bi / 1e3), na < 1 ? (ea = (La) => {
    const Va = La * na, to = Va * Bi, ro = Va - Zi, no = calcAngularFreq(La, na), eo = Math.exp(-to);
    return safeMin - ro / no * eo;
  }, ra = (La) => {
    const to = La * na * Bi, ro = to * Zi + Zi, no = Math.pow(na, 2) * Math.pow(La, 2) * Bi, eo = Math.exp(-to), ao = calcAngularFreq(Math.pow(La, 2), na);
    return (-ea(La) + safeMin > 0 ? -1 : 1) * ((ro - no) * eo) / ao;
  }) : (ea = (La) => {
    const Va = Math.exp(-La * Bi), to = (La - Zi) * Bi + 1;
    return -safeMin + Va * to;
  }, ra = (La) => {
    const Va = Math.exp(-La * Bi), to = (Zi - La) * (Bi * Bi);
    return Va * to;
  });
  const ia = 5 / Bi, fa = approximateRoot(ea, ra, ia);
  if (Bi = Bi * 1e3, isNaN(fa))
    return {
      stiffness: 100,
      damping: 10,
      duration: Bi
    };
  {
    const La = Math.pow(fa, 2) * Qi;
    return {
      stiffness: La,
      damping: na * 2 * Math.sqrt(Qi * La),
      duration: Bi
    };
  }
}
const rootIterations = 12;
function approximateRoot(Bi, e, Zi) {
  let Qi = Zi;
  for (let ea = 1; ea < rootIterations; ea++)
    Qi = Qi - Bi(Qi) / e(Qi);
  return Qi;
}
function calcAngularFreq(Bi, e) {
  return Bi * Math.sqrt(1 - e * e);
}
const durationKeys = ["duration", "bounce"], physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(Bi, e) {
  return e.some((Zi) => Bi[Zi] !== void 0);
}
function getSpringOptions(Bi) {
  let e = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, Bi);
  if (!isSpringType(Bi, physicsKeys) && isSpringType(Bi, durationKeys)) {
    const Zi = findSpring(Bi);
    e = Object.assign(Object.assign(Object.assign({}, e), Zi), { velocity: 0, mass: 1 }), e.isResolvedFromDuration = !0;
  }
  return e;
}
function spring(Bi) {
  var { from: e = 0, to: Zi = 1, restSpeed: Qi = 2, restDelta: ea } = Bi, ra = __rest(Bi, ["from", "to", "restSpeed", "restDelta"]);
  const na = { done: !1, value: e };
  let { stiffness: ia, damping: fa, mass: La, velocity: Va, duration: to, isResolvedFromDuration: ro } = getSpringOptions(ra), no = zero, eo = zero;
  function ao() {
    const io = Va ? -(Va / 1e3) : 0, xs = Zi - e, Ts = fa / (2 * Math.sqrt(ia * La)), qs = Math.sqrt(ia / La) / 1e3;
    if (ea === void 0 && (ea = Math.min(Math.abs(Zi - e) / 100, 0.4)), Ts < 1) {
      const Fs = calcAngularFreq(qs, Ts);
      no = (Do) => {
        const ys = Math.exp(-Ts * qs * Do);
        return Zi - ys * ((io + Ts * qs * xs) / Fs * Math.sin(Fs * Do) + xs * Math.cos(Fs * Do));
      }, eo = (Do) => {
        const ys = Math.exp(-Ts * qs * Do);
        return Ts * qs * ys * (Math.sin(Fs * Do) * (io + Ts * qs * xs) / Fs + xs * Math.cos(Fs * Do)) - ys * (Math.cos(Fs * Do) * (io + Ts * qs * xs) - Fs * xs * Math.sin(Fs * Do));
      };
    } else if (Ts === 1)
      no = (Fs) => Zi - Math.exp(-qs * Fs) * (xs + (io + qs * xs) * Fs);
    else {
      const Fs = qs * Math.sqrt(Ts * Ts - 1);
      no = (Do) => {
        const ys = Math.exp(-Ts * qs * Do), Io = Math.min(Fs * Do, 300);
        return Zi - ys * ((io + Ts * qs * xs) * Math.sinh(Io) + Fs * xs * Math.cosh(Io)) / Fs;
      };
    }
  }
  return ao(), {
    next: (io) => {
      const xs = no(io);
      if (ro)
        na.done = io >= to;
      else {
        const Ts = eo(io) * 1e3, qs = Math.abs(Ts) <= Qi, Fs = Math.abs(Zi - xs) <= ea;
        na.done = qs && Fs;
      }
      return na.value = na.done ? Zi : xs, na;
    },
    flipTarget: () => {
      Va = -Va, [e, Zi] = [Zi, e], ao();
    }
  };
}
spring.needsInterpolation = (Bi, e) => typeof Bi == "string" || typeof e == "string";
const zero = (Bi) => 0, progress = (Bi, e, Zi) => {
  const Qi = e - Bi;
  return Qi === 0 ? 1 : (Zi - Bi) / Qi;
}, mix = (Bi, e, Zi) => -Zi * Bi + Zi * e + Bi;
function hueToRgb(Bi, e, Zi) {
  return Zi < 0 && (Zi += 1), Zi > 1 && (Zi -= 1), Zi < 1 / 6 ? Bi + (e - Bi) * 6 * Zi : Zi < 1 / 2 ? e : Zi < 2 / 3 ? Bi + (e - Bi) * (2 / 3 - Zi) * 6 : Bi;
}
function hslaToRgba({ hue: Bi, saturation: e, lightness: Zi, alpha: Qi }) {
  Bi /= 360, e /= 100, Zi /= 100;
  let ea = 0, ra = 0, na = 0;
  if (!e)
    ea = ra = na = Zi;
  else {
    const ia = Zi < 0.5 ? Zi * (1 + e) : Zi + e - Zi * e, fa = 2 * Zi - ia;
    ea = hueToRgb(fa, ia, Bi + 1 / 3), ra = hueToRgb(fa, ia, Bi), na = hueToRgb(fa, ia, Bi - 1 / 3);
  }
  return {
    red: Math.round(ea * 255),
    green: Math.round(ra * 255),
    blue: Math.round(na * 255),
    alpha: Qi
  };
}
const mixLinearColor = (Bi, e, Zi) => {
  const Qi = Bi * Bi, ea = e * e;
  return Math.sqrt(Math.max(0, Zi * (ea - Qi) + Qi));
}, colorTypes = [hex, rgba, hsla], getColorType = (Bi) => colorTypes.find((e) => e.test(Bi)), notAnimatable = (Bi) => `'${Bi}' is not an animatable color. Use the equivalent color code instead.`, mixColor = (Bi, e) => {
  let Zi = getColorType(Bi), Qi = getColorType(e);
  invariant$1(!!Zi, notAnimatable(Bi)), invariant$1(!!Qi, notAnimatable(e));
  let ea = Zi.parse(Bi), ra = Qi.parse(e);
  Zi === hsla && (ea = hslaToRgba(ea), Zi = rgba), Qi === hsla && (ra = hslaToRgba(ra), Qi = rgba);
  const na = Object.assign({}, ea);
  return (ia) => {
    for (const fa in na)
      fa !== "alpha" && (na[fa] = mixLinearColor(ea[fa], ra[fa], ia));
    return na.alpha = mix(ea.alpha, ra.alpha, ia), Zi.transform(na);
  };
}, isNum = (Bi) => typeof Bi == "number", combineFunctions = (Bi, e) => (Zi) => e(Bi(Zi)), pipe = (...Bi) => Bi.reduce(combineFunctions);
function getMixer(Bi, e) {
  return isNum(Bi) ? (Zi) => mix(Bi, e, Zi) : color.test(Bi) ? mixColor(Bi, e) : mixComplex(Bi, e);
}
const mixArray = (Bi, e) => {
  const Zi = [...Bi], Qi = Zi.length, ea = Bi.map((ra, na) => getMixer(ra, e[na]));
  return (ra) => {
    for (let na = 0; na < Qi; na++)
      Zi[na] = ea[na](ra);
    return Zi;
  };
}, mixObject = (Bi, e) => {
  const Zi = Object.assign(Object.assign({}, Bi), e), Qi = {};
  for (const ea in Zi)
    Bi[ea] !== void 0 && e[ea] !== void 0 && (Qi[ea] = getMixer(Bi[ea], e[ea]));
  return (ea) => {
    for (const ra in Qi)
      Zi[ra] = Qi[ra](ea);
    return Zi;
  };
};
function analyse(Bi) {
  const e = complex.parse(Bi), Zi = e.length;
  let Qi = 0, ea = 0, ra = 0;
  for (let na = 0; na < Zi; na++)
    Qi || typeof e[na] == "number" ? Qi++ : e[na].hue !== void 0 ? ra++ : ea++;
  return { parsed: e, numNumbers: Qi, numRGB: ea, numHSL: ra };
}
const mixComplex = (Bi, e) => {
  const Zi = complex.createTransformer(e), Qi = analyse(Bi), ea = analyse(e);
  return Qi.numHSL === ea.numHSL && Qi.numRGB === ea.numRGB && Qi.numNumbers >= ea.numNumbers ? pipe(mixArray(Qi.parsed, ea.parsed), Zi) : (warning$1(!0, `Complex values '${Bi}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (na) => `${na > 0 ? e : Bi}`);
}, mixNumber = (Bi, e) => (Zi) => mix(Bi, e, Zi);
function detectMixerFactory(Bi) {
  if (typeof Bi == "number")
    return mixNumber;
  if (typeof Bi == "string")
    return color.test(Bi) ? mixColor : mixComplex;
  if (Array.isArray(Bi))
    return mixArray;
  if (typeof Bi == "object")
    return mixObject;
}
function createMixers(Bi, e, Zi) {
  const Qi = [], ea = Zi || detectMixerFactory(Bi[0]), ra = Bi.length - 1;
  for (let na = 0; na < ra; na++) {
    let ia = ea(Bi[na], Bi[na + 1]);
    if (e) {
      const fa = Array.isArray(e) ? e[na] : e;
      ia = pipe(fa, ia);
    }
    Qi.push(ia);
  }
  return Qi;
}
function fastInterpolate([Bi, e], [Zi]) {
  return (Qi) => Zi(progress(Bi, e, Qi));
}
function slowInterpolate(Bi, e) {
  const Zi = Bi.length, Qi = Zi - 1;
  return (ea) => {
    let ra = 0, na = !1;
    if (ea <= Bi[0] ? na = !0 : ea >= Bi[Qi] && (ra = Qi - 1, na = !0), !na) {
      let fa = 1;
      for (; fa < Zi && !(Bi[fa] > ea || fa === Qi); fa++)
        ;
      ra = fa - 1;
    }
    const ia = progress(Bi[ra], Bi[ra + 1], ea);
    return e[ra](ia);
  };
}
function interpolate(Bi, e, { clamp: Zi = !0, ease: Qi, mixer: ea } = {}) {
  const ra = Bi.length;
  invariant$1(ra === e.length, "Both input and output ranges must be the same length"), invariant$1(!Qi || !Array.isArray(Qi) || Qi.length === ra - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), Bi[0] > Bi[ra - 1] && (Bi = [].concat(Bi), e = [].concat(e), Bi.reverse(), e.reverse());
  const na = createMixers(e, Qi, ea), ia = ra === 2 ? fastInterpolate(Bi, na) : slowInterpolate(Bi, na);
  return Zi ? (fa) => ia(clamp(Bi[0], Bi[ra - 1], fa)) : ia;
}
const reverseEasing = (Bi) => (e) => 1 - Bi(1 - e), mirrorEasing = (Bi) => (e) => e <= 0.5 ? Bi(2 * e) / 2 : (2 - Bi(2 * (1 - e))) / 2, createExpoIn = (Bi) => (e) => Math.pow(e, Bi), createBackIn = (Bi) => (e) => e * e * ((Bi + 1) * e - Bi), createAnticipate = (Bi) => {
  const e = createBackIn(Bi);
  return (Zi) => (Zi *= 2) < 1 ? 0.5 * e(Zi) : 0.5 * (2 - Math.pow(2, -10 * (Zi - 1)));
}, DEFAULT_OVERSHOOT_STRENGTH = 1.525, BOUNCE_FIRST_THRESHOLD = 4 / 11, BOUNCE_SECOND_THRESHOLD = 8 / 11, BOUNCE_THIRD_THRESHOLD = 9 / 10, linear = (Bi) => Bi, easeIn = createExpoIn(2), easeOut = reverseEasing(easeIn), easeInOut = mirrorEasing(easeIn), circIn = (Bi) => 1 - Math.sin(Math.acos(Bi)), circOut = reverseEasing(circIn), circInOut = mirrorEasing(circOut), backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH), backOut = reverseEasing(backIn), backInOut = mirrorEasing(backIn), anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH), ca$1 = 4356 / 361, cb = 35442 / 1805, cc$1 = 16061 / 1805, bounceOut = (Bi) => {
  if (Bi === 1 || Bi === 0)
    return Bi;
  const e = Bi * Bi;
  return Bi < BOUNCE_FIRST_THRESHOLD ? 7.5625 * e : Bi < BOUNCE_SECOND_THRESHOLD ? 9.075 * e - 9.9 * Bi + 3.4 : Bi < BOUNCE_THIRD_THRESHOLD ? ca$1 * e - cb * Bi + cc$1 : 10.8 * Bi * Bi - 20.52 * Bi + 10.72;
}, bounceIn = reverseEasing(bounceOut), bounceInOut = (Bi) => Bi < 0.5 ? 0.5 * (1 - bounceOut(1 - Bi * 2)) : 0.5 * bounceOut(Bi * 2 - 1) + 0.5;
function defaultEasing(Bi, e) {
  return Bi.map(() => e || easeInOut).splice(0, Bi.length - 1);
}
function defaultOffset(Bi) {
  const e = Bi.length;
  return Bi.map((Zi, Qi) => Qi !== 0 ? Qi / (e - 1) : 0);
}
function convertOffsetToTimes(Bi, e) {
  return Bi.map((Zi) => Zi * e);
}
function keyframes$1({ from: Bi = 0, to: e = 1, ease: Zi, offset: Qi, duration: ea = 300 }) {
  const ra = { done: !1, value: Bi }, na = Array.isArray(e) ? e : [Bi, e], ia = convertOffsetToTimes(Qi && Qi.length === na.length ? Qi : defaultOffset(na), ea);
  function fa() {
    return interpolate(ia, na, {
      ease: Array.isArray(Zi) ? Zi : defaultEasing(na, Zi)
    });
  }
  let La = fa();
  return {
    next: (Va) => (ra.value = La(Va), ra.done = Va >= ea, ra),
    flipTarget: () => {
      na.reverse(), La = fa();
    }
  };
}
function decay({ velocity: Bi = 0, from: e = 0, power: Zi = 0.8, timeConstant: Qi = 350, restDelta: ea = 0.5, modifyTarget: ra }) {
  const na = { done: !1, value: e };
  let ia = Zi * Bi;
  const fa = e + ia, La = ra === void 0 ? fa : ra(fa);
  return La !== fa && (ia = La - e), {
    next: (Va) => {
      const to = -ia * Math.exp(-Va / Qi);
      return na.done = !(to > ea || to < -ea), na.value = na.done ? La : La + to, na;
    },
    flipTarget: () => {
    }
  };
}
const types = { keyframes: keyframes$1, spring, decay };
function detectAnimationFromOptions(Bi) {
  if (Array.isArray(Bi.to))
    return keyframes$1;
  if (types[Bi.type])
    return types[Bi.type];
  const e = new Set(Object.keys(Bi));
  return e.has("ease") || e.has("duration") && !e.has("dampingRatio") ? keyframes$1 : e.has("dampingRatio") || e.has("stiffness") || e.has("mass") || e.has("damping") || e.has("restSpeed") || e.has("restDelta") ? spring : keyframes$1;
}
const defaultTimestep = 1 / 60 * 1e3, getCurrentTime = typeof performance < "u" ? () => performance.now() : () => Date.now(), onNextFrame = typeof window < "u" ? (Bi) => window.requestAnimationFrame(Bi) : (Bi) => setTimeout(() => Bi(getCurrentTime()), defaultTimestep);
function createRenderStep(Bi) {
  let e = [], Zi = [], Qi = 0, ea = !1, ra = !1;
  const na = /* @__PURE__ */ new WeakSet(), ia = {
    schedule: (fa, La = !1, Va = !1) => {
      const to = Va && ea, ro = to ? e : Zi;
      return La && na.add(fa), ro.indexOf(fa) === -1 && (ro.push(fa), to && ea && (Qi = e.length)), fa;
    },
    cancel: (fa) => {
      const La = Zi.indexOf(fa);
      La !== -1 && Zi.splice(La, 1), na.delete(fa);
    },
    process: (fa) => {
      if (ea) {
        ra = !0;
        return;
      }
      if (ea = !0, [e, Zi] = [Zi, e], Zi.length = 0, Qi = e.length, Qi)
        for (let La = 0; La < Qi; La++) {
          const Va = e[La];
          Va(fa), na.has(Va) && (ia.schedule(Va), Bi());
        }
      ea = !1, ra && (ra = !1, ia.process(fa));
    }
  };
  return ia;
}
const maxElapsed = 40;
let useDefaultElapsed = !0, runNextFrame = !1, isProcessing = !1;
const frame = {
  delta: 0,
  timestamp: 0
}, stepsOrder = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], steps = stepsOrder.reduce((Bi, e) => (Bi[e] = createRenderStep(() => runNextFrame = !0), Bi), {}), sync = stepsOrder.reduce((Bi, e) => {
  const Zi = steps[e];
  return Bi[e] = (Qi, ea = !1, ra = !1) => (runNextFrame || startLoop(), Zi.schedule(Qi, ea, ra)), Bi;
}, {}), cancelSync = stepsOrder.reduce((Bi, e) => (Bi[e] = steps[e].cancel, Bi), {}), flushSync = stepsOrder.reduce((Bi, e) => (Bi[e] = () => steps[e].process(frame), Bi), {}), processStep = (Bi) => steps[Bi].process(frame), processFrame = (Bi) => {
  runNextFrame = !1, frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(Bi - frame.timestamp, maxElapsed), 1), frame.timestamp = Bi, isProcessing = !0, stepsOrder.forEach(processStep), isProcessing = !1, runNextFrame && (useDefaultElapsed = !1, onNextFrame(processFrame));
}, startLoop = () => {
  runNextFrame = !0, useDefaultElapsed = !0, isProcessing || onNextFrame(processFrame);
}, getFrameData = () => frame;
function loopElapsed(Bi, e, Zi = 0) {
  return Bi - e - Zi;
}
function reverseElapsed(Bi, e, Zi = 0, Qi = !0) {
  return Qi ? loopElapsed(e + -Bi, e, Zi) : e - (Bi - e) + Zi;
}
function hasRepeatDelayElapsed(Bi, e, Zi, Qi) {
  return Qi ? Bi >= e + Zi : Bi <= -Zi;
}
const framesync = (Bi) => {
  const e = ({ delta: Zi }) => Bi(Zi);
  return {
    start: () => sync.update(e, !0),
    stop: () => cancelSync.update(e)
  };
};
function animate$1(Bi) {
  var e, Zi, { from: Qi, autoplay: ea = !0, driver: ra = framesync, elapsed: na = 0, repeat: ia = 0, repeatType: fa = "loop", repeatDelay: La = 0, onPlay: Va, onStop: to, onComplete: ro, onRepeat: no, onUpdate: eo } = Bi, ao = __rest(Bi, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: io } = ao, xs, Ts = 0, qs = ao.duration, Fs, Do = !1, ys = !0, Io;
  const so = detectAnimationFromOptions(ao);
  !((Zi = (e = so).needsInterpolation) === null || Zi === void 0) && Zi.call(e, Qi, io) && (Io = interpolate([0, 100], [Qi, io], {
    clamp: !1
  }), Qi = 0, io = 100);
  const os = so(Object.assign(Object.assign({}, ao), { from: Qi, to: io }));
  function Xs() {
    Ts++, fa === "reverse" ? (ys = Ts % 2 === 0, na = reverseElapsed(na, qs, La, ys)) : (na = loopElapsed(na, qs, La), fa === "mirror" && os.flipTarget()), Do = !1, no && no();
  }
  function gl() {
    xs.stop(), ro && ro();
  }
  function Sl(wl) {
    if (ys || (wl = -wl), na += wl, !Do) {
      const jl = os.next(Math.max(0, na));
      Fs = jl.value, Io && (Fs = Io(Fs)), Do = ys ? jl.done : na <= 0;
    }
    eo?.(Fs), Do && (Ts === 0 && (qs ?? (qs = na)), Ts < ia ? hasRepeatDelayElapsed(na, qs, La, ys) && Xs() : gl());
  }
  function El() {
    Va?.(), xs = ra(Sl), xs.start();
  }
  return ea && El(), {
    stop: () => {
      to?.(), xs.stop();
    }
  };
}
function velocityPerSecond(Bi, e) {
  return e ? Bi * (1e3 / e) : 0;
}
function inertia({ from: Bi = 0, velocity: e = 0, min: Zi, max: Qi, power: ea = 0.8, timeConstant: ra = 750, bounceStiffness: na = 500, bounceDamping: ia = 10, restDelta: fa = 1, modifyTarget: La, driver: Va, onUpdate: to, onComplete: ro, onStop: no }) {
  let eo;
  function ao(qs) {
    return Zi !== void 0 && qs < Zi || Qi !== void 0 && qs > Qi;
  }
  function io(qs) {
    return Zi === void 0 ? Qi : Qi === void 0 || Math.abs(Zi - qs) < Math.abs(Qi - qs) ? Zi : Qi;
  }
  function xs(qs) {
    eo?.stop(), eo = animate$1(Object.assign(Object.assign({}, qs), {
      driver: Va,
      onUpdate: (Fs) => {
        var Do;
        to?.(Fs), (Do = qs.onUpdate) === null || Do === void 0 || Do.call(qs, Fs);
      },
      onComplete: ro,
      onStop: no
    }));
  }
  function Ts(qs) {
    xs(Object.assign({ type: "spring", stiffness: na, damping: ia, restDelta: fa }, qs));
  }
  if (ao(Bi))
    Ts({ from: Bi, velocity: e, to: io(Bi) });
  else {
    let qs = ea * e + Bi;
    typeof La < "u" && (qs = La(qs));
    const Fs = io(qs), Do = Fs === Zi ? -1 : 1;
    let ys, Io;
    const so = (os) => {
      ys = Io, Io = os, e = velocityPerSecond(os - ys, getFrameData().delta), (Do === 1 && os > Fs || Do === -1 && os < Fs) && Ts({ from: os, to: Fs, velocity: e });
    };
    xs({
      type: "decay",
      from: Bi,
      velocity: e,
      timeConstant: ra,
      power: ea,
      restDelta: fa,
      modifyTarget: La,
      onUpdate: ao(qs) ? so : void 0
    });
  }
  return {
    stop: () => eo?.stop()
  };
}
const isPoint = (Bi) => Bi.hasOwnProperty("x") && Bi.hasOwnProperty("y"), isPoint3D = (Bi) => isPoint(Bi) && Bi.hasOwnProperty("z"), distance1D = (Bi, e) => Math.abs(Bi - e);
function distance(Bi, e) {
  if (isNum(Bi) && isNum(e))
    return distance1D(Bi, e);
  if (isPoint(Bi) && isPoint(e)) {
    const Zi = distance1D(Bi.x, e.x), Qi = distance1D(Bi.y, e.y), ea = isPoint3D(Bi) && isPoint3D(e) ? distance1D(Bi.z, e.z) : 0;
    return Math.sqrt(Math.pow(Zi, 2) + Math.pow(Qi, 2) + Math.pow(ea, 2));
  }
}
const a$7 = (Bi, e) => 1 - 3 * e + 3 * Bi, b$3 = (Bi, e) => 3 * e - 6 * Bi, c$6 = (Bi) => 3 * Bi, calcBezier = (Bi, e, Zi) => ((a$7(e, Zi) * Bi + b$3(e, Zi)) * Bi + c$6(e)) * Bi, getSlope = (Bi, e, Zi) => 3 * a$7(e, Zi) * Bi * Bi + 2 * b$3(e, Zi) * Bi + c$6(e), subdivisionPrecision = 1e-7, subdivisionMaxIterations = 10;
function binarySubdivide(Bi, e, Zi, Qi, ea) {
  let ra, na, ia = 0;
  do
    na = e + (Zi - e) / 2, ra = calcBezier(na, Qi, ea) - Bi, ra > 0 ? Zi = na : e = na;
  while (Math.abs(ra) > subdivisionPrecision && ++ia < subdivisionMaxIterations);
  return na;
}
const newtonIterations = 8, newtonMinSlope = 1e-3;
function newtonRaphsonIterate(Bi, e, Zi, Qi) {
  for (let ea = 0; ea < newtonIterations; ++ea) {
    const ra = getSlope(e, Zi, Qi);
    if (ra === 0)
      return e;
    const na = calcBezier(e, Zi, Qi) - Bi;
    e -= na / ra;
  }
  return e;
}
const kSplineTableSize = 11, kSampleStepSize = 1 / (kSplineTableSize - 1);
function cubicBezier(Bi, e, Zi, Qi) {
  if (Bi === e && Zi === Qi)
    return linear;
  const ea = new Float32Array(kSplineTableSize);
  for (let na = 0; na < kSplineTableSize; ++na)
    ea[na] = calcBezier(na * kSampleStepSize, Bi, Zi);
  function ra(na) {
    let ia = 0, fa = 1;
    const La = kSplineTableSize - 1;
    for (; fa !== La && ea[fa] <= na; ++fa)
      ia += kSampleStepSize;
    --fa;
    const Va = (na - ea[fa]) / (ea[fa + 1] - ea[fa]), to = ia + Va * kSampleStepSize, ro = getSlope(to, Bi, Zi);
    return ro >= newtonMinSlope ? newtonRaphsonIterate(na, to, Bi, Zi) : ro === 0 ? to : binarySubdivide(na, ia, ia + kSampleStepSize, Bi, Zi);
  }
  return (na) => na === 0 || na === 1 ? na : calcBezier(ra(na), e, Qi);
}
function useTapGesture(Bi) {
  var e = Bi.onTap, Zi = Bi.onTapStart, Qi = Bi.onTapCancel, ea = Bi.whileTap, ra = Bi.visualElement, na = e || Zi || Qi || ea, ia = useRef(!1), fa = useRef(null), La = {
    passive: !(Zi || e || Qi || eo)
  };
  function Va() {
    var ao;
    (ao = fa.current) === null || ao === void 0 || ao.call(fa), fa.current = null;
  }
  function to() {
    var ao;
    return Va(), ia.current = !1, (ao = ra.animationState) === null || ao === void 0 || ao.setActive(AnimationType.Tap, !1), !isDragActive();
  }
  function ro(ao, io) {
    to() && (isNodeOrChild(ra.getInstance(), ao.target) ? e?.(ao, io) : Qi?.(ao, io));
  }
  function no(ao, io) {
    to() && Qi?.(ao, io);
  }
  function eo(ao, io) {
    var xs;
    Va(), !ia.current && (ia.current = !0, fa.current = pipe(addPointerEvent(window, "pointerup", ro, La), addPointerEvent(window, "pointercancel", no, La)), (xs = ra.animationState) === null || xs === void 0 || xs.setActive(AnimationType.Tap, !0), Zi?.(ao, io));
  }
  usePointerEvent(ra, "pointerdown", na ? eo : void 0, La), useUnmountEffect(Va);
}
var warned = /* @__PURE__ */ new Set();
function warnOnce(Bi, e, Zi) {
  Bi || warned.has(e) || (console.warn(e), warned.add(e));
}
var observerCallbacks = /* @__PURE__ */ new WeakMap(), observers = /* @__PURE__ */ new WeakMap(), fireObserverCallback = function(Bi) {
  var e;
  (e = observerCallbacks.get(Bi.target)) === null || e === void 0 || e(Bi);
}, fireAllObserverCallbacks = function(Bi) {
  Bi.forEach(fireObserverCallback);
};
function initIntersectionObserver(Bi) {
  var e = Bi.root, Zi = __rest$1(Bi, ["root"]), Qi = e || document;
  observers.has(Qi) || observers.set(Qi, {});
  var ea = observers.get(Qi), ra = JSON.stringify(Zi);
  return ea[ra] || (ea[ra] = new IntersectionObserver(fireAllObserverCallbacks, __assign({ root: e }, Zi))), ea[ra];
}
function observeIntersection(Bi, e, Zi) {
  var Qi = initIntersectionObserver(e);
  return observerCallbacks.set(Bi, Zi), Qi.observe(Bi), function() {
    observerCallbacks.delete(Bi), Qi.unobserve(Bi);
  };
}
function useViewport(Bi) {
  var e = Bi.visualElement, Zi = Bi.whileInView, Qi = Bi.onViewportEnter, ea = Bi.onViewportLeave, ra = Bi.viewport, na = ra === void 0 ? {} : ra, ia = useRef({
    hasEnteredView: !1,
    isInView: !1
  }), fa = !!(Zi || Qi || ea);
  na.once && ia.current.hasEnteredView && (fa = !1);
  var La = typeof IntersectionObserver > "u" ? useMissingIntersectionObserver : useIntersectionObserver;
  La(fa, ia.current, e, na);
}
var thresholdNames = {
  some: 0,
  all: 1
};
function useIntersectionObserver(Bi, e, Zi, Qi) {
  var ea = Qi.root, ra = Qi.margin, na = Qi.amount, ia = na === void 0 ? "some" : na, fa = Qi.once;
  useEffect(function() {
    if (Bi) {
      var La = {
        root: ea?.current,
        rootMargin: ra,
        threshold: typeof ia == "number" ? ia : thresholdNames[ia]
      }, Va = function(to) {
        var ro, no = to.isIntersecting;
        if (e.isInView !== no && (e.isInView = no, !(fa && !no && e.hasEnteredView))) {
          no && (e.hasEnteredView = !0), (ro = Zi.animationState) === null || ro === void 0 || ro.setActive(AnimationType.InView, no);
          var eo = Zi.getProps(), ao = no ? eo.onViewportEnter : eo.onViewportLeave;
          ao?.(to);
        }
      };
      return observeIntersection(Zi.getInstance(), La, Va);
    }
  }, [Bi, ea, ra, ia]);
}
function useMissingIntersectionObserver(Bi, e, Zi, Qi) {
  var ea = Qi.fallback, ra = ea === void 0 ? !0 : ea;
  useEffect(function() {
    !Bi || !ra || (env !== "production" && warnOnce(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var na;
      e.hasEnteredView = !0;
      var ia = Zi.getProps().onViewportEnter;
      ia?.(null), (na = Zi.animationState) === null || na === void 0 || na.setActive(AnimationType.InView, !0);
    }));
  }, [Bi]);
}
var makeRenderlessComponent = function(Bi) {
  return function(e) {
    return Bi(e), null;
  };
}, gestureAnimations = {
  inView: makeRenderlessComponent(useViewport),
  tap: makeRenderlessComponent(useTapGesture),
  focus: makeRenderlessComponent(useFocusGesture),
  hover: makeRenderlessComponent(useHoverGesture)
}, counter = 0, incrementId = function() {
  return counter++;
}, useId = function() {
  return useConstant(incrementId);
};
function usePresence() {
  var Bi = useContext(PresenceContext);
  if (Bi === null)
    return [!0, null];
  var e = Bi.isPresent, Zi = Bi.onExitComplete, Qi = Bi.register, ea = useId();
  useEffect(function() {
    return Qi(ea);
  }, []);
  var ra = function() {
    return Zi?.(ea);
  };
  return !e && Zi ? [!1, ra] : [!0];
}
function shallowCompare(Bi, e) {
  if (!Array.isArray(e))
    return !1;
  var Zi = e.length;
  if (Zi !== Bi.length)
    return !1;
  for (var Qi = 0; Qi < Zi; Qi++)
    if (e[Qi] !== Bi[Qi])
      return !1;
  return !0;
}
var secondsToMilliseconds = function(Bi) {
  return Bi * 1e3;
}, easingLookup = {
  linear,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate,
  bounceIn,
  bounceInOut,
  bounceOut
}, easingDefinitionToFunction = function(Bi) {
  if (Array.isArray(Bi)) {
    invariant$1(Bi.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var e = __read(Bi, 4), Zi = e[0], Qi = e[1], ea = e[2], ra = e[3];
    return cubicBezier(Zi, Qi, ea, ra);
  } else if (typeof Bi == "string")
    return invariant$1(easingLookup[Bi] !== void 0, "Invalid easing type '".concat(Bi, "'")), easingLookup[Bi];
  return Bi;
}, isEasingArray = function(Bi) {
  return Array.isArray(Bi) && typeof Bi[0] != "number";
}, isAnimatable = function(Bi, e) {
  return Bi === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
  complex.test(e) && // And it contains numbers and/or colors
  !e.startsWith("url("));
}, underDampedSpring = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, criticallyDampedSpring = function(Bi) {
  return {
    type: "spring",
    stiffness: 550,
    damping: Bi === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, linearTween = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, keyframes = function(Bi) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: Bi
  };
}, defaultTransitions = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: criticallyDampedSpring,
  scaleY: criticallyDampedSpring,
  scale: criticallyDampedSpring,
  opacity: linearTween,
  backgroundColor: linearTween,
  color: linearTween,
  default: criticallyDampedSpring
}, getDefaultTransition = function(Bi, e) {
  var Zi;
  return isKeyframesTarget(e) ? Zi = keyframes : Zi = defaultTransitions[Bi] || defaultTransitions.default, __assign({ to: e }, Zi(e));
}, defaultValueTypes = __assign(__assign({}, numberValueTypes), {
  // Color props
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter
}), getDefaultValueType = function(Bi) {
  return defaultValueTypes[Bi];
};
function getAnimatableNone(Bi, e) {
  var Zi, Qi = getDefaultValueType(Bi);
  return Qi !== filter && (Qi = complex), (Zi = Qi.getAnimatableNone) === null || Zi === void 0 ? void 0 : Zi.call(Qi, e);
}
function isTransitionDefined(Bi) {
  Bi.when, Bi.delay, Bi.delayChildren, Bi.staggerChildren, Bi.staggerDirection, Bi.repeat, Bi.repeatType, Bi.repeatDelay, Bi.from;
  var e = __rest$1(Bi, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(e).length;
}
var legacyRepeatWarning = !1;
function convertTransitionToAnimationOptions(Bi) {
  var e = Bi.ease, Zi = Bi.times, Qi = Bi.yoyo, ea = Bi.flip, ra = Bi.loop, na = __rest$1(Bi, ["ease", "times", "yoyo", "flip", "loop"]), ia = __assign({}, na);
  return Zi && (ia.offset = Zi), na.duration && (ia.duration = secondsToMilliseconds(na.duration)), na.repeatDelay && (ia.repeatDelay = secondsToMilliseconds(na.repeatDelay)), e && (ia.ease = isEasingArray(e) ? e.map(easingDefinitionToFunction) : easingDefinitionToFunction(e)), na.type === "tween" && (ia.type = "keyframes"), (Qi || ra || ea) && (warning$1(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), legacyRepeatWarning = !0, Qi ? ia.repeatType = "reverse" : ra ? ia.repeatType = "loop" : ea && (ia.repeatType = "mirror"), ia.repeat = ra || Qi || ea || na.repeat), na.type !== "spring" && (ia.type = "keyframes"), ia;
}
function getDelayFromTransition(Bi, e) {
  var Zi, Qi, ea = getValueTransition(Bi, e) || {};
  return (Qi = (Zi = ea.delay) !== null && Zi !== void 0 ? Zi : Bi.delay) !== null && Qi !== void 0 ? Qi : 0;
}
function hydrateKeyframes(Bi) {
  return Array.isArray(Bi.to) && Bi.to[0] === null && (Bi.to = __spreadArray([], __read(Bi.to), !1), Bi.to[0] = Bi.from), Bi;
}
function getPopmotionAnimationOptions(Bi, e, Zi) {
  var Qi;
  return Array.isArray(e.to) && ((Qi = Bi.duration) !== null && Qi !== void 0 || (Bi.duration = 0.8)), hydrateKeyframes(e), isTransitionDefined(Bi) || (Bi = __assign(__assign({}, Bi), getDefaultTransition(Zi, e.to))), __assign(__assign({}, e), convertTransitionToAnimationOptions(Bi));
}
function getAnimation(Bi, e, Zi, Qi, ea) {
  var ra, na = getValueTransition(Qi, Bi), ia = (ra = na.from) !== null && ra !== void 0 ? ra : e.get(), fa = isAnimatable(Bi, Zi);
  ia === "none" && fa && typeof Zi == "string" ? ia = getAnimatableNone(Bi, Zi) : isZero(ia) && typeof Zi == "string" ? ia = getZeroUnit(Zi) : !Array.isArray(Zi) && isZero(Zi) && typeof ia == "string" && (Zi = getZeroUnit(ia));
  var La = isAnimatable(Bi, ia);
  warning$1(La === fa, "You are trying to animate ".concat(Bi, ' from "').concat(ia, '" to "').concat(Zi, '". ').concat(ia, " is not an animatable value - to enable this animation set ").concat(ia, " to a value animatable to ").concat(Zi, " via the `style` property."));
  function Va() {
    var ro = {
      from: ia,
      to: Zi,
      velocity: e.getVelocity(),
      onComplete: ea,
      onUpdate: function(no) {
        return e.set(no);
      }
    };
    return na.type === "inertia" || na.type === "decay" ? inertia(__assign(__assign({}, ro), na)) : animate$1(__assign(__assign({}, getPopmotionAnimationOptions(na, ro, Bi)), { onUpdate: function(no) {
      var eo;
      ro.onUpdate(no), (eo = na.onUpdate) === null || eo === void 0 || eo.call(na, no);
    }, onComplete: function() {
      var no;
      ro.onComplete(), (no = na.onComplete) === null || no === void 0 || no.call(na);
    } }));
  }
  function to() {
    var ro, no, eo = resolveFinalValueInKeyframes(Zi);
    return e.set(eo), ea(), (ro = na?.onUpdate) === null || ro === void 0 || ro.call(na, eo), (no = na?.onComplete) === null || no === void 0 || no.call(na), { stop: function() {
    } };
  }
  return !La || !fa || na.type === !1 ? to : Va;
}
function isZero(Bi) {
  return Bi === 0 || typeof Bi == "string" && parseFloat(Bi) === 0 && Bi.indexOf(" ") === -1;
}
function getZeroUnit(Bi) {
  return typeof Bi == "number" ? 0 : getAnimatableNone("", Bi);
}
function getValueTransition(Bi, e) {
  return Bi[e] || Bi.default || Bi;
}
function startAnimation(Bi, e, Zi, Qi) {
  return Qi === void 0 && (Qi = {}), e.start(function(ea) {
    var ra, na, ia = getAnimation(Bi, e, Zi, Qi, ea), fa = getDelayFromTransition(Qi, Bi), La = function() {
      return na = ia();
    };
    return fa ? ra = window.setTimeout(La, secondsToMilliseconds(fa)) : La(), function() {
      clearTimeout(ra), na?.stop();
    };
  });
}
var isNumericalString = function(Bi) {
  return /^\-?\d*\.?\d+$/.test(Bi);
}, isZeroValueString = function(Bi) {
  return /^0[^.\s]+$/.test(Bi);
};
function addUniqueItem(Bi, e) {
  Bi.indexOf(e) === -1 && Bi.push(e);
}
function removeItem(Bi, e) {
  var Zi = Bi.indexOf(e);
  Zi > -1 && Bi.splice(Zi, 1);
}
var SubscriptionManager = (
  /** @class */
  function() {
    function Bi() {
      this.subscriptions = [];
    }
    return Bi.prototype.add = function(e) {
      var Zi = this;
      return addUniqueItem(this.subscriptions, e), function() {
        return removeItem(Zi.subscriptions, e);
      };
    }, Bi.prototype.notify = function(e, Zi, Qi) {
      var ea = this.subscriptions.length;
      if (ea)
        if (ea === 1)
          this.subscriptions[0](e, Zi, Qi);
        else
          for (var ra = 0; ra < ea; ra++) {
            var na = this.subscriptions[ra];
            na && na(e, Zi, Qi);
          }
    }, Bi.prototype.getSize = function() {
      return this.subscriptions.length;
    }, Bi.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, Bi;
  }()
), isFloat = function(Bi) {
  return !isNaN(parseFloat(Bi));
}, MotionValue = (
  /** @class */
  function() {
    function Bi(e) {
      var Zi = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new SubscriptionManager(), this.velocityUpdateSubscribers = new SubscriptionManager(), this.renderSubscribers = new SubscriptionManager(), this.canTrackVelocity = !1, this.updateAndNotify = function(Qi, ea) {
        ea === void 0 && (ea = !0), Zi.prev = Zi.current, Zi.current = Qi;
        var ra = getFrameData(), na = ra.delta, ia = ra.timestamp;
        Zi.lastUpdated !== ia && (Zi.timeDelta = na, Zi.lastUpdated = ia, sync.postRender(Zi.scheduleVelocityCheck)), Zi.prev !== Zi.current && Zi.updateSubscribers.notify(Zi.current), Zi.velocityUpdateSubscribers.getSize() && Zi.velocityUpdateSubscribers.notify(Zi.getVelocity()), ea && Zi.renderSubscribers.notify(Zi.current);
      }, this.scheduleVelocityCheck = function() {
        return sync.postRender(Zi.velocityCheck);
      }, this.velocityCheck = function(Qi) {
        var ea = Qi.timestamp;
        ea !== Zi.lastUpdated && (Zi.prev = Zi.current, Zi.velocityUpdateSubscribers.notify(Zi.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = isFloat(this.current);
    }
    return Bi.prototype.onChange = function(e) {
      return this.updateSubscribers.add(e);
    }, Bi.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, Bi.prototype.onRenderRequest = function(e) {
      return e(this.get()), this.renderSubscribers.add(e);
    }, Bi.prototype.attach = function(e) {
      this.passiveEffect = e;
    }, Bi.prototype.set = function(e, Zi) {
      Zi === void 0 && (Zi = !0), !Zi || !this.passiveEffect ? this.updateAndNotify(e, Zi) : this.passiveEffect(e, this.updateAndNotify);
    }, Bi.prototype.get = function() {
      return this.current;
    }, Bi.prototype.getPrevious = function() {
      return this.prev;
    }, Bi.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, Bi.prototype.start = function(e) {
      var Zi = this;
      return this.stop(), new Promise(function(Qi) {
        Zi.hasAnimated = !0, Zi.stopAnimation = e(Qi);
      }).then(function() {
        return Zi.clearAnimation();
      });
    }, Bi.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, Bi.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, Bi.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, Bi.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, Bi;
  }()
);
function motionValue(Bi) {
  return new MotionValue(Bi);
}
var testValueType = function(Bi) {
  return function(e) {
    return e.test(Bi);
  };
}, auto = {
  test: function(Bi) {
    return Bi === "auto";
  },
  parse: function(Bi) {
    return Bi;
  }
}, dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto], findDimensionValueType = function(Bi) {
  return dimensionValueTypes.find(testValueType(Bi));
}, valueTypes = __spreadArray(__spreadArray([], __read(dimensionValueTypes), !1), [color, complex], !1), findValueType = function(Bi) {
  return valueTypes.find(testValueType(Bi));
};
function setMotionValue(Bi, e, Zi) {
  Bi.hasValue(e) ? Bi.getValue(e).set(Zi) : Bi.addValue(e, motionValue(Zi));
}
function setTarget(Bi, e) {
  var Zi = resolveVariant(Bi, e), Qi = Zi ? Bi.makeTargetAnimatable(Zi, !1) : {}, ea = Qi.transitionEnd, ra = ea === void 0 ? {} : ea;
  Qi.transition;
  var na = __rest$1(Qi, ["transitionEnd", "transition"]);
  na = __assign(__assign({}, na), ra);
  for (var ia in na) {
    var fa = resolveFinalValueInKeyframes(na[ia]);
    setMotionValue(Bi, ia, fa);
  }
}
function checkTargetForNewValues(Bi, e, Zi) {
  var Qi, ea, ra, na, ia = Object.keys(e).filter(function(no) {
    return !Bi.hasValue(no);
  }), fa = ia.length;
  if (fa)
    for (var La = 0; La < fa; La++) {
      var Va = ia[La], to = e[Va], ro = null;
      Array.isArray(to) && (ro = to[0]), ro === null && (ro = (ea = (Qi = Zi[Va]) !== null && Qi !== void 0 ? Qi : Bi.readValue(Va)) !== null && ea !== void 0 ? ea : e[Va]), ro != null && (typeof ro == "string" && (isNumericalString(ro) || isZeroValueString(ro)) ? ro = parseFloat(ro) : !findValueType(ro) && complex.test(to) && (ro = getAnimatableNone(Va, to)), Bi.addValue(Va, motionValue(ro)), (ra = (na = Zi)[Va]) !== null && ra !== void 0 || (na[Va] = ro), Bi.setBaseTarget(Va, ro));
    }
}
function getOriginFromTransition(Bi, e) {
  if (e) {
    var Zi = e[Bi] || e.default || e;
    return Zi.from;
  }
}
function getOrigin(Bi, e, Zi) {
  var Qi, ea, ra = {};
  for (var na in Bi)
    ra[na] = (Qi = getOriginFromTransition(na, e)) !== null && Qi !== void 0 ? Qi : (ea = Zi.getValue(na)) === null || ea === void 0 ? void 0 : ea.get();
  return ra;
}
function animateVisualElement(Bi, e, Zi) {
  Zi === void 0 && (Zi = {}), Bi.notifyAnimationStart(e);
  var Qi;
  if (Array.isArray(e)) {
    var ea = e.map(function(na) {
      return animateVariant(Bi, na, Zi);
    });
    Qi = Promise.all(ea);
  } else if (typeof e == "string")
    Qi = animateVariant(Bi, e, Zi);
  else {
    var ra = typeof e == "function" ? resolveVariant(Bi, e, Zi.custom) : e;
    Qi = animateTarget(Bi, ra, Zi);
  }
  return Qi.then(function() {
    return Bi.notifyAnimationComplete(e);
  });
}
function animateVariant(Bi, e, Zi) {
  var Qi;
  Zi === void 0 && (Zi = {});
  var ea = resolveVariant(Bi, e, Zi.custom), ra = (ea || {}).transition, na = ra === void 0 ? Bi.getDefaultTransition() || {} : ra;
  Zi.transitionOverride && (na = Zi.transitionOverride);
  var ia = ea ? function() {
    return animateTarget(Bi, ea, Zi);
  } : function() {
    return Promise.resolve();
  }, fa = !((Qi = Bi.variantChildren) === null || Qi === void 0) && Qi.size ? function(no) {
    no === void 0 && (no = 0);
    var eo = na.delayChildren, ao = eo === void 0 ? 0 : eo, io = na.staggerChildren, xs = na.staggerDirection;
    return animateChildren(Bi, e, ao + no, io, xs, Zi);
  } : function() {
    return Promise.resolve();
  }, La = na.when;
  if (La) {
    var Va = __read(La === "beforeChildren" ? [ia, fa] : [fa, ia], 2), to = Va[0], ro = Va[1];
    return to().then(ro);
  } else
    return Promise.all([ia(), fa(Zi.delay)]);
}
function animateTarget(Bi, e, Zi) {
  var Qi, ea = Zi === void 0 ? {} : Zi, ra = ea.delay, na = ra === void 0 ? 0 : ra, ia = ea.transitionOverride, fa = ea.type, La = Bi.makeTargetAnimatable(e), Va = La.transition, to = Va === void 0 ? Bi.getDefaultTransition() : Va, ro = La.transitionEnd, no = __rest$1(La, ["transition", "transitionEnd"]);
  ia && (to = ia);
  var eo = [], ao = fa && ((Qi = Bi.animationState) === null || Qi === void 0 ? void 0 : Qi.getState()[fa]);
  for (var io in no) {
    var xs = Bi.getValue(io), Ts = no[io];
    if (!(!xs || Ts === void 0 || ao && shouldBlockAnimation(ao, io))) {
      var qs = __assign({ delay: na }, to);
      Bi.shouldReduceMotion && isTransformProp(io) && (qs = __assign(__assign({}, qs), { type: !1, delay: 0 }));
      var Fs = startAnimation(io, xs, Ts, qs);
      eo.push(Fs);
    }
  }
  return Promise.all(eo).then(function() {
    ro && setTarget(Bi, ro);
  });
}
function animateChildren(Bi, e, Zi, Qi, ea, ra) {
  Zi === void 0 && (Zi = 0), Qi === void 0 && (Qi = 0), ea === void 0 && (ea = 1);
  var na = [], ia = (Bi.variantChildren.size - 1) * Qi, fa = ea === 1 ? function(La) {
    return La === void 0 && (La = 0), La * Qi;
  } : function(La) {
    return La === void 0 && (La = 0), ia - La * Qi;
  };
  return Array.from(Bi.variantChildren).sort(sortByTreeOrder).forEach(function(La, Va) {
    na.push(animateVariant(La, e, __assign(__assign({}, ra), { delay: Zi + fa(Va) })).then(function() {
      return La.notifyAnimationComplete(e);
    }));
  }), Promise.all(na);
}
function sortByTreeOrder(Bi, e) {
  return Bi.sortNodePosition(e);
}
function shouldBlockAnimation(Bi, e) {
  var Zi = Bi.protectedKeys, Qi = Bi.needsAnimating, ea = Zi.hasOwnProperty(e) && Qi[e] !== !0;
  return Qi[e] = !1, ea;
}
var variantPriorityOrder = [
  AnimationType.Animate,
  AnimationType.InView,
  AnimationType.Focus,
  AnimationType.Hover,
  AnimationType.Tap,
  AnimationType.Drag,
  AnimationType.Exit
], reversePriorityOrder = __spreadArray([], __read(variantPriorityOrder), !1).reverse(), numAnimationTypes = variantPriorityOrder.length;
function animateList(Bi) {
  return function(e) {
    return Promise.all(e.map(function(Zi) {
      var Qi = Zi.animation, ea = Zi.options;
      return animateVisualElement(Bi, Qi, ea);
    }));
  };
}
function createAnimationState(Bi) {
  var e = animateList(Bi), Zi = createState(), Qi = {}, ea = !0, ra = function(Va, to) {
    var ro = resolveVariant(Bi, to);
    if (ro) {
      ro.transition;
      var no = ro.transitionEnd, eo = __rest$1(ro, ["transition", "transitionEnd"]);
      Va = __assign(__assign(__assign({}, Va), eo), no);
    }
    return Va;
  };
  function na(Va) {
    return Qi[Va] !== void 0;
  }
  function ia(Va) {
    e = Va(Bi);
  }
  function fa(Va, to) {
    for (var ro, no = Bi.getProps(), eo = Bi.getVariantContext(!0) || {}, ao = [], io = /* @__PURE__ */ new Set(), xs = {}, Ts = 1 / 0, qs = function(Io) {
      var so = reversePriorityOrder[Io], os = Zi[so], Xs = (ro = no[so]) !== null && ro !== void 0 ? ro : eo[so], gl = isVariantLabel(Xs), Sl = so === to ? os.isActive : null;
      Sl === !1 && (Ts = Io);
      var El = Xs === eo[so] && Xs !== no[so] && gl;
      if (El && ea && Bi.manuallyAnimateOnMount && (El = !1), os.protectedKeys = __assign({}, xs), // If it isn't active and hasn't *just* been set as inactive
      !os.isActive && Sl === null || // If we didn't and don't have any defined prop for this animation type
      !Xs && !os.prevProp || // Or if the prop doesn't define an animation
      isAnimationControls(Xs) || typeof Xs == "boolean")
        return "continue";
      var wl = checkVariantsDidChange(os.prevProp, Xs), jl = wl || // If we're making this variant active, we want to always make it active
      so === to && os.isActive && !El && gl || // If we removed a higher-priority variant (i is in reverse order)
      Io > Ts && gl, kl = Array.isArray(Xs) ? Xs : [Xs], Fl = kl.reduce(ra, {});
      Sl === !1 && (Fl = {});
      var Ml = os.prevResolvedValues, ql = Ml === void 0 ? {} : Ml, Kl = __assign(__assign({}, ql), Fl), Zl = function(Pl) {
        jl = !0, io.delete(Pl), os.needsAnimating[Pl] = !0;
      };
      for (var Il in Kl) {
        var xl = Fl[Il], bl = ql[Il];
        xs.hasOwnProperty(Il) || (xl !== bl ? isKeyframesTarget(xl) && isKeyframesTarget(bl) ? !shallowCompare(xl, bl) || wl ? Zl(Il) : os.protectedKeys[Il] = !0 : xl !== void 0 ? Zl(Il) : io.add(Il) : xl !== void 0 && io.has(Il) ? Zl(Il) : os.protectedKeys[Il] = !0);
      }
      os.prevProp = Xs, os.prevResolvedValues = Fl, os.isActive && (xs = __assign(__assign({}, xs), Fl)), ea && Bi.blockInitialAnimation && (jl = !1), jl && !El && ao.push.apply(ao, __spreadArray([], __read(kl.map(function(Pl) {
        return {
          animation: Pl,
          options: __assign({ type: so }, Va)
        };
      })), !1));
    }, Fs = 0; Fs < numAnimationTypes; Fs++)
      qs(Fs);
    if (Qi = __assign({}, xs), io.size) {
      var Do = {};
      io.forEach(function(Io) {
        var so = Bi.getBaseTarget(Io);
        so !== void 0 && (Do[Io] = so);
      }), ao.push({ animation: Do });
    }
    var ys = !!ao.length;
    return ea && no.initial === !1 && !Bi.manuallyAnimateOnMount && (ys = !1), ea = !1, ys ? e(ao) : Promise.resolve();
  }
  function La(Va, to, ro) {
    var no;
    if (Zi[Va].isActive === to)
      return Promise.resolve();
    (no = Bi.variantChildren) === null || no === void 0 || no.forEach(function(io) {
      var xs;
      return (xs = io.animationState) === null || xs === void 0 ? void 0 : xs.setActive(Va, to);
    }), Zi[Va].isActive = to;
    var eo = fa(ro, Va);
    for (var ao in Zi)
      Zi[ao].protectedKeys = {};
    return eo;
  }
  return {
    isAnimated: na,
    animateChanges: fa,
    setActive: La,
    setAnimateFunction: ia,
    getState: function() {
      return Zi;
    }
  };
}
function checkVariantsDidChange(Bi, e) {
  return typeof e == "string" ? e !== Bi : isVariantLabels(e) ? !shallowCompare(e, Bi) : !1;
}
function createTypeState(Bi) {
  return Bi === void 0 && (Bi = !1), {
    isActive: Bi,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  var Bi;
  return Bi = {}, Bi[AnimationType.Animate] = createTypeState(!0), Bi[AnimationType.InView] = createTypeState(), Bi[AnimationType.Hover] = createTypeState(), Bi[AnimationType.Tap] = createTypeState(), Bi[AnimationType.Drag] = createTypeState(), Bi[AnimationType.Focus] = createTypeState(), Bi[AnimationType.Exit] = createTypeState(), Bi;
}
var animations = {
  animation: makeRenderlessComponent(function(Bi) {
    var e = Bi.visualElement, Zi = Bi.animate;
    e.animationState || (e.animationState = createAnimationState(e)), isAnimationControls(Zi) && useEffect(function() {
      return Zi.subscribe(e);
    }, [Zi]);
  }),
  exit: makeRenderlessComponent(function(Bi) {
    var e = Bi.custom, Zi = Bi.visualElement, Qi = __read(usePresence(), 2), ea = Qi[0], ra = Qi[1], na = useContext(PresenceContext);
    useEffect(function() {
      var ia, fa;
      Zi.isPresent = ea;
      var La = (ia = Zi.animationState) === null || ia === void 0 ? void 0 : ia.setActive(AnimationType.Exit, !ea, { custom: (fa = na?.custom) !== null && fa !== void 0 ? fa : e });
      !ea && La?.then(ra);
    }, [ea]);
  })
}, PanSession = (
  /** @class */
  function() {
    function Bi(e, Zi, Qi) {
      var ea = this, ra = Qi === void 0 ? {} : Qi, na = ra.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (ea.lastMoveEvent && ea.lastMoveEventInfo) {
          var ro = getPanInfo(ea.lastMoveEventInfo, ea.history), no = ea.startEvent !== null, eo = distance(ro.offset, { x: 0, y: 0 }) >= 3;
          if (!(!no && !eo)) {
            var ao = ro.point, io = getFrameData().timestamp;
            ea.history.push(__assign(__assign({}, ao), { timestamp: io }));
            var xs = ea.handlers, Ts = xs.onStart, qs = xs.onMove;
            no || (Ts && Ts(ea.lastMoveEvent, ro), ea.startEvent = ea.lastMoveEvent), qs && qs(ea.lastMoveEvent, ro);
          }
        }
      }, this.handlePointerMove = function(ro, no) {
        if (ea.lastMoveEvent = ro, ea.lastMoveEventInfo = transformPoint(no, ea.transformPagePoint), isMouseEvent(ro) && ro.buttons === 0) {
          ea.handlePointerUp(ro, no);
          return;
        }
        sync.update(ea.updatePoint, !0);
      }, this.handlePointerUp = function(ro, no) {
        ea.end();
        var eo = ea.handlers, ao = eo.onEnd, io = eo.onSessionEnd, xs = getPanInfo(transformPoint(no, ea.transformPagePoint), ea.history);
        ea.startEvent && ao && ao(ro, xs), io && io(ro, xs);
      }, !(isTouchEvent(e) && e.touches.length > 1)) {
        this.handlers = Zi, this.transformPagePoint = na;
        var ia = extractEventInfo(e), fa = transformPoint(ia, this.transformPagePoint), La = fa.point, Va = getFrameData().timestamp;
        this.history = [__assign(__assign({}, La), { timestamp: Va })];
        var to = Zi.onSessionStart;
        to && to(e, getPanInfo(fa, this.history)), this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
      }
    }
    return Bi.prototype.updateHandlers = function(e) {
      this.handlers = e;
    }, Bi.prototype.end = function() {
      this.removeListeners && this.removeListeners(), cancelSync.update(this.updatePoint);
    }, Bi;
  }()
);
function transformPoint(Bi, e) {
  return e ? { point: e(Bi.point) } : Bi;
}
function subtractPoint(Bi, e) {
  return { x: Bi.x - e.x, y: Bi.y - e.y };
}
function getPanInfo(Bi, e) {
  var Zi = Bi.point;
  return {
    point: Zi,
    delta: subtractPoint(Zi, lastDevicePoint(e)),
    offset: subtractPoint(Zi, startDevicePoint(e)),
    velocity: getVelocity(e, 0.1)
  };
}
function startDevicePoint(Bi) {
  return Bi[0];
}
function lastDevicePoint(Bi) {
  return Bi[Bi.length - 1];
}
function getVelocity(Bi, e) {
  if (Bi.length < 2)
    return { x: 0, y: 0 };
  for (var Zi = Bi.length - 1, Qi = null, ea = lastDevicePoint(Bi); Zi >= 0 && (Qi = Bi[Zi], !(ea.timestamp - Qi.timestamp > secondsToMilliseconds(e))); )
    Zi--;
  if (!Qi)
    return { x: 0, y: 0 };
  var ra = (ea.timestamp - Qi.timestamp) / 1e3;
  if (ra === 0)
    return { x: 0, y: 0 };
  var na = {
    x: (ea.x - Qi.x) / ra,
    y: (ea.y - Qi.y) / ra
  };
  return na.x === 1 / 0 && (na.x = 0), na.y === 1 / 0 && (na.y = 0), na;
}
function calcLength(Bi) {
  return Bi.max - Bi.min;
}
function isNear(Bi, e, Zi) {
  return e === void 0 && (e = 0), Zi === void 0 && (Zi = 0.01), distance(Bi, e) < Zi;
}
function calcAxisDelta(Bi, e, Zi, Qi) {
  Qi === void 0 && (Qi = 0.5), Bi.origin = Qi, Bi.originPoint = mix(e.min, e.max, Bi.origin), Bi.scale = calcLength(Zi) / calcLength(e), (isNear(Bi.scale, 1, 1e-4) || isNaN(Bi.scale)) && (Bi.scale = 1), Bi.translate = mix(Zi.min, Zi.max, Bi.origin) - Bi.originPoint, (isNear(Bi.translate) || isNaN(Bi.translate)) && (Bi.translate = 0);
}
function calcBoxDelta(Bi, e, Zi, Qi) {
  calcAxisDelta(Bi.x, e.x, Zi.x, Qi?.originX), calcAxisDelta(Bi.y, e.y, Zi.y, Qi?.originY);
}
function calcRelativeAxis(Bi, e, Zi) {
  Bi.min = Zi.min + e.min, Bi.max = Bi.min + calcLength(e);
}
function calcRelativeBox(Bi, e, Zi) {
  calcRelativeAxis(Bi.x, e.x, Zi.x), calcRelativeAxis(Bi.y, e.y, Zi.y);
}
function calcRelativeAxisPosition(Bi, e, Zi) {
  Bi.min = e.min - Zi.min, Bi.max = Bi.min + calcLength(e);
}
function calcRelativePosition(Bi, e, Zi) {
  calcRelativeAxisPosition(Bi.x, e.x, Zi.x), calcRelativeAxisPosition(Bi.y, e.y, Zi.y);
}
function applyConstraints(Bi, e, Zi) {
  var Qi = e.min, ea = e.max;
  return Qi !== void 0 && Bi < Qi ? Bi = Zi ? mix(Qi, Bi, Zi.min) : Math.max(Bi, Qi) : ea !== void 0 && Bi > ea && (Bi = Zi ? mix(ea, Bi, Zi.max) : Math.min(Bi, ea)), Bi;
}
function calcRelativeAxisConstraints(Bi, e, Zi) {
  return {
    min: e !== void 0 ? Bi.min + e : void 0,
    max: Zi !== void 0 ? Bi.max + Zi - (Bi.max - Bi.min) : void 0
  };
}
function calcRelativeConstraints(Bi, e) {
  var Zi = e.top, Qi = e.left, ea = e.bottom, ra = e.right;
  return {
    x: calcRelativeAxisConstraints(Bi.x, Qi, ra),
    y: calcRelativeAxisConstraints(Bi.y, Zi, ea)
  };
}
function calcViewportAxisConstraints(Bi, e) {
  var Zi, Qi = e.min - Bi.min, ea = e.max - Bi.max;
  return e.max - e.min < Bi.max - Bi.min && (Zi = __read([ea, Qi], 2), Qi = Zi[0], ea = Zi[1]), { min: Qi, max: ea };
}
function calcViewportConstraints(Bi, e) {
  return {
    x: calcViewportAxisConstraints(Bi.x, e.x),
    y: calcViewportAxisConstraints(Bi.y, e.y)
  };
}
function calcOrigin(Bi, e) {
  var Zi = 0.5, Qi = calcLength(Bi), ea = calcLength(e);
  return ea > Qi ? Zi = progress(e.min, e.max - Qi, Bi.min) : Qi > ea && (Zi = progress(Bi.min, Bi.max - ea, e.min)), clamp(0, 1, Zi);
}
function rebaseAxisConstraints(Bi, e) {
  var Zi = {};
  return e.min !== void 0 && (Zi.min = e.min - Bi.min), e.max !== void 0 && (Zi.max = e.max - Bi.min), Zi;
}
var defaultElastic = 0.35;
function resolveDragElastic(Bi) {
  return Bi === void 0 && (Bi = defaultElastic), Bi === !1 ? Bi = 0 : Bi === !0 && (Bi = defaultElastic), {
    x: resolveAxisElastic(Bi, "left", "right"),
    y: resolveAxisElastic(Bi, "top", "bottom")
  };
}
function resolveAxisElastic(Bi, e, Zi) {
  return {
    min: resolvePointElastic(Bi, e),
    max: resolvePointElastic(Bi, Zi)
  };
}
function resolvePointElastic(Bi, e) {
  var Zi;
  return typeof Bi == "number" ? Bi : (Zi = Bi[e]) !== null && Zi !== void 0 ? Zi : 0;
}
var createAxisDelta = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, createDelta = function() {
  return {
    x: createAxisDelta(),
    y: createAxisDelta()
  };
}, createAxis = function() {
  return { min: 0, max: 0 };
}, createBox = function() {
  return {
    x: createAxis(),
    y: createAxis()
  };
};
function eachAxis(Bi) {
  return [Bi("x"), Bi("y")];
}
function convertBoundingBoxToBox(Bi) {
  var e = Bi.top, Zi = Bi.left, Qi = Bi.right, ea = Bi.bottom;
  return {
    x: { min: Zi, max: Qi },
    y: { min: e, max: ea }
  };
}
function convertBoxToBoundingBox(Bi) {
  var e = Bi.x, Zi = Bi.y;
  return { top: Zi.min, right: e.max, bottom: Zi.max, left: e.min };
}
function transformBoxPoints(Bi, e) {
  if (!e)
    return Bi;
  var Zi = e({ x: Bi.left, y: Bi.top }), Qi = e({ x: Bi.right, y: Bi.bottom });
  return {
    top: Zi.y,
    left: Zi.x,
    bottom: Qi.y,
    right: Qi.x
  };
}
function isIdentityScale(Bi) {
  return Bi === void 0 || Bi === 1;
}
function hasScale(Bi) {
  var e = Bi.scale, Zi = Bi.scaleX, Qi = Bi.scaleY;
  return !isIdentityScale(e) || !isIdentityScale(Zi) || !isIdentityScale(Qi);
}
function hasTransform(Bi) {
  return hasScale(Bi) || hasTranslate(Bi.x) || hasTranslate(Bi.y) || Bi.z || Bi.rotate || Bi.rotateX || Bi.rotateY;
}
function hasTranslate(Bi) {
  return Bi && Bi !== "0%";
}
function scalePoint(Bi, e, Zi) {
  var Qi = Bi - Zi, ea = e * Qi;
  return Zi + ea;
}
function applyPointDelta(Bi, e, Zi, Qi, ea) {
  return ea !== void 0 && (Bi = scalePoint(Bi, ea, Qi)), scalePoint(Bi, Zi, Qi) + e;
}
function applyAxisDelta(Bi, e, Zi, Qi, ea) {
  e === void 0 && (e = 0), Zi === void 0 && (Zi = 1), Bi.min = applyPointDelta(Bi.min, e, Zi, Qi, ea), Bi.max = applyPointDelta(Bi.max, e, Zi, Qi, ea);
}
function applyBoxDelta(Bi, e) {
  var Zi = e.x, Qi = e.y;
  applyAxisDelta(Bi.x, Zi.translate, Zi.scale, Zi.originPoint), applyAxisDelta(Bi.y, Qi.translate, Qi.scale, Qi.originPoint);
}
function applyTreeDeltas(Bi, e, Zi, Qi) {
  var ea, ra;
  Qi === void 0 && (Qi = !1);
  var na = Zi.length;
  if (na) {
    e.x = e.y = 1;
    for (var ia, fa, La = 0; La < na; La++)
      ia = Zi[La], fa = ia.projectionDelta, ((ra = (ea = ia.instance) === null || ea === void 0 ? void 0 : ea.style) === null || ra === void 0 ? void 0 : ra.display) !== "contents" && (Qi && ia.options.layoutScroll && ia.scroll && ia !== ia.root && transformBox(Bi, { x: -ia.scroll.x, y: -ia.scroll.y }), fa && (e.x *= fa.x.scale, e.y *= fa.y.scale, applyBoxDelta(Bi, fa)), Qi && hasTransform(ia.latestValues) && transformBox(Bi, ia.latestValues));
  }
}
function translateAxis(Bi, e) {
  Bi.min = Bi.min + e, Bi.max = Bi.max + e;
}
function transformAxis(Bi, e, Zi) {
  var Qi = __read(Zi, 3), ea = Qi[0], ra = Qi[1], na = Qi[2], ia = e[na] !== void 0 ? e[na] : 0.5, fa = mix(Bi.min, Bi.max, ia);
  applyAxisDelta(Bi, e[ea], e[ra], fa, e.scale);
}
var xKeys$1 = ["x", "scaleX", "originX"], yKeys$1 = ["y", "scaleY", "originY"];
function transformBox(Bi, e) {
  transformAxis(Bi.x, e, xKeys$1), transformAxis(Bi.y, e, yKeys$1);
}
function measureViewportBox(Bi, e) {
  return convertBoundingBoxToBox(transformBoxPoints(Bi.getBoundingClientRect(), e));
}
function measurePageBox(Bi, e, Zi) {
  var Qi = measureViewportBox(Bi, Zi), ea = e.scroll;
  return ea && (translateAxis(Qi.x, ea.x), translateAxis(Qi.y, ea.y)), Qi;
}
var elementDragControls = /* @__PURE__ */ new WeakMap(), VisualElementDragControls = (
  /** @class */
  function() {
    function Bi(e) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = createBox(), this.visualElement = e;
    }
    return Bi.prototype.start = function(e, Zi) {
      var Qi = this, ea = Zi === void 0 ? {} : Zi, ra = ea.snapToCursor, na = ra === void 0 ? !1 : ra;
      if (this.visualElement.isPresent !== !1) {
        var ia = function(to) {
          Qi.stopAnimation(), na && Qi.snapToCursor(extractEventInfo(to, "page").point);
        }, fa = function(to, ro) {
          var no, eo = Qi.getProps(), ao = eo.drag, io = eo.dragPropagation, xs = eo.onDragStart;
          ao && !io && (Qi.openGlobalLock && Qi.openGlobalLock(), Qi.openGlobalLock = getGlobalLock(ao), !Qi.openGlobalLock) || (Qi.isDragging = !0, Qi.currentDirection = null, Qi.resolveConstraints(), Qi.visualElement.projection && (Qi.visualElement.projection.isAnimationBlocked = !0, Qi.visualElement.projection.target = void 0), eachAxis(function(Ts) {
            var qs, Fs, Do = Qi.getAxisMotionValue(Ts).get() || 0;
            if (percent.test(Do)) {
              var ys = (Fs = (qs = Qi.visualElement.projection) === null || qs === void 0 ? void 0 : qs.layout) === null || Fs === void 0 ? void 0 : Fs.actual[Ts];
              if (ys) {
                var Io = calcLength(ys);
                Do = Io * (parseFloat(Do) / 100);
              }
            }
            Qi.originPoint[Ts] = Do;
          }), xs?.(to, ro), (no = Qi.visualElement.animationState) === null || no === void 0 || no.setActive(AnimationType.Drag, !0));
        }, La = function(to, ro) {
          var no = Qi.getProps(), eo = no.dragPropagation, ao = no.dragDirectionLock, io = no.onDirectionLock, xs = no.onDrag;
          if (!(!eo && !Qi.openGlobalLock)) {
            var Ts = ro.offset;
            if (ao && Qi.currentDirection === null) {
              Qi.currentDirection = getCurrentDirection(Ts), Qi.currentDirection !== null && io?.(Qi.currentDirection);
              return;
            }
            Qi.updateAxis("x", ro.point, Ts), Qi.updateAxis("y", ro.point, Ts), Qi.visualElement.syncRender(), xs?.(to, ro);
          }
        }, Va = function(to, ro) {
          return Qi.stop(to, ro);
        };
        this.panSession = new PanSession(e, {
          onSessionStart: ia,
          onStart: fa,
          onMove: La,
          onSessionEnd: Va
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, Bi.prototype.stop = function(e, Zi) {
      var Qi = this.isDragging;
      if (this.cancel(), !!Qi) {
        var ea = Zi.velocity;
        this.startAnimation(ea);
        var ra = this.getProps().onDragEnd;
        ra?.(e, Zi);
      }
    }, Bi.prototype.cancel = function() {
      var e, Zi;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (e = this.panSession) === null || e === void 0 || e.end(), this.panSession = void 0;
      var Qi = this.getProps().dragPropagation;
      !Qi && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (Zi = this.visualElement.animationState) === null || Zi === void 0 || Zi.setActive(AnimationType.Drag, !1);
    }, Bi.prototype.updateAxis = function(e, Zi, Qi) {
      var ea = this.getProps().drag;
      if (!(!Qi || !shouldDrag(e, ea, this.currentDirection))) {
        var ra = this.getAxisMotionValue(e), na = this.originPoint[e] + Qi[e];
        this.constraints && this.constraints[e] && (na = applyConstraints(na, this.constraints[e], this.elastic[e])), ra.set(na);
      }
    }, Bi.prototype.resolveConstraints = function() {
      var e = this, Zi = this.getProps(), Qi = Zi.dragConstraints, ea = Zi.dragElastic, ra = (this.visualElement.projection || {}).layout, na = this.constraints;
      Qi && isRefObject(Qi) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : Qi && ra ? this.constraints = calcRelativeConstraints(ra.actual, Qi) : this.constraints = !1, this.elastic = resolveDragElastic(ea), na !== this.constraints && ra && this.constraints && !this.hasMutatedConstraints && eachAxis(function(ia) {
        e.getAxisMotionValue(ia) && (e.constraints[ia] = rebaseAxisConstraints(ra.actual[ia], e.constraints[ia]));
      });
    }, Bi.prototype.resolveRefConstraints = function() {
      var e = this.getProps(), Zi = e.dragConstraints, Qi = e.onMeasureDragConstraints;
      if (!Zi || !isRefObject(Zi))
        return !1;
      var ea = Zi.current;
      invariant$1(ea !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var ra = this.visualElement.projection;
      if (!ra || !ra.layout)
        return !1;
      var na = measurePageBox(ea, ra.root, this.visualElement.getTransformPagePoint()), ia = calcViewportConstraints(ra.layout.actual, na);
      if (Qi) {
        var fa = Qi(convertBoxToBoundingBox(ia));
        this.hasMutatedConstraints = !!fa, fa && (ia = convertBoundingBoxToBox(fa));
      }
      return ia;
    }, Bi.prototype.startAnimation = function(e) {
      var Zi = this, Qi = this.getProps(), ea = Qi.drag, ra = Qi.dragMomentum, na = Qi.dragElastic, ia = Qi.dragTransition, fa = Qi.dragSnapToOrigin, La = Qi.onDragTransitionEnd, Va = this.constraints || {}, to = eachAxis(function(ro) {
        var no;
        if (shouldDrag(ro, ea, Zi.currentDirection)) {
          var eo = (no = Va?.[ro]) !== null && no !== void 0 ? no : {};
          fa && (eo = { min: 0, max: 0 });
          var ao = na ? 200 : 1e6, io = na ? 40 : 1e7, xs = __assign(__assign({ type: "inertia", velocity: ra ? e[ro] : 0, bounceStiffness: ao, bounceDamping: io, timeConstant: 750, restDelta: 1, restSpeed: 10 }, ia), eo);
          return Zi.startAxisValueAnimation(ro, xs);
        }
      });
      return Promise.all(to).then(La);
    }, Bi.prototype.startAxisValueAnimation = function(e, Zi) {
      var Qi = this.getAxisMotionValue(e);
      return startAnimation(e, Qi, 0, Zi);
    }, Bi.prototype.stopAnimation = function() {
      var e = this;
      eachAxis(function(Zi) {
        return e.getAxisMotionValue(Zi).stop();
      });
    }, Bi.prototype.getAxisMotionValue = function(e) {
      var Zi, Qi, ea = "_drag" + e.toUpperCase(), ra = this.visualElement.getProps()[ea];
      return ra || this.visualElement.getValue(e, (Qi = (Zi = this.visualElement.getProps().initial) === null || Zi === void 0 ? void 0 : Zi[e]) !== null && Qi !== void 0 ? Qi : 0);
    }, Bi.prototype.snapToCursor = function(e) {
      var Zi = this;
      eachAxis(function(Qi) {
        var ea = Zi.getProps().drag;
        if (shouldDrag(Qi, ea, Zi.currentDirection)) {
          var ra = Zi.visualElement.projection, na = Zi.getAxisMotionValue(Qi);
          if (ra && ra.layout) {
            var ia = ra.layout.actual[Qi], fa = ia.min, La = ia.max;
            na.set(e[Qi] - mix(fa, La, 0.5));
          }
        }
      });
    }, Bi.prototype.scalePositionWithinConstraints = function() {
      var e = this, Zi, Qi = this.getProps(), ea = Qi.drag, ra = Qi.dragConstraints, na = this.visualElement.projection;
      if (!(!isRefObject(ra) || !na || !this.constraints)) {
        this.stopAnimation();
        var ia = { x: 0, y: 0 };
        eachAxis(function(La) {
          var Va = e.getAxisMotionValue(La);
          if (Va) {
            var to = Va.get();
            ia[La] = calcOrigin({ min: to, max: to }, e.constraints[La]);
          }
        });
        var fa = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = fa ? fa({}, "") : "none", (Zi = na.root) === null || Zi === void 0 || Zi.updateScroll(), na.updateLayout(), this.resolveConstraints(), eachAxis(function(La) {
          if (shouldDrag(La, ea, null)) {
            var Va = e.getAxisMotionValue(La), to = e.constraints[La], ro = to.min, no = to.max;
            Va.set(mix(ro, no, ia[La]));
          }
        });
      }
    }, Bi.prototype.addListeners = function() {
      var e = this, Zi;
      elementDragControls.set(this.visualElement, this);
      var Qi = this.visualElement.getInstance(), ea = addPointerEvent(Qi, "pointerdown", function(La) {
        var Va = e.getProps(), to = Va.drag, ro = Va.dragListener, no = ro === void 0 ? !0 : ro;
        to && no && e.start(La);
      }), ra = function() {
        var La = e.getProps().dragConstraints;
        isRefObject(La) && (e.constraints = e.resolveRefConstraints());
      }, na = this.visualElement.projection, ia = na.addEventListener("measure", ra);
      na && !na.layout && ((Zi = na.root) === null || Zi === void 0 || Zi.updateScroll(), na.updateLayout()), ra();
      var fa = addDomEvent(window, "resize", function() {
        return e.scalePositionWithinConstraints();
      });
      return na.addEventListener("didUpdate", function(La) {
        var Va = La.delta, to = La.hasLayoutChanged;
        e.isDragging && to && (eachAxis(function(ro) {
          var no = e.getAxisMotionValue(ro);
          no && (e.originPoint[ro] += Va[ro].translate, no.set(no.get() + Va[ro].translate));
        }), e.visualElement.syncRender());
      }), function() {
        fa(), ea(), ia();
      };
    }, Bi.prototype.getProps = function() {
      var e = this.visualElement.getProps(), Zi = e.drag, Qi = Zi === void 0 ? !1 : Zi, ea = e.dragDirectionLock, ra = ea === void 0 ? !1 : ea, na = e.dragPropagation, ia = na === void 0 ? !1 : na, fa = e.dragConstraints, La = fa === void 0 ? !1 : fa, Va = e.dragElastic, to = Va === void 0 ? defaultElastic : Va, ro = e.dragMomentum, no = ro === void 0 ? !0 : ro;
      return __assign(__assign({}, e), { drag: Qi, dragDirectionLock: ra, dragPropagation: ia, dragConstraints: La, dragElastic: to, dragMomentum: no });
    }, Bi;
  }()
);
function shouldDrag(Bi, e, Zi) {
  return (e === !0 || e === Bi) && (Zi === null || Zi === Bi);
}
function getCurrentDirection(Bi, e) {
  e === void 0 && (e = 10);
  var Zi = null;
  return Math.abs(Bi.y) > e ? Zi = "y" : Math.abs(Bi.x) > e && (Zi = "x"), Zi;
}
function useDrag$1(Bi) {
  var e = Bi.dragControls, Zi = Bi.visualElement, Qi = useConstant(function() {
    return new VisualElementDragControls(Zi);
  });
  useEffect(function() {
    return e && e.subscribe(Qi);
  }, [Qi, e]), useEffect(function() {
    return Qi.addListeners();
  }, [Qi]);
}
function usePanGesture(Bi) {
  var e = Bi.onPan, Zi = Bi.onPanStart, Qi = Bi.onPanEnd, ea = Bi.onPanSessionStart, ra = Bi.visualElement, na = e || Zi || Qi || ea, ia = useRef(null), fa = useContext(MotionConfigContext).transformPagePoint, La = {
    onSessionStart: ea,
    onStart: Zi,
    onMove: e,
    onEnd: function(to, ro) {
      ia.current = null, Qi && Qi(to, ro);
    }
  };
  useEffect(function() {
    ia.current !== null && ia.current.updateHandlers(La);
  });
  function Va(to) {
    ia.current = new PanSession(to, La, {
      transformPagePoint: fa
    });
  }
  usePointerEvent(ra, "pointerdown", na && Va), useUnmountEffect(function() {
    return ia.current && ia.current.end();
  });
}
var drag = {
  pan: makeRenderlessComponent(usePanGesture),
  drag: makeRenderlessComponent(useDrag$1)
}, names = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function createLifecycles() {
  var Bi = names.map(function() {
    return new SubscriptionManager();
  }), e = {}, Zi = {
    clearAllListeners: function() {
      return Bi.forEach(function(Qi) {
        return Qi.clear();
      });
    },
    updatePropListeners: function(Qi) {
      names.forEach(function(ea) {
        var ra, na = "on" + ea, ia = Qi[na];
        (ra = e[ea]) === null || ra === void 0 || ra.call(e), ia && (e[ea] = Zi[na](ia));
      });
    }
  };
  return Bi.forEach(function(Qi, ea) {
    Zi["on" + names[ea]] = function(ra) {
      return Qi.add(ra);
    }, Zi["notify" + names[ea]] = function() {
      for (var ra = [], na = 0; na < arguments.length; na++)
        ra[na] = arguments[na];
      return Qi.notify.apply(Qi, __spreadArray([], __read(ra), !1));
    };
  }), Zi;
}
function updateMotionValuesFromProps(Bi, e, Zi) {
  var Qi;
  for (var ea in e) {
    var ra = e[ea], na = Zi[ea];
    if (isMotionValue(ra))
      Bi.addValue(ea, ra), process.env.NODE_ENV === "development" && warnOnce(ra.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(ra.version, " with 6.5.1 may not work as expected."));
    else if (isMotionValue(na))
      Bi.addValue(ea, motionValue(ra));
    else if (na !== ra)
      if (Bi.hasValue(ea)) {
        var ia = Bi.getValue(ea);
        !ia.hasAnimated && ia.set(ra);
      } else
        Bi.addValue(ea, motionValue((Qi = Bi.getStaticValue(ea)) !== null && Qi !== void 0 ? Qi : ra));
  }
  for (var ea in Zi)
    e[ea] === void 0 && Bi.removeValue(ea);
  return e;
}
var visualElement = function(Bi) {
  var e = Bi.treeType, Zi = e === void 0 ? "" : e, Qi = Bi.build, ea = Bi.getBaseTarget, ra = Bi.makeTargetAnimatable, na = Bi.measureViewportBox, ia = Bi.render, fa = Bi.readValueFromInstance, La = Bi.removeValueFromRenderState, Va = Bi.sortNodePosition, to = Bi.scrapeMotionValuesFromProps;
  return function(ro, no) {
    var eo = ro.parent, ao = ro.props, io = ro.presenceId, xs = ro.blockInitialAnimation, Ts = ro.visualState, qs = ro.shouldReduceMotion;
    no === void 0 && (no = {});
    var Fs = !1, Do = Ts.latestValues, ys = Ts.renderState, Io, so = createLifecycles(), os = /* @__PURE__ */ new Map(), Xs = /* @__PURE__ */ new Map(), gl = {}, Sl = __assign({}, Do), El;
    function wl() {
      !Io || !Fs || (jl(), ia(Io, ys, ao.style, xl.projection));
    }
    function jl() {
      Qi(xl, ys, Do, no, ao);
    }
    function kl() {
      so.notifyUpdate(Do);
    }
    function Fl(bl, Pl) {
      var Nl = Pl.onChange(function(Ol) {
        Do[bl] = Ol, ao.onUpdate && sync.update(kl, !1, !0);
      }), Bl = Pl.onRenderRequest(xl.scheduleRender);
      Xs.set(bl, function() {
        Nl(), Bl();
      });
    }
    var Ml = to(ao);
    for (var ql in Ml) {
      var Kl = Ml[ql];
      Do[ql] !== void 0 && isMotionValue(Kl) && Kl.set(Do[ql], !1);
    }
    var Zl = checkIfControllingVariants(ao), Il = checkIfVariantNode(ao), xl = __assign(__assign({
      treeType: Zi,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: eo ? eo.depth + 1 : 0,
      parent: eo,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: io,
      shouldReduceMotion: qs,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: Il ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!eo?.isMounted(),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: xs,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!Io;
      },
      mount: function(bl) {
        Fs = !0, Io = xl.current = bl, xl.projection && xl.projection.mount(bl), Il && eo && !Zl && (El = eo?.addVariantChild(xl)), os.forEach(function(Pl, Nl) {
          return Fl(Nl, Pl);
        }), eo?.children.add(xl), xl.setProps(ao);
      },
      /**
       *
       */
      unmount: function() {
        var bl;
        (bl = xl.projection) === null || bl === void 0 || bl.unmount(), cancelSync.update(kl), cancelSync.render(wl), Xs.forEach(function(Pl) {
          return Pl();
        }), El?.(), eo?.children.delete(xl), so.clearAllListeners(), Io = void 0, Fs = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(bl) {
        var Pl, Nl = xl.getClosestVariantNode();
        if (Nl)
          return (Pl = Nl.variantChildren) === null || Pl === void 0 || Pl.add(bl), function() {
            return Nl.variantChildren.delete(bl);
          };
      },
      sortNodePosition: function(bl) {
        return !Va || Zi !== bl.treeType ? 0 : Va(xl.getInstance(), bl.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return Il ? xl : eo?.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return ao.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return Io;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(bl) {
        return Do[bl];
      },
      setStaticValue: function(bl, Pl) {
        return Do[bl] = Pl;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return Do;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(bl) {
        xl.isVisible !== bl && (xl.isVisible = bl, xl.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(bl, Pl) {
        return Pl === void 0 && (Pl = !0), ra(xl, bl, ao, Pl);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return na(Io, ao);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(bl, Pl) {
        xl.hasValue(bl) && xl.removeValue(bl), os.set(bl, Pl), Do[bl] = Pl.get(), Fl(bl, Pl);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(bl) {
        var Pl;
        os.delete(bl), (Pl = Xs.get(bl)) === null || Pl === void 0 || Pl(), Xs.delete(bl), delete Do[bl], La(bl, ys);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(bl) {
        return os.has(bl);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(bl, Pl) {
        var Nl = os.get(bl);
        return Nl === void 0 && Pl !== void 0 && (Nl = motionValue(Pl), xl.addValue(bl, Nl)), Nl;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(bl) {
        return os.forEach(bl);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(bl) {
        var Pl;
        return (Pl = Do[bl]) !== null && Pl !== void 0 ? Pl : fa(Io, bl, no);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(bl, Pl) {
        Sl[bl] = Pl;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(bl) {
        if (ea) {
          var Pl = ea(ao, bl);
          if (Pl !== void 0 && !isMotionValue(Pl))
            return Pl;
        }
        return Sl[bl];
      }
    }, so), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return jl(), ys;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        sync.render(wl, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: wl,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(bl) {
        (bl.transformTemplate || ao.transformTemplate) && xl.scheduleRender(), ao = bl, so.updatePropListeners(bl), gl = updateMotionValuesFromProps(xl, to(ao), gl);
      },
      getProps: function() {
        return ao;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(bl) {
        var Pl;
        return (Pl = ao.variants) === null || Pl === void 0 ? void 0 : Pl[bl];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return ao.transition;
      },
      getTransformPagePoint: function() {
        return ao.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(bl) {
        if (bl === void 0 && (bl = !1), bl)
          return eo?.getVariantContext();
        if (!Zl) {
          var Pl = eo?.getVariantContext() || {};
          return ao.initial !== void 0 && (Pl.initial = ao.initial), Pl;
        }
        for (var Nl = {}, Bl = 0; Bl < numVariantProps; Bl++) {
          var Ol = variantProps[Bl], To = ao[Ol];
          (isVariantLabel(To) || To === !1) && (Nl[Ol] = To);
        }
        return Nl;
      }
    });
    return xl;
  };
}, variantProps = __spreadArray(["initial"], __read(variantPriorityOrder), !1), numVariantProps = variantProps.length;
function isCSSVariable(Bi) {
  return typeof Bi == "string" && Bi.startsWith("var(--");
}
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(Bi) {
  var e = cssVariableRegex.exec(Bi);
  if (!e)
    return [,];
  var Zi = __read(e, 3), Qi = Zi[1], ea = Zi[2];
  return [Qi, ea];
}
var maxDepth = 4;
function getVariableValue(Bi, e, Zi) {
  Zi === void 0 && (Zi = 1), invariant$1(Zi <= maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(Bi, '". This may indicate a circular fallback dependency.'));
  var Qi = __read(parseCSSVariable(Bi), 2), ea = Qi[0], ra = Qi[1];
  if (ea) {
    var na = window.getComputedStyle(e).getPropertyValue(ea);
    return na ? na.trim() : isCSSVariable(ra) ? getVariableValue(ra, e, Zi + 1) : ra;
  }
}
function resolveCSSVariables(Bi, e, Zi) {
  var Qi, ea = __rest$1(e, []), ra = Bi.getInstance();
  if (!(ra instanceof Element))
    return { target: ea, transitionEnd: Zi };
  Zi && (Zi = __assign({}, Zi)), Bi.forEachValue(function(La) {
    var Va = La.get();
    if (isCSSVariable(Va)) {
      var to = getVariableValue(Va, ra);
      to && La.set(to);
    }
  });
  for (var na in ea) {
    var ia = ea[na];
    if (isCSSVariable(ia)) {
      var fa = getVariableValue(ia, ra);
      fa && (ea[na] = fa, Zi && ((Qi = Zi[na]) !== null && Qi !== void 0 || (Zi[na] = ia)));
    }
  }
  return { target: ea, transitionEnd: Zi };
}
var positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), isPositionalKey = function(Bi) {
  return positionalKeys.has(Bi);
}, hasPositionalKey = function(Bi) {
  return Object.keys(Bi).some(isPositionalKey);
}, setAndResetVelocity = function(Bi, e) {
  Bi.set(e, !1), Bi.set(e);
}, isNumOrPxType = function(Bi) {
  return Bi === number || Bi === px;
}, BoundingBoxDimension;
(function(Bi) {
  Bi.width = "width", Bi.height = "height", Bi.left = "left", Bi.right = "right", Bi.top = "top", Bi.bottom = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function(Bi, e) {
  return parseFloat(Bi.split(", ")[e]);
}, getTranslateFromMatrix = function(Bi, e) {
  return function(Zi, Qi) {
    var ea = Qi.transform;
    if (ea === "none" || !ea)
      return 0;
    var ra = ea.match(/^matrix3d\((.+)\)$/);
    if (ra)
      return getPosFromMatrix(ra[1], e);
    var na = ea.match(/^matrix\((.+)\)$/);
    return na ? getPosFromMatrix(na[1], Bi) : 0;
  };
}, transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]), nonTranslationalTransformKeys = transformProps.filter(function(Bi) {
  return !transformKeys.has(Bi);
});
function removeNonTranslationalTransform(Bi) {
  var e = [];
  return nonTranslationalTransformKeys.forEach(function(Zi) {
    var Qi = Bi.getValue(Zi);
    Qi !== void 0 && (e.push([Zi, Qi.get()]), Qi.set(Zi.startsWith("scale") ? 1 : 0));
  }), e.length && Bi.syncRender(), e;
}
var positionalValues = {
  // Dimensions
  width: function(Bi, e) {
    var Zi = Bi.x, Qi = e.paddingLeft, ea = Qi === void 0 ? "0" : Qi, ra = e.paddingRight, na = ra === void 0 ? "0" : ra;
    return Zi.max - Zi.min - parseFloat(ea) - parseFloat(na);
  },
  height: function(Bi, e) {
    var Zi = Bi.y, Qi = e.paddingTop, ea = Qi === void 0 ? "0" : Qi, ra = e.paddingBottom, na = ra === void 0 ? "0" : ra;
    return Zi.max - Zi.min - parseFloat(ea) - parseFloat(na);
  },
  top: function(Bi, e) {
    var Zi = e.top;
    return parseFloat(Zi);
  },
  left: function(Bi, e) {
    var Zi = e.left;
    return parseFloat(Zi);
  },
  bottom: function(Bi, e) {
    var Zi = Bi.y, Qi = e.top;
    return parseFloat(Qi) + (Zi.max - Zi.min);
  },
  right: function(Bi, e) {
    var Zi = Bi.x, Qi = e.left;
    return parseFloat(Qi) + (Zi.max - Zi.min);
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
}, convertChangedValueTypes = function(Bi, e, Zi) {
  var Qi = e.measureViewportBox(), ea = e.getInstance(), ra = getComputedStyle(ea), na = ra.display, ia = {};
  na === "none" && e.setStaticValue("display", Bi.display || "block"), Zi.forEach(function(La) {
    ia[La] = positionalValues[La](Qi, ra);
  }), e.syncRender();
  var fa = e.measureViewportBox();
  return Zi.forEach(function(La) {
    var Va = e.getValue(La);
    setAndResetVelocity(Va, ia[La]), Bi[La] = positionalValues[La](fa, ra);
  }), Bi;
}, checkAndConvertChangedValueTypes = function(Bi, e, Zi, Qi) {
  Zi === void 0 && (Zi = {}), Qi === void 0 && (Qi = {}), e = __assign({}, e), Qi = __assign({}, Qi);
  var ea = Object.keys(e).filter(isPositionalKey), ra = [], na = !1, ia = [];
  if (ea.forEach(function(Va) {
    var to = Bi.getValue(Va);
    if (Bi.hasValue(Va)) {
      var ro = Zi[Va], no = findDimensionValueType(ro), eo = e[Va], ao;
      if (isKeyframesTarget(eo)) {
        var io = eo.length, xs = eo[0] === null ? 1 : 0;
        ro = eo[xs], no = findDimensionValueType(ro);
        for (var Ts = xs; Ts < io; Ts++)
          ao ? invariant$1(findDimensionValueType(eo[Ts]) === ao, "All keyframes must be of the same type") : (ao = findDimensionValueType(eo[Ts]), invariant$1(ao === no || isNumOrPxType(no) && isNumOrPxType(ao), "Keyframes must be of the same dimension as the current value"));
      } else
        ao = findDimensionValueType(eo);
      if (no !== ao)
        if (isNumOrPxType(no) && isNumOrPxType(ao)) {
          var qs = to.get();
          typeof qs == "string" && to.set(parseFloat(qs)), typeof eo == "string" ? e[Va] = parseFloat(eo) : Array.isArray(eo) && ao === px && (e[Va] = eo.map(parseFloat));
        } else no?.transform && ao?.transform && (ro === 0 || eo === 0) ? ro === 0 ? to.set(ao.transform(ro)) : e[Va] = no.transform(eo) : (na || (ra = removeNonTranslationalTransform(Bi), na = !0), ia.push(Va), Qi[Va] = Qi[Va] !== void 0 ? Qi[Va] : e[Va], setAndResetVelocity(to, eo));
    }
  }), ia.length) {
    var fa = ia.indexOf("height") >= 0 ? window.pageYOffset : null, La = convertChangedValueTypes(e, Bi, ia);
    return ra.length && ra.forEach(function(Va) {
      var to = __read(Va, 2), ro = to[0], no = to[1];
      Bi.getValue(ro).set(no);
    }), Bi.syncRender(), fa !== null && window.scrollTo({ top: fa }), { target: La, transitionEnd: Qi };
  } else
    return { target: e, transitionEnd: Qi };
};
function unitConversion(Bi, e, Zi, Qi) {
  return hasPositionalKey(e) ? checkAndConvertChangedValueTypes(Bi, e, Zi, Qi) : { target: e, transitionEnd: Qi };
}
var parseDomVariant = function(Bi, e, Zi, Qi) {
  var ea = resolveCSSVariables(Bi, e, Qi);
  return e = ea.target, Qi = ea.transitionEnd, unitConversion(Bi, e, Zi, Qi);
};
function getComputedStyle$1(Bi) {
  return window.getComputedStyle(Bi);
}
var htmlConfig = {
  treeType: "dom",
  readValueFromInstance: function(Bi, e) {
    if (isTransformProp(e)) {
      var Zi = getDefaultValueType(e);
      return Zi && Zi.default || 0;
    } else {
      var Qi = getComputedStyle$1(Bi);
      return (isCSSVariable$1(e) ? Qi.getPropertyValue(e) : Qi[e]) || 0;
    }
  },
  sortNodePosition: function(Bi, e) {
    return Bi.compareDocumentPosition(e) & 2 ? 1 : -1;
  },
  getBaseTarget: function(Bi, e) {
    var Zi;
    return (Zi = Bi.style) === null || Zi === void 0 ? void 0 : Zi[e];
  },
  measureViewportBox: function(Bi, e) {
    var Zi = e.transformPagePoint;
    return measureViewportBox(Bi, Zi);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(Bi, e, Zi) {
    var Qi = Zi.transformTemplate;
    e.style.transform = Qi ? Qi({}, "") : "none", Bi.scheduleRender();
  },
  restoreTransform: function(Bi, e) {
    Bi.style.transform = e.style.transform;
  },
  removeValueFromRenderState: function(Bi, e) {
    var Zi = e.vars, Qi = e.style;
    delete Zi[Bi], delete Qi[Bi];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(Bi, e, Zi, Qi) {
    var ea = Zi.transformValues;
    Qi === void 0 && (Qi = !0);
    var ra = e.transition, na = e.transitionEnd, ia = __rest$1(e, ["transition", "transitionEnd"]), fa = getOrigin(ia, ra || {}, Bi);
    if (ea && (na && (na = ea(na)), ia && (ia = ea(ia)), fa && (fa = ea(fa))), Qi) {
      checkTargetForNewValues(Bi, ia, fa);
      var La = parseDomVariant(Bi, ia, fa, na);
      na = La.transitionEnd, ia = La.target;
    }
    return __assign({ transition: ra, transitionEnd: na }, ia);
  },
  scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
  build: function(Bi, e, Zi, Qi, ea) {
    Bi.isVisible !== void 0 && (e.style.visibility = Bi.isVisible ? "visible" : "hidden"), buildHTMLStyles(e, Zi, Qi, ea.transformTemplate);
  },
  render: renderHTML
}, htmlVisualElement = visualElement(htmlConfig), svgVisualElement = visualElement(__assign(__assign({}, htmlConfig), { getBaseTarget: function(Bi, e) {
  return Bi[e];
}, readValueFromInstance: function(Bi, e) {
  var Zi;
  return isTransformProp(e) ? ((Zi = getDefaultValueType(e)) === null || Zi === void 0 ? void 0 : Zi.default) || 0 : (e = camelCaseAttributes.has(e) ? e : camelToDash(e), Bi.getAttribute(e));
}, scrapeMotionValuesFromProps, build: function(Bi, e, Zi, Qi, ea) {
  buildSVGAttrs(e, Zi, Qi, ea.transformTemplate);
}, render: renderSVG })), createDomVisualElement = function(Bi, e) {
  return isSVGComponent(Bi) ? svgVisualElement(e, { enableHardwareAcceleration: !1 }) : htmlVisualElement(e, { enableHardwareAcceleration: !0 });
};
function pixelsToPercent(Bi, e) {
  return e.max === e.min ? 0 : Bi / (e.max - e.min) * 100;
}
var correctBorderRadius = {
  correct: function(Bi, e) {
    if (!e.target)
      return Bi;
    if (typeof Bi == "string")
      if (px.test(Bi))
        Bi = parseFloat(Bi);
      else
        return Bi;
    var Zi = pixelsToPercent(Bi, e.target.x), Qi = pixelsToPercent(Bi, e.target.y);
    return "".concat(Zi, "% ").concat(Qi, "%");
  }
}, varToken = "_$css", correctBoxShadow = {
  correct: function(Bi, e) {
    var Zi = e.treeScale, Qi = e.projectionDelta, ea = Bi, ra = Bi.includes("var("), na = [];
    ra && (Bi = Bi.replace(cssVariableRegex, function(ao) {
      return na.push(ao), varToken;
    }));
    var ia = complex.parse(Bi);
    if (ia.length > 5)
      return ea;
    var fa = complex.createTransformer(Bi), La = typeof ia[0] != "number" ? 1 : 0, Va = Qi.x.scale * Zi.x, to = Qi.y.scale * Zi.y;
    ia[0 + La] /= Va, ia[1 + La] /= to;
    var ro = mix(Va, to, 0.5);
    typeof ia[2 + La] == "number" && (ia[2 + La] /= ro), typeof ia[3 + La] == "number" && (ia[3 + La] /= ro);
    var no = fa(ia);
    if (ra) {
      var eo = 0;
      no = no.replace(varToken, function() {
        var ao = na[eo];
        return eo++, ao;
      });
    }
    return no;
  }
}, MeasureLayoutWithContext = (
  /** @class */
  function(Bi) {
    __extends(e, Bi);
    function e() {
      return Bi !== null && Bi.apply(this, arguments) || this;
    }
    return e.prototype.componentDidMount = function() {
      var Zi = this, Qi = this.props, ea = Qi.visualElement, ra = Qi.layoutGroup, na = Qi.switchLayoutGroup, ia = Qi.layoutId, fa = ea.projection;
      addScaleCorrector(defaultScaleCorrectors), fa && (ra?.group && ra.group.add(fa), na?.register && ia && na.register(fa), fa.root.didUpdate(), fa.addEventListener("animationComplete", function() {
        Zi.safeToRemove();
      }), fa.setOptions(__assign(__assign({}, fa.options), { onExitComplete: function() {
        return Zi.safeToRemove();
      } }))), globalProjectionState.hasEverUpdated = !0;
    }, e.prototype.getSnapshotBeforeUpdate = function(Zi) {
      var Qi = this, ea = this.props, ra = ea.layoutDependency, na = ea.visualElement, ia = ea.drag, fa = ea.isPresent, La = na.projection;
      return La && (La.isPresent = fa, ia || Zi.layoutDependency !== ra || ra === void 0 ? La.willUpdate() : this.safeToRemove(), Zi.isPresent !== fa && (fa ? La.promote() : La.relegate() || sync.postRender(function() {
        var Va;
        !((Va = La.getStack()) === null || Va === void 0) && Va.members.length || Qi.safeToRemove();
      }))), null;
    }, e.prototype.componentDidUpdate = function() {
      var Zi = this.props.visualElement.projection;
      Zi && (Zi.root.didUpdate(), !Zi.currentAnimation && Zi.isLead() && this.safeToRemove());
    }, e.prototype.componentWillUnmount = function() {
      var Zi = this.props, Qi = Zi.visualElement, ea = Zi.layoutGroup, ra = Zi.switchLayoutGroup, na = Qi.projection;
      na && (na.scheduleCheckAfterUnmount(), ea?.group && ea.group.remove(na), ra?.deregister && ra.deregister(na));
    }, e.prototype.safeToRemove = function() {
      var Zi = this.props.safeToRemove;
      Zi?.();
    }, e.prototype.render = function() {
      return null;
    }, e;
  }(a__default.Component)
);
function MeasureLayout(Bi) {
  var e = __read(usePresence(), 2), Zi = e[0], Qi = e[1], ea = useContext(LayoutGroupContext);
  return a__default.createElement(MeasureLayoutWithContext, __assign({}, Bi, { layoutGroup: ea, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent: Zi, safeToRemove: Qi }));
}
var defaultScaleCorrectors = {
  borderRadius: __assign(__assign({}, correctBorderRadius), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
}, layoutFeatures = {
  measureLayout: MeasureLayout
};
function animate(Bi, e, Zi) {
  Zi === void 0 && (Zi = {});
  var Qi = isMotionValue(Bi) ? Bi : motionValue(Bi);
  return startAnimation("", Qi, e, Zi), {
    stop: function() {
      return Qi.stop();
    },
    isAnimating: function() {
      return Qi.isAnimating();
    }
  };
}
var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], numBorders = borders.length, asNumber = function(Bi) {
  return typeof Bi == "string" ? parseFloat(Bi) : Bi;
}, isPx = function(Bi) {
  return typeof Bi == "number" || px.test(Bi);
};
function mixValues(Bi, e, Zi, Qi, ea, ra) {
  var na, ia, fa, La;
  ea ? (Bi.opacity = mix(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (na = Zi.opacity) !== null && na !== void 0 ? na : 1,
    easeCrossfadeIn(Qi)
  ), Bi.opacityExit = mix((ia = e.opacity) !== null && ia !== void 0 ? ia : 1, 0, easeCrossfadeOut(Qi))) : ra && (Bi.opacity = mix((fa = e.opacity) !== null && fa !== void 0 ? fa : 1, (La = Zi.opacity) !== null && La !== void 0 ? La : 1, Qi));
  for (var Va = 0; Va < numBorders; Va++) {
    var to = "border".concat(borders[Va], "Radius"), ro = getRadius(e, to), no = getRadius(Zi, to);
    if (!(ro === void 0 && no === void 0)) {
      ro || (ro = 0), no || (no = 0);
      var eo = ro === 0 || no === 0 || isPx(ro) === isPx(no);
      eo ? (Bi[to] = Math.max(mix(asNumber(ro), asNumber(no), Qi), 0), (percent.test(no) || percent.test(ro)) && (Bi[to] += "%")) : Bi[to] = no;
    }
  }
  (e.rotate || Zi.rotate) && (Bi.rotate = mix(e.rotate || 0, Zi.rotate || 0, Qi));
}
function getRadius(Bi, e) {
  var Zi;
  return (Zi = Bi[e]) !== null && Zi !== void 0 ? Zi : Bi.borderRadius;
}
var easeCrossfadeIn = compress(0, 0.5, circOut), easeCrossfadeOut = compress(0.5, 0.95, linear);
function compress(Bi, e, Zi) {
  return function(Qi) {
    return Qi < Bi ? 0 : Qi > e ? 1 : Zi(progress(Bi, e, Qi));
  };
}
function copyAxisInto(Bi, e) {
  Bi.min = e.min, Bi.max = e.max;
}
function copyBoxInto(Bi, e) {
  copyAxisInto(Bi.x, e.x), copyAxisInto(Bi.y, e.y);
}
function removePointDelta(Bi, e, Zi, Qi, ea) {
  return Bi -= e, Bi = scalePoint(Bi, 1 / Zi, Qi), ea !== void 0 && (Bi = scalePoint(Bi, 1 / ea, Qi)), Bi;
}
function removeAxisDelta(Bi, e, Zi, Qi, ea, ra, na) {
  if (e === void 0 && (e = 0), Zi === void 0 && (Zi = 1), Qi === void 0 && (Qi = 0.5), ra === void 0 && (ra = Bi), na === void 0 && (na = Bi), percent.test(e)) {
    e = parseFloat(e);
    var ia = mix(na.min, na.max, e / 100);
    e = ia - na.min;
  }
  if (typeof e == "number") {
    var fa = mix(ra.min, ra.max, Qi);
    Bi === ra && (fa -= e), Bi.min = removePointDelta(Bi.min, e, Zi, fa, ea), Bi.max = removePointDelta(Bi.max, e, Zi, fa, ea);
  }
}
function removeAxisTransforms(Bi, e, Zi, Qi, ea) {
  var ra = __read(Zi, 3), na = ra[0], ia = ra[1], fa = ra[2];
  removeAxisDelta(Bi, e[na], e[ia], e[fa], e.scale, Qi, ea);
}
var xKeys = ["x", "scaleX", "originX"], yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(Bi, e, Zi, Qi) {
  removeAxisTransforms(Bi.x, e, xKeys, Zi?.x, Qi?.x), removeAxisTransforms(Bi.y, e, yKeys, Zi?.y, Qi?.y);
}
function isAxisDeltaZero(Bi) {
  return Bi.translate === 0 && Bi.scale === 1;
}
function isDeltaZero(Bi) {
  return isAxisDeltaZero(Bi.x) && isAxisDeltaZero(Bi.y);
}
function boxEquals(Bi, e) {
  return Bi.x.min === e.x.min && Bi.x.max === e.x.max && Bi.y.min === e.y.min && Bi.y.max === e.y.max;
}
var NodeStack = (
  /** @class */
  function() {
    function Bi() {
      this.members = [];
    }
    return Bi.prototype.add = function(e) {
      addUniqueItem(this.members, e), e.scheduleRender();
    }, Bi.prototype.remove = function(e) {
      if (removeItem(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
        var Zi = this.members[this.members.length - 1];
        Zi && this.promote(Zi);
      }
    }, Bi.prototype.relegate = function(e) {
      var Zi = this.members.findIndex(function(na) {
        return e === na;
      });
      if (Zi === 0)
        return !1;
      for (var Qi, ea = Zi; ea >= 0; ea--) {
        var ra = this.members[ea];
        if (ra.isPresent !== !1) {
          Qi = ra;
          break;
        }
      }
      return Qi ? (this.promote(Qi), !0) : !1;
    }, Bi.prototype.promote = function(e, Zi) {
      var Qi, ea = this.lead;
      if (e !== ea && (this.prevLead = ea, this.lead = e, e.show(), ea)) {
        ea.instance && ea.scheduleRender(), e.scheduleRender(), e.resumeFrom = ea, Zi && (e.resumeFrom.preserveOpacity = !0), ea.snapshot && (e.snapshot = ea.snapshot, e.snapshot.latestValues = ea.animationValues || ea.latestValues, e.snapshot.isShared = !0), !((Qi = e.root) === null || Qi === void 0) && Qi.isUpdating && (e.isLayoutDirty = !0);
        var ra = e.options.crossfade;
        ra === !1 && ea.hide();
      }
    }, Bi.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(e) {
        var Zi, Qi, ea, ra, na;
        (Qi = (Zi = e.options).onExitComplete) === null || Qi === void 0 || Qi.call(Zi), (na = (ea = e.resumingFrom) === null || ea === void 0 ? void 0 : (ra = ea.options).onExitComplete) === null || na === void 0 || na.call(ra);
      });
    }, Bi.prototype.scheduleRender = function() {
      this.members.forEach(function(e) {
        e.instance && e.scheduleRender(!1);
      });
    }, Bi.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, Bi;
  }()
), identityProjection = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function buildProjectionTransform(Bi, e, Zi) {
  var Qi = Bi.x.translate / e.x, ea = Bi.y.translate / e.y, ra = "translate3d(".concat(Qi, "px, ").concat(ea, "px, 0) ");
  if (ra += "scale(".concat(1 / e.x, ", ").concat(1 / e.y, ") "), Zi) {
    var na = Zi.rotate, ia = Zi.rotateX, fa = Zi.rotateY;
    na && (ra += "rotate(".concat(na, "deg) ")), ia && (ra += "rotateX(".concat(ia, "deg) ")), fa && (ra += "rotateY(".concat(fa, "deg) "));
  }
  var La = Bi.x.scale * e.x, Va = Bi.y.scale * e.y;
  return ra += "scale(".concat(La, ", ").concat(Va, ")"), ra === identityProjection ? "none" : ra;
}
var compareByDepth = function(Bi, e) {
  return Bi.depth - e.depth;
}, FlatTree = (
  /** @class */
  function() {
    function Bi() {
      this.children = [], this.isDirty = !1;
    }
    return Bi.prototype.add = function(e) {
      addUniqueItem(this.children, e), this.isDirty = !0;
    }, Bi.prototype.remove = function(e) {
      removeItem(this.children, e), this.isDirty = !0;
    }, Bi.prototype.forEach = function(e) {
      this.isDirty && this.children.sort(compareByDepth), this.isDirty = !1, this.children.forEach(e);
    }, Bi;
  }()
), animationTarget = 1e3;
function createProjectionNode(Bi) {
  var e = Bi.attachResizeListener, Zi = Bi.defaultParent, Qi = Bi.measureScroll, ea = Bi.checkIsScrollRoot, ra = Bi.resetTransform;
  return (
    /** @class */
    function() {
      function na(ia, fa, La) {
        var Va = this;
        fa === void 0 && (fa = {}), La === void 0 && (La = Zi?.()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          Va.isUpdating && (Va.isUpdating = !1, Va.clearAllSnapshots());
        }, this.updateProjection = function() {
          Va.nodes.forEach(resolveTargetDelta), Va.nodes.forEach(calcProjection);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = ia, this.latestValues = fa, this.root = La ? La.root || La : this, this.path = La ? __spreadArray(__spreadArray([], __read(La.path), !1), [La], !1) : [], this.parent = La, this.depth = La ? La.depth + 1 : 0, ia && this.root.registerPotentialNode(ia, this);
        for (var to = 0; to < this.path.length; to++)
          this.path[to].shouldResetTransform = !0;
        this.root === this && (this.nodes = new FlatTree());
      }
      return na.prototype.addEventListener = function(ia, fa) {
        return this.eventHandlers.has(ia) || this.eventHandlers.set(ia, new SubscriptionManager()), this.eventHandlers.get(ia).add(fa);
      }, na.prototype.notifyListeners = function(ia) {
        for (var fa = [], La = 1; La < arguments.length; La++)
          fa[La - 1] = arguments[La];
        var Va = this.eventHandlers.get(ia);
        Va?.notify.apply(Va, __spreadArray([], __read(fa), !1));
      }, na.prototype.hasListeners = function(ia) {
        return this.eventHandlers.has(ia);
      }, na.prototype.registerPotentialNode = function(ia, fa) {
        this.potentialNodes.set(ia, fa);
      }, na.prototype.mount = function(ia, fa) {
        var La = this, Va;
        if (fa === void 0 && (fa = !1), !this.instance) {
          this.isSVG = ia instanceof SVGElement && ia.tagName !== "svg", this.instance = ia;
          var to = this.options, ro = to.layoutId, no = to.layout, eo = to.visualElement;
          if (eo && !eo.getInstance() && eo.mount(ia), this.root.nodes.add(this), (Va = this.parent) === null || Va === void 0 || Va.children.add(this), this.id && this.root.potentialNodes.delete(this.id), fa && (no || ro) && (this.isLayoutDirty = !0), e) {
            var ao, io = function() {
              return La.root.updateBlockedByResize = !1;
            };
            e(ia, function() {
              La.root.updateBlockedByResize = !0, clearTimeout(ao), ao = window.setTimeout(io, 250), globalProjectionState.hasAnimatedSinceResize && (globalProjectionState.hasAnimatedSinceResize = !1, La.nodes.forEach(finishAnimation));
            });
          }
          ro && this.root.registerSharedNode(ro, this), this.options.animate !== !1 && eo && (ro || no) && this.addEventListener("didUpdate", function(xs) {
            var Ts, qs, Fs, Do, ys, Io = xs.delta, so = xs.hasLayoutChanged, os = xs.hasRelativeTargetChanged, Xs = xs.layout;
            if (La.isTreeAnimationBlocked()) {
              La.target = void 0, La.relativeTarget = void 0;
              return;
            }
            var gl = (qs = (Ts = La.options.transition) !== null && Ts !== void 0 ? Ts : eo.getDefaultTransition()) !== null && qs !== void 0 ? qs : defaultLayoutTransition, Sl = eo.getProps(), El = Sl.onLayoutAnimationStart, wl = Sl.onLayoutAnimationComplete, jl = !La.targetLayout || !boxEquals(La.targetLayout, Xs) || os, kl = !so && os;
            if (!((Fs = La.resumeFrom) === null || Fs === void 0) && Fs.instance || kl || so && (jl || !La.currentAnimation)) {
              La.resumeFrom && (La.resumingFrom = La.resumeFrom, La.resumingFrom.resumingFrom = void 0), La.setAnimationOrigin(Io, kl);
              var Fl = __assign(__assign({}, getValueTransition(gl, "layout")), { onPlay: El, onComplete: wl });
              eo.shouldReduceMotion && (Fl.delay = 0, Fl.type = !1), La.startAnimation(Fl);
            } else
              !so && La.animationProgress === 0 && La.finishAnimation(), La.isLead() && ((ys = (Do = La.options).onExitComplete) === null || ys === void 0 || ys.call(Do));
            La.targetLayout = Xs;
          });
        }
      }, na.prototype.unmount = function() {
        var ia, fa;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (ia = this.getStack()) === null || ia === void 0 || ia.remove(this), (fa = this.parent) === null || fa === void 0 || fa.children.delete(this), this.instance = void 0, cancelSync.preRender(this.updateProjection);
      }, na.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, na.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, na.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, na.prototype.isTreeAnimationBlocked = function() {
        var ia;
        return this.isAnimationBlocked || ((ia = this.parent) === null || ia === void 0 ? void 0 : ia.isTreeAnimationBlocked()) || !1;
      }, na.prototype.startUpdate = function() {
        var ia;
        this.isUpdateBlocked() || (this.isUpdating = !0, (ia = this.nodes) === null || ia === void 0 || ia.forEach(resetRotation));
      }, na.prototype.willUpdate = function(ia) {
        var fa, La, Va;
        if (ia === void 0 && (ia = !0), this.root.isUpdateBlocked()) {
          (La = (fa = this.options).onExitComplete) === null || La === void 0 || La.call(fa);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var to = 0; to < this.path.length; to++) {
            var ro = this.path[to];
            ro.shouldResetTransform = !0, ro.updateScroll();
          }
          var no = this.options, eo = no.layoutId, ao = no.layout;
          if (!(eo === void 0 && !ao)) {
            var io = (Va = this.options.visualElement) === null || Va === void 0 ? void 0 : Va.getProps().transformTemplate;
            this.prevTransformTemplateValue = io?.(this.latestValues, ""), this.updateSnapshot(), ia && this.notifyListeners("willUpdate");
          }
        }
      }, na.prototype.didUpdate = function() {
        var ia = this.isUpdateBlocked();
        if (ia) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(clearMeasurements);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(mountNodeEarly), this.potentialNodes.clear()), this.nodes.forEach(resetTransformStyle), this.nodes.forEach(updateLayout), this.nodes.forEach(notifyLayoutUpdate), this.clearAllSnapshots(), flushSync.update(), flushSync.preRender(), flushSync.render());
      }, na.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(clearSnapshot), this.sharedNodes.forEach(removeLeadSnapshots);
      }, na.prototype.scheduleUpdateProjection = function() {
        sync.preRender(this.updateProjection, !1, !0);
      }, na.prototype.scheduleCheckAfterUnmount = function() {
        var ia = this;
        sync.postRender(function() {
          ia.isLayoutDirty ? ia.root.didUpdate() : ia.root.checkUpdateFailed();
        });
      }, na.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var ia = this.measure(), fa = this.removeTransform(this.removeElementScroll(ia));
          roundBox(fa), this.snapshot = {
            measured: ia,
            layout: fa,
            latestValues: {}
          };
        }
      }, na.prototype.updateLayout = function() {
        var ia;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var fa = 0; fa < this.path.length; fa++) {
              var La = this.path[fa];
              La.updateScroll();
            }
          var Va = this.measure();
          roundBox(Va);
          var to = this.layout;
          this.layout = {
            measured: Va,
            actual: this.removeElementScroll(Va)
          }, this.layoutCorrected = createBox(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (ia = this.options.visualElement) === null || ia === void 0 || ia.notifyLayoutMeasure(this.layout.actual, to?.actual);
        }
      }, na.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = ea(this.instance), this.scroll = Qi(this.instance));
      }, na.prototype.resetTransform = function() {
        var ia;
        if (ra) {
          var fa = this.isLayoutDirty || this.shouldResetTransform, La = this.projectionDelta && !isDeltaZero(this.projectionDelta), Va = (ia = this.options.visualElement) === null || ia === void 0 ? void 0 : ia.getProps().transformTemplate, to = Va?.(this.latestValues, ""), ro = to !== this.prevTransformTemplateValue;
          fa && (La || hasTransform(this.latestValues) || ro) && (ra(this.instance, to), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, na.prototype.measure = function() {
        var ia = this.options.visualElement;
        if (!ia)
          return createBox();
        var fa = ia.measureViewportBox(), La = this.root.scroll;
        return La && (translateAxis(fa.x, La.x), translateAxis(fa.y, La.y)), fa;
      }, na.prototype.removeElementScroll = function(ia) {
        var fa = createBox();
        copyBoxInto(fa, ia);
        for (var La = 0; La < this.path.length; La++) {
          var Va = this.path[La], to = Va.scroll, ro = Va.options, no = Va.isScrollRoot;
          if (Va !== this.root && to && ro.layoutScroll) {
            if (no) {
              copyBoxInto(fa, ia);
              var eo = this.root.scroll;
              eo && (translateAxis(fa.x, -eo.x), translateAxis(fa.y, -eo.y));
            }
            translateAxis(fa.x, to.x), translateAxis(fa.y, to.y);
          }
        }
        return fa;
      }, na.prototype.applyTransform = function(ia, fa) {
        fa === void 0 && (fa = !1);
        var La = createBox();
        copyBoxInto(La, ia);
        for (var Va = 0; Va < this.path.length; Va++) {
          var to = this.path[Va];
          !fa && to.options.layoutScroll && to.scroll && to !== to.root && transformBox(La, {
            x: -to.scroll.x,
            y: -to.scroll.y
          }), hasTransform(to.latestValues) && transformBox(La, to.latestValues);
        }
        return hasTransform(this.latestValues) && transformBox(La, this.latestValues), La;
      }, na.prototype.removeTransform = function(ia) {
        var fa, La = createBox();
        copyBoxInto(La, ia);
        for (var Va = 0; Va < this.path.length; Va++) {
          var to = this.path[Va];
          if (to.instance && hasTransform(to.latestValues)) {
            hasScale(to.latestValues) && to.updateSnapshot();
            var ro = createBox(), no = to.measure();
            copyBoxInto(ro, no), removeBoxTransforms(La, to.latestValues, (fa = to.snapshot) === null || fa === void 0 ? void 0 : fa.layout, ro);
          }
        }
        return hasTransform(this.latestValues) && removeBoxTransforms(La, this.latestValues), La;
      }, na.prototype.setTargetDelta = function(ia) {
        this.targetDelta = ia, this.root.scheduleUpdateProjection();
      }, na.prototype.setOptions = function(ia) {
        var fa;
        this.options = __assign(__assign(__assign({}, this.options), ia), { crossfade: (fa = ia.crossfade) !== null && fa !== void 0 ? fa : !0 });
      }, na.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, na.prototype.resolveTargetDelta = function() {
        var ia, fa = this.options, La = fa.layout, Va = fa.layoutId;
        !this.layout || !(La || Va) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = createBox(), this.targetWithTransforms = createBox()), this.relativeTarget && this.relativeTargetOrigin && (!((ia = this.relativeParent) === null || ia === void 0) && ia.target) ? calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : copyBoxInto(this.target, this.layout.actual), applyBoxDelta(this.target, this.targetDelta)) : copyBoxInto(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.target, this.relativeParent.target), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin)))));
      }, na.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || hasTransform(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, na.prototype.calcProjection = function() {
        var ia, fa = this.options, La = fa.layout, Va = fa.layoutId;
        if (this.isTreeAnimating = !!(!((ia = this.parent) === null || ia === void 0) && ia.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(La || Va))) {
          var to = this.getLead();
          copyBoxInto(this.layoutCorrected, this.layout.actual), applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== to);
          var ro = to.target;
          if (ro) {
            this.projectionDelta || (this.projectionDelta = createDelta(), this.projectionDeltaWithTransform = createDelta());
            var no = this.treeScale.x, eo = this.treeScale.y, ao = this.projectionTransform;
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, ro, this.latestValues), this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale), (this.projectionTransform !== ao || this.treeScale.x !== no || this.treeScale.y !== eo) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", ro));
          }
        }
      }, na.prototype.hide = function() {
        this.isVisible = !1;
      }, na.prototype.show = function() {
        this.isVisible = !0;
      }, na.prototype.scheduleRender = function(ia) {
        var fa, La, Va;
        ia === void 0 && (ia = !0), (La = (fa = this.options).scheduleRender) === null || La === void 0 || La.call(fa), ia && ((Va = this.getStack()) === null || Va === void 0 || Va.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, na.prototype.setAnimationOrigin = function(ia, fa) {
        var La = this, Va;
        fa === void 0 && (fa = !1);
        var to = this.snapshot, ro = to?.latestValues || {}, no = __assign({}, this.latestValues), eo = createDelta();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !fa;
        var ao = createBox(), io = to?.isShared, xs = (((Va = this.getStack()) === null || Va === void 0 ? void 0 : Va.members.length) || 0) <= 1, Ts = !!(io && !xs && this.options.crossfade === !0 && !this.path.some(hasOpacityCrossfade));
        this.animationProgress = 0, this.mixTargetDelta = function(qs) {
          var Fs, Do = qs / 1e3;
          mixAxisDelta(eo.x, ia.x, Do), mixAxisDelta(eo.y, ia.y, Do), La.setTargetDelta(eo), La.relativeTarget && La.relativeTargetOrigin && La.layout && (!((Fs = La.relativeParent) === null || Fs === void 0) && Fs.layout) && (calcRelativePosition(ao, La.layout.actual, La.relativeParent.layout.actual), mixBox(La.relativeTarget, La.relativeTargetOrigin, ao, Do)), io && (La.animationValues = no, mixValues(no, ro, La.latestValues, Do, Ts, xs)), La.root.scheduleUpdateProjection(), La.scheduleRender(), La.animationProgress = Do;
        }, this.mixTargetDelta(0);
      }, na.prototype.startAnimation = function(ia) {
        var fa = this, La, Va;
        this.notifyListeners("animationStart"), (La = this.currentAnimation) === null || La === void 0 || La.stop(), this.resumingFrom && ((Va = this.resumingFrom.currentAnimation) === null || Va === void 0 || Va.stop()), this.pendingAnimation && (cancelSync.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = sync.update(function() {
          globalProjectionState.hasAnimatedSinceResize = !0, fa.currentAnimation = animate(0, animationTarget, __assign(__assign({}, ia), { onUpdate: function(to) {
            var ro;
            fa.mixTargetDelta(to), (ro = ia.onUpdate) === null || ro === void 0 || ro.call(ia, to);
          }, onComplete: function() {
            var to;
            (to = ia.onComplete) === null || to === void 0 || to.call(ia), fa.completeAnimation();
          } })), fa.resumingFrom && (fa.resumingFrom.currentAnimation = fa.currentAnimation), fa.pendingAnimation = void 0;
        });
      }, na.prototype.completeAnimation = function() {
        var ia;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (ia = this.getStack()) === null || ia === void 0 || ia.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, na.prototype.finishAnimation = function() {
        var ia;
        this.currentAnimation && ((ia = this.mixTargetDelta) === null || ia === void 0 || ia.call(this, animationTarget), this.currentAnimation.stop()), this.completeAnimation();
      }, na.prototype.applyTransformsToTarget = function() {
        var ia = this.getLead(), fa = ia.targetWithTransforms, La = ia.target, Va = ia.layout, to = ia.latestValues;
        !fa || !La || !Va || (copyBoxInto(fa, La), transformBox(fa, to), calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, fa, to));
      }, na.prototype.registerSharedNode = function(ia, fa) {
        var La, Va, to;
        this.sharedNodes.has(ia) || this.sharedNodes.set(ia, new NodeStack());
        var ro = this.sharedNodes.get(ia);
        ro.add(fa), fa.promote({
          transition: (La = fa.options.initialPromotionConfig) === null || La === void 0 ? void 0 : La.transition,
          preserveFollowOpacity: (to = (Va = fa.options.initialPromotionConfig) === null || Va === void 0 ? void 0 : Va.shouldPreserveFollowOpacity) === null || to === void 0 ? void 0 : to.call(Va, fa)
        });
      }, na.prototype.isLead = function() {
        var ia = this.getStack();
        return ia ? ia.lead === this : !0;
      }, na.prototype.getLead = function() {
        var ia, fa = this.options.layoutId;
        return fa ? ((ia = this.getStack()) === null || ia === void 0 ? void 0 : ia.lead) || this : this;
      }, na.prototype.getPrevLead = function() {
        var ia, fa = this.options.layoutId;
        return fa ? (ia = this.getStack()) === null || ia === void 0 ? void 0 : ia.prevLead : void 0;
      }, na.prototype.getStack = function() {
        var ia = this.options.layoutId;
        if (ia)
          return this.root.sharedNodes.get(ia);
      }, na.prototype.promote = function(ia) {
        var fa = ia === void 0 ? {} : ia, La = fa.needsReset, Va = fa.transition, to = fa.preserveFollowOpacity, ro = this.getStack();
        ro && ro.promote(this, to), La && (this.projectionDelta = void 0, this.needsReset = !0), Va && this.setOptions({ transition: Va });
      }, na.prototype.relegate = function() {
        var ia = this.getStack();
        return ia ? ia.relegate(this) : !1;
      }, na.prototype.resetRotation = function() {
        var ia = this.options.visualElement;
        if (ia) {
          for (var fa = !1, La = {}, Va = 0; Va < transformAxes.length; Va++) {
            var to = transformAxes[Va], ro = "rotate" + to;
            ia.getStaticValue(ro) && (fa = !0, La[ro] = ia.getStaticValue(ro), ia.setStaticValue(ro, 0));
          }
          if (fa) {
            ia?.syncRender();
            for (var ro in La)
              ia.setStaticValue(ro, La[ro]);
            ia.scheduleRender();
          }
        }
      }, na.prototype.getProjectionStyles = function(ia) {
        var fa, La, Va, to, ro, no;
        ia === void 0 && (ia = {});
        var eo = {};
        if (!this.instance || this.isSVG)
          return eo;
        if (this.isVisible)
          eo.visibility = "";
        else
          return { visibility: "hidden" };
        var ao = (fa = this.options.visualElement) === null || fa === void 0 ? void 0 : fa.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, eo.opacity = "", eo.pointerEvents = resolveMotionValue(ia.pointerEvents) || "", eo.transform = ao ? ao(this.latestValues, "") : "none", eo;
        var io = this.getLead();
        if (!this.projectionDelta || !this.layout || !io.target) {
          var xs = {};
          return this.options.layoutId && (xs.opacity = (La = this.latestValues.opacity) !== null && La !== void 0 ? La : 1, xs.pointerEvents = resolveMotionValue(ia.pointerEvents) || ""), this.hasProjected && !hasTransform(this.latestValues) && (xs.transform = ao ? ao({}, "") : "none", this.hasProjected = !1), xs;
        }
        var Ts = io.animationValues || io.latestValues;
        this.applyTransformsToTarget(), eo.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, Ts), ao && (eo.transform = ao(Ts, eo.transform));
        var qs = this.projectionDelta, Fs = qs.x, Do = qs.y;
        eo.transformOrigin = "".concat(Fs.origin * 100, "% ").concat(Do.origin * 100, "% 0"), io.animationValues ? eo.opacity = io === this ? (to = (Va = Ts.opacity) !== null && Va !== void 0 ? Va : this.latestValues.opacity) !== null && to !== void 0 ? to : 1 : this.preserveOpacity ? this.latestValues.opacity : Ts.opacityExit : eo.opacity = io === this ? (ro = Ts.opacity) !== null && ro !== void 0 ? ro : "" : (no = Ts.opacityExit) !== null && no !== void 0 ? no : 0;
        for (var ys in scaleCorrectors)
          if (Ts[ys] !== void 0) {
            var Io = scaleCorrectors[ys], so = Io.correct, os = Io.applyTo, Xs = so(Ts[ys], io);
            if (os)
              for (var gl = os.length, Sl = 0; Sl < gl; Sl++)
                eo[os[Sl]] = Xs;
            else
              eo[ys] = Xs;
          }
        return this.options.layoutId && (eo.pointerEvents = io === this ? resolveMotionValue(ia.pointerEvents) || "" : "none"), eo;
      }, na.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, na.prototype.resetTree = function() {
        this.root.nodes.forEach(function(ia) {
          var fa;
          return (fa = ia.currentAnimation) === null || fa === void 0 ? void 0 : fa.stop();
        }), this.root.nodes.forEach(clearMeasurements), this.root.sharedNodes.clear();
      }, na;
    }()
  );
}
function updateLayout(Bi) {
  Bi.updateLayout();
}
function notifyLayoutUpdate(Bi) {
  var e, Zi, Qi, ea, ra = (Zi = (e = Bi.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) !== null && Zi !== void 0 ? Zi : Bi.snapshot;
  if (Bi.isLead() && Bi.layout && ra && Bi.hasListeners("didUpdate")) {
    var na = Bi.layout, ia = na.actual, fa = na.measured;
    Bi.options.animationType === "size" ? eachAxis(function(Ts) {
      var qs = ra.isShared ? ra.measured[Ts] : ra.layout[Ts], Fs = calcLength(qs);
      qs.min = ia[Ts].min, qs.max = qs.min + Fs;
    }) : Bi.options.animationType === "position" && eachAxis(function(Ts) {
      var qs = ra.isShared ? ra.measured[Ts] : ra.layout[Ts], Fs = calcLength(ia[Ts]);
      qs.max = qs.min + Fs;
    });
    var La = createDelta();
    calcBoxDelta(La, ia, ra.layout);
    var Va = createDelta();
    ra.isShared ? calcBoxDelta(Va, Bi.applyTransform(fa, !0), ra.measured) : calcBoxDelta(Va, ia, ra.layout);
    var to = !isDeltaZero(La), ro = !1;
    if (!Bi.resumeFrom && (Bi.relativeParent = Bi.getClosestProjectingParent(), Bi.relativeParent && !Bi.relativeParent.resumeFrom)) {
      var no = Bi.relativeParent, eo = no.snapshot, ao = no.layout;
      if (eo && ao) {
        var io = createBox();
        calcRelativePosition(io, ra.layout, eo.layout);
        var xs = createBox();
        calcRelativePosition(xs, ia, ao.actual), boxEquals(io, xs) || (ro = !0);
      }
    }
    Bi.notifyListeners("didUpdate", {
      layout: ia,
      snapshot: ra,
      delta: Va,
      layoutDelta: La,
      hasLayoutChanged: to,
      hasRelativeTargetChanged: ro
    });
  } else Bi.isLead() && ((ea = (Qi = Bi.options).onExitComplete) === null || ea === void 0 || ea.call(Qi));
  Bi.options.transition = void 0;
}
function clearSnapshot(Bi) {
  Bi.clearSnapshot();
}
function clearMeasurements(Bi) {
  Bi.clearMeasurements();
}
function resetTransformStyle(Bi) {
  var e = Bi.options.visualElement;
  e?.getProps().onBeforeLayoutMeasure && e.notifyBeforeLayoutMeasure(), Bi.resetTransform();
}
function finishAnimation(Bi) {
  Bi.finishAnimation(), Bi.targetDelta = Bi.relativeTarget = Bi.target = void 0;
}
function resolveTargetDelta(Bi) {
  Bi.resolveTargetDelta();
}
function calcProjection(Bi) {
  Bi.calcProjection();
}
function resetRotation(Bi) {
  Bi.resetRotation();
}
function removeLeadSnapshots(Bi) {
  Bi.removeLeadSnapshot();
}
function mixAxisDelta(Bi, e, Zi) {
  Bi.translate = mix(e.translate, 0, Zi), Bi.scale = mix(e.scale, 1, Zi), Bi.origin = e.origin, Bi.originPoint = e.originPoint;
}
function mixAxis(Bi, e, Zi, Qi) {
  Bi.min = mix(e.min, Zi.min, Qi), Bi.max = mix(e.max, Zi.max, Qi);
}
function mixBox(Bi, e, Zi, Qi) {
  mixAxis(Bi.x, e.x, Zi.x, Qi), mixAxis(Bi.y, e.y, Zi.y, Qi);
}
function hasOpacityCrossfade(Bi) {
  return Bi.animationValues && Bi.animationValues.opacityExit !== void 0;
}
var defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function mountNodeEarly(Bi, e) {
  for (var Zi = Bi.root, Qi = Bi.path.length - 1; Qi >= 0; Qi--)
    if (Bi.path[Qi].instance) {
      Zi = Bi.path[Qi];
      break;
    }
  var ea = Zi && Zi !== Bi.root ? Zi.instance : document, ra = ea.querySelector('[data-projection-id="'.concat(e, '"]'));
  ra && Bi.mount(ra, !0);
}
function roundAxis(Bi) {
  Bi.min = Math.round(Bi.min), Bi.max = Math.round(Bi.max);
}
function roundBox(Bi) {
  roundAxis(Bi.x), roundAxis(Bi.y);
}
var DocumentProjectionNode = createProjectionNode({
  attachResizeListener: function(Bi, e) {
    return addDomEvent(Bi, "resize", e);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), rootProjectionNode = {
  current: void 0
}, HTMLProjectionNode = createProjectionNode({
  measureScroll: function(Bi) {
    return {
      x: Bi.scrollLeft,
      y: Bi.scrollTop
    };
  },
  defaultParent: function() {
    if (!rootProjectionNode.current) {
      var Bi = new DocumentProjectionNode(0, {});
      Bi.mount(window), Bi.setOptions({ layoutScroll: !0 }), rootProjectionNode.current = Bi;
    }
    return rootProjectionNode.current;
  },
  resetTransform: function(Bi, e) {
    Bi.style.transform = e ?? "none";
  },
  checkIsScrollRoot: function(Bi) {
    return window.getComputedStyle(Bi).position === "fixed";
  }
}), featureBundle = __assign(__assign(__assign(__assign({}, animations), gestureAnimations), drag), layoutFeatures), motion = /* @__PURE__ */ createMotionProxy(function(Bi, e) {
  return createDomMotionConfig(Bi, e, featureBundle, createDomVisualElement, HTMLProjectionNode);
});
function useIsMounted() {
  var Bi = useRef(!1);
  return useIsomorphicLayoutEffect$1(function() {
    return Bi.current = !0, function() {
      Bi.current = !1;
    };
  }, []), Bi;
}
function useForceUpdate() {
  var Bi = useIsMounted(), e = __read(useState(0), 2), Zi = e[0], Qi = e[1], ea = useCallback(function() {
    Bi.current && Qi(Zi + 1);
  }, [Zi]), ra = useCallback(function() {
    return sync.postRender(ea);
  }, [ea]);
  return [ra, Zi];
}
var PresenceChild = function(Bi) {
  var e = Bi.children, Zi = Bi.initial, Qi = Bi.isPresent, ea = Bi.onExitComplete, ra = Bi.custom, na = Bi.presenceAffectsLayout, ia = useConstant(newChildrenMap), fa = useId(), La = useMemo(
    function() {
      return {
        id: fa,
        initial: Zi,
        isPresent: Qi,
        custom: ra,
        onExitComplete: function(Va) {
          var to, ro;
          ia.set(Va, !0);
          try {
            for (var no = __values(ia.values()), eo = no.next(); !eo.done; eo = no.next()) {
              var ao = eo.value;
              if (!ao)
                return;
            }
          } catch (io) {
            to = { error: io };
          } finally {
            try {
              eo && !eo.done && (ro = no.return) && ro.call(no);
            } finally {
              if (to) throw to.error;
            }
          }
          ea?.();
        },
        register: function(Va) {
          return ia.set(Va, !1), function() {
            return ia.delete(Va);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    na ? void 0 : [Qi]
  );
  return useMemo(function() {
    ia.forEach(function(Va, to) {
      return ia.set(to, !1);
    });
  }, [Qi]), a$8.useEffect(function() {
    !Qi && !ia.size && ea?.();
  }, [Qi]), a$8.createElement(PresenceContext.Provider, { value: La }, e);
};
function newChildrenMap() {
  return /* @__PURE__ */ new Map();
}
var getChildKey = function(Bi) {
  return Bi.key || "";
};
function updateChildLookup(Bi, e) {
  Bi.forEach(function(Zi) {
    var Qi = getChildKey(Zi);
    e.set(Qi, Zi);
  });
}
function onlyElements(Bi) {
  var e = [];
  return Children.forEach(Bi, function(Zi) {
    isValidElement(Zi) && e.push(Zi);
  }), e;
}
var AnimatePresence = function(Bi) {
  var e = Bi.children, Zi = Bi.custom, Qi = Bi.initial, ea = Qi === void 0 ? !0 : Qi, ra = Bi.onExitComplete, na = Bi.exitBeforeEnter, ia = Bi.presenceAffectsLayout, fa = ia === void 0 ? !0 : ia, La = __read(useForceUpdate(), 1), Va = La[0], to = useContext(LayoutGroupContext).forceRender;
  to && (Va = to);
  var ro = useIsMounted(), no = onlyElements(e), eo = no, ao = /* @__PURE__ */ new Set(), io = useRef(eo), xs = useRef(/* @__PURE__ */ new Map()).current, Ts = useRef(!0);
  if (useIsomorphicLayoutEffect$1(function() {
    Ts.current = !1, updateChildLookup(no, xs), io.current = eo;
  }), useUnmountEffect(function() {
    Ts.current = !0, xs.clear(), ao.clear();
  }), Ts.current)
    return a$8.createElement(a$8.Fragment, null, eo.map(function(so) {
      return a$8.createElement(PresenceChild, { key: getChildKey(so), isPresent: !0, initial: ea ? void 0 : !1, presenceAffectsLayout: fa }, so);
    }));
  eo = __spreadArray([], __read(eo), !1);
  for (var qs = io.current.map(getChildKey), Fs = no.map(getChildKey), Do = qs.length, ys = 0; ys < Do; ys++) {
    var Io = qs[ys];
    Fs.indexOf(Io) === -1 && ao.add(Io);
  }
  return na && ao.size && (eo = []), ao.forEach(function(so) {
    if (Fs.indexOf(so) === -1) {
      var os = xs.get(so);
      if (os) {
        var Xs = qs.indexOf(so), gl = function() {
          xs.delete(so), ao.delete(so);
          var Sl = io.current.findIndex(function(El) {
            return El.key === so;
          });
          if (io.current.splice(Sl, 1), !ao.size) {
            if (io.current = no, ro.current === !1)
              return;
            Va(), ra && ra();
          }
        };
        eo.splice(Xs, 0, a$8.createElement(PresenceChild, { key: getChildKey(os), isPresent: !1, onExitComplete: gl, custom: Zi, presenceAffectsLayout: fa }, os));
      }
    }
  }), eo = eo.map(function(so) {
    var os = so.key;
    return ao.has(os) ? so : a$8.createElement(PresenceChild, { key: getChildKey(so), isPresent: !0, presenceAffectsLayout: fa }, so);
  }), env !== "production" && na && eo.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), a$8.createElement(a$8.Fragment, null, ao.size ? eo : eo.map(function(so) {
    return cloneElement(so);
  }));
}, DeprecatedLayoutGroupContext = createContext(null), notify = function(Bi) {
  return !Bi.isLayoutDirty && Bi.willUpdate(!1);
};
function nodeGroup() {
  var Bi = /* @__PURE__ */ new Set(), e = /* @__PURE__ */ new WeakMap(), Zi = function() {
    return Bi.forEach(notify);
  };
  return {
    add: function(Qi) {
      Bi.add(Qi), e.set(Qi, Qi.addEventListener("willUpdate", Zi));
    },
    remove: function(Qi) {
      var ea;
      Bi.delete(Qi), (ea = e.get(Qi)) === null || ea === void 0 || ea(), e.delete(Qi), Zi();
    },
    dirty: Zi
  };
}
var shouldInheritGroup = function(Bi) {
  return Bi === !0;
}, shouldInheritId = function(Bi) {
  return shouldInheritGroup(Bi === !0) || Bi === "id";
}, LayoutGroup = function(Bi) {
  var e, Zi, Qi = Bi.children, ea = Bi.id, ra = Bi.inheritId, na = Bi.inherit, ia = na === void 0 ? !0 : na;
  ra !== void 0 && (ia = ra);
  var fa = useContext(LayoutGroupContext), La = useContext(DeprecatedLayoutGroupContext), Va = __read(useForceUpdate(), 2), to = Va[0], ro = Va[1], no = useRef(null), eo = (e = fa.id) !== null && e !== void 0 ? e : La;
  no.current === null && (shouldInheritId(ia) && eo && (ea = ea ? eo + "-" + ea : eo), no.current = {
    id: ea,
    group: shouldInheritGroup(ia) && (Zi = fa?.group) !== null && Zi !== void 0 ? Zi : nodeGroup()
  });
  var ao = useMemo(function() {
    return __assign(__assign({}, no.current), { forceRender: to });
  }, [ro]);
  return a$8.createElement(LayoutGroupContext.Provider, { value: ao }, Qi);
}, id = 0, AnimateSharedLayout = function(Bi) {
  var e = Bi.children;
  return a$8.useEffect(function() {
    warning$1(!1, "AnimateSharedLayout is deprecated: https://www.framer.com/docs/guide-upgrade/##shared-layout-animations");
  }, []), a$8.createElement(LayoutGroup, { id: useConstant(function() {
    return "asl-".concat(id++);
  }) }, e);
};
const exit = {
  y: "-200%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, initial = {
  y: "-50%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, Delete = ({ onDelete: Bi, className: e = "" }) => {
  const [Zi, Qi] = useState(!1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    motion.button,
    {
      layout: !0,
      className: `${e} relative cursor-pointer bg-red-400 focus:ring-red-400 hover:bg-red-500 disabled:bg-red-400 z-0 px-4 py-2 text-sm text-white transition-all rounded-lg focus:outline-none focus:ring-2 focus:ring-opacity-75 disabled:opacity-50 disabled:cursor-default`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "opacity-0", children: Zi ? "Sure?" : "Delete" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.p,
          {
            className: "absolute text-white",
            onClick: () => Qi(!0),
            exit,
            initial,
            children: !Zi && "Delete"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { children: Zi && /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.p,
          {
            className: "absolute text-white",
            onClick: () => Bi(),
            initial: { y: "200%", top: "50%", left: "50%", x: "-50%" },
            animate: { y: "-50%", top: "50%", left: "50%", x: "-50%" },
            children: "Sure?"
          }
        ) })
      ]
    }
  );
}, Divider = () => /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { className: "w-full h-px border-t-neutral-600" }), containerStyles$1 = cva(
  [
    "w-48",
    "h-screen",
    "fixed",
    "top-0",
    "left-[100vw]",
    "bg-white",
    "transition-transform"
  ],
  {
    variants: {
      visible: {
        true: "-translate-x-full",
        false: ""
      }
    }
  }
), Drawer = ({
  visible: Bi,
  children: e,
  onClose: Zi
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  Bi && /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "fixed top-0 left-0 w-screen h-screen bg-black opacity-50",
      onClick: () => Zi()
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: containerStyles$1({ visible: Bi }), children: e })
] }), size = 16, DrawerButton = ({
  sideBarVisible: Bi,
  onClick: e,
  className: Zi = ""
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  motion.svg,
  {
    className: `my-auto cursor-pointer ${Zi}`,
    width: size,
    height: size,
    viewBox: `0 0 ${size} ${size}`,
    animate: Bi ? "open" : "closed",
    onClick: () => e(),
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 1 L ${size} 1` },
            open: { d: `M ${size} 0 L 0 ${size}` }
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          d: `M 0 ${size / 2} L ${size} ${size / 2}`,
          variants: {
            closed: { opacity: 1 },
            open: { opacity: 0 }
          },
          transition: { duration: 0.1 }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 ${size - 1} L ${size} ${size - 1}` },
            open: { d: `M 0 0 L ${size} ${size}` }
          }
        }
      )
    ]
  }
), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document < "u" ? a__default.useLayoutEffect : () => {
};
function $8ae05eaa5c114e9c$export$7f54fc3180508a52(Bi) {
  const e = useRef(null);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    e.current = Bi;
  }, [
    Bi
  ]), useCallback((...Zi) => {
    const Qi = e.current;
    return Qi?.(...Zi);
  }, []);
}
function $1dbecbe27a04f9af$export$14d238f342723f25(Bi) {
  let [e, Zi] = useState(Bi), Qi = useRef(null), ea = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    if (!Qi.current) return;
    let na = Qi.current.next();
    if (na.done) {
      Qi.current = null;
      return;
    }
    e === na.value ? ea() : Zi(na.value);
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    Qi.current && ea();
  });
  let ra = $8ae05eaa5c114e9c$export$7f54fc3180508a52((na) => {
    Qi.current = na(e), ea();
  });
  return [
    e,
    ra
  ];
}
const $b5e257d569688ac6$var$defaultContext = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, $b5e257d569688ac6$var$SSRContext = /* @__PURE__ */ a__default.createContext($b5e257d569688ac6$var$defaultContext), $b5e257d569688ac6$var$IsSSRContext = /* @__PURE__ */ a__default.createContext(!1);
let $b5e257d569688ac6$var$canUseDOM = !!(typeof window < "u" && window.document && window.document.createElement), $b5e257d569688ac6$var$componentIds = /* @__PURE__ */ new WeakMap();
function $b5e257d569688ac6$var$useCounter(Bi = !1) {
  let e = useContext($b5e257d569688ac6$var$SSRContext), Zi = useRef(null);
  if (Zi.current === null && !Bi) {
    var Qi, ea;
    let ra = (ea = a__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || ea === void 0 || (Qi = ea.ReactCurrentOwner) === null || Qi === void 0 ? void 0 : Qi.current;
    if (ra) {
      let na = $b5e257d569688ac6$var$componentIds.get(ra);
      na == null ? $b5e257d569688ac6$var$componentIds.set(ra, {
        id: e.current,
        state: ra.memoizedState
      }) : ra.memoizedState !== na.state && (e.current = na.id, $b5e257d569688ac6$var$componentIds.delete(ra));
    }
    Zi.current = ++e.current;
  }
  return Zi.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(Bi) {
  let e = useContext($b5e257d569688ac6$var$SSRContext);
  e === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let Zi = $b5e257d569688ac6$var$useCounter(!!Bi), Qi = e === $b5e257d569688ac6$var$defaultContext && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${e.prefix}`;
  return Bi || `${Qi}-${Zi}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId(Bi) {
  let e = a__default.useId(), [Zi] = useState($b5e257d569688ac6$export$535bd6ca7f90a273()), Qi = Zi || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
  return Bi || `${Qi}-${e}`;
}
const $b5e257d569688ac6$export$619500959fc48b26 = typeof a__default.useId == "function" ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
  return !1;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
  return !0;
}
function $b5e257d569688ac6$var$subscribe(Bi) {
  return () => {
  };
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
  return typeof a__default.useSyncExternalStore == "function" ? a__default.useSyncExternalStore($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot) : useContext($b5e257d569688ac6$var$IsSSRContext);
}
let $bdb11010cef70236$var$canUseDOM = !!(typeof window < "u" && window.document && window.document.createElement), $bdb11010cef70236$var$idsUpdaterMap = /* @__PURE__ */ new Map();
function $bdb11010cef70236$export$f680877a34711e37(Bi) {
  let [e, Zi] = useState(Bi), Qi = useRef(null), ea = $b5e257d569688ac6$export$619500959fc48b26(e), ra = useCallback((na) => {
    Qi.current = na;
  }, []);
  return $bdb11010cef70236$var$canUseDOM && ($bdb11010cef70236$var$idsUpdaterMap.has(ea) && !$bdb11010cef70236$var$idsUpdaterMap.get(ea).includes(ra) ? $bdb11010cef70236$var$idsUpdaterMap.set(ea, [
    ...$bdb11010cef70236$var$idsUpdaterMap.get(ea),
    ra
  ]) : $bdb11010cef70236$var$idsUpdaterMap.set(ea, [
    ra
  ])), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let na = ea;
    return () => {
      $bdb11010cef70236$var$idsUpdaterMap.delete(na);
    };
  }, [
    ea
  ]), useEffect(() => {
    let na = Qi.current;
    na && (Qi.current = null, Zi(na));
  }), ea;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(Bi, e) {
  if (Bi === e) return Bi;
  let Zi = $bdb11010cef70236$var$idsUpdaterMap.get(Bi);
  if (Zi)
    return Zi.forEach((ea) => ea(e)), e;
  let Qi = $bdb11010cef70236$var$idsUpdaterMap.get(e);
  return Qi ? (Qi.forEach((ea) => ea(Bi)), Bi) : e;
}
function $bdb11010cef70236$export$b4cc09c592e8fdb8(Bi = []) {
  let e = $bdb11010cef70236$export$f680877a34711e37(), [Zi, Qi] = $1dbecbe27a04f9af$export$14d238f342723f25(e), ea = useCallback(() => {
    Qi(function* () {
      yield e, yield document.getElementById(e) ? e : void 0;
    });
  }, [
    e,
    Qi
  ]);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(ea, [
    e,
    ea,
    ...Bi
  ]), Zi;
}
function $ff5963eb1fccf552$export$e08e3b67e392101e(...Bi) {
  return (...e) => {
    for (let Zi of Bi) typeof Zi == "function" && Zi(...e);
  };
}
const $431fbd86ca7dc216$export$b204af158042fbac = (Bi) => {
  var e;
  return (e = Bi?.ownerDocument) !== null && e !== void 0 ? e : document;
}, $431fbd86ca7dc216$export$f21a1ffae260145a = (Bi) => Bi && "window" in Bi && Bi.window === Bi ? Bi : $431fbd86ca7dc216$export$b204af158042fbac(Bi).defaultView || window;
function $3ef42575df84b30b$export$9d1611c77c2fe928(...Bi) {
  let e = {
    ...Bi[0]
  };
  for (let Zi = 1; Zi < Bi.length; Zi++) {
    let Qi = Bi[Zi];
    for (let ea in Qi) {
      let ra = e[ea], na = Qi[ea];
      typeof ra == "function" && typeof na == "function" && // This is a lot faster than a regex.
      ea[0] === "o" && ea[1] === "n" && ea.charCodeAt(2) >= /* 'A' */
      65 && ea.charCodeAt(2) <= /* 'Z' */
      90 ? e[ea] = $ff5963eb1fccf552$export$e08e3b67e392101e(ra, na) : (ea === "className" || ea === "UNSAFE_className") && typeof ra == "string" && typeof na == "string" ? e[ea] = clsx(ra, na) : ea === "id" && ra && na ? e.id = $bdb11010cef70236$export$cd8c9cb68f842629(ra, na) : e[ea] = na !== void 0 ? na : ra;
    }
  }
  return e;
}
function $5dc95899b306f630$export$c9058316764c140e(...Bi) {
  return Bi.length === 1 && Bi[0] ? Bi[0] : (e) => {
    for (let Zi of Bi)
      typeof Zi == "function" ? Zi(e) : Zi != null && (Zi.current = e);
  };
}
const $65484d02dcb7eb3e$var$DOMPropNames = /* @__PURE__ */ new Set([
  "id"
]), $65484d02dcb7eb3e$var$labelablePropNames = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), $65484d02dcb7eb3e$var$linkPropNames = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, e = {}) {
  let { labelable: Zi, isLink: Qi, propNames: ea } = e, ra = {};
  for (const na in Bi) Object.prototype.hasOwnProperty.call(Bi, na) && ($65484d02dcb7eb3e$var$DOMPropNames.has(na) || Zi && $65484d02dcb7eb3e$var$labelablePropNames.has(na) || Qi && $65484d02dcb7eb3e$var$linkPropNames.has(na) || ea?.has(na) || $65484d02dcb7eb3e$var$propRe.test(na)) && (ra[na] = Bi[na]);
  return ra;
}
function $7215afc6de606d6b$export$de79e2c695e052f3(Bi) {
  if ($7215afc6de606d6b$var$supportsPreventScroll()) Bi.focus({
    preventScroll: !0
  });
  else {
    let e = $7215afc6de606d6b$var$getScrollableElements(Bi);
    Bi.focus(), $7215afc6de606d6b$var$restoreScrollPosition(e);
  }
}
let $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return $7215afc6de606d6b$var$supportsPreventScrollCached = !0, !0;
        }
      });
    } catch {
    }
  }
  return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(Bi) {
  let e = Bi.parentNode, Zi = [], Qi = document.scrollingElement || document.documentElement;
  for (; e instanceof HTMLElement && e !== Qi; )
    (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) && Zi.push({
      element: e,
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft
    }), e = e.parentNode;
  return Qi instanceof HTMLElement && Zi.push({
    element: Qi,
    scrollTop: Qi.scrollTop,
    scrollLeft: Qi.scrollLeft
  }), Zi;
}
function $7215afc6de606d6b$var$restoreScrollPosition(Bi) {
  for (let { element: e, scrollTop: Zi, scrollLeft: Qi } of Bi)
    e.scrollTop = Zi, e.scrollLeft = Qi;
}
function $c87311424ea30a05$var$testUserAgent(Bi) {
  var e;
  return typeof window > "u" || window.navigator == null ? !1 : ((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.brands.some((Zi) => Bi.test(Zi.brand))) || Bi.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(Bi) {
  var e;
  return typeof window < "u" && window.navigator != null ? Bi.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function $c87311424ea30a05$var$cached(Bi) {
  let e = null;
  return () => (e == null && (e = Bi()), e);
}
const $c87311424ea30a05$export$9ac100e40613ea10 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}), $c87311424ea30a05$export$186c6964ca17d99 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}), $c87311424ea30a05$export$7bef049ce92e4224 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}), $c87311424ea30a05$export$fedb369cb70207f1 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}), $c87311424ea30a05$export$e1865c3bedcd822b = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$9ac100e40613ea10() || $c87311424ea30a05$export$fedb369cb70207f1();
}), $c87311424ea30a05$export$78551043582a6a98 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
}), $c87311424ea30a05$export$6446a186d09e379e = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
}), $c87311424ea30a05$export$a11b0059900ceec8 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Android/i);
}), $c87311424ea30a05$export$b7d78993b74f766d = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Firefox/i);
}), $ea8dcbcb9ea1b556$var$RouterContext = /* @__PURE__ */ createContext({
  isNative: !0,
  open: $ea8dcbcb9ea1b556$var$openSyntheticLink,
  useHref: (Bi) => Bi
});
function $ea8dcbcb9ea1b556$export$9a302a45f65d0572() {
  return useContext($ea8dcbcb9ea1b556$var$RouterContext);
}
function $ea8dcbcb9ea1b556$export$95185d699e05d4d7(Bi, e, Zi = !0) {
  var Qi, ea;
  let { metaKey: ra, ctrlKey: na, altKey: ia, shiftKey: fa } = e;
  $c87311424ea30a05$export$b7d78993b74f766d() && (!((ea = window.event) === null || ea === void 0 || (Qi = ea.type) === null || Qi === void 0) && Qi.startsWith("key")) && Bi.target === "_blank" && ($c87311424ea30a05$export$9ac100e40613ea10() ? ra = !0 : na = !0);
  let La = $c87311424ea30a05$export$78551043582a6a98() && $c87311424ea30a05$export$9ac100e40613ea10() && !$c87311424ea30a05$export$7bef049ce92e4224() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: ra,
    ctrlKey: na,
    altKey: ia,
    shiftKey: fa
  }) : new MouseEvent("click", {
    metaKey: ra,
    ctrlKey: na,
    altKey: ia,
    shiftKey: fa,
    bubbles: !0,
    cancelable: !0
  });
  $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = Zi, $7215afc6de606d6b$export$de79e2c695e052f3(Bi), Bi.dispatchEvent(La), $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = !1;
}
$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = !1;
function $ea8dcbcb9ea1b556$var$getSyntheticLink(Bi, e) {
  if (Bi instanceof HTMLAnchorElement) e(Bi);
  else if (Bi.hasAttribute("data-href")) {
    let Zi = document.createElement("a");
    Zi.href = Bi.getAttribute("data-href"), Bi.hasAttribute("data-target") && (Zi.target = Bi.getAttribute("data-target")), Bi.hasAttribute("data-rel") && (Zi.rel = Bi.getAttribute("data-rel")), Bi.hasAttribute("data-download") && (Zi.download = Bi.getAttribute("data-download")), Bi.hasAttribute("data-ping") && (Zi.ping = Bi.getAttribute("data-ping")), Bi.hasAttribute("data-referrer-policy") && (Zi.referrerPolicy = Bi.getAttribute("data-referrer-policy")), Bi.appendChild(Zi), e(Zi), Bi.removeChild(Zi);
  }
}
function $ea8dcbcb9ea1b556$var$openSyntheticLink(Bi, e) {
  $ea8dcbcb9ea1b556$var$getSyntheticLink(Bi, (Zi) => $ea8dcbcb9ea1b556$export$95185d699e05d4d7(Zi, e));
}
function $ea8dcbcb9ea1b556$export$7e924b3091a3bd18(Bi) {
  let e = $ea8dcbcb9ea1b556$export$9a302a45f65d0572();
  var Zi;
  const Qi = e.useHref((Zi = Bi?.href) !== null && Zi !== void 0 ? Zi : "");
  return {
    href: Bi?.href ? Qi : void 0,
    target: Bi?.target,
    rel: Bi?.rel,
    download: Bi?.download,
    ping: Bi?.ping,
    referrerPolicy: Bi?.referrerPolicy
  };
}
let $bbed8b41f857bcc0$var$transitionsByElement = /* @__PURE__ */ new Map(), $bbed8b41f857bcc0$var$transitionCallbacks = /* @__PURE__ */ new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
  if (typeof window > "u") return;
  function Bi(Qi) {
    return "propertyName" in Qi;
  }
  let e = (Qi) => {
    if (!Bi(Qi) || !Qi.target) return;
    let ea = $bbed8b41f857bcc0$var$transitionsByElement.get(Qi.target);
    ea || (ea = /* @__PURE__ */ new Set(), $bbed8b41f857bcc0$var$transitionsByElement.set(Qi.target, ea), Qi.target.addEventListener("transitioncancel", Zi, {
      once: !0
    })), ea.add(Qi.propertyName);
  }, Zi = (Qi) => {
    if (!Bi(Qi) || !Qi.target) return;
    let ea = $bbed8b41f857bcc0$var$transitionsByElement.get(Qi.target);
    if (ea && (ea.delete(Qi.propertyName), ea.size === 0 && (Qi.target.removeEventListener("transitioncancel", Zi), $bbed8b41f857bcc0$var$transitionsByElement.delete(Qi.target)), $bbed8b41f857bcc0$var$transitionsByElement.size === 0)) {
      for (let ra of $bbed8b41f857bcc0$var$transitionCallbacks) ra();
      $bbed8b41f857bcc0$var$transitionCallbacks.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", Zi);
}
typeof document < "u" && (document.readyState !== "loading" ? $bbed8b41f857bcc0$var$setupGlobalEvents() : document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents));
function $bbed8b41f857bcc0$export$24490316f764c430(Bi) {
  requestAnimationFrame(() => {
    $bbed8b41f857bcc0$var$transitionsByElement.size === 0 ? Bi() : $bbed8b41f857bcc0$var$transitionCallbacks.add(Bi);
  });
}
function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
  let Bi = useRef(/* @__PURE__ */ new Map()), e = useCallback((ea, ra, na, ia) => {
    let fa = ia?.once ? (...La) => {
      Bi.current.delete(na), na(...La);
    } : na;
    Bi.current.set(na, {
      type: ra,
      eventTarget: ea,
      fn: fa,
      options: ia
    }), ea.addEventListener(ra, fa, ia);
  }, []), Zi = useCallback((ea, ra, na, ia) => {
    var fa;
    let La = ((fa = Bi.current.get(na)) === null || fa === void 0 ? void 0 : fa.fn) || na;
    ea.removeEventListener(ra, La, ia), Bi.current.delete(na);
  }, []), Qi = useCallback(() => {
    Bi.current.forEach((ea, ra) => {
      Zi(ea.eventTarget, ea.type, ra, ea.options);
    });
  }, [
    Zi
  ]);
  return useEffect(() => Qi, [
    Qi
  ]), {
    addGlobalListener: e,
    removeGlobalListener: Zi,
    removeAllGlobalListeners: Qi
  };
}
function $313b98861ee5dd6c$export$d6875122194c7b44(Bi, e) {
  let { id: Zi, "aria-label": Qi, "aria-labelledby": ea } = Bi;
  return Zi = $bdb11010cef70236$export$f680877a34711e37(Zi), ea && Qi ? ea = [
    .../* @__PURE__ */ new Set([
      Zi,
      ...ea.trim().split(/\s+/)
    ])
  ].join(" ") : ea && (ea = ea.trim().split(/\s+/).join(" ")), !Qi && !ea && e && (Qi = e), {
    id: Zi,
    "aria-label": Qi,
    "aria-labelledby": ea
  };
}
function $df56164dff5785e2$export$4338b53315abf666(Bi) {
  const e = useRef(null);
  return useMemo(() => ({
    get current() {
      return e.current;
    },
    set current(Zi) {
      e.current = Zi, typeof Bi == "function" ? Bi(Zi) : Bi && (Bi.current = Zi);
    }
  }), [
    Bi
  ]);
}
function $ca9b37712f007381$export$72ef708ab07251f1(Bi, e) {
  const Zi = useRef(!0), Qi = useRef(null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => (Zi.current = !0, () => {
    Zi.current = !1;
  }), []), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    Zi.current ? Zi.current = !1 : (!Qi.current || e.some((ea, ra) => !Object.is(ea, Qi[ra]))) && Bi(), Qi.current = e;
  }, e);
}
function $9daab02d461809db$var$hasResizeObserver() {
  return typeof window.ResizeObserver < "u";
}
function $9daab02d461809db$export$683480f191c0e3ea(Bi) {
  const { ref: e, box: Zi, onResize: Qi } = Bi;
  useEffect(() => {
    let ea = e?.current;
    if (ea)
      if ($9daab02d461809db$var$hasResizeObserver()) {
        const ra = new window.ResizeObserver((na) => {
          na.length && Qi();
        });
        return ra.observe(ea, {
          box: Zi
        }), () => {
          ea && ra.unobserve(ea);
        };
      } else
        return window.addEventListener("resize", Qi, !1), () => {
          window.removeEventListener("resize", Qi, !1);
        };
  }, [
    Qi,
    e,
    Zi
  ]);
}
function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(Bi, e) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (Bi && Bi.ref && e)
      return Bi.ref.current = e.current, () => {
        Bi.ref && (Bi.ref.current = null);
      };
  });
}
function $cc38e7bd3fc7b213$export$2bb74740c4e19def(Bi, e) {
  if (!Bi) return !1;
  let Zi = window.getComputedStyle(Bi), Qi = /(auto|scroll)/.test(Zi.overflow + Zi.overflowX + Zi.overflowY);
  return Qi && e && (Qi = Bi.scrollHeight !== Bi.clientHeight || Bi.scrollWidth !== Bi.clientWidth), Qi;
}
function $62d8ded9296f3872$export$cfa2225e87938781(Bi, e) {
  let Zi = Bi;
  for ($cc38e7bd3fc7b213$export$2bb74740c4e19def(Zi, e) && (Zi = Zi.parentElement); Zi && !$cc38e7bd3fc7b213$export$2bb74740c4e19def(Zi, e); ) Zi = Zi.parentElement;
  return Zi || document.scrollingElement || document.documentElement;
}
function $a40c673dc9f6d9c7$export$94ed1c92c7beeb22(Bi, e) {
  const Zi = [];
  for (; Bi && Bi !== document.documentElement; )
    $cc38e7bd3fc7b213$export$2bb74740c4e19def(Bi, e) && Zi.push(Bi), Bi = Bi.parentElement;
  return Zi;
}
let $ef06256079686ba0$var$descriptionId = 0;
const $ef06256079686ba0$var$descriptionNodes = /* @__PURE__ */ new Map();
function $ef06256079686ba0$export$f8aeda7b10753fa1(Bi) {
  let [e, Zi] = useState();
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (!Bi) return;
    let Qi = $ef06256079686ba0$var$descriptionNodes.get(Bi);
    if (Qi)
      Zi(Qi.element.id);
    else {
      let ea = `react-aria-description-${$ef06256079686ba0$var$descriptionId++}`;
      Zi(ea);
      let ra = document.createElement("div");
      ra.id = ea, ra.style.display = "none", ra.textContent = Bi, document.body.appendChild(ra), Qi = {
        refCount: 0,
        element: ra
      }, $ef06256079686ba0$var$descriptionNodes.set(Bi, Qi);
    }
    return Qi.refCount++, () => {
      Qi && --Qi.refCount === 0 && (Qi.element.remove(), $ef06256079686ba0$var$descriptionNodes.delete(Bi));
    };
  }, [
    Bi
  ]), {
    "aria-describedby": Bi ? e : void 0
  };
}
function $e9faafb641e167db$export$90fc3a17d93f704c(Bi, e, Zi, Qi) {
  let ea = $8ae05eaa5c114e9c$export$7f54fc3180508a52(Zi), ra = Zi == null;
  useEffect(() => {
    if (ra || !Bi.current) return;
    let na = Bi.current;
    return na.addEventListener(e, ea, Qi), () => {
      na.removeEventListener(e, ea, Qi);
    };
  }, [
    Bi,
    e,
    Qi,
    ra,
    ea
  ]);
}
function $2f04cbc44ee30ce0$export$53a0910f038337bd(Bi, e) {
  let Zi = $2f04cbc44ee30ce0$var$relativeOffset(Bi, e, "left"), Qi = $2f04cbc44ee30ce0$var$relativeOffset(Bi, e, "top"), ea = e.offsetWidth, ra = e.offsetHeight, na = Bi.scrollLeft, ia = Bi.scrollTop, { borderTopWidth: fa, borderLeftWidth: La, scrollPaddingTop: Va, scrollPaddingRight: to, scrollPaddingBottom: ro, scrollPaddingLeft: no } = getComputedStyle(Bi), eo = na + parseInt(La, 10), ao = ia + parseInt(fa, 10), io = eo + Bi.clientWidth, xs = ao + Bi.clientHeight, Ts = parseInt(Va, 10) || 0, qs = parseInt(ro, 10) || 0, Fs = parseInt(to, 10) || 0, Do = parseInt(no, 10) || 0;
  Zi <= na + Do ? na = Zi - parseInt(La, 10) - Do : Zi + ea > io - Fs && (na += Zi + ea - io + Fs), Qi <= ao + Ts ? ia = Qi - parseInt(fa, 10) - Ts : Qi + ra > xs - qs && (ia += Qi + ra - xs + qs), Bi.scrollLeft = na, Bi.scrollTop = ia;
}
function $2f04cbc44ee30ce0$var$relativeOffset(Bi, e, Zi) {
  const Qi = Zi === "left" ? "offsetLeft" : "offsetTop";
  let ea = 0;
  for (; e.offsetParent && (ea += e[Qi], e.offsetParent !== Bi); ) {
    if (e.offsetParent.contains(Bi)) {
      ea -= Bi[Qi];
      break;
    }
    e = e.offsetParent;
  }
  return ea;
}
function $2f04cbc44ee30ce0$export$c826860796309d1b(Bi, e) {
  if (Bi && document.contains(Bi)) {
    let na = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(na).overflow === "hidden") {
      let fa = $a40c673dc9f6d9c7$export$94ed1c92c7beeb22(Bi);
      for (let La of fa) $2f04cbc44ee30ce0$export$53a0910f038337bd(La, Bi);
    } else {
      var Zi;
      let { left: fa, top: La } = Bi.getBoundingClientRect();
      Bi == null || (Zi = Bi.scrollIntoView) === null || Zi === void 0 || Zi.call(Bi, {
        block: "nearest"
      });
      let { left: Va, top: to } = Bi.getBoundingClientRect();
      if (Math.abs(fa - Va) > 1 || Math.abs(La - to) > 1) {
        var Qi, ea, ra;
        e == null || (ea = e.containingElement) === null || ea === void 0 || (Qi = ea.scrollIntoView) === null || Qi === void 0 || Qi.call(ea, {
          block: "center",
          inline: "center"
        }), (ra = Bi.scrollIntoView) === null || ra === void 0 || ra.call(Bi, {
          block: "nearest"
        });
      }
    }
  }
}
function $6a7db85432448f7f$export$60278871457622de(Bi) {
  return Bi.mozInputSource === 0 && Bi.isTrusted ? !0 : $c87311424ea30a05$export$a11b0059900ceec8() && Bi.pointerType ? Bi.type === "click" && Bi.buttons === 1 : Bi.detail === 0 && !Bi.pointerType;
}
function $6a7db85432448f7f$export$29bf1b5f2c56cf63(Bi) {
  return !$c87311424ea30a05$export$a11b0059900ceec8() && Bi.width === 0 && Bi.height === 0 || Bi.width === 1 && Bi.height === 1 && Bi.pressure === 0 && Bi.detail === 0 && Bi.pointerType === "mouse";
}
function $99facab73266f662$export$5add1d006293d136(Bi, e, Zi) {
  let Qi = useRef(e), ea = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    Zi && Zi(Qi.current);
  });
  useEffect(() => {
    var ra;
    let na = Bi == null || (ra = Bi.current) === null || ra === void 0 ? void 0 : ra.form;
    return na?.addEventListener("reset", ea), () => {
      na?.removeEventListener("reset", ea);
    };
  }, [
    Bi,
    ea
  ]);
}
const $5671b20cf9b562b2$export$447a38995de2c711 = "react-aria-clear-focus", $5671b20cf9b562b2$export$831c820ad60f9d12 = "react-aria-focus", $5671b20cf9b562b2$export$9db568f6321ad9dc = "react-aria-update-activedescendant";
function $21f1aa98acb08317$export$16792effe837dba3(Bi) {
  return $c87311424ea30a05$export$9ac100e40613ea10() ? Bi.metaKey : Bi.ctrlKey;
}
function $d3f049242431219c$export$6d3443f2c48bfc20(Bi, e = !0) {
  let [Zi, Qi] = useState(!0), ea = Zi && e;
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (ea && Bi.current && "getAnimations" in Bi.current)
      for (let ra of Bi.current.getAnimations()) ra instanceof CSSTransition && ra.cancel();
  }, [
    Bi,
    ea
  ]), $d3f049242431219c$var$useAnimation(Bi, ea, useCallback(() => Qi(!1), [])), ea;
}
function $d3f049242431219c$export$45fda7c47f93fd48(Bi, e) {
  let [Zi, Qi] = useState(e ? "open" : "closed");
  switch (Zi) {
    case "open":
      e || Qi("exiting");
      break;
    case "closed":
    case "exiting":
      e && Qi("open");
      break;
  }
  let ea = Zi === "exiting";
  return $d3f049242431219c$var$useAnimation(Bi, ea, useCallback(() => {
    Qi((ra) => ra === "exiting" ? "closed" : ra);
  }, [])), ea;
}
function $d3f049242431219c$var$useAnimation(Bi, e, Zi) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (e && Bi.current) {
      if (!("getAnimations" in Bi.current)) {
        Zi();
        return;
      }
      let Qi = Bi.current.getAnimations();
      if (Qi.length === 0) {
        Zi();
        return;
      }
      let ea = !1;
      return Promise.all(Qi.map((ra) => ra.finished)).then(() => {
        ea || flushSync$1(() => {
          Zi();
        });
      }).catch(() => {
      }), () => {
        ea = !0;
      };
    }
  }, [
    Bi,
    e,
    Zi
  ]);
}
function $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi, e, Zi) {
  let [Qi, ea] = useState(Bi || e), ra = useRef(Bi !== void 0), na = Bi !== void 0;
  useEffect(() => {
    let La = ra.current;
    La !== na && console.warn(`WARN: A component changed from ${La ? "controlled" : "uncontrolled"} to ${na ? "controlled" : "uncontrolled"}.`), ra.current = na;
  }, [
    na
  ]);
  let ia = na ? Bi : Qi, fa = useCallback((La, ...Va) => {
    let to = (ro, ...no) => {
      Zi && (Object.is(ia, ro) || Zi(ro, ...no)), na || (ia = ro);
    };
    typeof La == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), ea((no, ...eo) => {
      let ao = La(na ? ia : no, ...eo);
      return to(ao, ...Va), na ? no : ao;
    })) : (na || ea(La), to(La, ...Va));
  }, [
    na,
    ia,
    Zi
  ]);
  return [
    ia,
    fa
  ];
}
function $9446cca9a3875146$export$7d15b64cf5a3a4c4(Bi, e = -1 / 0, Zi = 1 / 0) {
  return Math.min(Math.max(Bi, e), Zi);
}
const $64fa3d84918910a7$export$c62b8e45d58ddad9 = Symbol("default");
function $64fa3d84918910a7$export$2881499e37b75b9a({ values: Bi, children: e }) {
  for (let [Zi, Qi] of Bi)
    e = /* @__PURE__ */ a__default.createElement(Zi.Provider, {
      value: Qi
    }, e);
  return e;
}
function $64fa3d84918910a7$export$4d86445c2cf5e3(Bi) {
  let { className: e, style: Zi, children: Qi, defaultClassName: ea, defaultChildren: ra, defaultStyle: na, values: ia } = Bi;
  return useMemo(() => {
    let fa, La, Va;
    return typeof e == "function" ? fa = e({
      ...ia,
      defaultClassName: ea
    }) : fa = e, typeof Zi == "function" ? La = Zi({
      ...ia,
      defaultStyle: na || {}
    }) : La = Zi, typeof Qi == "function" ? Va = Qi({
      ...ia,
      defaultChildren: ra
    }) : Qi == null ? Va = ra : Va = Qi, {
      className: fa ?? ea,
      style: La || na ? {
        ...na,
        ...La
      } : void 0,
      children: Va ?? ra,
      "data-rac": ""
    };
  }, [
    e,
    Zi,
    Qi,
    ea,
    ra,
    na,
    ia
  ]);
}
function $64fa3d84918910a7$export$fabf2dc03a41866e(Bi, e) {
  let Zi = useContext(Bi);
  if (e === null)
    return null;
  if (Zi && typeof Zi == "object" && "slots" in Zi && Zi.slots) {
    let Qi = new Intl.ListFormat().format(Object.keys(Zi.slots).map((ra) => `"${ra}"`));
    if (!e && !Zi.slots[$64fa3d84918910a7$export$c62b8e45d58ddad9]) throw new Error(`A slot prop is required. Valid slot names are ${Qi}.`);
    let ea = e || $64fa3d84918910a7$export$c62b8e45d58ddad9;
    if (!Zi.slots[ea])
      throw new Error(`Invalid slot "${e}". Valid slot names are ${Qi}.`);
    return Zi.slots[ea];
  }
  return Zi;
}
function $64fa3d84918910a7$export$29f1550f4b0d4415(Bi, e, Zi) {
  let Qi = $64fa3d84918910a7$export$fabf2dc03a41866e(Zi, Bi.slot) || {}, { ref: ea, ...ra } = Qi, na = $df56164dff5785e2$export$4338b53315abf666(useMemo(() => $5dc95899b306f630$export$c9058316764c140e(e, ea), [
    e,
    ea
  ])), ia = $3ef42575df84b30b$export$9d1611c77c2fe928(ra, Bi);
  return "style" in ra && ra.style && "style" in Bi && Bi.style && (typeof ra.style == "function" || typeof Bi.style == "function" ? ia.style = (fa) => {
    let La = typeof ra.style == "function" ? ra.style(fa) : ra.style, Va = {
      ...fa.defaultStyle,
      ...La
    }, to = typeof Bi.style == "function" ? Bi.style({
      ...fa,
      defaultStyle: Va
    }) : Bi.style;
    return {
      ...Va,
      ...to
    };
  } : ia.style = {
    ...ra.style,
    ...Bi.style
  }), [
    ia,
    na
  ];
}
function $64fa3d84918910a7$export$9d4c57ee4c6ffdd8() {
  let [Bi, e] = useState(!0), Zi = useRef(!1), Qi = useCallback((ea) => {
    Zi.current = !0, e(!!ea);
  }, []);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    Zi.current || e(!1);
  }, []), [
    Qi,
    Bi
  ];
}
function $64fa3d84918910a7$export$ef03459518577ad4(Bi) {
  const e = /^(data-.*)$/;
  let Zi = {};
  for (const Qi in Bi) e.test(Qi) || (Zi[Qi] = Bi[Qi]);
  return Zi;
}
class $23b9f4fcf0fe224b$export$d68d59712b04d9d1 {
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let e = new $23b9f4fcf0fe224b$export$d68d59712b04d9d1(this.type, this.key);
    return e.value = this.value, e.level = this.level, e.hasChildNodes = this.hasChildNodes, e.rendered = this.rendered, e.textValue = this.textValue, e["aria-label"] = this["aria-label"], e.index = this.index, e.parentKey = this.parentKey, e.prevKey = this.prevKey, e.nextKey = this.nextKey, e.firstChildKey = this.firstChildKey, e.lastChildKey = this.lastChildKey, e.props = this.props, e.render = this.render, e;
  }
  constructor(e, Zi) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.type = e, this.key = Zi;
  }
}
class $23b9f4fcf0fe224b$export$408d25a4e12db025 {
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let e = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; e; )
      yield e, e = e.nextKey != null ? this.keyMap.get(e.nextKey) : void 0;
  }
  getChildren(e) {
    let Zi = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let Qi = Zi.get(e), ea = Qi?.firstChildKey != null ? Zi.get(Qi.firstChildKey) : null;
        for (; ea; )
          yield ea, ea = ea.nextKey != null ? Zi.get(ea.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(e) {
    let Zi = this.keyMap.get(e);
    if (!Zi) return null;
    if (Zi.prevKey != null) {
      for (Zi = this.keyMap.get(Zi.prevKey); Zi && Zi.type !== "item" && Zi.lastChildKey != null; ) Zi = this.keyMap.get(Zi.lastChildKey);
      var Qi;
      return (Qi = Zi?.key) !== null && Qi !== void 0 ? Qi : null;
    }
    return Zi.parentKey;
  }
  getKeyAfter(e) {
    let Zi = this.keyMap.get(e);
    if (!Zi) return null;
    if (Zi.type !== "item" && Zi.firstChildKey != null) return Zi.firstChildKey;
    for (; Zi; ) {
      if (Zi.nextKey != null) return Zi.nextKey;
      if (Zi.parentKey != null) Zi = this.keyMap.get(Zi.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let e = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; e?.lastChildKey != null; ) e = this.keyMap.get(e.lastChildKey);
    var Zi;
    return (Zi = e?.key) !== null && Zi !== void 0 ? Zi : null;
  }
  getItem(e) {
    var Zi;
    return (Zi = this.keyMap.get(e)) !== null && Zi !== void 0 ? Zi : null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let e = this.constructor, Zi = new e();
    return Zi.keyMap = new Map(this.keyMap), Zi.firstKey = this.firstKey, Zi.lastKey = this.lastKey, Zi;
  }
  addNode(e) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    this.keyMap.set(e.key, e);
  }
  removeNode(e) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    this.keyMap.delete(e);
  }
  commit(e, Zi, Qi = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = e, this.lastKey = Zi, this.frozen = !Qi;
  }
  // TODO: this is pretty specific to menu, will need to check if it is generic enough
  // Will need to handle varying levels I assume but will revisit after I get searchable menu working for base menu
  // TODO: an alternative is to simply walk the collection and add all item nodes that match the filter and any sections/separators we encounter
  // to an array, then walk that new array and fix all the next/Prev keys while adding them to the new collection
  filter(e) {
    let Zi = new $23b9f4fcf0fe224b$export$408d25a4e12db025(), Qi = null;
    for (let ea of this)
      if (ea.type === "section" && ea.hasChildNodes) {
        let ra = ea.clone(), na = null;
        for (let ia of this.getChildren(ea.key)) if (e(ia.textValue) || ia.type === "header") {
          let fa = ia.clone();
          na == null && (ra.firstChildKey = fa.key), Zi.firstKey == null && (Zi.firstKey = ra.key), na && na.parentKey === fa.parentKey ? (na.nextKey = fa.key, fa.prevKey = na.key) : fa.prevKey = null, fa.nextKey = null, Zi.addNode(fa), na = fa;
        }
        na && (na.type !== "header" ? (ra.lastChildKey = na.key, Qi == null ? ra.prevKey = null : (Qi.type === "section" || Qi.type === "separator") && (Qi.nextKey = ra.key, ra.prevKey = Qi.key), ra.nextKey = null, Qi = ra, Zi.addNode(ra)) : (Zi.firstKey === ra.key && (Zi.firstKey = null), Zi.removeNode(na.key)));
      } else if (ea.type === "separator") {
        let ra = ea.clone();
        ra.nextKey = null, Qi?.type === "section" && (Qi.nextKey = ra.key, ra.prevKey = Qi.key, Qi = ra, Zi.addNode(ra));
      } else if (e(ea.textValue)) {
        let ra = ea.clone();
        Zi.firstKey == null && (Zi.firstKey = ra.key), Qi != null && Qi.type !== "section" && Qi.type !== "separator" && Qi.parentKey === ra.parentKey ? (Qi.nextKey = ra.key, ra.prevKey = Qi.key) : ra.prevKey = null, ra.nextKey = null, Zi.addNode(ra), Qi = ra;
      }
    if (Qi?.type === "separator" && Qi.nextKey === null) {
      let ea;
      Qi.prevKey != null && (ea = Zi.getItem(Qi.prevKey), ea.nextKey = null), Zi.removeNode(Qi.key), Qi = ea;
    }
    return Zi.lastKey = Qi?.key || null, Zi;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1;
  }
}
class $681cc3c98f569e39$export$410b0c854570d131 {
  *[Symbol.iterator]() {
    let e = this.firstChild;
    for (; e; )
      yield e, e = e.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(e) {
    this._firstChild = e, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(e) {
    this._lastChild = e, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(e) {
    this._previousSibling = e, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(e) {
    this._nextSibling = e, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(e) {
    this._parentNode = e, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    var e;
    return ((e = this.parentNode) === null || e === void 0 ? void 0 : e.isConnected) || !1;
  }
  appendChild(e) {
    this.ownerDocument.startTransaction(), e.parentNode && e.parentNode.removeChild(e), this.firstChild == null && (this.firstChild = e), this.lastChild ? (this.lastChild.nextSibling = e, e.index = this.lastChild.index + 1, e.previousSibling = this.lastChild) : (e.previousSibling = null, e.index = 0), e.parentNode = this, e.nextSibling = null, this.lastChild = e, this.ownerDocument.markDirty(this), e.hasSetProps && this.ownerDocument.addNode(e), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  insertBefore(e, Zi) {
    if (Zi == null) return this.appendChild(e);
    this.ownerDocument.startTransaction(), e.parentNode && e.parentNode.removeChild(e), e.nextSibling = Zi, e.previousSibling = Zi.previousSibling, e.index = Zi.index, this.firstChild === Zi ? this.firstChild = e : Zi.previousSibling && (Zi.previousSibling.nextSibling = e), Zi.previousSibling = e, e.parentNode = Zi.parentNode;
    let Qi = Zi;
    for (; Qi; )
      Qi.index++, Qi = Qi.nextSibling;
    e.hasSetProps && this.ownerDocument.addNode(e), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  removeChild(e) {
    if (e.parentNode !== this || !this.ownerDocument.isMounted) return;
    this.ownerDocument.startTransaction();
    let Zi = e.nextSibling;
    for (; Zi; )
      Zi.index--, Zi = Zi.nextSibling;
    e.nextSibling && (e.nextSibling.previousSibling = e.previousSibling), e.previousSibling && (e.previousSibling.nextSibling = e.nextSibling), this.firstChild === e && (this.firstChild = e.nextSibling), this.lastChild === e && (this.lastChild = e.previousSibling), e.parentNode = null, e.nextSibling = null, e.previousSibling = null, e.index = 0, this.ownerDocument.removeNode(e), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  constructor(e) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this.ownerDocument = e;
  }
}
class $681cc3c98f569e39$export$dc064fe9e59310fd extends $681cc3c98f569e39$export$410b0c854570d131 {
  get index() {
    return this._index;
  }
  set index(e) {
    this._index = e, this.ownerDocument.markDirty(this);
  }
  get level() {
    return this.parentNode instanceof $681cc3c98f569e39$export$dc064fe9e59310fd ? this.parentNode.level + (this.node.type === "item" ? 1 : 0) : 0;
  }
  updateNode() {
    var e, Zi, Qi, ea;
    let ra = this.ownerDocument.getMutableNode(this);
    ra.index = this.index, ra.level = this.level, ra.parentKey = this.parentNode instanceof $681cc3c98f569e39$export$dc064fe9e59310fd ? this.parentNode.node.key : null;
    var na;
    ra.prevKey = (na = (e = this.previousSibling) === null || e === void 0 ? void 0 : e.node.key) !== null && na !== void 0 ? na : null;
    var ia;
    ra.nextKey = (ia = (Zi = this.nextSibling) === null || Zi === void 0 ? void 0 : Zi.node.key) !== null && ia !== void 0 ? ia : null, ra.hasChildNodes = !!this.firstChild;
    var fa;
    ra.firstChildKey = (fa = (Qi = this.firstChild) === null || Qi === void 0 ? void 0 : Qi.node.key) !== null && fa !== void 0 ? fa : null;
    var La;
    ra.lastChildKey = (La = (ea = this.lastChild) === null || ea === void 0 ? void 0 : ea.node.key) !== null && La !== void 0 ? La : null;
  }
  setProps(e, Zi, Qi, ea) {
    let ra = this.ownerDocument.getMutableNode(this), { value: na, textValue: ia, id: fa, ...La } = e;
    if (La.ref = Zi, ra.props = La, ra.rendered = Qi, ra.render = ea, ra.value = na, ra.textValue = ia || (typeof La.children == "string" ? La.children : "") || e["aria-label"] || "", fa != null && fa !== ra.key) {
      if (this.hasSetProps) throw new Error("Cannot change the id of an item");
      ra.key = fa;
    }
    this.hasSetProps || (this.ownerDocument.addNode(this), this.ownerDocument.endTransaction(), this.hasSetProps = !0), this.ownerDocument.queueUpdate();
  }
  get style() {
    return {};
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
  constructor(e, Zi) {
    super(Zi), this.nodeType = 8, this._index = 0, this.hasSetProps = !1, this.node = new $23b9f4fcf0fe224b$export$d68d59712b04d9d1(e, `react-aria-${++Zi.nodeId}`), this.ownerDocument.startTransaction();
  }
}
class $681cc3c98f569e39$export$b34a105447964f9f extends $681cc3c98f569e39$export$410b0c854570d131 {
  get isConnected() {
    return this.isMounted;
  }
  createElement(e) {
    return new $681cc3c98f569e39$export$dc064fe9e59310fd(e, this);
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode(e) {
    let Zi = e.node;
    return this.mutatedNodes.has(e) || (Zi = e.node.clone(), this.mutatedNodes.add(e), e.node = Zi), this.markDirty(e), Zi;
  }
  getMutableCollection() {
    return !this.isSSR && !this.collectionMutated && (this.collection = this.collection.clone(), this.collectionMutated = !0), this.collection;
  }
  markDirty(e) {
    this.dirtyNodes.add(e);
  }
  startTransaction() {
    this.transactionCount++;
  }
  endTransaction() {
    this.transactionCount--;
  }
  addNode(e) {
    let Zi = this.getMutableCollection();
    if (!Zi.getItem(e.node.key)) {
      Zi.addNode(e.node);
      for (let Qi of e) this.addNode(Qi);
    }
    this.markDirty(e);
  }
  removeNode(e) {
    for (let Qi of e) this.removeNode(Qi);
    this.getMutableCollection().removeNode(e.node.key), this.markDirty(e);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.transactionCount > 0 ? this.collection : (this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let ra of this.dirtyNodes) ra instanceof $681cc3c98f569e39$export$dc064fe9e59310fd && ra.isConnected && ra.updateNode();
    if (this.dirtyNodes.clear(), this.mutatedNodes.size || this.collectionMutated) {
      var e, Zi;
      let ra = this.getMutableCollection();
      for (let na of this.mutatedNodes) na.isConnected && ra.addNode(na.node);
      var Qi, ea;
      ra.commit((Qi = (e = this.firstChild) === null || e === void 0 ? void 0 : e.node.key) !== null && Qi !== void 0 ? Qi : null, (ea = (Zi = this.lastChild) === null || Zi === void 0 ? void 0 : Zi.node.key) !== null && ea !== void 0 ? ea : null, this.isSSR), this.mutatedNodes.clear();
    }
    this.collectionMutated = !1;
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.transactionCount > 0))
      for (let e of this.subscriptions) e();
  }
  subscribe(e) {
    return this.subscriptions.add(e), () => this.subscriptions.delete(e);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
  constructor(e) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.isMounted = !0, this.mutatedNodes = /* @__PURE__ */ new Set(), this.subscriptions = /* @__PURE__ */ new Set(), this.transactionCount = 0, this.collection = e, this.collectionMutated = !0;
  }
}
function $e948873055cbafe4$export$727c8fc270210f13(Bi) {
  let { children: e, items: Zi, idScope: Qi, addIdAndValue: ea, dependencies: ra = [] } = Bi, na = useMemo(() => /* @__PURE__ */ new WeakMap(), ra);
  return useMemo(() => {
    if (Zi && typeof e == "function") {
      let La = [];
      for (let Va of Zi) {
        let to = na.get(Va);
        if (!to) {
          to = e(Va);
          var ia, fa;
          let ro = (fa = (ia = to.props.id) !== null && ia !== void 0 ? ia : Va.key) !== null && fa !== void 0 ? fa : Va.id;
          if (ro == null) throw new Error("Could not determine key for item");
          Qi && (ro = Qi + ":" + ro), to = cloneElement(to, ea ? {
            key: ro,
            id: ro,
            value: Va
          } : {
            key: ro
          }), na.set(Va, to);
        }
        La.push(to);
      }
      return La;
    } else if (typeof e != "function") return e;
  }, [
    e,
    Zi,
    na,
    Qi,
    ea
  ]);
}
if (typeof HTMLTemplateElement < "u") {
  const Bi = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : Bi.call(this);
    }
  });
}
const $f39a9eba43920ace$export$94b6d0abf7d33e8c = /* @__PURE__ */ createContext(!1), $f39a9eba43920ace$var$hiddenFragment = typeof DocumentFragment < "u" ? new DocumentFragment() : null;
function $f39a9eba43920ace$export$8dc98ba7eadeaa56(Bi) {
  let e = useContext($f39a9eba43920ace$export$94b6d0abf7d33e8c), Zi = $b5e257d569688ac6$export$535bd6ca7f90a273();
  if (e)
    return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, Bi.children);
  let Qi = /* @__PURE__ */ a__default.createElement($f39a9eba43920ace$export$94b6d0abf7d33e8c.Provider, {
    value: !0
  }, Bi.children);
  return Zi ? /* @__PURE__ */ a__default.createElement("template", {
    "data-react-aria-hidden": !0
  }, Qi) : /* @__PURE__ */ createPortal(Qi, $f39a9eba43920ace$var$hiddenFragment);
}
function $f39a9eba43920ace$export$86427a43e3e48ebb(Bi) {
  let e = (Zi, Qi) => useContext($f39a9eba43920ace$export$94b6d0abf7d33e8c) ? null : Bi(Zi, Qi);
  return e.displayName = Bi.displayName || Bi.name, forwardRef(e);
}
function $f39a9eba43920ace$export$b5d7cc18bb8d2b59() {
  return useContext($f39a9eba43920ace$export$94b6d0abf7d33e8c);
}
var shim = { exports: {} }, useSyncExternalStoreShim_production = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production;
function requireUseSyncExternalStoreShim_production() {
  if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  hasRequiredUseSyncExternalStoreShim_production = 1;
  var Bi = a__default;
  function e(to, ro) {
    return to === ro && (to !== 0 || 1 / to === 1 / ro) || to !== to && ro !== ro;
  }
  var Zi = typeof Object.is == "function" ? Object.is : e, Qi = Bi.useState, ea = Bi.useEffect, ra = Bi.useLayoutEffect, na = Bi.useDebugValue;
  function ia(to, ro) {
    var no = ro(), eo = Qi({ inst: { value: no, getSnapshot: ro } }), ao = eo[0].inst, io = eo[1];
    return ra(
      function() {
        ao.value = no, ao.getSnapshot = ro, fa(ao) && io({ inst: ao });
      },
      [to, no, ro]
    ), ea(
      function() {
        return fa(ao) && io({ inst: ao }), to(function() {
          fa(ao) && io({ inst: ao });
        });
      },
      [to]
    ), na(no), no;
  }
  function fa(to) {
    var ro = to.getSnapshot;
    to = to.value;
    try {
      var no = ro();
      return !Zi(to, no);
    } catch {
      return !0;
    }
  }
  function La(to, ro) {
    return ro();
  }
  var Va = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? La : ia;
  return useSyncExternalStoreShim_production.useSyncExternalStore = Bi.useSyncExternalStore !== void 0 ? Bi.useSyncExternalStore : Va, useSyncExternalStoreShim_production;
}
var useSyncExternalStoreShim_development = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  return hasRequiredUseSyncExternalStoreShim_development || (hasRequiredUseSyncExternalStoreShim_development = 1, process.env.NODE_ENV !== "production" && function() {
    function Bi(no, eo) {
      return no === eo && (no !== 0 || 1 / no === 1 / eo) || no !== no && eo !== eo;
    }
    function e(no, eo) {
      Va || ea.startTransition === void 0 || (Va = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var ao = eo();
      if (!to) {
        var io = eo();
        ra(ao, io) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), to = !0);
      }
      io = na({
        inst: { value: ao, getSnapshot: eo }
      });
      var xs = io[0].inst, Ts = io[1];
      return fa(
        function() {
          xs.value = ao, xs.getSnapshot = eo, Zi(xs) && Ts({ inst: xs });
        },
        [no, ao, eo]
      ), ia(
        function() {
          return Zi(xs) && Ts({ inst: xs }), no(function() {
            Zi(xs) && Ts({ inst: xs });
          });
        },
        [no]
      ), La(ao), ao;
    }
    function Zi(no) {
      var eo = no.getSnapshot;
      no = no.value;
      try {
        var ao = eo();
        return !ra(no, ao);
      } catch {
        return !0;
      }
    }
    function Qi(no, eo) {
      return eo();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var ea = a__default, ra = typeof Object.is == "function" ? Object.is : Bi, na = ea.useState, ia = ea.useEffect, fa = ea.useLayoutEffect, La = ea.useDebugValue, Va = !1, to = !1, ro = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? Qi : e;
    useSyncExternalStoreShim_development.useSyncExternalStore = ea.useSyncExternalStore !== void 0 ? ea.useSyncExternalStore : ro, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  return hasRequiredShim || (hasRequiredShim = 1, process.env.NODE_ENV === "production" ? shim.exports = requireUseSyncExternalStoreShim_production() : shim.exports = requireUseSyncExternalStoreShim_development()), shim.exports;
}
var shimExports = requireShim();
const $e1995378a142960e$var$ShallowRenderContext = /* @__PURE__ */ createContext(!1), $e1995378a142960e$var$CollectionDocumentContext = /* @__PURE__ */ createContext(null);
function $e1995378a142960e$export$bf788dd355e3a401(Bi) {
  if (useContext($e1995378a142960e$var$CollectionDocumentContext))
    return Bi.content;
  let { collection: Zi, document: Qi } = $e1995378a142960e$var$useCollectionDocument(Bi.createCollection);
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement($f39a9eba43920ace$export$8dc98ba7eadeaa56, null, /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionDocumentContext.Provider, {
    value: Qi
  }, Bi.content)), /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionInner, {
    render: Bi.children,
    collection: Zi
  }));
}
function $e1995378a142960e$var$CollectionInner({ collection: Bi, render: e }) {
  return e(Bi);
}
function $e1995378a142960e$var$useSyncExternalStoreFallback(Bi, e, Zi) {
  let Qi = $b5e257d569688ac6$export$535bd6ca7f90a273(), ea = useRef(Qi);
  ea.current = Qi;
  let ra = useCallback(() => ea.current ? Zi() : e(), [
    e,
    Zi
  ]);
  return shimExports.useSyncExternalStore(Bi, ra);
}
const $e1995378a142960e$var$useSyncExternalStore = typeof a__default.useSyncExternalStore == "function" ? a__default.useSyncExternalStore : $e1995378a142960e$var$useSyncExternalStoreFallback;
function $e1995378a142960e$var$useCollectionDocument(Bi) {
  let [e] = useState(() => new $681cc3c98f569e39$export$b34a105447964f9f(Bi?.() || new $23b9f4fcf0fe224b$export$408d25a4e12db025())), Zi = useCallback((na) => e.subscribe(na), [
    e
  ]), Qi = useCallback(() => {
    let na = e.getCollection();
    return e.isSSR && e.resetAfterSSR(), na;
  }, [
    e
  ]), ea = useCallback(() => (e.isSSR = !0, e.getCollection()), [
    e
  ]), ra = $e1995378a142960e$var$useSyncExternalStore(Zi, Qi, ea);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => (e.isMounted = !0, () => {
    e.isMounted = !1;
  }), [
    e
  ]), {
    collection: ra,
    document: e
  };
}
const $e1995378a142960e$var$SSRContext = /* @__PURE__ */ createContext(null);
function $e1995378a142960e$var$useSSRCollectionNode(Bi, e, Zi, Qi, ea, ra) {
  let na = useCallback((fa) => {
    fa?.setProps(e, Zi, Qi, ra);
  }, [
    e,
    Zi,
    Qi,
    ra
  ]), ia = useContext($e1995378a142960e$var$SSRContext);
  if (ia) {
    let fa = ia.ownerDocument.nodesByProps.get(e);
    return fa || (fa = ia.ownerDocument.createElement(Bi), fa.setProps(e, Zi, Qi, ra), ia.appendChild(fa), ia.ownerDocument.updateCollection(), ia.ownerDocument.nodesByProps.set(e, fa)), ea ? /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$SSRContext.Provider, {
      value: fa
    }, ea) : null;
  }
  return /* @__PURE__ */ a__default.createElement(Bi, {
    ref: na
  }, ea);
}
function $e1995378a142960e$export$18af5c7a9e9b3664(Bi, e) {
  let Zi = ({ node: ea }) => e(ea.props, ea.props.ref, ea), Qi = forwardRef((ea, ra) => {
    if (!useContext($e1995378a142960e$var$ShallowRenderContext)) {
      if (e.length >= 3) throw new Error(e.name + " cannot be rendered outside a collection.");
      return e(ea, ra);
    }
    return $e1995378a142960e$var$useSSRCollectionNode(Bi, ea, ra, "children" in ea ? ea.children : null, null, (ia) => /* @__PURE__ */ a__default.createElement(Zi, {
      node: ia
    }));
  });
  return Qi.displayName = e.name, Qi;
}
function $e1995378a142960e$var$useCollectionChildren(Bi) {
  return $e948873055cbafe4$export$727c8fc270210f13({
    ...Bi,
    addIdAndValue: !0
  });
}
const $e1995378a142960e$var$CollectionContext = /* @__PURE__ */ createContext(null);
function $e1995378a142960e$export$fb8073518f34e6ec(Bi) {
  let e = useContext($e1995378a142960e$var$CollectionContext), Zi = (e?.dependencies || []).concat(Bi.dependencies), Qi = Bi.idScope || e?.idScope, ea = $e1995378a142960e$var$useCollectionChildren({
    ...Bi,
    idScope: Qi,
    dependencies: Zi
  });
  return useContext($e1995378a142960e$var$CollectionDocumentContext) && (ea = /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionRoot, null, ea)), e = useMemo(() => ({
    dependencies: Zi,
    idScope: Qi
  }), [
    Qi,
    ...Zi
  ]), /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionContext.Provider, {
    value: e
  }, ea);
}
function $e1995378a142960e$var$CollectionRoot({ children: Bi }) {
  let e = useContext($e1995378a142960e$var$CollectionDocumentContext), Zi = useMemo(() => /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionDocumentContext.Provider, {
    value: null
  }, /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$ShallowRenderContext.Provider, {
    value: !0
  }, Bi)), [
    Bi
  ]);
  return $b5e257d569688ac6$export$535bd6ca7f90a273() ? /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$SSRContext.Provider, {
    value: e
  }, Zi) : /* @__PURE__ */ createPortal(Zi, e);
}
const $01b77f81d0f07f68$export$75b6ee27786ba447 = /* @__PURE__ */ createContext({}), $01b77f81d0f07f68$export$b04be29aa201d4f5 = /* @__PURE__ */ $f39a9eba43920ace$export$86427a43e3e48ebb(function(e, Zi) {
  [e, Zi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Zi, $01b77f81d0f07f68$export$75b6ee27786ba447);
  let { elementType: Qi = "label", ...ea } = e;
  return /* @__PURE__ */ a__default.createElement(Qi, {
    className: "react-aria-Label",
    ...ea,
    ref: Zi
  });
});
let $14c0b72509d70225$var$state = "default", $14c0b72509d70225$var$savedUserSelect = "", $14c0b72509d70225$var$modifiedElementMap = /* @__PURE__ */ new WeakMap();
function $14c0b72509d70225$export$16a4697467175487(Bi) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state === "default") {
      const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
      $14c0b72509d70225$var$savedUserSelect = e.documentElement.style.webkitUserSelect, e.documentElement.style.webkitUserSelect = "none";
    }
    $14c0b72509d70225$var$state = "disabled";
  } else (Bi instanceof HTMLElement || Bi instanceof SVGElement) && ($14c0b72509d70225$var$modifiedElementMap.set(Bi, Bi.style.userSelect), Bi.style.userSelect = "none");
}
function $14c0b72509d70225$export$b0d6fa1ab32e3295(Bi) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state !== "disabled") return;
    $14c0b72509d70225$var$state = "restoring", setTimeout(() => {
      $bbed8b41f857bcc0$export$24490316f764c430(() => {
        if ($14c0b72509d70225$var$state === "restoring") {
          const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
          e.documentElement.style.webkitUserSelect === "none" && (e.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || ""), $14c0b72509d70225$var$savedUserSelect = "", $14c0b72509d70225$var$state = "default";
        }
      });
    }, 300);
  } else if ((Bi instanceof HTMLElement || Bi instanceof SVGElement) && Bi && $14c0b72509d70225$var$modifiedElementMap.has(Bi)) {
    let e = $14c0b72509d70225$var$modifiedElementMap.get(Bi);
    Bi.style.userSelect === "none" && (Bi.style.userSelect = e), Bi.getAttribute("style") === "" && Bi.removeAttribute("style"), $14c0b72509d70225$var$modifiedElementMap.delete(Bi);
  }
}
const $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = a__default.createContext({
  register: () => {
  }
});
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
function _class_apply_descriptor_get(Bi, e) {
  return e.get ? e.get.call(Bi) : e.value;
}
function _class_extract_field_descriptor(Bi, e, Zi) {
  if (!e.has(Bi)) throw new TypeError("attempted to " + Zi + " private field on non-instance");
  return e.get(Bi);
}
function _class_private_field_get(Bi, e) {
  var Zi = _class_extract_field_descriptor(Bi, e, "get");
  return _class_apply_descriptor_get(Bi, Zi);
}
function _check_private_redeclaration(Bi, e) {
  if (e.has(Bi))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _class_private_field_init(Bi, e, Zi) {
  _check_private_redeclaration(Bi, e), e.set(Bi, Zi);
}
function _class_apply_descriptor_set(Bi, e, Zi) {
  if (e.set) e.set.call(Bi, Zi);
  else {
    if (!e.writable)
      throw new TypeError("attempted to set read only private field");
    e.value = Zi;
  }
}
function _class_private_field_set(Bi, e, Zi) {
  var Qi = _class_extract_field_descriptor(Bi, e, "set");
  return _class_apply_descriptor_set(Bi, Qi, Zi), Zi;
}
function $f6c31cce2adf654f$var$usePressResponderContext(Bi) {
  let e = useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
  if (e) {
    let { register: Zi, ...Qi } = e;
    Bi = $3ef42575df84b30b$export$9d1611c77c2fe928(Qi, Bi), Zi();
  }
  return $e7801be82b4b2a53$export$4debdb1a3f0fa79e(e, Bi.ref), Bi;
}
var $f6c31cce2adf654f$var$_shouldStopPropagation = /* @__PURE__ */ new WeakMap();
class $f6c31cce2adf654f$var$PressEvent {
  continuePropagation() {
    _class_private_field_set(this, $f6c31cce2adf654f$var$_shouldStopPropagation, !1);
  }
  get shouldStopPropagation() {
    return _class_private_field_get(this, $f6c31cce2adf654f$var$_shouldStopPropagation);
  }
  constructor(e, Zi, Qi, ea) {
    _class_private_field_init(this, $f6c31cce2adf654f$var$_shouldStopPropagation, {
      writable: !0,
      value: void 0
    }), _class_private_field_set(this, $f6c31cce2adf654f$var$_shouldStopPropagation, !0);
    var ra;
    let na = (ra = ea?.target) !== null && ra !== void 0 ? ra : Qi.currentTarget;
    const ia = na?.getBoundingClientRect();
    let fa, La = 0, Va, to = null;
    Qi.clientX != null && Qi.clientY != null && (Va = Qi.clientX, to = Qi.clientY), ia && (Va != null && to != null ? (fa = Va - ia.left, La = to - ia.top) : (fa = ia.width / 2, La = ia.height / 2)), this.type = e, this.pointerType = Zi, this.target = Qi.currentTarget, this.shiftKey = Qi.shiftKey, this.metaKey = Qi.metaKey, this.ctrlKey = Qi.ctrlKey, this.altKey = Qi.altKey, this.x = fa, this.y = La;
  }
}
const $f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $f6c31cce2adf654f$export$45712eceda6fad21(Bi) {
  let {
    onPress: e,
    onPressChange: Zi,
    onPressStart: Qi,
    onPressEnd: ea,
    onPressUp: ra,
    isDisabled: na,
    isPressed: ia,
    preventFocusOnPress: fa,
    shouldCancelOnPointerExit: La,
    allowTextSelectionOnPress: Va,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: to,
    ...ro
  } = $f6c31cce2adf654f$var$usePressResponderContext(Bi), [no, eo] = useState(!1), ao = useRef({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: io, removeAllGlobalListeners: xs } = $03deb23ff14920c4$export$4eaf04e54aa8eed6(), Ts = $8ae05eaa5c114e9c$export$7f54fc3180508a52((so, os) => {
    let Xs = ao.current;
    if (na || Xs.didFirePressStart) return !1;
    let gl = !0;
    if (Xs.isTriggeringEvent = !0, Qi) {
      let Sl = new $f6c31cce2adf654f$var$PressEvent("pressstart", os, so);
      Qi(Sl), gl = Sl.shouldStopPropagation;
    }
    return Zi && Zi(!0), Xs.isTriggeringEvent = !1, Xs.didFirePressStart = !0, eo(!0), gl;
  }), qs = $8ae05eaa5c114e9c$export$7f54fc3180508a52((so, os, Xs = !0) => {
    let gl = ao.current;
    if (!gl.didFirePressStart) return !1;
    gl.ignoreClickAfterPress = !0, gl.didFirePressStart = !1, gl.isTriggeringEvent = !0;
    let Sl = !0;
    if (ea) {
      let El = new $f6c31cce2adf654f$var$PressEvent("pressend", os, so);
      ea(El), Sl = El.shouldStopPropagation;
    }
    if (Zi && Zi(!1), eo(!1), e && Xs && !na) {
      let El = new $f6c31cce2adf654f$var$PressEvent("press", os, so);
      e(El), Sl && (Sl = El.shouldStopPropagation);
    }
    return gl.isTriggeringEvent = !1, Sl;
  }), Fs = $8ae05eaa5c114e9c$export$7f54fc3180508a52((so, os) => {
    let Xs = ao.current;
    if (na) return !1;
    if (ra) {
      Xs.isTriggeringEvent = !0;
      let gl = new $f6c31cce2adf654f$var$PressEvent("pressup", os, so);
      return ra(gl), Xs.isTriggeringEvent = !1, gl.shouldStopPropagation;
    }
    return !0;
  }), Do = $8ae05eaa5c114e9c$export$7f54fc3180508a52((so) => {
    let os = ao.current;
    os.isPressed && os.target && (os.isOverTarget && os.pointerType != null && qs($f6c31cce2adf654f$var$createEvent(os.target, so), os.pointerType, !1), os.isPressed = !1, os.isOverTarget = !1, os.activePointerId = null, os.pointerType = null, xs(), Va || $14c0b72509d70225$export$b0d6fa1ab32e3295(os.target));
  }), ys = $8ae05eaa5c114e9c$export$7f54fc3180508a52((so) => {
    La && Do(so);
  }), Io = useMemo(() => {
    let so = ao.current, os = {
      onKeyDown(gl) {
        if ($f6c31cce2adf654f$var$isValidKeyboardEvent(gl.nativeEvent, gl.currentTarget) && gl.currentTarget.contains(gl.target)) {
          var Sl;
          $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(gl.target, gl.key) && gl.preventDefault();
          let El = !0;
          if (!so.isPressed && !gl.repeat) {
            so.target = gl.currentTarget, so.isPressed = !0, El = Ts(gl, "keyboard");
            let wl = gl.currentTarget, jl = (kl) => {
              $f6c31cce2adf654f$var$isValidKeyboardEvent(kl, wl) && !kl.repeat && wl.contains(kl.target) && so.target && Fs($f6c31cce2adf654f$var$createEvent(so.target, kl), "keyboard");
            };
            io($431fbd86ca7dc216$export$b204af158042fbac(gl.currentTarget), "keyup", $ff5963eb1fccf552$export$e08e3b67e392101e(jl, Xs), !0);
          }
          El && gl.stopPropagation(), gl.metaKey && $c87311424ea30a05$export$9ac100e40613ea10() && ((Sl = so.metaKeyEvents) === null || Sl === void 0 || Sl.set(gl.key, gl.nativeEvent));
        } else gl.key === "Meta" && (so.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(gl) {
        if (!(gl && !gl.currentTarget.contains(gl.target)) && gl && gl.button === 0 && !so.isTriggeringEvent && !$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening) {
          let Sl = !0;
          if (na && gl.preventDefault(), !so.ignoreClickAfterPress && !so.ignoreEmulatedMouseEvents && !so.isPressed && (so.pointerType === "virtual" || $6a7db85432448f7f$export$60278871457622de(gl.nativeEvent))) {
            !na && !fa && $7215afc6de606d6b$export$de79e2c695e052f3(gl.currentTarget);
            let El = Ts(gl, "virtual"), wl = Fs(gl, "virtual"), jl = qs(gl, "virtual");
            Sl = El && wl && jl;
          }
          so.ignoreEmulatedMouseEvents = !1, so.ignoreClickAfterPress = !1, Sl && gl.stopPropagation();
        }
      }
    }, Xs = (gl) => {
      var Sl;
      if (so.isPressed && so.target && $f6c31cce2adf654f$var$isValidKeyboardEvent(gl, so.target)) {
        var El;
        $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(gl.target, gl.key) && gl.preventDefault();
        let jl = gl.target;
        qs($f6c31cce2adf654f$var$createEvent(so.target, gl), "keyboard", so.target.contains(jl)), xs(), gl.key !== "Enter" && $f6c31cce2adf654f$var$isHTMLAnchorLink(so.target) && so.target.contains(jl) && !gl[$f6c31cce2adf654f$var$LINK_CLICKED] && (gl[$f6c31cce2adf654f$var$LINK_CLICKED] = !0, $ea8dcbcb9ea1b556$export$95185d699e05d4d7(so.target, gl, !1)), so.isPressed = !1, (El = so.metaKeyEvents) === null || El === void 0 || El.delete(gl.key);
      } else if (gl.key === "Meta" && (!((Sl = so.metaKeyEvents) === null || Sl === void 0) && Sl.size)) {
        var wl;
        let jl = so.metaKeyEvents;
        so.metaKeyEvents = void 0;
        for (let kl of jl.values()) (wl = so.target) === null || wl === void 0 || wl.dispatchEvent(new KeyboardEvent("keyup", kl));
      }
    };
    if (typeof PointerEvent < "u") {
      os.onPointerDown = (wl) => {
        if (wl.button !== 0 || !wl.currentTarget.contains(wl.target)) return;
        if ($6a7db85432448f7f$export$29bf1b5f2c56cf63(wl.nativeEvent)) {
          so.pointerType = "virtual";
          return;
        }
        $f6c31cce2adf654f$var$shouldPreventDefaultDown(wl.currentTarget) && wl.preventDefault(), so.pointerType = wl.pointerType;
        let jl = !0;
        if (!so.isPressed) {
          so.isPressed = !0, so.isOverTarget = !0, so.activePointerId = wl.pointerId, so.target = wl.currentTarget, !na && !fa && $7215afc6de606d6b$export$de79e2c695e052f3(wl.currentTarget), Va || $14c0b72509d70225$export$16a4697467175487(so.target), jl = Ts(wl, so.pointerType);
          let kl = wl.target;
          "releasePointerCapture" in kl && kl.releasePointerCapture(wl.pointerId), io($431fbd86ca7dc216$export$b204af158042fbac(wl.currentTarget), "pointerup", gl, !1), io($431fbd86ca7dc216$export$b204af158042fbac(wl.currentTarget), "pointercancel", El, !1);
        }
        jl && wl.stopPropagation();
      }, os.onMouseDown = (wl) => {
        wl.currentTarget.contains(wl.target) && wl.button === 0 && ($f6c31cce2adf654f$var$shouldPreventDefaultDown(wl.currentTarget) && wl.preventDefault(), wl.stopPropagation());
      }, os.onPointerUp = (wl) => {
        !wl.currentTarget.contains(wl.target) || so.pointerType === "virtual" || wl.button === 0 && Fs(wl, so.pointerType || wl.pointerType);
      }, os.onPointerEnter = (wl) => {
        wl.pointerId === so.activePointerId && so.target && !so.isOverTarget && so.pointerType != null && (so.isOverTarget = !0, Ts($f6c31cce2adf654f$var$createEvent(so.target, wl), so.pointerType));
      }, os.onPointerLeave = (wl) => {
        wl.pointerId === so.activePointerId && so.target && so.isOverTarget && so.pointerType != null && (so.isOverTarget = !1, qs($f6c31cce2adf654f$var$createEvent(so.target, wl), so.pointerType, !1), ys(wl));
      };
      let gl = (wl) => {
        wl.pointerId === so.activePointerId && so.isPressed && wl.button === 0 && so.target && (so.target.contains(wl.target) && so.pointerType != null ? qs($f6c31cce2adf654f$var$createEvent(so.target, wl), so.pointerType) : so.isOverTarget && so.pointerType != null && qs($f6c31cce2adf654f$var$createEvent(so.target, wl), so.pointerType, !1), so.isPressed = !1, so.isOverTarget = !1, so.activePointerId = null, so.pointerType = null, xs(), Va || $14c0b72509d70225$export$b0d6fa1ab32e3295(so.target), "ontouchend" in so.target && wl.pointerType !== "mouse" && io(so.target, "touchend", Sl, {
          once: !0
        }));
      }, Sl = (wl) => {
        $f6c31cce2adf654f$var$shouldPreventDefaultUp(wl.currentTarget) && wl.preventDefault();
      }, El = (wl) => {
        Do(wl);
      };
      os.onDragStart = (wl) => {
        wl.currentTarget.contains(wl.target) && Do(wl);
      };
    } else {
      os.onMouseDown = (El) => {
        if (El.button !== 0 || !El.currentTarget.contains(El.target)) return;
        if ($f6c31cce2adf654f$var$shouldPreventDefaultDown(El.currentTarget) && El.preventDefault(), so.ignoreEmulatedMouseEvents) {
          El.stopPropagation();
          return;
        }
        so.isPressed = !0, so.isOverTarget = !0, so.target = El.currentTarget, so.pointerType = $6a7db85432448f7f$export$60278871457622de(El.nativeEvent) ? "virtual" : "mouse", !na && !fa && $7215afc6de606d6b$export$de79e2c695e052f3(El.currentTarget), Ts(El, so.pointerType) && El.stopPropagation(), io($431fbd86ca7dc216$export$b204af158042fbac(El.currentTarget), "mouseup", gl, !1);
      }, os.onMouseEnter = (El) => {
        if (!El.currentTarget.contains(El.target)) return;
        let wl = !0;
        so.isPressed && !so.ignoreEmulatedMouseEvents && so.pointerType != null && (so.isOverTarget = !0, wl = Ts(El, so.pointerType)), wl && El.stopPropagation();
      }, os.onMouseLeave = (El) => {
        if (!El.currentTarget.contains(El.target)) return;
        let wl = !0;
        so.isPressed && !so.ignoreEmulatedMouseEvents && so.pointerType != null && (so.isOverTarget = !1, wl = qs(El, so.pointerType, !1), ys(El)), wl && El.stopPropagation();
      }, os.onMouseUp = (El) => {
        El.currentTarget.contains(El.target) && !so.ignoreEmulatedMouseEvents && El.button === 0 && Fs(El, so.pointerType || "mouse");
      };
      let gl = (El) => {
        if (El.button === 0) {
          if (so.isPressed = !1, xs(), so.ignoreEmulatedMouseEvents) {
            so.ignoreEmulatedMouseEvents = !1;
            return;
          }
          so.target && $f6c31cce2adf654f$var$isOverTarget(El, so.target) && so.pointerType != null ? qs($f6c31cce2adf654f$var$createEvent(so.target, El), so.pointerType) : so.target && so.isOverTarget && so.pointerType != null && qs($f6c31cce2adf654f$var$createEvent(so.target, El), so.pointerType, !1), so.isOverTarget = !1;
        }
      };
      os.onTouchStart = (El) => {
        if (!El.currentTarget.contains(El.target)) return;
        let wl = $f6c31cce2adf654f$var$getTouchFromEvent(El.nativeEvent);
        if (!wl) return;
        so.activePointerId = wl.identifier, so.ignoreEmulatedMouseEvents = !0, so.isOverTarget = !0, so.isPressed = !0, so.target = El.currentTarget, so.pointerType = "touch", !na && !fa && $7215afc6de606d6b$export$de79e2c695e052f3(El.currentTarget), Va || $14c0b72509d70225$export$16a4697467175487(so.target), Ts($f6c31cce2adf654f$var$createTouchEvent(so.target, El), so.pointerType) && El.stopPropagation(), io($431fbd86ca7dc216$export$f21a1ffae260145a(El.currentTarget), "scroll", Sl, !0);
      }, os.onTouchMove = (El) => {
        if (!El.currentTarget.contains(El.target)) return;
        if (!so.isPressed) {
          El.stopPropagation();
          return;
        }
        let wl = $f6c31cce2adf654f$var$getTouchById(El.nativeEvent, so.activePointerId), jl = !0;
        wl && $f6c31cce2adf654f$var$isOverTarget(wl, El.currentTarget) ? !so.isOverTarget && so.pointerType != null && (so.isOverTarget = !0, jl = Ts($f6c31cce2adf654f$var$createTouchEvent(so.target, El), so.pointerType)) : so.isOverTarget && so.pointerType != null && (so.isOverTarget = !1, jl = qs($f6c31cce2adf654f$var$createTouchEvent(so.target, El), so.pointerType, !1), ys($f6c31cce2adf654f$var$createTouchEvent(so.target, El))), jl && El.stopPropagation();
      }, os.onTouchEnd = (El) => {
        if (!El.currentTarget.contains(El.target)) return;
        if (!so.isPressed) {
          El.stopPropagation();
          return;
        }
        let wl = $f6c31cce2adf654f$var$getTouchById(El.nativeEvent, so.activePointerId), jl = !0;
        wl && $f6c31cce2adf654f$var$isOverTarget(wl, El.currentTarget) && so.pointerType != null ? (Fs($f6c31cce2adf654f$var$createTouchEvent(so.target, El), so.pointerType), jl = qs($f6c31cce2adf654f$var$createTouchEvent(so.target, El), so.pointerType)) : so.isOverTarget && so.pointerType != null && (jl = qs($f6c31cce2adf654f$var$createTouchEvent(so.target, El), so.pointerType, !1)), jl && El.stopPropagation(), so.isPressed = !1, so.activePointerId = null, so.isOverTarget = !1, so.ignoreEmulatedMouseEvents = !0, so.target && !Va && $14c0b72509d70225$export$b0d6fa1ab32e3295(so.target), xs();
      }, os.onTouchCancel = (El) => {
        El.currentTarget.contains(El.target) && (El.stopPropagation(), so.isPressed && Do($f6c31cce2adf654f$var$createTouchEvent(so.target, El)));
      };
      let Sl = (El) => {
        so.isPressed && El.target.contains(so.target) && Do({
          currentTarget: so.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      os.onDragStart = (El) => {
        El.currentTarget.contains(El.target) && Do(El);
      };
    }
    return os;
  }, [
    io,
    na,
    fa,
    xs,
    Va,
    Do,
    ys,
    qs,
    Ts,
    Fs
  ]);
  return useEffect(() => () => {
    var so;
    Va || $14c0b72509d70225$export$b0d6fa1ab32e3295((so = ao.current.target) !== null && so !== void 0 ? so : void 0);
  }, [
    Va
  ]), {
    isPressed: ia || no,
    pressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(ro, Io)
  };
}
function $f6c31cce2adf654f$var$isHTMLAnchorLink(Bi) {
  return Bi.tagName === "A" && Bi.hasAttribute("href");
}
function $f6c31cce2adf654f$var$isValidKeyboardEvent(Bi, e) {
  const { key: Zi, code: Qi } = Bi, ea = e, ra = ea.getAttribute("role");
  return (Zi === "Enter" || Zi === " " || Zi === "Spacebar" || Qi === "Space") && !(ea instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(ea).HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(ea, Zi) || ea instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(ea).HTMLTextAreaElement || ea.isContentEditable) && // Links should only trigger with Enter key
  !((ra === "link" || !ra && $f6c31cce2adf654f$var$isHTMLAnchorLink(ea)) && Zi !== "Enter");
}
function $f6c31cce2adf654f$var$getTouchFromEvent(Bi) {
  const { targetTouches: e } = Bi;
  return e.length > 0 ? e[0] : null;
}
function $f6c31cce2adf654f$var$getTouchById(Bi, e) {
  const Zi = Bi.changedTouches;
  for (let Qi = 0; Qi < Zi.length; Qi++) {
    const ea = Zi[Qi];
    if (ea.identifier === e) return ea;
  }
  return null;
}
function $f6c31cce2adf654f$var$createTouchEvent(Bi, e) {
  let Zi = 0, Qi = 0;
  return e.targetTouches && e.targetTouches.length === 1 && (Zi = e.targetTouches[0].clientX, Qi = e.targetTouches[0].clientY), {
    currentTarget: Bi,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: Zi,
    clientY: Qi
  };
}
function $f6c31cce2adf654f$var$createEvent(Bi, e) {
  let Zi = e.clientX, Qi = e.clientY;
  return {
    currentTarget: Bi,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: Zi,
    clientY: Qi
  };
}
function $f6c31cce2adf654f$var$getPointClientRect(Bi) {
  let e = 0, Zi = 0;
  return Bi.width !== void 0 ? e = Bi.width / 2 : Bi.radiusX !== void 0 && (e = Bi.radiusX), Bi.height !== void 0 ? Zi = Bi.height / 2 : Bi.radiusY !== void 0 && (Zi = Bi.radiusY), {
    top: Bi.clientY - Zi,
    right: Bi.clientX + e,
    bottom: Bi.clientY + Zi,
    left: Bi.clientX - e
  };
}
function $f6c31cce2adf654f$var$areRectanglesOverlapping(Bi, e) {
  return !(Bi.left > e.right || e.left > Bi.right || Bi.top > e.bottom || e.top > Bi.bottom);
}
function $f6c31cce2adf654f$var$isOverTarget(Bi, e) {
  let Zi = e.getBoundingClientRect(), Qi = $f6c31cce2adf654f$var$getPointClientRect(Bi);
  return $f6c31cce2adf654f$var$areRectanglesOverlapping(Zi, Qi);
}
function $f6c31cce2adf654f$var$shouldPreventDefaultDown(Bi) {
  return !(Bi instanceof HTMLElement) || !Bi.hasAttribute("draggable");
}
function $f6c31cce2adf654f$var$shouldPreventDefaultUp(Bi) {
  return Bi instanceof HTMLInputElement ? !1 : Bi instanceof HTMLButtonElement ? Bi.type !== "submit" && Bi.type !== "reset" : !$f6c31cce2adf654f$var$isHTMLAnchorLink(Bi);
}
function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(Bi, e) {
  return Bi instanceof HTMLInputElement ? !$f6c31cce2adf654f$var$isValidInputKey(Bi, e) : $f6c31cce2adf654f$var$shouldPreventDefaultUp(Bi);
}
const $f6c31cce2adf654f$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $f6c31cce2adf654f$var$isValidInputKey(Bi, e) {
  return Bi.type === "checkbox" || Bi.type === "radio" ? e === " " : $f6c31cce2adf654f$var$nonTextInputTypes.has(Bi.type);
}
const $f1ab8c75478c6f73$export$3351871ee4b288b8 = /* @__PURE__ */ a__default.forwardRef(({ children: Bi, ...e }, Zi) => {
  let Qi = useRef(!1), ea = useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
  Zi = $df56164dff5785e2$export$4338b53315abf666(Zi || ea?.ref);
  let ra = $3ef42575df84b30b$export$9d1611c77c2fe928(ea || {}, {
    ...e,
    ref: Zi,
    register() {
      Qi.current = !0, ea && ea.register();
    }
  });
  return $e7801be82b4b2a53$export$4debdb1a3f0fa79e(ea, Zi), useEffect(() => {
    Qi.current || (console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), Qi.current = !0);
  }, []), /* @__PURE__ */ a__default.createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
    value: ra
  }, Bi);
});
function $f1ab8c75478c6f73$export$cf75428e0b9ed1ea({ children: Bi }) {
  let e = useMemo(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ a__default.createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
    value: e
  }, Bi);
}
class $8a9cb279dc87e130$export$905e7fc544a71f36 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(e, Zi) {
    this.nativeEvent = Zi, this.target = Zi.target, this.currentTarget = Zi.currentTarget, this.relatedTarget = Zi.relatedTarget, this.bubbles = Zi.bubbles, this.cancelable = Zi.cancelable, this.defaultPrevented = Zi.defaultPrevented, this.eventPhase = Zi.eventPhase, this.isTrusted = Zi.isTrusted, this.timeStamp = Zi.timeStamp, this.type = e;
  }
}
function $8a9cb279dc87e130$export$715c682d09d639cc(Bi) {
  let e = useRef({
    isFocused: !1,
    observer: null
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const Qi = e.current;
    return () => {
      Qi.observer && (Qi.observer.disconnect(), Qi.observer = null);
    };
  }, []);
  let Zi = $8ae05eaa5c114e9c$export$7f54fc3180508a52((Qi) => {
    Bi?.(Qi);
  });
  return useCallback((Qi) => {
    if (Qi.target instanceof HTMLButtonElement || Qi.target instanceof HTMLInputElement || Qi.target instanceof HTMLTextAreaElement || Qi.target instanceof HTMLSelectElement) {
      e.current.isFocused = !0;
      let ea = Qi.target, ra = (na) => {
        e.current.isFocused = !1, ea.disabled && Zi(new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", na)), e.current.observer && (e.current.observer.disconnect(), e.current.observer = null);
      };
      ea.addEventListener("focusout", ra, {
        once: !0
      }), e.current.observer = new MutationObserver(() => {
        if (e.current.isFocused && ea.disabled) {
          var na;
          (na = e.current.observer) === null || na === void 0 || na.disconnect();
          let ia = ea === document.activeElement ? null : document.activeElement;
          ea.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: ia
          })), ea.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: ia
          }));
        }
      }), e.current.observer.observe(ea, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    Zi
  ]);
}
function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(Bi) {
  let { isDisabled: e, onFocus: Zi, onBlur: Qi, onFocusChange: ea } = Bi;
  const ra = useCallback((fa) => {
    if (fa.target === fa.currentTarget)
      return Qi && Qi(fa), ea && ea(!1), !0;
  }, [
    Qi,
    ea
  ]), na = $8a9cb279dc87e130$export$715c682d09d639cc(ra), ia = useCallback((fa) => {
    const La = $431fbd86ca7dc216$export$b204af158042fbac(fa.target);
    fa.target === fa.currentTarget && La.activeElement === fa.target && (Zi && Zi(fa), ea && ea(!0), na(fa));
  }, [
    ea,
    Zi,
    na
  ]);
  return {
    focusProps: {
      onFocus: !e && (Zi || ea || Qi) ? ia : void 0,
      onBlur: !e && (Qi || ea) ? ra : void 0
    }
  };
}
let $507fabe10e71c6fb$var$currentModality = null, $507fabe10e71c6fb$var$changeHandlers = /* @__PURE__ */ new Set(), $507fabe10e71c6fb$export$d90243b58daecda7 = /* @__PURE__ */ new Map(), $507fabe10e71c6fb$var$hasEventBeforeFocus = !1, $507fabe10e71c6fb$var$hasBlurredWindowRecently = !1;
const $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
  Tab: !0,
  Escape: !0
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(Bi, e) {
  for (let Zi of $507fabe10e71c6fb$var$changeHandlers) Zi(Bi, e);
}
function $507fabe10e71c6fb$var$isValidKey(Bi) {
  return !(Bi.metaKey || !$c87311424ea30a05$export$9ac100e40613ea10() && Bi.altKey || Bi.ctrlKey || Bi.key === "Control" || Bi.key === "Shift" || Bi.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(Bi) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = !0, $507fabe10e71c6fb$var$isValidKey(Bi) && ($507fabe10e71c6fb$var$currentModality = "keyboard", $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", Bi));
}
function $507fabe10e71c6fb$var$handlePointerEvent(Bi) {
  $507fabe10e71c6fb$var$currentModality = "pointer", (Bi.type === "mousedown" || Bi.type === "pointerdown") && ($507fabe10e71c6fb$var$hasEventBeforeFocus = !0, $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", Bi));
}
function $507fabe10e71c6fb$var$handleClickEvent(Bi) {
  $6a7db85432448f7f$export$60278871457622de(Bi) && ($507fabe10e71c6fb$var$hasEventBeforeFocus = !0, $507fabe10e71c6fb$var$currentModality = "virtual");
}
function $507fabe10e71c6fb$var$handleFocusEvent(Bi) {
  Bi.target === window || Bi.target === document || (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently && ($507fabe10e71c6fb$var$currentModality = "virtual", $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", Bi)), $507fabe10e71c6fb$var$hasEventBeforeFocus = !1, $507fabe10e71c6fb$var$hasBlurredWindowRecently = !1);
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = !1, $507fabe10e71c6fb$var$hasBlurredWindowRecently = !0;
}
function $507fabe10e71c6fb$var$setupGlobalFocusEvents(Bi) {
  if (typeof window > "u" || $507fabe10e71c6fb$export$d90243b58daecda7.get($431fbd86ca7dc216$export$f21a1ffae260145a(Bi))) return;
  const e = $431fbd86ca7dc216$export$f21a1ffae260145a(Bi), Zi = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  let Qi = e.HTMLElement.prototype.focus;
  e.HTMLElement.prototype.focus = function() {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = !0, Qi.apply(this, arguments);
  }, Zi.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), Zi.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), Zi.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, !0), e.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, !0), e.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, !1), typeof PointerEvent < "u" ? (Zi.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, !0), Zi.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, !0), Zi.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, !0)) : (Zi.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, !0), Zi.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, !0), Zi.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, !0)), e.addEventListener("beforeunload", () => {
    $507fabe10e71c6fb$var$tearDownWindowFocusTracking(Bi);
  }, {
    once: !0
  }), $507fabe10e71c6fb$export$d90243b58daecda7.set(e, {
    focus: Qi
  });
}
const $507fabe10e71c6fb$var$tearDownWindowFocusTracking = (Bi, e) => {
  const Zi = $431fbd86ca7dc216$export$f21a1ffae260145a(Bi), Qi = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  e && Qi.removeEventListener("DOMContentLoaded", e), $507fabe10e71c6fb$export$d90243b58daecda7.has(Zi) && (Zi.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7.get(Zi).focus, Qi.removeEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), Qi.removeEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), Qi.removeEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, !0), Zi.removeEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, !0), Zi.removeEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, !1), typeof PointerEvent < "u" ? (Qi.removeEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, !0), Qi.removeEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, !0), Qi.removeEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, !0)) : (Qi.removeEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, !0), Qi.removeEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, !0), Qi.removeEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, !0)), $507fabe10e71c6fb$export$d90243b58daecda7.delete(Zi));
};
function $507fabe10e71c6fb$export$2f1888112f558a7d(Bi) {
  const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  let Zi;
  return e.readyState !== "loading" ? $507fabe10e71c6fb$var$setupGlobalFocusEvents(Bi) : (Zi = () => {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents(Bi);
  }, e.addEventListener("DOMContentLoaded", Zi)), () => $507fabe10e71c6fb$var$tearDownWindowFocusTracking(Bi, Zi);
}
typeof document < "u" && $507fabe10e71c6fb$export$2f1888112f558a7d();
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
  return $507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
  return $507fabe10e71c6fb$var$currentModality;
}
function $507fabe10e71c6fb$export$8397ddfc504fdb9a(Bi) {
  $507fabe10e71c6fb$var$currentModality = Bi, $507fabe10e71c6fb$var$triggerChangeHandlers(Bi, null);
}
const $507fabe10e71c6fb$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $507fabe10e71c6fb$var$isKeyboardFocusEvent(Bi, e, Zi) {
  var Qi;
  const ea = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(Zi?.target).HTMLInputElement : HTMLInputElement, ra = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(Zi?.target).HTMLTextAreaElement : HTMLTextAreaElement, na = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(Zi?.target).HTMLElement : HTMLElement, ia = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(Zi?.target).KeyboardEvent : KeyboardEvent;
  return Bi = Bi || Zi?.target instanceof ea && !$507fabe10e71c6fb$var$nonTextInputTypes.has(Zi == null || (Qi = Zi.target) === null || Qi === void 0 ? void 0 : Qi.type) || Zi?.target instanceof ra || Zi?.target instanceof na && Zi?.target.isContentEditable, !(Bi && e === "keyboard" && Zi instanceof ia && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[Zi.key]);
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(Bi, e, Zi) {
  $507fabe10e71c6fb$var$setupGlobalFocusEvents(), useEffect(() => {
    let Qi = (ea, ra) => {
      $507fabe10e71c6fb$var$isKeyboardFocusEvent(!!Zi?.isTextInput, ea, ra) && Bi($507fabe10e71c6fb$export$b9b3dfddab17db27());
    };
    return $507fabe10e71c6fb$var$changeHandlers.add(Qi), () => {
      $507fabe10e71c6fb$var$changeHandlers.delete(Qi);
    };
  }, e);
}
function $9ab94262bd0047c7$export$420e68273165f4ec(Bi) {
  let { isDisabled: e, onBlurWithin: Zi, onFocusWithin: Qi, onFocusWithinChange: ea } = Bi, ra = useRef({
    isFocusWithin: !1
  }), na = useCallback((La) => {
    ra.current.isFocusWithin && !La.currentTarget.contains(La.relatedTarget) && (ra.current.isFocusWithin = !1, Zi && Zi(La), ea && ea(!1));
  }, [
    Zi,
    ea,
    ra
  ]), ia = $8a9cb279dc87e130$export$715c682d09d639cc(na), fa = useCallback((La) => {
    !ra.current.isFocusWithin && document.activeElement === La.target && (Qi && Qi(La), ea && ea(!0), ra.current.isFocusWithin = !0, ia(La));
  }, [
    Qi,
    ea,
    ia
  ]);
  return e ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: fa,
      onBlur: na
    }
  };
}
let $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = !1, $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
  $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = !0, setTimeout(() => {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = !1;
  }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(Bi) {
  Bi.pointerType === "touch" && $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent) : document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents), $6179b936705e76d3$var$hoverCount++, () => {
      $6179b936705e76d3$var$hoverCount--, !($6179b936705e76d3$var$hoverCount > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent) : document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents));
    };
}
function $6179b936705e76d3$export$ae780daf29e6d456(Bi) {
  let { onHoverStart: e, onHoverChange: Zi, onHoverEnd: Qi, isDisabled: ea } = Bi, [ra, na] = useState(!1), ia = useRef({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  useEffect($6179b936705e76d3$var$setupGlobalTouchEvents, []);
  let { hoverProps: fa, triggerHoverEnd: La } = useMemo(() => {
    let Va = (no, eo) => {
      if (ia.pointerType = eo, ea || eo === "touch" || ia.isHovered || !no.currentTarget.contains(no.target)) return;
      ia.isHovered = !0;
      let ao = no.currentTarget;
      ia.target = ao, e && e({
        type: "hoverstart",
        target: ao,
        pointerType: eo
      }), Zi && Zi(!0), na(!0);
    }, to = (no, eo) => {
      if (ia.pointerType = "", ia.target = null, eo === "touch" || !ia.isHovered) return;
      ia.isHovered = !1;
      let ao = no.currentTarget;
      Qi && Qi({
        type: "hoverend",
        target: ao,
        pointerType: eo
      }), Zi && Zi(!1), na(!1);
    }, ro = {};
    return typeof PointerEvent < "u" ? (ro.onPointerEnter = (no) => {
      $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && no.pointerType === "mouse" || Va(no, no.pointerType);
    }, ro.onPointerLeave = (no) => {
      !ea && no.currentTarget.contains(no.target) && to(no, no.pointerType);
    }) : (ro.onTouchStart = () => {
      ia.ignoreEmulatedMouseEvents = !0;
    }, ro.onMouseEnter = (no) => {
      !ia.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && Va(no, "mouse"), ia.ignoreEmulatedMouseEvents = !1;
    }, ro.onMouseLeave = (no) => {
      !ea && no.currentTarget.contains(no.target) && to(no, "mouse");
    }), {
      hoverProps: ro,
      triggerHoverEnd: to
    };
  }, [
    e,
    Zi,
    Qi,
    ea,
    ia
  ]);
  return useEffect(() => {
    ea && La({
      currentTarget: ia.target
    }, ia.pointerType);
  }, [
    ea
  ]), {
    hoverProps: fa,
    isHovered: ra
  };
}
function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(Bi) {
  let { ref: e, onInteractOutside: Zi, isDisabled: Qi, onInteractOutsideStart: ea } = Bi, ra = useRef({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), na = $8ae05eaa5c114e9c$export$7f54fc3180508a52((fa) => {
    Zi && $e0b6e0b68ec7f50f$var$isValidEvent(fa, e) && (ea && ea(fa), ra.current.isPointerDown = !0);
  }), ia = $8ae05eaa5c114e9c$export$7f54fc3180508a52((fa) => {
    Zi && Zi(fa);
  });
  useEffect(() => {
    let fa = ra.current;
    if (Qi) return;
    const La = e.current, Va = $431fbd86ca7dc216$export$b204af158042fbac(La);
    if (typeof PointerEvent < "u") {
      let to = (ro) => {
        fa.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(ro, e) && ia(ro), fa.isPointerDown = !1;
      };
      return Va.addEventListener("pointerdown", na, !0), Va.addEventListener("pointerup", to, !0), () => {
        Va.removeEventListener("pointerdown", na, !0), Va.removeEventListener("pointerup", to, !0);
      };
    } else {
      let to = (no) => {
        fa.ignoreEmulatedMouseEvents ? fa.ignoreEmulatedMouseEvents = !1 : fa.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(no, e) && ia(no), fa.isPointerDown = !1;
      }, ro = (no) => {
        fa.ignoreEmulatedMouseEvents = !0, fa.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(no, e) && ia(no), fa.isPointerDown = !1;
      };
      return Va.addEventListener("mousedown", na, !0), Va.addEventListener("mouseup", to, !0), Va.addEventListener("touchstart", na, !0), Va.addEventListener("touchend", ro, !0), () => {
        Va.removeEventListener("mousedown", na, !0), Va.removeEventListener("mouseup", to, !0), Va.removeEventListener("touchstart", na, !0), Va.removeEventListener("touchend", ro, !0);
      };
    }
  }, [
    e,
    Qi,
    na,
    ia
  ]);
}
function $e0b6e0b68ec7f50f$var$isValidEvent(Bi, e) {
  if (Bi.button > 0) return !1;
  if (Bi.target) {
    const Zi = Bi.target.ownerDocument;
    if (!Zi || !Zi.documentElement.contains(Bi.target) || Bi.target.closest("[data-react-aria-top-layer]")) return !1;
  }
  return e.current && !e.current.contains(Bi.target);
}
function $93925083ecbb358c$export$48d1ea6320830260(Bi) {
  if (!Bi) return;
  let e = !0;
  return (Zi) => {
    let Qi = {
      ...Zi,
      preventDefault() {
        Zi.preventDefault();
      },
      isDefaultPrevented() {
        return Zi.isDefaultPrevented();
      },
      stopPropagation() {
        e ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : e = !0;
      },
      continuePropagation() {
        e = !1;
      },
      isPropagationStopped() {
        return e;
      }
    };
    Bi(Qi), e && Zi.stopPropagation();
  };
}
function $46d819fcbaf35654$export$8f71654801c2f7cd(Bi) {
  return {
    keyboardProps: Bi.isDisabled ? {} : {
      onKeyDown: $93925083ecbb358c$export$48d1ea6320830260(Bi.onKeyDown),
      onKeyUp: $93925083ecbb358c$export$48d1ea6320830260(Bi.onKeyUp)
    }
  };
}
const $8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $8a26561d2877236e$export$c24ed0104d07eab9(Bi) {
  let { isDisabled: e, onLongPressStart: Zi, onLongPressEnd: Qi, onLongPress: ea, threshold: ra = $8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: na } = Bi;
  const ia = useRef(void 0);
  let { addGlobalListener: fa, removeGlobalListener: La } = $03deb23ff14920c4$export$4eaf04e54aa8eed6(), { pressProps: Va } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled: e,
    onPressStart(ro) {
      if (ro.continuePropagation(), (ro.pointerType === "mouse" || ro.pointerType === "touch") && (Zi && Zi({
        ...ro,
        type: "longpressstart"
      }), ia.current = setTimeout(() => {
        ro.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), ea && ea({
          ...ro,
          type: "longpress"
        }), ia.current = void 0;
      }, ra), ro.pointerType === "touch")) {
        let no = (eo) => {
          eo.preventDefault();
        };
        fa(ro.target, "contextmenu", no, {
          once: !0
        }), fa(window, "pointerup", () => {
          setTimeout(() => {
            La(ro.target, "contextmenu", no);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(ro) {
      ia.current && clearTimeout(ia.current), Qi && (ro.pointerType === "mouse" || ro.pointerType === "touch") && Qi({
        ...ro,
        type: "longpressend"
      });
    }
  }), to = $ef06256079686ba0$export$f8aeda7b10753fa1(ea && !e ? na : void 0);
  return {
    longPressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(Va, to)
  };
}
function $6a99195332edec8b$export$80f3e147d781571c(Bi) {
  const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  if ($507fabe10e71c6fb$export$630ff653c5ada6a9() === "virtual") {
    let Zi = e.activeElement;
    $bbed8b41f857bcc0$export$24490316f764c430(() => {
      e.activeElement === Zi && Bi.isConnected && $7215afc6de606d6b$export$de79e2c695e052f3(Bi);
    });
  } else $7215afc6de606d6b$export$de79e2c695e052f3(Bi);
}
function $645f2e67b85a24c9$var$isStyleVisible(Bi) {
  const e = $431fbd86ca7dc216$export$f21a1ffae260145a(Bi);
  if (!(Bi instanceof e.HTMLElement) && !(Bi instanceof e.SVGElement)) return !1;
  let { display: Zi, visibility: Qi } = Bi.style, ea = Zi !== "none" && Qi !== "hidden" && Qi !== "collapse";
  if (ea) {
    const { getComputedStyle: ra } = Bi.ownerDocument.defaultView;
    let { display: na, visibility: ia } = ra(Bi);
    ea = na !== "none" && ia !== "hidden" && ia !== "collapse";
  }
  return ea;
}
function $645f2e67b85a24c9$var$isAttributeVisible(Bi, e) {
  return !Bi.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !Bi.hasAttribute("data-react-aria-prevent-focus") && (Bi.nodeName === "DETAILS" && e && e.nodeName !== "SUMMARY" ? Bi.hasAttribute("open") : !0);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(Bi, e) {
  return Bi.nodeName !== "#comment" && $645f2e67b85a24c9$var$isStyleVisible(Bi) && $645f2e67b85a24c9$var$isAttributeVisible(Bi, e) && (!Bi.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(Bi.parentElement, Bi));
}
const $9bf71ea28793e738$var$FocusContext = /* @__PURE__ */ a__default.createContext(null), $9bf71ea28793e738$var$RESTORE_FOCUS_EVENT = "react-aria-focus-scope-restore";
let $9bf71ea28793e738$var$activeScope = null;
function $9bf71ea28793e738$export$20e40289641fbbb6(Bi) {
  let { children: e, contain: Zi, restoreFocus: Qi, autoFocus: ea } = Bi, ra = useRef(null), na = useRef(null), ia = useRef([]), { parentNode: fa } = useContext($9bf71ea28793e738$var$FocusContext) || {}, La = useMemo(() => new $9bf71ea28793e738$var$TreeNode({
    scopeRef: ia
  }), [
    ia
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let ro = fa || $9bf71ea28793e738$export$d06fae2ee68b101e.root;
    if ($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(ro.scopeRef) && $9bf71ea28793e738$var$activeScope && !$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, ro.scopeRef)) {
      let no = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
      no && (ro = no);
    }
    ro.addChild(La), $9bf71ea28793e738$export$d06fae2ee68b101e.addNode(La);
  }, [
    La,
    fa
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let ro = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(ia);
    ro && (ro.contain = !!Zi);
  }, [
    Zi
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    var ro;
    let no = (ro = ra.current) === null || ro === void 0 ? void 0 : ro.nextSibling, eo = [], ao = (io) => io.stopPropagation();
    for (; no && no !== na.current; )
      eo.push(no), no.addEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, ao), no = no.nextSibling;
    return ia.current = eo, () => {
      for (let io of eo) io.removeEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, ao);
    };
  }, [
    e
  ]), $9bf71ea28793e738$var$useActiveScopeTracker(ia, Qi, Zi), $9bf71ea28793e738$var$useFocusContainment(ia, Zi), $9bf71ea28793e738$var$useRestoreFocus(ia, Qi, Zi), $9bf71ea28793e738$var$useAutoFocus(ia, ea), useEffect(() => {
    const ro = $431fbd86ca7dc216$export$b204af158042fbac(ia.current ? ia.current[0] : void 0).activeElement;
    let no = null;
    if ($9bf71ea28793e738$var$isElementInScope(ro, ia.current)) {
      for (let eo of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse()) eo.scopeRef && $9bf71ea28793e738$var$isElementInScope(ro, eo.scopeRef.current) && (no = eo);
      no === $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(ia) && ($9bf71ea28793e738$var$activeScope = no.scopeRef);
    }
  }, [
    ia
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => () => {
    var ro, no, eo;
    let ao = (eo = (no = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(ia)) === null || no === void 0 || (ro = no.parent) === null || ro === void 0 ? void 0 : ro.scopeRef) !== null && eo !== void 0 ? eo : null;
    (ia === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(ia, $9bf71ea28793e738$var$activeScope)) && (!ao || $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(ao)) && ($9bf71ea28793e738$var$activeScope = ao), $9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(ia);
  }, [
    ia
  ]);
  let Va = useMemo(() => $9bf71ea28793e738$var$createFocusManagerForScope(ia), []), to = useMemo(() => ({
    focusManager: Va,
    parentNode: La
  }), [
    La,
    Va
  ]);
  return /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$var$FocusContext.Provider, {
    value: to
  }, /* @__PURE__ */ a__default.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: ra
  }), e, /* @__PURE__ */ a__default.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: na
  }));
}
function $9bf71ea28793e738$var$createFocusManagerForScope(Bi) {
  return {
    focusNext(e = {}) {
      let Zi = Bi.current, { from: Qi, tabbable: ea, wrap: ra, accept: na } = e, ia = Qi || $431fbd86ca7dc216$export$b204af158042fbac(Zi[0]).activeElement, fa = Zi[0].previousElementSibling, La = $9bf71ea28793e738$var$getScopeRoot(Zi), Va = $9bf71ea28793e738$export$2d6ec8fc375ceafa(La, {
        tabbable: ea,
        accept: na
      }, Zi);
      Va.currentNode = $9bf71ea28793e738$var$isElementInScope(ia, Zi) ? ia : fa;
      let to = Va.nextNode();
      return !to && ra && (Va.currentNode = fa, to = Va.nextNode()), to && $9bf71ea28793e738$var$focusElement(to, !0), to;
    },
    focusPrevious(e = {}) {
      let Zi = Bi.current, { from: Qi, tabbable: ea, wrap: ra, accept: na } = e, ia = Qi || $431fbd86ca7dc216$export$b204af158042fbac(Zi[0]).activeElement, fa = Zi[Zi.length - 1].nextElementSibling, La = $9bf71ea28793e738$var$getScopeRoot(Zi), Va = $9bf71ea28793e738$export$2d6ec8fc375ceafa(La, {
        tabbable: ea,
        accept: na
      }, Zi);
      Va.currentNode = $9bf71ea28793e738$var$isElementInScope(ia, Zi) ? ia : fa;
      let to = Va.previousNode();
      return !to && ra && (Va.currentNode = fa, to = Va.previousNode()), to && $9bf71ea28793e738$var$focusElement(to, !0), to;
    },
    focusFirst(e = {}) {
      let Zi = Bi.current, { tabbable: Qi, accept: ea } = e, ra = $9bf71ea28793e738$var$getScopeRoot(Zi), na = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ra, {
        tabbable: Qi,
        accept: ea
      }, Zi);
      na.currentNode = Zi[0].previousElementSibling;
      let ia = na.nextNode();
      return ia && $9bf71ea28793e738$var$focusElement(ia, !0), ia;
    },
    focusLast(e = {}) {
      let Zi = Bi.current, { tabbable: Qi, accept: ea } = e, ra = $9bf71ea28793e738$var$getScopeRoot(Zi), na = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ra, {
        tabbable: Qi,
        accept: ea
      }, Zi);
      na.currentNode = Zi[Zi.length - 1].nextElementSibling;
      let ia = na.previousNode();
      return ia && $9bf71ea28793e738$var$focusElement(ia, !0), ia;
    }
  };
}
const $9bf71ea28793e738$var$focusableElements = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])'
], $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $9bf71ea28793e738$var$getScopeRoot(Bi) {
  return Bi[0].parentElement;
}
function $9bf71ea28793e738$var$shouldContainFocus(Bi) {
  let e = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  for (; e && e.scopeRef !== Bi; ) {
    if (e.contain) return !1;
    e = e.parent;
  }
  return !0;
}
function $9bf71ea28793e738$var$useFocusContainment(Bi, e) {
  let Zi = useRef(void 0), Qi = useRef(void 0);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let ea = Bi.current;
    if (!e) {
      Qi.current && (cancelAnimationFrame(Qi.current), Qi.current = void 0);
      return;
    }
    const ra = $431fbd86ca7dc216$export$b204af158042fbac(ea ? ea[0] : void 0);
    let na = (La) => {
      if (La.key !== "Tab" || La.altKey || La.ctrlKey || La.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(Bi) || La.isComposing) return;
      let Va = ra.activeElement, to = Bi.current;
      if (!to || !$9bf71ea28793e738$var$isElementInScope(Va, to)) return;
      let ro = $9bf71ea28793e738$var$getScopeRoot(to), no = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ro, {
        tabbable: !0
      }, to);
      if (!Va) return;
      no.currentNode = Va;
      let eo = La.shiftKey ? no.previousNode() : no.nextNode();
      eo || (no.currentNode = La.shiftKey ? to[to.length - 1].nextElementSibling : to[0].previousElementSibling, eo = La.shiftKey ? no.previousNode() : no.nextNode()), La.preventDefault(), eo && $9bf71ea28793e738$var$focusElement(eo, !0);
    }, ia = (La) => {
      (!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, Bi)) && $9bf71ea28793e738$var$isElementInScope(La.target, Bi.current) ? ($9bf71ea28793e738$var$activeScope = Bi, Zi.current = La.target) : $9bf71ea28793e738$var$shouldContainFocus(Bi) && !$9bf71ea28793e738$var$isElementInChildScope(La.target, Bi) ? Zi.current ? Zi.current.focus() : $9bf71ea28793e738$var$activeScope && $9bf71ea28793e738$var$activeScope.current && $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current) : $9bf71ea28793e738$var$shouldContainFocus(Bi) && (Zi.current = La.target);
    }, fa = (La) => {
      Qi.current && cancelAnimationFrame(Qi.current), Qi.current = requestAnimationFrame(() => {
        let Va = $507fabe10e71c6fb$export$630ff653c5ada6a9();
        if (!((Va === "virtual" || Va === null) && $c87311424ea30a05$export$a11b0059900ceec8() && $c87311424ea30a05$export$6446a186d09e379e()) && ra.activeElement && $9bf71ea28793e738$var$shouldContainFocus(Bi) && !$9bf71ea28793e738$var$isElementInChildScope(ra.activeElement, Bi))
          if ($9bf71ea28793e738$var$activeScope = Bi, ra.body.contains(La.target)) {
            var ro;
            Zi.current = La.target, (ro = Zi.current) === null || ro === void 0 || ro.focus();
          } else $9bf71ea28793e738$var$activeScope.current && $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
      });
    };
    return ra.addEventListener("keydown", na, !1), ra.addEventListener("focusin", ia, !1), ea?.forEach((La) => La.addEventListener("focusin", ia, !1)), ea?.forEach((La) => La.addEventListener("focusout", fa, !1)), () => {
      ra.removeEventListener("keydown", na, !1), ra.removeEventListener("focusin", ia, !1), ea?.forEach((La) => La.removeEventListener("focusin", ia, !1)), ea?.forEach((La) => La.removeEventListener("focusout", fa, !1));
    };
  }, [
    Bi,
    e
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => () => {
    Qi.current && cancelAnimationFrame(Qi.current);
  }, [
    Qi
  ]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(Bi) {
  return $9bf71ea28793e738$var$isElementInChildScope(Bi);
}
function $9bf71ea28793e738$var$isElementInScope(Bi, e) {
  return !Bi || !e ? !1 : e.some((Zi) => Zi.contains(Bi));
}
function $9bf71ea28793e738$var$isElementInChildScope(Bi, e = null) {
  if (Bi instanceof Element && Bi.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: Zi } of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(e)))
    if (Zi && $9bf71ea28793e738$var$isElementInScope(Bi, Zi.current)) return !0;
  return !1;
}
function $9bf71ea28793e738$export$1258395f99bf9cbf(Bi) {
  return $9bf71ea28793e738$var$isElementInChildScope(Bi, $9bf71ea28793e738$var$activeScope);
}
function $9bf71ea28793e738$var$isAncestorScope(Bi, e) {
  var Zi;
  let Qi = (Zi = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(e)) === null || Zi === void 0 ? void 0 : Zi.parent;
  for (; Qi; ) {
    if (Qi.scopeRef === Bi) return !0;
    Qi = Qi.parent;
  }
  return !1;
}
function $9bf71ea28793e738$var$focusElement(Bi, e = !1) {
  if (Bi != null && !e) try {
    $6a99195332edec8b$export$80f3e147d781571c(Bi);
  } catch {
  }
  else if (Bi != null) try {
    Bi.focus();
  } catch {
  }
}
function $9bf71ea28793e738$var$getFirstInScope(Bi, e = !0) {
  let Zi = Bi[0].previousElementSibling, Qi = $9bf71ea28793e738$var$getScopeRoot(Bi), ea = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Qi, {
    tabbable: e
  }, Bi);
  ea.currentNode = Zi;
  let ra = ea.nextNode();
  return e && !ra && (Qi = $9bf71ea28793e738$var$getScopeRoot(Bi), ea = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Qi, {
    tabbable: !1
  }, Bi), ea.currentNode = Zi, ra = ea.nextNode()), ra;
}
function $9bf71ea28793e738$var$focusFirstInScope(Bi, e = !0) {
  $9bf71ea28793e738$var$focusElement($9bf71ea28793e738$var$getFirstInScope(Bi, e));
}
function $9bf71ea28793e738$var$useAutoFocus(Bi, e) {
  const Zi = a__default.useRef(e);
  useEffect(() => {
    if (Zi.current) {
      $9bf71ea28793e738$var$activeScope = Bi;
      const Qi = $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0);
      !$9bf71ea28793e738$var$isElementInScope(Qi.activeElement, $9bf71ea28793e738$var$activeScope.current) && Bi.current && $9bf71ea28793e738$var$focusFirstInScope(Bi.current);
    }
    Zi.current = !1;
  }, [
    Bi
  ]);
}
function $9bf71ea28793e738$var$useActiveScopeTracker(Bi, e, Zi) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (e || Zi) return;
    let Qi = Bi.current;
    const ea = $431fbd86ca7dc216$export$b204af158042fbac(Qi ? Qi[0] : void 0);
    let ra = (na) => {
      let ia = na.target;
      $9bf71ea28793e738$var$isElementInScope(ia, Bi.current) ? $9bf71ea28793e738$var$activeScope = Bi : $9bf71ea28793e738$var$isElementInAnyScope(ia) || ($9bf71ea28793e738$var$activeScope = null);
    };
    return ea.addEventListener("focusin", ra, !1), Qi?.forEach((na) => na.addEventListener("focusin", ra, !1)), () => {
      ea.removeEventListener("focusin", ra, !1), Qi?.forEach((na) => na.removeEventListener("focusin", ra, !1));
    };
  }, [
    Bi,
    e,
    Zi
  ]);
}
function $9bf71ea28793e738$var$shouldRestoreFocus(Bi) {
  let e = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  for (; e && e.scopeRef !== Bi; ) {
    if (e.nodeToRestore) return !1;
    e = e.parent;
  }
  return e?.scopeRef === Bi;
}
function $9bf71ea28793e738$var$useRestoreFocus(Bi, e, Zi) {
  const Qi = useRef(typeof document < "u" ? $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0).activeElement : null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let ea = Bi.current;
    const ra = $431fbd86ca7dc216$export$b204af158042fbac(ea ? ea[0] : void 0);
    if (!e || Zi) return;
    let na = () => {
      (!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, Bi)) && $9bf71ea28793e738$var$isElementInScope(ra.activeElement, Bi.current) && ($9bf71ea28793e738$var$activeScope = Bi);
    };
    return ra.addEventListener("focusin", na, !1), ea?.forEach((ia) => ia.addEventListener("focusin", na, !1)), () => {
      ra.removeEventListener("focusin", na, !1), ea?.forEach((ia) => ia.removeEventListener("focusin", na, !1));
    };
  }, [
    Bi,
    Zi
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const ea = $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0);
    if (!e) return;
    let ra = (na) => {
      if (na.key !== "Tab" || na.altKey || na.ctrlKey || na.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(Bi) || na.isComposing) return;
      let ia = ea.activeElement;
      if (!$9bf71ea28793e738$var$isElementInChildScope(ia, Bi) || !$9bf71ea28793e738$var$shouldRestoreFocus(Bi)) return;
      let fa = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Bi);
      if (!fa) return;
      let La = fa.nodeToRestore, Va = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ea.body, {
        tabbable: !0
      });
      Va.currentNode = ia;
      let to = na.shiftKey ? Va.previousNode() : Va.nextNode();
      if ((!La || !ea.body.contains(La) || La === ea.body) && (La = void 0, fa.nodeToRestore = void 0), (!to || !$9bf71ea28793e738$var$isElementInChildScope(to, Bi)) && La) {
        Va.currentNode = La;
        do
          to = na.shiftKey ? Va.previousNode() : Va.nextNode();
        while ($9bf71ea28793e738$var$isElementInChildScope(to, Bi));
        na.preventDefault(), na.stopPropagation(), to ? $9bf71ea28793e738$var$focusElement(to, !0) : $9bf71ea28793e738$var$isElementInAnyScope(La) ? $9bf71ea28793e738$var$focusElement(La, !0) : ia.blur();
      }
    };
    return Zi || ea.addEventListener("keydown", ra, !0), () => {
      Zi || ea.removeEventListener("keydown", ra, !0);
    };
  }, [
    Bi,
    e,
    Zi
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const ea = $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0);
    if (!e) return;
    let ra = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Bi);
    if (ra) {
      var na;
      return ra.nodeToRestore = (na = Qi.current) !== null && na !== void 0 ? na : void 0, () => {
        let ia = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Bi);
        if (!ia) return;
        let fa = ia.nodeToRestore;
        if (e && fa && (ea.activeElement && $9bf71ea28793e738$var$isElementInChildScope(ea.activeElement, Bi) || ea.activeElement === ea.body && $9bf71ea28793e738$var$shouldRestoreFocus(Bi))) {
          let La = $9bf71ea28793e738$export$d06fae2ee68b101e.clone();
          requestAnimationFrame(() => {
            if (ea.activeElement === ea.body) {
              let Va = La.getTreeNode(Bi);
              for (; Va; ) {
                if (Va.nodeToRestore && Va.nodeToRestore.isConnected) {
                  $9bf71ea28793e738$var$restoreFocusToElement(Va.nodeToRestore);
                  return;
                }
                Va = Va.parent;
              }
              for (Va = La.getTreeNode(Bi); Va; ) {
                if (Va.scopeRef && Va.scopeRef.current && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Va.scopeRef)) {
                  let to = $9bf71ea28793e738$var$getFirstInScope(Va.scopeRef.current, !0);
                  $9bf71ea28793e738$var$restoreFocusToElement(to);
                  return;
                }
                Va = Va.parent;
              }
            }
          });
        }
      };
    }
  }, [
    Bi,
    e
  ]);
}
function $9bf71ea28793e738$var$restoreFocusToElement(Bi) {
  Bi.dispatchEvent(new CustomEvent($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, {
    bubbles: !0,
    cancelable: !0
  })) && $9bf71ea28793e738$var$focusElement(Bi);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(Bi, e, Zi) {
  let Qi = e?.tabbable ? $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR, ea = $431fbd86ca7dc216$export$b204af158042fbac(Bi).createTreeWalker(Bi, NodeFilter.SHOW_ELEMENT, {
    acceptNode(ra) {
      var na;
      return !(e == null || (na = e.from) === null || na === void 0) && na.contains(ra) ? NodeFilter.FILTER_REJECT : ra.matches(Qi) && $645f2e67b85a24c9$export$e989c0fffaa6b27a(ra) && (!Zi || $9bf71ea28793e738$var$isElementInScope(ra, Zi)) && (!e?.accept || e.accept(ra)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return e?.from && (ea.currentNode = e.from), ea;
}
class $9bf71ea28793e738$var$Tree {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(e) {
    return this.fastMap.get(e);
  }
  addTreeNode(e, Zi, Qi) {
    let ea = this.fastMap.get(Zi ?? null);
    if (!ea) return;
    let ra = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: e
    });
    ea.addChild(ra), ra.parent = ea, this.fastMap.set(e, ra), Qi && (ra.nodeToRestore = Qi);
  }
  addNode(e) {
    this.fastMap.set(e.scopeRef, e);
  }
  removeTreeNode(e) {
    if (e === null) return;
    let Zi = this.fastMap.get(e);
    if (!Zi) return;
    let Qi = Zi.parent;
    for (let ra of this.traverse()) ra !== Zi && Zi.nodeToRestore && ra.nodeToRestore && Zi.scopeRef && Zi.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(ra.nodeToRestore, Zi.scopeRef.current) && (ra.nodeToRestore = Zi.nodeToRestore);
    let ea = Zi.children;
    Qi && (Qi.removeChild(Zi), ea.size > 0 && ea.forEach((ra) => Qi && Qi.addChild(ra))), this.fastMap.delete(Zi.scopeRef);
  }
  // Pre Order Depth First
  *traverse(e = this.root) {
    if (e.scopeRef != null && (yield e), e.children.size > 0) for (let Zi of e.children) yield* this.traverse(Zi);
  }
  clone() {
    var e;
    let Zi = new $9bf71ea28793e738$var$Tree();
    var Qi;
    for (let ea of this.traverse()) Zi.addTreeNode(ea.scopeRef, (Qi = (e = ea.parent) === null || e === void 0 ? void 0 : e.scopeRef) !== null && Qi !== void 0 ? Qi : null, ea.nodeToRestore);
    return Zi;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class $9bf71ea28793e738$var$TreeNode {
  addChild(e) {
    this.children.add(e), e.parent = this;
  }
  removeChild(e) {
    this.children.delete(e), e.parent = void 0;
  }
  constructor(e) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = e.scopeRef;
  }
}
let $9bf71ea28793e738$export$d06fae2ee68b101e = new $9bf71ea28793e738$var$Tree();
function $f7dceffc5ad7768b$export$4e328f61c538687f(Bi = {}) {
  let { autoFocus: e = !1, isTextInput: Zi, within: Qi } = Bi, ea = useRef({
    isFocused: !1,
    isFocusVisible: e || $507fabe10e71c6fb$export$b9b3dfddab17db27()
  }), [ra, na] = useState(!1), [ia, fa] = useState(() => ea.current.isFocused && ea.current.isFocusVisible), La = useCallback(() => fa(ea.current.isFocused && ea.current.isFocusVisible), []), Va = useCallback((no) => {
    ea.current.isFocused = no, na(no), La();
  }, [
    La
  ]);
  $507fabe10e71c6fb$export$ec71b4b83ac08ec3((no) => {
    ea.current.isFocusVisible = no, La();
  }, [], {
    isTextInput: Zi
  });
  let { focusProps: to } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    isDisabled: Qi,
    onFocusChange: Va
  }), { focusWithinProps: ro } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !Qi,
    onFocusWithinChange: Va
  });
  return {
    isFocused: ra,
    isFocusVisible: ia,
    focusProps: Qi ? ro : to
  };
}
let $e6afbd83fe6ebbd2$var$FocusableContext = /* @__PURE__ */ a__default.createContext(null);
function $e6afbd83fe6ebbd2$var$useFocusableContext(Bi) {
  let e = useContext($e6afbd83fe6ebbd2$var$FocusableContext) || {};
  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(e, Bi);
  let { ref: Zi, ...Qi } = e;
  return Qi;
}
function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(Bi, e) {
  let { focusProps: Zi } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(Bi), { keyboardProps: Qi } = $46d819fcbaf35654$export$8f71654801c2f7cd(Bi), ea = $3ef42575df84b30b$export$9d1611c77c2fe928(Zi, Qi), ra = $e6afbd83fe6ebbd2$var$useFocusableContext(e), na = Bi.isDisabled ? {} : ra, ia = useRef(Bi.autoFocus);
  return useEffect(() => {
    ia.current && e.current && $6a99195332edec8b$export$80f3e147d781571c(e.current), ia.current = !1;
  }, [
    e
  ]), {
    focusableProps: $3ef42575df84b30b$export$9d1611c77c2fe928({
      ...ea,
      tabIndex: Bi.excludeFromTabOrder && !Bi.isDisabled ? -1 : void 0
    }, na)
  };
}
const $148a7a147e38ea7f$var$RTL_SCRIPTS = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), $148a7a147e38ea7f$var$RTL_LANGS = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function $148a7a147e38ea7f$export$702d680b21cbd764(Bi) {
  if (Intl.Locale) {
    let Zi = new Intl.Locale(Bi).maximize(), Qi = typeof Zi.getTextInfo == "function" ? Zi.getTextInfo() : Zi.textInfo;
    if (Qi) return Qi.direction === "rtl";
    if (Zi.script) return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(Zi.script);
  }
  let e = Bi.split("-")[0];
  return $148a7a147e38ea7f$var$RTL_LANGS.has(e);
}
const $1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
  let Bi = typeof window < "u" && window[$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      Bi
    ]);
  } catch {
    Bi = "en-US";
  }
  return {
    locale: Bi,
    direction: $148a7a147e38ea7f$export$702d680b21cbd764(Bi) ? "rtl" : "ltr"
  };
}
let $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5(), $1e5a04cdaf7d1af8$var$listeners = /* @__PURE__ */ new Set();
function $1e5a04cdaf7d1af8$var$updateLocale() {
  $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
  for (let Bi of $1e5a04cdaf7d1af8$var$listeners) Bi($1e5a04cdaf7d1af8$var$currentLocale);
}
function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
  let Bi = $b5e257d569688ac6$export$535bd6ca7f90a273(), [e, Zi] = useState($1e5a04cdaf7d1af8$var$currentLocale);
  return useEffect(() => ($1e5a04cdaf7d1af8$var$listeners.size === 0 && window.addEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale), $1e5a04cdaf7d1af8$var$listeners.add(Zi), () => {
    $1e5a04cdaf7d1af8$var$listeners.delete(Zi), $1e5a04cdaf7d1af8$var$listeners.size === 0 && window.removeEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
  }), []), Bi ? {
    locale: "en-US",
    direction: "ltr"
  } : e;
}
const $18f2051aff69b9bf$var$I18nContext = /* @__PURE__ */ a__default.createContext(null);
function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
  let Bi = $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
  return useContext($18f2051aff69b9bf$var$I18nContext) || Bi;
}
const $5b160d28a433310d$var$localeSymbol = Symbol.for("react-aria.i18n.locale"), $5b160d28a433310d$var$stringsSymbol = Symbol.for("react-aria.i18n.strings");
let $5b160d28a433310d$var$cachedGlobalStrings;
class $5b160d28a433310d$export$c17fa47878dc55b6 {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(e, Zi) {
    let ea = this.getStringsForLocale(Zi)[e];
    if (!ea) throw new Error(`Could not find intl message ${e} in ${Zi} locale`);
    return ea;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(e) {
    let Zi = this.strings[e];
    return Zi || (Zi = $5b160d28a433310d$var$getStringsForLocale(e, this.strings, this.defaultLocale), this.strings[e] = Zi), Zi;
  }
  static getGlobalDictionaryForPackage(e) {
    if (typeof window > "u") return null;
    let Zi = window[$5b160d28a433310d$var$localeSymbol];
    if ($5b160d28a433310d$var$cachedGlobalStrings === void 0) {
      let ea = window[$5b160d28a433310d$var$stringsSymbol];
      if (!ea) return null;
      $5b160d28a433310d$var$cachedGlobalStrings = {};
      for (let ra in ea) $5b160d28a433310d$var$cachedGlobalStrings[ra] = new $5b160d28a433310d$export$c17fa47878dc55b6({
        [Zi]: ea[ra]
      }, Zi);
    }
    let Qi = $5b160d28a433310d$var$cachedGlobalStrings?.[e];
    if (!Qi) throw new Error(`Strings for package "${e}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return Qi;
  }
  constructor(e, Zi = "en-US") {
    this.strings = Object.fromEntries(Object.entries(e).filter(([, Qi]) => Qi)), this.defaultLocale = Zi;
  }
}
function $5b160d28a433310d$var$getStringsForLocale(Bi, e, Zi = "en-US") {
  if (e[Bi]) return e[Bi];
  let Qi = $5b160d28a433310d$var$getLanguage(Bi);
  if (e[Qi]) return e[Qi];
  for (let ea in e)
    if (ea.startsWith(Qi + "-")) return e[ea];
  return e[Zi];
}
function $5b160d28a433310d$var$getLanguage(Bi) {
  return Intl.Locale ? new Intl.Locale(Bi).language : Bi.split("-")[0];
}
const $6db58dc88e78b024$var$pluralRulesCache = /* @__PURE__ */ new Map(), $6db58dc88e78b024$var$numberFormatCache = /* @__PURE__ */ new Map();
class $6db58dc88e78b024$export$2f817fcdc4b89ae0 {
  /** Formats a localized string for the given key with the provided variables. */
  format(e, Zi) {
    let Qi = this.strings.getStringForLocale(e, this.locale);
    return typeof Qi == "function" ? Qi(Zi, this) : Qi;
  }
  plural(e, Zi, Qi = "cardinal") {
    let ea = Zi["=" + e];
    if (ea) return typeof ea == "function" ? ea() : ea;
    let ra = this.locale + ":" + Qi, na = $6db58dc88e78b024$var$pluralRulesCache.get(ra);
    na || (na = new Intl.PluralRules(this.locale, {
      type: Qi
    }), $6db58dc88e78b024$var$pluralRulesCache.set(ra, na));
    let ia = na.select(e);
    return ea = Zi[ia] || Zi.other, typeof ea == "function" ? ea() : ea;
  }
  number(e) {
    let Zi = $6db58dc88e78b024$var$numberFormatCache.get(this.locale);
    return Zi || (Zi = new Intl.NumberFormat(this.locale), $6db58dc88e78b024$var$numberFormatCache.set(this.locale, Zi)), Zi.format(e);
  }
  select(e, Zi) {
    let Qi = e[Zi] || e.other;
    return typeof Qi == "function" ? Qi() : Qi;
  }
  constructor(e, Zi) {
    this.locale = e, this.strings = Zi;
  }
}
const $fca6afa0e843324b$var$cache = /* @__PURE__ */ new WeakMap();
function $fca6afa0e843324b$var$getCachedDictionary(Bi) {
  let e = $fca6afa0e843324b$var$cache.get(Bi);
  return e || (e = new $5b160d28a433310d$export$c17fa47878dc55b6(Bi), $fca6afa0e843324b$var$cache.set(Bi, e)), e;
}
function $fca6afa0e843324b$export$87b761675e8eaa10(Bi, e) {
  return e && $5b160d28a433310d$export$c17fa47878dc55b6.getGlobalDictionaryForPackage(e) || $fca6afa0e843324b$var$getCachedDictionary(Bi);
}
function $fca6afa0e843324b$export$f12b703ca79dfbb1(Bi, e) {
  let { locale: Zi } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), Qi = $fca6afa0e843324b$export$87b761675e8eaa10(Bi, e);
  return useMemo(() => new $6db58dc88e78b024$export$2f817fcdc4b89ae0(Zi, Qi), [
    Zi,
    Qi
  ]);
}
let $325a3faab7a68acd$var$cache = /* @__PURE__ */ new Map();
function $325a3faab7a68acd$export$a16aca283550c30d(Bi) {
  let { locale: e } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), Zi = e + (Bi ? Object.entries(Bi).sort((ea, ra) => ea[0] < ra[0] ? -1 : 1).join() : "");
  if ($325a3faab7a68acd$var$cache.has(Zi)) return $325a3faab7a68acd$var$cache.get(Zi);
  let Qi = new Intl.Collator(e, Bi);
  return $325a3faab7a68acd$var$cache.set(Zi, Qi), Qi;
}
function $701a24aa0da5b062$export$ea18c227d4417cc3(Bi, e) {
  let {
    elementType: Zi = "button",
    isDisabled: Qi,
    onPress: ea,
    onPressStart: ra,
    onPressEnd: na,
    onPressUp: ia,
    onPressChange: fa,
    preventFocusOnPress: La,
    allowFocusWhenDisabled: Va,
    // @ts-ignore
    onClick: to,
    href: ro,
    target: no,
    rel: eo,
    type: ao = "button"
  } = Bi, io;
  Zi === "button" ? io = {
    type: ao,
    disabled: Qi
  } : io = {
    role: "button",
    tabIndex: Qi ? void 0 : 0,
    href: Zi === "a" && !Qi ? ro : void 0,
    target: Zi === "a" ? no : void 0,
    type: Zi === "input" ? ao : void 0,
    disabled: Zi === "input" ? Qi : void 0,
    "aria-disabled": !Qi || Zi === "input" ? void 0 : Qi,
    rel: Zi === "a" ? eo : void 0
  };
  let { pressProps: xs, isPressed: Ts } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart: ra,
    onPressEnd: na,
    onPressChange: fa,
    onPress: ea,
    onPressUp: ia,
    isDisabled: Qi,
    preventFocusOnPress: La,
    ref: e
  }), { focusableProps: qs } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(Bi, e);
  Va && (qs.tabIndex = Qi ? -1 : qs.tabIndex);
  let Fs = $3ef42575df84b30b$export$9d1611c77c2fe928(qs, xs, $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }));
  return {
    isPressed: Ts,
    buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(io, Fs, {
      "aria-haspopup": Bi["aria-haspopup"],
      "aria-expanded": Bi["aria-expanded"],
      "aria-controls": Bi["aria-controls"],
      "aria-pressed": Bi["aria-pressed"],
      onClick: (Do) => {
        to && (to(Do), console.warn("onClick is deprecated, please use onPress"));
      }
    })
  };
}
const $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7e3;
let $319e236875307eab$var$liveAnnouncer = null;
function $319e236875307eab$export$a9b970dcc4ae71a9(Bi, e = "assertive", Zi = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
  $319e236875307eab$var$liveAnnouncer ? $319e236875307eab$var$liveAnnouncer.announce(Bi, e, Zi) : ($319e236875307eab$var$liveAnnouncer = new $319e236875307eab$var$LiveAnnouncer(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? $319e236875307eab$var$liveAnnouncer.announce(Bi, e, Zi) : setTimeout(() => {
    $319e236875307eab$var$liveAnnouncer?.isAttached() && $319e236875307eab$var$liveAnnouncer?.announce(Bi, e, Zi);
  }, 100));
}
class $319e236875307eab$var$LiveAnnouncer {
  isAttached() {
    var e;
    return (e = this.node) === null || e === void 0 ? void 0 : e.isConnected;
  }
  createLog(e) {
    let Zi = document.createElement("div");
    return Zi.setAttribute("role", "log"), Zi.setAttribute("aria-live", e), Zi.setAttribute("aria-relevant", "additions"), Zi;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(e, Zi = "assertive", Qi = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
    var ea, ra;
    if (!this.node) return;
    let na = document.createElement("div");
    typeof e == "object" ? (na.setAttribute("role", "img"), na.setAttribute("aria-labelledby", e["aria-labelledby"])) : na.textContent = e, Zi === "assertive" ? (ea = this.assertiveLog) === null || ea === void 0 || ea.appendChild(na) : (ra = this.politeLog) === null || ra === void 0 || ra.appendChild(na), e !== "" && setTimeout(() => {
      na.remove();
    }, Qi);
  }
  clear(e) {
    this.node && ((!e || e === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!e || e === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
const $e5be200c675c3b3a$export$aca958c65c314e6c = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = {
  ...$e5be200c675c3b3a$export$aca958c65c314e6c,
  customError: !0,
  valid: !1
}, $e5be200c675c3b3a$export$dad6ae84456c676a = {
  isInvalid: !1,
  validationDetails: $e5be200c675c3b3a$export$aca958c65c314e6c,
  validationErrors: []
}, $e5be200c675c3b3a$export$571b5131b7e65c11 = createContext({}), $e5be200c675c3b3a$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $e5be200c675c3b3a$export$fc1a364ae1f3ff10(Bi) {
  if (Bi[$e5be200c675c3b3a$export$a763b9476acd3eb]) {
    let { realtimeValidation: e, displayValidation: Zi, updateValidation: Qi, resetValidation: ea, commitValidation: ra } = Bi[$e5be200c675c3b3a$export$a763b9476acd3eb];
    return {
      realtimeValidation: e,
      displayValidation: Zi,
      updateValidation: Qi,
      resetValidation: ea,
      commitValidation: ra
    };
  }
  return $e5be200c675c3b3a$var$useFormValidationStateImpl(Bi);
}
function $e5be200c675c3b3a$var$useFormValidationStateImpl(Bi) {
  let { isInvalid: e, validationState: Zi, name: Qi, value: ea, builtinValidation: ra, validate: na, validationBehavior: ia = "aria" } = Bi;
  Zi && (e || (e = Zi === "invalid"));
  let fa = e !== void 0 ? {
    isInvalid: e,
    validationErrors: [],
    validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
  } : null, La = useMemo(() => {
    if (!na || ea == null) return null;
    let Xs = $e5be200c675c3b3a$var$runValidate(na, ea);
    return $e5be200c675c3b3a$var$getValidationResult(Xs);
  }, [
    na,
    ea
  ]);
  ra?.validationDetails.valid && (ra = void 0);
  let Va = useContext($e5be200c675c3b3a$export$571b5131b7e65c11), to = useMemo(() => Qi ? Array.isArray(Qi) ? Qi.flatMap((Xs) => $e5be200c675c3b3a$var$asArray(Va[Xs])) : $e5be200c675c3b3a$var$asArray(Va[Qi]) : [], [
    Va,
    Qi
  ]), [ro, no] = useState(Va), [eo, ao] = useState(!1);
  Va !== ro && (no(Va), ao(!1));
  let io = useMemo(() => $e5be200c675c3b3a$var$getValidationResult(eo ? [] : to), [
    eo,
    to
  ]), xs = useRef($e5be200c675c3b3a$export$dad6ae84456c676a), [Ts, qs] = useState($e5be200c675c3b3a$export$dad6ae84456c676a), Fs = useRef($e5be200c675c3b3a$export$dad6ae84456c676a), Do = () => {
    if (!ys) return;
    Io(!1);
    let Xs = La || ra || xs.current;
    $e5be200c675c3b3a$var$isEqualValidation(Xs, Fs.current) || (Fs.current = Xs, qs(Xs));
  }, [ys, Io] = useState(!1);
  return useEffect(Do), {
    realtimeValidation: fa || io || La || ra || $e5be200c675c3b3a$export$dad6ae84456c676a,
    displayValidation: ia === "native" ? fa || io || Ts : fa || io || La || ra || Ts,
    updateValidation(Xs) {
      ia === "aria" && !$e5be200c675c3b3a$var$isEqualValidation(Ts, Xs) ? qs(Xs) : xs.current = Xs;
    },
    resetValidation() {
      let Xs = $e5be200c675c3b3a$export$dad6ae84456c676a;
      $e5be200c675c3b3a$var$isEqualValidation(Xs, Fs.current) || (Fs.current = Xs, qs(Xs)), ia === "native" && Io(!1), ao(!0);
    },
    commitValidation() {
      ia === "native" && Io(!0), ao(!0);
    }
  };
}
function $e5be200c675c3b3a$var$asArray(Bi) {
  return Bi ? Array.isArray(Bi) ? Bi : [
    Bi
  ] : [];
}
function $e5be200c675c3b3a$var$runValidate(Bi, e) {
  if (typeof Bi == "function") {
    let Zi = Bi(e);
    if (Zi && typeof Zi != "boolean") return $e5be200c675c3b3a$var$asArray(Zi);
  }
  return [];
}
function $e5be200c675c3b3a$var$getValidationResult(Bi) {
  return Bi.length ? {
    isInvalid: !0,
    validationErrors: Bi,
    validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
  } : null;
}
function $e5be200c675c3b3a$var$isEqualValidation(Bi, e) {
  return Bi === e ? !0 : !!Bi && !!e && Bi.isInvalid === e.isInvalid && Bi.validationErrors.length === e.validationErrors.length && Bi.validationErrors.every((Zi, Qi) => Zi === e.validationErrors[Qi]) && Object.entries(Bi.validationDetails).every(([Zi, Qi]) => e.validationDetails[Zi] === Qi);
}
function $e93e671b31057976$export$b8473d3665f3a75a(Bi, e, Zi) {
  let { validationBehavior: Qi, focus: ea } = Bi;
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (Qi === "native" && Zi?.current && !Zi.current.disabled) {
      let fa = e.realtimeValidation.isInvalid ? e.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      Zi.current.setCustomValidity(fa), Zi.current.hasAttribute("title") || (Zi.current.title = ""), e.realtimeValidation.isInvalid || e.updateValidation($e93e671b31057976$var$getNativeValidity(Zi.current));
    }
  });
  let ra = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    e.resetValidation();
  }), na = $8ae05eaa5c114e9c$export$7f54fc3180508a52((fa) => {
    var La;
    e.displayValidation.isInvalid || e.commitValidation();
    let Va = Zi == null || (La = Zi.current) === null || La === void 0 ? void 0 : La.form;
    if (!fa.defaultPrevented && Zi && Va && $e93e671b31057976$var$getFirstInvalidInput(Va) === Zi.current) {
      var to;
      ea ? ea() : (to = Zi.current) === null || to === void 0 || to.focus(), $507fabe10e71c6fb$export$8397ddfc504fdb9a("keyboard");
    }
    fa.preventDefault();
  }), ia = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    e.commitValidation();
  });
  useEffect(() => {
    let fa = Zi?.current;
    if (!fa) return;
    let La = fa.form;
    return fa.addEventListener("invalid", na), fa.addEventListener("change", ia), La?.addEventListener("reset", ra), () => {
      fa.removeEventListener("invalid", na), fa.removeEventListener("change", ia), La?.removeEventListener("reset", ra);
    };
  }, [
    Zi,
    na,
    ia,
    ra,
    Qi
  ]);
}
function $e93e671b31057976$var$getValidity(Bi) {
  let e = Bi.validity;
  return {
    badInput: e.badInput,
    customError: e.customError,
    patternMismatch: e.patternMismatch,
    rangeOverflow: e.rangeOverflow,
    rangeUnderflow: e.rangeUnderflow,
    stepMismatch: e.stepMismatch,
    tooLong: e.tooLong,
    tooShort: e.tooShort,
    typeMismatch: e.typeMismatch,
    valueMissing: e.valueMissing,
    valid: e.valid
  };
}
function $e93e671b31057976$var$getNativeValidity(Bi) {
  return {
    isInvalid: !Bi.validity.valid,
    validationDetails: $e93e671b31057976$var$getValidity(Bi),
    validationErrors: Bi.validationMessage ? [
      Bi.validationMessage
    ] : []
  };
}
function $e93e671b31057976$var$getFirstInvalidInput(Bi) {
  for (let e = 0; e < Bi.elements.length; e++) {
    let Zi = Bi.elements[e];
    if (!Zi.validity.valid) return Zi;
  }
  return null;
}
function $d191a55c9702f145$export$8467354a121f1b9f(Bi) {
  let { id: e, label: Zi, "aria-labelledby": Qi, "aria-label": ea, labelElementType: ra = "label" } = Bi;
  e = $bdb11010cef70236$export$f680877a34711e37(e);
  let na = $bdb11010cef70236$export$f680877a34711e37(), ia = {};
  Zi ? (Qi = Qi ? `${na} ${Qi}` : na, ia = {
    id: na,
    htmlFor: ra === "label" ? e : void 0
  }) : !Qi && !ea && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let fa = $313b98861ee5dd6c$export$d6875122194c7b44({
    id: e,
    "aria-label": ea,
    "aria-labelledby": Qi
  });
  return {
    labelProps: ia,
    fieldProps: fa
  };
}
function $2baaea4c71418dea$export$294aa081a6c6f55d(Bi) {
  let { description: e, errorMessage: Zi, isInvalid: Qi, validationState: ea } = Bi, { labelProps: ra, fieldProps: na } = $d191a55c9702f145$export$8467354a121f1b9f(Bi), ia = $bdb11010cef70236$export$b4cc09c592e8fdb8([
    !!e,
    !!Zi,
    Qi,
    ea
  ]), fa = $bdb11010cef70236$export$b4cc09c592e8fdb8([
    !!e,
    !!Zi,
    Qi,
    ea
  ]);
  return na = $3ef42575df84b30b$export$9d1611c77c2fe928(na, {
    "aria-describedby": [
      ia,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      fa,
      Bi["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: ra,
    fieldProps: na,
    descriptionProps: {
      id: ia
    },
    errorMessageProps: {
      id: fa
    }
  };
}
const $5c3e21d68f1c4674$var$styles = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function $5c3e21d68f1c4674$export$a966af930f325cab(Bi = {}) {
  let { style: e, isFocusable: Zi } = Bi, [Qi, ea] = useState(!1), { focusWithinProps: ra } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !Zi,
    onFocusWithinChange: (ia) => ea(ia)
  }), na = useMemo(() => Qi ? e : e ? {
    ...$5c3e21d68f1c4674$var$styles,
    ...e
  } : $5c3e21d68f1c4674$var$styles, [
    Qi
  ]);
  return {
    visuallyHiddenProps: {
      ...ra,
      style: na
    }
  };
}
function $5c3e21d68f1c4674$export$439d29a4e110a164(Bi) {
  let { children: e, elementType: Zi = "div", isFocusable: Qi, style: ea, ...ra } = Bi, { visuallyHiddenProps: na } = $5c3e21d68f1c4674$export$a966af930f325cab(Bi);
  return /* @__PURE__ */ a__default.createElement(Zi, $3ef42575df84b30b$export$9d1611c77c2fe928(ra, na), e);
}
const $edcf132a9284368a$var$AXIS = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, $edcf132a9284368a$var$FLIPPED_DIRECTION = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, $edcf132a9284368a$var$CROSS_AXIS = {
  top: "left",
  left: "top"
}, $edcf132a9284368a$var$AXIS_SIZE = {
  top: "height",
  left: "width"
}, $edcf132a9284368a$var$TOTAL_SIZE = {
  width: "totalWidth",
  height: "totalHeight"
}, $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
let $edcf132a9284368a$var$visualViewport = typeof document < "u" ? window.visualViewport : null;
function $edcf132a9284368a$var$getContainerDimensions(Bi) {
  let e = 0, Zi = 0, Qi = 0, ea = 0, ra = 0, na = 0, ia = {};
  var fa;
  let La = ((fa = $edcf132a9284368a$var$visualViewport?.scale) !== null && fa !== void 0 ? fa : 1) > 1;
  if (Bi.tagName === "BODY") {
    let eo = document.documentElement;
    Qi = eo.clientWidth, ea = eo.clientHeight;
    var Va;
    e = (Va = $edcf132a9284368a$var$visualViewport?.width) !== null && Va !== void 0 ? Va : Qi;
    var to;
    Zi = (to = $edcf132a9284368a$var$visualViewport?.height) !== null && to !== void 0 ? to : ea, ia.top = eo.scrollTop || Bi.scrollTop, ia.left = eo.scrollLeft || Bi.scrollLeft, $edcf132a9284368a$var$visualViewport && (ra = $edcf132a9284368a$var$visualViewport.offsetTop, na = $edcf132a9284368a$var$visualViewport.offsetLeft);
  } else
    ({ width: e, height: Zi, top: ra, left: na } = $edcf132a9284368a$var$getOffset(Bi)), ia.top = Bi.scrollTop, ia.left = Bi.scrollLeft, Qi = e, ea = Zi;
  if ($c87311424ea30a05$export$78551043582a6a98() && (Bi.tagName === "BODY" || Bi.tagName === "HTML") && La) {
    ia.top = 0, ia.left = 0;
    var ro;
    ra = (ro = $edcf132a9284368a$var$visualViewport?.pageTop) !== null && ro !== void 0 ? ro : 0;
    var no;
    na = (no = $edcf132a9284368a$var$visualViewport?.pageLeft) !== null && no !== void 0 ? no : 0;
  }
  return {
    width: e,
    height: Zi,
    totalWidth: Qi,
    totalHeight: ea,
    scroll: ia,
    top: ra,
    left: na
  };
}
function $edcf132a9284368a$var$getScroll(Bi) {
  return {
    top: Bi.scrollTop,
    left: Bi.scrollLeft,
    width: Bi.scrollWidth,
    height: Bi.scrollHeight
  };
}
function $edcf132a9284368a$var$getDelta(Bi, e, Zi, Qi, ea, ra, na) {
  var ia;
  let fa = (ia = ea.scroll[Bi]) !== null && ia !== void 0 ? ia : 0, La = Qi[$edcf132a9284368a$var$AXIS_SIZE[Bi]], Va = Qi.scroll[$edcf132a9284368a$var$AXIS[Bi]] + ra, to = La + Qi.scroll[$edcf132a9284368a$var$AXIS[Bi]] - ra, ro = e - fa + na[Bi] - Qi[$edcf132a9284368a$var$AXIS[Bi]], no = e - fa + Zi + na[Bi] - Qi[$edcf132a9284368a$var$AXIS[Bi]];
  return ro < Va ? Va - ro : no > to ? Math.max(to - no, Va - ro) : 0;
}
function $edcf132a9284368a$var$getMargins(Bi) {
  let e = window.getComputedStyle(Bi);
  return {
    top: parseInt(e.marginTop, 10) || 0,
    bottom: parseInt(e.marginBottom, 10) || 0,
    left: parseInt(e.marginLeft, 10) || 0,
    right: parseInt(e.marginRight, 10) || 0
  };
}
function $edcf132a9284368a$var$parsePlacement(Bi) {
  if ($edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi]) return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi];
  let [e, Zi] = Bi.split(" "), Qi = $edcf132a9284368a$var$AXIS[e] || "right", ea = $edcf132a9284368a$var$CROSS_AXIS[Qi];
  $edcf132a9284368a$var$AXIS[Zi] || (Zi = "center");
  let ra = $edcf132a9284368a$var$AXIS_SIZE[Qi], na = $edcf132a9284368a$var$AXIS_SIZE[ea];
  return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi] = {
    placement: e,
    crossPlacement: Zi,
    axis: Qi,
    crossAxis: ea,
    size: ra,
    crossSize: na
  }, $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi];
}
function $edcf132a9284368a$var$computePosition(Bi, e, Zi, Qi, ea, ra, na, ia, fa, La) {
  let { placement: Va, crossPlacement: to, axis: ro, crossAxis: no, size: eo, crossSize: ao } = Qi, io = {};
  var xs;
  io[no] = (xs = Bi[no]) !== null && xs !== void 0 ? xs : 0;
  var Ts, qs, Fs, Do;
  to === "center" ? io[no] += (((Ts = Bi[ao]) !== null && Ts !== void 0 ? Ts : 0) - ((qs = Zi[ao]) !== null && qs !== void 0 ? qs : 0)) / 2 : to !== no && (io[no] += ((Fs = Bi[ao]) !== null && Fs !== void 0 ? Fs : 0) - ((Do = Zi[ao]) !== null && Do !== void 0 ? Do : 0)), io[no] += ra;
  const ys = Bi[no] - Zi[ao] + fa + La, Io = Bi[no] + Bi[ao] - fa - La;
  if (io[no] = $9446cca9a3875146$export$7d15b64cf5a3a4c4(io[no], ys, Io), Va === ro) {
    const so = ia ? na[eo] : e[$edcf132a9284368a$var$TOTAL_SIZE[eo]];
    io[$edcf132a9284368a$var$FLIPPED_DIRECTION[ro]] = Math.floor(so - Bi[ro] + ea);
  } else io[ro] = Math.floor(Bi[ro] + Bi[eo] + ea);
  return io;
}
function $edcf132a9284368a$var$getMaxHeight(Bi, e, Zi, Qi, ea, ra, na, ia) {
  const fa = Qi ? Zi.height : e[$edcf132a9284368a$var$TOTAL_SIZE.height];
  var La;
  let Va = Bi.top != null ? Zi.top + Bi.top : Zi.top + (fa - ((La = Bi.bottom) !== null && La !== void 0 ? La : 0) - na);
  var to, ro, no, eo, ao, io;
  let xs = ia !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, e.height + e.top + ((to = e.scroll.top) !== null && to !== void 0 ? to : 0) - Va - (((ro = ea.top) !== null && ro !== void 0 ? ro : 0) + ((no = ea.bottom) !== null && no !== void 0 ? no : 0) + ra))
  ) : Math.max(0, Va + na - (e.top + ((eo = e.scroll.top) !== null && eo !== void 0 ? eo : 0)) - (((ao = ea.top) !== null && ao !== void 0 ? ao : 0) + ((io = ea.bottom) !== null && io !== void 0 ? io : 0) + ra));
  return Math.min(e.height - ra * 2, xs);
}
function $edcf132a9284368a$var$getAvailableSpace(Bi, e, Zi, Qi, ea, ra) {
  let { placement: na, axis: ia, size: fa } = ra;
  var La, Va;
  if (na === ia) return Math.max(0, Zi[ia] - Bi[ia] - ((La = Bi.scroll[ia]) !== null && La !== void 0 ? La : 0) + e[ia] - ((Va = Qi[ia]) !== null && Va !== void 0 ? Va : 0) - Qi[$edcf132a9284368a$var$FLIPPED_DIRECTION[ia]] - ea);
  var to;
  return Math.max(0, Bi[fa] + Bi[ia] + Bi.scroll[ia] - e[ia] - Zi[ia] - Zi[fa] - ((to = Qi[ia]) !== null && to !== void 0 ? to : 0) - Qi[$edcf132a9284368a$var$FLIPPED_DIRECTION[ia]] - ea);
}
function $edcf132a9284368a$export$6839422d1f33cee9(Bi, e, Zi, Qi, ea, ra, na, ia, fa, La, Va, to, ro, no, eo, ao) {
  let io = $edcf132a9284368a$var$parsePlacement(Bi), { size: xs, crossAxis: Ts, crossSize: qs, placement: Fs, crossPlacement: Do } = io, ys = $edcf132a9284368a$var$computePosition(e, ia, Zi, io, Va, to, La, ro, eo, ao), Io = Va, so = $edcf132a9284368a$var$getAvailableSpace(ia, La, e, ea, ra + Va, io);
  if (na && Qi[xs] > so) {
    let bl = $edcf132a9284368a$var$parsePlacement(`${$edcf132a9284368a$var$FLIPPED_DIRECTION[Fs]} ${Do}`), Pl = $edcf132a9284368a$var$computePosition(e, ia, Zi, bl, Va, to, La, ro, eo, ao);
    $edcf132a9284368a$var$getAvailableSpace(ia, La, e, ea, ra + Va, bl) > so && (io = bl, ys = Pl, Io = Va);
  }
  let os = "bottom";
  io.axis === "top" ? io.placement === "top" ? os = "top" : io.placement === "bottom" && (os = "bottom") : io.crossAxis === "top" && (io.crossPlacement === "top" ? os = "bottom" : io.crossPlacement === "bottom" && (os = "top"));
  let Xs = $edcf132a9284368a$var$getDelta(Ts, ys[Ts], Zi[qs], ia, fa, ra, La);
  ys[Ts] += Xs;
  let gl = $edcf132a9284368a$var$getMaxHeight(ys, ia, La, ro, ea, ra, Zi.height, os);
  no && no < gl && (gl = no), Zi.height = Math.min(Zi.height, gl), ys = $edcf132a9284368a$var$computePosition(e, ia, Zi, io, Io, to, La, ro, eo, ao), Xs = $edcf132a9284368a$var$getDelta(Ts, ys[Ts], Zi[qs], ia, fa, ra, La), ys[Ts] += Xs;
  let Sl = {}, El = e[Ts] + 0.5 * e[qs] - ys[Ts] - ea[$edcf132a9284368a$var$AXIS[Ts]];
  const wl = eo / 2 + ao;
  var jl, kl, Fl, Ml;
  const ql = $edcf132a9284368a$var$AXIS[Ts] === "left" ? ((jl = ea.left) !== null && jl !== void 0 ? jl : 0) + ((kl = ea.right) !== null && kl !== void 0 ? kl : 0) : ((Fl = ea.top) !== null && Fl !== void 0 ? Fl : 0) + ((Ml = ea.bottom) !== null && Ml !== void 0 ? Ml : 0), Kl = Zi[qs] - ql - eo / 2 - ao, Zl = e[Ts] + eo / 2 - (ys[Ts] + ea[$edcf132a9284368a$var$AXIS[Ts]]), Il = e[Ts] + e[qs] - eo / 2 - (ys[Ts] + ea[$edcf132a9284368a$var$AXIS[Ts]]), xl = $9446cca9a3875146$export$7d15b64cf5a3a4c4(El, Zl, Il);
  return Sl[Ts] = $9446cca9a3875146$export$7d15b64cf5a3a4c4(xl, wl, Kl), {
    position: ys,
    maxHeight: gl,
    arrowOffsetLeft: Sl.left,
    arrowOffsetTop: Sl.top,
    placement: io.placement
  };
}
function $edcf132a9284368a$export$b3ceb0cbf1056d98(Bi) {
  let { placement: e, targetNode: Zi, overlayNode: Qi, scrollNode: ea, padding: ra, shouldFlip: na, boundaryElement: ia, offset: fa, crossOffset: La, maxHeight: Va, arrowSize: to = 0, arrowBoundaryOffset: ro = 0 } = Bi, no = Qi instanceof HTMLElement ? $edcf132a9284368a$var$getContainingBlock(Qi) : document.documentElement, eo = no === document.documentElement;
  const ao = window.getComputedStyle(no).position;
  let io = !!ao && ao !== "static", xs = eo ? $edcf132a9284368a$var$getOffset(Zi) : $edcf132a9284368a$var$getPosition(Zi, no);
  if (!eo) {
    let { marginTop: Sl, marginLeft: El } = window.getComputedStyle(Zi);
    xs.top += parseInt(Sl, 10) || 0, xs.left += parseInt(El, 10) || 0;
  }
  let Ts = $edcf132a9284368a$var$getOffset(Qi), qs = $edcf132a9284368a$var$getMargins(Qi);
  var Fs, Do;
  Ts.width += ((Fs = qs.left) !== null && Fs !== void 0 ? Fs : 0) + ((Do = qs.right) !== null && Do !== void 0 ? Do : 0);
  var ys, Io;
  Ts.height += ((ys = qs.top) !== null && ys !== void 0 ? ys : 0) + ((Io = qs.bottom) !== null && Io !== void 0 ? Io : 0);
  let so = $edcf132a9284368a$var$getScroll(ea), os = $edcf132a9284368a$var$getContainerDimensions(ia), Xs = $edcf132a9284368a$var$getContainerDimensions(no), gl = ia.tagName === "BODY" ? $edcf132a9284368a$var$getOffset(no) : $edcf132a9284368a$var$getPosition(no, ia);
  return no.tagName === "HTML" && ia.tagName === "BODY" && (Xs.scroll.top = 0, Xs.scroll.left = 0), $edcf132a9284368a$export$6839422d1f33cee9(e, xs, Ts, so, qs, ra, na, os, Xs, gl, fa, La, io, Va, to, ro);
}
function $edcf132a9284368a$var$getOffset(Bi) {
  let { top: e, left: Zi, width: Qi, height: ea } = Bi.getBoundingClientRect(), { scrollTop: ra, scrollLeft: na, clientTop: ia, clientLeft: fa } = document.documentElement;
  return {
    top: e + ra - ia,
    left: Zi + na - fa,
    width: Qi,
    height: ea
  };
}
function $edcf132a9284368a$var$getPosition(Bi, e) {
  let Zi = window.getComputedStyle(Bi), Qi;
  if (Zi.position === "fixed") {
    let { top: ea, left: ra, width: na, height: ia } = Bi.getBoundingClientRect();
    Qi = {
      top: ea,
      left: ra,
      width: na,
      height: ia
    };
  } else {
    Qi = $edcf132a9284368a$var$getOffset(Bi);
    let ea = $edcf132a9284368a$var$getOffset(e), ra = window.getComputedStyle(e);
    ea.top += (parseInt(ra.borderTopWidth, 10) || 0) - e.scrollTop, ea.left += (parseInt(ra.borderLeftWidth, 10) || 0) - e.scrollLeft, Qi.top -= ea.top, Qi.left -= ea.left;
  }
  return Qi.top -= parseInt(Zi.marginTop, 10) || 0, Qi.left -= parseInt(Zi.marginLeft, 10) || 0, Qi;
}
function $edcf132a9284368a$var$getContainingBlock(Bi) {
  let e = Bi.offsetParent;
  if (e && e === document.body && window.getComputedStyle(e).position === "static" && !$edcf132a9284368a$var$isContainingBlock(e) && (e = document.documentElement), e == null)
    for (e = Bi.parentElement; e && !$edcf132a9284368a$var$isContainingBlock(e); ) e = e.parentElement;
  return e || document.documentElement;
}
function $edcf132a9284368a$var$isContainingBlock(Bi) {
  let e = window.getComputedStyle(Bi);
  return e.transform !== "none" || /transform|perspective/.test(e.willChange) || e.filter !== "none" || e.contain === "paint" || "backdropFilter" in e && e.backdropFilter !== "none" || "WebkitBackdropFilter" in e && e.WebkitBackdropFilter !== "none";
}
const $dd149f63282afbbf$export$f6211563215e3b37 = /* @__PURE__ */ new WeakMap();
function $dd149f63282afbbf$export$18fc8428861184da(Bi) {
  let { triggerRef: e, isOpen: Zi, onClose: Qi } = Bi;
  useEffect(() => {
    if (!Zi || Qi === null) return;
    let ea = (ra) => {
      let na = ra.target;
      if (!e.current || na instanceof Node && !na.contains(e.current) || ra.target instanceof HTMLInputElement || ra.target instanceof HTMLTextAreaElement) return;
      let ia = Qi || $dd149f63282afbbf$export$f6211563215e3b37.get(e.current);
      ia && ia();
    };
    return window.addEventListener("scroll", ea, !0), () => {
      window.removeEventListener("scroll", ea, !0);
    };
  }, [
    Zi,
    Qi,
    e
  ]);
}
let $2a41e45df1593e64$var$visualViewport = typeof document < "u" ? window.visualViewport : null;
function $2a41e45df1593e64$export$d39e1813b3bdd0e1(Bi) {
  let { direction: e } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), { arrowSize: Zi = 0, targetRef: Qi, overlayRef: ea, scrollRef: ra = ea, placement: na = "bottom", containerPadding: ia = 12, shouldFlip: fa = !0, boundaryElement: La = typeof document < "u" ? document.body : null, offset: Va = 0, crossOffset: to = 0, shouldUpdatePosition: ro = !0, isOpen: no = !0, onClose: eo, maxHeight: ao, arrowBoundaryOffset: io = 0 } = Bi, [xs, Ts] = useState(null), qs = [
    ro,
    na,
    ea.current,
    Qi.current,
    ra.current,
    ia,
    fa,
    La,
    Va,
    to,
    no,
    e,
    ao,
    io,
    Zi
  ], Fs = useRef($2a41e45df1593e64$var$visualViewport?.scale);
  useEffect(() => {
    no && (Fs.current = $2a41e45df1593e64$var$visualViewport?.scale);
  }, [
    no
  ]);
  let Do = useCallback(() => {
    if (ro === !1 || !no || !ea.current || !Qi.current || !La || $2a41e45df1593e64$var$visualViewport?.scale !== Fs.current) return;
    let Xs = null;
    if (ra.current && ra.current.contains(document.activeElement)) {
      var gl;
      let Ml = (gl = document.activeElement) === null || gl === void 0 ? void 0 : gl.getBoundingClientRect(), ql = ra.current.getBoundingClientRect();
      var Sl;
      if (Xs = {
        type: "top",
        offset: ((Sl = Ml?.top) !== null && Sl !== void 0 ? Sl : 0) - ql.top
      }, Xs.offset > ql.height / 2) {
        Xs.type = "bottom";
        var El;
        Xs.offset = ((El = Ml?.bottom) !== null && El !== void 0 ? El : 0) - ql.bottom;
      }
    }
    let wl = ea.current;
    if (!ao && ea.current) {
      var jl;
      wl.style.top = "0px", wl.style.bottom = "";
      var kl;
      wl.style.maxHeight = ((kl = (jl = window.visualViewport) === null || jl === void 0 ? void 0 : jl.height) !== null && kl !== void 0 ? kl : window.innerHeight) + "px";
    }
    let Fl = $edcf132a9284368a$export$b3ceb0cbf1056d98({
      placement: $2a41e45df1593e64$var$translateRTL(na, e),
      overlayNode: ea.current,
      targetNode: Qi.current,
      scrollNode: ra.current || ea.current,
      padding: ia,
      shouldFlip: fa,
      boundaryElement: La,
      offset: Va,
      crossOffset: to,
      maxHeight: ao,
      arrowSize: Zi,
      arrowBoundaryOffset: io
    });
    if (Fl.position) {
      if (wl.style.top = "", wl.style.bottom = "", wl.style.left = "", wl.style.right = "", Object.keys(Fl.position).forEach((Ml) => wl.style[Ml] = Fl.position[Ml] + "px"), wl.style.maxHeight = Fl.maxHeight != null ? Fl.maxHeight + "px" : "", Xs && document.activeElement && ra.current) {
        let Ml = document.activeElement.getBoundingClientRect(), ql = ra.current.getBoundingClientRect(), Kl = Ml[Xs.type] - ql[Xs.type];
        ra.current.scrollTop += Kl - Xs.offset;
      }
      Ts(Fl);
    }
  }, qs);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(Do, qs), $2a41e45df1593e64$var$useResize(Do), $9daab02d461809db$export$683480f191c0e3ea({
    ref: ea,
    onResize: Do
  }), $9daab02d461809db$export$683480f191c0e3ea({
    ref: Qi,
    onResize: Do
  });
  let ys = useRef(!1);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let Xs, gl = () => {
      ys.current = !0, clearTimeout(Xs), Xs = setTimeout(() => {
        ys.current = !1;
      }, 500), Do();
    }, Sl = () => {
      ys.current && gl();
    };
    return $2a41e45df1593e64$var$visualViewport?.addEventListener("resize", gl), $2a41e45df1593e64$var$visualViewport?.addEventListener("scroll", Sl), () => {
      $2a41e45df1593e64$var$visualViewport?.removeEventListener("resize", gl), $2a41e45df1593e64$var$visualViewport?.removeEventListener("scroll", Sl);
    };
  }, [
    Do
  ]);
  let Io = useCallback(() => {
    ys.current || eo?.();
  }, [
    eo,
    ys
  ]);
  $dd149f63282afbbf$export$18fc8428861184da({
    triggerRef: Qi,
    isOpen: no,
    onClose: eo && Io
  });
  var so, os;
  return {
    overlayProps: {
      style: {
        position: "absolute",
        zIndex: 1e5,
        ...xs?.position,
        maxHeight: (so = xs?.maxHeight) !== null && so !== void 0 ? so : "100vh"
      }
    },
    placement: (os = xs?.placement) !== null && os !== void 0 ? os : null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: xs?.arrowOffsetLeft,
        top: xs?.arrowOffsetTop
      }
    },
    updatePosition: Do
  };
}
function $2a41e45df1593e64$var$useResize(Bi) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => (window.addEventListener("resize", Bi, !1), () => {
    window.removeEventListener("resize", Bi, !1);
  }), [
    Bi
  ]);
}
function $2a41e45df1593e64$var$translateRTL(Bi, e) {
  return e === "rtl" ? Bi.replace("start", "right").replace("end", "left") : Bi.replace("start", "left").replace("end", "right");
}
const $a11501f3d1d39e6c$var$visibleOverlays = [];
function $a11501f3d1d39e6c$export$ea8f71083e90600f(Bi, e) {
  let { onClose: Zi, shouldCloseOnBlur: Qi, isOpen: ea, isDismissable: ra = !1, isKeyboardDismissDisabled: na = !1, shouldCloseOnInteractOutside: ia } = Bi;
  useEffect(() => (ea && $a11501f3d1d39e6c$var$visibleOverlays.push(e), () => {
    let eo = $a11501f3d1d39e6c$var$visibleOverlays.indexOf(e);
    eo >= 0 && $a11501f3d1d39e6c$var$visibleOverlays.splice(eo, 1);
  }), [
    ea,
    e
  ]);
  let fa = () => {
    $a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === e && Zi && Zi();
  }, La = (eo) => {
    (!ia || ia(eo.target)) && $a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === e && (eo.stopPropagation(), eo.preventDefault());
  }, Va = (eo) => {
    (!ia || ia(eo.target)) && ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === e && (eo.stopPropagation(), eo.preventDefault()), fa());
  }, to = (eo) => {
    eo.key === "Escape" && !na && !eo.nativeEvent.isComposing && (eo.stopPropagation(), eo.preventDefault(), fa());
  };
  $e0b6e0b68ec7f50f$export$872b660ac5a1ff98({
    ref: e,
    onInteractOutside: ra && ea ? Va : void 0,
    onInteractOutsideStart: La
  });
  let { focusWithinProps: ro } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !Qi,
    onBlurWithin: (eo) => {
      !eo.relatedTarget || $9bf71ea28793e738$export$1258395f99bf9cbf(eo.relatedTarget) || (!ia || ia(eo.relatedTarget)) && Zi?.();
    }
  }), no = (eo) => {
    eo.target === eo.currentTarget && eo.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown: to,
      ...ro
    },
    underlayProps: {
      onPointerDown: no
    }
  };
}
function $628037886ba31236$export$f9d5c8beee7d008d(Bi, e, Zi) {
  let { type: Qi } = Bi, { isOpen: ea } = e;
  useEffect(() => {
    Zi && Zi.current && $dd149f63282afbbf$export$f6211563215e3b37.set(Zi.current, e.close);
  });
  let ra;
  Qi === "menu" ? ra = !0 : Qi === "listbox" && (ra = "listbox");
  let na = $bdb11010cef70236$export$f680877a34711e37();
  return {
    triggerProps: {
      "aria-haspopup": ra,
      "aria-expanded": ea,
      "aria-controls": ea ? na : void 0,
      onPress: e.toggle
    },
    overlayProps: {
      id: na
    }
  };
}
const $49c51c25361d4cd2$var$visualViewport = typeof document < "u" && window.visualViewport, $49c51c25361d4cd2$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let $49c51c25361d4cd2$var$preventScrollCount = 0, $49c51c25361d4cd2$var$restore;
function $49c51c25361d4cd2$export$ee0f7cc6afcd1c18(Bi = {}) {
  let { isDisabled: e } = Bi;
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (!e)
      return $49c51c25361d4cd2$var$preventScrollCount++, $49c51c25361d4cd2$var$preventScrollCount === 1 && ($c87311424ea30a05$export$fedb369cb70207f1() ? $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollMobileSafari() : $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollStandard()), () => {
        $49c51c25361d4cd2$var$preventScrollCount--, $49c51c25361d4cd2$var$preventScrollCount === 0 && $49c51c25361d4cd2$var$restore();
      };
  }, [
    e
  ]);
}
function $49c51c25361d4cd2$var$preventScrollStandard() {
  return $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
function $49c51c25361d4cd2$var$preventScrollMobileSafari() {
  let Bi, e, Zi = (La) => {
    Bi = $62d8ded9296f3872$export$cfa2225e87938781(La.target, !0), !(Bi === document.documentElement && Bi === document.body) && Bi instanceof HTMLElement && window.getComputedStyle(Bi).overscrollBehavior === "auto" && (e = $49c51c25361d4cd2$var$setStyle(Bi, "overscrollBehavior", "contain"));
  }, Qi = (La) => {
    if (!Bi || Bi === document.documentElement || Bi === document.body) {
      La.preventDefault();
      return;
    }
    Bi.scrollHeight === Bi.clientHeight && Bi.scrollWidth === Bi.clientWidth && La.preventDefault();
  }, ea = () => {
    e && e();
  }, ra = (La) => {
    let Va = La.target;
    $49c51c25361d4cd2$var$willOpenKeyboard(Va) && (ia(), Va.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      Va.style.transform = "", $49c51c25361d4cd2$var$visualViewport && ($49c51c25361d4cd2$var$visualViewport.height < window.innerHeight ? requestAnimationFrame(() => {
        $49c51c25361d4cd2$var$scrollIntoView(Va);
      }) : $49c51c25361d4cd2$var$visualViewport.addEventListener("resize", () => $49c51c25361d4cd2$var$scrollIntoView(Va), {
        once: !0
      }));
    }));
  }, na = null, ia = () => {
    if (na) return;
    let La = () => {
      window.scrollTo(0, 0);
    }, Va = window.pageXOffset, to = window.pageYOffset;
    na = $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$addEvent(window, "scroll", La), $49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${to}px`), () => {
      window.scrollTo(Va, to);
    }), window.scrollTo(0, 0);
  }, fa = $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$addEvent(document, "touchstart", Zi, {
    passive: !1,
    capture: !0
  }), $49c51c25361d4cd2$var$addEvent(document, "touchmove", Qi, {
    passive: !1,
    capture: !0
  }), $49c51c25361d4cd2$var$addEvent(document, "touchend", ea, {
    passive: !1,
    capture: !0
  }), $49c51c25361d4cd2$var$addEvent(document, "focus", ra, !0));
  return () => {
    e?.(), na?.(), fa();
  };
}
function $49c51c25361d4cd2$var$setStyle(Bi, e, Zi) {
  let Qi = Bi.style[e];
  return Bi.style[e] = Zi, () => {
    Bi.style[e] = Qi;
  };
}
function $49c51c25361d4cd2$var$addEvent(Bi, e, Zi, Qi) {
  return Bi.addEventListener(e, Zi, Qi), () => {
    Bi.removeEventListener(e, Zi, Qi);
  };
}
function $49c51c25361d4cd2$var$scrollIntoView(Bi) {
  let e = document.scrollingElement || document.documentElement, Zi = Bi;
  for (; Zi && Zi !== e; ) {
    let Qi = $62d8ded9296f3872$export$cfa2225e87938781(Zi);
    if (Qi !== document.documentElement && Qi !== document.body && Qi !== Zi) {
      let ea = Qi.getBoundingClientRect().top, ra = Zi.getBoundingClientRect().top;
      ra > ea + Zi.clientHeight && (Qi.scrollTop += ra - ea);
    }
    Zi = Qi.parentElement;
  }
}
function $49c51c25361d4cd2$var$willOpenKeyboard(Bi) {
  return Bi instanceof HTMLInputElement && !$49c51c25361d4cd2$var$nonTextInputTypes.has(Bi.type) || Bi instanceof HTMLTextAreaElement || Bi instanceof HTMLElement && Bi.isContentEditable;
}
var $773d5888b972f1cf$exports = {};
$773d5888b972f1cf$exports = {
  dismiss: "تجاهل"
};
var $d11f19852b941573$exports = {};
$d11f19852b941573$exports = {
  dismiss: "Отхвърляне"
};
var $b983974c2ee1efb3$exports = {};
$b983974c2ee1efb3$exports = {
  dismiss: "Odstranit"
};
var $5809cc9d4e92de73$exports = {};
$5809cc9d4e92de73$exports = {
  dismiss: "Luk"
};
var $c68c2e4fc74398d1$exports = {};
$c68c2e4fc74398d1$exports = {
  dismiss: "Schließen"
};
var $0898b4c153db2b77$exports = {};
$0898b4c153db2b77$exports = {
  dismiss: "Απόρριψη"
};
var $6d74810286a15183$exports = {};
$6d74810286a15183$exports = {
  dismiss: "Dismiss"
};
var $309d73dc65f78055$exports = {};
$309d73dc65f78055$exports = {
  dismiss: "Descartar"
};
var $44ad94f7205cf593$exports = {};
$44ad94f7205cf593$exports = {
  dismiss: "Lõpeta"
};
var $7c28f5687f0779a9$exports = {};
$7c28f5687f0779a9$exports = {
  dismiss: "Hylkää"
};
var $e6d75df4b68bd73a$exports = {};
$e6d75df4b68bd73a$exports = {
  dismiss: "Rejeter"
};
var $87505c9dab186d0f$exports = {};
$87505c9dab186d0f$exports = {
  dismiss: "התעלם"
};
var $553439c3ffb3e492$exports = {};
$553439c3ffb3e492$exports = {
  dismiss: "Odbaci"
};
var $74cf411061b983a2$exports = {};
$74cf411061b983a2$exports = {
  dismiss: "Elutasítás"
};
var $e933f298574dc435$exports = {};
$e933f298574dc435$exports = {
  dismiss: "Ignora"
};
var $ac91fc9fe02f71f6$exports = {};
$ac91fc9fe02f71f6$exports = {
  dismiss: "閉じる"
};
var $52b96f86422025af$exports = {};
$52b96f86422025af$exports = {
  dismiss: "무시"
};
var $c0d724c3e51dafa6$exports = {};
$c0d724c3e51dafa6$exports = {
  dismiss: "Atmesti"
};
var $c92899672a3fe72e$exports = {};
$c92899672a3fe72e$exports = {
  dismiss: "Nerādīt"
};
var $9f576b39d8e7a9d6$exports = {};
$9f576b39d8e7a9d6$exports = {
  dismiss: "Lukk"
};
var $9d025808aeec81a7$exports = {};
$9d025808aeec81a7$exports = {
  dismiss: "Negeren"
};
var $fce709921e2c0fa6$exports = {};
$fce709921e2c0fa6$exports = {
  dismiss: "Zignoruj"
};
var $2599cf0c4ab37f59$exports = {};
$2599cf0c4ab37f59$exports = {
  dismiss: "Descartar"
};
var $3c220ae7ef8a35fd$exports = {};
$3c220ae7ef8a35fd$exports = {
  dismiss: "Dispensar"
};
var $93562b5094072f54$exports = {};
$93562b5094072f54$exports = {
  dismiss: "Revocare"
};
var $cd9e2abd0d06c7b4$exports = {};
$cd9e2abd0d06c7b4$exports = {
  dismiss: "Пропустить"
};
var $45375701f409adf1$exports = {};
$45375701f409adf1$exports = {
  dismiss: "Zrušiť"
};
var $27fab53a576de9dd$exports = {};
$27fab53a576de9dd$exports = {
  dismiss: "Opusti"
};
var $4438748d9952e7c7$exports = {};
$4438748d9952e7c7$exports = {
  dismiss: "Odbaci"
};
var $0936d7347ef4da4c$exports = {};
$0936d7347ef4da4c$exports = {
  dismiss: "Avvisa"
};
var $29700c92185d38f8$exports = {};
$29700c92185d38f8$exports = {
  dismiss: "Kapat"
};
var $662ccaf2be4c25b3$exports = {};
$662ccaf2be4c25b3$exports = {
  dismiss: "Скасувати"
};
var $d80a27deda7cdb3c$exports = {};
$d80a27deda7cdb3c$exports = {
  dismiss: "取消"
};
var $2b2734393847c884$exports = {};
$2b2734393847c884$exports = {
  dismiss: "關閉"
};
var $a2f21f5f14f60553$exports = {};
$a2f21f5f14f60553$exports = {
  "ar-AE": $773d5888b972f1cf$exports,
  "bg-BG": $d11f19852b941573$exports,
  "cs-CZ": $b983974c2ee1efb3$exports,
  "da-DK": $5809cc9d4e92de73$exports,
  "de-DE": $c68c2e4fc74398d1$exports,
  "el-GR": $0898b4c153db2b77$exports,
  "en-US": $6d74810286a15183$exports,
  "es-ES": $309d73dc65f78055$exports,
  "et-EE": $44ad94f7205cf593$exports,
  "fi-FI": $7c28f5687f0779a9$exports,
  "fr-FR": $e6d75df4b68bd73a$exports,
  "he-IL": $87505c9dab186d0f$exports,
  "hr-HR": $553439c3ffb3e492$exports,
  "hu-HU": $74cf411061b983a2$exports,
  "it-IT": $e933f298574dc435$exports,
  "ja-JP": $ac91fc9fe02f71f6$exports,
  "ko-KR": $52b96f86422025af$exports,
  "lt-LT": $c0d724c3e51dafa6$exports,
  "lv-LV": $c92899672a3fe72e$exports,
  "nb-NO": $9f576b39d8e7a9d6$exports,
  "nl-NL": $9d025808aeec81a7$exports,
  "pl-PL": $fce709921e2c0fa6$exports,
  "pt-BR": $2599cf0c4ab37f59$exports,
  "pt-PT": $3c220ae7ef8a35fd$exports,
  "ro-RO": $93562b5094072f54$exports,
  "ru-RU": $cd9e2abd0d06c7b4$exports,
  "sk-SK": $45375701f409adf1$exports,
  "sl-SI": $27fab53a576de9dd$exports,
  "sr-SP": $4438748d9952e7c7$exports,
  "sv-SE": $0936d7347ef4da4c$exports,
  "tr-TR": $29700c92185d38f8$exports,
  "uk-UA": $662ccaf2be4c25b3$exports,
  "zh-CN": $d80a27deda7cdb3c$exports,
  "zh-TW": $2b2734393847c884$exports
};
function $parcel$interopDefault$1(Bi) {
  return Bi && Bi.__esModule ? Bi.default : Bi;
}
function $86ea4cb521eb2e37$export$2317d149ed6f78c4(Bi) {
  let { onDismiss: e, ...Zi } = Bi, Qi = $fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault$1($a2f21f5f14f60553$exports), "@react-aria/overlays"), ea = $313b98861ee5dd6c$export$d6875122194c7b44(Zi, Qi.format("dismiss")), ra = () => {
    e && e();
  };
  return /* @__PURE__ */ a__default.createElement($5c3e21d68f1c4674$export$439d29a4e110a164, null, /* @__PURE__ */ a__default.createElement("button", {
    ...ea,
    tabIndex: -1,
    onClick: ra,
    style: {
      width: 1,
      height: 1
    }
  }));
}
let $5e3802645cc19319$var$refCountMap = /* @__PURE__ */ new WeakMap(), $5e3802645cc19319$var$observerStack = [];
function $5e3802645cc19319$export$1c3ebcada18427bf(Bi, e = document.body) {
  let Zi = new Set(Bi), Qi = /* @__PURE__ */ new Set(), ea = (fa) => {
    for (let ro of fa.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) Zi.add(ro);
    let La = (ro) => {
      if (Zi.has(ro) || ro.parentElement && Qi.has(ro.parentElement) && ro.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let no of Zi)
        if (ro.contains(no)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, Va = document.createTreeWalker(fa, NodeFilter.SHOW_ELEMENT, {
      acceptNode: La
    }), to = La(fa);
    if (to === NodeFilter.FILTER_ACCEPT && ra(fa), to !== NodeFilter.FILTER_REJECT) {
      let ro = Va.nextNode();
      for (; ro != null; )
        ra(ro), ro = Va.nextNode();
    }
  }, ra = (fa) => {
    var La;
    let Va = (La = $5e3802645cc19319$var$refCountMap.get(fa)) !== null && La !== void 0 ? La : 0;
    fa.getAttribute("aria-hidden") === "true" && Va === 0 || (Va === 0 && fa.setAttribute("aria-hidden", "true"), Qi.add(fa), $5e3802645cc19319$var$refCountMap.set(fa, Va + 1));
  };
  $5e3802645cc19319$var$observerStack.length && $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].disconnect(), ea(e);
  let na = new MutationObserver((fa) => {
    for (let La of fa)
      if (!(La.type !== "childList" || La.addedNodes.length === 0) && ![
        ...Zi,
        ...Qi
      ].some((Va) => Va.contains(La.target))) {
        for (let Va of La.removedNodes) Va instanceof Element && (Zi.delete(Va), Qi.delete(Va));
        for (let Va of La.addedNodes)
          (Va instanceof HTMLElement || Va instanceof SVGElement) && (Va.dataset.liveAnnouncer === "true" || Va.dataset.reactAriaTopLayer === "true") ? Zi.add(Va) : Va instanceof Element && ea(Va);
      }
  });
  na.observe(e, {
    childList: !0,
    subtree: !0
  });
  let ia = {
    observe() {
      na.observe(e, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      na.disconnect();
    }
  };
  return $5e3802645cc19319$var$observerStack.push(ia), () => {
    na.disconnect();
    for (let fa of Qi) {
      let La = $5e3802645cc19319$var$refCountMap.get(fa);
      La != null && (La === 1 ? (fa.removeAttribute("aria-hidden"), $5e3802645cc19319$var$refCountMap.delete(fa)) : $5e3802645cc19319$var$refCountMap.set(fa, La - 1));
    }
    ia === $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1] ? ($5e3802645cc19319$var$observerStack.pop(), $5e3802645cc19319$var$observerStack.length && $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].observe()) : $5e3802645cc19319$var$observerStack.splice($5e3802645cc19319$var$observerStack.indexOf(ia), 1);
  };
}
function $f2f8a6077418541e$export$542a6fd13ac93354(Bi, e) {
  let { triggerRef: Zi, popoverRef: Qi, isNonModal: ea, isKeyboardDismissDisabled: ra, shouldCloseOnInteractOutside: na, ...ia } = Bi, { overlayProps: fa, underlayProps: La } = $a11501f3d1d39e6c$export$ea8f71083e90600f({
    // If popover is in the top layer, it should not prevent other popovers from being dismissed.
    isOpen: e.isOpen && !ia["data-react-aria-top-layer"],
    onClose: e.close,
    shouldCloseOnBlur: !0,
    isDismissable: !ea,
    isKeyboardDismissDisabled: ra,
    shouldCloseOnInteractOutside: na
  }, Qi), { overlayProps: Va, arrowProps: to, placement: ro } = $2a41e45df1593e64$export$d39e1813b3bdd0e1({
    ...ia,
    targetRef: Zi,
    overlayRef: Qi,
    isOpen: e.isOpen,
    onClose: ea ? e.close : null
  });
  return $49c51c25361d4cd2$export$ee0f7cc6afcd1c18({
    isDisabled: ea || !e.isOpen
  }), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (e.isOpen && !ea && Qi.current) return $5e3802645cc19319$export$1c3ebcada18427bf([
      Qi.current
    ]);
  }, [
    ea,
    e.isOpen,
    Qi
  ]), {
    popoverProps: $3ef42575df84b30b$export$9d1611c77c2fe928(fa, Va),
    arrowProps: to,
    underlayProps: La,
    placement: ro
  };
}
const $96b38030c423d352$export$60d741e20e0aa309 = /* @__PURE__ */ createContext({});
function $96b38030c423d352$export$574e9b0fb070c3b0() {
  var Bi;
  return (Bi = useContext($96b38030c423d352$export$60d741e20e0aa309)) !== null && Bi !== void 0 ? Bi : {};
}
const $337b884510726a0d$export$a2200b96afd16271 = /* @__PURE__ */ a__default.createContext(null);
function $337b884510726a0d$export$c6fdb837b070b4ff(Bi) {
  let e = $b5e257d569688ac6$export$535bd6ca7f90a273(), { portalContainer: Zi = e ? null : document.body, isExiting: Qi } = Bi, [ea, ra] = useState(!1), na = useMemo(() => ({
    contain: ea,
    setContain: ra
  }), [
    ea,
    ra
  ]), { getContainer: ia } = $96b38030c423d352$export$574e9b0fb070c3b0();
  if (!Bi.portalContainer && ia && (Zi = ia()), !Zi) return null;
  let fa = Bi.children;
  return Bi.disableFocusManagement || (fa = /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, {
    restoreFocus: !0,
    contain: ea && !Qi
  }, fa)), fa = /* @__PURE__ */ a__default.createElement($337b884510726a0d$export$a2200b96afd16271.Provider, {
    value: na
  }, /* @__PURE__ */ a__default.createElement($f1ab8c75478c6f73$export$cf75428e0b9ed1ea, null, fa)), /* @__PURE__ */ $4AOtR$reactdom.createPortal(fa, Zi);
}
const $b1f0cad8af73213b$export$3585ede4d035bf14 = /* @__PURE__ */ new WeakMap();
function $b1f0cad8af73213b$var$normalizeKey(Bi) {
  return typeof Bi == "string" ? Bi.replace(/\s*/g, "") : "" + Bi;
}
function $b1f0cad8af73213b$export$9145995848b05025(Bi, e) {
  let Zi = $b1f0cad8af73213b$export$3585ede4d035bf14.get(Bi);
  if (!Zi) throw new Error("Unknown list");
  return `${Zi.id}-option-${$b1f0cad8af73213b$var$normalizeKey(e)}`;
}
function $feb5ffebff200149$export$d3e3bd3e26688c04(Bi) {
  return $c87311424ea30a05$export$e1865c3bedcd822b() ? Bi.altKey : Bi.ctrlKey;
}
const $fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1e3;
function $fb3050f43d946246$export$e32c88dfddc6e1d8(Bi) {
  let { keyboardDelegate: e, selectionManager: Zi, onTypeSelect: Qi } = Bi, ea = useRef({
    search: "",
    timeout: void 0
  }).current, ra = (na) => {
    let ia = $fb3050f43d946246$var$getStringForKey(na.key);
    if (!(!ia || na.ctrlKey || na.metaKey || !na.currentTarget.contains(na.target))) {
      if (ia === " " && ea.search.trim().length > 0 && (na.preventDefault(), "continuePropagation" in na || na.stopPropagation()), ea.search += ia, e.getKeyForSearch != null) {
        let fa = e.getKeyForSearch(ea.search, Zi.focusedKey);
        fa == null && (fa = e.getKeyForSearch(ea.search)), fa != null && (Zi.setFocusedKey(fa), Qi && Qi(fa));
      }
      clearTimeout(ea.timeout), ea.timeout = setTimeout(() => {
        ea.search = "";
      }, $fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    }
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: e.getKeyForSearch ? ra : void 0
    }
  };
}
function $fb3050f43d946246$var$getStringForKey(Bi) {
  return Bi.length === 1 || !/^[A-Z]/i.test(Bi) ? Bi : "";
}
function $ae20dd8cbca75726$export$d6daf82dcd84e87c(Bi) {
  let { selectionManager: e, keyboardDelegate: Zi, ref: Qi, autoFocus: ea = !1, shouldFocusWrap: ra = !1, disallowEmptySelection: na = !1, disallowSelectAll: ia = !1, selectOnFocus: fa = e.selectionBehavior === "replace", disallowTypeAhead: La = !1, shouldUseVirtualFocus: Va, allowsTabNavigation: to = !1, isVirtualized: ro, scrollRef: no = Qi, linkBehavior: eo = "action" } = Bi, { direction: ao } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), io = $ea8dcbcb9ea1b556$export$9a302a45f65d0572(), xs = (El) => {
    var wl;
    if (El.altKey && El.key === "Tab" && El.preventDefault(), !(!((wl = Qi.current) === null || wl === void 0) && wl.contains(El.target))) return;
    const jl = (Ol, To) => {
      if (Ol != null) {
        if (e.isLink(Ol) && eo === "selection" && fa && !$feb5ffebff200149$export$d3e3bd3e26688c04(El)) {
          var Os;
          flushSync$1(() => {
            e.setFocusedKey(Ol, To);
          });
          let $l = (Os = no.current) === null || Os === void 0 ? void 0 : Os.querySelector(`[data-key="${CSS.escape(Ol.toString())}"]`), _l = e.getItemProps(Ol);
          $l && io.open($l, El, _l.href, _l.routerOptions);
          return;
        }
        if (e.setFocusedKey(Ol, To), e.isLink(Ol) && eo === "override") return;
        El.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(Ol) : fa && !$feb5ffebff200149$export$d3e3bd3e26688c04(El) && e.replaceSelection(Ol);
      }
    };
    switch (El.key) {
      case "ArrowDown":
        if (Zi.getKeyBelow) {
          var kl, Fl, Ml;
          let Ol = e.focusedKey != null ? (kl = Zi.getKeyBelow) === null || kl === void 0 ? void 0 : kl.call(Zi, e.focusedKey) : (Fl = Zi.getFirstKey) === null || Fl === void 0 ? void 0 : Fl.call(Zi);
          Ol == null && ra && (Ol = (Ml = Zi.getFirstKey) === null || Ml === void 0 ? void 0 : Ml.call(Zi, e.focusedKey)), Ol != null && (El.preventDefault(), jl(Ol));
        }
        break;
      case "ArrowUp":
        if (Zi.getKeyAbove) {
          var ql, Kl, Zl;
          let Ol = e.focusedKey != null ? (ql = Zi.getKeyAbove) === null || ql === void 0 ? void 0 : ql.call(Zi, e.focusedKey) : (Kl = Zi.getLastKey) === null || Kl === void 0 ? void 0 : Kl.call(Zi);
          Ol == null && ra && (Ol = (Zl = Zi.getLastKey) === null || Zl === void 0 ? void 0 : Zl.call(Zi, e.focusedKey)), Ol != null && (El.preventDefault(), jl(Ol));
        }
        break;
      case "ArrowLeft":
        if (Zi.getKeyLeftOf) {
          var Il, xl, bl;
          let Ol = e.focusedKey != null ? (Il = Zi.getKeyLeftOf) === null || Il === void 0 ? void 0 : Il.call(Zi, e.focusedKey) : null;
          Ol == null && ra && (Ol = ao === "rtl" ? (xl = Zi.getFirstKey) === null || xl === void 0 ? void 0 : xl.call(Zi, e.focusedKey) : (bl = Zi.getLastKey) === null || bl === void 0 ? void 0 : bl.call(Zi, e.focusedKey)), Ol != null && (El.preventDefault(), jl(Ol, ao === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (Zi.getKeyRightOf) {
          var Pl, Nl, Bl;
          let Ol = e.focusedKey != null ? (Pl = Zi.getKeyRightOf) === null || Pl === void 0 ? void 0 : Pl.call(Zi, e.focusedKey) : null;
          Ol == null && ra && (Ol = ao === "rtl" ? (Nl = Zi.getLastKey) === null || Nl === void 0 ? void 0 : Nl.call(Zi, e.focusedKey) : (Bl = Zi.getFirstKey) === null || Bl === void 0 ? void 0 : Bl.call(Zi, e.focusedKey)), Ol != null && (El.preventDefault(), jl(Ol, ao === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (Zi.getFirstKey) {
          if (e.focusedKey === null && El.shiftKey) return;
          El.preventDefault();
          let Ol = Zi.getFirstKey(e.focusedKey, $21f1aa98acb08317$export$16792effe837dba3(El));
          e.setFocusedKey(Ol), Ol != null && ($21f1aa98acb08317$export$16792effe837dba3(El) && El.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(Ol) : fa && e.replaceSelection(Ol));
        }
        break;
      case "End":
        if (Zi.getLastKey) {
          if (e.focusedKey === null && El.shiftKey) return;
          El.preventDefault();
          let Ol = Zi.getLastKey(e.focusedKey, $21f1aa98acb08317$export$16792effe837dba3(El));
          e.setFocusedKey(Ol), Ol != null && ($21f1aa98acb08317$export$16792effe837dba3(El) && El.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(Ol) : fa && e.replaceSelection(Ol));
        }
        break;
      case "PageDown":
        if (Zi.getKeyPageBelow && e.focusedKey != null) {
          let Ol = Zi.getKeyPageBelow(e.focusedKey);
          Ol != null && (El.preventDefault(), jl(Ol));
        }
        break;
      case "PageUp":
        if (Zi.getKeyPageAbove && e.focusedKey != null) {
          let Ol = Zi.getKeyPageAbove(e.focusedKey);
          Ol != null && (El.preventDefault(), jl(Ol));
        }
        break;
      case "a":
        $21f1aa98acb08317$export$16792effe837dba3(El) && e.selectionMode === "multiple" && ia !== !0 && (El.preventDefault(), e.selectAll());
        break;
      case "Escape":
        !na && e.selectedKeys.size !== 0 && (El.stopPropagation(), El.preventDefault(), e.clearSelection());
        break;
      case "Tab":
        if (!to) {
          if (El.shiftKey) Qi.current.focus();
          else {
            let Ol = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Qi.current, {
              tabbable: !0
            }), To, Os;
            do
              Os = Ol.lastChild(), Os && (To = Os);
            while (Os);
            To && !To.contains(document.activeElement) && $7215afc6de606d6b$export$de79e2c695e052f3(To);
          }
          break;
        }
    }
  }, Ts = useRef({
    top: 0,
    left: 0
  });
  $e9faafb641e167db$export$90fc3a17d93f704c(no, "scroll", ro ? void 0 : () => {
    var El, wl, jl, kl;
    Ts.current = {
      top: (jl = (El = no.current) === null || El === void 0 ? void 0 : El.scrollTop) !== null && jl !== void 0 ? jl : 0,
      left: (kl = (wl = no.current) === null || wl === void 0 ? void 0 : wl.scrollLeft) !== null && kl !== void 0 ? kl : 0
    };
  });
  let qs = (El) => {
    if (e.isFocused) {
      El.currentTarget.contains(El.target) || e.setFocused(!1);
      return;
    }
    if (El.currentTarget.contains(El.target)) {
      if (e.setFocused(!0), e.focusedKey == null) {
        var wl, jl;
        let Ml = (Kl) => {
          Kl != null && (e.setFocusedKey(Kl), fa && e.replaceSelection(Kl));
        }, ql = El.relatedTarget;
        var kl, Fl;
        ql && El.currentTarget.compareDocumentPosition(ql) & Node.DOCUMENT_POSITION_FOLLOWING ? Ml((kl = e.lastSelectedKey) !== null && kl !== void 0 ? kl : (wl = Zi.getLastKey) === null || wl === void 0 ? void 0 : wl.call(Zi)) : Ml((Fl = e.firstSelectedKey) !== null && Fl !== void 0 ? Fl : (jl = Zi.getFirstKey) === null || jl === void 0 ? void 0 : jl.call(Zi));
      } else !ro && no.current && (no.current.scrollTop = Ts.current.top, no.current.scrollLeft = Ts.current.left);
      if (e.focusedKey != null && no.current) {
        let Ml = no.current.querySelector(`[data-key="${CSS.escape(e.focusedKey.toString())}"]`);
        Ml && (Ml.contains(document.activeElement) || $7215afc6de606d6b$export$de79e2c695e052f3(Ml), $507fabe10e71c6fb$export$630ff653c5ada6a9() === "keyboard" && $2f04cbc44ee30ce0$export$c826860796309d1b(Ml, {
          containingElement: Qi.current
        }));
      }
    }
  }, Fs = (El) => {
    El.currentTarget.contains(El.relatedTarget) || e.setFocused(!1);
  }, Do = useRef(!1);
  $e9faafb641e167db$export$90fc3a17d93f704c(Qi, $5671b20cf9b562b2$export$831c820ad60f9d12, Va ? (El) => {
    let { detail: wl } = El;
    El.stopPropagation(), e.setFocused(!0), wl?.focusStrategy === "first" && (Do.current = !0);
  } : void 0);
  let ys = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    var El, wl;
    let jl = (wl = (El = Zi.getFirstKey) === null || El === void 0 ? void 0 : El.call(Zi)) !== null && wl !== void 0 ? wl : null;
    if (jl == null) {
      var kl;
      (kl = Qi.current) === null || kl === void 0 || kl.dispatchEvent(new CustomEvent($5671b20cf9b562b2$export$9db568f6321ad9dc, {
        cancelable: !0,
        bubbles: !0
      })), e.collection.size > 0 && (Do.current = !1);
    } else
      e.setFocusedKey(jl), Do.current = !1;
  });
  $ca9b37712f007381$export$72ef708ab07251f1(() => {
    Do.current && ys();
  }, [
    e.collection,
    ys
  ]);
  let Io = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    e.collection.size > 0 && (Do.current = !1);
  });
  $ca9b37712f007381$export$72ef708ab07251f1(() => {
    Io();
  }, [
    e.focusedKey,
    Io
  ]), $e9faafb641e167db$export$90fc3a17d93f704c(Qi, $5671b20cf9b562b2$export$447a38995de2c711, Va ? (El) => {
    El.stopPropagation(), e.setFocused(!1), e.setFocusedKey(null);
  } : void 0);
  const so = useRef(ea);
  useEffect(() => {
    if (so.current) {
      var El, wl;
      let Fl = null;
      var jl;
      ea === "first" && (Fl = (jl = (El = Zi.getFirstKey) === null || El === void 0 ? void 0 : El.call(Zi)) !== null && jl !== void 0 ? jl : null);
      var kl;
      ea === "last" && (Fl = (kl = (wl = Zi.getLastKey) === null || wl === void 0 ? void 0 : wl.call(Zi)) !== null && kl !== void 0 ? kl : null);
      let Ml = e.selectedKeys;
      if (Ml.size) {
        for (let ql of Ml) if (e.canSelectItem(ql)) {
          Fl = ql;
          break;
        }
      }
      e.setFocused(!0), e.setFocusedKey(Fl), Fl == null && !Va && Qi.current && $6a99195332edec8b$export$80f3e147d781571c(Qi.current);
    }
  }, []);
  let os = useRef(e.focusedKey);
  useEffect(() => {
    if (e.isFocused && e.focusedKey != null && (e.focusedKey !== os.current || so.current) && no.current && Qi.current) {
      let El = $507fabe10e71c6fb$export$630ff653c5ada6a9(), wl = Qi.current.querySelector(`[data-key="${CSS.escape(e.focusedKey.toString())}"]`);
      if (!wl)
        return;
      (El === "keyboard" || so.current) && ($2f04cbc44ee30ce0$export$53a0910f038337bd(no.current, wl), El !== "virtual" && $2f04cbc44ee30ce0$export$c826860796309d1b(wl, {
        containingElement: Qi.current
      }));
    }
    !Va && e.isFocused && e.focusedKey == null && os.current != null && Qi.current && $6a99195332edec8b$export$80f3e147d781571c(Qi.current), os.current = e.focusedKey, so.current = !1;
  }), $e9faafb641e167db$export$90fc3a17d93f704c(Qi, "react-aria-focus-scope-restore", (El) => {
    El.preventDefault(), e.setFocused(!0);
  });
  let Xs = {
    onKeyDown: xs,
    onFocus: qs,
    onBlur: Fs,
    onMouseDown(El) {
      no.current === El.target && El.preventDefault();
    }
  }, { typeSelectProps: gl } = $fb3050f43d946246$export$e32c88dfddc6e1d8({
    keyboardDelegate: Zi,
    selectionManager: e
  });
  La || (Xs = $3ef42575df84b30b$export$9d1611c77c2fe928(gl, Xs));
  let Sl;
  return Va ? Sl = -1 : Sl = e.focusedKey == null ? 0 : -1, {
    collectionProps: {
      ...Xs,
      tabIndex: Sl
    }
  };
}
function $880e95eb8b93ba9a$export$ecf600387e221c37(Bi) {
  let { id: e, selectionManager: Zi, key: Qi, ref: ea, shouldSelectOnPressUp: ra, shouldUseVirtualFocus: na, focus: ia, isDisabled: fa, onAction: La, allowsDifferentPressOrigin: Va, linkBehavior: to = "action" } = Bi, ro = $ea8dcbcb9ea1b556$export$9a302a45f65d0572();
  e = $bdb11010cef70236$export$f680877a34711e37(e);
  let no = (Ml) => {
    if (Ml.pointerType === "keyboard" && $feb5ffebff200149$export$d3e3bd3e26688c04(Ml)) Zi.toggleSelection(Qi);
    else {
      if (Zi.selectionMode === "none") return;
      if (Zi.isLink(Qi)) {
        if (to === "selection" && ea.current) {
          let ql = Zi.getItemProps(Qi);
          ro.open(ea.current, Ml, ql.href, ql.routerOptions), Zi.setSelectedKeys(Zi.selectedKeys);
          return;
        } else if (to === "override" || to === "none") return;
      }
      Zi.selectionMode === "single" ? Zi.isSelected(Qi) && !Zi.disallowEmptySelection ? Zi.toggleSelection(Qi) : Zi.replaceSelection(Qi) : Ml && Ml.shiftKey ? Zi.extendSelection(Qi) : Zi.selectionBehavior === "toggle" || Ml && ($21f1aa98acb08317$export$16792effe837dba3(Ml) || Ml.pointerType === "touch" || Ml.pointerType === "virtual") ? Zi.toggleSelection(Qi) : Zi.replaceSelection(Qi);
    }
  };
  useEffect(() => {
    if (Qi === Zi.focusedKey && Zi.isFocused)
      if (!na)
        ia ? ia() : document.activeElement !== ea.current && ea.current && $6a99195332edec8b$export$80f3e147d781571c(ea.current);
      else {
        var ql;
        let Kl = new CustomEvent($5671b20cf9b562b2$export$9db568f6321ad9dc, {
          cancelable: !0,
          bubbles: !0
        });
        (ql = ea.current) === null || ql === void 0 || ql.dispatchEvent(Kl);
      }
  }, [
    ea,
    Qi,
    Zi.focusedKey,
    Zi.childFocusStrategy,
    Zi.isFocused,
    na
  ]), fa = fa || Zi.isDisabled(Qi);
  let eo = {};
  !na && !fa ? eo = {
    tabIndex: Qi === Zi.focusedKey ? 0 : -1,
    onFocus(Ml) {
      Ml.target === ea.current && Zi.setFocusedKey(Qi);
    }
  } : fa && (eo.onMouseDown = (Ml) => {
    Ml.preventDefault();
  });
  let ao = Zi.isLink(Qi) && to === "override", io = Zi.isLink(Qi) && to !== "selection" && to !== "none", xs = !fa && Zi.canSelectItem(Qi) && !ao, Ts = (La || io) && !fa, qs = Ts && (Zi.selectionBehavior === "replace" ? !xs : !xs || Zi.isEmpty), Fs = Ts && xs && Zi.selectionBehavior === "replace", Do = qs || Fs, ys = useRef(null), Io = Do && xs, so = useRef(!1), os = useRef(!1), Xs = (Ml) => {
    if (La && La(), io && ea.current) {
      let ql = Zi.getItemProps(Qi);
      ro.open(ea.current, Ml, ql.href, ql.routerOptions);
    }
  }, gl = {};
  ra ? (gl.onPressStart = (Ml) => {
    ys.current = Ml.pointerType, so.current = Io, Ml.pointerType === "keyboard" && (!Do || $880e95eb8b93ba9a$var$isSelectionKey()) && no(Ml);
  }, Va ? (gl.onPressUp = qs ? void 0 : (Ml) => {
    Ml.pointerType === "mouse" && xs && no(Ml);
  }, gl.onPress = qs ? Xs : (Ml) => {
    Ml.pointerType !== "keyboard" && Ml.pointerType !== "mouse" && xs && no(Ml);
  }) : gl.onPress = (Ml) => {
    if (qs || Fs && Ml.pointerType !== "mouse") {
      if (Ml.pointerType === "keyboard" && !$880e95eb8b93ba9a$var$isActionKey()) return;
      Xs(Ml);
    } else Ml.pointerType !== "keyboard" && xs && no(Ml);
  }) : (gl.onPressStart = (Ml) => {
    ys.current = Ml.pointerType, so.current = Io, os.current = qs, xs && (Ml.pointerType === "mouse" && !qs || Ml.pointerType === "keyboard" && (!Ts || $880e95eb8b93ba9a$var$isSelectionKey())) && no(Ml);
  }, gl.onPress = (Ml) => {
    (Ml.pointerType === "touch" || Ml.pointerType === "pen" || Ml.pointerType === "virtual" || Ml.pointerType === "keyboard" && Do && $880e95eb8b93ba9a$var$isActionKey() || Ml.pointerType === "mouse" && os.current) && (Do ? Xs(Ml) : xs && no(Ml));
  }), eo["data-key"] = Qi, gl.preventFocusOnPress = na;
  let { pressProps: Sl, isPressed: El } = $f6c31cce2adf654f$export$45712eceda6fad21(gl), wl = Fs ? (Ml) => {
    ys.current === "mouse" && (Ml.stopPropagation(), Ml.preventDefault(), Xs(Ml));
  } : void 0, { longPressProps: jl } = $8a26561d2877236e$export$c24ed0104d07eab9({
    isDisabled: !Io,
    onLongPress(Ml) {
      Ml.pointerType === "touch" && (no(Ml), Zi.setSelectionBehavior("toggle"));
    }
  }), kl = (Ml) => {
    ys.current === "touch" && so.current && Ml.preventDefault();
  }, Fl = Zi.isLink(Qi) ? (Ml) => {
    $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening || Ml.preventDefault();
  } : void 0;
  return {
    itemProps: $3ef42575df84b30b$export$9d1611c77c2fe928(eo, xs || qs ? Sl : {}, Io ? jl : {}, {
      onDoubleClick: wl,
      onDragStartCapture: kl,
      onClick: Fl,
      id: e
    }),
    isPressed: El,
    isSelected: Zi.isSelected(Qi),
    isFocused: Zi.isFocused && Zi.focusedKey === Qi,
    isDisabled: fa,
    allowsSelection: xs,
    hasAction: Do
  };
}
function $880e95eb8b93ba9a$var$isActionKey() {
  let Bi = window.event;
  return Bi?.key === "Enter";
}
function $880e95eb8b93ba9a$var$isSelectionKey() {
  let Bi = window.event;
  return Bi?.key === " " || Bi?.code === "Space";
}
class $657e4dc4a6e88df0$export$8f5ed9ff9f511381 {
  getItemRect(e) {
    let Zi = this.ref.current;
    if (!Zi) return null;
    let Qi = e != null ? Zi.querySelector(`[data-key="${CSS.escape(e.toString())}"]`) : null;
    if (!Qi) return null;
    let ea = Zi.getBoundingClientRect(), ra = Qi.getBoundingClientRect();
    return {
      x: ra.left - ea.left + Zi.scrollLeft,
      y: ra.top - ea.top + Zi.scrollTop,
      width: ra.width,
      height: ra.height
    };
  }
  getContentSize() {
    let e = this.ref.current;
    var Zi, Qi;
    return {
      width: (Zi = e?.scrollWidth) !== null && Zi !== void 0 ? Zi : 0,
      height: (Qi = e?.scrollHeight) !== null && Qi !== void 0 ? Qi : 0
    };
  }
  getVisibleRect() {
    let e = this.ref.current;
    var Zi, Qi, ea, ra;
    return {
      x: (Zi = e?.scrollLeft) !== null && Zi !== void 0 ? Zi : 0,
      y: (Qi = e?.scrollTop) !== null && Qi !== void 0 ? Qi : 0,
      width: (ea = e?.offsetWidth) !== null && ea !== void 0 ? ea : 0,
      height: (ra = e?.offsetHeight) !== null && ra !== void 0 ? ra : 0
    };
  }
  constructor(e) {
    this.ref = e;
  }
}
class $2a25aae57d74318e$export$a05409b8bb224a5a {
  isDisabled(e) {
    var Zi;
    return this.disabledBehavior === "all" && (((Zi = e.props) === null || Zi === void 0 ? void 0 : Zi.isDisabled) || this.disabledKeys.has(e.key));
  }
  findNextNonDisabled(e, Zi) {
    let Qi = e;
    for (; Qi != null; ) {
      let ea = this.collection.getItem(Qi);
      if (ea?.type === "item" && !this.isDisabled(ea)) return Qi;
      Qi = Zi(Qi);
    }
    return null;
  }
  getNextKey(e) {
    let Zi = e;
    return Zi = this.collection.getKeyAfter(Zi), this.findNextNonDisabled(Zi, (Qi) => this.collection.getKeyAfter(Qi));
  }
  getPreviousKey(e) {
    let Zi = e;
    return Zi = this.collection.getKeyBefore(Zi), this.findNextNonDisabled(Zi, (Qi) => this.collection.getKeyBefore(Qi));
  }
  findKey(e, Zi, Qi) {
    let ea = e, ra = this.layoutDelegate.getItemRect(ea);
    if (!ra || ea == null) return null;
    let na = ra;
    do {
      if (ea = Zi(ea), ea == null) break;
      ra = this.layoutDelegate.getItemRect(ea);
    } while (ra && Qi(na, ra) && ea != null);
    return ea;
  }
  isSameRow(e, Zi) {
    return e.y === Zi.y || e.x !== Zi.x;
  }
  isSameColumn(e, Zi) {
    return e.x === Zi.x || e.y !== Zi.y;
  }
  getKeyBelow(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (Zi) => this.getNextKey(Zi), this.isSameRow) : this.getNextKey(e);
  }
  getKeyAbove(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (Zi) => this.getPreviousKey(Zi), this.isSameRow) : this.getPreviousKey(e);
  }
  getNextColumn(e, Zi) {
    return Zi ? this.getPreviousKey(e) : this.getNextKey(e);
  }
  getKeyRightOf(e) {
    let Zi = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[Zi] ? (e = this.layoutDelegate[Zi](e), this.findNextNonDisabled(e, (Qi) => this.layoutDelegate[Zi](Qi))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "rtl") : this.findKey(e, (Qi) => this.getNextColumn(Qi, this.direction === "rtl"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "rtl") : null;
  }
  getKeyLeftOf(e) {
    let Zi = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[Zi] ? (e = this.layoutDelegate[Zi](e), this.findNextNonDisabled(e, (Qi) => this.layoutDelegate[Zi](Qi))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "ltr") : this.findKey(e, (Qi) => this.getNextColumn(Qi, this.direction === "ltr"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "ltr") : null;
  }
  getFirstKey() {
    let e = this.collection.getFirstKey();
    return this.findNextNonDisabled(e, (Zi) => this.collection.getKeyAfter(Zi));
  }
  getLastKey() {
    let e = this.collection.getLastKey();
    return this.findNextNonDisabled(e, (Zi) => this.collection.getKeyBefore(Zi));
  }
  getKeyPageAbove(e) {
    let Zi = this.ref.current, Qi = this.layoutDelegate.getItemRect(e);
    if (!Qi) return null;
    if (Zi && !$cc38e7bd3fc7b213$export$2bb74740c4e19def(Zi)) return this.getFirstKey();
    let ea = e;
    if (this.orientation === "horizontal") {
      let ra = Math.max(0, Qi.x + Qi.width - this.layoutDelegate.getVisibleRect().width);
      for (; Qi && Qi.x > ra && ea != null; )
        ea = this.getKeyAbove(ea), Qi = ea == null ? null : this.layoutDelegate.getItemRect(ea);
    } else {
      let ra = Math.max(0, Qi.y + Qi.height - this.layoutDelegate.getVisibleRect().height);
      for (; Qi && Qi.y > ra && ea != null; )
        ea = this.getKeyAbove(ea), Qi = ea == null ? null : this.layoutDelegate.getItemRect(ea);
    }
    return ea ?? this.getFirstKey();
  }
  getKeyPageBelow(e) {
    let Zi = this.ref.current, Qi = this.layoutDelegate.getItemRect(e);
    if (!Qi) return null;
    if (Zi && !$cc38e7bd3fc7b213$export$2bb74740c4e19def(Zi)) return this.getLastKey();
    let ea = e;
    if (this.orientation === "horizontal") {
      let ra = Math.min(this.layoutDelegate.getContentSize().width, Qi.y - Qi.width + this.layoutDelegate.getVisibleRect().width);
      for (; Qi && Qi.x < ra && ea != null; )
        ea = this.getKeyBelow(ea), Qi = ea == null ? null : this.layoutDelegate.getItemRect(ea);
    } else {
      let ra = Math.min(this.layoutDelegate.getContentSize().height, Qi.y - Qi.height + this.layoutDelegate.getVisibleRect().height);
      for (; Qi && Qi.y < ra && ea != null; )
        ea = this.getKeyBelow(ea), Qi = ea == null ? null : this.layoutDelegate.getItemRect(ea);
    }
    return ea ?? this.getLastKey();
  }
  getKeyForSearch(e, Zi) {
    if (!this.collator) return null;
    let Qi = this.collection, ea = Zi || this.getFirstKey();
    for (; ea != null; ) {
      let ra = Qi.getItem(ea);
      if (!ra) return null;
      let na = ra.textValue.slice(0, e.length);
      if (ra.textValue && this.collator.compare(na, e) === 0) return ea;
      ea = this.getNextKey(ea);
    }
    return null;
  }
  constructor(...e) {
    if (e.length === 1) {
      let Zi = e[0];
      this.collection = Zi.collection, this.ref = Zi.ref, this.collator = Zi.collator, this.disabledKeys = Zi.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = Zi.disabledBehavior || "all", this.orientation = Zi.orientation || "vertical", this.direction = Zi.direction, this.layout = Zi.layout || "stack", this.layoutDelegate = Zi.layoutDelegate || new $657e4dc4a6e88df0$export$8f5ed9ff9f511381(Zi.ref);
    } else
      this.collection = e[0], this.disabledKeys = e[1], this.ref = e[2], this.collator = e[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new $657e4dc4a6e88df0$export$8f5ed9ff9f511381(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
}
function $982254629710d113$export$b95089534ab7c1fd(Bi) {
  let { selectionManager: e, collection: Zi, disabledKeys: Qi, ref: ea, keyboardDelegate: ra, layoutDelegate: na } = Bi, ia = $325a3faab7a68acd$export$a16aca283550c30d({
    usage: "search",
    sensitivity: "base"
  }), fa = e.disabledBehavior, La = useMemo(() => ra || new $2a25aae57d74318e$export$a05409b8bb224a5a({
    collection: Zi,
    disabledKeys: Qi,
    disabledBehavior: fa,
    ref: ea,
    collator: ia,
    layoutDelegate: na
  }), [
    ra,
    na,
    Zi,
    Qi,
    ea,
    ia,
    fa
  ]), { collectionProps: Va } = $ae20dd8cbca75726$export$d6daf82dcd84e87c({
    ...Bi,
    ref: ea,
    selectionManager: e,
    keyboardDelegate: La
  });
  return {
    listProps: Va
  };
}
function $c132121280ec012d$export$50eacbbf140a3141(Bi, e, Zi) {
  let Qi = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }), ea = Bi.selectionBehavior || "toggle", ra = Bi.linkBehavior || (ea === "replace" ? "action" : "override");
  ea === "toggle" && ra === "action" && (ra = "override");
  let { listProps: na } = $982254629710d113$export$b95089534ab7c1fd({
    ...Bi,
    ref: Zi,
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    linkBehavior: ra
  }), { focusWithinProps: ia } = $9ab94262bd0047c7$export$420e68273165f4ec({
    onFocusWithin: Bi.onFocus,
    onBlurWithin: Bi.onBlur,
    onFocusWithinChange: Bi.onFocusChange
  }), fa = $bdb11010cef70236$export$f680877a34711e37(Bi.id);
  $b1f0cad8af73213b$export$3585ede4d035bf14.set(e, {
    id: fa,
    shouldUseVirtualFocus: Bi.shouldUseVirtualFocus,
    shouldSelectOnPressUp: Bi.shouldSelectOnPressUp,
    shouldFocusOnHover: Bi.shouldFocusOnHover,
    isVirtualized: Bi.isVirtualized,
    onAction: Bi.onAction,
    linkBehavior: ra
  });
  let { labelProps: La, fieldProps: Va } = $d191a55c9702f145$export$8467354a121f1b9f({
    ...Bi,
    id: fa,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: La,
    listBoxProps: $3ef42575df84b30b$export$9d1611c77c2fe928(Qi, ia, e.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      ...$3ef42575df84b30b$export$9d1611c77c2fe928(Va, na)
    })
  };
}
class $eb2240fc39a57fa5$export$bf788dd355e3a401 {
  build(e, Zi) {
    return this.context = Zi, $eb2240fc39a57fa5$var$iterable(() => this.iterateCollection(e));
  }
  *iterateCollection(e) {
    let { children: Zi, items: Qi } = e;
    if (a__default.isValidElement(Zi) && Zi.type === a__default.Fragment) yield* this.iterateCollection({
      children: Zi.props.children,
      items: Qi
    });
    else if (typeof Zi == "function") {
      if (!Qi) throw new Error("props.children was a function but props.items is missing");
      let ea = 0;
      for (let ra of Qi)
        yield* this.getFullNode({
          value: ra,
          index: ea
        }, {
          renderer: Zi
        }), ea++;
    } else {
      let ea = [];
      a__default.Children.forEach(Zi, (na) => {
        na && ea.push(na);
      });
      let ra = 0;
      for (let na of ea) {
        let ia = this.getFullNode({
          element: na,
          index: ra
        }, {});
        for (let fa of ia)
          ra++, yield fa;
      }
    }
  }
  getKey(e, Zi, Qi, ea) {
    if (e.key != null) return e.key;
    if (Zi.type === "cell" && Zi.key != null) return `${ea}${Zi.key}`;
    let ra = Zi.value;
    if (ra != null) {
      var na;
      let ia = (na = ra.key) !== null && na !== void 0 ? na : ra.id;
      if (ia == null) throw new Error("No key found for item");
      return ia;
    }
    return ea ? `${ea}.${Zi.index}` : `$.${Zi.index}`;
  }
  getChildState(e, Zi) {
    return {
      renderer: Zi.renderer || e.renderer
    };
  }
  *getFullNode(e, Zi, Qi, ea) {
    if (a__default.isValidElement(e.element) && e.element.type === a__default.Fragment) {
      let io = [];
      a__default.Children.forEach(e.element.props.children, (Ts) => {
        io.push(Ts);
      });
      var ra;
      let xs = (ra = e.index) !== null && ra !== void 0 ? ra : 0;
      for (const Ts of io) yield* this.getFullNode({
        element: Ts,
        index: xs++
      }, Zi, Qi, ea);
      return;
    }
    let na = e.element;
    if (!na && e.value && Zi && Zi.renderer) {
      let io = this.cache.get(e.value);
      if (io && (!io.shouldInvalidate || !io.shouldInvalidate(this.context))) {
        io.index = e.index, io.parentKey = ea ? ea.key : null, yield io;
        return;
      }
      na = Zi.renderer(e.value);
    }
    if (a__default.isValidElement(na)) {
      let io = na.type;
      if (typeof io != "function" && typeof io.getCollectionNode != "function") {
        let Fs = na.type;
        throw new Error(`Unknown element <${Fs}> in collection.`);
      }
      let xs = io.getCollectionNode(na.props, this.context);
      var ia;
      let Ts = (ia = e.index) !== null && ia !== void 0 ? ia : 0, qs = xs.next();
      for (; !qs.done && qs.value; ) {
        let Fs = qs.value;
        e.index = Ts;
        var fa;
        let Do = (fa = Fs.key) !== null && fa !== void 0 ? fa : null;
        Do == null && (Do = Fs.element ? null : this.getKey(na, e, Zi, Qi));
        let Io = [
          ...this.getFullNode({
            ...Fs,
            key: Do,
            index: Ts,
            wrapper: $eb2240fc39a57fa5$var$compose(e.wrapper, Fs.wrapper)
          }, this.getChildState(Zi, Fs), Qi ? `${Qi}${na.key}` : na.key, ea)
        ];
        for (let so of Io) {
          var La, Va;
          so.value = (Va = (La = Fs.value) !== null && La !== void 0 ? La : e.value) !== null && Va !== void 0 ? Va : null, so.value && this.cache.set(so.value, so);
          var to;
          if (e.type && so.type !== e.type) throw new Error(`Unsupported type <${$eb2240fc39a57fa5$var$capitalize(so.type)}> in <${$eb2240fc39a57fa5$var$capitalize((to = ea?.type) !== null && to !== void 0 ? to : "unknown parent type")}>. Only <${$eb2240fc39a57fa5$var$capitalize(e.type)}> is supported.`);
          Ts++, yield so;
        }
        qs = xs.next(Io);
      }
      return;
    }
    if (e.key == null || e.type == null) return;
    let ro = this;
    var no, eo;
    let ao = {
      type: e.type,
      props: e.props,
      key: e.key,
      parentKey: ea ? ea.key : null,
      value: (no = e.value) !== null && no !== void 0 ? no : null,
      level: ea ? ea.level + 1 : 0,
      index: e.index,
      rendered: e.rendered,
      textValue: (eo = e.textValue) !== null && eo !== void 0 ? eo : "",
      "aria-label": e["aria-label"],
      wrapper: e.wrapper,
      shouldInvalidate: e.shouldInvalidate,
      hasChildNodes: e.hasChildNodes || !1,
      childNodes: $eb2240fc39a57fa5$var$iterable(function* () {
        if (!e.hasChildNodes || !e.childNodes) return;
        let io = 0;
        for (let xs of e.childNodes()) {
          xs.key != null && (xs.key = `${ao.key}${xs.key}`);
          let Ts = ro.getFullNode({
            ...xs,
            index: io
          }, ro.getChildState(Zi, xs), ao.key, ao);
          for (let qs of Ts)
            io++, yield qs;
        }
      })
    };
    yield ao;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function $eb2240fc39a57fa5$var$iterable(Bi) {
  let e = [], Zi = null;
  return {
    *[Symbol.iterator]() {
      for (let Qi of e) yield Qi;
      Zi || (Zi = Bi());
      for (let Qi of Zi)
        e.push(Qi), yield Qi;
    }
  };
}
function $eb2240fc39a57fa5$var$compose(Bi, e) {
  if (Bi && e) return (Zi) => Bi(e(Zi));
  if (Bi) return Bi;
  if (e) return e;
}
function $eb2240fc39a57fa5$var$capitalize(Bi) {
  return Bi[0].toUpperCase() + Bi.slice(1);
}
function $7613b1592d41b092$export$6cd28814d92fa9c9(Bi, e, Zi) {
  let Qi = useMemo(() => new $eb2240fc39a57fa5$export$bf788dd355e3a401(), []), { children: ea, items: ra, collection: na } = Bi;
  return useMemo(() => {
    if (na) return na;
    let fa = Qi.build({
      children: ea,
      items: ra
    }, Zi);
    return e(fa);
  }, [
    Qi,
    ea,
    ra,
    na,
    Zi,
    e
  ]);
}
function $c5a24bc478652b5f$export$1005530eda016c13(Bi, e) {
  return typeof e.getChildren == "function" ? e.getChildren(Bi.key) : Bi.childNodes;
}
function $c5a24bc478652b5f$export$fbdeaa6a76694f71(Bi) {
  return $c5a24bc478652b5f$export$5f3398f8733f90e2(Bi);
}
function $c5a24bc478652b5f$export$5f3398f8733f90e2(Bi, e) {
  for (let Zi of Bi)
    return Zi;
}
function $c5a24bc478652b5f$export$8c434b3a7a4dad6(Bi, e, Zi) {
  if (e.parentKey === Zi.parentKey) return e.index - Zi.index;
  let Qi = [
    ...$c5a24bc478652b5f$var$getAncestors(Bi, e),
    e
  ], ea = [
    ...$c5a24bc478652b5f$var$getAncestors(Bi, Zi),
    Zi
  ], ra = Qi.slice(0, ea.length).findIndex((na, ia) => na !== ea[ia]);
  return ra !== -1 ? (e = Qi[ra], Zi = ea[ra], e.index - Zi.index) : Qi.findIndex((na) => na === Zi) >= 0 ? 1 : (ea.findIndex((na) => na === e) >= 0, -1);
}
function $c5a24bc478652b5f$var$getAncestors(Bi, e) {
  let Zi = [], Qi = e;
  for (; Qi?.parentKey != null; )
    Qi = Bi.getItem(Qi.parentKey), Qi && Zi.unshift(Qi);
  return Zi;
}
const $453cc9f0df89c0a5$var$cache = /* @__PURE__ */ new WeakMap();
function $453cc9f0df89c0a5$export$77d5aafae4e095b2(Bi) {
  let e = $453cc9f0df89c0a5$var$cache.get(Bi);
  if (e != null) return e;
  let Zi = 0, Qi = (ea) => {
    for (let ra of ea) ra.type === "section" ? Qi($c5a24bc478652b5f$export$1005530eda016c13(ra, Bi)) : Zi++;
  };
  return Qi(Bi), $453cc9f0df89c0a5$var$cache.set(Bi, Zi), Zi;
}
function $293f70390ea03370$export$497855f14858aa34(Bi, e, Zi) {
  var Qi, ea;
  let { key: ra } = Bi, na = $b1f0cad8af73213b$export$3585ede4d035bf14.get(e);
  var ia;
  let fa = (ia = Bi.isDisabled) !== null && ia !== void 0 ? ia : e.selectionManager.isDisabled(ra);
  var La;
  let Va = (La = Bi.isSelected) !== null && La !== void 0 ? La : e.selectionManager.isSelected(ra);
  var to;
  let ro = (to = Bi.shouldSelectOnPressUp) !== null && to !== void 0 ? to : na?.shouldSelectOnPressUp;
  var no;
  let eo = (no = Bi.shouldFocusOnHover) !== null && no !== void 0 ? no : na?.shouldFocusOnHover;
  var ao;
  let io = (ao = Bi.shouldUseVirtualFocus) !== null && ao !== void 0 ? ao : na?.shouldUseVirtualFocus;
  var xs;
  let Ts = (xs = Bi.isVirtualized) !== null && xs !== void 0 ? xs : na?.isVirtualized, qs = $bdb11010cef70236$export$b4cc09c592e8fdb8(), Fs = $bdb11010cef70236$export$b4cc09c592e8fdb8(), Do = {
    role: "option",
    "aria-disabled": fa || void 0,
    "aria-selected": e.selectionManager.selectionMode !== "none" ? Va : void 0
  };
  $c87311424ea30a05$export$9ac100e40613ea10() && $c87311424ea30a05$export$78551043582a6a98() || (Do["aria-label"] = Bi["aria-label"], Do["aria-labelledby"] = qs, Do["aria-describedby"] = Fs);
  let ys = e.collection.getItem(ra);
  if (Ts) {
    let Fl = Number(ys?.index);
    Do["aria-posinset"] = Number.isNaN(Fl) ? void 0 : Fl + 1, Do["aria-setsize"] = $453cc9f0df89c0a5$export$77d5aafae4e095b2(e.collection);
  }
  let Io = na?.onAction ? () => {
    var Fl;
    return na == null || (Fl = na.onAction) === null || Fl === void 0 ? void 0 : Fl.call(na, ra);
  } : void 0, so = $b1f0cad8af73213b$export$9145995848b05025(e, ra), { itemProps: os, isPressed: Xs, isFocused: gl, hasAction: Sl, allowsSelection: El } = $880e95eb8b93ba9a$export$ecf600387e221c37({
    selectionManager: e.selectionManager,
    key: ra,
    ref: Zi,
    shouldSelectOnPressUp: ro,
    allowsDifferentPressOrigin: ro && eo,
    isVirtualized: Ts,
    shouldUseVirtualFocus: io,
    isDisabled: fa,
    onAction: Io || !(ys == null || (Qi = ys.props) === null || Qi === void 0) && Qi.onAction ? $ff5963eb1fccf552$export$e08e3b67e392101e(ys == null || (ea = ys.props) === null || ea === void 0 ? void 0 : ea.onAction, Io) : void 0,
    linkBehavior: na?.linkBehavior,
    id: so
  }), { hoverProps: wl } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: fa || !eo,
    onHoverStart() {
      $507fabe10e71c6fb$export$b9b3dfddab17db27() || (e.selectionManager.setFocused(!0), e.selectionManager.setFocusedKey(ra));
    }
  }), jl = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(ys?.props);
  delete jl.id;
  let kl = $ea8dcbcb9ea1b556$export$7e924b3091a3bd18(ys?.props);
  return {
    optionProps: {
      ...Do,
      ...$3ef42575df84b30b$export$9d1611c77c2fe928(jl, os, wl, kl),
      id: so
    },
    labelProps: {
      id: qs
    },
    descriptionProps: {
      id: Fs
    },
    isFocused: gl,
    isFocusVisible: gl && $507fabe10e71c6fb$export$b9b3dfddab17db27(),
    isSelected: Va,
    isDisabled: fa,
    isPressed: Xs,
    allowsSelection: El,
    hasAction: Sl
  };
}
function $af383d3bef1cfdc9$export$c3f9f39876e4bc7(Bi) {
  let { heading: e, "aria-label": Zi } = Bi, Qi = $bdb11010cef70236$export$f680877a34711e37();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: e ? {
      // Techincally, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: Qi,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": Zi,
      "aria-labelledby": e ? Qi : void 0
    }
  };
}
var $c0398ad35c3639b7$exports = {};
$c0398ad35c3639b7$exports = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var $7af657c4165927c3$exports = {};
$7af657c4165927c3$exports = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var $d95d4da6d531ab81$exports = {};
$d95d4da6d531ab81$exports = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var $24ebda9c775dca17$exports = {};
$24ebda9c775dca17$exports = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var $743e0dfca6cab1e9$exports = {};
$743e0dfca6cab1e9$exports = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var $a2f41026e05f1c84$exports = {};
$a2f41026e05f1c84$exports = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var $43b800e97c901737$exports = {};
$43b800e97c901737$exports = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var $442f5f6ac211e29f$exports = {};
$442f5f6ac211e29f$exports = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var $dff280acfeb2d8ac$exports = {};
$dff280acfeb2d8ac$exports = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var $51608325613944d7$exports = {};
$51608325613944d7$exports = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var $c4a1b1eabeaa87be$exports = {};
$c4a1b1eabeaa87be$exports = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var $8c74815cdee18d1b$exports = {};
$8c74815cdee18d1b$exports = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var $fd0e9ef6a7fe0ec9$exports = {};
$fd0e9ef6a7fe0ec9$exports = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var $a89a74a39eba465a$exports = {};
$a89a74a39eba465a$exports = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var $edc7c66594a0ae8a$exports = {};
$edc7c66594a0ae8a$exports = {
  longPressMessage: "Premere a lungo o premere Alt + Freccia giù per aprire il menu"
};
var $f1ab51510712db52$exports = {};
$f1ab51510712db52$exports = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var $f9b672d9b82fa3d6$exports = {};
$f9b672d9b82fa3d6$exports = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var $a385f3910feda499$exports = {};
$a385f3910feda499$exports = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var $4f1bde932c441789$exports = {};
$4f1bde932c441789$exports = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var $914a51a8a594d5be$exports = {};
$914a51a8a594d5be$exports = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var $89aaf803103bb500$exports = {};
$89aaf803103bb500$exports = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var $c685891476dbaaca$exports = {};
$c685891476dbaaca$exports = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var $885879b9b10c2959$exports = {};
$885879b9b10c2959$exports = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var $6b39616688a51692$exports = {};
$6b39616688a51692$exports = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var $f26362aed63f47e2$exports = {};
$f26362aed63f47e2$exports = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var $06cbade644558bf0$exports = {};
$06cbade644558bf0$exports = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var $0a391ff68f9d59b1$exports = {};
$0a391ff68f9d59b1$exports = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var $8193cf0e649c7928$exports = {};
$8193cf0e649c7928$exports = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var $f398debcce5a5c55$exports = {};
$f398debcce5a5c55$exports = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var $9e9fef000aa4c013$exports = {};
$9e9fef000aa4c013$exports = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var $c016c8183bbe3d68$exports = {};
$c016c8183bbe3d68$exports = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var $ca4f6c8462244e62$exports = {};
$ca4f6c8462244e62$exports = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var $2d9960c02ccac927$exports = {};
$2d9960c02ccac927$exports = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var $f1b682a4c8c5631c$exports = {};
$f1b682a4c8c5631c$exports = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var $2cbb7ca666678a14$exports = {};
$2cbb7ca666678a14$exports = {
  "ar-AE": $c0398ad35c3639b7$exports,
  "bg-BG": $7af657c4165927c3$exports,
  "cs-CZ": $d95d4da6d531ab81$exports,
  "da-DK": $24ebda9c775dca17$exports,
  "de-DE": $743e0dfca6cab1e9$exports,
  "el-GR": $a2f41026e05f1c84$exports,
  "en-US": $43b800e97c901737$exports,
  "es-ES": $442f5f6ac211e29f$exports,
  "et-EE": $dff280acfeb2d8ac$exports,
  "fi-FI": $51608325613944d7$exports,
  "fr-FR": $c4a1b1eabeaa87be$exports,
  "he-IL": $8c74815cdee18d1b$exports,
  "hr-HR": $fd0e9ef6a7fe0ec9$exports,
  "hu-HU": $a89a74a39eba465a$exports,
  "it-IT": $edc7c66594a0ae8a$exports,
  "ja-JP": $f1ab51510712db52$exports,
  "ko-KR": $f9b672d9b82fa3d6$exports,
  "lt-LT": $a385f3910feda499$exports,
  "lv-LV": $4f1bde932c441789$exports,
  "nb-NO": $914a51a8a594d5be$exports,
  "nl-NL": $89aaf803103bb500$exports,
  "pl-PL": $c685891476dbaaca$exports,
  "pt-BR": $885879b9b10c2959$exports,
  "pt-PT": $6b39616688a51692$exports,
  "ro-RO": $f26362aed63f47e2$exports,
  "ru-RU": $06cbade644558bf0$exports,
  "sk-SK": $0a391ff68f9d59b1$exports,
  "sl-SI": $8193cf0e649c7928$exports,
  "sr-SP": $f398debcce5a5c55$exports,
  "sv-SE": $9e9fef000aa4c013$exports,
  "tr-TR": $c016c8183bbe3d68$exports,
  "uk-UA": $ca4f6c8462244e62$exports,
  "zh-CN": $2d9960c02ccac927$exports,
  "zh-TW": $f1b682a4c8c5631c$exports
};
function $parcel$interopDefault(Bi) {
  return Bi && Bi.__esModule ? Bi.default : Bi;
}
function $168583247155ddda$export$dc9c12ed27dd1b49(Bi, e, Zi) {
  let { type: Qi = "menu", isDisabled: ea, trigger: ra = "press" } = Bi, na = $bdb11010cef70236$export$f680877a34711e37(), { triggerProps: ia, overlayProps: fa } = $628037886ba31236$export$f9d5c8beee7d008d({
    type: Qi
  }, e, Zi), La = (no) => {
    if (!ea && !(ra === "longPress" && !no.altKey) && Zi && Zi.current)
      switch (no.key) {
        case "Enter":
        case " ":
          if (ra === "longPress") return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in no || no.stopPropagation(), no.preventDefault(), e.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in no || no.stopPropagation(), no.preventDefault(), e.toggle("last");
          break;
        default:
          "continuePropagation" in no && no.continuePropagation();
      }
  }, Va = $fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault($2cbb7ca666678a14$exports), "@react-aria/menu"), { longPressProps: to } = $8a26561d2877236e$export$c24ed0104d07eab9({
    isDisabled: ea || ra !== "longPress",
    accessibilityDescription: Va.format("longPressMessage"),
    onLongPressStart() {
      e.close();
    },
    onLongPress() {
      e.open("first");
    }
  }), ro = {
    onPressStart(no) {
      no.pointerType !== "touch" && no.pointerType !== "keyboard" && !ea && e.open(no.pointerType === "virtual" ? "first" : null);
    },
    onPress(no) {
      no.pointerType === "touch" && !ea && e.toggle();
    }
  };
  return delete ia.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...ia,
      ...ra === "press" ? ro : to,
      id: na,
      onKeyDown: La
    },
    menuProps: {
      ...fa,
      "aria-labelledby": na,
      autoFocus: e.focusStrategy || !0,
      onClose: e.close
    }
  };
}
const $fc79756100351201$export$6f49b4016bfc8d56 = /* @__PURE__ */ new WeakMap();
function $d5336fe17ce95402$export$38eaa17faae8f579(Bi, e, Zi) {
  let { shouldFocusWrap: Qi = !0, onKeyDown: ea, onKeyUp: ra, ...na } = Bi;
  !Bi["aria-label"] && !Bi["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let ia = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }), { listProps: fa } = $982254629710d113$export$b95089534ab7c1fd({
    ...na,
    ref: Zi,
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    shouldFocusWrap: Qi,
    linkBehavior: "override"
  });
  return $fc79756100351201$export$6f49b4016bfc8d56.set(e, {
    onClose: Bi.onClose,
    onAction: Bi.onAction,
    shouldUseVirtualFocus: Bi.shouldUseVirtualFocus
  }), {
    menuProps: $3ef42575df84b30b$export$9d1611c77c2fe928(ia, {
      onKeyDown: ea,
      onKeyUp: ra
    }, {
      role: "menu",
      ...fa,
      onKeyDown: (La) => {
        var Va;
        (La.key !== "Escape" || Bi.shouldUseVirtualFocus) && ((Va = fa.onKeyDown) === null || Va === void 0 || Va.call(fa, La));
      }
    })
  };
}
function $a2e5df62f93c7633$export$9d32628fc2aea7da(Bi, e, Zi) {
  let { id: Qi, key: ea, closeOnSelect: ra, isVirtualized: na, "aria-haspopup": ia, onPressStart: fa, onPressUp: La, onPress: Va, onPressChange: to, onPressEnd: ro, onHoverStart: no, onHoverChange: eo, onHoverEnd: ao, onKeyDown: io, onKeyUp: xs, onFocus: Ts, onFocusChange: qs, onBlur: Fs, selectionManager: Do = e.selectionManager } = Bi, ys = !!ia, Io = ys && Bi["aria-expanded"] === "true";
  var so;
  let os = (so = Bi.isDisabled) !== null && so !== void 0 ? so : Do.isDisabled(ea);
  var Xs;
  let gl = (Xs = Bi.isSelected) !== null && Xs !== void 0 ? Xs : Do.isSelected(ea), Sl = $fc79756100351201$export$6f49b4016bfc8d56.get(e), El = e.collection.getItem(ea), wl = Bi.onClose || Sl.onClose, jl = $ea8dcbcb9ea1b556$export$9a302a45f65d0572(), kl = (Cl) => {
    var ml;
    if (!ys) {
      if (!(El == null || (ml = El.props) === null || ml === void 0) && ml.onAction ? El.props.onAction() : Bi.onAction && Bi.onAction(ea), Sl.onAction) {
        let Tl = Sl.onAction;
        Tl(ea);
      }
      Cl.target instanceof HTMLAnchorElement && El && jl.open(Cl.target, Cl, El.props.href, El.props.routerOptions);
    }
  }, Fl = "menuitem";
  ys || (Do.selectionMode === "single" ? Fl = "menuitemradio" : Do.selectionMode === "multiple" && (Fl = "menuitemcheckbox"));
  let Ml = $bdb11010cef70236$export$b4cc09c592e8fdb8(), ql = $bdb11010cef70236$export$b4cc09c592e8fdb8(), Kl = $bdb11010cef70236$export$b4cc09c592e8fdb8(), Zl = {
    id: Qi,
    "aria-disabled": os || void 0,
    role: Fl,
    "aria-label": Bi["aria-label"],
    "aria-labelledby": Ml,
    "aria-describedby": [
      ql,
      Kl
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": Bi["aria-controls"],
    "aria-haspopup": ia,
    "aria-expanded": Bi["aria-expanded"]
  };
  Do.selectionMode !== "none" && !ys && (Zl["aria-checked"] = gl), na && (Zl["aria-posinset"] = El?.index, Zl["aria-setsize"] = $453cc9f0df89c0a5$export$77d5aafae4e095b2(e.collection));
  let Il = (Cl) => {
    Cl.pointerType === "keyboard" && kl(Cl), fa?.(Cl);
  }, xl = () => {
    !ys && wl && (ra ?? (Do.selectionMode !== "multiple" || Do.isLink(ea))) && wl();
  }, bl = (Cl) => {
    Cl.pointerType === "mouse" && (kl(Cl), xl()), La?.(Cl);
  }, Pl = (Cl) => {
    Cl.pointerType !== "keyboard" && Cl.pointerType !== "mouse" && (kl(Cl), xl()), Va?.(Cl);
  }, { itemProps: Nl, isFocused: Bl } = $880e95eb8b93ba9a$export$ecf600387e221c37({
    id: Qi,
    selectionManager: Do,
    key: ea,
    ref: Zi,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: Sl.shouldUseVirtualFocus
  }), { pressProps: Ol, isPressed: To } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart: Il,
    onPress: Pl,
    onPressUp: bl,
    onPressChange: to,
    onPressEnd: ro,
    isDisabled: os
  }), { hoverProps: Os } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: os,
    onHoverStart(Cl) {
      !$507fabe10e71c6fb$export$b9b3dfddab17db27() && !(Io && ia === "dialog") && (Do.setFocused(!0), Do.setFocusedKey(ea)), no?.(Cl);
    },
    onHoverChange: eo,
    onHoverEnd: ao
  }), { keyboardProps: $l } = $46d819fcbaf35654$export$8f71654801c2f7cd({
    onKeyDown: (Cl) => {
      if (Cl.repeat) {
        Cl.continuePropagation();
        return;
      }
      switch (Cl.key) {
        case " ":
          !os && Do.selectionMode === "none" && !ys && ra !== !1 && wl && wl();
          break;
        case "Enter":
          !os && ra !== !1 && !ys && wl && wl();
          break;
        default:
          ys || Cl.continuePropagation(), io?.(Cl);
          break;
      }
    },
    onKeyUp: xs
  }), { focusProps: _l } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    onBlur: Fs,
    onFocus: Ts,
    onFocusChange: qs
  }), Al = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(El?.props);
  delete Al.id;
  let Rl = $ea8dcbcb9ea1b556$export$7e924b3091a3bd18(El?.props);
  return {
    menuItemProps: {
      ...Zl,
      ...$3ef42575df84b30b$export$9d1611c77c2fe928(Al, Rl, ys ? {
        onFocus: Nl.onFocus,
        "data-key": Nl["data-key"]
      } : Nl, Ol, Os, $l, _l),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: Nl.tabIndex != null && Io ? -1 : Nl.tabIndex
    },
    labelProps: {
      id: Ml
    },
    descriptionProps: {
      id: ql
    },
    keyboardShortcutProps: {
      id: Kl
    },
    isFocused: Bl,
    isSelected: gl,
    isPressed: To,
    isDisabled: os
  };
}
function $3e5eb2498db5b506$export$73f7a44322579622(Bi) {
  let { heading: e, "aria-label": Zi } = Bi, Qi = $bdb11010cef70236$export$f680877a34711e37();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: e ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: Qi,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": Zi,
      "aria-labelledby": e ? Qi : void 0
    }
  };
}
const $58aed456727eb0f3$export$703601b7e90536f8 = /* @__PURE__ */ new WeakMap();
function $58aed456727eb0f3$export$e64b2f635402ca43(Bi, e, Zi) {
  let { keyboardDelegate: Qi, isDisabled: ea, isRequired: ra, name: na, validationBehavior: ia = "aria" } = Bi, fa = $325a3faab7a68acd$export$a16aca283550c30d({
    usage: "search",
    sensitivity: "base"
  }), La = useMemo(() => Qi || new $2a25aae57d74318e$export$a05409b8bb224a5a(e.collection, e.disabledKeys, Zi, fa), [
    Qi,
    e.collection,
    e.disabledKeys,
    fa
  ]), { menuTriggerProps: Va, menuProps: to } = $168583247155ddda$export$dc9c12ed27dd1b49({
    isDisabled: ea,
    type: "listbox"
  }, e, Zi), ro = (so) => {
    switch (so.key) {
      case "ArrowLeft": {
        var os, Xs;
        so.preventDefault();
        let El = e.selectedKey != null ? (os = La.getKeyAbove) === null || os === void 0 ? void 0 : os.call(La, e.selectedKey) : (Xs = La.getFirstKey) === null || Xs === void 0 ? void 0 : Xs.call(La);
        El && e.setSelectedKey(El);
        break;
      }
      case "ArrowRight": {
        var gl, Sl;
        so.preventDefault();
        let El = e.selectedKey != null ? (gl = La.getKeyBelow) === null || gl === void 0 ? void 0 : gl.call(La, e.selectedKey) : (Sl = La.getFirstKey) === null || Sl === void 0 ? void 0 : Sl.call(La);
        El && e.setSelectedKey(El);
        break;
      }
    }
  }, { typeSelectProps: no } = $fb3050f43d946246$export$e32c88dfddc6e1d8({
    keyboardDelegate: La,
    selectionManager: e.selectionManager,
    onTypeSelect(so) {
      e.setSelectedKey(so);
    }
  }), { isInvalid: eo, validationErrors: ao, validationDetails: io } = e.displayValidation, { labelProps: xs, fieldProps: Ts, descriptionProps: qs, errorMessageProps: Fs } = $2baaea4c71418dea$export$294aa081a6c6f55d({
    ...Bi,
    labelElementType: "span",
    isInvalid: eo,
    errorMessage: Bi.errorMessage || ao
  });
  no.onKeyDown = no.onKeyDownCapture, delete no.onKeyDownCapture;
  let Do = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }), ys = $3ef42575df84b30b$export$9d1611c77c2fe928(no, Va, Ts), Io = $bdb11010cef70236$export$f680877a34711e37();
  return $58aed456727eb0f3$export$703601b7e90536f8.set(e, {
    isDisabled: ea,
    isRequired: ra,
    name: na,
    validationBehavior: ia
  }), {
    labelProps: {
      ...xs,
      onClick: () => {
        if (!Bi.isDisabled) {
          var so;
          (so = Zi.current) === null || so === void 0 || so.focus(), $507fabe10e71c6fb$export$8397ddfc504fdb9a("keyboard");
        }
      }
    },
    triggerProps: $3ef42575df84b30b$export$9d1611c77c2fe928(Do, {
      ...ys,
      isDisabled: ea,
      onKeyDown: $ff5963eb1fccf552$export$e08e3b67e392101e(ys.onKeyDown, ro, Bi.onKeyDown),
      onKeyUp: Bi.onKeyUp,
      "aria-labelledby": [
        Io,
        ys["aria-labelledby"],
        ys["aria-label"] && !ys["aria-labelledby"] ? ys.id : null
      ].filter(Boolean).join(" "),
      onFocus(so) {
        e.isFocused || (Bi.onFocus && Bi.onFocus(so), Bi.onFocusChange && Bi.onFocusChange(!0), e.setFocused(!0));
      },
      onBlur(so) {
        e.isOpen || (Bi.onBlur && Bi.onBlur(so), Bi.onFocusChange && Bi.onFocusChange(!1), e.setFocused(!1));
      }
    }),
    valueProps: {
      id: Io
    },
    menuProps: {
      ...to,
      autoFocus: e.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (so) => {
        so.currentTarget.contains(so.relatedTarget) || (Bi.onBlur && Bi.onBlur(so), Bi.onFocusChange && Bi.onFocusChange(!1), e.setFocused(!1));
      },
      "aria-labelledby": [
        Ts["aria-labelledby"],
        ys["aria-label"] && !Ts["aria-labelledby"] ? ys.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: qs,
    errorMessageProps: Fs,
    isInvalid: eo,
    validationErrors: ao,
    validationDetails: io
  };
}
function $bdd25dc72710631f$export$f809e80f58e251d1(Bi, e, Zi) {
  let Qi = $58aed456727eb0f3$export$703601b7e90536f8.get(e) || {}, { autoComplete: ea, name: ra = Qi.name, isDisabled: na = Qi.isDisabled } = Bi, { validationBehavior: ia, isRequired: fa } = Qi, { visuallyHiddenProps: La } = $5c3e21d68f1c4674$export$a966af930f325cab();
  $99facab73266f662$export$5add1d006293d136(Bi.selectRef, e.selectedKey, e.setSelectedKey), $e93e671b31057976$export$b8473d3665f3a75a({
    validationBehavior: ia,
    focus: () => {
      var to;
      return (to = Zi.current) === null || to === void 0 ? void 0 : to.focus();
    }
  }, e, Bi.selectRef);
  var Va;
  return {
    containerProps: {
      ...La,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      style: {
        display: "none"
      }
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: ea,
      disabled: na,
      required: ia === "native" && fa,
      name: ra,
      value: (Va = e.selectedKey) !== null && Va !== void 0 ? Va : "",
      onChange: (to) => e.setSelectedKey(to.target.value)
    }
  };
}
function $bdd25dc72710631f$export$cbd84cdb2e668835(Bi) {
  let { state: e, triggerRef: Zi, label: Qi, name: ea, isDisabled: ra } = Bi, na = useRef(null), { containerProps: ia, selectProps: fa } = $bdd25dc72710631f$export$f809e80f58e251d1({
    ...Bi,
    selectRef: na
  }, e, Zi);
  var La;
  return e.collection.size <= 300 ? /* @__PURE__ */ a__default.createElement("div", {
    ...ia,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ a__default.createElement("label", null, Qi, /* @__PURE__ */ a__default.createElement("select", {
    ...fa,
    ref: na
  }, /* @__PURE__ */ a__default.createElement("option", null), [
    ...e.collection.getKeys()
  ].map((Va) => {
    let to = e.collection.getItem(Va);
    if (to && to.type === "item") return /* @__PURE__ */ a__default.createElement("option", {
      key: to.key,
      value: to.key
    }, to.textValue);
  })))) : ea ? /* @__PURE__ */ a__default.createElement("input", {
    type: "hidden",
    autoComplete: fa.autoComplete,
    name: ea,
    disabled: ra,
    value: (La = e.selectedKey) !== null && La !== void 0 ? La : ""
  }) : null;
}
const $0393f8ab869a0f1a$export$e9f3bf65a26ce129 = /* @__PURE__ */ createContext(null), $d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), $d2b4bc8c273e7be6$export$24d547caef80ccd1 = /* @__PURE__ */ createContext({}), $d2b4bc8c273e7be6$export$353f5b6fc5456de1 = /* @__PURE__ */ $f39a9eba43920ace$export$86427a43e3e48ebb(function(e, Zi) {
  [e, Zi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Zi, $d2b4bc8c273e7be6$export$24d547caef80ccd1), e = $d2b4bc8c273e7be6$var$disablePendingProps(e);
  let Qi = e, { isPending: ea } = Qi, { buttonProps: ra, isPressed: na } = $701a24aa0da5b062$export$ea18c227d4417cc3(e, Zi), { focusProps: ia, isFocused: fa, isFocusVisible: La } = $f7dceffc5ad7768b$export$4e328f61c538687f(e), { hoverProps: Va, isHovered: to } = $6179b936705e76d3$export$ae780daf29e6d456({
    ...e,
    isDisabled: e.isDisabled || ea
  }), ro = {
    isHovered: to,
    isPressed: (Qi.isPressed || na) && !ea,
    isFocused: fa,
    isFocusVisible: La,
    isDisabled: e.isDisabled || !1,
    isPending: ea ?? !1
  }, no = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    values: ro,
    defaultClassName: "react-aria-Button"
  }), eo = $bdb11010cef70236$export$f680877a34711e37(ra.id), ao = $bdb11010cef70236$export$f680877a34711e37(), io = ra["aria-labelledby"];
  ea && (io ? io = `${io} ${ao}` : ra["aria-label"] && (io = `${eo} ${ao}`));
  let xs = useRef(ea);
  return useEffect(() => {
    let Ts = {
      "aria-labelledby": io || eo
    };
    (!xs.current && fa && ea || xs.current && fa && !ea) && $319e236875307eab$export$a9b970dcc4ae71a9(Ts, "assertive"), xs.current = ea;
  }, [
    ea,
    fa,
    io,
    eo
  ]), /* @__PURE__ */ a__default.createElement("button", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(e, {
      propNames: $d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes
    }),
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(ra, ia, Va),
    ...no,
    type: ra.type === "submit" && ea ? "button" : ra.type,
    id: eo,
    ref: Zi,
    "aria-labelledby": io,
    slot: e.slot || void 0,
    "aria-disabled": ea ? "true" : ra["aria-disabled"],
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": ro.isPressed || void 0,
    "data-hovered": to || void 0,
    "data-focused": fa || void 0,
    "data-pending": ea || void 0,
    "data-focus-visible": La || void 0
  }, /* @__PURE__ */ a__default.createElement($0393f8ab869a0f1a$export$e9f3bf65a26ce129.Provider, {
    value: {
      id: ao
    }
  }, no.children));
});
function $d2b4bc8c273e7be6$var$disablePendingProps(Bi) {
  return Bi.isPending && (Bi.onPress = void 0, Bi.onPressStart = void 0, Bi.onPressEnd = void 0, Bi.onPressChange = void 0, Bi.onPressUp = void 0, Bi.onKeyDown = void 0, Bi.onKeyUp = void 0, Bi.onClick = void 0, Bi.href = void 0), Bi;
}
const $514c0188e459b4c0$export$9afb8bc826b033ea = /* @__PURE__ */ createContext({}), $ee014567cb39d3f0$export$ff05c3ac10437e03 = /* @__PURE__ */ createContext(null);
class $a02d57049d202695$export$d085fb9e920b5ca7 {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let Zi = this.keyMap.get(e);
    var Qi;
    return Zi && (Qi = Zi.prevKey) !== null && Qi !== void 0 ? Qi : null;
  }
  getKeyAfter(e) {
    let Zi = this.keyMap.get(e);
    var Qi;
    return Zi && (Qi = Zi.nextKey) !== null && Qi !== void 0 ? Qi : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    var Zi;
    return (Zi = this.keyMap.get(e)) !== null && Zi !== void 0 ? Zi : null;
  }
  at(e) {
    const Zi = [
      ...this.getKeys()
    ];
    return this.getItem(Zi[e]);
  }
  getChildren(e) {
    let Zi = this.keyMap.get(e);
    return Zi?.childNodes || [];
  }
  constructor(e) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e;
    let Zi = (na) => {
      if (this.keyMap.set(na.key, na), na.childNodes && na.type === "section") for (let ia of na.childNodes) Zi(ia);
    };
    for (let na of e) Zi(na);
    let Qi = null, ea = 0;
    for (let [na, ia] of this.keyMap)
      Qi ? (Qi.nextKey = na, ia.prevKey = Qi.key) : (this.firstKey = na, ia.prevKey = void 0), ia.type === "item" && (ia.index = ea++), Qi = ia, Qi.nextKey = void 0;
    var ra;
    this.lastKey = (ra = Qi?.key) !== null && ra !== void 0 ? ra : null;
  }
}
class $e40ea825a81a3709$export$52baac22726c72bf extends Set {
  constructor(e, Zi, Qi) {
    super(e), e instanceof $e40ea825a81a3709$export$52baac22726c72bf ? (this.anchorKey = Zi ?? e.anchorKey, this.currentKey = Qi ?? e.currentKey) : (this.anchorKey = Zi ?? null, this.currentKey = Qi ?? null);
  }
}
function $7af3f5b51489e0b5$var$equalSets(Bi, e) {
  if (Bi.size !== e.size) return !1;
  for (let Zi of Bi)
    if (!e.has(Zi)) return !1;
  return !0;
}
function $7af3f5b51489e0b5$export$253fe78d46329472(Bi) {
  let { selectionMode: e = "none", disallowEmptySelection: Zi = !1, allowDuplicateSelectionEvents: Qi, selectionBehavior: ea = "toggle", disabledBehavior: ra = "all" } = Bi, na = useRef(!1), [, ia] = useState(!1), fa = useRef(null), La = useRef(null), [, Va] = useState(null), to = useMemo(() => $7af3f5b51489e0b5$var$convertSelection(Bi.selectedKeys), [
    Bi.selectedKeys
  ]), ro = useMemo(() => $7af3f5b51489e0b5$var$convertSelection(Bi.defaultSelectedKeys, new $e40ea825a81a3709$export$52baac22726c72bf()), [
    Bi.defaultSelectedKeys
  ]), [no, eo] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(to, ro, Bi.onSelectionChange), ao = useMemo(() => Bi.disabledKeys ? new Set(Bi.disabledKeys) : /* @__PURE__ */ new Set(), [
    Bi.disabledKeys
  ]), [io, xs] = useState(ea);
  ea === "replace" && io === "toggle" && typeof no == "object" && no.size === 0 && xs("replace");
  let Ts = useRef(ea);
  return useEffect(() => {
    ea !== Ts.current && (xs(ea), Ts.current = ea);
  }, [
    ea
  ]), {
    selectionMode: e,
    disallowEmptySelection: Zi,
    selectionBehavior: io,
    setSelectionBehavior: xs,
    get isFocused() {
      return na.current;
    },
    setFocused(qs) {
      na.current = qs, ia(qs);
    },
    get focusedKey() {
      return fa.current;
    },
    get childFocusStrategy() {
      return La.current;
    },
    setFocusedKey(qs, Fs = "first") {
      fa.current = qs, La.current = Fs, Va(qs);
    },
    selectedKeys: no,
    setSelectedKeys(qs) {
      (Qi || !$7af3f5b51489e0b5$var$equalSets(qs, no)) && eo(qs);
    },
    disabledKeys: ao,
    disabledBehavior: ra
  };
}
function $7af3f5b51489e0b5$var$convertSelection(Bi, e) {
  return Bi ? Bi === "all" ? "all" : new $e40ea825a81a3709$export$52baac22726c72bf(Bi) : e;
}
class $d496c0a20b6e58ec$export$6c8a5aaad13c9852 {
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(e) {
    this.state.setSelectionBehavior(e);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(e) {
    this.state.setFocused(e);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(e, Zi) {
    (e == null || this.collection.getItem(e)) && this.state.setFocusedKey(e, Zi);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(e) {
    if (this.state.selectionMode === "none") return !1;
    let Zi = this.getKey(e);
    return Zi == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(Zi) : this.state.selectedKeys.has(Zi);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let e = this.getSelectAllKeys(), Zi = this.state.selectedKeys;
    return this._isSelectAll = e.every((Qi) => Zi.has(Qi)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let e = null;
    for (let Qi of this.state.selectedKeys) {
      let ea = this.collection.getItem(Qi);
      (!e || ea && $c5a24bc478652b5f$export$8c434b3a7a4dad6(this.collection, ea, e) < 0) && (e = ea);
    }
    var Zi;
    return (Zi = e?.key) !== null && Zi !== void 0 ? Zi : null;
  }
  get lastSelectedKey() {
    let e = null;
    for (let Qi of this.state.selectedKeys) {
      let ea = this.collection.getItem(Qi);
      (!e || ea && $c5a24bc478652b5f$export$8c434b3a7a4dad6(this.collection, ea, e) > 0) && (e = ea);
    }
    var Zi;
    return (Zi = e?.key) !== null && Zi !== void 0 ? Zi : null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(e);
      return;
    }
    let Zi = this.getKey(e);
    if (Zi == null) return;
    let Qi;
    if (this.state.selectedKeys === "all") Qi = new $e40ea825a81a3709$export$52baac22726c72bf([
      Zi
    ], Zi, Zi);
    else {
      let na = this.state.selectedKeys;
      var ea;
      let ia = (ea = na.anchorKey) !== null && ea !== void 0 ? ea : Zi;
      Qi = new $e40ea825a81a3709$export$52baac22726c72bf(na, ia, Zi);
      var ra;
      for (let fa of this.getKeyRange(ia, (ra = na.currentKey) !== null && ra !== void 0 ? ra : Zi)) Qi.delete(fa);
      for (let fa of this.getKeyRange(Zi, ia)) this.canSelectItem(fa) && Qi.add(fa);
    }
    this.state.setSelectedKeys(Qi);
  }
  getKeyRange(e, Zi) {
    let Qi = this.collection.getItem(e), ea = this.collection.getItem(Zi);
    return Qi && ea ? $c5a24bc478652b5f$export$8c434b3a7a4dad6(this.collection, Qi, ea) <= 0 ? this.getKeyRangeInternal(e, Zi) : this.getKeyRangeInternal(Zi, e) : [];
  }
  getKeyRangeInternal(e, Zi) {
    var Qi;
    if (!((Qi = this.layoutDelegate) === null || Qi === void 0) && Qi.getKeyRange) return this.layoutDelegate.getKeyRange(e, Zi);
    let ea = [], ra = e;
    for (; ra != null; ) {
      let na = this.collection.getItem(ra);
      if (na && (na.type === "item" || na.type === "cell" && this.allowsCellSelection) && ea.push(ra), ra === Zi) return ea;
      ra = this.collection.getKeyAfter(ra);
    }
    return [];
  }
  getKey(e) {
    let Zi = this.collection.getItem(e);
    if (!Zi || Zi.type === "cell" && this.allowsCellSelection) return e;
    for (; Zi && Zi.type !== "item" && Zi.parentKey != null; ) Zi = this.collection.getItem(Zi.parentKey);
    return !Zi || Zi.type !== "item" ? null : Zi.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(e)) {
      this.replaceSelection(e);
      return;
    }
    let Zi = this.getKey(e);
    if (Zi == null) return;
    let Qi = new $e40ea825a81a3709$export$52baac22726c72bf(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    Qi.has(Zi) ? Qi.delete(Zi) : this.canSelectItem(Zi) && (Qi.add(Zi), Qi.anchorKey = Zi, Qi.currentKey = Zi), !(this.disallowEmptySelection && Qi.size === 0) && this.state.setSelectedKeys(Qi);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(e) {
    if (this.selectionMode === "none") return;
    let Zi = this.getKey(e);
    if (Zi == null) return;
    let Qi = this.canSelectItem(Zi) ? new $e40ea825a81a3709$export$52baac22726c72bf([
      Zi
    ], Zi, Zi) : new $e40ea825a81a3709$export$52baac22726c72bf();
    this.state.setSelectedKeys(Qi);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(e) {
    if (this.selectionMode === "none") return;
    let Zi = new $e40ea825a81a3709$export$52baac22726c72bf();
    for (let Qi of e) {
      let ea = this.getKey(Qi);
      if (ea != null && (Zi.add(ea), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(Zi);
  }
  getSelectAllKeys() {
    let e = [], Zi = (Qi) => {
      for (; Qi != null; ) {
        if (this.canSelectItem(Qi)) {
          var ea;
          let na = this.collection.getItem(Qi);
          na?.type === "item" && e.push(Qi);
          var ra;
          na?.hasChildNodes && (this.allowsCellSelection || na.type !== "item") && Zi((ra = (ea = $c5a24bc478652b5f$export$fbdeaa6a76694f71($c5a24bc478652b5f$export$1005530eda016c13(na, this.collection))) === null || ea === void 0 ? void 0 : ea.key) !== null && ra !== void 0 ? ra : null);
        }
        Qi = this.collection.getKeyAfter(Qi);
      }
    };
    return Zi(this.collection.getFirstKey()), e;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new $e40ea825a81a3709$export$52baac22726c72bf());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(e, Zi) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(e) && !this.disallowEmptySelection ? this.toggleSelection(e) : this.replaceSelection(e) : this.selectionBehavior === "toggle" || Zi && (Zi.pointerType === "touch" || Zi.pointerType === "virtual") ? this.toggleSelection(e) : this.replaceSelection(e));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(e) {
    if (e === this.state.selectedKeys) return !0;
    let Zi = this.selectedKeys;
    if (e.size !== Zi.size) return !1;
    for (let Qi of e)
      if (!Zi.has(Qi)) return !1;
    for (let Qi of Zi)
      if (!e.has(Qi)) return !1;
    return !0;
  }
  canSelectItem(e) {
    var Zi;
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(e)) return !1;
    let Qi = this.collection.getItem(e);
    return !(!Qi || !(Qi == null || (Zi = Qi.props) === null || Zi === void 0) && Zi.isDisabled || Qi.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(e) {
    var Zi, Qi;
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(e) || !!(!((Qi = this.collection.getItem(e)) === null || Qi === void 0 || (Zi = Qi.props) === null || Zi === void 0) && Zi.isDisabled));
  }
  isLink(e) {
    var Zi, Qi;
    return !!(!((Qi = this.collection.getItem(e)) === null || Qi === void 0 || (Zi = Qi.props) === null || Zi === void 0) && Zi.href);
  }
  getItemProps(e) {
    var Zi;
    return (Zi = this.collection.getItem(e)) === null || Zi === void 0 ? void 0 : Zi.props;
  }
  constructor(e, Zi, Qi) {
    this.collection = e, this.state = Zi;
    var ea;
    this.allowsCellSelection = (ea = Qi?.allowsCellSelection) !== null && ea !== void 0 ? ea : !1, this._isSelectAll = null, this.layoutDelegate = Qi?.layoutDelegate || null;
  }
}
function $e72dd72e1c76a225$export$2f645645f7bca764(Bi) {
  let { filter: e, layoutDelegate: Zi } = Bi, Qi = $7af3f5b51489e0b5$export$253fe78d46329472(Bi), ea = useMemo(() => Bi.disabledKeys ? new Set(Bi.disabledKeys) : /* @__PURE__ */ new Set(), [
    Bi.disabledKeys
  ]), ra = useCallback((Va) => e ? new $a02d57049d202695$export$d085fb9e920b5ca7(e(Va)) : new $a02d57049d202695$export$d085fb9e920b5ca7(Va), [
    e
  ]), na = useMemo(() => ({
    suppressTextValueWarning: Bi.suppressTextValueWarning
  }), [
    Bi.suppressTextValueWarning
  ]), ia = $7613b1592d41b092$export$6cd28814d92fa9c9(Bi, ra, na), fa = useMemo(() => new $d496c0a20b6e58ec$export$6c8a5aaad13c9852(ia, Qi, {
    layoutDelegate: Zi
  }), [
    ia,
    Qi,
    Zi
  ]);
  const La = useRef(null);
  return useEffect(() => {
    if (Qi.focusedKey != null && !ia.getItem(Qi.focusedKey) && La.current) {
      const xs = La.current.getItem(Qi.focusedKey), Ts = [
        ...La.current.getKeys()
      ].map((so) => {
        const os = La.current.getItem(so);
        return os?.type === "item" ? os : null;
      }).filter((so) => so !== null), qs = [
        ...ia.getKeys()
      ].map((so) => {
        const os = ia.getItem(so);
        return os?.type === "item" ? os : null;
      }).filter((so) => so !== null);
      var Va, to;
      const Fs = ((Va = Ts?.length) !== null && Va !== void 0 ? Va : 0) - ((to = qs?.length) !== null && to !== void 0 ? to : 0);
      var ro, no, eo;
      let Do = Math.min(Fs > 1 ? Math.max(((ro = xs?.index) !== null && ro !== void 0 ? ro : 0) - Fs + 1, 0) : (no = xs?.index) !== null && no !== void 0 ? no : 0, ((eo = qs?.length) !== null && eo !== void 0 ? eo : 0) - 1), ys = null, Io = !1;
      for (; Do >= 0; ) {
        if (!fa.isDisabled(qs[Do].key)) {
          ys = qs[Do];
          break;
        }
        if (Do < qs.length - 1 && !Io) Do++;
        else {
          Io = !0;
          var ao, io;
          Do > ((ao = xs?.index) !== null && ao !== void 0 ? ao : 0) && (Do = (io = xs?.index) !== null && io !== void 0 ? io : 0), Do--;
        }
      }
      Qi.setFocusedKey(ys ? ys.key : null);
    }
    La.current = ia;
  }, [
    ia,
    fa,
    Qi,
    Qi.focusedKey
  ]), {
    collection: ia,
    disabledKeys: ea,
    selectionManager: fa
  };
}
function $a0d645289fe9b86b$export$e7f05e985daf4b5f(Bi) {
  var e;
  let [Zi, Qi] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi.selectedKey, (e = Bi.defaultSelectedKey) !== null && e !== void 0 ? e : null, Bi.onSelectionChange), ea = useMemo(() => Zi != null ? [
    Zi
  ] : [], [
    Zi
  ]), { collection: ra, disabledKeys: na, selectionManager: ia } = $e72dd72e1c76a225$export$2f645645f7bca764({
    ...Bi,
    selectionMode: "single",
    disallowEmptySelection: !0,
    allowDuplicateSelectionEvents: !0,
    selectedKeys: ea,
    onSelectionChange: (La) => {
      if (La === "all") return;
      var Va;
      let to = (Va = La.values().next().value) !== null && Va !== void 0 ? Va : null;
      to === Zi && Bi.onSelectionChange && Bi.onSelectionChange(to), Qi(to);
    }
  }), fa = Zi != null ? ra.getItem(Zi) : null;
  return {
    collection: ra,
    disabledKeys: na,
    selectionManager: ia,
    selectedKey: Zi,
    setSelectedKey: Qi,
    selectedItem: fa
  };
}
function $fc909762b330b746$export$61c6a8c84e605fb6(Bi) {
  let [e, Zi] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi.isOpen, Bi.defaultOpen || !1, Bi.onOpenChange);
  const Qi = useCallback(() => {
    Zi(!0);
  }, [
    Zi
  ]), ea = useCallback(() => {
    Zi(!1);
  }, [
    Zi
  ]), ra = useCallback(() => {
    Zi(!e);
  }, [
    Zi,
    e
  ]);
  return {
    isOpen: e,
    setOpen: Zi,
    open: Qi,
    close: ea,
    toggle: ra
  };
}
function $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(Bi) {
  let e = $fc909762b330b746$export$61c6a8c84e605fb6(Bi), [Zi, Qi] = useState(null), [ea, ra] = useState([]), na = () => {
    ra([]), e.close();
  };
  return {
    focusStrategy: Zi,
    ...e,
    open(La = null) {
      Qi(La), e.open();
    },
    toggle(La = null) {
      Qi(La), e.toggle();
    },
    close() {
      na();
    },
    expandedKeysStack: ea,
    openSubmenu: (La, Va) => {
      ra((to) => Va > to.length ? to : [
        ...to.slice(0, Va),
        La
      ]);
    },
    closeSubmenu: (La, Va) => {
      ra((to) => to[Va] === La ? to.slice(0, Va) : to);
    }
  };
}
function $2bc3a590c5373a4e$export$5159ec8b34d4ec12(Bi) {
  let e = $fc909762b330b746$export$61c6a8c84e605fb6(Bi), [Zi, Qi] = useState(null), ea = $a0d645289fe9b86b$export$e7f05e985daf4b5f({
    ...Bi,
    onSelectionChange: (fa) => {
      Bi.onSelectionChange != null && Bi.onSelectionChange(fa), e.close(), ra.commitValidation();
    }
  }), ra = $e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...Bi,
    value: ea.selectedKey
  }), [na, ia] = useState(!1);
  return {
    ...ra,
    ...ea,
    ...e,
    focusStrategy: Zi,
    open(fa = null) {
      ea.collection.size !== 0 && (Qi(fa), e.open());
    },
    toggle(fa = null) {
      ea.collection.size !== 0 && (Qi(fa), e.toggle());
    },
    isFocused: na,
    setFocused: ia
  };
}
class $05ca4cd7c4a5a999$export$863faf230ee2118a {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let Zi = this.keyMap.get(e);
    var Qi;
    return Zi && (Qi = Zi.prevKey) !== null && Qi !== void 0 ? Qi : null;
  }
  getKeyAfter(e) {
    let Zi = this.keyMap.get(e);
    var Qi;
    return Zi && (Qi = Zi.nextKey) !== null && Qi !== void 0 ? Qi : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    var Zi;
    return (Zi = this.keyMap.get(e)) !== null && Zi !== void 0 ? Zi : null;
  }
  at(e) {
    const Zi = [
      ...this.getKeys()
    ];
    return this.getItem(Zi[e]);
  }
  constructor(e, { expandedKeys: Zi } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e, Zi = Zi || /* @__PURE__ */ new Set();
    let Qi = (ia) => {
      if (this.keyMap.set(ia.key, ia), ia.childNodes && (ia.type === "section" || Zi.has(ia.key))) for (let fa of ia.childNodes) Qi(fa);
    };
    for (let ia of e) Qi(ia);
    let ea = null, ra = 0;
    for (let [ia, fa] of this.keyMap)
      ea ? (ea.nextKey = ia, fa.prevKey = ea.key) : (this.firstKey = ia, fa.prevKey = void 0), fa.type === "item" && (fa.index = ra++), ea = fa, ea.nextKey = void 0;
    var na;
    this.lastKey = (na = ea?.key) !== null && na !== void 0 ? na : null;
  }
}
function $875d6693e12af071$export$728d6ba534403756(Bi) {
  let { onExpandedChange: e } = Bi, [Zi, Qi] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi.expandedKeys ? new Set(Bi.expandedKeys) : void 0, Bi.defaultExpandedKeys ? new Set(Bi.defaultExpandedKeys) : /* @__PURE__ */ new Set(), e), ea = $7af3f5b51489e0b5$export$253fe78d46329472(Bi), ra = useMemo(() => Bi.disabledKeys ? new Set(Bi.disabledKeys) : /* @__PURE__ */ new Set(), [
    Bi.disabledKeys
  ]), na = $7613b1592d41b092$export$6cd28814d92fa9c9(Bi, useCallback((fa) => new $05ca4cd7c4a5a999$export$863faf230ee2118a(fa, {
    expandedKeys: Zi
  }), [
    Zi
  ]), null);
  return useEffect(() => {
    ea.focusedKey != null && !na.getItem(ea.focusedKey) && ea.setFocusedKey(null);
  }, [
    na,
    ea.focusedKey
  ]), {
    collection: na,
    expandedKeys: Zi,
    disabledKeys: ra,
    toggleKey: (fa) => {
      Qi($875d6693e12af071$var$toggleKey(Zi, fa));
    },
    setExpandedKeys: Qi,
    selectionManager: new $d496c0a20b6e58ec$export$6c8a5aaad13c9852(na, ea)
  };
}
function $875d6693e12af071$var$toggleKey(Bi, e) {
  let Zi = new Set(Bi);
  return Zi.has(e) ? Zi.delete(e) : Zi.add(e), Zi;
}
const $d3e0e05bdfcf66bd$export$c24727297075ec6a = /* @__PURE__ */ createContext(null), $3985021b0ad6602f$export$37fb8590cf2c088c = /* @__PURE__ */ createContext({});
let $3985021b0ad6602f$var$filterHoverProps = (Bi) => {
  let { onHoverStart: e, onHoverChange: Zi, onHoverEnd: Qi, ...ea } = Bi;
  return ea;
};
const $3985021b0ad6602f$export$f5b8910cec6cf069 = /* @__PURE__ */ $f39a9eba43920ace$export$86427a43e3e48ebb(function(e, Zi) {
  [e, Zi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Zi, $3985021b0ad6602f$export$37fb8590cf2c088c);
  let { hoverProps: Qi, isHovered: ea } = $6179b936705e76d3$export$ae780daf29e6d456(e), { isFocused: ra, isFocusVisible: na, focusProps: ia } = $f7dceffc5ad7768b$export$4e328f61c538687f({
    isTextInput: !0,
    autoFocus: e.autoFocus
  }), fa = !!e["aria-invalid"] && e["aria-invalid"] !== "false", La = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    values: {
      isHovered: ea,
      isFocused: ra,
      isFocusVisible: na,
      isDisabled: e.disabled || !1,
      isInvalid: fa
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ a__default.createElement("input", {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928($3985021b0ad6602f$var$filterHoverProps(e), ia, Qi),
    ...La,
    ref: Zi,
    "data-focused": ra || void 0,
    "data-disabled": e.disabled || void 0,
    "data-hovered": ea || void 0,
    "data-focus-visible": na || void 0,
    "data-invalid": fa || void 0
  });
}), $d2f53cda644affe3$export$65d2a03b8800d6e3 = /* @__PURE__ */ createContext(null), $7135fc7d473fd974$export$d40e14dec8b060a8 = /* @__PURE__ */ createContext(null), $7135fc7d473fd974$export$a164736487e3f0ae = {
  CollectionRoot({ collection: Bi, renderDropIndicator: e }) {
    return $7135fc7d473fd974$var$useCollectionRender(Bi, null, e);
  },
  CollectionBranch({ collection: Bi, parent: e, renderDropIndicator: Zi }) {
    return $7135fc7d473fd974$var$useCollectionRender(Bi, e, Zi);
  }
};
function $7135fc7d473fd974$var$useCollectionRender(Bi, e, Zi) {
  return $e948873055cbafe4$export$727c8fc270210f13({
    items: e ? Bi.getChildren(e.key) : Bi,
    dependencies: [
      Zi
    ],
    children(Qi) {
      var ea;
      let ra = Qi.render(Qi);
      if (!Zi || Qi.type !== "item") return ra;
      let na = Qi.key, ia = Bi.getKeyAfter(na);
      return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, Zi({
        type: "item",
        key: na,
        dropPosition: "before"
      }), ra, (ia == null || ((ea = Bi.getItem(ia)) === null || ea === void 0 ? void 0 : ea.type) !== "item") && Zi({
        type: "item",
        key: na,
        dropPosition: "after"
      }));
    }
  });
}
const $7135fc7d473fd974$export$4feb769f8ddf26c5 = /* @__PURE__ */ createContext($7135fc7d473fd974$export$a164736487e3f0ae);
function $7135fc7d473fd974$export$90e00781bc59d8f9(Bi) {
  return useMemo(() => Bi != null ? /* @__PURE__ */ new Set([
    Bi
  ]) : null, [
    Bi
  ]);
}
const $612b8eb6cb90e02d$export$d188a835a7bc5783 = /* @__PURE__ */ createContext({}), $612b8eb6cb90e02d$export$f55761759794cf55 = /* @__PURE__ */ createContext(null), $612b8eb6cb90e02d$export$62ed72bc21f6b8a6 = /* @__PURE__ */ forwardRef(function(e, Zi) {
  let { render: Qi } = useContext($612b8eb6cb90e02d$export$f55761759794cf55);
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, Qi(e, Zi));
});
function $612b8eb6cb90e02d$export$971707d8a129a1f7(Bi, e) {
  var Zi;
  let Qi = Bi?.renderDropIndicator, ea = Bi == null || (Zi = Bi.isVirtualDragging) === null || Zi === void 0 ? void 0 : Zi.call(Bi), ra = useCallback((na) => {
    if (ea || e?.isDropTarget(na)) return Qi ? Qi(na) : /* @__PURE__ */ a__default.createElement($612b8eb6cb90e02d$export$62ed72bc21f6b8a6, {
      target: na
    });
  }, [
    e?.target,
    ea,
    Qi
  ]);
  return Bi?.useDropIndicator ? ra : void 0;
}
function $612b8eb6cb90e02d$export$d1e8e3fbb7461f6(Bi, e, Zi) {
  var Qi, ea;
  let ra = Bi.focusedKey, na = null;
  if (!(e == null || (Qi = e.isVirtualDragging) === null || Qi === void 0) && Qi.call(e) && (Zi == null || (ea = Zi.target) === null || ea === void 0 ? void 0 : ea.type) === "item") {
    na = Zi.target.key;
    var ia;
    Zi.target.dropPosition === "after" && (na = (ia = Zi.collection.getKeyAfter(na)) !== null && ia !== void 0 ? ia : na);
  }
  return useMemo(() => new Set([
    ra,
    na
  ].filter((fa) => fa != null)), [
    ra,
    na
  ]);
}
const $72a5793c14baf454$export$e0e4026c12a8bdbb = /* @__PURE__ */ createContext({}), $431f98aba6844401$export$6615d83f6de245ce = /* @__PURE__ */ createContext({}), $eed445e0843c11d0$export$7ff8f37d2d81a48d = /* @__PURE__ */ createContext(null), $eed445e0843c11d0$export$7c5906fe4f1f2af2 = /* @__PURE__ */ createContext(null), $eed445e0843c11d0$export$41f133550aa26f48 = /* @__PURE__ */ forwardRef(function(e, Zi) {
  [e, Zi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Zi, $eed445e0843c11d0$export$7ff8f37d2d81a48d);
  let Qi = useContext($eed445e0843c11d0$export$7c5906fe4f1f2af2);
  return Qi ? /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$ListBoxInner, {
    state: Qi,
    props: e,
    listBoxRef: Zi
  }) : /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$bf788dd355e3a401, {
    content: /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$fb8073518f34e6ec, e)
  }, (ea) => /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$StandaloneListBox, {
    props: e,
    listBoxRef: Zi,
    collection: ea
  }));
});
function $eed445e0843c11d0$var$StandaloneListBox({ props: Bi, listBoxRef: e, collection: Zi }) {
  Bi = {
    ...Bi,
    collection: Zi,
    children: null,
    items: null
  };
  let { layoutDelegate: Qi } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), { filterFn: ea, collectionProps: ra, collectionRef: na } = useContext($d2f53cda644affe3$export$65d2a03b8800d6e3) || {};
  e = $df56164dff5785e2$export$4338b53315abf666(useMemo(() => $5dc95899b306f630$export$c9058316764c140e(e, na !== void 0 ? na : null), [
    na,
    e
  ]));
  let ia = useMemo(() => ea ? Zi.filter(ea) : Zi, [
    Zi,
    ea
  ]), fa = $e72dd72e1c76a225$export$2f645645f7bca764({
    ...Bi,
    collection: ia,
    layoutDelegate: Qi
  });
  return /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$ListBoxInner, {
    state: fa,
    props: {
      ...Bi,
      ...ra
    },
    listBoxRef: e
  });
}
function $eed445e0843c11d0$var$ListBoxInner({ state: Bi, props: e, listBoxRef: Zi }) {
  let { dragAndDropHooks: Qi, layout: ea = "stack", orientation: ra = "vertical" } = e, { collection: na, selectionManager: ia } = Bi, fa = !!Qi?.useDraggableCollectionState, La = !!Qi?.useDroppableCollectionState, { direction: Va } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), { disabledBehavior: to, disabledKeys: ro } = ia, no = $325a3faab7a68acd$export$a16aca283550c30d({
    usage: "search",
    sensitivity: "base"
  }), { isVirtualized: eo, layoutDelegate: ao, dropTargetDelegate: io, CollectionRoot: xs } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), Ts = useMemo(() => e.keyboardDelegate || new $2a25aae57d74318e$export$a05409b8bb224a5a({
    collection: na,
    collator: no,
    ref: Zi,
    disabledKeys: ro,
    disabledBehavior: to,
    layout: ea,
    orientation: ra,
    direction: Va,
    layoutDelegate: ao
  }), [
    na,
    no,
    Zi,
    to,
    ro,
    ra,
    Va,
    e.keyboardDelegate,
    ea,
    ao
  ]), { listBoxProps: qs } = $c132121280ec012d$export$50eacbbf140a3141({
    ...e,
    shouldSelectOnPressUp: fa || e.shouldSelectOnPressUp,
    keyboardDelegate: Ts,
    isVirtualized: eo
  }, Bi, Zi), Fs = useRef(fa), Do = useRef(La);
  useEffect(() => {
    Fs.current !== fa && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), Do.current !== La && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
  }, [
    fa,
    La
  ]);
  let ys, Io, so, os = !1, Xs = null, gl = useRef(null);
  if (fa && Qi) {
    ys = Qi.useDraggableCollectionState({
      collection: na,
      selectionManager: ia,
      preview: Qi.renderDragPreview ? gl : void 0
    }), Qi.useDraggableCollection({}, ys, Zi);
    let Ml = Qi.DragPreview;
    Xs = Qi.renderDragPreview ? /* @__PURE__ */ a__default.createElement(Ml, {
      ref: gl
    }, Qi.renderDragPreview) : null;
  }
  if (La && Qi) {
    Io = Qi.useDroppableCollectionState({
      collection: na,
      selectionManager: ia
    });
    let Ml = Qi.dropTargetDelegate || io || new Qi.ListDropTargetDelegate(na, Zi, {
      orientation: ra,
      layout: ea,
      direction: Va
    });
    so = Qi.useDroppableCollection({
      keyboardDelegate: Ts,
      dropTargetDelegate: Ml
    }, Io, Zi), os = Io.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: Sl, isFocused: El, isFocusVisible: wl } = $f7dceffc5ad7768b$export$4e328f61c538687f(), jl = {
    isDropTarget: os,
    isEmpty: Bi.collection.size === 0,
    isFocused: El,
    isFocusVisible: wl,
    layout: e.layout || "stack",
    state: Bi
  }, kl = $64fa3d84918910a7$export$4d86445c2cf5e3({
    className: e.className,
    style: e.style,
    defaultClassName: "react-aria-ListBox",
    values: jl
  }), Fl = null;
  return Bi.collection.size === 0 && e.renderEmptyState && (Fl = /* @__PURE__ */ a__default.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, e.renderEmptyState(jl))), /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, null, /* @__PURE__ */ a__default.createElement("div", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(e),
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(qs, Sl, so?.collectionProps),
    ...kl,
    ref: Zi,
    slot: e.slot || void 0,
    onScroll: e.onScroll,
    "data-drop-target": os || void 0,
    "data-empty": Bi.collection.size === 0 || void 0,
    "data-focused": El || void 0,
    "data-focus-visible": wl || void 0,
    "data-layout": e.layout || "stack",
    "data-orientation": e.orientation || "vertical"
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $eed445e0843c11d0$export$7ff8f37d2d81a48d,
        e
      ],
      [
        $eed445e0843c11d0$export$7c5906fe4f1f2af2,
        Bi
      ],
      [
        $612b8eb6cb90e02d$export$d188a835a7bc5783,
        {
          dragAndDropHooks: Qi,
          dragState: ys,
          dropState: Io
        }
      ],
      [
        $431f98aba6844401$export$6615d83f6de245ce,
        {
          elementType: "div"
        }
      ],
      [
        $612b8eb6cb90e02d$export$f55761759794cf55,
        {
          render: $eed445e0843c11d0$var$ListBoxDropIndicatorWrapper
        }
      ],
      [
        $7135fc7d473fd974$export$d40e14dec8b060a8,
        {
          name: "ListBoxSection",
          render: $eed445e0843c11d0$var$ListBoxSectionInner
        }
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement(xs, {
    collection: na,
    scrollRef: Zi,
    persistedKeys: $612b8eb6cb90e02d$export$d1e8e3fbb7461f6(ia, Qi, Io),
    renderDropIndicator: $612b8eb6cb90e02d$export$971707d8a129a1f7(Qi, Io)
  })), Fl, Xs));
}
function $eed445e0843c11d0$var$ListBoxSectionInner(Bi, e, Zi, Qi = "react-aria-ListBoxSection") {
  let ea = useContext($eed445e0843c11d0$export$7c5906fe4f1f2af2), { dragAndDropHooks: ra, dropState: na } = useContext($612b8eb6cb90e02d$export$d188a835a7bc5783), { CollectionBranch: ia } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), [fa, La] = $64fa3d84918910a7$export$9d4c57ee4c6ffdd8();
  var Va;
  let { headingProps: to, groupProps: ro } = $af383d3bef1cfdc9$export$c3f9f39876e4bc7({
    heading: La,
    "aria-label": (Va = Bi["aria-label"]) !== null && Va !== void 0 ? Va : void 0
  }), no = $64fa3d84918910a7$export$4d86445c2cf5e3({
    defaultClassName: Qi,
    className: Bi.className,
    style: Bi.style,
    values: {}
  });
  return /* @__PURE__ */ a__default.createElement("section", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi),
    ...ro,
    ...no,
    ref: e
  }, /* @__PURE__ */ a__default.createElement($72a5793c14baf454$export$e0e4026c12a8bdbb.Provider, {
    value: {
      ...to,
      ref: fa
    }
  }, /* @__PURE__ */ a__default.createElement(ia, {
    collection: ea.collection,
    parent: Zi,
    renderDropIndicator: $612b8eb6cb90e02d$export$971707d8a129a1f7(ra, na)
  })));
}
const $eed445e0843c11d0$export$a11e76429ed99b4 = /* @__PURE__ */ $e1995378a142960e$export$18af5c7a9e9b3664("item", function(e, Zi, Qi) {
  let ea = $df56164dff5785e2$export$4338b53315abf666(Zi), ra = useContext($eed445e0843c11d0$export$7c5906fe4f1f2af2), { dragAndDropHooks: na, dragState: ia, dropState: fa } = useContext($612b8eb6cb90e02d$export$d188a835a7bc5783), { optionProps: La, labelProps: Va, descriptionProps: to, ...ro } = $293f70390ea03370$export$497855f14858aa34({
    key: Qi.key,
    "aria-label": e?.["aria-label"]
  }, ra, ea), { hoverProps: no, isHovered: eo } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: !ro.allowsSelection && !ro.hasAction,
    onHoverStart: Qi.props.onHoverStart,
    onHoverChange: Qi.props.onHoverChange,
    onHoverEnd: Qi.props.onHoverEnd
  }), ao = null;
  ia && na && (ao = na.useDraggableItem({
    key: Qi.key
  }, ia));
  let io = null;
  fa && na && (io = na.useDroppableItem({
    target: {
      type: "item",
      key: Qi.key,
      dropPosition: "on"
    }
  }, fa, ea));
  let xs = ia && ia.isDragging(Qi.key), Ts = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    id: void 0,
    children: e.children,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...ro,
      isHovered: eo,
      selectionMode: ra.selectionManager.selectionMode,
      selectionBehavior: ra.selectionManager.selectionBehavior,
      allowsDragging: !!ia,
      isDragging: xs,
      isDropTarget: io?.isDropTarget
    }
  });
  useEffect(() => {
    Qi.textValue || console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    Qi.textValue
  ]);
  let qs = e.href ? "a" : "div";
  return /* @__PURE__ */ a__default.createElement(qs, {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(La, no, ao?.dragProps, io?.dropProps),
    ...Ts,
    ref: ea,
    "data-allows-dragging": !!ia || void 0,
    "data-selected": ro.isSelected || void 0,
    "data-disabled": ro.isDisabled || void 0,
    "data-hovered": eo || void 0,
    "data-focused": ro.isFocused || void 0,
    "data-focus-visible": ro.isFocusVisible || void 0,
    "data-pressed": ro.isPressed || void 0,
    "data-dragging": xs || void 0,
    "data-drop-target": io?.isDropTarget || void 0,
    "data-selection-mode": ra.selectionManager.selectionMode === "none" ? void 0 : ra.selectionManager.selectionMode
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $514c0188e459b4c0$export$9afb8bc826b033ea,
        {
          slots: {
            label: Va,
            description: to
          }
        }
      ]
    ]
  }, Ts.children));
});
function $eed445e0843c11d0$var$ListBoxDropIndicatorWrapper(Bi, e) {
  e = $df56164dff5785e2$export$4338b53315abf666(e);
  let { dragAndDropHooks: Zi, dropState: Qi } = useContext($612b8eb6cb90e02d$export$d188a835a7bc5783), { dropIndicatorProps: ea, isHidden: ra, isDropTarget: na } = Zi.useDropIndicator(Bi, Qi, e);
  return ra ? null : /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$ListBoxDropIndicatorForwardRef, {
    ...Bi,
    dropIndicatorProps: ea,
    isDropTarget: na,
    ref: e
  });
}
function $eed445e0843c11d0$var$ListBoxDropIndicator(Bi, e) {
  let { dropIndicatorProps: Zi, isDropTarget: Qi, ...ea } = Bi, ra = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...ea,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: Qi
    }
  });
  return /* @__PURE__ */ a__default.createElement("div", {
    ...Zi,
    ...ra,
    // eslint-disable-next-line
    role: "option",
    ref: e,
    "data-drop-target": Qi || void 0
  });
}
const $eed445e0843c11d0$var$ListBoxDropIndicatorForwardRef = /* @__PURE__ */ forwardRef($eed445e0843c11d0$var$ListBoxDropIndicator), $44f671af83e7d9e0$export$2de4954e8ae13b9f = /* @__PURE__ */ createContext({
  placement: "bottom"
}), $07b14b47974efb58$export$9b9a0cd73afb7ca4 = /* @__PURE__ */ createContext(null), $07b14b47974efb58$export$5b6b19405a83ff9d = /* @__PURE__ */ forwardRef(function(e, Zi) {
  [e, Zi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Zi, $07b14b47974efb58$export$9b9a0cd73afb7ca4);
  let Qi = useContext($de32f1b87079253c$export$d2f961adcb0afbe), ea = $fc909762b330b746$export$61c6a8c84e605fb6(e), ra = e.isOpen != null || e.defaultOpen != null || !Qi ? ea : Qi, na = $d3f049242431219c$export$45fda7c47f93fd48(Zi, ra.isOpen) || e.isExiting || !1;
  if ($f39a9eba43920ace$export$b5d7cc18bb8d2b59()) {
    let fa = e.children;
    return typeof fa == "function" && (fa = fa({
      trigger: e.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, fa);
  }
  return ra && !ra.isOpen && !na ? null : /* @__PURE__ */ a__default.createElement($07b14b47974efb58$var$PopoverInner, {
    ...e,
    triggerRef: e.triggerRef,
    state: ra,
    popoverRef: Zi,
    isExiting: na
  });
});
function $07b14b47974efb58$var$PopoverInner({ state: Bi, isExiting: e, UNSTABLE_portalContainer: Zi, ...Qi }) {
  let ea = useRef(null), [ra, na] = useState(0);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    ea.current && Bi.isOpen && na(ea.current.getBoundingClientRect().width);
  }, [
    Bi.isOpen,
    ea
  ]);
  var ia;
  let { popoverProps: fa, underlayProps: La, arrowProps: Va, placement: to } = $f2f8a6077418541e$export$542a6fd13ac93354({
    ...Qi,
    offset: (ia = Qi.offset) !== null && ia !== void 0 ? ia : 8,
    arrowSize: ra
  }, Bi), ro = Qi.popoverRef, no = $d3f049242431219c$export$6d3443f2c48bfc20(ro, !!to) || Qi.isEntering || !1, eo = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...Qi,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: Qi.trigger || null,
      placement: to,
      isEntering: no,
      isExiting: e
    }
  }), ao = {
    ...fa.style,
    ...eo.style
  };
  return /* @__PURE__ */ a__default.createElement($337b884510726a0d$export$c6fdb837b070b4ff, {
    ...Qi,
    isExiting: e,
    portalContainer: Zi
  }, !Qi.isNonModal && Bi.isOpen && /* @__PURE__ */ a__default.createElement("div", {
    "data-testid": "underlay",
    ...La,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ a__default.createElement("div", {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928($65484d02dcb7eb3e$export$457c3d6518dd4c6f(Qi), fa),
    ...eo,
    ref: ro,
    slot: Qi.slot || void 0,
    style: ao,
    "data-trigger": Qi.trigger,
    "data-placement": to,
    "data-entering": no || void 0,
    "data-exiting": e || void 0
  }, !Qi.isNonModal && /* @__PURE__ */ a__default.createElement($86ea4cb521eb2e37$export$2317d149ed6f78c4, {
    onDismiss: Bi.close
  }), /* @__PURE__ */ a__default.createElement($44f671af83e7d9e0$export$2de4954e8ae13b9f.Provider, {
    value: {
      ...Va,
      placement: to,
      ref: ea
    }
  }, eo.children), /* @__PURE__ */ a__default.createElement($86ea4cb521eb2e37$export$2317d149ed6f78c4, {
    onDismiss: Bi.close
  })));
}
const $63df2425e2108aa8$export$744d98a3b8a94e1c = /* @__PURE__ */ createContext({}), $3674c52c6b3c5bce$export$c7e742effb1c51e2 = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$24aad8519b95b41b = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$795aec4671cbae19 = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$var$SelectionManagerContext = /* @__PURE__ */ createContext(null);
function $3674c52c6b3c5bce$export$27d2ad3c5815583e(Bi) {
  let e = $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(Bi), Zi = useRef(null), { menuTriggerProps: Qi, menuProps: ea } = $168583247155ddda$export$dc9c12ed27dd1b49({
    ...Bi,
    type: "menu"
  }, e, Zi), [ra, na] = useState(null), ia = useCallback(() => {
    Zi.current && na(Zi.current.offsetWidth + "px");
  }, [
    Zi
  ]);
  $9daab02d461809db$export$683480f191c0e3ea({
    ref: Zi,
    onResize: ia
  });
  let fa = useRef(null);
  return /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $3674c52c6b3c5bce$export$c7e742effb1c51e2,
        {
          ...ea,
          ref: fa
        }
      ],
      [
        $de32f1b87079253c$export$d2f961adcb0afbe,
        e
      ],
      [
        $3674c52c6b3c5bce$export$795aec4671cbae19,
        e
      ],
      [
        $07b14b47974efb58$export$9b9a0cd73afb7ca4,
        {
          trigger: "MenuTrigger",
          triggerRef: Zi,
          scrollRef: fa,
          placement: "bottom start",
          style: {
            "--trigger-width": ra
          }
        }
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement($f1ab8c75478c6f73$export$3351871ee4b288b8, {
    ...Qi,
    ref: Zi,
    isPressed: e.isOpen
  }, Bi.children));
}
const $3674c52c6b3c5bce$var$SubmenuTriggerContext = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$d9b273488cd8ce6f = /* @__PURE__ */ forwardRef(function(e, Zi) {
  return [e, Zi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Zi, $3674c52c6b3c5bce$export$c7e742effb1c51e2), /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$bf788dd355e3a401, {
    content: /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$fb8073518f34e6ec, e)
  }, (Qi) => Qi.size > 0 && /* @__PURE__ */ a__default.createElement($3674c52c6b3c5bce$var$MenuInner, {
    props: e,
    collection: Qi,
    menuRef: Zi
  }));
});
function $3674c52c6b3c5bce$var$MenuInner({ props: Bi, collection: e, menuRef: Zi }) {
  let { filterFn: Qi, collectionProps: ea, collectionRef: ra } = useContext($d2f53cda644affe3$export$65d2a03b8800d6e3) || {};
  Zi = $df56164dff5785e2$export$4338b53315abf666(useMemo(() => $5dc95899b306f630$export$c9058316764c140e(Zi, ra !== void 0 ? ra : null), [
    ra,
    Zi
  ]));
  let na = useMemo(() => Qi ? e.filter(Qi) : e, [
    e,
    Qi
  ]), ia = $875d6693e12af071$export$728d6ba534403756({
    ...Bi,
    collection: na,
    children: void 0
  }), fa = useContext($3674c52c6b3c5bce$export$795aec4671cbae19), { isVirtualized: La, CollectionRoot: Va } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), { menuProps: to } = $d5336fe17ce95402$export$38eaa17faae8f579({
    ...Bi,
    ...ea,
    isVirtualized: La,
    onClose: Bi.onClose || fa?.close
  }, ia, Zi), ro = $64fa3d84918910a7$export$4d86445c2cf5e3({
    defaultClassName: "react-aria-Menu",
    className: Bi.className,
    style: Bi.style,
    values: {}
  });
  return /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, null, /* @__PURE__ */ a__default.createElement("div", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi),
    ...to,
    ...ro,
    ref: Zi,
    slot: Bi.slot || void 0,
    onScroll: Bi.onScroll
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $3674c52c6b3c5bce$export$24aad8519b95b41b,
        ia
      ],
      [
        $431f98aba6844401$export$6615d83f6de245ce,
        {
          elementType: "div"
        }
      ],
      [
        $7135fc7d473fd974$export$d40e14dec8b060a8,
        {
          name: "MenuSection",
          render: $3674c52c6b3c5bce$var$MenuSectionInner
        }
      ],
      [
        $3674c52c6b3c5bce$var$SubmenuTriggerContext,
        {
          parentMenuRef: Zi
        }
      ],
      [
        $3674c52c6b3c5bce$var$MenuItemContext,
        null
      ],
      [
        $3674c52c6b3c5bce$var$SelectionManagerContext,
        ia.selectionManager
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement(Va, {
    collection: ia.collection,
    persistedKeys: $7135fc7d473fd974$export$90e00781bc59d8f9(ia.selectionManager.focusedKey),
    scrollRef: Zi
  }))));
}
class $3674c52c6b3c5bce$var$GroupSelectionManager extends $d496c0a20b6e58ec$export$6c8a5aaad13c9852 {
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(e, Zi) {
    return this.parent.setFocusedKey(e, Zi);
  }
  setFocused(e) {
    this.parent.setFocused(e);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
  constructor(e, Zi) {
    super(e.collection, Zi), this.parent = e;
  }
}
function $3674c52c6b3c5bce$var$MenuSectionInner(Bi, e, Zi, Qi = "react-aria-MenuSection") {
  var ea, ra;
  let na = useContext($3674c52c6b3c5bce$export$24aad8519b95b41b), { CollectionBranch: ia } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), [fa, La] = $64fa3d84918910a7$export$9d4c57ee4c6ffdd8();
  var Va;
  let { headingProps: to, groupProps: ro } = $3e5eb2498db5b506$export$73f7a44322579622({
    heading: La,
    "aria-label": (Va = Zi.props["aria-label"]) !== null && Va !== void 0 ? Va : void 0
  }), no = $64fa3d84918910a7$export$4d86445c2cf5e3({
    defaultClassName: Qi,
    className: (ea = Zi.props) === null || ea === void 0 ? void 0 : ea.className,
    style: (ra = Zi.props) === null || ra === void 0 ? void 0 : ra.style,
    values: {}
  }), eo = useContext($3674c52c6b3c5bce$var$SelectionManagerContext), ao = $7af3f5b51489e0b5$export$253fe78d46329472(Bi), io = Bi.selectionMode != null ? new $3674c52c6b3c5bce$var$GroupSelectionManager(eo, ao) : eo;
  return /* @__PURE__ */ a__default.createElement("section", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi),
    ...ro,
    ...no,
    ref: e
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $72a5793c14baf454$export$e0e4026c12a8bdbb,
        {
          ...to,
          ref: fa
        }
      ],
      [
        $3674c52c6b3c5bce$var$SelectionManagerContext,
        io
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement(ia, {
    collection: na.collection,
    parent: Zi
  })));
}
const $3674c52c6b3c5bce$var$MenuItemContext = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$2ce376c2cc3355c8 = /* @__PURE__ */ $e1995378a142960e$export$18af5c7a9e9b3664("item", function(e, Zi, Qi) {
  var ea;
  [e, Zi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Zi, $3674c52c6b3c5bce$var$MenuItemContext);
  let ra = (ea = $64fa3d84918910a7$export$fabf2dc03a41866e($3674c52c6b3c5bce$var$MenuItemContext)) === null || ea === void 0 ? void 0 : ea.id, na = useContext($3674c52c6b3c5bce$export$24aad8519b95b41b), ia = $df56164dff5785e2$export$4338b53315abf666(Zi), fa = useContext($3674c52c6b3c5bce$var$SelectionManagerContext), { menuItemProps: La, labelProps: Va, descriptionProps: to, keyboardShortcutProps: ro, ...no } = $a2e5df62f93c7633$export$9d32628fc2aea7da({
    ...e,
    id: ra,
    key: Qi.key,
    selectionManager: fa
  }, na, ia), { isFocusVisible: eo, focusProps: ao } = $f7dceffc5ad7768b$export$4e328f61c538687f(), { hoverProps: io, isHovered: xs } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: no.isDisabled
  }), Ts = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    id: void 0,
    children: Qi.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...no,
      isHovered: xs,
      isFocusVisible: eo,
      selectionMode: fa.selectionMode,
      selectionBehavior: fa.selectionBehavior,
      hasSubmenu: !!e["aria-haspopup"],
      isOpen: e["aria-expanded"] === "true"
    }
  }), qs = e.href ? "a" : "div";
  return /* @__PURE__ */ a__default.createElement(qs, {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(La, ao, io),
    ...Ts,
    ref: ia,
    "data-disabled": no.isDisabled || void 0,
    "data-hovered": xs || void 0,
    "data-focused": no.isFocused || void 0,
    "data-focus-visible": eo || void 0,
    "data-pressed": no.isPressed || void 0,
    "data-selected": no.isSelected || void 0,
    "data-selection-mode": fa.selectionMode === "none" ? void 0 : fa.selectionMode,
    "data-has-submenu": !!e["aria-haspopup"] || void 0,
    "data-open": e["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $514c0188e459b4c0$export$9afb8bc826b033ea,
        {
          slots: {
            label: Va,
            description: to
          }
        }
      ],
      [
        $63df2425e2108aa8$export$744d98a3b8a94e1c,
        ro
      ]
    ]
  }, Ts.children));
}), $de32f1b87079253c$export$d2f961adcb0afbe = /* @__PURE__ */ createContext(null), $1e2864c73f66a4da$export$6fb4a10d2c950550 = /* @__PURE__ */ forwardRef(function(e, Zi) {
  let { onSelect: Qi, acceptedFileTypes: ea, allowsMultiple: ra, defaultCamera: na, children: ia, acceptDirectory: fa, ...La } = e, Va = $df56164dff5785e2$export$4338b53315abf666(Zi), to = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(La);
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement($f1ab8c75478c6f73$export$3351871ee4b288b8, {
    onPress: () => {
      var ro, no;
      !((ro = Va.current) === null || ro === void 0) && ro.value && (Va.current.value = ""), (no = Va.current) === null || no === void 0 || no.click();
    }
  }, ia), /* @__PURE__ */ a__default.createElement($3985021b0ad6602f$export$f5b8910cec6cf069, {
    ...to,
    type: "file",
    ref: Va,
    style: {
      display: "none"
    },
    accept: ea?.toString(),
    onChange: (ro) => Qi?.(ro.target.files),
    capture: na,
    multiple: ra,
    // @ts-expect-error
    webkitdirectory: fa ? "" : void 0
  }));
}), $82d7e5349645de74$export$7540cee5be7dc19b = /* @__PURE__ */ createContext(null), $82d7e5349645de74$export$ef445b55be0601bd = /* @__PURE__ */ createContext(null), $82d7e5349645de74$export$ef9b1a59e592288f = /* @__PURE__ */ forwardRef(function(e, Zi) {
  [e, Zi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, Zi, $82d7e5349645de74$export$7540cee5be7dc19b);
  let { children: Qi, isDisabled: ea = !1, isInvalid: ra = !1, isRequired: na = !1 } = e, ia = useMemo(() => typeof Qi == "function" ? Qi({
    isOpen: !1,
    isDisabled: ea,
    isInvalid: ra,
    isRequired: na,
    isFocused: !1,
    isFocusVisible: !1,
    defaultChildren: null
  }) : Qi, [
    Qi,
    ea,
    ra,
    na
  ]);
  return /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$bf788dd355e3a401, {
    content: ia
  }, (fa) => /* @__PURE__ */ a__default.createElement($82d7e5349645de74$var$SelectInner, {
    props: e,
    collection: fa,
    selectRef: Zi
  }));
});
function $82d7e5349645de74$var$SelectInner({ props: Bi, selectRef: e, collection: Zi }) {
  let { validationBehavior: Qi } = $64fa3d84918910a7$export$fabf2dc03a41866e($d3e0e05bdfcf66bd$export$c24727297075ec6a) || {};
  var ea, ra;
  let na = (ra = (ea = Bi.validationBehavior) !== null && ea !== void 0 ? ea : Qi) !== null && ra !== void 0 ? ra : "native", ia = $2bc3a590c5373a4e$export$5159ec8b34d4ec12({
    ...Bi,
    collection: Zi,
    children: void 0,
    validationBehavior: na
  }), { isFocusVisible: fa, focusProps: La } = $f7dceffc5ad7768b$export$4e328f61c538687f({
    within: !0
  }), Va = useRef(null), [to, ro] = $64fa3d84918910a7$export$9d4c57ee4c6ffdd8(), { labelProps: no, triggerProps: eo, valueProps: ao, menuProps: io, descriptionProps: xs, errorMessageProps: Ts, ...qs } = $58aed456727eb0f3$export$e64b2f635402ca43({
    ...$64fa3d84918910a7$export$ef03459518577ad4(Bi),
    label: ro,
    validationBehavior: na
  }, ia, Va), [Fs, Do] = useState(null), ys = useCallback(() => {
    Va.current && Do(Va.current.offsetWidth + "px");
  }, [
    Va
  ]);
  $9daab02d461809db$export$683480f191c0e3ea({
    ref: Va,
    onResize: ys
  });
  let Io = useMemo(() => ({
    isOpen: ia.isOpen,
    isFocused: ia.isFocused,
    isFocusVisible: fa,
    isDisabled: Bi.isDisabled || !1,
    isInvalid: qs.isInvalid || !1,
    isRequired: Bi.isRequired || !1
  }), [
    ia.isOpen,
    ia.isFocused,
    fa,
    Bi.isDisabled,
    qs.isInvalid,
    Bi.isRequired
  ]), so = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...Bi,
    values: Io,
    defaultClassName: "react-aria-Select"
  }), os = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi);
  delete os.id;
  let Xs = useRef(null);
  return /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $82d7e5349645de74$export$7540cee5be7dc19b,
        Bi
      ],
      [
        $82d7e5349645de74$export$ef445b55be0601bd,
        ia
      ],
      [
        $82d7e5349645de74$export$f8f745c04421623f,
        ao
      ],
      [
        $01b77f81d0f07f68$export$75b6ee27786ba447,
        {
          ...no,
          ref: to,
          elementType: "span"
        }
      ],
      [
        $d2b4bc8c273e7be6$export$24d547caef80ccd1,
        {
          ...eo,
          ref: Va,
          isPressed: ia.isOpen
        }
      ],
      [
        $de32f1b87079253c$export$d2f961adcb0afbe,
        ia
      ],
      [
        $07b14b47974efb58$export$9b9a0cd73afb7ca4,
        {
          trigger: "Select",
          triggerRef: Va,
          scrollRef: Xs,
          placement: "bottom start",
          style: {
            "--trigger-width": Fs
          }
        }
      ],
      [
        $eed445e0843c11d0$export$7ff8f37d2d81a48d,
        {
          ...io,
          ref: Xs
        }
      ],
      [
        $eed445e0843c11d0$export$7c5906fe4f1f2af2,
        ia
      ],
      [
        $514c0188e459b4c0$export$9afb8bc826b033ea,
        {
          slots: {
            description: xs,
            errorMessage: Ts
          }
        }
      ],
      [
        $ee014567cb39d3f0$export$ff05c3ac10437e03,
        qs
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement("div", {
    ...os,
    ...so,
    ...La,
    ref: e,
    slot: Bi.slot || void 0,
    "data-focused": ia.isFocused || void 0,
    "data-focus-visible": fa || void 0,
    "data-open": ia.isOpen || void 0,
    "data-disabled": Bi.isDisabled || void 0,
    "data-invalid": qs.isInvalid || void 0,
    "data-required": Bi.isRequired || void 0
  }), /* @__PURE__ */ a__default.createElement($bdd25dc72710631f$export$cbd84cdb2e668835, {
    autoComplete: Bi.autoComplete,
    state: ia,
    triggerRef: Va,
    label: ro,
    name: Bi.name,
    isDisabled: Bi.isDisabled
  }));
}
const $82d7e5349645de74$export$f8f745c04421623f = /* @__PURE__ */ createContext(null), Dropdown = ({
  options: Bi,
  onSelect: e,
  label: Zi,
  className: Qi = ""
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  $82d7e5349645de74$export$ef9b1a59e592288f,
  {
    className: Qi,
    onSelectionChange: (ea) => {
      e(ea);
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx($d2b4bc8c273e7be6$export$353f5b6fc5456de1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { "aria-hidden": "true", children: [
        Zi && /* @__PURE__ */ jsxRuntimeExports.jsx($01b77f81d0f07f68$export$b04be29aa201d4f5, { children: Zi }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { className: "px-2", icon: faChevronDown, size: "sm" })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx($07b14b47974efb58$export$5b6b19405a83ff9d, { className: "bg-white border border-black", children: /* @__PURE__ */ jsxRuntimeExports.jsx($eed445e0843c11d0$export$41f133550aa26f48, { children: Bi.map((ea) => /* @__PURE__ */ jsxRuntimeExports.jsx($eed445e0843c11d0$export$a11e76429ed99b4, { id: ea.id, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "p-1 bg-white w-full block cursor-auto focus:outline-2 focus:outline-neutral-800 ", children: ea.label }) }, `dropdown-${ea.id}`)) }) })
    ]
  }
), Field = forwardRef(({ className: Bi, ...e }, Zi) => /* @__PURE__ */ jsxRuntimeExports.jsx("input", { ref: Zi, className: twMerge(
  "bg-neutral-200 p-2 block h-auto max-h-8 my-2 border-black border dark:bg-neutral-500 dark:text-neutral-100 placeholder-neutral-400 dark:placeholder-neutral-400",
  Bi
), ...e })), Select = forwardRef(({ className: Bi, ...e }, Zi) => /* @__PURE__ */ jsxRuntimeExports.jsx("select", { ref: Zi, ...e, className: twMerge("bg-neutral-200 rounded-md p-2 block h-auto", Bi) })), DynamicFormInput = forwardRef(({ field: Bi, onChange: e, other: Zi, ...Qi }, ea) => {
  const [ra, na] = useState(!1);
  switch (Bi.type) {
    case "textarea":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "textarea",
        {
          ref: ea,
          onChange: e,
          ...Qi
        }
      );
    case "select":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Select,
          {
            ref: ea,
            required: !Bi.optional,
            onChange: (ia) => {
              ia.target.value === "other" ? na(!0) : na(!1), e && e(ia);
            },
            ...Qi,
            children: [
              Bi.options.map((ia, fa) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: ia, children: ia }, fa)),
              Bi?.allowOther && /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "other", children: "Other" })
            ]
          }
        ),
        ra && Zi?.()
      ] });
    case "submit":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          ref: ea,
          onChange: e,
          ...Qi,
          type: "submit",
          children: Bi.text
        }
      );
    case "email":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Field,
        {
          required: !Bi.optional,
          ref: ea,
          onChange: e,
          type: "email",
          ...Qi
        }
      );
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Field,
        {
          required: !Bi.optional,
          ref: ea,
          onChange: e,
          ...Qi
        }
      );
  }
}), ellispes = keyframes$2`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`, Dot = styled.span`
  animation: ${ellispes} 3s linear infinite;
  animation-delay: ${({ index: Bi }) => Bi * 0.1}s;
`, Ellipses = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Dot, { index: 0, children: "." }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Dot, { index: 1, children: "." }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Dot, { index: 2, children: "." })
] }), Error$1 = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { ...Bi, className: "text-red-500 text-sm" });
class ErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    cd(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError(Zi) {
    return { hasError: !0 };
  }
  componentDidCatch(Zi, Qi) {
    console.error("Uncaught error:", Zi, Qi);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: "Sorry.. there was an error" }) : this.props.children;
  }
}
var Re$2 = /* @__PURE__ */ ((Bi) => (Bi.ALL = "all", Bi.NONE = "none", Bi.FILE = "file", Bi.DIR = "dir", Bi.FILE_LIST = "file_list", Bi.DIR_LIST = "dir_list", Bi))(Re$2 || {}), b$2;
(function(Bi) {
  Bi.assertEqual = (ea) => ea;
  function e(ea) {
  }
  Bi.assertIs = e;
  function Zi(ea) {
    throw new Error();
  }
  Bi.assertNever = Zi, Bi.arrayToEnum = (ea) => {
    const ra = {};
    for (const na of ea)
      ra[na] = na;
    return ra;
  }, Bi.getValidEnumValues = (ea) => {
    const ra = Bi.objectKeys(ea).filter((ia) => typeof ea[ea[ia]] != "number"), na = {};
    for (const ia of ra)
      na[ia] = ea[ia];
    return Bi.objectValues(na);
  }, Bi.objectValues = (ea) => Bi.objectKeys(ea).map(function(ra) {
    return ea[ra];
  }), Bi.objectKeys = typeof Object.keys == "function" ? (ea) => Object.keys(ea) : (ea) => {
    const ra = [];
    for (const na in ea)
      Object.prototype.hasOwnProperty.call(ea, na) && ra.push(na);
    return ra;
  }, Bi.find = (ea, ra) => {
    for (const na of ea)
      if (ra(na))
        return na;
  }, Bi.isInteger = typeof Number.isInteger == "function" ? (ea) => Number.isInteger(ea) : (ea) => typeof ea == "number" && isFinite(ea) && Math.floor(ea) === ea;
  function Qi(ea, ra = " | ") {
    return ea.map((na) => typeof na == "string" ? `'${na}'` : na).join(ra);
  }
  Bi.joinValues = Qi, Bi.jsonStringifyReplacer = (ea, ra) => typeof ra == "bigint" ? ra.toString() : ra;
})(b$2 || (b$2 = {}));
var we;
(function(Bi) {
  Bi.mergeShapes = (e, Zi) => ({
    ...e,
    ...Zi
    // second overwrites first
  });
})(we || (we = {}));
const f$7 = b$2.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), N$1 = (Bi) => {
  switch (typeof Bi) {
    case "undefined":
      return f$7.undefined;
    case "string":
      return f$7.string;
    case "number":
      return isNaN(Bi) ? f$7.nan : f$7.number;
    case "boolean":
      return f$7.boolean;
    case "function":
      return f$7.function;
    case "bigint":
      return f$7.bigint;
    case "symbol":
      return f$7.symbol;
    case "object":
      return Array.isArray(Bi) ? f$7.array : Bi === null ? f$7.null : Bi.then && typeof Bi.then == "function" && Bi.catch && typeof Bi.catch == "function" ? f$7.promise : typeof Map < "u" && Bi instanceof Map ? f$7.map : typeof Set < "u" && Bi instanceof Set ? f$7.set : typeof Date < "u" && Bi instanceof Date ? f$7.date : f$7.object;
    default:
      return f$7.unknown;
  }
}, d$3 = b$2.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), We$2 = (Bi) => JSON.stringify(Bi, null, 2).replace(/"([^"]+)":/g, "$1:");
let S$1 = class Tf extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (Qi) => {
      this.issues = [...this.issues, Qi];
    }, this.addIssues = (Qi = []) => {
      this.issues = [...this.issues, ...Qi];
    };
    const Zi = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, Zi) : this.__proto__ = Zi, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const Zi = e || function(ra) {
      return ra.message;
    }, Qi = { _errors: [] }, ea = (ra) => {
      for (const na of ra.issues)
        if (na.code === "invalid_union")
          na.unionErrors.map(ea);
        else if (na.code === "invalid_return_type")
          ea(na.returnTypeError);
        else if (na.code === "invalid_arguments")
          ea(na.argumentsError);
        else if (na.path.length === 0)
          Qi._errors.push(Zi(na));
        else {
          let ia = Qi, fa = 0;
          for (; fa < na.path.length; ) {
            const La = na.path[fa];
            fa === na.path.length - 1 ? (ia[La] = ia[La] || { _errors: [] }, ia[La]._errors.push(Zi(na))) : ia[La] = ia[La] || { _errors: [] }, ia = ia[La], fa++;
          }
        }
    };
    return ea(this), Qi;
  }
  static assert(e) {
    if (!(e instanceof Tf))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, b$2.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (Zi) => Zi.message) {
    const Zi = {}, Qi = [];
    for (const ea of this.issues)
      ea.path.length > 0 ? (Zi[ea.path[0]] = Zi[ea.path[0]] || [], Zi[ea.path[0]].push(e(ea))) : Qi.push(e(ea));
    return { formErrors: Qi, fieldErrors: Zi };
  }
  get formErrors() {
    return this.flatten();
  }
};
S$1.create = (Bi) => new S$1(Bi);
const J$1 = (Bi, e) => {
  let Zi;
  switch (Bi.code) {
    case d$3.invalid_type:
      Bi.received === f$7.undefined ? Zi = "Required" : Zi = `Expected ${Bi.expected}, received ${Bi.received}`;
      break;
    case d$3.invalid_literal:
      Zi = `Invalid literal value, expected ${JSON.stringify(Bi.expected, b$2.jsonStringifyReplacer)}`;
      break;
    case d$3.unrecognized_keys:
      Zi = `Unrecognized key(s) in object: ${b$2.joinValues(Bi.keys, ", ")}`;
      break;
    case d$3.invalid_union:
      Zi = "Invalid input";
      break;
    case d$3.invalid_union_discriminator:
      Zi = `Invalid discriminator value. Expected ${b$2.joinValues(Bi.options)}`;
      break;
    case d$3.invalid_enum_value:
      Zi = `Invalid enum value. Expected ${b$2.joinValues(Bi.options)}, received '${Bi.received}'`;
      break;
    case d$3.invalid_arguments:
      Zi = "Invalid function arguments";
      break;
    case d$3.invalid_return_type:
      Zi = "Invalid function return type";
      break;
    case d$3.invalid_date:
      Zi = "Invalid date";
      break;
    case d$3.invalid_string:
      typeof Bi.validation == "object" ? "includes" in Bi.validation ? (Zi = `Invalid input: must include "${Bi.validation.includes}"`, typeof Bi.validation.position == "number" && (Zi = `${Zi} at one or more positions greater than or equal to ${Bi.validation.position}`)) : "startsWith" in Bi.validation ? Zi = `Invalid input: must start with "${Bi.validation.startsWith}"` : "endsWith" in Bi.validation ? Zi = `Invalid input: must end with "${Bi.validation.endsWith}"` : b$2.assertNever(Bi.validation) : Bi.validation !== "regex" ? Zi = `Invalid ${Bi.validation}` : Zi = "Invalid";
      break;
    case d$3.too_small:
      Bi.type === "array" ? Zi = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "more than"} ${Bi.minimum} element(s)` : Bi.type === "string" ? Zi = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "over"} ${Bi.minimum} character(s)` : Bi.type === "number" ? Zi = `Number must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${Bi.minimum}` : Bi.type === "date" ? Zi = `Date must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(Bi.minimum))}` : Zi = "Invalid input";
      break;
    case d$3.too_big:
      Bi.type === "array" ? Zi = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "less than"} ${Bi.maximum} element(s)` : Bi.type === "string" ? Zi = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "under"} ${Bi.maximum} character(s)` : Bi.type === "number" ? Zi = `Number must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "bigint" ? Zi = `BigInt must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "date" ? Zi = `Date must be ${Bi.exact ? "exactly" : Bi.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(Bi.maximum))}` : Zi = "Invalid input";
      break;
    case d$3.custom:
      Zi = "Invalid input";
      break;
    case d$3.invalid_intersection_types:
      Zi = "Intersection results could not be merged";
      break;
    case d$3.not_multiple_of:
      Zi = `Number must be a multiple of ${Bi.multipleOf}`;
      break;
    case d$3.not_finite:
      Zi = "Number must be finite";
      break;
    default:
      Zi = e.defaultError, b$2.assertNever(Bi);
  }
  return { message: Zi };
};
let Ae$1 = J$1;
function qe$2(Bi) {
  Ae$1 = Bi;
}
function fe$2() {
  return Ae$1;
}
const pe$2 = (Bi) => {
  const { data: e, path: Zi, errorMaps: Qi, issueData: ea } = Bi, ra = [...Zi, ...ea.path || []], na = {
    ...ea,
    path: ra
  };
  if (ea.message !== void 0)
    return {
      ...ea,
      path: ra,
      message: ea.message
    };
  let ia = "";
  const fa = Qi.filter((La) => !!La).slice().reverse();
  for (const La of fa)
    ia = La(na, { data: e, defaultError: ia }).message;
  return {
    ...ea,
    path: ra,
    message: ia
  };
}, Je$2 = [];
function u(Bi, e) {
  const Zi = fe$2(), Qi = pe$2({
    issueData: e,
    data: Bi.data,
    path: Bi.path,
    errorMaps: [
      Bi.common.contextualErrorMap,
      // contextual error map is first priority
      Bi.schemaErrorMap,
      // then schema-bound map if available
      Zi,
      // then global override map
      Zi === J$1 ? void 0 : J$1
      // then global default map
    ].filter((ea) => !!ea)
  });
  Bi.common.issues.push(Qi);
}
class k {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, Zi) {
    const Qi = [];
    for (const ea of Zi) {
      if (ea.status === "aborted")
        return y$3;
      ea.status === "dirty" && e.dirty(), Qi.push(ea.value);
    }
    return { status: e.value, value: Qi };
  }
  static async mergeObjectAsync(e, Zi) {
    const Qi = [];
    for (const ea of Zi) {
      const ra = await ea.key, na = await ea.value;
      Qi.push({
        key: ra,
        value: na
      });
    }
    return k.mergeObjectSync(e, Qi);
  }
  static mergeObjectSync(e, Zi) {
    const Qi = {};
    for (const ea of Zi) {
      const { key: ra, value: na } = ea;
      if (ra.status === "aborted" || na.status === "aborted")
        return y$3;
      ra.status === "dirty" && e.dirty(), na.status === "dirty" && e.dirty(), ra.value !== "__proto__" && (typeof na.value < "u" || ea.alwaysSet) && (Qi[ra.value] = na.value);
    }
    return { status: e.value, value: Qi };
  }
}
const y$3 = Object.freeze({
  status: "aborted"
}), W$2 = (Bi) => ({ status: "dirty", value: Bi }), T$2 = (Bi) => ({ status: "valid", value: Bi }), Te$2 = (Bi) => Bi.status === "aborted", Se$2 = (Bi) => Bi.status === "dirty", V$1 = (Bi) => Bi.status === "valid", X$2 = (Bi) => typeof Promise < "u" && Bi instanceof Promise;
function me$2(Bi, e, Zi, Qi) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(Bi);
}
function Ne$2(Bi, e, Zi, Qi, ea) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(Bi, Zi), Zi;
}
var p$3;
(function(Bi) {
  Bi.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, Bi.toString = (e) => typeof e == "string" ? e : e?.message;
})(p$3 || (p$3 = {}));
var H$3, K$1;
let O$2 = class {
  constructor(e, Zi, Qi, ea) {
    this._cachedPath = [], this.parent = e, this.data = Zi, this._path = Qi, this._key = ea;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const Ee$2 = (Bi, e) => {
  if (V$1(e))
    return { success: !0, data: e.value };
  if (!Bi.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const Zi = new S$1(Bi.common.issues);
      return this._error = Zi, this._error;
    }
  };
};
function _(Bi) {
  if (!Bi)
    return {};
  const { errorMap: e, invalid_type_error: Zi, required_error: Qi, description: ea } = Bi;
  if (e && (Zi || Qi))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: ea } : { errorMap: (ra, na) => {
    var ia, fa;
    const { message: La } = Bi;
    return ra.code === "invalid_enum_value" ? { message: La ?? na.defaultError } : typeof na.data > "u" ? { message: (ia = La ?? Qi) !== null && ia !== void 0 ? ia : na.defaultError } : ra.code !== "invalid_type" ? { message: na.defaultError } : { message: (fa = La ?? Zi) !== null && fa !== void 0 ? fa : na.defaultError };
  }, description: ea };
}
class v {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return N$1(e.data);
  }
  _getOrReturnCtx(e, Zi) {
    return Zi || {
      common: e.parent.common,
      data: e.data,
      parsedType: N$1(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new k(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: N$1(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const Zi = this._parse(e);
    if (X$2(Zi))
      throw new Error("Synchronous parse encountered promise.");
    return Zi;
  }
  _parseAsync(e) {
    const Zi = this._parse(e);
    return Promise.resolve(Zi);
  }
  parse(e, Zi) {
    const Qi = this.safeParse(e, Zi);
    if (Qi.success)
      return Qi.data;
    throw Qi.error;
  }
  safeParse(e, Zi) {
    var Qi;
    const ea = {
      common: {
        issues: [],
        async: (Qi = Zi?.async) !== null && Qi !== void 0 ? Qi : !1,
        contextualErrorMap: Zi?.errorMap
      },
      path: Zi?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: N$1(e)
    }, ra = this._parseSync({ data: e, path: ea.path, parent: ea });
    return Ee$2(ea, ra);
  }
  "~validate"(e) {
    var Zi, Qi;
    const ea = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: N$1(e)
    };
    if (!this["~standard"].async)
      try {
        const ra = this._parseSync({ data: e, path: [], parent: ea });
        return V$1(ra) ? {
          value: ra.value
        } : {
          issues: ea.common.issues
        };
      } catch (ra) {
        !((Qi = (Zi = ra?.message) === null || Zi === void 0 ? void 0 : Zi.toLowerCase()) === null || Qi === void 0) && Qi.includes("encountered") && (this["~standard"].async = !0), ea.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: ea }).then((ra) => V$1(ra) ? {
      value: ra.value
    } : {
      issues: ea.common.issues
    });
  }
  async parseAsync(e, Zi) {
    const Qi = await this.safeParseAsync(e, Zi);
    if (Qi.success)
      return Qi.data;
    throw Qi.error;
  }
  async safeParseAsync(e, Zi) {
    const Qi = {
      common: {
        issues: [],
        contextualErrorMap: Zi?.errorMap,
        async: !0
      },
      path: Zi?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: N$1(e)
    }, ea = this._parse({ data: e, path: Qi.path, parent: Qi }), ra = await (X$2(ea) ? ea : Promise.resolve(ea));
    return Ee$2(Qi, ra);
  }
  refine(e, Zi) {
    const Qi = (ea) => typeof Zi == "string" || typeof Zi > "u" ? { message: Zi } : typeof Zi == "function" ? Zi(ea) : Zi;
    return this._refinement((ea, ra) => {
      const na = e(ea), ia = () => ra.addIssue({
        code: d$3.custom,
        ...Qi(ea)
      });
      return typeof Promise < "u" && na instanceof Promise ? na.then((fa) => fa ? !0 : (ia(), !1)) : na ? !0 : (ia(), !1);
    });
  }
  refinement(e, Zi) {
    return this._refinement((Qi, ea) => e(Qi) ? !0 : (ea.addIssue(typeof Zi == "function" ? Zi(Qi, ea) : Zi), !1));
  }
  _refinement(e) {
    return new E$2({
      schema: this,
      typeName: g$3.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (Zi) => this["~validate"](Zi)
    };
  }
  optional() {
    return j$1.create(this, this._def);
  }
  nullable() {
    return $$1.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Z$1.create(this);
  }
  promise() {
    return G$2.create(this, this._def);
  }
  or(e) {
    return re$2.create([this, e], this._def);
  }
  and(e) {
    return ne$1.create(this, e, this._def);
  }
  transform(e) {
    return new E$2({
      ..._(this._def),
      schema: this,
      typeName: g$3.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const Zi = typeof e == "function" ? e : () => e;
    return new ce$2({
      ..._(this._def),
      innerType: this,
      defaultValue: Zi,
      typeName: g$3.ZodDefault
    });
  }
  brand() {
    return new Ze$2({
      typeName: g$3.ZodBranded,
      type: this,
      ..._(this._def)
    });
  }
  catch(e) {
    const Zi = typeof e == "function" ? e : () => e;
    return new de$2({
      ..._(this._def),
      innerType: this,
      catchValue: Zi,
      typeName: g$3.ZodCatch
    });
  }
  describe(e) {
    const Zi = this.constructor;
    return new Zi({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return ue$1.create(this, e);
  }
  readonly() {
    return le$1.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Ye$2 = /^c[^\s-]{8,}$/i, Ge$2 = /^[0-9a-z]+$/, He$2 = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Ke$2 = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Xe$2 = /^[a-z0-9_-]{21}$/i, Qe$2 = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, et$2 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, tt$1 = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, rt$2 = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let ke$1;
const nt$1 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, st$2 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, at$1 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, it$2 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, ot$2 = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, ct$2 = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ie$2 = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", dt$2 = new RegExp(`^${Ie$2}$`);
function Me$2(Bi) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return Bi.precision ? e = `${e}\\.\\d{${Bi.precision}}` : Bi.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function lt$2(Bi) {
  return new RegExp(`^${Me$2(Bi)}$`);
}
function De$1(Bi) {
  let e = `${Ie$2}T${Me$2(Bi)}`;
  const Zi = [];
  return Zi.push(Bi.local ? "Z?" : "Z"), Bi.offset && Zi.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${Zi.join("|")})`, new RegExp(`^${e}$`);
}
function ut$1(Bi, e) {
  return !!((e === "v4" || !e) && nt$1.test(Bi) || (e === "v6" || !e) && at$1.test(Bi));
}
function ht$2(Bi, e) {
  if (!Qe$2.test(Bi))
    return !1;
  try {
    const [Zi] = Bi.split("."), Qi = Zi.replace(/-/g, "+").replace(/_/g, "/").padEnd(Zi.length + (4 - Zi.length % 4) % 4, "="), ea = JSON.parse(atob(Qi));
    return !(typeof ea != "object" || ea === null || !ea.typ || !ea.alg || e && ea.alg !== e);
  } catch {
    return !1;
  }
}
function ft$2(Bi, e) {
  return !!((e === "v4" || !e) && st$2.test(Bi) || (e === "v6" || !e) && it$2.test(Bi));
}
let C$2 = class Nd extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== f$7.string) {
      const ea = this._getOrReturnCtx(e);
      return u(ea, {
        code: d$3.invalid_type,
        expected: f$7.string,
        received: ea.parsedType
      }), y$3;
    }
    const Zi = new k();
    let Qi;
    for (const ea of this._def.checks)
      if (ea.kind === "min")
        e.data.length < ea.value && (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
          code: d$3.too_small,
          minimum: ea.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "max")
        e.data.length > ea.value && (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
          code: d$3.too_big,
          maximum: ea.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "length") {
        const ra = e.data.length > ea.value, na = e.data.length < ea.value;
        (ra || na) && (Qi = this._getOrReturnCtx(e, Qi), ra ? u(Qi, {
          code: d$3.too_big,
          maximum: ea.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: ea.message
        }) : na && u(Qi, {
          code: d$3.too_small,
          minimum: ea.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: ea.message
        }), Zi.dirty());
      } else if (ea.kind === "email")
        tt$1.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
          validation: "email",
          code: d$3.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "emoji")
        ke$1 || (ke$1 = new RegExp(rt$2, "u")), ke$1.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
          validation: "emoji",
          code: d$3.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "uuid")
        Ke$2.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
          validation: "uuid",
          code: d$3.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "nanoid")
        Xe$2.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
          validation: "nanoid",
          code: d$3.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "cuid")
        Ye$2.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
          validation: "cuid",
          code: d$3.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "cuid2")
        Ge$2.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
          validation: "cuid2",
          code: d$3.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "ulid")
        He$2.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
          validation: "ulid",
          code: d$3.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "url")
        try {
          new URL(e.data);
        } catch {
          Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
            validation: "url",
            code: d$3.invalid_string,
            message: ea.message
          }), Zi.dirty();
        }
      else ea.kind === "regex" ? (ea.regex.lastIndex = 0, ea.regex.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        validation: "regex",
        code: d$3.invalid_string,
        message: ea.message
      }), Zi.dirty())) : ea.kind === "trim" ? e.data = e.data.trim() : ea.kind === "includes" ? e.data.includes(ea.value, ea.position) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        code: d$3.invalid_string,
        validation: { includes: ea.value, position: ea.position },
        message: ea.message
      }), Zi.dirty()) : ea.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : ea.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : ea.kind === "startsWith" ? e.data.startsWith(ea.value) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        code: d$3.invalid_string,
        validation: { startsWith: ea.value },
        message: ea.message
      }), Zi.dirty()) : ea.kind === "endsWith" ? e.data.endsWith(ea.value) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        code: d$3.invalid_string,
        validation: { endsWith: ea.value },
        message: ea.message
      }), Zi.dirty()) : ea.kind === "datetime" ? De$1(ea).test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        code: d$3.invalid_string,
        validation: "datetime",
        message: ea.message
      }), Zi.dirty()) : ea.kind === "date" ? dt$2.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        code: d$3.invalid_string,
        validation: "date",
        message: ea.message
      }), Zi.dirty()) : ea.kind === "time" ? lt$2(ea).test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        code: d$3.invalid_string,
        validation: "time",
        message: ea.message
      }), Zi.dirty()) : ea.kind === "duration" ? et$2.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        validation: "duration",
        code: d$3.invalid_string,
        message: ea.message
      }), Zi.dirty()) : ea.kind === "ip" ? ut$1(e.data, ea.version) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        validation: "ip",
        code: d$3.invalid_string,
        message: ea.message
      }), Zi.dirty()) : ea.kind === "jwt" ? ht$2(e.data, ea.alg) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        validation: "jwt",
        code: d$3.invalid_string,
        message: ea.message
      }), Zi.dirty()) : ea.kind === "cidr" ? ft$2(e.data, ea.version) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        validation: "cidr",
        code: d$3.invalid_string,
        message: ea.message
      }), Zi.dirty()) : ea.kind === "base64" ? ot$2.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        validation: "base64",
        code: d$3.invalid_string,
        message: ea.message
      }), Zi.dirty()) : ea.kind === "base64url" ? ct$2.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        validation: "base64url",
        code: d$3.invalid_string,
        message: ea.message
      }), Zi.dirty()) : b$2.assertNever(ea);
    return { status: Zi.value, value: e.data };
  }
  _regex(e, Zi, Qi) {
    return this.refinement((ea) => e.test(ea), {
      validation: Zi,
      code: d$3.invalid_string,
      ...p$3.errToObj(Qi)
    });
  }
  _addCheck(e) {
    return new Nd({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...p$3.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...p$3.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...p$3.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...p$3.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...p$3.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...p$3.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...p$3.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...p$3.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...p$3.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...p$3.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...p$3.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...p$3.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...p$3.errToObj(e) });
  }
  datetime(e) {
    var Zi, Qi;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: (Zi = e?.offset) !== null && Zi !== void 0 ? Zi : !1,
      local: (Qi = e?.local) !== null && Qi !== void 0 ? Qi : !1,
      ...p$3.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...p$3.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...p$3.errToObj(e) });
  }
  regex(e, Zi) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...p$3.errToObj(Zi)
    });
  }
  includes(e, Zi) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: Zi?.position,
      ...p$3.errToObj(Zi?.message)
    });
  }
  startsWith(e, Zi) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...p$3.errToObj(Zi)
    });
  }
  endsWith(e, Zi) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...p$3.errToObj(Zi)
    });
  }
  min(e, Zi) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...p$3.errToObj(Zi)
    });
  }
  max(e, Zi) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...p$3.errToObj(Zi)
    });
  }
  length(e, Zi) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...p$3.errToObj(Zi)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, p$3.errToObj(e));
  }
  trim() {
    return new Nd({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Nd({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Nd({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "min" && (e === null || Zi.value > e) && (e = Zi.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "max" && (e === null || Zi.value < e) && (e = Zi.value);
    return e;
  }
};
C$2.create = (Bi) => {
  var e;
  return new C$2({
    checks: [],
    typeName: g$3.ZodString,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ..._(Bi)
  });
};
function pt$2(Bi, e) {
  const Zi = (Bi.toString().split(".")[1] || "").length, Qi = (e.toString().split(".")[1] || "").length, ea = Zi > Qi ? Zi : Qi, ra = parseInt(Bi.toFixed(ea).replace(".", "")), na = parseInt(e.toFixed(ea).replace(".", ""));
  return ra % na / Math.pow(10, ea);
}
let M$2 = class Zd extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== f$7.number) {
      const ea = this._getOrReturnCtx(e);
      return u(ea, {
        code: d$3.invalid_type,
        expected: f$7.number,
        received: ea.parsedType
      }), y$3;
    }
    let Zi;
    const Qi = new k();
    for (const ea of this._def.checks)
      ea.kind === "int" ? b$2.isInteger(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.invalid_type,
        expected: "integer",
        received: "float",
        message: ea.message
      }), Qi.dirty()) : ea.kind === "min" ? (ea.inclusive ? e.data < ea.value : e.data <= ea.value) && (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.too_small,
        minimum: ea.value,
        type: "number",
        inclusive: ea.inclusive,
        exact: !1,
        message: ea.message
      }), Qi.dirty()) : ea.kind === "max" ? (ea.inclusive ? e.data > ea.value : e.data >= ea.value) && (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.too_big,
        maximum: ea.value,
        type: "number",
        inclusive: ea.inclusive,
        exact: !1,
        message: ea.message
      }), Qi.dirty()) : ea.kind === "multipleOf" ? pt$2(e.data, ea.value) !== 0 && (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.not_multiple_of,
        multipleOf: ea.value,
        message: ea.message
      }), Qi.dirty()) : ea.kind === "finite" ? Number.isFinite(e.data) || (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.not_finite,
        message: ea.message
      }), Qi.dirty()) : b$2.assertNever(ea);
    return { status: Qi.value, value: e.data };
  }
  gte(e, Zi) {
    return this.setLimit("min", e, !0, p$3.toString(Zi));
  }
  gt(e, Zi) {
    return this.setLimit("min", e, !1, p$3.toString(Zi));
  }
  lte(e, Zi) {
    return this.setLimit("max", e, !0, p$3.toString(Zi));
  }
  lt(e, Zi) {
    return this.setLimit("max", e, !1, p$3.toString(Zi));
  }
  setLimit(e, Zi, Qi, ea) {
    return new Zd({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: Zi,
          inclusive: Qi,
          message: p$3.toString(ea)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Zd({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: p$3.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  multipleOf(e, Zi) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p$3.toString(Zi)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: p$3.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: p$3.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: p$3.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "min" && (e === null || Zi.value > e) && (e = Zi.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "max" && (e === null || Zi.value < e) && (e = Zi.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && b$2.isInteger(e.value));
  }
  get isFinite() {
    let e = null, Zi = null;
    for (const Qi of this._def.checks) {
      if (Qi.kind === "finite" || Qi.kind === "int" || Qi.kind === "multipleOf")
        return !0;
      Qi.kind === "min" ? (Zi === null || Qi.value > Zi) && (Zi = Qi.value) : Qi.kind === "max" && (e === null || Qi.value < e) && (e = Qi.value);
    }
    return Number.isFinite(Zi) && Number.isFinite(e);
  }
};
M$2.create = (Bi) => new M$2({
  checks: [],
  typeName: g$3.ZodNumber,
  coerce: Bi?.coerce || !1,
  ..._(Bi)
});
let D$1 = class Xd extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== f$7.bigint)
      return this._getInvalidInput(e);
    let Zi;
    const Qi = new k();
    for (const ea of this._def.checks)
      ea.kind === "min" ? (ea.inclusive ? e.data < ea.value : e.data <= ea.value) && (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.too_small,
        type: "bigint",
        minimum: ea.value,
        inclusive: ea.inclusive,
        message: ea.message
      }), Qi.dirty()) : ea.kind === "max" ? (ea.inclusive ? e.data > ea.value : e.data >= ea.value) && (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.too_big,
        type: "bigint",
        maximum: ea.value,
        inclusive: ea.inclusive,
        message: ea.message
      }), Qi.dirty()) : ea.kind === "multipleOf" ? e.data % ea.value !== BigInt(0) && (Zi = this._getOrReturnCtx(e, Zi), u(Zi, {
        code: d$3.not_multiple_of,
        multipleOf: ea.value,
        message: ea.message
      }), Qi.dirty()) : b$2.assertNever(ea);
    return { status: Qi.value, value: e.data };
  }
  _getInvalidInput(e) {
    const Zi = this._getOrReturnCtx(e);
    return u(Zi, {
      code: d$3.invalid_type,
      expected: f$7.bigint,
      received: Zi.parsedType
    }), y$3;
  }
  gte(e, Zi) {
    return this.setLimit("min", e, !0, p$3.toString(Zi));
  }
  gt(e, Zi) {
    return this.setLimit("min", e, !1, p$3.toString(Zi));
  }
  lte(e, Zi) {
    return this.setLimit("max", e, !0, p$3.toString(Zi));
  }
  lt(e, Zi) {
    return this.setLimit("max", e, !1, p$3.toString(Zi));
  }
  setLimit(e, Zi, Qi, ea) {
    return new Xd({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: Zi,
          inclusive: Qi,
          message: p$3.toString(ea)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Xd({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  multipleOf(e, Zi) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p$3.toString(Zi)
    });
  }
  get minValue() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "min" && (e === null || Zi.value > e) && (e = Zi.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "max" && (e === null || Zi.value < e) && (e = Zi.value);
    return e;
  }
};
D$1.create = (Bi) => {
  var e;
  return new D$1({
    checks: [],
    typeName: g$3.ZodBigInt,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ..._(Bi)
  });
};
let Q$2 = class extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== f$7.boolean) {
      const Zi = this._getOrReturnCtx(e);
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$7.boolean,
        received: Zi.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
Q$2.create = (Bi) => new Q$2({
  typeName: g$3.ZodBoolean,
  coerce: Bi?.coerce || !1,
  ..._(Bi)
});
let z$1 = class Cf extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== f$7.date) {
      const ea = this._getOrReturnCtx(e);
      return u(ea, {
        code: d$3.invalid_type,
        expected: f$7.date,
        received: ea.parsedType
      }), y$3;
    }
    if (isNaN(e.data.getTime())) {
      const ea = this._getOrReturnCtx(e);
      return u(ea, {
        code: d$3.invalid_date
      }), y$3;
    }
    const Zi = new k();
    let Qi;
    for (const ea of this._def.checks)
      ea.kind === "min" ? e.data.getTime() < ea.value && (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        code: d$3.too_small,
        message: ea.message,
        inclusive: !0,
        exact: !1,
        minimum: ea.value,
        type: "date"
      }), Zi.dirty()) : ea.kind === "max" ? e.data.getTime() > ea.value && (Qi = this._getOrReturnCtx(e, Qi), u(Qi, {
        code: d$3.too_big,
        message: ea.message,
        inclusive: !0,
        exact: !1,
        maximum: ea.value,
        type: "date"
      }), Zi.dirty()) : b$2.assertNever(ea);
    return {
      status: Zi.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Cf({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, Zi) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: p$3.toString(Zi)
    });
  }
  max(e, Zi) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: p$3.toString(Zi)
    });
  }
  get minDate() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "min" && (e === null || Zi.value > e) && (e = Zi.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "max" && (e === null || Zi.value < e) && (e = Zi.value);
    return e != null ? new Date(e) : null;
  }
};
z$1.create = (Bi) => new z$1({
  checks: [],
  coerce: Bi?.coerce || !1,
  typeName: g$3.ZodDate,
  ..._(Bi)
});
let ge$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== f$7.symbol) {
      const Zi = this._getOrReturnCtx(e);
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$7.symbol,
        received: Zi.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
ge$2.create = (Bi) => new ge$2({
  typeName: g$3.ZodSymbol,
  ..._(Bi)
});
let ee$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== f$7.undefined) {
      const Zi = this._getOrReturnCtx(e);
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$7.undefined,
        received: Zi.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
ee$2.create = (Bi) => new ee$2({
  typeName: g$3.ZodUndefined,
  ..._(Bi)
});
let te$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== f$7.null) {
      const Zi = this._getOrReturnCtx(e);
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$7.null,
        received: Zi.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
te$2.create = (Bi) => new te$2({
  typeName: g$3.ZodNull,
  ..._(Bi)
});
let Y$2 = class extends v {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return T$2(e.data);
  }
};
Y$2.create = (Bi) => new Y$2({
  typeName: g$3.ZodAny,
  ..._(Bi)
});
let L$2 = class extends v {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return T$2(e.data);
  }
};
L$2.create = (Bi) => new L$2({
  typeName: g$3.ZodUnknown,
  ..._(Bi)
});
let I$2 = class extends v {
  _parse(e) {
    const Zi = this._getOrReturnCtx(e);
    return u(Zi, {
      code: d$3.invalid_type,
      expected: f$7.never,
      received: Zi.parsedType
    }), y$3;
  }
};
I$2.create = (Bi) => new I$2({
  typeName: g$3.ZodNever,
  ..._(Bi)
});
let ye$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== f$7.undefined) {
      const Zi = this._getOrReturnCtx(e);
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$7.void,
        received: Zi.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
ye$2.create = (Bi) => new ye$2({
  typeName: g$3.ZodVoid,
  ..._(Bi)
});
let Z$1 = class Bd extends v {
  _parse(e) {
    const { ctx: Zi, status: Qi } = this._processInputParams(e), ea = this._def;
    if (Zi.parsedType !== f$7.array)
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$7.array,
        received: Zi.parsedType
      }), y$3;
    if (ea.exactLength !== null) {
      const na = Zi.data.length > ea.exactLength.value, ia = Zi.data.length < ea.exactLength.value;
      (na || ia) && (u(Zi, {
        code: na ? d$3.too_big : d$3.too_small,
        minimum: ia ? ea.exactLength.value : void 0,
        maximum: na ? ea.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: ea.exactLength.message
      }), Qi.dirty());
    }
    if (ea.minLength !== null && Zi.data.length < ea.minLength.value && (u(Zi, {
      code: d$3.too_small,
      minimum: ea.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: ea.minLength.message
    }), Qi.dirty()), ea.maxLength !== null && Zi.data.length > ea.maxLength.value && (u(Zi, {
      code: d$3.too_big,
      maximum: ea.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: ea.maxLength.message
    }), Qi.dirty()), Zi.common.async)
      return Promise.all([...Zi.data].map((na, ia) => ea.type._parseAsync(new O$2(Zi, na, Zi.path, ia)))).then((na) => k.mergeArray(Qi, na));
    const ra = [...Zi.data].map((na, ia) => ea.type._parseSync(new O$2(Zi, na, Zi.path, ia)));
    return k.mergeArray(Qi, ra);
  }
  get element() {
    return this._def.type;
  }
  min(e, Zi) {
    return new Bd({
      ...this._def,
      minLength: { value: e, message: p$3.toString(Zi) }
    });
  }
  max(e, Zi) {
    return new Bd({
      ...this._def,
      maxLength: { value: e, message: p$3.toString(Zi) }
    });
  }
  length(e, Zi) {
    return new Bd({
      ...this._def,
      exactLength: { value: e, message: p$3.toString(Zi) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
Z$1.create = (Bi, e) => new Z$1({
  type: Bi,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: g$3.ZodArray,
  ..._(e)
});
function B$2(Bi) {
  if (Bi instanceof x$2) {
    const e = {};
    for (const Zi in Bi.shape) {
      const Qi = Bi.shape[Zi];
      e[Zi] = j$1.create(B$2(Qi));
    }
    return new x$2({
      ...Bi._def,
      shape: () => e
    });
  } else return Bi instanceof Z$1 ? new Z$1({
    ...Bi._def,
    type: B$2(Bi.element)
  }) : Bi instanceof j$1 ? j$1.create(B$2(Bi.unwrap())) : Bi instanceof $$1 ? $$1.create(B$2(Bi.unwrap())) : Bi instanceof R$2 ? R$2.create(Bi.items.map((e) => B$2(e))) : Bi;
}
let x$2 = class Sd extends v {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), Zi = b$2.objectKeys(e);
    return this._cached = { shape: e, keys: Zi };
  }
  _parse(e) {
    if (this._getType(e) !== f$7.object) {
      const fa = this._getOrReturnCtx(e);
      return u(fa, {
        code: d$3.invalid_type,
        expected: f$7.object,
        received: fa.parsedType
      }), y$3;
    }
    const { status: Zi, ctx: Qi } = this._processInputParams(e), { shape: ea, keys: ra } = this._getCached(), na = [];
    if (!(this._def.catchall instanceof I$2 && this._def.unknownKeys === "strip"))
      for (const fa in Qi.data)
        ra.includes(fa) || na.push(fa);
    const ia = [];
    for (const fa of ra) {
      const La = ea[fa], Va = Qi.data[fa];
      ia.push({
        key: { status: "valid", value: fa },
        value: La._parse(new O$2(Qi, Va, Qi.path, fa)),
        alwaysSet: fa in Qi.data
      });
    }
    if (this._def.catchall instanceof I$2) {
      const fa = this._def.unknownKeys;
      if (fa === "passthrough")
        for (const La of na)
          ia.push({
            key: { status: "valid", value: La },
            value: { status: "valid", value: Qi.data[La] }
          });
      else if (fa === "strict")
        na.length > 0 && (u(Qi, {
          code: d$3.unrecognized_keys,
          keys: na
        }), Zi.dirty());
      else if (fa !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const fa = this._def.catchall;
      for (const La of na) {
        const Va = Qi.data[La];
        ia.push({
          key: { status: "valid", value: La },
          value: fa._parse(
            new O$2(Qi, Va, Qi.path, La)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: La in Qi.data
        });
      }
    }
    return Qi.common.async ? Promise.resolve().then(async () => {
      const fa = [];
      for (const La of ia) {
        const Va = await La.key, to = await La.value;
        fa.push({
          key: Va,
          value: to,
          alwaysSet: La.alwaysSet
        });
      }
      return fa;
    }).then((fa) => k.mergeObjectSync(Zi, fa)) : k.mergeObjectSync(Zi, ia);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return p$3.errToObj, new Sd({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (Zi, Qi) => {
          var ea, ra, na, ia;
          const fa = (na = (ra = (ea = this._def).errorMap) === null || ra === void 0 ? void 0 : ra.call(ea, Zi, Qi).message) !== null && na !== void 0 ? na : Qi.defaultError;
          return Zi.code === "unrecognized_keys" ? {
            message: (ia = p$3.errToObj(e).message) !== null && ia !== void 0 ? ia : fa
          } : {
            message: fa
          };
        }
      } : {}
    });
  }
  strip() {
    return new Sd({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Sd({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Sd({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Sd({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: g$3.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, Zi) {
    return this.augment({ [e]: Zi });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Sd({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const Zi = {};
    return b$2.objectKeys(e).forEach((Qi) => {
      e[Qi] && this.shape[Qi] && (Zi[Qi] = this.shape[Qi]);
    }), new Sd({
      ...this._def,
      shape: () => Zi
    });
  }
  omit(e) {
    const Zi = {};
    return b$2.objectKeys(this.shape).forEach((Qi) => {
      e[Qi] || (Zi[Qi] = this.shape[Qi]);
    }), new Sd({
      ...this._def,
      shape: () => Zi
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return B$2(this);
  }
  partial(e) {
    const Zi = {};
    return b$2.objectKeys(this.shape).forEach((Qi) => {
      const ea = this.shape[Qi];
      e && !e[Qi] ? Zi[Qi] = ea : Zi[Qi] = ea.optional();
    }), new Sd({
      ...this._def,
      shape: () => Zi
    });
  }
  required(e) {
    const Zi = {};
    return b$2.objectKeys(this.shape).forEach((Qi) => {
      if (e && !e[Qi])
        Zi[Qi] = this.shape[Qi];
      else {
        let ea = this.shape[Qi];
        for (; ea instanceof j$1; )
          ea = ea._def.innerType;
        Zi[Qi] = ea;
      }
    }), new Sd({
      ...this._def,
      shape: () => Zi
    });
  }
  keyof() {
    return Pe$2(b$2.objectKeys(this.shape));
  }
};
x$2.create = (Bi, e) => new x$2({
  shape: () => Bi,
  unknownKeys: "strip",
  catchall: I$2.create(),
  typeName: g$3.ZodObject,
  ..._(e)
});
x$2.strictCreate = (Bi, e) => new x$2({
  shape: () => Bi,
  unknownKeys: "strict",
  catchall: I$2.create(),
  typeName: g$3.ZodObject,
  ..._(e)
});
x$2.lazycreate = (Bi, e) => new x$2({
  shape: Bi,
  unknownKeys: "strip",
  catchall: I$2.create(),
  typeName: g$3.ZodObject,
  ..._(e)
});
let re$2 = class extends v {
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e), Qi = this._def.options;
    function ea(ra) {
      for (const ia of ra)
        if (ia.result.status === "valid")
          return ia.result;
      for (const ia of ra)
        if (ia.result.status === "dirty")
          return Zi.common.issues.push(...ia.ctx.common.issues), ia.result;
      const na = ra.map((ia) => new S$1(ia.ctx.common.issues));
      return u(Zi, {
        code: d$3.invalid_union,
        unionErrors: na
      }), y$3;
    }
    if (Zi.common.async)
      return Promise.all(Qi.map(async (ra) => {
        const na = {
          ...Zi,
          common: {
            ...Zi.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await ra._parseAsync({
            data: Zi.data,
            path: Zi.path,
            parent: na
          }),
          ctx: na
        };
      })).then(ea);
    {
      let ra;
      const na = [];
      for (const fa of Qi) {
        const La = {
          ...Zi,
          common: {
            ...Zi.common,
            issues: []
          },
          parent: null
        }, Va = fa._parseSync({
          data: Zi.data,
          path: Zi.path,
          parent: La
        });
        if (Va.status === "valid")
          return Va;
        Va.status === "dirty" && !ra && (ra = { result: Va, ctx: La }), La.common.issues.length && na.push(La.common.issues);
      }
      if (ra)
        return Zi.common.issues.push(...ra.ctx.common.issues), ra.result;
      const ia = na.map((fa) => new S$1(fa));
      return u(Zi, {
        code: d$3.invalid_union,
        unionErrors: ia
      }), y$3;
    }
  }
  get options() {
    return this._def.options;
  }
};
re$2.create = (Bi, e) => new re$2({
  options: Bi,
  typeName: g$3.ZodUnion,
  ..._(e)
});
const A$2 = (Bi) => Bi instanceof ae$2 ? A$2(Bi.schema) : Bi instanceof E$2 ? A$2(Bi.innerType()) : Bi instanceof ie$1 ? [Bi.value] : Bi instanceof P$3 ? Bi.options : Bi instanceof oe$2 ? b$2.objectValues(Bi.enum) : Bi instanceof ce$2 ? A$2(Bi._def.innerType) : Bi instanceof ee$2 ? [void 0] : Bi instanceof te$2 ? [null] : Bi instanceof j$1 ? [void 0, ...A$2(Bi.unwrap())] : Bi instanceof $$1 ? [null, ...A$2(Bi.unwrap())] : Bi instanceof Ze$2 || Bi instanceof le$1 ? A$2(Bi.unwrap()) : Bi instanceof de$2 ? A$2(Bi._def.innerType) : [];
let be$2 = class Of extends v {
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== f$7.object)
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$7.object,
        received: Zi.parsedType
      }), y$3;
    const Qi = this.discriminator, ea = Zi.data[Qi], ra = this.optionsMap.get(ea);
    return ra ? Zi.common.async ? ra._parseAsync({
      data: Zi.data,
      path: Zi.path,
      parent: Zi
    }) : ra._parseSync({
      data: Zi.data,
      path: Zi.path,
      parent: Zi
    }) : (u(Zi, {
      code: d$3.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [Qi]
    }), y$3);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, Zi, Qi) {
    const ea = /* @__PURE__ */ new Map();
    for (const ra of Zi) {
      const na = A$2(ra.shape[e]);
      if (!na.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const ia of na) {
        if (ea.has(ia))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(ia)}`);
        ea.set(ia, ra);
      }
    }
    return new Of({
      typeName: g$3.ZodDiscriminatedUnion,
      discriminator: e,
      options: Zi,
      optionsMap: ea,
      ..._(Qi)
    });
  }
};
function Ce$2(Bi, e) {
  const Zi = N$1(Bi), Qi = N$1(e);
  if (Bi === e)
    return { valid: !0, data: Bi };
  if (Zi === f$7.object && Qi === f$7.object) {
    const ea = b$2.objectKeys(e), ra = b$2.objectKeys(Bi).filter((ia) => ea.indexOf(ia) !== -1), na = { ...Bi, ...e };
    for (const ia of ra) {
      const fa = Ce$2(Bi[ia], e[ia]);
      if (!fa.valid)
        return { valid: !1 };
      na[ia] = fa.data;
    }
    return { valid: !0, data: na };
  } else if (Zi === f$7.array && Qi === f$7.array) {
    if (Bi.length !== e.length)
      return { valid: !1 };
    const ea = [];
    for (let ra = 0; ra < Bi.length; ra++) {
      const na = Bi[ra], ia = e[ra], fa = Ce$2(na, ia);
      if (!fa.valid)
        return { valid: !1 };
      ea.push(fa.data);
    }
    return { valid: !0, data: ea };
  } else return Zi === f$7.date && Qi === f$7.date && +Bi == +e ? { valid: !0, data: Bi } : { valid: !1 };
}
let ne$1 = class extends v {
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e), ea = (ra, na) => {
      if (Te$2(ra) || Te$2(na))
        return y$3;
      const ia = Ce$2(ra.value, na.value);
      return ia.valid ? ((Se$2(ra) || Se$2(na)) && Zi.dirty(), { status: Zi.value, value: ia.data }) : (u(Qi, {
        code: d$3.invalid_intersection_types
      }), y$3);
    };
    return Qi.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: Qi.data,
        path: Qi.path,
        parent: Qi
      }),
      this._def.right._parseAsync({
        data: Qi.data,
        path: Qi.path,
        parent: Qi
      })
    ]).then(([ra, na]) => ea(ra, na)) : ea(this._def.left._parseSync({
      data: Qi.data,
      path: Qi.path,
      parent: Qi
    }), this._def.right._parseSync({
      data: Qi.data,
      path: Qi.path,
      parent: Qi
    }));
  }
};
ne$1.create = (Bi, e, Zi) => new ne$1({
  left: Bi,
  right: e,
  typeName: g$3.ZodIntersection,
  ..._(Zi)
});
let R$2 = class Pf extends v {
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e);
    if (Qi.parsedType !== f$7.array)
      return u(Qi, {
        code: d$3.invalid_type,
        expected: f$7.array,
        received: Qi.parsedType
      }), y$3;
    if (Qi.data.length < this._def.items.length)
      return u(Qi, {
        code: d$3.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), y$3;
    !this._def.rest && Qi.data.length > this._def.items.length && (u(Qi, {
      code: d$3.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), Zi.dirty());
    const ea = [...Qi.data].map((ra, na) => {
      const ia = this._def.items[na] || this._def.rest;
      return ia ? ia._parse(new O$2(Qi, ra, Qi.path, na)) : null;
    }).filter((ra) => !!ra);
    return Qi.common.async ? Promise.all(ea).then((ra) => k.mergeArray(Zi, ra)) : k.mergeArray(Zi, ea);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Pf({
      ...this._def,
      rest: e
    });
  }
};
R$2.create = (Bi, e) => {
  if (!Array.isArray(Bi))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new R$2({
    items: Bi,
    typeName: g$3.ZodTuple,
    rest: null,
    ..._(e)
  });
};
let se$2 = class Qd extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e);
    if (Qi.parsedType !== f$7.object)
      return u(Qi, {
        code: d$3.invalid_type,
        expected: f$7.object,
        received: Qi.parsedType
      }), y$3;
    const ea = [], ra = this._def.keyType, na = this._def.valueType;
    for (const ia in Qi.data)
      ea.push({
        key: ra._parse(new O$2(Qi, ia, Qi.path, ia)),
        value: na._parse(new O$2(Qi, Qi.data[ia], Qi.path, ia)),
        alwaysSet: ia in Qi.data
      });
    return Qi.common.async ? k.mergeObjectAsync(Zi, ea) : k.mergeObjectSync(Zi, ea);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, Zi, Qi) {
    return Zi instanceof v ? new Qd({
      keyType: e,
      valueType: Zi,
      typeName: g$3.ZodRecord,
      ..._(Qi)
    }) : new Qd({
      keyType: C$2.create(),
      valueType: e,
      typeName: g$3.ZodRecord,
      ..._(Zi)
    });
  }
}, _e$1 = class extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e);
    if (Qi.parsedType !== f$7.map)
      return u(Qi, {
        code: d$3.invalid_type,
        expected: f$7.map,
        received: Qi.parsedType
      }), y$3;
    const ea = this._def.keyType, ra = this._def.valueType, na = [...Qi.data.entries()].map(([ia, fa], La) => ({
      key: ea._parse(new O$2(Qi, ia, Qi.path, [La, "key"])),
      value: ra._parse(new O$2(Qi, fa, Qi.path, [La, "value"]))
    }));
    if (Qi.common.async) {
      const ia = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const fa of na) {
          const La = await fa.key, Va = await fa.value;
          if (La.status === "aborted" || Va.status === "aborted")
            return y$3;
          (La.status === "dirty" || Va.status === "dirty") && Zi.dirty(), ia.set(La.value, Va.value);
        }
        return { status: Zi.value, value: ia };
      });
    } else {
      const ia = /* @__PURE__ */ new Map();
      for (const fa of na) {
        const La = fa.key, Va = fa.value;
        if (La.status === "aborted" || Va.status === "aborted")
          return y$3;
        (La.status === "dirty" || Va.status === "dirty") && Zi.dirty(), ia.set(La.value, Va.value);
      }
      return { status: Zi.value, value: ia };
    }
  }
};
_e$1.create = (Bi, e, Zi) => new _e$1({
  valueType: e,
  keyType: Bi,
  typeName: g$3.ZodMap,
  ..._(Zi)
});
let F$1 = class Jd extends v {
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e);
    if (Qi.parsedType !== f$7.set)
      return u(Qi, {
        code: d$3.invalid_type,
        expected: f$7.set,
        received: Qi.parsedType
      }), y$3;
    const ea = this._def;
    ea.minSize !== null && Qi.data.size < ea.minSize.value && (u(Qi, {
      code: d$3.too_small,
      minimum: ea.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: ea.minSize.message
    }), Zi.dirty()), ea.maxSize !== null && Qi.data.size > ea.maxSize.value && (u(Qi, {
      code: d$3.too_big,
      maximum: ea.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: ea.maxSize.message
    }), Zi.dirty());
    const ra = this._def.valueType;
    function na(fa) {
      const La = /* @__PURE__ */ new Set();
      for (const Va of fa) {
        if (Va.status === "aborted")
          return y$3;
        Va.status === "dirty" && Zi.dirty(), La.add(Va.value);
      }
      return { status: Zi.value, value: La };
    }
    const ia = [...Qi.data.values()].map((fa, La) => ra._parse(new O$2(Qi, fa, Qi.path, La)));
    return Qi.common.async ? Promise.all(ia).then((fa) => na(fa)) : na(ia);
  }
  min(e, Zi) {
    return new Jd({
      ...this._def,
      minSize: { value: e, message: p$3.toString(Zi) }
    });
  }
  max(e, Zi) {
    return new Jd({
      ...this._def,
      maxSize: { value: e, message: p$3.toString(Zi) }
    });
  }
  size(e, Zi) {
    return this.min(e, Zi).max(e, Zi);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
F$1.create = (Bi, e) => new F$1({
  valueType: Bi,
  minSize: null,
  maxSize: null,
  typeName: g$3.ZodSet,
  ..._(e)
});
let q$1 = class Ud extends v {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== f$7.function)
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$7.function,
        received: Zi.parsedType
      }), y$3;
    function Qi(ia, fa) {
      return pe$2({
        data: ia,
        path: Zi.path,
        errorMaps: [
          Zi.common.contextualErrorMap,
          Zi.schemaErrorMap,
          fe$2(),
          J$1
        ].filter((La) => !!La),
        issueData: {
          code: d$3.invalid_arguments,
          argumentsError: fa
        }
      });
    }
    function ea(ia, fa) {
      return pe$2({
        data: ia,
        path: Zi.path,
        errorMaps: [
          Zi.common.contextualErrorMap,
          Zi.schemaErrorMap,
          fe$2(),
          J$1
        ].filter((La) => !!La),
        issueData: {
          code: d$3.invalid_return_type,
          returnTypeError: fa
        }
      });
    }
    const ra = { errorMap: Zi.common.contextualErrorMap }, na = Zi.data;
    if (this._def.returns instanceof G$2) {
      const ia = this;
      return T$2(async function(...fa) {
        const La = new S$1([]), Va = await ia._def.args.parseAsync(fa, ra).catch((ro) => {
          throw La.addIssue(Qi(fa, ro)), La;
        }), to = await Reflect.apply(na, this, Va);
        return await ia._def.returns._def.type.parseAsync(to, ra).catch((ro) => {
          throw La.addIssue(ea(to, ro)), La;
        });
      });
    } else {
      const ia = this;
      return T$2(function(...fa) {
        const La = ia._def.args.safeParse(fa, ra);
        if (!La.success)
          throw new S$1([Qi(fa, La.error)]);
        const Va = Reflect.apply(na, this, La.data), to = ia._def.returns.safeParse(Va, ra);
        if (!to.success)
          throw new S$1([ea(Va, to.error)]);
        return to.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new Ud({
      ...this._def,
      args: R$2.create(e).rest(L$2.create())
    });
  }
  returns(e) {
    return new Ud({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, Zi, Qi) {
    return new Ud({
      args: e || R$2.create([]).rest(L$2.create()),
      returns: Zi || L$2.create(),
      typeName: g$3.ZodFunction,
      ..._(Qi)
    });
  }
}, ae$2 = class extends v {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e);
    return this._def.getter()._parse({ data: Zi.data, path: Zi.path, parent: Zi });
  }
};
ae$2.create = (Bi, e) => new ae$2({
  getter: Bi,
  typeName: g$3.ZodLazy,
  ..._(e)
});
let ie$1 = class extends v {
  _parse(e) {
    if (e.data !== this._def.value) {
      const Zi = this._getOrReturnCtx(e);
      return u(Zi, {
        received: Zi.data,
        code: d$3.invalid_literal,
        expected: this._def.value
      }), y$3;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
ie$1.create = (Bi, e) => new ie$1({
  value: Bi,
  typeName: g$3.ZodLiteral,
  ..._(e)
});
function Pe$2(Bi, e) {
  return new P$3({
    values: Bi,
    typeName: g$3.ZodEnum,
    ..._(e)
  });
}
let P$3 = class ef extends v {
  constructor() {
    super(...arguments), H$3.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const Zi = this._getOrReturnCtx(e), Qi = this._def.values;
      return u(Zi, {
        expected: b$2.joinValues(Qi),
        received: Zi.parsedType,
        code: d$3.invalid_type
      }), y$3;
    }
    if (me$2(this, H$3) || Ne$2(this, H$3, new Set(this._def.values)), !me$2(this, H$3).has(e.data)) {
      const Zi = this._getOrReturnCtx(e), Qi = this._def.values;
      return u(Zi, {
        received: Zi.data,
        code: d$3.invalid_enum_value,
        options: Qi
      }), y$3;
    }
    return T$2(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const Zi of this._def.values)
      e[Zi] = Zi;
    return e;
  }
  get Values() {
    const e = {};
    for (const Zi of this._def.values)
      e[Zi] = Zi;
    return e;
  }
  get Enum() {
    const e = {};
    for (const Zi of this._def.values)
      e[Zi] = Zi;
    return e;
  }
  extract(e, Zi = this._def) {
    return ef.create(e, {
      ...this._def,
      ...Zi
    });
  }
  exclude(e, Zi = this._def) {
    return ef.create(this.options.filter((Qi) => !e.includes(Qi)), {
      ...this._def,
      ...Zi
    });
  }
};
H$3 = /* @__PURE__ */ new WeakMap();
P$3.create = Pe$2;
let oe$2 = class extends v {
  constructor() {
    super(...arguments), K$1.set(this, void 0);
  }
  _parse(e) {
    const Zi = b$2.getValidEnumValues(this._def.values), Qi = this._getOrReturnCtx(e);
    if (Qi.parsedType !== f$7.string && Qi.parsedType !== f$7.number) {
      const ea = b$2.objectValues(Zi);
      return u(Qi, {
        expected: b$2.joinValues(ea),
        received: Qi.parsedType,
        code: d$3.invalid_type
      }), y$3;
    }
    if (me$2(this, K$1) || Ne$2(this, K$1, new Set(b$2.getValidEnumValues(this._def.values))), !me$2(this, K$1).has(e.data)) {
      const ea = b$2.objectValues(Zi);
      return u(Qi, {
        received: Qi.data,
        code: d$3.invalid_enum_value,
        options: ea
      }), y$3;
    }
    return T$2(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
K$1 = /* @__PURE__ */ new WeakMap();
oe$2.create = (Bi, e) => new oe$2({
  values: Bi,
  typeName: g$3.ZodNativeEnum,
  ..._(e)
});
let G$2 = class extends v {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== f$7.promise && Zi.common.async === !1)
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$7.promise,
        received: Zi.parsedType
      }), y$3;
    const Qi = Zi.parsedType === f$7.promise ? Zi.data : Promise.resolve(Zi.data);
    return T$2(Qi.then((ea) => this._def.type.parseAsync(ea, {
      path: Zi.path,
      errorMap: Zi.common.contextualErrorMap
    })));
  }
};
G$2.create = (Bi, e) => new G$2({
  type: Bi,
  typeName: g$3.ZodPromise,
  ..._(e)
});
let E$2 = class extends v {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === g$3.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e), ea = this._def.effect || null, ra = {
      addIssue: (na) => {
        u(Qi, na), na.fatal ? Zi.abort() : Zi.dirty();
      },
      get path() {
        return Qi.path;
      }
    };
    if (ra.addIssue = ra.addIssue.bind(ra), ea.type === "preprocess") {
      const na = ea.transform(Qi.data, ra);
      if (Qi.common.async)
        return Promise.resolve(na).then(async (ia) => {
          if (Zi.value === "aborted")
            return y$3;
          const fa = await this._def.schema._parseAsync({
            data: ia,
            path: Qi.path,
            parent: Qi
          });
          return fa.status === "aborted" ? y$3 : fa.status === "dirty" || Zi.value === "dirty" ? W$2(fa.value) : fa;
        });
      {
        if (Zi.value === "aborted")
          return y$3;
        const ia = this._def.schema._parseSync({
          data: na,
          path: Qi.path,
          parent: Qi
        });
        return ia.status === "aborted" ? y$3 : ia.status === "dirty" || Zi.value === "dirty" ? W$2(ia.value) : ia;
      }
    }
    if (ea.type === "refinement") {
      const na = (ia) => {
        const fa = ea.refinement(ia, ra);
        if (Qi.common.async)
          return Promise.resolve(fa);
        if (fa instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return ia;
      };
      if (Qi.common.async === !1) {
        const ia = this._def.schema._parseSync({
          data: Qi.data,
          path: Qi.path,
          parent: Qi
        });
        return ia.status === "aborted" ? y$3 : (ia.status === "dirty" && Zi.dirty(), na(ia.value), { status: Zi.value, value: ia.value });
      } else
        return this._def.schema._parseAsync({ data: Qi.data, path: Qi.path, parent: Qi }).then((ia) => ia.status === "aborted" ? y$3 : (ia.status === "dirty" && Zi.dirty(), na(ia.value).then(() => ({ status: Zi.value, value: ia.value }))));
    }
    if (ea.type === "transform")
      if (Qi.common.async === !1) {
        const na = this._def.schema._parseSync({
          data: Qi.data,
          path: Qi.path,
          parent: Qi
        });
        if (!V$1(na))
          return na;
        const ia = ea.transform(na.value, ra);
        if (ia instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: Zi.value, value: ia };
      } else
        return this._def.schema._parseAsync({ data: Qi.data, path: Qi.path, parent: Qi }).then((na) => V$1(na) ? Promise.resolve(ea.transform(na.value, ra)).then((ia) => ({ status: Zi.value, value: ia })) : na);
    b$2.assertNever(ea);
  }
};
E$2.create = (Bi, e, Zi) => new E$2({
  schema: Bi,
  typeName: g$3.ZodEffects,
  effect: e,
  ..._(Zi)
});
E$2.createWithPreprocess = (Bi, e, Zi) => new E$2({
  schema: e,
  effect: { type: "preprocess", transform: Bi },
  typeName: g$3.ZodEffects,
  ..._(Zi)
});
let j$1 = class extends v {
  _parse(e) {
    return this._getType(e) === f$7.undefined ? T$2(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
j$1.create = (Bi, e) => new j$1({
  innerType: Bi,
  typeName: g$3.ZodOptional,
  ..._(e)
});
let $$1 = class extends v {
  _parse(e) {
    return this._getType(e) === f$7.null ? T$2(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
$$1.create = (Bi, e) => new $$1({
  innerType: Bi,
  typeName: g$3.ZodNullable,
  ..._(e)
});
let ce$2 = class extends v {
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e);
    let Qi = Zi.data;
    return Zi.parsedType === f$7.undefined && (Qi = this._def.defaultValue()), this._def.innerType._parse({
      data: Qi,
      path: Zi.path,
      parent: Zi
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ce$2.create = (Bi, e) => new ce$2({
  innerType: Bi,
  typeName: g$3.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ..._(e)
});
let de$2 = class extends v {
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e), Qi = {
      ...Zi,
      common: {
        ...Zi.common,
        issues: []
      }
    }, ea = this._def.innerType._parse({
      data: Qi.data,
      path: Qi.path,
      parent: {
        ...Qi
      }
    });
    return X$2(ea) ? ea.then((ra) => ({
      status: "valid",
      value: ra.status === "valid" ? ra.value : this._def.catchValue({
        get error() {
          return new S$1(Qi.common.issues);
        },
        input: Qi.data
      })
    })) : {
      status: "valid",
      value: ea.status === "valid" ? ea.value : this._def.catchValue({
        get error() {
          return new S$1(Qi.common.issues);
        },
        input: Qi.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
de$2.create = (Bi, e) => new de$2({
  innerType: Bi,
  typeName: g$3.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ..._(e)
});
let ve$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== f$7.nan) {
      const Zi = this._getOrReturnCtx(e);
      return u(Zi, {
        code: d$3.invalid_type,
        expected: f$7.nan,
        received: Zi.parsedType
      }), y$3;
    }
    return { status: "valid", value: e.data };
  }
};
ve$2.create = (Bi) => new ve$2({
  typeName: g$3.ZodNaN,
  ..._(Bi)
});
const mt$2 = Symbol("zod_brand");
let Ze$2 = class extends v {
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e), Qi = Zi.data;
    return this._def.type._parse({
      data: Qi,
      path: Zi.path,
      parent: Zi
    });
  }
  unwrap() {
    return this._def.type;
  }
}, ue$1 = class kf extends v {
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e);
    if (Qi.common.async)
      return (async () => {
        const ea = await this._def.in._parseAsync({
          data: Qi.data,
          path: Qi.path,
          parent: Qi
        });
        return ea.status === "aborted" ? y$3 : ea.status === "dirty" ? (Zi.dirty(), W$2(ea.value)) : this._def.out._parseAsync({
          data: ea.value,
          path: Qi.path,
          parent: Qi
        });
      })();
    {
      const ea = this._def.in._parseSync({
        data: Qi.data,
        path: Qi.path,
        parent: Qi
      });
      return ea.status === "aborted" ? y$3 : ea.status === "dirty" ? (Zi.dirty(), {
        status: "dirty",
        value: ea.value
      }) : this._def.out._parseSync({
        data: ea.value,
        path: Qi.path,
        parent: Qi
      });
    }
  }
  static create(e, Zi) {
    return new kf({
      in: e,
      out: Zi,
      typeName: g$3.ZodPipeline
    });
  }
}, le$1 = class extends v {
  _parse(e) {
    const Zi = this._def.innerType._parse(e), Qi = (ea) => (V$1(ea) && (ea.value = Object.freeze(ea.value)), ea);
    return X$2(Zi) ? Zi.then((ea) => Qi(ea)) : Qi(Zi);
  }
  unwrap() {
    return this._def.innerType;
  }
};
le$1.create = (Bi, e) => new le$1({
  innerType: Bi,
  typeName: g$3.ZodReadonly,
  ..._(e)
});
function je$2(Bi, e) {
  const Zi = typeof Bi == "function" ? Bi(e) : typeof Bi == "string" ? { message: Bi } : Bi;
  return typeof Zi == "string" ? { message: Zi } : Zi;
}
function $e$1(Bi, e = {}, Zi) {
  return Bi ? Y$2.create().superRefine((Qi, ea) => {
    var ra, na;
    const ia = Bi(Qi);
    if (ia instanceof Promise)
      return ia.then((fa) => {
        var La, Va;
        if (!fa) {
          const to = je$2(e, Qi), ro = (Va = (La = to.fatal) !== null && La !== void 0 ? La : Zi) !== null && Va !== void 0 ? Va : !0;
          ea.addIssue({ code: "custom", ...to, fatal: ro });
        }
      });
    if (!ia) {
      const fa = je$2(e, Qi), La = (na = (ra = fa.fatal) !== null && ra !== void 0 ? ra : Zi) !== null && na !== void 0 ? na : !0;
      ea.addIssue({ code: "custom", ...fa, fatal: La });
    }
  }) : Y$2.create();
}
const gt$2 = {
  object: x$2.lazycreate
};
var g$3;
(function(Bi) {
  Bi.ZodString = "ZodString", Bi.ZodNumber = "ZodNumber", Bi.ZodNaN = "ZodNaN", Bi.ZodBigInt = "ZodBigInt", Bi.ZodBoolean = "ZodBoolean", Bi.ZodDate = "ZodDate", Bi.ZodSymbol = "ZodSymbol", Bi.ZodUndefined = "ZodUndefined", Bi.ZodNull = "ZodNull", Bi.ZodAny = "ZodAny", Bi.ZodUnknown = "ZodUnknown", Bi.ZodNever = "ZodNever", Bi.ZodVoid = "ZodVoid", Bi.ZodArray = "ZodArray", Bi.ZodObject = "ZodObject", Bi.ZodUnion = "ZodUnion", Bi.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", Bi.ZodIntersection = "ZodIntersection", Bi.ZodTuple = "ZodTuple", Bi.ZodRecord = "ZodRecord", Bi.ZodMap = "ZodMap", Bi.ZodSet = "ZodSet", Bi.ZodFunction = "ZodFunction", Bi.ZodLazy = "ZodLazy", Bi.ZodLiteral = "ZodLiteral", Bi.ZodEnum = "ZodEnum", Bi.ZodEffects = "ZodEffects", Bi.ZodNativeEnum = "ZodNativeEnum", Bi.ZodOptional = "ZodOptional", Bi.ZodNullable = "ZodNullable", Bi.ZodDefault = "ZodDefault", Bi.ZodCatch = "ZodCatch", Bi.ZodPromise = "ZodPromise", Bi.ZodBranded = "ZodBranded", Bi.ZodPipeline = "ZodPipeline", Bi.ZodReadonly = "ZodReadonly";
})(g$3 || (g$3 = {}));
const yt$2 = (Bi, e = {
  message: `Input not instance of ${Bi.name}`
}) => $e$1((Zi) => Zi instanceof Bi, e), Le$2 = C$2.create, Ve$2 = M$2.create, _t$2 = ve$2.create, vt$2 = D$1.create, ze$2 = Q$2.create, bt$2 = z$1.create, xt$2 = ge$2.create, kt$1 = ee$2.create, wt$2 = te$2.create, Tt$1 = Y$2.create, St$2 = L$2.create, Ct$2 = I$2.create, Zt$2 = ye$2.create, Et$2 = Z$1.create, jt$2 = x$2.create, Ot$2 = x$2.strictCreate, Rt$2 = re$2.create, At$2 = be$2.create, Nt$2 = ne$1.create, It$2 = R$2.create, Mt$2 = se$2.create, Dt$2 = _e$1.create, Pt$2 = F$1.create, $t$2 = q$1.create, Lt$2 = ae$2.create, Vt$2 = ie$1.create, zt$2 = P$3.create, Ft$2 = oe$2.create, Ut$2 = G$2.create, Oe$2 = E$2.create, Bt$2 = j$1.create, Wt$2 = $$1.create, qt$2 = E$2.createWithPreprocess, Jt$1 = ue$1.create, Yt$2 = () => Le$2().optional(), Gt$2 = () => Ve$2().optional(), Ht$2 = () => ze$2().optional(), Kt$1 = {
  string: (Bi) => C$2.create({ ...Bi, coerce: !0 }),
  number: (Bi) => M$2.create({ ...Bi, coerce: !0 }),
  boolean: (Bi) => Q$2.create({
    ...Bi,
    coerce: !0
  }),
  bigint: (Bi) => D$1.create({ ...Bi, coerce: !0 }),
  date: (Bi) => z$1.create({ ...Bi, coerce: !0 })
}, Xt$2 = y$3;
var i$6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: J$1,
  setErrorMap: qe$2,
  getErrorMap: fe$2,
  makeIssue: pe$2,
  EMPTY_PATH: Je$2,
  addIssueToContext: u,
  ParseStatus: k,
  INVALID: y$3,
  DIRTY: W$2,
  OK: T$2,
  isAborted: Te$2,
  isDirty: Se$2,
  isValid: V$1,
  isAsync: X$2,
  get util() {
    return b$2;
  },
  get objectUtil() {
    return we;
  },
  ZodParsedType: f$7,
  getParsedType: N$1,
  ZodType: v,
  datetimeRegex: De$1,
  ZodString: C$2,
  ZodNumber: M$2,
  ZodBigInt: D$1,
  ZodBoolean: Q$2,
  ZodDate: z$1,
  ZodSymbol: ge$2,
  ZodUndefined: ee$2,
  ZodNull: te$2,
  ZodAny: Y$2,
  ZodUnknown: L$2,
  ZodNever: I$2,
  ZodVoid: ye$2,
  ZodArray: Z$1,
  ZodObject: x$2,
  ZodUnion: re$2,
  ZodDiscriminatedUnion: be$2,
  ZodIntersection: ne$1,
  ZodTuple: R$2,
  ZodRecord: se$2,
  ZodMap: _e$1,
  ZodSet: F$1,
  ZodFunction: q$1,
  ZodLazy: ae$2,
  ZodLiteral: ie$1,
  ZodEnum: P$3,
  ZodNativeEnum: oe$2,
  ZodPromise: G$2,
  ZodEffects: E$2,
  ZodTransformer: E$2,
  ZodOptional: j$1,
  ZodNullable: $$1,
  ZodDefault: ce$2,
  ZodCatch: de$2,
  ZodNaN: ve$2,
  BRAND: mt$2,
  ZodBranded: Ze$2,
  ZodPipeline: ue$1,
  ZodReadonly: le$1,
  custom: $e$1,
  Schema: v,
  ZodSchema: v,
  late: gt$2,
  get ZodFirstPartyTypeKind() {
    return g$3;
  },
  coerce: Kt$1,
  any: Tt$1,
  array: Et$2,
  bigint: vt$2,
  boolean: ze$2,
  date: bt$2,
  discriminatedUnion: At$2,
  effect: Oe$2,
  enum: zt$2,
  function: $t$2,
  instanceof: yt$2,
  intersection: Nt$2,
  lazy: Lt$2,
  literal: Vt$2,
  map: Dt$2,
  nan: _t$2,
  nativeEnum: Ft$2,
  never: Ct$2,
  null: wt$2,
  nullable: Wt$2,
  number: Ve$2,
  object: jt$2,
  oboolean: Ht$2,
  onumber: Gt$2,
  optional: Bt$2,
  ostring: Yt$2,
  pipeline: Jt$1,
  preprocess: qt$2,
  promise: Ut$2,
  record: Mt$2,
  set: Pt$2,
  strictObject: Ot$2,
  string: Le$2,
  symbol: xt$2,
  transformer: Oe$2,
  tuple: It$2,
  undefined: kt$1,
  union: Rt$2,
  unknown: St$2,
  void: Zt$2,
  NEVER: Xt$2,
  ZodIssueCode: d$3,
  quotelessJson: We$2,
  ZodError: S$1
});
const Qt$2 = i$6.object({
  _type: i$6.literal("string"),
  _validation: i$6.string().optional(),
  _value: i$6.string().optional(),
  _optional: i$6.boolean().optional()
}), er$2 = i$6.object({
  _type: i$6.literal("boolean"),
  _value: i$6.boolean().optional(),
  _optional: i$6.boolean().optional()
}), tr$2 = i$6.object({
  _type: i$6.literal("selection"),
  _options: i$6.array(i$6.string()),
  _optional: i$6.boolean().optional(),
  _value: i$6.string().optional()
}), Fe$2 = i$6.object({
  bucketId: i$6.number(),
  isFolder: i$6.boolean(),
  path: i$6.string()
}), rr$1 = i$6.nativeEnum(Re$2), U$2 = i$6.lazy(
  () => i$6.union([
    ar$2,
    nr$2,
    tr$2,
    Qt$2,
    sr$2,
    er$2
  ])
), nr$2 = i$6.object({
  _type: i$6.literal("path"),
  _value: i$6.union([i$6.array(Fe$2), i$6.array(i$6.string())]).optional(),
  // _value: z.array(s3PathSchema).optional(),
  _regexp: i$6.string().optional(),
  _optional: i$6.boolean().optional(),
  _pathType: rr$1
}), sr$2 = i$6.lazy(
  () => i$6.object({
    _type: i$6.literal("list"),
    _value: i$6.array(U$2).optional(),
    _optional: i$6.boolean().optional(),
    _schema: U$2
  })
), ar$2 = i$6.lazy(
  () => i$6.object({
    _type: i$6.literal("object"),
    _optional: i$6.boolean().optional(),
    _fields: i$6.record(U$2),
    _value: i$6.record(U$2).optional()
  })
);
i$6.record(
  i$6.coerce.number(),
  U$2
);
i$6.record(
  i$6.string(),
  U$2
);
const ir$2 = i$6.object({
  type: i$6.literal("pattern"),
  pattern: i$6.string()
}), or$2 = i$6.object({
  type: i$6.literal("value"),
  value: i$6.union([i$6.string(), i$6.number(), i$6.boolean(), i$6.array(Fe$2)])
}), cr$2 = i$6.object({
  type: i$6.literal("code"),
  codeBase64: i$6.string()
}), dr$2 = i$6.union([
  ir$2,
  or$2,
  cr$2
]);
U$2.and(
  i$6.object({
    _actionData: dr$2.optional()
  })
);
const Ue$2 = i$6.object({
  permissions: i$6.string(),
  links: i$6.string(),
  owner: i$6.string(),
  group: i$6.string(),
  size: i$6.string(),
  month: i$6.string(),
  date: i$6.string(),
  yearOrTime: i$6.string(),
  name: i$6.string(),
  fullPath: i$6.string()
}), lr$2 = i$6.array(Ue$2);
i$6.object({
  url: i$6.string()
});
i$6.object({
  socketId: i$6.string(),
  hasSavedSession: i$6.boolean().nullish()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  directory: i$6.string(),
  contents: lr$2
});
i$6.object({
  syncPwd: i$6.boolean()
});
i$6.object({
  defaultDirectory: i$6.string(),
  termState: i$6.string().nullish()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  query: i$6.string()
});
i$6.object({
  results: i$6.array(Ue$2),
  date: i$6.string(),
  query: i$6.string()
});
i$6.object({
  tinkerBoxId: i$6.number(),
  rows: i$6.number(),
  cols: i$6.number(),
  syncPwd: i$6.boolean().nullish()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  termState: i$6.string()
});
const ur$2 = i$6.object({
  name: i$6.string(),
  type: i$6.literal("select"),
  options: i$6.array(i$6.string()),
  optional: i$6.boolean().optional(),
  allowOther: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
}), hr$2 = i$6.object({
  name: i$6.string(),
  type: i$6.union([i$6.literal("text"), i$6.literal("textarea")]),
  optional: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
}), fr$2 = i$6.object({
  name: i$6.string(),
  type: i$6.literal("email"),
  optional: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
}), pr$2 = i$6.object({
  name: i$6.string(),
  type: i$6.literal("submit"),
  text: i$6.string().optional(),
  optional: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
});
i$6.array(
  i$6.object({
    name: i$6.string(),
    value: i$6.string()
  })
);
const mr$2 = i$6.union([
  ur$2,
  hr$2,
  fr$2,
  pr$2
]);
i$6.array(mr$2);
const gr$2 = i$6.object({
  id: i$6.number(),
  name: i$6.string(),
  labId: i$6.number(),
  status: i$6.string(),
  ipAddress: i$6.string().nullable(),
  lastLogin: i$6.date().nullable()
});
i$6.object({
  tinkerboxes: i$6.array(gr$2)
});
const yr$2 = i$6.object({
  key: i$6.string(),
  name: i$6.string(),
  isFolder: i$6.boolean(),
  bucket: i$6.string(),
  fullPath: i$6.string()
});
i$6.object({
  contents: i$6.array(yr$2)
});
i$6.object({
  buckets: i$6.array(
    i$6.object({
      id: i$6.number().int(),
      bucket: i$6.string(),
      region: i$6.string(),
      prefix: i$6.string().nullish()
    })
  )
});
var niceErrors = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(e, Zi) {
    return "Cannot apply '" + e + "' to '" + Zi.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(e, Zi) {
    return "[mobx.array] Index out of bounds, " + e + " is larger than " + Zi;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(e) {
    return "Cannot initialize from classes that inherit from Map: " + e.constructor.name;
  },
  20: function(e) {
    return "Cannot initialize map from " + e;
  },
  21: function(e) {
    return "Cannot convert to map from '" + e + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(e) {
    return "Cannot obtain administration from " + e;
  },
  25: function(e, Zi) {
    return "the entry '" + e + "' does not exist in the observable map '" + Zi + "'";
  },
  26: "please specify a property",
  27: function(e, Zi) {
    return "no observable property '" + e.toString() + "' found on the observable object '" + Zi + "'";
  },
  28: function(e) {
    return "Cannot obtain atom from " + e;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(e, Zi) {
    return "Cycle detected in computation " + e + ": " + Zi;
  },
  33: function(e) {
    return "The setter of computed value '" + e + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(e) {
    return "[ComputedValue '" + e + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(e) {
    return "[mobx] `observableArray." + e + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + e + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, errors = process.env.NODE_ENV !== "production" ? niceErrors : {};
function die(Bi) {
  for (var e = arguments.length, Zi = new Array(e > 1 ? e - 1 : 0), Qi = 1; Qi < e; Qi++)
    Zi[Qi - 1] = arguments[Qi];
  if (process.env.NODE_ENV !== "production") {
    var ea = typeof Bi == "string" ? Bi : errors[Bi];
    throw typeof ea == "function" && (ea = ea.apply(null, Zi)), new Error("[MobX] " + ea);
  }
  throw new Error(typeof Bi == "number" ? "[MobX] minified error nr: " + Bi + (Zi.length ? " " + Zi.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + Bi);
}
var mockGlobal = {};
function getGlobal() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : mockGlobal;
}
var assign = Object.assign, getDescriptor = Object.getOwnPropertyDescriptor, defineProperty = Object.defineProperty, objectPrototype = Object.prototype, EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy < "u", plainObjectString = /* @__PURE__ */ Object.toString();
function assertProxies() {
  hasProxy || die(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function warnAboutProxyRequirement(Bi) {
  process.env.NODE_ENV !== "production" && globalState.verifyProxies && die("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + Bi);
}
function getNextId() {
  return ++globalState.mobxGuid;
}
function once(Bi) {
  var e = !1;
  return function() {
    if (!e)
      return e = !0, Bi.apply(this, arguments);
  };
}
var noop$1 = function() {
};
function isFunction$1(Bi) {
  return typeof Bi == "function";
}
function isStringish(Bi) {
  var e = typeof Bi;
  switch (e) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function isObject$3(Bi) {
  return Bi !== null && typeof Bi == "object";
}
function isPlainObject$2(Bi) {
  if (!isObject$3(Bi))
    return !1;
  var e = Object.getPrototypeOf(Bi);
  if (e == null)
    return !0;
  var Zi = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
  return typeof Zi == "function" && Zi.toString() === plainObjectString;
}
function isGenerator(Bi) {
  var e = Bi?.constructor;
  return e ? e.name === "GeneratorFunction" || e.displayName === "GeneratorFunction" : !1;
}
function addHiddenProp(Bi, e, Zi) {
  defineProperty(Bi, e, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: Zi
  });
}
function addHiddenFinalProp(Bi, e, Zi) {
  defineProperty(Bi, e, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: Zi
  });
}
function createInstanceofPredicate(Bi, e) {
  var Zi = "isMobX" + Bi;
  return e.prototype[Zi] = !0, function(Qi) {
    return isObject$3(Qi) && Qi[Zi] === !0;
  };
}
function isES6Map(Bi) {
  return Bi instanceof Map;
}
function isES6Set(Bi) {
  return Bi instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols < "u";
function getPlainObjectKeys(Bi) {
  var e = Object.keys(Bi);
  if (!hasGetOwnPropertySymbols)
    return e;
  var Zi = Object.getOwnPropertySymbols(Bi);
  return Zi.length ? [].concat(e, Zi.filter(function(Qi) {
    return objectPrototype.propertyIsEnumerable.call(Bi, Qi);
  })) : e;
}
var ownKeys$2 = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(Bi) {
  return Object.getOwnPropertyNames(Bi).concat(Object.getOwnPropertySymbols(Bi));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function stringifyKey(Bi) {
  return typeof Bi == "string" ? Bi : typeof Bi == "symbol" ? Bi.toString() : new String(Bi).toString();
}
function toPrimitive(Bi) {
  return Bi === null ? null : typeof Bi == "object" ? "" + Bi : Bi;
}
function hasProp(Bi, e) {
  return objectPrototype.hasOwnProperty.call(Bi, e);
}
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function(e) {
  var Zi = {};
  return ownKeys$2(e).forEach(function(Qi) {
    Zi[Qi] = getDescriptor(e, Qi);
  }), Zi;
};
function _defineProperties(Bi, e) {
  for (var Zi = 0; Zi < e.length; Zi++) {
    var Qi = e[Zi];
    Qi.enumerable = Qi.enumerable || !1, Qi.configurable = !0, "value" in Qi && (Qi.writable = !0), Object.defineProperty(Bi, _toPropertyKey(Qi.key), Qi);
  }
}
function _createClass(Bi, e, Zi) {
  return e && _defineProperties(Bi.prototype, e), Object.defineProperty(Bi, "prototype", {
    writable: !1
  }), Bi;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(Bi) {
    for (var e = 1; e < arguments.length; e++) {
      var Zi = arguments[e];
      for (var Qi in Zi)
        Object.prototype.hasOwnProperty.call(Zi, Qi) && (Bi[Qi] = Zi[Qi]);
    }
    return Bi;
  }, _extends.apply(this, arguments);
}
function _inheritsLoose(Bi, e) {
  Bi.prototype = Object.create(e.prototype), Bi.prototype.constructor = Bi, _setPrototypeOf(Bi, e);
}
function _setPrototypeOf(Bi, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Qi, ea) {
    return Qi.__proto__ = ea, Qi;
  }, _setPrototypeOf(Bi, e);
}
function _assertThisInitialized(Bi) {
  if (Bi === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Bi;
}
function _unsupportedIterableToArray$2(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray$2(Bi, e);
    var Zi = Object.prototype.toString.call(Bi).slice(8, -1);
    if (Zi === "Object" && Bi.constructor && (Zi = Bi.constructor.name), Zi === "Map" || Zi === "Set") return Array.from(Bi);
    if (Zi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Zi)) return _arrayLikeToArray$2(Bi, e);
  }
}
function _arrayLikeToArray$2(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var Zi = 0, Qi = new Array(e); Zi < e; Zi++) Qi[Zi] = Bi[Zi];
  return Qi;
}
function _createForOfIteratorHelperLoose(Bi, e) {
  var Zi = typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (Zi) return (Zi = Zi.call(Bi)).next.bind(Zi);
  if (Array.isArray(Bi) || (Zi = _unsupportedIterableToArray$2(Bi)) || e) {
    Zi && (Bi = Zi);
    var Qi = 0;
    return function() {
      return Qi >= Bi.length ? {
        done: !0
      } : {
        done: !1,
        value: Bi[Qi++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toPrimitive(Bi, e) {
  if (typeof Bi != "object" || Bi === null) return Bi;
  var Zi = Bi[Symbol.toPrimitive];
  if (Zi !== void 0) {
    var Qi = Zi.call(Bi, e);
    if (typeof Qi != "object") return Qi;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(Bi);
}
function _toPropertyKey(Bi) {
  var e = _toPrimitive(Bi, "string");
  return typeof e == "symbol" ? e : String(e);
}
var storedAnnotationsSymbol = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function createDecoratorAnnotation(Bi) {
  function e(Zi, Qi) {
    if (is20223Decorator(Qi))
      return Bi.decorate_20223_(Zi, Qi);
    storeAnnotation(Zi, Qi, Bi);
  }
  return Object.assign(e, Bi);
}
function storeAnnotation(Bi, e, Zi) {
  if (hasProp(Bi, storedAnnotationsSymbol) || addHiddenProp(Bi, storedAnnotationsSymbol, _extends({}, Bi[storedAnnotationsSymbol])), process.env.NODE_ENV !== "production" && isOverride(Zi) && !hasProp(Bi[storedAnnotationsSymbol], e)) {
    var Qi = Bi.constructor.name + ".prototype." + e.toString();
    die("'" + Qi + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  assertNotDecorated(Bi, Zi, e), isOverride(Zi) || (Bi[storedAnnotationsSymbol][e] = Zi);
}
function assertNotDecorated(Bi, e, Zi) {
  if (process.env.NODE_ENV !== "production" && !isOverride(e) && hasProp(Bi[storedAnnotationsSymbol], Zi)) {
    var Qi = Bi.constructor.name + ".prototype." + Zi.toString(), ea = Bi[storedAnnotationsSymbol][Zi].annotationType_, ra = e.annotationType_;
    die("Cannot apply '@" + ra + "' to '" + Qi + "':" + (`
The field is already decorated with '@` + ea + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function collectStoredAnnotations(Bi) {
  return hasProp(Bi, storedAnnotationsSymbol) || addHiddenProp(Bi, storedAnnotationsSymbol, _extends({}, Bi[storedAnnotationsSymbol])), Bi[storedAnnotationsSymbol];
}
function is20223Decorator(Bi) {
  return typeof Bi == "object" && typeof Bi.kind == "string";
}
function assert20223DecoratorType(Bi, e) {
  process.env.NODE_ENV !== "production" && !e.includes(Bi.kind) && die("The decorator applied to '" + String(Bi.name) + "' cannot be used on a " + Bi.kind + " element");
}
var $mobx = /* @__PURE__ */ Symbol("mobx administration"), Atom = /* @__PURE__ */ function() {
  function Bi(Zi) {
    Zi === void 0 && (Zi = process.env.NODE_ENV !== "production" ? "Atom@" + getNextId() : "Atom"), this.name_ = void 0, this.isPendingUnobservation_ = !1, this.isBeingObserved_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = Zi;
  }
  var e = Bi.prototype;
  return e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(Qi) {
      return Qi();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(Qi) {
      return Qi();
    });
  }, e.reportObserved = function() {
    return reportObserved(this);
  }, e.reportChanged = function() {
    startBatch(), propagateChanged(this), endBatch();
  }, e.toString = function() {
    return this.name_;
  }, Bi;
}(), isAtom = /* @__PURE__ */ createInstanceofPredicate("Atom", Atom);
function createAtom(Bi, e, Zi) {
  e === void 0 && (e = noop$1), Zi === void 0 && (Zi = noop$1);
  var Qi = new Atom(Bi);
  return e !== noop$1 && onBecomeObserved(Qi, e), Zi !== noop$1 && onBecomeUnobserved(Qi, Zi), Qi;
}
function structuralComparer(Bi, e) {
  return deepEqual$1(Bi, e);
}
function defaultComparer(Bi, e) {
  return Object.is ? Object.is(Bi, e) : Bi === e ? Bi !== 0 || 1 / Bi === 1 / e : Bi !== Bi && e !== e;
}
var comparer = {
  structural: structuralComparer,
  default: defaultComparer
};
function deepEnhancer(Bi, e, Zi) {
  return isObservable(Bi) ? Bi : Array.isArray(Bi) ? observable.array(Bi, {
    name: Zi
  }) : isPlainObject$2(Bi) ? observable.object(Bi, void 0, {
    name: Zi
  }) : isES6Map(Bi) ? observable.map(Bi, {
    name: Zi
  }) : isES6Set(Bi) ? observable.set(Bi, {
    name: Zi
  }) : typeof Bi == "function" && !isAction(Bi) && !isFlow(Bi) ? isGenerator(Bi) ? flow(Bi) : autoAction(Zi, Bi) : Bi;
}
function shallowEnhancer(Bi, e, Zi) {
  if (Bi == null || isObservableObject(Bi) || isObservableArray(Bi) || isObservableMap(Bi) || isObservableSet(Bi))
    return Bi;
  if (Array.isArray(Bi))
    return observable.array(Bi, {
      name: Zi,
      deep: !1
    });
  if (isPlainObject$2(Bi))
    return observable.object(Bi, void 0, {
      name: Zi,
      deep: !1
    });
  if (isES6Map(Bi))
    return observable.map(Bi, {
      name: Zi,
      deep: !1
    });
  if (isES6Set(Bi))
    return observable.set(Bi, {
      name: Zi,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && die("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function referenceEnhancer(Bi) {
  return Bi;
}
function refStructEnhancer(Bi, e) {
  return process.env.NODE_ENV !== "production" && isObservable(Bi) && die("observable.struct should not be used with observable values"), deepEqual$1(Bi, e) ? e : Bi;
}
var OVERRIDE = "override";
function isOverride(Bi) {
  return Bi.annotationType_ === OVERRIDE;
}
function createActionAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$1,
    extend_: extend_$1,
    decorate_20223_: decorate_20223_$1
  };
}
function make_$1(Bi, e, Zi, Qi) {
  var ea;
  if ((ea = this.options_) != null && ea.bound)
    return this.extend_(Bi, e, Zi, !1) === null ? 0 : 1;
  if (Qi === Bi.target_)
    return this.extend_(Bi, e, Zi, !1) === null ? 0 : 2;
  if (isAction(Zi.value))
    return 1;
  var ra = createActionDescriptor(Bi, this, e, Zi, !1);
  return defineProperty(Qi, e, ra), 2;
}
function extend_$1(Bi, e, Zi, Qi) {
  var ea = createActionDescriptor(Bi, this, e, Zi);
  return Bi.defineProperty_(e, ea, Qi);
}
function decorate_20223_$1(Bi, e) {
  process.env.NODE_ENV !== "production" && assert20223DecoratorType(e, ["method", "field"]);
  var Zi = e.kind, Qi = e.name, ea = e.addInitializer, ra = this, na = function(La) {
    var Va, to, ro, no;
    return createAction((Va = (to = ra.options_) == null ? void 0 : to.name) != null ? Va : Qi.toString(), La, (ro = (no = ra.options_) == null ? void 0 : no.autoAction) != null ? ro : !1);
  };
  if (Zi == "field") {
    ea(function() {
      storeAnnotation(this, Qi, ra);
    });
    return;
  }
  if (Zi == "method") {
    var ia;
    return isAction(Bi) || (Bi = na(Bi)), (ia = this.options_) != null && ia.bound && ea(function() {
      var fa = this, La = fa[Qi].bind(fa);
      La.isMobxAction = !0, fa[Qi] = La;
    }), Bi;
  }
  die("Cannot apply '" + ra.annotationType_ + "' to '" + String(Qi) + "' (kind: " + Zi + "):" + (`
'` + ra.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(Bi, e, Zi, Qi) {
  var ea = e.annotationType_, ra = Qi.value;
  process.env.NODE_ENV !== "production" && !isFunction$1(ra) && die("Cannot apply '" + ea + "' to '" + Bi.name_ + "." + Zi.toString() + "':" + (`
'` + ea + "' can only be used on properties with a function value."));
}
function createActionDescriptor(Bi, e, Zi, Qi, ea) {
  var ra, na, ia, fa, La, Va, to;
  ea === void 0 && (ea = globalState.safeDescriptors), assertActionDescriptor(Bi, e, Zi, Qi);
  var ro = Qi.value;
  if ((ra = e.options_) != null && ra.bound) {
    var no;
    ro = ro.bind((no = Bi.proxy_) != null ? no : Bi.target_);
  }
  return {
    value: createAction(
      (na = (ia = e.options_) == null ? void 0 : ia.name) != null ? na : Zi.toString(),
      ro,
      (fa = (La = e.options_) == null ? void 0 : La.autoAction) != null ? fa : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (Va = e.options_) != null && Va.bound ? (to = Bi.proxy_) != null ? to : Bi.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: ea ? Bi.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !ea
  };
}
function createFlowAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$2,
    extend_: extend_$2,
    decorate_20223_: decorate_20223_$2
  };
}
function make_$2(Bi, e, Zi, Qi) {
  var ea;
  if (Qi === Bi.target_)
    return this.extend_(Bi, e, Zi, !1) === null ? 0 : 2;
  if ((ea = this.options_) != null && ea.bound && (!hasProp(Bi.target_, e) || !isFlow(Bi.target_[e])) && this.extend_(Bi, e, Zi, !1) === null)
    return 0;
  if (isFlow(Zi.value))
    return 1;
  var ra = createFlowDescriptor(Bi, this, e, Zi, !1, !1);
  return defineProperty(Qi, e, ra), 2;
}
function extend_$2(Bi, e, Zi, Qi) {
  var ea, ra = createFlowDescriptor(Bi, this, e, Zi, (ea = this.options_) == null ? void 0 : ea.bound);
  return Bi.defineProperty_(e, ra, Qi);
}
function decorate_20223_$2(Bi, e) {
  var Zi;
  process.env.NODE_ENV !== "production" && assert20223DecoratorType(e, ["method"]);
  var Qi = e.name, ea = e.addInitializer;
  return isFlow(Bi) || (Bi = flow(Bi)), (Zi = this.options_) != null && Zi.bound && ea(function() {
    var ra = this, na = ra[Qi].bind(ra);
    na.isMobXFlow = !0, ra[Qi] = na;
  }), Bi;
}
function assertFlowDescriptor(Bi, e, Zi, Qi) {
  var ea = e.annotationType_, ra = Qi.value;
  process.env.NODE_ENV !== "production" && !isFunction$1(ra) && die("Cannot apply '" + ea + "' to '" + Bi.name_ + "." + Zi.toString() + "':" + (`
'` + ea + "' can only be used on properties with a generator function value."));
}
function createFlowDescriptor(Bi, e, Zi, Qi, ea, ra) {
  ra === void 0 && (ra = globalState.safeDescriptors), assertFlowDescriptor(Bi, e, Zi, Qi);
  var na = Qi.value;
  if (isFlow(na) || (na = flow(na)), ea) {
    var ia;
    na = na.bind((ia = Bi.proxy_) != null ? ia : Bi.target_), na.isMobXFlow = !0;
  }
  return {
    value: na,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: ra ? Bi.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !ra
  };
}
function createComputedAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$3,
    extend_: extend_$3,
    decorate_20223_: decorate_20223_$3
  };
}
function make_$3(Bi, e, Zi) {
  return this.extend_(Bi, e, Zi, !1) === null ? 0 : 1;
}
function extend_$3(Bi, e, Zi, Qi) {
  return assertComputedDescriptor(Bi, this, e, Zi), Bi.defineComputedProperty_(e, _extends({}, this.options_, {
    get: Zi.get,
    set: Zi.set
  }), Qi);
}
function decorate_20223_$3(Bi, e) {
  process.env.NODE_ENV !== "production" && assert20223DecoratorType(e, ["getter"]);
  var Zi = this, Qi = e.name, ea = e.addInitializer;
  return ea(function() {
    var ra = asObservableObject(this)[$mobx], na = _extends({}, Zi.options_, {
      get: Bi,
      context: this
    });
    na.name || (na.name = process.env.NODE_ENV !== "production" ? ra.name_ + "." + Qi.toString() : "ObservableObject." + Qi.toString()), ra.values_.set(Qi, new ComputedValue(na));
  }), function() {
    return this[$mobx].getObservablePropValue_(Qi);
  };
}
function assertComputedDescriptor(Bi, e, Zi, Qi) {
  var ea = e.annotationType_, ra = Qi.get;
  process.env.NODE_ENV !== "production" && !ra && die("Cannot apply '" + ea + "' to '" + Bi.name_ + "." + Zi.toString() + "':" + (`
'` + ea + "' can only be used on getter(+setter) properties."));
}
function createObservableAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$4,
    extend_: extend_$4,
    decorate_20223_: decorate_20223_$4
  };
}
function make_$4(Bi, e, Zi) {
  return this.extend_(Bi, e, Zi, !1) === null ? 0 : 1;
}
function extend_$4(Bi, e, Zi, Qi) {
  var ea, ra;
  return assertObservableDescriptor(Bi, this, e, Zi), Bi.defineObservableProperty_(e, Zi.value, (ea = (ra = this.options_) == null ? void 0 : ra.enhancer) != null ? ea : deepEnhancer, Qi);
}
function decorate_20223_$4(Bi, e) {
  if (process.env.NODE_ENV !== "production") {
    if (e.kind === "field")
      throw die("Please use `@observable accessor " + String(e.name) + "` instead of `@observable " + String(e.name) + "`");
    assert20223DecoratorType(e, ["accessor"]);
  }
  var Zi = this, Qi = e.kind, ea = e.name, ra = /* @__PURE__ */ new WeakSet();
  function na(ia, fa) {
    var La, Va, to = asObservableObject(ia)[$mobx], ro = new ObservableValue(fa, (La = (Va = Zi.options_) == null ? void 0 : Va.enhancer) != null ? La : deepEnhancer, process.env.NODE_ENV !== "production" ? to.name_ + "." + ea.toString() : "ObservableObject." + ea.toString(), !1);
    to.values_.set(ea, ro), ra.add(ia);
  }
  if (Qi == "accessor")
    return {
      get: function() {
        return ra.has(this) || na(this, Bi.get.call(this)), this[$mobx].getObservablePropValue_(ea);
      },
      set: function(fa) {
        return ra.has(this) || na(this, fa), this[$mobx].setObservablePropValue_(ea, fa);
      },
      init: function(fa) {
        return ra.has(this) || na(this, fa), fa;
      }
    };
}
function assertObservableDescriptor(Bi, e, Zi, Qi) {
  var ea = e.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in Qi) && die("Cannot apply '" + ea + "' to '" + Bi.name_ + "." + Zi.toString() + "':" + (`
'` + ea + "' cannot be used on getter/setter properties"));
}
var AUTO = "true", autoAnnotation = /* @__PURE__ */ createAutoAnnotation();
function createAutoAnnotation(Bi) {
  return {
    annotationType_: AUTO,
    options_: Bi,
    make_: make_$5,
    extend_: extend_$5,
    decorate_20223_: decorate_20223_$5
  };
}
function make_$5(Bi, e, Zi, Qi) {
  var ea, ra;
  if (Zi.get)
    return computed.make_(Bi, e, Zi, Qi);
  if (Zi.set) {
    var na = createAction(e.toString(), Zi.set);
    return Qi === Bi.target_ ? Bi.defineProperty_(e, {
      configurable: globalState.safeDescriptors ? Bi.isPlainObject_ : !0,
      set: na
    }) === null ? 0 : 2 : (defineProperty(Qi, e, {
      configurable: !0,
      set: na
    }), 2);
  }
  if (Qi !== Bi.target_ && typeof Zi.value == "function") {
    var ia;
    if (isGenerator(Zi.value)) {
      var fa, La = (fa = this.options_) != null && fa.autoBind ? flow.bound : flow;
      return La.make_(Bi, e, Zi, Qi);
    }
    var Va = (ia = this.options_) != null && ia.autoBind ? autoAction.bound : autoAction;
    return Va.make_(Bi, e, Zi, Qi);
  }
  var to = ((ea = this.options_) == null ? void 0 : ea.deep) === !1 ? observable.ref : observable;
  if (typeof Zi.value == "function" && (ra = this.options_) != null && ra.autoBind) {
    var ro;
    Zi.value = Zi.value.bind((ro = Bi.proxy_) != null ? ro : Bi.target_);
  }
  return to.make_(Bi, e, Zi, Qi);
}
function extend_$5(Bi, e, Zi, Qi) {
  var ea, ra;
  if (Zi.get)
    return computed.extend_(Bi, e, Zi, Qi);
  if (Zi.set)
    return Bi.defineProperty_(e, {
      configurable: globalState.safeDescriptors ? Bi.isPlainObject_ : !0,
      set: createAction(e.toString(), Zi.set)
    }, Qi);
  if (typeof Zi.value == "function" && (ea = this.options_) != null && ea.autoBind) {
    var na;
    Zi.value = Zi.value.bind((na = Bi.proxy_) != null ? na : Bi.target_);
  }
  var ia = ((ra = this.options_) == null ? void 0 : ra.deep) === !1 ? observable.ref : observable;
  return ia.extend_(Bi, e, Zi, Qi);
}
function decorate_20223_$5(Bi, e) {
  die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable", OBSERVABLE_REF = "observable.ref", OBSERVABLE_SHALLOW = "observable.shallow", OBSERVABLE_STRUCT = "observable.struct", defaultCreateObservableOptions = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(Bi) {
  return Bi || defaultCreateObservableOptions;
}
var observableAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE), observableRefAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_REF, {
  enhancer: referenceEnhancer
}), observableShallowAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_SHALLOW, {
  enhancer: shallowEnhancer
}), observableStructAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_STRUCT, {
  enhancer: refStructEnhancer
}), observableDecoratorAnnotation = /* @__PURE__ */ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(Bi) {
  return Bi.deep === !0 ? deepEnhancer : Bi.deep === !1 ? referenceEnhancer : getEnhancerFromAnnotation(Bi.defaultDecorator);
}
function getAnnotationFromOptions(Bi) {
  var e;
  return Bi ? (e = Bi.defaultDecorator) != null ? e : createAutoAnnotation(Bi) : void 0;
}
function getEnhancerFromAnnotation(Bi) {
  var e, Zi;
  return Bi && (e = (Zi = Bi.options_) == null ? void 0 : Zi.enhancer) != null ? e : deepEnhancer;
}
function createObservable(Bi, e, Zi) {
  if (is20223Decorator(e))
    return observableAnnotation.decorate_20223_(Bi, e);
  if (isStringish(e)) {
    storeAnnotation(Bi, e, observableAnnotation);
    return;
  }
  return isObservable(Bi) ? Bi : isPlainObject$2(Bi) ? observable.object(Bi, e, Zi) : Array.isArray(Bi) ? observable.array(Bi, e) : isES6Map(Bi) ? observable.map(Bi, e) : isES6Set(Bi) ? observable.set(Bi, e) : typeof Bi == "object" && Bi !== null ? Bi : observable.box(Bi, e);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
  box: function(e, Zi) {
    var Qi = asCreateObservableOptions(Zi);
    return new ObservableValue(e, getEnhancerFromOptions(Qi), Qi.name, !0, Qi.equals);
  },
  array: function(e, Zi) {
    var Qi = asCreateObservableOptions(Zi);
    return (globalState.useProxies === !1 || Qi.proxy === !1 ? createLegacyArray : createObservableArray)(e, getEnhancerFromOptions(Qi), Qi.name);
  },
  map: function(e, Zi) {
    var Qi = asCreateObservableOptions(Zi);
    return new ObservableMap(e, getEnhancerFromOptions(Qi), Qi.name);
  },
  set: function(e, Zi) {
    var Qi = asCreateObservableOptions(Zi);
    return new ObservableSet(e, getEnhancerFromOptions(Qi), Qi.name);
  },
  object: function(e, Zi, Qi) {
    return initObservable(function() {
      return extendObservable(globalState.useProxies === !1 || Qi?.proxy === !1 ? asObservableObject({}, Qi) : asDynamicObservableObject({}, Qi), e, Zi);
    });
  },
  ref: /* @__PURE__ */ createDecoratorAnnotation(observableRefAnnotation),
  shallow: /* @__PURE__ */ createDecoratorAnnotation(observableShallowAnnotation),
  deep: observableDecoratorAnnotation,
  struct: /* @__PURE__ */ createDecoratorAnnotation(observableStructAnnotation)
}, observable = /* @__PURE__ */ assign(createObservable, observableFactories), COMPUTED = "computed", COMPUTED_STRUCT = "computed.struct", computedAnnotation = /* @__PURE__ */ createComputedAnnotation(COMPUTED), computedStructAnnotation = /* @__PURE__ */ createComputedAnnotation(COMPUTED_STRUCT, {
  equals: comparer.structural
}), computed = function(e, Zi) {
  if (is20223Decorator(Zi))
    return computedAnnotation.decorate_20223_(e, Zi);
  if (isStringish(Zi))
    return storeAnnotation(e, Zi, computedAnnotation);
  if (isPlainObject$2(e))
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, e));
  process.env.NODE_ENV !== "production" && (isFunction$1(e) || die("First argument to `computed` should be an expression."), isFunction$1(Zi) && die("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var Qi = isPlainObject$2(Zi) ? Zi : {};
  return Qi.get = e, Qi.name || (Qi.name = e.name || ""), new ComputedValue(Qi);
};
Object.assign(computed, computedAnnotation);
computed.struct = /* @__PURE__ */ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor, currentActionId = 0, nextActionId = 1, isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /* @__PURE__ */ getDescriptor(function() {
}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : !1, tmpNameDescriptor = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function createAction(Bi, e, Zi, Qi) {
  Zi === void 0 && (Zi = !1), process.env.NODE_ENV !== "production" && (isFunction$1(e) || die("`action` can only be invoked on functions"), (typeof Bi != "string" || !Bi) && die("actions should have valid names, got: '" + Bi + "'"));
  function ea() {
    return executeAction(Bi, Zi, e, Qi || this, arguments);
  }
  return ea.isMobxAction = !0, ea.toString = function() {
    return e.toString();
  }, isFunctionNameConfigurable && (tmpNameDescriptor.value = Bi, defineProperty(ea, "name", tmpNameDescriptor)), ea;
}
function executeAction(Bi, e, Zi, Qi, ea) {
  var ra = _startAction(Bi, e, Qi, ea);
  try {
    return Zi.apply(Qi, ea);
  } catch (na) {
    throw ra.error_ = na, na;
  } finally {
    _endAction(ra);
  }
}
function _startAction(Bi, e, Zi, Qi) {
  var ea = process.env.NODE_ENV !== "production" && isSpyEnabled() && !!Bi, ra = 0;
  if (process.env.NODE_ENV !== "production" && ea) {
    ra = Date.now();
    var na = Qi ? Array.from(Qi) : EMPTY_ARRAY;
    spyReportStart({
      type: ACTION,
      name: Bi,
      object: Zi,
      arguments: na
    });
  }
  var ia = globalState.trackingDerivation, fa = !e || !ia;
  startBatch();
  var La = globalState.allowStateChanges;
  fa && (untrackedStart(), La = allowStateChangesStart(!0));
  var Va = allowStateReadsStart(!0), to = {
    runAsAction_: fa,
    prevDerivation_: ia,
    prevAllowStateChanges_: La,
    prevAllowStateReads_: Va,
    notifySpy_: ea,
    startTime_: ra,
    actionId_: nextActionId++,
    parentActionId_: currentActionId
  };
  return currentActionId = to.actionId_, to;
}
function _endAction(Bi) {
  currentActionId !== Bi.actionId_ && die(30), currentActionId = Bi.parentActionId_, Bi.error_ !== void 0 && (globalState.suppressReactionErrors = !0), allowStateChangesEnd(Bi.prevAllowStateChanges_), allowStateReadsEnd(Bi.prevAllowStateReads_), endBatch(), Bi.runAsAction_ && untrackedEnd(Bi.prevDerivation_), process.env.NODE_ENV !== "production" && Bi.notifySpy_ && spyReportEnd({
    time: Date.now() - Bi.startTime_
  }), globalState.suppressReactionErrors = !1;
}
function allowStateChanges(Bi, e) {
  var Zi = allowStateChangesStart(Bi);
  try {
    return e();
  } finally {
    allowStateChangesEnd(Zi);
  }
}
function allowStateChangesStart(Bi) {
  var e = globalState.allowStateChanges;
  return globalState.allowStateChanges = Bi, e;
}
function allowStateChangesEnd(Bi) {
  globalState.allowStateChanges = Bi;
}
var _Symbol$toPrimitive, CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /* @__PURE__ */ function(Bi) {
  _inheritsLoose(e, Bi);
  function e(Qi, ea, ra, na, ia) {
    var fa;
    return ra === void 0 && (ra = process.env.NODE_ENV !== "production" ? "ObservableValue@" + getNextId() : "ObservableValue"), na === void 0 && (na = !0), ia === void 0 && (ia = comparer.default), fa = Bi.call(this, ra) || this, fa.enhancer = void 0, fa.name_ = void 0, fa.equals = void 0, fa.hasUnreportedChange_ = !1, fa.interceptors_ = void 0, fa.changeListeners_ = void 0, fa.value_ = void 0, fa.dehancer = void 0, fa.enhancer = ea, fa.name_ = ra, fa.equals = ia, fa.value_ = ea(Qi, void 0, ra), process.env.NODE_ENV !== "production" && na && isSpyEnabled() && spyReport({
      type: CREATE,
      object: _assertThisInitialized(fa),
      observableKind: "value",
      debugObjectName: fa.name_,
      newValue: "" + fa.value_
    }), fa;
  }
  var Zi = e.prototype;
  return Zi.dehanceValue = function(ea) {
    return this.dehancer !== void 0 ? this.dehancer(ea) : ea;
  }, Zi.set = function(ea) {
    var ra = this.value_;
    if (ea = this.prepareNewValue_(ea), ea !== globalState.UNCHANGED) {
      var na = isSpyEnabled();
      process.env.NODE_ENV !== "production" && na && spyReportStart({
        type: UPDATE,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: ea,
        oldValue: ra
      }), this.setNewValue_(ea), process.env.NODE_ENV !== "production" && na && spyReportEnd();
    }
  }, Zi.prepareNewValue_ = function(ea) {
    if (checkIfStateModificationsAreAllowed(this), hasInterceptors(this)) {
      var ra = interceptChange(this, {
        object: this,
        type: UPDATE,
        newValue: ea
      });
      if (!ra)
        return globalState.UNCHANGED;
      ea = ra.newValue;
    }
    return ea = this.enhancer(ea, this.value_, this.name_), this.equals(this.value_, ea) ? globalState.UNCHANGED : ea;
  }, Zi.setNewValue_ = function(ea) {
    var ra = this.value_;
    this.value_ = ea, this.reportChanged(), hasListeners(this) && notifyListeners(this, {
      type: UPDATE,
      object: this,
      newValue: ea,
      oldValue: ra
    });
  }, Zi.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, Zi.intercept_ = function(ea) {
    return registerInterceptor(this, ea);
  }, Zi.observe_ = function(ea, ra) {
    return ra && ea({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: UPDATE,
      newValue: this.value_,
      oldValue: void 0
    }), registerListener(this, ea);
  }, Zi.raw = function() {
    return this.value_;
  }, Zi.toJSON = function() {
    return this.get();
  }, Zi.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, Zi.valueOf = function() {
    return toPrimitive(this.get());
  }, Zi[_Symbol$toPrimitive] = function() {
    return this.valueOf();
  }, e;
}(Atom), _Symbol$toPrimitive$1;
_Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /* @__PURE__ */ function() {
  function Bi(Zi) {
    this.dependenciesState_ = IDerivationState_.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.isBeingObserved_ = !1, this.isPendingUnobservation_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new CaughtException(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.isComputing_ = !1, this.isRunningSetter_ = !1, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = TraceMode.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, Zi.get || die(31), this.derivation = Zi.get, this.name_ = Zi.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + getNextId() : "ComputedValue"), Zi.set && (this.setter_ = createAction(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", Zi.set)), this.equals_ = Zi.equals || (Zi.compareStructural || Zi.struct ? comparer.structural : comparer.default), this.scope_ = Zi.context, this.requiresReaction_ = Zi.requiresReaction, this.keepAlive_ = !!Zi.keepAlive;
  }
  var e = Bi.prototype;
  return e.onBecomeStale_ = function() {
    propagateMaybeChanged(this);
  }, e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(Qi) {
      return Qi();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(Qi) {
      return Qi();
    });
  }, e.get = function() {
    if (this.isComputing_ && die(32, this.name_, this.derivation), globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      shouldCompute(this) && (this.warnAboutUntrackedRead_(), startBatch(), this.value_ = this.computeValue_(!1), endBatch());
    else if (reportObserved(this), shouldCompute(this)) {
      var Qi = globalState.trackingContext;
      this.keepAlive_ && !Qi && (globalState.trackingContext = this), this.trackAndCompute() && propagateChangeConfirmed(this), globalState.trackingContext = Qi;
    }
    var ea = this.value_;
    if (isCaughtException(ea))
      throw ea.cause;
    return ea;
  }, e.set = function(Qi) {
    if (this.setter_) {
      this.isRunningSetter_ && die(33, this.name_), this.isRunningSetter_ = !0;
      try {
        this.setter_.call(this.scope_, Qi);
      } finally {
        this.isRunningSetter_ = !1;
      }
    } else
      die(34, this.name_);
  }, e.trackAndCompute = function() {
    var Qi = this.value_, ea = (
      /* see #1208 */
      this.dependenciesState_ === IDerivationState_.NOT_TRACKING_
    ), ra = this.computeValue_(!0), na = ea || isCaughtException(Qi) || isCaughtException(ra) || !this.equals_(Qi, ra);
    return na && (this.value_ = ra, process.env.NODE_ENV !== "production" && isSpyEnabled() && spyReport({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: Qi,
      newValue: ra
    })), na;
  }, e.computeValue_ = function(Qi) {
    this.isComputing_ = !0;
    var ea = allowStateChangesStart(!1), ra;
    if (Qi)
      ra = trackDerivedFunction(this, this.derivation, this.scope_);
    else if (globalState.disableErrorBoundaries === !0)
      ra = this.derivation.call(this.scope_);
    else
      try {
        ra = this.derivation.call(this.scope_);
      } catch (na) {
        ra = new CaughtException(na);
      }
    return allowStateChangesEnd(ea), this.isComputing_ = !1, ra;
  }, e.suspend_ = function() {
    this.keepAlive_ || (clearObserving(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== TraceMode.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, e.observe_ = function(Qi, ea) {
    var ra = this, na = !0, ia = void 0;
    return autorun(function() {
      var fa = ra.get();
      if (!na || ea) {
        var La = untrackedStart();
        Qi({
          observableKind: "computed",
          debugObjectName: ra.name_,
          type: UPDATE,
          object: ra,
          newValue: fa,
          oldValue: ia
        }), untrackedEnd(La);
      }
      na = !1, ia = fa;
    });
  }, e.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== TraceMode.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : globalState.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, e.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, e.valueOf = function() {
    return toPrimitive(this.get());
  }, e[_Symbol$toPrimitive$1] = function() {
    return this.valueOf();
  }, Bi;
}(), isComputedValue = /* @__PURE__ */ createInstanceofPredicate("ComputedValue", ComputedValue), IDerivationState_;
(function(Bi) {
  Bi[Bi.NOT_TRACKING_ = -1] = "NOT_TRACKING_", Bi[Bi.UP_TO_DATE_ = 0] = "UP_TO_DATE_", Bi[Bi.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", Bi[Bi.STALE_ = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(Bi) {
  Bi[Bi.NONE = 0] = "NONE", Bi[Bi.LOG = 1] = "LOG", Bi[Bi.BREAK = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function(e) {
  this.cause = void 0, this.cause = e;
};
function isCaughtException(Bi) {
  return Bi instanceof CaughtException;
}
function shouldCompute(Bi) {
  switch (Bi.dependenciesState_) {
    case IDerivationState_.UP_TO_DATE_:
      return !1;
    case IDerivationState_.NOT_TRACKING_:
    case IDerivationState_.STALE_:
      return !0;
    case IDerivationState_.POSSIBLY_STALE_: {
      for (var e = allowStateReadsStart(!0), Zi = untrackedStart(), Qi = Bi.observing_, ea = Qi.length, ra = 0; ra < ea; ra++) {
        var na = Qi[ra];
        if (isComputedValue(na)) {
          if (globalState.disableErrorBoundaries)
            na.get();
          else
            try {
              na.get();
            } catch {
              return untrackedEnd(Zi), allowStateReadsEnd(e), !0;
            }
          if (Bi.dependenciesState_ === IDerivationState_.STALE_)
            return untrackedEnd(Zi), allowStateReadsEnd(e), !0;
        }
      }
      return changeDependenciesStateTo0(Bi), untrackedEnd(Zi), allowStateReadsEnd(e), !1;
    }
  }
}
function checkIfStateModificationsAreAllowed(Bi) {
  if (process.env.NODE_ENV !== "production") {
    var e = Bi.observers_.size > 0;
    !globalState.allowStateChanges && (e || globalState.enforceActions === "always") && console.warn("[MobX] " + (globalState.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + Bi.name_);
  }
}
function checkIfStateReadsAreAllowed(Bi) {
  process.env.NODE_ENV !== "production" && !globalState.allowStateReads && globalState.observableRequiresReaction && console.warn("[mobx] Observable '" + Bi.name_ + "' being read outside a reactive context.");
}
function trackDerivedFunction(Bi, e, Zi) {
  var Qi = allowStateReadsStart(!0);
  changeDependenciesStateTo0(Bi), Bi.newObserving_ = new Array(Bi.observing_.length + 100), Bi.unboundDepsCount_ = 0, Bi.runId_ = ++globalState.runId;
  var ea = globalState.trackingDerivation;
  globalState.trackingDerivation = Bi, globalState.inBatch++;
  var ra;
  if (globalState.disableErrorBoundaries === !0)
    ra = e.call(Zi);
  else
    try {
      ra = e.call(Zi);
    } catch (na) {
      ra = new CaughtException(na);
    }
  return globalState.inBatch--, globalState.trackingDerivation = ea, bindDependencies(Bi), warnAboutDerivationWithoutDependencies(Bi), allowStateReadsEnd(Qi), ra;
}
function warnAboutDerivationWithoutDependencies(Bi) {
  process.env.NODE_ENV !== "production" && Bi.observing_.length === 0 && (typeof Bi.requiresObservable_ == "boolean" ? Bi.requiresObservable_ : globalState.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + Bi.name_ + "' is created/updated without reading any observable value.");
}
function bindDependencies(Bi) {
  for (var e = Bi.observing_, Zi = Bi.observing_ = Bi.newObserving_, Qi = IDerivationState_.UP_TO_DATE_, ea = 0, ra = Bi.unboundDepsCount_, na = 0; na < ra; na++) {
    var ia = Zi[na];
    ia.diffValue_ === 0 && (ia.diffValue_ = 1, ea !== na && (Zi[ea] = ia), ea++), ia.dependenciesState_ > Qi && (Qi = ia.dependenciesState_);
  }
  for (Zi.length = ea, Bi.newObserving_ = null, ra = e.length; ra--; ) {
    var fa = e[ra];
    fa.diffValue_ === 0 && removeObserver(fa, Bi), fa.diffValue_ = 0;
  }
  for (; ea--; ) {
    var La = Zi[ea];
    La.diffValue_ === 1 && (La.diffValue_ = 0, addObserver(La, Bi));
  }
  Qi !== IDerivationState_.UP_TO_DATE_ && (Bi.dependenciesState_ = Qi, Bi.onBecomeStale_());
}
function clearObserving(Bi) {
  var e = Bi.observing_;
  Bi.observing_ = [];
  for (var Zi = e.length; Zi--; )
    removeObserver(e[Zi], Bi);
  Bi.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(Bi) {
  var e = untrackedStart();
  try {
    return Bi();
  } finally {
    untrackedEnd(e);
  }
}
function untrackedStart() {
  var Bi = globalState.trackingDerivation;
  return globalState.trackingDerivation = null, Bi;
}
function untrackedEnd(Bi) {
  globalState.trackingDerivation = Bi;
}
function allowStateReadsStart(Bi) {
  var e = globalState.allowStateReads;
  return globalState.allowStateReads = Bi, e;
}
function allowStateReadsEnd(Bi) {
  globalState.allowStateReads = Bi;
}
function changeDependenciesStateTo0(Bi) {
  if (Bi.dependenciesState_ !== IDerivationState_.UP_TO_DATE_) {
    Bi.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    for (var e = Bi.observing_, Zi = e.length; Zi--; )
      e[Zi].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
  }
}
var MobXGlobals = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, canMergeGlobalState = !0, isolateCalled = !1, globalState = /* @__PURE__ */ function() {
  var Bi = /* @__PURE__ */ getGlobal();
  return Bi.__mobxInstanceCount > 0 && !Bi.__mobxGlobals && (canMergeGlobalState = !1), Bi.__mobxGlobals && Bi.__mobxGlobals.version !== new MobXGlobals().version && (canMergeGlobalState = !1), canMergeGlobalState ? Bi.__mobxGlobals ? (Bi.__mobxInstanceCount += 1, Bi.__mobxGlobals.UNCHANGED || (Bi.__mobxGlobals.UNCHANGED = {}), Bi.__mobxGlobals) : (Bi.__mobxInstanceCount = 1, Bi.__mobxGlobals = /* @__PURE__ */ new MobXGlobals()) : (setTimeout(function() {
    isolateCalled || die(35);
  }, 1), new MobXGlobals());
}();
function isolateGlobalState() {
  if ((globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) && die(36), isolateCalled = !0, canMergeGlobalState) {
    var Bi = getGlobal();
    --Bi.__mobxInstanceCount === 0 && (Bi.__mobxGlobals = void 0), globalState = new MobXGlobals();
  }
}
function getGlobalState() {
  return globalState;
}
function addObserver(Bi, e) {
  Bi.observers_.add(e), Bi.lowestObserverState_ > e.dependenciesState_ && (Bi.lowestObserverState_ = e.dependenciesState_);
}
function removeObserver(Bi, e) {
  Bi.observers_.delete(e), Bi.observers_.size === 0 && queueForUnobservation(Bi);
}
function queueForUnobservation(Bi) {
  Bi.isPendingUnobservation_ === !1 && (Bi.isPendingUnobservation_ = !0, globalState.pendingUnobservations.push(Bi));
}
function startBatch() {
  globalState.inBatch++;
}
function endBatch() {
  if (--globalState.inBatch === 0) {
    runReactions();
    for (var Bi = globalState.pendingUnobservations, e = 0; e < Bi.length; e++) {
      var Zi = Bi[e];
      Zi.isPendingUnobservation_ = !1, Zi.observers_.size === 0 && (Zi.isBeingObserved_ && (Zi.isBeingObserved_ = !1, Zi.onBUO()), Zi instanceof ComputedValue && Zi.suspend_());
    }
    globalState.pendingUnobservations = [];
  }
}
function reportObserved(Bi) {
  checkIfStateReadsAreAllowed(Bi);
  var e = globalState.trackingDerivation;
  return e !== null ? (e.runId_ !== Bi.lastAccessedBy_ && (Bi.lastAccessedBy_ = e.runId_, e.newObserving_[e.unboundDepsCount_++] = Bi, !Bi.isBeingObserved_ && globalState.trackingContext && (Bi.isBeingObserved_ = !0, Bi.onBO())), Bi.isBeingObserved_) : (Bi.observers_.size === 0 && globalState.inBatch > 0 && queueForUnobservation(Bi), !1);
}
function propagateChanged(Bi) {
  Bi.lowestObserverState_ !== IDerivationState_.STALE_ && (Bi.lowestObserverState_ = IDerivationState_.STALE_, Bi.observers_.forEach(function(e) {
    e.dependenciesState_ === IDerivationState_.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && e.isTracing_ !== TraceMode.NONE && logTraceInfo(e, Bi), e.onBecomeStale_()), e.dependenciesState_ = IDerivationState_.STALE_;
  }));
}
function propagateChangeConfirmed(Bi) {
  Bi.lowestObserverState_ !== IDerivationState_.STALE_ && (Bi.lowestObserverState_ = IDerivationState_.STALE_, Bi.observers_.forEach(function(e) {
    e.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_ ? (e.dependenciesState_ = IDerivationState_.STALE_, process.env.NODE_ENV !== "production" && e.isTracing_ !== TraceMode.NONE && logTraceInfo(e, Bi)) : e.dependenciesState_ === IDerivationState_.UP_TO_DATE_ && (Bi.lowestObserverState_ = IDerivationState_.UP_TO_DATE_);
  }));
}
function propagateMaybeChanged(Bi) {
  Bi.lowestObserverState_ === IDerivationState_.UP_TO_DATE_ && (Bi.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_, Bi.observers_.forEach(function(e) {
    e.dependenciesState_ === IDerivationState_.UP_TO_DATE_ && (e.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_, e.onBecomeStale_());
  }));
}
function logTraceInfo(Bi, e) {
  if (console.log("[mobx.trace] '" + Bi.name_ + "' is invalidated due to a change in: '" + e.name_ + "'"), Bi.isTracing_ === TraceMode.BREAK) {
    var Zi = [];
    printDepTree(getDependencyTree(Bi), Zi, 1), new Function(`debugger;
/*
Tracing '` + Bi.name_ + `'

You are entering this break point because derivation '` + Bi.name_ + "' is being traced and '" + e.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (Bi instanceof ComputedValue ? Bi.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + Zi.join(`
`) + `
*/
    `)();
  }
}
function printDepTree(Bi, e, Zi) {
  if (e.length >= 1e3) {
    e.push("(and many more)");
    return;
  }
  e.push("" + "	".repeat(Zi - 1) + Bi.name), Bi.dependencies && Bi.dependencies.forEach(function(Qi) {
    return printDepTree(Qi, e, Zi + 1);
  });
}
var Reaction = /* @__PURE__ */ function() {
  function Bi(Zi, Qi, ea, ra) {
    Zi === void 0 && (Zi = process.env.NODE_ENV !== "production" ? "Reaction@" + getNextId() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = IDerivationState_.NOT_TRACKING_, this.diffValue_ = 0, this.runId_ = 0, this.unboundDepsCount_ = 0, this.isDisposed_ = !1, this.isScheduled_ = !1, this.isTrackPending_ = !1, this.isRunning_ = !1, this.isTracing_ = TraceMode.NONE, this.name_ = Zi, this.onInvalidate_ = Qi, this.errorHandler_ = ea, this.requiresObservable_ = ra;
  }
  var e = Bi.prototype;
  return e.onBecomeStale_ = function() {
    this.schedule_();
  }, e.schedule_ = function() {
    this.isScheduled_ || (this.isScheduled_ = !0, globalState.pendingReactions.push(this), runReactions());
  }, e.isScheduled = function() {
    return this.isScheduled_;
  }, e.runReaction_ = function() {
    if (!this.isDisposed_) {
      startBatch(), this.isScheduled_ = !1;
      var Qi = globalState.trackingContext;
      if (globalState.trackingContext = this, shouldCompute(this)) {
        this.isTrackPending_ = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending_ && isSpyEnabled() && spyReport({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (ea) {
          this.reportExceptionInDerivation_(ea);
        }
      }
      globalState.trackingContext = Qi, endBatch();
    }
  }, e.track = function(Qi) {
    if (!this.isDisposed_) {
      startBatch();
      var ea = isSpyEnabled(), ra;
      process.env.NODE_ENV !== "production" && ea && (ra = Date.now(), spyReportStart({
        name: this.name_,
        type: "reaction"
      })), this.isRunning_ = !0;
      var na = globalState.trackingContext;
      globalState.trackingContext = this;
      var ia = trackDerivedFunction(this, Qi, void 0);
      globalState.trackingContext = na, this.isRunning_ = !1, this.isTrackPending_ = !1, this.isDisposed_ && clearObserving(this), isCaughtException(ia) && this.reportExceptionInDerivation_(ia.cause), process.env.NODE_ENV !== "production" && ea && spyReportEnd({
        time: Date.now() - ra
      }), endBatch();
    }
  }, e.reportExceptionInDerivation_ = function(Qi) {
    var ea = this;
    if (this.errorHandler_) {
      this.errorHandler_(Qi, this);
      return;
    }
    if (globalState.disableErrorBoundaries)
      throw Qi;
    var ra = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    globalState.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(ra, Qi), process.env.NODE_ENV !== "production" && isSpyEnabled() && spyReport({
      type: "error",
      name: this.name_,
      message: ra,
      error: "" + Qi
    }), globalState.globalReactionErrorHandlers.forEach(function(na) {
      return na(Qi, ea);
    });
  }, e.dispose = function() {
    this.isDisposed_ || (this.isDisposed_ = !0, this.isRunning_ || (startBatch(), clearObserving(this), endBatch()));
  }, e.getDisposer_ = function(Qi) {
    var ea = this, ra = function na() {
      ea.dispose(), Qi == null || Qi.removeEventListener == null || Qi.removeEventListener("abort", na);
    };
    return Qi == null || Qi.addEventListener == null || Qi.addEventListener("abort", ra), ra[$mobx] = this, ra;
  }, e.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, e.trace = function(Qi) {
    Qi === void 0 && (Qi = !1), trace(this, Qi);
  }, Bi;
}(), MAX_REACTION_ITERATIONS = 100, reactionScheduler = function(e) {
  return e();
};
function runReactions() {
  globalState.inBatch > 0 || globalState.isRunningReactions || reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
  globalState.isRunningReactions = !0;
  for (var Bi = globalState.pendingReactions, e = 0; Bi.length > 0; ) {
    ++e === MAX_REACTION_ITERATIONS && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + Bi[0]) : "[mobx] cycle in reaction: " + Bi[0]), Bi.splice(0));
    for (var Zi = Bi.splice(0), Qi = 0, ea = Zi.length; Qi < ea; Qi++)
      Zi[Qi].runReaction_();
  }
  globalState.isRunningReactions = !1;
}
var isReaction = /* @__PURE__ */ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(Bi) {
  var e = reactionScheduler;
  reactionScheduler = function(Qi) {
    return Bi(function() {
      return e(Qi);
    });
  };
}
function isSpyEnabled() {
  return process.env.NODE_ENV !== "production" && !!globalState.spyListeners.length;
}
function spyReport(Bi) {
  if (process.env.NODE_ENV !== "production" && globalState.spyListeners.length)
    for (var e = globalState.spyListeners, Zi = 0, Qi = e.length; Zi < Qi; Zi++)
      e[Zi](Bi);
}
function spyReportStart(Bi) {
  if (process.env.NODE_ENV !== "production") {
    var e = _extends({}, Bi, {
      spyReportStart: !0
    });
    spyReport(e);
  }
}
var END_EVENT = {
  type: "report-end",
  spyReportEnd: !0
};
function spyReportEnd(Bi) {
  process.env.NODE_ENV !== "production" && spyReport(Bi ? _extends({}, Bi, {
    type: "report-end",
    spyReportEnd: !0
  }) : END_EVENT);
}
function spy(Bi) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (globalState.spyListeners.push(Bi), once(function() {
    globalState.spyListeners = globalState.spyListeners.filter(function(e) {
      return e !== Bi;
    });
  }));
}
var ACTION = "action", ACTION_BOUND = "action.bound", AUTOACTION = "autoAction", AUTOACTION_BOUND = "autoAction.bound", DEFAULT_ACTION_NAME = "<unnamed action>", actionAnnotation = /* @__PURE__ */ createActionAnnotation(ACTION), actionBoundAnnotation = /* @__PURE__ */ createActionAnnotation(ACTION_BOUND, {
  bound: !0
}), autoActionAnnotation = /* @__PURE__ */ createActionAnnotation(AUTOACTION, {
  autoAction: !0
}), autoActionBoundAnnotation = /* @__PURE__ */ createActionAnnotation(AUTOACTION_BOUND, {
  autoAction: !0,
  bound: !0
});
function createActionFactory(Bi) {
  var e = function(Qi, ea) {
    if (isFunction$1(Qi))
      return createAction(Qi.name || DEFAULT_ACTION_NAME, Qi, Bi);
    if (isFunction$1(ea))
      return createAction(Qi, ea, Bi);
    if (is20223Decorator(ea))
      return (Bi ? autoActionAnnotation : actionAnnotation).decorate_20223_(Qi, ea);
    if (isStringish(ea))
      return storeAnnotation(Qi, ea, Bi ? autoActionAnnotation : actionAnnotation);
    if (isStringish(Qi))
      return createDecoratorAnnotation(createActionAnnotation(Bi ? AUTOACTION : ACTION, {
        name: Qi,
        autoAction: Bi
      }));
    process.env.NODE_ENV !== "production" && die("Invalid arguments for `action`");
  };
  return e;
}
var action = /* @__PURE__ */ createActionFactory(!1);
Object.assign(action, actionAnnotation);
var autoAction = /* @__PURE__ */ createActionFactory(!0);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /* @__PURE__ */ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /* @__PURE__ */ createDecoratorAnnotation(autoActionBoundAnnotation);
function isAction(Bi) {
  return isFunction$1(Bi) && Bi.isMobxAction === !0;
}
function autorun(Bi, e) {
  var Zi, Qi, ea, ra, na;
  e === void 0 && (e = EMPTY_OBJECT), process.env.NODE_ENV !== "production" && (isFunction$1(Bi) || die("Autorun expects a function as first argument"), isAction(Bi) && die("Autorun does not accept actions since actions are untrackable"));
  var ia = (Zi = (Qi = e) == null ? void 0 : Qi.name) != null ? Zi : process.env.NODE_ENV !== "production" ? Bi.name || "Autorun@" + getNextId() : "Autorun", fa = !e.scheduler && !e.delay, La;
  if (fa)
    La = new Reaction(ia, function() {
      this.track(ro);
    }, e.onError, e.requiresObservable);
  else {
    var Va = createSchedulerFromOptions(e), to = !1;
    La = new Reaction(ia, function() {
      to || (to = !0, Va(function() {
        to = !1, La.isDisposed_ || La.track(ro);
      }));
    }, e.onError, e.requiresObservable);
  }
  function ro() {
    Bi(La);
  }
  return (ea = e) != null && (ra = ea.signal) != null && ra.aborted || La.schedule_(), La.getDisposer_((na = e) == null ? void 0 : na.signal);
}
var run = function(e) {
  return e();
};
function createSchedulerFromOptions(Bi) {
  return Bi.scheduler ? Bi.scheduler : Bi.delay ? function(e) {
    return setTimeout(e, Bi.delay);
  } : run;
}
var ON_BECOME_OBSERVED = "onBO", ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(Bi, e, Zi) {
  return interceptHook(ON_BECOME_OBSERVED, Bi, e, Zi);
}
function onBecomeUnobserved(Bi, e, Zi) {
  return interceptHook(ON_BECOME_UNOBSERVED, Bi, e, Zi);
}
function interceptHook(Bi, e, Zi, Qi) {
  var ea = getAtom(e), ra = isFunction$1(Qi) ? Qi : Zi, na = Bi + "L";
  return ea[na] ? ea[na].add(ra) : ea[na] = /* @__PURE__ */ new Set([ra]), function() {
    var ia = ea[na];
    ia && (ia.delete(ra), ia.size === 0 && delete ea[na]);
  };
}
var NEVER = "never", ALWAYS = "always", OBSERVED = "observed";
function configure(Bi) {
  Bi.isolateGlobalState === !0 && isolateGlobalState();
  var e = Bi.useProxies, Zi = Bi.enforceActions;
  if (e !== void 0 && (globalState.useProxies = e === ALWAYS ? !0 : e === NEVER ? !1 : typeof Proxy < "u"), e === "ifavailable" && (globalState.verifyProxies = !0), Zi !== void 0) {
    var Qi = Zi === ALWAYS ? ALWAYS : Zi === OBSERVED;
    globalState.enforceActions = Qi, globalState.allowStateChanges = !(Qi === !0 || Qi === ALWAYS);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(ea) {
    ea in Bi && (globalState[ea] = !!Bi[ea]);
  }), globalState.allowStateReads = !globalState.observableRequiresReaction, process.env.NODE_ENV !== "production" && globalState.disableErrorBoundaries === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), Bi.reactionScheduler && setReactionScheduler(Bi.reactionScheduler);
}
function extendObservable(Bi, e, Zi, Qi) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && die("'extendObservable' expected 2-4 arguments"), typeof Bi != "object" && die("'extendObservable' expects an object as first argument"), isObservableMap(Bi) && die("'extendObservable' should not be used on maps, use map.merge instead"), isPlainObject$2(e) || die("'extendObservable' only accepts plain objects as second argument"), (isObservable(e) || isObservable(Zi)) && die("Extending an object with another observable (object) is not supported"));
  var ea = getOwnPropertyDescriptors(e);
  return initObservable(function() {
    var ra = asObservableObject(Bi, Qi)[$mobx];
    ownKeys$2(ea).forEach(function(na) {
      ra.extend_(
        na,
        ea[na],
        // must pass "undefined" for { key: undefined }
        Zi && na in Zi ? Zi[na] : !0
      );
    });
  }), Bi;
}
function getDependencyTree(Bi, e) {
  return nodeToDependencyTree(getAtom(Bi, e));
}
function nodeToDependencyTree(Bi) {
  var e = {
    name: Bi.name_
  };
  return Bi.observing_ && Bi.observing_.length > 0 && (e.dependencies = unique(Bi.observing_).map(nodeToDependencyTree)), e;
}
function unique(Bi) {
  return Array.from(new Set(Bi));
}
var generatorId = 0;
function FlowCancellationError() {
  this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var flowAnnotation = /* @__PURE__ */ createFlowAnnotation("flow"), flowBoundAnnotation = /* @__PURE__ */ createFlowAnnotation("flow.bound", {
  bound: !0
}), flow = /* @__PURE__ */ Object.assign(function(e, Zi) {
  if (is20223Decorator(Zi))
    return flowAnnotation.decorate_20223_(e, Zi);
  if (isStringish(Zi))
    return storeAnnotation(e, Zi, flowAnnotation);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && die("Flow expects single argument with generator function");
  var Qi = e, ea = Qi.name || "<unnamed flow>", ra = function() {
    var ia = this, fa = arguments, La = ++generatorId, Va = action(ea + " - runid: " + La + " - init", Qi).apply(ia, fa), to, ro = void 0, no = new Promise(function(eo, ao) {
      var io = 0;
      to = ao;
      function xs(Fs) {
        ro = void 0;
        var Do;
        try {
          Do = action(ea + " - runid: " + La + " - yield " + io++, Va.next).call(Va, Fs);
        } catch (ys) {
          return ao(ys);
        }
        qs(Do);
      }
      function Ts(Fs) {
        ro = void 0;
        var Do;
        try {
          Do = action(ea + " - runid: " + La + " - yield " + io++, Va.throw).call(Va, Fs);
        } catch (ys) {
          return ao(ys);
        }
        qs(Do);
      }
      function qs(Fs) {
        if (isFunction$1(Fs?.then)) {
          Fs.then(qs, ao);
          return;
        }
        return Fs.done ? eo(Fs.value) : (ro = Promise.resolve(Fs.value), ro.then(xs, Ts));
      }
      xs(void 0);
    });
    return no.cancel = action(ea + " - runid: " + La + " - cancel", function() {
      try {
        ro && cancelPromise(ro);
        var eo = Va.return(void 0), ao = Promise.resolve(eo.value);
        ao.then(noop$1, noop$1), cancelPromise(ao), to(new FlowCancellationError());
      } catch (io) {
        to(io);
      }
    }), no;
  };
  return ra.isMobXFlow = !0, ra;
}, flowAnnotation);
flow.bound = /* @__PURE__ */ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(Bi) {
  isFunction$1(Bi.cancel) && Bi.cancel();
}
function isFlow(Bi) {
  return Bi?.isMobXFlow === !0;
}
function _isObservable(Bi, e) {
  return Bi ? isObservableObject(Bi) || !!Bi[$mobx] || isAtom(Bi) || isReaction(Bi) || isComputedValue(Bi) : !1;
}
function isObservable(Bi) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && die("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), _isObservable(Bi);
}
function trace() {
  if (process.env.NODE_ENV !== "production") {
    for (var Bi = !1, e = arguments.length, Zi = new Array(e), Qi = 0; Qi < e; Qi++)
      Zi[Qi] = arguments[Qi];
    typeof Zi[Zi.length - 1] == "boolean" && (Bi = Zi.pop());
    var ea = getAtomFromArgs(Zi);
    if (!ea)
      return die("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    ea.isTracing_ === TraceMode.NONE && console.log("[mobx.trace] '" + ea.name_ + "' tracing enabled"), ea.isTracing_ = Bi ? TraceMode.BREAK : TraceMode.LOG;
  }
}
function getAtomFromArgs(Bi) {
  switch (Bi.length) {
    case 0:
      return globalState.trackingDerivation;
    case 1:
      return getAtom(Bi[0]);
    case 2:
      return getAtom(Bi[0], Bi[1]);
  }
}
function transaction(Bi, e) {
  e === void 0 && (e = void 0), startBatch();
  try {
    return Bi.apply(e);
  } finally {
    endBatch();
  }
}
function getAdm(Bi) {
  return Bi[$mobx];
}
var objectProxyTraps = {
  has: function(e, Zi) {
    return process.env.NODE_ENV !== "production" && globalState.trackingDerivation && warnAboutProxyRequirement("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), getAdm(e).has_(Zi);
  },
  get: function(e, Zi) {
    return getAdm(e).get_(Zi);
  },
  set: function(e, Zi, Qi) {
    var ea;
    return isStringish(Zi) ? (process.env.NODE_ENV !== "production" && !getAdm(e).values_.has(Zi) && warnAboutProxyRequirement("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (ea = getAdm(e).set_(Zi, Qi, !0)) != null ? ea : !0) : !1;
  },
  deleteProperty: function(e, Zi) {
    var Qi;
    return process.env.NODE_ENV !== "production" && warnAboutProxyRequirement("delete properties from an observable object. Use 'remove' from 'mobx' instead."), isStringish(Zi) ? (Qi = getAdm(e).delete_(Zi, !0)) != null ? Qi : !0 : !1;
  },
  defineProperty: function(e, Zi, Qi) {
    var ea;
    return process.env.NODE_ENV !== "production" && warnAboutProxyRequirement("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (ea = getAdm(e).defineProperty_(Zi, Qi)) != null ? ea : !0;
  },
  ownKeys: function(e) {
    return process.env.NODE_ENV !== "production" && globalState.trackingDerivation && warnAboutProxyRequirement("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), getAdm(e).ownKeys_();
  },
  preventExtensions: function(e) {
    die(13);
  }
};
function asDynamicObservableObject(Bi, e) {
  var Zi, Qi;
  return assertProxies(), Bi = asObservableObject(Bi, e), (Qi = (Zi = Bi[$mobx]).proxy_) != null ? Qi : Zi.proxy_ = new Proxy(Bi, objectProxyTraps);
}
function hasInterceptors(Bi) {
  return Bi.interceptors_ !== void 0 && Bi.interceptors_.length > 0;
}
function registerInterceptor(Bi, e) {
  var Zi = Bi.interceptors_ || (Bi.interceptors_ = []);
  return Zi.push(e), once(function() {
    var Qi = Zi.indexOf(e);
    Qi !== -1 && Zi.splice(Qi, 1);
  });
}
function interceptChange(Bi, e) {
  var Zi = untrackedStart();
  try {
    for (var Qi = [].concat(Bi.interceptors_ || []), ea = 0, ra = Qi.length; ea < ra && (e = Qi[ea](e), e && !e.type && die(14), !!e); ea++)
      ;
    return e;
  } finally {
    untrackedEnd(Zi);
  }
}
function hasListeners(Bi) {
  return Bi.changeListeners_ !== void 0 && Bi.changeListeners_.length > 0;
}
function registerListener(Bi, e) {
  var Zi = Bi.changeListeners_ || (Bi.changeListeners_ = []);
  return Zi.push(e), once(function() {
    var Qi = Zi.indexOf(e);
    Qi !== -1 && Zi.splice(Qi, 1);
  });
}
function notifyListeners(Bi, e) {
  var Zi = untrackedStart(), Qi = Bi.changeListeners_;
  if (Qi) {
    Qi = Qi.slice();
    for (var ea = 0, ra = Qi.length; ea < ra; ea++)
      Qi[ea](e);
    untrackedEnd(Zi);
  }
}
function makeObservable(Bi, e, Zi) {
  return initObservable(function() {
    var Qi, ea = asObservableObject(Bi, Zi)[$mobx];
    process.env.NODE_ENV !== "production" && e && Bi[storedAnnotationsSymbol] && die("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (Qi = e) != null || (e = collectStoredAnnotations(Bi)), ownKeys$2(e).forEach(function(ra) {
      return ea.make_(ra, e[ra]);
    });
  }), Bi;
}
var keysSymbol = /* @__PURE__ */ Symbol("mobx-keys");
function makeAutoObservable(Bi, e, Zi) {
  return process.env.NODE_ENV !== "production" && (!isPlainObject$2(Bi) && !isPlainObject$2(Object.getPrototypeOf(Bi)) && die("'makeAutoObservable' can only be used for classes that don't have a superclass"), isObservableObject(Bi) && die("makeAutoObservable can only be used on objects not already made observable")), isPlainObject$2(Bi) ? extendObservable(Bi, Bi, e, Zi) : (initObservable(function() {
    var Qi = asObservableObject(Bi, Zi)[$mobx];
    if (!Bi[keysSymbol]) {
      var ea = Object.getPrototypeOf(Bi), ra = new Set([].concat(ownKeys$2(Bi), ownKeys$2(ea)));
      ra.delete("constructor"), ra.delete($mobx), addHiddenProp(ea, keysSymbol, ra);
    }
    Bi[keysSymbol].forEach(function(na) {
      return Qi.make_(
        na,
        // must pass "undefined" for { key: undefined }
        e && na in e ? e[na] : !0
      );
    });
  }), Bi);
}
var SPLICE = "splice", UPDATE = "update", MAX_SPLICE_SIZE = 1e4, arrayTraps = {
  get: function(e, Zi) {
    var Qi = e[$mobx];
    return Zi === $mobx ? Qi : Zi === "length" ? Qi.getArrayLength_() : typeof Zi == "string" && !isNaN(Zi) ? Qi.get_(parseInt(Zi)) : hasProp(arrayExtensions, Zi) ? arrayExtensions[Zi] : e[Zi];
  },
  set: function(e, Zi, Qi) {
    var ea = e[$mobx];
    return Zi === "length" && ea.setArrayLength_(Qi), typeof Zi == "symbol" || isNaN(Zi) ? e[Zi] = Qi : ea.set_(parseInt(Zi), Qi), !0;
  },
  preventExtensions: function() {
    die(15);
  }
}, ObservableArrayAdministration = /* @__PURE__ */ function() {
  function Bi(Zi, Qi, ea, ra) {
    Zi === void 0 && (Zi = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = ea, this.legacyMode_ = ra, this.atom_ = new Atom(Zi), this.enhancer_ = function(na, ia) {
      return Qi(na, ia, process.env.NODE_ENV !== "production" ? Zi + "[..]" : "ObservableArray[..]");
    };
  }
  var e = Bi.prototype;
  return e.dehanceValue_ = function(Qi) {
    return this.dehancer !== void 0 ? this.dehancer(Qi) : Qi;
  }, e.dehanceValues_ = function(Qi) {
    return this.dehancer !== void 0 && Qi.length > 0 ? Qi.map(this.dehancer) : Qi;
  }, e.intercept_ = function(Qi) {
    return registerInterceptor(this, Qi);
  }, e.observe_ = function(Qi, ea) {
    return ea === void 0 && (ea = !1), ea && Qi({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), registerListener(this, Qi);
  }, e.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, e.setArrayLength_ = function(Qi) {
    (typeof Qi != "number" || isNaN(Qi) || Qi < 0) && die("Out of range: " + Qi);
    var ea = this.values_.length;
    if (Qi !== ea)
      if (Qi > ea) {
        for (var ra = new Array(Qi - ea), na = 0; na < Qi - ea; na++)
          ra[na] = void 0;
        this.spliceWithArray_(ea, 0, ra);
      } else
        this.spliceWithArray_(Qi, ea - Qi);
  }, e.updateArrayLength_ = function(Qi, ea) {
    Qi !== this.lastKnownLength_ && die(16), this.lastKnownLength_ += ea, this.legacyMode_ && ea > 0 && reserveArrayBuffer(Qi + ea + 1);
  }, e.spliceWithArray_ = function(Qi, ea, ra) {
    var na = this;
    checkIfStateModificationsAreAllowed(this.atom_);
    var ia = this.values_.length;
    if (Qi === void 0 ? Qi = 0 : Qi > ia ? Qi = ia : Qi < 0 && (Qi = Math.max(0, ia + Qi)), arguments.length === 1 ? ea = ia - Qi : ea == null ? ea = 0 : ea = Math.max(0, Math.min(ea, ia - Qi)), ra === void 0 && (ra = EMPTY_ARRAY), hasInterceptors(this)) {
      var fa = interceptChange(this, {
        object: this.proxy_,
        type: SPLICE,
        index: Qi,
        removedCount: ea,
        added: ra
      });
      if (!fa)
        return EMPTY_ARRAY;
      ea = fa.removedCount, ra = fa.added;
    }
    if (ra = ra.length === 0 ? ra : ra.map(function(to) {
      return na.enhancer_(to, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var La = ra.length - ea;
      this.updateArrayLength_(ia, La);
    }
    var Va = this.spliceItemsIntoValues_(Qi, ea, ra);
    return (ea !== 0 || ra.length !== 0) && this.notifyArraySplice_(Qi, ra, Va), this.dehanceValues_(Va);
  }, e.spliceItemsIntoValues_ = function(Qi, ea, ra) {
    if (ra.length < MAX_SPLICE_SIZE) {
      var na;
      return (na = this.values_).splice.apply(na, [Qi, ea].concat(ra));
    } else {
      var ia = this.values_.slice(Qi, Qi + ea), fa = this.values_.slice(Qi + ea);
      this.values_.length += ra.length - ea;
      for (var La = 0; La < ra.length; La++)
        this.values_[Qi + La] = ra[La];
      for (var Va = 0; Va < fa.length; Va++)
        this.values_[Qi + ra.length + Va] = fa[Va];
      return ia;
    }
  }, e.notifyArrayChildUpdate_ = function(Qi, ea, ra) {
    var na = !this.owned_ && isSpyEnabled(), ia = hasListeners(this), fa = ia || na ? {
      observableKind: "array",
      object: this.proxy_,
      type: UPDATE,
      debugObjectName: this.atom_.name_,
      index: Qi,
      newValue: ea,
      oldValue: ra
    } : null;
    process.env.NODE_ENV !== "production" && na && spyReportStart(fa), this.atom_.reportChanged(), ia && notifyListeners(this, fa), process.env.NODE_ENV !== "production" && na && spyReportEnd();
  }, e.notifyArraySplice_ = function(Qi, ea, ra) {
    var na = !this.owned_ && isSpyEnabled(), ia = hasListeners(this), fa = ia || na ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: SPLICE,
      index: Qi,
      removed: ra,
      added: ea,
      removedCount: ra.length,
      addedCount: ea.length
    } : null;
    process.env.NODE_ENV !== "production" && na && spyReportStart(fa), this.atom_.reportChanged(), ia && notifyListeners(this, fa), process.env.NODE_ENV !== "production" && na && spyReportEnd();
  }, e.get_ = function(Qi) {
    if (this.legacyMode_ && Qi >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + Qi + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + Qi);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[Qi]);
  }, e.set_ = function(Qi, ea) {
    var ra = this.values_;
    if (this.legacyMode_ && Qi > ra.length && die(17, Qi, ra.length), Qi < ra.length) {
      checkIfStateModificationsAreAllowed(this.atom_);
      var na = ra[Qi];
      if (hasInterceptors(this)) {
        var ia = interceptChange(this, {
          type: UPDATE,
          object: this.proxy_,
          index: Qi,
          newValue: ea
        });
        if (!ia)
          return;
        ea = ia.newValue;
      }
      ea = this.enhancer_(ea, na);
      var fa = ea !== na;
      fa && (ra[Qi] = ea, this.notifyArrayChildUpdate_(Qi, ea, na));
    } else {
      for (var La = new Array(Qi + 1 - ra.length), Va = 0; Va < La.length - 1; Va++)
        La[Va] = void 0;
      La[La.length - 1] = ea, this.spliceWithArray_(ra.length, 0, La);
    }
  }, Bi;
}();
function createObservableArray(Bi, e, Zi, Qi) {
  return Zi === void 0 && (Zi = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray"), Qi === void 0 && (Qi = !1), assertProxies(), initObservable(function() {
    var ea = new ObservableArrayAdministration(Zi, e, Qi, !1);
    addHiddenFinalProp(ea.values_, $mobx, ea);
    var ra = new Proxy(ea.values_, arrayTraps);
    return ea.proxy_ = ra, Bi && Bi.length && ea.spliceWithArray_(0, 0, Bi), ra;
  });
}
var arrayExtensions = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(e) {
    var Zi = this[$mobx];
    return Zi.spliceWithArray_(0, Zi.values_.length, e);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(e, Zi) {
    for (var Qi = arguments.length, ea = new Array(Qi > 2 ? Qi - 2 : 0), ra = 2; ra < Qi; ra++)
      ea[ra - 2] = arguments[ra];
    var na = this[$mobx];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return na.spliceWithArray_(e);
      case 2:
        return na.spliceWithArray_(e, Zi);
    }
    return na.spliceWithArray_(e, Zi, ea);
  },
  spliceWithArray: function(e, Zi, Qi) {
    return this[$mobx].spliceWithArray_(e, Zi, Qi);
  },
  push: function() {
    for (var e = this[$mobx], Zi = arguments.length, Qi = new Array(Zi), ea = 0; ea < Zi; ea++)
      Qi[ea] = arguments[ea];
    return e.spliceWithArray_(e.values_.length, 0, Qi), e.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var e = this[$mobx], Zi = arguments.length, Qi = new Array(Zi), ea = 0; ea < Zi; ea++)
      Qi[ea] = arguments[ea];
    return e.spliceWithArray_(0, 0, Qi), e.values_.length;
  },
  reverse: function() {
    return globalState.trackingDerivation && die(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    globalState.trackingDerivation && die(37, "sort");
    var e = this.slice();
    return e.sort.apply(e, arguments), this.replace(e), this;
  },
  remove: function(e) {
    var Zi = this[$mobx], Qi = Zi.dehanceValues_(Zi.values_).indexOf(e);
    return Qi > -1 ? (this.splice(Qi, 1), !0) : !1;
  }
};
addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(Bi, e) {
  typeof Array.prototype[Bi] == "function" && (arrayExtensions[Bi] = e(Bi));
}
function simpleFunc(Bi) {
  return function() {
    var e = this[$mobx];
    e.atom_.reportObserved();
    var Zi = e.dehanceValues_(e.values_);
    return Zi[Bi].apply(Zi, arguments);
  };
}
function mapLikeFunc(Bi) {
  return function(e, Zi) {
    var Qi = this, ea = this[$mobx];
    ea.atom_.reportObserved();
    var ra = ea.dehanceValues_(ea.values_);
    return ra[Bi](function(na, ia) {
      return e.call(Zi, na, ia, Qi);
    });
  };
}
function reduceLikeFunc(Bi) {
  return function() {
    var e = this, Zi = this[$mobx];
    Zi.atom_.reportObserved();
    var Qi = Zi.dehanceValues_(Zi.values_), ea = arguments[0];
    return arguments[0] = function(ra, na, ia) {
      return ea(ra, na, ia, e);
    }, Qi[Bi].apply(Qi, arguments);
  };
}
var isObservableArrayAdministration = /* @__PURE__ */ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(Bi) {
  return isObject$3(Bi) && isObservableArrayAdministration(Bi[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag, ObservableMapMarker = {}, ADD = "add", DELETE = "delete";
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /* @__PURE__ */ function() {
  function Bi(Zi, Qi, ea) {
    var ra = this;
    Qi === void 0 && (Qi = deepEnhancer), ea === void 0 && (ea = process.env.NODE_ENV !== "production" ? "ObservableMap@" + getNextId() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[$mobx] = ObservableMapMarker, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = Qi, this.name_ = ea, isFunction$1(Map) || die(18), initObservable(function() {
      ra.keysAtom_ = createAtom(process.env.NODE_ENV !== "production" ? ra.name_ + ".keys()" : "ObservableMap.keys()"), ra.data_ = /* @__PURE__ */ new Map(), ra.hasMap_ = /* @__PURE__ */ new Map(), Zi && ra.merge(Zi);
    });
  }
  var e = Bi.prototype;
  return e.has_ = function(Qi) {
    return this.data_.has(Qi);
  }, e.has = function(Qi) {
    var ea = this;
    if (!globalState.trackingDerivation)
      return this.has_(Qi);
    var ra = this.hasMap_.get(Qi);
    if (!ra) {
      var na = ra = new ObservableValue(this.has_(Qi), referenceEnhancer, process.env.NODE_ENV !== "production" ? this.name_ + "." + stringifyKey(Qi) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(Qi, na), onBecomeUnobserved(na, function() {
        return ea.hasMap_.delete(Qi);
      });
    }
    return ra.get();
  }, e.set = function(Qi, ea) {
    var ra = this.has_(Qi);
    if (hasInterceptors(this)) {
      var na = interceptChange(this, {
        type: ra ? UPDATE : ADD,
        object: this,
        newValue: ea,
        name: Qi
      });
      if (!na)
        return this;
      ea = na.newValue;
    }
    return ra ? this.updateValue_(Qi, ea) : this.addValue_(Qi, ea), this;
  }, e.delete = function(Qi) {
    var ea = this;
    if (checkIfStateModificationsAreAllowed(this.keysAtom_), hasInterceptors(this)) {
      var ra = interceptChange(this, {
        type: DELETE,
        object: this,
        name: Qi
      });
      if (!ra)
        return !1;
    }
    if (this.has_(Qi)) {
      var na = isSpyEnabled(), ia = hasListeners(this), fa = ia || na ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: this.data_.get(Qi).value_,
        name: Qi
      } : null;
      return process.env.NODE_ENV !== "production" && na && spyReportStart(fa), transaction(function() {
        var La;
        ea.keysAtom_.reportChanged(), (La = ea.hasMap_.get(Qi)) == null || La.setNewValue_(!1);
        var Va = ea.data_.get(Qi);
        Va.setNewValue_(void 0), ea.data_.delete(Qi);
      }), ia && notifyListeners(this, fa), process.env.NODE_ENV !== "production" && na && spyReportEnd(), !0;
    }
    return !1;
  }, e.updateValue_ = function(Qi, ea) {
    var ra = this.data_.get(Qi);
    if (ea = ra.prepareNewValue_(ea), ea !== globalState.UNCHANGED) {
      var na = isSpyEnabled(), ia = hasListeners(this), fa = ia || na ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: UPDATE,
        object: this,
        oldValue: ra.value_,
        name: Qi,
        newValue: ea
      } : null;
      process.env.NODE_ENV !== "production" && na && spyReportStart(fa), ra.setNewValue_(ea), ia && notifyListeners(this, fa), process.env.NODE_ENV !== "production" && na && spyReportEnd();
    }
  }, e.addValue_ = function(Qi, ea) {
    var ra = this;
    checkIfStateModificationsAreAllowed(this.keysAtom_), transaction(function() {
      var La, Va = new ObservableValue(ea, ra.enhancer_, process.env.NODE_ENV !== "production" ? ra.name_ + "." + stringifyKey(Qi) : "ObservableMap.key", !1);
      ra.data_.set(Qi, Va), ea = Va.value_, (La = ra.hasMap_.get(Qi)) == null || La.setNewValue_(!0), ra.keysAtom_.reportChanged();
    });
    var na = isSpyEnabled(), ia = hasListeners(this), fa = ia || na ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: ADD,
      object: this,
      name: Qi,
      newValue: ea
    } : null;
    process.env.NODE_ENV !== "production" && na && spyReportStart(fa), ia && notifyListeners(this, fa), process.env.NODE_ENV !== "production" && na && spyReportEnd();
  }, e.get = function(Qi) {
    return this.has(Qi) ? this.dehanceValue_(this.data_.get(Qi).get()) : this.dehanceValue_(void 0);
  }, e.dehanceValue_ = function(Qi) {
    return this.dehancer !== void 0 ? this.dehancer(Qi) : Qi;
  }, e.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, e.values = function() {
    var Qi = this, ea = this.keys();
    return makeIterable({
      next: function() {
        var na = ea.next(), ia = na.done, fa = na.value;
        return {
          done: ia,
          value: ia ? void 0 : Qi.get(fa)
        };
      }
    });
  }, e.entries = function() {
    var Qi = this, ea = this.keys();
    return makeIterable({
      next: function() {
        var na = ea.next(), ia = na.done, fa = na.value;
        return {
          done: ia,
          value: ia ? void 0 : [fa, Qi.get(fa)]
        };
      }
    });
  }, e[_Symbol$iterator] = function() {
    return this.entries();
  }, e.forEach = function(Qi, ea) {
    for (var ra = _createForOfIteratorHelperLoose(this), na; !(na = ra()).done; ) {
      var ia = na.value, fa = ia[0], La = ia[1];
      Qi.call(ea, La, fa, this);
    }
  }, e.merge = function(Qi) {
    var ea = this;
    return isObservableMap(Qi) && (Qi = new Map(Qi)), transaction(function() {
      isPlainObject$2(Qi) ? getPlainObjectKeys(Qi).forEach(function(ra) {
        return ea.set(ra, Qi[ra]);
      }) : Array.isArray(Qi) ? Qi.forEach(function(ra) {
        var na = ra[0], ia = ra[1];
        return ea.set(na, ia);
      }) : isES6Map(Qi) ? (Qi.constructor !== Map && die(19, Qi), Qi.forEach(function(ra, na) {
        return ea.set(na, ra);
      })) : Qi != null && die(20, Qi);
    }), this;
  }, e.clear = function() {
    var Qi = this;
    transaction(function() {
      untracked(function() {
        for (var ea = _createForOfIteratorHelperLoose(Qi.keys()), ra; !(ra = ea()).done; ) {
          var na = ra.value;
          Qi.delete(na);
        }
      });
    });
  }, e.replace = function(Qi) {
    var ea = this;
    return transaction(function() {
      for (var ra = convertToMap(Qi), na = /* @__PURE__ */ new Map(), ia = !1, fa = _createForOfIteratorHelperLoose(ea.data_.keys()), La; !(La = fa()).done; ) {
        var Va = La.value;
        if (!ra.has(Va)) {
          var to = ea.delete(Va);
          if (to)
            ia = !0;
          else {
            var ro = ea.data_.get(Va);
            na.set(Va, ro);
          }
        }
      }
      for (var no = _createForOfIteratorHelperLoose(ra.entries()), eo; !(eo = no()).done; ) {
        var ao = eo.value, io = ao[0], xs = ao[1], Ts = ea.data_.has(io);
        if (ea.set(io, xs), ea.data_.has(io)) {
          var qs = ea.data_.get(io);
          na.set(io, qs), Ts || (ia = !0);
        }
      }
      if (!ia)
        if (ea.data_.size !== na.size)
          ea.keysAtom_.reportChanged();
        else
          for (var Fs = ea.data_.keys(), Do = na.keys(), ys = Fs.next(), Io = Do.next(); !ys.done; ) {
            if (ys.value !== Io.value) {
              ea.keysAtom_.reportChanged();
              break;
            }
            ys = Fs.next(), Io = Do.next();
          }
      ea.data_ = na;
    }), this;
  }, e.toString = function() {
    return "[object ObservableMap]";
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.observe_ = function(Qi, ea) {
    return process.env.NODE_ENV !== "production" && ea === !0 && die("`observe` doesn't support fireImmediately=true in combination with maps."), registerListener(this, Qi);
  }, e.intercept_ = function(Qi) {
    return registerInterceptor(this, Qi);
  }, _createClass(Bi, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: _Symbol$toStringTag,
    get: function() {
      return "Map";
    }
  }]), Bi;
}(), isObservableMap = /* @__PURE__ */ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(Bi) {
  if (isES6Map(Bi) || isObservableMap(Bi))
    return Bi;
  if (Array.isArray(Bi))
    return new Map(Bi);
  if (isPlainObject$2(Bi)) {
    var e = /* @__PURE__ */ new Map();
    for (var Zi in Bi)
      e.set(Zi, Bi[Zi]);
    return e;
  } else
    return die(21, Bi);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1, ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /* @__PURE__ */ function() {
  function Bi(Zi, Qi, ea) {
    var ra = this;
    Qi === void 0 && (Qi = deepEnhancer), ea === void 0 && (ea = process.env.NODE_ENV !== "production" ? "ObservableSet@" + getNextId() : "ObservableSet"), this.name_ = void 0, this[$mobx] = ObservableSetMarker, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = ea, isFunction$1(Set) || die(22), this.enhancer_ = function(na, ia) {
      return Qi(na, ia, ea);
    }, initObservable(function() {
      ra.atom_ = createAtom(ra.name_), Zi && ra.replace(Zi);
    });
  }
  var e = Bi.prototype;
  return e.dehanceValue_ = function(Qi) {
    return this.dehancer !== void 0 ? this.dehancer(Qi) : Qi;
  }, e.clear = function() {
    var Qi = this;
    transaction(function() {
      untracked(function() {
        for (var ea = _createForOfIteratorHelperLoose(Qi.data_.values()), ra; !(ra = ea()).done; ) {
          var na = ra.value;
          Qi.delete(na);
        }
      });
    });
  }, e.forEach = function(Qi, ea) {
    for (var ra = _createForOfIteratorHelperLoose(this), na; !(na = ra()).done; ) {
      var ia = na.value;
      Qi.call(ea, ia, ia, this);
    }
  }, e.add = function(Qi) {
    var ea = this;
    if (checkIfStateModificationsAreAllowed(this.atom_), hasInterceptors(this)) {
      var ra = interceptChange(this, {
        type: ADD,
        object: this,
        newValue: Qi
      });
      if (!ra)
        return this;
    }
    if (!this.has(Qi)) {
      transaction(function() {
        ea.data_.add(ea.enhancer_(Qi, void 0)), ea.atom_.reportChanged();
      });
      var na = process.env.NODE_ENV !== "production" && isSpyEnabled(), ia = hasListeners(this), fa = ia || na ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: ADD,
        object: this,
        newValue: Qi
      } : null;
      na && process.env.NODE_ENV !== "production" && spyReportStart(fa), ia && notifyListeners(this, fa), na && process.env.NODE_ENV !== "production" && spyReportEnd();
    }
    return this;
  }, e.delete = function(Qi) {
    var ea = this;
    if (hasInterceptors(this)) {
      var ra = interceptChange(this, {
        type: DELETE,
        object: this,
        oldValue: Qi
      });
      if (!ra)
        return !1;
    }
    if (this.has(Qi)) {
      var na = process.env.NODE_ENV !== "production" && isSpyEnabled(), ia = hasListeners(this), fa = ia || na ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: Qi
      } : null;
      return na && process.env.NODE_ENV !== "production" && spyReportStart(fa), transaction(function() {
        ea.atom_.reportChanged(), ea.data_.delete(Qi);
      }), ia && notifyListeners(this, fa), na && process.env.NODE_ENV !== "production" && spyReportEnd(), !0;
    }
    return !1;
  }, e.has = function(Qi) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(Qi));
  }, e.entries = function() {
    var Qi = 0, ea = Array.from(this.keys()), ra = Array.from(this.values());
    return makeIterable({
      next: function() {
        var ia = Qi;
        return Qi += 1, ia < ra.length ? {
          value: [ea[ia], ra[ia]],
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, e.keys = function() {
    return this.values();
  }, e.values = function() {
    this.atom_.reportObserved();
    var Qi = this, ea = 0, ra = Array.from(this.data_.values());
    return makeIterable({
      next: function() {
        return ea < ra.length ? {
          value: Qi.dehanceValue_(ra[ea++]),
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, e.replace = function(Qi) {
    var ea = this;
    return isObservableSet(Qi) && (Qi = new Set(Qi)), transaction(function() {
      Array.isArray(Qi) ? (ea.clear(), Qi.forEach(function(ra) {
        return ea.add(ra);
      })) : isES6Set(Qi) ? (ea.clear(), Qi.forEach(function(ra) {
        return ea.add(ra);
      })) : Qi != null && die("Cannot initialize set from " + Qi);
    }), this;
  }, e.observe_ = function(Qi, ea) {
    return process.env.NODE_ENV !== "production" && ea === !0 && die("`observe` doesn't support fireImmediately=true in combination with sets."), registerListener(this, Qi);
  }, e.intercept_ = function(Qi) {
    return registerInterceptor(this, Qi);
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.toString = function() {
    return "[object ObservableSet]";
  }, e[_Symbol$iterator$1] = function() {
    return this.values();
  }, _createClass(Bi, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: _Symbol$toStringTag$1,
    get: function() {
      return "Set";
    }
  }]), Bi;
}(), isObservableSet = /* @__PURE__ */ createInstanceofPredicate("ObservableSet", ObservableSet), descriptorCache = /* @__PURE__ */ Object.create(null), REMOVE = "remove", ObservableObjectAdministration = /* @__PURE__ */ function() {
  function Bi(Zi, Qi, ea, ra) {
    Qi === void 0 && (Qi = /* @__PURE__ */ new Map()), ra === void 0 && (ra = autoAnnotation), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = Zi, this.values_ = Qi, this.name_ = ea, this.defaultAnnotation_ = ra, this.keysAtom_ = new Atom(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = isPlainObject$2(this.target_), process.env.NODE_ENV !== "production" && !isAnnotation(this.defaultAnnotation_) && die("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var e = Bi.prototype;
  return e.getObservablePropValue_ = function(Qi) {
    return this.values_.get(Qi).get();
  }, e.setObservablePropValue_ = function(Qi, ea) {
    var ra = this.values_.get(Qi);
    if (ra instanceof ComputedValue)
      return ra.set(ea), !0;
    if (hasInterceptors(this)) {
      var na = interceptChange(this, {
        type: UPDATE,
        object: this.proxy_ || this.target_,
        name: Qi,
        newValue: ea
      });
      if (!na)
        return null;
      ea = na.newValue;
    }
    if (ea = ra.prepareNewValue_(ea), ea !== globalState.UNCHANGED) {
      var ia = hasListeners(this), fa = process.env.NODE_ENV !== "production" && isSpyEnabled(), La = ia || fa ? {
        type: UPDATE,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: ra.value_,
        name: Qi,
        newValue: ea
      } : null;
      process.env.NODE_ENV !== "production" && fa && spyReportStart(La), ra.setNewValue_(ea), ia && notifyListeners(this, La), process.env.NODE_ENV !== "production" && fa && spyReportEnd();
    }
    return !0;
  }, e.get_ = function(Qi) {
    return globalState.trackingDerivation && !hasProp(this.target_, Qi) && this.has_(Qi), this.target_[Qi];
  }, e.set_ = function(Qi, ea, ra) {
    return ra === void 0 && (ra = !1), hasProp(this.target_, Qi) ? this.values_.has(Qi) ? this.setObservablePropValue_(Qi, ea) : ra ? Reflect.set(this.target_, Qi, ea) : (this.target_[Qi] = ea, !0) : this.extend_(Qi, {
      value: ea,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, ra);
  }, e.has_ = function(Qi) {
    if (!globalState.trackingDerivation)
      return Qi in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var ea = this.pendingKeys_.get(Qi);
    return ea || (ea = new ObservableValue(Qi in this.target_, referenceEnhancer, process.env.NODE_ENV !== "production" ? this.name_ + "." + stringifyKey(Qi) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(Qi, ea)), ea.get();
  }, e.make_ = function(Qi, ea) {
    if (ea === !0 && (ea = this.defaultAnnotation_), ea !== !1) {
      if (assertAnnotable(this, ea, Qi), !(Qi in this.target_)) {
        var ra;
        if ((ra = this.target_[storedAnnotationsSymbol]) != null && ra[Qi])
          return;
        die(1, ea.annotationType_, this.name_ + "." + Qi.toString());
      }
      for (var na = this.target_; na && na !== objectPrototype; ) {
        var ia = getDescriptor(na, Qi);
        if (ia) {
          var fa = ea.make_(this, Qi, ia, na);
          if (fa === 0)
            return;
          if (fa === 1)
            break;
        }
        na = Object.getPrototypeOf(na);
      }
      recordAnnotationApplied(this, ea, Qi);
    }
  }, e.extend_ = function(Qi, ea, ra, na) {
    if (na === void 0 && (na = !1), ra === !0 && (ra = this.defaultAnnotation_), ra === !1)
      return this.defineProperty_(Qi, ea, na);
    assertAnnotable(this, ra, Qi);
    var ia = ra.extend_(this, Qi, ea, na);
    return ia && recordAnnotationApplied(this, ra, Qi), ia;
  }, e.defineProperty_ = function(Qi, ea, ra) {
    ra === void 0 && (ra = !1), checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      var na = this.delete_(Qi);
      if (!na)
        return na;
      if (hasInterceptors(this)) {
        var ia = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: Qi,
          type: ADD,
          newValue: ea.value
        });
        if (!ia)
          return null;
        var fa = ia.newValue;
        ea.value !== fa && (ea = _extends({}, ea, {
          value: fa
        }));
      }
      if (ra) {
        if (!Reflect.defineProperty(this.target_, Qi, ea))
          return !1;
      } else
        defineProperty(this.target_, Qi, ea);
      this.notifyPropertyAddition_(Qi, ea.value);
    } finally {
      endBatch();
    }
    return !0;
  }, e.defineObservableProperty_ = function(Qi, ea, ra, na) {
    na === void 0 && (na = !1), checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      var ia = this.delete_(Qi);
      if (!ia)
        return ia;
      if (hasInterceptors(this)) {
        var fa = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: Qi,
          type: ADD,
          newValue: ea
        });
        if (!fa)
          return null;
        ea = fa.newValue;
      }
      var La = getCachedObservablePropDescriptor(Qi), Va = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: La.get,
        set: La.set
      };
      if (na) {
        if (!Reflect.defineProperty(this.target_, Qi, Va))
          return !1;
      } else
        defineProperty(this.target_, Qi, Va);
      var to = new ObservableValue(ea, ra, process.env.NODE_ENV !== "production" ? this.name_ + "." + Qi.toString() : "ObservableObject.key", !1);
      this.values_.set(Qi, to), this.notifyPropertyAddition_(Qi, to.value_);
    } finally {
      endBatch();
    }
    return !0;
  }, e.defineComputedProperty_ = function(Qi, ea, ra) {
    ra === void 0 && (ra = !1), checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      var na = this.delete_(Qi);
      if (!na)
        return na;
      if (hasInterceptors(this)) {
        var ia = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: Qi,
          type: ADD,
          newValue: void 0
        });
        if (!ia)
          return null;
      }
      ea.name || (ea.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + Qi.toString() : "ObservableObject.key"), ea.context = this.proxy_ || this.target_;
      var fa = getCachedObservablePropDescriptor(Qi), La = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: fa.get,
        set: fa.set
      };
      if (ra) {
        if (!Reflect.defineProperty(this.target_, Qi, La))
          return !1;
      } else
        defineProperty(this.target_, Qi, La);
      this.values_.set(Qi, new ComputedValue(ea)), this.notifyPropertyAddition_(Qi, void 0);
    } finally {
      endBatch();
    }
    return !0;
  }, e.delete_ = function(Qi, ea) {
    if (ea === void 0 && (ea = !1), checkIfStateModificationsAreAllowed(this.keysAtom_), !hasProp(this.target_, Qi))
      return !0;
    if (hasInterceptors(this)) {
      var ra = interceptChange(this, {
        object: this.proxy_ || this.target_,
        name: Qi,
        type: REMOVE
      });
      if (!ra)
        return null;
    }
    try {
      var na, ia;
      startBatch();
      var fa = hasListeners(this), La = process.env.NODE_ENV !== "production" && isSpyEnabled(), Va = this.values_.get(Qi), to = void 0;
      if (!Va && (fa || La)) {
        var ro;
        to = (ro = getDescriptor(this.target_, Qi)) == null ? void 0 : ro.value;
      }
      if (ea) {
        if (!Reflect.deleteProperty(this.target_, Qi))
          return !1;
      } else
        delete this.target_[Qi];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[Qi], Va && (this.values_.delete(Qi), Va instanceof ObservableValue && (to = Va.value_), propagateChanged(Va)), this.keysAtom_.reportChanged(), (na = this.pendingKeys_) == null || (ia = na.get(Qi)) == null || ia.set(Qi in this.target_), fa || La) {
        var no = {
          type: REMOVE,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: to,
          name: Qi
        };
        process.env.NODE_ENV !== "production" && La && spyReportStart(no), fa && notifyListeners(this, no), process.env.NODE_ENV !== "production" && La && spyReportEnd();
      }
    } finally {
      endBatch();
    }
    return !0;
  }, e.observe_ = function(Qi, ea) {
    return process.env.NODE_ENV !== "production" && ea === !0 && die("`observe` doesn't support the fire immediately property for observable objects."), registerListener(this, Qi);
  }, e.intercept_ = function(Qi) {
    return registerInterceptor(this, Qi);
  }, e.notifyPropertyAddition_ = function(Qi, ea) {
    var ra, na, ia = hasListeners(this), fa = process.env.NODE_ENV !== "production" && isSpyEnabled();
    if (ia || fa) {
      var La = ia || fa ? {
        type: ADD,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: Qi,
        newValue: ea
      } : null;
      process.env.NODE_ENV !== "production" && fa && spyReportStart(La), ia && notifyListeners(this, La), process.env.NODE_ENV !== "production" && fa && spyReportEnd();
    }
    (ra = this.pendingKeys_) == null || (na = ra.get(Qi)) == null || na.set(!0), this.keysAtom_.reportChanged();
  }, e.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), ownKeys$2(this.target_);
  }, e.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, Bi;
}();
function asObservableObject(Bi, e) {
  var Zi;
  if (process.env.NODE_ENV !== "production" && e && isObservableObject(Bi) && die("Options can't be provided for already observable objects."), hasProp(Bi, $mobx))
    return process.env.NODE_ENV !== "production" && !(getAdministration$1(Bi) instanceof ObservableObjectAdministration) && die("Cannot convert '" + getDebugName(Bi) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), Bi;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(Bi) && die("Cannot make the designated object observable; it is not extensible");
  var Qi = (Zi = e?.name) != null ? Zi : process.env.NODE_ENV !== "production" ? (isPlainObject$2(Bi) ? "ObservableObject" : Bi.constructor.name) + "@" + getNextId() : "ObservableObject", ea = new ObservableObjectAdministration(Bi, /* @__PURE__ */ new Map(), String(Qi), getAnnotationFromOptions(e));
  return addHiddenProp(Bi, $mobx, ea), Bi;
}
var isObservableObjectAdministration = /* @__PURE__ */ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(Bi) {
  return descriptorCache[Bi] || (descriptorCache[Bi] = {
    get: function() {
      return this[$mobx].getObservablePropValue_(Bi);
    },
    set: function(Zi) {
      return this[$mobx].setObservablePropValue_(Bi, Zi);
    }
  });
}
function isObservableObject(Bi) {
  return isObject$3(Bi) ? isObservableObjectAdministration(Bi[$mobx]) : !1;
}
function recordAnnotationApplied(Bi, e, Zi) {
  var Qi;
  process.env.NODE_ENV !== "production" && (Bi.appliedAnnotations_[Zi] = e), (Qi = Bi.target_[storedAnnotationsSymbol]) == null || delete Qi[Zi];
}
function assertAnnotable(Bi, e, Zi) {
  if (process.env.NODE_ENV !== "production" && !isAnnotation(e) && die("Cannot annotate '" + Bi.name_ + "." + Zi.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !isOverride(e) && hasProp(Bi.appliedAnnotations_, Zi)) {
    var Qi = Bi.name_ + "." + Zi.toString(), ea = Bi.appliedAnnotations_[Zi].annotationType_, ra = e.annotationType_;
    die("Cannot apply '" + ra + "' to '" + Qi + "':" + (`
The field is already annotated with '` + ea + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var ENTRY_0 = /* @__PURE__ */ createArrayEntryDescriptor(0), safariPrototypeSetterInheritanceBug = /* @__PURE__ */ function() {
  var Bi = !1, e = {};
  return Object.defineProperty(e, "0", {
    set: function() {
      Bi = !0;
    }
  }), Object.create(e)[0] = 1, Bi === !1;
}(), OBSERVABLE_ARRAY_BUFFER_SIZE = 0, StubArray = function() {
};
function inherit(Bi, e) {
  Object.setPrototypeOf ? Object.setPrototypeOf(Bi.prototype, e) : Bi.prototype.__proto__ !== void 0 ? Bi.prototype.__proto__ = e : Bi.prototype = e;
}
inherit(StubArray, Array.prototype);
var LegacyObservableArray = /* @__PURE__ */ function(Bi, e, Zi) {
  _inheritsLoose(Qi, Bi);
  function Qi(ra, na, ia, fa) {
    var La;
    return ia === void 0 && (ia = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray"), fa === void 0 && (fa = !1), La = Bi.call(this) || this, initObservable(function() {
      var Va = new ObservableArrayAdministration(ia, na, fa, !0);
      Va.proxy_ = _assertThisInitialized(La), addHiddenFinalProp(_assertThisInitialized(La), $mobx, Va), ra && ra.length && La.spliceWithArray(0, 0, ra), safariPrototypeSetterInheritanceBug && Object.defineProperty(_assertThisInitialized(La), "0", ENTRY_0);
    }), La;
  }
  var ea = Qi.prototype;
  return ea.concat = function() {
    this[$mobx].atom_.reportObserved();
    for (var na = arguments.length, ia = new Array(na), fa = 0; fa < na; fa++)
      ia[fa] = arguments[fa];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      ia.map(function(La) {
        return isObservableArray(La) ? La.slice() : La;
      })
    );
  }, ea[Zi] = function() {
    var ra = this, na = 0;
    return makeIterable({
      next: function() {
        return na < ra.length ? {
          value: ra[na++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, _createClass(Qi, [{
    key: "length",
    get: function() {
      return this[$mobx].getArrayLength_();
    },
    set: function(na) {
      this[$mobx].setArrayLength_(na);
    }
  }, {
    key: e,
    get: function() {
      return "Array";
    }
  }]), Qi;
}(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(Bi) {
  var e = Bi[0], Zi = Bi[1];
  e !== "concat" && addHiddenProp(LegacyObservableArray.prototype, e, Zi);
});
function createArrayEntryDescriptor(Bi) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[$mobx].get_(Bi);
    },
    set: function(Zi) {
      this[$mobx].set_(Bi, Zi);
    }
  };
}
function createArrayBufferItem(Bi) {
  defineProperty(LegacyObservableArray.prototype, "" + Bi, createArrayEntryDescriptor(Bi));
}
function reserveArrayBuffer(Bi) {
  if (Bi > OBSERVABLE_ARRAY_BUFFER_SIZE) {
    for (var e = OBSERVABLE_ARRAY_BUFFER_SIZE; e < Bi + 100; e++)
      createArrayBufferItem(e);
    OBSERVABLE_ARRAY_BUFFER_SIZE = Bi;
  }
}
reserveArrayBuffer(1e3);
function createLegacyArray(Bi, e, Zi) {
  return new LegacyObservableArray(Bi, e, Zi);
}
function getAtom(Bi, e) {
  if (typeof Bi == "object" && Bi !== null) {
    if (isObservableArray(Bi))
      return e !== void 0 && die(23), Bi[$mobx].atom_;
    if (isObservableSet(Bi))
      return Bi.atom_;
    if (isObservableMap(Bi)) {
      if (e === void 0)
        return Bi.keysAtom_;
      var Zi = Bi.data_.get(e) || Bi.hasMap_.get(e);
      return Zi || die(25, e, getDebugName(Bi)), Zi;
    }
    if (isObservableObject(Bi)) {
      if (!e)
        return die(26);
      var Qi = Bi[$mobx].values_.get(e);
      return Qi || die(27, e, getDebugName(Bi)), Qi;
    }
    if (isAtom(Bi) || isComputedValue(Bi) || isReaction(Bi))
      return Bi;
  } else if (isFunction$1(Bi) && isReaction(Bi[$mobx]))
    return Bi[$mobx];
  die(28);
}
function getAdministration$1(Bi, e) {
  if (Bi || die(29), isAtom(Bi) || isComputedValue(Bi) || isReaction(Bi) || isObservableMap(Bi) || isObservableSet(Bi))
    return Bi;
  if (Bi[$mobx])
    return Bi[$mobx];
  die(24, Bi);
}
function getDebugName(Bi, e) {
  var Zi;
  if (e !== void 0)
    Zi = getAtom(Bi, e);
  else {
    if (isAction(Bi))
      return Bi.name;
    isObservableObject(Bi) || isObservableMap(Bi) || isObservableSet(Bi) ? Zi = getAdministration$1(Bi) : Zi = getAtom(Bi);
  }
  return Zi.name_;
}
function initObservable(Bi) {
  var e = untrackedStart(), Zi = allowStateChangesStart(!0);
  startBatch();
  try {
    return Bi();
  } finally {
    endBatch(), allowStateChangesEnd(Zi), untrackedEnd(e);
  }
}
var toString = objectPrototype.toString;
function deepEqual$1(Bi, e, Zi) {
  return Zi === void 0 && (Zi = -1), eq(Bi, e, Zi);
}
function eq(Bi, e, Zi, Qi, ea) {
  if (Bi === e)
    return Bi !== 0 || 1 / Bi === 1 / e;
  if (Bi == null || e == null)
    return !1;
  if (Bi !== Bi)
    return e !== e;
  var ra = typeof Bi;
  if (ra !== "function" && ra !== "object" && typeof e != "object")
    return !1;
  var na = toString.call(Bi);
  if (na !== toString.call(e))
    return !1;
  switch (na) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + Bi == "" + e;
    case "[object Number]":
      return +Bi != +Bi ? +e != +e : +Bi == 0 ? 1 / +Bi === 1 / e : +Bi == +e;
    case "[object Date]":
    case "[object Boolean]":
      return +Bi == +e;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(Bi) === Symbol.valueOf.call(e);
    case "[object Map]":
    case "[object Set]":
      Zi >= 0 && Zi++;
      break;
  }
  Bi = unwrap(Bi), e = unwrap(e);
  var ia = na === "[object Array]";
  if (!ia) {
    if (typeof Bi != "object" || typeof e != "object")
      return !1;
    var fa = Bi.constructor, La = e.constructor;
    if (fa !== La && !(isFunction$1(fa) && fa instanceof fa && isFunction$1(La) && La instanceof La) && "constructor" in Bi && "constructor" in e)
      return !1;
  }
  if (Zi === 0)
    return !1;
  Zi < 0 && (Zi = -1), Qi = Qi || [], ea = ea || [];
  for (var Va = Qi.length; Va--; )
    if (Qi[Va] === Bi)
      return ea[Va] === e;
  if (Qi.push(Bi), ea.push(e), ia) {
    if (Va = Bi.length, Va !== e.length)
      return !1;
    for (; Va--; )
      if (!eq(Bi[Va], e[Va], Zi - 1, Qi, ea))
        return !1;
  } else {
    var to = Object.keys(Bi), ro;
    if (Va = to.length, Object.keys(e).length !== Va)
      return !1;
    for (; Va--; )
      if (ro = to[Va], !(hasProp(e, ro) && eq(Bi[ro], e[ro], Zi - 1, Qi, ea)))
        return !1;
  }
  return Qi.pop(), ea.pop(), !0;
}
function unwrap(Bi) {
  return isObservableArray(Bi) ? Bi.slice() : isES6Map(Bi) || isObservableMap(Bi) || isES6Set(Bi) || isObservableSet(Bi) ? Array.from(Bi.entries()) : Bi;
}
function makeIterable(Bi) {
  return Bi[Symbol.iterator] = getSelf, Bi;
}
function getSelf() {
  return this;
}
function isAnnotation(Bi) {
  return (
    // Can be function
    Bi instanceof Object && typeof Bi.annotationType_ == "string" && isFunction$1(Bi.make_) && isFunction$1(Bi.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(Bi) {
  var e = getGlobal();
  typeof e[Bi] > "u" && die("MobX requires global '" + Bi + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy,
  extras: {
    getDebugName
  },
  $mobx
});
if (!useState)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!makeObservable)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function defaultNoopBatch(Bi) {
  Bi();
}
function observerBatching(Bi) {
  Bi || (Bi = defaultNoopBatch, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), configure({ reactionScheduler: Bi });
}
function printDebugValue(Bi) {
  return getDependencyTree(Bi);
}
var REGISTRY_FINALIZE_AFTER = 1e4, REGISTRY_SWEEP_INTERVAL = 1e4, TimerBasedFinalizationRegistry = (
  /** @class */
  function() {
    function Bi(e) {
      var Zi = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(Qi) {
          Qi === void 0 && (Qi = REGISTRY_FINALIZE_AFTER), clearTimeout(Zi.sweepTimeout), Zi.sweepTimeout = void 0;
          var ea = Date.now();
          Zi.registrations.forEach(function(ra, na) {
            ea - ra.registeredAt >= Qi && (Zi.finalize(ra.value), Zi.registrations.delete(na));
          }), Zi.registrations.size > 0 && Zi.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          Zi.sweep(0);
        }
      });
    }
    return Object.defineProperty(Bi.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e, Zi, Qi) {
        this.registrations.set(Qi, {
          value: Zi,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(Bi.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e) {
        this.registrations.delete(e);
      }
    }), Object.defineProperty(Bi.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, REGISTRY_SWEEP_INTERVAL));
      }
    }), Bi;
  }()
), UniversalFinalizationRegistry = typeof FinalizationRegistry < "u" ? FinalizationRegistry : TimerBasedFinalizationRegistry, observerFinalizationRegistry = new UniversalFinalizationRegistry(function(Bi) {
  var e;
  (e = Bi.reaction) === null || e === void 0 || e.dispose(), Bi.reaction = null;
}), getServerSnapshot = function() {
};
function createReaction$1(Bi) {
  Bi.reaction = new Reaction("observer".concat(Bi.name), function() {
    var e;
    Bi.stateVersion = Symbol(), (e = Bi.onStoreChange) === null || e === void 0 || e.call(Bi);
  });
}
function useObserver(Bi, e) {
  e === void 0 && (e = "observed");
  var Zi = a__default.useRef(null);
  if (!Zi.current) {
    var Qi = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: e,
      subscribe: function(ia) {
        return observerFinalizationRegistry.unregister(Qi), Qi.onStoreChange = ia, Qi.reaction || (createReaction$1(Qi), Qi.stateVersion = Symbol()), function() {
          var fa;
          Qi.onStoreChange = null, (fa = Qi.reaction) === null || fa === void 0 || fa.dispose(), Qi.reaction = null;
        };
      },
      getSnapshot: function() {
        return Qi.stateVersion;
      }
    };
    Zi.current = Qi;
  }
  var ea = Zi.current;
  ea.reaction || (createReaction$1(ea), observerFinalizationRegistry.register(Zi, ea, ea)), a__default.useDebugValue(ea.reaction, printDebugValue), shimExports.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    ea.subscribe,
    ea.getSnapshot,
    getServerSnapshot
  );
  var ra, na;
  if (ea.reaction.track(function() {
    try {
      ra = Bi();
    } catch (ia) {
      na = ia;
    }
  }), na)
    throw na;
  return ra;
}
var warnObserverOptionsDeprecated = !0, hasSymbol = typeof Symbol == "function" && Symbol.for, ReactForwardRefSymbol = hasSymbol ? Symbol.for("react.forward_ref") : typeof forwardRef == "function" && forwardRef(function(Bi) {
  return null;
}).$$typeof, ReactMemoSymbol = hasSymbol ? Symbol.for("react.memo") : typeof memo == "function" && memo(function(Bi) {
  return null;
}).$$typeof;
function observer$1(Bi, e) {
  var Zi;
  if (process.env.NODE_ENV, ReactMemoSymbol && Bi.$$typeof === ReactMemoSymbol)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var Qi = (Zi = void 0) !== null && Zi !== void 0 ? Zi : !1, ea = Bi, ra = Bi.displayName || Bi.name;
  if (ReactForwardRefSymbol && Bi.$$typeof === ReactForwardRefSymbol && (Qi = !0, ea = Bi.render, typeof ea != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var na = function(ia, fa) {
    return useObserver(function() {
      return ea(ia, fa);
    }, ra);
  };
  return na.displayName = Bi.displayName, Object.defineProperty(na, "name", {
    value: Bi.name,
    writable: !0,
    configurable: !0
  }), Bi.contextTypes && (na.contextTypes = Bi.contextTypes), Qi && (na = forwardRef(na)), na = memo(na), copyStaticProperties(Bi, na), process.env.NODE_ENV !== "production" && Object.defineProperty(na, "contextTypes", {
    set: function() {
      var ia, fa;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((ia = this.type) === null || ia === void 0 ? void 0 : ia.displayName) || ((fa = this.type) === null || fa === void 0 ? void 0 : fa.name) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), na;
}
var hoistBlackList = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function copyStaticProperties(Bi, e) {
  Object.keys(Bi).forEach(function(Zi) {
    hoistBlackList[Zi] || Object.defineProperty(e, Zi, Object.getOwnPropertyDescriptor(Bi, Zi));
  });
}
process.env.NODE_ENV;
function useLocalObservable(Bi, e) {
  return useState(function() {
    return observable(Bi(), e, { autoBind: !0 });
  })[0];
}
var _a$1;
observerBatching(unstable_batchedUpdates);
_a$1 = observerFinalizationRegistry.finalizeAllImmediately;
function shallowEqual$1(Bi, e) {
  if (is$1(Bi, e))
    return !0;
  if (typeof Bi != "object" || Bi === null || typeof e != "object" || e === null)
    return !1;
  var Zi = Object.keys(Bi), Qi = Object.keys(e);
  if (Zi.length !== Qi.length)
    return !1;
  for (var ea = 0; ea < Zi.length; ea++)
    if (!Object.hasOwnProperty.call(e, Zi[ea]) || !is$1(Bi[Zi[ea]], e[Zi[ea]]))
      return !1;
  return !0;
}
function is$1(Bi, e) {
  return Bi === e ? Bi !== 0 || 1 / Bi === 1 / e : Bi !== Bi && e !== e;
}
var mobxMixins = /* @__PURE__ */ Symbol("patchMixins"), mobxPatchedDefinition = /* @__PURE__ */ Symbol("patchedDefinition");
function getMixins(Bi, e) {
  var Zi = Bi[mobxMixins] = Bi[mobxMixins] || {}, Qi = Zi[e] = Zi[e] || {};
  return Qi.locks = Qi.locks || 0, Qi.methods = Qi.methods || [], Qi;
}
function wrapper(Bi, e) {
  for (var Zi = this, Qi = arguments.length, ea = new Array(Qi > 2 ? Qi - 2 : 0), ra = 2; ra < Qi; ra++)
    ea[ra - 2] = arguments[ra];
  e.locks++;
  try {
    var na;
    return Bi != null && (na = Bi.apply(this, ea)), na;
  } finally {
    e.locks--, e.locks === 0 && e.methods.forEach(function(ia) {
      ia.apply(Zi, ea);
    });
  }
}
function wrapFunction(Bi, e) {
  var Zi = function() {
    for (var ea = arguments.length, ra = new Array(ea), na = 0; na < ea; na++)
      ra[na] = arguments[na];
    wrapper.call.apply(wrapper, [this, Bi, e].concat(ra));
  };
  return Zi;
}
function patch(Bi, e, Zi) {
  var Qi = getMixins(Bi, e);
  Qi.methods.indexOf(Zi) < 0 && Qi.methods.push(Zi);
  var ea = Object.getOwnPropertyDescriptor(Bi, e);
  if (!(ea && ea[mobxPatchedDefinition])) {
    var ra = Bi[e], na = createDefinition(Bi, e, ea ? ea.enumerable : void 0, Qi, ra);
    Object.defineProperty(Bi, e, na);
  }
}
function createDefinition(Bi, e, Zi, Qi, ea) {
  var ra, na = wrapFunction(ea, Qi);
  return ra = {}, ra[mobxPatchedDefinition] = !0, ra.get = function() {
    return na;
  }, ra.set = function(fa) {
    if (this === Bi)
      na = wrapFunction(fa, Qi);
    else {
      var La = createDefinition(this, e, Zi, Qi, fa);
      Object.defineProperty(this, e, La);
    }
  }, ra.configurable = !0, ra.enumerable = Zi, ra;
}
var administrationSymbol = /* @__PURE__ */ Symbol("ObserverAdministration"), isMobXReactObserverSymbol = /* @__PURE__ */ Symbol("isMobXReactObserver"), observablePropDescriptors;
process.env.NODE_ENV !== "production" && (observablePropDescriptors = {
  props: /* @__PURE__ */ createObservablePropDescriptor("props"),
  state: /* @__PURE__ */ createObservablePropDescriptor("state"),
  context: /* @__PURE__ */ createObservablePropDescriptor("context")
});
function getAdministration(Bi) {
  var e;
  return (e = Bi[administrationSymbol]) != null ? e : Bi[administrationSymbol] = {
    reaction: null,
    mounted: !1,
    reactionInvalidatedBeforeMount: !1,
    forceUpdate: null,
    name: getDisplayName(Bi.constructor),
    state: void 0,
    props: void 0,
    context: void 0
  };
}
function makeClassComponentObserver(Bi) {
  var e = Bi.prototype;
  if (Bi[isMobXReactObserverSymbol]) {
    var Zi = getDisplayName(Bi);
    throw new Error("The provided component class (" + Zi + ") has already been declared as an observer component.");
  } else
    Bi[isMobXReactObserverSymbol] = !0;
  if (e.componentWillReact)
    throw new Error("The componentWillReact life-cycle event is no longer supported");
  if (Bi.__proto__ !== PureComponent) {
    if (!e.shouldComponentUpdate)
      e.shouldComponentUpdate = observerSCU;
    else if (e.shouldComponentUpdate !== observerSCU)
      throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }
  process.env.NODE_ENV !== "production" && Object.defineProperties(e, observablePropDescriptors);
  var Qi = e.render;
  if (typeof Qi != "function") {
    var ea = getDisplayName(Bi);
    throw new Error("[mobx-react] class component (" + ea + ") is missing `render` method.\n`observer` requires `render` being a function defined on prototype.\n`render = () => {}` or `render = function() {}` is not supported.");
  }
  e.render = function() {
    return Object.defineProperty(this, "render", {
      // There is no safe way to replace render, therefore it's forbidden.
      configurable: !1,
      writable: !1,
      value: createReactiveRender.call(this, Qi)
    }), this.render();
  };
  var ra = e.componentDidMount;
  return e.componentDidMount = function() {
    var na = this;
    if (process.env.NODE_ENV !== "production" && this.componentDidMount !== Object.getPrototypeOf(this).componentDidMount) {
      var ia = getDisplayName(Bi);
      throw new Error("[mobx-react] `observer(" + ia + ").componentDidMount` must be defined on prototype.\n`componentDidMount = () => {}` or `componentDidMount = function() {}` is not supported.");
    }
    var fa = getAdministration(this);
    return fa.mounted = !0, observerFinalizationRegistry.unregister(this), fa.forceUpdate = function() {
      return na.forceUpdate();
    }, (!fa.reaction || fa.reactionInvalidatedBeforeMount) && fa.forceUpdate(), ra?.apply(this, arguments);
  }, patch(e, "componentWillUnmount", function() {
    var na, ia = getAdministration(this);
    (na = ia.reaction) == null || na.dispose(), ia.reaction = null, ia.forceUpdate = null, ia.mounted = !1, ia.reactionInvalidatedBeforeMount = !1;
  }), Bi;
}
function getDisplayName(Bi) {
  return Bi.displayName || Bi.name || "<component>";
}
function createReactiveRender(Bi) {
  var e = Bi.bind(this), Zi = getAdministration(this);
  function Qi() {
    Zi.reaction || (Zi.reaction = createReaction(Zi), Zi.mounted || observerFinalizationRegistry.register(this, Zi, this));
    var ea = void 0, ra = void 0;
    if (Zi.reaction.track(function() {
      try {
        ra = allowStateChanges(!1, e);
      } catch (na) {
        ea = na;
      }
    }), ea)
      throw ea;
    return ra;
  }
  return Qi;
}
function createReaction(Bi) {
  return new Reaction(Bi.name + ".render()", function() {
    if (!Bi.mounted) {
      Bi.reactionInvalidatedBeforeMount = !0;
      return;
    }
    try {
      Bi.forceUpdate == null || Bi.forceUpdate();
    } catch {
      var e;
      (e = Bi.reaction) == null || e.dispose(), Bi.reaction = null;
    }
  });
}
function observerSCU(Bi, e) {
  return this.state !== e ? !0 : !shallowEqual$1(this.props, Bi);
}
function createObservablePropDescriptor(Bi) {
  return {
    configurable: !0,
    enumerable: !0,
    get: function() {
      var Zi = getAdministration(this), Qi = getGlobalState().trackingDerivation;
      if (Qi && Qi !== Zi.reaction)
        throw new Error('[mobx-react] Cannot read "' + Zi.name + "." + Bi + `" in a reactive context, as it isn't observable.
                    Please use component lifecycle method to copy the value into a local observable first.
                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations`);
      return Zi[Bi];
    },
    set: function(Zi) {
      getAdministration(this)[Bi] = Zi;
    }
  };
}
function observer(Bi, e) {
  return Bi.isMobxInjector === !0 && console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`"), Object.prototype.isPrototypeOf.call(Component, Bi) || Object.prototype.isPrototypeOf.call(PureComponent, Bi) ? makeClassComponentObserver(Bi) : observer$1(Bi);
}
a__default.version.split(".")[0];
if (!Component)
  throw new Error("mobx-react requires React to be available");
if (!observable)
  throw new Error("mobx-react requires mobx to be available");
const DndContext = createContext({
  dragDropManager: void 0
});
function formatProdErrorMessage(Bi) {
  return "Minified Redux error #" + Bi + "; visit https://redux.js.org/Errors?code=" + Bi + " for the full message or use the non-minified dev environment for full errors. ";
}
var $$observable = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), randomString = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString()
};
function isPlainObject$1(Bi) {
  if (typeof Bi != "object" || Bi === null) return !1;
  for (var e = Bi; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(Bi) === e;
}
function miniKindOf(Bi) {
  if (Bi === void 0) return "undefined";
  if (Bi === null) return "null";
  var e = typeof Bi;
  switch (e) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return e;
  }
  if (Array.isArray(Bi)) return "array";
  if (isDate(Bi)) return "date";
  if (isError(Bi)) return "error";
  var Zi = ctorName(Bi);
  switch (Zi) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return Zi;
  }
  return e.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(Bi) {
  return typeof Bi.constructor == "function" ? Bi.constructor.name : null;
}
function isError(Bi) {
  return Bi instanceof Error || typeof Bi.message == "string" && Bi.constructor && typeof Bi.constructor.stackTraceLimit == "number";
}
function isDate(Bi) {
  return Bi instanceof Date ? !0 : typeof Bi.toDateString == "function" && typeof Bi.getDate == "function" && typeof Bi.setDate == "function";
}
function kindOf(Bi) {
  var e = typeof Bi;
  return process.env.NODE_ENV !== "production" && (e = miniKindOf(Bi)), e;
}
function createStore(Bi, e, Zi) {
  var Qi;
  if (typeof e == "function" && typeof Zi == "function" || typeof Zi == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof e == "function" && typeof Zi > "u" && (Zi = e, e = void 0), typeof Zi < "u") {
    if (typeof Zi != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(Zi) + "'");
    return Zi(createStore)(Bi, e);
  }
  if (typeof Bi != "function")
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(Bi) + "'");
  var ea = Bi, ra = e, na = [], ia = na, fa = !1;
  function La() {
    ia === na && (ia = na.slice());
  }
  function Va() {
    if (fa)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return ra;
  }
  function to(ao) {
    if (typeof ao != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(ao) + "'");
    if (fa)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var io = !0;
    return La(), ia.push(ao), function() {
      if (io) {
        if (fa)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        io = !1, La();
        var Ts = ia.indexOf(ao);
        ia.splice(Ts, 1), na = null;
      }
    };
  }
  function ro(ao) {
    if (!isPlainObject$1(ao))
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(ao) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof ao.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (fa)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : "Reducers may not dispatch actions.");
    try {
      fa = !0, ra = ea(ra, ao);
    } finally {
      fa = !1;
    }
    for (var io = na = ia, xs = 0; xs < io.length; xs++) {
      var Ts = io[xs];
      Ts();
    }
    return ao;
  }
  function no(ao) {
    if (typeof ao != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(ao));
    ea = ao, ro({
      type: ActionTypes.REPLACE
    });
  }
  function eo() {
    var ao, io = to;
    return ao = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(Ts) {
        if (typeof Ts != "object" || Ts === null)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(Ts) + "'");
        function qs() {
          Ts.next && Ts.next(Va());
        }
        qs();
        var Fs = io(qs);
        return {
          unsubscribe: Fs
        };
      }
    }, ao[$$observable] = function() {
      return this;
    }, ao;
  }
  return ro({
    type: ActionTypes.INIT
  }), Qi = {
    dispatch: ro,
    subscribe: to,
    getState: Va,
    replaceReducer: no
  }, Qi[$$observable] = eo, Qi;
}
function warning(Bi) {
  typeof console < "u" && typeof console.error == "function" && console.error(Bi);
  try {
    throw new Error(Bi);
  } catch {
  }
}
function isCrushed() {
}
process.env.NODE_ENV !== "production" && typeof isCrushed.name == "string" && isCrushed.name !== "isCrushed" && warning('You are currently using minified code outside of NODE_ENV === "production". This means that you are running a slower development build of Redux. You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) to ensure you have the correct code for your production build.');
function invariant(Bi, e, ...Zi) {
  if (isProduction() && e === void 0)
    throw new Error("invariant requires an error message argument");
  if (!Bi) {
    let Qi;
    if (e === void 0)
      Qi = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      let ea = 0;
      Qi = new Error(e.replace(/%s/g, function() {
        return Zi[ea++];
      })), Qi.name = "Invariant Violation";
    }
    throw Qi.framesToPop = 1, Qi;
  }
}
function isProduction() {
  return typeof process < "u" && process.env.NODE_ENV === "production";
}
function get$1(Bi, e, Zi) {
  return e.split(".").reduce(
    (Qi, ea) => Qi && Qi[ea] ? Qi[ea] : Zi || null,
    Bi
  );
}
function without$1(Bi, e) {
  return Bi.filter(
    (Zi) => Zi !== e
  );
}
function isObject$2(Bi) {
  return typeof Bi == "object";
}
function xor(Bi, e) {
  const Zi = /* @__PURE__ */ new Map(), Qi = (ra) => {
    Zi.set(ra, Zi.has(ra) ? Zi.get(ra) + 1 : 1);
  };
  Bi.forEach(Qi), e.forEach(Qi);
  const ea = [];
  return Zi.forEach((ra, na) => {
    ra === 1 && ea.push(na);
  }), ea;
}
function intersection(Bi, e) {
  return Bi.filter(
    (Zi) => e.indexOf(Zi) > -1
  );
}
const INIT_COORDS = "dnd-core/INIT_COORDS", BEGIN_DRAG = "dnd-core/BEGIN_DRAG", PUBLISH_DRAG_SOURCE = "dnd-core/PUBLISH_DRAG_SOURCE", HOVER = "dnd-core/HOVER", DROP = "dnd-core/DROP", END_DRAG = "dnd-core/END_DRAG";
function setClientOffset(Bi, e) {
  return {
    type: INIT_COORDS,
    payload: {
      sourceClientOffset: e || null,
      clientOffset: Bi || null
    }
  };
}
const ResetCoordinatesAction = {
  type: INIT_COORDS,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function createBeginDrag(Bi) {
  return function(Zi = [], Qi = {
    publishSource: !0
  }) {
    const { publishSource: ea = !0, clientOffset: ra, getSourceClientOffset: na } = Qi, ia = Bi.getMonitor(), fa = Bi.getRegistry();
    Bi.dispatch(setClientOffset(ra)), verifyInvariants$1(Zi, ia, fa);
    const La = getDraggableSource(Zi, ia);
    if (La == null) {
      Bi.dispatch(ResetCoordinatesAction);
      return;
    }
    let Va = null;
    if (ra) {
      if (!na)
        throw new Error("getSourceClientOffset must be defined");
      verifyGetSourceClientOffsetIsFunction(na), Va = na(La);
    }
    Bi.dispatch(setClientOffset(ra, Va));
    const ro = fa.getSource(La).beginDrag(ia, La);
    if (ro == null)
      return;
    verifyItemIsObject(ro), fa.pinSource(La);
    const no = fa.getSourceType(La);
    return {
      type: BEGIN_DRAG,
      payload: {
        itemType: no,
        item: ro,
        sourceId: La,
        clientOffset: ra || null,
        sourceClientOffset: Va || null,
        isSourcePublic: !!ea
      }
    };
  };
}
function verifyInvariants$1(Bi, e, Zi) {
  invariant(!e.isDragging(), "Cannot call beginDrag while dragging."), Bi.forEach(function(Qi) {
    invariant(Zi.getSource(Qi), "Expected sourceIds to be registered.");
  });
}
function verifyGetSourceClientOffsetIsFunction(Bi) {
  invariant(typeof Bi == "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function verifyItemIsObject(Bi) {
  invariant(isObject$2(Bi), "Item must be an object.");
}
function getDraggableSource(Bi, e) {
  let Zi = null;
  for (let Qi = Bi.length - 1; Qi >= 0; Qi--)
    if (e.canDragSource(Bi[Qi])) {
      Zi = Bi[Qi];
      break;
    }
  return Zi;
}
function _defineProperty$6(Bi, e, Zi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Zi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Zi, Bi;
}
function _objectSpread$6(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Zi = arguments[e] != null ? arguments[e] : {}, Qi = Object.keys(Zi);
    typeof Object.getOwnPropertySymbols == "function" && (Qi = Qi.concat(Object.getOwnPropertySymbols(Zi).filter(function(ea) {
      return Object.getOwnPropertyDescriptor(Zi, ea).enumerable;
    }))), Qi.forEach(function(ea) {
      _defineProperty$6(Bi, ea, Zi[ea]);
    });
  }
  return Bi;
}
function createDrop(Bi) {
  return function(Zi = {}) {
    const Qi = Bi.getMonitor(), ea = Bi.getRegistry();
    verifyInvariants(Qi), getDroppableTargets(Qi).forEach((na, ia) => {
      const fa = determineDropResult(na, ia, ea, Qi), La = {
        type: DROP,
        payload: {
          dropResult: _objectSpread$6({}, Zi, fa)
        }
      };
      Bi.dispatch(La);
    });
  };
}
function verifyInvariants(Bi) {
  invariant(Bi.isDragging(), "Cannot call drop while not dragging."), invariant(!Bi.didDrop(), "Cannot call drop twice during one drag operation.");
}
function determineDropResult(Bi, e, Zi, Qi) {
  const ea = Zi.getTarget(Bi);
  let ra = ea ? ea.drop(Qi, Bi) : void 0;
  return verifyDropResultType(ra), typeof ra > "u" && (ra = e === 0 ? {} : Qi.getDropResult()), ra;
}
function verifyDropResultType(Bi) {
  invariant(typeof Bi > "u" || isObject$2(Bi), "Drop result must either be an object or undefined.");
}
function getDroppableTargets(Bi) {
  const e = Bi.getTargetIds().filter(Bi.canDropOnTarget, Bi);
  return e.reverse(), e;
}
function createEndDrag(Bi) {
  return function() {
    const Zi = Bi.getMonitor(), Qi = Bi.getRegistry();
    verifyIsDragging(Zi);
    const ea = Zi.getSourceId();
    return ea != null && (Qi.getSource(ea, !0).endDrag(Zi, ea), Qi.unpinSource()), {
      type: END_DRAG
    };
  };
}
function verifyIsDragging(Bi) {
  invariant(Bi.isDragging(), "Cannot call endDrag while not dragging.");
}
function matchesType(Bi, e) {
  return e === null ? Bi === null : Array.isArray(Bi) ? Bi.some(
    (Zi) => Zi === e
  ) : Bi === e;
}
function createHover(Bi) {
  return function(Zi, { clientOffset: Qi } = {}) {
    verifyTargetIdsIsArray(Zi);
    const ea = Zi.slice(0), ra = Bi.getMonitor(), na = Bi.getRegistry(), ia = ra.getItemType();
    return removeNonMatchingTargetIds(ea, na, ia), checkInvariants(ea, ra, na), hoverAllTargets(ea, ra, na), {
      type: HOVER,
      payload: {
        targetIds: ea,
        clientOffset: Qi || null
      }
    };
  };
}
function verifyTargetIdsIsArray(Bi) {
  invariant(Array.isArray(Bi), "Expected targetIds to be an array.");
}
function checkInvariants(Bi, e, Zi) {
  invariant(e.isDragging(), "Cannot call hover while not dragging."), invariant(!e.didDrop(), "Cannot call hover after drop.");
  for (let Qi = 0; Qi < Bi.length; Qi++) {
    const ea = Bi[Qi];
    invariant(Bi.lastIndexOf(ea) === Qi, "Expected targetIds to be unique in the passed array.");
    const ra = Zi.getTarget(ea);
    invariant(ra, "Expected targetIds to be registered.");
  }
}
function removeNonMatchingTargetIds(Bi, e, Zi) {
  for (let Qi = Bi.length - 1; Qi >= 0; Qi--) {
    const ea = Bi[Qi], ra = e.getTargetType(ea);
    matchesType(ra, Zi) || Bi.splice(Qi, 1);
  }
}
function hoverAllTargets(Bi, e, Zi) {
  Bi.forEach(function(Qi) {
    Zi.getTarget(Qi).hover(e, Qi);
  });
}
function createPublishDragSource(Bi) {
  return function() {
    if (Bi.getMonitor().isDragging())
      return {
        type: PUBLISH_DRAG_SOURCE
      };
  };
}
function createDragDropActions(Bi) {
  return {
    beginDrag: createBeginDrag(Bi),
    publishDragSource: createPublishDragSource(Bi),
    hover: createHover(Bi),
    drop: createDrop(Bi),
    endDrag: createEndDrag(Bi)
  };
}
class DragDropManagerImpl {
  receiveBackend(e) {
    this.backend = e;
  }
  getMonitor() {
    return this.monitor;
  }
  getBackend() {
    return this.backend;
  }
  getRegistry() {
    return this.monitor.registry;
  }
  getActions() {
    const e = this, { dispatch: Zi } = this.store;
    function Qi(ra) {
      return (...na) => {
        const ia = ra.apply(e, na);
        typeof ia < "u" && Zi(ia);
      };
    }
    const ea = createDragDropActions(this);
    return Object.keys(ea).reduce((ra, na) => {
      const ia = ea[na];
      return ra[na] = Qi(ia), ra;
    }, {});
  }
  dispatch(e) {
    this.store.dispatch(e);
  }
  constructor(e, Zi) {
    this.isSetUp = !1, this.handleRefCountChange = () => {
      const Qi = this.store.getState().refCount > 0;
      this.backend && (Qi && !this.isSetUp ? (this.backend.setup(), this.isSetUp = !0) : !Qi && this.isSetUp && (this.backend.teardown(), this.isSetUp = !1));
    }, this.store = e, this.monitor = Zi, e.subscribe(this.handleRefCountChange);
  }
}
function add(Bi, e) {
  return {
    x: Bi.x + e.x,
    y: Bi.y + e.y
  };
}
function subtract(Bi, e) {
  return {
    x: Bi.x - e.x,
    y: Bi.y - e.y
  };
}
function getSourceClientOffset(Bi) {
  const { clientOffset: e, initialClientOffset: Zi, initialSourceClientOffset: Qi } = Bi;
  return !e || !Zi || !Qi ? null : subtract(add(e, Qi), Zi);
}
function getDifferenceFromInitialOffset(Bi) {
  const { clientOffset: e, initialClientOffset: Zi } = Bi;
  return !e || !Zi ? null : subtract(e, Zi);
}
const NONE = [], ALL = [];
NONE.__IS_NONE__ = !0;
ALL.__IS_ALL__ = !0;
function areDirty(Bi, e) {
  return Bi === NONE ? !1 : Bi === ALL || typeof e > "u" ? !0 : intersection(e, Bi).length > 0;
}
class DragDropMonitorImpl {
  subscribeToStateChange(e, Zi = {}) {
    const { handlerIds: Qi } = Zi;
    invariant(typeof e == "function", "listener must be a function."), invariant(typeof Qi > "u" || Array.isArray(Qi), "handlerIds, when specified, must be an array of strings.");
    let ea = this.store.getState().stateId;
    const ra = () => {
      const na = this.store.getState(), ia = na.stateId;
      try {
        ia === ea || ia === ea + 1 && !areDirty(na.dirtyHandlerIds, Qi) || e();
      } finally {
        ea = ia;
      }
    };
    return this.store.subscribe(ra);
  }
  subscribeToOffsetChange(e) {
    invariant(typeof e == "function", "listener must be a function.");
    let Zi = this.store.getState().dragOffset;
    const Qi = () => {
      const ea = this.store.getState().dragOffset;
      ea !== Zi && (Zi = ea, e());
    };
    return this.store.subscribe(Qi);
  }
  canDragSource(e) {
    if (!e)
      return !1;
    const Zi = this.registry.getSource(e);
    return invariant(Zi, `Expected to find a valid source. sourceId=${e}`), this.isDragging() ? !1 : Zi.canDrag(this, e);
  }
  canDropOnTarget(e) {
    if (!e)
      return !1;
    const Zi = this.registry.getTarget(e);
    if (invariant(Zi, `Expected to find a valid target. targetId=${e}`), !this.isDragging() || this.didDrop())
      return !1;
    const Qi = this.registry.getTargetType(e), ea = this.getItemType();
    return matchesType(Qi, ea) && Zi.canDrop(this, e);
  }
  isDragging() {
    return !!this.getItemType();
  }
  isDraggingSource(e) {
    if (!e)
      return !1;
    const Zi = this.registry.getSource(e, !0);
    if (invariant(Zi, `Expected to find a valid source. sourceId=${e}`), !this.isDragging() || !this.isSourcePublic())
      return !1;
    const Qi = this.registry.getSourceType(e), ea = this.getItemType();
    return Qi !== ea ? !1 : Zi.isDragging(this, e);
  }
  isOverTarget(e, Zi = {
    shallow: !1
  }) {
    if (!e)
      return !1;
    const { shallow: Qi } = Zi;
    if (!this.isDragging())
      return !1;
    const ea = this.registry.getTargetType(e), ra = this.getItemType();
    if (ra && !matchesType(ea, ra))
      return !1;
    const na = this.getTargetIds();
    if (!na.length)
      return !1;
    const ia = na.indexOf(e);
    return Qi ? ia === na.length - 1 : ia > -1;
  }
  getItemType() {
    return this.store.getState().dragOperation.itemType;
  }
  getItem() {
    return this.store.getState().dragOperation.item;
  }
  getSourceId() {
    return this.store.getState().dragOperation.sourceId;
  }
  getTargetIds() {
    return this.store.getState().dragOperation.targetIds;
  }
  getDropResult() {
    return this.store.getState().dragOperation.dropResult;
  }
  didDrop() {
    return this.store.getState().dragOperation.didDrop;
  }
  isSourcePublic() {
    return !!this.store.getState().dragOperation.isSourcePublic;
  }
  getInitialClientOffset() {
    return this.store.getState().dragOffset.initialClientOffset;
  }
  getInitialSourceClientOffset() {
    return this.store.getState().dragOffset.initialSourceClientOffset;
  }
  getClientOffset() {
    return this.store.getState().dragOffset.clientOffset;
  }
  getSourceClientOffset() {
    return getSourceClientOffset(this.store.getState().dragOffset);
  }
  getDifferenceFromInitialOffset() {
    return getDifferenceFromInitialOffset(this.store.getState().dragOffset);
  }
  constructor(e, Zi) {
    this.store = e, this.registry = Zi;
  }
}
const scope = typeof global < "u" ? global : self, BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
function makeRequestCallFromTimer(Bi) {
  return function() {
    const Zi = setTimeout(ea, 0), Qi = setInterval(ea, 50);
    function ea() {
      clearTimeout(Zi), clearInterval(Qi), Bi();
    }
  };
}
function makeRequestCallFromMutationObserver(Bi) {
  let e = 1;
  const Zi = new BrowserMutationObserver(Bi), Qi = document.createTextNode("");
  return Zi.observe(Qi, {
    characterData: !0
  }), function() {
    e = -e, Qi.data = e;
  };
}
const makeRequestCall = typeof BrowserMutationObserver == "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  makeRequestCallFromMutationObserver
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  makeRequestCallFromTimer
);
class AsapQueue {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(e) {
    const { queue: Zi, requestFlush: Qi } = this;
    Zi.length || (Qi(), this.flushing = !0), Zi[Zi.length] = e;
  }
  constructor() {
    this.queue = [], this.pendingErrors = [], this.flushing = !1, this.index = 0, this.capacity = 1024, this.flush = () => {
      const { queue: e } = this;
      for (; this.index < e.length; ) {
        const Zi = this.index;
        if (this.index++, e[Zi].call(), this.index > this.capacity) {
          for (let Qi = 0, ea = e.length - this.index; Qi < ea; Qi++)
            e[Qi] = e[Qi + this.index];
          e.length -= this.index, this.index = 0;
        }
      }
      e.length = 0, this.index = 0, this.flushing = !1;
    }, this.registerPendingError = (e) => {
      this.pendingErrors.push(e), this.requestErrorThrow();
    }, this.requestFlush = makeRequestCall(this.flush), this.requestErrorThrow = makeRequestCallFromTimer(() => {
      if (this.pendingErrors.length)
        throw this.pendingErrors.shift();
    });
  }
}
class RawTask {
  call() {
    try {
      this.task && this.task();
    } catch (e) {
      this.onError(e);
    } finally {
      this.task = null, this.release(this);
    }
  }
  constructor(e, Zi) {
    this.onError = e, this.release = Zi, this.task = null;
  }
}
class TaskFactory {
  create(e) {
    const Zi = this.freeTasks, Qi = Zi.length ? Zi.pop() : new RawTask(
      this.onError,
      (ea) => Zi[Zi.length] = ea
    );
    return Qi.task = e, Qi;
  }
  constructor(e) {
    this.onError = e, this.freeTasks = [];
  }
}
const asapQueue = new AsapQueue(), taskFactory = new TaskFactory(asapQueue.registerPendingError);
function asap(Bi) {
  asapQueue.enqueueTask(taskFactory.create(Bi));
}
const ADD_SOURCE = "dnd-core/ADD_SOURCE", ADD_TARGET = "dnd-core/ADD_TARGET", REMOVE_SOURCE = "dnd-core/REMOVE_SOURCE", REMOVE_TARGET = "dnd-core/REMOVE_TARGET";
function addSource(Bi) {
  return {
    type: ADD_SOURCE,
    payload: {
      sourceId: Bi
    }
  };
}
function addTarget(Bi) {
  return {
    type: ADD_TARGET,
    payload: {
      targetId: Bi
    }
  };
}
function removeSource(Bi) {
  return {
    type: REMOVE_SOURCE,
    payload: {
      sourceId: Bi
    }
  };
}
function removeTarget(Bi) {
  return {
    type: REMOVE_TARGET,
    payload: {
      targetId: Bi
    }
  };
}
function validateSourceContract(Bi) {
  invariant(typeof Bi.canDrag == "function", "Expected canDrag to be a function."), invariant(typeof Bi.beginDrag == "function", "Expected beginDrag to be a function."), invariant(typeof Bi.endDrag == "function", "Expected endDrag to be a function.");
}
function validateTargetContract(Bi) {
  invariant(typeof Bi.canDrop == "function", "Expected canDrop to be a function."), invariant(typeof Bi.hover == "function", "Expected hover to be a function."), invariant(typeof Bi.drop == "function", "Expected beginDrag to be a function.");
}
function validateType(Bi, e) {
  if (e && Array.isArray(Bi)) {
    Bi.forEach(
      (Zi) => validateType(Zi, !1)
    );
    return;
  }
  invariant(typeof Bi == "string" || typeof Bi == "symbol", e ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var HandlerRole;
(function(Bi) {
  Bi.SOURCE = "SOURCE", Bi.TARGET = "TARGET";
})(HandlerRole || (HandlerRole = {}));
let nextUniqueId = 0;
function getNextUniqueId() {
  return nextUniqueId++;
}
function getNextHandlerId(Bi) {
  const e = getNextUniqueId().toString();
  switch (Bi) {
    case HandlerRole.SOURCE:
      return `S${e}`;
    case HandlerRole.TARGET:
      return `T${e}`;
    default:
      throw new Error(`Unknown Handler Role: ${Bi}`);
  }
}
function parseRoleFromHandlerId(Bi) {
  switch (Bi[0]) {
    case "S":
      return HandlerRole.SOURCE;
    case "T":
      return HandlerRole.TARGET;
    default:
      throw new Error(`Cannot parse handler ID: ${Bi}`);
  }
}
function mapContainsValue(Bi, e) {
  const Zi = Bi.entries();
  let Qi = !1;
  do {
    const { done: ea, value: [, ra] } = Zi.next();
    if (ra === e)
      return !0;
    Qi = !!ea;
  } while (!Qi);
  return !1;
}
class HandlerRegistryImpl {
  addSource(e, Zi) {
    validateType(e), validateSourceContract(Zi);
    const Qi = this.addHandler(HandlerRole.SOURCE, e, Zi);
    return this.store.dispatch(addSource(Qi)), Qi;
  }
  addTarget(e, Zi) {
    validateType(e, !0), validateTargetContract(Zi);
    const Qi = this.addHandler(HandlerRole.TARGET, e, Zi);
    return this.store.dispatch(addTarget(Qi)), Qi;
  }
  containsHandler(e) {
    return mapContainsValue(this.dragSources, e) || mapContainsValue(this.dropTargets, e);
  }
  getSource(e, Zi = !1) {
    return invariant(this.isSourceId(e), "Expected a valid source ID."), Zi && e === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(e);
  }
  getTarget(e) {
    return invariant(this.isTargetId(e), "Expected a valid target ID."), this.dropTargets.get(e);
  }
  getSourceType(e) {
    return invariant(this.isSourceId(e), "Expected a valid source ID."), this.types.get(e);
  }
  getTargetType(e) {
    return invariant(this.isTargetId(e), "Expected a valid target ID."), this.types.get(e);
  }
  isSourceId(e) {
    return parseRoleFromHandlerId(e) === HandlerRole.SOURCE;
  }
  isTargetId(e) {
    return parseRoleFromHandlerId(e) === HandlerRole.TARGET;
  }
  removeSource(e) {
    invariant(this.getSource(e), "Expected an existing source."), this.store.dispatch(removeSource(e)), asap(() => {
      this.dragSources.delete(e), this.types.delete(e);
    });
  }
  removeTarget(e) {
    invariant(this.getTarget(e), "Expected an existing target."), this.store.dispatch(removeTarget(e)), this.dropTargets.delete(e), this.types.delete(e);
  }
  pinSource(e) {
    const Zi = this.getSource(e);
    invariant(Zi, "Expected an existing source."), this.pinnedSourceId = e, this.pinnedSource = Zi;
  }
  unpinSource() {
    invariant(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
  }
  addHandler(e, Zi, Qi) {
    const ea = getNextHandlerId(e);
    return this.types.set(ea, Zi), e === HandlerRole.SOURCE ? this.dragSources.set(ea, Qi) : e === HandlerRole.TARGET && this.dropTargets.set(ea, Qi), ea;
  }
  constructor(e) {
    this.types = /* @__PURE__ */ new Map(), this.dragSources = /* @__PURE__ */ new Map(), this.dropTargets = /* @__PURE__ */ new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = e;
  }
}
const strictEquality = (Bi, e) => Bi === e;
function areCoordsEqual(Bi, e) {
  return !Bi && !e ? !0 : !Bi || !e ? !1 : Bi.x === e.x && Bi.y === e.y;
}
function areArraysEqual(Bi, e, Zi = strictEquality) {
  if (Bi.length !== e.length)
    return !1;
  for (let Qi = 0; Qi < Bi.length; ++Qi)
    if (!Zi(Bi[Qi], e[Qi]))
      return !1;
  return !0;
}
function reduce$5(Bi = NONE, e) {
  switch (e.type) {
    case HOVER:
      break;
    case ADD_SOURCE:
    case ADD_TARGET:
    case REMOVE_TARGET:
    case REMOVE_SOURCE:
      return NONE;
    case BEGIN_DRAG:
    case PUBLISH_DRAG_SOURCE:
    case END_DRAG:
    case DROP:
    default:
      return ALL;
  }
  const { targetIds: Zi = [], prevTargetIds: Qi = [] } = e.payload, ea = xor(Zi, Qi);
  if (!(ea.length > 0 || !areArraysEqual(Zi, Qi)))
    return NONE;
  const na = Qi[Qi.length - 1], ia = Zi[Zi.length - 1];
  return na !== ia && (na && ea.push(na), ia && ea.push(ia)), ea;
}
function _defineProperty$5(Bi, e, Zi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Zi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Zi, Bi;
}
function _objectSpread$5(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Zi = arguments[e] != null ? arguments[e] : {}, Qi = Object.keys(Zi);
    typeof Object.getOwnPropertySymbols == "function" && (Qi = Qi.concat(Object.getOwnPropertySymbols(Zi).filter(function(ea) {
      return Object.getOwnPropertyDescriptor(Zi, ea).enumerable;
    }))), Qi.forEach(function(ea) {
      _defineProperty$5(Bi, ea, Zi[ea]);
    });
  }
  return Bi;
}
const initialState$2 = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function reduce$4(Bi = initialState$2, e) {
  const { payload: Zi } = e;
  switch (e.type) {
    case INIT_COORDS:
    case BEGIN_DRAG:
      return {
        initialSourceClientOffset: Zi.sourceClientOffset,
        initialClientOffset: Zi.clientOffset,
        clientOffset: Zi.clientOffset
      };
    case HOVER:
      return areCoordsEqual(Bi.clientOffset, Zi.clientOffset) ? Bi : _objectSpread$5({}, Bi, {
        clientOffset: Zi.clientOffset
      });
    case END_DRAG:
    case DROP:
      return initialState$2;
    default:
      return Bi;
  }
}
function _defineProperty$4(Bi, e, Zi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Zi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Zi, Bi;
}
function _objectSpread$4(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Zi = arguments[e] != null ? arguments[e] : {}, Qi = Object.keys(Zi);
    typeof Object.getOwnPropertySymbols == "function" && (Qi = Qi.concat(Object.getOwnPropertySymbols(Zi).filter(function(ea) {
      return Object.getOwnPropertyDescriptor(Zi, ea).enumerable;
    }))), Qi.forEach(function(ea) {
      _defineProperty$4(Bi, ea, Zi[ea]);
    });
  }
  return Bi;
}
const initialState$1 = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: !1,
  isSourcePublic: null
};
function reduce$3(Bi = initialState$1, e) {
  const { payload: Zi } = e;
  switch (e.type) {
    case BEGIN_DRAG:
      return _objectSpread$4({}, Bi, {
        itemType: Zi.itemType,
        item: Zi.item,
        sourceId: Zi.sourceId,
        isSourcePublic: Zi.isSourcePublic,
        dropResult: null,
        didDrop: !1
      });
    case PUBLISH_DRAG_SOURCE:
      return _objectSpread$4({}, Bi, {
        isSourcePublic: !0
      });
    case HOVER:
      return _objectSpread$4({}, Bi, {
        targetIds: Zi.targetIds
      });
    case REMOVE_TARGET:
      return Bi.targetIds.indexOf(Zi.targetId) === -1 ? Bi : _objectSpread$4({}, Bi, {
        targetIds: without$1(Bi.targetIds, Zi.targetId)
      });
    case DROP:
      return _objectSpread$4({}, Bi, {
        dropResult: Zi.dropResult,
        didDrop: !0,
        targetIds: []
      });
    case END_DRAG:
      return _objectSpread$4({}, Bi, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: !1,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return Bi;
  }
}
function reduce$2(Bi = 0, e) {
  switch (e.type) {
    case ADD_SOURCE:
    case ADD_TARGET:
      return Bi + 1;
    case REMOVE_SOURCE:
    case REMOVE_TARGET:
      return Bi - 1;
    default:
      return Bi;
  }
}
function reduce$1(Bi = 0) {
  return Bi + 1;
}
function _defineProperty$3(Bi, e, Zi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Zi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Zi, Bi;
}
function _objectSpread$3(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Zi = arguments[e] != null ? arguments[e] : {}, Qi = Object.keys(Zi);
    typeof Object.getOwnPropertySymbols == "function" && (Qi = Qi.concat(Object.getOwnPropertySymbols(Zi).filter(function(ea) {
      return Object.getOwnPropertyDescriptor(Zi, ea).enumerable;
    }))), Qi.forEach(function(ea) {
      _defineProperty$3(Bi, ea, Zi[ea]);
    });
  }
  return Bi;
}
function reduce(Bi = {}, e) {
  return {
    dirtyHandlerIds: reduce$5(Bi.dirtyHandlerIds, {
      type: e.type,
      payload: _objectSpread$3({}, e.payload, {
        prevTargetIds: get$1(Bi, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: reduce$4(Bi.dragOffset, e),
    refCount: reduce$2(Bi.refCount, e),
    dragOperation: reduce$3(Bi.dragOperation, e),
    stateId: reduce$1(Bi.stateId)
  };
}
function createDragDropManager(Bi, e = void 0, Zi = {}, Qi = !1) {
  const ea = makeStoreInstance(Qi), ra = new DragDropMonitorImpl(ea, new HandlerRegistryImpl(ea)), na = new DragDropManagerImpl(ea, ra), ia = Bi(na, e, Zi);
  return na.receiveBackend(ia), na;
}
function makeStoreInstance(Bi) {
  const e = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return createStore(reduce, Bi && e && e({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}
function _objectWithoutProperties$1(Bi, e) {
  if (Bi == null) return {};
  var Zi = _objectWithoutPropertiesLoose$1(Bi, e), Qi, ea;
  if (Object.getOwnPropertySymbols) {
    var ra = Object.getOwnPropertySymbols(Bi);
    for (ea = 0; ea < ra.length; ea++)
      Qi = ra[ea], !(e.indexOf(Qi) >= 0) && Object.prototype.propertyIsEnumerable.call(Bi, Qi) && (Zi[Qi] = Bi[Qi]);
  }
  return Zi;
}
function _objectWithoutPropertiesLoose$1(Bi, e) {
  if (Bi == null) return {};
  var Zi = {}, Qi = Object.keys(Bi), ea, ra;
  for (ra = 0; ra < Qi.length; ra++)
    ea = Qi[ra], !(e.indexOf(ea) >= 0) && (Zi[ea] = Bi[ea]);
  return Zi;
}
let refCount = 0;
const INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var DndProvider = /* @__PURE__ */ memo(function(e) {
  var { children: Zi } = e, Qi = _objectWithoutProperties$1(e, [
    "children"
  ]);
  const [ea, ra] = getDndContextValue(Qi);
  return useEffect(() => {
    if (ra) {
      const na = getGlobalContext();
      return ++refCount, () => {
        --refCount === 0 && (na[INSTANCE_SYM] = null);
      };
    }
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx(DndContext.Provider, {
    value: ea,
    children: Zi
  });
});
function getDndContextValue(Bi) {
  if ("manager" in Bi)
    return [
      {
        dragDropManager: Bi.manager
      },
      !1
    ];
  const e = createSingletonDndContext(Bi.backend, Bi.context, Bi.options, Bi.debugMode), Zi = !Bi.context;
  return [
    e,
    Zi
  ];
}
function createSingletonDndContext(Bi, e = getGlobalContext(), Zi, Qi) {
  const ea = e;
  return ea[INSTANCE_SYM] || (ea[INSTANCE_SYM] = {
    dragDropManager: createDragDropManager(Bi, e, Zi, Qi)
  }), ea[INSTANCE_SYM];
}
function getGlobalContext() {
  return typeof global < "u" ? global : window;
}
var fastDeepEqual, hasRequiredFastDeepEqual;
function requireFastDeepEqual() {
  return hasRequiredFastDeepEqual || (hasRequiredFastDeepEqual = 1, fastDeepEqual = function Bi(e, Zi) {
    if (e === Zi) return !0;
    if (e && Zi && typeof e == "object" && typeof Zi == "object") {
      if (e.constructor !== Zi.constructor) return !1;
      var Qi, ea, ra;
      if (Array.isArray(e)) {
        if (Qi = e.length, Qi != Zi.length) return !1;
        for (ea = Qi; ea-- !== 0; )
          if (!Bi(e[ea], Zi[ea])) return !1;
        return !0;
      }
      if (e.constructor === RegExp) return e.source === Zi.source && e.flags === Zi.flags;
      if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === Zi.valueOf();
      if (e.toString !== Object.prototype.toString) return e.toString() === Zi.toString();
      if (ra = Object.keys(e), Qi = ra.length, Qi !== Object.keys(Zi).length) return !1;
      for (ea = Qi; ea-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(Zi, ra[ea])) return !1;
      for (ea = Qi; ea-- !== 0; ) {
        var na = ra[ea];
        if (!Bi(e[na], Zi[na])) return !1;
      }
      return !0;
    }
    return e !== e && Zi !== Zi;
  }), fastDeepEqual;
}
var fastDeepEqualExports = requireFastDeepEqual();
const equal = /* @__PURE__ */ getDefaultExportFromCjs(fastDeepEqualExports), useIsomorphicLayoutEffect = typeof window < "u" ? useLayoutEffect : useEffect;
function useCollector(Bi, e, Zi) {
  const [Qi, ea] = useState(
    () => e(Bi)
  ), ra = useCallback(() => {
    const na = e(Bi);
    equal(Qi, na) || (ea(na), Zi && Zi());
  }, [
    Qi,
    Bi,
    Zi
  ]);
  return useIsomorphicLayoutEffect(ra), [
    Qi,
    ra
  ];
}
function useMonitorOutput(Bi, e, Zi) {
  const [Qi, ea] = useCollector(Bi, e, Zi);
  return useIsomorphicLayoutEffect(function() {
    const na = Bi.getHandlerId();
    if (na != null)
      return Bi.subscribeToStateChange(ea, {
        handlerIds: [
          na
        ]
      });
  }, [
    Bi,
    ea
  ]), Qi;
}
function useCollectedProps(Bi, e, Zi) {
  return useMonitorOutput(
    e,
    Bi || (() => ({})),
    () => Zi.reconnect()
  );
}
function useOptionalFactory(Bi, e) {
  const Zi = [];
  return typeof Bi != "function" && Zi.push(Bi), useMemo(() => typeof Bi == "function" ? Bi() : Bi, Zi);
}
function useConnectDragSource(Bi) {
  return useMemo(
    () => Bi.hooks.dragSource(),
    [
      Bi
    ]
  );
}
function useConnectDragPreview(Bi) {
  return useMemo(
    () => Bi.hooks.dragPreview(),
    [
      Bi
    ]
  );
}
let isCallingCanDrag = !1, isCallingIsDragging = !1;
class DragSourceMonitorImpl {
  receiveHandlerId(e) {
    this.sourceId = e;
  }
  getHandlerId() {
    return this.sourceId;
  }
  canDrag() {
    invariant(!isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return isCallingCanDrag = !0, this.internalMonitor.canDragSource(this.sourceId);
    } finally {
      isCallingCanDrag = !1;
    }
  }
  isDragging() {
    if (!this.sourceId)
      return !1;
    invariant(!isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return isCallingIsDragging = !0, this.internalMonitor.isDraggingSource(this.sourceId);
    } finally {
      isCallingIsDragging = !1;
    }
  }
  subscribeToStateChange(e, Zi) {
    return this.internalMonitor.subscribeToStateChange(e, Zi);
  }
  isDraggingSource(e) {
    return this.internalMonitor.isDraggingSource(e);
  }
  isOverTarget(e, Zi) {
    return this.internalMonitor.isOverTarget(e, Zi);
  }
  getTargetIds() {
    return this.internalMonitor.getTargetIds();
  }
  isSourcePublic() {
    return this.internalMonitor.isSourcePublic();
  }
  getSourceId() {
    return this.internalMonitor.getSourceId();
  }
  subscribeToOffsetChange(e) {
    return this.internalMonitor.subscribeToOffsetChange(e);
  }
  canDragSource(e) {
    return this.internalMonitor.canDragSource(e);
  }
  canDropOnTarget(e) {
    return this.internalMonitor.canDropOnTarget(e);
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(e) {
    this.sourceId = null, this.internalMonitor = e.getMonitor();
  }
}
let isCallingCanDrop = !1;
class DropTargetMonitorImpl {
  receiveHandlerId(e) {
    this.targetId = e;
  }
  getHandlerId() {
    return this.targetId;
  }
  subscribeToStateChange(e, Zi) {
    return this.internalMonitor.subscribeToStateChange(e, Zi);
  }
  canDrop() {
    if (!this.targetId)
      return !1;
    invariant(!isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
    try {
      return isCallingCanDrop = !0, this.internalMonitor.canDropOnTarget(this.targetId);
    } finally {
      isCallingCanDrop = !1;
    }
  }
  isOver(e) {
    return this.targetId ? this.internalMonitor.isOverTarget(this.targetId, e) : !1;
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(e) {
    this.targetId = null, this.internalMonitor = e.getMonitor();
  }
}
function registerTarget(Bi, e, Zi) {
  const Qi = Zi.getRegistry(), ea = Qi.addTarget(Bi, e);
  return [
    ea,
    () => Qi.removeTarget(ea)
  ];
}
function registerSource(Bi, e, Zi) {
  const Qi = Zi.getRegistry(), ea = Qi.addSource(Bi, e);
  return [
    ea,
    () => Qi.removeSource(ea)
  ];
}
function shallowEqual(Bi, e, Zi, Qi) {
  let ea;
  if (ea !== void 0)
    return !!ea;
  if (Bi === e)
    return !0;
  if (typeof Bi != "object" || !Bi || typeof e != "object" || !e)
    return !1;
  const ra = Object.keys(Bi), na = Object.keys(e);
  if (ra.length !== na.length)
    return !1;
  const ia = Object.prototype.hasOwnProperty.bind(e);
  for (let fa = 0; fa < ra.length; fa++) {
    const La = ra[fa];
    if (!ia(La))
      return !1;
    const Va = Bi[La], to = e[La];
    if (ea = void 0, ea === !1 || ea === void 0 && Va !== to)
      return !1;
  }
  return !0;
}
function isRef(Bi) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    Bi !== null && typeof Bi == "object" && Object.prototype.hasOwnProperty.call(Bi, "current")
  );
}
function throwIfCompositeComponentElement(Bi) {
  if (typeof Bi.type == "string")
    return;
  const e = Bi.type.displayName || Bi.type.name || "the component";
  throw new Error(`Only native element nodes can now be passed to React DnD connectors.You can either wrap ${e} into a <div>, or turn it into a drag source or a drop target itself.`);
}
function wrapHookToRecognizeElement(Bi) {
  return (e = null, Zi = null) => {
    if (!isValidElement(e)) {
      const ra = e;
      return Bi(ra, Zi), ra;
    }
    const Qi = e;
    return throwIfCompositeComponentElement(Qi), cloneWithRef(Qi, Zi ? (ra) => Bi(ra, Zi) : Bi);
  };
}
function wrapConnectorHooks(Bi) {
  const e = {};
  return Object.keys(Bi).forEach((Zi) => {
    const Qi = Bi[Zi];
    if (Zi.endsWith("Ref"))
      e[Zi] = Bi[Zi];
    else {
      const ea = wrapHookToRecognizeElement(Qi);
      e[Zi] = () => ea;
    }
  }), e;
}
function setRef(Bi, e) {
  typeof Bi == "function" ? Bi(e) : Bi.current = e;
}
function cloneWithRef(Bi, e) {
  const Zi = Bi.ref;
  return invariant(typeof Zi != "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs"), Zi ? cloneElement(Bi, {
    ref: (Qi) => {
      setRef(Zi, Qi), setRef(e, Qi);
    }
  }) : cloneElement(Bi, {
    ref: e
  });
}
class SourceConnector {
  receiveHandlerId(e) {
    this.handlerId !== e && (this.handlerId = e, this.reconnect());
  }
  get connectTarget() {
    return this.dragSource;
  }
  get dragSourceOptions() {
    return this.dragSourceOptionsInternal;
  }
  set dragSourceOptions(e) {
    this.dragSourceOptionsInternal = e;
  }
  get dragPreviewOptions() {
    return this.dragPreviewOptionsInternal;
  }
  set dragPreviewOptions(e) {
    this.dragPreviewOptionsInternal = e;
  }
  reconnect() {
    const e = this.reconnectDragSource();
    this.reconnectDragPreview(e);
  }
  reconnectDragSource() {
    const e = this.dragSource, Zi = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
    return Zi && this.disconnectDragSource(), this.handlerId ? e ? (Zi && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = e, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, e, this.dragSourceOptions)), Zi) : (this.lastConnectedDragSource = e, Zi) : Zi;
  }
  reconnectDragPreview(e = !1) {
    const Zi = this.dragPreview, Qi = e || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
    if (Qi && this.disconnectDragPreview(), !!this.handlerId) {
      if (!Zi) {
        this.lastConnectedDragPreview = Zi;
        return;
      }
      Qi && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = Zi, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, Zi, this.dragPreviewOptions));
    }
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didConnectedDragSourceChange() {
    return this.lastConnectedDragSource !== this.dragSource;
  }
  didConnectedDragPreviewChange() {
    return this.lastConnectedDragPreview !== this.dragPreview;
  }
  didDragSourceOptionsChange() {
    return !shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
  }
  didDragPreviewOptionsChange() {
    return !shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
  }
  disconnectDragSource() {
    this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
  }
  disconnectDragPreview() {
    this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
  }
  get dragSource() {
    return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
  }
  get dragPreview() {
    return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
  }
  clearDragSource() {
    this.dragSourceNode = null, this.dragSourceRef = null;
  }
  clearDragPreview() {
    this.dragPreviewNode = null, this.dragPreviewRef = null;
  }
  constructor(e) {
    this.hooks = wrapConnectorHooks({
      dragSource: (Zi, Qi) => {
        this.clearDragSource(), this.dragSourceOptions = Qi || null, isRef(Zi) ? this.dragSourceRef = Zi : this.dragSourceNode = Zi, this.reconnectDragSource();
      },
      dragPreview: (Zi, Qi) => {
        this.clearDragPreview(), this.dragPreviewOptions = Qi || null, isRef(Zi) ? this.dragPreviewRef = Zi : this.dragPreviewNode = Zi, this.reconnectDragPreview();
      }
    }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = e;
  }
}
class TargetConnector {
  get connectTarget() {
    return this.dropTarget;
  }
  reconnect() {
    const e = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
    e && this.disconnectDropTarget();
    const Zi = this.dropTarget;
    if (this.handlerId) {
      if (!Zi) {
        this.lastConnectedDropTarget = Zi;
        return;
      }
      e && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = Zi, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, Zi, this.dropTargetOptions));
    }
  }
  receiveHandlerId(e) {
    e !== this.handlerId && (this.handlerId = e, this.reconnect());
  }
  get dropTargetOptions() {
    return this.dropTargetOptionsInternal;
  }
  set dropTargetOptions(e) {
    this.dropTargetOptionsInternal = e;
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didDropTargetChange() {
    return this.lastConnectedDropTarget !== this.dropTarget;
  }
  didOptionsChange() {
    return !shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
  }
  disconnectDropTarget() {
    this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
  }
  get dropTarget() {
    return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
  }
  clearDropTarget() {
    this.dropTargetRef = null, this.dropTargetNode = null;
  }
  constructor(e) {
    this.hooks = wrapConnectorHooks({
      dropTarget: (Zi, Qi) => {
        this.clearDropTarget(), this.dropTargetOptions = Qi, isRef(Zi) ? this.dropTargetRef = Zi : this.dropTargetNode = Zi, this.reconnect();
      }
    }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = e;
  }
}
function useDragDropManager() {
  const { dragDropManager: Bi } = useContext(DndContext);
  return invariant(Bi != null, "Expected drag drop context"), Bi;
}
function useDragSourceConnector(Bi, e) {
  const Zi = useDragDropManager(), Qi = useMemo(
    () => new SourceConnector(Zi.getBackend()),
    [
      Zi
    ]
  );
  return useIsomorphicLayoutEffect(() => (Qi.dragSourceOptions = Bi || null, Qi.reconnect(), () => Qi.disconnectDragSource()), [
    Qi,
    Bi
  ]), useIsomorphicLayoutEffect(() => (Qi.dragPreviewOptions = e || null, Qi.reconnect(), () => Qi.disconnectDragPreview()), [
    Qi,
    e
  ]), Qi;
}
function useDragSourceMonitor() {
  const Bi = useDragDropManager();
  return useMemo(
    () => new DragSourceMonitorImpl(Bi),
    [
      Bi
    ]
  );
}
class DragSourceImpl {
  beginDrag() {
    const e = this.spec, Zi = this.monitor;
    let Qi = null;
    return typeof e.item == "object" ? Qi = e.item : typeof e.item == "function" ? Qi = e.item(Zi) : Qi = {}, Qi ?? null;
  }
  canDrag() {
    const e = this.spec, Zi = this.monitor;
    return typeof e.canDrag == "boolean" ? e.canDrag : typeof e.canDrag == "function" ? e.canDrag(Zi) : !0;
  }
  isDragging(e, Zi) {
    const Qi = this.spec, ea = this.monitor, { isDragging: ra } = Qi;
    return ra ? ra(ea) : Zi === e.getSourceId();
  }
  endDrag() {
    const e = this.spec, Zi = this.monitor, Qi = this.connector, { end: ea } = e;
    ea && ea(Zi.getItem(), Zi), Qi.reconnect();
  }
  constructor(e, Zi, Qi) {
    this.spec = e, this.monitor = Zi, this.connector = Qi;
  }
}
function useDragSource(Bi, e, Zi) {
  const Qi = useMemo(
    () => new DragSourceImpl(Bi, e, Zi),
    [
      e,
      Zi
    ]
  );
  return useEffect(() => {
    Qi.spec = Bi;
  }, [
    Bi
  ]), Qi;
}
function useDragType(Bi) {
  return useMemo(() => {
    const e = Bi.type;
    return invariant(e != null, "spec.type must be defined"), e;
  }, [
    Bi
  ]);
}
function useRegisteredDragSource(Bi, e, Zi) {
  const Qi = useDragDropManager(), ea = useDragSource(Bi, e, Zi), ra = useDragType(Bi);
  useIsomorphicLayoutEffect(function() {
    if (ra != null) {
      const [ia, fa] = registerSource(ra, ea, Qi);
      return e.receiveHandlerId(ia), Zi.receiveHandlerId(ia), fa;
    }
  }, [
    Qi,
    e,
    Zi,
    ea,
    ra
  ]);
}
function useDrag(Bi, e) {
  const Zi = useOptionalFactory(Bi);
  invariant(!Zi.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  const Qi = useDragSourceMonitor(), ea = useDragSourceConnector(Zi.options, Zi.previewOptions);
  return useRegisteredDragSource(Zi, Qi, ea), [
    useCollectedProps(Zi.collect, Qi, ea),
    useConnectDragSource(ea),
    useConnectDragPreview(ea)
  ];
}
function useConnectDropTarget(Bi) {
  return useMemo(
    () => Bi.hooks.dropTarget(),
    [
      Bi
    ]
  );
}
function useDropTargetConnector(Bi) {
  const e = useDragDropManager(), Zi = useMemo(
    () => new TargetConnector(e.getBackend()),
    [
      e
    ]
  );
  return useIsomorphicLayoutEffect(() => (Zi.dropTargetOptions = Bi || null, Zi.reconnect(), () => Zi.disconnectDropTarget()), [
    Bi
  ]), Zi;
}
function useDropTargetMonitor() {
  const Bi = useDragDropManager();
  return useMemo(
    () => new DropTargetMonitorImpl(Bi),
    [
      Bi
    ]
  );
}
function useAccept(Bi) {
  const { accept: e } = Bi;
  return useMemo(() => (invariant(Bi.accept != null, "accept must be defined"), Array.isArray(e) ? e : [
    e
  ]), [
    e
  ]);
}
class DropTargetImpl {
  canDrop() {
    const e = this.spec, Zi = this.monitor;
    return e.canDrop ? e.canDrop(Zi.getItem(), Zi) : !0;
  }
  hover() {
    const e = this.spec, Zi = this.monitor;
    e.hover && e.hover(Zi.getItem(), Zi);
  }
  drop() {
    const e = this.spec, Zi = this.monitor;
    if (e.drop)
      return e.drop(Zi.getItem(), Zi);
  }
  constructor(e, Zi) {
    this.spec = e, this.monitor = Zi;
  }
}
function useDropTarget(Bi, e) {
  const Zi = useMemo(
    () => new DropTargetImpl(Bi, e),
    [
      e
    ]
  );
  return useEffect(() => {
    Zi.spec = Bi;
  }, [
    Bi
  ]), Zi;
}
function useRegisteredDropTarget(Bi, e, Zi) {
  const Qi = useDragDropManager(), ea = useDropTarget(Bi, e), ra = useAccept(Bi);
  useIsomorphicLayoutEffect(function() {
    const [ia, fa] = registerTarget(ra, ea, Qi);
    return e.receiveHandlerId(ia), Zi.receiveHandlerId(ia), fa;
  }, [
    Qi,
    e,
    ea,
    Zi,
    ra.map(
      (na) => na.toString()
    ).join("|")
  ]);
}
function useDrop(Bi, e) {
  const Zi = useOptionalFactory(Bi), Qi = useDropTargetMonitor(), ea = useDropTargetConnector(Zi.options);
  return useRegisteredDropTarget(Zi, Qi, ea), [
    useCollectedProps(Zi.collect, Qi, ea),
    useConnectDropTarget(ea)
  ];
}
function memoize(Bi) {
  let e = null;
  return () => (e == null && (e = Bi()), e);
}
function without(Bi, e) {
  return Bi.filter(
    (Zi) => Zi !== e
  );
}
function union(Bi, e) {
  const Zi = /* @__PURE__ */ new Set(), Qi = (ra) => Zi.add(ra);
  Bi.forEach(Qi), e.forEach(Qi);
  const ea = [];
  return Zi.forEach(
    (ra) => ea.push(ra)
  ), ea;
}
class EnterLeaveCounter {
  enter(e) {
    const Zi = this.entered.length, Qi = (ea) => this.isNodeInDocument(ea) && (!ea.contains || ea.contains(e));
    return this.entered = union(this.entered.filter(Qi), [
      e
    ]), Zi === 0 && this.entered.length > 0;
  }
  leave(e) {
    const Zi = this.entered.length;
    return this.entered = without(this.entered.filter(this.isNodeInDocument), e), Zi > 0 && this.entered.length === 0;
  }
  reset() {
    this.entered = [];
  }
  constructor(e) {
    this.entered = [], this.isNodeInDocument = e;
  }
}
class NativeDragSource {
  initializeExposedProperties() {
    Object.keys(this.config.exposeProperties).forEach((e) => {
      Object.defineProperty(this.item, e, {
        configurable: !0,
        enumerable: !0,
        get() {
          return console.warn(`Browser doesn't allow reading "${e}" until the drop event.`), null;
        }
      });
    });
  }
  loadDataTransfer(e) {
    if (e) {
      const Zi = {};
      Object.keys(this.config.exposeProperties).forEach((Qi) => {
        const ea = this.config.exposeProperties[Qi];
        ea != null && (Zi[Qi] = {
          value: ea(e, this.config.matchesTypes),
          configurable: !0,
          enumerable: !0
        });
      }), Object.defineProperties(this.item, Zi);
    }
  }
  canDrag() {
    return !0;
  }
  beginDrag() {
    return this.item;
  }
  isDragging(e, Zi) {
    return Zi === e.getSourceId();
  }
  endDrag() {
  }
  constructor(e) {
    this.config = e, this.item = {}, this.initializeExposedProperties();
  }
}
const FILE = "__NATIVE_FILE__", URL$1 = "__NATIVE_URL__", TEXT = "__NATIVE_TEXT__", HTML = "__NATIVE_HTML__", NativeTypes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FILE,
  HTML,
  TEXT,
  URL: URL$1
}, Symbol.toStringTag, { value: "Module" }));
function getDataFromDataTransfer(Bi, e, Zi) {
  const Qi = e.reduce(
    (ea, ra) => ea || Bi.getData(ra),
    ""
  );
  return Qi ?? Zi;
}
const nativeTypesConfig = {
  [FILE]: {
    exposeProperties: {
      files: (Bi) => Array.prototype.slice.call(Bi.files),
      items: (Bi) => Bi.items,
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Files"
    ]
  },
  [HTML]: {
    exposeProperties: {
      html: (Bi, e) => getDataFromDataTransfer(Bi, e, ""),
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Html",
      "text/html"
    ]
  },
  [URL$1]: {
    exposeProperties: {
      urls: (Bi, e) => getDataFromDataTransfer(Bi, e, "").split(`
`),
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Url",
      "text/uri-list"
    ]
  },
  [TEXT]: {
    exposeProperties: {
      text: (Bi, e) => getDataFromDataTransfer(Bi, e, ""),
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Text",
      "text/plain"
    ]
  }
};
function createNativeDragSource(Bi, e) {
  const Zi = nativeTypesConfig[Bi];
  if (!Zi)
    throw new Error(`native type ${Bi} has no configuration`);
  const Qi = new NativeDragSource(Zi);
  return Qi.loadDataTransfer(e), Qi;
}
function matchNativeItemType(Bi) {
  if (!Bi)
    return null;
  const e = Array.prototype.slice.call(Bi.types || []);
  return Object.keys(nativeTypesConfig).filter((Zi) => {
    const Qi = nativeTypesConfig[Zi];
    return Qi?.matchesTypes ? Qi.matchesTypes.some(
      (ea) => e.indexOf(ea) > -1
    ) : !1;
  })[0] || null;
}
const isFirefox = memoize(
  () => /firefox/i.test(navigator.userAgent)
), isSafari = memoize(
  () => !!window.safari
);
class MonotonicInterpolant {
  interpolate(e) {
    const { xs: Zi, ys: Qi, c1s: ea, c2s: ra, c3s: na } = this;
    let ia = Zi.length - 1;
    if (e === Zi[ia])
      return Qi[ia];
    let fa = 0, La = na.length - 1, Va;
    for (; fa <= La; ) {
      Va = Math.floor(0.5 * (fa + La));
      const no = Zi[Va];
      if (no < e)
        fa = Va + 1;
      else if (no > e)
        La = Va - 1;
      else
        return Qi[Va];
    }
    ia = Math.max(0, La);
    const to = e - Zi[ia], ro = to * to;
    return Qi[ia] + ea[ia] * to + ra[ia] * ro + na[ia] * to * ro;
  }
  constructor(e, Zi) {
    const { length: Qi } = e, ea = [];
    for (let no = 0; no < Qi; no++)
      ea.push(no);
    ea.sort(
      (no, eo) => e[no] < e[eo] ? -1 : 1
    );
    const ra = [], na = [];
    let ia, fa;
    for (let no = 0; no < Qi - 1; no++)
      ia = e[no + 1] - e[no], fa = Zi[no + 1] - Zi[no], ra.push(ia), na.push(fa / ia);
    const La = [
      na[0]
    ];
    for (let no = 0; no < ra.length - 1; no++) {
      const eo = na[no], ao = na[no + 1];
      if (eo * ao <= 0)
        La.push(0);
      else {
        ia = ra[no];
        const io = ra[no + 1], xs = ia + io;
        La.push(3 * xs / ((xs + io) / eo + (xs + ia) / ao));
      }
    }
    La.push(na[na.length - 1]);
    const Va = [], to = [];
    let ro;
    for (let no = 0; no < La.length - 1; no++) {
      ro = na[no];
      const eo = La[no], ao = 1 / ra[no], io = eo + La[no + 1] - ro - ro;
      Va.push((ro - eo - io) * ao), to.push(io * ao * ao);
    }
    this.xs = e, this.ys = Zi, this.c1s = La, this.c2s = Va, this.c3s = to;
  }
}
const ELEMENT_NODE = 1;
function getNodeClientOffset(Bi) {
  const e = Bi.nodeType === ELEMENT_NODE ? Bi : Bi.parentElement;
  if (!e)
    return null;
  const { top: Zi, left: Qi } = e.getBoundingClientRect();
  return {
    x: Qi,
    y: Zi
  };
}
function getEventClientOffset(Bi) {
  return {
    x: Bi.clientX,
    y: Bi.clientY
  };
}
function isImageNode(Bi) {
  var e;
  return Bi.nodeName === "IMG" && (isFirefox() || !(!((e = document.documentElement) === null || e === void 0) && e.contains(Bi)));
}
function getDragPreviewSize(Bi, e, Zi, Qi) {
  let ea = Bi ? e.width : Zi, ra = Bi ? e.height : Qi;
  return isSafari() && Bi && (ra /= window.devicePixelRatio, ea /= window.devicePixelRatio), {
    dragPreviewWidth: ea,
    dragPreviewHeight: ra
  };
}
function getDragPreviewOffset(Bi, e, Zi, Qi, ea) {
  const ra = isImageNode(e), ia = getNodeClientOffset(ra ? Bi : e), fa = {
    x: Zi.x - ia.x,
    y: Zi.y - ia.y
  }, { offsetWidth: La, offsetHeight: Va } = Bi, { anchorX: to, anchorY: ro } = Qi, { dragPreviewWidth: no, dragPreviewHeight: eo } = getDragPreviewSize(ra, e, La, Va), ao = () => {
    let ys = new MonotonicInterpolant([
      0,
      0.5,
      1
    ], [
      // Dock to the top
      fa.y,
      // Align at the center
      fa.y / Va * eo,
      // Dock to the bottom
      fa.y + eo - Va
    ]).interpolate(ro);
    return isSafari() && ra && (ys += (window.devicePixelRatio - 1) * eo), ys;
  }, io = () => new MonotonicInterpolant([
    0,
    0.5,
    1
  ], [
    // Dock to the left
    fa.x,
    // Align at the center
    fa.x / La * no,
    // Dock to the right
    fa.x + no - La
  ]).interpolate(to), { offsetX: xs, offsetY: Ts } = ea, qs = xs === 0 || xs, Fs = Ts === 0 || Ts;
  return {
    x: qs ? xs : io(),
    y: Fs ? Ts : ao()
  };
}
class OptionsReader {
  get window() {
    if (this.globalContext)
      return this.globalContext;
    if (typeof window < "u")
      return window;
  }
  get document() {
    var e;
    return !((e = this.globalContext) === null || e === void 0) && e.document ? this.globalContext.document : this.window ? this.window.document : void 0;
  }
  get rootElement() {
    var e;
    return ((e = this.optionsArgs) === null || e === void 0 ? void 0 : e.rootElement) || this.window;
  }
  constructor(e, Zi) {
    this.ownerDocument = null, this.globalContext = e, this.optionsArgs = Zi;
  }
}
function _defineProperty$2(Bi, e, Zi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: Zi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = Zi, Bi;
}
function _objectSpread$2(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Zi = arguments[e] != null ? arguments[e] : {}, Qi = Object.keys(Zi);
    typeof Object.getOwnPropertySymbols == "function" && (Qi = Qi.concat(Object.getOwnPropertySymbols(Zi).filter(function(ea) {
      return Object.getOwnPropertyDescriptor(Zi, ea).enumerable;
    }))), Qi.forEach(function(ea) {
      _defineProperty$2(Bi, ea, Zi[ea]);
    });
  }
  return Bi;
}
class HTML5BackendImpl {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var e, Zi;
    return {
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      sourceNodeOptions: this.sourceNodeOptions.size,
      sourceNodes: this.sourceNodes.size,
      dragStartSourceIds: ((e = this.dragStartSourceIds) === null || e === void 0 ? void 0 : e.length) || 0,
      dropTargetIds: this.dropTargetIds.length,
      dragEnterTargetIds: this.dragEnterTargetIds.length,
      dragOverTargetIds: ((Zi = this.dragOverTargetIds) === null || Zi === void 0 ? void 0 : Zi.length) || 0
    };
  }
  // public for test
  get window() {
    return this.options.window;
  }
  get document() {
    return this.options.document;
  }
  /**
  * Get the root element to use for event subscriptions
  */
  get rootElement() {
    return this.options.rootElement;
  }
  setup() {
    const e = this.rootElement;
    if (e !== void 0) {
      if (e.__isReactDndBackendSetUp)
        throw new Error("Cannot have two HTML5 backends at the same time.");
      e.__isReactDndBackendSetUp = !0, this.addEventListeners(e);
    }
  }
  teardown() {
    const e = this.rootElement;
    if (e !== void 0 && (e.__isReactDndBackendSetUp = !1, this.removeEventListeners(this.rootElement), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId)) {
      var Zi;
      (Zi = this.window) === null || Zi === void 0 || Zi.cancelAnimationFrame(this.asyncEndDragFrameId);
    }
  }
  connectDragPreview(e, Zi, Qi) {
    return this.sourcePreviewNodeOptions.set(e, Qi), this.sourcePreviewNodes.set(e, Zi), () => {
      this.sourcePreviewNodes.delete(e), this.sourcePreviewNodeOptions.delete(e);
    };
  }
  connectDragSource(e, Zi, Qi) {
    this.sourceNodes.set(e, Zi), this.sourceNodeOptions.set(e, Qi);
    const ea = (na) => this.handleDragStart(na, e), ra = (na) => this.handleSelectStart(na);
    return Zi.setAttribute("draggable", "true"), Zi.addEventListener("dragstart", ea), Zi.addEventListener("selectstart", ra), () => {
      this.sourceNodes.delete(e), this.sourceNodeOptions.delete(e), Zi.removeEventListener("dragstart", ea), Zi.removeEventListener("selectstart", ra), Zi.setAttribute("draggable", "false");
    };
  }
  connectDropTarget(e, Zi) {
    const Qi = (na) => this.handleDragEnter(na, e), ea = (na) => this.handleDragOver(na, e), ra = (na) => this.handleDrop(na, e);
    return Zi.addEventListener("dragenter", Qi), Zi.addEventListener("dragover", ea), Zi.addEventListener("drop", ra), () => {
      Zi.removeEventListener("dragenter", Qi), Zi.removeEventListener("dragover", ea), Zi.removeEventListener("drop", ra);
    };
  }
  addEventListeners(e) {
    e.addEventListener && (e.addEventListener("dragstart", this.handleTopDragStart), e.addEventListener("dragstart", this.handleTopDragStartCapture, !0), e.addEventListener("dragend", this.handleTopDragEndCapture, !0), e.addEventListener("dragenter", this.handleTopDragEnter), e.addEventListener("dragenter", this.handleTopDragEnterCapture, !0), e.addEventListener("dragleave", this.handleTopDragLeaveCapture, !0), e.addEventListener("dragover", this.handleTopDragOver), e.addEventListener("dragover", this.handleTopDragOverCapture, !0), e.addEventListener("drop", this.handleTopDrop), e.addEventListener("drop", this.handleTopDropCapture, !0));
  }
  removeEventListeners(e) {
    e.removeEventListener && (e.removeEventListener("dragstart", this.handleTopDragStart), e.removeEventListener("dragstart", this.handleTopDragStartCapture, !0), e.removeEventListener("dragend", this.handleTopDragEndCapture, !0), e.removeEventListener("dragenter", this.handleTopDragEnter), e.removeEventListener("dragenter", this.handleTopDragEnterCapture, !0), e.removeEventListener("dragleave", this.handleTopDragLeaveCapture, !0), e.removeEventListener("dragover", this.handleTopDragOver), e.removeEventListener("dragover", this.handleTopDragOverCapture, !0), e.removeEventListener("drop", this.handleTopDrop), e.removeEventListener("drop", this.handleTopDropCapture, !0));
  }
  getCurrentSourceNodeOptions() {
    const e = this.monitor.getSourceId(), Zi = this.sourceNodeOptions.get(e);
    return _objectSpread$2({
      dropEffect: this.altKeyPressed ? "copy" : "move"
    }, Zi || {});
  }
  getCurrentDropEffect() {
    return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
  }
  getCurrentSourcePreviewNodeOptions() {
    const e = this.monitor.getSourceId(), Zi = this.sourcePreviewNodeOptions.get(e);
    return _objectSpread$2({
      anchorX: 0.5,
      anchorY: 0.5,
      captureDraggingState: !1
    }, Zi || {});
  }
  isDraggingNativeItem() {
    const e = this.monitor.getItemType();
    return Object.keys(NativeTypes).some(
      (Zi) => NativeTypes[Zi] === e
    );
  }
  beginDragNativeItem(e, Zi) {
    this.clearCurrentDragSourceNode(), this.currentNativeSource = createNativeDragSource(e, Zi), this.currentNativeHandle = this.registry.addSource(e, this.currentNativeSource), this.actions.beginDrag([
      this.currentNativeHandle
    ]);
  }
  setCurrentDragSourceNode(e) {
    this.clearCurrentDragSourceNode(), this.currentDragSourceNode = e;
    const Zi = 1e3;
    this.mouseMoveTimeoutTimer = setTimeout(() => {
      var Qi;
      return (Qi = this.rootElement) === null || Qi === void 0 ? void 0 : Qi.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
    }, Zi);
  }
  clearCurrentDragSourceNode() {
    if (this.currentDragSourceNode) {
      if (this.currentDragSourceNode = null, this.rootElement) {
        var e;
        (e = this.window) === null || e === void 0 || e.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
      }
      return this.mouseMoveTimeoutTimer = null, !0;
    }
    return !1;
  }
  handleDragStart(e, Zi) {
    e.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(Zi));
  }
  handleDragEnter(e, Zi) {
    this.dragEnterTargetIds.unshift(Zi);
  }
  handleDragOver(e, Zi) {
    this.dragOverTargetIds === null && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(Zi);
  }
  handleDrop(e, Zi) {
    this.dropTargetIds.unshift(Zi);
  }
  constructor(e, Zi, Qi) {
    this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourceNodeOptions = /* @__PURE__ */ new Map(), this.dragStartSourceIds = null, this.dropTargetIds = [], this.dragEnterTargetIds = [], this.currentNativeSource = null, this.currentNativeHandle = null, this.currentDragSourceNode = null, this.altKeyPressed = !1, this.mouseMoveTimeoutTimer = null, this.asyncEndDragFrameId = null, this.dragOverTargetIds = null, this.lastClientOffset = null, this.hoverRafId = null, this.getSourceClientOffset = (ea) => {
      const ra = this.sourceNodes.get(ea);
      return ra && getNodeClientOffset(ra) || null;
    }, this.endDragNativeItem = () => {
      this.isDraggingNativeItem() && (this.actions.endDrag(), this.currentNativeHandle && this.registry.removeSource(this.currentNativeHandle), this.currentNativeHandle = null, this.currentNativeSource = null);
    }, this.isNodeInDocument = (ea) => !!(ea && this.document && this.document.body && this.document.body.contains(ea)), this.endDragIfSourceWasRemovedFromDOM = () => {
      const ea = this.currentDragSourceNode;
      ea == null || this.isNodeInDocument(ea) || (this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover());
    }, this.scheduleHover = (ea) => {
      this.hoverRafId === null && typeof requestAnimationFrame < "u" && (this.hoverRafId = requestAnimationFrame(() => {
        this.monitor.isDragging() && this.actions.hover(ea || [], {
          clientOffset: this.lastClientOffset
        }), this.hoverRafId = null;
      }));
    }, this.cancelHover = () => {
      this.hoverRafId !== null && typeof cancelAnimationFrame < "u" && (cancelAnimationFrame(this.hoverRafId), this.hoverRafId = null);
    }, this.handleTopDragStartCapture = () => {
      this.clearCurrentDragSourceNode(), this.dragStartSourceIds = [];
    }, this.handleTopDragStart = (ea) => {
      if (ea.defaultPrevented)
        return;
      const { dragStartSourceIds: ra } = this;
      this.dragStartSourceIds = null;
      const na = getEventClientOffset(ea);
      this.monitor.isDragging() && (this.actions.endDrag(), this.cancelHover()), this.actions.beginDrag(ra || [], {
        publishSource: !1,
        getSourceClientOffset: this.getSourceClientOffset,
        clientOffset: na
      });
      const { dataTransfer: ia } = ea, fa = matchNativeItemType(ia);
      if (this.monitor.isDragging()) {
        if (ia && typeof ia.setDragImage == "function") {
          const Va = this.monitor.getSourceId(), to = this.sourceNodes.get(Va), ro = this.sourcePreviewNodes.get(Va) || to;
          if (ro) {
            const { anchorX: no, anchorY: eo, offsetX: ao, offsetY: io } = this.getCurrentSourcePreviewNodeOptions(), qs = getDragPreviewOffset(to, ro, na, {
              anchorX: no,
              anchorY: eo
            }, {
              offsetX: ao,
              offsetY: io
            });
            ia.setDragImage(ro, qs.x, qs.y);
          }
        }
        try {
          ia?.setData("application/json", {});
        } catch {
        }
        this.setCurrentDragSourceNode(ea.target);
        const { captureDraggingState: La } = this.getCurrentSourcePreviewNodeOptions();
        La ? this.actions.publishDragSource() : setTimeout(
          () => this.actions.publishDragSource(),
          0
        );
      } else if (fa)
        this.beginDragNativeItem(fa);
      else {
        if (ia && !ia.types && (ea.target && !ea.target.hasAttribute || !ea.target.hasAttribute("draggable")))
          return;
        ea.preventDefault();
      }
    }, this.handleTopDragEndCapture = () => {
      this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleTopDragEnterCapture = (ea) => {
      if (this.dragEnterTargetIds = [], this.isDraggingNativeItem()) {
        var ra;
        (ra = this.currentNativeSource) === null || ra === void 0 || ra.loadDataTransfer(ea.dataTransfer);
      }
      if (!this.enterLeaveCounter.enter(ea.target) || this.monitor.isDragging())
        return;
      const { dataTransfer: ia } = ea, fa = matchNativeItemType(ia);
      fa && this.beginDragNativeItem(fa, ia);
    }, this.handleTopDragEnter = (ea) => {
      const { dragEnterTargetIds: ra } = this;
      if (this.dragEnterTargetIds = [], !this.monitor.isDragging())
        return;
      this.altKeyPressed = ea.altKey, ra.length > 0 && this.actions.hover(ra, {
        clientOffset: getEventClientOffset(ea)
      }), ra.some(
        (ia) => this.monitor.canDropOnTarget(ia)
      ) && (ea.preventDefault(), ea.dataTransfer && (ea.dataTransfer.dropEffect = this.getCurrentDropEffect()));
    }, this.handleTopDragOverCapture = (ea) => {
      if (this.dragOverTargetIds = [], this.isDraggingNativeItem()) {
        var ra;
        (ra = this.currentNativeSource) === null || ra === void 0 || ra.loadDataTransfer(ea.dataTransfer);
      }
    }, this.handleTopDragOver = (ea) => {
      const { dragOverTargetIds: ra } = this;
      if (this.dragOverTargetIds = [], !this.monitor.isDragging()) {
        ea.preventDefault(), ea.dataTransfer && (ea.dataTransfer.dropEffect = "none");
        return;
      }
      this.altKeyPressed = ea.altKey, this.lastClientOffset = getEventClientOffset(ea), this.scheduleHover(ra), (ra || []).some(
        (ia) => this.monitor.canDropOnTarget(ia)
      ) ? (ea.preventDefault(), ea.dataTransfer && (ea.dataTransfer.dropEffect = this.getCurrentDropEffect())) : this.isDraggingNativeItem() ? ea.preventDefault() : (ea.preventDefault(), ea.dataTransfer && (ea.dataTransfer.dropEffect = "none"));
    }, this.handleTopDragLeaveCapture = (ea) => {
      this.isDraggingNativeItem() && ea.preventDefault(), this.enterLeaveCounter.leave(ea.target) && (this.isDraggingNativeItem() && setTimeout(
        () => this.endDragNativeItem(),
        0
      ), this.cancelHover());
    }, this.handleTopDropCapture = (ea) => {
      if (this.dropTargetIds = [], this.isDraggingNativeItem()) {
        var ra;
        ea.preventDefault(), (ra = this.currentNativeSource) === null || ra === void 0 || ra.loadDataTransfer(ea.dataTransfer);
      } else matchNativeItemType(ea.dataTransfer) && ea.preventDefault();
      this.enterLeaveCounter.reset();
    }, this.handleTopDrop = (ea) => {
      const { dropTargetIds: ra } = this;
      this.dropTargetIds = [], this.actions.hover(ra, {
        clientOffset: getEventClientOffset(ea)
      }), this.actions.drop({
        dropEffect: this.getCurrentDropEffect()
      }), this.isDraggingNativeItem() ? this.endDragNativeItem() : this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleSelectStart = (ea) => {
      const ra = ea.target;
      typeof ra.dragDrop == "function" && (ra.tagName === "INPUT" || ra.tagName === "SELECT" || ra.tagName === "TEXTAREA" || ra.isContentEditable || (ea.preventDefault(), ra.dragDrop()));
    }, this.options = new OptionsReader(Zi, Qi), this.actions = e.getActions(), this.monitor = e.getMonitor(), this.registry = e.getRegistry(), this.enterLeaveCounter = new EnterLeaveCounter(this.isNodeInDocument);
  }
}
const HTML5Backend = function(e, Zi, Qi) {
  return new HTML5BackendImpl(e, Zi, Qi);
}, COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function toFileWithPath(Bi, e, Zi) {
  const Qi = withMimeType(Bi), { webkitRelativePath: ea } = Bi, ra = typeof e == "string" ? e : typeof ea == "string" && ea.length > 0 ? ea : `./${Bi.name}`;
  return typeof Qi.path != "string" && setObjProp(Qi, "path", ra), setObjProp(Qi, "relativePath", ra), Qi;
}
function withMimeType(Bi) {
  const { name: e } = Bi;
  if (e && e.lastIndexOf(".") !== -1 && !Bi.type) {
    const Qi = e.split(".").pop().toLowerCase(), ea = COMMON_MIME_TYPES.get(Qi);
    ea && Object.defineProperty(Bi, "type", {
      value: ea,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return Bi;
}
function setObjProp(Bi, e, Zi) {
  Object.defineProperty(Bi, e, {
    value: Zi,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const FILES_TO_IGNORE = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function fromEvent(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return isObject$1(Bi) && isDataTransfer(Bi.dataTransfer) ? getDataTransferFiles(Bi.dataTransfer, Bi.type) : isChangeEvt(Bi) ? getInputFiles(Bi) : Array.isArray(Bi) && Bi.every((e) => "getFile" in e && typeof e.getFile == "function") ? getFsHandleFiles(Bi) : [];
  });
}
function isDataTransfer(Bi) {
  return isObject$1(Bi);
}
function isChangeEvt(Bi) {
  return isObject$1(Bi) && isObject$1(Bi.target);
}
function isObject$1(Bi) {
  return typeof Bi == "object" && Bi !== null;
}
function getInputFiles(Bi) {
  return fromList(Bi.target.files).map((e) => toFileWithPath(e));
}
function getFsHandleFiles(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return (yield Promise.all(Bi.map((Zi) => Zi.getFile()))).map((Zi) => toFileWithPath(Zi));
  });
}
function getDataTransferFiles(Bi, e) {
  return __awaiter(this, void 0, void 0, function* () {
    if (Bi.items) {
      const Zi = fromList(Bi.items).filter((ea) => ea.kind === "file");
      if (e !== "drop")
        return Zi;
      const Qi = yield Promise.all(Zi.map(toFilePromises));
      return noIgnoredFiles(flatten(Qi));
    }
    return noIgnoredFiles(fromList(Bi.files).map((Zi) => toFileWithPath(Zi)));
  });
}
function noIgnoredFiles(Bi) {
  return Bi.filter((e) => FILES_TO_IGNORE.indexOf(e.name) === -1);
}
function fromList(Bi) {
  if (Bi === null)
    return [];
  const e = [];
  for (let Zi = 0; Zi < Bi.length; Zi++) {
    const Qi = Bi[Zi];
    e.push(Qi);
  }
  return e;
}
function toFilePromises(Bi) {
  if (typeof Bi.webkitGetAsEntry != "function")
    return fromDataTransferItem(Bi);
  const e = Bi.webkitGetAsEntry();
  return e && e.isDirectory ? fromDirEntry(e) : fromDataTransferItem(Bi, e);
}
function flatten(Bi) {
  return Bi.reduce((e, Zi) => [
    ...e,
    ...Array.isArray(Zi) ? flatten(Zi) : [Zi]
  ], []);
}
function fromDataTransferItem(Bi, e) {
  return __awaiter(this, void 0, void 0, function* () {
    var Zi;
    if (globalThis.isSecureContext && typeof Bi.getAsFileSystemHandle == "function") {
      const ra = yield Bi.getAsFileSystemHandle();
      if (ra === null)
        throw new Error(`${Bi} is not a File`);
      if (ra !== void 0) {
        const na = yield ra.getFile();
        return na.handle = ra, toFileWithPath(na);
      }
    }
    const Qi = Bi.getAsFile();
    if (!Qi)
      throw new Error(`${Bi} is not a File`);
    return toFileWithPath(Qi, (Zi = e?.fullPath) !== null && Zi !== void 0 ? Zi : void 0);
  });
}
function fromEntry(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return Bi.isDirectory ? fromDirEntry(Bi) : fromFileEntry(Bi);
  });
}
function fromDirEntry(Bi) {
  const e = Bi.createReader();
  return new Promise((Zi, Qi) => {
    const ea = [];
    function ra() {
      e.readEntries((na) => __awaiter(this, void 0, void 0, function* () {
        if (na.length) {
          const ia = Promise.all(na.map(fromEntry));
          ea.push(ia), ra();
        } else
          try {
            const ia = yield Promise.all(ea);
            Zi(ia);
          } catch (ia) {
            Qi(ia);
          }
      }), (na) => {
        Qi(na);
      });
    }
    ra();
  });
}
function fromFileEntry(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return new Promise((e, Zi) => {
      Bi.file((Qi) => {
        const ea = toFileWithPath(Qi, Bi.fullPath);
        e(ea);
      }, (Qi) => {
        Zi(Qi);
      });
    });
  });
}
var es$1 = {}, hasRequiredEs;
function requireEs() {
  return hasRequiredEs || (hasRequiredEs = 1, es$1.__esModule = !0, es$1.default = function(Bi, e) {
    if (Bi && e) {
      var Zi = Array.isArray(e) ? e : e.split(",");
      if (Zi.length === 0)
        return !0;
      var Qi = Bi.name || "", ea = (Bi.type || "").toLowerCase(), ra = ea.replace(/\/.*$/, "");
      return Zi.some(function(na) {
        var ia = na.trim().toLowerCase();
        return ia.charAt(0) === "." ? Qi.toLowerCase().endsWith(ia) : ia.endsWith("/*") ? ra === ia.replace(/\/.*$/, "") : ea === ia;
      });
    }
    return !0;
  }), es$1;
}
var esExports = requireEs();
const _accepts = /* @__PURE__ */ getDefaultExportFromCjs(esExports);
function _toConsumableArray$1(Bi) {
  return _arrayWithoutHoles$1(Bi) || _iterableToArray$1(Bi) || _unsupportedIterableToArray$1(Bi) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$1(Bi) {
  if (typeof Symbol < "u" && Bi[Symbol.iterator] != null || Bi["@@iterator"] != null) return Array.from(Bi);
}
function _arrayWithoutHoles$1(Bi) {
  if (Array.isArray(Bi)) return _arrayLikeToArray$1(Bi);
}
function ownKeys$1(Bi, e) {
  var Zi = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Qi = Object.getOwnPropertySymbols(Bi);
    e && (Qi = Qi.filter(function(ea) {
      return Object.getOwnPropertyDescriptor(Bi, ea).enumerable;
    })), Zi.push.apply(Zi, Qi);
  }
  return Zi;
}
function _objectSpread$1(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Zi = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys$1(Object(Zi), !0).forEach(function(Qi) {
      _defineProperty$1(Bi, Qi, Zi[Qi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(Zi)) : ownKeys$1(Object(Zi)).forEach(function(Qi) {
      Object.defineProperty(Bi, Qi, Object.getOwnPropertyDescriptor(Zi, Qi));
    });
  }
  return Bi;
}
function _defineProperty$1(Bi, e, Zi) {
  return e in Bi ? Object.defineProperty(Bi, e, { value: Zi, enumerable: !0, configurable: !0, writable: !0 }) : Bi[e] = Zi, Bi;
}
function _slicedToArray$1(Bi, e) {
  return _arrayWithHoles$1(Bi) || _iterableToArrayLimit$1(Bi, e) || _unsupportedIterableToArray$1(Bi, e) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray$1(Bi, e);
    var Zi = Object.prototype.toString.call(Bi).slice(8, -1);
    if (Zi === "Object" && Bi.constructor && (Zi = Bi.constructor.name), Zi === "Map" || Zi === "Set") return Array.from(Bi);
    if (Zi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Zi)) return _arrayLikeToArray$1(Bi, e);
  }
}
function _arrayLikeToArray$1(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var Zi = 0, Qi = new Array(e); Zi < e; Zi++)
    Qi[Zi] = Bi[Zi];
  return Qi;
}
function _iterableToArrayLimit$1(Bi, e) {
  var Zi = Bi == null ? null : typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (Zi != null) {
    var Qi = [], ea = !0, ra = !1, na, ia;
    try {
      for (Zi = Zi.call(Bi); !(ea = (na = Zi.next()).done) && (Qi.push(na.value), !(e && Qi.length === e)); ea = !0)
        ;
    } catch (fa) {
      ra = !0, ia = fa;
    } finally {
      try {
        !ea && Zi.return != null && Zi.return();
      } finally {
        if (ra) throw ia;
      }
    }
    return Qi;
  }
}
function _arrayWithHoles$1(Bi) {
  if (Array.isArray(Bi)) return Bi;
}
var accepts = typeof _accepts == "function" ? _accepts : _accepts.default, FILE_INVALID_TYPE = "file-invalid-type", FILE_TOO_LARGE = "file-too-large", FILE_TOO_SMALL = "file-too-small", TOO_MANY_FILES = "too-many-files", getInvalidTypeRejectionErr = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", Zi = e.split(","), Qi = Zi.length > 1 ? "one of ".concat(Zi.join(", ")) : Zi[0];
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(Qi)
  };
}, getTooLargeRejectionErr = function(e) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(e, " ").concat(e === 1 ? "byte" : "bytes")
  };
}, getTooSmallRejectionErr = function(e) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(e, " ").concat(e === 1 ? "byte" : "bytes")
  };
}, TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(Bi, e) {
  var Zi = Bi.type === "application/x-moz-file" || accepts(Bi, e);
  return [Zi, Zi ? null : getInvalidTypeRejectionErr(e)];
}
function fileMatchSize(Bi, e, Zi) {
  if (isDefined(Bi.size))
    if (isDefined(e) && isDefined(Zi)) {
      if (Bi.size > Zi) return [!1, getTooLargeRejectionErr(Zi)];
      if (Bi.size < e) return [!1, getTooSmallRejectionErr(e)];
    } else {
      if (isDefined(e) && Bi.size < e) return [!1, getTooSmallRejectionErr(e)];
      if (isDefined(Zi) && Bi.size > Zi) return [!1, getTooLargeRejectionErr(Zi)];
    }
  return [!0, null];
}
function isDefined(Bi) {
  return Bi != null;
}
function allFilesAccepted(Bi) {
  var e = Bi.files, Zi = Bi.accept, Qi = Bi.minSize, ea = Bi.maxSize, ra = Bi.multiple, na = Bi.maxFiles, ia = Bi.validator;
  return !ra && e.length > 1 || ra && na >= 1 && e.length > na ? !1 : e.every(function(fa) {
    var La = fileAccepted(fa, Zi), Va = _slicedToArray$1(La, 1), to = Va[0], ro = fileMatchSize(fa, Qi, ea), no = _slicedToArray$1(ro, 1), eo = no[0], ao = ia ? ia(fa) : null;
    return to && eo && !ao;
  });
}
function isPropagationStopped(Bi) {
  return typeof Bi.isPropagationStopped == "function" ? Bi.isPropagationStopped() : typeof Bi.cancelBubble < "u" ? Bi.cancelBubble : !1;
}
function isEvtWithFiles(Bi) {
  return Bi.dataTransfer ? Array.prototype.some.call(Bi.dataTransfer.types, function(e) {
    return e === "Files" || e === "application/x-moz-file";
  }) : !!Bi.target && !!Bi.target.files;
}
function onDocumentDragOver(Bi) {
  Bi.preventDefault();
}
function isIe(Bi) {
  return Bi.indexOf("MSIE") !== -1 || Bi.indexOf("Trident/") !== -1;
}
function isEdge(Bi) {
  return Bi.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(Bi) || isEdge(Bi);
}
function composeEventHandlers() {
  for (var Bi = arguments.length, e = new Array(Bi), Zi = 0; Zi < Bi; Zi++)
    e[Zi] = arguments[Zi];
  return function(Qi) {
    for (var ea = arguments.length, ra = new Array(ea > 1 ? ea - 1 : 0), na = 1; na < ea; na++)
      ra[na - 1] = arguments[na];
    return e.some(function(ia) {
      return !isPropagationStopped(Qi) && ia && ia.apply(void 0, [Qi].concat(ra)), isPropagationStopped(Qi);
    });
  };
}
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(Bi) {
  if (isDefined(Bi)) {
    var e = Object.entries(Bi).filter(function(Zi) {
      var Qi = _slicedToArray$1(Zi, 2), ea = Qi[0], ra = Qi[1], na = !0;
      return isMIMEType(ea) || (console.warn('Skipped "'.concat(ea, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), na = !1), (!Array.isArray(ra) || !ra.every(isExt)) && (console.warn('Skipped "'.concat(ea, '" because an invalid file extension was provided.')), na = !1), na;
    }).reduce(function(Zi, Qi) {
      var ea = _slicedToArray$1(Qi, 2), ra = ea[0], na = ea[1];
      return _objectSpread$1(_objectSpread$1({}, Zi), {}, _defineProperty$1({}, ra, na));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: e
    }];
  }
  return Bi;
}
function acceptPropAsAcceptAttr(Bi) {
  if (isDefined(Bi))
    return Object.entries(Bi).reduce(function(e, Zi) {
      var Qi = _slicedToArray$1(Zi, 2), ea = Qi[0], ra = Qi[1];
      return [].concat(_toConsumableArray$1(e), [ea], _toConsumableArray$1(ra));
    }, []).filter(function(e) {
      return isMIMEType(e) || isExt(e);
    }).join(",");
}
function isAbort(Bi) {
  return Bi instanceof DOMException && (Bi.name === "AbortError" || Bi.code === Bi.ABORT_ERR);
}
function isSecurityError(Bi) {
  return Bi instanceof DOMException && (Bi.name === "SecurityError" || Bi.code === Bi.SECURITY_ERR);
}
function isMIMEType(Bi) {
  return Bi === "audio/*" || Bi === "video/*" || Bi === "image/*" || Bi === "text/*" || Bi === "application/*" || /\w+\/[-+.\w]+/g.test(Bi);
}
function isExt(Bi) {
  return /^.*\.[\w]+$/.test(Bi);
}
var _excluded = ["children"], _excluded2 = ["open"], _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray(Bi) {
  return _arrayWithoutHoles(Bi) || _iterableToArray(Bi) || _unsupportedIterableToArray(Bi) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray(Bi) {
  if (typeof Symbol < "u" && Bi[Symbol.iterator] != null || Bi["@@iterator"] != null) return Array.from(Bi);
}
function _arrayWithoutHoles(Bi) {
  if (Array.isArray(Bi)) return _arrayLikeToArray(Bi);
}
function _slicedToArray(Bi, e) {
  return _arrayWithHoles(Bi) || _iterableToArrayLimit(Bi, e) || _unsupportedIterableToArray(Bi, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray(Bi, e);
    var Zi = Object.prototype.toString.call(Bi).slice(8, -1);
    if (Zi === "Object" && Bi.constructor && (Zi = Bi.constructor.name), Zi === "Map" || Zi === "Set") return Array.from(Bi);
    if (Zi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Zi)) return _arrayLikeToArray(Bi, e);
  }
}
function _arrayLikeToArray(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var Zi = 0, Qi = new Array(e); Zi < e; Zi++)
    Qi[Zi] = Bi[Zi];
  return Qi;
}
function _iterableToArrayLimit(Bi, e) {
  var Zi = Bi == null ? null : typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (Zi != null) {
    var Qi = [], ea = !0, ra = !1, na, ia;
    try {
      for (Zi = Zi.call(Bi); !(ea = (na = Zi.next()).done) && (Qi.push(na.value), !(e && Qi.length === e)); ea = !0)
        ;
    } catch (fa) {
      ra = !0, ia = fa;
    } finally {
      try {
        !ea && Zi.return != null && Zi.return();
      } finally {
        if (ra) throw ia;
      }
    }
    return Qi;
  }
}
function _arrayWithHoles(Bi) {
  if (Array.isArray(Bi)) return Bi;
}
function ownKeys(Bi, e) {
  var Zi = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Qi = Object.getOwnPropertySymbols(Bi);
    e && (Qi = Qi.filter(function(ea) {
      return Object.getOwnPropertyDescriptor(Bi, ea).enumerable;
    })), Zi.push.apply(Zi, Qi);
  }
  return Zi;
}
function _objectSpread(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var Zi = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys(Object(Zi), !0).forEach(function(Qi) {
      _defineProperty(Bi, Qi, Zi[Qi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(Zi)) : ownKeys(Object(Zi)).forEach(function(Qi) {
      Object.defineProperty(Bi, Qi, Object.getOwnPropertyDescriptor(Zi, Qi));
    });
  }
  return Bi;
}
function _defineProperty(Bi, e, Zi) {
  return e in Bi ? Object.defineProperty(Bi, e, { value: Zi, enumerable: !0, configurable: !0, writable: !0 }) : Bi[e] = Zi, Bi;
}
function _objectWithoutProperties(Bi, e) {
  if (Bi == null) return {};
  var Zi = _objectWithoutPropertiesLoose(Bi, e), Qi, ea;
  if (Object.getOwnPropertySymbols) {
    var ra = Object.getOwnPropertySymbols(Bi);
    for (ea = 0; ea < ra.length; ea++)
      Qi = ra[ea], !(e.indexOf(Qi) >= 0) && Object.prototype.propertyIsEnumerable.call(Bi, Qi) && (Zi[Qi] = Bi[Qi]);
  }
  return Zi;
}
function _objectWithoutPropertiesLoose(Bi, e) {
  if (Bi == null) return {};
  var Zi = {}, Qi = Object.keys(Bi), ea, ra;
  for (ra = 0; ra < Qi.length; ra++)
    ea = Qi[ra], !(e.indexOf(ea) >= 0) && (Zi[ea] = Bi[ea]);
  return Zi;
}
var Dropzone = /* @__PURE__ */ forwardRef(function(Bi, e) {
  var Zi = Bi.children, Qi = _objectWithoutProperties(Bi, _excluded), ea = useDropzone(Qi), ra = ea.open, na = _objectWithoutProperties(ea, _excluded2);
  return useImperativeHandle(e, function() {
    return {
      open: ra
    };
  }, [ra]), /* @__PURE__ */ a__default.createElement(Fragment, null, Zi(_objectSpread(_objectSpread({}, na), {}, {
    open: ra
  })));
});
Dropzone.displayName = "Dropzone";
var defaultProps = {
  disabled: !1,
  getFilesFromEvent: fromEvent,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
var initialState = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = _objectSpread(_objectSpread({}, defaultProps), Bi), Zi = e.accept, Qi = e.disabled, ea = e.getFilesFromEvent, ra = e.maxSize, na = e.minSize, ia = e.multiple, fa = e.maxFiles, La = e.onDragEnter, Va = e.onDragLeave, to = e.onDragOver, ro = e.onDrop, no = e.onDropAccepted, eo = e.onDropRejected, ao = e.onFileDialogCancel, io = e.onFileDialogOpen, xs = e.useFsAccessApi, Ts = e.autoFocus, qs = e.preventDropOnDocument, Fs = e.noClick, Do = e.noKeyboard, ys = e.noDrag, Io = e.noDragEventsBubbling, so = e.onError, os = e.validator, Xs = useMemo(function() {
    return acceptPropAsAcceptAttr(Zi);
  }, [Zi]), gl = useMemo(function() {
    return pickerOptionsFromAccept(Zi);
  }, [Zi]), Sl = useMemo(function() {
    return typeof io == "function" ? io : noop;
  }, [io]), El = useMemo(function() {
    return typeof ao == "function" ? ao : noop;
  }, [ao]), wl = useRef(null), jl = useRef(null), kl = useReducer(reducer, initialState), Fl = _slicedToArray(kl, 2), Ml = Fl[0], ql = Fl[1], Kl = Ml.isFocused, Zl = Ml.isFileDialogActive, Il = useRef(typeof window < "u" && window.isSecureContext && xs && canUseFileSystemAccessAPI()), xl = function() {
    !Il.current && Zl && setTimeout(function() {
      if (jl.current) {
        var rc = jl.current.files;
        rc.length || (ql({
          type: "closeDialog"
        }), El());
      }
    }, 300);
  };
  useEffect(function() {
    return window.addEventListener("focus", xl, !1), function() {
      window.removeEventListener("focus", xl, !1);
    };
  }, [jl, Zl, El, Il]);
  var bl = useRef([]), Pl = function(rc) {
    wl.current && wl.current.contains(rc.target) || (rc.preventDefault(), bl.current = []);
  };
  useEffect(function() {
    return qs && (document.addEventListener("dragover", onDocumentDragOver, !1), document.addEventListener("drop", Pl, !1)), function() {
      qs && (document.removeEventListener("dragover", onDocumentDragOver), document.removeEventListener("drop", Pl));
    };
  }, [wl, qs]), useEffect(function() {
    return !Qi && Ts && wl.current && wl.current.focus(), function() {
    };
  }, [wl, Ts, Qi]);
  var Nl = useCallback(function(Wl) {
    so ? so(Wl) : console.error(Wl);
  }, [so]), Bl = useCallback(function(Wl) {
    Wl.preventDefault(), Wl.persist(), zl(Wl), bl.current = [].concat(_toConsumableArray(bl.current), [Wl.target]), isEvtWithFiles(Wl) && Promise.resolve(ea(Wl)).then(function(rc) {
      if (!(isPropagationStopped(Wl) && !Io)) {
        var uc = rc.length, ac = uc > 0 && allFilesAccepted({
          files: rc,
          accept: Xs,
          minSize: na,
          maxSize: ra,
          multiple: ia,
          maxFiles: fa,
          validator: os
        }), zu = uc > 0 && !ac;
        ql({
          isDragAccept: ac,
          isDragReject: zu,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), La && La(Wl);
      }
    }).catch(function(rc) {
      return Nl(rc);
    });
  }, [ea, La, Nl, Io, Xs, na, ra, ia, fa, os]), Ol = useCallback(function(Wl) {
    Wl.preventDefault(), Wl.persist(), zl(Wl);
    var rc = isEvtWithFiles(Wl);
    if (rc && Wl.dataTransfer)
      try {
        Wl.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return rc && to && to(Wl), !1;
  }, [to, Io]), To = useCallback(function(Wl) {
    Wl.preventDefault(), Wl.persist(), zl(Wl);
    var rc = bl.current.filter(function(ac) {
      return wl.current && wl.current.contains(ac);
    }), uc = rc.indexOf(Wl.target);
    uc !== -1 && rc.splice(uc, 1), bl.current = rc, !(rc.length > 0) && (ql({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), isEvtWithFiles(Wl) && Va && Va(Wl));
  }, [wl, Va, Io]), Os = useCallback(function(Wl, rc) {
    var uc = [], ac = [];
    Wl.forEach(function(zu) {
      var Xu = fileAccepted(zu, Xs), ed = _slicedToArray(Xu, 2), td = ed[0], od = ed[1], ld = fileMatchSize(zu, na, ra), sd = _slicedToArray(ld, 2), bd = sd[0], $d = sd[1], _d = os ? os(zu) : null;
      if (td && bd && !_d)
        uc.push(zu);
      else {
        var tc = [od, $d];
        _d && (tc = tc.concat(_d)), ac.push({
          file: zu,
          errors: tc.filter(function(Xl) {
            return Xl;
          })
        });
      }
    }), (!ia && uc.length > 1 || ia && fa >= 1 && uc.length > fa) && (uc.forEach(function(zu) {
      ac.push({
        file: zu,
        errors: [TOO_MANY_FILES_REJECTION]
      });
    }), uc.splice(0)), ql({
      acceptedFiles: uc,
      fileRejections: ac,
      isDragReject: ac.length > 0,
      type: "setFiles"
    }), ro && ro(uc, ac, rc), ac.length > 0 && eo && eo(ac, rc), uc.length > 0 && no && no(uc, rc);
  }, [ql, ia, Xs, na, ra, fa, ro, no, eo, os]), $l = useCallback(function(Wl) {
    Wl.preventDefault(), Wl.persist(), zl(Wl), bl.current = [], isEvtWithFiles(Wl) && Promise.resolve(ea(Wl)).then(function(rc) {
      isPropagationStopped(Wl) && !Io || Os(rc, Wl);
    }).catch(function(rc) {
      return Nl(rc);
    }), ql({
      type: "reset"
    });
  }, [ea, Os, Nl, Io]), _l = useCallback(function() {
    if (Il.current) {
      ql({
        type: "openDialog"
      }), Sl();
      var Wl = {
        multiple: ia,
        types: gl
      };
      window.showOpenFilePicker(Wl).then(function(rc) {
        return ea(rc);
      }).then(function(rc) {
        Os(rc, null), ql({
          type: "closeDialog"
        });
      }).catch(function(rc) {
        isAbort(rc) ? (El(rc), ql({
          type: "closeDialog"
        })) : isSecurityError(rc) ? (Il.current = !1, jl.current ? (jl.current.value = null, jl.current.click()) : Nl(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : Nl(rc);
      });
      return;
    }
    jl.current && (ql({
      type: "openDialog"
    }), Sl(), jl.current.value = null, jl.current.click());
  }, [ql, Sl, El, xs, Os, Nl, gl, ia]), Al = useCallback(function(Wl) {
    !wl.current || !wl.current.isEqualNode(Wl.target) || (Wl.key === " " || Wl.key === "Enter" || Wl.keyCode === 32 || Wl.keyCode === 13) && (Wl.preventDefault(), _l());
  }, [wl, _l]), Rl = useCallback(function() {
    ql({
      type: "focus"
    });
  }, []), Cl = useCallback(function() {
    ql({
      type: "blur"
    });
  }, []), ml = useCallback(function() {
    Fs || (isIeOrEdge() ? setTimeout(_l, 0) : _l());
  }, [Fs, _l]), Tl = function(rc) {
    return Qi ? null : rc;
  }, Ll = function(rc) {
    return Do ? null : Tl(rc);
  }, Vl = function(rc) {
    return ys ? null : Tl(rc);
  }, zl = function(rc) {
    Io && rc.stopPropagation();
  }, Ul = useMemo(function() {
    return function() {
      var Wl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, rc = Wl.refKey, uc = rc === void 0 ? "ref" : rc, ac = Wl.role, zu = Wl.onKeyDown, Xu = Wl.onFocus, ed = Wl.onBlur, td = Wl.onClick, od = Wl.onDragEnter, ld = Wl.onDragOver, sd = Wl.onDragLeave, bd = Wl.onDrop, $d = _objectWithoutProperties(Wl, _excluded3);
      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: Ll(composeEventHandlers(zu, Al)),
        onFocus: Ll(composeEventHandlers(Xu, Rl)),
        onBlur: Ll(composeEventHandlers(ed, Cl)),
        onClick: Tl(composeEventHandlers(td, ml)),
        onDragEnter: Vl(composeEventHandlers(od, Bl)),
        onDragOver: Vl(composeEventHandlers(ld, Ol)),
        onDragLeave: Vl(composeEventHandlers(sd, To)),
        onDrop: Vl(composeEventHandlers(bd, $l)),
        role: typeof ac == "string" && ac !== "" ? ac : "presentation"
      }, uc, wl), !Qi && !Do ? {
        tabIndex: 0
      } : {}), $d);
    };
  }, [wl, Al, Rl, Cl, ml, Bl, Ol, To, $l, Do, ys, Qi]), Yl = useCallback(function(Wl) {
    Wl.stopPropagation();
  }, []), Jl = useMemo(function() {
    return function() {
      var Wl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, rc = Wl.refKey, uc = rc === void 0 ? "ref" : rc, ac = Wl.onChange, zu = Wl.onClick, Xu = _objectWithoutProperties(Wl, _excluded4), ed = _defineProperty({
        accept: Xs,
        multiple: ia,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: Tl(composeEventHandlers(ac, $l)),
        onClick: Tl(composeEventHandlers(zu, Yl)),
        tabIndex: -1
      }, uc, jl);
      return _objectSpread(_objectSpread({}, ed), Xu);
    };
  }, [jl, Zi, ia, $l, Qi]);
  return _objectSpread(_objectSpread({}, Ml), {}, {
    isFocused: Kl && !Qi,
    getRootProps: Ul,
    getInputProps: Jl,
    rootRef: wl,
    inputRef: jl,
    open: Tl(_l)
  });
}
function reducer(Bi, e) {
  switch (e.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isFocused: !0
      });
    case "blur":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isFocused: !1
      });
    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isDragActive: e.isDragActive,
        isDragAccept: e.isDragAccept,
        isDragReject: e.isDragReject
      });
    case "setFiles":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        acceptedFiles: e.acceptedFiles,
        fileRejections: e.fileRejections,
        isDragReject: e.isDragReject
      });
    case "reset":
      return _objectSpread({}, initialState);
    default:
      return Bi;
  }
}
function noop() {
}
const CheckBox = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "checkbox", ...Bi, className: "bg-neutral-600 checkbox" });
var isCheckBoxInput = (Bi) => Bi.type === "checkbox", isDateObject = (Bi) => Bi instanceof Date, isNullOrUndefined = (Bi) => Bi == null;
const isObjectType = (Bi) => typeof Bi == "object";
var isObject = (Bi) => !isNullOrUndefined(Bi) && !Array.isArray(Bi) && isObjectType(Bi) && !isDateObject(Bi), getEventValue = (Bi) => isObject(Bi) && Bi.target ? isCheckBoxInput(Bi.target) ? Bi.target.checked : Bi.target.value : Bi, getNodeParentName = (Bi) => Bi.substring(0, Bi.search(/\.\d+(\.|$)/)) || Bi, isNameInFieldArray = (Bi, e) => Bi.has(getNodeParentName(e)), isPlainObject = (Bi) => {
  const e = Bi.constructor && Bi.constructor.prototype;
  return isObject(e) && e.hasOwnProperty("isPrototypeOf");
}, isWeb = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function cloneObject(Bi) {
  let e;
  const Zi = Array.isArray(Bi);
  if (Bi instanceof Date)
    e = new Date(Bi);
  else if (Bi instanceof Set)
    e = new Set(Bi);
  else if (!(isWeb && (Bi instanceof Blob || Bi instanceof FileList)) && (Zi || isObject(Bi)))
    if (e = Zi ? [] : {}, !Zi && !isPlainObject(Bi))
      e = Bi;
    else
      for (const Qi in Bi)
        Bi.hasOwnProperty(Qi) && (e[Qi] = cloneObject(Bi[Qi]));
  else
    return Bi;
  return e;
}
var compact = (Bi) => Array.isArray(Bi) ? Bi.filter(Boolean) : [], isUndefined = (Bi) => Bi === void 0, get = (Bi, e, Zi) => {
  if (!e || !isObject(Bi))
    return Zi;
  const Qi = compact(e.split(/[,[\].]+?/)).reduce((ea, ra) => isNullOrUndefined(ea) ? ea : ea[ra], Bi);
  return isUndefined(Qi) || Qi === Bi ? isUndefined(Bi[e]) ? Zi : Bi[e] : Qi;
};
const EVENTS = {
  BLUR: "blur",
  FOCUS_OUT: "focusout"
}, VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, INPUT_VALIDATION_RULES = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
a__default.createContext(null);
var getProxyFormState = (Bi, e, Zi, Qi = !0) => {
  const ea = {
    defaultValues: e._defaultValues
  };
  for (const ra in Bi)
    Object.defineProperty(ea, ra, {
      get: () => {
        const na = ra;
        return e._proxyFormState[na] !== VALIDATION_MODE.all && (e._proxyFormState[na] = !Qi || VALIDATION_MODE.all), Bi[na];
      }
    });
  return ea;
}, isEmptyObject = (Bi) => isObject(Bi) && !Object.keys(Bi).length, shouldRenderFormState = (Bi, e, Zi, Qi) => {
  Zi(Bi);
  const { name: ea, ...ra } = Bi;
  return isEmptyObject(ra) || Object.keys(ra).length >= Object.keys(e).length || Object.keys(ra).find((na) => e[na] === VALIDATION_MODE.all);
}, convertToArrayPayload = (Bi) => Array.isArray(Bi) ? Bi : [Bi];
function useSubscribe(Bi) {
  const e = a__default.useRef(Bi);
  e.current = Bi, a__default.useEffect(() => {
    const Zi = !Bi.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      Zi && Zi.unsubscribe();
    };
  }, [Bi.disabled]);
}
var isString = (Bi) => typeof Bi == "string", generateWatchOutput = (Bi, e, Zi, Qi, ea) => isString(Bi) ? (Qi && e.watch.add(Bi), get(Zi, Bi, ea)) : Array.isArray(Bi) ? Bi.map((ra) => (Qi && e.watch.add(ra), get(Zi, ra))) : (Qi && (e.watchAll = !0), Zi), isKey = (Bi) => /^\w*$/.test(Bi), stringToPath = (Bi) => compact(Bi.replace(/["|']|\]/g, "").split(/\.|\[/));
function set(Bi, e, Zi) {
  let Qi = -1;
  const ea = isKey(e) ? [e] : stringToPath(e), ra = ea.length, na = ra - 1;
  for (; ++Qi < ra; ) {
    const ia = ea[Qi];
    let fa = Zi;
    if (Qi !== na) {
      const La = Bi[ia];
      fa = isObject(La) || Array.isArray(La) ? La : isNaN(+ea[Qi + 1]) ? {} : [];
    }
    Bi[ia] = fa, Bi = Bi[ia];
  }
  return Bi;
}
var appendErrors = (Bi, e, Zi, Qi, ea) => e ? {
  ...Zi[Bi],
  types: {
    ...Zi[Bi] && Zi[Bi].types ? Zi[Bi].types : {},
    [Qi]: ea || !0
  }
} : {};
const focusFieldBy = (Bi, e, Zi) => {
  for (const Qi of Zi || Object.keys(Bi)) {
    const ea = get(Bi, Qi);
    if (ea) {
      const { _f: ra, ...na } = ea;
      if (ra && e(ra.name)) {
        if (ra.ref.focus) {
          ra.ref.focus();
          break;
        } else if (ra.refs && ra.refs[0].focus) {
          ra.refs[0].focus();
          break;
        }
      } else isObject(na) && focusFieldBy(na, e);
    }
  }
};
var getValidationModes = (Bi) => ({
  isOnSubmit: !Bi || Bi === VALIDATION_MODE.onSubmit,
  isOnBlur: Bi === VALIDATION_MODE.onBlur,
  isOnChange: Bi === VALIDATION_MODE.onChange,
  isOnAll: Bi === VALIDATION_MODE.all,
  isOnTouch: Bi === VALIDATION_MODE.onTouched
}), isWatched = (Bi, e, Zi) => !Zi && (e.watchAll || e.watch.has(Bi) || [...e.watch].some((Qi) => Bi.startsWith(Qi) && /^\.\w+/.test(Bi.slice(Qi.length)))), updateFieldArrayRootError = (Bi, e, Zi) => {
  const Qi = compact(get(Bi, Zi));
  return set(Qi, "root", e[Zi]), set(Bi, Zi, Qi), Bi;
}, isBoolean$1 = (Bi) => typeof Bi == "boolean", isFileInput = (Bi) => Bi.type === "file", isFunction = (Bi) => typeof Bi == "function", isHTMLElement = (Bi) => {
  if (!isWeb)
    return !1;
  const e = Bi ? Bi.ownerDocument : 0;
  return Bi instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, isMessage = (Bi) => isString(Bi), isRadioInput = (Bi) => Bi.type === "radio", isRegex = (Bi) => Bi instanceof RegExp;
const defaultResult = {
  value: !1,
  isValid: !1
}, validResult = { value: !0, isValid: !0 };
var getCheckboxValue = (Bi) => {
  if (Array.isArray(Bi)) {
    if (Bi.length > 1) {
      const e = Bi.filter((Zi) => Zi && Zi.checked && !Zi.disabled).map((Zi) => Zi.value);
      return { value: e, isValid: !!e.length };
    }
    return Bi[0].checked && !Bi[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      Bi[0].attributes && !isUndefined(Bi[0].attributes.value) ? isUndefined(Bi[0].value) || Bi[0].value === "" ? validResult : { value: Bi[0].value, isValid: !0 } : validResult
    ) : defaultResult;
  }
  return defaultResult;
};
const defaultReturn = {
  isValid: !1,
  value: null
};
var getRadioValue = (Bi) => Array.isArray(Bi) ? Bi.reduce((e, Zi) => Zi && Zi.checked && !Zi.disabled ? {
  isValid: !0,
  value: Zi.value
} : e, defaultReturn) : defaultReturn;
function getValidateError(Bi, e, Zi = "validate") {
  if (isMessage(Bi) || Array.isArray(Bi) && Bi.every(isMessage) || isBoolean$1(Bi) && !Bi)
    return {
      type: Zi,
      message: isMessage(Bi) ? Bi : "",
      ref: e
    };
}
var getValueAndMessage = (Bi) => isObject(Bi) && !isRegex(Bi) ? Bi : {
  value: Bi,
  message: ""
}, validateField = async (Bi, e, Zi, Qi, ea) => {
  const { ref: ra, refs: na, required: ia, maxLength: fa, minLength: La, min: Va, max: to, pattern: ro, validate: no, name: eo, valueAsNumber: ao, mount: io, disabled: xs } = Bi._f, Ts = get(e, eo);
  if (!io || xs)
    return {};
  const qs = na ? na[0] : ra, Fs = (Sl) => {
    Qi && qs.reportValidity && (qs.setCustomValidity(isBoolean$1(Sl) ? "" : Sl || ""), qs.reportValidity());
  }, Do = {}, ys = isRadioInput(ra), Io = isCheckBoxInput(ra), so = ys || Io, os = (ao || isFileInput(ra)) && isUndefined(ra.value) && isUndefined(Ts) || isHTMLElement(ra) && ra.value === "" || Ts === "" || Array.isArray(Ts) && !Ts.length, Xs = appendErrors.bind(null, eo, Zi, Do), gl = (Sl, El, wl, jl = INPUT_VALIDATION_RULES.maxLength, kl = INPUT_VALIDATION_RULES.minLength) => {
    const Fl = Sl ? El : wl;
    Do[eo] = {
      type: Sl ? jl : kl,
      message: Fl,
      ref: ra,
      ...Xs(Sl ? jl : kl, Fl)
    };
  };
  if (ea ? !Array.isArray(Ts) || !Ts.length : ia && (!so && (os || isNullOrUndefined(Ts)) || isBoolean$1(Ts) && !Ts || Io && !getCheckboxValue(na).isValid || ys && !getRadioValue(na).isValid)) {
    const { value: Sl, message: El } = isMessage(ia) ? { value: !!ia, message: ia } : getValueAndMessage(ia);
    if (Sl && (Do[eo] = {
      type: INPUT_VALIDATION_RULES.required,
      message: El,
      ref: qs,
      ...Xs(INPUT_VALIDATION_RULES.required, El)
    }, !Zi))
      return Fs(El), Do;
  }
  if (!os && (!isNullOrUndefined(Va) || !isNullOrUndefined(to))) {
    let Sl, El;
    const wl = getValueAndMessage(to), jl = getValueAndMessage(Va);
    if (!isNullOrUndefined(Ts) && !isNaN(Ts)) {
      const kl = ra.valueAsNumber || Ts && +Ts;
      isNullOrUndefined(wl.value) || (Sl = kl > wl.value), isNullOrUndefined(jl.value) || (El = kl < jl.value);
    } else {
      const kl = ra.valueAsDate || new Date(Ts), Fl = (Kl) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Kl), Ml = ra.type == "time", ql = ra.type == "week";
      isString(wl.value) && Ts && (Sl = Ml ? Fl(Ts) > Fl(wl.value) : ql ? Ts > wl.value : kl > new Date(wl.value)), isString(jl.value) && Ts && (El = Ml ? Fl(Ts) < Fl(jl.value) : ql ? Ts < jl.value : kl < new Date(jl.value));
    }
    if ((Sl || El) && (gl(!!Sl, wl.message, jl.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min), !Zi))
      return Fs(Do[eo].message), Do;
  }
  if ((fa || La) && !os && (isString(Ts) || ea && Array.isArray(Ts))) {
    const Sl = getValueAndMessage(fa), El = getValueAndMessage(La), wl = !isNullOrUndefined(Sl.value) && Ts.length > +Sl.value, jl = !isNullOrUndefined(El.value) && Ts.length < +El.value;
    if ((wl || jl) && (gl(wl, Sl.message, El.message), !Zi))
      return Fs(Do[eo].message), Do;
  }
  if (ro && !os && isString(Ts)) {
    const { value: Sl, message: El } = getValueAndMessage(ro);
    if (isRegex(Sl) && !Ts.match(Sl) && (Do[eo] = {
      type: INPUT_VALIDATION_RULES.pattern,
      message: El,
      ref: ra,
      ...Xs(INPUT_VALIDATION_RULES.pattern, El)
    }, !Zi))
      return Fs(El), Do;
  }
  if (no) {
    if (isFunction(no)) {
      const Sl = await no(Ts, e), El = getValidateError(Sl, qs);
      if (El && (Do[eo] = {
        ...El,
        ...Xs(INPUT_VALIDATION_RULES.validate, El.message)
      }, !Zi))
        return Fs(El.message), Do;
    } else if (isObject(no)) {
      let Sl = {};
      for (const El in no) {
        if (!isEmptyObject(Sl) && !Zi)
          break;
        const wl = getValidateError(await no[El](Ts, e), qs, El);
        wl && (Sl = {
          ...wl,
          ...Xs(El, wl.message)
        }, Fs(wl.message), Zi && (Do[eo] = Sl));
      }
      if (!isEmptyObject(Sl) && (Do[eo] = {
        ref: qs,
        ...Sl
      }, !Zi))
        return Do;
    }
  }
  return Fs(!0), Do;
};
function baseGet(Bi, e) {
  const Zi = e.slice(0, -1).length;
  let Qi = 0;
  for (; Qi < Zi; )
    Bi = isUndefined(Bi) ? Qi++ : Bi[e[Qi++]];
  return Bi;
}
function isEmptyArray(Bi) {
  for (const e in Bi)
    if (Bi.hasOwnProperty(e) && !isUndefined(Bi[e]))
      return !1;
  return !0;
}
function unset(Bi, e) {
  const Zi = Array.isArray(e) ? e : isKey(e) ? [e] : stringToPath(e), Qi = Zi.length === 1 ? Bi : baseGet(Bi, Zi), ea = Zi.length - 1, ra = Zi[ea];
  return Qi && delete Qi[ra], ea !== 0 && (isObject(Qi) && isEmptyObject(Qi) || Array.isArray(Qi) && isEmptyArray(Qi)) && unset(Bi, Zi.slice(0, -1)), Bi;
}
function createSubject() {
  let Bi = [];
  return {
    get observers() {
      return Bi;
    },
    next: (ea) => {
      for (const ra of Bi)
        ra.next && ra.next(ea);
    },
    subscribe: (ea) => (Bi.push(ea), {
      unsubscribe: () => {
        Bi = Bi.filter((ra) => ra !== ea);
      }
    }),
    unsubscribe: () => {
      Bi = [];
    }
  };
}
var isPrimitive = (Bi) => isNullOrUndefined(Bi) || !isObjectType(Bi);
function deepEqual(Bi, e) {
  if (isPrimitive(Bi) || isPrimitive(e))
    return Bi === e;
  if (isDateObject(Bi) && isDateObject(e))
    return Bi.getTime() === e.getTime();
  const Zi = Object.keys(Bi), Qi = Object.keys(e);
  if (Zi.length !== Qi.length)
    return !1;
  for (const ea of Zi) {
    const ra = Bi[ea];
    if (!Qi.includes(ea))
      return !1;
    if (ea !== "ref") {
      const na = e[ea];
      if (isDateObject(ra) && isDateObject(na) || isObject(ra) && isObject(na) || Array.isArray(ra) && Array.isArray(na) ? !deepEqual(ra, na) : ra !== na)
        return !1;
    }
  }
  return !0;
}
var isMultipleSelect = (Bi) => Bi.type === "select-multiple", isRadioOrCheckbox = (Bi) => isRadioInput(Bi) || isCheckBoxInput(Bi), live = (Bi) => isHTMLElement(Bi) && Bi.isConnected, objectHasFunction = (Bi) => {
  for (const e in Bi)
    if (isFunction(Bi[e]))
      return !0;
  return !1;
};
function markFieldsDirty(Bi, e = {}) {
  const Zi = Array.isArray(Bi);
  if (isObject(Bi) || Zi)
    for (const Qi in Bi)
      Array.isArray(Bi[Qi]) || isObject(Bi[Qi]) && !objectHasFunction(Bi[Qi]) ? (e[Qi] = Array.isArray(Bi[Qi]) ? [] : {}, markFieldsDirty(Bi[Qi], e[Qi])) : isNullOrUndefined(Bi[Qi]) || (e[Qi] = !0);
  return e;
}
function getDirtyFieldsFromDefaultValues(Bi, e, Zi) {
  const Qi = Array.isArray(Bi);
  if (isObject(Bi) || Qi)
    for (const ea in Bi)
      Array.isArray(Bi[ea]) || isObject(Bi[ea]) && !objectHasFunction(Bi[ea]) ? isUndefined(e) || isPrimitive(Zi[ea]) ? Zi[ea] = Array.isArray(Bi[ea]) ? markFieldsDirty(Bi[ea], []) : { ...markFieldsDirty(Bi[ea]) } : getDirtyFieldsFromDefaultValues(Bi[ea], isNullOrUndefined(e) ? {} : e[ea], Zi[ea]) : Zi[ea] = !deepEqual(Bi[ea], e[ea]);
  return Zi;
}
var getDirtyFields = (Bi, e) => getDirtyFieldsFromDefaultValues(Bi, e, markFieldsDirty(e)), getFieldValueAs = (Bi, { valueAsNumber: e, valueAsDate: Zi, setValueAs: Qi }) => isUndefined(Bi) ? Bi : e ? Bi === "" ? NaN : Bi && +Bi : Zi && isString(Bi) ? new Date(Bi) : Qi ? Qi(Bi) : Bi;
function getFieldValue(Bi) {
  const e = Bi.ref;
  if (!(Bi.refs ? Bi.refs.every((Zi) => Zi.disabled) : e.disabled))
    return isFileInput(e) ? e.files : isRadioInput(e) ? getRadioValue(Bi.refs).value : isMultipleSelect(e) ? [...e.selectedOptions].map(({ value: Zi }) => Zi) : isCheckBoxInput(e) ? getCheckboxValue(Bi.refs).value : getFieldValueAs(isUndefined(e.value) ? Bi.ref.value : e.value, Bi);
}
var getResolverOptions = (Bi, e, Zi, Qi) => {
  const ea = {};
  for (const ra of Bi) {
    const na = get(e, ra);
    na && set(ea, ra, na._f);
  }
  return {
    criteriaMode: Zi,
    names: [...Bi],
    fields: ea,
    shouldUseNativeValidation: Qi
  };
}, getRuleValue = (Bi) => isUndefined(Bi) ? Bi : isRegex(Bi) ? Bi.source : isObject(Bi) ? isRegex(Bi.value) ? Bi.value.source : Bi.value : Bi, hasValidation = (Bi) => Bi.mount && (Bi.required || Bi.min || Bi.max || Bi.maxLength || Bi.minLength || Bi.pattern || Bi.validate);
function schemaErrorLookup(Bi, e, Zi) {
  const Qi = get(Bi, Zi);
  if (Qi || isKey(Zi))
    return {
      error: Qi,
      name: Zi
    };
  const ea = Zi.split(".");
  for (; ea.length; ) {
    const ra = ea.join("."), na = get(e, ra), ia = get(Bi, ra);
    if (na && !Array.isArray(na) && Zi !== ra)
      return { name: Zi };
    if (ia && ia.type)
      return {
        name: ra,
        error: ia
      };
    ea.pop();
  }
  return {
    name: Zi
  };
}
var skipValidation = (Bi, e, Zi, Qi, ea) => ea.isOnAll ? !1 : !Zi && ea.isOnTouch ? !(e || Bi) : (Zi ? Qi.isOnBlur : ea.isOnBlur) ? !Bi : (Zi ? Qi.isOnChange : ea.isOnChange) ? Bi : !0, unsetEmptyArray = (Bi, e) => !compact(get(Bi, e)).length && unset(Bi, e);
const defaultOptions$1 = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: !0
};
function createFormControl(Bi = {}, e) {
  let Zi = {
    ...defaultOptions$1,
    ...Bi
  }, Qi = {
    submitCount: 0,
    isDirty: !1,
    isLoading: isFunction(Zi.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: {}
  }, ea = {}, ra = isObject(Zi.defaultValues) || isObject(Zi.values) ? cloneObject(Zi.defaultValues || Zi.values) || {} : {}, na = Zi.shouldUnregister ? {} : cloneObject(ra), ia = {
    action: !1,
    mount: !1,
    watch: !1
  }, fa = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, La, Va = 0;
  const to = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, ro = {
    values: createSubject(),
    array: createSubject(),
    state: createSubject()
  }, no = Bi.resetOptions && Bi.resetOptions.keepDirtyValues, eo = getValidationModes(Zi.mode), ao = getValidationModes(Zi.reValidateMode), io = Zi.criteriaMode === VALIDATION_MODE.all, xs = (ml) => (Tl) => {
    clearTimeout(Va), Va = setTimeout(ml, Tl);
  }, Ts = async (ml) => {
    if (to.isValid || ml) {
      const Tl = Zi.resolver ? isEmptyObject((await os()).errors) : await gl(ea, !0);
      Tl !== Qi.isValid && ro.state.next({
        isValid: Tl
      });
    }
  }, qs = (ml) => to.isValidating && ro.state.next({
    isValidating: ml
  }), Fs = (ml, Tl = [], Ll, Vl, zl = !0, Ul = !0) => {
    if (Vl && Ll) {
      if (ia.action = !0, Ul && Array.isArray(get(ea, ml))) {
        const Yl = Ll(get(ea, ml), Vl.argA, Vl.argB);
        zl && set(ea, ml, Yl);
      }
      if (Ul && Array.isArray(get(Qi.errors, ml))) {
        const Yl = Ll(get(Qi.errors, ml), Vl.argA, Vl.argB);
        zl && set(Qi.errors, ml, Yl), unsetEmptyArray(Qi.errors, ml);
      }
      if (to.touchedFields && Ul && Array.isArray(get(Qi.touchedFields, ml))) {
        const Yl = Ll(get(Qi.touchedFields, ml), Vl.argA, Vl.argB);
        zl && set(Qi.touchedFields, ml, Yl);
      }
      to.dirtyFields && (Qi.dirtyFields = getDirtyFields(ra, na)), ro.state.next({
        name: ml,
        isDirty: El(ml, Tl),
        dirtyFields: Qi.dirtyFields,
        errors: Qi.errors,
        isValid: Qi.isValid
      });
    } else
      set(na, ml, Tl);
  }, Do = (ml, Tl) => {
    set(Qi.errors, ml, Tl), ro.state.next({
      errors: Qi.errors
    });
  }, ys = (ml, Tl, Ll, Vl) => {
    const zl = get(ea, ml);
    if (zl) {
      const Ul = get(na, ml, isUndefined(Ll) ? get(ra, ml) : Ll);
      isUndefined(Ul) || Vl && Vl.defaultChecked || Tl ? set(na, ml, Tl ? Ul : getFieldValue(zl._f)) : kl(ml, Ul), ia.mount && Ts();
    }
  }, Io = (ml, Tl, Ll, Vl, zl) => {
    let Ul = !1, Yl = !1;
    const Jl = {
      name: ml
    };
    if (!Ll || Vl) {
      to.isDirty && (Yl = Qi.isDirty, Qi.isDirty = Jl.isDirty = El(), Ul = Yl !== Jl.isDirty);
      const Wl = deepEqual(get(ra, ml), Tl);
      Yl = get(Qi.dirtyFields, ml), Wl ? unset(Qi.dirtyFields, ml) : set(Qi.dirtyFields, ml, !0), Jl.dirtyFields = Qi.dirtyFields, Ul = Ul || to.dirtyFields && Yl !== !Wl;
    }
    if (Ll) {
      const Wl = get(Qi.touchedFields, ml);
      Wl || (set(Qi.touchedFields, ml, Ll), Jl.touchedFields = Qi.touchedFields, Ul = Ul || to.touchedFields && Wl !== Ll);
    }
    return Ul && zl && ro.state.next(Jl), Ul ? Jl : {};
  }, so = (ml, Tl, Ll, Vl) => {
    const zl = get(Qi.errors, ml), Ul = to.isValid && isBoolean$1(Tl) && Qi.isValid !== Tl;
    if (Bi.delayError && Ll ? (La = xs(() => Do(ml, Ll)), La(Bi.delayError)) : (clearTimeout(Va), La = null, Ll ? set(Qi.errors, ml, Ll) : unset(Qi.errors, ml)), (Ll ? !deepEqual(zl, Ll) : zl) || !isEmptyObject(Vl) || Ul) {
      const Yl = {
        ...Vl,
        ...Ul && isBoolean$1(Tl) ? { isValid: Tl } : {},
        errors: Qi.errors,
        name: ml
      };
      Qi = {
        ...Qi,
        ...Yl
      }, ro.state.next(Yl);
    }
    qs(!1);
  }, os = async (ml) => Zi.resolver(na, Zi.context, getResolverOptions(ml || fa.mount, ea, Zi.criteriaMode, Zi.shouldUseNativeValidation)), Xs = async (ml) => {
    const { errors: Tl } = await os();
    if (ml)
      for (const Ll of ml) {
        const Vl = get(Tl, Ll);
        Vl ? set(Qi.errors, Ll, Vl) : unset(Qi.errors, Ll);
      }
    else
      Qi.errors = Tl;
    return Tl;
  }, gl = async (ml, Tl, Ll = {
    valid: !0
  }) => {
    for (const Vl in ml) {
      const zl = ml[Vl];
      if (zl) {
        const { _f: Ul, ...Yl } = zl;
        if (Ul) {
          const Jl = fa.array.has(Ul.name), Wl = await validateField(zl, na, io, Zi.shouldUseNativeValidation && !Tl, Jl);
          if (Wl[Ul.name] && (Ll.valid = !1, Tl))
            break;
          !Tl && (get(Wl, Ul.name) ? Jl ? updateFieldArrayRootError(Qi.errors, Wl, Ul.name) : set(Qi.errors, Ul.name, Wl[Ul.name]) : unset(Qi.errors, Ul.name));
        }
        Yl && await gl(Yl, Tl, Ll);
      }
    }
    return Ll.valid;
  }, Sl = () => {
    for (const ml of fa.unMount) {
      const Tl = get(ea, ml);
      Tl && (Tl._f.refs ? Tl._f.refs.every((Ll) => !live(Ll)) : !live(Tl._f.ref)) && Nl(ml);
    }
    fa.unMount = /* @__PURE__ */ new Set();
  }, El = (ml, Tl) => (ml && Tl && set(na, ml, Tl), !deepEqual(Zl(), ra)), wl = (ml, Tl, Ll) => generateWatchOutput(ml, fa, {
    ...ia.mount ? na : isUndefined(Tl) ? ra : isString(ml) ? { [ml]: Tl } : Tl
  }, Ll, Tl), jl = (ml) => compact(get(ia.mount ? na : ra, ml, Bi.shouldUnregister ? get(ra, ml, []) : [])), kl = (ml, Tl, Ll = {}) => {
    const Vl = get(ea, ml);
    let zl = Tl;
    if (Vl) {
      const Ul = Vl._f;
      Ul && (!Ul.disabled && set(na, ml, getFieldValueAs(Tl, Ul)), zl = isHTMLElement(Ul.ref) && isNullOrUndefined(Tl) ? "" : Tl, isMultipleSelect(Ul.ref) ? [...Ul.ref.options].forEach((Yl) => Yl.selected = zl.includes(Yl.value)) : Ul.refs ? isCheckBoxInput(Ul.ref) ? Ul.refs.length > 1 ? Ul.refs.forEach((Yl) => (!Yl.defaultChecked || !Yl.disabled) && (Yl.checked = Array.isArray(zl) ? !!zl.find((Jl) => Jl === Yl.value) : zl === Yl.value)) : Ul.refs[0] && (Ul.refs[0].checked = !!zl) : Ul.refs.forEach((Yl) => Yl.checked = Yl.value === zl) : isFileInput(Ul.ref) ? Ul.ref.value = "" : (Ul.ref.value = zl, Ul.ref.type || ro.values.next({
        name: ml,
        values: { ...na }
      })));
    }
    (Ll.shouldDirty || Ll.shouldTouch) && Io(ml, zl, Ll.shouldTouch, Ll.shouldDirty, !0), Ll.shouldValidate && Kl(ml);
  }, Fl = (ml, Tl, Ll) => {
    for (const Vl in Tl) {
      const zl = Tl[Vl], Ul = `${ml}.${Vl}`, Yl = get(ea, Ul);
      (fa.array.has(ml) || !isPrimitive(zl) || Yl && !Yl._f) && !isDateObject(zl) ? Fl(Ul, zl, Ll) : kl(Ul, zl, Ll);
    }
  }, Ml = (ml, Tl, Ll = {}) => {
    const Vl = get(ea, ml), zl = fa.array.has(ml), Ul = cloneObject(Tl);
    set(na, ml, Ul), zl ? (ro.array.next({
      name: ml,
      values: { ...na }
    }), (to.isDirty || to.dirtyFields) && Ll.shouldDirty && ro.state.next({
      name: ml,
      dirtyFields: getDirtyFields(ra, na),
      isDirty: El(ml, Ul)
    })) : Vl && !Vl._f && !isNullOrUndefined(Ul) ? Fl(ml, Ul, Ll) : kl(ml, Ul, Ll), isWatched(ml, fa) && ro.state.next({ ...Qi }), ro.values.next({
      name: ml,
      values: { ...na }
    }), !ia.mount && e();
  }, ql = async (ml) => {
    const Tl = ml.target;
    let Ll = Tl.name, Vl = !0;
    const zl = get(ea, Ll), Ul = () => Tl.type ? getFieldValue(zl._f) : getEventValue(ml);
    if (zl) {
      let Yl, Jl;
      const Wl = Ul(), rc = ml.type === EVENTS.BLUR || ml.type === EVENTS.FOCUS_OUT, uc = !hasValidation(zl._f) && !Zi.resolver && !get(Qi.errors, Ll) && !zl._f.deps || skipValidation(rc, get(Qi.touchedFields, Ll), Qi.isSubmitted, ao, eo), ac = isWatched(Ll, fa, rc);
      set(na, Ll, Wl), rc ? (zl._f.onBlur && zl._f.onBlur(ml), La && La(0)) : zl._f.onChange && zl._f.onChange(ml);
      const zu = Io(Ll, Wl, rc, !1), Xu = !isEmptyObject(zu) || ac;
      if (!rc && ro.values.next({
        name: Ll,
        type: ml.type,
        values: { ...na }
      }), uc)
        return to.isValid && Ts(), Xu && ro.state.next({ name: Ll, ...ac ? {} : zu });
      if (!rc && ac && ro.state.next({ ...Qi }), qs(!0), Zi.resolver) {
        const { errors: ed } = await os([Ll]), td = schemaErrorLookup(Qi.errors, ea, Ll), od = schemaErrorLookup(ed, ea, td.name || Ll);
        Yl = od.error, Ll = od.name, Jl = isEmptyObject(ed);
      } else
        Yl = (await validateField(zl, na, io, Zi.shouldUseNativeValidation))[Ll], Vl = isNaN(Wl) || Wl === get(na, Ll, Wl), Vl && (Yl ? Jl = !1 : to.isValid && (Jl = await gl(ea, !0)));
      Vl && (zl._f.deps && Kl(zl._f.deps), so(Ll, Jl, Yl, zu));
    }
  }, Kl = async (ml, Tl = {}) => {
    let Ll, Vl;
    const zl = convertToArrayPayload(ml);
    if (qs(!0), Zi.resolver) {
      const Ul = await Xs(isUndefined(ml) ? ml : zl);
      Ll = isEmptyObject(Ul), Vl = ml ? !zl.some((Yl) => get(Ul, Yl)) : Ll;
    } else ml ? (Vl = (await Promise.all(zl.map(async (Ul) => {
      const Yl = get(ea, Ul);
      return await gl(Yl && Yl._f ? { [Ul]: Yl } : Yl);
    }))).every(Boolean), !(!Vl && !Qi.isValid) && Ts()) : Vl = Ll = await gl(ea);
    return ro.state.next({
      ...!isString(ml) || to.isValid && Ll !== Qi.isValid ? {} : { name: ml },
      ...Zi.resolver || !ml ? { isValid: Ll } : {},
      errors: Qi.errors,
      isValidating: !1
    }), Tl.shouldFocus && !Vl && focusFieldBy(ea, (Ul) => Ul && get(Qi.errors, Ul), ml ? zl : fa.mount), Vl;
  }, Zl = (ml) => {
    const Tl = {
      ...ra,
      ...ia.mount ? na : {}
    };
    return isUndefined(ml) ? Tl : isString(ml) ? get(Tl, ml) : ml.map((Ll) => get(Tl, Ll));
  }, Il = (ml, Tl) => ({
    invalid: !!get((Tl || Qi).errors, ml),
    isDirty: !!get((Tl || Qi).dirtyFields, ml),
    isTouched: !!get((Tl || Qi).touchedFields, ml),
    error: get((Tl || Qi).errors, ml)
  }), xl = (ml) => {
    ml && convertToArrayPayload(ml).forEach((Tl) => unset(Qi.errors, Tl)), ro.state.next({
      errors: ml ? Qi.errors : {}
    });
  }, bl = (ml, Tl, Ll) => {
    const Vl = (get(ea, ml, { _f: {} })._f || {}).ref;
    set(Qi.errors, ml, {
      ...Tl,
      ref: Vl
    }), ro.state.next({
      name: ml,
      errors: Qi.errors,
      isValid: !1
    }), Ll && Ll.shouldFocus && Vl && Vl.focus && Vl.focus();
  }, Pl = (ml, Tl) => isFunction(ml) ? ro.values.subscribe({
    next: (Ll) => ml(wl(void 0, Tl), Ll)
  }) : wl(ml, Tl, !0), Nl = (ml, Tl = {}) => {
    for (const Ll of ml ? convertToArrayPayload(ml) : fa.mount)
      fa.mount.delete(Ll), fa.array.delete(Ll), Tl.keepValue || (unset(ea, Ll), unset(na, Ll)), !Tl.keepError && unset(Qi.errors, Ll), !Tl.keepDirty && unset(Qi.dirtyFields, Ll), !Tl.keepTouched && unset(Qi.touchedFields, Ll), !Zi.shouldUnregister && !Tl.keepDefaultValue && unset(ra, Ll);
    ro.values.next({
      values: { ...na }
    }), ro.state.next({
      ...Qi,
      ...Tl.keepDirty ? { isDirty: El() } : {}
    }), !Tl.keepIsValid && Ts();
  }, Bl = (ml, Tl = {}) => {
    let Ll = get(ea, ml);
    const Vl = isBoolean$1(Tl.disabled);
    return set(ea, ml, {
      ...Ll || {},
      _f: {
        ...Ll && Ll._f ? Ll._f : { ref: { name: ml } },
        name: ml,
        mount: !0,
        ...Tl
      }
    }), fa.mount.add(ml), Ll ? Vl && set(na, ml, Tl.disabled ? void 0 : get(na, ml, getFieldValue(Ll._f))) : ys(ml, !0, Tl.value), {
      ...Vl ? { disabled: Tl.disabled } : {},
      ...Zi.progressive ? {
        required: !!Tl.required,
        min: getRuleValue(Tl.min),
        max: getRuleValue(Tl.max),
        minLength: getRuleValue(Tl.minLength),
        maxLength: getRuleValue(Tl.maxLength),
        pattern: getRuleValue(Tl.pattern)
      } : {},
      name: ml,
      onChange: ql,
      onBlur: ql,
      ref: (zl) => {
        if (zl) {
          Bl(ml, Tl), Ll = get(ea, ml);
          const Ul = isUndefined(zl.value) && zl.querySelectorAll && zl.querySelectorAll("input,select,textarea")[0] || zl, Yl = isRadioOrCheckbox(Ul), Jl = Ll._f.refs || [];
          if (Yl ? Jl.find((Wl) => Wl === Ul) : Ul === Ll._f.ref)
            return;
          set(ea, ml, {
            _f: {
              ...Ll._f,
              ...Yl ? {
                refs: [
                  ...Jl.filter(live),
                  Ul,
                  ...Array.isArray(get(ra, ml)) ? [{}] : []
                ],
                ref: { type: Ul.type, name: ml }
              } : { ref: Ul }
            }
          }), ys(ml, !1, void 0, Ul);
        } else
          Ll = get(ea, ml, {}), Ll._f && (Ll._f.mount = !1), (Zi.shouldUnregister || Tl.shouldUnregister) && !(isNameInFieldArray(fa.array, ml) && ia.action) && fa.unMount.add(ml);
      }
    };
  }, Ol = () => Zi.shouldFocusError && focusFieldBy(ea, (ml) => ml && get(Qi.errors, ml), fa.mount), To = (ml, Tl) => async (Ll) => {
    Ll && (Ll.preventDefault && Ll.preventDefault(), Ll.persist && Ll.persist());
    let Vl = cloneObject(na);
    if (ro.state.next({
      isSubmitting: !0
    }), Zi.resolver) {
      const { errors: zl, values: Ul } = await os();
      Qi.errors = zl, Vl = Ul;
    } else
      await gl(ea);
    unset(Qi.errors, "root"), isEmptyObject(Qi.errors) ? (ro.state.next({
      errors: {}
    }), await ml(Vl, Ll)) : (Tl && await Tl({ ...Qi.errors }, Ll), Ol(), setTimeout(Ol)), ro.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: isEmptyObject(Qi.errors),
      submitCount: Qi.submitCount + 1,
      errors: Qi.errors
    });
  }, Os = (ml, Tl = {}) => {
    get(ea, ml) && (isUndefined(Tl.defaultValue) ? Ml(ml, get(ra, ml)) : (Ml(ml, Tl.defaultValue), set(ra, ml, Tl.defaultValue)), Tl.keepTouched || unset(Qi.touchedFields, ml), Tl.keepDirty || (unset(Qi.dirtyFields, ml), Qi.isDirty = Tl.defaultValue ? El(ml, get(ra, ml)) : El()), Tl.keepError || (unset(Qi.errors, ml), to.isValid && Ts()), ro.state.next({ ...Qi }));
  }, $l = (ml, Tl = {}) => {
    const Ll = ml || ra, Vl = cloneObject(Ll), zl = ml && !isEmptyObject(ml) ? Vl : ra;
    if (Tl.keepDefaultValues || (ra = Ll), !Tl.keepValues) {
      if (Tl.keepDirtyValues || no)
        for (const Ul of fa.mount)
          get(Qi.dirtyFields, Ul) ? set(zl, Ul, get(na, Ul)) : Ml(Ul, get(zl, Ul));
      else {
        if (isWeb && isUndefined(ml))
          for (const Ul of fa.mount) {
            const Yl = get(ea, Ul);
            if (Yl && Yl._f) {
              const Jl = Array.isArray(Yl._f.refs) ? Yl._f.refs[0] : Yl._f.ref;
              if (isHTMLElement(Jl)) {
                const Wl = Jl.closest("form");
                if (Wl) {
                  Wl.reset();
                  break;
                }
              }
            }
          }
        ea = {};
      }
      na = Bi.shouldUnregister ? Tl.keepDefaultValues ? cloneObject(ra) : {} : cloneObject(zl), ro.array.next({
        values: { ...zl }
      }), ro.values.next({
        values: { ...zl }
      });
    }
    fa = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !ia.mount && e(), ia.mount = !to.isValid || !!Tl.keepIsValid, ia.watch = !!Bi.shouldUnregister, ro.state.next({
      submitCount: Tl.keepSubmitCount ? Qi.submitCount : 0,
      isDirty: Tl.keepDirty ? Qi.isDirty : !!(Tl.keepDefaultValues && !deepEqual(ml, ra)),
      isSubmitted: Tl.keepIsSubmitted ? Qi.isSubmitted : !1,
      dirtyFields: Tl.keepDirtyValues ? Qi.dirtyFields : Tl.keepDefaultValues && ml ? getDirtyFields(ra, ml) : {},
      touchedFields: Tl.keepTouched ? Qi.touchedFields : {},
      errors: Tl.keepErrors ? Qi.errors : {},
      isSubmitting: !1,
      isSubmitSuccessful: !1
    });
  }, _l = (ml, Tl) => $l(isFunction(ml) ? ml(na) : ml, Tl);
  return {
    control: {
      register: Bl,
      unregister: Nl,
      getFieldState: Il,
      handleSubmit: To,
      setError: bl,
      _executeSchema: os,
      _getWatch: wl,
      _getDirty: El,
      _updateValid: Ts,
      _removeUnmounted: Sl,
      _updateFieldArray: Fs,
      _getFieldArray: jl,
      _reset: $l,
      _resetDefaultValues: () => isFunction(Zi.defaultValues) && Zi.defaultValues().then((ml) => {
        _l(ml, Zi.resetOptions), ro.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (ml) => {
        Qi = {
          ...Qi,
          ...ml
        };
      },
      _subjects: ro,
      _proxyFormState: to,
      get _fields() {
        return ea;
      },
      get _formValues() {
        return na;
      },
      get _state() {
        return ia;
      },
      set _state(ml) {
        ia = ml;
      },
      get _defaultValues() {
        return ra;
      },
      get _names() {
        return fa;
      },
      set _names(ml) {
        fa = ml;
      },
      get _formState() {
        return Qi;
      },
      set _formState(ml) {
        Qi = ml;
      },
      get _options() {
        return Zi;
      },
      set _options(ml) {
        Zi = {
          ...Zi,
          ...ml
        };
      }
    },
    trigger: Kl,
    register: Bl,
    handleSubmit: To,
    watch: Pl,
    setValue: Ml,
    getValues: Zl,
    reset: _l,
    resetField: Os,
    clearErrors: xl,
    unregister: Nl,
    setError: bl,
    setFocus: (ml, Tl = {}) => {
      const Ll = get(ea, ml), Vl = Ll && Ll._f;
      if (Vl) {
        const zl = Vl.refs ? Vl.refs[0] : Vl.ref;
        zl.focus && (zl.focus(), Tl.shouldSelect && zl.select());
      }
    },
    getFieldState: Il
  };
}
function useForm(Bi = {}) {
  const e = a__default.useRef(), Zi = a__default.useRef(), [Qi, ea] = a__default.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: isFunction(Bi.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    defaultValues: isFunction(Bi.defaultValues) ? void 0 : Bi.defaultValues
  });
  e.current || (e.current = {
    ...createFormControl(Bi, () => ea((na) => ({ ...na }))),
    formState: Qi
  });
  const ra = e.current.control;
  return ra._options = Bi, useSubscribe({
    subject: ra._subjects.state,
    next: (na) => {
      shouldRenderFormState(na, ra._proxyFormState, ra._updateFormState) && ea({ ...ra._formState });
    }
  }), a__default.useEffect(() => {
    Bi.values && !deepEqual(Bi.values, Zi.current) ? (ra._reset(Bi.values, ra._options.resetOptions), Zi.current = Bi.values) : ra._resetDefaultValues();
  }, [Bi.values, ra]), a__default.useEffect(() => {
    ra._state.mount || (ra._updateValid(), ra._state.mount = !0), ra._state.watch && (ra._state.watch = !1, ra._subjects.state.next({ ...ra._formState })), ra._removeUnmounted();
  }), e.current.formState = getProxyFormState(Qi, ra), e.current;
}
const Input = forwardRef(
  ({ className: Bi, ...e }, Zi) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "input",
    {
      ref: Zi,
      ...e,
      className: twMerge(
        "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
        Bi
      )
    }
  )
), vi$1 = (Bi, e) => {
  const Zi = (Qi) => {
    Bi.current && !Bi.current.contains(Qi.target) && e();
  };
  useEffect(() => (document.addEventListener("click", Zi), () => {
    document.removeEventListener("click", Zi);
  }));
};
function li$1(Bi, e, Zi = 250) {
  const [Qi, ea] = useState(0);
  return useEffect(() => {
    const ra = setTimeout(() => {
      ea(0);
    }, Zi);
    return Qi === 2 && e(), () => clearTimeout(ra);
  }, [Qi]), () => ea((ra) => ra + 1);
}
var Bt$1 = "delete", m$4 = 5, B$1 = 1 << m$4, b$1 = B$1 - 1, y$2 = {};
function pr$1() {
  return { value: !1 };
}
function U$1(Bi) {
  Bi && (Bi.value = !0);
}
function Er$1() {
}
function ct$1(Bi) {
  return Bi.size === void 0 && (Bi.size = Bi.__iterate(Ee$1)), Bi.size;
}
function rt$1(Bi, e) {
  if (typeof e != "number") {
    var Zi = e >>> 0;
    if ("" + Zi !== e || Zi === 4294967295)
      return NaN;
    e = Zi;
  }
  return e < 0 ? ct$1(Bi) + e : e;
}
function Ee$1() {
  return !0;
}
function tr$1(Bi, e, Zi) {
  return (Bi === 0 && !ze$1(Bi) || Zi !== void 0 && Bi <= -Zi) && (e === void 0 || Zi !== void 0 && e >= Zi);
}
function Ut$1(Bi, e) {
  return Oe$1(Bi, e, 0);
}
function rr(Bi, e) {
  return Oe$1(Bi, e, e);
}
function Oe$1(Bi, e, Zi) {
  return Bi === void 0 ? Zi : ze$1(Bi) ? e === 1 / 0 ? e : Math.max(0, e + Bi) | 0 : e === void 0 || e === Bi ? Bi : Math.min(e, Bi) | 0;
}
function ze$1(Bi) {
  return Bi < 0 || Bi === 0 && 1 / Bi === -1 / 0;
}
var Ie$1 = "@@__IMMUTABLE_ITERABLE__@@";
function L$1(Bi) {
  return !!(Bi && Bi[Ie$1]);
}
var Me$1 = "@@__IMMUTABLE_KEYED__@@";
function O$1(Bi) {
  return !!(Bi && Bi[Me$1]);
}
var qe$1 = "@@__IMMUTABLE_INDEXED__@@";
function T$1(Bi) {
  return !!(Bi && Bi[qe$1]);
}
function er$1(Bi) {
  return O$1(Bi) || T$1(Bi);
}
var z = function(Bi) {
  return L$1(Bi) ? Bi : N(Bi);
}, K = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return O$1(Zi) ? Zi : it$1(Zi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e;
}(z), at = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return T$1(Zi) ? Zi : H$2(Zi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e;
}(z), gt$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return L$1(Zi) && !er$1(Zi) ? Zi : Et$1(Zi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e;
}(z);
z.Keyed = K;
z.Indexed = at;
z.Set = gt$1;
var Ae = "@@__IMMUTABLE_SEQ__@@";
function Or$1(Bi) {
  return !!(Bi && Bi[Ae]);
}
var be$1 = "@@__IMMUTABLE_RECORD__@@";
function St$1(Bi) {
  return !!(Bi && Bi[be$1]);
}
function Z(Bi) {
  return L$1(Bi) || St$1(Bi);
}
var mt$1 = "@@__IMMUTABLE_ORDERED__@@";
function W$1(Bi) {
  return !!(Bi && Bi[mt$1]);
}
var Pt$1 = 0, Y$1 = 1, C$1 = 2, vr$1 = typeof Symbol == "function" && Symbol.iterator, Re$1 = "@@iterator", nr$1 = vr$1 || Re$1, l$5 = function(Bi) {
  this.next = Bi;
};
l$5.prototype.toString = function() {
  return "[Iterator]";
};
l$5.KEYS = Pt$1;
l$5.VALUES = Y$1;
l$5.ENTRIES = C$1;
l$5.prototype.inspect = l$5.prototype.toSource = function() {
  return this.toString();
};
l$5.prototype[nr$1] = function() {
  return this;
};
function E$1(Bi, e, Zi, Qi) {
  var ea = Bi === 0 ? e : Bi === 1 ? Zi : [e, Zi];
  return Qi ? Qi.value = ea : Qi = {
    value: ea,
    done: !1
  }, Qi;
}
function j() {
  return { value: void 0, done: !0 };
}
function Te$1(Bi) {
  return Array.isArray(Bi) ? !0 : !!ir$1(Bi);
}
function Gr$1(Bi) {
  return Bi && typeof Bi.next == "function";
}
function dr$1(Bi) {
  var e = ir$1(Bi);
  return e && e.call(Bi);
}
function ir$1(Bi) {
  var e = Bi && (vr$1 && Bi[vr$1] || Bi[Re$1]);
  if (typeof e == "function")
    return e;
}
function gn$1(Bi) {
  var e = ir$1(Bi);
  return e && e === Bi.entries;
}
function Sn$1(Bi) {
  var e = ir$1(Bi);
  return e && e === Bi.keys;
}
var wt$1 = Object.prototype.hasOwnProperty;
function Le$1(Bi) {
  return Array.isArray(Bi) || typeof Bi == "string" ? !0 : Bi && typeof Bi == "object" && Number.isInteger(Bi.length) && Bi.length >= 0 && (Bi.length === 0 ? Object.keys(Bi).length === 1 : Bi.hasOwnProperty(Bi.length - 1));
}
var N = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return Zi == null ? Ir() : Z(Zi) ? Zi.toSeq() : wn$1(Zi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.toSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, e.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, e.prototype.__iterate = function(Zi, Qi) {
    var ea = this._cache;
    if (ea) {
      for (var ra = ea.length, na = 0; na !== ra; ) {
        var ia = ea[Qi ? ra - ++na : na++];
        if (Zi(ia[1], ia[0], this) === !1)
          break;
      }
      return na;
    }
    return this.__iterateUncached(Zi, Qi);
  }, e.prototype.__iterator = function(Zi, Qi) {
    var ea = this._cache;
    if (ea) {
      var ra = ea.length, na = 0;
      return new l$5(function() {
        if (na === ra)
          return j();
        var ia = ea[Qi ? ra - ++na : na++];
        return E$1(Zi, ia[0], ia[1]);
      });
    }
    return this.__iteratorUncached(Zi, Qi);
  }, e;
}(z), it$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return Zi == null ? Ir().toKeyedSeq() : L$1(Zi) ? O$1(Zi) ? Zi.toSeq() : Zi.fromEntrySeq() : St$1(Zi) ? Zi.toSeq() : Mr$1(Zi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.toKeyedSeq = function() {
    return this;
  }, e;
}(N), H$2 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return Zi == null ? Ir() : L$1(Zi) ? O$1(Zi) ? Zi.entrySeq() : Zi.toIndexedSeq() : St$1(Zi) ? Zi.toSeq().entrySeq() : je$1(Zi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toIndexedSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, e;
}(N), Et$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return (L$1(Zi) && !er$1(Zi) ? Zi : H$2(Zi)).toSetSeq();
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toSetSeq = function() {
    return this;
  }, e;
}(N);
N.isSeq = Or$1;
N.Keyed = it$1;
N.Set = Et$1;
N.Indexed = H$2;
N.prototype[Ae] = !0;
var st$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    this._array = Zi, this.size = Zi.length;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.get = function(Zi, Qi) {
    return this.has(Zi) ? this._array[rt$1(this, Zi)] : Qi;
  }, e.prototype.__iterate = function(Zi, Qi) {
    for (var ea = this._array, ra = ea.length, na = 0; na !== ra; ) {
      var ia = Qi ? ra - ++na : na++;
      if (Zi(ea[ia], ia, this) === !1)
        break;
    }
    return na;
  }, e.prototype.__iterator = function(Zi, Qi) {
    var ea = this._array, ra = ea.length, na = 0;
    return new l$5(function() {
      if (na === ra)
        return j();
      var ia = Qi ? ra - ++na : na++;
      return E$1(Zi, ia, ea[ia]);
    });
  }, e;
}(H$2), zr$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    var Qi = Object.keys(Zi).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(Zi) : []
    );
    this._object = Zi, this._keys = Qi, this.size = Qi.length;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.get = function(Zi, Qi) {
    return Qi !== void 0 && !this.has(Zi) ? Qi : this._object[Zi];
  }, e.prototype.has = function(Zi) {
    return wt$1.call(this._object, Zi);
  }, e.prototype.__iterate = function(Zi, Qi) {
    for (var ea = this._object, ra = this._keys, na = ra.length, ia = 0; ia !== na; ) {
      var fa = ra[Qi ? na - ++ia : ia++];
      if (Zi(ea[fa], fa, this) === !1)
        break;
    }
    return ia;
  }, e.prototype.__iterator = function(Zi, Qi) {
    var ea = this._object, ra = this._keys, na = ra.length, ia = 0;
    return new l$5(function() {
      if (ia === na)
        return j();
      var fa = ra[Qi ? na - ++ia : ia++];
      return E$1(Zi, fa, ea[fa]);
    });
  }, e;
}(it$1);
zr$1.prototype[mt$1] = !0;
var mn$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    this._collection = Zi, this.size = Zi.length || Zi.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.__iterateUncached = function(Zi, Qi) {
    if (Qi)
      return this.cacheResult().__iterate(Zi, Qi);
    var ea = this._collection, ra = dr$1(ea), na = 0;
    if (Gr$1(ra))
      for (var ia; !(ia = ra.next()).done && Zi(ia.value, na++, this) !== !1; )
        ;
    return na;
  }, e.prototype.__iteratorUncached = function(Zi, Qi) {
    if (Qi)
      return this.cacheResult().__iterator(Zi, Qi);
    var ea = this._collection, ra = dr$1(ea);
    if (!Gr$1(ra))
      return new l$5(j);
    var na = 0;
    return new l$5(function() {
      var ia = ra.next();
      return ia.done ? ia : E$1(Zi, na++, ia.value);
    });
  }, e;
}(H$2), Qr$1;
function Ir() {
  return Qr$1 || (Qr$1 = new st$1([]));
}
function Mr$1(Bi) {
  var e = qr$1(Bi);
  if (e)
    return e.fromEntrySeq();
  if (typeof Bi == "object")
    return new zr$1(Bi);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + Bi
  );
}
function je$1(Bi) {
  var e = qr$1(Bi);
  if (e)
    return e;
  throw new TypeError(
    "Expected Array or collection object of values: " + Bi
  );
}
function wn$1(Bi) {
  var e = qr$1(Bi);
  if (e)
    return gn$1(Bi) ? e.fromEntrySeq() : Sn$1(Bi) ? e.toSetSeq() : e;
  if (typeof Bi == "object")
    return new zr$1(Bi);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + Bi
  );
}
function qr$1(Bi) {
  return Le$1(Bi) ? new st$1(Bi) : Te$1(Bi) ? new mn$1(Bi) : void 0;
}
var ke = "@@__IMMUTABLE_MAP__@@";
function Ar$1(Bi) {
  return !!(Bi && Bi[ke]);
}
function $e(Bi) {
  return Ar$1(Bi) && W$1(Bi);
}
function Vr(Bi) {
  return !!(Bi && typeof Bi.equals == "function" && typeof Bi.hashCode == "function");
}
function D(Bi, e) {
  if (Bi === e || Bi !== Bi && e !== e)
    return !0;
  if (!Bi || !e)
    return !1;
  if (typeof Bi.valueOf == "function" && typeof e.valueOf == "function") {
    if (Bi = Bi.valueOf(), e = e.valueOf(), Bi === e || Bi !== Bi && e !== e)
      return !0;
    if (!Bi || !e)
      return !1;
  }
  return !!(Vr(Bi) && Vr(e) && Bi.equals(e));
}
var Mt$1 = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(Bi, e) {
  Bi |= 0, e |= 0;
  var Zi = Bi & 65535, Qi = e & 65535;
  return Zi * Qi + ((Bi >>> 16) * Qi + Zi * (e >>> 16) << 16 >>> 0) | 0;
};
function ur$1(Bi) {
  return Bi >>> 1 & 1073741824 | Bi & 3221225471;
}
var En$1 = Object.prototype.valueOf;
function $(Bi) {
  if (Bi == null)
    return xr(Bi);
  if (typeof Bi.hashCode == "function")
    return ur$1(Bi.hashCode(Bi));
  var e = An$1(Bi);
  if (e == null)
    return xr(e);
  switch (typeof e) {
    case "boolean":
      return e ? 1108378657 : 1108378656;
    case "number":
      return On(e);
    case "string":
      return e.length > bn$1 ? zn$1(e) : yr$1(e);
    case "object":
    case "function":
      return Mn$1(e);
    case "symbol":
      return In$1(e);
    default:
      if (typeof e.toString == "function")
        return yr$1(e.toString());
      throw new Error("Value type " + typeof e + " cannot be hashed.");
  }
}
function xr(Bi) {
  return Bi === null ? 1108378658 : 1108378659;
}
function On(Bi) {
  if (Bi !== Bi || Bi === 1 / 0)
    return 0;
  var e = Bi | 0;
  for (e !== Bi && (e ^= Bi * 4294967295); Bi > 4294967295; )
    Bi /= 4294967295, e ^= Bi;
  return ur$1(e);
}
function zn$1(Bi) {
  var e = hr$1[Bi];
  return e === void 0 && (e = yr$1(Bi), fr$1 === Rn$1 && (fr$1 = 0, hr$1 = {}), fr$1++, hr$1[Bi] = e), e;
}
function yr$1(Bi) {
  for (var e = 0, Zi = 0; Zi < Bi.length; Zi++)
    e = 31 * e + Bi.charCodeAt(Zi) | 0;
  return ur$1(e);
}
function In$1(Bi) {
  var e = ee$1[Bi];
  return e !== void 0 || (e = De(), ee$1[Bi] = e), e;
}
function Mn$1(Bi) {
  var e;
  if (lr$1 && (e = gr$1.get(Bi), e !== void 0) || (e = Bi[ot$1], e !== void 0) || !re$1 && (e = Bi.propertyIsEnumerable && Bi.propertyIsEnumerable[ot$1], e !== void 0 || (e = qn$1(Bi), e !== void 0)))
    return e;
  if (e = De(), lr$1)
    gr$1.set(Bi, e);
  else {
    if (te$1 !== void 0 && te$1(Bi) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (re$1)
      Object.defineProperty(Bi, ot$1, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: e
      });
    else if (Bi.propertyIsEnumerable !== void 0 && Bi.propertyIsEnumerable === Bi.constructor.prototype.propertyIsEnumerable)
      Bi.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, Bi.propertyIsEnumerable[ot$1] = e;
    else if (Bi.nodeType !== void 0)
      Bi[ot$1] = e;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return e;
}
var te$1 = Object.isExtensible, re$1 = function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
}();
function qn$1(Bi) {
  if (Bi && Bi.nodeType > 0)
    switch (Bi.nodeType) {
      case 1:
        return Bi.uniqueID;
      case 9:
        return Bi.documentElement && Bi.documentElement.uniqueID;
    }
}
function An$1(Bi) {
  return Bi.valueOf !== En$1 && typeof Bi.valueOf == "function" ? Bi.valueOf(Bi) : Bi;
}
function De() {
  var Bi = ++ar$1;
  return ar$1 & 1073741824 && (ar$1 = 0), Bi;
}
var lr$1 = typeof WeakMap == "function", gr$1;
lr$1 && (gr$1 = /* @__PURE__ */ new WeakMap());
var ee$1 = /* @__PURE__ */ Object.create(null), ar$1 = 0, ot$1 = "__immutablehash__";
typeof Symbol == "function" && (ot$1 = Symbol(ot$1));
var bn$1 = 16, Rn$1 = 255, fr$1 = 0, hr$1 = {}, or$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi, Qi) {
    this._iter = Zi, this._useKeys = Qi, this.size = Zi.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.get = function(Zi, Qi) {
    return this._iter.get(Zi, Qi);
  }, e.prototype.has = function(Zi) {
    return this._iter.has(Zi);
  }, e.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, e.prototype.reverse = function() {
    var Zi = this, Qi = br$1(this, !0);
    return this._useKeys || (Qi.valueSeq = function() {
      return Zi._iter.toSeq().reverse();
    }), Qi;
  }, e.prototype.map = function(Zi, Qi) {
    var ea = this, ra = Ce$1(this, Zi, Qi);
    return this._useKeys || (ra.valueSeq = function() {
      return ea._iter.toSeq().map(Zi, Qi);
    }), ra;
  }, e.prototype.__iterate = function(Zi, Qi) {
    var ea = this;
    return this._iter.__iterate(function(ra, na) {
      return Zi(ra, na, ea);
    }, Qi);
  }, e.prototype.__iterator = function(Zi, Qi) {
    return this._iter.__iterator(Zi, Qi);
  }, e;
}(it$1);
or$1.prototype[mt$1] = !0;
var Ne$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    this._iter = Zi, this.size = Zi.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.includes = function(Zi) {
    return this._iter.includes(Zi);
  }, e.prototype.__iterate = function(Zi, Qi) {
    var ea = this, ra = 0;
    return Qi && ct$1(this), this._iter.__iterate(
      function(na) {
        return Zi(na, Qi ? ea.size - ++ra : ra++, ea);
      },
      Qi
    );
  }, e.prototype.__iterator = function(Zi, Qi) {
    var ea = this, ra = this._iter.__iterator(Y$1, Qi), na = 0;
    return Qi && ct$1(this), new l$5(function() {
      var ia = ra.next();
      return ia.done ? ia : E$1(
        Zi,
        Qi ? ea.size - ++na : na++,
        ia.value,
        ia
      );
    });
  }, e;
}(H$2), Be$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    this._iter = Zi, this.size = Zi.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.has = function(Zi) {
    return this._iter.includes(Zi);
  }, e.prototype.__iterate = function(Zi, Qi) {
    var ea = this;
    return this._iter.__iterate(function(ra) {
      return Zi(ra, ra, ea);
    }, Qi);
  }, e.prototype.__iterator = function(Zi, Qi) {
    var ea = this._iter.__iterator(Y$1, Qi);
    return new l$5(function() {
      var ra = ea.next();
      return ra.done ? ra : E$1(Zi, ra.value, ra.value, ra);
    });
  }, e;
}(Et$1), Ue$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    this._iter = Zi, this.size = Zi.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, e.prototype.__iterate = function(Zi, Qi) {
    var ea = this;
    return this._iter.__iterate(function(ra) {
      if (ra) {
        ie(ra);
        var na = L$1(ra);
        return Zi(
          na ? ra.get(1) : ra[1],
          na ? ra.get(0) : ra[0],
          ea
        );
      }
    }, Qi);
  }, e.prototype.__iterator = function(Zi, Qi) {
    var ea = this._iter.__iterator(Y$1, Qi);
    return new l$5(function() {
      for (; ; ) {
        var ra = ea.next();
        if (ra.done)
          return ra;
        var na = ra.value;
        if (na) {
          ie(na);
          var ia = L$1(na);
          return E$1(
            Zi,
            ia ? na.get(0) : na[0],
            ia ? na.get(1) : na[1],
            ra
          );
        }
      }
    });
  }, e;
}(it$1);
Ne$1.prototype.cacheResult = or$1.prototype.cacheResult = Be$1.prototype.cacheResult = Ue$1.prototype.cacheResult = Tr$1;
function Pe$1(Bi) {
  var e = G$1(Bi);
  return e._iter = Bi, e.size = Bi.size, e.flip = function() {
    return Bi;
  }, e.reverse = function() {
    var Zi = Bi.reverse.apply(this);
    return Zi.flip = function() {
      return Bi.reverse();
    }, Zi;
  }, e.has = function(Zi) {
    return Bi.includes(Zi);
  }, e.includes = function(Zi) {
    return Bi.has(Zi);
  }, e.cacheResult = Tr$1, e.__iterateUncached = function(Zi, Qi) {
    var ea = this;
    return Bi.__iterate(function(ra, na) {
      return Zi(na, ra, ea) !== !1;
    }, Qi);
  }, e.__iteratorUncached = function(Zi, Qi) {
    if (Zi === C$1) {
      var ea = Bi.__iterator(Zi, Qi);
      return new l$5(function() {
        var ra = ea.next();
        if (!ra.done) {
          var na = ra.value[0];
          ra.value[0] = ra.value[1], ra.value[1] = na;
        }
        return ra;
      });
    }
    return Bi.__iterator(
      Zi === Y$1 ? Pt$1 : Y$1,
      Qi
    );
  }, e;
}
function Ce$1(Bi, e, Zi) {
  var Qi = G$1(Bi);
  return Qi.size = Bi.size, Qi.has = function(ea) {
    return Bi.has(ea);
  }, Qi.get = function(ea, ra) {
    var na = Bi.get(ea, y$2);
    return na === y$2 ? ra : e.call(Zi, na, ea, Bi);
  }, Qi.__iterateUncached = function(ea, ra) {
    var na = this;
    return Bi.__iterate(
      function(ia, fa, La) {
        return ea(e.call(Zi, ia, fa, La), fa, na) !== !1;
      },
      ra
    );
  }, Qi.__iteratorUncached = function(ea, ra) {
    var na = Bi.__iterator(C$1, ra);
    return new l$5(function() {
      var ia = na.next();
      if (ia.done)
        return ia;
      var fa = ia.value, La = fa[0];
      return E$1(
        ea,
        La,
        e.call(Zi, fa[1], La, Bi),
        ia
      );
    });
  }, Qi;
}
function br$1(Bi, e) {
  var Zi = this, Qi = G$1(Bi);
  return Qi._iter = Bi, Qi.size = Bi.size, Qi.reverse = function() {
    return Bi;
  }, Bi.flip && (Qi.flip = function() {
    var ea = Pe$1(Bi);
    return ea.reverse = function() {
      return Bi.flip();
    }, ea;
  }), Qi.get = function(ea, ra) {
    return Bi.get(e ? ea : -1 - ea, ra);
  }, Qi.has = function(ea) {
    return Bi.has(e ? ea : -1 - ea);
  }, Qi.includes = function(ea) {
    return Bi.includes(ea);
  }, Qi.cacheResult = Tr$1, Qi.__iterate = function(ea, ra) {
    var na = this, ia = 0;
    return ra && ct$1(Bi), Bi.__iterate(
      function(fa, La) {
        return ea(fa, e ? La : ra ? na.size - ++ia : ia++, na);
      },
      !ra
    );
  }, Qi.__iterator = function(ea, ra) {
    var na = 0;
    ra && ct$1(Bi);
    var ia = Bi.__iterator(C$1, !ra);
    return new l$5(function() {
      var fa = ia.next();
      if (fa.done)
        return fa;
      var La = fa.value;
      return E$1(
        ea,
        e ? La[0] : ra ? Zi.size - ++na : na++,
        La[1],
        fa
      );
    });
  }, Qi;
}
function Ke$1(Bi, e, Zi, Qi) {
  var ea = G$1(Bi);
  return Qi && (ea.has = function(ra) {
    var na = Bi.get(ra, y$2);
    return na !== y$2 && !!e.call(Zi, na, ra, Bi);
  }, ea.get = function(ra, na) {
    var ia = Bi.get(ra, y$2);
    return ia !== y$2 && e.call(Zi, ia, ra, Bi) ? ia : na;
  }), ea.__iterateUncached = function(ra, na) {
    var ia = this, fa = 0;
    return Bi.__iterate(function(La, Va, to) {
      if (e.call(Zi, La, Va, to))
        return fa++, ra(La, Qi ? Va : fa - 1, ia);
    }, na), fa;
  }, ea.__iteratorUncached = function(ra, na) {
    var ia = Bi.__iterator(C$1, na), fa = 0;
    return new l$5(function() {
      for (; ; ) {
        var La = ia.next();
        if (La.done)
          return La;
        var Va = La.value, to = Va[0], ro = Va[1];
        if (e.call(Zi, ro, to, Bi))
          return E$1(ra, Qi ? to : fa++, ro, La);
      }
    });
  }, ea;
}
function Tn$1(Bi, e, Zi) {
  var Qi = zt$1().asMutable();
  return Bi.__iterate(function(ea, ra) {
    Qi.update(e.call(Zi, ea, ra, Bi), 0, function(na) {
      return na + 1;
    });
  }), Qi.asImmutable();
}
function Ln$1(Bi, e, Zi) {
  var Qi = O$1(Bi), ea = (W$1(Bi) ? V() : zt$1()).asMutable();
  Bi.__iterate(function(na, ia) {
    ea.update(
      e.call(Zi, na, ia, Bi),
      function(fa) {
        return fa = fa || [], fa.push(Qi ? [ia, na] : na), fa;
      }
    );
  });
  var ra = Ye$1(Bi);
  return ea.map(function(na) {
    return g$2(Bi, ra(na));
  }).asImmutable();
}
function Rr$1(Bi, e, Zi, Qi) {
  var ea = Bi.size;
  if (tr$1(e, Zi, ea))
    return Bi;
  var ra = Ut$1(e, ea), na = rr(Zi, ea);
  if (ra !== ra || na !== na)
    return Rr$1(Bi.toSeq().cacheResult(), e, Zi, Qi);
  var ia = na - ra, fa;
  ia === ia && (fa = ia < 0 ? 0 : ia);
  var La = G$1(Bi);
  return La.size = fa === 0 ? fa : Bi.size && fa || void 0, !Qi && Or$1(Bi) && fa >= 0 && (La.get = function(Va, to) {
    return Va = rt$1(this, Va), Va >= 0 && Va < fa ? Bi.get(Va + ra, to) : to;
  }), La.__iterateUncached = function(Va, to) {
    var ro = this;
    if (fa === 0)
      return 0;
    if (to)
      return this.cacheResult().__iterate(Va, to);
    var no = 0, eo = !0, ao = 0;
    return Bi.__iterate(function(io, xs) {
      if (!(eo && (eo = no++ < ra)))
        return ao++, Va(io, Qi ? xs : ao - 1, ro) !== !1 && ao !== fa;
    }), ao;
  }, La.__iteratorUncached = function(Va, to) {
    if (fa !== 0 && to)
      return this.cacheResult().__iterator(Va, to);
    if (fa === 0)
      return new l$5(j);
    var ro = Bi.__iterator(Va, to), no = 0, eo = 0;
    return new l$5(function() {
      for (; no++ < ra; )
        ro.next();
      if (++eo > fa)
        return j();
      var ao = ro.next();
      return Qi || Va === Y$1 || ao.done ? ao : Va === Pt$1 ? E$1(Va, eo - 1, void 0, ao) : E$1(Va, eo - 1, ao.value[1], ao);
    });
  }, La;
}
function jn$1(Bi, e, Zi) {
  var Qi = G$1(Bi);
  return Qi.__iterateUncached = function(ea, ra) {
    var na = this;
    if (ra)
      return this.cacheResult().__iterate(ea, ra);
    var ia = 0;
    return Bi.__iterate(
      function(fa, La, Va) {
        return e.call(Zi, fa, La, Va) && ++ia && ea(fa, La, na);
      }
    ), ia;
  }, Qi.__iteratorUncached = function(ea, ra) {
    var na = this;
    if (ra)
      return this.cacheResult().__iterator(ea, ra);
    var ia = Bi.__iterator(C$1, ra), fa = !0;
    return new l$5(function() {
      if (!fa)
        return j();
      var La = ia.next();
      if (La.done)
        return La;
      var Va = La.value, to = Va[0], ro = Va[1];
      return e.call(Zi, ro, to, na) ? ea === C$1 ? La : E$1(ea, to, ro, La) : (fa = !1, j());
    });
  }, Qi;
}
function Fe$1(Bi, e, Zi, Qi) {
  var ea = G$1(Bi);
  return ea.__iterateUncached = function(ra, na) {
    var ia = this;
    if (na)
      return this.cacheResult().__iterate(ra, na);
    var fa = !0, La = 0;
    return Bi.__iterate(function(Va, to, ro) {
      if (!(fa && (fa = e.call(Zi, Va, to, ro))))
        return La++, ra(Va, Qi ? to : La - 1, ia);
    }), La;
  }, ea.__iteratorUncached = function(ra, na) {
    var ia = this;
    if (na)
      return this.cacheResult().__iterator(ra, na);
    var fa = Bi.__iterator(C$1, na), La = !0, Va = 0;
    return new l$5(function() {
      var to, ro, no;
      do {
        if (to = fa.next(), to.done)
          return Qi || ra === Y$1 ? to : ra === Pt$1 ? E$1(ra, Va++, void 0, to) : E$1(ra, Va++, to.value[1], to);
        var eo = to.value;
        ro = eo[0], no = eo[1], La && (La = e.call(Zi, no, ro, ia));
      } while (La);
      return ra === C$1 ? to : E$1(ra, ro, no, to);
    });
  }, ea;
}
function kn$1(Bi, e) {
  var Zi = O$1(Bi), Qi = [Bi].concat(e).map(function(na) {
    return L$1(na) ? Zi && (na = K(na)) : na = Zi ? Mr$1(na) : je$1(Array.isArray(na) ? na : [na]), na;
  }).filter(function(na) {
    return na.size !== 0;
  });
  if (Qi.length === 0)
    return Bi;
  if (Qi.length === 1) {
    var ea = Qi[0];
    if (ea === Bi || Zi && O$1(ea) || T$1(Bi) && T$1(ea))
      return ea;
  }
  var ra = new st$1(Qi);
  return Zi ? ra = ra.toKeyedSeq() : T$1(Bi) || (ra = ra.toSetSeq()), ra = ra.flatten(!0), ra.size = Qi.reduce(function(na, ia) {
    if (na !== void 0) {
      var fa = ia.size;
      if (fa !== void 0)
        return na + fa;
    }
  }, 0), ra;
}
function We$1(Bi, e, Zi) {
  var Qi = G$1(Bi);
  return Qi.__iterateUncached = function(ea, ra) {
    if (ra)
      return this.cacheResult().__iterate(ea, ra);
    var na = 0, ia = !1;
    function fa(La, Va) {
      La.__iterate(function(to, ro) {
        return (!e || Va < e) && L$1(to) ? fa(to, Va + 1) : (na++, ea(to, Zi ? ro : na - 1, Qi) === !1 && (ia = !0)), !ia;
      }, ra);
    }
    return fa(Bi, 0), na;
  }, Qi.__iteratorUncached = function(ea, ra) {
    if (ra)
      return this.cacheResult().__iterator(ea, ra);
    var na = Bi.__iterator(ea, ra), ia = [], fa = 0;
    return new l$5(function() {
      for (; na; ) {
        var La = na.next();
        if (La.done !== !1) {
          na = ia.pop();
          continue;
        }
        var Va = La.value;
        if (ea === C$1 && (Va = Va[1]), (!e || ia.length < e) && L$1(Va))
          ia.push(na), na = Va.__iterator(ea, ra);
        else
          return Zi ? La : E$1(ea, fa++, Va, La);
      }
      return j();
    });
  }, Qi;
}
function $n$1(Bi, e, Zi) {
  var Qi = Ye$1(Bi);
  return Bi.toSeq().map(function(ea, ra) {
    return Qi(e.call(Zi, ea, ra, Bi));
  }).flatten(!0);
}
function Dn$1(Bi, e) {
  var Zi = G$1(Bi);
  return Zi.size = Bi.size && Bi.size * 2 - 1, Zi.__iterateUncached = function(Qi, ea) {
    var ra = this, na = 0;
    return Bi.__iterate(
      function(ia) {
        return (!na || Qi(e, na++, ra) !== !1) && Qi(ia, na++, ra) !== !1;
      },
      ea
    ), na;
  }, Zi.__iteratorUncached = function(Qi, ea) {
    var ra = Bi.__iterator(Y$1, ea), na = 0, ia;
    return new l$5(function() {
      return (!ia || na % 2) && (ia = ra.next(), ia.done) ? ia : na % 2 ? E$1(Qi, na++, e) : E$1(Qi, na++, ia.value, ia);
    });
  }, Zi;
}
function _t$1(Bi, e, Zi) {
  e || (e = He$1);
  var Qi = O$1(Bi), ea = 0, ra = Bi.toSeq().map(function(na, ia) {
    return [ia, na, ea++, Zi ? Zi(na, ia, Bi) : na];
  }).valueSeq().toArray();
  return ra.sort(function(na, ia) {
    return e(na[3], ia[3]) || na[2] - ia[2];
  }).forEach(
    Qi ? function(na, ia) {
      ra[ia].length = 2;
    } : function(na, ia) {
      ra[ia] = na[1];
    }
  ), Qi ? it$1(ra) : T$1(Bi) ? H$2(ra) : Et$1(ra);
}
function Ht$1(Bi, e, Zi) {
  if (e || (e = He$1), Zi) {
    var Qi = Bi.toSeq().map(function(ea, ra) {
      return [ea, Zi(ea, ra, Bi)];
    }).reduce(function(ea, ra) {
      return ne(e, ea[1], ra[1]) ? ra : ea;
    });
    return Qi && Qi[0];
  }
  return Bi.reduce(function(ea, ra) {
    return ne(e, ea, ra) ? ra : ea;
  });
}
function ne(Bi, e, Zi) {
  var Qi = Bi(Zi, e);
  return Qi === 0 && Zi !== e && (Zi == null || Zi !== Zi) || Qi > 0;
}
function Jt(Bi, e, Zi, Qi) {
  var ea = G$1(Bi), ra = new st$1(Zi).map(function(na) {
    return na.size;
  });
  return ea.size = Qi ? ra.max() : ra.min(), ea.__iterate = function(na, ia) {
    for (var fa = this.__iterator(Y$1, ia), La, Va = 0; !(La = fa.next()).done && na(La.value, Va++, this) !== !1; )
      ;
    return Va;
  }, ea.__iteratorUncached = function(na, ia) {
    var fa = Zi.map(
      function(to) {
        return to = z(to), dr$1(ia ? to.reverse() : to);
      }
    ), La = 0, Va = !1;
    return new l$5(function() {
      var to;
      return Va || (to = fa.map(function(ro) {
        return ro.next();
      }), Va = Qi ? to.every(function(ro) {
        return ro.done;
      }) : to.some(function(ro) {
        return ro.done;
      })), Va ? j() : E$1(
        na,
        La++,
        e.apply(
          null,
          to.map(function(ro) {
            return ro.value;
          })
        )
      );
    });
  }, ea;
}
function g$2(Bi, e) {
  return Bi === e ? Bi : Or$1(Bi) ? e : Bi.constructor(e);
}
function ie(Bi) {
  if (Bi !== Object(Bi))
    throw new TypeError("Expected [K, V] tuple: " + Bi);
}
function Ye$1(Bi) {
  return O$1(Bi) ? K : T$1(Bi) ? at : gt$1;
}
function G$1(Bi) {
  return Object.create(
    (O$1(Bi) ? it$1 : T$1(Bi) ? H$2 : Et$1).prototype
  );
}
function Tr$1() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : N.prototype.cacheResult.call(this);
}
function He$1(Bi, e) {
  return Bi === void 0 && e === void 0 ? 0 : Bi === void 0 ? 1 : e === void 0 ? -1 : Bi > e ? 1 : Bi < e ? -1 : 0;
}
function X$1(Bi, e) {
  e = e || 0;
  for (var Zi = Math.max(0, Bi.length - e), Qi = new Array(Zi), ea = 0; ea < Zi; ea++)
    Qi[ea] = Bi[ea + e];
  return Qi;
}
function Lr(Bi, e) {
  if (!Bi)
    throw new Error(e);
}
function P$2(Bi) {
  Lr(
    Bi !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function Je$1(Bi) {
  if (Le$1(Bi) && typeof Bi != "string")
    return Bi;
  if (W$1(Bi))
    return Bi.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + Bi
  );
}
var Nn$1 = Object.prototype.toString;
function Bn$1(Bi) {
  if (!Bi || typeof Bi != "object" || Nn$1.call(Bi) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(Bi);
  if (e === null)
    return !0;
  for (var Zi = e, Qi = Object.getPrototypeOf(e); Qi !== null; )
    Zi = Qi, Qi = Object.getPrototypeOf(Zi);
  return Zi === e;
}
function et$1(Bi) {
  return typeof Bi == "object" && (Z(Bi) || Array.isArray(Bi) || Bn$1(Bi));
}
function Lt$1(Bi) {
  try {
    return typeof Bi == "string" ? JSON.stringify(Bi) : String(Bi);
  } catch {
    return JSON.stringify(Bi);
  }
}
function Un$1(Bi, e) {
  return Z(Bi) ? Bi.has(e) : et$1(Bi) && wt$1.call(Bi, e);
}
function Xe$1(Bi, e, Zi) {
  return Z(Bi) ? Bi.get(e, Zi) : Un$1(Bi, e) ? typeof Bi.get == "function" ? Bi.get(e) : Bi[e] : Zi;
}
function Vt$1(Bi) {
  if (Array.isArray(Bi))
    return X$1(Bi);
  var e = {};
  for (var Zi in Bi)
    wt$1.call(Bi, Zi) && (e[Zi] = Bi[Zi]);
  return e;
}
function Pn$1(Bi, e) {
  if (!et$1(Bi))
    throw new TypeError(
      "Cannot update non-data-structure value: " + Bi
    );
  if (Z(Bi)) {
    if (!Bi.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + Bi
      );
    return Bi.remove(e);
  }
  if (!wt$1.call(Bi, e))
    return Bi;
  var Zi = Vt$1(Bi);
  return Array.isArray(Zi) ? Zi.splice(e, 1) : delete Zi[e], Zi;
}
function Cn$1(Bi, e, Zi) {
  if (!et$1(Bi))
    throw new TypeError(
      "Cannot update non-data-structure value: " + Bi
    );
  if (Z(Bi)) {
    if (!Bi.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + Bi
      );
    return Bi.set(e, Zi);
  }
  if (wt$1.call(Bi, e) && Zi === Bi[e])
    return Bi;
  var Qi = Vt$1(Bi);
  return Qi[e] = Zi, Qi;
}
function Ot$1(Bi, e, Zi, Qi) {
  Qi || (Qi = Zi, Zi = void 0);
  var ea = Ze$1(
    Z(Bi),
    Bi,
    Je$1(e),
    0,
    Zi,
    Qi
  );
  return ea === y$2 ? Zi : ea;
}
function Ze$1(Bi, e, Zi, Qi, ea, ra) {
  var na = e === y$2;
  if (Qi === Zi.length) {
    var ia = na ? ea : e, fa = ra(ia);
    return fa === ia ? e : fa;
  }
  if (!na && !et$1(e))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + Zi.slice(0, Qi).map(Lt$1) + "]: " + e
    );
  var La = Zi[Qi], Va = na ? y$2 : Xe$1(e, La, y$2), to = Ze$1(
    Va === y$2 ? Bi : Z(Va),
    Va,
    Zi,
    Qi + 1,
    ea,
    ra
  );
  return to === Va ? e : to === y$2 ? Pn$1(e, La) : Cn$1(
    na ? Bi ? F() : {} : e,
    La,
    to
  );
}
function Kn$1(Bi, e, Zi) {
  return Ot$1(Bi, e, y$2, function() {
    return Zi;
  });
}
function jr$1(Bi, e) {
  return Kn$1(this, Bi, e);
}
function Fn$1(Bi, e) {
  return Ot$1(Bi, e, function() {
    return y$2;
  });
}
function kr$1(Bi) {
  return Fn$1(this, Bi);
}
function Ge$1(Bi, e, Zi, Qi) {
  return Ot$1(Bi, [e], Zi, Qi);
}
function $r$1(Bi, e, Zi) {
  return arguments.length === 1 ? Bi(this) : Ge$1(this, Bi, e, Zi);
}
function Dr(Bi, e, Zi) {
  return Ot$1(this, Bi, e, Zi);
}
function Qe$1() {
  for (var Bi = [], e = arguments.length; e--; )
    Bi[e] = arguments[e];
  return xe$1(this, Bi);
}
function Ve$1(Bi) {
  for (var e = [], Zi = arguments.length - 1; Zi-- > 0; )
    e[Zi] = arguments[Zi + 1];
  if (typeof Bi != "function")
    throw new TypeError("Invalid merger function: " + Bi);
  return xe$1(this, e, Bi);
}
function xe$1(Bi, e, Zi) {
  for (var Qi = [], ea = 0; ea < e.length; ea++) {
    var ra = K(e[ea]);
    ra.size !== 0 && Qi.push(ra);
  }
  return Qi.length === 0 ? Bi : Bi.toSeq().size === 0 && !Bi.__ownerID && Qi.length === 1 ? Bi.constructor(Qi[0]) : Bi.withMutations(function(na) {
    for (var ia = Zi ? function(La, Va) {
      Ge$1(
        na,
        Va,
        y$2,
        function(to) {
          return to === y$2 ? La : Zi(to, La, Va);
        }
      );
    } : function(La, Va) {
      na.set(Va, La);
    }, fa = 0; fa < Qi.length; fa++)
      Qi[fa].forEach(ia);
  });
}
function Nr$1(Bi, e, Zi) {
  return Br$1(Bi, e, Wn$1(Zi));
}
function Br$1(Bi, e, Zi) {
  if (!et$1(Bi))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + Bi
    );
  if (Z(Bi))
    return typeof Zi == "function" && Bi.mergeWith ? Bi.mergeWith.apply(Bi, [Zi].concat(e)) : Bi.merge ? Bi.merge.apply(Bi, e) : Bi.concat.apply(Bi, e);
  for (var Qi = Array.isArray(Bi), ea = Bi, ra = Qi ? at : K, na = Qi ? function(fa) {
    ea === Bi && (ea = Vt$1(ea)), ea.push(fa);
  } : function(fa, La) {
    var Va = wt$1.call(ea, La), to = Va && Zi ? Zi(ea[La], fa, La) : fa;
    (!Va || to !== ea[La]) && (ea === Bi && (ea = Vt$1(ea)), ea[La] = to);
  }, ia = 0; ia < e.length; ia++)
    ra(e[ia]).forEach(na);
  return ea;
}
function Wn$1(Bi) {
  function e(Zi, Qi, ea) {
    return et$1(Zi) && et$1(Qi) && Yn$1(Zi, Qi) ? Br$1(Zi, [Qi], e) : Bi ? Bi(Zi, Qi, ea) : Qi;
  }
  return e;
}
function Yn$1(Bi, e) {
  var Zi = N(Bi), Qi = N(e);
  return T$1(Zi) === T$1(Qi) && O$1(Zi) === O$1(Qi);
}
function tn$1() {
  for (var Bi = [], e = arguments.length; e--; )
    Bi[e] = arguments[e];
  return Nr$1(this, Bi);
}
function rn$1(Bi) {
  for (var e = [], Zi = arguments.length - 1; Zi-- > 0; )
    e[Zi] = arguments[Zi + 1];
  return Nr$1(this, e, Bi);
}
function Ur$1(Bi) {
  for (var e = [], Zi = arguments.length - 1; Zi-- > 0; )
    e[Zi] = arguments[Zi + 1];
  return Ot$1(this, Bi, F(), function(Qi) {
    return Br$1(Qi, e);
  });
}
function Pr$1(Bi) {
  for (var e = [], Zi = arguments.length - 1; Zi-- > 0; )
    e[Zi] = arguments[Zi + 1];
  return Ot$1(
    this,
    Bi,
    F(),
    function(Qi) {
      return Nr$1(Qi, e);
    }
  );
}
function Ct$1(Bi) {
  var e = this.asMutable();
  return Bi(e), e.wasAltered() ? e.__ensureOwner(this.__ownerID) : this;
}
function Kt() {
  return this.__ownerID ? this : this.__ensureOwner(new Er$1());
}
function Ft$1() {
  return this.__ensureOwner();
}
function Cr$1() {
  return this.__altered;
}
var zt$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return Zi == null ? F() : Ar$1(Zi) && !W$1(Zi) ? Zi : F().withMutations(function(Qi) {
      var ea = Bi(Zi);
      P$2(ea.size), ea.forEach(function(ra, na) {
        return Qi.set(na, ra);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    for (var Zi = [], Qi = arguments.length; Qi--; )
      Zi[Qi] = arguments[Qi];
    return F().withMutations(function(ea) {
      for (var ra = 0; ra < Zi.length; ra += 2) {
        if (ra + 1 >= Zi.length)
          throw new Error("Missing value for key: " + Zi[ra]);
        ea.set(Zi[ra], Zi[ra + 1]);
      }
    });
  }, e.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, e.prototype.get = function(Zi, Qi) {
    return this._root ? this._root.get(0, void 0, Zi, Qi) : Qi;
  }, e.prototype.set = function(Zi, Qi) {
    return se$1(this, Zi, Qi);
  }, e.prototype.remove = function(Zi) {
    return se$1(this, Zi, y$2);
  }, e.prototype.deleteAll = function(Zi) {
    var Qi = z(Zi);
    return Qi.size === 0 ? this : this.withMutations(function(ea) {
      Qi.forEach(function(ra) {
        return ea.remove(ra);
      });
    });
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : F();
  }, e.prototype.sort = function(Zi) {
    return V(_t$1(this, Zi));
  }, e.prototype.sortBy = function(Zi, Qi) {
    return V(_t$1(this, Qi, Zi));
  }, e.prototype.map = function(Zi, Qi) {
    var ea = this;
    return this.withMutations(function(ra) {
      ra.forEach(function(na, ia) {
        ra.set(ia, Zi.call(Qi, na, ia, ea));
      });
    });
  }, e.prototype.__iterator = function(Zi, Qi) {
    return new Hn$1(this, Zi, Qi);
  }, e.prototype.__iterate = function(Zi, Qi) {
    var ea = this, ra = 0;
    return this._root && this._root.iterate(function(na) {
      return ra++, Zi(na[1], na[0], ea);
    }, Qi), ra;
  }, e.prototype.__ensureOwner = function(Zi) {
    return Zi === this.__ownerID ? this : Zi ? Kr$1(this.size, this._root, Zi, this.__hash) : this.size === 0 ? F() : (this.__ownerID = Zi, this.__altered = !1, this);
  }, e;
}(K);
zt$1.isMap = Ar$1;
var w$2 = zt$1.prototype;
w$2[ke] = !0;
w$2[Bt$1] = w$2.remove;
w$2.removeAll = w$2.deleteAll;
w$2.setIn = jr$1;
w$2.removeIn = w$2.deleteIn = kr$1;
w$2.update = $r$1;
w$2.updateIn = Dr;
w$2.merge = w$2.concat = Qe$1;
w$2.mergeWith = Ve$1;
w$2.mergeDeep = tn$1;
w$2.mergeDeepWith = rn$1;
w$2.mergeIn = Ur$1;
w$2.mergeDeepIn = Pr$1;
w$2.withMutations = Ct$1;
w$2.wasAltered = Cr$1;
w$2.asImmutable = Ft$1;
w$2["@@transducer/init"] = w$2.asMutable = Kt;
w$2["@@transducer/step"] = function(Bi, e) {
  return Bi.set(e[0], e[1]);
};
w$2["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
var jt$1 = function(Bi, e) {
  this.ownerID = Bi, this.entries = e;
};
jt$1.prototype.get = function(Bi, e, Zi, Qi) {
  for (var ea = this.entries, ra = 0, na = ea.length; ra < na; ra++)
    if (D(Zi, ea[ra][0]))
      return ea[ra][1];
  return Qi;
};
jt$1.prototype.update = function(Bi, e, Zi, Qi, ea, ra, na) {
  for (var ia = ea === y$2, fa = this.entries, La = 0, Va = fa.length; La < Va && !D(Qi, fa[La][0]); La++)
    ;
  var to = La < Va;
  if (to ? fa[La][1] === ea : ia)
    return this;
  if (U$1(na), (ia || !to) && U$1(ra), !(ia && fa.length === 1)) {
    if (!to && !ia && fa.length >= Vn$1)
      return Jn$1(Bi, fa, Qi, ea);
    var ro = Bi && Bi === this.ownerID, no = ro ? fa : X$1(fa);
    return to ? ia ? La === Va - 1 ? no.pop() : no[La] = no.pop() : no[La] = [Qi, ea] : no.push([Qi, ea]), ro ? (this.entries = no, this) : new jt$1(Bi, no);
  }
};
var pt$1 = function(Bi, e, Zi) {
  this.ownerID = Bi, this.bitmap = e, this.nodes = Zi;
};
pt$1.prototype.get = function(Bi, e, Zi, Qi) {
  e === void 0 && (e = $(Zi));
  var ea = 1 << ((Bi === 0 ? e : e >>> Bi) & b$1), ra = this.bitmap;
  return (ra & ea) === 0 ? Qi : this.nodes[en(ra & ea - 1)].get(
    Bi + m$4,
    e,
    Zi,
    Qi
  );
};
pt$1.prototype.update = function(Bi, e, Zi, Qi, ea, ra, na) {
  Zi === void 0 && (Zi = $(Qi));
  var ia = (e === 0 ? Zi : Zi >>> e) & b$1, fa = 1 << ia, La = this.bitmap, Va = (La & fa) !== 0;
  if (!Va && ea === y$2)
    return this;
  var to = en(La & fa - 1), ro = this.nodes, no = Va ? ro[to] : void 0, eo = Fr$1(
    no,
    Bi,
    e + m$4,
    Zi,
    Qi,
    ea,
    ra,
    na
  );
  if (eo === no)
    return this;
  if (!Va && eo && ro.length >= xn$1)
    return Zn$1(Bi, ro, La, ia, eo);
  if (Va && !eo && ro.length === 2 && ae$1(ro[to ^ 1]))
    return ro[to ^ 1];
  if (Va && eo && ro.length === 1 && ae$1(eo))
    return eo;
  var ao = Bi && Bi === this.ownerID, io = Va ? eo ? La : La ^ fa : La | fa, xs = Va ? eo ? nn$1(ro, to, eo, ao) : Qn$1(ro, to, ao) : Gn$1(ro, to, eo, ao);
  return ao ? (this.bitmap = io, this.nodes = xs, this) : new pt$1(Bi, io, xs);
};
var kt = function(Bi, e, Zi) {
  this.ownerID = Bi, this.count = e, this.nodes = Zi;
};
kt.prototype.get = function(Bi, e, Zi, Qi) {
  e === void 0 && (e = $(Zi));
  var ea = (Bi === 0 ? e : e >>> Bi) & b$1, ra = this.nodes[ea];
  return ra ? ra.get(Bi + m$4, e, Zi, Qi) : Qi;
};
kt.prototype.update = function(Bi, e, Zi, Qi, ea, ra, na) {
  Zi === void 0 && (Zi = $(Qi));
  var ia = (e === 0 ? Zi : Zi >>> e) & b$1, fa = ea === y$2, La = this.nodes, Va = La[ia];
  if (fa && !Va)
    return this;
  var to = Fr$1(
    Va,
    Bi,
    e + m$4,
    Zi,
    Qi,
    ea,
    ra,
    na
  );
  if (to === Va)
    return this;
  var ro = this.count;
  if (!Va)
    ro++;
  else if (!to && (ro--, ro < ti))
    return Xn$1(Bi, La, ro, ia);
  var no = Bi && Bi === this.ownerID, eo = nn$1(La, ia, to, no);
  return no ? (this.count = ro, this.nodes = eo, this) : new kt(Bi, ro, eo);
};
var vt$1 = function(Bi, e, Zi) {
  this.ownerID = Bi, this.keyHash = e, this.entries = Zi;
};
vt$1.prototype.get = function(Bi, e, Zi, Qi) {
  for (var ea = this.entries, ra = 0, na = ea.length; ra < na; ra++)
    if (D(Zi, ea[ra][0]))
      return ea[ra][1];
  return Qi;
};
vt$1.prototype.update = function(Bi, e, Zi, Qi, ea, ra, na) {
  Zi === void 0 && (Zi = $(Qi));
  var ia = ea === y$2;
  if (Zi !== this.keyHash)
    return ia ? this : (U$1(na), U$1(ra), Wr$1(this, Bi, e, Zi, [Qi, ea]));
  for (var fa = this.entries, La = 0, Va = fa.length; La < Va && !D(Qi, fa[La][0]); La++)
    ;
  var to = La < Va;
  if (to ? fa[La][1] === ea : ia)
    return this;
  if (U$1(na), (ia || !to) && U$1(ra), ia && Va === 2)
    return new Q$1(Bi, this.keyHash, fa[La ^ 1]);
  var ro = Bi && Bi === this.ownerID, no = ro ? fa : X$1(fa);
  return to ? ia ? La === Va - 1 ? no.pop() : no[La] = no.pop() : no[La] = [Qi, ea] : no.push([Qi, ea]), ro ? (this.entries = no, this) : new vt$1(Bi, this.keyHash, no);
};
var Q$1 = function(Bi, e, Zi) {
  this.ownerID = Bi, this.keyHash = e, this.entry = Zi;
};
Q$1.prototype.get = function(Bi, e, Zi, Qi) {
  return D(Zi, this.entry[0]) ? this.entry[1] : Qi;
};
Q$1.prototype.update = function(Bi, e, Zi, Qi, ea, ra, na) {
  var ia = ea === y$2, fa = D(Qi, this.entry[0]);
  if (fa ? ea === this.entry[1] : ia)
    return this;
  if (U$1(na), ia) {
    U$1(ra);
    return;
  }
  return fa ? Bi && Bi === this.ownerID ? (this.entry[1] = ea, this) : new Q$1(Bi, this.keyHash, [Qi, ea]) : (U$1(ra), Wr$1(this, Bi, e, $(Qi), [Qi, ea]));
};
jt$1.prototype.iterate = vt$1.prototype.iterate = function(Bi, e) {
  for (var Zi = this.entries, Qi = 0, ea = Zi.length - 1; Qi <= ea; Qi++)
    if (Bi(Zi[e ? ea - Qi : Qi]) === !1)
      return !1;
};
pt$1.prototype.iterate = kt.prototype.iterate = function(Bi, e) {
  for (var Zi = this.nodes, Qi = 0, ea = Zi.length - 1; Qi <= ea; Qi++) {
    var ra = Zi[e ? ea - Qi : Qi];
    if (ra && ra.iterate(Bi, e) === !1)
      return !1;
  }
};
Q$1.prototype.iterate = function(Bi, e) {
  return Bi(this.entry);
};
var Hn$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi, Qi, ea) {
    this._type = Qi, this._reverse = ea, this._stack = Zi._root && ue(Zi._root);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.next = function() {
    for (var Zi = this._type, Qi = this._stack; Qi; ) {
      var ea = Qi.node, ra = Qi.index++, na = void 0;
      if (ea.entry) {
        if (ra === 0)
          return cr$1(Zi, ea.entry);
      } else if (ea.entries) {
        if (na = ea.entries.length - 1, ra <= na)
          return cr$1(
            Zi,
            ea.entries[this._reverse ? na - ra : ra]
          );
      } else if (na = ea.nodes.length - 1, ra <= na) {
        var ia = ea.nodes[this._reverse ? na - ra : ra];
        if (ia) {
          if (ia.entry)
            return cr$1(Zi, ia.entry);
          Qi = this._stack = ue(ia, Qi);
        }
        continue;
      }
      Qi = this._stack = this._stack.__prev;
    }
    return j();
  }, e;
}(l$5);
function cr$1(Bi, e) {
  return E$1(Bi, e[0], e[1]);
}
function ue(Bi, e) {
  return {
    node: Bi,
    index: 0,
    __prev: e
  };
}
function Kr$1(Bi, e, Zi, Qi) {
  var ea = Object.create(w$2);
  return ea.size = Bi, ea._root = e, ea.__ownerID = Zi, ea.__hash = Qi, ea.__altered = !1, ea;
}
var oe$1;
function F() {
  return oe$1 || (oe$1 = Kr$1(0));
}
function se$1(Bi, e, Zi) {
  var Qi, ea;
  if (Bi._root) {
    var ra = pr$1(), na = pr$1();
    if (Qi = Fr$1(
      Bi._root,
      Bi.__ownerID,
      0,
      void 0,
      e,
      Zi,
      ra,
      na
    ), !na.value)
      return Bi;
    ea = Bi.size + (ra.value ? Zi === y$2 ? -1 : 1 : 0);
  } else {
    if (Zi === y$2)
      return Bi;
    ea = 1, Qi = new jt$1(Bi.__ownerID, [[e, Zi]]);
  }
  return Bi.__ownerID ? (Bi.size = ea, Bi._root = Qi, Bi.__hash = void 0, Bi.__altered = !0, Bi) : Qi ? Kr$1(ea, Qi) : F();
}
function Fr$1(Bi, e, Zi, Qi, ea, ra, na, ia) {
  return Bi ? Bi.update(
    e,
    Zi,
    Qi,
    ea,
    ra,
    na,
    ia
  ) : ra === y$2 ? Bi : (U$1(ia), U$1(na), new Q$1(e, Qi, [ea, ra]));
}
function ae$1(Bi) {
  return Bi.constructor === Q$1 || Bi.constructor === vt$1;
}
function Wr$1(Bi, e, Zi, Qi, ea) {
  if (Bi.keyHash === Qi)
    return new vt$1(e, Qi, [Bi.entry, ea]);
  var ra = (Zi === 0 ? Bi.keyHash : Bi.keyHash >>> Zi) & b$1, na = (Zi === 0 ? Qi : Qi >>> Zi) & b$1, ia, fa = ra === na ? [Wr$1(Bi, e, Zi + m$4, Qi, ea)] : (ia = new Q$1(e, Qi, ea), ra < na ? [Bi, ia] : [ia, Bi]);
  return new pt$1(e, 1 << ra | 1 << na, fa);
}
function Jn$1(Bi, e, Zi, Qi) {
  Bi || (Bi = new Er$1());
  for (var ea = new Q$1(Bi, $(Zi), [Zi, Qi]), ra = 0; ra < e.length; ra++) {
    var na = e[ra];
    ea = ea.update(Bi, 0, void 0, na[0], na[1]);
  }
  return ea;
}
function Xn$1(Bi, e, Zi, Qi) {
  for (var ea = 0, ra = 0, na = new Array(Zi), ia = 0, fa = 1, La = e.length; ia < La; ia++, fa <<= 1) {
    var Va = e[ia];
    Va !== void 0 && ia !== Qi && (ea |= fa, na[ra++] = Va);
  }
  return new pt$1(Bi, ea, na);
}
function Zn$1(Bi, e, Zi, Qi, ea) {
  for (var ra = 0, na = new Array(B$1), ia = 0; Zi !== 0; ia++, Zi >>>= 1)
    na[ia] = Zi & 1 ? e[ra++] : void 0;
  return na[Qi] = ea, new kt(Bi, ra + 1, na);
}
function en(Bi) {
  return Bi -= Bi >> 1 & 1431655765, Bi = (Bi & 858993459) + (Bi >> 2 & 858993459), Bi = Bi + (Bi >> 4) & 252645135, Bi += Bi >> 8, Bi += Bi >> 16, Bi & 127;
}
function nn$1(Bi, e, Zi, Qi) {
  var ea = Qi ? Bi : X$1(Bi);
  return ea[e] = Zi, ea;
}
function Gn$1(Bi, e, Zi, Qi) {
  var ea = Bi.length + 1;
  if (Qi && e + 1 === ea)
    return Bi[e] = Zi, Bi;
  for (var ra = new Array(ea), na = 0, ia = 0; ia < ea; ia++)
    ia === e ? (ra[ia] = Zi, na = -1) : ra[ia] = Bi[ia + na];
  return ra;
}
function Qn$1(Bi, e, Zi) {
  var Qi = Bi.length - 1;
  if (Zi && e === Qi)
    return Bi.pop(), Bi;
  for (var ea = new Array(Qi), ra = 0, na = 0; na < Qi; na++)
    na === e && (ra = 1), ea[na] = Bi[na + ra];
  return ea;
}
var Vn$1 = B$1 / 4, xn$1 = B$1 / 2, ti = B$1 / 4, un$1 = "@@__IMMUTABLE_LIST__@@";
function on$1(Bi) {
  return !!(Bi && Bi[un$1]);
}
var sr$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    var Qi = Qt$1();
    if (Zi == null)
      return Qi;
    if (on$1(Zi))
      return Zi;
    var ea = Bi(Zi), ra = ea.size;
    return ra === 0 ? Qi : (P$2(ra), ra > 0 && ra < B$1 ? $t$1(0, ra, m$4, null, new tt(ea.toArray())) : Qi.withMutations(function(na) {
      na.setSize(ra), ea.forEach(function(ia, fa) {
        return na.set(fa, ia);
      });
    }));
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, e.prototype.get = function(Zi, Qi) {
    if (Zi = rt$1(this, Zi), Zi >= 0 && Zi < this.size) {
      Zi += this._origin;
      var ea = sn$1(this, Zi);
      return ea && ea.array[Zi & b$1];
    }
    return Qi;
  }, e.prototype.set = function(Zi, Qi) {
    return ri$1(this, Zi, Qi);
  }, e.prototype.remove = function(Zi) {
    return this.has(Zi) ? Zi === 0 ? this.shift() : Zi === this.size - 1 ? this.pop() : this.splice(Zi, 1) : this;
  }, e.prototype.insert = function(Zi, Qi) {
    return this.splice(Zi, 0, Qi);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = m$4, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : Qt$1();
  }, e.prototype.push = function() {
    var Zi = arguments, Qi = this.size;
    return this.withMutations(function(ea) {
      x$1(ea, 0, Qi + Zi.length);
      for (var ra = 0; ra < Zi.length; ra++)
        ea.set(Qi + ra, Zi[ra]);
    });
  }, e.prototype.pop = function() {
    return x$1(this, 0, -1);
  }, e.prototype.unshift = function() {
    var Zi = arguments;
    return this.withMutations(function(Qi) {
      x$1(Qi, -Zi.length);
      for (var ea = 0; ea < Zi.length; ea++)
        Qi.set(ea, Zi[ea]);
    });
  }, e.prototype.shift = function() {
    return x$1(this, 1);
  }, e.prototype.concat = function() {
    for (var Zi = arguments, Qi = [], ea = 0; ea < arguments.length; ea++) {
      var ra = Zi[ea], na = Bi(
        typeof ra != "string" && Te$1(ra) ? ra : [ra]
      );
      na.size !== 0 && Qi.push(na);
    }
    return Qi.length === 0 ? this : this.size === 0 && !this.__ownerID && Qi.length === 1 ? this.constructor(Qi[0]) : this.withMutations(function(ia) {
      Qi.forEach(function(fa) {
        return fa.forEach(function(La) {
          return ia.push(La);
        });
      });
    });
  }, e.prototype.setSize = function(Zi) {
    return x$1(this, 0, Zi);
  }, e.prototype.map = function(Zi, Qi) {
    var ea = this;
    return this.withMutations(function(ra) {
      for (var na = 0; na < ea.size; na++)
        ra.set(na, Zi.call(Qi, ra.get(na), na, ea));
    });
  }, e.prototype.slice = function(Zi, Qi) {
    var ea = this.size;
    return tr$1(Zi, Qi, ea) ? this : x$1(
      this,
      Ut$1(Zi, ea),
      rr(Qi, ea)
    );
  }, e.prototype.__iterator = function(Zi, Qi) {
    var ea = Qi ? this.size : 0, ra = fe$1(this, Qi);
    return new l$5(function() {
      var na = ra();
      return na === Rt$1 ? j() : E$1(Zi, Qi ? --ea : ea++, na);
    });
  }, e.prototype.__iterate = function(Zi, Qi) {
    for (var ea = Qi ? this.size : 0, ra = fe$1(this, Qi), na; (na = ra()) !== Rt$1 && Zi(na, Qi ? --ea : ea++, this) !== !1; )
      ;
    return ea;
  }, e.prototype.__ensureOwner = function(Zi) {
    return Zi === this.__ownerID ? this : Zi ? $t$1(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      Zi,
      this.__hash
    ) : this.size === 0 ? Qt$1() : (this.__ownerID = Zi, this.__altered = !1, this);
  }, e;
}(at);
sr$1.isList = on$1;
var I$1 = sr$1.prototype;
I$1[un$1] = !0;
I$1[Bt$1] = I$1.remove;
I$1.merge = I$1.concat;
I$1.setIn = jr$1;
I$1.deleteIn = I$1.removeIn = kr$1;
I$1.update = $r$1;
I$1.updateIn = Dr;
I$1.mergeIn = Ur$1;
I$1.mergeDeepIn = Pr$1;
I$1.withMutations = Ct$1;
I$1.wasAltered = Cr$1;
I$1.asImmutable = Ft$1;
I$1["@@transducer/init"] = I$1.asMutable = Kt;
I$1["@@transducer/step"] = function(Bi, e) {
  return Bi.push(e);
};
I$1["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
var tt = function(Bi, e) {
  this.array = Bi, this.ownerID = e;
};
tt.prototype.removeBefore = function(Bi, e, Zi) {
  if (Zi === e ? 1 << e : this.array.length === 0)
    return this;
  var Qi = Zi >>> e & b$1;
  if (Qi >= this.array.length)
    return new tt([], Bi);
  var ea = Qi === 0, ra;
  if (e > 0) {
    var na = this.array[Qi];
    if (ra = na && na.removeBefore(Bi, e - m$4, Zi), ra === na && ea)
      return this;
  }
  if (ea && !ra)
    return this;
  var ia = dt$1(this, Bi);
  if (!ea)
    for (var fa = 0; fa < Qi; fa++)
      ia.array[fa] = void 0;
  return ra && (ia.array[Qi] = ra), ia;
};
tt.prototype.removeAfter = function(Bi, e, Zi) {
  if (Zi === (e ? 1 << e : 0) || this.array.length === 0)
    return this;
  var Qi = Zi - 1 >>> e & b$1;
  if (Qi >= this.array.length)
    return this;
  var ea;
  if (e > 0) {
    var ra = this.array[Qi];
    if (ea = ra && ra.removeAfter(Bi, e - m$4, Zi), ea === ra && Qi === this.array.length - 1)
      return this;
  }
  var na = dt$1(this, Bi);
  return na.array.splice(Qi + 1), ea && (na.array[Qi] = ea), na;
};
var Rt$1 = {};
function fe$1(Bi, e) {
  var Zi = Bi._origin, Qi = Bi._capacity, ea = Dt$1(Qi), ra = Bi._tail;
  return na(Bi._root, Bi._level, 0);
  function na(La, Va, to) {
    return Va === 0 ? ia(La, to) : fa(La, Va, to);
  }
  function ia(La, Va) {
    var to = Va === ea ? ra && ra.array : La && La.array, ro = Va > Zi ? 0 : Zi - Va, no = Qi - Va;
    return no > B$1 && (no = B$1), function() {
      if (ro === no)
        return Rt$1;
      var eo = e ? --no : ro++;
      return to && to[eo];
    };
  }
  function fa(La, Va, to) {
    var ro, no = La && La.array, eo = to > Zi ? 0 : Zi - to >> Va, ao = (Qi - to >> Va) + 1;
    return ao > B$1 && (ao = B$1), function() {
      for (; ; ) {
        if (ro) {
          var io = ro();
          if (io !== Rt$1)
            return io;
          ro = null;
        }
        if (eo === ao)
          return Rt$1;
        var xs = e ? --ao : eo++;
        ro = na(
          no && no[xs],
          Va - m$4,
          to + (xs << Va)
        );
      }
    };
  }
}
function $t$1(Bi, e, Zi, Qi, ea, ra, na) {
  var ia = Object.create(I$1);
  return ia.size = e - Bi, ia._origin = Bi, ia._capacity = e, ia._level = Zi, ia._root = Qi, ia._tail = ea, ia.__ownerID = ra, ia.__hash = na, ia.__altered = !1, ia;
}
var he$1;
function Qt$1() {
  return he$1 || (he$1 = $t$1(0, 0, m$4));
}
function ri$1(Bi, e, Zi) {
  if (e = rt$1(Bi, e), e !== e)
    return Bi;
  if (e >= Bi.size || e < 0)
    return Bi.withMutations(function(na) {
      e < 0 ? x$1(na, e).set(0, Zi) : x$1(na, 0, e + 1).set(e, Zi);
    });
  e += Bi._origin;
  var Qi = Bi._tail, ea = Bi._root, ra = pr$1();
  return e >= Dt$1(Bi._capacity) ? Qi = Sr$1(Qi, Bi.__ownerID, 0, e, Zi, ra) : ea = Sr$1(
    ea,
    Bi.__ownerID,
    Bi._level,
    e,
    Zi,
    ra
  ), ra.value ? Bi.__ownerID ? (Bi._root = ea, Bi._tail = Qi, Bi.__hash = void 0, Bi.__altered = !0, Bi) : $t$1(Bi._origin, Bi._capacity, Bi._level, ea, Qi) : Bi;
}
function Sr$1(Bi, e, Zi, Qi, ea, ra) {
  var na = Qi >>> Zi & b$1, ia = Bi && na < Bi.array.length;
  if (!ia && ea === void 0)
    return Bi;
  var fa;
  if (Zi > 0) {
    var La = Bi && Bi.array[na], Va = Sr$1(
      La,
      e,
      Zi - m$4,
      Qi,
      ea,
      ra
    );
    return Va === La ? Bi : (fa = dt$1(Bi, e), fa.array[na] = Va, fa);
  }
  return ia && Bi.array[na] === ea ? Bi : (ra && U$1(ra), fa = dt$1(Bi, e), ea === void 0 && na === fa.array.length - 1 ? fa.array.pop() : fa.array[na] = ea, fa);
}
function dt$1(Bi, e) {
  return e && Bi && e === Bi.ownerID ? Bi : new tt(Bi ? Bi.array.slice() : [], e);
}
function sn$1(Bi, e) {
  if (e >= Dt$1(Bi._capacity))
    return Bi._tail;
  if (e < 1 << Bi._level + m$4) {
    for (var Zi = Bi._root, Qi = Bi._level; Zi && Qi > 0; )
      Zi = Zi.array[e >>> Qi & b$1], Qi -= m$4;
    return Zi;
  }
}
function x$1(Bi, e, Zi) {
  e !== void 0 && (e |= 0), Zi !== void 0 && (Zi |= 0);
  var Qi = Bi.__ownerID || new Er$1(), ea = Bi._origin, ra = Bi._capacity, na = ea + e, ia = Zi === void 0 ? ra : Zi < 0 ? ra + Zi : ea + Zi;
  if (na === ea && ia === ra)
    return Bi;
  if (na >= ia)
    return Bi.clear();
  for (var fa = Bi._level, La = Bi._root, Va = 0; na + Va < 0; )
    La = new tt(
      La && La.array.length ? [void 0, La] : [],
      Qi
    ), fa += m$4, Va += 1 << fa;
  Va && (na += Va, ea += Va, ia += Va, ra += Va);
  for (var to = Dt$1(ra), ro = Dt$1(ia); ro >= 1 << fa + m$4; )
    La = new tt(
      La && La.array.length ? [La] : [],
      Qi
    ), fa += m$4;
  var no = Bi._tail, eo = ro < to ? sn$1(Bi, ia - 1) : ro > to ? new tt([], Qi) : no;
  if (no && ro > to && na < ra && no.array.length) {
    La = dt$1(La, Qi);
    for (var ao = La, io = fa; io > m$4; io -= m$4) {
      var xs = to >>> io & b$1;
      ao = ao.array[xs] = dt$1(ao.array[xs], Qi);
    }
    ao.array[to >>> m$4 & b$1] = no;
  }
  if (ia < ra && (eo = eo && eo.removeAfter(Qi, 0, ia)), na >= ro)
    na -= ro, ia -= ro, fa = m$4, La = null, eo = eo && eo.removeBefore(Qi, 0, na);
  else if (na > ea || ro < to) {
    for (Va = 0; La; ) {
      var Ts = na >>> fa & b$1;
      if (Ts !== ro >>> fa & b$1)
        break;
      Ts && (Va += (1 << fa) * Ts), fa -= m$4, La = La.array[Ts];
    }
    La && na > ea && (La = La.removeBefore(Qi, fa, na - Va)), La && ro < to && (La = La.removeAfter(
      Qi,
      fa,
      ro - Va
    )), Va && (na -= Va, ia -= Va);
  }
  return Bi.__ownerID ? (Bi.size = ia - na, Bi._origin = na, Bi._capacity = ia, Bi._level = fa, Bi._root = La, Bi._tail = eo, Bi.__hash = void 0, Bi.__altered = !0, Bi) : $t$1(na, ia, fa, La, eo);
}
function Dt$1(Bi) {
  return Bi < B$1 ? 0 : Bi - 1 >>> m$4 << m$4;
}
var V = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return Zi == null ? qt$1() : $e(Zi) ? Zi : qt$1().withMutations(function(Qi) {
      var ea = K(Zi);
      P$2(ea.size), ea.forEach(function(ra, na) {
        return Qi.set(na, ra);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, e.prototype.get = function(Zi, Qi) {
    var ea = this._map.get(Zi);
    return ea !== void 0 ? this._list.get(ea)[1] : Qi;
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : qt$1();
  }, e.prototype.set = function(Zi, Qi) {
    return _e(this, Zi, Qi);
  }, e.prototype.remove = function(Zi) {
    return _e(this, Zi, y$2);
  }, e.prototype.__iterate = function(Zi, Qi) {
    var ea = this;
    return this._list.__iterate(
      function(ra) {
        return ra && Zi(ra[1], ra[0], ea);
      },
      Qi
    );
  }, e.prototype.__iterator = function(Zi, Qi) {
    return this._list.fromEntrySeq().__iterator(Zi, Qi);
  }, e.prototype.__ensureOwner = function(Zi) {
    if (Zi === this.__ownerID)
      return this;
    var Qi = this._map.__ensureOwner(Zi), ea = this._list.__ensureOwner(Zi);
    return Zi ? Yr$1(Qi, ea, Zi, this.__hash) : this.size === 0 ? qt$1() : (this.__ownerID = Zi, this.__altered = !1, this._map = Qi, this._list = ea, this);
  }, e;
}(zt$1);
V.isOrderedMap = $e;
V.prototype[mt$1] = !0;
V.prototype[Bt$1] = V.prototype.remove;
function Yr$1(Bi, e, Zi, Qi) {
  var ea = Object.create(V.prototype);
  return ea.size = Bi ? Bi.size : 0, ea._map = Bi, ea._list = e, ea.__ownerID = Zi, ea.__hash = Qi, ea.__altered = !1, ea;
}
var ce$1;
function qt$1() {
  return ce$1 || (ce$1 = Yr$1(F(), Qt$1()));
}
function _e(Bi, e, Zi) {
  var Qi = Bi._map, ea = Bi._list, ra = Qi.get(e), na = ra !== void 0, ia, fa;
  if (Zi === y$2) {
    if (!na)
      return Bi;
    ea.size >= B$1 && ea.size >= Qi.size * 2 ? (fa = ea.filter(function(La, Va) {
      return La !== void 0 && ra !== Va;
    }), ia = fa.toKeyedSeq().map(function(La) {
      return La[0];
    }).flip().toMap(), Bi.__ownerID && (ia.__ownerID = fa.__ownerID = Bi.__ownerID)) : (ia = Qi.remove(e), fa = ra === ea.size - 1 ? ea.pop() : ea.set(ra, void 0));
  } else if (na) {
    if (Zi === ea.get(ra)[1])
      return Bi;
    ia = Qi, fa = ea.set(ra, [e, Zi]);
  } else
    ia = Qi.set(e, ea.size), fa = ea.set(ea.size, [e, Zi]);
  return Bi.__ownerID ? (Bi.size = ia.size, Bi._map = ia, Bi._list = fa, Bi.__hash = void 0, Bi.__altered = !0, Bi) : Yr$1(ia, fa);
}
var an$1 = "@@__IMMUTABLE_STACK__@@";
function mr$1(Bi) {
  return !!(Bi && Bi[an$1]);
}
var Hr$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return Zi == null ? Xt$1() : mr$1(Zi) ? Zi : Xt$1().pushAll(Zi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, e.prototype.get = function(Zi, Qi) {
    var ea = this._head;
    for (Zi = rt$1(this, Zi); ea && Zi--; )
      ea = ea.next;
    return ea ? ea.value : Qi;
  }, e.prototype.peek = function() {
    return this._head && this._head.value;
  }, e.prototype.push = function() {
    var Zi = arguments;
    if (arguments.length === 0)
      return this;
    for (var Qi = this.size + arguments.length, ea = this._head, ra = arguments.length - 1; ra >= 0; ra--)
      ea = {
        value: Zi[ra],
        next: ea
      };
    return this.__ownerID ? (this.size = Qi, this._head = ea, this.__hash = void 0, this.__altered = !0, this) : At$1(Qi, ea);
  }, e.prototype.pushAll = function(Zi) {
    if (Zi = Bi(Zi), Zi.size === 0)
      return this;
    if (this.size === 0 && mr$1(Zi))
      return Zi;
    P$2(Zi.size);
    var Qi = this.size, ea = this._head;
    return Zi.__iterate(function(ra) {
      Qi++, ea = {
        value: ra,
        next: ea
      };
    }, !0), this.__ownerID ? (this.size = Qi, this._head = ea, this.__hash = void 0, this.__altered = !0, this) : At$1(Qi, ea);
  }, e.prototype.pop = function() {
    return this.slice(1);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Xt$1();
  }, e.prototype.slice = function(Zi, Qi) {
    if (tr$1(Zi, Qi, this.size))
      return this;
    var ea = Ut$1(Zi, this.size), ra = rr(Qi, this.size);
    if (ra !== this.size)
      return Bi.prototype.slice.call(this, Zi, Qi);
    for (var na = this.size - ea, ia = this._head; ea--; )
      ia = ia.next;
    return this.__ownerID ? (this.size = na, this._head = ia, this.__hash = void 0, this.__altered = !0, this) : At$1(na, ia);
  }, e.prototype.__ensureOwner = function(Zi) {
    return Zi === this.__ownerID ? this : Zi ? At$1(this.size, this._head, Zi, this.__hash) : this.size === 0 ? Xt$1() : (this.__ownerID = Zi, this.__altered = !1, this);
  }, e.prototype.__iterate = function(Zi, Qi) {
    var ea = this;
    if (Qi)
      return new st$1(this.toArray()).__iterate(
        function(ia, fa) {
          return Zi(ia, fa, ea);
        },
        Qi
      );
    for (var ra = 0, na = this._head; na && Zi(na.value, ra++, this) !== !1; )
      na = na.next;
    return ra;
  }, e.prototype.__iterator = function(Zi, Qi) {
    if (Qi)
      return new st$1(this.toArray()).__iterator(Zi, Qi);
    var ea = 0, ra = this._head;
    return new l$5(function() {
      if (ra) {
        var na = ra.value;
        return ra = ra.next, E$1(Zi, ea++, na);
      }
      return j();
    });
  }, e;
}(at);
Hr$1.isStack = mr$1;
var R$1 = Hr$1.prototype;
R$1[an$1] = !0;
R$1.shift = R$1.pop;
R$1.unshift = R$1.push;
R$1.unshiftAll = R$1.pushAll;
R$1.withMutations = Ct$1;
R$1.wasAltered = Cr$1;
R$1.asImmutable = Ft$1;
R$1["@@transducer/init"] = R$1.asMutable = Kt;
R$1["@@transducer/step"] = function(Bi, e) {
  return Bi.unshift(e);
};
R$1["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
function At$1(Bi, e, Zi, Qi) {
  var ea = Object.create(R$1);
  return ea.size = Bi, ea._head = e, ea.__ownerID = Zi, ea.__hash = Qi, ea.__altered = !1, ea;
}
var pe$1;
function Xt$1() {
  return pe$1 || (pe$1 = At$1(0));
}
var fn$1 = "@@__IMMUTABLE_SET__@@";
function Jr$1(Bi) {
  return !!(Bi && Bi[fn$1]);
}
function hn$1(Bi) {
  return Jr$1(Bi) && W$1(Bi);
}
function cn$1(Bi, e) {
  if (Bi === e)
    return !0;
  if (!L$1(e) || Bi.size !== void 0 && e.size !== void 0 && Bi.size !== e.size || Bi.__hash !== void 0 && e.__hash !== void 0 && Bi.__hash !== e.__hash || O$1(Bi) !== O$1(e) || T$1(Bi) !== T$1(e) || W$1(Bi) !== W$1(e))
    return !1;
  if (Bi.size === 0 && e.size === 0)
    return !0;
  var Zi = !er$1(Bi);
  if (W$1(Bi)) {
    var Qi = Bi.entries();
    return e.every(function(fa, La) {
      var Va = Qi.next().value;
      return Va && D(Va[1], fa) && (Zi || D(Va[0], La));
    }) && Qi.next().done;
  }
  var ea = !1;
  if (Bi.size === void 0)
    if (e.size === void 0)
      typeof Bi.cacheResult == "function" && Bi.cacheResult();
    else {
      ea = !0;
      var ra = Bi;
      Bi = e, e = ra;
    }
  var na = !0, ia = e.__iterate(function(fa, La) {
    if (Zi ? !Bi.has(fa) : ea ? !D(fa, Bi.get(La, y$2)) : !D(Bi.get(La, y$2), fa))
      return na = !1, !1;
  });
  return na && Bi.size === ia;
}
function ft$1(Bi, e) {
  var Zi = function(Qi) {
    Bi.prototype[Qi] = e[Qi];
  };
  return Object.keys(e).forEach(Zi), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach(Zi), Bi;
}
function xt$1(Bi) {
  if (!Bi || typeof Bi != "object")
    return Bi;
  if (!L$1(Bi)) {
    if (!et$1(Bi))
      return Bi;
    Bi = N(Bi);
  }
  if (O$1(Bi)) {
    var e = {};
    return Bi.__iterate(function(Qi, ea) {
      e[ea] = xt$1(Qi);
    }), e;
  }
  var Zi = [];
  return Bi.__iterate(function(Qi) {
    Zi.push(xt$1(Qi));
  }), Zi;
}
var Wt$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return Zi == null ? bt$1() : Jr$1(Zi) && !W$1(Zi) ? Zi : bt$1().withMutations(function(Qi) {
      var ea = Bi(Zi);
      P$2(ea.size), ea.forEach(function(ra) {
        return Qi.add(ra);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(Zi) {
    return this(K(Zi).keySeq());
  }, e.intersect = function(Zi) {
    return Zi = z(Zi).toArray(), Zi.length ? q.intersect.apply(e(Zi.pop()), Zi) : bt$1();
  }, e.union = function(Zi) {
    return Zi = z(Zi).toArray(), Zi.length ? q.union.apply(e(Zi.pop()), Zi) : bt$1();
  }, e.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, e.prototype.has = function(Zi) {
    return this._map.has(Zi);
  }, e.prototype.add = function(Zi) {
    return Zt$1(this, this._map.set(Zi, Zi));
  }, e.prototype.remove = function(Zi) {
    return Zt$1(this, this._map.remove(Zi));
  }, e.prototype.clear = function() {
    return Zt$1(this, this._map.clear());
  }, e.prototype.map = function(Zi, Qi) {
    var ea = this, ra = !1, na = Zt$1(
      this,
      this._map.mapEntries(function(ia) {
        var fa = ia[1], La = Zi.call(Qi, fa, fa, ea);
        return La !== fa && (ra = !0), [La, La];
      }, Qi)
    );
    return ra ? na : this;
  }, e.prototype.union = function() {
    for (var Zi = [], Qi = arguments.length; Qi--; )
      Zi[Qi] = arguments[Qi];
    return Zi = Zi.filter(function(ea) {
      return ea.size !== 0;
    }), Zi.length === 0 ? this : this.size === 0 && !this.__ownerID && Zi.length === 1 ? this.constructor(Zi[0]) : this.withMutations(function(ea) {
      for (var ra = 0; ra < Zi.length; ra++)
        Bi(Zi[ra]).forEach(function(na) {
          return ea.add(na);
        });
    });
  }, e.prototype.intersect = function() {
    for (var Zi = [], Qi = arguments.length; Qi--; )
      Zi[Qi] = arguments[Qi];
    if (Zi.length === 0)
      return this;
    Zi = Zi.map(function(ra) {
      return Bi(ra);
    });
    var ea = [];
    return this.forEach(function(ra) {
      Zi.every(function(na) {
        return na.includes(ra);
      }) || ea.push(ra);
    }), this.withMutations(function(ra) {
      ea.forEach(function(na) {
        ra.remove(na);
      });
    });
  }, e.prototype.subtract = function() {
    for (var Zi = [], Qi = arguments.length; Qi--; )
      Zi[Qi] = arguments[Qi];
    if (Zi.length === 0)
      return this;
    Zi = Zi.map(function(ra) {
      return Bi(ra);
    });
    var ea = [];
    return this.forEach(function(ra) {
      Zi.some(function(na) {
        return na.includes(ra);
      }) && ea.push(ra);
    }), this.withMutations(function(ra) {
      ea.forEach(function(na) {
        ra.remove(na);
      });
    });
  }, e.prototype.sort = function(Zi) {
    return Nt$1(_t$1(this, Zi));
  }, e.prototype.sortBy = function(Zi, Qi) {
    return Nt$1(_t$1(this, Qi, Zi));
  }, e.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, e.prototype.__iterate = function(Zi, Qi) {
    var ea = this;
    return this._map.__iterate(function(ra) {
      return Zi(ra, ra, ea);
    }, Qi);
  }, e.prototype.__iterator = function(Zi, Qi) {
    return this._map.__iterator(Zi, Qi);
  }, e.prototype.__ensureOwner = function(Zi) {
    if (Zi === this.__ownerID)
      return this;
    var Qi = this._map.__ensureOwner(Zi);
    return Zi ? this.__make(Qi, Zi) : this.size === 0 ? this.__empty() : (this.__ownerID = Zi, this._map = Qi, this);
  }, e;
}(gt$1);
Wt$1.isSet = Jr$1;
var q = Wt$1.prototype;
q[fn$1] = !0;
q[Bt$1] = q.remove;
q.merge = q.concat = q.union;
q.withMutations = Ct$1;
q.asImmutable = Ft$1;
q["@@transducer/init"] = q.asMutable = Kt;
q["@@transducer/step"] = function(Bi, e) {
  return Bi.add(e);
};
q["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
q.__empty = bt$1;
q.__make = _n$1;
function Zt$1(Bi, e) {
  return Bi.__ownerID ? (Bi.size = e.size, Bi._map = e, Bi) : e === Bi._map ? Bi : e.size === 0 ? Bi.__empty() : Bi.__make(e);
}
function _n$1(Bi, e) {
  var Zi = Object.create(q);
  return Zi.size = Bi ? Bi.size : 0, Zi._map = Bi, Zi.__ownerID = e, Zi;
}
var ve$1;
function bt$1() {
  return ve$1 || (ve$1 = _n$1(F()));
}
var ei$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi, Qi, ea) {
    if (!(this instanceof e))
      return new e(Zi, Qi, ea);
    if (Lr(ea !== 0, "Cannot step a Range by 0"), Zi = Zi || 0, Qi === void 0 && (Qi = 1 / 0), ea = ea === void 0 ? 1 : Math.abs(ea), Qi < Zi && (ea = -ea), this._start = Zi, this._end = Qi, this._step = ea, this.size = Math.max(0, Math.ceil((Qi - Zi) / ea - 1) + 1), this.size === 0) {
      if (_r$1)
        return _r$1;
      _r$1 = this;
    }
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, e.prototype.get = function(Zi, Qi) {
    return this.has(Zi) ? this._start + rt$1(this, Zi) * this._step : Qi;
  }, e.prototype.includes = function(Zi) {
    var Qi = (Zi - this._start) / this._step;
    return Qi >= 0 && Qi < this.size && Qi === Math.floor(Qi);
  }, e.prototype.slice = function(Zi, Qi) {
    return tr$1(Zi, Qi, this.size) ? this : (Zi = Ut$1(Zi, this.size), Qi = rr(Qi, this.size), Qi <= Zi ? new e(0, 0) : new e(
      this.get(Zi, this._end),
      this.get(Qi, this._end),
      this._step
    ));
  }, e.prototype.indexOf = function(Zi) {
    var Qi = Zi - this._start;
    if (Qi % this._step === 0) {
      var ea = Qi / this._step;
      if (ea >= 0 && ea < this.size)
        return ea;
    }
    return -1;
  }, e.prototype.lastIndexOf = function(Zi) {
    return this.indexOf(Zi);
  }, e.prototype.__iterate = function(Zi, Qi) {
    for (var ea = this.size, ra = this._step, na = Qi ? this._start + (ea - 1) * ra : this._start, ia = 0; ia !== ea && Zi(na, Qi ? ea - ++ia : ia++, this) !== !1; )
      na += Qi ? -ra : ra;
    return ia;
  }, e.prototype.__iterator = function(Zi, Qi) {
    var ea = this.size, ra = this._step, na = Qi ? this._start + (ea - 1) * ra : this._start, ia = 0;
    return new l$5(function() {
      if (ia === ea)
        return j();
      var fa = na;
      return na += Qi ? -ra : ra, E$1(Zi, Qi ? ea - ++ia : ia++, fa);
    });
  }, e.prototype.equals = function(Zi) {
    return Zi instanceof e ? this._start === Zi._start && this._end === Zi._end && this._step === Zi._step : cn$1(this, Zi);
  }, e;
}(H$2), _r$1;
function pn$1(Bi, e, Zi) {
  for (var Qi = Je$1(e), ea = 0; ea !== Qi.length; )
    if (Bi = Xe$1(Bi, Qi[ea++], y$2), Bi === y$2)
      return Zi;
  return Bi;
}
function vn$1(Bi, e) {
  return pn$1(this, Bi, e);
}
function ni(Bi, e) {
  return pn$1(Bi, e, y$2) !== y$2;
}
function ii(Bi) {
  return ni(this, Bi);
}
function dn() {
  P$2(this.size);
  var Bi = {};
  return this.__iterate(function(e, Zi) {
    Bi[Zi] = e;
  }), Bi;
}
z.isIterable = L$1;
z.isKeyed = O$1;
z.isIndexed = T$1;
z.isAssociative = er$1;
z.isOrdered = W$1;
z.Iterator = l$5;
ft$1(z, {
  toArray: function() {
    P$2(this.size);
    var Bi = new Array(this.size || 0), e = O$1(this), Zi = 0;
    return this.__iterate(function(Qi, ea) {
      Bi[Zi++] = e ? [ea, Qi] : Qi;
    }), Bi;
  },
  toIndexedSeq: function() {
    return new Ne$1(this);
  },
  toJS: function() {
    return xt$1(this);
  },
  toKeyedSeq: function() {
    return new or$1(this, !0);
  },
  toMap: function() {
    return zt$1(this.toKeyedSeq());
  },
  toObject: dn,
  toOrderedMap: function() {
    return V(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return Nt$1(O$1(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return Wt$1(O$1(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new Be$1(this);
  },
  toSeq: function() {
    return T$1(this) ? this.toIndexedSeq() : O$1(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return Hr$1(O$1(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return sr$1(O$1(this) ? this.valueSeq() : this);
  },
  toString: function() {
    return "[Collection]";
  },
  __toString: function(Bi, e) {
    return this.size === 0 ? Bi + e : Bi + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + e;
  },
  concat: function() {
    for (var Bi = [], e = arguments.length; e--; )
      Bi[e] = arguments[e];
    return g$2(this, kn$1(this, Bi));
  },
  includes: function(Bi) {
    return this.some(function(e) {
      return D(e, Bi);
    });
  },
  entries: function() {
    return this.__iterator(C$1);
  },
  every: function(Bi, e) {
    P$2(this.size);
    var Zi = !0;
    return this.__iterate(function(Qi, ea, ra) {
      if (!Bi.call(e, Qi, ea, ra))
        return Zi = !1, !1;
    }), Zi;
  },
  filter: function(Bi, e) {
    return g$2(this, Ke$1(this, Bi, e, !0));
  },
  find: function(Bi, e, Zi) {
    var Qi = this.findEntry(Bi, e);
    return Qi ? Qi[1] : Zi;
  },
  forEach: function(Bi, e) {
    return P$2(this.size), this.__iterate(e ? Bi.bind(e) : Bi);
  },
  join: function(Bi) {
    P$2(this.size), Bi = Bi !== void 0 ? "" + Bi : ",";
    var e = "", Zi = !0;
    return this.__iterate(function(Qi) {
      Zi ? Zi = !1 : e += Bi, e += Qi != null ? Qi.toString() : "";
    }), e;
  },
  keys: function() {
    return this.__iterator(Pt$1);
  },
  map: function(Bi, e) {
    return g$2(this, Ce$1(this, Bi, e));
  },
  reduce: function(Bi, e, Zi) {
    return de$1(
      this,
      Bi,
      e,
      Zi,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(Bi, e, Zi) {
    return de$1(
      this,
      Bi,
      e,
      Zi,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return g$2(this, br$1(this, !0));
  },
  slice: function(Bi, e) {
    return g$2(this, Rr$1(this, Bi, e, !0));
  },
  some: function(Bi, e) {
    return !this.every(Gt$1(Bi), e);
  },
  sort: function(Bi) {
    return g$2(this, _t$1(this, Bi));
  },
  values: function() {
    return this.__iterator(Y$1);
  },
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(Bi, e) {
    return ct$1(
      Bi ? this.toSeq().filter(Bi, e) : this
    );
  },
  countBy: function(Bi, e) {
    return Tn$1(this, Bi, e);
  },
  equals: function(Bi) {
    return cn$1(this, Bi);
  },
  entrySeq: function() {
    var Bi = this;
    if (Bi._cache)
      return new st$1(Bi._cache);
    var e = Bi.toSeq().map(oi$1).toIndexedSeq();
    return e.fromEntrySeq = function() {
      return Bi.toSeq();
    }, e;
  },
  filterNot: function(Bi, e) {
    return this.filter(Gt$1(Bi), e);
  },
  findEntry: function(Bi, e, Zi) {
    var Qi = Zi;
    return this.__iterate(function(ea, ra, na) {
      if (Bi.call(e, ea, ra, na))
        return Qi = [ra, ea], !1;
    }), Qi;
  },
  findKey: function(Bi, e) {
    var Zi = this.findEntry(Bi, e);
    return Zi && Zi[0];
  },
  findLast: function(Bi, e, Zi) {
    return this.toKeyedSeq().reverse().find(Bi, e, Zi);
  },
  findLastEntry: function(Bi, e, Zi) {
    return this.toKeyedSeq().reverse().findEntry(Bi, e, Zi);
  },
  findLastKey: function(Bi, e) {
    return this.toKeyedSeq().reverse().findKey(Bi, e);
  },
  first: function(Bi) {
    return this.find(Ee$1, null, Bi);
  },
  flatMap: function(Bi, e) {
    return g$2(this, $n$1(this, Bi, e));
  },
  flatten: function(Bi) {
    return g$2(this, We$1(this, Bi, !0));
  },
  fromEntrySeq: function() {
    return new Ue$1(this);
  },
  get: function(Bi, e) {
    return this.find(function(Zi, Qi) {
      return D(Qi, Bi);
    }, void 0, e);
  },
  getIn: vn$1,
  groupBy: function(Bi, e) {
    return Ln$1(this, Bi, e);
  },
  has: function(Bi) {
    return this.get(Bi, y$2) !== y$2;
  },
  hasIn: ii,
  isSubset: function(Bi) {
    return Bi = typeof Bi.includes == "function" ? Bi : z(Bi), this.every(function(e) {
      return Bi.includes(e);
    });
  },
  isSuperset: function(Bi) {
    return Bi = typeof Bi.isSubset == "function" ? Bi : z(Bi), Bi.isSubset(this);
  },
  keyOf: function(Bi) {
    return this.findKey(function(e) {
      return D(e, Bi);
    });
  },
  keySeq: function() {
    return this.toSeq().map(ui$1).toIndexedSeq();
  },
  last: function(Bi) {
    return this.toSeq().reverse().first(Bi);
  },
  lastKeyOf: function(Bi) {
    return this.toKeyedSeq().reverse().keyOf(Bi);
  },
  max: function(Bi) {
    return Ht$1(this, Bi);
  },
  maxBy: function(Bi, e) {
    return Ht$1(this, e, Bi);
  },
  min: function(Bi) {
    return Ht$1(
      this,
      Bi ? ye$1(Bi) : ge$1
    );
  },
  minBy: function(Bi, e) {
    return Ht$1(
      this,
      e ? ye$1(e) : ge$1,
      Bi
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(Bi) {
    return Bi === 0 ? this : this.slice(Math.max(0, Bi));
  },
  skipLast: function(Bi) {
    return Bi === 0 ? this : this.slice(0, -Math.max(0, Bi));
  },
  skipWhile: function(Bi, e) {
    return g$2(this, Fe$1(this, Bi, e, !0));
  },
  skipUntil: function(Bi, e) {
    return this.skipWhile(Gt$1(Bi), e);
  },
  sortBy: function(Bi, e) {
    return g$2(this, _t$1(this, e, Bi));
  },
  take: function(Bi) {
    return this.slice(0, Math.max(0, Bi));
  },
  takeLast: function(Bi) {
    return this.slice(-Math.max(0, Bi));
  },
  takeWhile: function(Bi, e) {
    return g$2(this, jn$1(this, Bi, e));
  },
  takeUntil: function(Bi, e) {
    return this.takeWhile(Gt$1(Bi), e);
  },
  update: function(Bi) {
    return Bi(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  hashCode: function() {
    return this.__hash || (this.__hash = si$1(this));
  }
});
var A$1 = z.prototype;
A$1[Ie$1] = !0;
A$1[nr$1] = A$1.values;
A$1.toJSON = A$1.toArray;
A$1.__toStringMapper = Lt$1;
A$1.inspect = A$1.toSource = function() {
  return this.toString();
};
A$1.chain = A$1.flatMap;
A$1.contains = A$1.includes;
ft$1(K, {
  flip: function() {
    return g$2(this, Pe$1(this));
  },
  mapEntries: function(Bi, e) {
    var Zi = this, Qi = 0;
    return g$2(
      this,
      this.toSeq().map(function(ea, ra) {
        return Bi.call(e, [ra, ea], Qi++, Zi);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(Bi, e) {
    var Zi = this;
    return g$2(
      this,
      this.toSeq().flip().map(function(Qi, ea) {
        return Bi.call(e, Qi, ea, Zi);
      }).flip()
    );
  }
});
var Yt$1 = K.prototype;
Yt$1[Me$1] = !0;
Yt$1[nr$1] = A$1.entries;
Yt$1.toJSON = dn;
Yt$1.__toStringMapper = function(Bi, e) {
  return Lt$1(e) + ": " + Lt$1(Bi);
};
ft$1(at, {
  toKeyedSeq: function() {
    return new or$1(this, !1);
  },
  filter: function(Bi, e) {
    return g$2(this, Ke$1(this, Bi, e, !1));
  },
  findIndex: function(Bi, e) {
    var Zi = this.findEntry(Bi, e);
    return Zi ? Zi[0] : -1;
  },
  indexOf: function(Bi) {
    var e = this.keyOf(Bi);
    return e === void 0 ? -1 : e;
  },
  lastIndexOf: function(Bi) {
    var e = this.lastKeyOf(Bi);
    return e === void 0 ? -1 : e;
  },
  reverse: function() {
    return g$2(this, br$1(this, !1));
  },
  slice: function(Bi, e) {
    return g$2(this, Rr$1(this, Bi, e, !1));
  },
  splice: function(Bi, e) {
    var Zi = arguments.length;
    if (e = Math.max(e || 0, 0), Zi === 0 || Zi === 2 && !e)
      return this;
    Bi = Ut$1(Bi, Bi < 0 ? this.count() : this.size);
    var Qi = this.slice(0, Bi);
    return g$2(
      this,
      Zi === 1 ? Qi : Qi.concat(X$1(arguments, 2), this.slice(Bi + e))
    );
  },
  findLastIndex: function(Bi, e) {
    var Zi = this.findLastEntry(Bi, e);
    return Zi ? Zi[0] : -1;
  },
  first: function(Bi) {
    return this.get(0, Bi);
  },
  flatten: function(Bi) {
    return g$2(this, We$1(this, Bi, !1));
  },
  get: function(Bi, e) {
    return Bi = rt$1(this, Bi), Bi < 0 || this.size === 1 / 0 || this.size !== void 0 && Bi > this.size ? e : this.find(function(Zi, Qi) {
      return Qi === Bi;
    }, void 0, e);
  },
  has: function(Bi) {
    return Bi = rt$1(this, Bi), Bi >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || Bi < this.size : this.indexOf(Bi) !== -1);
  },
  interpose: function(Bi) {
    return g$2(this, Dn$1(this, Bi));
  },
  interleave: function() {
    var Bi = [this].concat(X$1(arguments)), e = Jt(this.toSeq(), H$2.of, Bi), Zi = e.flatten(!0);
    return e.size && (Zi.size = e.size * Bi.length), g$2(this, Zi);
  },
  keySeq: function() {
    return ei$1(0, this.size);
  },
  last: function(Bi) {
    return this.get(-1, Bi);
  },
  skipWhile: function(Bi, e) {
    return g$2(this, Fe$1(this, Bi, e, !1));
  },
  zip: function() {
    var Bi = [this].concat(X$1(arguments));
    return g$2(this, Jt(this, le, Bi));
  },
  zipAll: function() {
    var Bi = [this].concat(X$1(arguments));
    return g$2(this, Jt(this, le, Bi, !0));
  },
  zipWith: function(Bi) {
    var e = X$1(arguments);
    return e[0] = this, g$2(this, Jt(this, Bi, e));
  }
});
var It$1 = at.prototype;
It$1[qe$1] = !0;
It$1[mt$1] = !0;
ft$1(gt$1, {
  get: function(Bi, e) {
    return this.has(Bi) ? Bi : e;
  },
  includes: function(Bi) {
    return this.has(Bi);
  },
  keySeq: function() {
    return this.valueSeq();
  }
});
var yt$1 = gt$1.prototype;
yt$1.has = A$1.includes;
yt$1.contains = yt$1.includes;
yt$1.keys = yt$1.values;
ft$1(it$1, Yt$1);
ft$1(H$2, It$1);
ft$1(Et$1, yt$1);
function de$1(Bi, e, Zi, Qi, ea, ra) {
  return P$2(Bi.size), Bi.__iterate(function(na, ia, fa) {
    ea ? (ea = !1, Zi = na) : Zi = e.call(Qi, Zi, na, ia, fa);
  }, ra), Zi;
}
function ui$1(Bi, e) {
  return e;
}
function oi$1(Bi, e) {
  return [e, Bi];
}
function Gt$1(Bi) {
  return function() {
    return !Bi.apply(this, arguments);
  };
}
function ye$1(Bi) {
  return function() {
    return -Bi.apply(this, arguments);
  };
}
function le() {
  return X$1(arguments);
}
function ge$1(Bi, e) {
  return Bi < e ? 1 : Bi > e ? -1 : 0;
}
function si$1(Bi) {
  if (Bi.size === 1 / 0)
    return 0;
  var e = W$1(Bi), Zi = O$1(Bi), Qi = e ? 1 : 0, ea = Bi.__iterate(
    Zi ? e ? function(ra, na) {
      Qi = 31 * Qi + Se$1($(ra), $(na)) | 0;
    } : function(ra, na) {
      Qi = Qi + Se$1($(ra), $(na)) | 0;
    } : e ? function(ra) {
      Qi = 31 * Qi + $(ra) | 0;
    } : function(ra) {
      Qi = Qi + $(ra) | 0;
    }
  );
  return ai$1(ea, Qi);
}
function ai$1(Bi, e) {
  return e = Mt$1(e, 3432918353), e = Mt$1(e << 15 | e >>> -15, 461845907), e = Mt$1(e << 13 | e >>> -13, 5), e = (e + 3864292196 | 0) ^ Bi, e = Mt$1(e ^ e >>> 16, 2246822507), e = Mt$1(e ^ e >>> 13, 3266489909), e = ur$1(e ^ e >>> 16), e;
}
function Se$1(Bi, e) {
  return Bi ^ e + 2654435769 + (Bi << 6) + (Bi >> 2) | 0;
}
var Nt$1 = /* @__PURE__ */ function(Bi) {
  function e(Zi) {
    return Zi == null ? wr$1() : hn$1(Zi) ? Zi : wr$1().withMutations(function(Qi) {
      var ea = gt$1(Zi);
      P$2(ea.size), ea.forEach(function(ra) {
        return Qi.add(ra);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(Zi) {
    return this(K(Zi).keySeq());
  }, e.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, e;
}(Wt$1);
Nt$1.isOrderedSet = hn$1;
var ht$1 = Nt$1.prototype;
ht$1[mt$1] = !0;
ht$1.zip = It$1.zip;
ht$1.zipWith = It$1.zipWith;
ht$1.zipAll = It$1.zipAll;
ht$1.__empty = wr$1;
ht$1.__make = yn$1;
function yn$1(Bi, e) {
  var Zi = Object.create(ht$1);
  return Zi.size = Bi ? Bi.size : 0, Zi._map = Bi, Zi.__ownerID = e, Zi;
}
var me$1;
function wr$1() {
  return me$1 || (me$1 = yn$1(qt$1()));
}
function fi$1(Bi) {
  if (St$1(Bi))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (Z(Bi))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (Bi === null || typeof Bi != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var M$1 = function(Bi, e) {
  var Zi;
  fi$1(Bi);
  var Qi = function(ra) {
    var na = this;
    if (ra instanceof Qi)
      return ra;
    if (!(this instanceof Qi))
      return new Qi(ra);
    if (!Zi) {
      Zi = !0;
      var ia = Object.keys(Bi), fa = ea._indices = {};
      ea._name = e, ea._keys = ia, ea._defaultValues = Bi;
      for (var La = 0; La < ia.length; La++) {
        var Va = ia[La];
        fa[Va] = La, ea[Va] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + Zr$1(this) + ' with property "' + Va + '" since that property name is part of the Record API.'
        ) : hi$1(ea, Va);
      }
    }
    return this.__ownerID = void 0, this._values = sr$1().withMutations(function(to) {
      to.setSize(na._keys.length), K(ra).forEach(function(ro, no) {
        to.set(na._indices[no], ro === na._defaultValues[no] ? void 0 : ro);
      });
    }), this;
  }, ea = Qi.prototype = Object.create(S);
  return ea.constructor = Qi, e && (Qi.displayName = e), Qi;
};
M$1.prototype.toString = function() {
  for (var Bi = Zr$1(this) + " { ", e = this._keys, Zi, Qi = 0, ea = e.length; Qi !== ea; Qi++)
    Zi = e[Qi], Bi += (Qi ? ", " : "") + Zi + ": " + Lt$1(this.get(Zi));
  return Bi + " }";
};
M$1.prototype.equals = function(Bi) {
  return this === Bi || St$1(Bi) && lt$1(this).equals(lt$1(Bi));
};
M$1.prototype.hashCode = function() {
  return lt$1(this).hashCode();
};
M$1.prototype.has = function(Bi) {
  return this._indices.hasOwnProperty(Bi);
};
M$1.prototype.get = function(Bi, e) {
  if (!this.has(Bi))
    return e;
  var Zi = this._indices[Bi], Qi = this._values.get(Zi);
  return Qi === void 0 ? this._defaultValues[Bi] : Qi;
};
M$1.prototype.set = function(Bi, e) {
  if (this.has(Bi)) {
    var Zi = this._values.set(
      this._indices[Bi],
      e === this._defaultValues[Bi] ? void 0 : e
    );
    if (Zi !== this._values && !this.__ownerID)
      return Xr$1(this, Zi);
  }
  return this;
};
M$1.prototype.remove = function(Bi) {
  return this.set(Bi);
};
M$1.prototype.clear = function() {
  var Bi = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : Xr$1(this, Bi);
};
M$1.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
M$1.prototype.toSeq = function() {
  return lt$1(this);
};
M$1.prototype.toJS = function() {
  return xt$1(this);
};
M$1.prototype.entries = function() {
  return this.__iterator(C$1);
};
M$1.prototype.__iterator = function(Bi, e) {
  return lt$1(this).__iterator(Bi, e);
};
M$1.prototype.__iterate = function(Bi, e) {
  return lt$1(this).__iterate(Bi, e);
};
M$1.prototype.__ensureOwner = function(Bi) {
  if (Bi === this.__ownerID)
    return this;
  var e = this._values.__ensureOwner(Bi);
  return Bi ? Xr$1(this, e, Bi) : (this.__ownerID = Bi, this._values = e, this);
};
M$1.isRecord = St$1;
M$1.getDescriptiveName = Zr$1;
var S = M$1.prototype;
S[be$1] = !0;
S[Bt$1] = S.remove;
S.deleteIn = S.removeIn = kr$1;
S.getIn = vn$1;
S.hasIn = A$1.hasIn;
S.merge = Qe$1;
S.mergeWith = Ve$1;
S.mergeIn = Ur$1;
S.mergeDeep = tn$1;
S.mergeDeepWith = rn$1;
S.mergeDeepIn = Pr$1;
S.setIn = jr$1;
S.update = $r$1;
S.updateIn = Dr;
S.withMutations = Ct$1;
S.asMutable = Kt;
S.asImmutable = Ft$1;
S[nr$1] = S.entries;
S.toJSON = S.toObject = A$1.toObject;
S.inspect = S.toSource = function() {
  return this.toString();
};
function Xr$1(Bi, e, Zi) {
  var Qi = Object.create(Object.getPrototypeOf(Bi));
  return Qi._values = e, Qi.__ownerID = Zi, Qi;
}
function Zr$1(Bi) {
  return Bi.constructor.displayName || Bi.constructor.name || "Record";
}
function lt$1(Bi) {
  return Mr$1(Bi._keys.map(function(e) {
    return [e, Bi.get(e)];
  }));
}
function hi$1(Bi, e) {
  try {
    Object.defineProperty(Bi, e, {
      get: function() {
        return this.get(e);
      },
      set: function(Zi) {
        Lr(this.__ownerID, "Cannot set on an immutable record."), this.set(e, Zi);
      }
    });
  } catch {
  }
}
const Si$1 = (Bi, e) => {
  useEffect(() => (document.addEventListener("keydown", (Zi) => {
    Bi[Zi.key] && Bi[Zi.key]();
  }), () => {
    document.removeEventListener("keydown", () => null);
  }), e || []);
}, containerVariants = cva(
  [
    "dark:bg-neutral-900",
    "dark:text-neutral-200",
    "absolute",
    "transform",
    "shadow-sm",
    "border",
    "border-black",
    "top-1/2",
    "left-1/2",
    "bg-neutral-100",
    "max-h-[75vh]",
    "z-50"
  ],
  {
    variants: {
      size: {
        fit: ["w-auto", "h-auto"],
        sm: ["w-sm", "h-[50vh]"],
        md: ["w-md", "h-[50vh]"],
        lg: ["w-lg", "h-[50vh]"]
      }
    }
  }
), Modal = ({
  children: Bi,
  visible: e,
  onClose: Zi,
  className: Qi,
  containerClassName: ea = "modal-root",
  variant: ra = "lg"
}) => {
  const na = useRef(null), { root: ia } = useModalContext();
  return Si$1({
    Escape: Zi
  }), ia ? e ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.div,
        {
          className: twMerge(
            "fixed top-0 left-0 w-screen h-screen opacity-80 bg-neutral-700 z-40 overlay",
            Qi
          ),
          onClick: () => Zi(),
          initial: { opacity: 0 },
          animate: { opacity: 0.8 }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.div,
        {
          className: twMerge(
            containerVariants({ size: ra }),
            ea
          ),
          ref: na,
          initial: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "100vh"
          },
          animate: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "50vh"
          },
          exit: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) ",
            top: "100vh"
          },
          children: Bi
        }
      )
    ] }) }),
    ia
  ) : null : (console.error("No root element found"), null);
}, ModalContext = createContext({ root: null }), useModalContext = () => a__default.useContext(ModalContext), ModalContainer = ({
  className: Bi = "modal-root",
  children: e
}) => {
  const [Zi, Qi] = a__default.useState(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContext.Provider, { value: { root: Zi }, children: [
    e,
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: Qi, className: Bi })
  ] });
}, CreateFolderModal = ({
  visible: Bi,
  onClose: e,
  onCreateFolder: Zi
}) => {
  const { register: Qi, handleSubmit: ea, reset: ra } = useForm({ defaultValues: { name: "" } }), { ref: na, ...ia } = Qi("name"), [fa, La] = useState(null);
  return useEffect(() => {
    fa && fa.focus();
  }, [fa]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Modal,
    {
      visible: Bi,
      onClose: () => e(!1),
      variant: "fit",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "border-black border w-full h-full bg-white p-4", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: "create folder" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "form",
          {
            className: "flex flex-col items-center justify-center gap-4",
            onSubmit: ea((Va) => {
              ra(), Zi(Va.name);
            }),
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Input,
                {
                  ref: (Va) => {
                    na(Va), La(Va);
                  },
                  className: "block",
                  ...ia,
                  type: "text",
                  placeholder: "folder name"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { children: "Create" })
            ]
          }
        )
      ] })
    }
  );
}, t$6 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216.49,79.52l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.52ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,88H152V32Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM152,88V44l44,44Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Z" }))
  ]
]), a$6 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM44,56H90.61l10.67,12H44ZM212,196H44V92H212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM36,56a4,4,0,0,1,4-4H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4Z" }))
  ]
]), H$1 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM90.61,56l10.67,12H44V56ZM212,196H44V92H212Zm-72-76v12h12a12,12,0,0,1,0,24H140v12a12,12,0,0,1-24,0V156H104a12,12,0,0,1,0-24h12V120a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Zm112,96H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2ZM158,144a6,6,0,0,1-6,6H134v18a6,6,0,0,1-12,0V150H104a6,6,0,0,1,0-12h18V120a6,6,0,0,1,12,0v18h18A6,6,0,0,1,158,144Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM40,52H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36V56A4,4,0,0,1,40,52ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4ZM156,144a4,4,0,0,1-4,4H132v20a4,4,0,0,1-8,0V148H104a4,4,0,0,1,0-8h20V120a4,4,0,0,1,8,0v20h20A4,4,0,0,1,156,144Z" }))
  ]
]), t$5 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM40,76H216a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24ZM216,180H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,64V192H40V64Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM192,184H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM40,70H216a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12ZM216,186H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM40,68H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z" }))
  ]
]), t$4 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,144v64a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V144a12,12,0,0,1,24,0v52H204V144a12,12,0,0,1,24,0ZM96.49,80.49,116,61v83a12,12,0,0,0,24,0V61l19.51,19.52a12,12,0,1,0,17-17l-40-40a12,12,0,0,0-17,0l-40,40a12,12,0,1,0,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M216,48V208H40V48A16,16,0,0,1,56,32H200A16,16,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM88,80h32v64a8,8,0,0,0,16,0V80h32a8,8,0,0,0,5.66-13.66l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,88,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222,144v64a6,6,0,0,1-6,6H40a6,6,0,0,1-6-6V144a6,6,0,0,1,12,0v58H210V144a6,6,0,0,1,12,0ZM92.24,76.24,122,46.49V144a6,6,0,0,0,12,0V46.49l29.76,29.75a6,6,0,0,0,8.48-8.48l-40-40a6,6,0,0,0-8.48,0l-40,40a6,6,0,0,0,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220,144v64a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V144a4,4,0,0,1,8,0v60H212V144a4,4,0,0,1,8,0ZM90.83,74.83,124,41.66V144a4,4,0,0,0,8,0V41.66l33.17,33.17a4,4,0,1,0,5.66-5.66l-40-40a4,4,0,0,0-5.66,0l-40,40a4,4,0,0,0,5.66,5.66Z" }))
  ]
]), o = createContext({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
});
var y$1 = Object.defineProperty, c$5 = Object.getOwnPropertySymbols, f$6 = Object.prototype.hasOwnProperty, g$1 = Object.prototype.propertyIsEnumerable, d$2 = (Bi, e, Zi) => e in Bi ? y$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Zi }) : Bi[e] = Zi, l$4 = (Bi, e) => {
  for (var Zi in e || (e = {}))
    f$6.call(e, Zi) && d$2(Bi, Zi, e[Zi]);
  if (c$5)
    for (var Zi of c$5(e))
      g$1.call(e, Zi) && d$2(Bi, Zi, e[Zi]);
  return Bi;
}, a$5 = (Bi, e) => {
  var Zi = {};
  for (var Qi in Bi)
    f$6.call(Bi, Qi) && e.indexOf(Qi) < 0 && (Zi[Qi] = Bi[Qi]);
  if (Bi != null && c$5)
    for (var Qi of c$5(Bi))
      e.indexOf(Qi) < 0 && g$1.call(Bi, Qi) && (Zi[Qi] = Bi[Qi]);
  return Zi;
};
const h = forwardRef((Bi, e) => {
  const Zi = Bi, {
    alt: Qi,
    color: ea,
    size: ra,
    weight: na,
    mirrored: ia,
    children: fa,
    weights: La
  } = Zi, Va = a$5(Zi, [
    "alt",
    "color",
    "size",
    "weight",
    "mirrored",
    "children",
    "weights"
  ]), to = useContext(o), {
    color: ro = "currentColor",
    size: no,
    weight: eo = "regular",
    mirrored: ao = !1
  } = to, io = a$5(to, [
    "color",
    "size",
    "weight",
    "mirrored"
  ]);
  return /* @__PURE__ */ a__default.createElement(
    "svg",
    l$4(l$4({
      ref: e,
      xmlns: "http://www.w3.org/2000/svg",
      width: ra ?? no,
      height: ra ?? no,
      fill: ea ?? ro,
      viewBox: "0 0 256 256",
      transform: ia || ao ? "scale(-1, 1)" : void 0
    }, io), Va),
    !!Qi && /* @__PURE__ */ a__default.createElement("title", null, Qi),
    fa,
    La.get(na ?? eo)
  );
});
h.displayName = "IconBase";
const b = h;
var f$5 = Object.defineProperty, p$2 = Object.defineProperties, s$4 = Object.getOwnPropertyDescriptors, t$3 = Object.getOwnPropertySymbols, c$4 = Object.prototype.hasOwnProperty, l$3 = Object.prototype.propertyIsEnumerable, m$3 = (Bi, e, Zi) => e in Bi ? f$5(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Zi }) : Bi[e] = Zi, a$4 = (Bi, e) => {
  for (var Zi in e || (e = {}))
    c$4.call(e, Zi) && m$3(Bi, Zi, e[Zi]);
  if (t$3)
    for (var Zi of t$3(e))
      l$3.call(e, Zi) && m$3(Bi, Zi, e[Zi]);
  return Bi;
}, i$5 = (Bi, e) => p$2(Bi, s$4(e));
const I = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, i$5(a$4({ ref: e }, Bi), { weights: t$6 })));
I.displayName = "File";
var c$3 = Object.defineProperty, d$1 = Object.defineProperties, f$4 = Object.getOwnPropertyDescriptors, t$2 = Object.getOwnPropertySymbols, i$4 = Object.prototype.hasOwnProperty, l$2 = Object.prototype.propertyIsEnumerable, a$3 = (Bi, e, Zi) => e in Bi ? c$3(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Zi }) : Bi[e] = Zi, m$2 = (Bi, e) => {
  for (var Zi in e || (e = {}))
    i$4.call(e, Zi) && a$3(Bi, Zi, e[Zi]);
  if (t$2)
    for (var Zi of t$2(e))
      l$2.call(e, Zi) && a$3(Bi, Zi, e[Zi]);
  return Bi;
}, s$3 = (Bi, e) => d$1(Bi, f$4(e));
const w$1 = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, s$3(m$2({ ref: e }, Bi), { weights: a$6 })));
w$1.displayName = "Folder";
var m$1 = Object.defineProperty, c$2 = Object.defineProperties, d = Object.getOwnPropertyDescriptors, t$1 = Object.getOwnPropertySymbols, f$3 = Object.prototype.hasOwnProperty, i$3 = Object.prototype.propertyIsEnumerable, s$2 = (Bi, e, Zi) => e in Bi ? m$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Zi }) : Bi[e] = Zi, a$2 = (Bi, e) => {
  for (var Zi in e || (e = {}))
    f$3.call(e, Zi) && s$2(Bi, Zi, e[Zi]);
  if (t$1)
    for (var Zi of t$1(e))
      i$3.call(e, Zi) && s$2(Bi, Zi, e[Zi]);
  return Bi;
}, l$1 = (Bi, e) => c$2(Bi, d(e));
const P$1 = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, l$1(a$2({ ref: e }, Bi), { weights: H$1 })));
P$1.displayName = "FolderPlus";
var s$1 = Object.defineProperty, f$2 = Object.defineProperties, p$1 = Object.getOwnPropertyDescriptors, r$1 = Object.getOwnPropertySymbols, c$1 = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable, m = (Bi, e, Zi) => e in Bi ? s$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Zi }) : Bi[e] = Zi, a$1 = (Bi, e) => {
  for (var Zi in e || (e = {}))
    c$1.call(e, Zi) && m(Bi, Zi, e[Zi]);
  if (r$1)
    for (var Zi of r$1(e))
      n.call(e, Zi) && m(Bi, Zi, e[Zi]);
  return Bi;
}, i$2 = (Bi, e) => f$2(Bi, p$1(e));
const L = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, i$2(a$1({ ref: e }, Bi), { weights: t$5 })));
L.displayName = "List";
var i$1 = Object.defineProperty, l = Object.defineProperties, f$1 = Object.getOwnPropertyDescriptors, r = Object.getOwnPropertySymbols, s = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable, a = (Bi, e, Zi) => e in Bi ? i$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Zi }) : Bi[e] = Zi, p = (Bi, e) => {
  for (var Zi in e || (e = {}))
    s.call(e, Zi) && a(Bi, Zi, e[Zi]);
  if (r)
    for (var Zi of r(e))
      c.call(e, Zi) && a(Bi, Zi, e[Zi]);
  return Bi;
}, t = (Bi, e) => l(Bi, f$1(e));
const R = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, t(p({ ref: e }, Bi), { weights: t$4 })));
R.displayName = "UploadSimple";
var pathBrowserify, hasRequiredPathBrowserify;
function requirePathBrowserify() {
  if (hasRequiredPathBrowserify) return pathBrowserify;
  hasRequiredPathBrowserify = 1;
  function Bi(ea) {
    if (typeof ea != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(ea));
  }
  function e(ea, ra) {
    for (var na = "", ia = 0, fa = -1, La = 0, Va, to = 0; to <= ea.length; ++to) {
      if (to < ea.length)
        Va = ea.charCodeAt(to);
      else {
        if (Va === 47)
          break;
        Va = 47;
      }
      if (Va === 47) {
        if (!(fa === to - 1 || La === 1)) if (fa !== to - 1 && La === 2) {
          if (na.length < 2 || ia !== 2 || na.charCodeAt(na.length - 1) !== 46 || na.charCodeAt(na.length - 2) !== 46) {
            if (na.length > 2) {
              var ro = na.lastIndexOf("/");
              if (ro !== na.length - 1) {
                ro === -1 ? (na = "", ia = 0) : (na = na.slice(0, ro), ia = na.length - 1 - na.lastIndexOf("/")), fa = to, La = 0;
                continue;
              }
            } else if (na.length === 2 || na.length === 1) {
              na = "", ia = 0, fa = to, La = 0;
              continue;
            }
          }
          ra && (na.length > 0 ? na += "/.." : na = "..", ia = 2);
        } else
          na.length > 0 ? na += "/" + ea.slice(fa + 1, to) : na = ea.slice(fa + 1, to), ia = to - fa - 1;
        fa = to, La = 0;
      } else Va === 46 && La !== -1 ? ++La : La = -1;
    }
    return na;
  }
  function Zi(ea, ra) {
    var na = ra.dir || ra.root, ia = ra.base || (ra.name || "") + (ra.ext || "");
    return na ? na === ra.root ? na + ia : na + ea + ia : ia;
  }
  var Qi = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var ra = "", na = !1, ia, fa = arguments.length - 1; fa >= -1 && !na; fa--) {
        var La;
        fa >= 0 ? La = arguments[fa] : (ia === void 0 && (ia = process.cwd()), La = ia), Bi(La), La.length !== 0 && (ra = La + "/" + ra, na = La.charCodeAt(0) === 47);
      }
      return ra = e(ra, !na), na ? ra.length > 0 ? "/" + ra : "/" : ra.length > 0 ? ra : ".";
    },
    normalize: function(ra) {
      if (Bi(ra), ra.length === 0) return ".";
      var na = ra.charCodeAt(0) === 47, ia = ra.charCodeAt(ra.length - 1) === 47;
      return ra = e(ra, !na), ra.length === 0 && !na && (ra = "."), ra.length > 0 && ia && (ra += "/"), na ? "/" + ra : ra;
    },
    isAbsolute: function(ra) {
      return Bi(ra), ra.length > 0 && ra.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var ra, na = 0; na < arguments.length; ++na) {
        var ia = arguments[na];
        Bi(ia), ia.length > 0 && (ra === void 0 ? ra = ia : ra += "/" + ia);
      }
      return ra === void 0 ? "." : Qi.normalize(ra);
    },
    relative: function(ra, na) {
      if (Bi(ra), Bi(na), ra === na || (ra = Qi.resolve(ra), na = Qi.resolve(na), ra === na)) return "";
      for (var ia = 1; ia < ra.length && ra.charCodeAt(ia) === 47; ++ia)
        ;
      for (var fa = ra.length, La = fa - ia, Va = 1; Va < na.length && na.charCodeAt(Va) === 47; ++Va)
        ;
      for (var to = na.length, ro = to - Va, no = La < ro ? La : ro, eo = -1, ao = 0; ao <= no; ++ao) {
        if (ao === no) {
          if (ro > no) {
            if (na.charCodeAt(Va + ao) === 47)
              return na.slice(Va + ao + 1);
            if (ao === 0)
              return na.slice(Va + ao);
          } else La > no && (ra.charCodeAt(ia + ao) === 47 ? eo = ao : ao === 0 && (eo = 0));
          break;
        }
        var io = ra.charCodeAt(ia + ao), xs = na.charCodeAt(Va + ao);
        if (io !== xs)
          break;
        io === 47 && (eo = ao);
      }
      var Ts = "";
      for (ao = ia + eo + 1; ao <= fa; ++ao)
        (ao === fa || ra.charCodeAt(ao) === 47) && (Ts.length === 0 ? Ts += ".." : Ts += "/..");
      return Ts.length > 0 ? Ts + na.slice(Va + eo) : (Va += eo, na.charCodeAt(Va) === 47 && ++Va, na.slice(Va));
    },
    _makeLong: function(ra) {
      return ra;
    },
    dirname: function(ra) {
      if (Bi(ra), ra.length === 0) return ".";
      for (var na = ra.charCodeAt(0), ia = na === 47, fa = -1, La = !0, Va = ra.length - 1; Va >= 1; --Va)
        if (na = ra.charCodeAt(Va), na === 47) {
          if (!La) {
            fa = Va;
            break;
          }
        } else
          La = !1;
      return fa === -1 ? ia ? "/" : "." : ia && fa === 1 ? "//" : ra.slice(0, fa);
    },
    basename: function(ra, na) {
      if (na !== void 0 && typeof na != "string") throw new TypeError('"ext" argument must be a string');
      Bi(ra);
      var ia = 0, fa = -1, La = !0, Va;
      if (na !== void 0 && na.length > 0 && na.length <= ra.length) {
        if (na.length === ra.length && na === ra) return "";
        var to = na.length - 1, ro = -1;
        for (Va = ra.length - 1; Va >= 0; --Va) {
          var no = ra.charCodeAt(Va);
          if (no === 47) {
            if (!La) {
              ia = Va + 1;
              break;
            }
          } else
            ro === -1 && (La = !1, ro = Va + 1), to >= 0 && (no === na.charCodeAt(to) ? --to === -1 && (fa = Va) : (to = -1, fa = ro));
        }
        return ia === fa ? fa = ro : fa === -1 && (fa = ra.length), ra.slice(ia, fa);
      } else {
        for (Va = ra.length - 1; Va >= 0; --Va)
          if (ra.charCodeAt(Va) === 47) {
            if (!La) {
              ia = Va + 1;
              break;
            }
          } else fa === -1 && (La = !1, fa = Va + 1);
        return fa === -1 ? "" : ra.slice(ia, fa);
      }
    },
    extname: function(ra) {
      Bi(ra);
      for (var na = -1, ia = 0, fa = -1, La = !0, Va = 0, to = ra.length - 1; to >= 0; --to) {
        var ro = ra.charCodeAt(to);
        if (ro === 47) {
          if (!La) {
            ia = to + 1;
            break;
          }
          continue;
        }
        fa === -1 && (La = !1, fa = to + 1), ro === 46 ? na === -1 ? na = to : Va !== 1 && (Va = 1) : na !== -1 && (Va = -1);
      }
      return na === -1 || fa === -1 || // We saw a non-dot character immediately before the dot
      Va === 0 || // The (right-most) trimmed path component is exactly '..'
      Va === 1 && na === fa - 1 && na === ia + 1 ? "" : ra.slice(na, fa);
    },
    format: function(ra) {
      if (ra === null || typeof ra != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof ra);
      return Zi("/", ra);
    },
    parse: function(ra) {
      Bi(ra);
      var na = { root: "", dir: "", base: "", ext: "", name: "" };
      if (ra.length === 0) return na;
      var ia = ra.charCodeAt(0), fa = ia === 47, La;
      fa ? (na.root = "/", La = 1) : La = 0;
      for (var Va = -1, to = 0, ro = -1, no = !0, eo = ra.length - 1, ao = 0; eo >= La; --eo) {
        if (ia = ra.charCodeAt(eo), ia === 47) {
          if (!no) {
            to = eo + 1;
            break;
          }
          continue;
        }
        ro === -1 && (no = !1, ro = eo + 1), ia === 46 ? Va === -1 ? Va = eo : ao !== 1 && (ao = 1) : Va !== -1 && (ao = -1);
      }
      return Va === -1 || ro === -1 || // We saw a non-dot character immediately before the dot
      ao === 0 || // The (right-most) trimmed path component is exactly '..'
      ao === 1 && Va === ro - 1 && Va === to + 1 ? ro !== -1 && (to === 0 && fa ? na.base = na.name = ra.slice(1, ro) : na.base = na.name = ra.slice(to, ro)) : (to === 0 && fa ? (na.name = ra.slice(1, Va), na.base = ra.slice(1, ro)) : (na.name = ra.slice(to, Va), na.base = ra.slice(to, ro)), na.ext = ra.slice(Va, ro)), to > 0 ? na.dir = ra.slice(0, to - 1) : fa && (na.dir = "/"), na;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return Qi.posix = Qi, pathBrowserify = Qi, pathBrowserify;
}
var pathBrowserifyExports = requirePathBrowserify();
const MenuItemStyle = cva([
  "dark:hover:bg-neutral-300",
  "dark:hover:text-neutral-700",
  "hover:bg-neutral-100",
  "p-1",
  "items-center",
  "gap-2",
  "whitespace-nowrap",
  "w-full",
  "flex",
  "text-left",
  "text-sm",
  "disabled:text-neutral-500",
  "disabled:hover:bg-none",
  "cursor-default"
]);
function MenuItem({ className: Bi = "", ...e }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx($3674c52c6b3c5bce$export$2ce376c2cc3355c8, { ...e, className: MenuItemStyle({}) });
}
const MenuStyle = cva([
  "bg-white",
  "text-black",
  "border-b",
  "border",
  "shadow-md",
  "p-2"
]);
function Menu({ children: Bi, button: e, className: Zi, isOpen: Qi, setOpen: ea }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs($3674c52c6b3c5bce$export$27d2ad3c5815583e, { isOpen: Qi, onOpenChange: ea, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx($d2b4bc8c273e7be6$export$353f5b6fc5456de1, { children: e || /* @__PURE__ */ jsxRuntimeExports.jsx(
      FontAwesomeIcon,
      {
        className: "dark:text-neutral-300 text-neutral-700",
        icon: faBars
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx($07b14b47974efb58$export$5b6b19405a83ff9d, { children: /* @__PURE__ */ jsxRuntimeExports.jsx($3674c52c6b3c5bce$export$d9b273488cd8ce6f, { className: twMerge(MenuStyle({}), Zi), children: Bi }) })
  ] });
}
const FileBrowserHeader = observer(
  ({
    store: Bi,
    homeDirectory: e,
    searchDisabled: Zi,
    searchBarExtras: Qi
  }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { className: "row-start-1 w-full", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-2 flex w-full gap-4 border border-black", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex w-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          disabled: Zi,
          value: Bi.searchQuery ?? "",
          onChange: (ea) => Bi.setSearchQuery(ea.target.value),
          className: "w-full p-1 rounded border-none h-6 my-auto flex-grow bg-white dark:bg-neutral-300 text-neutral-600 focus:outline-none",
          type: "text",
          placeholder: "search..."
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          $1e2864c73f66a4da$export$6fb4a10d2c950550,
          {
            onSelect: (ea) => {
              ea && Bi.onDrop(Array.from(ea));
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx($d2b4bc8c273e7be6$export$353f5b6fc5456de1, { className: MenuItemStyle(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(R, { size: 18 }) })
          }
        ),
        Qi && Qi(Bi.searchQuery ?? ""),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Menu, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuItem, { onAction: () => {
          Bi.setCreateFolderModalVisible(!0);
        }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(P$1, { size: 18 }),
          " Create Folder"
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300 hover:fill-neutral-300",
        onClick: () => Bi.popToRoot(),
        children: [
          e,
          "/"
        ]
      }
    ),
    Bi.currentPath.map((ea, ra) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300",
        onClick: () => {
          ra !== Bi.currentPath.length - 1 && Bi.popFolderHistoryToIndex(ra);
        },
        children: [
          pathBrowserifyExports.basename(ea),
          "/"
        ]
      },
      `${ea}-${ra}`
    ))
  ] })
);
function UploadToast({ files: Bi }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "m-2", children: "Uploading:" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { children: Bi.map((e) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "pl-4 list-none", children: e.name }, e.name)) })
  ] });
}
class FileBrowserStore {
  constructor(e) {
    cd(this, "searchQuery", null);
    cd(this, "currentPath", []);
    cd(this, "searchResults", null);
    cd(this, "createFolderModalVisible", !1);
    cd(this, "onSearch");
    cd(this, "onUpload");
    cd(this, "onNavigate");
    cd(this, "searchLoading", !1);
    e ? this.currentPath = e : this.currentPath = [], makeAutoObservable(this), this.onDrop = this.onDrop.bind(this), this.pushPathPart = this.pushPathPart.bind(this), this.setCreateFolderModalVisible = this.setCreateFolderModalVisible.bind(this), this.setSearchQuery = this.setSearchQuery.bind(this), this.popFolderHistory = this.popFolderHistory.bind(this), this.popFolderHistoryToIndex = this.popFolderHistoryToIndex.bind(this), this.setSearchResults = this.setSearchResults.bind(this);
  }
  setCreateFolderModalVisible(e) {
    this.createFolderModalVisible = e;
  }
  pushPathPart(e) {
    this.currentPath.push(e);
  }
  popFolderHistory() {
    this.currentPath.pop(), this.onNavigate?.(
      this.currentPath
    );
  }
  popToRoot() {
    this.currentPath = [], this.onNavigate?.([]);
  }
  popFolderHistoryToIndex(e) {
    this.currentPath = this.currentPath.slice(0, e + 1), this.onNavigate?.(
      this.currentPath
    );
  }
  async setSearchResults(e) {
    this.searchResults = e;
  }
  async setSearchQuery(e) {
    if (this.searchQuery = e, e) {
      if (!this.onSearch)
        return;
    } else {
      this.searchResults = null, this.searchLoading = !1;
      return;
    }
    this.onSearch(e);
  }
  // get currentFolderPath() {
  //     if (this.currentPath.length === 0) {
  //         return "";
  //     }
  //     // return this.folderHistory.reduce((acc, f) => acc + f, "");
  //     return this.currentPath[this.currentPath.length - 1];
  // }
  async onDrop(e) {
    if (e[0].size / (1024 * 1024 * 1024) > 1)
      throw toast("File cannot be bigger than 1GB"), new Error("File cannot be bigger than 1GB");
    if (this.onUpload)
      try {
        const ea = await this.onUpload(e);
        if (!ea)
          return;
        const ra = toast(/* @__PURE__ */ jsxRuntimeExports.jsx(UploadToast, { files: e }), {
          progress: 0
        });
        ea.subscribe({
          onProgress: (na) => {
            toast.update(ra, {
              progress: na
            });
          },
          onError: (na) => {
            toast.error("Something went wrong!: " + na.message);
          },
          onComplete: () => {
            toast.dismiss(ra);
          }
        });
      } catch (ea) {
        toast.error("Something went wrong!: " + ea);
      }
  }
}
function selectionIncludes(Bi, e) {
  return !!e.find(
    ({ path: Zi, isFolder: Qi }) => Bi.path === Zi && Qi === Bi.isFolder
  );
}
function getNewSelection(Bi, e, Zi) {
  switch (Zi) {
    case Re$2.ALL:
      return selectionIncludes(e, Bi) ? Bi.filter((Qi) => Qi.path !== e.path) : [...Bi, e];
    case Re$2.FILE:
      return e.isFolder ? Bi : selectionIncludes(e, Bi) ? [] : [e];
    case Re$2.DIR:
      return e.isFolder ? selectionIncludes(e, Bi) ? [] : [e] : Bi;
    case Re$2.FILE_LIST:
      return e.isFolder ? Bi : selectionIncludes(e, Bi) ? Bi.filter((Qi) => Qi.path !== e.path) : [...Bi, e];
    case Re$2.NONE:
    default:
      return Bi;
  }
}
const Spacer = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex-grow" });
function PathActions({
  onDelete: Bi,
  path: e,
  onPreview: Zi,
  onDownload: Qi,
  onMoveUpAFolder: ea,
  className: ra = "",
  isOpen: na,
  setOpen: ia
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Menu,
    {
      button: /* @__PURE__ */ jsxRuntimeExports.jsx(L, { className: ra, size: 18, "data-testid": `path-actions-${e.path}` }),
      isOpen: na,
      setOpen: ia,
      children: [
        !e.isFolder && Qi && /* @__PURE__ */ jsxRuntimeExports.jsx(
          MenuItem,
          {
            onAction: async () => {
              Qi(e);
            },
            children: "Download"
          }
        ),
        ea && /* @__PURE__ */ jsxRuntimeExports.jsx(
          MenuItem,
          {
            onAction: async () => {
              const fa = pathBrowserifyExports.dirname(pathBrowserifyExports.dirname(e.path)), La = pathBrowserifyExports.basename(e.path), Va = `${fa}/${La}`;
              ea(fa === "." ? null : { path: e, parent: fa, newPath: Va });
            },
            children: "Move Up a Folder"
          }
        ),
        Bi && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { onAction: () => Bi(), children: "Delete" }),
        !e.isFolder && Zi && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { onAction: () => Zi(e), children: "Preview" })
      ]
    }
  );
}
const containerStyles = cva(
  [
    "relative",
    "flex",
    "gap-2",
    "p-1",
    "select-none",
    "hover:bg-neutral-200",
    "dark:hover:bg-neutral-600",
    "items-center",
    "w-full",
    "group"
  ],
  {
    variants: {
      selected: {
        true: ["text-blue-500", "hover:after:h-0"],
        false: ["text-neutral-800", "dark:text-neutral-200"]
      },
      isOver: {
        true: ["bg-neutral-300", "dark:bg-neutral-600"],
        false: ["bg-transparent"]
      }
    }
  }
), S3Container = forwardRef(
  (Bi, e) => {
    const {
      children: Zi,
      selected: Qi,
      showCheckbox: ea = !0,
      style: ra,
      onCheckboxValueChange: na,
      onClick: ia,
      isOver: fa,
      path: La
    } = Bi;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      motion.div,
      {
        "data-testid": `file-${La}`,
        className: containerStyles({ selected: Qi, isOver: fa }),
        ref: e,
        style: ra,
        onClick: (Va) => {
          Va.stopPropagation, ia?.(Va);
        },
        layout: !0,
        children: [
          ea && /* @__PURE__ */ jsxRuntimeExports.jsx(
            CheckBox,
            {
              onClick: (Va) => Va.stopPropagation(),
              onChange: (Va) => {
                na(Va.currentTarget.checked);
              },
              className: "mr-2",
              checked: Qi
            }
          ),
          Zi
        ]
      }
    );
  }
), S3File = ({
  path: Bi,
  onClick: e,
  selected: Zi,
  readOnly: Qi = !1,
  showFullPath: ea = !1,
  onDelete: ra,
  style: na,
  onPreview: ia,
  onDownload: fa,
  onMoveUpAFolder: La,
  showCheckbox: Va = !0
}) => {
  const [, to] = useDrag({
    canDrag: !Qi,
    type: "S3File",
    item: { ...Bi },
    collect: (ao) => ({
      isDragging: ao.isDragging()
    })
  }), ro = pathBrowserifyExports.basename(Bi.path), [no, eo] = useState(!1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    S3Container,
    {
      path: Bi.path,
      style: { ...na },
      onClick: (ao) => {
        ao.stopPropagation();
      },
      showCheckbox: Va,
      onCheckboxValueChange: () => e(Bi),
      selected: Zi,
      ref: to,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(I, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col justify-around flex-shrink h-full overflow-hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: ea ? Bi.path : ro }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          PathActions,
          {
            className: `${no ? "" : "opacity-0 focus:opacity-100"} group-hover:opacity-100 focus:opacity-100`,
            onPreview: ia,
            path: Bi,
            onDelete: ra ? () => ra?.(Bi) : void 0,
            onMoveUpAFolder: La,
            onDownload: fa,
            isOpen: no,
            setOpen: eo
          }
        )
      ]
    }
  );
}, S3Folder = ({
  path: Bi,
  onClick: e,
  onDblClick: Zi,
  selected: Qi,
  onDrop: ea,
  readOnly: ra = !1,
  style: na,
  onDelete: ia,
  showActions: fa,
  onPreview: La,
  showFullPath: Va,
  showCheckbox: to = !0
}) => {
  const ro = li$1(
    () => {
    },
    () => Zi(Bi)
  ), [, no] = useDrag({
    canDrag: !ra,
    type: "S3Folder",
    item: { ...Bi },
    collect: (xs) => ({
      isDragging: xs.isDragging()
    })
  }), [eo] = useState(!1), [{ isOver: ao }, io] = useDrop({
    canDrop: () => !ra,
    accept: ["S3Folder", "S3File"],
    drop: (xs) => ea(xs),
    collect: (xs) => ({
      isOver: xs.isOver()
    })
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: io, style: na, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    S3Container,
    {
      path: Bi.path,
      selected: Qi,
      isOver: ao,
      onClick: (xs) => {
        xs.stopPropagation(), ro();
      },
      ref: no,
      showCheckbox: to,
      onCheckboxValueChange: () => e(Bi),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(w$1, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col justify-around h-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: Va ? Bi.path : pathBrowserifyExports.basename(Bi.path) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        fa && La && ia && eo && /* @__PURE__ */ jsxRuntimeExports.jsx(
          PathActions,
          {
            onPreview: La,
            path: Bi,
            onDelete: ia ? () => ia(Bi) : void 0
          }
        )
      ]
    }
  ) });
};
function useMobxPropSync(Bi, e) {
  useEffect(() => {
    for (const Zi in Bi)
      Bi.hasOwnProperty(Zi) && Bi[Zi] && (e[Zi] = Bi[Zi]);
  }, [Bi, e]);
}
const FileBrowser = observer(
  ({
    selectionMode: Bi = Re$2.NONE,
    // files,
    selection: e,
    onSelectionChange: Zi,
    readOnly: Qi = !1,
    className: ea,
    showActions: ra = !0,
    onDownload: na,
    onMoveUpAFolder: ia,
    style: fa,
    onPreview: La,
    onDelete: Va,
    onMove: to,
    onCreateFolder: ro,
    onSearch: no,
    searchDisabled: eo = !1,
    onNavigate: ao,
    filePathHomeDirectory: io = "~",
    onUpload: xs,
    searchBarExtras: Ts,
    getFiles: qs,
    path: Fs
  }) => {
    const Do = useLocalObservable(
      () => new FileBrowserStore(Fs)
    ), { getRootProps: ys, getInputProps: Io, isDragActive: so } = useDropzone({
      noClick: !0,
      onDrop: Do.onDrop
    }), os = useCallback(
      (wl) => getNewSelection(e, wl, Bi),
      [e, Bi]
    ), Xs = useCallback(async () => {
      Do.searchLoading = !0;
      const wl = Do.searchQuery;
      if (!no || !wl) {
        Do.searchLoading = !1;
        return;
      }
      Do.setSearchResults([]), setTimeout(async () => {
        if (Do.searchQuery === wl && wl) {
          const jl = await no(wl);
          if (!jl) return;
          Do.setSearchResults(jl), Do.searchLoading = !1;
        }
      }, 500);
    }, [no, Do.searchQuery]);
    useEffect(() => {
      Do.onSearch = Xs;
    }, [Xs]), useMobxPropSync(
      {
        onUpload: xs,
        onNavigate: ao,
        currentPath: Fs
      },
      Do
    );
    const gl = useQuery({
      queryKey: ["file-browser-files", ...Fs],
      queryFn: async () => await qs(Fs)
    }), Sl = Do.searchResults || gl.data || [], El = useRef(null);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: twMerge(
          "grid-rows-[2rem 1fr] box-border relative flex flex-col justify-start flex-grow w-full gap-2 overflow-auto text-neutral-800 bg-white",
          ea
        ),
        style: fa,
        ...ys(),
        children: [
          so && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              style: { zIndex: 999 },
              className: "w-full h-full absolute top-0 left-0 flex justify-center items-center z-[999] bg-opacity-20 text-orange-2 pointer-events-none bg-white text-4xl",
              children: "Drop files here"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("input", { className: "z-50 bg-purple-500", ...Io() }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            FileBrowserHeader,
            {
              searchDisabled: eo,
              selection: e,
              store: Do,
              homeDirectory: io,
              searchBarExtras: Ts
            }
          ) }),
          Bi !== Re$2.NONE && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mr-auto ml-1 flex items-center gap-2 text-neutral-400", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              CheckBox,
              {
                checked: e.length > 0,
                onChange: () => {
                  Sl && (e.length === 0 ? Zi?.([...e, ...Sl]) : Zi?.([]));
                }
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-xs", children: [
              e.length,
              " file",
              e.length !== 1 && "s",
              " selected"
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              ref: El,
              className: "relative flex-grow overflow-auto",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(DndProvider, { backend: HTML5Backend, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "row-start-2 row-span-1 flex-grow relative", children: [
                gl.isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-2 italic text-neutral-600", children: "Loading..." }) : null,
                Sl?.length === 0 && !Do.searchLoading && !gl.isLoading && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-2 italic text-neutral-600", children: "No files" }),
                Do.searchLoading && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-2 italic text-neutral-600", children: "Searching..." }),
                Sl && Sl.length > 0 && Sl.map((wl) => {
                  const jl = {
                    key: getKey(wl),
                    showActions: ra,
                    readOnly: Qi,
                    onDelete: Va ? () => {
                      Va([wl]), Zi?.([]);
                    } : void 0,
                    onClick: (kl) => {
                      const Fl = os(kl);
                      Zi?.(Fl);
                    },
                    showFullPath: !!Do.searchQuery,
                    // show full path if searching
                    path: wl,
                    selected: selectionIncludes(wl, e),
                    onPreview: La
                  };
                  return wl.isFolder ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                    S3Folder,
                    {
                      ...jl,
                      showCheckbox: Bi !== Re$2.NONE && Bi !== Re$2.FILE && Bi !== Re$2.FILE_LIST,
                      onDblClick: (kl) => {
                        const Fl = kl.path.split("/").filter(Boolean).pop();
                        Fl && (Do.pushPathPart(Fl), ao?.(
                          Do.currentPath
                        ));
                      },
                      onDrop: (kl) => to?.(kl, wl)
                    }
                  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                    S3File,
                    {
                      ...jl,
                      showCheckbox: Bi !== Re$2.NONE && Bi !== Re$2.DIR && Bi !== Re$2.DIR_LIST,
                      onMoveUpAFolder: ia,
                      onDownload: na
                    }
                  );
                })
              ] }) })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            CreateFolderModal,
            {
              visible: Do.createFolderModalVisible,
              onClose: () => Do.setCreateFolderModalVisible(!1),
              onCreateFolder: async (wl) => {
                ro?.(wl, Do.currentPath), Do.setCreateFolderModalVisible(!1);
              }
            }
          )
        ]
      }
    );
  }
), getKey = (Bi) => `${Bi.isFolder ? "folder" : "file"}-${Bi.path}`;
var us = Object.defineProperty, cs = (Bi, e, Zi) => e in Bi ? us(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: Zi }) : Bi[e] = Zi, mt = (Bi, e, Zi) => cs(Bi, e + "", Zi), Qr = function(Bi, e) {
  return Qr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zi, Qi) {
    Zi.__proto__ = Qi;
  } || function(Zi, Qi) {
    for (var ea in Qi) Object.prototype.hasOwnProperty.call(Qi, ea) && (Zi[ea] = Qi[ea]);
  }, Qr(Bi, e);
};
function ls(Bi, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Qr(Bi, e);
  function Zi() {
    this.constructor = Bi;
  }
  Bi.prototype = e === null ? Object.create(e) : (Zi.prototype = e.prototype, new Zi());
}
var Sr = "Invariant Violation", Gn = Object.setPrototypeOf, fs = Gn === void 0 ? function(Bi, e) {
  return Bi.__proto__ = e, Bi;
} : Gn, B = (
  /** @class */
  function(Bi) {
    ls(e, Bi);
    function e(Zi) {
      Zi === void 0 && (Zi = Sr);
      var Qi = Bi.call(this, typeof Zi == "number" ? Sr + ": " + Zi + " (see https://github.com/apollographql/invariant-packages)" : Zi) || this;
      return Qi.framesToPop = 1, Qi.name = Sr, fs(Qi, e.prototype), Qi;
    }
    return e;
  }(Error)
);
function E(Bi, e) {
  if (!Bi)
    throw new B(e);
}
var Gi = ["debug", "log", "warn", "error", "silent"], ds = Gi.indexOf("log");
function Ht(Bi) {
  return function() {
    if (Gi.indexOf(Bi) >= ds) {
      var e = console[Bi] || console.log;
      return e.apply(console, arguments);
    }
  };
}
(function(Bi) {
  Bi.debug = Ht("debug"), Bi.log = Ht("log"), Bi.warn = Ht("warn"), Bi.error = Ht("error");
})(E || (E = {}));
function he(Bi) {
  try {
    return Bi();
  } catch {
  }
}
const Jn = he(function() {
  return globalThis;
}) || he(function() {
  return window;
}) || he(function() {
  return self;
}) || he(function() {
  return global;
}) || he(function() {
  return he.constructor("return this")();
});
var Hn = "__", Yn = [Hn, Hn].join("DEV");
function hs() {
  try {
    return !!__DEV__;
  } catch {
    return Object.defineProperty(Jn, Yn, {
      value: he(function() {
        return process.env.NODE_ENV;
      }) !== "production",
      enumerable: !1,
      configurable: !0,
      writable: !0
    }), Jn[Yn];
  }
}
const Or = hs();
function Pe(Bi) {
  try {
    return Bi();
  } catch {
  }
}
var Br = Pe(function() {
  return globalThis;
}) || Pe(function() {
  return window;
}) || Pe(function() {
  return self;
}) || Pe(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Pe(function() {
  return Pe.constructor("return this")();
}), Zr = !1;
function ps() {
  Br && !Pe(function() {
    return process.env.NODE_ENV;
  }) && !Pe(function() {
    return process;
  }) && (Object.defineProperty(Br, "process", {
    value: {
      env: {
        // This default needs to be "production" instead of "development", to
        // avoid the problem https://github.com/graphql/graphql-js/pull/2894
        // will eventually solve, once merged and released.
        NODE_ENV: "production"
      }
    },
    // Let anyone else change global.process as they see fit, but hide it from
    // Object.keys(global) enumeration.
    configurable: !0,
    enumerable: !1,
    writable: !0
  }), Zr = !0);
}
ps();
function Kn() {
  Zr && (delete Br.process, Zr = !1);
}
var Ji = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function vs(Bi, e) {
  throw new Error("Unexpected invariant triggered.");
}
var Ur = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function Hi(Bi) {
  var e = Bi.prototype.toJSON;
  typeof e == "function" || vs(), Bi.prototype.inspect = e, Ur && (Bi.prototype[Ur] = e);
}
var ms = /* @__PURE__ */ function() {
  function Bi(Zi, Qi, ea) {
    this.start = Zi.start, this.end = Qi.end, this.startToken = Zi, this.endToken = Qi, this.source = ea;
  }
  var e = Bi.prototype;
  return e.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, Bi;
}();
Hi(ms);
var gs = /* @__PURE__ */ function() {
  function Bi(Zi, Qi, ea, ra, na, ia, fa) {
    this.kind = Zi, this.start = Qi, this.end = ea, this.line = ra, this.column = na, this.value = fa, this.prev = ia, this.next = null;
  }
  var e = Bi.prototype;
  return e.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, Bi;
}();
Hi(gs);
function Xn(Bi) {
  return Bi != null && typeof Bi.kind == "string";
}
function Xt(Bi) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xt = function(e) {
    return typeof e;
  } : Xt = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xt(Bi);
}
var bs = 10, Yi = 2;
function Ki(Bi) {
  return yr(Bi, []);
}
function yr(Bi, e) {
  switch (Xt(Bi)) {
    case "string":
      return JSON.stringify(Bi);
    case "function":
      return Bi.name ? "[function ".concat(Bi.name, "]") : "[function]";
    case "object":
      return Bi === null ? "null" : _s(Bi, e);
    default:
      return String(Bi);
  }
}
function _s(Bi, e) {
  if (e.indexOf(Bi) !== -1)
    return "[Circular]";
  var Zi = [].concat(e, [Bi]), Qi = Es(Bi);
  if (Qi !== void 0) {
    var ea = Qi.call(Bi);
    if (ea !== Bi)
      return typeof ea == "string" ? ea : yr(ea, Zi);
  } else if (Array.isArray(Bi))
    return ks(Bi, Zi);
  return ws(Bi, Zi);
}
function ws(Bi, e) {
  var Zi = Object.keys(Bi);
  if (Zi.length === 0)
    return "{}";
  if (e.length > Yi)
    return "[" + Ss(Bi) + "]";
  var Qi = Zi.map(function(ea) {
    var ra = yr(Bi[ea], e);
    return ea + ": " + ra;
  });
  return "{ " + Qi.join(", ") + " }";
}
function ks(Bi, e) {
  if (Bi.length === 0)
    return "[]";
  if (e.length > Yi)
    return "[Array]";
  for (var Zi = Math.min(bs, Bi.length), Qi = Bi.length - Zi, ea = [], ra = 0; ra < Zi; ++ra)
    ea.push(yr(Bi[ra], e));
  return Qi === 1 ? ea.push("... 1 more item") : Qi > 1 && ea.push("... ".concat(Qi, " more items")), "[" + ea.join(", ") + "]";
}
function Es(Bi) {
  var e = Bi[String(Ur)];
  if (typeof e == "function")
    return e;
  if (typeof Bi.inspect == "function")
    return Bi.inspect;
}
function Ss(Bi) {
  var e = Object.prototype.toString.call(Bi).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof Bi.constructor == "function") {
    var Zi = Bi.constructor.name;
    if (typeof Zi == "string" && Zi !== "")
      return Zi;
  }
  return e;
}
function Ds(Bi) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", Zi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Qi = Bi.indexOf(`
`) === -1, ea = Bi[0] === " " || Bi[0] === "	", ra = Bi[Bi.length - 1] === '"', na = Bi[Bi.length - 1] === "\\", ia = !Qi || ra || na || Zi, fa = "";
  return ia && !(Qi && ea) && (fa += `
` + e), fa += e ? Bi.replace(/\n/g, `
` + e) : Bi, ia && (fa += `
`), '"""' + fa.replace(/"""/g, '\\"""') + '"""';
}
var Is = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, gn = Object.freeze({});
function Te(Bi, e) {
  var Zi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Is, Qi = void 0, ea = Array.isArray(Bi), ra = [Bi], na = -1, ia = [], fa = void 0, La = void 0, Va = void 0, to = [], ro = [], no = Bi;
  do {
    na++;
    var eo = na === ra.length, ao = eo && ia.length !== 0;
    if (eo) {
      if (La = ro.length === 0 ? void 0 : to[to.length - 1], fa = Va, Va = ro.pop(), ao) {
        if (ea)
          fa = fa.slice();
        else {
          for (var io = {}, xs = 0, Ts = Object.keys(fa); xs < Ts.length; xs++) {
            var qs = Ts[xs];
            io[qs] = fa[qs];
          }
          fa = io;
        }
        for (var Fs = 0, Do = 0; Do < ia.length; Do++) {
          var ys = ia[Do][0], Io = ia[Do][1];
          ea && (ys -= Fs), ea && Io === null ? (fa.splice(ys, 1), Fs++) : fa[ys] = Io;
        }
      }
      na = Qi.index, ra = Qi.keys, ia = Qi.edits, ea = Qi.inArray, Qi = Qi.prev;
    } else {
      if (La = Va ? ea ? na : ra[na] : void 0, fa = Va ? Va[La] : no, fa == null)
        continue;
      Va && to.push(La);
    }
    var so = void 0;
    if (!Array.isArray(fa)) {
      if (!Xn(fa))
        throw new Error("Invalid AST Node: ".concat(Ki(fa), "."));
      var os = Rs(e, fa.kind, eo);
      if (os) {
        if (so = os.call(e, fa, La, Va, to, ro), so === gn)
          break;
        if (so === !1) {
          if (!eo) {
            to.pop();
            continue;
          }
        } else if (so !== void 0 && (ia.push([La, so]), !eo))
          if (Xn(so))
            fa = so;
          else {
            to.pop();
            continue;
          }
      }
    }
    if (so === void 0 && ao && ia.push([La, fa]), eo)
      to.pop();
    else {
      var Xs;
      Qi = {
        inArray: ea,
        index: na,
        keys: ra,
        edits: ia,
        prev: Qi
      }, ea = Array.isArray(fa), ra = ea ? fa : (Xs = Zi[fa.kind]) !== null && Xs !== void 0 ? Xs : [], na = -1, ia = [], Va && ro.push(Va), Va = fa;
    }
  } while (Qi !== void 0);
  return ia.length !== 0 && (no = ia[ia.length - 1][1]), no;
}
function Rs(Bi, e, Zi) {
  var Qi = Bi[e];
  if (Qi) {
    if (!Zi && typeof Qi == "function")
      return Qi;
    var ea = Zi ? Qi.leave : Qi.enter;
    if (typeof ea == "function")
      return ea;
  } else {
    var ra = Zi ? Bi.leave : Bi.enter;
    if (ra) {
      if (typeof ra == "function")
        return ra;
      var na = ra[e];
      if (typeof na == "function")
        return na;
    }
  }
}
function Xi(Bi) {
  return Te(Bi, {
    leave: Cs
  });
}
var js = 80, Cs = {
  Name: function(Bi) {
    return Bi.value;
  },
  Variable: function(Bi) {
    return "$" + Bi.name;
  },
  // Document
  Document: function(Bi) {
    return x(Bi.definitions, `

`) + `
`;
  },
  OperationDefinition: function(Bi) {
    var e = Bi.operation, Zi = Bi.name, Qi = J("(", x(Bi.variableDefinitions, ", "), ")"), ea = x(Bi.directives, " "), ra = Bi.selectionSet;
    return !Zi && !ea && !Qi && e === "query" ? ra : x([e, x([Zi, Qi]), ea, ra], " ");
  },
  VariableDefinition: function(Bi) {
    var e = Bi.variable, Zi = Bi.type, Qi = Bi.defaultValue, ea = Bi.directives;
    return e + ": " + Zi + J(" = ", Qi) + J(" ", x(ea, " "));
  },
  SelectionSet: function(Bi) {
    var e = Bi.selections;
    return ye(e);
  },
  Field: function(Bi) {
    var e = Bi.alias, Zi = Bi.name, Qi = Bi.arguments, ea = Bi.directives, ra = Bi.selectionSet, na = J("", e, ": ") + Zi, ia = na + J("(", x(Qi, ", "), ")");
    return ia.length > js && (ia = na + J(`(
`, er(x(Qi, `
`)), `
)`)), x([ia, x(ea, " "), ra], " ");
  },
  Argument: function(Bi) {
    var e = Bi.name, Zi = Bi.value;
    return e + ": " + Zi;
  },
  // Fragments
  FragmentSpread: function(Bi) {
    var e = Bi.name, Zi = Bi.directives;
    return "..." + e + J(" ", x(Zi, " "));
  },
  InlineFragment: function(Bi) {
    var e = Bi.typeCondition, Zi = Bi.directives, Qi = Bi.selectionSet;
    return x(["...", J("on ", e), x(Zi, " "), Qi], " ");
  },
  FragmentDefinition: function(Bi) {
    var e = Bi.name, Zi = Bi.typeCondition, Qi = Bi.variableDefinitions, ea = Bi.directives, ra = Bi.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(e).concat(J("(", x(Qi, ", "), ")"), " ") + "on ".concat(Zi, " ").concat(J("", x(ea, " "), " ")) + ra
    );
  },
  // Value
  IntValue: function(Bi) {
    var e = Bi.value;
    return e;
  },
  FloatValue: function(Bi) {
    var e = Bi.value;
    return e;
  },
  StringValue: function(Bi, e) {
    var Zi = Bi.value, Qi = Bi.block;
    return Qi ? Ds(Zi, e === "description" ? "" : "  ") : JSON.stringify(Zi);
  },
  BooleanValue: function(Bi) {
    var e = Bi.value;
    return e ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(Bi) {
    var e = Bi.value;
    return e;
  },
  ListValue: function(Bi) {
    var e = Bi.values;
    return "[" + x(e, ", ") + "]";
  },
  ObjectValue: function(Bi) {
    var e = Bi.fields;
    return "{" + x(e, ", ") + "}";
  },
  ObjectField: function(Bi) {
    var e = Bi.name, Zi = Bi.value;
    return e + ": " + Zi;
  },
  // Directive
  Directive: function(Bi) {
    var e = Bi.name, Zi = Bi.arguments;
    return "@" + e + J("(", x(Zi, ", "), ")");
  },
  // Type
  NamedType: function(Bi) {
    var e = Bi.name;
    return e;
  },
  ListType: function(Bi) {
    var e = Bi.type;
    return "[" + e + "]";
  },
  NonNullType: function(Bi) {
    var e = Bi.type;
    return e + "!";
  },
  // Type System Definitions
  SchemaDefinition: pe(function(Bi) {
    var e = Bi.directives, Zi = Bi.operationTypes;
    return x(["schema", x(e, " "), ye(Zi)], " ");
  }),
  OperationTypeDefinition: function(Bi) {
    var e = Bi.operation, Zi = Bi.type;
    return e + ": " + Zi;
  },
  ScalarTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Zi = Bi.directives;
    return x(["scalar", e, x(Zi, " ")], " ");
  }),
  ObjectTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Zi = Bi.interfaces, Qi = Bi.directives, ea = Bi.fields;
    return x(["type", e, J("implements ", x(Zi, " & ")), x(Qi, " "), ye(ea)], " ");
  }),
  FieldDefinition: pe(function(Bi) {
    var e = Bi.name, Zi = Bi.arguments, Qi = Bi.type, ea = Bi.directives;
    return e + (ei(Zi) ? J(`(
`, er(x(Zi, `
`)), `
)`) : J("(", x(Zi, ", "), ")")) + ": " + Qi + J(" ", x(ea, " "));
  }),
  InputValueDefinition: pe(function(Bi) {
    var e = Bi.name, Zi = Bi.type, Qi = Bi.defaultValue, ea = Bi.directives;
    return x([e + ": " + Zi, J("= ", Qi), x(ea, " ")], " ");
  }),
  InterfaceTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Zi = Bi.interfaces, Qi = Bi.directives, ea = Bi.fields;
    return x(["interface", e, J("implements ", x(Zi, " & ")), x(Qi, " "), ye(ea)], " ");
  }),
  UnionTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Zi = Bi.directives, Qi = Bi.types;
    return x(["union", e, x(Zi, " "), Qi && Qi.length !== 0 ? "= " + x(Qi, " | ") : ""], " ");
  }),
  EnumTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Zi = Bi.directives, Qi = Bi.values;
    return x(["enum", e, x(Zi, " "), ye(Qi)], " ");
  }),
  EnumValueDefinition: pe(function(Bi) {
    var e = Bi.name, Zi = Bi.directives;
    return x([e, x(Zi, " ")], " ");
  }),
  InputObjectTypeDefinition: pe(function(Bi) {
    var e = Bi.name, Zi = Bi.directives, Qi = Bi.fields;
    return x(["input", e, x(Zi, " "), ye(Qi)], " ");
  }),
  DirectiveDefinition: pe(function(Bi) {
    var e = Bi.name, Zi = Bi.arguments, Qi = Bi.repeatable, ea = Bi.locations;
    return "directive @" + e + (ei(Zi) ? J(`(
`, er(x(Zi, `
`)), `
)`) : J("(", x(Zi, ", "), ")")) + (Qi ? " repeatable" : "") + " on " + x(ea, " | ");
  }),
  SchemaExtension: function(Bi) {
    var e = Bi.directives, Zi = Bi.operationTypes;
    return x(["extend schema", x(e, " "), ye(Zi)], " ");
  },
  ScalarTypeExtension: function(Bi) {
    var e = Bi.name, Zi = Bi.directives;
    return x(["extend scalar", e, x(Zi, " ")], " ");
  },
  ObjectTypeExtension: function(Bi) {
    var e = Bi.name, Zi = Bi.interfaces, Qi = Bi.directives, ea = Bi.fields;
    return x(["extend type", e, J("implements ", x(Zi, " & ")), x(Qi, " "), ye(ea)], " ");
  },
  InterfaceTypeExtension: function(Bi) {
    var e = Bi.name, Zi = Bi.interfaces, Qi = Bi.directives, ea = Bi.fields;
    return x(["extend interface", e, J("implements ", x(Zi, " & ")), x(Qi, " "), ye(ea)], " ");
  },
  UnionTypeExtension: function(Bi) {
    var e = Bi.name, Zi = Bi.directives, Qi = Bi.types;
    return x(["extend union", e, x(Zi, " "), Qi && Qi.length !== 0 ? "= " + x(Qi, " | ") : ""], " ");
  },
  EnumTypeExtension: function(Bi) {
    var e = Bi.name, Zi = Bi.directives, Qi = Bi.values;
    return x(["extend enum", e, x(Zi, " "), ye(Qi)], " ");
  },
  InputObjectTypeExtension: function(Bi) {
    var e = Bi.name, Zi = Bi.directives, Qi = Bi.fields;
    return x(["extend input", e, x(Zi, " "), ye(Qi)], " ");
  }
};
function pe(Bi) {
  return function(e) {
    return x([e.description, Bi(e)], `
`);
  };
}
function x(Bi) {
  var e, Zi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (e = Bi?.filter(function(Qi) {
    return Qi;
  }).join(Zi)) !== null && e !== void 0 ? e : "";
}
function ye(Bi) {
  return J(`{
`, er(x(Bi, `
`)), `
}`);
}
function J(Bi, e) {
  var Zi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return e != null && e !== "" ? Bi + e + Zi : "";
}
function er(Bi) {
  return J("  ", Bi.replace(/\n/g, `
  `));
}
function As(Bi) {
  return Bi.indexOf(`
`) !== -1;
}
function ei(Bi) {
  return Bi != null && Bi.some(As);
}
function Ns() {
  return Kn();
}
function Ps() {
  __DEV__ ? E(typeof Or == "boolean", Or) : E(typeof Or == "boolean", 38);
}
Ns();
Ps();
var zr = function(Bi, e) {
  return zr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Zi, Qi) {
    Zi.__proto__ = Qi;
  } || function(Zi, Qi) {
    for (var ea in Qi) Object.prototype.hasOwnProperty.call(Qi, ea) && (Zi[ea] = Qi[ea]);
  }, zr(Bi, e);
};
function be(Bi, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  zr(Bi, e);
  function Zi() {
    this.constructor = Bi;
  }
  Bi.prototype = e === null ? Object.create(e) : (Zi.prototype = e.prototype, new Zi());
}
var y = function() {
  return y = Object.assign || function(Bi) {
    for (var e, Zi = 1, Qi = arguments.length; Zi < Qi; Zi++) {
      e = arguments[Zi];
      for (var ea in e) Object.prototype.hasOwnProperty.call(e, ea) && (Bi[ea] = e[ea]);
    }
    return Bi;
  }, y.apply(this, arguments);
};
function lt(Bi, e) {
  var Zi = {};
  for (var Qi in Bi) Object.prototype.hasOwnProperty.call(Bi, Qi) && e.indexOf(Qi) < 0 && (Zi[Qi] = Bi[Qi]);
  if (Bi != null && typeof Object.getOwnPropertySymbols == "function")
    for (var ea = 0, Qi = Object.getOwnPropertySymbols(Bi); ea < Qi.length; ea++)
      e.indexOf(Qi[ea]) < 0 && Object.prototype.propertyIsEnumerable.call(Bi, Qi[ea]) && (Zi[Qi[ea]] = Bi[Qi[ea]]);
  return Zi;
}
function Fe(Bi, e, Zi, Qi) {
  function ea(ra) {
    return ra instanceof Zi ? ra : new Zi(function(na) {
      na(ra);
    });
  }
  return new (Zi || (Zi = Promise))(function(ra, na) {
    function ia(Va) {
      try {
        La(Qi.next(Va));
      } catch (to) {
        na(to);
      }
    }
    function fa(Va) {
      try {
        La(Qi.throw(Va));
      } catch (to) {
        na(to);
      }
    }
    function La(Va) {
      Va.done ? ra(Va.value) : ea(Va.value).then(ia, fa);
    }
    La((Qi = Qi.apply(Bi, [])).next());
  });
}
function Me(Bi, e) {
  var Zi = { label: 0, sent: function() {
    if (ra[0] & 1) throw ra[1];
    return ra[1];
  }, trys: [], ops: [] }, Qi, ea, ra, na;
  return na = { next: ia(0), throw: ia(1), return: ia(2) }, typeof Symbol == "function" && (na[Symbol.iterator] = function() {
    return this;
  }), na;
  function ia(La) {
    return function(Va) {
      return fa([La, Va]);
    };
  }
  function fa(La) {
    if (Qi) throw new TypeError("Generator is already executing.");
    for (; Zi; ) try {
      if (Qi = 1, ea && (ra = La[0] & 2 ? ea.return : La[0] ? ea.throw || ((ra = ea.return) && ra.call(ea), 0) : ea.next) && !(ra = ra.call(ea, La[1])).done) return ra;
      switch (ea = 0, ra && (La = [La[0] & 2, ra.value]), La[0]) {
        case 0:
        case 1:
          ra = La;
          break;
        case 4:
          return Zi.label++, { value: La[1], done: !1 };
        case 5:
          Zi.label++, ea = La[1], La = [0];
          continue;
        case 7:
          La = Zi.ops.pop(), Zi.trys.pop();
          continue;
        default:
          if (ra = Zi.trys, !(ra = ra.length > 0 && ra[ra.length - 1]) && (La[0] === 6 || La[0] === 2)) {
            Zi = 0;
            continue;
          }
          if (La[0] === 3 && (!ra || La[1] > ra[0] && La[1] < ra[3])) {
            Zi.label = La[1];
            break;
          }
          if (La[0] === 6 && Zi.label < ra[1]) {
            Zi.label = ra[1], ra = La;
            break;
          }
          if (ra && Zi.label < ra[2]) {
            Zi.label = ra[2], Zi.ops.push(La);
            break;
          }
          ra[2] && Zi.ops.pop(), Zi.trys.pop();
          continue;
      }
      La = e.call(Bi, Zi);
    } catch (Va) {
      La = [6, Va], ea = 0;
    } finally {
      Qi = ra = 0;
    }
    if (La[0] & 5) throw La[1];
    return { value: La[0] ? La[1] : void 0, done: !0 };
  }
}
function ir(Bi, e, Zi) {
  if (Zi || arguments.length === 2) for (var Qi = 0, ea = e.length, ra; Qi < ea; Qi++)
    (ra || !(Qi in e)) && (ra || (ra = Array.prototype.slice.call(e, 0, Qi)), ra[Qi] = e[Qi]);
  return Bi.concat(ra || Array.prototype.slice.call(e));
}
function vr(Bi, e) {
  var Zi = Bi.directives;
  return !Zi || !Zi.length ? !0 : Vs(Zi).every(function(Qi) {
    var ea = Qi.directive, ra = Qi.ifArgument, na = !1;
    return ra.value.kind === "Variable" ? (na = e && e[ra.value.name.value], __DEV__ ? E(na !== void 0, "Invalid variable referenced in @".concat(ea.name.value, " directive.")) : E(na !== void 0, 39)) : na = ra.value.value, ea.name.value === "skip" ? !na : na;
  });
}
function bn(Bi, e, Zi) {
  var Qi = new Set(Bi), ea = Qi.size;
  return Te(e, {
    Directive: function(ra) {
      if (Qi.delete(ra.name.value) && !Zi)
        return gn;
    }
  }), Zi ? !Qi.size : Qi.size < ea;
}
function Ms(Bi) {
  var e = Bi.name.value;
  return e === "skip" || e === "include";
}
function Vs(Bi) {
  var e = [];
  return Bi && Bi.length && Bi.forEach(function(Zi) {
    if (Ms(Zi)) {
      var Qi = Zi.arguments, ea = Zi.name.value;
      __DEV__ ? E(Qi && Qi.length === 1, "Incorrect number of arguments for the @".concat(ea, " directive.")) : E(Qi && Qi.length === 1, 40);
      var ra = Qi[0];
      __DEV__ ? E(ra.name && ra.name.value === "if", "Invalid argument for the @".concat(ea, " directive.")) : E(ra.name && ra.name.value === "if", 41);
      var na = ra.value;
      __DEV__ ? E(na && (na.kind === "Variable" || na.kind === "BooleanValue"), "Argument for the @".concat(ea, " directive must be a variable or a boolean value.")) : E(na && (na.kind === "Variable" || na.kind === "BooleanValue"), 42), e.push({ directive: Zi, ifArgument: ra });
    }
  }), e;
}
function Ls(Bi, e) {
  var Zi = e, Qi = [];
  Bi.definitions.forEach(function(ra) {
    if (ra.kind === "OperationDefinition")
      throw __DEV__ ? new B("Found a ".concat(ra.operation, " operation").concat(ra.name ? " named '".concat(ra.name.value, "'") : "", ". ") + "No operations are allowed when using a fragment as a query. Only fragments are allowed.") : new B(43);
    ra.kind === "FragmentDefinition" && Qi.push(ra);
  }), typeof Zi > "u" && (__DEV__ ? E(Qi.length === 1, "Found ".concat(Qi.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : E(Qi.length === 1, 44), Zi = Qi[0].name.value);
  var ea = y(y({}, Bi), { definitions: ir([
    {
      kind: "OperationDefinition",
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: Zi
            }
          }
        ]
      }
    }
  ], Bi.definitions, !0) });
  return ea;
}
function _n(Bi) {
  Bi === void 0 && (Bi = []);
  var e = {};
  return Bi.forEach(function(Zi) {
    e[Zi.name.value] = Zi;
  }), e;
}
function wn(Bi, e) {
  switch (Bi.kind) {
    case "InlineFragment":
      return Bi;
    case "FragmentSpread": {
      var Zi = Bi.name.value;
      if (typeof e == "function")
        return e(Zi);
      var Qi = e && e[Zi];
      return __DEV__ ? E(Qi, "No fragment named ".concat(Zi)) : E(Qi, 45), Qi || null;
    }
    default:
      return null;
  }
}
function Y(Bi) {
  return Bi !== null && typeof Bi == "object";
}
function ot(Bi) {
  return { __ref: String(Bi) };
}
function U(Bi) {
  return !!(Bi && typeof Bi == "object" && typeof Bi.__ref == "string");
}
function Qs(Bi) {
  return Bi.kind === "StringValue";
}
function Bs(Bi) {
  return Bi.kind === "BooleanValue";
}
function Zs(Bi) {
  return Bi.kind === "IntValue";
}
function Us(Bi) {
  return Bi.kind === "FloatValue";
}
function zs(Bi) {
  return Bi.kind === "Variable";
}
function $s(Bi) {
  return Bi.kind === "ObjectValue";
}
function Ws(Bi) {
  return Bi.kind === "ListValue";
}
function Gs(Bi) {
  return Bi.kind === "EnumValue";
}
function Js(Bi) {
  return Bi.kind === "NullValue";
}
function ft(Bi, e, Zi, Qi) {
  if (Zs(Zi) || Us(Zi))
    Bi[e.value] = Number(Zi.value);
  else if (Bs(Zi) || Qs(Zi))
    Bi[e.value] = Zi.value;
  else if ($s(Zi)) {
    var ea = {};
    Zi.fields.map(function(na) {
      return ft(ea, na.name, na.value, Qi);
    }), Bi[e.value] = ea;
  } else if (zs(Zi)) {
    var ra = (Qi || {})[Zi.name.value];
    Bi[e.value] = ra;
  } else if (Ws(Zi))
    Bi[e.value] = Zi.values.map(function(na) {
      var ia = {};
      return ft(ia, e, na, Qi), ia[e.value];
    });
  else if (Gs(Zi))
    Bi[e.value] = Zi.value;
  else if (Js(Zi))
    Bi[e.value] = null;
  else
    throw __DEV__ ? new B('The inline argument "'.concat(e.value, '" of kind "').concat(Zi.kind, '"') + "is not supported. Use variables instead of inline arguments to overcome this limitation.") : new B(54);
}
function Hs(Bi, e) {
  var Zi = null;
  Bi.directives && (Zi = {}, Bi.directives.forEach(function(ea) {
    Zi[ea.name.value] = {}, ea.arguments && ea.arguments.forEach(function(ra) {
      var na = ra.name, ia = ra.value;
      return ft(Zi[ea.name.value], na, ia, e);
    });
  }));
  var Qi = null;
  return Bi.arguments && Bi.arguments.length && (Qi = {}, Bi.arguments.forEach(function(ea) {
    var ra = ea.name, na = ea.value;
    return ft(Qi, ra, na, e);
  })), kn(Bi.name.value, Qi, Zi);
}
var Ys = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export"
], kn = Object.assign(function(Bi, e, Zi) {
  if (e && Zi && Zi.connection && Zi.connection.key)
    if (Zi.connection.filter && Zi.connection.filter.length > 0) {
      var Qi = Zi.connection.filter ? Zi.connection.filter : [];
      Qi.sort();
      var ea = {};
      return Qi.forEach(function(ia) {
        ea[ia] = e[ia];
      }), "".concat(Zi.connection.key, "(").concat(gt(ea), ")");
    } else
      return Zi.connection.key;
  var ra = Bi;
  if (e) {
    var na = gt(e);
    ra += "(".concat(na, ")");
  }
  return Zi && Object.keys(Zi).forEach(function(ia) {
    Ys.indexOf(ia) === -1 && (Zi[ia] && Object.keys(Zi[ia]).length ? ra += "@".concat(ia, "(").concat(gt(Zi[ia]), ")") : ra += "@".concat(ia));
  }), ra;
}, {
  setStringify: function(Bi) {
    var e = gt;
    return gt = Bi, e;
  }
}), gt = function(Bi) {
  return JSON.stringify(Bi, Ks);
};
function Ks(Bi, e) {
  return Y(e) && !Array.isArray(e) && (e = Object.keys(e).sort().reduce(function(Zi, Qi) {
    return Zi[Qi] = e[Qi], Zi;
  }, {})), e;
}
function mr(Bi, e) {
  if (Bi.arguments && Bi.arguments.length) {
    var Zi = {};
    return Bi.arguments.forEach(function(Qi) {
      var ea = Qi.name, ra = Qi.value;
      return ft(Zi, ea, ra, e);
    }), Zi;
  }
  return null;
}
function Je(Bi) {
  return Bi.alias ? Bi.alias.value : Bi.name.value;
}
function $r(Bi, e, Zi) {
  if (typeof Bi.__typename == "string")
    return Bi.__typename;
  for (var Qi = 0, ea = e.selections; Qi < ea.length; Qi++) {
    var ra = ea[Qi];
    if (je(ra)) {
      if (ra.name.value === "__typename")
        return Bi[Je(ra)];
    } else {
      var na = $r(Bi, wn(ra, Zi).selectionSet, Zi);
      if (typeof na == "string")
        return na;
    }
  }
}
function je(Bi) {
  return Bi.kind === "Field";
}
function gr(Bi) {
  __DEV__ ? E(Bi && Bi.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : E(Bi && Bi.kind === "Document", 46);
  var e = Bi.definitions.filter(function(Zi) {
    return Zi.kind !== "FragmentDefinition";
  }).map(function(Zi) {
    if (Zi.kind !== "OperationDefinition")
      throw __DEV__ ? new B('Schema type definitions not allowed in queries. Found: "'.concat(Zi.kind, '"')) : new B(47);
    return Zi;
  });
  return __DEV__ ? E(e.length <= 1, "Ambiguous GraphQL document: contains ".concat(e.length, " operations")) : E(e.length <= 1, 48), Bi;
}
function zt(Bi) {
  return gr(Bi), Bi.definitions.filter(function(e) {
    return e.kind === "OperationDefinition";
  })[0];
}
function Wr(Bi) {
  return Bi.definitions.filter(function(e) {
    return e.kind === "OperationDefinition" && e.name;
  }).map(function(e) {
    return e.name.value;
  })[0] || null;
}
function En(Bi) {
  return Bi.definitions.filter(function(e) {
    return e.kind === "FragmentDefinition";
  });
}
function ta(Bi) {
  var e = zt(Bi);
  return __DEV__ ? E(e && e.operation === "query", "Must contain a query definition.") : E(e && e.operation === "query", 49), e;
}
function br(Bi) {
  gr(Bi);
  for (var e, Zi = 0, Qi = Bi.definitions; Zi < Qi.length; Zi++) {
    var ea = Qi[Zi];
    if (ea.kind === "OperationDefinition") {
      var ra = ea.operation;
      if (ra === "query" || ra === "mutation" || ra === "subscription")
        return ea;
    }
    ea.kind === "FragmentDefinition" && !e && (e = ea);
  }
  if (e)
    return e;
  throw __DEV__ ? new B("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.") : new B(53);
}
function Sn(Bi) {
  var e = /* @__PURE__ */ Object.create(null), Zi = Bi && Bi.variableDefinitions;
  return Zi && Zi.length && Zi.forEach(function(Qi) {
    Qi.defaultValue && ft(e, Qi.variable.name, Qi.defaultValue);
  }), e;
}
var ri = {
  kind: "Field",
  name: {
    kind: "Name",
    value: "__typename"
  }
}, xn = Object.assign(function(Bi) {
  return Te(Bi, {
    SelectionSet: {
      enter: function(e, Zi, Qi) {
        if (!(Qi && Qi.kind === "OperationDefinition")) {
          var ea = e.selections;
          if (ea) {
            var ra = ea.some(function(ia) {
              return je(ia) && (ia.name.value === "__typename" || ia.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!ra) {
              var na = Qi;
              if (!(je(na) && na.directives && na.directives.some(function(ia) {
                return ia.name.value === "export";
              })))
                return y(y({}, e), { selections: ir(ir([], ea, !0), [ri], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(Bi) {
    return Bi === ri;
  }
}), oo = Object.prototype.hasOwnProperty;
function Tn(Bi) {
  var e = Bi[0] || {}, Zi = Bi.length;
  if (Zi > 1)
    for (var Qi = new He(), ea = 1; ea < Zi; ++ea)
      e = Qi.merge(e, Bi[ea]);
  return e;
}
var uo = function(Bi, e, Zi) {
  return this.merge(Bi[Zi], e[Zi]);
}, He = function() {
  function Bi(e) {
    e === void 0 && (e = uo), this.reconciler = e, this.isObject = Y, this.pastCopies = /* @__PURE__ */ new Set();
  }
  return Bi.prototype.merge = function(e, Zi) {
    for (var Qi = this, ea = [], ra = 2; ra < arguments.length; ra++)
      ea[ra - 2] = arguments[ra];
    return Y(Zi) && Y(e) ? (Object.keys(Zi).forEach(function(na) {
      if (oo.call(e, na)) {
        var ia = e[na];
        if (Zi[na] !== ia) {
          var fa = Qi.reconciler.apply(Qi, ir([e, Zi, na], ea, !1));
          fa !== ia && (e = Qi.shallowCopyForMerge(e), e[na] = fa);
        }
      } else
        e = Qi.shallowCopyForMerge(e), e[na] = Zi[na];
    }), e) : Zi;
  }, Bi.prototype.shallowCopyForMerge = function(e) {
    return Y(e) && (this.pastCopies.has(e) || (Array.isArray(e) ? e = e.slice(0) : e = y({ __proto__: Object.getPrototypeOf(e) }, e), this.pastCopies.add(e))), e;
  }, Bi;
}();
function co(Bi, e) {
  var Zi = typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (Zi) return (Zi = Zi.call(Bi)).next.bind(Zi);
  if (Array.isArray(Bi) || (Zi = lo(Bi)) || e) {
    Zi && (Bi = Zi);
    var Qi = 0;
    return function() {
      return Qi >= Bi.length ? { done: !0 } : { done: !1, value: Bi[Qi++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lo(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return ai(Bi, e);
    var Zi = Object.prototype.toString.call(Bi).slice(8, -1);
    if (Zi === "Object" && Bi.constructor && (Zi = Bi.constructor.name), Zi === "Map" || Zi === "Set") return Array.from(Bi);
    if (Zi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Zi)) return ai(Bi, e);
  }
}
function ai(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var Zi = 0, Qi = new Array(e); Zi < e; Zi++)
    Qi[Zi] = Bi[Zi];
  return Qi;
}
function si(Bi, e) {
  for (var Zi = 0; Zi < e.length; Zi++) {
    var Qi = e[Zi];
    Qi.enumerable = Qi.enumerable || !1, Qi.configurable = !0, "value" in Qi && (Qi.writable = !0), Object.defineProperty(Bi, Qi.key, Qi);
  }
}
function Dn(Bi, e, Zi) {
  return e && si(Bi.prototype, e), Zi && si(Bi, Zi), Object.defineProperty(Bi, "prototype", { writable: !1 }), Bi;
}
var In = function() {
  return typeof Symbol == "function";
}, Rn = function(Bi) {
  return In() && !!Symbol[Bi];
}, jn = function(Bi) {
  return Rn(Bi) ? Symbol[Bi] : "@@" + Bi;
};
In() && !Rn("observable") && (Symbol.observable = Symbol("observable"));
var fo = jn("iterator"), Gr = jn("observable"), aa = jn("species");
function ar(Bi, e) {
  var Zi = Bi[e];
  if (Zi != null) {
    if (typeof Zi != "function") throw new TypeError(Zi + " is not a function");
    return Zi;
  }
}
function bt(Bi) {
  var e = Bi.constructor;
  return e !== void 0 && (e = e[aa], e === null && (e = void 0)), e !== void 0 ? e : G;
}
function ho(Bi) {
  return Bi instanceof G;
}
function dt(Bi) {
  dt.log ? dt.log(Bi) : setTimeout(function() {
    throw Bi;
  });
}
function tr(Bi) {
  Promise.resolve().then(function() {
    try {
      Bi();
    } catch (e) {
      dt(e);
    }
  });
}
function sa(Bi) {
  var e = Bi._cleanup;
  if (e !== void 0 && (Bi._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var Zi = ar(e, "unsubscribe");
        Zi && Zi.call(e);
      }
    } catch (Qi) {
      dt(Qi);
    }
}
function Jr(Bi) {
  Bi._observer = void 0, Bi._queue = void 0, Bi._state = "closed";
}
function po(Bi) {
  var e = Bi._queue;
  if (e) {
    Bi._queue = void 0, Bi._state = "ready";
    for (var Zi = 0; Zi < e.length && (oa(Bi, e[Zi].type, e[Zi].value), Bi._state !== "closed"); ++Zi)
      ;
  }
}
function oa(Bi, e, Zi) {
  Bi._state = "running";
  var Qi = Bi._observer;
  try {
    var ea = ar(Qi, e);
    switch (e) {
      case "next":
        ea && ea.call(Qi, Zi);
        break;
      case "error":
        if (Jr(Bi), ea) ea.call(Qi, Zi);
        else throw Zi;
        break;
      case "complete":
        Jr(Bi), ea && ea.call(Qi);
        break;
    }
  } catch (ra) {
    dt(ra);
  }
  Bi._state === "closed" ? sa(Bi) : Bi._state === "running" && (Bi._state = "ready");
}
function Tr(Bi, e, Zi) {
  if (Bi._state !== "closed") {
    if (Bi._state === "buffering") {
      Bi._queue.push({
        type: e,
        value: Zi
      });
      return;
    }
    if (Bi._state !== "ready") {
      Bi._state = "buffering", Bi._queue = [{
        type: e,
        value: Zi
      }], tr(function() {
        return po(Bi);
      });
      return;
    }
    oa(Bi, e, Zi);
  }
}
var yo = /* @__PURE__ */ function() {
  function Bi(Zi, Qi) {
    this._cleanup = void 0, this._observer = Zi, this._queue = void 0, this._state = "initializing";
    var ea = new vo(this);
    try {
      this._cleanup = Qi.call(void 0, ea);
    } catch (ra) {
      ea.error(ra);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = Bi.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (Jr(this), sa(this));
  }, Dn(Bi, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), Bi;
}(), vo = /* @__PURE__ */ function() {
  function Bi(Zi) {
    this._subscription = Zi;
  }
  var e = Bi.prototype;
  return e.next = function(Zi) {
    Tr(this._subscription, "next", Zi);
  }, e.error = function(Zi) {
    Tr(this._subscription, "error", Zi);
  }, e.complete = function() {
    Tr(this._subscription, "complete");
  }, Dn(Bi, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), Bi;
}(), G = /* @__PURE__ */ function() {
  function Bi(Zi) {
    if (!(this instanceof Bi)) throw new TypeError("Observable cannot be called as a function");
    if (typeof Zi != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = Zi;
  }
  var e = Bi.prototype;
  return e.subscribe = function(Zi) {
    return (typeof Zi != "object" || Zi === null) && (Zi = {
      next: Zi,
      error: arguments[1],
      complete: arguments[2]
    }), new yo(Zi, this._subscriber);
  }, e.forEach = function(Zi) {
    var Qi = this;
    return new Promise(function(ea, ra) {
      if (typeof Zi != "function") {
        ra(new TypeError(Zi + " is not a function"));
        return;
      }
      function na() {
        ia.unsubscribe(), ea();
      }
      var ia = Qi.subscribe({
        next: function(fa) {
          try {
            Zi(fa, na);
          } catch (La) {
            ra(La), ia.unsubscribe();
          }
        },
        error: ra,
        complete: ea
      });
    });
  }, e.map = function(Zi) {
    var Qi = this;
    if (typeof Zi != "function") throw new TypeError(Zi + " is not a function");
    var ea = bt(this);
    return new ea(function(ra) {
      return Qi.subscribe({
        next: function(na) {
          try {
            na = Zi(na);
          } catch (ia) {
            return ra.error(ia);
          }
          ra.next(na);
        },
        error: function(na) {
          ra.error(na);
        },
        complete: function() {
          ra.complete();
        }
      });
    });
  }, e.filter = function(Zi) {
    var Qi = this;
    if (typeof Zi != "function") throw new TypeError(Zi + " is not a function");
    var ea = bt(this);
    return new ea(function(ra) {
      return Qi.subscribe({
        next: function(na) {
          try {
            if (!Zi(na)) return;
          } catch (ia) {
            return ra.error(ia);
          }
          ra.next(na);
        },
        error: function(na) {
          ra.error(na);
        },
        complete: function() {
          ra.complete();
        }
      });
    });
  }, e.reduce = function(Zi) {
    var Qi = this;
    if (typeof Zi != "function") throw new TypeError(Zi + " is not a function");
    var ea = bt(this), ra = arguments.length > 1, na = !1, ia = arguments[1], fa = ia;
    return new ea(function(La) {
      return Qi.subscribe({
        next: function(Va) {
          var to = !na;
          if (na = !0, !to || ra)
            try {
              fa = Zi(fa, Va);
            } catch (ro) {
              return La.error(ro);
            }
          else
            fa = Va;
        },
        error: function(Va) {
          La.error(Va);
        },
        complete: function() {
          if (!na && !ra) return La.error(new TypeError("Cannot reduce an empty sequence"));
          La.next(fa), La.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var Zi = this, Qi = arguments.length, ea = new Array(Qi), ra = 0; ra < Qi; ra++)
      ea[ra] = arguments[ra];
    var na = bt(this);
    return new na(function(ia) {
      var fa, La = 0;
      function Va(to) {
        fa = to.subscribe({
          next: function(ro) {
            ia.next(ro);
          },
          error: function(ro) {
            ia.error(ro);
          },
          complete: function() {
            La === ea.length ? (fa = void 0, ia.complete()) : Va(na.from(ea[La++]));
          }
        });
      }
      return Va(Zi), function() {
        fa && (fa.unsubscribe(), fa = void 0);
      };
    });
  }, e.flatMap = function(Zi) {
    var Qi = this;
    if (typeof Zi != "function") throw new TypeError(Zi + " is not a function");
    var ea = bt(this);
    return new ea(function(ra) {
      var na = [], ia = Qi.subscribe({
        next: function(La) {
          if (Zi)
            try {
              La = Zi(La);
            } catch (to) {
              return ra.error(to);
            }
          var Va = ea.from(La).subscribe({
            next: function(to) {
              ra.next(to);
            },
            error: function(to) {
              ra.error(to);
            },
            complete: function() {
              var to = na.indexOf(Va);
              to >= 0 && na.splice(to, 1), fa();
            }
          });
          na.push(Va);
        },
        error: function(La) {
          ra.error(La);
        },
        complete: function() {
          fa();
        }
      });
      function fa() {
        ia.closed && na.length === 0 && ra.complete();
      }
      return function() {
        na.forEach(function(La) {
          return La.unsubscribe();
        }), ia.unsubscribe();
      };
    });
  }, e[Gr] = function() {
    return this;
  }, Bi.from = function(Zi) {
    var Qi = typeof this == "function" ? this : Bi;
    if (Zi == null) throw new TypeError(Zi + " is not an object");
    var ea = ar(Zi, Gr);
    if (ea) {
      var ra = ea.call(Zi);
      if (Object(ra) !== ra) throw new TypeError(ra + " is not an object");
      return ho(ra) && ra.constructor === Qi ? ra : new Qi(function(na) {
        return ra.subscribe(na);
      });
    }
    if (Rn("iterator") && (ea = ar(Zi, fo), ea))
      return new Qi(function(na) {
        tr(function() {
          if (!na.closed) {
            for (var ia = co(ea.call(Zi)), fa; !(fa = ia()).done; ) {
              var La = fa.value;
              if (na.next(La), na.closed) return;
            }
            na.complete();
          }
        });
      });
    if (Array.isArray(Zi))
      return new Qi(function(na) {
        tr(function() {
          if (!na.closed) {
            for (var ia = 0; ia < Zi.length; ++ia)
              if (na.next(Zi[ia]), na.closed) return;
            na.complete();
          }
        });
      });
    throw new TypeError(Zi + " is not observable");
  }, Bi.of = function() {
    for (var Zi = arguments.length, Qi = new Array(Zi), ea = 0; ea < Zi; ea++)
      Qi[ea] = arguments[ea];
    var ra = typeof this == "function" ? this : Bi;
    return new ra(function(na) {
      tr(function() {
        if (!na.closed) {
          for (var ia = 0; ia < Qi.length; ++ia)
            if (na.next(Qi[ia]), na.closed) return;
          na.complete();
        }
      });
    });
  }, Dn(Bi, null, [{
    key: aa,
    get: function() {
      return this;
    }
  }]), Bi;
}();
In() && Object.defineProperty(G, Symbol("extensions"), {
  value: {
    symbol: Gr,
    hostReportError: dt
  },
  configurable: !0
});
function mo(Bi) {
  var e, Zi = Bi.Symbol;
  if (typeof Zi == "function")
    if (Zi.observable)
      e = Zi.observable;
    else {
      typeof Zi.for == "function" ? e = Zi.for("https://github.com/benlesh/symbol-observable") : e = Zi("https://github.com/benlesh/symbol-observable");
      try {
        Zi.observable = e;
      } catch {
      }
    }
  else
    e = "@@observable";
  return e;
}
var rt;
typeof self < "u" ? rt = self : typeof window < "u" ? rt = window : typeof global < "u" ? rt = global : typeof module < "u" ? rt = module : rt = Function("return this")();
mo(rt);
var oi = G.prototype, ui = "@@observable";
oi[ui] || (oi[ui] = function() {
  return this;
});
var go = Object.prototype.toString;
function Cn(Bi) {
  return Hr(Bi);
}
function Hr(Bi, e) {
  switch (go.call(Bi)) {
    case "[object Array]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(Bi))
        return e.get(Bi);
      var Zi = Bi.slice(0);
      return e.set(Bi, Zi), Zi.forEach(function(ea, ra) {
        Zi[ra] = Hr(ea, e);
      }), Zi;
    }
    case "[object Object]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(Bi))
        return e.get(Bi);
      var Qi = Object.create(Object.getPrototypeOf(Bi));
      return e.set(Bi, Qi), Object.keys(Bi).forEach(function(ea) {
        Qi[ea] = Hr(Bi[ea], e);
      }), Qi;
    }
    default:
      return Bi;
  }
}
function bo(Bi) {
  var e = /* @__PURE__ */ new Set([Bi]);
  return e.forEach(function(Zi) {
    Y(Zi) && _o(Zi) === Zi && Object.getOwnPropertyNames(Zi).forEach(function(Qi) {
      Y(Zi[Qi]) && e.add(Zi[Qi]);
    });
  }), Bi;
}
function _o(Bi) {
  if (__DEV__ && !Object.isFrozen(Bi))
    try {
      Object.freeze(Bi);
    } catch (e) {
      if (e instanceof TypeError)
        return null;
      throw e;
    }
  return Bi;
}
function Yr(Bi) {
  return __DEV__ && bo(Bi), Bi;
}
function xt(Bi, e, Zi) {
  var Qi = [];
  Bi.forEach(function(ea) {
    return ea[e] && Qi.push(ea);
  }), Qi.forEach(function(ea) {
    return ea[e](Zi);
  });
}
var et = typeof WeakMap == "function" && he(function() {
  return navigator.product;
}) !== "ReactNative", wo = typeof WeakSet == "function", ua = typeof Symbol == "function" && typeof Symbol.for == "function", _r = ua && Symbol.asyncIterator;
he(function() {
  return window.document.createElement;
});
he(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function ca(Bi) {
  function e(Zi) {
    Object.defineProperty(Bi, Zi, { value: G });
  }
  return ua && Symbol.species && e(Symbol.species), e("@@species"), Bi;
}
function ci(Bi) {
  return Bi && typeof Bi.then == "function";
}
var Et = function(Bi) {
  be(e, Bi);
  function e(Zi) {
    var Qi = Bi.call(this, function(ea) {
      return Qi.addObserver(ea), function() {
        return Qi.removeObserver(ea);
      };
    }) || this;
    return Qi.observers = /* @__PURE__ */ new Set(), Qi.promise = new Promise(function(ea, ra) {
      Qi.resolve = ea, Qi.reject = ra;
    }), Qi.handlers = {
      next: function(ea) {
        Qi.sub !== null && (Qi.latest = ["next", ea], Qi.notify("next", ea), xt(Qi.observers, "next", ea));
      },
      error: function(ea) {
        var ra = Qi.sub;
        ra !== null && (ra && setTimeout(function() {
          return ra.unsubscribe();
        }), Qi.sub = null, Qi.latest = ["error", ea], Qi.reject(ea), Qi.notify("error", ea), xt(Qi.observers, "error", ea));
      },
      complete: function() {
        var ea = Qi.sub;
        if (ea !== null) {
          var ra = Qi.sources.shift();
          ra ? ci(ra) ? ra.then(function(na) {
            return Qi.sub = na.subscribe(Qi.handlers);
          }) : Qi.sub = ra.subscribe(Qi.handlers) : (ea && setTimeout(function() {
            return ea.unsubscribe();
          }), Qi.sub = null, Qi.latest && Qi.latest[0] === "next" ? Qi.resolve(Qi.latest[1]) : Qi.resolve(), Qi.notify("complete"), xt(Qi.observers, "complete"));
        }
      }
    }, Qi.nextResultListeners = /* @__PURE__ */ new Set(), Qi.cancel = function(ea) {
      Qi.reject(ea), Qi.sources = [], Qi.handlers.complete();
    }, Qi.promise.catch(function(ea) {
    }), typeof Zi == "function" && (Zi = [new G(Zi)]), ci(Zi) ? Zi.then(function(ea) {
      return Qi.start(ea);
    }, Qi.handlers.error) : Qi.start(Zi), Qi;
  }
  return e.prototype.start = function(Zi) {
    this.sub === void 0 && (this.sources = Array.from(Zi), this.handlers.complete());
  }, e.prototype.deliverLastMessage = function(Zi) {
    if (this.latest) {
      var Qi = this.latest[0], ea = Zi[Qi];
      ea && ea.call(Zi, this.latest[1]), this.sub === null && Qi === "next" && Zi.complete && Zi.complete();
    }
  }, e.prototype.addObserver = function(Zi) {
    this.observers.has(Zi) || (this.deliverLastMessage(Zi), this.observers.add(Zi));
  }, e.prototype.removeObserver = function(Zi) {
    this.observers.delete(Zi) && this.observers.size < 1 && this.handlers.complete();
  }, e.prototype.notify = function(Zi, Qi) {
    var ea = this.nextResultListeners;
    ea.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), ea.forEach(function(ra) {
      return ra(Zi, Qi);
    }));
  }, e.prototype.beforeNext = function(Zi) {
    var Qi = !1;
    this.nextResultListeners.add(function(ea, ra) {
      Qi || (Qi = !0, Zi(ea, ra));
    });
  }, e;
}(G);
ca(Et);
function Ee(Bi) {
  return Array.isArray(Bi) && Bi.length > 0;
}
function wr() {
  for (var Bi = [], e = 0; e < arguments.length; e++)
    Bi[e] = arguments[e];
  var Zi = /* @__PURE__ */ Object.create(null);
  return Bi.forEach(function(Qi) {
    Qi && Object.keys(Qi).forEach(function(ea) {
      var ra = Qi[ea];
      ra !== void 0 && (Zi[ea] = ra);
    });
  }), Zi;
}
var li = /* @__PURE__ */ new Map();
function Kr(Bi) {
  var e = li.get(Bi) || 1;
  return li.set(Bi, e + 1), "".concat(Bi, ":").concat(e, ":").concat(Math.random().toString(36).slice(2));
}
function ko(Bi) {
  var e = Kr("stringifyForDisplay");
  return JSON.stringify(Bi, function(Zi, Qi) {
    return Qi === void 0 ? e : Qi;
  }).split(JSON.stringify(e)).join("<undefined>");
}
function fi(Bi) {
  return new G(function(e) {
    e.error(Bi);
  });
}
var Xr = function(Bi, e, Zi) {
  var Qi = new Error(Zi);
  throw Qi.name = "ServerError", Qi.response = Bi, Qi.statusCode = Bi.status, Qi.result = e, Qi;
};
function Eo(Bi) {
  for (var e = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], Zi = 0, Qi = Object.keys(Bi); Zi < Qi.length; Zi++) {
    var ea = Qi[Zi];
    if (e.indexOf(ea) < 0)
      throw __DEV__ ? new B("illegal argument: ".concat(ea)) : new B(26);
  }
  return Bi;
}
function So(Bi, e) {
  var Zi = y({}, Bi), Qi = function(ra) {
    typeof ra == "function" ? Zi = y(y({}, Zi), ra(Zi)) : Zi = y(y({}, Zi), ra);
  }, ea = function() {
    return y({}, Zi);
  };
  return Object.defineProperty(e, "setContext", {
    enumerable: !1,
    value: Qi
  }), Object.defineProperty(e, "getContext", {
    enumerable: !1,
    value: ea
  }), e;
}
function Oo(Bi) {
  var e = {
    variables: Bi.variables || {},
    extensions: Bi.extensions || {},
    operationName: Bi.operationName,
    query: Bi.query
  };
  return e.operationName || (e.operationName = typeof e.query != "string" ? Wr(e.query) || void 0 : ""), e;
}
function di(Bi, e) {
  return e ? e(Bi) : G.of();
}
function _t(Bi) {
  return typeof Bi == "function" ? new Ue(Bi) : Bi;
}
function Yt(Bi) {
  return Bi.request.length <= 1;
}
var xo = function(Bi) {
  be(e, Bi);
  function e(Zi, Qi) {
    var ea = Bi.call(this, Zi) || this;
    return ea.link = Qi, ea;
  }
  return e;
}(Error), Ue = function() {
  function Bi(e) {
    e && (this.request = e);
  }
  return Bi.empty = function() {
    return new Bi(function() {
      return G.of();
    });
  }, Bi.from = function(e) {
    return e.length === 0 ? Bi.empty() : e.map(_t).reduce(function(Zi, Qi) {
      return Zi.concat(Qi);
    });
  }, Bi.split = function(e, Zi, Qi) {
    var ea = _t(Zi), ra = _t(Qi || new Bi(di));
    return Yt(ea) && Yt(ra) ? new Bi(function(na) {
      return e(na) ? ea.request(na) || G.of() : ra.request(na) || G.of();
    }) : new Bi(function(na, ia) {
      return e(na) ? ea.request(na, ia) || G.of() : ra.request(na, ia) || G.of();
    });
  }, Bi.execute = function(e, Zi) {
    return e.request(So(Zi.context, Oo(Eo(Zi)))) || G.of();
  }, Bi.concat = function(e, Zi) {
    var Qi = _t(e);
    if (Yt(Qi))
      return __DEV__ && E.warn(new xo("You are calling concat on a terminating link, which will have no effect", Qi)), Qi;
    var ea = _t(Zi);
    return Yt(ea) ? new Bi(function(ra) {
      return Qi.request(ra, function(na) {
        return ea.request(na) || G.of();
      }) || G.of();
    }) : new Bi(function(ra, na) {
      return Qi.request(ra, function(ia) {
        return ea.request(ia, na) || G.of();
      }) || G.of();
    });
  }, Bi.prototype.split = function(e, Zi, Qi) {
    return this.concat(Bi.split(e, Zi, Qi || new Bi(di)));
  }, Bi.prototype.concat = function(e) {
    return Bi.concat(this, e);
  }, Bi.prototype.request = function(e, Zi) {
    throw __DEV__ ? new B("request is not implemented") : new B(21);
  }, Bi.prototype.onError = function(e, Zi) {
    if (Zi && Zi.error)
      return Zi.error(e), !1;
    throw e;
  }, Bi.prototype.setOnError = function(e) {
    return this.onError = e, this;
  }, Bi;
}();
Ue.from;
Ue.split;
Ue.execute;
function Ro(Bi) {
  return !!Bi.body;
}
function jo(Bi) {
  return !!Bi.getReader;
}
function Co(Bi) {
  return !!(_r && Bi[Symbol.asyncIterator]);
}
function Ao(Bi) {
  return !!Bi.stream;
}
function No(Bi) {
  return !!Bi.arrayBuffer;
}
function Po(Bi) {
  return !!Bi.pipe;
}
function Fo(Bi) {
  var e, Zi = Bi[Symbol.asyncIterator]();
  return e = {
    next: function() {
      return Zi.next();
    }
  }, e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
}
function Mo(Bi) {
  var e = null, Zi = null, Qi = !1, ea = [], ra = [];
  function na(to) {
    if (!Zi) {
      if (ra.length) {
        var ro = ra.shift();
        if (Array.isArray(ro) && ro[0])
          return ro[0]({ value: to, done: !1 });
      }
      ea.push(to);
    }
  }
  function ia(to) {
    Zi = to;
    var ro = ra.slice();
    ro.forEach(function(no) {
      no[1](to);
    }), !e || e();
  }
  function fa() {
    Qi = !0;
    var to = ra.slice();
    to.forEach(function(ro) {
      ro[0]({ value: void 0, done: !0 });
    }), !e || e();
  }
  e = function() {
    e = null, Bi.removeListener("data", na), Bi.removeListener("error", ia), Bi.removeListener("end", fa), Bi.removeListener("finish", fa), Bi.removeListener("close", fa);
  }, Bi.on("data", na), Bi.on("error", ia), Bi.on("end", fa), Bi.on("finish", fa), Bi.on("close", fa);
  function La() {
    return new Promise(function(to, ro) {
      if (Zi)
        return ro(Zi);
      if (ea.length)
        return to({ value: ea.shift(), done: !1 });
      if (Qi)
        return to({ value: void 0, done: !0 });
      ra.push([to, ro]);
    });
  }
  var Va = {
    next: function() {
      return La();
    }
  };
  return _r && (Va[Symbol.asyncIterator] = function() {
    return this;
  }), Va;
}
function Vo(Bi) {
  var e = !1, Zi = {
    next: function() {
      return e ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (e = !0, new Promise(function(Qi, ea) {
        Bi.then(function(ra) {
          Qi({ value: ra, done: !1 });
        }).catch(ea);
      }));
    }
  };
  return _r && (Zi[Symbol.asyncIterator] = function() {
    return this;
  }), Zi;
}
function hi(Bi) {
  var e = {
    next: function() {
      return Bi.read();
    }
  };
  return _r && (e[Symbol.asyncIterator] = function() {
    return this;
  }), e;
}
function Lo(Bi) {
  var e = Bi;
  if (Ro(Bi) && (e = Bi.body), Co(e))
    return Fo(e);
  if (jo(e))
    return hi(e.getReader());
  if (Ao(e))
    return hi(e.stream().getReader());
  if (No(e))
    return Vo(e.arrayBuffer());
  if (Po(e))
    return Mo(e);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var pi = Object.prototype.hasOwnProperty;
function qo(Bi, e) {
  var Zi, Qi, ea;
  return Fe(this, void 0, void 0, function() {
    var ra, na, ia, fa, La, Va, to, ro, no, eo, ao, io, xs, Ts, qs, Fs, Do, ys, Io, so;
    return Me(this, function(os) {
      switch (os.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          ra = new TextDecoder("utf-8"), na = (Zi = Bi.headers) === null || Zi === void 0 ? void 0 : Zi.get("content-type"), ia = "boundary=", fa = na != null && na.includes(ia) ? na?.substring(na?.indexOf(ia) + ia.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", La = "--".concat(fa), Va = "", to = Lo(Bi), ro = !0, os.label = 1;
        case 1:
          return ro ? [4, to.next()] : [3, 3];
        case 2:
          for (no = os.sent(), eo = no.value, ao = no.done, io = typeof eo == "string" ? eo : ra.decode(eo), ro = !ao, Va += io, xs = Va.indexOf(La); xs > -1; ) {
            if (Ts = void 0, so = [
              Va.slice(0, xs),
              Va.slice(xs + La.length)
            ], Ts = so[0], Va = so[1], Ts.trim()) {
              if (qs = Ts.indexOf(`\r
\r
`), Fs = Qo(Ts.slice(0, qs)), Do = Fs["content-type"], Do && Do.toLowerCase().indexOf("application/json") === -1)
                throw new Error("Unsupported patch content type: application/json is required.");
              ys = Ts.slice(qs);
              try {
                Io = la(Bi, ys.replace(`\r
`, "")), (Object.keys(Io).length > 1 || "data" in Io || "incremental" in Io || "errors" in Io) && ((Qi = e.next) === null || Qi === void 0 || Qi.call(e, Io));
              } catch (Xs) {
                An(Xs, e);
              }
            }
            xs = Va.indexOf(La);
          }
          return [3, 1];
        case 3:
          return (ea = e.complete) === null || ea === void 0 || ea.call(e), [2];
      }
    });
  });
}
function Qo(Bi) {
  var e = {};
  return Bi.split(`
`).forEach(function(Zi) {
    var Qi = Zi.indexOf(":");
    if (Qi > -1) {
      var ea = Zi.slice(0, Qi).trim().toLowerCase(), ra = Zi.slice(Qi + 1).trim();
      e[ea] = ra;
    }
  }), e;
}
function la(Bi, e) {
  if (Bi.status >= 300) {
    var Zi = function() {
      try {
        return JSON.parse(e);
      } catch {
        return e;
      }
    };
    Xr(Bi, Zi(), "Response not successful: Received status code ".concat(Bi.status));
  }
  try {
    return JSON.parse(e);
  } catch (ea) {
    var Qi = ea;
    throw Qi.name = "ServerParseError", Qi.response = Bi, Qi.statusCode = Bi.status, Qi.bodyText = e, Qi;
  }
}
function An(Bi, e) {
  var Zi, Qi;
  Bi.name !== "AbortError" && (Bi.result && Bi.result.errors && Bi.result.data && ((Zi = e.next) === null || Zi === void 0 || Zi.call(e, Bi.result)), (Qi = e.error) === null || Qi === void 0 || Qi.call(e, Bi));
}
function Bo(Bi, e, Zi) {
  Zo(e)(Bi).then(function(Qi) {
    var ea, ra;
    (ea = Zi.next) === null || ea === void 0 || ea.call(Zi, Qi), (ra = Zi.complete) === null || ra === void 0 || ra.call(Zi);
  }).catch(function(Qi) {
    return An(Qi, Zi);
  });
}
function Zo(Bi) {
  return function(e) {
    return e.text().then(function(Zi) {
      return la(e, Zi);
    }).then(function(Zi) {
      return e.status >= 300 && Xr(e, Zi, "Response not successful: Received status code ".concat(e.status)), !Array.isArray(Zi) && !pi.call(Zi, "data") && !pi.call(Zi, "errors") && Xr(e, Zi, "Server response was missing for query '".concat(Array.isArray(Bi) ? Bi.map(function(Qi) {
        return Qi.operationName;
      }) : Bi.operationName, "'.")), Zi;
    });
  };
}
var tn = function(Bi, e) {
  var Zi;
  try {
    Zi = JSON.stringify(Bi);
  } catch (ea) {
    var Qi = __DEV__ ? new B("Network request failed. ".concat(e, " is not serializable: ").concat(ea.message)) : new B(23);
    throw Qi.parseError = ea, Qi;
  }
  return Zi;
}, Uo = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, zo = {
  accept: "*/*",
  "content-type": "application/json"
}, $o = {
  method: "POST"
}, Wo = {
  http: Uo,
  headers: zo,
  options: $o
}, Go = function(Bi, e) {
  return e(Bi);
};
function Jo(Bi, e) {
  for (var Zi = [], Qi = 2; Qi < arguments.length; Qi++)
    Zi[Qi - 2] = arguments[Qi];
  var ea = {}, ra = {};
  Zi.forEach(function(to) {
    ea = y(y(y({}, ea), to.options), { headers: y(y({}, ea.headers), to.headers) }), to.credentials && (ea.credentials = to.credentials), ra = y(y({}, ra), to.http);
  }), ea.headers = Ho(ea.headers, ra.preserveHeaderCase);
  var na = Bi.operationName, ia = Bi.extensions, fa = Bi.variables, La = Bi.query, Va = { operationName: na, variables: fa };
  return ra.includeExtensions && (Va.extensions = ia), ra.includeQuery && (Va.query = e(La, Xi)), {
    options: ea,
    body: Va
  };
}
function Ho(Bi, e) {
  if (!e) {
    var Zi = /* @__PURE__ */ Object.create(null);
    return Object.keys(Object(Bi)).forEach(function(ra) {
      Zi[ra.toLowerCase()] = Bi[ra];
    }), Zi;
  }
  var Qi = /* @__PURE__ */ Object.create(null);
  Object.keys(Object(Bi)).forEach(function(ra) {
    Qi[ra.toLowerCase()] = { originalName: ra, value: Bi[ra] };
  });
  var ea = /* @__PURE__ */ Object.create(null);
  return Object.keys(Qi).forEach(function(ra) {
    ea[Qi[ra].originalName] = Qi[ra].value;
  }), ea;
}
var Yo = function(Bi) {
  if (!Bi && typeof fetch > "u")
    throw __DEV__ ? new B(`
"fetch" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:

import fetch from 'cross-fetch';
import { ApolloClient, HttpLink } from '@apollo/client';
const client = new ApolloClient({
  link: new HttpLink({ uri: '/graphql', fetch })
});
    `) : new B(22);
}, Ko = function() {
  if (typeof AbortController > "u")
    return { controller: !1, signal: !1 };
  var Bi = new AbortController(), e = Bi.signal;
  return { controller: Bi, signal: e };
}, Xo = function(Bi, e) {
  var Zi = Bi.getContext(), Qi = Zi.uri;
  return Qi || (typeof e == "function" ? e(Bi) : e || "/graphql");
};
function eu(Bi, e) {
  var Zi = [], Qi = function(to, ro) {
    Zi.push("".concat(to, "=").concat(encodeURIComponent(ro)));
  };
  if ("query" in e && Qi("query", e.query), e.operationName && Qi("operationName", e.operationName), e.variables) {
    var ea = void 0;
    try {
      ea = tn(e.variables, "Variables map");
    } catch (to) {
      return { parseError: to };
    }
    Qi("variables", ea);
  }
  if (e.extensions) {
    var ra = void 0;
    try {
      ra = tn(e.extensions, "Extensions map");
    } catch (to) {
      return { parseError: to };
    }
    Qi("extensions", ra);
  }
  var na = "", ia = Bi, fa = Bi.indexOf("#");
  fa !== -1 && (na = Bi.substr(fa), ia = Bi.substr(0, fa));
  var La = ia.indexOf("?") === -1 ? "?" : "&", Va = ia + La + Zi.join("&") + na;
  return { newURI: Va };
}
var yi = he(function() {
  return fetch;
}), tu = function(Bi) {
  Bi === void 0 && (Bi = {});
  var e = Bi.uri, Zi = e === void 0 ? "/graphql" : e, Qi = Bi.fetch, ea = Bi.print, ra = ea === void 0 ? Go : ea, na = Bi.includeExtensions, ia = Bi.preserveHeaderCase, fa = Bi.useGETForQueries, La = Bi.includeUnusedVariables, Va = La === void 0 ? !1 : La, to = lt(Bi, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  __DEV__ && Yo(Qi || yi);
  var ro = {
    http: { includeExtensions: na, preserveHeaderCase: ia },
    options: to.fetchOptions,
    credentials: to.credentials,
    headers: to.headers
  };
  return new Ue(function(no) {
    var eo = Xo(no, Zi), ao = no.getContext(), io = {};
    if (ao.clientAwareness) {
      var xs = ao.clientAwareness, Ts = xs.name, qs = xs.version;
      Ts && (io["apollographql-client-name"] = Ts), qs && (io["apollographql-client-version"] = qs);
    }
    var Fs = y(y({}, io), ao.headers), Do = {
      http: ao.http,
      options: ao.fetchOptions,
      credentials: ao.credentials,
      headers: Fs
    }, ys = Jo(no, ra, Wo, ro, Do), Io = ys.options, so = ys.body;
    if (so.variables && !Va) {
      var os = new Set(Object.keys(so.variables));
      Te(no.query, {
        Variable: function(Ml, ql, Kl) {
          Kl && Kl.kind !== "VariableDefinition" && os.delete(Ml.name.value);
        }
      }), os.size && (so.variables = y({}, so.variables), os.forEach(function(Ml) {
        delete so.variables[Ml];
      }));
    }
    var Xs;
    if (!Io.signal) {
      var gl = Ko(), Sl = gl.controller, El = gl.signal;
      Xs = Sl, Xs && (Io.signal = El);
    }
    var wl = function(Ml) {
      return Ml.kind === "OperationDefinition" && Ml.operation === "mutation";
    };
    if (fa && !no.query.definitions.some(wl) && (Io.method = "GET"), bn(["defer"], no.query) && (Io.headers.accept = "multipart/mixed; deferSpec=20220824, application/json"), Io.method === "GET") {
      var jl = eu(eo, so), kl = jl.newURI, Fl = jl.parseError;
      if (Fl)
        return fi(Fl);
      eo = kl;
    } else
      try {
        Io.body = tn(so, "Payload");
      } catch (Ml) {
        return fi(Ml);
      }
    return new G(function(Ml) {
      var ql = Qi || he(function() {
        return fetch;
      }) || yi;
      return ql(eo, Io).then(function(Kl) {
        var Zl;
        no.setContext({ response: Kl });
        var Il = (Zl = Kl.headers) === null || Zl === void 0 ? void 0 : Zl.get("content-type");
        return Il !== null && /^multipart\/mixed/i.test(Il) ? qo(Kl, Ml) : Bo(Kl, no, Ml);
      }).catch(function(Kl) {
        return An(Kl, Ml);
      }), function() {
        Xs && Xs.abort();
      };
    });
  });
};
(function(Bi) {
  be(e, Bi);
  function e(Zi) {
    Zi === void 0 && (Zi = {});
    var Qi = Bi.call(this, tu(Zi).request) || this;
    return Qi.options = Zi, Qi;
  }
  return e;
})(Ue);
var da = Object.prototype, vi = da.toString, ru = da.hasOwnProperty, mi = Function.prototype.toString, rn = /* @__PURE__ */ new Map();
function re(Bi, e) {
  try {
    return nn(Bi, e);
  } finally {
    rn.clear();
  }
}
function nn(Bi, e) {
  if (Bi === e)
    return !0;
  var Zi = vi.call(Bi), Qi = vi.call(e);
  if (Zi !== Qi)
    return !1;
  switch (Zi) {
    case "[object Array]":
      if (Bi.length !== e.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (bi(Bi, e))
        return !0;
      var ea = gi(Bi), ra = gi(e), na = ea.length;
      if (na !== ra.length)
        return !1;
      for (var ia = 0; ia < na; ++ia)
        if (!ru.call(e, ea[ia]))
          return !1;
      for (var ia = 0; ia < na; ++ia) {
        var fa = ea[ia];
        if (!nn(Bi[fa], e[fa]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return Bi.name === e.name && Bi.message === e.message;
    case "[object Number]":
      if (Bi !== Bi)
        return e !== e;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +Bi == +e;
    case "[object RegExp]":
    case "[object String]":
      return Bi == "" + e;
    case "[object Map]":
    case "[object Set]": {
      if (Bi.size !== e.size)
        return !1;
      if (bi(Bi, e))
        return !0;
      for (var La = Bi.entries(), Va = Zi === "[object Map]"; ; ) {
        var to = La.next();
        if (to.done)
          break;
        var ro = to.value, no = ro[0], eo = ro[1];
        if (!e.has(no) || Va && !nn(eo, e.get(no)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      Bi = new Uint8Array(Bi), e = new Uint8Array(e);
    // Fall through...
    case "[object DataView]": {
      var ao = Bi.byteLength;
      if (ao === e.byteLength)
        for (; ao-- && Bi[ao] === e[ao]; )
          ;
      return ao === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      var io = mi.call(Bi);
      return io !== mi.call(e) ? !1 : !au(io, iu);
    }
  }
  return !1;
}
function gi(Bi) {
  return Object.keys(Bi).filter(nu, Bi);
}
function nu(Bi) {
  return this[Bi] !== void 0;
}
var iu = "{ [native code] }";
function au(Bi, e) {
  var Zi = Bi.length - e.length;
  return Zi >= 0 && Bi.indexOf(e, Zi) === Zi;
}
function bi(Bi, e) {
  var Zi = rn.get(Bi);
  if (Zi) {
    if (Zi.has(e))
      return !0;
  } else
    rn.set(Bi, Zi = /* @__PURE__ */ new Set());
  return Zi.add(e), !1;
}
var ou = function() {
  return /* @__PURE__ */ Object.create(null);
}, ha = Array.prototype, uu = ha.forEach, cu = ha.slice, $t = (
  /** @class */
  function() {
    function Bi(e, Zi) {
      e === void 0 && (e = !0), Zi === void 0 && (Zi = ou), this.weakness = e, this.makeData = Zi;
    }
    return Bi.prototype.lookup = function() {
      for (var e = [], Zi = 0; Zi < arguments.length; Zi++)
        e[Zi] = arguments[Zi];
      return this.lookupArray(e);
    }, Bi.prototype.lookupArray = function(e) {
      var Zi = this;
      return uu.call(e, function(Qi) {
        return Zi = Zi.getChildTrie(Qi);
      }), Zi.data || (Zi.data = this.makeData(cu.call(e)));
    }, Bi.prototype.getChildTrie = function(e) {
      var Zi = this.weakness && lu(e) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map()), Qi = Zi.get(e);
      return Qi || Zi.set(e, Qi = new Bi(this.weakness, this.makeData)), Qi;
    }, Bi;
  }()
);
function lu(Bi) {
  switch (typeof Bi) {
    case "object":
      if (Bi === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var ae = null, _i = {}, fu = 1, du = function() {
  return (
    /** @class */
    function() {
      function Bi() {
        this.id = [
          "slot",
          fu++,
          Date.now(),
          Math.random().toString(36).slice(2)
        ].join(":");
      }
      return Bi.prototype.hasValue = function() {
        for (var e = ae; e; e = e.parent)
          if (this.id in e.slots) {
            var Zi = e.slots[this.id];
            if (Zi === _i)
              break;
            return e !== ae && (ae.slots[this.id] = Zi), !0;
          }
        return ae && (ae.slots[this.id] = _i), !1;
      }, Bi.prototype.getValue = function() {
        if (this.hasValue())
          return ae.slots[this.id];
      }, Bi.prototype.withValue = function(e, Zi, Qi, ea) {
        var ra, na = (ra = {
          __proto__: null
        }, ra[this.id] = e, ra), ia = ae;
        ae = { parent: ia, slots: na };
        try {
          return Zi.apply(ea, Qi);
        } finally {
          ae = ia;
        }
      }, Bi.bind = function(e) {
        var Zi = ae;
        return function() {
          var Qi = ae;
          try {
            return ae = Zi, e.apply(this, arguments);
          } finally {
            ae = Qi;
          }
        };
      }, Bi.noContext = function(e, Zi, Qi) {
        if (ae) {
          var ea = ae;
          try {
            return ae = null, e.apply(Qi, Zi);
          } finally {
            ae = ea;
          }
        } else
          return e.apply(Qi, Zi);
      }, Bi;
    }()
  );
}, Rr = "@wry/context:Slot", jr = Array, Nn = jr[Rr] || function() {
  var Bi = du();
  try {
    Object.defineProperty(jr, Rr, {
      value: jr[Rr] = Bi,
      enumerable: !1,
      writable: !1,
      configurable: !1
    });
  } finally {
    return Bi;
  }
}();
Nn.bind;
Nn.noContext;
function hu() {
}
var pu = (
  /** @class */
  function() {
    function Bi(e, Zi) {
      e === void 0 && (e = 1 / 0), Zi === void 0 && (Zi = hu), this.max = e, this.dispose = Zi, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
    }
    return Bi.prototype.has = function(e) {
      return this.map.has(e);
    }, Bi.prototype.get = function(e) {
      var Zi = this.getNode(e);
      return Zi && Zi.value;
    }, Bi.prototype.getNode = function(e) {
      var Zi = this.map.get(e);
      if (Zi && Zi !== this.newest) {
        var Qi = Zi.older, ea = Zi.newer;
        ea && (ea.older = Qi), Qi && (Qi.newer = ea), Zi.older = this.newest, Zi.older.newer = Zi, Zi.newer = null, this.newest = Zi, Zi === this.oldest && (this.oldest = ea);
      }
      return Zi;
    }, Bi.prototype.set = function(e, Zi) {
      var Qi = this.getNode(e);
      return Qi ? Qi.value = Zi : (Qi = {
        key: e,
        value: Zi,
        newer: null,
        older: this.newest
      }, this.newest && (this.newest.newer = Qi), this.newest = Qi, this.oldest = this.oldest || Qi, this.map.set(e, Qi), Qi.value);
    }, Bi.prototype.clean = function() {
      for (; this.oldest && this.map.size > this.max; )
        this.delete(this.oldest.key);
    }, Bi.prototype.delete = function(e) {
      var Zi = this.map.get(e);
      return Zi ? (Zi === this.newest && (this.newest = Zi.older), Zi === this.oldest && (this.oldest = Zi.newer), Zi.newer && (Zi.newer.older = Zi.older), Zi.older && (Zi.older.newer = Zi.newer), this.map.delete(e), this.dispose(Zi.value, e), !0) : !1;
    }, Bi;
  }()
), kr = new Nn(), Cr, yu = Object.prototype.hasOwnProperty, Pn = (Cr = Array.from, Cr === void 0 ? function(Bi) {
  var e = [];
  return Bi.forEach(function(Zi) {
    return e.push(Zi);
  }), e;
} : Cr);
function Fn(Bi) {
  var e = Bi.unsubscribe;
  typeof e == "function" && (Bi.unsubscribe = void 0, e());
}
var It = [], vu = 100;
function ht(Bi, e) {
  if (!Bi)
    throw new Error(e || "assertion failure");
}
function mu(Bi, e) {
  var Zi = Bi.length;
  return (
    // Unknown values are not equal to each other.
    Zi > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    Zi === e.length && // The underlying value or exception must be the same.
    Bi[Zi - 1] === e[Zi - 1]
  );
}
function pa(Bi) {
  switch (Bi.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return Bi[0];
    case 2:
      throw Bi[1];
  }
}
function gu(Bi) {
  return Bi.slice(0);
}
var bu = (
  /** @class */
  function() {
    function Bi(e) {
      this.fn = e, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Bi.count;
    }
    return Bi.prototype.peek = function() {
      if (this.value.length === 1 && !Ve(this))
        return wi(this), this.value[0];
    }, Bi.prototype.recompute = function(e) {
      return ht(!this.recomputing, "already recomputing"), wi(this), Ve(this) ? _u(this, e) : pa(this.value);
    }, Bi.prototype.setDirty = function() {
      this.dirty || (this.dirty = !0, this.value.length = 0, ya(this), Fn(this));
    }, Bi.prototype.dispose = function() {
      var e = this;
      this.setDirty(), _a(this), Mn(this, function(Zi, Qi) {
        Zi.setDirty(), wa(Zi, e);
      });
    }, Bi.prototype.forget = function() {
      this.dispose();
    }, Bi.prototype.dependOn = function(e) {
      e.add(this), this.deps || (this.deps = It.pop() || /* @__PURE__ */ new Set()), this.deps.add(e);
    }, Bi.prototype.forgetDeps = function() {
      var e = this;
      this.deps && (Pn(this.deps).forEach(function(Zi) {
        return Zi.delete(e);
      }), this.deps.clear(), It.push(this.deps), this.deps = null);
    }, Bi.count = 0, Bi;
  }()
);
function wi(Bi) {
  var e = kr.getValue();
  if (e)
    return Bi.parents.add(e), e.childValues.has(Bi) || e.childValues.set(Bi, []), Ve(Bi) ? ma(e, Bi) : ga(e, Bi), e;
}
function _u(Bi, e) {
  return _a(Bi), kr.withValue(Bi, wu, [Bi, e]), Eu(Bi, e) && ku(Bi), pa(Bi.value);
}
function wu(Bi, e) {
  Bi.recomputing = !0, Bi.value.length = 0;
  try {
    Bi.value[0] = Bi.fn.apply(null, e);
  } catch (Zi) {
    Bi.value[1] = Zi;
  }
  Bi.recomputing = !1;
}
function Ve(Bi) {
  return Bi.dirty || !!(Bi.dirtyChildren && Bi.dirtyChildren.size);
}
function ku(Bi) {
  Bi.dirty = !1, !Ve(Bi) && va(Bi);
}
function ya(Bi) {
  Mn(Bi, ma);
}
function va(Bi) {
  Mn(Bi, ga);
}
function Mn(Bi, e) {
  var Zi = Bi.parents.size;
  if (Zi)
    for (var Qi = Pn(Bi.parents), ea = 0; ea < Zi; ++ea)
      e(Qi[ea], Bi);
}
function ma(Bi, e) {
  ht(Bi.childValues.has(e)), ht(Ve(e));
  var Zi = !Ve(Bi);
  if (!Bi.dirtyChildren)
    Bi.dirtyChildren = It.pop() || /* @__PURE__ */ new Set();
  else if (Bi.dirtyChildren.has(e))
    return;
  Bi.dirtyChildren.add(e), Zi && ya(Bi);
}
function ga(Bi, e) {
  ht(Bi.childValues.has(e)), ht(!Ve(e));
  var Zi = Bi.childValues.get(e);
  Zi.length === 0 ? Bi.childValues.set(e, gu(e.value)) : mu(Zi, e.value) || Bi.setDirty(), ba(Bi, e), !Ve(Bi) && va(Bi);
}
function ba(Bi, e) {
  var Zi = Bi.dirtyChildren;
  Zi && (Zi.delete(e), Zi.size === 0 && (It.length < vu && It.push(Zi), Bi.dirtyChildren = null));
}
function _a(Bi) {
  Bi.childValues.size > 0 && Bi.childValues.forEach(function(e, Zi) {
    wa(Bi, Zi);
  }), Bi.forgetDeps(), ht(Bi.dirtyChildren === null);
}
function wa(Bi, e) {
  e.parents.delete(Bi), Bi.childValues.delete(e), ba(Bi, e);
}
function Eu(Bi, e) {
  if (typeof Bi.subscribe == "function")
    try {
      Fn(Bi), Bi.unsubscribe = Bi.subscribe.apply(null, e);
    } catch {
      return Bi.setDirty(), !1;
    }
  return !0;
}
var Su = {
  setDirty: !0,
  dispose: !0,
  forget: !0
};
function ka(Bi) {
  var e = /* @__PURE__ */ new Map();
  function Zi(Qi) {
    var ea = kr.getValue();
    if (ea) {
      var ra = e.get(Qi);
      ra || e.set(Qi, ra = /* @__PURE__ */ new Set()), ea.dependOn(ra);
    }
  }
  return Zi.dirty = function(Qi, ea) {
    var ra = e.get(Qi);
    if (ra) {
      var na = ea && yu.call(Su, ea) ? ea : "setDirty";
      Pn(ra).forEach(function(ia) {
        return ia[na]();
      }), e.delete(Qi), Fn(ra);
    }
  }, Zi;
}
function Ea() {
  var Bi = new $t(typeof WeakMap == "function");
  return function() {
    return Bi.lookupArray(arguments);
  };
}
Ea();
var Ar = /* @__PURE__ */ new Set();
function sr(Bi, e) {
  e === void 0 && (e = /* @__PURE__ */ Object.create(null));
  var Zi = new pu(e.max || Math.pow(2, 16), function(La) {
    return La.dispose();
  }), Qi = e.keyArgs, ea = e.makeCacheKey || Ea(), ra = function() {
    var La = ea.apply(null, Qi ? Qi.apply(null, arguments) : arguments);
    if (La === void 0)
      return Bi.apply(null, arguments);
    var Va = Zi.get(La);
    Va || (Zi.set(La, Va = new bu(Bi)), Va.subscribe = e.subscribe, Va.forget = function() {
      return Zi.delete(La);
    });
    var to = Va.recompute(Array.prototype.slice.call(arguments));
    return Zi.set(La, Va), Ar.add(Zi), kr.hasValue() || (Ar.forEach(function(ro) {
      return ro.clean();
    }), Ar.clear()), to;
  };
  Object.defineProperty(ra, "size", {
    get: function() {
      return Zi.map.size;
    },
    configurable: !1,
    enumerable: !1
  });
  function na(La) {
    var Va = Zi.get(La);
    Va && Va.setDirty();
  }
  ra.dirtyKey = na, ra.dirty = function() {
    na(ea.apply(null, arguments));
  };
  function ia(La) {
    var Va = Zi.get(La);
    if (Va)
      return Va.peek();
  }
  ra.peekKey = ia, ra.peek = function() {
    return ia(ea.apply(null, arguments));
  };
  function fa(La) {
    return Zi.delete(La);
  }
  return ra.forgetKey = fa, ra.forget = function() {
    return fa(ea.apply(null, arguments));
  }, ra.makeCacheKey = ea, ra.getKey = Qi ? function() {
    return ea.apply(null, Qi.apply(null, arguments));
  } : ea, Object.freeze(ra);
}
var Ou = function() {
  function Bi() {
    this.getFragmentDoc = sr(Ls);
  }
  return Bi.prototype.batch = function(e) {
    var Zi = this, Qi = typeof e.optimistic == "string" ? e.optimistic : e.optimistic === !1 ? null : void 0, ea;
    return this.performTransaction(function() {
      return ea = e.update(Zi);
    }, Qi), ea;
  }, Bi.prototype.recordOptimisticTransaction = function(e, Zi) {
    this.performTransaction(e, Zi);
  }, Bi.prototype.transformDocument = function(e) {
    return e;
  }, Bi.prototype.transformForLink = function(e) {
    return e;
  }, Bi.prototype.identify = function(e) {
  }, Bi.prototype.gc = function() {
    return [];
  }, Bi.prototype.modify = function(e) {
    return !1;
  }, Bi.prototype.readQuery = function(e, Zi) {
    return Zi === void 0 && (Zi = !!e.optimistic), this.read(y(y({}, e), { rootId: e.id || "ROOT_QUERY", optimistic: Zi }));
  }, Bi.prototype.readFragment = function(e, Zi) {
    return Zi === void 0 && (Zi = !!e.optimistic), this.read(y(y({}, e), { query: this.getFragmentDoc(e.fragment, e.fragmentName), rootId: e.id, optimistic: Zi }));
  }, Bi.prototype.writeQuery = function(e) {
    var Zi = e.id, Qi = e.data, ea = lt(e, ["id", "data"]);
    return this.write(Object.assign(ea, {
      dataId: Zi || "ROOT_QUERY",
      result: Qi
    }));
  }, Bi.prototype.writeFragment = function(e) {
    var Zi = e.id, Qi = e.data, ea = e.fragment, ra = e.fragmentName, na = lt(e, ["id", "data", "fragment", "fragmentName"]);
    return this.write(Object.assign(na, {
      query: this.getFragmentDoc(ea, ra),
      dataId: Zi,
      result: Qi
    }));
  }, Bi.prototype.updateQuery = function(e, Zi) {
    return this.batch({
      update: function(Qi) {
        var ea = Qi.readQuery(e), ra = Zi(ea);
        return ra == null ? ea : (Qi.writeQuery(y(y({}, e), { data: ra })), ra);
      }
    });
  }, Bi.prototype.updateFragment = function(e, Zi) {
    return this.batch({
      update: function(Qi) {
        var ea = Qi.readFragment(e), ra = Zi(ea);
        return ra == null ? ea : (Qi.writeFragment(y(y({}, e), { data: ra })), ra);
      }
    });
  }, Bi;
}(), Sa = function(Bi) {
  be(e, Bi);
  function e(Zi, Qi, ea, ra) {
    var na, ia = Bi.call(this, Zi) || this;
    if (ia.message = Zi, ia.path = Qi, ia.query = ea, ia.variables = ra, Array.isArray(ia.path)) {
      ia.missing = ia.message;
      for (var fa = ia.path.length - 1; fa >= 0; --fa)
        ia.missing = (na = {}, na[ia.path[fa]] = ia.missing, na);
    } else
      ia.missing = ia.path;
    return ia.__proto__ = e.prototype, ia;
  }
  return e;
}(Error), te = Object.prototype.hasOwnProperty;
function wt(Bi) {
  return Bi == null;
}
var ee = Array.isArray;
function Oa(Bi, e) {
  var Zi = Bi.__typename, Qi = Bi.id, ea = Bi._id;
  if (typeof Zi == "string" && (e && (e.keyObject = wt(Qi) ? wt(ea) ? void 0 : { _id: ea } : { id: Qi }), wt(Qi) && !wt(ea) && (Qi = ea), !wt(Qi)))
    return "".concat(Zi, ":").concat(typeof Qi == "number" || typeof Qi == "string" ? Qi : JSON.stringify(Qi));
}
var xa = {
  dataIdFromObject: Oa,
  addTypename: !0,
  resultCaching: !0,
  canonizeResults: !1
};
function xu(Bi) {
  return wr(xa, Bi);
}
function Ta(Bi) {
  var e = Bi.canonizeResults;
  return e === void 0 ? xa.canonizeResults : e;
}
function Tu(Bi, e) {
  return U(e) ? Bi.get(e.__ref, "__typename") : e && e.__typename;
}
var Da = /^[_a-z][_0-9a-z]*/i;
function Le(Bi) {
  var e = Bi.match(Da);
  return e ? e[0] : Bi;
}
function an(Bi, e, Zi) {
  return Y(e) ? ee(e) ? e.every(function(Qi) {
    return an(Bi, Qi, Zi);
  }) : Bi.selections.every(function(Qi) {
    if (je(Qi) && vr(Qi, Zi)) {
      var ea = Je(Qi);
      return te.call(e, ea) && (!Qi.selectionSet || an(Qi.selectionSet, e[ea], Zi));
    }
    return !0;
  }) : !1;
}
function it(Bi) {
  return Y(Bi) && !U(Bi) && !ee(Bi);
}
function Du() {
  return new He();
}
function Ia(Bi, e) {
  var Zi = _n(En(Bi));
  return {
    fragmentMap: Zi,
    lookupFragment: function(Qi) {
      var ea = Zi[Qi];
      return !ea && e && (ea = e.lookup(Qi)), ea || null;
    }
  };
}
var nr = /* @__PURE__ */ Object.create(null), Nr = function() {
  return nr;
}, ki = /* @__PURE__ */ Object.create(null), Rt = function() {
  function Bi(e, Zi) {
    var Qi = this;
    this.policies = e, this.group = Zi, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(ea, ra) {
      return Yr(U(ea) ? Qi.get(ea.__ref, ra) : ea && ea[ra]);
    }, this.canRead = function(ea) {
      return U(ea) ? Qi.has(ea.__ref) : typeof ea == "object";
    }, this.toReference = function(ea, ra) {
      if (typeof ea == "string")
        return ot(ea);
      if (U(ea))
        return ea;
      var na = Qi.policies.identify(ea)[0];
      if (na) {
        var ia = ot(na);
        return ra && Qi.merge(na, ea), ia;
      }
    };
  }
  return Bi.prototype.toObject = function() {
    return y({}, this.data);
  }, Bi.prototype.has = function(e) {
    return this.lookup(e, !0) !== void 0;
  }, Bi.prototype.get = function(e, Zi) {
    if (this.group.depend(e, Zi), te.call(this.data, e)) {
      var Qi = this.data[e];
      if (Qi && te.call(Qi, Zi))
        return Qi[Zi];
    }
    if (Zi === "__typename" && te.call(this.policies.rootTypenamesById, e))
      return this.policies.rootTypenamesById[e];
    if (this instanceof Ne)
      return this.parent.get(e, Zi);
  }, Bi.prototype.lookup = function(e, Zi) {
    if (Zi && this.group.depend(e, "__exists"), te.call(this.data, e))
      return this.data[e];
    if (this instanceof Ne)
      return this.parent.lookup(e, Zi);
    if (this.policies.rootTypenamesById[e])
      return /* @__PURE__ */ Object.create(null);
  }, Bi.prototype.merge = function(e, Zi) {
    var Qi = this, ea;
    U(e) && (e = e.__ref), U(Zi) && (Zi = Zi.__ref);
    var ra = typeof e == "string" ? this.lookup(ea = e) : e, na = typeof Zi == "string" ? this.lookup(ea = Zi) : Zi;
    if (na) {
      __DEV__ ? E(typeof ea == "string", "store.merge expects a string ID") : E(typeof ea == "string", 1);
      var ia = new He(Ru).merge(ra, na);
      if (this.data[ea] = ia, ia !== ra && (delete this.refs[ea], this.group.caching)) {
        var fa = /* @__PURE__ */ Object.create(null);
        ra || (fa.__exists = 1), Object.keys(na).forEach(function(La) {
          if (!ra || ra[La] !== ia[La]) {
            fa[La] = 1;
            var Va = Le(La);
            Va !== La && !Qi.policies.hasKeyArgs(ia.__typename, Va) && (fa[Va] = 1), ia[La] === void 0 && !(Qi instanceof Ne) && delete ia[La];
          }
        }), fa.__typename && !(ra && ra.__typename) && this.policies.rootTypenamesById[ea] === ia.__typename && delete fa.__typename, Object.keys(fa).forEach(function(La) {
          return Qi.group.dirty(ea, La);
        });
      }
    }
  }, Bi.prototype.modify = function(e, Zi) {
    var Qi = this, ea = this.lookup(e);
    if (ea) {
      var ra = /* @__PURE__ */ Object.create(null), na = !1, ia = !0, fa = {
        DELETE: nr,
        INVALIDATE: ki,
        isReference: U,
        toReference: this.toReference,
        canRead: this.canRead,
        readField: function(La, Va) {
          return Qi.policies.readField(typeof La == "string" ? {
            fieldName: La,
            from: Va || ot(e)
          } : La, { store: Qi });
        }
      };
      if (Object.keys(ea).forEach(function(La) {
        var Va = Le(La), to = ea[La];
        if (to !== void 0) {
          var ro = typeof Zi == "function" ? Zi : Zi[La] || Zi[Va];
          if (ro) {
            var no = ro === Nr ? nr : ro(Yr(to), y(y({}, fa), { fieldName: Va, storeFieldName: La, storage: Qi.getStorage(e, La) }));
            no === ki ? Qi.group.dirty(e, La) : (no === nr && (no = void 0), no !== to && (ra[La] = no, na = !0, to = no));
          }
          to !== void 0 && (ia = !1);
        }
      }), na)
        return this.merge(e, ra), ia && (this instanceof Ne ? this.data[e] = void 0 : delete this.data[e], this.group.dirty(e, "__exists")), !0;
    }
    return !1;
  }, Bi.prototype.delete = function(e, Zi, Qi) {
    var ea, ra = this.lookup(e);
    if (ra) {
      var na = this.getFieldValue(ra, "__typename"), ia = Zi && Qi ? this.policies.getStoreFieldName({ typename: na, fieldName: Zi, args: Qi }) : Zi;
      return this.modify(e, ia ? (ea = {}, ea[ia] = Nr, ea) : Nr);
    }
    return !1;
  }, Bi.prototype.evict = function(e, Zi) {
    var Qi = !1;
    return e.id && (te.call(this.data, e.id) && (Qi = this.delete(e.id, e.fieldName, e.args)), this instanceof Ne && this !== Zi && (Qi = this.parent.evict(e, Zi) || Qi), (e.fieldName || Qi) && this.group.dirty(e.id, e.fieldName || "__exists")), Qi;
  }, Bi.prototype.clear = function() {
    this.replace(null);
  }, Bi.prototype.extract = function() {
    var e = this, Zi = this.toObject(), Qi = [];
    return this.getRootIdSet().forEach(function(ea) {
      te.call(e.policies.rootTypenamesById, ea) || Qi.push(ea);
    }), Qi.length && (Zi.__META = { extraRootIds: Qi.sort() }), Zi;
  }, Bi.prototype.replace = function(e) {
    var Zi = this;
    if (Object.keys(this.data).forEach(function(ra) {
      e && te.call(e, ra) || Zi.delete(ra);
    }), e) {
      var Qi = e.__META, ea = lt(e, ["__META"]);
      Object.keys(ea).forEach(function(ra) {
        Zi.merge(ra, ea[ra]);
      }), Qi && Qi.extraRootIds.forEach(this.retain, this);
    }
  }, Bi.prototype.retain = function(e) {
    return this.rootIds[e] = (this.rootIds[e] || 0) + 1;
  }, Bi.prototype.release = function(e) {
    if (this.rootIds[e] > 0) {
      var Zi = --this.rootIds[e];
      return Zi || delete this.rootIds[e], Zi;
    }
    return 0;
  }, Bi.prototype.getRootIdSet = function(e) {
    return e === void 0 && (e = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(e.add, e), this instanceof Ne ? this.parent.getRootIdSet(e) : Object.keys(this.policies.rootTypenamesById).forEach(e.add, e), e;
  }, Bi.prototype.gc = function() {
    var e = this, Zi = this.getRootIdSet(), Qi = this.toObject();
    Zi.forEach(function(na) {
      te.call(Qi, na) && (Object.keys(e.findChildRefIds(na)).forEach(Zi.add, Zi), delete Qi[na]);
    });
    var ea = Object.keys(Qi);
    if (ea.length) {
      for (var ra = this; ra instanceof Ne; )
        ra = ra.parent;
      ea.forEach(function(na) {
        return ra.delete(na);
      });
    }
    return ea;
  }, Bi.prototype.findChildRefIds = function(e) {
    if (!te.call(this.refs, e)) {
      var Zi = this.refs[e] = /* @__PURE__ */ Object.create(null), Qi = this.data[e];
      if (!Qi)
        return Zi;
      var ea = /* @__PURE__ */ new Set([Qi]);
      ea.forEach(function(ra) {
        U(ra) && (Zi[ra.__ref] = !0), Y(ra) && Object.keys(ra).forEach(function(na) {
          var ia = ra[na];
          Y(ia) && ea.add(ia);
        });
      });
    }
    return this.refs[e];
  }, Bi.prototype.makeCacheKey = function() {
    return this.group.keyMaker.lookupArray(arguments);
  }, Bi;
}(), Ra = function() {
  function Bi(e, Zi) {
    Zi === void 0 && (Zi = null), this.caching = e, this.parent = Zi, this.d = null, this.resetCaching();
  }
  return Bi.prototype.resetCaching = function() {
    this.d = this.caching ? ka() : null, this.keyMaker = new $t(et);
  }, Bi.prototype.depend = function(e, Zi) {
    if (this.d) {
      this.d(Pr(e, Zi));
      var Qi = Le(Zi);
      Qi !== Zi && this.d(Pr(e, Qi)), this.parent && this.parent.depend(e, Zi);
    }
  }, Bi.prototype.dirty = function(e, Zi) {
    this.d && this.d.dirty(Pr(e, Zi), Zi === "__exists" ? "forget" : "setDirty");
  }, Bi;
}();
function Pr(Bi, e) {
  return e + "#" + Bi;
}
function Ei(Bi, e) {
  Tt(Bi) && Bi.group.depend(e, "__exists");
}
(function(Bi) {
  var e = function(Zi) {
    be(Qi, Zi);
    function Qi(ea) {
      var ra = ea.policies, na = ea.resultCaching, ia = na === void 0 ? !0 : na, fa = ea.seed, La = Zi.call(this, ra, new Ra(ia)) || this;
      return La.stump = new Iu(La), La.storageTrie = new $t(et), fa && La.replace(fa), La;
    }
    return Qi.prototype.addLayer = function(ea, ra) {
      return this.stump.addLayer(ea, ra);
    }, Qi.prototype.removeLayer = function() {
      return this;
    }, Qi.prototype.getStorage = function() {
      return this.storageTrie.lookupArray(arguments);
    }, Qi;
  }(Bi);
  Bi.Root = e;
})(Rt || (Rt = {}));
var Ne = function(Bi) {
  be(e, Bi);
  function e(Zi, Qi, ea, ra) {
    var na = Bi.call(this, Qi.policies, ra) || this;
    return na.id = Zi, na.parent = Qi, na.replay = ea, na.group = ra, ea(na), na;
  }
  return e.prototype.addLayer = function(Zi, Qi) {
    return new e(Zi, this, Qi, this.group);
  }, e.prototype.removeLayer = function(Zi) {
    var Qi = this, ea = this.parent.removeLayer(Zi);
    return Zi === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(ra) {
      var na = Qi.data[ra], ia = ea.lookup(ra);
      ia ? na ? na !== ia && Object.keys(na).forEach(function(fa) {
        re(na[fa], ia[fa]) || Qi.group.dirty(ra, fa);
      }) : (Qi.group.dirty(ra, "__exists"), Object.keys(ia).forEach(function(fa) {
        Qi.group.dirty(ra, fa);
      })) : Qi.delete(ra);
    }), ea) : ea === this.parent ? this : ea.addLayer(this.id, this.replay);
  }, e.prototype.toObject = function() {
    return y(y({}, this.parent.toObject()), this.data);
  }, e.prototype.findChildRefIds = function(Zi) {
    var Qi = this.parent.findChildRefIds(Zi);
    return te.call(this.data, Zi) ? y(y({}, Qi), Bi.prototype.findChildRefIds.call(this, Zi)) : Qi;
  }, e.prototype.getStorage = function() {
    for (var Zi = this.parent; Zi.parent; )
      Zi = Zi.parent;
    return Zi.getStorage.apply(Zi, arguments);
  }, e;
}(Rt), Iu = function(Bi) {
  be(e, Bi);
  function e(Zi) {
    return Bi.call(this, "EntityStore.Stump", Zi, function() {
    }, new Ra(Zi.group.caching, Zi.group)) || this;
  }
  return e.prototype.removeLayer = function() {
    return this;
  }, e.prototype.merge = function() {
    return this.parent.merge.apply(this.parent, arguments);
  }, e;
}(Ne);
function Ru(Bi, e, Zi) {
  var Qi = Bi[Zi], ea = e[Zi];
  return re(Qi, ea) ? Qi : ea;
}
function Tt(Bi) {
  return !!(Bi instanceof Rt && Bi.group.caching);
}
function ju(Bi) {
  return Y(Bi) ? ee(Bi) ? Bi.slice(0) : y({ __proto__: Object.getPrototypeOf(Bi) }, Bi) : Bi;
}
var sn = function() {
  function Bi() {
    this.known = new (wo ? WeakSet : Set)(), this.pool = new $t(et), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
  }
  return Bi.prototype.isKnown = function(e) {
    return Y(e) && this.known.has(e);
  }, Bi.prototype.pass = function(e) {
    if (Y(e)) {
      var Zi = ju(e);
      return this.passes.set(Zi, e), Zi;
    }
    return e;
  }, Bi.prototype.admit = function(e) {
    var Zi = this;
    if (Y(e)) {
      var Qi = this.passes.get(e);
      if (Qi)
        return Qi;
      var ea = Object.getPrototypeOf(e);
      switch (ea) {
        case Array.prototype: {
          if (this.known.has(e))
            return e;
          var ra = e.map(this.admit, this), na = this.pool.lookupArray(ra);
          return na.array || (this.known.add(na.array = ra), __DEV__ && Object.freeze(ra)), na.array;
        }
        case null:
        case Object.prototype: {
          if (this.known.has(e))
            return e;
          var ia = Object.getPrototypeOf(e), fa = [ia], La = this.sortedKeys(e);
          fa.push(La.json);
          var Va = fa.length;
          La.sorted.forEach(function(no) {
            fa.push(Zi.admit(e[no]));
          });
          var na = this.pool.lookupArray(fa);
          if (!na.object) {
            var to = na.object = Object.create(ia);
            this.known.add(to), La.sorted.forEach(function(no, eo) {
              to[no] = fa[Va + eo];
            }), __DEV__ && Object.freeze(to);
          }
          return na.object;
        }
      }
    }
    return e;
  }, Bi.prototype.sortedKeys = function(e) {
    var Zi = Object.keys(e), Qi = this.pool.lookupArray(Zi);
    if (!Qi.keys) {
      Zi.sort();
      var ea = JSON.stringify(Zi);
      (Qi.keys = this.keysByJSON.get(ea)) || this.keysByJSON.set(ea, Qi.keys = { sorted: Zi, json: ea });
    }
    return Qi.keys;
  }, Bi;
}(), We = Object.assign(function(Bi) {
  if (Y(Bi)) {
    on === void 0 && Si();
    var e = on.admit(Bi), Zi = un.get(e);
    return Zi === void 0 && un.set(e, Zi = JSON.stringify(e)), Zi;
  }
  return JSON.stringify(Bi);
}, {
  reset: Si
}), on, un;
function Si() {
  on = new sn(), un = new (et ? WeakMap : Map)();
}
function Oi(Bi) {
  return [
    Bi.selectionSet,
    Bi.objectOrReference,
    Bi.context,
    Bi.context.canonizeResults
  ];
}
var Cu = function() {
  function Bi(e) {
    var Zi = this;
    this.knownResults = new (et ? WeakMap : Map)(), this.config = wr(e, {
      addTypename: e.addTypename !== !1,
      canonizeResults: Ta(e)
    }), this.canon = e.canon || new sn(), this.executeSelectionSet = sr(function(Qi) {
      var ea, ra = Qi.context.canonizeResults, na = Oi(Qi);
      na[3] = !ra;
      var ia = (ea = Zi.executeSelectionSet).peek.apply(ea, na);
      return ia ? ra ? y(y({}, ia), { result: Zi.canon.admit(ia.result) }) : ia : (Ei(Qi.context.store, Qi.enclosingRef.__ref), Zi.execSelectionSetImpl(Qi));
    }, {
      max: this.config.resultCacheMaxSize,
      keyArgs: Oi,
      makeCacheKey: function(Qi, ea, ra, na) {
        if (Tt(ra.store))
          return ra.store.makeCacheKey(Qi, U(ea) ? ea.__ref : ea, ra.varString, na);
      }
    }), this.executeSubSelectedArray = sr(function(Qi) {
      return Ei(Qi.context.store, Qi.enclosingRef.__ref), Zi.execSubSelectedArrayImpl(Qi);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(Qi) {
        var ea = Qi.field, ra = Qi.array, na = Qi.context;
        if (Tt(na.store))
          return na.store.makeCacheKey(ea, ra, na.varString);
      }
    });
  }
  return Bi.prototype.resetCanon = function() {
    this.canon = new sn();
  }, Bi.prototype.diffQueryAgainstStore = function(e) {
    var Zi = e.store, Qi = e.query, ea = e.rootId, ra = ea === void 0 ? "ROOT_QUERY" : ea, na = e.variables, ia = e.returnPartialData, fa = ia === void 0 ? !0 : ia, La = e.canonizeResults, Va = La === void 0 ? this.config.canonizeResults : La, to = this.config.cache.policies;
    na = y(y({}, Sn(ta(Qi))), na);
    var ro = ot(ra), no = this.executeSelectionSet({
      selectionSet: br(Qi).selectionSet,
      objectOrReference: ro,
      enclosingRef: ro,
      context: y({ store: Zi, query: Qi, policies: to, variables: na, varString: We(na), canonizeResults: Va }, Ia(Qi, this.config.fragments))
    }), eo;
    if (no.missing && (eo = [new Sa(Au(no.missing), no.missing, Qi, na)], !fa))
      throw eo[0];
    return {
      result: no.result,
      complete: !eo,
      missing: eo
    };
  }, Bi.prototype.isFresh = function(e, Zi, Qi, ea) {
    if (Tt(ea.store) && this.knownResults.get(e) === Qi) {
      var ra = this.executeSelectionSet.peek(Qi, Zi, ea, this.canon.isKnown(e));
      if (ra && e === ra.result)
        return !0;
    }
    return !1;
  }, Bi.prototype.execSelectionSetImpl = function(e) {
    var Zi = this, Qi = e.selectionSet, ea = e.objectOrReference, ra = e.enclosingRef, na = e.context;
    if (U(ea) && !na.policies.rootTypenamesById[ea.__ref] && !na.store.has(ea.__ref))
      return {
        result: this.canon.empty,
        missing: "Dangling reference to missing ".concat(ea.__ref, " object")
      };
    var ia = na.variables, fa = na.policies, La = na.store, Va = La.getFieldValue(ea, "__typename"), to = [], ro, no = new He();
    this.config.addTypename && typeof Va == "string" && !fa.rootIdsByTypename[Va] && to.push({ __typename: Va });
    function eo(qs, Fs) {
      var Do;
      return qs.missing && (ro = no.merge(ro, (Do = {}, Do[Fs] = qs.missing, Do))), qs.result;
    }
    var ao = new Set(Qi.selections);
    ao.forEach(function(qs) {
      var Fs, Do;
      if (vr(qs, ia))
        if (je(qs)) {
          var ys = fa.readField({
            fieldName: qs.name.value,
            field: qs,
            variables: na.variables,
            from: ea
          }, na), Io = Je(qs);
          ys === void 0 ? xn.added(qs) || (ro = no.merge(ro, (Fs = {}, Fs[Io] = "Can't find field '".concat(qs.name.value, "' on ").concat(U(ea) ? ea.__ref + " object" : "object " + JSON.stringify(ea, null, 2)), Fs))) : ee(ys) ? ys = eo(Zi.executeSubSelectedArray({
            field: qs,
            array: ys,
            enclosingRef: ra,
            context: na
          }), Io) : qs.selectionSet ? ys != null && (ys = eo(Zi.executeSelectionSet({
            selectionSet: qs.selectionSet,
            objectOrReference: ys,
            enclosingRef: U(ys) ? ys : ra,
            context: na
          }), Io)) : na.canonizeResults && (ys = Zi.canon.pass(ys)), ys !== void 0 && to.push((Do = {}, Do[Io] = ys, Do));
        } else {
          var so = wn(qs, na.lookupFragment);
          if (!so && qs.kind === Ji.FRAGMENT_SPREAD)
            throw __DEV__ ? new B("No fragment named ".concat(qs.name.value)) : new B(5);
          so && fa.fragmentMatches(so, Va) && so.selectionSet.selections.forEach(ao.add, ao);
        }
    });
    var io = Tn(to), xs = { result: io, missing: ro }, Ts = na.canonizeResults ? this.canon.admit(xs) : Yr(xs);
    return Ts.result && this.knownResults.set(Ts.result, Qi), Ts;
  }, Bi.prototype.execSubSelectedArrayImpl = function(e) {
    var Zi = this, Qi = e.field, ea = e.array, ra = e.enclosingRef, na = e.context, ia, fa = new He();
    function La(Va, to) {
      var ro;
      return Va.missing && (ia = fa.merge(ia, (ro = {}, ro[to] = Va.missing, ro))), Va.result;
    }
    return Qi.selectionSet && (ea = ea.filter(na.store.canRead)), ea = ea.map(function(Va, to) {
      return Va === null ? null : ee(Va) ? La(Zi.executeSubSelectedArray({
        field: Qi,
        array: Va,
        enclosingRef: ra,
        context: na
      }), to) : Qi.selectionSet ? La(Zi.executeSelectionSet({
        selectionSet: Qi.selectionSet,
        objectOrReference: Va,
        enclosingRef: U(Va) ? Va : ra,
        context: na
      }), to) : (__DEV__ && Nu(na.store, Qi, Va), Va);
    }), {
      result: na.canonizeResults ? this.canon.admit(ea) : ea,
      missing: ia
    };
  }, Bi;
}();
function Au(Bi) {
  try {
    JSON.stringify(Bi, function(e, Zi) {
      if (typeof Zi == "string")
        throw Zi;
      return Zi;
    });
  } catch (e) {
    return e;
  }
}
function Nu(Bi, e, Zi) {
  if (!e.selectionSet) {
    var Qi = /* @__PURE__ */ new Set([Zi]);
    Qi.forEach(function(ea) {
      Y(ea) && (__DEV__ ? E(!U(ea), "Missing selection set for object of type ".concat(Tu(Bi, ea), " returned for query field ").concat(e.name.value)) : E(!U(ea), 6), Object.values(ea).forEach(Qi.add, Qi));
    });
  }
}
var se = null, xi = {}, Pu = 1, Fu = function() {
  return (
    /** @class */
    function() {
      function Bi() {
        this.id = [
          "slot",
          Pu++,
          Date.now(),
          Math.random().toString(36).slice(2)
        ].join(":");
      }
      return Bi.prototype.hasValue = function() {
        for (var e = se; e; e = e.parent)
          if (this.id in e.slots) {
            var Zi = e.slots[this.id];
            if (Zi === xi)
              break;
            return e !== se && (se.slots[this.id] = Zi), !0;
          }
        return se && (se.slots[this.id] = xi), !1;
      }, Bi.prototype.getValue = function() {
        if (this.hasValue())
          return se.slots[this.id];
      }, Bi.prototype.withValue = function(e, Zi, Qi, ea) {
        var ra, na = (ra = {
          __proto__: null
        }, ra[this.id] = e, ra), ia = se;
        se = { parent: ia, slots: na };
        try {
          return Zi.apply(ea, Qi);
        } finally {
          se = ia;
        }
      }, Bi.bind = function(e) {
        var Zi = se;
        return function() {
          var Qi = se;
          try {
            return se = Zi, e.apply(this, arguments);
          } finally {
            se = Qi;
          }
        };
      }, Bi.noContext = function(e, Zi, Qi) {
        if (se) {
          var ea = se;
          try {
            return se = null, e.apply(Qi, Zi);
          } finally {
            se = ea;
          }
        } else
          return e.apply(Qi, Zi);
      }, Bi;
    }()
  );
};
function Ti(Bi) {
  try {
    return Bi();
  } catch {
  }
}
var Fr = "@wry/context:Slot", Mu = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  Ti(function() {
    return globalThis;
  }) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  Ti(function() {
    return global;
  }) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), Di = Mu, Vn = Di[Fr] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Fr] || function(Bi) {
  try {
    Object.defineProperty(Di, Fr, {
      value: Bi,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return Bi;
  }
}(Fu());
Vn.bind;
Vn.noContext;
var Ln = new Vn(), Ii = /* @__PURE__ */ new WeakMap();
function Dt(Bi) {
  var e = Ii.get(Bi);
  return e || Ii.set(Bi, e = {
    vars: /* @__PURE__ */ new Set(),
    dep: ka()
  }), e;
}
function Ri(Bi) {
  Dt(Bi).vars.forEach(function(e) {
    return e.forgetCache(Bi);
  });
}
function Vu(Bi) {
  Dt(Bi).vars.forEach(function(e) {
    return e.attachCache(Bi);
  });
}
function Lu(Bi) {
  var e = /* @__PURE__ */ new Set(), Zi = /* @__PURE__ */ new Set(), Qi = function(ra) {
    if (arguments.length > 0) {
      if (Bi !== ra) {
        Bi = ra, e.forEach(function(fa) {
          Dt(fa).dep.dirty(Qi), qu(fa);
        });
        var na = Array.from(Zi);
        Zi.clear(), na.forEach(function(fa) {
          return fa(Bi);
        });
      }
    } else {
      var ia = Ln.getValue();
      ia && (ea(ia), Dt(ia).dep(Qi));
    }
    return Bi;
  };
  Qi.onNextChange = function(ra) {
    return Zi.add(ra), function() {
      Zi.delete(ra);
    };
  };
  var ea = Qi.attachCache = function(ra) {
    return e.add(ra), Dt(ra).vars.add(Qi), Qi;
  };
  return Qi.forgetCache = function(ra) {
    return e.delete(ra);
  }, Qi;
}
function qu(Bi) {
  Bi.broadcastWatches && Bi.broadcastWatches();
}
var ji = /* @__PURE__ */ Object.create(null);
function qn(Bi) {
  var e = JSON.stringify(Bi);
  return ji[e] || (ji[e] = /* @__PURE__ */ Object.create(null));
}
function Ci(Bi) {
  var e = qn(Bi);
  return e.keyFieldsFn || (e.keyFieldsFn = function(Zi, Qi) {
    var ea = function(na, ia) {
      return Qi.readField(ia, na);
    }, ra = Qi.keyObject = Qn(Bi, function(na) {
      var ia = ut(Qi.storeObject, na, ea);
      return ia === void 0 && Zi !== Qi.storeObject && te.call(Zi, na[0]) && (ia = ut(Zi, na, Ca)), __DEV__ ? E(ia !== void 0, "Missing field '".concat(na.join("."), "' while extracting keyFields from ").concat(JSON.stringify(Zi))) : E(ia !== void 0, 2), ia;
    });
    return "".concat(Qi.typename, ":").concat(JSON.stringify(ra));
  });
}
function Ai(Bi) {
  var e = qn(Bi);
  return e.keyArgsFn || (e.keyArgsFn = function(Zi, Qi) {
    var ea = Qi.field, ra = Qi.variables, na = Qi.fieldName, ia = Qn(Bi, function(La) {
      var Va = La[0], to = Va.charAt(0);
      if (to === "@") {
        if (ea && Ee(ea.directives)) {
          var ro = Va.slice(1), no = ea.directives.find(function(xs) {
            return xs.name.value === ro;
          }), eo = no && mr(no, ra);
          return eo && ut(eo, La.slice(1));
        }
        return;
      }
      if (to === "$") {
        var ao = Va.slice(1);
        if (ra && te.call(ra, ao)) {
          var io = La.slice(0);
          return io[0] = ao, ut(ra, io);
        }
        return;
      }
      if (Zi)
        return ut(Zi, La);
    }), fa = JSON.stringify(ia);
    return (Zi || fa !== "{}") && (na += ":" + fa), na;
  });
}
function Qn(Bi, e) {
  var Zi = new He();
  return ja(Bi).reduce(function(Qi, ea) {
    var ra, na = e(ea);
    if (na !== void 0) {
      for (var ia = ea.length - 1; ia >= 0; --ia)
        na = (ra = {}, ra[ea[ia]] = na, ra);
      Qi = Zi.merge(Qi, na);
    }
    return Qi;
  }, /* @__PURE__ */ Object.create(null));
}
function ja(Bi) {
  var e = qn(Bi);
  if (!e.paths) {
    var Zi = e.paths = [], Qi = [];
    Bi.forEach(function(ea, ra) {
      ee(ea) ? (ja(ea).forEach(function(na) {
        return Zi.push(Qi.concat(na));
      }), Qi.length = 0) : (Qi.push(ea), ee(Bi[ra + 1]) || (Zi.push(Qi.slice(0)), Qi.length = 0));
    });
  }
  return e.paths;
}
function Ca(Bi, e) {
  return Bi[e];
}
function ut(Bi, e, Zi) {
  return Zi = Zi || Ca, Aa(e.reduce(function Qi(ea, ra) {
    return ee(ea) ? ea.map(function(na) {
      return Qi(na, ra);
    }) : ea && Zi(ea, ra);
  }, Bi));
}
function Aa(Bi) {
  return Y(Bi) ? ee(Bi) ? Bi.map(Aa) : Qn(Object.keys(Bi).sort(), function(e) {
    return ut(Bi, e);
  }) : Bi;
}
kn.setStringify(We);
function cn(Bi) {
  return Bi.args !== void 0 ? Bi.args : Bi.field ? mr(Bi.field, Bi.variables) : null;
}
var Qu = function() {
}, Ni = function(Bi, e) {
  return e.fieldName;
}, Pi = function(Bi, e, Zi) {
  var Qi = Zi.mergeObjects;
  return Qi(Bi, e);
}, Fi = function(Bi, e) {
  return e;
}, Bu = function() {
  function Bi(e) {
    this.config = e, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = y({ dataIdFromObject: Oa }, e), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), e.possibleTypes && this.addPossibleTypes(e.possibleTypes), e.typePolicies && this.addTypePolicies(e.typePolicies);
  }
  return Bi.prototype.identify = function(e, Zi) {
    var Qi, ea = this, ra = Zi && (Zi.typename || ((Qi = Zi.storeObject) === null || Qi === void 0 ? void 0 : Qi.__typename)) || e.__typename;
    if (ra === this.rootTypenamesById.ROOT_QUERY)
      return ["ROOT_QUERY"];
    for (var na = Zi && Zi.storeObject || e, ia = y(y({}, Zi), { typename: ra, storeObject: na, readField: Zi && Zi.readField || function() {
      var ro = Bn(arguments, na);
      return ea.readField(ro, {
        store: ea.cache.data,
        variables: ro.variables
      });
    } }), fa, La = ra && this.getTypePolicy(ra), Va = La && La.keyFn || this.config.dataIdFromObject; Va; ) {
      var to = Va(e, ia);
      if (ee(to))
        Va = Ci(to);
      else {
        fa = to;
        break;
      }
    }
    return fa = fa ? String(fa) : void 0, ia.keyObject ? [fa, ia.keyObject] : [fa];
  }, Bi.prototype.addTypePolicies = function(e) {
    var Zi = this;
    Object.keys(e).forEach(function(Qi) {
      var ea = e[Qi], ra = ea.queryType, na = ea.mutationType, ia = ea.subscriptionType, fa = lt(ea, ["queryType", "mutationType", "subscriptionType"]);
      ra && Zi.setRootTypename("Query", Qi), na && Zi.setRootTypename("Mutation", Qi), ia && Zi.setRootTypename("Subscription", Qi), te.call(Zi.toBeAdded, Qi) ? Zi.toBeAdded[Qi].push(fa) : Zi.toBeAdded[Qi] = [fa];
    });
  }, Bi.prototype.updateTypePolicy = function(e, Zi) {
    var Qi = this, ea = this.getTypePolicy(e), ra = Zi.keyFields, na = Zi.fields;
    function ia(fa, La) {
      fa.merge = typeof La == "function" ? La : La === !0 ? Pi : La === !1 ? Fi : fa.merge;
    }
    ia(ea, Zi.merge), ea.keyFn = ra === !1 ? Qu : ee(ra) ? Ci(ra) : typeof ra == "function" ? ra : ea.keyFn, na && Object.keys(na).forEach(function(fa) {
      var La = Qi.getFieldPolicy(e, fa, !0), Va = na[fa];
      if (typeof Va == "function")
        La.read = Va;
      else {
        var to = Va.keyArgs, ro = Va.read, no = Va.merge;
        La.keyFn = to === !1 ? Ni : ee(to) ? Ai(to) : typeof to == "function" ? to : La.keyFn, typeof ro == "function" && (La.read = ro), ia(La, no);
      }
      La.read && La.merge && (La.keyFn = La.keyFn || Ni);
    });
  }, Bi.prototype.setRootTypename = function(e, Zi) {
    Zi === void 0 && (Zi = e);
    var Qi = "ROOT_" + e.toUpperCase(), ea = this.rootTypenamesById[Qi];
    Zi !== ea && (__DEV__ ? E(!ea || ea === e, "Cannot change root ".concat(e, " __typename more than once")) : E(!ea || ea === e, 3), ea && delete this.rootIdsByTypename[ea], this.rootIdsByTypename[Zi] = Qi, this.rootTypenamesById[Qi] = Zi);
  }, Bi.prototype.addPossibleTypes = function(e) {
    var Zi = this;
    this.usingPossibleTypes = !0, Object.keys(e).forEach(function(Qi) {
      Zi.getSupertypeSet(Qi, !0), e[Qi].forEach(function(ea) {
        Zi.getSupertypeSet(ea, !0).add(Qi);
        var ra = ea.match(Da);
        (!ra || ra[0] !== ea) && Zi.fuzzySubtypes.set(ea, new RegExp(ea));
      });
    });
  }, Bi.prototype.getTypePolicy = function(e) {
    var Zi = this;
    if (!te.call(this.typePolicies, e)) {
      var Qi = this.typePolicies[e] = /* @__PURE__ */ Object.create(null);
      Qi.fields = /* @__PURE__ */ Object.create(null);
      var ea = this.supertypeMap.get(e);
      ea && ea.size && ea.forEach(function(na) {
        var ia = Zi.getTypePolicy(na), fa = ia.fields, La = lt(ia, ["fields"]);
        Object.assign(Qi, La), Object.assign(Qi.fields, fa);
      });
    }
    var ra = this.toBeAdded[e];
    return ra && ra.length && ra.splice(0).forEach(function(na) {
      Zi.updateTypePolicy(e, na);
    }), this.typePolicies[e];
  }, Bi.prototype.getFieldPolicy = function(e, Zi, Qi) {
    if (e) {
      var ea = this.getTypePolicy(e).fields;
      return ea[Zi] || Qi && (ea[Zi] = /* @__PURE__ */ Object.create(null));
    }
  }, Bi.prototype.getSupertypeSet = function(e, Zi) {
    var Qi = this.supertypeMap.get(e);
    return !Qi && Zi && this.supertypeMap.set(e, Qi = /* @__PURE__ */ new Set()), Qi;
  }, Bi.prototype.fragmentMatches = function(e, Zi, Qi, ea) {
    var ra = this;
    if (!e.typeCondition)
      return !0;
    if (!Zi)
      return !1;
    var na = e.typeCondition.name.value;
    if (Zi === na)
      return !0;
    if (this.usingPossibleTypes && this.supertypeMap.has(na))
      for (var ia = this.getSupertypeSet(Zi, !0), fa = [ia], La = function(eo) {
        var ao = ra.getSupertypeSet(eo, !1);
        ao && ao.size && fa.indexOf(ao) < 0 && fa.push(ao);
      }, Va = !!(Qi && this.fuzzySubtypes.size), to = !1, ro = 0; ro < fa.length; ++ro) {
        var no = fa[ro];
        if (no.has(na))
          return ia.has(na) || (to && __DEV__ && E.warn("Inferring subtype ".concat(Zi, " of supertype ").concat(na)), ia.add(na)), !0;
        no.forEach(La), Va && ro === fa.length - 1 && an(e.selectionSet, Qi, ea) && (Va = !1, to = !0, this.fuzzySubtypes.forEach(function(eo, ao) {
          var io = Zi.match(eo);
          io && io[0] === Zi && La(ao);
        }));
      }
    return !1;
  }, Bi.prototype.hasKeyArgs = function(e, Zi) {
    var Qi = this.getFieldPolicy(e, Zi, !1);
    return !!(Qi && Qi.keyFn);
  }, Bi.prototype.getStoreFieldName = function(e) {
    var Zi = e.typename, Qi = e.fieldName, ea = this.getFieldPolicy(Zi, Qi, !1), ra, na = ea && ea.keyFn;
    if (na && Zi)
      for (var ia = {
        typename: Zi,
        fieldName: Qi,
        field: e.field || null,
        variables: e.variables
      }, fa = cn(e); na; ) {
        var La = na(fa, ia);
        if (ee(La))
          na = Ai(La);
        else {
          ra = La || Qi;
          break;
        }
      }
    return ra === void 0 && (ra = e.field ? Hs(e.field, e.variables) : kn(Qi, cn(e))), ra === !1 ? Qi : Qi === Le(ra) ? ra : Qi + ":" + ra;
  }, Bi.prototype.readField = function(e, Zi) {
    var Qi = e.from;
    if (Qi) {
      var ea = e.field || e.fieldName;
      if (ea) {
        if (e.typename === void 0) {
          var ra = Zi.store.getFieldValue(Qi, "__typename");
          ra && (e.typename = ra);
        }
        var na = this.getStoreFieldName(e), ia = Le(na), fa = Zi.store.getFieldValue(Qi, na), La = this.getFieldPolicy(e.typename, ia, !1), Va = La && La.read;
        if (Va) {
          var to = Mi(this, Qi, e, Zi, Zi.store.getStorage(U(Qi) ? Qi.__ref : Qi, na));
          return Ln.withValue(this.cache, Va, [fa, to]);
        }
        return fa;
      }
    }
  }, Bi.prototype.getReadFunction = function(e, Zi) {
    var Qi = this.getFieldPolicy(e, Zi, !1);
    return Qi && Qi.read;
  }, Bi.prototype.getMergeFunction = function(e, Zi, Qi) {
    var ea = this.getFieldPolicy(e, Zi, !1), ra = ea && ea.merge;
    return !ra && Qi && (ea = this.getTypePolicy(Qi), ra = ea && ea.merge), ra;
  }, Bi.prototype.runMergeFunction = function(e, Zi, Qi, ea, ra) {
    var na = Qi.field, ia = Qi.typename, fa = Qi.merge;
    return fa === Pi ? Na(ea.store)(e, Zi) : fa === Fi ? Zi : (ea.overwrite && (e = void 0), fa(e, Zi, Mi(this, void 0, { typename: ia, fieldName: na.name.value, field: na, variables: ea.variables }, ea, ra || /* @__PURE__ */ Object.create(null))));
  }, Bi;
}();
function Mi(Bi, e, Zi, Qi, ea) {
  var ra = Bi.getStoreFieldName(Zi), na = Le(ra), ia = Zi.variables || Qi.variables, fa = Qi.store, La = fa.toReference, Va = fa.canRead;
  return {
    args: cn(Zi),
    field: Zi.field || null,
    fieldName: na,
    storeFieldName: ra,
    variables: ia,
    isReference: U,
    toReference: La,
    storage: ea,
    cache: Bi.cache,
    canRead: Va,
    readField: function() {
      return Bi.readField(Bn(arguments, e, ia), Qi);
    },
    mergeObjects: Na(Qi.store)
  };
}
function Bn(Bi, e, Zi) {
  var Qi = Bi[0], ea = Bi[1], ra = Bi.length, na;
  return typeof Qi == "string" ? na = {
    fieldName: Qi,
    from: ra > 1 ? ea : e
  } : (na = y({}, Qi), te.call(na, "from") || (na.from = e)), __DEV__ && na.from === void 0 && __DEV__ && E.warn("Undefined 'from' passed to readField with arguments ".concat(ko(Array.from(Bi)))), na.variables === void 0 && (na.variables = Zi), na;
}
function Na(Bi) {
  return function(e, Zi) {
    if (ee(e) || ee(Zi))
      throw __DEV__ ? new B("Cannot automatically merge arrays") : new B(4);
    if (Y(e) && Y(Zi)) {
      var Qi = Bi.getFieldValue(e, "__typename"), ea = Bi.getFieldValue(Zi, "__typename"), ra = Qi && ea && Qi !== ea;
      if (ra)
        return Zi;
      if (U(e) && it(Zi))
        return Bi.merge(e.__ref, Zi), e;
      if (it(e) && U(Zi))
        return Bi.merge(e, Zi.__ref), Zi;
      if (it(e) && it(Zi))
        return y(y({}, e), Zi);
    }
    return Zi;
  };
}
function Mr(Bi, e, Zi) {
  var Qi = "".concat(e).concat(Zi), ea = Bi.flavors.get(Qi);
  return ea || Bi.flavors.set(Qi, ea = Bi.clientOnly === e && Bi.deferred === Zi ? Bi : y(y({}, Bi), { clientOnly: e, deferred: Zi })), ea;
}
var Zu = function() {
  function Bi(e, Zi, Qi) {
    this.cache = e, this.reader = Zi, this.fragments = Qi;
  }
  return Bi.prototype.writeToStore = function(e, Zi) {
    var Qi = this, ea = Zi.query, ra = Zi.result, na = Zi.dataId, ia = Zi.variables, fa = Zi.overwrite, La = zt(ea), Va = Du();
    ia = y(y({}, Sn(La)), ia);
    var to = y(y({ store: e, written: /* @__PURE__ */ Object.create(null), merge: function(no, eo) {
      return Va.merge(no, eo);
    }, variables: ia, varString: We(ia) }, Ia(ea, this.fragments)), { overwrite: !!fa, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), ro = this.processSelectionSet({
      result: ra || /* @__PURE__ */ Object.create(null),
      dataId: na,
      selectionSet: La.selectionSet,
      mergeTree: { map: /* @__PURE__ */ new Map() },
      context: to
    });
    if (!U(ro))
      throw __DEV__ ? new B("Could not identify object ".concat(JSON.stringify(ra))) : new B(7);
    return to.incomingById.forEach(function(no, eo) {
      var ao = no.storeObject, io = no.mergeTree, xs = no.fieldNodeSet, Ts = ot(eo);
      if (io && io.map.size) {
        var qs = Qi.applyMerges(io, Ts, ao, to);
        if (U(qs))
          return;
        ao = qs;
      }
      if (__DEV__ && !to.overwrite) {
        var Fs = /* @__PURE__ */ Object.create(null);
        xs.forEach(function(Io) {
          Io.selectionSet && (Fs[Io.name.value] = !0);
        });
        var Do = function(Io) {
          return Fs[Le(Io)] === !0;
        }, ys = function(Io) {
          var so = io && io.map.get(Io);
          return !!(so && so.info && so.info.merge);
        };
        Object.keys(ao).forEach(function(Io) {
          Do(Io) && !ys(Io) && Uu(Ts, ao, Io, to.store);
        });
      }
      e.merge(eo, ao);
    }), e.retain(ro.__ref), ro;
  }, Bi.prototype.processSelectionSet = function(e) {
    var Zi = this, Qi = e.dataId, ea = e.result, ra = e.selectionSet, na = e.context, ia = e.mergeTree, fa = this.cache.policies, La = /* @__PURE__ */ Object.create(null), Va = Qi && fa.rootTypenamesById[Qi] || $r(ea, ra, na.fragmentMap) || Qi && na.store.get(Qi, "__typename");
    typeof Va == "string" && (La.__typename = Va);
    var to = function() {
      var qs = Bn(arguments, La, na.variables);
      if (U(qs.from)) {
        var Fs = na.incomingById.get(qs.from.__ref);
        if (Fs) {
          var Do = fa.readField(y(y({}, qs), { from: Fs.storeObject }), na);
          if (Do !== void 0)
            return Do;
        }
      }
      return fa.readField(qs, na);
    }, ro = /* @__PURE__ */ new Set();
    this.flattenFields(ra, ea, na, Va).forEach(function(qs, Fs) {
      var Do, ys = Je(Fs), Io = ea[ys];
      if (ro.add(Fs), Io !== void 0) {
        var so = fa.getStoreFieldName({
          typename: Va,
          fieldName: Fs.name.value,
          field: Fs,
          variables: qs.variables
        }), os = Vi(ia, so), Xs = Zi.processFieldValue(Io, Fs, Fs.selectionSet ? Mr(qs, !1, !1) : qs, os), gl = void 0;
        Fs.selectionSet && (U(Xs) || it(Xs)) && (gl = to("__typename", Xs));
        var Sl = fa.getMergeFunction(Va, Fs.name.value, gl);
        Sl ? os.info = {
          field: Fs,
          typename: Va,
          merge: Sl
        } : Li(ia, so), La = qs.merge(La, (Do = {}, Do[so] = Xs, Do));
      } else __DEV__ && !qs.clientOnly && !qs.deferred && !xn.added(Fs) && !fa.getReadFunction(Va, Fs.name.value) && __DEV__ && E.error("Missing field '".concat(Je(Fs), "' while writing result ").concat(JSON.stringify(ea, null, 2)).substring(0, 1e3));
    });
    try {
      var no = fa.identify(ea, {
        typename: Va,
        selectionSet: ra,
        fragmentMap: na.fragmentMap,
        storeObject: La,
        readField: to
      }), eo = no[0], ao = no[1];
      Qi = Qi || eo, ao && (La = na.merge(La, ao));
    } catch (qs) {
      if (!Qi)
        throw qs;
    }
    if (typeof Qi == "string") {
      var io = ot(Qi), xs = na.written[Qi] || (na.written[Qi] = []);
      if (xs.indexOf(ra) >= 0 || (xs.push(ra), this.reader && this.reader.isFresh(ea, io, ra, na)))
        return io;
      var Ts = na.incomingById.get(Qi);
      return Ts ? (Ts.storeObject = na.merge(Ts.storeObject, La), Ts.mergeTree = ln(Ts.mergeTree, ia), ro.forEach(function(qs) {
        return Ts.fieldNodeSet.add(qs);
      })) : na.incomingById.set(Qi, {
        storeObject: La,
        mergeTree: or(ia) ? void 0 : ia,
        fieldNodeSet: ro
      }), io;
    }
    return La;
  }, Bi.prototype.processFieldValue = function(e, Zi, Qi, ea) {
    var ra = this;
    return !Zi.selectionSet || e === null ? __DEV__ ? Cn(e) : e : ee(e) ? e.map(function(na, ia) {
      var fa = ra.processFieldValue(na, Zi, Qi, Vi(ea, ia));
      return Li(ea, ia), fa;
    }) : this.processSelectionSet({
      result: e,
      selectionSet: Zi.selectionSet,
      context: Qi,
      mergeTree: ea
    });
  }, Bi.prototype.flattenFields = function(e, Zi, Qi, ea) {
    ea === void 0 && (ea = $r(Zi, e, Qi.fragmentMap));
    var ra = /* @__PURE__ */ new Map(), na = this.cache.policies, ia = new $t(!1);
    return function fa(La, Va) {
      var to = ia.lookup(La, Va.clientOnly, Va.deferred);
      to.visited || (to.visited = !0, La.selections.forEach(function(ro) {
        if (vr(ro, Qi.variables)) {
          var no = Va.clientOnly, eo = Va.deferred;
          if (!(no && eo) && Ee(ro.directives) && ro.directives.forEach(function(xs) {
            var Ts = xs.name.value;
            if (Ts === "client" && (no = !0), Ts === "defer") {
              var qs = mr(xs, Qi.variables);
              (!qs || qs.if !== !1) && (eo = !0);
            }
          }), je(ro)) {
            var ao = ra.get(ro);
            ao && (no = no && ao.clientOnly, eo = eo && ao.deferred), ra.set(ro, Mr(Qi, no, eo));
          } else {
            var io = wn(ro, Qi.lookupFragment);
            if (!io && ro.kind === Ji.FRAGMENT_SPREAD)
              throw __DEV__ ? new B("No fragment named ".concat(ro.name.value)) : new B(8);
            io && na.fragmentMatches(io, ea, Zi, Qi.variables) && fa(io.selectionSet, Mr(Qi, no, eo));
          }
        }
      }));
    }(e, Qi), ra;
  }, Bi.prototype.applyMerges = function(e, Zi, Qi, ea, ra) {
    var na, ia = this;
    if (e.map.size && !U(Qi)) {
      var fa = !ee(Qi) && (U(Zi) || it(Zi)) ? Zi : void 0, La = Qi;
      fa && !ra && (ra = [U(fa) ? fa.__ref : fa]);
      var Va, to = function(ro, no) {
        return ee(ro) ? typeof no == "number" ? ro[no] : void 0 : ea.store.getFieldValue(ro, String(no));
      };
      e.map.forEach(function(ro, no) {
        var eo = to(fa, no), ao = to(La, no);
        if (ao !== void 0) {
          ra && ra.push(no);
          var io = ia.applyMerges(ro, eo, ao, ea, ra);
          io !== ao && (Va = Va || /* @__PURE__ */ new Map(), Va.set(no, io)), ra && E(ra.pop() === no);
        }
      }), Va && (Qi = ee(La) ? La.slice(0) : y({}, La), Va.forEach(function(ro, no) {
        Qi[no] = ro;
      }));
    }
    return e.info ? this.cache.policies.runMergeFunction(Zi, Qi, e.info, ea, ra && (na = ea.store).getStorage.apply(na, ra)) : Qi;
  }, Bi;
}(), Pa = [];
function Vi(Bi, e) {
  var Zi = Bi.map;
  return Zi.has(e) || Zi.set(e, Pa.pop() || { map: /* @__PURE__ */ new Map() }), Zi.get(e);
}
function ln(Bi, e) {
  if (Bi === e || !e || or(e))
    return Bi;
  if (!Bi || or(Bi))
    return e;
  var Zi = Bi.info && e.info ? y(y({}, Bi.info), e.info) : Bi.info || e.info, Qi = Bi.map.size && e.map.size, ea = Qi ? /* @__PURE__ */ new Map() : Bi.map.size ? Bi.map : e.map, ra = { info: Zi, map: ea };
  if (Qi) {
    var na = new Set(e.map.keys());
    Bi.map.forEach(function(ia, fa) {
      ra.map.set(fa, ln(ia, e.map.get(fa))), na.delete(fa);
    }), na.forEach(function(ia) {
      ra.map.set(ia, ln(e.map.get(ia), Bi.map.get(ia)));
    });
  }
  return ra;
}
function or(Bi) {
  return !Bi || !(Bi.info || Bi.map.size);
}
function Li(Bi, e) {
  var Zi = Bi.map, Qi = Zi.get(e);
  Qi && or(Qi) && (Pa.push(Qi), Zi.delete(e));
}
var qi = /* @__PURE__ */ new Set();
function Uu(Bi, e, Zi, Qi) {
  var ea = function(to) {
    var ro = Qi.getFieldValue(to, Zi);
    return typeof ro == "object" && ro;
  }, ra = ea(Bi);
  if (ra) {
    var na = ea(e);
    if (na && !U(ra) && !re(ra, na) && !Object.keys(ra).every(function(to) {
      return Qi.getFieldValue(na, to) !== void 0;
    })) {
      var ia = Qi.getFieldValue(Bi, "__typename") || Qi.getFieldValue(e, "__typename"), fa = Le(Zi), La = "".concat(ia, ".").concat(fa);
      if (!qi.has(La)) {
        qi.add(La);
        var Va = [];
        !ee(ra) && !ee(na) && [ra, na].forEach(function(to) {
          var ro = Qi.getFieldValue(to, "__typename");
          typeof ro == "string" && !Va.includes(ro) && Va.push(ro);
        }), __DEV__ && E.warn("Cache data may be lost when replacing the ".concat(fa, " field of a ").concat(ia, ` object.

To address this problem (which is not a bug in Apollo Client), `).concat(Va.length ? "either ensure all objects of type " + Va.join(" and ") + " have an ID or a custom merge function, or " : "", "define a custom merge function for the ").concat(La, ` field, so InMemoryCache can safely merge these objects:

  existing: `).concat(JSON.stringify(ra).slice(0, 1e3), `
  incoming: `).concat(JSON.stringify(na).slice(0, 1e3), `

For more information about these options, please refer to the documentation:

  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers
  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects
`));
      }
    }
  }
}
(function(Bi) {
  be(e, Bi);
  function e(Zi) {
    Zi === void 0 && (Zi = {});
    var Qi = Bi.call(this) || this;
    return Qi.watches = /* @__PURE__ */ new Set(), Qi.typenameDocumentCache = /* @__PURE__ */ new Map(), Qi.makeVar = Lu, Qi.txCount = 0, Qi.config = xu(Zi), Qi.addTypename = !!Qi.config.addTypename, Qi.policies = new Bu({
      cache: Qi,
      dataIdFromObject: Qi.config.dataIdFromObject,
      possibleTypes: Qi.config.possibleTypes,
      typePolicies: Qi.config.typePolicies
    }), Qi.init(), Qi;
  }
  return e.prototype.init = function() {
    var Zi = this.data = new Rt.Root({
      policies: this.policies,
      resultCaching: this.config.resultCaching
    });
    this.optimisticData = Zi.stump, this.resetResultCache();
  }, e.prototype.resetResultCache = function(Zi) {
    var Qi = this, ea = this.storeReader, ra = this.config.fragments;
    this.storeWriter = new Zu(this, this.storeReader = new Cu({
      cache: this,
      addTypename: this.addTypename,
      resultCacheMaxSize: this.config.resultCacheMaxSize,
      canonizeResults: Ta(this.config),
      canon: Zi ? void 0 : ea && ea.canon,
      fragments: ra
    }), ra), this.maybeBroadcastWatch = sr(function(na, ia) {
      return Qi.broadcastWatch(na, ia);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(na) {
        var ia = na.optimistic ? Qi.optimisticData : Qi.data;
        if (Tt(ia)) {
          var fa = na.optimistic, La = na.id, Va = na.variables;
          return ia.makeCacheKey(na.query, na.callback, We({ optimistic: fa, id: La, variables: Va }));
        }
      }
    }), (/* @__PURE__ */ new Set([
      this.data.group,
      this.optimisticData.group
    ])).forEach(function(na) {
      return na.resetCaching();
    });
  }, e.prototype.restore = function(Zi) {
    return this.init(), Zi && this.data.replace(Zi), this;
  }, e.prototype.extract = function(Zi) {
    return Zi === void 0 && (Zi = !1), (Zi ? this.optimisticData : this.data).extract();
  }, e.prototype.read = function(Zi) {
    var Qi = Zi.returnPartialData, ea = Qi === void 0 ? !1 : Qi;
    try {
      return this.storeReader.diffQueryAgainstStore(y(y({}, Zi), { store: Zi.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: ea })).result || null;
    } catch (ra) {
      if (ra instanceof Sa)
        return null;
      throw ra;
    }
  }, e.prototype.write = function(Zi) {
    try {
      return ++this.txCount, this.storeWriter.writeToStore(this.data, Zi);
    } finally {
      !--this.txCount && Zi.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.modify = function(Zi) {
    if (te.call(Zi, "id") && !Zi.id)
      return !1;
    var Qi = Zi.optimistic ? this.optimisticData : this.data;
    try {
      return ++this.txCount, Qi.modify(Zi.id || "ROOT_QUERY", Zi.fields);
    } finally {
      !--this.txCount && Zi.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.diff = function(Zi) {
    return this.storeReader.diffQueryAgainstStore(y(y({}, Zi), { store: Zi.optimistic ? this.optimisticData : this.data, rootId: Zi.id || "ROOT_QUERY", config: this.config }));
  }, e.prototype.watch = function(Zi) {
    var Qi = this;
    return this.watches.size || Vu(this), this.watches.add(Zi), Zi.immediate && this.maybeBroadcastWatch(Zi), function() {
      Qi.watches.delete(Zi) && !Qi.watches.size && Ri(Qi), Qi.maybeBroadcastWatch.forget(Zi);
    };
  }, e.prototype.gc = function(Zi) {
    We.reset();
    var Qi = this.optimisticData.gc();
    return Zi && !this.txCount && (Zi.resetResultCache ? this.resetResultCache(Zi.resetResultIdentities) : Zi.resetResultIdentities && this.storeReader.resetCanon()), Qi;
  }, e.prototype.retain = function(Zi, Qi) {
    return (Qi ? this.optimisticData : this.data).retain(Zi);
  }, e.prototype.release = function(Zi, Qi) {
    return (Qi ? this.optimisticData : this.data).release(Zi);
  }, e.prototype.identify = function(Zi) {
    if (U(Zi))
      return Zi.__ref;
    try {
      return this.policies.identify(Zi)[0];
    } catch (Qi) {
      __DEV__ && E.warn(Qi);
    }
  }, e.prototype.evict = function(Zi) {
    if (!Zi.id) {
      if (te.call(Zi, "id"))
        return !1;
      Zi = y(y({}, Zi), { id: "ROOT_QUERY" });
    }
    try {
      return ++this.txCount, this.optimisticData.evict(Zi, this.data);
    } finally {
      !--this.txCount && Zi.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.reset = function(Zi) {
    var Qi = this;
    return this.init(), We.reset(), Zi && Zi.discardWatches ? (this.watches.forEach(function(ea) {
      return Qi.maybeBroadcastWatch.forget(ea);
    }), this.watches.clear(), Ri(this)) : this.broadcastWatches(), Promise.resolve();
  }, e.prototype.removeOptimistic = function(Zi) {
    var Qi = this.optimisticData.removeLayer(Zi);
    Qi !== this.optimisticData && (this.optimisticData = Qi, this.broadcastWatches());
  }, e.prototype.batch = function(Zi) {
    var Qi = this, ea = Zi.update, ra = Zi.optimistic, na = ra === void 0 ? !0 : ra, ia = Zi.removeOptimistic, fa = Zi.onWatchUpdated, La, Va = function(ro) {
      var no = Qi, eo = no.data, ao = no.optimisticData;
      ++Qi.txCount, ro && (Qi.data = Qi.optimisticData = ro);
      try {
        return La = ea(Qi);
      } finally {
        --Qi.txCount, Qi.data = eo, Qi.optimisticData = ao;
      }
    }, to = /* @__PURE__ */ new Set();
    return fa && !this.txCount && this.broadcastWatches(y(y({}, Zi), { onWatchUpdated: function(ro) {
      return to.add(ro), !1;
    } })), typeof na == "string" ? this.optimisticData = this.optimisticData.addLayer(na, Va) : na === !1 ? Va(this.data) : Va(), typeof ia == "string" && (this.optimisticData = this.optimisticData.removeLayer(ia)), fa && to.size ? (this.broadcastWatches(y(y({}, Zi), { onWatchUpdated: function(ro, no) {
      var eo = fa.call(this, ro, no);
      return eo !== !1 && to.delete(ro), eo;
    } })), to.size && to.forEach(function(ro) {
      return Qi.maybeBroadcastWatch.dirty(ro);
    })) : this.broadcastWatches(Zi), La;
  }, e.prototype.performTransaction = function(Zi, Qi) {
    return this.batch({
      update: Zi,
      optimistic: Qi || Qi !== null
    });
  }, e.prototype.transformDocument = function(Zi) {
    if (this.addTypename) {
      var Qi = this.typenameDocumentCache.get(Zi);
      return Qi || (Qi = xn(Zi), this.typenameDocumentCache.set(Zi, Qi), this.typenameDocumentCache.set(Qi, Qi)), Qi;
    }
    return Zi;
  }, e.prototype.transformForLink = function(Zi) {
    var Qi = this.config.fragments;
    return Qi ? Qi.transform(Zi) : Zi;
  }, e.prototype.broadcastWatches = function(Zi) {
    var Qi = this;
    this.txCount || this.watches.forEach(function(ea) {
      return Qi.maybeBroadcastWatch(ea, Zi);
    });
  }, e.prototype.broadcastWatch = function(Zi, Qi) {
    var ea = Zi.lastDiff, ra = this.diff(Zi);
    Qi && (Zi.optimistic && typeof Qi.optimistic == "string" && (ra.fromOptimisticTransaction = !0), Qi.onWatchUpdated && Qi.onWatchUpdated.call(this, Zi, ra, ea) === !1) || (!ea || !re(ea.result, ra.result)) && Zi.callback(Zi.lastDiff = ra, ea);
  }, e;
})(Ou);
var Wu = function(Bi) {
  var e = "";
  if (Ee(Bi.graphQLErrors) || Ee(Bi.clientErrors)) {
    var Zi = (Bi.graphQLErrors || []).concat(Bi.clientErrors || []);
    Zi.forEach(function(Qi) {
      var ea = Qi ? Qi.message : "Error message not found.";
      e += "".concat(ea, `
`);
    });
  }
  return Bi.networkError && (e += "".concat(Bi.networkError.message, `
`)), e = e.replace(/\n$/, ""), e;
}, ze = function(Bi) {
  be(e, Bi);
  function e(Zi) {
    var Qi = Zi.graphQLErrors, ea = Zi.clientErrors, ra = Zi.networkError, na = Zi.errorMessage, ia = Zi.extraInfo, fa = Bi.call(this, na) || this;
    return fa.graphQLErrors = Qi || [], fa.clientErrors = ea || [], fa.networkError = ra || null, fa.message = na || Wu(fa), fa.extraInfo = ia, fa.__proto__ = e.prototype, fa;
  }
  return e;
}(Error), W;
(function(Bi) {
  Bi[Bi.loading = 1] = "loading", Bi[Bi.setVariables = 2] = "setVariables", Bi[Bi.fetchMore = 3] = "fetchMore", Bi[Bi.refetch = 4] = "refetch", Bi[Bi.poll = 6] = "poll", Bi[Bi.ready = 7] = "ready", Bi[Bi.error = 8] = "error";
})(W || (W = {}));
function jt(Bi) {
  return Bi ? Bi < 7 : !1;
}
var Gu = Object.assign, Ju = Object.hasOwnProperty, fn = function(Bi) {
  be(e, Bi);
  function e(Zi) {
    var Qi = Zi.queryManager, ea = Zi.queryInfo, ra = Zi.options, na = Bi.call(this, function(io) {
      try {
        var xs = io._subscription._observer;
        xs && !xs.error && (xs.error = Hu);
      } catch {
      }
      var Ts = !na.observers.size;
      na.observers.add(io);
      var qs = na.last;
      return qs && qs.error ? io.error && io.error(qs.error) : qs && qs.result && io.next && io.next(qs.result), Ts && na.reobserve().catch(function() {
      }), function() {
        na.observers.delete(io) && !na.observers.size && na.tearDownQuery();
      };
    }) || this;
    na.observers = /* @__PURE__ */ new Set(), na.subscriptions = /* @__PURE__ */ new Set(), na.queryInfo = ea, na.queryManager = Qi, na.isTornDown = !1;
    var ia = Qi.defaultOptions.watchQuery, fa = ia === void 0 ? {} : ia, La = fa.fetchPolicy, Va = La === void 0 ? "cache-first" : La, to = ra.fetchPolicy, ro = to === void 0 ? Va : to, no = ra.initialFetchPolicy, eo = no === void 0 ? ro === "standby" ? Va : ro : no;
    na.options = y(y({}, ra), { initialFetchPolicy: eo, fetchPolicy: ro }), na.queryId = ea.queryId || Qi.generateQueryId();
    var ao = zt(na.query);
    return na.queryName = ao && ao.name && ao.name.value, na;
  }
  return Object.defineProperty(e.prototype, "query", {
    get: function() {
      return this.queryManager.transform(this.options.query).document;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "variables", {
    get: function() {
      return this.options.variables;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.result = function() {
    var Zi = this;
    return new Promise(function(Qi, ea) {
      var ra = {
        next: function(ia) {
          Qi(ia), Zi.observers.delete(ra), Zi.observers.size || Zi.queryManager.removeQuery(Zi.queryId), setTimeout(function() {
            na.unsubscribe();
          }, 0);
        },
        error: ea
      }, na = Zi.subscribe(ra);
    });
  }, e.prototype.getCurrentResult = function(Zi) {
    Zi === void 0 && (Zi = !0);
    var Qi = this.getLastResult(!0), ea = this.queryInfo.networkStatus || Qi && Qi.networkStatus || W.ready, ra = y(y({}, Qi), { loading: jt(ea), networkStatus: ea }), na = this.options.fetchPolicy, ia = na === void 0 ? "cache-first" : na;
    if (!(ia === "network-only" || ia === "no-cache" || ia === "standby" || this.queryManager.transform(this.options.query).hasForcedResolvers)) {
      var fa = this.queryInfo.getDiff();
      (fa.complete || this.options.returnPartialData) && (ra.data = fa.result), re(ra.data, {}) && (ra.data = void 0), fa.complete ? (delete ra.partial, fa.complete && ra.networkStatus === W.loading && (ia === "cache-first" || ia === "cache-only") && (ra.networkStatus = W.ready, ra.loading = !1)) : ra.partial = !0, __DEV__ && !fa.complete && !this.options.partialRefetch && !ra.loading && !ra.data && !ra.error && Ma(fa.missing);
    }
    return Zi && this.updateLastResult(ra), ra;
  }, e.prototype.isDifferentFromLastResult = function(Zi) {
    return !this.last || !re(this.last.result, Zi);
  }, e.prototype.getLast = function(Zi, Qi) {
    var ea = this.last;
    if (ea && ea[Zi] && (!Qi || re(ea.variables, this.variables)))
      return ea[Zi];
  }, e.prototype.getLastResult = function(Zi) {
    return this.getLast("result", Zi);
  }, e.prototype.getLastError = function(Zi) {
    return this.getLast("error", Zi);
  }, e.prototype.resetLastResults = function() {
    delete this.last, this.isTornDown = !1;
  }, e.prototype.resetQueryStoreErrors = function() {
    this.queryManager.resetErrors(this.queryId);
  }, e.prototype.refetch = function(Zi) {
    var Qi, ea = {
      pollInterval: 0
    }, ra = this.options.fetchPolicy;
    if (ra === "cache-and-network" ? ea.fetchPolicy = ra : ra === "no-cache" ? ea.fetchPolicy = "no-cache" : ea.fetchPolicy = "network-only", __DEV__ && Zi && Ju.call(Zi, "variables")) {
      var na = ta(this.query), ia = na.variableDefinitions;
      (!ia || !ia.some(function(fa) {
        return fa.variable.name.value === "variables";
      })) && __DEV__ && E.warn("Called refetch(".concat(JSON.stringify(Zi), ") for query ").concat(((Qi = na.name) === null || Qi === void 0 ? void 0 : Qi.value) || JSON.stringify(na), `, which does not declare a $variables variable.
Did you mean to call refetch(variables) instead of refetch({ variables })?`));
    }
    return Zi && !re(this.options.variables, Zi) && (ea.variables = this.options.variables = y(y({}, this.options.variables), Zi)), this.queryInfo.resetLastWrite(), this.reobserve(ea, W.refetch);
  }, e.prototype.fetchMore = function(Zi) {
    var Qi = this, ea = y(y({}, Zi.query ? Zi : y(y(y(y({}, this.options), { query: this.query }), Zi), { variables: y(y({}, this.options.variables), Zi.variables) })), { fetchPolicy: "no-cache" }), ra = this.queryManager.generateQueryId(), na = this.queryInfo, ia = na.networkStatus;
    na.networkStatus = W.fetchMore, ea.notifyOnNetworkStatusChange && this.observe();
    var fa = /* @__PURE__ */ new Set();
    return this.queryManager.fetchQuery(ra, ea, W.fetchMore).then(function(La) {
      return Qi.queryManager.removeQuery(ra), na.networkStatus === W.fetchMore && (na.networkStatus = ia), Qi.queryManager.cache.batch({
        update: function(Va) {
          var to = Zi.updateQuery;
          to ? Va.updateQuery({
            query: Qi.query,
            variables: Qi.variables,
            returnPartialData: !0,
            optimistic: !1
          }, function(ro) {
            return to(ro, {
              fetchMoreResult: La.data,
              variables: ea.variables
            });
          }) : Va.writeQuery({
            query: ea.query,
            variables: ea.variables,
            data: La.data
          });
        },
        onWatchUpdated: function(Va) {
          fa.add(Va.query);
        }
      }), La;
    }).finally(function() {
      fa.has(Qi.query) || Fa(Qi);
    });
  }, e.prototype.subscribeToMore = function(Zi) {
    var Qi = this, ea = this.queryManager.startGraphQLSubscription({
      query: Zi.document,
      variables: Zi.variables,
      context: Zi.context
    }).subscribe({
      next: function(ra) {
        var na = Zi.updateQuery;
        na && Qi.updateQuery(function(ia, fa) {
          var La = fa.variables;
          return na(ia, {
            subscriptionData: ra,
            variables: La
          });
        });
      },
      error: function(ra) {
        if (Zi.onError) {
          Zi.onError(ra);
          return;
        }
        __DEV__ && E.error("Unhandled GraphQL subscription error", ra);
      }
    });
    return this.subscriptions.add(ea), function() {
      Qi.subscriptions.delete(ea) && ea.unsubscribe();
    };
  }, e.prototype.setOptions = function(Zi) {
    return this.reobserve(Zi);
  }, e.prototype.setVariables = function(Zi) {
    return re(this.variables, Zi) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = Zi, this.observers.size ? this.reobserve({
      fetchPolicy: this.options.initialFetchPolicy,
      variables: Zi
    }, W.setVariables) : Promise.resolve());
  }, e.prototype.updateQuery = function(Zi) {
    var Qi = this.queryManager, ea = Qi.cache.diff({
      query: this.options.query,
      variables: this.variables,
      returnPartialData: !0,
      optimistic: !1
    }).result, ra = Zi(ea, {
      variables: this.variables
    });
    ra && (Qi.cache.writeQuery({
      query: this.options.query,
      data: ra,
      variables: this.variables
    }), Qi.broadcastQueries());
  }, e.prototype.startPolling = function(Zi) {
    this.options.pollInterval = Zi, this.updatePolling();
  }, e.prototype.stopPolling = function() {
    this.options.pollInterval = 0, this.updatePolling();
  }, e.prototype.applyNextFetchPolicy = function(Zi, Qi) {
    if (Qi.nextFetchPolicy) {
      var ea = Qi.fetchPolicy, ra = ea === void 0 ? "cache-first" : ea, na = Qi.initialFetchPolicy, ia = na === void 0 ? ra : na;
      ra === "standby" || (typeof Qi.nextFetchPolicy == "function" ? Qi.fetchPolicy = Qi.nextFetchPolicy(ra, {
        reason: Zi,
        options: Qi,
        observable: this,
        initialFetchPolicy: ia
      }) : Zi === "variables-changed" ? Qi.fetchPolicy = ia : Qi.fetchPolicy = Qi.nextFetchPolicy);
    }
    return Qi.fetchPolicy;
  }, e.prototype.fetch = function(Zi, Qi) {
    return this.queryManager.setObservableQuery(this), this.queryManager.fetchQueryObservable(this.queryId, Zi, Qi);
  }, e.prototype.updatePolling = function() {
    var Zi = this;
    if (!this.queryManager.ssrMode) {
      var Qi = this, ea = Qi.pollingInfo, ra = Qi.options.pollInterval;
      if (!ra) {
        ea && (clearTimeout(ea.timeout), delete this.pollingInfo);
        return;
      }
      if (!(ea && ea.interval === ra)) {
        __DEV__ ? E(ra, "Attempted to start a polling query without a polling interval.") : E(ra, 12);
        var na = ea || (this.pollingInfo = {});
        na.interval = ra;
        var ia = function() {
          Zi.pollingInfo && (jt(Zi.queryInfo.networkStatus) ? fa() : Zi.reobserve({
            fetchPolicy: Zi.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
          }, W.poll).then(fa, fa));
        }, fa = function() {
          var La = Zi.pollingInfo;
          La && (clearTimeout(La.timeout), La.timeout = setTimeout(ia, La.interval));
        };
        fa();
      }
    }
  }, e.prototype.updateLastResult = function(Zi, Qi) {
    return Qi === void 0 && (Qi = this.variables), this.last = y(y({}, this.last), { result: this.queryManager.assumeImmutableResults ? Zi : Cn(Zi), variables: Qi }), Ee(Zi.errors) || delete this.last.error, this.last;
  }, e.prototype.reobserve = function(Zi, Qi) {
    var ea = this;
    this.isTornDown = !1;
    var ra = Qi === W.refetch || Qi === W.fetchMore || Qi === W.poll, na = this.options.variables, ia = this.options.fetchPolicy, fa = wr(this.options, Zi || {}), La = ra ? fa : Gu(this.options, fa);
    ra || (this.updatePolling(), Zi && Zi.variables && !re(Zi.variables, na) && La.fetchPolicy !== "standby" && La.fetchPolicy === ia && (this.applyNextFetchPolicy("variables-changed", La), Qi === void 0 && (Qi = W.setVariables)));
    var Va = La.variables && y({}, La.variables), to = this.fetch(La, Qi), ro = {
      next: function(no) {
        ea.reportResult(no, Va);
      },
      error: function(no) {
        ea.reportError(no, Va);
      }
    };
    return ra || (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = to, this.observer = ro), to.addObserver(ro), to.promise;
  }, e.prototype.observe = function() {
    this.reportResult(this.getCurrentResult(!1), this.variables);
  }, e.prototype.reportResult = function(Zi, Qi) {
    var ea = this.getLastError();
    (ea || this.isDifferentFromLastResult(Zi)) && ((ea || !Zi.partial || this.options.returnPartialData) && this.updateLastResult(Zi, Qi), xt(this.observers, "next", Zi));
  }, e.prototype.reportError = function(Zi, Qi) {
    var ea = y(y({}, this.getLastResult()), { error: Zi, errors: Zi.graphQLErrors, networkStatus: W.error, loading: !1 });
    this.updateLastResult(ea, Qi), xt(this.observers, "error", this.last.error = Zi);
  }, e.prototype.hasObservers = function() {
    return this.observers.size > 0;
  }, e.prototype.tearDownQuery = function() {
    this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(Zi) {
      return Zi.unsubscribe();
    }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
  }, e;
}(G);
ca(fn);
function Fa(Bi) {
  var e = Bi.options, Zi = e.fetchPolicy, Qi = e.nextFetchPolicy;
  return Zi === "cache-and-network" || Zi === "network-only" ? Bi.reobserve({
    fetchPolicy: "cache-first",
    nextFetchPolicy: function() {
      return this.nextFetchPolicy = Qi, typeof Qi == "function" ? Qi.apply(this, arguments) : Zi;
    }
  }) : Bi.reobserve();
}
function Hu(Bi) {
  __DEV__ && E.error("Unhandled error", Bi.message, Bi.stack);
}
function Ma(Bi) {
  __DEV__ && Bi && __DEV__ && E.debug("Missing cache result fields: ".concat(JSON.stringify(Bi)), Bi);
}
function ec(Bi) {
  return Y(Bi) && "code" in Bi && "reason" in Bi;
}
(function(Bi) {
  be(e, Bi);
  function e(Zi) {
    var Qi = Bi.call(this) || this;
    return Qi.client = Zi, Qi;
  }
  return e.prototype.request = function(Zi) {
    var Qi = this;
    return new G(function(ea) {
      return Qi.client.subscribe(y(y({}, Zi), { query: Xi(Zi.query) }), {
        next: ea.next.bind(ea),
        complete: ea.complete.bind(ea),
        error: function(ra) {
          return ra instanceof Error ? ea.error(ra) : ec(ra) ? ea.error(new Error("Socket closed with event ".concat(ra.code, " ").concat(ra.reason || ""))) : ea.error(new ze({
            graphQLErrors: Array.isArray(ra) ? ra : [ra]
          }));
        }
      });
    });
  }, e;
})(Ue);
var fe;
(function(Bi) {
  Bi[Bi.InternalServerError = 4500] = "InternalServerError", Bi[Bi.InternalClientError = 4005] = "InternalClientError", Bi[Bi.BadRequest = 4400] = "BadRequest", Bi[Bi.BadResponse = 4004] = "BadResponse", Bi[Bi.Unauthorized = 4401] = "Unauthorized", Bi[Bi.Forbidden = 4403] = "Forbidden", Bi[Bi.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", Bi[Bi.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", Bi[Bi.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", Bi[Bi.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", Bi[Bi.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(fe || (fe = {}));
var X;
(function(Bi) {
  Bi.ConnectionInit = "connection_init", Bi.ConnectionAck = "connection_ack", Bi.Ping = "ping", Bi.Pong = "pong", Bi.Subscribe = "subscribe", Bi.Next = "next", Bi.Error = "error", Bi.Complete = "complete";
})(X || (X = {}));
var Q;
(function(Bi) {
  Bi.assertEqual = (ea) => ea;
  function e(ea) {
  }
  Bi.assertIs = e;
  function Zi(ea) {
    throw new Error();
  }
  Bi.assertNever = Zi, Bi.arrayToEnum = (ea) => {
    const ra = {};
    for (const na of ea)
      ra[na] = na;
    return ra;
  }, Bi.getValidEnumValues = (ea) => {
    const ra = Bi.objectKeys(ea).filter((ia) => typeof ea[ea[ia]] != "number"), na = {};
    for (const ia of ra)
      na[ia] = ea[ia];
    return Bi.objectValues(na);
  }, Bi.objectValues = (ea) => Bi.objectKeys(ea).map(function(ra) {
    return ea[ra];
  }), Bi.objectKeys = typeof Object.keys == "function" ? (ea) => Object.keys(ea) : (ea) => {
    const ra = [];
    for (const na in ea)
      Object.prototype.hasOwnProperty.call(ea, na) && ra.push(na);
    return ra;
  }, Bi.find = (ea, ra) => {
    for (const na of ea)
      if (ra(na))
        return na;
  }, Bi.isInteger = typeof Number.isInteger == "function" ? (ea) => Number.isInteger(ea) : (ea) => typeof ea == "number" && isFinite(ea) && Math.floor(ea) === ea;
  function Qi(ea, ra = " | ") {
    return ea.map((na) => typeof na == "string" ? `'${na}'` : na).join(ra);
  }
  Bi.joinValues = Qi, Bi.jsonStringifyReplacer = (ea, ra) => typeof ra == "bigint" ? ra.toString() : ra;
})(Q || (Q = {}));
var hn;
(function(Bi) {
  Bi.mergeShapes = (e, Zi) => ({
    ...e,
    ...Zi
    // second overwrites first
  });
})(hn || (hn = {}));
const O = Q.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Re = (Bi) => {
  switch (typeof Bi) {
    case "undefined":
      return O.undefined;
    case "string":
      return O.string;
    case "number":
      return isNaN(Bi) ? O.nan : O.number;
    case "boolean":
      return O.boolean;
    case "function":
      return O.function;
    case "bigint":
      return O.bigint;
    case "symbol":
      return O.symbol;
    case "object":
      return Array.isArray(Bi) ? O.array : Bi === null ? O.null : Bi.then && typeof Bi.then == "function" && Bi.catch && typeof Bi.catch == "function" ? O.promise : typeof Map < "u" && Bi instanceof Map ? O.map : typeof Set < "u" && Bi instanceof Set ? O.set : typeof Date < "u" && Bi instanceof Date ? O.date : O.object;
    default:
      return O.unknown;
  }
}, g = Q.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), cc = (Bi) => JSON.stringify(Bi, null, 2).replace(/"([^"]+)":/g, "$1:");
class de extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (Qi) => {
      this.issues = [...this.issues, Qi];
    }, this.addIssues = (Qi = []) => {
      this.issues = [...this.issues, ...Qi];
    };
    const Zi = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, Zi) : this.__proto__ = Zi, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const Zi = e || function(ra) {
      return ra.message;
    }, Qi = { _errors: [] }, ea = (ra) => {
      for (const na of ra.issues)
        if (na.code === "invalid_union")
          na.unionErrors.map(ea);
        else if (na.code === "invalid_return_type")
          ea(na.returnTypeError);
        else if (na.code === "invalid_arguments")
          ea(na.argumentsError);
        else if (na.path.length === 0)
          Qi._errors.push(Zi(na));
        else {
          let ia = Qi, fa = 0;
          for (; fa < na.path.length; ) {
            const La = na.path[fa];
            fa === na.path.length - 1 ? (ia[La] = ia[La] || { _errors: [] }, ia[La]._errors.push(Zi(na))) : ia[La] = ia[La] || { _errors: [] }, ia = ia[La], fa++;
          }
        }
    };
    return ea(this), Qi;
  }
  static assert(e) {
    if (!(e instanceof de))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Q.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (Zi) => Zi.message) {
    const Zi = {}, Qi = [];
    for (const ea of this.issues)
      ea.path.length > 0 ? (Zi[ea.path[0]] = Zi[ea.path[0]] || [], Zi[ea.path[0]].push(e(ea))) : Qi.push(e(ea));
    return { formErrors: Qi, fieldErrors: Zi };
  }
  get formErrors() {
    return this.flatten();
  }
}
de.create = (Bi) => new de(Bi);
const pt = (Bi, e) => {
  let Zi;
  switch (Bi.code) {
    case g.invalid_type:
      Bi.received === O.undefined ? Zi = "Required" : Zi = `Expected ${Bi.expected}, received ${Bi.received}`;
      break;
    case g.invalid_literal:
      Zi = `Invalid literal value, expected ${JSON.stringify(Bi.expected, Q.jsonStringifyReplacer)}`;
      break;
    case g.unrecognized_keys:
      Zi = `Unrecognized key(s) in object: ${Q.joinValues(Bi.keys, ", ")}`;
      break;
    case g.invalid_union:
      Zi = "Invalid input";
      break;
    case g.invalid_union_discriminator:
      Zi = `Invalid discriminator value. Expected ${Q.joinValues(Bi.options)}`;
      break;
    case g.invalid_enum_value:
      Zi = `Invalid enum value. Expected ${Q.joinValues(Bi.options)}, received '${Bi.received}'`;
      break;
    case g.invalid_arguments:
      Zi = "Invalid function arguments";
      break;
    case g.invalid_return_type:
      Zi = "Invalid function return type";
      break;
    case g.invalid_date:
      Zi = "Invalid date";
      break;
    case g.invalid_string:
      typeof Bi.validation == "object" ? "includes" in Bi.validation ? (Zi = `Invalid input: must include "${Bi.validation.includes}"`, typeof Bi.validation.position == "number" && (Zi = `${Zi} at one or more positions greater than or equal to ${Bi.validation.position}`)) : "startsWith" in Bi.validation ? Zi = `Invalid input: must start with "${Bi.validation.startsWith}"` : "endsWith" in Bi.validation ? Zi = `Invalid input: must end with "${Bi.validation.endsWith}"` : Q.assertNever(Bi.validation) : Bi.validation !== "regex" ? Zi = `Invalid ${Bi.validation}` : Zi = "Invalid";
      break;
    case g.too_small:
      Bi.type === "array" ? Zi = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "more than"} ${Bi.minimum} element(s)` : Bi.type === "string" ? Zi = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "over"} ${Bi.minimum} character(s)` : Bi.type === "number" ? Zi = `Number must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${Bi.minimum}` : Bi.type === "date" ? Zi = `Date must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(Bi.minimum))}` : Zi = "Invalid input";
      break;
    case g.too_big:
      Bi.type === "array" ? Zi = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "less than"} ${Bi.maximum} element(s)` : Bi.type === "string" ? Zi = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "under"} ${Bi.maximum} character(s)` : Bi.type === "number" ? Zi = `Number must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "bigint" ? Zi = `BigInt must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "date" ? Zi = `Date must be ${Bi.exact ? "exactly" : Bi.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(Bi.maximum))}` : Zi = "Invalid input";
      break;
    case g.custom:
      Zi = "Invalid input";
      break;
    case g.invalid_intersection_types:
      Zi = "Intersection results could not be merged";
      break;
    case g.not_multiple_of:
      Zi = `Number must be a multiple of ${Bi.multipleOf}`;
      break;
    case g.not_finite:
      Zi = "Number must be finite";
      break;
    default:
      Zi = e.defaultError, Q.assertNever(Bi);
  }
  return { message: Zi };
};
let qa = pt;
function lc(Bi) {
  qa = Bi;
}
function ur() {
  return qa;
}
const cr = (Bi) => {
  const { data: e, path: Zi, errorMaps: Qi, issueData: ea } = Bi, ra = [...Zi, ...ea.path || []], na = {
    ...ea,
    path: ra
  };
  if (ea.message !== void 0)
    return {
      ...ea,
      path: ra,
      message: ea.message
    };
  let ia = "";
  const fa = Qi.filter((La) => !!La).slice().reverse();
  for (const La of fa)
    ia = La(na, { data: e, defaultError: ia }).message;
  return {
    ...ea,
    path: ra,
    message: ia
  };
}, fc = [];
function w(Bi, e) {
  const Zi = ur(), Qi = cr({
    issueData: e,
    data: Bi.data,
    path: Bi.path,
    errorMaps: [
      Bi.common.contextualErrorMap,
      // contextual error map is first priority
      Bi.schemaErrorMap,
      // then schema-bound map if available
      Zi,
      // then global override map
      Zi === pt ? void 0 : pt
      // then global default map
    ].filter((ea) => !!ea)
  });
  Bi.common.issues.push(Qi);
}
class oe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, Zi) {
    const Qi = [];
    for (const ea of Zi) {
      if (ea.status === "aborted")
        return A;
      ea.status === "dirty" && e.dirty(), Qi.push(ea.value);
    }
    return { status: e.value, value: Qi };
  }
  static async mergeObjectAsync(e, Zi) {
    const Qi = [];
    for (const ea of Zi) {
      const ra = await ea.key, na = await ea.value;
      Qi.push({
        key: ra,
        value: na
      });
    }
    return oe.mergeObjectSync(e, Qi);
  }
  static mergeObjectSync(e, Zi) {
    const Qi = {};
    for (const ea of Zi) {
      const { key: ra, value: na } = ea;
      if (ra.status === "aborted" || na.status === "aborted")
        return A;
      ra.status === "dirty" && e.dirty(), na.status === "dirty" && e.dirty(), ra.value !== "__proto__" && (typeof na.value < "u" || ea.alwaysSet) && (Qi[ra.value] = na.value);
    }
    return { status: e.value, value: Qi };
  }
}
const A = Object.freeze({
  status: "aborted"
}), st = (Bi) => ({ status: "dirty", value: Bi }), ce = (Bi) => ({ status: "valid", value: Bi }), pn = (Bi) => Bi.status === "aborted", yn = (Bi) => Bi.status === "dirty", Ye = (Bi) => Bi.status === "valid", Ct = (Bi) => typeof Promise < "u" && Bi instanceof Promise;
function lr(Bi, e, Zi, Qi) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(Bi);
}
function Qa(Bi, e, Zi, Qi, ea) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(Bi, Zi), Zi;
}
var T;
(function(Bi) {
  Bi.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, Bi.toString = (e) => typeof e == "string" ? e : e?.message;
})(T || (T = {}));
var St, Ot;
class Oe {
  constructor(e, Zi, Qi, ea) {
    this._cachedPath = [], this.parent = e, this.data = Zi, this._path = Qi, this._key = ea;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Ui = (Bi, e) => {
  if (Ye(e))
    return { success: !0, data: e.value };
  if (!Bi.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const Zi = new de(Bi.common.issues);
      return this._error = Zi, this._error;
    }
  };
};
function P(Bi) {
  if (!Bi)
    return {};
  const { errorMap: e, invalid_type_error: Zi, required_error: Qi, description: ea } = Bi;
  if (e && (Zi || Qi))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: ea } : { errorMap: (ra, na) => {
    var ia, fa;
    const { message: La } = Bi;
    return ra.code === "invalid_enum_value" ? { message: La ?? na.defaultError } : typeof na.data > "u" ? { message: (ia = La ?? Qi) !== null && ia !== void 0 ? ia : na.defaultError } : ra.code !== "invalid_type" ? { message: na.defaultError } : { message: (fa = La ?? Zi) !== null && fa !== void 0 ? fa : na.defaultError };
  }, description: ea };
}
class M {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Re(e.data);
  }
  _getOrReturnCtx(e, Zi) {
    return Zi || {
      common: e.parent.common,
      data: e.data,
      parsedType: Re(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new oe(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Re(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const Zi = this._parse(e);
    if (Ct(Zi))
      throw new Error("Synchronous parse encountered promise.");
    return Zi;
  }
  _parseAsync(e) {
    const Zi = this._parse(e);
    return Promise.resolve(Zi);
  }
  parse(e, Zi) {
    const Qi = this.safeParse(e, Zi);
    if (Qi.success)
      return Qi.data;
    throw Qi.error;
  }
  safeParse(e, Zi) {
    var Qi;
    const ea = {
      common: {
        issues: [],
        async: (Qi = Zi?.async) !== null && Qi !== void 0 ? Qi : !1,
        contextualErrorMap: Zi?.errorMap
      },
      path: Zi?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    }, ra = this._parseSync({ data: e, path: ea.path, parent: ea });
    return Ui(ea, ra);
  }
  "~validate"(e) {
    var Zi, Qi;
    const ea = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    };
    if (!this["~standard"].async)
      try {
        const ra = this._parseSync({ data: e, path: [], parent: ea });
        return Ye(ra) ? {
          value: ra.value
        } : {
          issues: ea.common.issues
        };
      } catch (ra) {
        !((Qi = (Zi = ra?.message) === null || Zi === void 0 ? void 0 : Zi.toLowerCase()) === null || Qi === void 0) && Qi.includes("encountered") && (this["~standard"].async = !0), ea.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: ea }).then((ra) => Ye(ra) ? {
      value: ra.value
    } : {
      issues: ea.common.issues
    });
  }
  async parseAsync(e, Zi) {
    const Qi = await this.safeParseAsync(e, Zi);
    if (Qi.success)
      return Qi.data;
    throw Qi.error;
  }
  async safeParseAsync(e, Zi) {
    const Qi = {
      common: {
        issues: [],
        contextualErrorMap: Zi?.errorMap,
        async: !0
      },
      path: Zi?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    }, ea = this._parse({ data: e, path: Qi.path, parent: Qi }), ra = await (Ct(ea) ? ea : Promise.resolve(ea));
    return Ui(Qi, ra);
  }
  refine(e, Zi) {
    const Qi = (ea) => typeof Zi == "string" || typeof Zi > "u" ? { message: Zi } : typeof Zi == "function" ? Zi(ea) : Zi;
    return this._refinement((ea, ra) => {
      const na = e(ea), ia = () => ra.addIssue({
        code: g.custom,
        ...Qi(ea)
      });
      return typeof Promise < "u" && na instanceof Promise ? na.then((fa) => fa ? !0 : (ia(), !1)) : na ? !0 : (ia(), !1);
    });
  }
  refinement(e, Zi) {
    return this._refinement((Qi, ea) => e(Qi) ? !0 : (ea.addIssue(typeof Zi == "function" ? Zi(Qi, ea) : Zi), !1));
  }
  _refinement(e) {
    return new ge({
      schema: this,
      typeName: C.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (Zi) => this["~validate"](Zi)
    };
  }
  optional() {
    return Se.create(this, this._def);
  }
  nullable() {
    return Ze.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return me.create(this);
  }
  promise() {
    return vt.create(this, this._def);
  }
  or(e) {
    return Ft.create([this, e], this._def);
  }
  and(e) {
    return Mt.create(this, e, this._def);
  }
  transform(e) {
    return new ge({
      ...P(this._def),
      schema: this,
      typeName: C.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const Zi = typeof e == "function" ? e : () => e;
    return new Bt({
      ...P(this._def),
      innerType: this,
      defaultValue: Zi,
      typeName: C.ZodDefault
    });
  }
  brand() {
    return new Zn({
      typeName: C.ZodBranded,
      type: this,
      ...P(this._def)
    });
  }
  catch(e) {
    const Zi = typeof e == "function" ? e : () => e;
    return new Zt({
      ...P(this._def),
      innerType: this,
      catchValue: Zi,
      typeName: C.ZodCatch
    });
  }
  describe(e) {
    const Zi = this.constructor;
    return new Zi({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Wt.create(this, e);
  }
  readonly() {
    return Ut.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const dc = /^c[^\s-]{8,}$/i, hc = /^[0-9a-z]+$/, pc = /^[0-9A-HJKMNP-TV-Z]{26}$/i, yc = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, vc = /^[a-z0-9_-]{21}$/i, mc = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, gc = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, bc = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, _c = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let qr;
const wc = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, kc = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Ec = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Sc = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Oc = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, xc = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ba = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Tc = new RegExp(`^${Ba}$`);
function Za(Bi) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return Bi.precision ? e = `${e}\\.\\d{${Bi.precision}}` : Bi.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function Dc(Bi) {
  return new RegExp(`^${Za(Bi)}$`);
}
function Ua(Bi) {
  let e = `${Ba}T${Za(Bi)}`;
  const Zi = [];
  return Zi.push(Bi.local ? "Z?" : "Z"), Bi.offset && Zi.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${Zi.join("|")})`, new RegExp(`^${e}$`);
}
function Ic(Bi, e) {
  return !!((e === "v4" || !e) && wc.test(Bi) || (e === "v6" || !e) && Ec.test(Bi));
}
function Rc(Bi, e) {
  if (!mc.test(Bi))
    return !1;
  try {
    const [Zi] = Bi.split("."), Qi = Zi.replace(/-/g, "+").replace(/_/g, "/").padEnd(Zi.length + (4 - Zi.length % 4) % 4, "="), ea = JSON.parse(atob(Qi));
    return !(typeof ea != "object" || ea === null || !ea.typ || !ea.alg || e && ea.alg !== e);
  } catch {
    return !1;
  }
}
function jc(Bi, e) {
  return !!((e === "v4" || !e) && kc.test(Bi) || (e === "v6" || !e) && Sc.test(Bi));
}
class ve extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== O.string) {
      const ea = this._getOrReturnCtx(e);
      return w(ea, {
        code: g.invalid_type,
        expected: O.string,
        received: ea.parsedType
      }), A;
    }
    const Zi = new oe();
    let Qi;
    for (const ea of this._def.checks)
      if (ea.kind === "min")
        e.data.length < ea.value && (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
          code: g.too_small,
          minimum: ea.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "max")
        e.data.length > ea.value && (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
          code: g.too_big,
          maximum: ea.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "length") {
        const ra = e.data.length > ea.value, na = e.data.length < ea.value;
        (ra || na) && (Qi = this._getOrReturnCtx(e, Qi), ra ? w(Qi, {
          code: g.too_big,
          maximum: ea.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: ea.message
        }) : na && w(Qi, {
          code: g.too_small,
          minimum: ea.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: ea.message
        }), Zi.dirty());
      } else if (ea.kind === "email")
        bc.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
          validation: "email",
          code: g.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "emoji")
        qr || (qr = new RegExp(_c, "u")), qr.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
          validation: "emoji",
          code: g.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "uuid")
        yc.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
          validation: "uuid",
          code: g.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "nanoid")
        vc.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
          validation: "nanoid",
          code: g.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "cuid")
        dc.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
          validation: "cuid",
          code: g.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "cuid2")
        hc.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
          validation: "cuid2",
          code: g.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "ulid")
        pc.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
          validation: "ulid",
          code: g.invalid_string,
          message: ea.message
        }), Zi.dirty());
      else if (ea.kind === "url")
        try {
          new URL(e.data);
        } catch {
          Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
            validation: "url",
            code: g.invalid_string,
            message: ea.message
          }), Zi.dirty();
        }
      else ea.kind === "regex" ? (ea.regex.lastIndex = 0, ea.regex.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        validation: "regex",
        code: g.invalid_string,
        message: ea.message
      }), Zi.dirty())) : ea.kind === "trim" ? e.data = e.data.trim() : ea.kind === "includes" ? e.data.includes(ea.value, ea.position) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        code: g.invalid_string,
        validation: { includes: ea.value, position: ea.position },
        message: ea.message
      }), Zi.dirty()) : ea.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : ea.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : ea.kind === "startsWith" ? e.data.startsWith(ea.value) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        code: g.invalid_string,
        validation: { startsWith: ea.value },
        message: ea.message
      }), Zi.dirty()) : ea.kind === "endsWith" ? e.data.endsWith(ea.value) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        code: g.invalid_string,
        validation: { endsWith: ea.value },
        message: ea.message
      }), Zi.dirty()) : ea.kind === "datetime" ? Ua(ea).test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        code: g.invalid_string,
        validation: "datetime",
        message: ea.message
      }), Zi.dirty()) : ea.kind === "date" ? Tc.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        code: g.invalid_string,
        validation: "date",
        message: ea.message
      }), Zi.dirty()) : ea.kind === "time" ? Dc(ea).test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        code: g.invalid_string,
        validation: "time",
        message: ea.message
      }), Zi.dirty()) : ea.kind === "duration" ? gc.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        validation: "duration",
        code: g.invalid_string,
        message: ea.message
      }), Zi.dirty()) : ea.kind === "ip" ? Ic(e.data, ea.version) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        validation: "ip",
        code: g.invalid_string,
        message: ea.message
      }), Zi.dirty()) : ea.kind === "jwt" ? Rc(e.data, ea.alg) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        validation: "jwt",
        code: g.invalid_string,
        message: ea.message
      }), Zi.dirty()) : ea.kind === "cidr" ? jc(e.data, ea.version) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        validation: "cidr",
        code: g.invalid_string,
        message: ea.message
      }), Zi.dirty()) : ea.kind === "base64" ? Oc.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        validation: "base64",
        code: g.invalid_string,
        message: ea.message
      }), Zi.dirty()) : ea.kind === "base64url" ? xc.test(e.data) || (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        validation: "base64url",
        code: g.invalid_string,
        message: ea.message
      }), Zi.dirty()) : Q.assertNever(ea);
    return { status: Zi.value, value: e.data };
  }
  _regex(e, Zi, Qi) {
    return this.refinement((ea) => e.test(ea), {
      validation: Zi,
      code: g.invalid_string,
      ...T.errToObj(Qi)
    });
  }
  _addCheck(e) {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...T.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...T.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...T.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...T.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...T.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...T.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...T.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...T.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...T.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...T.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...T.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...T.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...T.errToObj(e) });
  }
  datetime(e) {
    var Zi, Qi;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: (Zi = e?.offset) !== null && Zi !== void 0 ? Zi : !1,
      local: (Qi = e?.local) !== null && Qi !== void 0 ? Qi : !1,
      ...T.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...T.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...T.errToObj(e) });
  }
  regex(e, Zi) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...T.errToObj(Zi)
    });
  }
  includes(e, Zi) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: Zi?.position,
      ...T.errToObj(Zi?.message)
    });
  }
  startsWith(e, Zi) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...T.errToObj(Zi)
    });
  }
  endsWith(e, Zi) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...T.errToObj(Zi)
    });
  }
  min(e, Zi) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...T.errToObj(Zi)
    });
  }
  max(e, Zi) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...T.errToObj(Zi)
    });
  }
  length(e, Zi) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...T.errToObj(Zi)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, T.errToObj(e));
  }
  trim() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "min" && (e === null || Zi.value > e) && (e = Zi.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "max" && (e === null || Zi.value < e) && (e = Zi.value);
    return e;
  }
}
ve.create = (Bi) => {
  var e;
  return new ve({
    checks: [],
    typeName: C.ZodString,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ...P(Bi)
  });
};
function Cc(Bi, e) {
  const Zi = (Bi.toString().split(".")[1] || "").length, Qi = (e.toString().split(".")[1] || "").length, ea = Zi > Qi ? Zi : Qi, ra = parseInt(Bi.toFixed(ea).replace(".", "")), na = parseInt(e.toFixed(ea).replace(".", ""));
  return ra % na / Math.pow(10, ea);
}
class qe extends M {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== O.number) {
      const ea = this._getOrReturnCtx(e);
      return w(ea, {
        code: g.invalid_type,
        expected: O.number,
        received: ea.parsedType
      }), A;
    }
    let Zi;
    const Qi = new oe();
    for (const ea of this._def.checks)
      ea.kind === "int" ? Q.isInteger(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.invalid_type,
        expected: "integer",
        received: "float",
        message: ea.message
      }), Qi.dirty()) : ea.kind === "min" ? (ea.inclusive ? e.data < ea.value : e.data <= ea.value) && (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.too_small,
        minimum: ea.value,
        type: "number",
        inclusive: ea.inclusive,
        exact: !1,
        message: ea.message
      }), Qi.dirty()) : ea.kind === "max" ? (ea.inclusive ? e.data > ea.value : e.data >= ea.value) && (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.too_big,
        maximum: ea.value,
        type: "number",
        inclusive: ea.inclusive,
        exact: !1,
        message: ea.message
      }), Qi.dirty()) : ea.kind === "multipleOf" ? Cc(e.data, ea.value) !== 0 && (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.not_multiple_of,
        multipleOf: ea.value,
        message: ea.message
      }), Qi.dirty()) : ea.kind === "finite" ? Number.isFinite(e.data) || (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.not_finite,
        message: ea.message
      }), Qi.dirty()) : Q.assertNever(ea);
    return { status: Qi.value, value: e.data };
  }
  gte(e, Zi) {
    return this.setLimit("min", e, !0, T.toString(Zi));
  }
  gt(e, Zi) {
    return this.setLimit("min", e, !1, T.toString(Zi));
  }
  lte(e, Zi) {
    return this.setLimit("max", e, !0, T.toString(Zi));
  }
  lt(e, Zi) {
    return this.setLimit("max", e, !1, T.toString(Zi));
  }
  setLimit(e, Zi, Qi, ea) {
    return new qe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: Zi,
          inclusive: Qi,
          message: T.toString(ea)
        }
      ]
    });
  }
  _addCheck(e) {
    return new qe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: T.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: T.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: T.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: T.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: T.toString(e)
    });
  }
  multipleOf(e, Zi) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: T.toString(Zi)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: T.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: T.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: T.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "min" && (e === null || Zi.value > e) && (e = Zi.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "max" && (e === null || Zi.value < e) && (e = Zi.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && Q.isInteger(e.value));
  }
  get isFinite() {
    let e = null, Zi = null;
    for (const Qi of this._def.checks) {
      if (Qi.kind === "finite" || Qi.kind === "int" || Qi.kind === "multipleOf")
        return !0;
      Qi.kind === "min" ? (Zi === null || Qi.value > Zi) && (Zi = Qi.value) : Qi.kind === "max" && (e === null || Qi.value < e) && (e = Qi.value);
    }
    return Number.isFinite(Zi) && Number.isFinite(e);
  }
}
qe.create = (Bi) => new qe({
  checks: [],
  typeName: C.ZodNumber,
  coerce: Bi?.coerce || !1,
  ...P(Bi)
});
class Qe extends M {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== O.bigint)
      return this._getInvalidInput(e);
    let Zi;
    const Qi = new oe();
    for (const ea of this._def.checks)
      ea.kind === "min" ? (ea.inclusive ? e.data < ea.value : e.data <= ea.value) && (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.too_small,
        type: "bigint",
        minimum: ea.value,
        inclusive: ea.inclusive,
        message: ea.message
      }), Qi.dirty()) : ea.kind === "max" ? (ea.inclusive ? e.data > ea.value : e.data >= ea.value) && (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.too_big,
        type: "bigint",
        maximum: ea.value,
        inclusive: ea.inclusive,
        message: ea.message
      }), Qi.dirty()) : ea.kind === "multipleOf" ? e.data % ea.value !== BigInt(0) && (Zi = this._getOrReturnCtx(e, Zi), w(Zi, {
        code: g.not_multiple_of,
        multipleOf: ea.value,
        message: ea.message
      }), Qi.dirty()) : Q.assertNever(ea);
    return { status: Qi.value, value: e.data };
  }
  _getInvalidInput(e) {
    const Zi = this._getOrReturnCtx(e);
    return w(Zi, {
      code: g.invalid_type,
      expected: O.bigint,
      received: Zi.parsedType
    }), A;
  }
  gte(e, Zi) {
    return this.setLimit("min", e, !0, T.toString(Zi));
  }
  gt(e, Zi) {
    return this.setLimit("min", e, !1, T.toString(Zi));
  }
  lte(e, Zi) {
    return this.setLimit("max", e, !0, T.toString(Zi));
  }
  lt(e, Zi) {
    return this.setLimit("max", e, !1, T.toString(Zi));
  }
  setLimit(e, Zi, Qi, ea) {
    return new Qe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: Zi,
          inclusive: Qi,
          message: T.toString(ea)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Qe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: T.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: T.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: T.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: T.toString(e)
    });
  }
  multipleOf(e, Zi) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: T.toString(Zi)
    });
  }
  get minValue() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "min" && (e === null || Zi.value > e) && (e = Zi.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "max" && (e === null || Zi.value < e) && (e = Zi.value);
    return e;
  }
}
Qe.create = (Bi) => {
  var e;
  return new Qe({
    checks: [],
    typeName: C.ZodBigInt,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ...P(Bi)
  });
};
class At extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== O.boolean) {
      const Zi = this._getOrReturnCtx(e);
      return w(Zi, {
        code: g.invalid_type,
        expected: O.boolean,
        received: Zi.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
At.create = (Bi) => new At({
  typeName: C.ZodBoolean,
  coerce: Bi?.coerce || !1,
  ...P(Bi)
});
class Ke extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== O.date) {
      const ea = this._getOrReturnCtx(e);
      return w(ea, {
        code: g.invalid_type,
        expected: O.date,
        received: ea.parsedType
      }), A;
    }
    if (isNaN(e.data.getTime())) {
      const ea = this._getOrReturnCtx(e);
      return w(ea, {
        code: g.invalid_date
      }), A;
    }
    const Zi = new oe();
    let Qi;
    for (const ea of this._def.checks)
      ea.kind === "min" ? e.data.getTime() < ea.value && (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        code: g.too_small,
        message: ea.message,
        inclusive: !0,
        exact: !1,
        minimum: ea.value,
        type: "date"
      }), Zi.dirty()) : ea.kind === "max" ? e.data.getTime() > ea.value && (Qi = this._getOrReturnCtx(e, Qi), w(Qi, {
        code: g.too_big,
        message: ea.message,
        inclusive: !0,
        exact: !1,
        maximum: ea.value,
        type: "date"
      }), Zi.dirty()) : Q.assertNever(ea);
    return {
      status: Zi.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Ke({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, Zi) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: T.toString(Zi)
    });
  }
  max(e, Zi) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: T.toString(Zi)
    });
  }
  get minDate() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "min" && (e === null || Zi.value > e) && (e = Zi.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const Zi of this._def.checks)
      Zi.kind === "max" && (e === null || Zi.value < e) && (e = Zi.value);
    return e != null ? new Date(e) : null;
  }
}
Ke.create = (Bi) => new Ke({
  checks: [],
  coerce: Bi?.coerce || !1,
  typeName: C.ZodDate,
  ...P(Bi)
});
class fr extends M {
  _parse(e) {
    if (this._getType(e) !== O.symbol) {
      const Zi = this._getOrReturnCtx(e);
      return w(Zi, {
        code: g.invalid_type,
        expected: O.symbol,
        received: Zi.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
fr.create = (Bi) => new fr({
  typeName: C.ZodSymbol,
  ...P(Bi)
});
class Nt extends M {
  _parse(e) {
    if (this._getType(e) !== O.undefined) {
      const Zi = this._getOrReturnCtx(e);
      return w(Zi, {
        code: g.invalid_type,
        expected: O.undefined,
        received: Zi.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
Nt.create = (Bi) => new Nt({
  typeName: C.ZodUndefined,
  ...P(Bi)
});
class Pt extends M {
  _parse(e) {
    if (this._getType(e) !== O.null) {
      const Zi = this._getOrReturnCtx(e);
      return w(Zi, {
        code: g.invalid_type,
        expected: O.null,
        received: Zi.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
Pt.create = (Bi) => new Pt({
  typeName: C.ZodNull,
  ...P(Bi)
});
class yt extends M {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return ce(e.data);
  }
}
yt.create = (Bi) => new yt({
  typeName: C.ZodAny,
  ...P(Bi)
});
class Ge extends M {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return ce(e.data);
  }
}
Ge.create = (Bi) => new Ge({
  typeName: C.ZodUnknown,
  ...P(Bi)
});
class Ce extends M {
  _parse(e) {
    const Zi = this._getOrReturnCtx(e);
    return w(Zi, {
      code: g.invalid_type,
      expected: O.never,
      received: Zi.parsedType
    }), A;
  }
}
Ce.create = (Bi) => new Ce({
  typeName: C.ZodNever,
  ...P(Bi)
});
class dr extends M {
  _parse(e) {
    if (this._getType(e) !== O.undefined) {
      const Zi = this._getOrReturnCtx(e);
      return w(Zi, {
        code: g.invalid_type,
        expected: O.void,
        received: Zi.parsedType
      }), A;
    }
    return ce(e.data);
  }
}
dr.create = (Bi) => new dr({
  typeName: C.ZodVoid,
  ...P(Bi)
});
class me extends M {
  _parse(e) {
    const { ctx: Zi, status: Qi } = this._processInputParams(e), ea = this._def;
    if (Zi.parsedType !== O.array)
      return w(Zi, {
        code: g.invalid_type,
        expected: O.array,
        received: Zi.parsedType
      }), A;
    if (ea.exactLength !== null) {
      const na = Zi.data.length > ea.exactLength.value, ia = Zi.data.length < ea.exactLength.value;
      (na || ia) && (w(Zi, {
        code: na ? g.too_big : g.too_small,
        minimum: ia ? ea.exactLength.value : void 0,
        maximum: na ? ea.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: ea.exactLength.message
      }), Qi.dirty());
    }
    if (ea.minLength !== null && Zi.data.length < ea.minLength.value && (w(Zi, {
      code: g.too_small,
      minimum: ea.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: ea.minLength.message
    }), Qi.dirty()), ea.maxLength !== null && Zi.data.length > ea.maxLength.value && (w(Zi, {
      code: g.too_big,
      maximum: ea.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: ea.maxLength.message
    }), Qi.dirty()), Zi.common.async)
      return Promise.all([...Zi.data].map((na, ia) => ea.type._parseAsync(new Oe(Zi, na, Zi.path, ia)))).then((na) => oe.mergeArray(Qi, na));
    const ra = [...Zi.data].map((na, ia) => ea.type._parseSync(new Oe(Zi, na, Zi.path, ia)));
    return oe.mergeArray(Qi, ra);
  }
  get element() {
    return this._def.type;
  }
  min(e, Zi) {
    return new me({
      ...this._def,
      minLength: { value: e, message: T.toString(Zi) }
    });
  }
  max(e, Zi) {
    return new me({
      ...this._def,
      maxLength: { value: e, message: T.toString(Zi) }
    });
  }
  length(e, Zi) {
    return new me({
      ...this._def,
      exactLength: { value: e, message: T.toString(Zi) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
me.create = (Bi, e) => new me({
  type: Bi,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: C.ZodArray,
  ...P(e)
});
function nt(Bi) {
  if (Bi instanceof H) {
    const e = {};
    for (const Zi in Bi.shape) {
      const Qi = Bi.shape[Zi];
      e[Zi] = Se.create(nt(Qi));
    }
    return new H({
      ...Bi._def,
      shape: () => e
    });
  } else return Bi instanceof me ? new me({
    ...Bi._def,
    type: nt(Bi.element)
  }) : Bi instanceof Se ? Se.create(nt(Bi.unwrap())) : Bi instanceof Ze ? Ze.create(nt(Bi.unwrap())) : Bi instanceof xe ? xe.create(Bi.items.map((e) => nt(e))) : Bi;
}
class H extends M {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), Zi = Q.objectKeys(e);
    return this._cached = { shape: e, keys: Zi };
  }
  _parse(e) {
    if (this._getType(e) !== O.object) {
      const fa = this._getOrReturnCtx(e);
      return w(fa, {
        code: g.invalid_type,
        expected: O.object,
        received: fa.parsedType
      }), A;
    }
    const { status: Zi, ctx: Qi } = this._processInputParams(e), { shape: ea, keys: ra } = this._getCached(), na = [];
    if (!(this._def.catchall instanceof Ce && this._def.unknownKeys === "strip"))
      for (const fa in Qi.data)
        ra.includes(fa) || na.push(fa);
    const ia = [];
    for (const fa of ra) {
      const La = ea[fa], Va = Qi.data[fa];
      ia.push({
        key: { status: "valid", value: fa },
        value: La._parse(new Oe(Qi, Va, Qi.path, fa)),
        alwaysSet: fa in Qi.data
      });
    }
    if (this._def.catchall instanceof Ce) {
      const fa = this._def.unknownKeys;
      if (fa === "passthrough")
        for (const La of na)
          ia.push({
            key: { status: "valid", value: La },
            value: { status: "valid", value: Qi.data[La] }
          });
      else if (fa === "strict")
        na.length > 0 && (w(Qi, {
          code: g.unrecognized_keys,
          keys: na
        }), Zi.dirty());
      else if (fa !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const fa = this._def.catchall;
      for (const La of na) {
        const Va = Qi.data[La];
        ia.push({
          key: { status: "valid", value: La },
          value: fa._parse(
            new Oe(Qi, Va, Qi.path, La)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: La in Qi.data
        });
      }
    }
    return Qi.common.async ? Promise.resolve().then(async () => {
      const fa = [];
      for (const La of ia) {
        const Va = await La.key, to = await La.value;
        fa.push({
          key: Va,
          value: to,
          alwaysSet: La.alwaysSet
        });
      }
      return fa;
    }).then((fa) => oe.mergeObjectSync(Zi, fa)) : oe.mergeObjectSync(Zi, ia);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return T.errToObj, new H({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (Zi, Qi) => {
          var ea, ra, na, ia;
          const fa = (na = (ra = (ea = this._def).errorMap) === null || ra === void 0 ? void 0 : ra.call(ea, Zi, Qi).message) !== null && na !== void 0 ? na : Qi.defaultError;
          return Zi.code === "unrecognized_keys" ? {
            message: (ia = T.errToObj(e).message) !== null && ia !== void 0 ? ia : fa
          } : {
            message: fa
          };
        }
      } : {}
    });
  }
  strip() {
    return new H({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new H({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new H({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new H({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: C.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, Zi) {
    return this.augment({ [e]: Zi });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new H({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const Zi = {};
    return Q.objectKeys(e).forEach((Qi) => {
      e[Qi] && this.shape[Qi] && (Zi[Qi] = this.shape[Qi]);
    }), new H({
      ...this._def,
      shape: () => Zi
    });
  }
  omit(e) {
    const Zi = {};
    return Q.objectKeys(this.shape).forEach((Qi) => {
      e[Qi] || (Zi[Qi] = this.shape[Qi]);
    }), new H({
      ...this._def,
      shape: () => Zi
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return nt(this);
  }
  partial(e) {
    const Zi = {};
    return Q.objectKeys(this.shape).forEach((Qi) => {
      const ea = this.shape[Qi];
      e && !e[Qi] ? Zi[Qi] = ea : Zi[Qi] = ea.optional();
    }), new H({
      ...this._def,
      shape: () => Zi
    });
  }
  required(e) {
    const Zi = {};
    return Q.objectKeys(this.shape).forEach((Qi) => {
      if (e && !e[Qi])
        Zi[Qi] = this.shape[Qi];
      else {
        let ea = this.shape[Qi];
        for (; ea instanceof Se; )
          ea = ea._def.innerType;
        Zi[Qi] = ea;
      }
    }), new H({
      ...this._def,
      shape: () => Zi
    });
  }
  keyof() {
    return za(Q.objectKeys(this.shape));
  }
}
H.create = (Bi, e) => new H({
  shape: () => Bi,
  unknownKeys: "strip",
  catchall: Ce.create(),
  typeName: C.ZodObject,
  ...P(e)
});
H.strictCreate = (Bi, e) => new H({
  shape: () => Bi,
  unknownKeys: "strict",
  catchall: Ce.create(),
  typeName: C.ZodObject,
  ...P(e)
});
H.lazycreate = (Bi, e) => new H({
  shape: Bi,
  unknownKeys: "strip",
  catchall: Ce.create(),
  typeName: C.ZodObject,
  ...P(e)
});
class Ft extends M {
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e), Qi = this._def.options;
    function ea(ra) {
      for (const ia of ra)
        if (ia.result.status === "valid")
          return ia.result;
      for (const ia of ra)
        if (ia.result.status === "dirty")
          return Zi.common.issues.push(...ia.ctx.common.issues), ia.result;
      const na = ra.map((ia) => new de(ia.ctx.common.issues));
      return w(Zi, {
        code: g.invalid_union,
        unionErrors: na
      }), A;
    }
    if (Zi.common.async)
      return Promise.all(Qi.map(async (ra) => {
        const na = {
          ...Zi,
          common: {
            ...Zi.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await ra._parseAsync({
            data: Zi.data,
            path: Zi.path,
            parent: na
          }),
          ctx: na
        };
      })).then(ea);
    {
      let ra;
      const na = [];
      for (const fa of Qi) {
        const La = {
          ...Zi,
          common: {
            ...Zi.common,
            issues: []
          },
          parent: null
        }, Va = fa._parseSync({
          data: Zi.data,
          path: Zi.path,
          parent: La
        });
        if (Va.status === "valid")
          return Va;
        Va.status === "dirty" && !ra && (ra = { result: Va, ctx: La }), La.common.issues.length && na.push(La.common.issues);
      }
      if (ra)
        return Zi.common.issues.push(...ra.ctx.common.issues), ra.result;
      const ia = na.map((fa) => new de(fa));
      return w(Zi, {
        code: g.invalid_union,
        unionErrors: ia
      }), A;
    }
  }
  get options() {
    return this._def.options;
  }
}
Ft.create = (Bi, e) => new Ft({
  options: Bi,
  typeName: C.ZodUnion,
  ...P(e)
});
const Ie = (Bi) => Bi instanceof Lt ? Ie(Bi.schema) : Bi instanceof ge ? Ie(Bi.innerType()) : Bi instanceof qt ? [Bi.value] : Bi instanceof Be ? Bi.options : Bi instanceof Qt ? Q.objectValues(Bi.enum) : Bi instanceof Bt ? Ie(Bi._def.innerType) : Bi instanceof Nt ? [void 0] : Bi instanceof Pt ? [null] : Bi instanceof Se ? [void 0, ...Ie(Bi.unwrap())] : Bi instanceof Ze ? [null, ...Ie(Bi.unwrap())] : Bi instanceof Zn || Bi instanceof Ut ? Ie(Bi.unwrap()) : Bi instanceof Zt ? Ie(Bi._def.innerType) : [];
class Er extends M {
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== O.object)
      return w(Zi, {
        code: g.invalid_type,
        expected: O.object,
        received: Zi.parsedType
      }), A;
    const Qi = this.discriminator, ea = Zi.data[Qi], ra = this.optionsMap.get(ea);
    return ra ? Zi.common.async ? ra._parseAsync({
      data: Zi.data,
      path: Zi.path,
      parent: Zi
    }) : ra._parseSync({
      data: Zi.data,
      path: Zi.path,
      parent: Zi
    }) : (w(Zi, {
      code: g.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [Qi]
    }), A);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, Zi, Qi) {
    const ea = /* @__PURE__ */ new Map();
    for (const ra of Zi) {
      const na = Ie(ra.shape[e]);
      if (!na.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const ia of na) {
        if (ea.has(ia))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(ia)}`);
        ea.set(ia, ra);
      }
    }
    return new Er({
      typeName: C.ZodDiscriminatedUnion,
      discriminator: e,
      options: Zi,
      optionsMap: ea,
      ...P(Qi)
    });
  }
}
function vn(Bi, e) {
  const Zi = Re(Bi), Qi = Re(e);
  if (Bi === e)
    return { valid: !0, data: Bi };
  if (Zi === O.object && Qi === O.object) {
    const ea = Q.objectKeys(e), ra = Q.objectKeys(Bi).filter((ia) => ea.indexOf(ia) !== -1), na = { ...Bi, ...e };
    for (const ia of ra) {
      const fa = vn(Bi[ia], e[ia]);
      if (!fa.valid)
        return { valid: !1 };
      na[ia] = fa.data;
    }
    return { valid: !0, data: na };
  } else if (Zi === O.array && Qi === O.array) {
    if (Bi.length !== e.length)
      return { valid: !1 };
    const ea = [];
    for (let ra = 0; ra < Bi.length; ra++) {
      const na = Bi[ra], ia = e[ra], fa = vn(na, ia);
      if (!fa.valid)
        return { valid: !1 };
      ea.push(fa.data);
    }
    return { valid: !0, data: ea };
  } else return Zi === O.date && Qi === O.date && +Bi == +e ? { valid: !0, data: Bi } : { valid: !1 };
}
class Mt extends M {
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e), ea = (ra, na) => {
      if (pn(ra) || pn(na))
        return A;
      const ia = vn(ra.value, na.value);
      return ia.valid ? ((yn(ra) || yn(na)) && Zi.dirty(), { status: Zi.value, value: ia.data }) : (w(Qi, {
        code: g.invalid_intersection_types
      }), A);
    };
    return Qi.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: Qi.data,
        path: Qi.path,
        parent: Qi
      }),
      this._def.right._parseAsync({
        data: Qi.data,
        path: Qi.path,
        parent: Qi
      })
    ]).then(([ra, na]) => ea(ra, na)) : ea(this._def.left._parseSync({
      data: Qi.data,
      path: Qi.path,
      parent: Qi
    }), this._def.right._parseSync({
      data: Qi.data,
      path: Qi.path,
      parent: Qi
    }));
  }
}
Mt.create = (Bi, e, Zi) => new Mt({
  left: Bi,
  right: e,
  typeName: C.ZodIntersection,
  ...P(Zi)
});
class xe extends M {
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e);
    if (Qi.parsedType !== O.array)
      return w(Qi, {
        code: g.invalid_type,
        expected: O.array,
        received: Qi.parsedType
      }), A;
    if (Qi.data.length < this._def.items.length)
      return w(Qi, {
        code: g.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), A;
    !this._def.rest && Qi.data.length > this._def.items.length && (w(Qi, {
      code: g.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), Zi.dirty());
    const ea = [...Qi.data].map((ra, na) => {
      const ia = this._def.items[na] || this._def.rest;
      return ia ? ia._parse(new Oe(Qi, ra, Qi.path, na)) : null;
    }).filter((ra) => !!ra);
    return Qi.common.async ? Promise.all(ea).then((ra) => oe.mergeArray(Zi, ra)) : oe.mergeArray(Zi, ea);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new xe({
      ...this._def,
      rest: e
    });
  }
}
xe.create = (Bi, e) => {
  if (!Array.isArray(Bi))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new xe({
    items: Bi,
    typeName: C.ZodTuple,
    rest: null,
    ...P(e)
  });
};
class Vt extends M {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e);
    if (Qi.parsedType !== O.object)
      return w(Qi, {
        code: g.invalid_type,
        expected: O.object,
        received: Qi.parsedType
      }), A;
    const ea = [], ra = this._def.keyType, na = this._def.valueType;
    for (const ia in Qi.data)
      ea.push({
        key: ra._parse(new Oe(Qi, ia, Qi.path, ia)),
        value: na._parse(new Oe(Qi, Qi.data[ia], Qi.path, ia)),
        alwaysSet: ia in Qi.data
      });
    return Qi.common.async ? oe.mergeObjectAsync(Zi, ea) : oe.mergeObjectSync(Zi, ea);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, Zi, Qi) {
    return Zi instanceof M ? new Vt({
      keyType: e,
      valueType: Zi,
      typeName: C.ZodRecord,
      ...P(Qi)
    }) : new Vt({
      keyType: ve.create(),
      valueType: e,
      typeName: C.ZodRecord,
      ...P(Zi)
    });
  }
}
class hr extends M {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e);
    if (Qi.parsedType !== O.map)
      return w(Qi, {
        code: g.invalid_type,
        expected: O.map,
        received: Qi.parsedType
      }), A;
    const ea = this._def.keyType, ra = this._def.valueType, na = [...Qi.data.entries()].map(([ia, fa], La) => ({
      key: ea._parse(new Oe(Qi, ia, Qi.path, [La, "key"])),
      value: ra._parse(new Oe(Qi, fa, Qi.path, [La, "value"]))
    }));
    if (Qi.common.async) {
      const ia = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const fa of na) {
          const La = await fa.key, Va = await fa.value;
          if (La.status === "aborted" || Va.status === "aborted")
            return A;
          (La.status === "dirty" || Va.status === "dirty") && Zi.dirty(), ia.set(La.value, Va.value);
        }
        return { status: Zi.value, value: ia };
      });
    } else {
      const ia = /* @__PURE__ */ new Map();
      for (const fa of na) {
        const La = fa.key, Va = fa.value;
        if (La.status === "aborted" || Va.status === "aborted")
          return A;
        (La.status === "dirty" || Va.status === "dirty") && Zi.dirty(), ia.set(La.value, Va.value);
      }
      return { status: Zi.value, value: ia };
    }
  }
}
hr.create = (Bi, e, Zi) => new hr({
  valueType: e,
  keyType: Bi,
  typeName: C.ZodMap,
  ...P(Zi)
});
class Xe extends M {
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e);
    if (Qi.parsedType !== O.set)
      return w(Qi, {
        code: g.invalid_type,
        expected: O.set,
        received: Qi.parsedType
      }), A;
    const ea = this._def;
    ea.minSize !== null && Qi.data.size < ea.minSize.value && (w(Qi, {
      code: g.too_small,
      minimum: ea.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: ea.minSize.message
    }), Zi.dirty()), ea.maxSize !== null && Qi.data.size > ea.maxSize.value && (w(Qi, {
      code: g.too_big,
      maximum: ea.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: ea.maxSize.message
    }), Zi.dirty());
    const ra = this._def.valueType;
    function na(fa) {
      const La = /* @__PURE__ */ new Set();
      for (const Va of fa) {
        if (Va.status === "aborted")
          return A;
        Va.status === "dirty" && Zi.dirty(), La.add(Va.value);
      }
      return { status: Zi.value, value: La };
    }
    const ia = [...Qi.data.values()].map((fa, La) => ra._parse(new Oe(Qi, fa, Qi.path, La)));
    return Qi.common.async ? Promise.all(ia).then((fa) => na(fa)) : na(ia);
  }
  min(e, Zi) {
    return new Xe({
      ...this._def,
      minSize: { value: e, message: T.toString(Zi) }
    });
  }
  max(e, Zi) {
    return new Xe({
      ...this._def,
      maxSize: { value: e, message: T.toString(Zi) }
    });
  }
  size(e, Zi) {
    return this.min(e, Zi).max(e, Zi);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Xe.create = (Bi, e) => new Xe({
  valueType: Bi,
  minSize: null,
  maxSize: null,
  typeName: C.ZodSet,
  ...P(e)
});
class ct extends M {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== O.function)
      return w(Zi, {
        code: g.invalid_type,
        expected: O.function,
        received: Zi.parsedType
      }), A;
    function Qi(ia, fa) {
      return cr({
        data: ia,
        path: Zi.path,
        errorMaps: [
          Zi.common.contextualErrorMap,
          Zi.schemaErrorMap,
          ur(),
          pt
        ].filter((La) => !!La),
        issueData: {
          code: g.invalid_arguments,
          argumentsError: fa
        }
      });
    }
    function ea(ia, fa) {
      return cr({
        data: ia,
        path: Zi.path,
        errorMaps: [
          Zi.common.contextualErrorMap,
          Zi.schemaErrorMap,
          ur(),
          pt
        ].filter((La) => !!La),
        issueData: {
          code: g.invalid_return_type,
          returnTypeError: fa
        }
      });
    }
    const ra = { errorMap: Zi.common.contextualErrorMap }, na = Zi.data;
    if (this._def.returns instanceof vt) {
      const ia = this;
      return ce(async function(...fa) {
        const La = new de([]), Va = await ia._def.args.parseAsync(fa, ra).catch((ro) => {
          throw La.addIssue(Qi(fa, ro)), La;
        }), to = await Reflect.apply(na, this, Va);
        return await ia._def.returns._def.type.parseAsync(to, ra).catch((ro) => {
          throw La.addIssue(ea(to, ro)), La;
        });
      });
    } else {
      const ia = this;
      return ce(function(...fa) {
        const La = ia._def.args.safeParse(fa, ra);
        if (!La.success)
          throw new de([Qi(fa, La.error)]);
        const Va = Reflect.apply(na, this, La.data), to = ia._def.returns.safeParse(Va, ra);
        if (!to.success)
          throw new de([ea(Va, to.error)]);
        return to.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ct({
      ...this._def,
      args: xe.create(e).rest(Ge.create())
    });
  }
  returns(e) {
    return new ct({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, Zi, Qi) {
    return new ct({
      args: e || xe.create([]).rest(Ge.create()),
      returns: Zi || Ge.create(),
      typeName: C.ZodFunction,
      ...P(Qi)
    });
  }
}
class Lt extends M {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e);
    return this._def.getter()._parse({ data: Zi.data, path: Zi.path, parent: Zi });
  }
}
Lt.create = (Bi, e) => new Lt({
  getter: Bi,
  typeName: C.ZodLazy,
  ...P(e)
});
class qt extends M {
  _parse(e) {
    if (e.data !== this._def.value) {
      const Zi = this._getOrReturnCtx(e);
      return w(Zi, {
        received: Zi.data,
        code: g.invalid_literal,
        expected: this._def.value
      }), A;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
qt.create = (Bi, e) => new qt({
  value: Bi,
  typeName: C.ZodLiteral,
  ...P(e)
});
function za(Bi, e) {
  return new Be({
    values: Bi,
    typeName: C.ZodEnum,
    ...P(e)
  });
}
class Be extends M {
  constructor() {
    super(...arguments), St.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const Zi = this._getOrReturnCtx(e), Qi = this._def.values;
      return w(Zi, {
        expected: Q.joinValues(Qi),
        received: Zi.parsedType,
        code: g.invalid_type
      }), A;
    }
    if (lr(this, St) || Qa(this, St, new Set(this._def.values)), !lr(this, St).has(e.data)) {
      const Zi = this._getOrReturnCtx(e), Qi = this._def.values;
      return w(Zi, {
        received: Zi.data,
        code: g.invalid_enum_value,
        options: Qi
      }), A;
    }
    return ce(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const Zi of this._def.values)
      e[Zi] = Zi;
    return e;
  }
  get Values() {
    const e = {};
    for (const Zi of this._def.values)
      e[Zi] = Zi;
    return e;
  }
  get Enum() {
    const e = {};
    for (const Zi of this._def.values)
      e[Zi] = Zi;
    return e;
  }
  extract(e, Zi = this._def) {
    return Be.create(e, {
      ...this._def,
      ...Zi
    });
  }
  exclude(e, Zi = this._def) {
    return Be.create(this.options.filter((Qi) => !e.includes(Qi)), {
      ...this._def,
      ...Zi
    });
  }
}
St = /* @__PURE__ */ new WeakMap();
Be.create = za;
class Qt extends M {
  constructor() {
    super(...arguments), Ot.set(this, void 0);
  }
  _parse(e) {
    const Zi = Q.getValidEnumValues(this._def.values), Qi = this._getOrReturnCtx(e);
    if (Qi.parsedType !== O.string && Qi.parsedType !== O.number) {
      const ea = Q.objectValues(Zi);
      return w(Qi, {
        expected: Q.joinValues(ea),
        received: Qi.parsedType,
        code: g.invalid_type
      }), A;
    }
    if (lr(this, Ot) || Qa(this, Ot, new Set(Q.getValidEnumValues(this._def.values))), !lr(this, Ot).has(e.data)) {
      const ea = Q.objectValues(Zi);
      return w(Qi, {
        received: Qi.data,
        code: g.invalid_enum_value,
        options: ea
      }), A;
    }
    return ce(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ot = /* @__PURE__ */ new WeakMap();
Qt.create = (Bi, e) => new Qt({
  values: Bi,
  typeName: C.ZodNativeEnum,
  ...P(e)
});
class vt extends M {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e);
    if (Zi.parsedType !== O.promise && Zi.common.async === !1)
      return w(Zi, {
        code: g.invalid_type,
        expected: O.promise,
        received: Zi.parsedType
      }), A;
    const Qi = Zi.parsedType === O.promise ? Zi.data : Promise.resolve(Zi.data);
    return ce(Qi.then((ea) => this._def.type.parseAsync(ea, {
      path: Zi.path,
      errorMap: Zi.common.contextualErrorMap
    })));
  }
}
vt.create = (Bi, e) => new vt({
  type: Bi,
  typeName: C.ZodPromise,
  ...P(e)
});
class ge extends M {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === C.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e), ea = this._def.effect || null, ra = {
      addIssue: (na) => {
        w(Qi, na), na.fatal ? Zi.abort() : Zi.dirty();
      },
      get path() {
        return Qi.path;
      }
    };
    if (ra.addIssue = ra.addIssue.bind(ra), ea.type === "preprocess") {
      const na = ea.transform(Qi.data, ra);
      if (Qi.common.async)
        return Promise.resolve(na).then(async (ia) => {
          if (Zi.value === "aborted")
            return A;
          const fa = await this._def.schema._parseAsync({
            data: ia,
            path: Qi.path,
            parent: Qi
          });
          return fa.status === "aborted" ? A : fa.status === "dirty" || Zi.value === "dirty" ? st(fa.value) : fa;
        });
      {
        if (Zi.value === "aborted")
          return A;
        const ia = this._def.schema._parseSync({
          data: na,
          path: Qi.path,
          parent: Qi
        });
        return ia.status === "aborted" ? A : ia.status === "dirty" || Zi.value === "dirty" ? st(ia.value) : ia;
      }
    }
    if (ea.type === "refinement") {
      const na = (ia) => {
        const fa = ea.refinement(ia, ra);
        if (Qi.common.async)
          return Promise.resolve(fa);
        if (fa instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return ia;
      };
      if (Qi.common.async === !1) {
        const ia = this._def.schema._parseSync({
          data: Qi.data,
          path: Qi.path,
          parent: Qi
        });
        return ia.status === "aborted" ? A : (ia.status === "dirty" && Zi.dirty(), na(ia.value), { status: Zi.value, value: ia.value });
      } else
        return this._def.schema._parseAsync({ data: Qi.data, path: Qi.path, parent: Qi }).then((ia) => ia.status === "aborted" ? A : (ia.status === "dirty" && Zi.dirty(), na(ia.value).then(() => ({ status: Zi.value, value: ia.value }))));
    }
    if (ea.type === "transform")
      if (Qi.common.async === !1) {
        const na = this._def.schema._parseSync({
          data: Qi.data,
          path: Qi.path,
          parent: Qi
        });
        if (!Ye(na))
          return na;
        const ia = ea.transform(na.value, ra);
        if (ia instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: Zi.value, value: ia };
      } else
        return this._def.schema._parseAsync({ data: Qi.data, path: Qi.path, parent: Qi }).then((na) => Ye(na) ? Promise.resolve(ea.transform(na.value, ra)).then((ia) => ({ status: Zi.value, value: ia })) : na);
    Q.assertNever(ea);
  }
}
ge.create = (Bi, e, Zi) => new ge({
  schema: Bi,
  typeName: C.ZodEffects,
  effect: e,
  ...P(Zi)
});
ge.createWithPreprocess = (Bi, e, Zi) => new ge({
  schema: e,
  effect: { type: "preprocess", transform: Bi },
  typeName: C.ZodEffects,
  ...P(Zi)
});
class Se extends M {
  _parse(e) {
    return this._getType(e) === O.undefined ? ce(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Se.create = (Bi, e) => new Se({
  innerType: Bi,
  typeName: C.ZodOptional,
  ...P(e)
});
class Ze extends M {
  _parse(e) {
    return this._getType(e) === O.null ? ce(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ze.create = (Bi, e) => new Ze({
  innerType: Bi,
  typeName: C.ZodNullable,
  ...P(e)
});
class Bt extends M {
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e);
    let Qi = Zi.data;
    return Zi.parsedType === O.undefined && (Qi = this._def.defaultValue()), this._def.innerType._parse({
      data: Qi,
      path: Zi.path,
      parent: Zi
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Bt.create = (Bi, e) => new Bt({
  innerType: Bi,
  typeName: C.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...P(e)
});
class Zt extends M {
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e), Qi = {
      ...Zi,
      common: {
        ...Zi.common,
        issues: []
      }
    }, ea = this._def.innerType._parse({
      data: Qi.data,
      path: Qi.path,
      parent: {
        ...Qi
      }
    });
    return Ct(ea) ? ea.then((ra) => ({
      status: "valid",
      value: ra.status === "valid" ? ra.value : this._def.catchValue({
        get error() {
          return new de(Qi.common.issues);
        },
        input: Qi.data
      })
    })) : {
      status: "valid",
      value: ea.status === "valid" ? ea.value : this._def.catchValue({
        get error() {
          return new de(Qi.common.issues);
        },
        input: Qi.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Zt.create = (Bi, e) => new Zt({
  innerType: Bi,
  typeName: C.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...P(e)
});
class pr extends M {
  _parse(e) {
    if (this._getType(e) !== O.nan) {
      const Zi = this._getOrReturnCtx(e);
      return w(Zi, {
        code: g.invalid_type,
        expected: O.nan,
        received: Zi.parsedType
      }), A;
    }
    return { status: "valid", value: e.data };
  }
}
pr.create = (Bi) => new pr({
  typeName: C.ZodNaN,
  ...P(Bi)
});
const Ac = Symbol("zod_brand");
class Zn extends M {
  _parse(e) {
    const { ctx: Zi } = this._processInputParams(e), Qi = Zi.data;
    return this._def.type._parse({
      data: Qi,
      path: Zi.path,
      parent: Zi
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Wt extends M {
  _parse(e) {
    const { status: Zi, ctx: Qi } = this._processInputParams(e);
    if (Qi.common.async)
      return (async () => {
        const ea = await this._def.in._parseAsync({
          data: Qi.data,
          path: Qi.path,
          parent: Qi
        });
        return ea.status === "aborted" ? A : ea.status === "dirty" ? (Zi.dirty(), st(ea.value)) : this._def.out._parseAsync({
          data: ea.value,
          path: Qi.path,
          parent: Qi
        });
      })();
    {
      const ea = this._def.in._parseSync({
        data: Qi.data,
        path: Qi.path,
        parent: Qi
      });
      return ea.status === "aborted" ? A : ea.status === "dirty" ? (Zi.dirty(), {
        status: "dirty",
        value: ea.value
      }) : this._def.out._parseSync({
        data: ea.value,
        path: Qi.path,
        parent: Qi
      });
    }
  }
  static create(e, Zi) {
    return new Wt({
      in: e,
      out: Zi,
      typeName: C.ZodPipeline
    });
  }
}
class Ut extends M {
  _parse(e) {
    const Zi = this._def.innerType._parse(e), Qi = (ea) => (Ye(ea) && (ea.value = Object.freeze(ea.value)), ea);
    return Ct(Zi) ? Zi.then((ea) => Qi(ea)) : Qi(Zi);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ut.create = (Bi, e) => new Ut({
  innerType: Bi,
  typeName: C.ZodReadonly,
  ...P(e)
});
function zi(Bi, e) {
  const Zi = typeof Bi == "function" ? Bi(e) : typeof Bi == "string" ? { message: Bi } : Bi;
  return typeof Zi == "string" ? { message: Zi } : Zi;
}
function $a(Bi, e = {}, Zi) {
  return Bi ? yt.create().superRefine((Qi, ea) => {
    var ra, na;
    const ia = Bi(Qi);
    if (ia instanceof Promise)
      return ia.then((fa) => {
        var La, Va;
        if (!fa) {
          const to = zi(e, Qi), ro = (Va = (La = to.fatal) !== null && La !== void 0 ? La : Zi) !== null && Va !== void 0 ? Va : !0;
          ea.addIssue({ code: "custom", ...to, fatal: ro });
        }
      });
    if (!ia) {
      const fa = zi(e, Qi), La = (na = (ra = fa.fatal) !== null && ra !== void 0 ? ra : Zi) !== null && na !== void 0 ? na : !0;
      ea.addIssue({ code: "custom", ...fa, fatal: La });
    }
  }) : yt.create();
}
const Nc = {
  object: H.lazycreate
};
var C;
(function(Bi) {
  Bi.ZodString = "ZodString", Bi.ZodNumber = "ZodNumber", Bi.ZodNaN = "ZodNaN", Bi.ZodBigInt = "ZodBigInt", Bi.ZodBoolean = "ZodBoolean", Bi.ZodDate = "ZodDate", Bi.ZodSymbol = "ZodSymbol", Bi.ZodUndefined = "ZodUndefined", Bi.ZodNull = "ZodNull", Bi.ZodAny = "ZodAny", Bi.ZodUnknown = "ZodUnknown", Bi.ZodNever = "ZodNever", Bi.ZodVoid = "ZodVoid", Bi.ZodArray = "ZodArray", Bi.ZodObject = "ZodObject", Bi.ZodUnion = "ZodUnion", Bi.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", Bi.ZodIntersection = "ZodIntersection", Bi.ZodTuple = "ZodTuple", Bi.ZodRecord = "ZodRecord", Bi.ZodMap = "ZodMap", Bi.ZodSet = "ZodSet", Bi.ZodFunction = "ZodFunction", Bi.ZodLazy = "ZodLazy", Bi.ZodLiteral = "ZodLiteral", Bi.ZodEnum = "ZodEnum", Bi.ZodEffects = "ZodEffects", Bi.ZodNativeEnum = "ZodNativeEnum", Bi.ZodOptional = "ZodOptional", Bi.ZodNullable = "ZodNullable", Bi.ZodDefault = "ZodDefault", Bi.ZodCatch = "ZodCatch", Bi.ZodPromise = "ZodPromise", Bi.ZodBranded = "ZodBranded", Bi.ZodPipeline = "ZodPipeline", Bi.ZodReadonly = "ZodReadonly";
})(C || (C = {}));
const Pc = (Bi, e = {
  message: `Input not instance of ${Bi.name}`
}) => $a((Zi) => Zi instanceof Bi, e), Wa = ve.create, Ga = qe.create, Fc = pr.create, Mc = Qe.create, Ja = At.create, Vc = Ke.create, Lc = fr.create, qc = Nt.create, Qc = Pt.create, Bc = yt.create, Zc = Ge.create, Uc = Ce.create, zc = dr.create, $c = me.create, Wc = H.create, Gc = H.strictCreate, Jc = Ft.create, Hc = Er.create, Yc = Mt.create, Kc = xe.create, Xc = Vt.create, el = hr.create, tl = Xe.create, rl = ct.create, nl = Lt.create, il = qt.create, al = Be.create, sl = Qt.create, ol = vt.create, $i = ge.create, ul = Se.create, cl = Ze.create, ll = ge.createWithPreprocess, fl = Wt.create, dl = () => Wa().optional(), hl = () => Ga().optional(), pl = () => Ja().optional(), yl = {
  string: (Bi) => ve.create({ ...Bi, coerce: !0 }),
  number: (Bi) => qe.create({ ...Bi, coerce: !0 }),
  boolean: (Bi) => At.create({
    ...Bi,
    coerce: !0
  }),
  bigint: (Bi) => Qe.create({ ...Bi, coerce: !0 }),
  date: (Bi) => Ke.create({ ...Bi, coerce: !0 })
}, vl = A;
var f = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: pt,
  setErrorMap: lc,
  getErrorMap: ur,
  makeIssue: cr,
  EMPTY_PATH: fc,
  addIssueToContext: w,
  ParseStatus: oe,
  INVALID: A,
  DIRTY: st,
  OK: ce,
  isAborted: pn,
  isDirty: yn,
  isValid: Ye,
  isAsync: Ct,
  get util() {
    return Q;
  },
  get objectUtil() {
    return hn;
  },
  ZodParsedType: O,
  getParsedType: Re,
  ZodType: M,
  datetimeRegex: Ua,
  ZodString: ve,
  ZodNumber: qe,
  ZodBigInt: Qe,
  ZodBoolean: At,
  ZodDate: Ke,
  ZodSymbol: fr,
  ZodUndefined: Nt,
  ZodNull: Pt,
  ZodAny: yt,
  ZodUnknown: Ge,
  ZodNever: Ce,
  ZodVoid: dr,
  ZodArray: me,
  ZodObject: H,
  ZodUnion: Ft,
  ZodDiscriminatedUnion: Er,
  ZodIntersection: Mt,
  ZodTuple: xe,
  ZodRecord: Vt,
  ZodMap: hr,
  ZodSet: Xe,
  ZodFunction: ct,
  ZodLazy: Lt,
  ZodLiteral: qt,
  ZodEnum: Be,
  ZodNativeEnum: Qt,
  ZodPromise: vt,
  ZodEffects: ge,
  ZodTransformer: ge,
  ZodOptional: Se,
  ZodNullable: Ze,
  ZodDefault: Bt,
  ZodCatch: Zt,
  ZodNaN: pr,
  BRAND: Ac,
  ZodBranded: Zn,
  ZodPipeline: Wt,
  ZodReadonly: Ut,
  custom: $a,
  Schema: M,
  ZodSchema: M,
  late: Nc,
  get ZodFirstPartyTypeKind() {
    return C;
  },
  coerce: yl,
  any: Bc,
  array: $c,
  bigint: Mc,
  boolean: Ja,
  date: Vc,
  discriminatedUnion: Hc,
  effect: $i,
  enum: al,
  function: rl,
  instanceof: Pc,
  intersection: Yc,
  lazy: nl,
  literal: il,
  map: el,
  nan: Fc,
  nativeEnum: sl,
  never: Uc,
  null: Qc,
  nullable: cl,
  number: Ga,
  object: Wc,
  oboolean: pl,
  onumber: hl,
  optional: ul,
  ostring: dl,
  pipeline: fl,
  preprocess: ll,
  promise: ol,
  record: Xc,
  set: tl,
  strictObject: Gc,
  string: Wa,
  symbol: Lc,
  transformer: $i,
  tuple: Kc,
  undefined: qc,
  union: Jc,
  unknown: Zc,
  void: zc,
  NEVER: vl,
  ZodIssueCode: g,
  quotelessJson: cc,
  ZodError: de
});
const Ha = f.object({
  id: f.number(),
  name: f.string(),
  slug: f.string(),
  status: f.enum(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  input: f.object({}).partial().passthrough(),
  output: f.object({}).partial().passthrough().nullable(),
  createdAt: f.string(),
  startedAt: f.string().nullable(),
  endedAt: f.string().nullable()
}).passthrough();
f.object({ analyses: f.array(Ha) }).passthrough();
f.object({
  name: f.string().min(1).max(100),
  outputLocation: f.object({ s3BucketId: f.number(), path: f.string().optional() }).passthrough(),
  analysisSchemaId: f.number().int().gt(0),
  version: f.number(),
  input: f.unknown()
}).passthrough();
f.object({
  analysisId: f.number().nullable(),
  analysisSlug: f.string().nullable(),
  success: f.boolean()
}).passthrough();
const Ya = f.object({ id: f.number(), name: f.string(), versions: f.array(f.number()) }).passthrough();
f.object({ analysisSchemas: f.array(Ya) }).passthrough();
const Un = f.object({
  id: f.number(),
  name: f.string(),
  schema: f.object({}).partial().passthrough()
}).passthrough(), mn = f.object({ id: f.number(), name: f.string(), valueSchema: Un }).passthrough(), Ka = f.object({
  analysisSchemaId: f.number(),
  version: f.number(),
  createdAt: f.string(),
  description: f.object({ short: f.string().nullable(), long: f.string().nullable() }).partial().passthrough(),
  inputs: f.array(mn),
  outputs: f.array(mn)
}).passthrough();
f.object({ versions: f.array(Ka) }).passthrough();
f.object({ valueSchemas: f.array(Un) }).passthrough();
const Xa = f.enum([
  "ADMIN",
  "USER",
  "PROFESSOR",
  "PREMIUM_USER",
  "FREE_USER"
]), zn = f.object({
  id: f.string(),
  firstname: f.string().nullable(),
  lastname: f.string().nullable(),
  email: f.string().nullable(),
  keyPairId: f.number(),
  roles: f.array(Xa),
  permissions: f.array(f.string())
}).passthrough();
f.object({ user: zn }).partial().passthrough();
f.object({ email: f.string() }).passthrough();
f.object({ success: f.boolean() }).passthrough();
f.object({ otp: f.string() }).passthrough();
f.object({ success: f.boolean() }).passthrough();
const Dl = f.object({ success: f.boolean() }).passthrough();
f.object({ token: f.string() }).passthrough();
f.object({ token: f.string() }).passthrough();
f.object({ valid: f.boolean() }).passthrough();
const es = f.object({ id: f.number(), permissionId: f.string() }).passthrough();
f.object({ name: f.string(), permissions: f.array(es) }).passthrough();
const ts = f.object({
  id: f.number(),
  instanceProfile: f.string().nullable(),
  securityGroup: f.string().nullable()
}).passthrough(), Gt = f.object({
  id: f.number(),
  name: f.string(),
  labId: f.number().nullish(),
  userId: f.string().nullish(),
  status: f.enum([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  ipAddress: f.string().nullish(),
  lastLogin: f.string().nullish(),
  keypairId: f.number().nullish()
}).passthrough();
f.object({
  infra: f.array(ts),
  keyPairs: f.array(f.string()),
  tinkerBoxes: f.array(Gt)
}).passthrough();
f.object({ count: f.number().gte(1).lte(15) }).passthrough();
f.object({
  firstname: f.string().min(1),
  lastname: f.string().min(1),
  email: f.string().email(),
  password: f.string().min(8)
}).passthrough();
f.object({ users: f.array(zn) }).passthrough();
f.object({
  firstname: f.string().nullable(),
  lastname: f.string().nullable(),
  email: f.string().nullable()
}).partial().passthrough();
const rs = f.object({ tinkerBox: Gt, keyMaterial: f.string() }).passthrough();
f.object({ tinkerBoxes: f.array(rs) }).passthrough();
const ns = f.object({
  labName: f.string(),
  ec2Cost: f.number(),
  s3Cost: f.number(),
  efsCost: f.number(),
  totalCost: f.number()
}).passthrough();
f.object({ clients: f.array(ns) }).passthrough();
const is = f.object({
  name: f.string(),
  labName: f.string(),
  usage: f.string(),
  cost: f.number()
}).passthrough();
f.object({ tinkerBoxes: f.array(is) }).passthrough();
f.object({ tinkerboxes: f.array(Gt) }).passthrough();
f.object({ tinkerBox: Gt }).passthrough();
f.object({ name: f.string().nullable() }).partial().passthrough();
const as = f.object({
  id: f.number(),
  name: f.string(),
  s3BucketId: f.number(),
  keyPairId: f.number()
}).passthrough();
f.object({ labs: f.array(as) }).passthrough();
f.object({
  name: f.string(),
  numTinkerBoxes: f.number().optional().default(1)
}).passthrough();
f.object({ labId: f.number(), taskId: f.string() }).passthrough();
f.object({ id: f.string(), labId: f.number(), logs: f.string() }).passthrough();
const $n = f.object({
  id: f.number(),
  labId: f.number(),
  userId: f.string(),
  role: f.enum(["OWNER", "MEMBER"]),
  user: f.object({
    firstname: f.string().nullable(),
    lastname: f.string().nullable(),
    email: f.string().nullable(),
    id: f.string()
  }).partial().passthrough()
}).passthrough();
f.object({ labMember: $n.nullable() }).passthrough();
f.object({ labMembers: f.array($n) }).passthrough();
f.object({
  labMember: f.object({
    id: f.number().int(),
    labId: f.number().int(),
    userId: f.string(),
    role: f.enum(["OWNER", "MEMBER"])
  }).passthrough()
}).passthrough();
f.object({ role: f.string() }).passthrough();
f.object({ labMemberId: f.number(), role: f.string() }).passthrough();
f.object({ success: f.boolean() }).passthrough();
f.object({
  client_secret: f.string().nullable(),
  status: f.string().nullable(),
  payment_status: f.string()
}).passthrough();
f.object({ name: f.string(), email: f.string().email(), message: f.string() }).passthrough();
f.object({ path: f.string(), s3BucketId: f.number().optional() }).passthrough();
const nf = f.object({ success: f.boolean() }).passthrough(), af = f.object({ url: f.string() }).passthrough(), ss = f.object({
  isFolder: f.boolean(),
  bucketId: f.number().optional(),
  path: f.string()
}).passthrough(), sf = f.object({ contents: f.array(ss) }).passthrough(), of = f.object({ files: f.array(f.string()) }).passthrough();
f.object({
  buckets: f.array(
    f.object({
      id: f.number().int(),
      bucket: f.string(),
      region: f.string(),
      prefix: f.string().nullish()
    }).passthrough()
  )
}).passthrough();
f.object({
  source: f.object({
    isFolder: f.boolean(),
    bucketId: f.number().optional(),
    path: f.string()
  }).passthrough(),
  target: f.object({
    isFolder: f.boolean(),
    bucketId: f.number().optional(),
    path: f.string()
  }).passthrough()
}).passthrough();
const lf = f.object({
  fileTransfers: f.array(
    f.object({
      id: f.number().int(),
      name: f.string(),
      userId: f.string(),
      progress: f.number()
    }).passthrough()
  )
}).passthrough();
f.object({
  name: f.string().min(1).max(255),
  analysisSchemaId: f.number().int(),
  analysisSchemaVersion: f.number().int().gt(0),
  triggerLocation: f.object({
    bucketId: f.number().int().gt(0),
    folderPath: f.string().max(2048)
  }).passthrough(),
  config: f.unknown()
}).passthrough();
f.object({
  id: f.number(),
  name: f.string(),
  s3BucketId: f.number(),
  triggerFolder: f.string(),
  analysisSchemaId: f.number(),
  analysisSchemaVersion: f.number(),
  config: f.object({}).partial().passthrough()
}).passthrough();
f.object({ name: f.string(), enabled: f.boolean() }).passthrough();
f.object({
  id: f.number(),
  name: f.string(),
  schema: f.object({}).partial().passthrough()
}).passthrough();
f.object({
  id: f.number(),
  formId: f.number(),
  data: f.object({}).partial().passthrough(),
  dateCreated: f.string()
}).passthrough();
f.object({
  id: f.number(),
  name: f.string(),
  displayName: f.string(),
  hichip: f.string(),
  source: f.string(),
  bucket: f.string(),
  bedpeKey: f.string(),
  hicKey: f.string(),
  category: f.string()
}).passthrough();
f.object({
  id: f.number(),
  sampleId: f.number(),
  cluster: f.string(),
  chr: f.string(),
  start: f.number(),
  end: f.number(),
  size: f.number(),
  genes: f.string()
}).passthrough();
f.object({
  plotId: f.string(),
  status: f.enum(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  outputBucket: f.string(),
  outputKey: f.string(),
  inputs: f.object({}).partial().passthrough(),
  endedAt: f.string().nullable(),
  downloadUrl: f.string().nullable()
}).passthrough();
f.object({
  sample: f.string(),
  range: f.string(),
  genomeBuild: f.enum(["hg19", "hg38"]),
  color: f.string().regex(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
  inherent: f.string(),
  flank: f.number(),
  bedpe: f.string()
}).passthrough();
const Wn = f.object({
  id: f.number(),
  title: f.string(),
  content: f.string(),
  createdAt: f.string(),
  updatedAt: f.string(),
  isActive: f.boolean()
}).passthrough();
f.object({ announcements: f.array(Wn) }).passthrough();
f.object({ announcement: Wn.nullable() }).passthrough();
const Wi = {
  SuccessDto: Dl,
  CreateDirectoryResponse: nf,
  PresignedUrlResponse: af,
  ContentsResponse: sf,
  DeleteFilesResponse: of,
  FileTransfersResponse: lf
};
class xf {
  constructor(e) {
    mt(this, "fetch"), this.fetch = e;
  }
  async download(e, Zi, Qi = null, ea = !0) {
    let ra = `/files/presigned/${encodeURIComponent(Zi)}/url?method=download`;
    e && (ra += `&bucket=${e}`), Qi && (ra += `&limit=${Qi}`);
    const na = (await this.fetch(
      ra,
      { method: "GET" },
      Wi.PresignedUrlResponse
    )).url;
    if (ea) {
      const ia = document.createElement("a");
      ia.href = na, ia.download = "", ia.target = "_blank", ia.click(), document.body.appendChild(ia), ia.click(), setTimeout(() => {
        document.body.removeChild(ia);
      });
    }
    return na;
  }
  async upload(e, Zi, Qi) {
    const ea = [];
    let ra = `/files/presigned/${encodeURIComponent(Qi)}/url?method=upload`;
    Zi && (ra = ra += `&bucket=${Zi}`);
    const na = (await this.fetch(
      ra,
      { method: "GET" },
      Wi.PresignedUrlResponse
    )).url, ia = new XMLHttpRequest();
    return ia.open("PUT", na), ia.addEventListener("error", () => {
      for (const fa of ea)
        fa.onError(new Error("Failed to upload file"));
    }), ia.onerror = () => {
      for (const fa of ea)
        fa.onError(new Error("Failed to upload file"));
    }, ia.upload.addEventListener("progress", (fa) => {
      const La = fa.loaded / fa.total;
      for (const Va of ea)
        Va.onProgress(La);
    }), ia.upload.addEventListener("load", () => {
      for (const fa of ea)
        fa.onComplete();
      ia.upload.removeEventListener("progress", () => null);
    }), ia.send(e), {
      subscribe(fa) {
        ea.push(fa);
      }
    };
  }
}
const Logo = ({ className: Bi = "" }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    className: `${Bi} block`,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.81 296.2",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M64.3,112.5C28.5,174.6-.4,225.4,0,225.6s34.7-9.2,76.2-20.7,76.3-21.1,77.4-21.3c1.8-.3,2.3,2.8,9.6,56,4.2,31,7.8,56.5,8,56.6s20.5-15.2,45.2-34.3c29.3-22.7,44.6-35.1,44.4-36.1C260.2,223.6,131.2.4,130.2,0,129.8-.1,100.1,50.5,64.3,112.5Z" }) })
  }
);
function useErrorToast(Bi) {
  useEffect(() => {
    Bi && toast.error(Bi.toString());
  }, [Bi]);
}
async function createFolder(Bi, e, Zi) {
  await Bi(
    "/files/directory",
    {
      method: "POST",
      body: JSON.stringify({ s3BucketId: e, path: Zi })
    },
    Wi.CreateDirectoryResponse
  );
}
const useCreateFolder = (Bi) => {
  const e = useMutation({
    mutationKey: ["createFolder"],
    mutationFn: async (Zi) => createFolder(Bi, Zi.s3BucketId, Zi.path)
  });
  return { ...e, createFolder: e.mutateAsync };
};
async function deleteFiles(Bi, e, Zi) {
  let ea = `/files/${encodeURIComponent(e)}?`;
  return Zi && (ea += `&bucket=${Zi}`), await Bi(
    ea,
    { method: "DELETE" },
    Wi.DeleteFilesResponse
  );
}
const useDeleteFiles = (Bi) => {
  const e = useMutation({
    mutationKey: ["deleteFiles"],
    mutationFn: (Zi) => deleteFiles(Bi, Zi.path, Zi.s3BucketId)
  });
  return { ...e, deleteFiles: e.mutateAsync };
};
async function getFileTranfsers(Bi) {
  return Bi(
    "/file-transfer",
    { method: "GET" },
    Wi.FileTransfersResponse
  );
}
const useFileTransfersQuery = (Bi, e) => useQuery({
  queryKey: ["file-transfers"],
  queryFn: () => getFileTranfsers(e),
  refetchInterval: 500,
  enabled: Bi
}), searchFiles = async (Bi, e, Zi) => await Zi(
  `/files/?search=${e}&bucket=${Bi}`,
  {},
  Wi.ContentsResponse
), getFolderContents = async (Bi, e, Zi) => {
  let ea = `/files/${encodeURIComponent(e || "")}?`;
  return Bi && (ea += `bucket=${Bi}`), await Zi(ea, { method: "GET" }, Wi.ContentsResponse);
}, useFolderContentsQuery = (Bi, e, Zi) => useQuery({
  queryKey: ["files", Bi, e],
  queryFn: async () => getFolderContents(Bi, e, Zi),
  refetchInterval: 2e3
});
async function moveFiles(Bi, e, Zi) {
  return Zi(
    "/files/move",
    {
      method: "POST",
      body: JSON.stringify({ source: Bi, target: e })
    },
    Wi.SuccessDto
  );
}
function useMoveFilesMutation(Bi) {
  const e = useMutation({
    mutationKey: ["moveFiles"],
    mutationFn: ({ src: Zi, dest: Qi }) => moveFiles(Zi, Qi, Bi)
  });
  return { ...e, moveFiles: e.mutateAsync };
}
function S3FileBrowser({
  s3BucketId: Bi,
  fetch: e,
  selectionMode: Zi,
  onSelectionChange: Qi,
  path: ea,
  setPath: ra,
  readOnly: na = !1,
  selection: ia = [],
  className: fa = ""
}) {
  const La = ea.join("/"), { error: Va, refetch: to } = useFolderContentsQuery(
    Bi,
    La,
    e
  ), [ro, no] = useState(!1), { createFolder: eo } = useCreateFolder(e), { deleteFiles: ao, error: io } = useDeleteFiles(e), { moveFiles: xs, error: Ts } = useMoveFilesMutation(e), { data: qs, error: Fs } = useFileTransfersQuery(ro, e);
  return useEffect(() => {
    qs?.fileTransfers && qs.fileTransfers.length > 0;
  }, [qs]), useErrorToast(Ts), useErrorToast(Fs), useFileTranfersProgress(qs), useEffect(() => {
    Va && toast.error(Va.message), io && toast.error(io.message);
  }, [Va, io]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    FileBrowser,
    {
      className: fa,
      selectionMode: Zi,
      filePathHomeDirectory: /* @__PURE__ */ jsxRuntimeExports.jsx(Logo, { className: "inline w-3 h-3" }),
      getFiles: async (Do) => (await getFolderContents(
        Bi,
        Do.join("/"),
        e
      )).contents,
      selection: ia,
      readOnly: na,
      onSelectionChange: Qi,
      onDownload: async (Do) => {
        await new xf(e).download(Bi, Do.path, null, !0), to();
      },
      path: ea,
      onMoveUpAFolder: async (Do) => {
        if (!Do) {
          toast.error("Already at root folder");
          return;
        }
        const { path: ys, parent: Io } = Do;
        console.log("onMoveUpAFolder", { path: ys, parent: Io }), await xs({
          src: ys,
          dest: { isFolder: !0, path: Io, bucketId: ys.bucketId }
        }), no(!0), await to();
      },
      onNavigate: (Do) => {
        ra(Do);
      },
      onMove: async (Do, ys) => {
        if (!ys.isFolder) {
          toast.error("Target must be a folder");
          return;
        }
        await xs({ src: Do, dest: ys }), await to(), no(!0);
      },
      onSearch: async (Do) => {
        const ys = await searchFiles(Bi, Do, e);
        return console.log("searchFiles", ys), ys.contents;
      },
      onUpload: function(Do) {
        const ys = new xf(e), Io = `${La}/${Do[0].name}`;
        return ys.upload(Do[0], Bi, Io);
      },
      onDelete: async (Do) => {
        await ao({ s3BucketId: Bi, path: Do[0].path }), await to();
      },
      onCreateFolder: async (Do) => {
        await eo({ s3BucketId: Bi, path: Do }), await to();
      },
      onPreview: async (Do) => {
        await new xf(e).download(Bi, Do.path), to();
      }
    }
  );
}
const useFileTranfersProgress = (Bi) => {
  useEffect(() => {
    if (Bi?.fileTransfers.length)
      for (const e of Bi.fileTransfers)
        toast(e.name, {
          progress: e.progress,
          toastId: e.id
        });
  }, [Bi]);
};
var getRandomValues, rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate(Bi) {
  return typeof Bi == "string" && REGEX.test(Bi);
}
var byteToHex = [];
for (var i = 0; i < 256; ++i)
  byteToHex.push((i + 256).toString(16).substr(1));
function stringify(Bi) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, Zi = (byteToHex[Bi[e + 0]] + byteToHex[Bi[e + 1]] + byteToHex[Bi[e + 2]] + byteToHex[Bi[e + 3]] + "-" + byteToHex[Bi[e + 4]] + byteToHex[Bi[e + 5]] + "-" + byteToHex[Bi[e + 6]] + byteToHex[Bi[e + 7]] + "-" + byteToHex[Bi[e + 8]] + byteToHex[Bi[e + 9]] + "-" + byteToHex[Bi[e + 10]] + byteToHex[Bi[e + 11]] + byteToHex[Bi[e + 12]] + byteToHex[Bi[e + 13]] + byteToHex[Bi[e + 14]] + byteToHex[Bi[e + 15]]).toLowerCase();
  if (!validate(Zi))
    throw TypeError("Stringified UUID is invalid");
  return Zi;
}
function v4(Bi, e, Zi) {
  Bi = Bi || {};
  var Qi = Bi.random || (Bi.rng || rng)();
  return Qi[6] = Qi[6] & 15 | 64, Qi[8] = Qi[8] & 63 | 128, stringify(Qi);
}
const fileListToArray = (Bi) => {
  const e = [];
  for (let Zi = 0; Zi < Bi.length; Zi++) {
    const Qi = Bi.item(Zi);
    Qi && e.push(Qi);
  }
  return e;
}, FileInput = ({
  children: Bi,
  onChange: e,
  className: Zi
}) => {
  const Qi = useRef(v4());
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `${Zi} cursor-pointer`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "label",
      {
        htmlFor: Qi.current,
        onClick: (ea) => ea.stopPropagation(),
        className: "cursor-pointer",
        onKeyDown: (ea) => {
          ea.key === "Enter" && ea.stopPropagation();
        },
        children: Bi
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        onClick: (ea) => ea.stopPropagation(),
        onChange: (ea) => {
          e(ea.target.files ? fileListToArray(ea.target.files) : []);
        },
        className: "absolute w-0 h-0",
        type: "file",
        id: Qi.current
      }
    )
  ] });
}, FormikField = ({ name: Bi, ...e }) => {
  const [Zi, Qi] = useField(Bi), { capture: ea, ...ra } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Field, { ...ra, ...Zi, placeholder: e.placeholder || Bi }),
    Qi.touched && Qi.error && /* @__PURE__ */ jsxRuntimeExports.jsx(Error$1, { children: Qi.error })
  ] });
};
function GridArea({ area: Bi, children: e, className: Zi }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${Zi || ""}`, style: { gridArea: Bi }, children: e });
}
var reactResponsive$1 = { exports: {} }, reactResponsive = reactResponsive$1.exports, hasRequiredReactResponsive;
function requireReactResponsive() {
  return hasRequiredReactResponsive || (hasRequiredReactResponsive = 1, function(Bi, e) {
    (function(Qi, ea) {
      Bi.exports = ea(a__default);
    })(reactResponsive, (Zi) => (
      /******/
      (() => {
        var Qi = {
          /***/
          "./node_modules/css-mediaquery/index.js": (
            /*!**********************************************!*\
              !*** ./node_modules/css-mediaquery/index.js ***!
              \**********************************************/
            /***/
            (ia, fa) => {
              fa.match = eo, fa.parse = ao;
              var La = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, Va = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, to = /^(?:(min|max)-)?(.+)/, ro = /(em|rem|px|cm|mm|in|pt|pc)?$/, no = /(dpi|dpcm|dppx)?$/;
              function eo(qs, Fs) {
                return ao(qs).some(function(Do) {
                  var ys = Do.inverse, Io = Do.type === "all" || Fs.type === Do.type;
                  if (Io && ys || !(Io || ys))
                    return !1;
                  var so = Do.expressions.every(function(os) {
                    var Xs = os.feature, gl = os.modifier, Sl = os.value, El = Fs[Xs];
                    if (!El)
                      return !1;
                    switch (Xs) {
                      case "orientation":
                      case "scan":
                        return El.toLowerCase() === Sl.toLowerCase();
                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        Sl = Ts(Sl), El = Ts(El);
                        break;
                      case "resolution":
                        Sl = xs(Sl), El = xs(El);
                        break;
                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case /* Deprecated */
                      "device-pixel-ratio":
                        Sl = io(Sl), El = io(El);
                        break;
                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        Sl = parseInt(Sl, 10) || 1, El = parseInt(El, 10) || 0;
                        break;
                    }
                    switch (gl) {
                      case "min":
                        return El >= Sl;
                      case "max":
                        return El <= Sl;
                      default:
                        return El === Sl;
                    }
                  });
                  return so && !ys || !so && ys;
                });
              }
              function ao(qs) {
                return qs.split(",").map(function(Fs) {
                  Fs = Fs.trim();
                  var Do = Fs.match(La), ys = Do[1], Io = Do[2], so = Do[3] || "", os = {};
                  return os.inverse = !!ys && ys.toLowerCase() === "not", os.type = Io ? Io.toLowerCase() : "all", so = so.match(/\([^\)]+\)/g) || [], os.expressions = so.map(function(Xs) {
                    var gl = Xs.match(Va), Sl = gl[1].toLowerCase().match(to);
                    return {
                      modifier: Sl[1],
                      feature: Sl[2],
                      value: gl[2]
                    };
                  }), os;
                });
              }
              function io(qs) {
                var Fs = Number(qs), Do;
                return Fs || (Do = qs.match(/^(\d+)\s*\/\s*(\d+)$/), Fs = Do[1] / Do[2]), Fs;
              }
              function xs(qs) {
                var Fs = parseFloat(qs), Do = String(qs).match(no)[1];
                switch (Do) {
                  case "dpcm":
                    return Fs / 2.54;
                  case "dppx":
                    return Fs * 96;
                  default:
                    return Fs;
                }
              }
              function Ts(qs) {
                var Fs = parseFloat(qs), Do = String(qs).match(ro)[1];
                switch (Do) {
                  case "em":
                    return Fs * 16;
                  case "rem":
                    return Fs * 16;
                  case "cm":
                    return Fs * 96 / 2.54;
                  case "mm":
                    return Fs * 96 / 2.54 / 10;
                  case "in":
                    return Fs * 96;
                  case "pt":
                    return Fs * 72;
                  case "pc":
                    return Fs * 72 / 12;
                  default:
                    return Fs;
                }
              }
            }
          ),
          /***/
          "./node_modules/hyphenate-style-name/index.js": (
            /*!****************************************************!*\
              !*** ./node_modules/hyphenate-style-name/index.js ***!
              \****************************************************/
            /***/
            (ia, fa, La) => {
              La.r(fa), La.d(fa, {
                /* harmony export */
                default: () => ao
                /* harmony export */
              });
              var Va = /[A-Z]/g, to = /^ms-/, ro = {};
              function no(io) {
                return "-" + io.toLowerCase();
              }
              function eo(io) {
                if (ro.hasOwnProperty(io))
                  return ro[io];
                var xs = io.replace(Va, no);
                return ro[io] = to.test(xs) ? "-" + xs : xs;
              }
              const ao = eo;
            }
          ),
          /***/
          "./node_modules/matchmediaquery/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/matchmediaquery/index.js ***!
              \***********************************************/
            /***/
            (ia, fa, La) => {
              var Va = La(
                /*! css-mediaquery */
                "./node_modules/css-mediaquery/index.js"
              ).match, to = typeof window < "u" ? window.matchMedia : null;
              function ro(eo, ao, io) {
                var xs = this;
                if (to && !io) {
                  var Ts = to.call(window, eo);
                  this.matches = Ts.matches, this.media = Ts.media, Ts.addListener(Do);
                } else
                  this.matches = Va(eo, ao), this.media = eo;
                this.addListener = qs, this.removeListener = Fs, this.dispose = ys;
                function qs(Io) {
                  Ts && Ts.addListener(Io);
                }
                function Fs(Io) {
                  Ts && Ts.removeListener(Io);
                }
                function Do(Io) {
                  xs.matches = Io.matches, xs.media = Io.media;
                }
                function ys() {
                  Ts && Ts.removeListener(Do);
                }
              }
              function no(eo, ao, io) {
                return new ro(eo, ao, io);
              }
              ia.exports = no;
            }
          ),
          /***/
          "./node_modules/object-assign/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/object-assign/index.js ***!
              \*********************************************/
            /***/
            (ia) => {
              /*
              object-assign
              (c) Sindre Sorhus
              @license MIT
              */
              var fa = Object.getOwnPropertySymbols, La = Object.prototype.hasOwnProperty, Va = Object.prototype.propertyIsEnumerable;
              function to(no) {
                if (no == null)
                  throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(no);
              }
              function ro() {
                try {
                  if (!Object.assign)
                    return !1;
                  var no = new String("abc");
                  if (no[5] = "de", Object.getOwnPropertyNames(no)[0] === "5")
                    return !1;
                  for (var eo = {}, ao = 0; ao < 10; ao++)
                    eo["_" + String.fromCharCode(ao)] = ao;
                  var io = Object.getOwnPropertyNames(eo).map(function(Ts) {
                    return eo[Ts];
                  });
                  if (io.join("") !== "0123456789")
                    return !1;
                  var xs = {};
                  return "abcdefghijklmnopqrst".split("").forEach(function(Ts) {
                    xs[Ts] = Ts;
                  }), Object.keys(Object.assign({}, xs)).join("") === "abcdefghijklmnopqrst";
                } catch {
                  return !1;
                }
              }
              ia.exports = ro() ? Object.assign : function(no, eo) {
                for (var ao, io = to(no), xs, Ts = 1; Ts < arguments.length; Ts++) {
                  ao = Object(arguments[Ts]);
                  for (var qs in ao)
                    La.call(ao, qs) && (io[qs] = ao[qs]);
                  if (fa) {
                    xs = fa(ao);
                    for (var Fs = 0; Fs < xs.length; Fs++)
                      Va.call(ao, xs[Fs]) && (io[xs[Fs]] = ao[xs[Fs]]);
                  }
                }
                return io;
              };
            }
          ),
          /***/
          "./node_modules/prop-types/checkPropTypes.js": (
            /*!***************************************************!*\
              !*** ./node_modules/prop-types/checkPropTypes.js ***!
              \***************************************************/
            /***/
            (ia, fa, La) => {
              var Va = function() {
              };
              {
                var to = La(
                  /*! ./lib/ReactPropTypesSecret */
                  "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
                ), ro = {}, no = La(
                  /*! ./lib/has */
                  "./node_modules/prop-types/lib/has.js"
                );
                Va = function(ao) {
                  var io = "Warning: " + ao;
                  typeof console < "u" && console.error(io);
                  try {
                    throw new Error(io);
                  } catch {
                  }
                };
              }
              function eo(ao, io, xs, Ts, qs) {
                for (var Fs in ao)
                  if (no(ao, Fs)) {
                    var Do;
                    try {
                      if (typeof ao[Fs] != "function") {
                        var ys = Error(
                          (Ts || "React class") + ": " + xs + " type `" + Fs + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ao[Fs] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                        );
                        throw ys.name = "Invariant Violation", ys;
                      }
                      Do = ao[Fs](io, Fs, Ts, xs, null, to);
                    } catch (so) {
                      Do = so;
                    }
                    if (Do && !(Do instanceof Error) && Va(
                      (Ts || "React class") + ": type specification of " + xs + " `" + Fs + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof Do + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                    ), Do instanceof Error && !(Do.message in ro)) {
                      ro[Do.message] = !0;
                      var Io = qs ? qs() : "";
                      Va(
                        "Failed " + xs + " type: " + Do.message + (Io ?? "")
                      );
                    }
                  }
              }
              eo.resetWarningCache = function() {
                ro = {};
              }, ia.exports = eo;
            }
          ),
          /***/
          "./node_modules/prop-types/factoryWithTypeCheckers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
              \************************************************************/
            /***/
            (ia, fa, La) => {
              var Va = La(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), to = La(
                /*! object-assign */
                "./node_modules/object-assign/index.js"
              ), ro = La(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), no = La(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              ), eo = La(
                /*! ./checkPropTypes */
                "./node_modules/prop-types/checkPropTypes.js"
              ), ao = function() {
              };
              ao = function(xs) {
                var Ts = "Warning: " + xs;
                typeof console < "u" && console.error(Ts);
                try {
                  throw new Error(Ts);
                } catch {
                }
              };
              function io() {
                return null;
              }
              ia.exports = function(xs, Ts) {
                var qs = typeof Symbol == "function" && Symbol.iterator, Fs = "@@iterator";
                function Do(Os) {
                  var $l = Os && (qs && Os[qs] || Os[Fs]);
                  if (typeof $l == "function")
                    return $l;
                }
                var ys = "<<anonymous>>", Io = {
                  array: gl("array"),
                  bigint: gl("bigint"),
                  bool: gl("boolean"),
                  func: gl("function"),
                  number: gl("number"),
                  object: gl("object"),
                  string: gl("string"),
                  symbol: gl("symbol"),
                  any: Sl(),
                  arrayOf: El,
                  element: wl(),
                  elementType: jl(),
                  instanceOf: kl,
                  node: Kl(),
                  objectOf: Ml,
                  oneOf: Fl,
                  oneOfType: ql,
                  shape: Il,
                  exact: xl
                };
                function so(Os, $l) {
                  return Os === $l ? Os !== 0 || 1 / Os === 1 / $l : Os !== Os && $l !== $l;
                }
                function os(Os, $l) {
                  this.message = Os, this.data = $l && typeof $l == "object" ? $l : {}, this.stack = "";
                }
                os.prototype = Error.prototype;
                function Xs(Os) {
                  var $l = {}, _l = 0;
                  function Al(Cl, ml, Tl, Ll, Vl, zl, Ul) {
                    if (Ll = Ll || ys, zl = zl || Tl, Ul !== ro) {
                      if (Ts) {
                        var Yl = new Error(
                          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                        );
                        throw Yl.name = "Invariant Violation", Yl;
                      } else if (typeof console < "u") {
                        var Jl = Ll + ":" + Tl;
                        !$l[Jl] && // Avoid spamming the console because they are often not actionable except for lib authors
                        _l < 3 && (ao(
                          "You are manually calling a React.PropTypes validation function for the `" + zl + "` prop on `" + Ll + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                        ), $l[Jl] = !0, _l++);
                      }
                    }
                    return ml[Tl] == null ? Cl ? ml[Tl] === null ? new os("The " + Vl + " `" + zl + "` is marked as required " + ("in `" + Ll + "`, but its value is `null`.")) : new os("The " + Vl + " `" + zl + "` is marked as required in " + ("`" + Ll + "`, but its value is `undefined`.")) : null : Os(ml, Tl, Ll, Vl, zl);
                  }
                  var Rl = Al.bind(null, !1);
                  return Rl.isRequired = Al.bind(null, !0), Rl;
                }
                function gl(Os) {
                  function $l(_l, Al, Rl, Cl, ml, Tl) {
                    var Ll = _l[Al], Vl = Nl(Ll);
                    if (Vl !== Os) {
                      var zl = Bl(Ll);
                      return new os(
                        "Invalid " + Cl + " `" + ml + "` of type " + ("`" + zl + "` supplied to `" + Rl + "`, expected ") + ("`" + Os + "`."),
                        { expectedType: Os }
                      );
                    }
                    return null;
                  }
                  return Xs($l);
                }
                function Sl() {
                  return Xs(io);
                }
                function El(Os) {
                  function $l(_l, Al, Rl, Cl, ml) {
                    if (typeof Os != "function")
                      return new os("Property `" + ml + "` of component `" + Rl + "` has invalid PropType notation inside arrayOf.");
                    var Tl = _l[Al];
                    if (!Array.isArray(Tl)) {
                      var Ll = Nl(Tl);
                      return new os("Invalid " + Cl + " `" + ml + "` of type " + ("`" + Ll + "` supplied to `" + Rl + "`, expected an array."));
                    }
                    for (var Vl = 0; Vl < Tl.length; Vl++) {
                      var zl = Os(Tl, Vl, Rl, Cl, ml + "[" + Vl + "]", ro);
                      if (zl instanceof Error)
                        return zl;
                    }
                    return null;
                  }
                  return Xs($l);
                }
                function wl() {
                  function Os($l, _l, Al, Rl, Cl) {
                    var ml = $l[_l];
                    if (!xs(ml)) {
                      var Tl = Nl(ml);
                      return new os("Invalid " + Rl + " `" + Cl + "` of type " + ("`" + Tl + "` supplied to `" + Al + "`, expected a single ReactElement."));
                    }
                    return null;
                  }
                  return Xs(Os);
                }
                function jl() {
                  function Os($l, _l, Al, Rl, Cl) {
                    var ml = $l[_l];
                    if (!Va.isValidElementType(ml)) {
                      var Tl = Nl(ml);
                      return new os("Invalid " + Rl + " `" + Cl + "` of type " + ("`" + Tl + "` supplied to `" + Al + "`, expected a single ReactElement type."));
                    }
                    return null;
                  }
                  return Xs(Os);
                }
                function kl(Os) {
                  function $l(_l, Al, Rl, Cl, ml) {
                    if (!(_l[Al] instanceof Os)) {
                      var Tl = Os.name || ys, Ll = To(_l[Al]);
                      return new os("Invalid " + Cl + " `" + ml + "` of type " + ("`" + Ll + "` supplied to `" + Rl + "`, expected ") + ("instance of `" + Tl + "`."));
                    }
                    return null;
                  }
                  return Xs($l);
                }
                function Fl(Os) {
                  if (!Array.isArray(Os))
                    return arguments.length > 1 ? ao(
                      "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                    ) : ao("Invalid argument supplied to oneOf, expected an array."), io;
                  function $l(_l, Al, Rl, Cl, ml) {
                    for (var Tl = _l[Al], Ll = 0; Ll < Os.length; Ll++)
                      if (so(Tl, Os[Ll]))
                        return null;
                    var Vl = JSON.stringify(Os, function(Ul, Yl) {
                      var Jl = Bl(Yl);
                      return Jl === "symbol" ? String(Yl) : Yl;
                    });
                    return new os("Invalid " + Cl + " `" + ml + "` of value `" + String(Tl) + "` " + ("supplied to `" + Rl + "`, expected one of " + Vl + "."));
                  }
                  return Xs($l);
                }
                function Ml(Os) {
                  function $l(_l, Al, Rl, Cl, ml) {
                    if (typeof Os != "function")
                      return new os("Property `" + ml + "` of component `" + Rl + "` has invalid PropType notation inside objectOf.");
                    var Tl = _l[Al], Ll = Nl(Tl);
                    if (Ll !== "object")
                      return new os("Invalid " + Cl + " `" + ml + "` of type " + ("`" + Ll + "` supplied to `" + Rl + "`, expected an object."));
                    for (var Vl in Tl)
                      if (no(Tl, Vl)) {
                        var zl = Os(Tl, Vl, Rl, Cl, ml + "." + Vl, ro);
                        if (zl instanceof Error)
                          return zl;
                      }
                    return null;
                  }
                  return Xs($l);
                }
                function ql(Os) {
                  if (!Array.isArray(Os))
                    return ao("Invalid argument supplied to oneOfType, expected an instance of array."), io;
                  for (var $l = 0; $l < Os.length; $l++) {
                    var _l = Os[$l];
                    if (typeof _l != "function")
                      return ao(
                        "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Ol(_l) + " at index " + $l + "."
                      ), io;
                  }
                  function Al(Rl, Cl, ml, Tl, Ll) {
                    for (var Vl = [], zl = 0; zl < Os.length; zl++) {
                      var Ul = Os[zl], Yl = Ul(Rl, Cl, ml, Tl, Ll, ro);
                      if (Yl == null)
                        return null;
                      Yl.data && no(Yl.data, "expectedType") && Vl.push(Yl.data.expectedType);
                    }
                    var Jl = Vl.length > 0 ? ", expected one of type [" + Vl.join(", ") + "]" : "";
                    return new os("Invalid " + Tl + " `" + Ll + "` supplied to " + ("`" + ml + "`" + Jl + "."));
                  }
                  return Xs(Al);
                }
                function Kl() {
                  function Os($l, _l, Al, Rl, Cl) {
                    return bl($l[_l]) ? null : new os("Invalid " + Rl + " `" + Cl + "` supplied to " + ("`" + Al + "`, expected a ReactNode."));
                  }
                  return Xs(Os);
                }
                function Zl(Os, $l, _l, Al, Rl) {
                  return new os(
                    (Os || "React class") + ": " + $l + " type `" + _l + "." + Al + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Rl + "`."
                  );
                }
                function Il(Os) {
                  function $l(_l, Al, Rl, Cl, ml) {
                    var Tl = _l[Al], Ll = Nl(Tl);
                    if (Ll !== "object")
                      return new os("Invalid " + Cl + " `" + ml + "` of type `" + Ll + "` " + ("supplied to `" + Rl + "`, expected `object`."));
                    for (var Vl in Os) {
                      var zl = Os[Vl];
                      if (typeof zl != "function")
                        return Zl(Rl, Cl, ml, Vl, Bl(zl));
                      var Ul = zl(Tl, Vl, Rl, Cl, ml + "." + Vl, ro);
                      if (Ul)
                        return Ul;
                    }
                    return null;
                  }
                  return Xs($l);
                }
                function xl(Os) {
                  function $l(_l, Al, Rl, Cl, ml) {
                    var Tl = _l[Al], Ll = Nl(Tl);
                    if (Ll !== "object")
                      return new os("Invalid " + Cl + " `" + ml + "` of type `" + Ll + "` " + ("supplied to `" + Rl + "`, expected `object`."));
                    var Vl = to({}, _l[Al], Os);
                    for (var zl in Vl) {
                      var Ul = Os[zl];
                      if (no(Os, zl) && typeof Ul != "function")
                        return Zl(Rl, Cl, ml, zl, Bl(Ul));
                      if (!Ul)
                        return new os(
                          "Invalid " + Cl + " `" + ml + "` key `" + zl + "` supplied to `" + Rl + "`.\nBad object: " + JSON.stringify(_l[Al], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Os), null, "  ")
                        );
                      var Yl = Ul(Tl, zl, Rl, Cl, ml + "." + zl, ro);
                      if (Yl)
                        return Yl;
                    }
                    return null;
                  }
                  return Xs($l);
                }
                function bl(Os) {
                  switch (typeof Os) {
                    case "number":
                    case "string":
                    case "undefined":
                      return !0;
                    case "boolean":
                      return !Os;
                    case "object":
                      if (Array.isArray(Os))
                        return Os.every(bl);
                      if (Os === null || xs(Os))
                        return !0;
                      var $l = Do(Os);
                      if ($l) {
                        var _l = $l.call(Os), Al;
                        if ($l !== Os.entries) {
                          for (; !(Al = _l.next()).done; )
                            if (!bl(Al.value))
                              return !1;
                        } else
                          for (; !(Al = _l.next()).done; ) {
                            var Rl = Al.value;
                            if (Rl && !bl(Rl[1]))
                              return !1;
                          }
                      } else
                        return !1;
                      return !0;
                    default:
                      return !1;
                  }
                }
                function Pl(Os, $l) {
                  return Os === "symbol" ? !0 : $l ? $l["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && $l instanceof Symbol : !1;
                }
                function Nl(Os) {
                  var $l = typeof Os;
                  return Array.isArray(Os) ? "array" : Os instanceof RegExp ? "object" : Pl($l, Os) ? "symbol" : $l;
                }
                function Bl(Os) {
                  if (typeof Os > "u" || Os === null)
                    return "" + Os;
                  var $l = Nl(Os);
                  if ($l === "object") {
                    if (Os instanceof Date)
                      return "date";
                    if (Os instanceof RegExp)
                      return "regexp";
                  }
                  return $l;
                }
                function Ol(Os) {
                  var $l = Bl(Os);
                  switch ($l) {
                    case "array":
                    case "object":
                      return "an " + $l;
                    case "boolean":
                    case "date":
                    case "regexp":
                      return "a " + $l;
                    default:
                      return $l;
                  }
                }
                function To(Os) {
                  return !Os.constructor || !Os.constructor.name ? ys : Os.constructor.name;
                }
                return Io.checkPropTypes = eo, Io.resetWarningCache = eo.resetWarningCache, Io.PropTypes = Io, Io;
              };
            }
          ),
          /***/
          "./node_modules/prop-types/index.js": (
            /*!******************************************!*\
              !*** ./node_modules/prop-types/index.js ***!
              \******************************************/
            /***/
            (ia, fa, La) => {
              {
                var Va = La(
                  /*! react-is */
                  "./node_modules/react-is/index.js"
                ), to = !0;
                ia.exports = La(
                  /*! ./factoryWithTypeCheckers */
                  "./node_modules/prop-types/factoryWithTypeCheckers.js"
                )(Va.isElement, to);
              }
            }
          ),
          /***/
          "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
              \*************************************************************/
            /***/
            (ia) => {
              var fa = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
              ia.exports = fa;
            }
          ),
          /***/
          "./node_modules/prop-types/lib/has.js": (
            /*!********************************************!*\
              !*** ./node_modules/prop-types/lib/has.js ***!
              \********************************************/
            /***/
            (ia) => {
              ia.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            }
          ),
          /***/
          "./node_modules/react-is/cjs/react-is.development.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/react-is/cjs/react-is.development.js ***!
              \***********************************************************/
            /***/
            (ia, fa) => {
              /** @license React v16.13.1
               * react-is.development.js
               *
               * Copyright (c) Facebook, Inc. and its affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */
              (function() {
                var La = typeof Symbol == "function" && Symbol.for, Va = La ? Symbol.for("react.element") : 60103, to = La ? Symbol.for("react.portal") : 60106, ro = La ? Symbol.for("react.fragment") : 60107, no = La ? Symbol.for("react.strict_mode") : 60108, eo = La ? Symbol.for("react.profiler") : 60114, ao = La ? Symbol.for("react.provider") : 60109, io = La ? Symbol.for("react.context") : 60110, xs = La ? Symbol.for("react.async_mode") : 60111, Ts = La ? Symbol.for("react.concurrent_mode") : 60111, qs = La ? Symbol.for("react.forward_ref") : 60112, Fs = La ? Symbol.for("react.suspense") : 60113, Do = La ? Symbol.for("react.suspense_list") : 60120, ys = La ? Symbol.for("react.memo") : 60115, Io = La ? Symbol.for("react.lazy") : 60116, so = La ? Symbol.for("react.block") : 60121, os = La ? Symbol.for("react.fundamental") : 60117, Xs = La ? Symbol.for("react.responder") : 60118, gl = La ? Symbol.for("react.scope") : 60119;
                function Sl(Ul) {
                  return typeof Ul == "string" || typeof Ul == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                  Ul === ro || Ul === Ts || Ul === eo || Ul === no || Ul === Fs || Ul === Do || typeof Ul == "object" && Ul !== null && (Ul.$$typeof === Io || Ul.$$typeof === ys || Ul.$$typeof === ao || Ul.$$typeof === io || Ul.$$typeof === qs || Ul.$$typeof === os || Ul.$$typeof === Xs || Ul.$$typeof === gl || Ul.$$typeof === so);
                }
                function El(Ul) {
                  if (typeof Ul == "object" && Ul !== null) {
                    var Yl = Ul.$$typeof;
                    switch (Yl) {
                      case Va:
                        var Jl = Ul.type;
                        switch (Jl) {
                          case xs:
                          case Ts:
                          case ro:
                          case eo:
                          case no:
                          case Fs:
                            return Jl;
                          default:
                            var Wl = Jl && Jl.$$typeof;
                            switch (Wl) {
                              case io:
                              case qs:
                              case Io:
                              case ys:
                              case ao:
                                return Wl;
                              default:
                                return Yl;
                            }
                        }
                      case to:
                        return Yl;
                    }
                  }
                }
                var wl = xs, jl = Ts, kl = io, Fl = ao, Ml = Va, ql = qs, Kl = ro, Zl = Io, Il = ys, xl = to, bl = eo, Pl = no, Nl = Fs, Bl = !1;
                function Ol(Ul) {
                  return Bl || (Bl = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), To(Ul) || El(Ul) === xs;
                }
                function To(Ul) {
                  return El(Ul) === Ts;
                }
                function Os(Ul) {
                  return El(Ul) === io;
                }
                function $l(Ul) {
                  return El(Ul) === ao;
                }
                function _l(Ul) {
                  return typeof Ul == "object" && Ul !== null && Ul.$$typeof === Va;
                }
                function Al(Ul) {
                  return El(Ul) === qs;
                }
                function Rl(Ul) {
                  return El(Ul) === ro;
                }
                function Cl(Ul) {
                  return El(Ul) === Io;
                }
                function ml(Ul) {
                  return El(Ul) === ys;
                }
                function Tl(Ul) {
                  return El(Ul) === to;
                }
                function Ll(Ul) {
                  return El(Ul) === eo;
                }
                function Vl(Ul) {
                  return El(Ul) === no;
                }
                function zl(Ul) {
                  return El(Ul) === Fs;
                }
                fa.AsyncMode = wl, fa.ConcurrentMode = jl, fa.ContextConsumer = kl, fa.ContextProvider = Fl, fa.Element = Ml, fa.ForwardRef = ql, fa.Fragment = Kl, fa.Lazy = Zl, fa.Memo = Il, fa.Portal = xl, fa.Profiler = bl, fa.StrictMode = Pl, fa.Suspense = Nl, fa.isAsyncMode = Ol, fa.isConcurrentMode = To, fa.isContextConsumer = Os, fa.isContextProvider = $l, fa.isElement = _l, fa.isForwardRef = Al, fa.isFragment = Rl, fa.isLazy = Cl, fa.isMemo = ml, fa.isPortal = Tl, fa.isProfiler = Ll, fa.isStrictMode = Vl, fa.isSuspense = zl, fa.isValidElementType = Sl, fa.typeOf = El;
              })();
            }
          ),
          /***/
          "./node_modules/react-is/index.js": (
            /*!****************************************!*\
              !*** ./node_modules/react-is/index.js ***!
              \****************************************/
            /***/
            (ia, fa, La) => {
              ia.exports = La(
                /*! ./cjs/react-is.development.js */
                "./node_modules/react-is/cjs/react-is.development.js"
              );
            }
          ),
          /***/
          "./node_modules/shallow-equal/dist/index.esm.js": (
            /*!******************************************************!*\
              !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
              \******************************************************/
            /***/
            (ia, fa, La) => {
              La.r(fa), La.d(fa, {
                /* harmony export */
                shallowEqualArrays: () => (
                  /* binding */
                  to
                ),
                /* harmony export */
                shallowEqualObjects: () => (
                  /* binding */
                  Va
                )
                /* harmony export */
              });
              function Va(ro, no) {
                if (ro === no)
                  return !0;
                if (!ro || !no)
                  return !1;
                var eo = Object.keys(ro), ao = Object.keys(no), io = eo.length;
                if (ao.length !== io)
                  return !1;
                for (var xs = 0; xs < io; xs++) {
                  var Ts = eo[xs];
                  if (ro[Ts] !== no[Ts] || !Object.prototype.hasOwnProperty.call(no, Ts))
                    return !1;
                }
                return !0;
              }
              function to(ro, no) {
                if (ro === no)
                  return !0;
                if (!ro || !no)
                  return !1;
                var eo = ro.length;
                if (no.length !== eo)
                  return !1;
                for (var ao = 0; ao < eo; ao++)
                  if (ro[ao] !== no[ao])
                    return !1;
                return !0;
              }
            }
          ),
          /***/
          "./src/Component.ts": (
            /*!**************************!*\
              !*** ./src/Component.ts ***!
              \**************************/
            /***/
            function(ia, fa, La) {
              var Va = this && this.__rest || function(eo, ao) {
                var io = {};
                for (var xs in eo) Object.prototype.hasOwnProperty.call(eo, xs) && ao.indexOf(xs) < 0 && (io[xs] = eo[xs]);
                if (eo != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var Ts = 0, xs = Object.getOwnPropertySymbols(eo); Ts < xs.length; Ts++)
                    ao.indexOf(xs[Ts]) < 0 && Object.prototype.propertyIsEnumerable.call(eo, xs[Ts]) && (io[xs[Ts]] = eo[xs[Ts]]);
                return io;
              }, to = this && this.__importDefault || function(eo) {
                return eo && eo.__esModule ? eo : { default: eo };
              };
              Object.defineProperty(fa, "__esModule", { value: !0 });
              var ro = to(La(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              )), no = function(eo) {
                var ao = eo.children, io = eo.device, xs = eo.onChange, Ts = Va(eo, ["children", "device", "onChange"]), qs = (0, ro.default)(Ts, io, xs);
                return typeof ao == "function" ? ao(qs) : qs ? ao : null;
              };
              fa.default = no;
            }
          ),
          /***/
          "./src/Context.ts": (
            /*!************************!*\
              !*** ./src/Context.ts ***!
              \************************/
            /***/
            (ia, fa, La) => {
              Object.defineProperty(fa, "__esModule", { value: !0 });
              var Va = La(
                /*! react */
                "react"
              ), to = (0, Va.createContext)(void 0);
              fa.default = to;
            }
          ),
          /***/
          "./src/index.ts": (
            /*!**********************!*\
              !*** ./src/index.ts ***!
              \**********************/
            /***/
            function(ia, fa, La) {
              var Va = this && this.__importDefault || function(ao) {
                return ao && ao.__esModule ? ao : { default: ao };
              };
              Object.defineProperty(fa, "__esModule", { value: !0 }), fa.Context = fa.toQuery = fa.useMediaQuery = fa.default = void 0;
              var to = Va(La(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              ));
              fa.useMediaQuery = to.default;
              var ro = Va(La(
                /*! ./Component */
                "./src/Component.ts"
              ));
              fa.default = ro.default;
              var no = Va(La(
                /*! ./toQuery */
                "./src/toQuery.ts"
              ));
              fa.toQuery = no.default;
              var eo = Va(La(
                /*! ./Context */
                "./src/Context.ts"
              ));
              fa.Context = eo.default;
            }
          ),
          /***/
          "./src/mediaQuery.ts": (
            /*!***************************!*\
              !*** ./src/mediaQuery.ts ***!
              \***************************/
            /***/
            function(ia, fa, La) {
              var Va = this && this.__assign || function() {
                return Va = Object.assign || function(Fs) {
                  for (var Do, ys = 1, Io = arguments.length; ys < Io; ys++) {
                    Do = arguments[ys];
                    for (var so in Do) Object.prototype.hasOwnProperty.call(Do, so) && (Fs[so] = Do[so]);
                  }
                  return Fs;
                }, Va.apply(this, arguments);
              }, to = this && this.__rest || function(Fs, Do) {
                var ys = {};
                for (var Io in Fs) Object.prototype.hasOwnProperty.call(Fs, Io) && Do.indexOf(Io) < 0 && (ys[Io] = Fs[Io]);
                if (Fs != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var so = 0, Io = Object.getOwnPropertySymbols(Fs); so < Io.length; so++)
                    Do.indexOf(Io[so]) < 0 && Object.prototype.propertyIsEnumerable.call(Fs, Io[so]) && (ys[Io[so]] = Fs[Io[so]]);
                return ys;
              }, ro = this && this.__importDefault || function(Fs) {
                return Fs && Fs.__esModule ? Fs : { default: Fs };
              };
              Object.defineProperty(fa, "__esModule", { value: !0 });
              var no = ro(La(
                /*! prop-types */
                "./node_modules/prop-types/index.js"
              )), eo = no.default.oneOfType([
                no.default.string,
                no.default.number
              ]), ao = {
                all: no.default.bool,
                grid: no.default.bool,
                aural: no.default.bool,
                braille: no.default.bool,
                handheld: no.default.bool,
                print: no.default.bool,
                projection: no.default.bool,
                screen: no.default.bool,
                tty: no.default.bool,
                tv: no.default.bool,
                embossed: no.default.bool
              }, io = {
                orientation: no.default.oneOf([
                  "portrait",
                  "landscape"
                ]),
                scan: no.default.oneOf([
                  "progressive",
                  "interlace"
                ]),
                aspectRatio: no.default.string,
                deviceAspectRatio: no.default.string,
                height: eo,
                deviceHeight: eo,
                width: eo,
                deviceWidth: eo,
                color: no.default.bool,
                colorIndex: no.default.bool,
                monochrome: no.default.bool,
                resolution: eo,
                type: Object.keys(ao)
              };
              io.type;
              var xs = to(
                io,
                ["type"]
              ), Ts = Va({ minAspectRatio: no.default.string, maxAspectRatio: no.default.string, minDeviceAspectRatio: no.default.string, maxDeviceAspectRatio: no.default.string, minHeight: eo, maxHeight: eo, minDeviceHeight: eo, maxDeviceHeight: eo, minWidth: eo, maxWidth: eo, minDeviceWidth: eo, maxDeviceWidth: eo, minColor: no.default.number, maxColor: no.default.number, minColorIndex: no.default.number, maxColorIndex: no.default.number, minMonochrome: no.default.number, maxMonochrome: no.default.number, minResolution: eo, maxResolution: eo }, xs), qs = Va(Va({}, ao), Ts);
              fa.default = {
                all: qs,
                types: ao,
                matchers: io,
                features: Ts
              };
            }
          ),
          /***/
          "./src/toQuery.ts": (
            /*!************************!*\
              !*** ./src/toQuery.ts ***!
              \************************/
            /***/
            function(ia, fa, La) {
              var Va = this && this.__importDefault || function(xs) {
                return xs && xs.__esModule ? xs : { default: xs };
              };
              Object.defineProperty(fa, "__esModule", { value: !0 });
              var to = Va(La(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), ro = Va(La(
                /*! ./mediaQuery */
                "./src/mediaQuery.ts"
              )), no = function(xs) {
                return "not ".concat(xs);
              }, eo = function(xs, Ts) {
                var qs = (0, to.default)(xs);
                return typeof Ts == "number" && (Ts = "".concat(Ts, "px")), Ts === !0 ? qs : Ts === !1 ? no(qs) : "(".concat(qs, ": ").concat(Ts, ")");
              }, ao = function(xs) {
                return xs.join(" and ");
              }, io = function(xs) {
                var Ts = [];
                return Object.keys(ro.default.all).forEach(function(qs) {
                  var Fs = xs[qs];
                  Fs != null && Ts.push(eo(qs, Fs));
                }), ao(Ts);
              };
              fa.default = io;
            }
          ),
          /***/
          "./src/useMediaQuery.ts": (
            /*!******************************!*\
              !*** ./src/useMediaQuery.ts ***!
              \******************************/
            /***/
            function(ia, fa, La) {
              var Va = this && this.__importDefault || function(os) {
                return os && os.__esModule ? os : { default: os };
              };
              Object.defineProperty(fa, "__esModule", { value: !0 });
              var to = La(
                /*! react */
                "react"
              ), ro = Va(La(
                /*! matchmediaquery */
                "./node_modules/matchmediaquery/index.js"
              )), no = Va(La(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), eo = La(
                /*! shallow-equal */
                "./node_modules/shallow-equal/dist/index.esm.js"
              ), ao = Va(La(
                /*! ./toQuery */
                "./src/toQuery.ts"
              )), io = Va(La(
                /*! ./Context */
                "./src/Context.ts"
              )), xs = function(os) {
                return os.query || (0, ao.default)(os);
              }, Ts = function(os) {
                if (os) {
                  var Xs = Object.keys(os);
                  return Xs.reduce(function(gl, Sl) {
                    return gl[(0, no.default)(Sl)] = os[Sl], gl;
                  }, {});
                }
              }, qs = function() {
                var os = (0, to.useRef)(!1);
                return (0, to.useEffect)(function() {
                  os.current = !0;
                }, []), os.current;
              }, Fs = function(os) {
                var Xs = (0, to.useContext)(io.default), gl = function() {
                  return Ts(os) || Ts(Xs);
                }, Sl = (0, to.useState)(gl), El = Sl[0], wl = Sl[1];
                return (0, to.useEffect)(function() {
                  var jl = gl();
                  (0, eo.shallowEqualObjects)(El, jl) || wl(jl);
                }, [os, Xs]), El;
              }, Do = function(os) {
                var Xs = function() {
                  return xs(os);
                }, gl = (0, to.useState)(Xs), Sl = gl[0], El = gl[1];
                return (0, to.useEffect)(function() {
                  var wl = Xs();
                  Sl !== wl && El(wl);
                }, [os]), Sl;
              }, ys = function(os, Xs) {
                var gl = function() {
                  return (0, ro.default)(os, Xs || {}, !!Xs);
                }, Sl = (0, to.useState)(gl), El = Sl[0], wl = Sl[1], jl = qs();
                return (0, to.useEffect)(function() {
                  if (jl) {
                    var kl = gl();
                    return wl(kl), function() {
                      kl && kl.dispose();
                    };
                  }
                }, [os, Xs]), El;
              }, Io = function(os) {
                var Xs = (0, to.useState)(os.matches), gl = Xs[0], Sl = Xs[1];
                return (0, to.useEffect)(function() {
                  var El = function(wl) {
                    Sl(wl.matches);
                  };
                  return os.addListener(El), Sl(os.matches), function() {
                    os.removeListener(El);
                  };
                }, [os]), gl;
              }, so = function(os, Xs, gl) {
                var Sl = Fs(Xs), El = Do(os);
                if (!El)
                  throw new Error("Invalid or missing MediaQuery!");
                var wl = ys(El, Sl), jl = Io(wl), kl = qs();
                return (0, to.useEffect)(function() {
                  kl && gl && gl(jl);
                }, [jl]), (0, to.useEffect)(function() {
                  return function() {
                    wl && wl.dispose();
                  };
                }, []), jl;
              };
              fa.default = so;
            }
          ),
          /***/
          react: (
            /*!**************************************************************************************!*\
              !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
              \**************************************************************************************/
            /***/
            (ia) => {
              ia.exports = Zi;
            }
          )
          /******/
        }, ea = {};
        function ra(ia) {
          var fa = ea[ia];
          if (fa !== void 0)
            return fa.exports;
          var La = ea[ia] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return Qi[ia].call(La.exports, La, La.exports, ra), La.exports;
        }
        ra.d = (ia, fa) => {
          for (var La in fa)
            ra.o(fa, La) && !ra.o(ia, La) && Object.defineProperty(ia, La, { enumerable: !0, get: fa[La] });
        }, ra.o = (ia, fa) => Object.prototype.hasOwnProperty.call(ia, fa), ra.r = (ia) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(ia, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(ia, "__esModule", { value: !0 });
        };
        var na = ra("./src/index.ts");
        return na;
      })()
    ));
  }(reactResponsive$1)), reactResponsive$1.exports;
}
var reactResponsiveExports = /* @__PURE__ */ requireReactResponsive();
const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, useTailwindBreakpoint = (Bi) => reactResponsiveExports.useMediaQuery({ minWidth: breakpoints[Bi] }), AppLayoutContext = createContext({}), useAppLayoutContext = () => useContext(AppLayoutContext), AppBar$1 = ({
  children: Bi,
  className: e = "",
  style: Zi = {},
  hideDrawerButton: Qi = !0
}) => {
  const { menuVisible: ea, onMenuToggle: ra, layoutRef: na } = useAppLayoutContext(), ia = useTailwindBreakpoint("sm");
  return na ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "nav",
      {
        className: twMerge(
          "col-span-full bg-blue-500 flex justify-start items-center text-white px-4 col-start-1 row-span-1 w-full h-full",
          e
        ),
        style: Zi,
        children: [
          ia && !Qi && /* @__PURE__ */ jsxRuntimeExports.jsx(
            DrawerButton,
            {
              className: "mr-8",
              sideBarVisible: ea,
              onClick: () => ra?.(!ea)
            }
          ),
          Bi,
          !ia && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            DrawerButton,
            {
              sideBarVisible: ea,
              onClick: () => ra?.(!ea)
            }
          ) })
        ]
      }
    ),
    na
  ) : null;
}, AppLayoutBody = ({ children: Bi }) => {
  const { layoutRef: e } = useAppLayoutContext();
  return e ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx("main", { className: "w-full h-full overflow-hidden row-start-2 col-start-2 col-span-full", children: Bi }),
    e
  ) : null;
}, styles = cva(
  [
    "bg-neutral-200",
    "h-full",
    "overflow-auto",
    "row-start-2",
    "col-span-1",
    "col-start-1"
  ],
  {
    variants: {
      size: {
        sm: ["sm:hidden", "block", "z-50"],
        lg: ["sm:block"]
      }
    }
  }
), AppLayoutMenu = ({ children: Bi }) => {
  const { onMenuToggle: e, menuVisible: Zi, layoutRef: Qi } = useAppLayoutContext(), ea = useTailwindBreakpoint("sm");
  return Qi ? ea ? Zi ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "aside",
      {
        className: styles({ size: "lg" }),
        children: Bi
      },
      "app-layout-menu"
    ),
    Qi
  ) : null : Zi ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "aside",
      {
        className: styles({ size: "sm" }),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => e?.(!1),
              className: "ml-auto text-neutral-700",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faX, size: "sm" })
            }
          ),
          Bi
        ]
      },
      "app-layout-menu"
    ),
    Qi
  ) : null : null;
};
function AppLayoutMenuLink({
  to: Bi,
  icon: e,
  name: Zi,
  hasNotifications: Qi,
  children: ea,
  href: ra,
  linkProps: na
}) {
  if (!ra && !Bi)
    throw new Error("to or href is required");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AnimateSharedLayout, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col my-2", children: ra ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "a",
    {
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      href: ra,
      target: "_blank",
      rel: "noreferrer",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex align-middle ", children: [
          Qi && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            FontAwesomeIcon,
            {
              icon: e,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: Zi })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        ea
      ]
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Link,
    {
      to: Bi,
      ...na || {},
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex align-middle ", children: [
          Qi && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            FontAwesomeIcon,
            {
              icon: e,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: Zi })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        ea
      ]
    }
  ) }) });
}
const layoutRootStyles = cva([
  "grid",
  "w-screen",
  "h-screen",
  "overflow-hidden",
  "bg-neutral-100",
  "flex-col",
  "app-layout",
  "grid-cols-[min-content_minmax(0,1fr)]",
  "grid-rows-[6rem_minmax(0,1fr)]"
]), AppLayout = ({
  menuVisible: Bi = !1,
  children: e,
  onMenuToggle: Zi
}) => {
  const [Qi, ea] = a__default.useState(null), [ra, na] = a__default.useState(null), [ia, fa] = a__default.useState(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AppLayoutContext.Provider,
    {
      value: {
        menuVisible: Bi,
        menuRef: ia,
        onMenuToggle: Zi,
        layoutRef: Qi,
        headerRef: ra
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: layoutRootStyles(),
          ref: ea,
          children: e
        }
      )
    }
  );
};
AppLayout.Header = AppBar$1;
AppLayout.Body = AppLayoutBody;
AppLayout.Menu = AppLayoutMenu;
AppLayout.Link = AppLayoutMenuLink;
const AppBar = ({
  onClick: Bi,
  sideBarVisible: e,
  className: Zi,
  showMenu: Qi = !0,
  isLoggedIn: ea = !1,
  children: ra
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "nav",
  {
    className: twMerge(
      "w-screen h-full flex justify-between col-span-12 row-span-1 px-4 bg-blue-500",
      Zi
    ),
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex", children: [
        Qi && /* @__PURE__ */ jsxRuntimeExports.jsx(
          DrawerButton,
          {
            sideBarVisible: e,
            onClick: Bi || (() => null)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { to: "/app", className: "block mx-4 my-auto h-1/2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Logo, { className: "w-8 h-8" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "my-auto text-xl text-white uppercase font-terminal ", children: ra })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Menu,
        {
          className: "my-auto",
          button: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { color: "white", size: "1x", icon: faUserCog }),
          children: [
            ea && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mb-8 border-b border-opacity-30 border-b-black" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { className: "menu-item", to: "/app/account", children: "Account" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { className: "menu-item", to: "/app/account/change-password", children: "Change Password" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { className: "menu-item", to: "/app/account/tokens", children: "CLI Tokens" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                MenuItem,
                {
                  onAction: async () => {
                  },
                  children: "Logout"
                }
              )
            ] }),
            !ea && /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { to: "/login", children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { children: "Login" }) })
          ]
        }
      )
    ]
  }
), defaultOptions = {};
gql`
    mutation CreateFolder($newFolder: String!, $currentFolder: String!, $s3BucketId: Float) {
  createFolder(
    newFolder: $newFolder
    currentFolder: $currentFolder
    s3BucketId: $s3BucketId
  )
}
    `;
gql`
    mutation DeleteFiles($paths: [S3ObjectInput!]!) {
  deleteFilesResolver(paths: $paths)
}
    `;
gql`
    mutation MoveS3Files($target: S3ObjectInput!, $source: S3ObjectInput!) {
  moveS3Files(target: $target, source: $source)
}
    `;
gql`
    mutation MoveUpAFolder($moveUpAFolderPath: S3ObjectInput!) {
  moveUpAFolder(path: $moveUpAFolderPath)
}
    `;
gql`
    query FileTransfers {
  fileTransfers {
    name
    progress
    id
  }
}
    `;
gql`
    query FolderContents($s3BucketId: Float, $folder: String) {
  folderContents(s3BucketId: $s3BucketId, folder: $folder) {
    contents {
      key
      name
      isFolder
      fullPath
      bucket
    }
    errors
  }
  me {
    id
    awsUsername
  }
}
    `;
gql`
    query folderContentsSearch($search: String!, $s3BucketId: Int) {
  fileSearch(search: $search, s3BucketId: $s3BucketId) {
    results {
      fullPath
      key
      name
      isFolder
      bucket
    }
    errors
  }
}
    `;
const MeDocument = gql`
    query Me {
  me {
    id
    email
    awsUsername
    firstname
    lastname
    roles {
      role
    }
  }
}
    `;
function useMeQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useQuery(MeDocument, e);
}
function useMeLazyQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useLazyQuery(MeDocument, e);
}
const PresignedDownloadUrlDocument = gql`
    query PresignedDownloadUrl($bucket: String!, $key: String!, $limit: Float) {
  presignedDownloadUrl(bucket: $bucket, key: $key, limit: $limit)
}
    `;
function usePresignedDownloadUrlQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useQuery(PresignedDownloadUrlDocument, e);
}
function usePresignedDownloadUrlLazyQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useLazyQuery(PresignedDownloadUrlDocument, e);
}
gql`
    subscription FileTranfersUpdated {
  fileTransfersUpdated {
    progress
    id
    name
  }
}
    `;
const TaskQueueLogsDocument = gql`
    subscription TaskQueueLogs($jobId: String!) {
  taskQueueLogs(jobId: $jobId) {
    message
    timestamp
  }
}
    `;
function useTaskQueueLogsSubscription(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useSubscription(TaskQueueLogsDocument, e);
}
const ReaderLayout = ({ appBarTitle: Bi }) => {
  const { data: e } = useMeQuery();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(motion.div, { className: "grid w-screen h-screen bg-neutral-300 grid-rows-[4rem minmax(0, 1fr)] grid-cols-1", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AppBar,
      {
        className: "h-16 bg-blue-600 ",
        onClick: () => null,
        sideBarVisible: !1,
        showMenu: !1,
        isLoggedIn: !!e?.me,
        children: Bi
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex justify-around w-full h-full ", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-full h-full max-w-6xl p-4 overflow-scroll bg-neutral-100", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Outlet, {}) }) })
  ] });
}, pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}, Page = ({
  children: Bi,
  className: e
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  motion.div,
  {
    className: twMerge("w-full min-h-full overflow-scroll", e),
    initial: "initial",
    animate: "in",
    exit: "out",
    variants: pageVariants,
    children: Bi
  }
), PageHeaderTitle = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "text-2xl flex-grow border-opacity-25", children: Bi.children }), PageHeader = ({ children: Bi, title: e, className: Zi }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `flex py-2 mb-4 border-b border-black ${Zi}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  typeof e == "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeaderTitle, { children: e }) : e,
  Bi
] }) }), NotFound = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Page, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { title: "Page not found" }) }), ImagePreview = ({ data: Bi }) => {
  const e = URL.createObjectURL(Bi);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: e, alt: "" }) });
}, Spinner = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "loader" }), CircleSpinner = () => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." });
function commonjsRequire(Bi) {
  throw new Error('Could not dynamically require "' + Bi + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var pdf = { exports: {} };
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$5 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasRequiredPdf;
function requirePdf() {
  return hasRequiredPdf || (hasRequiredPdf = 1, function(module, exports) {
    (function(e, Zi) {
      module.exports = Zi();
    })(globalThis, () => (
      /******/
      (() => {
        var __webpack_modules__ = [
          ,
          /* 1 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.VerbosityLevel = e.Util = e.UnknownErrorException = e.UnexpectedResponseException = e.UNSUPPORTED_FEATURES = e.TextRenderingMode = e.StreamType = e.RenderingIntentFlag = e.PermissionFlag = e.PasswordResponses = e.PasswordException = e.PageActionEventType = e.OPS = e.MissingPDFException = e.LINE_FACTOR = e.LINE_DESCENT_FACTOR = e.InvalidPDFException = e.ImageKind = e.IDENTITY_MATRIX = e.FormatError = e.FontType = e.FeatureTest = e.FONT_IDENTITY_MATRIX = e.DocumentActionEventType = e.CMapCompressionType = e.BaseException = e.AnnotationType = e.AnnotationStateModelType = e.AnnotationReviewState = e.AnnotationReplyType = e.AnnotationMode = e.AnnotationMarkedState = e.AnnotationFlag = e.AnnotationFieldFlag = e.AnnotationEditorType = e.AnnotationEditorPrefix = e.AnnotationEditorParamsType = e.AnnotationBorderStyleType = e.AnnotationActionEventType = e.AbortException = void 0, e.arrayByteLength = Tl, e.arraysToBytes = Ll, e.assert = xl, e.bytesToString = Cl, e.createPromiseCapability = _d, e.createValidAbsoluteUrl = Pl, e.escapeString = Xu, e.getModificationDate = $d, e.getVerbosityLevel = ql, e.info = Kl, e.isArrayBuffer = sd, e.isArrayEqual = bd, e.isAscii = ed, e.objectFromMap = Ul, e.objectSize = zl, e.setVerbosityLevel = Ml, e.shadow = Nl, e.string32 = Vl, e.stringToBytes = ml, e.stringToPDFString = zu, e.stringToUTF16BEString = td, e.stringToUTF8String = od, e.unreachable = Il, e.utf8StringToString = ld, e.warn = Zl, Zi(2);
            const Qi = [1, 0, 0, 1, 0, 0];
            e.IDENTITY_MATRIX = Qi;
            const ea = [1e-3, 0, 0, 1e-3, 0, 0];
            e.FONT_IDENTITY_MATRIX = ea;
            const ra = 1.35;
            e.LINE_FACTOR = ra;
            const na = 0.35;
            e.LINE_DESCENT_FACTOR = na;
            const ia = {
              ANY: 1,
              DISPLAY: 2,
              PRINT: 4,
              ANNOTATIONS_FORMS: 16,
              ANNOTATIONS_STORAGE: 32,
              ANNOTATIONS_DISABLE: 64,
              OPLIST: 256
            };
            e.RenderingIntentFlag = ia;
            const fa = {
              DISABLE: 0,
              ENABLE: 1,
              ENABLE_FORMS: 2,
              ENABLE_STORAGE: 3
            };
            e.AnnotationMode = fa;
            const La = "pdfjs_internal_editor_";
            e.AnnotationEditorPrefix = La;
            const Va = {
              DISABLE: -1,
              NONE: 0,
              FREETEXT: 3,
              INK: 15
            };
            e.AnnotationEditorType = Va;
            const to = {
              FREETEXT_SIZE: 1,
              FREETEXT_COLOR: 2,
              FREETEXT_OPACITY: 3,
              INK_COLOR: 11,
              INK_THICKNESS: 12,
              INK_OPACITY: 13
            };
            e.AnnotationEditorParamsType = to;
            const ro = {
              PRINT: 4,
              MODIFY_CONTENTS: 8,
              COPY: 16,
              MODIFY_ANNOTATIONS: 32,
              FILL_INTERACTIVE_FORMS: 256,
              COPY_FOR_ACCESSIBILITY: 512,
              ASSEMBLE: 1024,
              PRINT_HIGH_QUALITY: 2048
            };
            e.PermissionFlag = ro;
            const no = {
              FILL: 0,
              STROKE: 1,
              FILL_STROKE: 2,
              INVISIBLE: 3,
              FILL_ADD_TO_PATH: 4,
              STROKE_ADD_TO_PATH: 5,
              FILL_STROKE_ADD_TO_PATH: 6,
              ADD_TO_PATH: 7,
              FILL_STROKE_MASK: 3,
              ADD_TO_PATH_FLAG: 4
            };
            e.TextRenderingMode = no;
            const eo = {
              GRAYSCALE_1BPP: 1,
              RGB_24BPP: 2,
              RGBA_32BPP: 3
            };
            e.ImageKind = eo;
            const ao = {
              TEXT: 1,
              LINK: 2,
              FREETEXT: 3,
              LINE: 4,
              SQUARE: 5,
              CIRCLE: 6,
              POLYGON: 7,
              POLYLINE: 8,
              HIGHLIGHT: 9,
              UNDERLINE: 10,
              SQUIGGLY: 11,
              STRIKEOUT: 12,
              STAMP: 13,
              CARET: 14,
              INK: 15,
              POPUP: 16,
              FILEATTACHMENT: 17,
              SOUND: 18,
              MOVIE: 19,
              WIDGET: 20,
              SCREEN: 21,
              PRINTERMARK: 22,
              TRAPNET: 23,
              WATERMARK: 24,
              THREED: 25,
              REDACT: 26
            };
            e.AnnotationType = ao;
            const io = {
              MARKED: "Marked",
              REVIEW: "Review"
            };
            e.AnnotationStateModelType = io;
            const xs = {
              MARKED: "Marked",
              UNMARKED: "Unmarked"
            };
            e.AnnotationMarkedState = xs;
            const Ts = {
              ACCEPTED: "Accepted",
              REJECTED: "Rejected",
              CANCELLED: "Cancelled",
              COMPLETED: "Completed",
              NONE: "None"
            };
            e.AnnotationReviewState = Ts;
            const qs = {
              GROUP: "Group",
              REPLY: "R"
            };
            e.AnnotationReplyType = qs;
            const Fs = {
              INVISIBLE: 1,
              HIDDEN: 2,
              PRINT: 4,
              NOZOOM: 8,
              NOROTATE: 16,
              NOVIEW: 32,
              READONLY: 64,
              LOCKED: 128,
              TOGGLENOVIEW: 256,
              LOCKEDCONTENTS: 512
            };
            e.AnnotationFlag = Fs;
            const Do = {
              READONLY: 1,
              REQUIRED: 2,
              NOEXPORT: 4,
              MULTILINE: 4096,
              PASSWORD: 8192,
              NOTOGGLETOOFF: 16384,
              RADIO: 32768,
              PUSHBUTTON: 65536,
              COMBO: 131072,
              EDIT: 262144,
              SORT: 524288,
              FILESELECT: 1048576,
              MULTISELECT: 2097152,
              DONOTSPELLCHECK: 4194304,
              DONOTSCROLL: 8388608,
              COMB: 16777216,
              RICHTEXT: 33554432,
              RADIOSINUNISON: 33554432,
              COMMITONSELCHANGE: 67108864
            };
            e.AnnotationFieldFlag = Do;
            const ys = {
              SOLID: 1,
              DASHED: 2,
              BEVELED: 3,
              INSET: 4,
              UNDERLINE: 5
            };
            e.AnnotationBorderStyleType = ys;
            const Io = {
              E: "Mouse Enter",
              X: "Mouse Exit",
              D: "Mouse Down",
              U: "Mouse Up",
              Fo: "Focus",
              Bl: "Blur",
              PO: "PageOpen",
              PC: "PageClose",
              PV: "PageVisible",
              PI: "PageInvisible",
              K: "Keystroke",
              F: "Format",
              V: "Validate",
              C: "Calculate"
            };
            e.AnnotationActionEventType = Io;
            const so = {
              WC: "WillClose",
              WS: "WillSave",
              DS: "DidSave",
              WP: "WillPrint",
              DP: "DidPrint"
            };
            e.DocumentActionEventType = so;
            const os = {
              O: "PageOpen",
              C: "PageClose"
            };
            e.PageActionEventType = os;
            const Xs = {
              UNKNOWN: "UNKNOWN",
              FLATE: "FLATE",
              LZW: "LZW",
              DCT: "DCT",
              JPX: "JPX",
              JBIG: "JBIG",
              A85: "A85",
              AHX: "AHX",
              CCF: "CCF",
              RLX: "RLX"
            };
            e.StreamType = Xs;
            const gl = {
              UNKNOWN: "UNKNOWN",
              TYPE1: "TYPE1",
              TYPE1STANDARD: "TYPE1STANDARD",
              TYPE1C: "TYPE1C",
              CIDFONTTYPE0: "CIDFONTTYPE0",
              CIDFONTTYPE0C: "CIDFONTTYPE0C",
              TRUETYPE: "TRUETYPE",
              CIDFONTTYPE2: "CIDFONTTYPE2",
              TYPE3: "TYPE3",
              OPENTYPE: "OPENTYPE",
              TYPE0: "TYPE0",
              MMTYPE1: "MMTYPE1"
            };
            e.FontType = gl;
            const Sl = {
              ERRORS: 0,
              WARNINGS: 1,
              INFOS: 5
            };
            e.VerbosityLevel = Sl;
            const El = {
              NONE: 0,
              BINARY: 1,
              STREAM: 2
            };
            e.CMapCompressionType = El;
            const wl = {
              dependency: 1,
              setLineWidth: 2,
              setLineCap: 3,
              setLineJoin: 4,
              setMiterLimit: 5,
              setDash: 6,
              setRenderingIntent: 7,
              setFlatness: 8,
              setGState: 9,
              save: 10,
              restore: 11,
              transform: 12,
              moveTo: 13,
              lineTo: 14,
              curveTo: 15,
              curveTo2: 16,
              curveTo3: 17,
              closePath: 18,
              rectangle: 19,
              stroke: 20,
              closeStroke: 21,
              fill: 22,
              eoFill: 23,
              fillStroke: 24,
              eoFillStroke: 25,
              closeFillStroke: 26,
              closeEOFillStroke: 27,
              endPath: 28,
              clip: 29,
              eoClip: 30,
              beginText: 31,
              endText: 32,
              setCharSpacing: 33,
              setWordSpacing: 34,
              setHScale: 35,
              setLeading: 36,
              setFont: 37,
              setTextRenderingMode: 38,
              setTextRise: 39,
              moveText: 40,
              setLeadingMoveText: 41,
              setTextMatrix: 42,
              nextLine: 43,
              showText: 44,
              showSpacedText: 45,
              nextLineShowText: 46,
              nextLineSetSpacingShowText: 47,
              setCharWidth: 48,
              setCharWidthAndBounds: 49,
              setStrokeColorSpace: 50,
              setFillColorSpace: 51,
              setStrokeColor: 52,
              setStrokeColorN: 53,
              setFillColor: 54,
              setFillColorN: 55,
              setStrokeGray: 56,
              setFillGray: 57,
              setStrokeRGBColor: 58,
              setFillRGBColor: 59,
              setStrokeCMYKColor: 60,
              setFillCMYKColor: 61,
              shadingFill: 62,
              beginInlineImage: 63,
              beginImageData: 64,
              endInlineImage: 65,
              paintXObject: 66,
              markPoint: 67,
              markPointProps: 68,
              beginMarkedContent: 69,
              beginMarkedContentProps: 70,
              endMarkedContent: 71,
              beginCompat: 72,
              endCompat: 73,
              paintFormXObjectBegin: 74,
              paintFormXObjectEnd: 75,
              beginGroup: 76,
              endGroup: 77,
              beginAnnotations: 78,
              endAnnotations: 79,
              beginAnnotation: 80,
              endAnnotation: 81,
              paintJpegXObject: 82,
              paintImageMaskXObject: 83,
              paintImageMaskXObjectGroup: 84,
              paintImageXObject: 85,
              paintInlineImageXObject: 86,
              paintInlineImageXObjectGroup: 87,
              paintImageXObjectRepeat: 88,
              paintImageMaskXObjectRepeat: 89,
              paintSolidColorImageMask: 90,
              constructPath: 91
            };
            e.OPS = wl;
            const jl = {
              unknown: "unknown",
              forms: "forms",
              javaScript: "javaScript",
              signatures: "signatures",
              smask: "smask",
              shadingPattern: "shadingPattern",
              font: "font",
              errorTilingPattern: "errorTilingPattern",
              errorExtGState: "errorExtGState",
              errorXObject: "errorXObject",
              errorFontLoadType3: "errorFontLoadType3",
              errorFontState: "errorFontState",
              errorFontMissing: "errorFontMissing",
              errorFontTranslate: "errorFontTranslate",
              errorColorSpace: "errorColorSpace",
              errorOperatorList: "errorOperatorList",
              errorFontToUnicode: "errorFontToUnicode",
              errorFontLoadNative: "errorFontLoadNative",
              errorFontBuildPath: "errorFontBuildPath",
              errorFontGetPath: "errorFontGetPath",
              errorMarkedContent: "errorMarkedContent",
              errorContentSubStream: "errorContentSubStream"
            };
            e.UNSUPPORTED_FEATURES = jl;
            const kl = {
              NEED_PASSWORD: 1,
              INCORRECT_PASSWORD: 2
            };
            e.PasswordResponses = kl;
            let Fl = Sl.WARNINGS;
            function Ml(tc) {
              Number.isInteger(tc) && (Fl = tc);
            }
            function ql() {
              return Fl;
            }
            function Kl(tc) {
              Fl >= Sl.INFOS && console.log(`Info: ${tc}`);
            }
            function Zl(tc) {
              Fl >= Sl.WARNINGS && console.log(`Warning: ${tc}`);
            }
            function Il(tc) {
              throw new Error(tc);
            }
            function xl(tc, Xl) {
              tc || Il(Xl);
            }
            function bl(tc) {
              if (!tc)
                return !1;
              switch (tc.protocol) {
                case "http:":
                case "https:":
                case "ftp:":
                case "mailto:":
                case "tel:":
                  return !0;
                default:
                  return !1;
              }
            }
            function Pl(tc, Xl = null, Ql = null) {
              if (!tc)
                return null;
              try {
                if (Ql && typeof tc == "string") {
                  if (Ql.addDefaultProtocol && tc.startsWith("www.")) {
                    const Yu = tc.match(/\./g);
                    Yu && Yu.length >= 2 && (tc = `http://${tc}`);
                  }
                  if (Ql.tryConvertEncoding)
                    try {
                      tc = od(tc);
                    } catch {
                    }
                }
                const $u = Xl ? new URL(tc, Xl) : new URL(tc);
                if (bl($u))
                  return $u;
              } catch {
              }
              return null;
            }
            function Nl(tc, Xl, Ql) {
              return Object.defineProperty(tc, Xl, {
                value: Ql,
                enumerable: !0,
                configurable: !0,
                writable: !1
              }), Ql;
            }
            const Bl = function() {
              function Xl(Ql, $u) {
                this.constructor === Xl && Il("Cannot initialize BaseException."), this.message = Ql, this.name = $u;
              }
              return Xl.prototype = new Error(), Xl.constructor = Xl, Xl;
            }();
            e.BaseException = Bl;
            class Ol extends Bl {
              constructor(Xl, Ql) {
                super(Xl, "PasswordException"), this.code = Ql;
              }
            }
            e.PasswordException = Ol;
            class To extends Bl {
              constructor(Xl, Ql) {
                super(Xl, "UnknownErrorException"), this.details = Ql;
              }
            }
            e.UnknownErrorException = To;
            class Os extends Bl {
              constructor(Xl) {
                super(Xl, "InvalidPDFException");
              }
            }
            e.InvalidPDFException = Os;
            class $l extends Bl {
              constructor(Xl) {
                super(Xl, "MissingPDFException");
              }
            }
            e.MissingPDFException = $l;
            class _l extends Bl {
              constructor(Xl, Ql) {
                super(Xl, "UnexpectedResponseException"), this.status = Ql;
              }
            }
            e.UnexpectedResponseException = _l;
            class Al extends Bl {
              constructor(Xl) {
                super(Xl, "FormatError");
              }
            }
            e.FormatError = Al;
            class Rl extends Bl {
              constructor(Xl) {
                super(Xl, "AbortException");
              }
            }
            e.AbortException = Rl;
            function Cl(tc) {
              (typeof tc != "object" || tc === null || tc.length === void 0) && Il("Invalid argument for bytesToString");
              const Xl = tc.length, Ql = 8192;
              if (Xl < Ql)
                return String.fromCharCode.apply(null, tc);
              const $u = [];
              for (let Yu = 0; Yu < Xl; Yu += Ql) {
                const ud = Math.min(Yu + Ql, Xl), dd = tc.subarray(Yu, ud);
                $u.push(String.fromCharCode.apply(null, dd));
              }
              return $u.join("");
            }
            function ml(tc) {
              typeof tc != "string" && Il("Invalid argument for stringToBytes");
              const Xl = tc.length, Ql = new Uint8Array(Xl);
              for (let $u = 0; $u < Xl; ++$u)
                Ql[$u] = tc.charCodeAt($u) & 255;
              return Ql;
            }
            function Tl(tc) {
              if (tc.length !== void 0)
                return tc.length;
              if (tc.byteLength !== void 0)
                return tc.byteLength;
              Il("Invalid argument for arrayByteLength");
            }
            function Ll(tc) {
              const Xl = tc.length;
              if (Xl === 1 && tc[0] instanceof Uint8Array)
                return tc[0];
              let Ql = 0;
              for (let ud = 0; ud < Xl; ud++)
                Ql += Tl(tc[ud]);
              let $u = 0;
              const Yu = new Uint8Array(Ql);
              for (let ud = 0; ud < Xl; ud++) {
                let dd = tc[ud];
                dd instanceof Uint8Array || (typeof dd == "string" ? dd = ml(dd) : dd = new Uint8Array(dd));
                const Ed = dd.byteLength;
                Yu.set(dd, $u), $u += Ed;
              }
              return Yu;
            }
            function Vl(tc) {
              return String.fromCharCode(tc >> 24 & 255, tc >> 16 & 255, tc >> 8 & 255, tc & 255);
            }
            function zl(tc) {
              return Object.keys(tc).length;
            }
            function Ul(tc) {
              const Xl = /* @__PURE__ */ Object.create(null);
              for (const [Ql, $u] of tc)
                Xl[Ql] = $u;
              return Xl;
            }
            function Yl() {
              const tc = new Uint8Array(4);
              return tc[0] = 1, new Uint32Array(tc.buffer, 0, 1)[0] === 1;
            }
            function Jl() {
              try {
                return new Function(""), !0;
              } catch {
                return !1;
              }
            }
            class Wl {
              static get isLittleEndian() {
                return Nl(this, "isLittleEndian", Yl());
              }
              static get isEvalSupported() {
                return Nl(this, "isEvalSupported", Jl());
              }
              static get isOffscreenCanvasSupported() {
                return Nl(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
              }
            }
            e.FeatureTest = Wl;
            const rc = [...Array(256).keys()].map((tc) => tc.toString(16).padStart(2, "0"));
            class uc {
              static makeHexColor(Xl, Ql, $u) {
                return `#${rc[Xl]}${rc[Ql]}${rc[$u]}`;
              }
              static scaleMinMax(Xl, Ql) {
                let $u;
                Xl[0] ? (Xl[0] < 0 && ($u = Ql[0], Ql[0] = Ql[1], Ql[1] = $u), Ql[0] *= Xl[0], Ql[1] *= Xl[0], Xl[3] < 0 && ($u = Ql[2], Ql[2] = Ql[3], Ql[3] = $u), Ql[2] *= Xl[3], Ql[3] *= Xl[3]) : ($u = Ql[0], Ql[0] = Ql[2], Ql[2] = $u, $u = Ql[1], Ql[1] = Ql[3], Ql[3] = $u, Xl[1] < 0 && ($u = Ql[2], Ql[2] = Ql[3], Ql[3] = $u), Ql[2] *= Xl[1], Ql[3] *= Xl[1], Xl[2] < 0 && ($u = Ql[0], Ql[0] = Ql[1], Ql[1] = $u), Ql[0] *= Xl[2], Ql[1] *= Xl[2]), Ql[0] += Xl[4], Ql[1] += Xl[4], Ql[2] += Xl[5], Ql[3] += Xl[5];
              }
              static transform(Xl, Ql) {
                return [Xl[0] * Ql[0] + Xl[2] * Ql[1], Xl[1] * Ql[0] + Xl[3] * Ql[1], Xl[0] * Ql[2] + Xl[2] * Ql[3], Xl[1] * Ql[2] + Xl[3] * Ql[3], Xl[0] * Ql[4] + Xl[2] * Ql[5] + Xl[4], Xl[1] * Ql[4] + Xl[3] * Ql[5] + Xl[5]];
              }
              static applyTransform(Xl, Ql) {
                const $u = Xl[0] * Ql[0] + Xl[1] * Ql[2] + Ql[4], Yu = Xl[0] * Ql[1] + Xl[1] * Ql[3] + Ql[5];
                return [$u, Yu];
              }
              static applyInverseTransform(Xl, Ql) {
                const $u = Ql[0] * Ql[3] - Ql[1] * Ql[2], Yu = (Xl[0] * Ql[3] - Xl[1] * Ql[2] + Ql[2] * Ql[5] - Ql[4] * Ql[3]) / $u, ud = (-Xl[0] * Ql[1] + Xl[1] * Ql[0] + Ql[4] * Ql[1] - Ql[5] * Ql[0]) / $u;
                return [Yu, ud];
              }
              static getAxialAlignedBoundingBox(Xl, Ql) {
                const $u = uc.applyTransform(Xl, Ql), Yu = uc.applyTransform(Xl.slice(2, 4), Ql), ud = uc.applyTransform([Xl[0], Xl[3]], Ql), dd = uc.applyTransform([Xl[2], Xl[1]], Ql);
                return [Math.min($u[0], Yu[0], ud[0], dd[0]), Math.min($u[1], Yu[1], ud[1], dd[1]), Math.max($u[0], Yu[0], ud[0], dd[0]), Math.max($u[1], Yu[1], ud[1], dd[1])];
              }
              static inverseTransform(Xl) {
                const Ql = Xl[0] * Xl[3] - Xl[1] * Xl[2];
                return [Xl[3] / Ql, -Xl[1] / Ql, -Xl[2] / Ql, Xl[0] / Ql, (Xl[2] * Xl[5] - Xl[4] * Xl[3]) / Ql, (Xl[4] * Xl[1] - Xl[5] * Xl[0]) / Ql];
              }
              static apply3dTransform(Xl, Ql) {
                return [Xl[0] * Ql[0] + Xl[1] * Ql[1] + Xl[2] * Ql[2], Xl[3] * Ql[0] + Xl[4] * Ql[1] + Xl[5] * Ql[2], Xl[6] * Ql[0] + Xl[7] * Ql[1] + Xl[8] * Ql[2]];
              }
              static singularValueDecompose2dScale(Xl) {
                const Ql = [Xl[0], Xl[2], Xl[1], Xl[3]], $u = Xl[0] * Ql[0] + Xl[1] * Ql[2], Yu = Xl[0] * Ql[1] + Xl[1] * Ql[3], ud = Xl[2] * Ql[0] + Xl[3] * Ql[2], dd = Xl[2] * Ql[1] + Xl[3] * Ql[3], Ed = ($u + dd) / 2, Od = Math.sqrt(($u + dd) ** 2 - 4 * ($u * dd - ud * Yu)) / 2, wd = Ed + Od || 1, vd = Ed - Od || 1;
                return [Math.sqrt(wd), Math.sqrt(vd)];
              }
              static normalizeRect(Xl) {
                const Ql = Xl.slice(0);
                return Xl[0] > Xl[2] && (Ql[0] = Xl[2], Ql[2] = Xl[0]), Xl[1] > Xl[3] && (Ql[1] = Xl[3], Ql[3] = Xl[1]), Ql;
              }
              static intersect(Xl, Ql) {
                const $u = Math.max(Math.min(Xl[0], Xl[2]), Math.min(Ql[0], Ql[2])), Yu = Math.min(Math.max(Xl[0], Xl[2]), Math.max(Ql[0], Ql[2]));
                if ($u > Yu)
                  return null;
                const ud = Math.max(Math.min(Xl[1], Xl[3]), Math.min(Ql[1], Ql[3])), dd = Math.min(Math.max(Xl[1], Xl[3]), Math.max(Ql[1], Ql[3]));
                return ud > dd ? null : [$u, ud, Yu, dd];
              }
              static bezierBoundingBox(Xl, Ql, $u, Yu, ud, dd, Ed, Od) {
                const wd = [], vd = [[], []];
                let Pd, Ad, kd, hd, Dd, Rd, jd, Gl;
                for (let nd = 0; nd < 2; ++nd) {
                  if (nd === 0 ? (Ad = 6 * Xl - 12 * $u + 6 * ud, Pd = -3 * Xl + 9 * $u - 9 * ud + 3 * Ed, kd = 3 * $u - 3 * Xl) : (Ad = 6 * Ql - 12 * Yu + 6 * dd, Pd = -3 * Ql + 9 * Yu - 9 * dd + 3 * Od, kd = 3 * Yu - 3 * Ql), Math.abs(Pd) < 1e-12) {
                    if (Math.abs(Ad) < 1e-12)
                      continue;
                    hd = -kd / Ad, 0 < hd && hd < 1 && wd.push(hd);
                    continue;
                  }
                  jd = Ad * Ad - 4 * kd * Pd, Gl = Math.sqrt(jd), !(jd < 0) && (Dd = (-Ad + Gl) / (2 * Pd), 0 < Dd && Dd < 1 && wd.push(Dd), Rd = (-Ad - Gl) / (2 * Pd), 0 < Rd && Rd < 1 && wd.push(Rd));
                }
                let ic = wd.length, su;
                const Ku = ic;
                for (; ic--; )
                  hd = wd[ic], su = 1 - hd, vd[0][ic] = su * su * su * Xl + 3 * su * su * hd * $u + 3 * su * hd * hd * ud + hd * hd * hd * Ed, vd[1][ic] = su * su * su * Ql + 3 * su * su * hd * Yu + 3 * su * hd * hd * dd + hd * hd * hd * Od;
                return vd[0][Ku] = Xl, vd[1][Ku] = Ql, vd[0][Ku + 1] = Ed, vd[1][Ku + 1] = Od, vd[0].length = vd[1].length = Ku + 2, [Math.min(...vd[0]), Math.min(...vd[1]), Math.max(...vd[0]), Math.max(...vd[1])];
              }
            }
            e.Util = uc;
            const ac = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
            function zu(tc) {
              if (tc[0] >= "ï") {
                let Ql;
                if (tc[0] === "þ" && tc[1] === "ÿ" ? Ql = "utf-16be" : tc[0] === "ÿ" && tc[1] === "þ" ? Ql = "utf-16le" : tc[0] === "ï" && tc[1] === "»" && tc[2] === "¿" && (Ql = "utf-8"), Ql)
                  try {
                    const $u = new TextDecoder(Ql, {
                      fatal: !0
                    }), Yu = ml(tc);
                    return $u.decode(Yu);
                  } catch ($u) {
                    Zl(`stringToPDFString: "${$u}".`);
                  }
              }
              const Xl = [];
              for (let Ql = 0, $u = tc.length; Ql < $u; Ql++) {
                const Yu = ac[tc.charCodeAt(Ql)];
                Xl.push(Yu ? String.fromCharCode(Yu) : tc.charAt(Ql));
              }
              return Xl.join("");
            }
            function Xu(tc) {
              return tc.replace(/([()\\\n\r])/g, (Xl) => Xl === `
` ? "\\n" : Xl === "\r" ? "\\r" : `\\${Xl}`);
            }
            function ed(tc) {
              return /^[\x00-\x7F]*$/.test(tc);
            }
            function td(tc) {
              const Xl = ["þÿ"];
              for (let Ql = 0, $u = tc.length; Ql < $u; Ql++) {
                const Yu = tc.charCodeAt(Ql);
                Xl.push(String.fromCharCode(Yu >> 8 & 255), String.fromCharCode(Yu & 255));
              }
              return Xl.join("");
            }
            function od(tc) {
              return decodeURIComponent(escape(tc));
            }
            function ld(tc) {
              return unescape(encodeURIComponent(tc));
            }
            function sd(tc) {
              return typeof tc == "object" && tc !== null && tc.byteLength !== void 0;
            }
            function bd(tc, Xl) {
              if (tc.length !== Xl.length)
                return !1;
              for (let Ql = 0, $u = tc.length; Ql < $u; Ql++)
                if (tc[Ql] !== Xl[Ql])
                  return !1;
              return !0;
            }
            function $d(tc = /* @__PURE__ */ new Date()) {
              return [tc.getUTCFullYear().toString(), (tc.getUTCMonth() + 1).toString().padStart(2, "0"), tc.getUTCDate().toString().padStart(2, "0"), tc.getUTCHours().toString().padStart(2, "0"), tc.getUTCMinutes().toString().padStart(2, "0"), tc.getUTCSeconds().toString().padStart(2, "0")].join("");
            }
            function _d() {
              const tc = /* @__PURE__ */ Object.create(null);
              let Xl = !1;
              return Object.defineProperty(tc, "settled", {
                get() {
                  return Xl;
                }
              }), tc.promise = new Promise(function(Ql, $u) {
                tc.resolve = function(Yu) {
                  Xl = !0, Ql(Yu);
                }, tc.reject = function(Yu) {
                  Xl = !0, $u(Yu);
                };
              }), tc;
            }
          },
          /* 2 */
          /***/
          (Bi, e, Zi) => {
            Zi(3);
          },
          /* 3 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.isNodeJS = void 0;
            const Zi = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
            e.isNodeJS = Zi;
          },
          /* 4 */
          /***/
          (__unused_webpack_module, exports, __w_pdfjs_require__) => {
            var Bi, Zi, Qi, ea, ra, na, ia, fa, tf, Va, to;
            Object.defineProperty(exports, "__esModule", {
              value: !0
            }), exports.build = exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0, exports.getDocument = getDocument, exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory, exports.version = void 0;
            var _util = __w_pdfjs_require__(1), _annotation_storage = __w_pdfjs_require__(5), _display_utils = __w_pdfjs_require__(8), _font_loader = __w_pdfjs_require__(11), _canvas = __w_pdfjs_require__(12), _worker_options = __w_pdfjs_require__(15), _is_node = __w_pdfjs_require__(3), _message_handler = __w_pdfjs_require__(16), _metadata = __w_pdfjs_require__(17), _optional_content_config = __w_pdfjs_require__(18), _transport_stream = __w_pdfjs_require__(19), _xfa_text = __w_pdfjs_require__(20);
            const DEFAULT_RANGE_CHUNK_SIZE = 65536, RENDERING_CANCELLED_TIMEOUT = 100;
            let DefaultCanvasFactory = _display_utils.DOMCanvasFactory;
            exports.DefaultCanvasFactory = DefaultCanvasFactory;
            let DefaultCMapReaderFactory = _display_utils.DOMCMapReaderFactory;
            exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
            let DefaultStandardFontDataFactory = _display_utils.DOMStandardFontDataFactory;
            if (exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory, _is_node.isNodeJS) {
              const {
                NodeCanvasFactory: no,
                NodeCMapReaderFactory: eo,
                NodeStandardFontDataFactory: ao
              } = __w_pdfjs_require__(21);
              exports.DefaultCanvasFactory = DefaultCanvasFactory = no, exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory = eo, exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory = ao;
            }
            let createPDFNetworkStream;
            function setPDFNetworkStreamFactory(no) {
              createPDFNetworkStream = no;
            }
            function getDocument(no) {
              const eo = new PDFDocumentLoadingTask();
              let ao;
              if (typeof no == "string" || no instanceof URL)
                ao = {
                  url: no
                };
              else if ((0, _util.isArrayBuffer)(no))
                ao = {
                  data: no
                };
              else if (no instanceof PDFDataRangeTransport)
                ao = {
                  range: no
                };
              else {
                if (typeof no != "object")
                  throw new Error("Invalid parameter in getDocument, need either string, URL, TypedArray, or parameter object.");
                if (!no.url && !no.data && !no.range)
                  throw new Error("Invalid parameter object: need either .data, .range or .url");
                ao = no;
              }
              const io = /* @__PURE__ */ Object.create(null);
              let xs = null, Ts = null;
              for (const Fs in ao) {
                const Do = ao[Fs];
                switch (Fs) {
                  case "url":
                    if (typeof window < "u")
                      try {
                        io[Fs] = new URL(Do, window.location).href;
                        continue;
                      } catch (ys) {
                        (0, _util.warn)(`Cannot create valid URL: "${ys}".`);
                      }
                    else if (typeof Do == "string" || Do instanceof URL) {
                      io[Fs] = Do.toString();
                      continue;
                    }
                    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                  case "range":
                    xs = Do;
                    continue;
                  case "worker":
                    Ts = Do;
                    continue;
                  case "data":
                    if (_is_node.isNodeJS && typeof Buffer < "u" && Do instanceof Buffer)
                      io[Fs] = new Uint8Array(Do);
                    else {
                      if (Do instanceof Uint8Array)
                        break;
                      if (typeof Do == "string")
                        io[Fs] = (0, _util.stringToBytes)(Do);
                      else if (typeof Do == "object" && Do !== null && !isNaN(Do.length))
                        io[Fs] = new Uint8Array(Do);
                      else if ((0, _util.isArrayBuffer)(Do))
                        io[Fs] = new Uint8Array(Do);
                      else
                        throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                    }
                    continue;
                }
                io[Fs] = Do;
              }
              if (io.CMapReaderFactory = io.CMapReaderFactory || DefaultCMapReaderFactory, io.StandardFontDataFactory = io.StandardFontDataFactory || DefaultStandardFontDataFactory, io.ignoreErrors = io.stopAtErrors !== !0, io.fontExtraProperties = io.fontExtraProperties === !0, io.pdfBug = io.pdfBug === !0, io.enableXfa = io.enableXfa === !0, (!Number.isInteger(io.rangeChunkSize) || io.rangeChunkSize < 1) && (io.rangeChunkSize = DEFAULT_RANGE_CHUNK_SIZE), (typeof io.docBaseUrl != "string" || (0, _display_utils.isDataScheme)(io.docBaseUrl)) && (io.docBaseUrl = null), (!Number.isInteger(io.maxImageSize) || io.maxImageSize < -1) && (io.maxImageSize = -1), typeof io.cMapUrl != "string" && (io.cMapUrl = null), typeof io.standardFontDataUrl != "string" && (io.standardFontDataUrl = null), typeof io.useWorkerFetch != "boolean" && (io.useWorkerFetch = io.CMapReaderFactory === _display_utils.DOMCMapReaderFactory && io.StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory), typeof io.isEvalSupported != "boolean" && (io.isEvalSupported = !0), typeof io.disableFontFace != "boolean" && (io.disableFontFace = _is_node.isNodeJS), typeof io.useSystemFonts != "boolean" && (io.useSystemFonts = !_is_node.isNodeJS && !io.disableFontFace), (typeof io.ownerDocument != "object" || io.ownerDocument === null) && (io.ownerDocument = globalThis.document), typeof io.disableRange != "boolean" && (io.disableRange = !1), typeof io.disableStream != "boolean" && (io.disableStream = !1), typeof io.disableAutoFetch != "boolean" && (io.disableAutoFetch = !1), (0, _util.setVerbosityLevel)(io.verbosity), !Ts) {
                const Fs = {
                  verbosity: io.verbosity,
                  port: _worker_options.GlobalWorkerOptions.workerPort
                };
                Ts = Fs.port ? PDFWorker.fromPort(Fs) : new PDFWorker(Fs), eo._worker = Ts;
              }
              const qs = eo.docId;
              return Ts.promise.then(function() {
                if (eo.destroyed)
                  throw new Error("Loading aborted");
                const Fs = _fetchDocument(Ts, io, xs, qs), Do = new Promise(function(ys) {
                  let Io;
                  xs ? Io = new _transport_stream.PDFDataTransportStream({
                    length: io.length,
                    initialData: io.initialData,
                    progressiveDone: io.progressiveDone,
                    contentDispositionFilename: io.contentDispositionFilename,
                    disableRange: io.disableRange,
                    disableStream: io.disableStream
                  }, xs) : io.data || (Io = createPDFNetworkStream({
                    url: io.url,
                    length: io.length,
                    httpHeaders: io.httpHeaders,
                    withCredentials: io.withCredentials,
                    rangeChunkSize: io.rangeChunkSize,
                    disableRange: io.disableRange,
                    disableStream: io.disableStream
                  })), ys(Io);
                });
                return Promise.all([Fs, Do]).then(function([ys, Io]) {
                  if (eo.destroyed)
                    throw new Error("Loading aborted");
                  const so = new _message_handler.MessageHandler(qs, ys, Ts.port), os = new WorkerTransport(so, eo, Io, io);
                  eo._transport = os, so.send("Ready", null);
                });
              }).catch(eo._capability.reject), eo;
            }
            async function _fetchDocument(no, eo, ao, io) {
              if (no.destroyed)
                throw new Error("Worker was destroyed");
              ao && (eo.length = ao.length, eo.initialData = ao.initialData, eo.progressiveDone = ao.progressiveDone, eo.contentDispositionFilename = ao.contentDispositionFilename);
              const xs = await no.messageHandler.sendWithPromise("GetDocRequest", {
                docId: io,
                apiVersion: "2.16.105",
                source: {
                  data: eo.data,
                  url: eo.url,
                  password: eo.password,
                  disableAutoFetch: eo.disableAutoFetch,
                  rangeChunkSize: eo.rangeChunkSize,
                  length: eo.length
                },
                maxImageSize: eo.maxImageSize,
                disableFontFace: eo.disableFontFace,
                docBaseUrl: eo.docBaseUrl,
                ignoreErrors: eo.ignoreErrors,
                isEvalSupported: eo.isEvalSupported,
                fontExtraProperties: eo.fontExtraProperties,
                enableXfa: eo.enableXfa,
                useSystemFonts: eo.useSystemFonts,
                cMapUrl: eo.useWorkerFetch ? eo.cMapUrl : null,
                standardFontDataUrl: eo.useWorkerFetch ? eo.standardFontDataUrl : null
              });
              if (eo.data && (eo.data = null), no.destroyed)
                throw new Error("Worker was destroyed");
              return xs;
            }
            const e = class e {
              constructor() {
                this._capability = (0, _util.createPromiseCapability)(), this._transport = null, this._worker = null, this.docId = `d${Yd(e, Bi)._++}`, this.destroyed = !1, this.onPassword = null, this.onProgress = null, this.onUnsupportedFeature = null;
              }
              get promise() {
                return this._capability.promise;
              }
              async destroy() {
                this.destroyed = !0, await this._transport?.destroy(), this._transport = null, this._worker && (this._worker.destroy(), this._worker = null);
              }
            };
            Bi = new WeakMap(), oc(e, Bi, 0);
            let PDFDocumentLoadingTask = e;
            exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
            class PDFDataRangeTransport {
              constructor(eo, ao, io = !1, xs = null) {
                this.length = eo, this.initialData = ao, this.progressiveDone = io, this.contentDispositionFilename = xs, this._rangeListeners = [], this._progressListeners = [], this._progressiveReadListeners = [], this._progressiveDoneListeners = [], this._readyCapability = (0, _util.createPromiseCapability)();
              }
              addRangeListener(eo) {
                this._rangeListeners.push(eo);
              }
              addProgressListener(eo) {
                this._progressListeners.push(eo);
              }
              addProgressiveReadListener(eo) {
                this._progressiveReadListeners.push(eo);
              }
              addProgressiveDoneListener(eo) {
                this._progressiveDoneListeners.push(eo);
              }
              onDataRange(eo, ao) {
                for (const io of this._rangeListeners)
                  io(eo, ao);
              }
              onDataProgress(eo, ao) {
                this._readyCapability.promise.then(() => {
                  for (const io of this._progressListeners)
                    io(eo, ao);
                });
              }
              onDataProgressiveRead(eo) {
                this._readyCapability.promise.then(() => {
                  for (const ao of this._progressiveReadListeners)
                    ao(eo);
                });
              }
              onDataProgressiveDone() {
                this._readyCapability.promise.then(() => {
                  for (const eo of this._progressiveDoneListeners)
                    eo();
                });
              }
              transportReady() {
                this._readyCapability.resolve();
              }
              requestDataRange(eo, ao) {
                (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
              }
              abort() {
              }
            }
            exports.PDFDataRangeTransport = PDFDataRangeTransport;
            class PDFDocumentProxy {
              constructor(eo, ao) {
                this._pdfInfo = eo, this._transport = ao, Object.defineProperty(this, "fingerprint", {
                  get() {
                    return (0, _display_utils.deprecated)("`PDFDocumentProxy.fingerprint`, please use `PDFDocumentProxy.fingerprints` instead."), this.fingerprints[0];
                  }
                }), Object.defineProperty(this, "getStats", {
                  value: async () => ((0, _display_utils.deprecated)("`PDFDocumentProxy.getStats`, please use the `PDFDocumentProxy.stats`-getter instead."), this.stats || {
                    streamTypes: {},
                    fontTypes: {}
                  })
                });
              }
              get annotationStorage() {
                return this._transport.annotationStorage;
              }
              get numPages() {
                return this._pdfInfo.numPages;
              }
              get fingerprints() {
                return this._pdfInfo.fingerprints;
              }
              get stats() {
                return this._transport.stats;
              }
              get isPureXfa() {
                return !!this._transport._htmlForXfa;
              }
              get allXfaHtml() {
                return this._transport._htmlForXfa;
              }
              getPage(eo) {
                return this._transport.getPage(eo);
              }
              getPageIndex(eo) {
                return this._transport.getPageIndex(eo);
              }
              getDestinations() {
                return this._transport.getDestinations();
              }
              getDestination(eo) {
                return this._transport.getDestination(eo);
              }
              getPageLabels() {
                return this._transport.getPageLabels();
              }
              getPageLayout() {
                return this._transport.getPageLayout();
              }
              getPageMode() {
                return this._transport.getPageMode();
              }
              getViewerPreferences() {
                return this._transport.getViewerPreferences();
              }
              getOpenAction() {
                return this._transport.getOpenAction();
              }
              getAttachments() {
                return this._transport.getAttachments();
              }
              getJavaScript() {
                return this._transport.getJavaScript();
              }
              getJSActions() {
                return this._transport.getDocJSActions();
              }
              getOutline() {
                return this._transport.getOutline();
              }
              getOptionalContentConfig() {
                return this._transport.getOptionalContentConfig();
              }
              getPermissions() {
                return this._transport.getPermissions();
              }
              getMetadata() {
                return this._transport.getMetadata();
              }
              getMarkInfo() {
                return this._transport.getMarkInfo();
              }
              getData() {
                return this._transport.getData();
              }
              getDownloadInfo() {
                return this._transport.downloadInfoCapability.promise;
              }
              cleanup(eo = !1) {
                return this._transport.startCleanup(eo || this.isPureXfa);
              }
              destroy() {
                return this.loadingTask.destroy();
              }
              get loadingParams() {
                return this._transport.loadingParams;
              }
              get loadingTask() {
                return this._transport.loadingTask;
              }
              saveDocument() {
                return this._transport.annotationStorage.size <= 0 && (0, _display_utils.deprecated)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead."), this._transport.saveDocument();
              }
              getFieldObjects() {
                return this._transport.getFieldObjects();
              }
              hasJSActions() {
                return this._transport.hasJSActions();
              }
              getCalculationOrderIds() {
                return this._transport.getCalculationOrderIds();
              }
            }
            exports.PDFDocumentProxy = PDFDocumentProxy;
            class PDFPageProxy {
              constructor(eo, ao, io, xs, Ts = !1) {
                this._pageIndex = eo, this._pageInfo = ao, this._ownerDocument = xs, this._transport = io, this._stats = Ts ? new _display_utils.StatTimer() : null, this._pdfBug = Ts, this.commonObjs = io.commonObjs, this.objs = new PDFObjects(), this._bitmaps = /* @__PURE__ */ new Set(), this.cleanupAfterRender = !1, this.pendingCleanup = !1, this._intentStates = /* @__PURE__ */ new Map(), this._annotationPromises = /* @__PURE__ */ new Map(), this.destroyed = !1;
              }
              get pageNumber() {
                return this._pageIndex + 1;
              }
              get rotate() {
                return this._pageInfo.rotate;
              }
              get ref() {
                return this._pageInfo.ref;
              }
              get userUnit() {
                return this._pageInfo.userUnit;
              }
              get view() {
                return this._pageInfo.view;
              }
              getViewport({
                scale: eo,
                rotation: ao = this.rotate,
                offsetX: io = 0,
                offsetY: xs = 0,
                dontFlip: Ts = !1
              } = {}) {
                return new _display_utils.PageViewport({
                  viewBox: this.view,
                  scale: eo,
                  rotation: ao,
                  offsetX: io,
                  offsetY: xs,
                  dontFlip: Ts
                });
              }
              getAnnotations({
                intent: eo = "display"
              } = {}) {
                const ao = this._transport.getRenderingIntent(eo);
                let io = this._annotationPromises.get(ao.cacheKey);
                return io || (io = this._transport.getAnnotations(this._pageIndex, ao.renderingIntent), this._annotationPromises.set(ao.cacheKey, io), io = io.then((xs) => {
                  for (const Ts of xs)
                    Ts.titleObj !== void 0 && Object.defineProperty(Ts, "title", {
                      get() {
                        return (0, _display_utils.deprecated)("`title`-property on annotation, please use `titleObj` instead."), Ts.titleObj.str;
                      }
                    }), Ts.contentsObj !== void 0 && Object.defineProperty(Ts, "contents", {
                      get() {
                        return (0, _display_utils.deprecated)("`contents`-property on annotation, please use `contentsObj` instead."), Ts.contentsObj.str;
                      }
                    });
                  return xs;
                })), io;
              }
              getJSActions() {
                return this._jsActionsPromise || (this._jsActionsPromise = this._transport.getPageJSActions(this._pageIndex));
              }
              async getXfa() {
                return this._transport._htmlForXfa?.children[this._pageIndex] || null;
              }
              render({
                canvasContext: eo,
                viewport: ao,
                intent: io = "display",
                annotationMode: xs = _util.AnnotationMode.ENABLE,
                transform: Ts = null,
                imageLayer: qs = null,
                canvasFactory: Fs = null,
                background: Do = null,
                optionalContentConfigPromise: ys = null,
                annotationCanvasMap: Io = null,
                pageColors: so = null,
                printAnnotationStorage: os = null
              }) {
                arguments[0]?.renderInteractiveForms !== void 0 && ((0, _display_utils.deprecated)("render no longer accepts the `renderInteractiveForms`-option, please use the `annotationMode`-option instead."), arguments[0].renderInteractiveForms === !0 && xs === _util.AnnotationMode.ENABLE && (xs = _util.AnnotationMode.ENABLE_FORMS)), arguments[0]?.includeAnnotationStorage !== void 0 && ((0, _display_utils.deprecated)("render no longer accepts the `includeAnnotationStorage`-option, please use the `annotationMode`-option instead."), arguments[0].includeAnnotationStorage === !0 && xs === _util.AnnotationMode.ENABLE && (xs = _util.AnnotationMode.ENABLE_STORAGE)), this._stats && this._stats.time("Overall");
                const Xs = this._transport.getRenderingIntent(io, xs, os);
                this.pendingCleanup = !1, ys || (ys = this._transport.getOptionalContentConfig());
                let gl = this._intentStates.get(Xs.cacheKey);
                gl || (gl = /* @__PURE__ */ Object.create(null), this._intentStates.set(Xs.cacheKey, gl)), gl.streamReaderCancelTimeout && (clearTimeout(gl.streamReaderCancelTimeout), gl.streamReaderCancelTimeout = null);
                const Sl = Fs || new DefaultCanvasFactory({
                  ownerDocument: this._ownerDocument
                }), El = !!(Xs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                gl.displayReadyCapability || (gl.displayReadyCapability = (0, _util.createPromiseCapability)(), gl.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: !1,
                  separateAnnots: null
                }, this._stats && this._stats.time("Page Request"), this._pumpOperatorList(Xs));
                const wl = (Fl) => {
                  gl.renderTasks.delete(jl), (this.cleanupAfterRender || El) && (this.pendingCleanup = !0), this._tryCleanup(), Fl ? (jl.capability.reject(Fl), this._abortOperatorList({
                    intentState: gl,
                    reason: Fl instanceof Error ? Fl : new Error(Fl)
                  })) : jl.capability.resolve(), this._stats && (this._stats.timeEnd("Rendering"), this._stats.timeEnd("Overall"));
                }, jl = new InternalRenderTask({
                  callback: wl,
                  params: {
                    canvasContext: eo,
                    viewport: ao,
                    transform: Ts,
                    imageLayer: qs,
                    background: Do
                  },
                  objs: this.objs,
                  commonObjs: this.commonObjs,
                  annotationCanvasMap: Io,
                  operatorList: gl.operatorList,
                  pageIndex: this._pageIndex,
                  canvasFactory: Sl,
                  useRequestAnimationFrame: !El,
                  pdfBug: this._pdfBug,
                  pageColors: so
                });
                (gl.renderTasks || (gl.renderTasks = /* @__PURE__ */ new Set())).add(jl);
                const kl = jl.task;
                return Promise.all([gl.displayReadyCapability.promise, ys]).then(([Fl, Ml]) => {
                  if (this.pendingCleanup) {
                    wl();
                    return;
                  }
                  this._stats && this._stats.time("Rendering"), jl.initializeGraphics({
                    transparency: Fl,
                    optionalContentConfig: Ml
                  }), jl.operatorListChanged();
                }).catch(wl), kl;
              }
              getOperatorList({
                intent: eo = "display",
                annotationMode: ao = _util.AnnotationMode.ENABLE,
                printAnnotationStorage: io = null
              } = {}) {
                function xs() {
                  qs.operatorList.lastChunk && (qs.opListReadCapability.resolve(qs.operatorList), qs.renderTasks.delete(Fs));
                }
                const Ts = this._transport.getRenderingIntent(eo, ao, io, !0);
                let qs = this._intentStates.get(Ts.cacheKey);
                qs || (qs = /* @__PURE__ */ Object.create(null), this._intentStates.set(Ts.cacheKey, qs));
                let Fs;
                return qs.opListReadCapability || (Fs = /* @__PURE__ */ Object.create(null), Fs.operatorListChanged = xs, qs.opListReadCapability = (0, _util.createPromiseCapability)(), (qs.renderTasks || (qs.renderTasks = /* @__PURE__ */ new Set())).add(Fs), qs.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: !1,
                  separateAnnots: null
                }, this._stats && this._stats.time("Page Request"), this._pumpOperatorList(Ts)), qs.opListReadCapability.promise;
              }
              streamTextContent({
                disableCombineTextItems: eo = !1,
                includeMarkedContent: ao = !1
              } = {}) {
                return this._transport.messageHandler.sendWithStream("GetTextContent", {
                  pageIndex: this._pageIndex,
                  combineTextItems: eo !== !0,
                  includeMarkedContent: ao === !0
                }, {
                  highWaterMark: 100,
                  size(xs) {
                    return xs.items.length;
                  }
                });
              }
              getTextContent(eo = {}) {
                if (this._transport._htmlForXfa)
                  return this.getXfa().then((io) => _xfa_text.XfaText.textContent(io));
                const ao = this.streamTextContent(eo);
                return new Promise(function(io, xs) {
                  function Ts() {
                    qs.read().then(function({
                      value: Do,
                      done: ys
                    }) {
                      if (ys) {
                        io(Fs);
                        return;
                      }
                      Object.assign(Fs.styles, Do.styles), Fs.items.push(...Do.items), Ts();
                    }, xs);
                  }
                  const qs = ao.getReader(), Fs = {
                    items: [],
                    styles: /* @__PURE__ */ Object.create(null)
                  };
                  Ts();
                });
              }
              getStructTree() {
                return this._structTreePromise || (this._structTreePromise = this._transport.getStructTree(this._pageIndex));
              }
              _destroy() {
                this.destroyed = !0;
                const eo = [];
                for (const ao of this._intentStates.values())
                  if (this._abortOperatorList({
                    intentState: ao,
                    reason: new Error("Page was destroyed."),
                    force: !0
                  }), !ao.opListReadCapability)
                    for (const io of ao.renderTasks)
                      eo.push(io.completed), io.cancel();
                this.objs.clear();
                for (const ao of this._bitmaps)
                  ao.close();
                return this._bitmaps.clear(), this._annotationPromises.clear(), this._jsActionsPromise = null, this._structTreePromise = null, this.pendingCleanup = !1, Promise.all(eo);
              }
              cleanup(eo = !1) {
                return this.pendingCleanup = !0, this._tryCleanup(eo);
              }
              _tryCleanup(eo = !1) {
                if (!this.pendingCleanup)
                  return !1;
                for (const {
                  renderTasks: ao,
                  operatorList: io
                } of this._intentStates.values())
                  if (ao.size > 0 || !io.lastChunk)
                    return !1;
                this._intentStates.clear(), this.objs.clear(), this._annotationPromises.clear(), this._jsActionsPromise = null, this._structTreePromise = null, eo && this._stats && (this._stats = new _display_utils.StatTimer());
                for (const ao of this._bitmaps)
                  ao.close();
                return this._bitmaps.clear(), this.pendingCleanup = !1, !0;
              }
              _startRenderPage(eo, ao) {
                const io = this._intentStates.get(ao);
                io && (this._stats && this._stats.timeEnd("Page Request"), io.displayReadyCapability && io.displayReadyCapability.resolve(eo));
              }
              _renderPageChunk(eo, ao) {
                for (let io = 0, xs = eo.length; io < xs; io++)
                  ao.operatorList.fnArray.push(eo.fnArray[io]), ao.operatorList.argsArray.push(eo.argsArray[io]);
                ao.operatorList.lastChunk = eo.lastChunk, ao.operatorList.separateAnnots = eo.separateAnnots;
                for (const io of ao.renderTasks)
                  io.operatorListChanged();
                eo.lastChunk && this._tryCleanup();
              }
              _pumpOperatorList({
                renderingIntent: eo,
                cacheKey: ao,
                annotationStorageMap: io
              }) {
                const Ts = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                  pageIndex: this._pageIndex,
                  intent: eo,
                  cacheKey: ao,
                  annotationStorage: io
                }).getReader(), qs = this._intentStates.get(ao);
                qs.streamReader = Ts;
                const Fs = () => {
                  Ts.read().then(({
                    value: Do,
                    done: ys
                  }) => {
                    if (ys) {
                      qs.streamReader = null;
                      return;
                    }
                    this._transport.destroyed || (this._renderPageChunk(Do, qs), Fs());
                  }, (Do) => {
                    if (qs.streamReader = null, !this._transport.destroyed) {
                      if (qs.operatorList) {
                        qs.operatorList.lastChunk = !0;
                        for (const ys of qs.renderTasks)
                          ys.operatorListChanged();
                        this._tryCleanup();
                      }
                      if (qs.displayReadyCapability)
                        qs.displayReadyCapability.reject(Do);
                      else if (qs.opListReadCapability)
                        qs.opListReadCapability.reject(Do);
                      else
                        throw Do;
                    }
                  });
                };
                Fs();
              }
              _abortOperatorList({
                intentState: eo,
                reason: ao,
                force: io = !1
              }) {
                if (eo.streamReader) {
                  if (!io) {
                    if (eo.renderTasks.size > 0)
                      return;
                    if (ao instanceof _display_utils.RenderingCancelledException) {
                      eo.streamReaderCancelTimeout = setTimeout(() => {
                        this._abortOperatorList({
                          intentState: eo,
                          reason: ao,
                          force: !0
                        }), eo.streamReaderCancelTimeout = null;
                      }, RENDERING_CANCELLED_TIMEOUT);
                      return;
                    }
                  }
                  if (eo.streamReader.cancel(new _util.AbortException(ao.message)).catch(() => {
                  }), eo.streamReader = null, !this._transport.destroyed) {
                    for (const [xs, Ts] of this._intentStates)
                      if (Ts === eo) {
                        this._intentStates.delete(xs);
                        break;
                      }
                    this.cleanup();
                  }
                }
              }
              get stats() {
                return this._stats;
              }
            }
            exports.PDFPageProxy = PDFPageProxy;
            class LoopbackPort {
              constructor() {
                this._listeners = [], this._deferred = Promise.resolve();
              }
              postMessage(eo, ao) {
                const io = {
                  data: structuredClone(eo, ao)
                };
                this._deferred.then(() => {
                  for (const xs of this._listeners)
                    xs.call(this, io);
                });
              }
              addEventListener(eo, ao) {
                this._listeners.push(ao);
              }
              removeEventListener(eo, ao) {
                const io = this._listeners.indexOf(ao);
                this._listeners.splice(io, 1);
              }
              terminate() {
                this._listeners.length = 0;
              }
            }
            exports.LoopbackPort = LoopbackPort;
            const PDFWorkerUtil = {
              isWorkerDisabled: !1,
              fallbackWorkerSrc: null,
              fakeWorkerId: 0
            };
            exports.PDFWorkerUtil = PDFWorkerUtil;
            {
              if (_is_node.isNodeJS && typeof commonjsRequire == "function")
                PDFWorkerUtil.isWorkerDisabled = !0, PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
              else if (typeof document == "object") {
                const no = document?.currentScript?.src;
                no && (PDFWorkerUtil.fallbackWorkerSrc = no.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2"));
              }
              PDFWorkerUtil.isSameOrigin = function(no, eo) {
                let ao;
                try {
                  if (ao = new URL(no), !ao.origin || ao.origin === "null")
                    return !1;
                } catch {
                  return !1;
                }
                const io = new URL(eo, ao);
                return ao.origin === io.origin;
              }, PDFWorkerUtil.createCDNWrapper = function(no) {
                const eo = `importScripts("${no}");`;
                return URL.createObjectURL(new Blob([eo]));
              };
            }
            const _PDFWorker = class _PDFWorker {
              constructor({
                name: no = null,
                port: eo = null,
                verbosity: ao = (0, _util.getVerbosityLevel)()
              } = {}) {
                if (eo && Hl(_PDFWorker, Zi).has(eo))
                  throw new Error("Cannot use more than one PDFWorker per port.");
                if (this.name = no, this.destroyed = !1, this.verbosity = ao, this._readyCapability = (0, _util.createPromiseCapability)(), this._port = null, this._webWorker = null, this._messageHandler = null, eo) {
                  Hl(_PDFWorker, Zi).set(eo, this), this._initializeFromPort(eo);
                  return;
                }
                this._initialize();
              }
              get promise() {
                return this._readyCapability.promise;
              }
              get port() {
                return this._port;
              }
              get messageHandler() {
                return this._messageHandler;
              }
              _initializeFromPort(no) {
                this._port = no, this._messageHandler = new _message_handler.MessageHandler("main", "worker", no), this._messageHandler.on("ready", function() {
                }), this._readyCapability.resolve();
              }
              _initialize() {
                if (!PDFWorkerUtil.isWorkerDisabled && !_PDFWorker._mainThreadWorkerMessageHandler) {
                  let {
                    workerSrc: no
                  } = _PDFWorker;
                  try {
                    PDFWorkerUtil.isSameOrigin(window.location.href, no) || (no = PDFWorkerUtil.createCDNWrapper(new URL(no, window.location).href));
                    const eo = new Worker(no), ao = new _message_handler.MessageHandler("main", "worker", eo), io = () => {
                      eo.removeEventListener("error", xs), ao.destroy(), eo.terminate(), this.destroyed ? this._readyCapability.reject(new Error("Worker was destroyed")) : this._setupFakeWorker();
                    }, xs = () => {
                      this._webWorker || io();
                    };
                    eo.addEventListener("error", xs), ao.on("test", (qs) => {
                      if (eo.removeEventListener("error", xs), this.destroyed) {
                        io();
                        return;
                      }
                      qs ? (this._messageHandler = ao, this._port = eo, this._webWorker = eo, this._readyCapability.resolve(), ao.send("configure", {
                        verbosity: this.verbosity
                      })) : (this._setupFakeWorker(), ao.destroy(), eo.terminate());
                    }), ao.on("ready", (qs) => {
                      if (eo.removeEventListener("error", xs), this.destroyed) {
                        io();
                        return;
                      }
                      try {
                        Ts();
                      } catch {
                        this._setupFakeWorker();
                      }
                    });
                    const Ts = () => {
                      const qs = new Uint8Array();
                      ao.send("test", qs, [qs.buffer]);
                    };
                    Ts();
                    return;
                  } catch {
                    (0, _util.info)("The worker has been disabled.");
                  }
                }
                this._setupFakeWorker();
              }
              _setupFakeWorker() {
                PDFWorkerUtil.isWorkerDisabled || ((0, _util.warn)("Setting up fake worker."), PDFWorkerUtil.isWorkerDisabled = !0), _PDFWorker._setupFakeWorkerGlobal.then((no) => {
                  if (this.destroyed) {
                    this._readyCapability.reject(new Error("Worker was destroyed"));
                    return;
                  }
                  const eo = new LoopbackPort();
                  this._port = eo;
                  const ao = `fake${PDFWorkerUtil.fakeWorkerId++}`, io = new _message_handler.MessageHandler(ao + "_worker", ao, eo);
                  no.setup(io, eo);
                  const xs = new _message_handler.MessageHandler(ao, ao + "_worker", eo);
                  this._messageHandler = xs, this._readyCapability.resolve(), xs.send("configure", {
                    verbosity: this.verbosity
                  });
                }).catch((no) => {
                  this._readyCapability.reject(new Error(`Setting up fake worker failed: "${no.message}".`));
                });
              }
              destroy() {
                this.destroyed = !0, this._webWorker && (this._webWorker.terminate(), this._webWorker = null), Hl(_PDFWorker, Zi).delete(this._port), this._port = null, this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
              }
              static fromPort(no) {
                if (!no?.port)
                  throw new Error("PDFWorker.fromPort - invalid method signature.");
                return Hl(this, Zi).has(no.port) ? Hl(this, Zi).get(no.port) : new _PDFWorker(no);
              }
              static get workerSrc() {
                if (_worker_options.GlobalWorkerOptions.workerSrc)
                  return _worker_options.GlobalWorkerOptions.workerSrc;
                if (PDFWorkerUtil.fallbackWorkerSrc !== null)
                  return _is_node.isNodeJS || (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.'), PDFWorkerUtil.fallbackWorkerSrc;
                throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
              }
              static get _mainThreadWorkerMessageHandler() {
                try {
                  return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                } catch {
                  return null;
                }
              }
              static get _setupFakeWorkerGlobal() {
                const loader = async () => {
                  const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                  if (mainWorkerMessageHandler)
                    return mainWorkerMessageHandler;
                  if (_is_node.isNodeJS && typeof commonjsRequire == "function") {
                    const worker = eval("require")(this.workerSrc);
                    return worker.WorkerMessageHandler;
                  }
                  return await (0, _display_utils.loadScript)(this.workerSrc), window.pdfjsWorker.WorkerMessageHandler;
                };
                return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
              }
            };
            Zi = new WeakMap(), oc(_PDFWorker, Zi, /* @__PURE__ */ new WeakMap());
            let PDFWorker = _PDFWorker;
            exports.PDFWorker = PDFWorker, PDFWorker.getWorkerSrc = function() {
              return (0, _display_utils.deprecated)("`PDFWorker.getWorkerSrc()`, please use `PDFWorker.workerSrc` instead."), this.workerSrc;
            };
            class WorkerTransport {
              constructor(eo, ao, io, xs) {
                oc(this, Qi, null);
                oc(this, ea, /* @__PURE__ */ new Map());
                oc(this, ra, /* @__PURE__ */ new Map());
                oc(this, na, null);
                this.messageHandler = eo, this.loadingTask = ao, this.commonObjs = new PDFObjects(), this.fontLoader = new _font_loader.FontLoader({
                  docId: ao.docId,
                  onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                  ownerDocument: xs.ownerDocument,
                  styleElement: xs.styleElement
                }), this._params = xs, xs.useWorkerFetch || (this.CMapReaderFactory = new xs.CMapReaderFactory({
                  baseUrl: xs.cMapUrl,
                  isCompressed: xs.cMapPacked
                }), this.StandardFontDataFactory = new xs.StandardFontDataFactory({
                  baseUrl: xs.standardFontDataUrl
                })), this.destroyed = !1, this.destroyCapability = null, this._passwordCapability = null, this._networkStream = io, this._fullReader = null, this._lastProgress = null, this.downloadInfoCapability = (0, _util.createPromiseCapability)(), this.setupMessageHandler();
              }
              get annotationStorage() {
                return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
              }
              get stats() {
                return Hl(this, Qi);
              }
              getRenderingIntent(eo, ao = _util.AnnotationMode.ENABLE, io = null, xs = !1) {
                let Ts = _util.RenderingIntentFlag.DISPLAY, qs = null;
                switch (eo) {
                  case "any":
                    Ts = _util.RenderingIntentFlag.ANY;
                    break;
                  case "display":
                    break;
                  case "print":
                    Ts = _util.RenderingIntentFlag.PRINT;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid intent: ${eo}`);
                }
                switch (ao) {
                  case _util.AnnotationMode.DISABLE:
                    Ts += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                    break;
                  case _util.AnnotationMode.ENABLE:
                    break;
                  case _util.AnnotationMode.ENABLE_FORMS:
                    Ts += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                    break;
                  case _util.AnnotationMode.ENABLE_STORAGE:
                    Ts += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE, qs = (Ts & _util.RenderingIntentFlag.PRINT && io instanceof _annotation_storage.PrintAnnotationStorage ? io : this.annotationStorage).serializable;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${ao}`);
                }
                return xs && (Ts += _util.RenderingIntentFlag.OPLIST), {
                  renderingIntent: Ts,
                  cacheKey: `${Ts}_${_annotation_storage.AnnotationStorage.getHash(qs)}`,
                  annotationStorageMap: qs
                };
              }
              destroy() {
                if (this.destroyCapability)
                  return this.destroyCapability.promise;
                this.destroyed = !0, this.destroyCapability = (0, _util.createPromiseCapability)(), this._passwordCapability && this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
                const eo = [];
                for (const io of Hl(this, ea).values())
                  eo.push(io._destroy());
                Hl(this, ea).clear(), Hl(this, ra).clear(), this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
                const ao = this.messageHandler.sendWithPromise("Terminate", null);
                return eo.push(ao), Promise.all(eo).then(() => {
                  this.commonObjs.clear(), this.fontLoader.clear(), sc(this, na, null), this._getFieldObjectsPromise = null, this._hasJSActionsPromise = null, this._networkStream && this._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated.")), this.messageHandler && (this.messageHandler.destroy(), this.messageHandler = null), this.destroyCapability.resolve();
                }, this.destroyCapability.reject), this.destroyCapability.promise;
              }
              setupMessageHandler() {
                const {
                  messageHandler: eo,
                  loadingTask: ao
                } = this;
                eo.on("GetReader", (io, xs) => {
                  (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (Ts) => {
                    this._lastProgress = {
                      loaded: Ts.loaded,
                      total: Ts.total
                    };
                  }, xs.onPull = () => {
                    this._fullReader.read().then(function({
                      value: Ts,
                      done: qs
                    }) {
                      if (qs) {
                        xs.close();
                        return;
                      }
                      (0, _util.assert)((0, _util.isArrayBuffer)(Ts), "GetReader - expected an ArrayBuffer."), xs.enqueue(new Uint8Array(Ts), 1, [Ts]);
                    }).catch((Ts) => {
                      xs.error(Ts);
                    });
                  }, xs.onCancel = (Ts) => {
                    this._fullReader.cancel(Ts), xs.ready.catch((qs) => {
                      if (!this.destroyed)
                        throw qs;
                    });
                  };
                }), eo.on("ReaderHeadersReady", (io) => {
                  const xs = (0, _util.createPromiseCapability)(), Ts = this._fullReader;
                  return Ts.headersReady.then(() => {
                    (!Ts.isStreamingSupported || !Ts.isRangeSupported) && (this._lastProgress && ao.onProgress?.(this._lastProgress), Ts.onProgress = (qs) => {
                      ao.onProgress?.({
                        loaded: qs.loaded,
                        total: qs.total
                      });
                    }), xs.resolve({
                      isStreamingSupported: Ts.isStreamingSupported,
                      isRangeSupported: Ts.isRangeSupported,
                      contentLength: Ts.contentLength
                    });
                  }, xs.reject), xs.promise;
                }), eo.on("GetRangeReader", (io, xs) => {
                  (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                  const Ts = this._networkStream.getRangeReader(io.begin, io.end);
                  if (!Ts) {
                    xs.close();
                    return;
                  }
                  xs.onPull = () => {
                    Ts.read().then(function({
                      value: qs,
                      done: Fs
                    }) {
                      if (Fs) {
                        xs.close();
                        return;
                      }
                      (0, _util.assert)((0, _util.isArrayBuffer)(qs), "GetRangeReader - expected an ArrayBuffer."), xs.enqueue(new Uint8Array(qs), 1, [qs]);
                    }).catch((qs) => {
                      xs.error(qs);
                    });
                  }, xs.onCancel = (qs) => {
                    Ts.cancel(qs), xs.ready.catch((Fs) => {
                      if (!this.destroyed)
                        throw Fs;
                    });
                  };
                }), eo.on("GetDoc", ({
                  pdfInfo: io
                }) => {
                  this._numPages = io.numPages, this._htmlForXfa = io.htmlForXfa, delete io.htmlForXfa, ao._capability.resolve(new PDFDocumentProxy(io, this));
                }), eo.on("DocException", function(io) {
                  let xs;
                  switch (io.name) {
                    case "PasswordException":
                      xs = new _util.PasswordException(io.message, io.code);
                      break;
                    case "InvalidPDFException":
                      xs = new _util.InvalidPDFException(io.message);
                      break;
                    case "MissingPDFException":
                      xs = new _util.MissingPDFException(io.message);
                      break;
                    case "UnexpectedResponseException":
                      xs = new _util.UnexpectedResponseException(io.message, io.status);
                      break;
                    case "UnknownErrorException":
                      xs = new _util.UnknownErrorException(io.message, io.details);
                      break;
                    default:
                      (0, _util.unreachable)("DocException - expected a valid Error.");
                  }
                  ao._capability.reject(xs);
                }), eo.on("PasswordRequest", (io) => {
                  if (this._passwordCapability = (0, _util.createPromiseCapability)(), ao.onPassword) {
                    const xs = (Ts) => {
                      Ts instanceof Error ? this._passwordCapability.reject(Ts) : this._passwordCapability.resolve({
                        password: Ts
                      });
                    };
                    try {
                      ao.onPassword(xs, io.code);
                    } catch (Ts) {
                      this._passwordCapability.reject(Ts);
                    }
                  } else
                    this._passwordCapability.reject(new _util.PasswordException(io.message, io.code));
                  return this._passwordCapability.promise;
                }), eo.on("DataLoaded", (io) => {
                  ao.onProgress?.({
                    loaded: io.length,
                    total: io.length
                  }), this.downloadInfoCapability.resolve(io);
                }), eo.on("StartRenderPage", (io) => {
                  if (this.destroyed)
                    return;
                  Hl(this, ea).get(io.pageIndex)._startRenderPage(io.transparency, io.cacheKey);
                }), eo.on("commonobj", ([io, xs, Ts]) => {
                  if (!this.destroyed && !this.commonObjs.has(io))
                    switch (xs) {
                      case "Font":
                        const qs = this._params;
                        if ("error" in Ts) {
                          const ys = Ts.error;
                          (0, _util.warn)(`Error during font loading: ${ys}`), this.commonObjs.resolve(io, ys);
                          break;
                        }
                        let Fs = null;
                        qs.pdfBug && globalThis.FontInspector?.enabled && (Fs = {
                          registerFont(ys, Io) {
                            globalThis.FontInspector.fontAdded(ys, Io);
                          }
                        });
                        const Do = new _font_loader.FontFaceObject(Ts, {
                          isEvalSupported: qs.isEvalSupported,
                          disableFontFace: qs.disableFontFace,
                          ignoreErrors: qs.ignoreErrors,
                          onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                          fontRegistry: Fs
                        });
                        this.fontLoader.bind(Do).catch((ys) => eo.sendWithPromise("FontFallback", {
                          id: io
                        })).finally(() => {
                          !qs.fontExtraProperties && Do.data && (Do.data = null), this.commonObjs.resolve(io, Do);
                        });
                        break;
                      case "FontPath":
                      case "Image":
                        this.commonObjs.resolve(io, Ts);
                        break;
                      default:
                        throw new Error(`Got unknown common object type ${xs}`);
                    }
                }), eo.on("obj", ([io, xs, Ts, qs]) => {
                  if (this.destroyed)
                    return;
                  const Fs = Hl(this, ea).get(xs);
                  if (!Fs.objs.has(io))
                    switch (Ts) {
                      case "Image":
                        Fs.objs.resolve(io, qs);
                        const Do = 8e6;
                        if (qs) {
                          let ys;
                          if (qs.bitmap) {
                            const {
                              bitmap: Io,
                              width: so,
                              height: os
                            } = qs;
                            ys = so * os * 4, Fs._bitmaps.add(Io);
                          } else
                            ys = qs.data?.length || 0;
                          ys > Do && (Fs.cleanupAfterRender = !0);
                        }
                        break;
                      case "Pattern":
                        Fs.objs.resolve(io, qs);
                        break;
                      default:
                        throw new Error(`Got unknown object type ${Ts}`);
                    }
                }), eo.on("DocProgress", (io) => {
                  this.destroyed || ao.onProgress?.({
                    loaded: io.loaded,
                    total: io.total
                  });
                }), eo.on("DocStats", (io) => {
                  this.destroyed || sc(this, Qi, Object.freeze({
                    streamTypes: Object.freeze(io.streamTypes),
                    fontTypes: Object.freeze(io.fontTypes)
                  }));
                }), eo.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this)), eo.on("FetchBuiltInCMap", (io) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.CMapReaderFactory ? this.CMapReaderFactory.fetch(io) : Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."))), eo.on("FetchStandardFontData", (io) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.StandardFontDataFactory ? this.StandardFontDataFactory.fetch(io) : Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter.")));
              }
              _onUnsupportedFeature({
                featureId: eo
              }) {
                this.destroyed || this.loadingTask.onUnsupportedFeature?.(eo);
              }
              getData() {
                return this.messageHandler.sendWithPromise("GetData", null);
              }
              getPage(eo) {
                if (!Number.isInteger(eo) || eo <= 0 || eo > this._numPages)
                  return Promise.reject(new Error("Invalid page request."));
                const ao = eo - 1, io = Hl(this, ra).get(ao);
                if (io)
                  return io;
                const xs = this.messageHandler.sendWithPromise("GetPage", {
                  pageIndex: ao
                }).then((Ts) => {
                  if (this.destroyed)
                    throw new Error("Transport destroyed");
                  const qs = new PDFPageProxy(ao, Ts, this, this._params.ownerDocument, this._params.pdfBug);
                  return Hl(this, ea).set(ao, qs), qs;
                });
                return Hl(this, ra).set(ao, xs), xs;
              }
              getPageIndex(eo) {
                return typeof eo != "object" || eo === null || !Number.isInteger(eo.num) || eo.num < 0 || !Number.isInteger(eo.gen) || eo.gen < 0 ? Promise.reject(new Error("Invalid pageIndex request.")) : this.messageHandler.sendWithPromise("GetPageIndex", {
                  num: eo.num,
                  gen: eo.gen
                });
              }
              getAnnotations(eo, ao) {
                return this.messageHandler.sendWithPromise("GetAnnotations", {
                  pageIndex: eo,
                  intent: ao
                });
              }
              saveDocument() {
                return this.messageHandler.sendWithPromise("SaveDocument", {
                  isPureXfa: !!this._htmlForXfa,
                  numPages: this._numPages,
                  annotationStorage: this.annotationStorage.serializable,
                  filename: this._fullReader?.filename ?? null
                }).finally(() => {
                  this.annotationStorage.resetModified();
                });
              }
              getFieldObjects() {
                return this._getFieldObjectsPromise || (this._getFieldObjectsPromise = this.messageHandler.sendWithPromise("GetFieldObjects", null));
              }
              hasJSActions() {
                return this._hasJSActionsPromise || (this._hasJSActionsPromise = this.messageHandler.sendWithPromise("HasJSActions", null));
              }
              getCalculationOrderIds() {
                return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
              }
              getDestinations() {
                return this.messageHandler.sendWithPromise("GetDestinations", null);
              }
              getDestination(eo) {
                return typeof eo != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
                  id: eo
                });
              }
              getPageLabels() {
                return this.messageHandler.sendWithPromise("GetPageLabels", null);
              }
              getPageLayout() {
                return this.messageHandler.sendWithPromise("GetPageLayout", null);
              }
              getPageMode() {
                return this.messageHandler.sendWithPromise("GetPageMode", null);
              }
              getViewerPreferences() {
                return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
              }
              getOpenAction() {
                return this.messageHandler.sendWithPromise("GetOpenAction", null);
              }
              getAttachments() {
                return this.messageHandler.sendWithPromise("GetAttachments", null);
              }
              getJavaScript() {
                return this.messageHandler.sendWithPromise("GetJavaScript", null);
              }
              getDocJSActions() {
                return this.messageHandler.sendWithPromise("GetDocJSActions", null);
              }
              getPageJSActions(eo) {
                return this.messageHandler.sendWithPromise("GetPageJSActions", {
                  pageIndex: eo
                });
              }
              getStructTree(eo) {
                return this.messageHandler.sendWithPromise("GetStructTree", {
                  pageIndex: eo
                });
              }
              getOutline() {
                return this.messageHandler.sendWithPromise("GetOutline", null);
              }
              getOptionalContentConfig() {
                return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((eo) => new _optional_content_config.OptionalContentConfig(eo));
              }
              getPermissions() {
                return this.messageHandler.sendWithPromise("GetPermissions", null);
              }
              getMetadata() {
                return Hl(this, na) || sc(this, na, this.messageHandler.sendWithPromise("GetMetadata", null).then((eo) => ({
                  info: eo[0],
                  metadata: eo[1] ? new _metadata.Metadata(eo[1]) : null,
                  contentDispositionFilename: this._fullReader?.filename ?? null,
                  contentLength: this._fullReader?.contentLength ?? null
                })));
              }
              getMarkInfo() {
                return this.messageHandler.sendWithPromise("GetMarkInfo", null);
              }
              async startCleanup(eo = !1) {
                if (await this.messageHandler.sendWithPromise("Cleanup", null), !this.destroyed) {
                  for (const ao of Hl(this, ea).values())
                    if (!ao.cleanup())
                      throw new Error(`startCleanup: Page ${ao.pageNumber} is currently rendering.`);
                  this.commonObjs.clear(), eo || this.fontLoader.clear(), sc(this, na, null), this._getFieldObjectsPromise = null, this._hasJSActionsPromise = null;
                }
              }
              get loadingParams() {
                const eo = this._params;
                return (0, _util.shadow)(this, "loadingParams", {
                  disableAutoFetch: eo.disableAutoFetch,
                  enableXfa: eo.enableXfa
                });
              }
            }
            Qi = new WeakMap(), ea = new WeakMap(), ra = new WeakMap(), na = new WeakMap();
            class PDFObjects {
              constructor() {
                oc(this, fa);
                oc(this, ia, /* @__PURE__ */ Object.create(null));
              }
              get(eo, ao = null) {
                if (ao) {
                  const xs = nc(this, fa, tf).call(this, eo);
                  return xs.capability.promise.then(() => ao(xs.data)), null;
                }
                const io = Hl(this, ia)[eo];
                if (!io?.capability.settled)
                  throw new Error(`Requesting object that isn't resolved yet ${eo}.`);
                return io.data;
              }
              has(eo) {
                return Hl(this, ia)[eo]?.capability.settled || !1;
              }
              resolve(eo, ao = null) {
                const io = nc(this, fa, tf).call(this, eo);
                io.data = ao, io.capability.resolve();
              }
              clear() {
                sc(this, ia, /* @__PURE__ */ Object.create(null));
              }
            }
            ia = new WeakMap(), fa = new WeakSet(), tf = function(eo) {
              const ao = Hl(this, ia)[eo];
              return ao || (Hl(this, ia)[eo] = {
                capability: (0, _util.createPromiseCapability)(),
                data: null
              });
            };
            class RenderTask {
              constructor(eo) {
                oc(this, Va, null);
                sc(this, Va, eo), this.onContinue = null;
              }
              get promise() {
                return Hl(this, Va).capability.promise;
              }
              cancel() {
                Hl(this, Va).cancel();
              }
              get separateAnnots() {
                const {
                  separateAnnots: eo
                } = Hl(this, Va).operatorList;
                if (!eo)
                  return !1;
                const {
                  annotationCanvasMap: ao
                } = Hl(this, Va);
                return eo.form || eo.canvas && ao?.size > 0;
              }
            }
            Va = new WeakMap(), exports.RenderTask = RenderTask;
            const ro = class ro {
              constructor({
                callback: eo,
                params: ao,
                objs: io,
                commonObjs: xs,
                annotationCanvasMap: Ts,
                operatorList: qs,
                pageIndex: Fs,
                canvasFactory: Do,
                useRequestAnimationFrame: ys = !1,
                pdfBug: Io = !1,
                pageColors: so = null
              }) {
                this.callback = eo, this.params = ao, this.objs = io, this.commonObjs = xs, this.annotationCanvasMap = Ts, this.operatorListIdx = null, this.operatorList = qs, this._pageIndex = Fs, this.canvasFactory = Do, this._pdfBug = Io, this.pageColors = so, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = ys === !0 && typeof window < "u", this.cancelled = !1, this.capability = (0, _util.createPromiseCapability)(), this.task = new RenderTask(this), this._cancelBound = this.cancel.bind(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = ao.canvasContext.canvas;
              }
              get completed() {
                return this.capability.promise.catch(function() {
                });
              }
              initializeGraphics({
                transparency: eo = !1,
                optionalContentConfig: ao
              }) {
                if (this.cancelled)
                  return;
                if (this._canvas) {
                  if (Hl(ro, to).has(this._canvas))
                    throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                  Hl(ro, to).add(this._canvas);
                }
                this._pdfBug && globalThis.StepperManager?.enabled && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
                const {
                  canvasContext: io,
                  viewport: xs,
                  transform: Ts,
                  imageLayer: qs,
                  background: Fs
                } = this.params;
                this.gfx = new _canvas.CanvasGraphics(io, this.commonObjs, this.objs, this.canvasFactory, qs, ao, this.annotationCanvasMap, this.pageColors), this.gfx.beginDrawing({
                  transform: Ts,
                  viewport: xs,
                  transparency: eo,
                  background: Fs
                }), this.operatorListIdx = 0, this.graphicsReady = !0, this.graphicsReadyCallback && this.graphicsReadyCallback();
              }
              cancel(eo = null) {
                this.running = !1, this.cancelled = !0, this.gfx && this.gfx.endDrawing(), this._canvas && Hl(ro, to).delete(this._canvas), this.callback(eo || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, "canvas"));
              }
              operatorListChanged() {
                if (!this.graphicsReady) {
                  this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
                  return;
                }
                this.stepper && this.stepper.updateOperatorList(this.operatorList), !this.running && this._continue();
              }
              _continue() {
                this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
              }
              _scheduleNext() {
                this._useRequestAnimationFrame ? window.requestAnimationFrame(() => {
                  this._nextBound().catch(this._cancelBound);
                }) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
              }
              async _next() {
                this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), this._canvas && Hl(ro, to).delete(this._canvas), this.callback())));
              }
            };
            to = new WeakMap(), oc(ro, to, /* @__PURE__ */ new WeakSet());
            let InternalRenderTask = ro;
            const version = "2.16.105";
            exports.version = version;
            const build = "172ccdbe5";
            exports.build = build;
          },
          /* 5 */
          /***/
          (Bi, e, Zi) => {
            var fa, Df, Va;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PrintAnnotationStorage = e.AnnotationStorage = void 0;
            var Qi = Zi(1), ea = Zi(6), ra = Zi(10);
            class na {
              constructor() {
                oc(this, fa);
                this._storage = /* @__PURE__ */ new Map(), this._modified = !1, this.onSetModified = null, this.onResetModified = null, this.onAnnotationEditor = null;
              }
              getValue(ro, no) {
                const eo = this._storage.get(ro);
                return eo === void 0 ? no : Object.assign(no, eo);
              }
              getRawValue(ro) {
                return this._storage.get(ro);
              }
              remove(ro) {
                if (this._storage.delete(ro), this._storage.size === 0 && this.resetModified(), typeof this.onAnnotationEditor == "function") {
                  for (const no of this._storage.values())
                    if (no instanceof ea.AnnotationEditor)
                      return;
                  this.onAnnotationEditor(null);
                }
              }
              setValue(ro, no) {
                const eo = this._storage.get(ro);
                let ao = !1;
                if (eo !== void 0)
                  for (const [io, xs] of Object.entries(no))
                    eo[io] !== xs && (ao = !0, eo[io] = xs);
                else
                  ao = !0, this._storage.set(ro, no);
                ao && nc(this, fa, Df).call(this), no instanceof ea.AnnotationEditor && typeof this.onAnnotationEditor == "function" && this.onAnnotationEditor(no.constructor._type);
              }
              has(ro) {
                return this._storage.has(ro);
              }
              getAll() {
                return this._storage.size > 0 ? (0, Qi.objectFromMap)(this._storage) : null;
              }
              get size() {
                return this._storage.size;
              }
              resetModified() {
                this._modified && (this._modified = !1, typeof this.onResetModified == "function" && this.onResetModified());
              }
              get print() {
                return new ia(this);
              }
              get serializable() {
                if (this._storage.size === 0)
                  return null;
                const ro = /* @__PURE__ */ new Map();
                for (const [no, eo] of this._storage) {
                  const ao = eo instanceof ea.AnnotationEditor ? eo.serialize() : eo;
                  ao && ro.set(no, ao);
                }
                return ro;
              }
              static getHash(ro) {
                if (!ro)
                  return "";
                const no = new ra.MurmurHash3_64();
                for (const [eo, ao] of ro)
                  no.update(`${eo}:${JSON.stringify(ao)}`);
                return no.hexdigest();
              }
            }
            fa = new WeakSet(), Df = function() {
              this._modified || (this._modified = !0, typeof this.onSetModified == "function" && this.onSetModified());
            }, e.AnnotationStorage = na;
            class ia extends na {
              constructor(no) {
                super();
                oc(this, Va, null);
                sc(this, Va, structuredClone(no.serializable));
              }
              get print() {
                (0, Qi.unreachable)("Should not call PrintAnnotationStorage.print");
              }
              get serializable() {
                return Hl(this, Va);
              }
            }
            Va = new WeakMap(), e.PrintAnnotationStorage = ia;
          },
          /* 6 */
          /***/
          (Bi, e, Zi) => {
            var na, ia, fa, La, Va, to;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.AnnotationEditor = void 0;
            var Qi = Zi(7), ea = Zi(1);
            const ro = class ro {
              constructor(eo) {
                oc(this, na, this.focusin.bind(this));
                oc(this, ia, this.focusout.bind(this));
                oc(this, fa, !1);
                oc(this, La, !1);
                oc(this, Va, !1);
                oc(this, to, ro._zIndex++);
                this.constructor === ro && (0, ea.unreachable)("Cannot initialize AnnotationEditor."), this.parent = eo.parent, this.id = eo.id, this.width = this.height = null, this.pageIndex = eo.parent.pageIndex, this.name = eo.name, this.div = null;
                const [ao, io] = this.parent.viewportBaseDimensions;
                this.x = eo.x / ao, this.y = eo.y / io, this.rotation = this.parent.viewport.rotation, this.isAttachedToDOM = !1;
              }
              static get _defaultLineColor() {
                return (0, ea.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
              }
              setInBackground() {
                this.div.style.zIndex = 0;
              }
              setInForeground() {
                this.div.style.zIndex = Hl(this, to);
              }
              focusin(eo) {
                Hl(this, fa) ? sc(this, fa, !1) : this.parent.setSelected(this);
              }
              focusout(eo) {
                !this.isAttachedToDOM || eo.relatedTarget?.closest(`#${this.id}`) || (eo.preventDefault(), this.parent.isMultipleSelection || this.commitOrRemove());
              }
              commitOrRemove() {
                this.isEmpty() ? this.remove() : this.commit();
              }
              commit() {
                this.parent.addToAnnotationStorage(this);
              }
              dragstart(eo) {
                const ao = this.parent.div.getBoundingClientRect();
                this.startX = eo.clientX - ao.x, this.startY = eo.clientY - ao.y, eo.dataTransfer.setData("text/plain", this.id), eo.dataTransfer.effectAllowed = "move";
              }
              setAt(eo, ao, io, xs) {
                const [Ts, qs] = this.parent.viewportBaseDimensions;
                [io, xs] = this.screenToPageTranslation(io, xs), this.x = (eo + io) / Ts, this.y = (ao + xs) / qs, this.div.style.left = `${100 * this.x}%`, this.div.style.top = `${100 * this.y}%`;
              }
              translate(eo, ao) {
                const [io, xs] = this.parent.viewportBaseDimensions;
                [eo, ao] = this.screenToPageTranslation(eo, ao), this.x += eo / io, this.y += ao / xs, this.div.style.left = `${100 * this.x}%`, this.div.style.top = `${100 * this.y}%`;
              }
              screenToPageTranslation(eo, ao) {
                const {
                  rotation: io
                } = this.parent.viewport;
                switch (io) {
                  case 90:
                    return [ao, -eo];
                  case 180:
                    return [-eo, -ao];
                  case 270:
                    return [-ao, eo];
                  default:
                    return [eo, ao];
                }
              }
              setDims(eo, ao) {
                const [io, xs] = this.parent.viewportBaseDimensions;
                this.div.style.width = `${100 * eo / io}%`, this.div.style.height = `${100 * ao / xs}%`;
              }
              getInitialTranslation() {
                return [0, 0];
              }
              render() {
                this.div = document.createElement("div"), this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360), this.div.className = this.name, this.div.setAttribute("id", this.id), this.div.setAttribute("tabIndex", 0), this.setInForeground(), this.div.addEventListener("focusin", Hl(this, na)), this.div.addEventListener("focusout", Hl(this, ia));
                const [eo, ao] = this.getInitialTranslation();
                return this.translate(eo, ao), (0, Qi.bindEvents)(this, this.div, ["dragstart", "pointerdown"]), this.div;
              }
              pointerdown(eo) {
                const ao = Qi.KeyboardManager.platform.isMac;
                if (eo.button !== 0 || eo.ctrlKey && ao) {
                  eo.preventDefault();
                  return;
                }
                eo.ctrlKey && !ao || eo.shiftKey || eo.metaKey && ao ? this.parent.toggleSelected(this) : this.parent.setSelected(this), sc(this, fa, !0);
              }
              getRect(eo, ao) {
                const [io, xs] = this.parent.viewportBaseDimensions, [Ts, qs] = this.parent.pageDimensions, Fs = Ts * eo / io, Do = qs * ao / xs, ys = this.x * Ts, Io = this.y * qs, so = this.width * Ts, os = this.height * qs;
                switch (this.rotation) {
                  case 0:
                    return [ys + Fs, qs - Io - Do - os, ys + Fs + so, qs - Io - Do];
                  case 90:
                    return [ys + Do, qs - Io + Fs, ys + Do + os, qs - Io + Fs + so];
                  case 180:
                    return [ys - Fs - so, qs - Io + Do, ys - Fs, qs - Io + Do + os];
                  case 270:
                    return [ys - Do - os, qs - Io - Fs - so, ys - Do, qs - Io - Fs];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              getRectInCurrentCoords(eo, ao) {
                const [io, xs, Ts, qs] = eo, Fs = Ts - io, Do = qs - xs;
                switch (this.rotation) {
                  case 0:
                    return [io, ao - qs, Fs, Do];
                  case 90:
                    return [io, ao - xs, Do, Fs];
                  case 180:
                    return [Ts, ao - xs, Fs, Do];
                  case 270:
                    return [Ts, ao - qs, Do, Fs];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              onceAdded() {
              }
              isEmpty() {
                return !1;
              }
              enableEditMode() {
                sc(this, Va, !0);
              }
              disableEditMode() {
                sc(this, Va, !1);
              }
              isInEditMode() {
                return Hl(this, Va);
              }
              shouldGetKeyboardEvents() {
                return !1;
              }
              needsToBeRebuilt() {
                return this.div && !this.isAttachedToDOM;
              }
              rebuild() {
                this.div?.addEventListener("focusin", Hl(this, na));
              }
              serialize() {
                (0, ea.unreachable)("An editor must be serializable");
              }
              static deserialize(eo, ao) {
                const io = new this.prototype.constructor({
                  parent: ao,
                  id: ao.getNextId()
                });
                io.rotation = eo.rotation;
                const [xs, Ts] = ao.pageDimensions, [qs, Fs, Do, ys] = io.getRectInCurrentCoords(eo.rect, Ts);
                return io.x = qs / xs, io.y = Fs / Ts, io.width = Do / xs, io.height = ys / Ts, io;
              }
              remove() {
                this.div.removeEventListener("focusin", Hl(this, na)), this.div.removeEventListener("focusout", Hl(this, ia)), this.isEmpty() || this.commit(), this.parent.remove(this);
              }
              select() {
                this.div?.classList.add("selectedEditor");
              }
              unselect() {
                this.div?.classList.remove("selectedEditor");
              }
              updateParams(eo, ao) {
              }
              disableEditing() {
              }
              enableEditing() {
              }
              get propertiesToUpdate() {
                return {};
              }
              get contentDiv() {
                return this.div;
              }
              get isEditing() {
                return Hl(this, La);
              }
              set isEditing(eo) {
                sc(this, La, eo), eo ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null);
              }
            };
            na = new WeakMap(), ia = new WeakMap(), fa = new WeakMap(), La = new WeakMap(), Va = new WeakMap(), to = new WeakMap(), cd(ro, "_colorManager", new Qi.ColorManager()), cd(ro, "_zIndex", 1);
            let ra = ro;
            e.AnnotationEditor = ra;
          },
          /* 7 */
          /***/
          (Bi, e, Zi) => {
            var no, eo, ao, io, xs, Ts, Rf, Do, Io, so, os, Xs, gl, Sl, El, wl, jl, kl, Fl, Ml, ql, Kl, Zl, Il, xl, bl, If, rf, yd, Ld, Mf, Ff, cf, Vd, zd;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.KeyboardManager = e.CommandManager = e.ColorManager = e.AnnotationEditorUIManager = void 0, e.bindEvents = ra, e.opacityToHex = na;
            var Qi = Zi(1), ea = Zi(8);
            function ra(Cl, ml, Tl) {
              for (const Ll of Tl)
                ml.addEventListener(Ll, Cl[Ll].bind(Cl));
            }
            function na(Cl) {
              return Math.round(Math.min(255, Math.max(1, 255 * Cl))).toString(16).padStart(2, "0");
            }
            class ia {
              constructor() {
                oc(this, no, 0);
              }
              getId() {
                return `${Qi.AnnotationEditorPrefix}${Yd(this, no)._++}`;
              }
            }
            no = new WeakMap();
            class fa {
              constructor(ml = 128) {
                oc(this, eo, []);
                oc(this, ao, !1);
                oc(this, io);
                oc(this, xs, -1);
                sc(this, io, ml);
              }
              add({
                cmd: ml,
                undo: Tl,
                mustExec: Ll,
                type: Vl = NaN,
                overwriteIfSameType: zl = !1,
                keepUndo: Ul = !1
              }) {
                if (Ll && ml(), Hl(this, ao))
                  return;
                const Yl = {
                  cmd: ml,
                  undo: Tl,
                  type: Vl
                };
                if (Hl(this, xs) === -1) {
                  Hl(this, eo).length > 0 && (Hl(this, eo).length = 0), sc(this, xs, 0), Hl(this, eo).push(Yl);
                  return;
                }
                if (zl && Hl(this, eo)[Hl(this, xs)].type === Vl) {
                  Ul && (Yl.undo = Hl(this, eo)[Hl(this, xs)].undo), Hl(this, eo)[Hl(this, xs)] = Yl;
                  return;
                }
                const Jl = Hl(this, xs) + 1;
                Jl === Hl(this, io) ? Hl(this, eo).splice(0, 1) : (sc(this, xs, Jl), Jl < Hl(this, eo).length && Hl(this, eo).splice(Jl)), Hl(this, eo).push(Yl);
              }
              undo() {
                Hl(this, xs) !== -1 && (sc(this, ao, !0), Hl(this, eo)[Hl(this, xs)].undo(), sc(this, ao, !1), sc(this, xs, Hl(this, xs) - 1));
              }
              redo() {
                Hl(this, xs) < Hl(this, eo).length - 1 && (sc(this, xs, Hl(this, xs) + 1), sc(this, ao, !0), Hl(this, eo)[Hl(this, xs)].cmd(), sc(this, ao, !1));
              }
              hasSomethingToUndo() {
                return Hl(this, xs) !== -1;
              }
              hasSomethingToRedo() {
                return Hl(this, xs) < Hl(this, eo).length - 1;
              }
              destroy() {
                sc(this, eo, null);
              }
            }
            eo = new WeakMap(), ao = new WeakMap(), io = new WeakMap(), xs = new WeakMap(), e.CommandManager = fa;
            const Fs = class Fs {
              constructor(ml) {
                oc(this, Ts);
                this.buffer = [], this.callbacks = /* @__PURE__ */ new Map(), this.allKeys = /* @__PURE__ */ new Set();
                const Tl = Fs.platform.isMac;
                for (const [Ll, Vl] of ml)
                  for (const zl of Ll) {
                    const Ul = zl.startsWith("mac+");
                    Tl && Ul ? (this.callbacks.set(zl.slice(4), Vl), this.allKeys.add(zl.split("+").at(-1))) : !Tl && !Ul && (this.callbacks.set(zl, Vl), this.allKeys.add(zl.split("+").at(-1)));
                  }
              }
              static get platform() {
                const ml = typeof navigator < "u" ? navigator.platform : "";
                return (0, Qi.shadow)(this, "platform", {
                  isWin: ml.includes("Win"),
                  isMac: ml.includes("Mac")
                });
              }
              exec(ml, Tl) {
                if (!this.allKeys.has(Tl.key))
                  return;
                const Ll = this.callbacks.get(nc(this, Ts, Rf).call(this, Tl));
                Ll && (Ll.bind(ml)(), Tl.stopPropagation(), Tl.preventDefault());
              }
            };
            Ts = new WeakSet(), Rf = function(ml) {
              ml.altKey && this.buffer.push("alt"), ml.ctrlKey && this.buffer.push("ctrl"), ml.metaKey && this.buffer.push("meta"), ml.shiftKey && this.buffer.push("shift"), this.buffer.push(ml.key);
              const Tl = this.buffer.join("+");
              return this.buffer.length = 0, Tl;
            };
            let La = Fs;
            e.KeyboardManager = La;
            class Va {
              constructor() {
                oc(this, Do, null);
              }
              copy(ml) {
                ml && (Array.isArray(ml) ? sc(this, Do, ml.map((Tl) => Tl.serialize())) : sc(this, Do, [ml.serialize()]), sc(this, Do, Hl(this, Do).filter((Tl) => !!Tl)), Hl(this, Do).length === 0 && sc(this, Do, null));
              }
              paste() {
                return Hl(this, Do);
              }
              isEmpty() {
                return Hl(this, Do) === null;
              }
              destroy() {
                sc(this, Do, null);
              }
            }
            Do = new WeakMap();
            const ys = class ys {
              get _colors() {
                const ml = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
                return (0, ea.getColorValues)(ml), (0, Qi.shadow)(this, "_colors", ml);
              }
              convert(ml) {
                const Tl = (0, ea.getRGB)(ml);
                if (!window.matchMedia("(forced-colors: active)").matches)
                  return Tl;
                for (const [Ll, Vl] of this._colors)
                  if (Vl.every((zl, Ul) => zl === Tl[Ul]))
                    return ys._colorsMapping.get(Ll);
                return Tl;
              }
              getHexCode(ml) {
                const Tl = this._colors.get(ml);
                return Tl ? Qi.Util.makeHexColor(...Tl) : ml;
              }
            };
            cd(ys, "_colorsMapping", /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]));
            let to = ys;
            e.ColorManager = to;
            const Rl = class Rl {
              constructor(ml, Tl) {
                oc(this, bl);
                oc(this, Io, null);
                oc(this, so, /* @__PURE__ */ new Map());
                oc(this, os, /* @__PURE__ */ new Map());
                oc(this, Xs, new Va());
                oc(this, gl, new fa());
                oc(this, Sl, 0);
                oc(this, El, null);
                oc(this, wl, null);
                oc(this, jl, new ia());
                oc(this, kl, !1);
                oc(this, Fl, Qi.AnnotationEditorType.NONE);
                oc(this, Ml, /* @__PURE__ */ new Set());
                oc(this, ql, this.keydown.bind(this));
                oc(this, Kl, this.onEditingAction.bind(this));
                oc(this, Zl, this.onPageChanging.bind(this));
                oc(this, Il, {
                  isEditing: !1,
                  isEmpty: !0,
                  hasEmptyClipboard: !0,
                  hasSomethingToUndo: !1,
                  hasSomethingToRedo: !1,
                  hasSelectedEditor: !1
                });
                oc(this, xl, null);
                sc(this, xl, ml), sc(this, wl, Tl), Hl(this, wl)._on("editingaction", Hl(this, Kl)), Hl(this, wl)._on("pagechanging", Hl(this, Zl));
              }
              destroy() {
                nc(this, bl, rf).call(this), Hl(this, wl)._off("editingaction", Hl(this, Kl)), Hl(this, wl)._off("pagechanging", Hl(this, Zl));
                for (const ml of Hl(this, os).values())
                  ml.destroy();
                Hl(this, os).clear(), Hl(this, so).clear(), sc(this, Io, null), Hl(this, Ml).clear(), Hl(this, Xs).destroy(), Hl(this, gl).destroy();
              }
              onPageChanging({
                pageNumber: ml
              }) {
                sc(this, Sl, ml - 1);
              }
              focusMainContainer() {
                Hl(this, xl).focus();
              }
              keydown(ml) {
                this.getActive()?.shouldGetKeyboardEvents() || Rl._keyboardManager.exec(this, ml);
              }
              onEditingAction(ml) {
                ["undo", "redo", "cut", "copy", "paste", "delete", "selectAll"].includes(ml.name) && this[ml.name]();
              }
              setEditingState(ml) {
                ml ? (nc(this, bl, If).call(this), nc(this, bl, yd).call(this, {
                  isEditing: Hl(this, Fl) !== Qi.AnnotationEditorType.NONE,
                  isEmpty: nc(this, bl, Vd).call(this),
                  hasSomethingToUndo: Hl(this, gl).hasSomethingToUndo(),
                  hasSomethingToRedo: Hl(this, gl).hasSomethingToRedo(),
                  hasSelectedEditor: !1,
                  hasEmptyClipboard: Hl(this, Xs).isEmpty()
                })) : (nc(this, bl, rf).call(this), nc(this, bl, yd).call(this, {
                  isEditing: !1
                }));
              }
              registerEditorTypes(ml) {
                sc(this, El, ml);
                for (const Tl of Hl(this, El))
                  nc(this, bl, Ld).call(this, Tl.defaultPropertiesToUpdate);
              }
              getId() {
                return Hl(this, jl).getId();
              }
              addLayer(ml) {
                Hl(this, os).set(ml.pageIndex, ml), Hl(this, kl) ? ml.enable() : ml.disable();
              }
              removeLayer(ml) {
                Hl(this, os).delete(ml.pageIndex);
              }
              updateMode(ml) {
                if (sc(this, Fl, ml), ml === Qi.AnnotationEditorType.NONE)
                  this.setEditingState(!1), nc(this, bl, Ff).call(this);
                else {
                  this.setEditingState(!0), nc(this, bl, Mf).call(this);
                  for (const Tl of Hl(this, os).values())
                    Tl.updateMode(ml);
                }
              }
              updateToolbar(ml) {
                ml !== Hl(this, Fl) && Hl(this, wl).dispatch("switchannotationeditormode", {
                  source: this,
                  mode: ml
                });
              }
              updateParams(ml, Tl) {
                for (const Ll of Hl(this, Ml))
                  Ll.updateParams(ml, Tl);
                for (const Ll of Hl(this, El))
                  Ll.updateDefaultParams(ml, Tl);
              }
              getEditors(ml) {
                const Tl = [];
                for (const Ll of Hl(this, so).values())
                  Ll.pageIndex === ml && Tl.push(Ll);
                return Tl;
              }
              getEditor(ml) {
                return Hl(this, so).get(ml);
              }
              addEditor(ml) {
                Hl(this, so).set(ml.id, ml);
              }
              removeEditor(ml) {
                Hl(this, so).delete(ml.id), this.unselect(ml);
              }
              setActiveEditor(ml) {
                Hl(this, Io) !== ml && (sc(this, Io, ml), ml && nc(this, bl, Ld).call(this, ml.propertiesToUpdate));
              }
              toggleSelected(ml) {
                if (Hl(this, Ml).has(ml)) {
                  Hl(this, Ml).delete(ml), ml.unselect(), nc(this, bl, yd).call(this, {
                    hasSelectedEditor: this.hasSelection
                  });
                  return;
                }
                Hl(this, Ml).add(ml), ml.select(), nc(this, bl, Ld).call(this, ml.propertiesToUpdate), nc(this, bl, yd).call(this, {
                  hasSelectedEditor: !0
                });
              }
              setSelected(ml) {
                for (const Tl of Hl(this, Ml))
                  Tl !== ml && Tl.unselect();
                Hl(this, Ml).clear(), Hl(this, Ml).add(ml), ml.select(), nc(this, bl, Ld).call(this, ml.propertiesToUpdate), nc(this, bl, yd).call(this, {
                  hasSelectedEditor: !0
                });
              }
              isSelected(ml) {
                return Hl(this, Ml).has(ml);
              }
              unselect(ml) {
                ml.unselect(), Hl(this, Ml).delete(ml), nc(this, bl, yd).call(this, {
                  hasSelectedEditor: this.hasSelection
                });
              }
              get hasSelection() {
                return Hl(this, Ml).size !== 0;
              }
              undo() {
                Hl(this, gl).undo(), nc(this, bl, yd).call(this, {
                  hasSomethingToUndo: Hl(this, gl).hasSomethingToUndo(),
                  hasSomethingToRedo: !0,
                  isEmpty: nc(this, bl, Vd).call(this)
                });
              }
              redo() {
                Hl(this, gl).redo(), nc(this, bl, yd).call(this, {
                  hasSomethingToUndo: !0,
                  hasSomethingToRedo: Hl(this, gl).hasSomethingToRedo(),
                  isEmpty: nc(this, bl, Vd).call(this)
                });
              }
              addCommands(ml) {
                Hl(this, gl).add(ml), nc(this, bl, yd).call(this, {
                  hasSomethingToUndo: !0,
                  hasSomethingToRedo: !1,
                  isEmpty: nc(this, bl, Vd).call(this)
                });
              }
              delete() {
                if (Hl(this, Io) && Hl(this, Io).commitOrRemove(), !this.hasSelection)
                  return;
                const ml = [...Hl(this, Ml)], Tl = () => {
                  for (const Vl of ml)
                    Vl.remove();
                }, Ll = () => {
                  for (const Vl of ml)
                    nc(this, bl, cf).call(this, Vl);
                };
                this.addCommands({
                  cmd: Tl,
                  undo: Ll,
                  mustExec: !0
                });
              }
              copy() {
                if (Hl(this, Io) && Hl(this, Io).commitOrRemove(), this.hasSelection) {
                  const ml = [];
                  for (const Tl of Hl(this, Ml))
                    Tl.isEmpty() || ml.push(Tl);
                  if (ml.length === 0)
                    return;
                  Hl(this, Xs).copy(ml), nc(this, bl, yd).call(this, {
                    hasEmptyClipboard: !1
                  });
                }
              }
              cut() {
                this.copy(), this.delete();
              }
              paste() {
                if (Hl(this, Xs).isEmpty())
                  return;
                this.unselectAll();
                const ml = Hl(this, os).get(Hl(this, Sl)), Tl = Hl(this, Xs).paste().map((zl) => ml.deserialize(zl)), Ll = () => {
                  for (const zl of Tl)
                    nc(this, bl, cf).call(this, zl);
                  nc(this, bl, zd).call(this, Tl);
                }, Vl = () => {
                  for (const zl of Tl)
                    zl.remove();
                };
                this.addCommands({
                  cmd: Ll,
                  undo: Vl,
                  mustExec: !0
                });
              }
              selectAll() {
                for (const ml of Hl(this, Ml))
                  ml.commit();
                nc(this, bl, zd).call(this, Hl(this, so).values());
              }
              unselectAll() {
                if (Hl(this, Io)) {
                  Hl(this, Io).commitOrRemove();
                  return;
                }
                if (nc(this, bl, zd).size !== 0) {
                  for (const ml of Hl(this, Ml))
                    ml.unselect();
                  Hl(this, Ml).clear(), nc(this, bl, yd).call(this, {
                    hasSelectedEditor: !1
                  });
                }
              }
              isActive(ml) {
                return Hl(this, Io) === ml;
              }
              getActive() {
                return Hl(this, Io);
              }
              getMode() {
                return Hl(this, Fl);
              }
            };
            Io = new WeakMap(), so = new WeakMap(), os = new WeakMap(), Xs = new WeakMap(), gl = new WeakMap(), Sl = new WeakMap(), El = new WeakMap(), wl = new WeakMap(), jl = new WeakMap(), kl = new WeakMap(), Fl = new WeakMap(), Ml = new WeakMap(), ql = new WeakMap(), Kl = new WeakMap(), Zl = new WeakMap(), Il = new WeakMap(), xl = new WeakMap(), bl = new WeakSet(), If = function() {
              Hl(this, xl).addEventListener("keydown", Hl(this, ql));
            }, rf = function() {
              Hl(this, xl).removeEventListener("keydown", Hl(this, ql));
            }, yd = function(ml) {
              Object.entries(ml).some(([Ll, Vl]) => Hl(this, Il)[Ll] !== Vl) && Hl(this, wl).dispatch("annotationeditorstateschanged", {
                source: this,
                details: Object.assign(Hl(this, Il), ml)
              });
            }, Ld = function(ml) {
              Hl(this, wl).dispatch("annotationeditorparamschanged", {
                source: this,
                details: ml
              });
            }, Mf = function() {
              if (!Hl(this, kl)) {
                sc(this, kl, !0);
                for (const ml of Hl(this, os).values())
                  ml.enable();
              }
            }, Ff = function() {
              if (this.unselectAll(), Hl(this, kl)) {
                sc(this, kl, !1);
                for (const ml of Hl(this, os).values())
                  ml.disable();
              }
            }, cf = function(ml) {
              const Tl = Hl(this, os).get(ml.pageIndex);
              Tl ? Tl.addOrRebuild(ml) : this.addEditor(ml);
            }, Vd = function() {
              if (Hl(this, so).size === 0)
                return !0;
              if (Hl(this, so).size === 1)
                for (const ml of Hl(this, so).values())
                  return ml.isEmpty();
              return !1;
            }, zd = function(ml) {
              Hl(this, Ml).clear();
              for (const Tl of ml)
                Tl.isEmpty() || (Hl(this, Ml).add(Tl), Tl.select());
              nc(this, bl, yd).call(this, {
                hasSelectedEditor: !0
              });
            }, cd(Rl, "_keyboardManager", new La([[["ctrl+a", "mac+meta+a"], Rl.prototype.selectAll], [["ctrl+c", "mac+meta+c"], Rl.prototype.copy], [["ctrl+v", "mac+meta+v"], Rl.prototype.paste], [["ctrl+x", "mac+meta+x"], Rl.prototype.cut], [["ctrl+z", "mac+meta+z"], Rl.prototype.undo], [["ctrl+y", "ctrl+shift+Z", "mac+meta+shift+Z"], Rl.prototype.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete"], Rl.prototype.delete], [["Escape", "mac+Escape"], Rl.prototype.unselectAll]]));
            let ro = Rl;
            e.AnnotationEditorUIManager = ro;
          },
          /* 8 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.StatTimer = e.RenderingCancelledException = e.PixelsPerInch = e.PageViewport = e.PDFDateString = e.DOMStandardFontDataFactory = e.DOMSVGFactory = e.DOMCanvasFactory = e.DOMCMapReaderFactory = e.AnnotationPrefix = void 0, e.deprecated = ys, e.getColorValues = gl, e.getCurrentTransform = Sl, e.getCurrentTransformInverse = El, e.getFilenameFromUrl = xs, e.getPdfFilenameFromUrl = Ts, e.getRGB = Xs, e.getXfaPageViewport = os, e.isDataScheme = ao, e.isPdfFile = io, e.isValidFetchUrl = Fs, e.loadScript = Do;
            var Qi = Zi(9), ea = Zi(1);
            const ra = "http://www.w3.org/2000/svg", na = "pdfjs_internal_id_";
            e.AnnotationPrefix = na;
            const wl = class wl {
            };
            cd(wl, "CSS", 96), cd(wl, "PDF", 72), cd(wl, "PDF_TO_CSS_UNITS", wl.CSS / wl.PDF);
            let ia = wl;
            e.PixelsPerInch = ia;
            class fa extends Qi.BaseCanvasFactory {
              constructor({
                ownerDocument: kl = globalThis.document
              } = {}) {
                super(), this._document = kl;
              }
              _createCanvas(kl, Fl) {
                const Ml = this._document.createElement("canvas");
                return Ml.width = kl, Ml.height = Fl, Ml;
              }
            }
            e.DOMCanvasFactory = fa;
            async function La(jl, kl = !1) {
              if (Fs(jl, document.baseURI)) {
                const Fl = await fetch(jl);
                if (!Fl.ok)
                  throw new Error(Fl.statusText);
                return kl ? new Uint8Array(await Fl.arrayBuffer()) : (0, ea.stringToBytes)(await Fl.text());
              }
              return new Promise((Fl, Ml) => {
                const ql = new XMLHttpRequest();
                ql.open("GET", jl, !0), kl && (ql.responseType = "arraybuffer"), ql.onreadystatechange = () => {
                  if (ql.readyState === XMLHttpRequest.DONE) {
                    if (ql.status === 200 || ql.status === 0) {
                      let Kl;
                      if (kl && ql.response ? Kl = new Uint8Array(ql.response) : !kl && ql.responseText && (Kl = (0, ea.stringToBytes)(ql.responseText)), Kl) {
                        Fl(Kl);
                        return;
                      }
                    }
                    Ml(new Error(ql.statusText));
                  }
                }, ql.send(null);
              });
            }
            class Va extends Qi.BaseCMapReaderFactory {
              _fetchData(kl, Fl) {
                return La(kl, this.isCompressed).then((Ml) => ({
                  cMapData: Ml,
                  compressionType: Fl
                }));
              }
            }
            e.DOMCMapReaderFactory = Va;
            class to extends Qi.BaseStandardFontDataFactory {
              _fetchData(kl) {
                return La(kl, !0);
              }
            }
            e.DOMStandardFontDataFactory = to;
            class ro extends Qi.BaseSVGFactory {
              _createSVG(kl) {
                return document.createElementNS(ra, kl);
              }
            }
            e.DOMSVGFactory = ro;
            class no {
              constructor({
                viewBox: kl,
                scale: Fl,
                rotation: Ml,
                offsetX: ql = 0,
                offsetY: Kl = 0,
                dontFlip: Zl = !1
              }) {
                this.viewBox = kl, this.scale = Fl, this.rotation = Ml, this.offsetX = ql, this.offsetY = Kl;
                const Il = (kl[2] + kl[0]) / 2, xl = (kl[3] + kl[1]) / 2;
                let bl, Pl, Nl, Bl;
                switch (Ml %= 360, Ml < 0 && (Ml += 360), Ml) {
                  case 180:
                    bl = -1, Pl = 0, Nl = 0, Bl = 1;
                    break;
                  case 90:
                    bl = 0, Pl = 1, Nl = 1, Bl = 0;
                    break;
                  case 270:
                    bl = 0, Pl = -1, Nl = -1, Bl = 0;
                    break;
                  case 0:
                    bl = 1, Pl = 0, Nl = 0, Bl = -1;
                    break;
                  default:
                    throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                }
                Zl && (Nl = -Nl, Bl = -Bl);
                let Ol, To, Os, $l;
                bl === 0 ? (Ol = Math.abs(xl - kl[1]) * Fl + ql, To = Math.abs(Il - kl[0]) * Fl + Kl, Os = Math.abs(kl[3] - kl[1]) * Fl, $l = Math.abs(kl[2] - kl[0]) * Fl) : (Ol = Math.abs(Il - kl[0]) * Fl + ql, To = Math.abs(xl - kl[1]) * Fl + Kl, Os = Math.abs(kl[2] - kl[0]) * Fl, $l = Math.abs(kl[3] - kl[1]) * Fl), this.transform = [bl * Fl, Pl * Fl, Nl * Fl, Bl * Fl, Ol - bl * Fl * Il - Nl * Fl * xl, To - Pl * Fl * Il - Bl * Fl * xl], this.width = Os, this.height = $l;
              }
              clone({
                scale: kl = this.scale,
                rotation: Fl = this.rotation,
                offsetX: Ml = this.offsetX,
                offsetY: ql = this.offsetY,
                dontFlip: Kl = !1
              } = {}) {
                return new no({
                  viewBox: this.viewBox.slice(),
                  scale: kl,
                  rotation: Fl,
                  offsetX: Ml,
                  offsetY: ql,
                  dontFlip: Kl
                });
              }
              convertToViewportPoint(kl, Fl) {
                return ea.Util.applyTransform([kl, Fl], this.transform);
              }
              convertToViewportRectangle(kl) {
                const Fl = ea.Util.applyTransform([kl[0], kl[1]], this.transform), Ml = ea.Util.applyTransform([kl[2], kl[3]], this.transform);
                return [Fl[0], Fl[1], Ml[0], Ml[1]];
              }
              convertToPdfPoint(kl, Fl) {
                return ea.Util.applyInverseTransform([kl, Fl], this.transform);
              }
            }
            e.PageViewport = no;
            class eo extends ea.BaseException {
              constructor(kl, Fl) {
                super(kl, "RenderingCancelledException"), this.type = Fl;
              }
            }
            e.RenderingCancelledException = eo;
            function ao(jl) {
              const kl = jl.length;
              let Fl = 0;
              for (; Fl < kl && jl[Fl].trim() === ""; )
                Fl++;
              return jl.substring(Fl, Fl + 5).toLowerCase() === "data:";
            }
            function io(jl) {
              return typeof jl == "string" && /\.pdf$/i.test(jl);
            }
            function xs(jl) {
              const kl = jl.indexOf("#"), Fl = jl.indexOf("?"), Ml = Math.min(kl > 0 ? kl : jl.length, Fl > 0 ? Fl : jl.length);
              return jl.substring(jl.lastIndexOf("/", Ml) + 1, Ml);
            }
            function Ts(jl, kl = "document.pdf") {
              if (typeof jl != "string")
                return kl;
              if (ao(jl))
                return (0, ea.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), kl;
              const Fl = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/, Ml = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i, ql = Fl.exec(jl);
              let Kl = Ml.exec(ql[1]) || Ml.exec(ql[2]) || Ml.exec(ql[3]);
              if (Kl && (Kl = Kl[0], Kl.includes("%")))
                try {
                  Kl = Ml.exec(decodeURIComponent(Kl))[0];
                } catch {
                }
              return Kl || kl;
            }
            class qs {
              constructor() {
                this.started = /* @__PURE__ */ Object.create(null), this.times = [];
              }
              time(kl) {
                kl in this.started && (0, ea.warn)(`Timer is already running for ${kl}`), this.started[kl] = Date.now();
              }
              timeEnd(kl) {
                kl in this.started || (0, ea.warn)(`Timer has not been started for ${kl}`), this.times.push({
                  name: kl,
                  start: this.started[kl],
                  end: Date.now()
                }), delete this.started[kl];
              }
              toString() {
                const kl = [];
                let Fl = 0;
                for (const Ml of this.times) {
                  const ql = Ml.name;
                  ql.length > Fl && (Fl = ql.length);
                }
                for (const Ml of this.times) {
                  const ql = Ml.end - Ml.start;
                  kl.push(`${Ml.name.padEnd(Fl)} ${ql}ms
`);
                }
                return kl.join("");
              }
            }
            e.StatTimer = qs;
            function Fs(jl, kl) {
              try {
                const {
                  protocol: Fl
                } = kl ? new URL(jl, kl) : new URL(jl);
                return Fl === "http:" || Fl === "https:";
              } catch {
                return !1;
              }
            }
            function Do(jl, kl = !1) {
              return new Promise((Fl, Ml) => {
                const ql = document.createElement("script");
                ql.src = jl, ql.onload = function(Kl) {
                  kl && ql.remove(), Fl(Kl);
                }, ql.onerror = function() {
                  Ml(new Error(`Cannot load script at: ${ql.src}`));
                }, (document.head || document.documentElement).append(ql);
              });
            }
            function ys(jl) {
              console.log("Deprecated API usage: " + jl);
            }
            let Io;
            class so {
              static toDateObject(kl) {
                if (!kl || typeof kl != "string")
                  return null;
                Io || (Io = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
                const Fl = Io.exec(kl);
                if (!Fl)
                  return null;
                const Ml = parseInt(Fl[1], 10);
                let ql = parseInt(Fl[2], 10);
                ql = ql >= 1 && ql <= 12 ? ql - 1 : 0;
                let Kl = parseInt(Fl[3], 10);
                Kl = Kl >= 1 && Kl <= 31 ? Kl : 1;
                let Zl = parseInt(Fl[4], 10);
                Zl = Zl >= 0 && Zl <= 23 ? Zl : 0;
                let Il = parseInt(Fl[5], 10);
                Il = Il >= 0 && Il <= 59 ? Il : 0;
                let xl = parseInt(Fl[6], 10);
                xl = xl >= 0 && xl <= 59 ? xl : 0;
                const bl = Fl[7] || "Z";
                let Pl = parseInt(Fl[8], 10);
                Pl = Pl >= 0 && Pl <= 23 ? Pl : 0;
                let Nl = parseInt(Fl[9], 10) || 0;
                return Nl = Nl >= 0 && Nl <= 59 ? Nl : 0, bl === "-" ? (Zl += Pl, Il += Nl) : bl === "+" && (Zl -= Pl, Il -= Nl), new Date(Date.UTC(Ml, ql, Kl, Zl, Il, xl));
              }
            }
            e.PDFDateString = so;
            function os(jl, {
              scale: kl = 1,
              rotation: Fl = 0
            }) {
              const {
                width: Ml,
                height: ql
              } = jl.attributes.style, Kl = [0, 0, parseInt(Ml), parseInt(ql)];
              return new no({
                viewBox: Kl,
                scale: kl,
                rotation: Fl
              });
            }
            function Xs(jl) {
              if (jl.startsWith("#")) {
                const kl = parseInt(jl.slice(1), 16);
                return [(kl & 16711680) >> 16, (kl & 65280) >> 8, kl & 255];
              }
              return jl.startsWith("rgb(") ? jl.slice(4, -1).split(",").map((kl) => parseInt(kl)) : jl.startsWith("rgba(") ? jl.slice(5, -1).split(",").map((kl) => parseInt(kl)).slice(0, 3) : ((0, ea.warn)(`Not a valid color format: "${jl}"`), [0, 0, 0]);
            }
            function gl(jl) {
              const kl = document.createElement("span");
              kl.style.visibility = "hidden", document.body.append(kl);
              for (const Fl of jl.keys()) {
                kl.style.color = Fl;
                const Ml = window.getComputedStyle(kl).color;
                jl.set(Fl, Xs(Ml));
              }
              kl.remove();
            }
            function Sl(jl) {
              const {
                a: kl,
                b: Fl,
                c: Ml,
                d: ql,
                e: Kl,
                f: Zl
              } = jl.getTransform();
              return [kl, Fl, Ml, ql, Kl, Zl];
            }
            function El(jl) {
              const {
                a: kl,
                b: Fl,
                c: Ml,
                d: ql,
                e: Kl,
                f: Zl
              } = jl.getTransform().invertSelf();
              return [kl, Fl, Ml, ql, Kl, Zl];
            }
          },
          /* 9 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.BaseStandardFontDataFactory = e.BaseSVGFactory = e.BaseCanvasFactory = e.BaseCMapReaderFactory = void 0;
            var Qi = Zi(1);
            class ea {
              constructor() {
                this.constructor === ea && (0, Qi.unreachable)("Cannot initialize BaseCanvasFactory.");
              }
              create(La, Va) {
                if (La <= 0 || Va <= 0)
                  throw new Error("Invalid canvas size");
                const to = this._createCanvas(La, Va);
                return {
                  canvas: to,
                  context: to.getContext("2d")
                };
              }
              reset(La, Va, to) {
                if (!La.canvas)
                  throw new Error("Canvas is not specified");
                if (Va <= 0 || to <= 0)
                  throw new Error("Invalid canvas size");
                La.canvas.width = Va, La.canvas.height = to;
              }
              destroy(La) {
                if (!La.canvas)
                  throw new Error("Canvas is not specified");
                La.canvas.width = 0, La.canvas.height = 0, La.canvas = null, La.context = null;
              }
              _createCanvas(La, Va) {
                (0, Qi.unreachable)("Abstract method `_createCanvas` called.");
              }
            }
            e.BaseCanvasFactory = ea;
            class ra {
              constructor({
                baseUrl: La = null,
                isCompressed: Va = !1
              }) {
                this.constructor === ra && (0, Qi.unreachable)("Cannot initialize BaseCMapReaderFactory."), this.baseUrl = La, this.isCompressed = Va;
              }
              async fetch({
                name: La
              }) {
                if (!this.baseUrl)
                  throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                if (!La)
                  throw new Error("CMap name must be specified.");
                const Va = this.baseUrl + La + (this.isCompressed ? ".bcmap" : ""), to = this.isCompressed ? Qi.CMapCompressionType.BINARY : Qi.CMapCompressionType.NONE;
                return this._fetchData(Va, to).catch((ro) => {
                  throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${Va}`);
                });
              }
              _fetchData(La, Va) {
                (0, Qi.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            e.BaseCMapReaderFactory = ra;
            class na {
              constructor({
                baseUrl: La = null
              }) {
                this.constructor === na && (0, Qi.unreachable)("Cannot initialize BaseStandardFontDataFactory."), this.baseUrl = La;
              }
              async fetch({
                filename: La
              }) {
                if (!this.baseUrl)
                  throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                if (!La)
                  throw new Error("Font filename must be specified.");
                const Va = `${this.baseUrl}${La}`;
                return this._fetchData(Va).catch((to) => {
                  throw new Error(`Unable to load font data at: ${Va}`);
                });
              }
              _fetchData(La) {
                (0, Qi.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            e.BaseStandardFontDataFactory = na;
            class ia {
              constructor() {
                this.constructor === ia && (0, Qi.unreachable)("Cannot initialize BaseSVGFactory.");
              }
              create(La, Va, to = !1) {
                if (La <= 0 || Va <= 0)
                  throw new Error("Invalid SVG dimensions");
                const ro = this._createSVG("svg:svg");
                return ro.setAttribute("version", "1.1"), to || (ro.setAttribute("width", `${La}px`), ro.setAttribute("height", `${Va}px`)), ro.setAttribute("preserveAspectRatio", "none"), ro.setAttribute("viewBox", `0 0 ${La} ${Va}`), ro;
              }
              createElement(La) {
                if (typeof La != "string")
                  throw new Error("Invalid SVG element type");
                return this._createSVG(La);
              }
              _createSVG(La) {
                (0, Qi.unreachable)("Abstract method `_createSVG` called.");
              }
            }
            e.BaseSVGFactory = ia;
          },
          /* 10 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.MurmurHash3_64 = void 0;
            var Qi = Zi(1);
            const ea = 3285377520, ra = 4294901760, na = 65535;
            class ia {
              constructor(La) {
                this.h1 = La ? La & 4294967295 : ea, this.h2 = La ? La & 4294967295 : ea;
              }
              update(La) {
                let Va, to;
                if (typeof La == "string") {
                  Va = new Uint8Array(La.length * 2), to = 0;
                  for (let Io = 0, so = La.length; Io < so; Io++) {
                    const os = La.charCodeAt(Io);
                    os <= 255 ? Va[to++] = os : (Va[to++] = os >>> 8, Va[to++] = os & 255);
                  }
                } else if ((0, Qi.isArrayBuffer)(La))
                  Va = La.slice(), to = Va.byteLength;
                else
                  throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                const ro = to >> 2, no = to - ro * 4, eo = new Uint32Array(Va.buffer, 0, ro);
                let ao = 0, io = 0, xs = this.h1, Ts = this.h2;
                const qs = 3432918353, Fs = 461845907, Do = qs & na, ys = Fs & na;
                for (let Io = 0; Io < ro; Io++)
                  Io & 1 ? (ao = eo[Io], ao = ao * qs & ra | ao * Do & na, ao = ao << 15 | ao >>> 17, ao = ao * Fs & ra | ao * ys & na, xs ^= ao, xs = xs << 13 | xs >>> 19, xs = xs * 5 + 3864292196) : (io = eo[Io], io = io * qs & ra | io * Do & na, io = io << 15 | io >>> 17, io = io * Fs & ra | io * ys & na, Ts ^= io, Ts = Ts << 13 | Ts >>> 19, Ts = Ts * 5 + 3864292196);
                switch (ao = 0, no) {
                  case 3:
                    ao ^= Va[ro * 4 + 2] << 16;
                  case 2:
                    ao ^= Va[ro * 4 + 1] << 8;
                  case 1:
                    ao ^= Va[ro * 4], ao = ao * qs & ra | ao * Do & na, ao = ao << 15 | ao >>> 17, ao = ao * Fs & ra | ao * ys & na, ro & 1 ? xs ^= ao : Ts ^= ao;
                }
                this.h1 = xs, this.h2 = Ts;
              }
              hexdigest() {
                let La = this.h1, Va = this.h2;
                La ^= Va >>> 1, La = La * 3981806797 & ra | La * 36045 & na, Va = Va * 4283543511 & ra | ((Va << 16 | La >>> 16) * 2950163797 & ra) >>> 16, La ^= Va >>> 1, La = La * 444984403 & ra | La * 60499 & na, Va = Va * 3301882366 & ra | ((Va << 16 | La >>> 16) * 3120437893 & ra) >>> 16, La ^= Va >>> 1;
                const to = (La >>> 0).toString(16), ro = (Va >>> 0).toString(16);
                return to.padStart(8, "0") + ro.padStart(8, "0");
              }
            }
            e.MurmurHash3_64 = ia;
          },
          /* 11 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.FontLoader = e.FontFaceObject = void 0;
            var Qi = Zi(1);
            class ea {
              constructor({
                docId: fa,
                onUnsupportedFeature: La,
                ownerDocument: Va = globalThis.document,
                styleElement: to = null
              }) {
                this.constructor === ea && (0, Qi.unreachable)("Cannot initialize BaseFontLoader."), this.docId = fa, this._onUnsupportedFeature = La, this._document = Va, this.nativeFontFaces = [], this.styleElement = null;
              }
              addNativeFontFace(fa) {
                this.nativeFontFaces.push(fa), this._document.fonts.add(fa);
              }
              insertRule(fa) {
                let La = this.styleElement;
                La || (La = this.styleElement = this._document.createElement("style"), La.id = `PDFJS_FONT_STYLE_TAG_${this.docId}`, this._document.documentElement.getElementsByTagName("head")[0].append(La));
                const Va = La.sheet;
                Va.insertRule(fa, Va.cssRules.length);
              }
              clear() {
                for (const fa of this.nativeFontFaces)
                  this._document.fonts.delete(fa);
                this.nativeFontFaces.length = 0, this.styleElement && (this.styleElement.remove(), this.styleElement = null);
              }
              async bind(fa) {
                if (fa.attached || fa.missingFile)
                  return;
                if (fa.attached = !0, this.isFontLoadingAPISupported) {
                  const Va = fa.createNativeFontFace();
                  if (Va) {
                    this.addNativeFontFace(Va);
                    try {
                      await Va.loaded;
                    } catch (to) {
                      throw this._onUnsupportedFeature({
                        featureId: Qi.UNSUPPORTED_FEATURES.errorFontLoadNative
                      }), (0, Qi.warn)(`Failed to load font '${Va.family}': '${to}'.`), fa.disableFontFace = !0, to;
                    }
                  }
                  return;
                }
                const La = fa.createFontFaceRule();
                if (La) {
                  if (this.insertRule(La), this.isSyncFontLoadingSupported)
                    return;
                  await new Promise((Va) => {
                    const to = this._queueLoadingCallback(Va);
                    this._prepareFontLoadEvent([La], [fa], to);
                  });
                }
              }
              _queueLoadingCallback(fa) {
                (0, Qi.unreachable)("Abstract method `_queueLoadingCallback`.");
              }
              get isFontLoadingAPISupported() {
                const fa = !!this._document?.fonts;
                return (0, Qi.shadow)(this, "isFontLoadingAPISupported", fa);
              }
              get isSyncFontLoadingSupported() {
                (0, Qi.unreachable)("Abstract method `isSyncFontLoadingSupported`.");
              }
              get _loadTestFont() {
                (0, Qi.unreachable)("Abstract method `_loadTestFont`.");
              }
              _prepareFontLoadEvent(fa, La, Va) {
                (0, Qi.unreachable)("Abstract method `_prepareFontLoadEvent`.");
              }
            }
            let ra;
            e.FontLoader = ra, e.FontLoader = ra = class extends ea {
              constructor(fa) {
                super(fa), this.loadingContext = {
                  requests: [],
                  nextRequestId: 0
                }, this.loadTestFontId = 0;
              }
              get isSyncFontLoadingSupported() {
                let fa = !1;
                return (typeof navigator > "u" || /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent)?.[1] >= 14) && (fa = !0), (0, Qi.shadow)(this, "isSyncFontLoadingSupported", fa);
              }
              _queueLoadingCallback(fa) {
                function La() {
                  for ((0, Qi.assert)(!to.done, "completeRequest() cannot be called twice."), to.done = !0; Va.requests.length > 0 && Va.requests[0].done; ) {
                    const ro = Va.requests.shift();
                    setTimeout(ro.callback, 0);
                  }
                }
                const Va = this.loadingContext, to = {
                  id: `pdfjs-font-loading-${Va.nextRequestId++}`,
                  done: !1,
                  complete: La,
                  callback: fa
                };
                return Va.requests.push(to), to;
              }
              get _loadTestFont() {
                const fa = function() {
                  return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                };
                return (0, Qi.shadow)(this, "_loadTestFont", fa());
              }
              _prepareFontLoadEvent(fa, La, Va) {
                function to(El, wl) {
                  return El.charCodeAt(wl) << 24 | El.charCodeAt(wl + 1) << 16 | El.charCodeAt(wl + 2) << 8 | El.charCodeAt(wl + 3) & 255;
                }
                function ro(El, wl, jl, kl) {
                  const Fl = El.substring(0, wl), Ml = El.substring(wl + jl);
                  return Fl + kl + Ml;
                }
                let no, eo;
                const ao = this._document.createElement("canvas");
                ao.width = 1, ao.height = 1;
                const io = ao.getContext("2d");
                let xs = 0;
                function Ts(El, wl) {
                  if (xs++, xs > 30) {
                    (0, Qi.warn)("Load test font never loaded."), wl();
                    return;
                  }
                  if (io.font = "30px " + El, io.fillText(".", 0, 20), io.getImageData(0, 0, 1, 1).data[3] > 0) {
                    wl();
                    return;
                  }
                  setTimeout(Ts.bind(null, El, wl));
                }
                const qs = `lt${Date.now()}${this.loadTestFontId++}`;
                let Fs = this._loadTestFont;
                Fs = ro(Fs, 976, qs.length, qs);
                const ys = 16, Io = 1482184792;
                let so = to(Fs, ys);
                for (no = 0, eo = qs.length - 3; no < eo; no += 4)
                  so = so - Io + to(qs, no) | 0;
                no < qs.length && (so = so - Io + to(qs + "XXX", no) | 0), Fs = ro(Fs, ys, 4, (0, Qi.string32)(so));
                const os = `url(data:font/opentype;base64,${btoa(Fs)});`, Xs = `@font-face {font-family:"${qs}";src:${os}}`;
                this.insertRule(Xs);
                const gl = [];
                for (const El of La)
                  gl.push(El.loadedName);
                gl.push(qs);
                const Sl = this._document.createElement("div");
                Sl.style.visibility = "hidden", Sl.style.width = Sl.style.height = "10px", Sl.style.position = "absolute", Sl.style.top = Sl.style.left = "0px";
                for (const El of gl) {
                  const wl = this._document.createElement("span");
                  wl.textContent = "Hi", wl.style.fontFamily = El, Sl.append(wl);
                }
                this._document.body.append(Sl), Ts(qs, () => {
                  Sl.remove(), Va.complete();
                });
              }
            };
            class na {
              constructor(fa, {
                isEvalSupported: La = !0,
                disableFontFace: Va = !1,
                ignoreErrors: to = !1,
                onUnsupportedFeature: ro,
                fontRegistry: no = null
              }) {
                this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
                for (const eo in fa)
                  this[eo] = fa[eo];
                this.isEvalSupported = La !== !1, this.disableFontFace = Va === !0, this.ignoreErrors = to === !0, this._onUnsupportedFeature = ro, this.fontRegistry = no;
              }
              createNativeFontFace() {
                if (!this.data || this.disableFontFace)
                  return null;
                let fa;
                if (!this.cssFontInfo)
                  fa = new FontFace(this.loadedName, this.data, {});
                else {
                  const La = {
                    weight: this.cssFontInfo.fontWeight
                  };
                  this.cssFontInfo.italicAngle && (La.style = `oblique ${this.cssFontInfo.italicAngle}deg`), fa = new FontFace(this.cssFontInfo.fontFamily, this.data, La);
                }
                return this.fontRegistry && this.fontRegistry.registerFont(this), fa;
              }
              createFontFaceRule() {
                if (!this.data || this.disableFontFace)
                  return null;
                const fa = (0, Qi.bytesToString)(this.data), La = `url(data:${this.mimetype};base64,${btoa(fa)});`;
                let Va;
                if (!this.cssFontInfo)
                  Va = `@font-face {font-family:"${this.loadedName}";src:${La}}`;
                else {
                  let to = `font-weight: ${this.cssFontInfo.fontWeight};`;
                  this.cssFontInfo.italicAngle && (to += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`), Va = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${to}src:${La}}`;
                }
                return this.fontRegistry && this.fontRegistry.registerFont(this, La), Va;
              }
              getPathGenerator(fa, La) {
                if (this.compiledGlyphs[La] !== void 0)
                  return this.compiledGlyphs[La];
                let Va;
                try {
                  Va = fa.get(this.loadedName + "_path_" + La);
                } catch (to) {
                  if (!this.ignoreErrors)
                    throw to;
                  return this._onUnsupportedFeature({
                    featureId: Qi.UNSUPPORTED_FEATURES.errorFontGetPath
                  }), (0, Qi.warn)(`getPathGenerator - ignoring character: "${to}".`), this.compiledGlyphs[La] = function(ro, no) {
                  };
                }
                if (this.isEvalSupported && Qi.FeatureTest.isEvalSupported) {
                  const to = [];
                  for (const ro of Va) {
                    const no = ro.args !== void 0 ? ro.args.join(",") : "";
                    to.push("c.", ro.cmd, "(", no, `);
`);
                  }
                  return this.compiledGlyphs[La] = new Function("c", "size", to.join(""));
                }
                return this.compiledGlyphs[La] = function(to, ro) {
                  for (const no of Va)
                    no.cmd === "scale" && (no.args = [ro, -ro]), to[no.cmd].apply(to, no.args);
                };
              }
            }
            e.FontFaceObject = na;
          },
          /* 12 */
          /***/
          (Bi, e, Zi) => {
            var ql, uf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.CanvasGraphics = void 0;
            var Qi = Zi(8), ea = Zi(1), ra = Zi(13), na = Zi(14), ia = Zi(3);
            const fa = 16, La = 100, Va = 4096, to = 15, ro = 10, no = ia.isNodeJS && typeof Path2D > "u" ? -1 : 1e3, eo = 16;
            function ao(Il, xl) {
              if (Il._removeMirroring)
                throw new Error("Context is already forwarding operations.");
              Il.__originalSave = Il.save, Il.__originalRestore = Il.restore, Il.__originalRotate = Il.rotate, Il.__originalScale = Il.scale, Il.__originalTranslate = Il.translate, Il.__originalTransform = Il.transform, Il.__originalSetTransform = Il.setTransform, Il.__originalResetTransform = Il.resetTransform, Il.__originalClip = Il.clip, Il.__originalMoveTo = Il.moveTo, Il.__originalLineTo = Il.lineTo, Il.__originalBezierCurveTo = Il.bezierCurveTo, Il.__originalRect = Il.rect, Il.__originalClosePath = Il.closePath, Il.__originalBeginPath = Il.beginPath, Il._removeMirroring = () => {
                Il.save = Il.__originalSave, Il.restore = Il.__originalRestore, Il.rotate = Il.__originalRotate, Il.scale = Il.__originalScale, Il.translate = Il.__originalTranslate, Il.transform = Il.__originalTransform, Il.setTransform = Il.__originalSetTransform, Il.resetTransform = Il.__originalResetTransform, Il.clip = Il.__originalClip, Il.moveTo = Il.__originalMoveTo, Il.lineTo = Il.__originalLineTo, Il.bezierCurveTo = Il.__originalBezierCurveTo, Il.rect = Il.__originalRect, Il.closePath = Il.__originalClosePath, Il.beginPath = Il.__originalBeginPath, delete Il._removeMirroring;
              }, Il.save = function() {
                xl.save(), this.__originalSave();
              }, Il.restore = function() {
                xl.restore(), this.__originalRestore();
              }, Il.translate = function(Pl, Nl) {
                xl.translate(Pl, Nl), this.__originalTranslate(Pl, Nl);
              }, Il.scale = function(Pl, Nl) {
                xl.scale(Pl, Nl), this.__originalScale(Pl, Nl);
              }, Il.transform = function(Pl, Nl, Bl, Ol, To, Os) {
                xl.transform(Pl, Nl, Bl, Ol, To, Os), this.__originalTransform(Pl, Nl, Bl, Ol, To, Os);
              }, Il.setTransform = function(Pl, Nl, Bl, Ol, To, Os) {
                xl.setTransform(Pl, Nl, Bl, Ol, To, Os), this.__originalSetTransform(Pl, Nl, Bl, Ol, To, Os);
              }, Il.resetTransform = function() {
                xl.resetTransform(), this.__originalResetTransform();
              }, Il.rotate = function(Pl) {
                xl.rotate(Pl), this.__originalRotate(Pl);
              }, Il.clip = function(Pl) {
                xl.clip(Pl), this.__originalClip(Pl);
              }, Il.moveTo = function(bl, Pl) {
                xl.moveTo(bl, Pl), this.__originalMoveTo(bl, Pl);
              }, Il.lineTo = function(bl, Pl) {
                xl.lineTo(bl, Pl), this.__originalLineTo(bl, Pl);
              }, Il.bezierCurveTo = function(bl, Pl, Nl, Bl, Ol, To) {
                xl.bezierCurveTo(bl, Pl, Nl, Bl, Ol, To), this.__originalBezierCurveTo(bl, Pl, Nl, Bl, Ol, To);
              }, Il.rect = function(bl, Pl, Nl, Bl) {
                xl.rect(bl, Pl, Nl, Bl), this.__originalRect(bl, Pl, Nl, Bl);
              }, Il.closePath = function() {
                xl.closePath(), this.__originalClosePath();
              }, Il.beginPath = function() {
                xl.beginPath(), this.__originalBeginPath();
              };
            }
            class io {
              constructor(xl) {
                this.canvasFactory = xl, this.cache = /* @__PURE__ */ Object.create(null);
              }
              getCanvas(xl, bl, Pl) {
                let Nl;
                return this.cache[xl] !== void 0 ? (Nl = this.cache[xl], this.canvasFactory.reset(Nl, bl, Pl)) : (Nl = this.canvasFactory.create(bl, Pl), this.cache[xl] = Nl), Nl;
              }
              delete(xl) {
                delete this.cache[xl];
              }
              clear() {
                for (const xl in this.cache) {
                  const bl = this.cache[xl];
                  this.canvasFactory.destroy(bl), delete this.cache[xl];
                }
              }
            }
            function xs(Il, xl, bl, Pl, Nl, Bl, Ol, To, Os, $l) {
              const [_l, Al, Rl, Cl, ml, Tl] = (0, Qi.getCurrentTransform)(Il);
              if (Al === 0 && Rl === 0) {
                const zl = Ol * _l + ml, Ul = Math.round(zl), Yl = To * Cl + Tl, Jl = Math.round(Yl), Wl = (Ol + Os) * _l + ml, rc = Math.abs(Math.round(Wl) - Ul) || 1, uc = (To + $l) * Cl + Tl, ac = Math.abs(Math.round(uc) - Jl) || 1;
                return Il.setTransform(Math.sign(_l), 0, 0, Math.sign(Cl), Ul, Jl), Il.drawImage(xl, bl, Pl, Nl, Bl, 0, 0, rc, ac), Il.setTransform(_l, Al, Rl, Cl, ml, Tl), [rc, ac];
              }
              if (_l === 0 && Cl === 0) {
                const zl = To * Rl + ml, Ul = Math.round(zl), Yl = Ol * Al + Tl, Jl = Math.round(Yl), Wl = (To + $l) * Rl + ml, rc = Math.abs(Math.round(Wl) - Ul) || 1, uc = (Ol + Os) * Al + Tl, ac = Math.abs(Math.round(uc) - Jl) || 1;
                return Il.setTransform(0, Math.sign(Al), Math.sign(Rl), 0, Ul, Jl), Il.drawImage(xl, bl, Pl, Nl, Bl, 0, 0, ac, rc), Il.setTransform(_l, Al, Rl, Cl, ml, Tl), [ac, rc];
              }
              Il.drawImage(xl, bl, Pl, Nl, Bl, Ol, To, Os, $l);
              const Ll = Math.hypot(_l, Al), Vl = Math.hypot(Rl, Cl);
              return [Ll * Os, Vl * $l];
            }
            function Ts(Il) {
              const {
                width: xl,
                height: bl
              } = Il;
              if (xl > no || bl > no)
                return null;
              const Pl = 1e3, Nl = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]), Bl = xl + 1;
              let Ol = new Uint8Array(Bl * (bl + 1)), To, Os, $l;
              const _l = xl + 7 & -8;
              let Al = new Uint8Array(_l * bl), Rl = 0;
              for (const Vl of Il.data) {
                let zl = 128;
                for (; zl > 0; )
                  Al[Rl++] = Vl & zl ? 0 : 255, zl >>= 1;
              }
              let Cl = 0;
              for (Rl = 0, Al[Rl] !== 0 && (Ol[0] = 1, ++Cl), Os = 1; Os < xl; Os++)
                Al[Rl] !== Al[Rl + 1] && (Ol[Os] = Al[Rl] ? 2 : 1, ++Cl), Rl++;
              for (Al[Rl] !== 0 && (Ol[Os] = 2, ++Cl), To = 1; To < bl; To++) {
                Rl = To * _l, $l = To * Bl, Al[Rl - _l] !== Al[Rl] && (Ol[$l] = Al[Rl] ? 1 : 8, ++Cl);
                let Vl = (Al[Rl] ? 4 : 0) + (Al[Rl - _l] ? 8 : 0);
                for (Os = 1; Os < xl; Os++)
                  Vl = (Vl >> 2) + (Al[Rl + 1] ? 4 : 0) + (Al[Rl - _l + 1] ? 8 : 0), Nl[Vl] && (Ol[$l + Os] = Nl[Vl], ++Cl), Rl++;
                if (Al[Rl - _l] !== Al[Rl] && (Ol[$l + Os] = Al[Rl] ? 2 : 4, ++Cl), Cl > Pl)
                  return null;
              }
              for (Rl = _l * (bl - 1), $l = To * Bl, Al[Rl] !== 0 && (Ol[$l] = 8, ++Cl), Os = 1; Os < xl; Os++)
                Al[Rl] !== Al[Rl + 1] && (Ol[$l + Os] = Al[Rl] ? 4 : 8, ++Cl), Rl++;
              if (Al[Rl] !== 0 && (Ol[$l + Os] = 4, ++Cl), Cl > Pl)
                return null;
              const ml = new Int32Array([0, Bl, -1, 0, -Bl, 0, 0, 0, 1]), Tl = new Path2D();
              for (To = 0; Cl && To <= bl; To++) {
                let Vl = To * Bl;
                const zl = Vl + xl;
                for (; Vl < zl && !Ol[Vl]; )
                  Vl++;
                if (Vl === zl)
                  continue;
                Tl.moveTo(Vl % Bl, To);
                const Ul = Vl;
                let Yl = Ol[Vl];
                do {
                  const Jl = ml[Yl];
                  do
                    Vl += Jl;
                  while (!Ol[Vl]);
                  const Wl = Ol[Vl];
                  Wl !== 5 && Wl !== 10 ? (Yl = Wl, Ol[Vl] = 0) : (Yl = Wl & 51 * Yl >> 4, Ol[Vl] &= Yl >> 2 | Yl << 2), Tl.lineTo(Vl % Bl, Vl / Bl | 0), Ol[Vl] || --Cl;
                } while (Ul !== Vl);
                --To;
              }
              return Al = null, Ol = null, function(Vl) {
                Vl.save(), Vl.scale(1 / xl, -1 / bl), Vl.translate(0, -bl), Vl.fill(Tl), Vl.beginPath(), Vl.restore();
              };
            }
            class qs {
              constructor(xl, bl) {
                this.alphaIsShape = !1, this.fontSize = 0, this.fontSizeScale = 1, this.textMatrix = ea.IDENTITY_MATRIX, this.textMatrixScale = 1, this.fontMatrix = ea.FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRenderingMode = ea.TextRenderingMode.FILL, this.textRise = 0, this.fillColor = "#000000", this.strokeColor = "#000000", this.patternFill = !1, this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.activeSMask = null, this.transferMaps = null, this.startNewPathAndClipBox([0, 0, xl, bl]);
              }
              clone() {
                const xl = Object.create(this);
                return xl.clipBox = this.clipBox.slice(), xl;
              }
              setCurrentPoint(xl, bl) {
                this.x = xl, this.y = bl;
              }
              updatePathMinMax(xl, bl, Pl) {
                [bl, Pl] = ea.Util.applyTransform([bl, Pl], xl), this.minX = Math.min(this.minX, bl), this.minY = Math.min(this.minY, Pl), this.maxX = Math.max(this.maxX, bl), this.maxY = Math.max(this.maxY, Pl);
              }
              updateRectMinMax(xl, bl) {
                const Pl = ea.Util.applyTransform(bl, xl), Nl = ea.Util.applyTransform(bl.slice(2), xl);
                this.minX = Math.min(this.minX, Pl[0], Nl[0]), this.minY = Math.min(this.minY, Pl[1], Nl[1]), this.maxX = Math.max(this.maxX, Pl[0], Nl[0]), this.maxY = Math.max(this.maxY, Pl[1], Nl[1]);
              }
              updateScalingPathMinMax(xl, bl) {
                ea.Util.scaleMinMax(xl, bl), this.minX = Math.min(this.minX, bl[0]), this.maxX = Math.max(this.maxX, bl[1]), this.minY = Math.min(this.minY, bl[2]), this.maxY = Math.max(this.maxY, bl[3]);
              }
              updateCurvePathMinMax(xl, bl, Pl, Nl, Bl, Ol, To, Os, $l, _l) {
                const Al = ea.Util.bezierBoundingBox(bl, Pl, Nl, Bl, Ol, To, Os, $l);
                if (_l) {
                  _l[0] = Math.min(_l[0], Al[0], Al[2]), _l[1] = Math.max(_l[1], Al[0], Al[2]), _l[2] = Math.min(_l[2], Al[1], Al[3]), _l[3] = Math.max(_l[3], Al[1], Al[3]);
                  return;
                }
                this.updateRectMinMax(xl, Al);
              }
              getPathBoundingBox(xl = ra.PathType.FILL, bl = null) {
                const Pl = [this.minX, this.minY, this.maxX, this.maxY];
                if (xl === ra.PathType.STROKE) {
                  bl || (0, ea.unreachable)("Stroke bounding box must include transform.");
                  const Nl = ea.Util.singularValueDecompose2dScale(bl), Bl = Nl[0] * this.lineWidth / 2, Ol = Nl[1] * this.lineWidth / 2;
                  Pl[0] -= Bl, Pl[1] -= Ol, Pl[2] += Bl, Pl[3] += Ol;
                }
                return Pl;
              }
              updateClipFromPath() {
                const xl = ea.Util.intersect(this.clipBox, this.getPathBoundingBox());
                this.startNewPathAndClipBox(xl || [0, 0, 0, 0]);
              }
              isEmptyClip() {
                return this.minX === 1 / 0;
              }
              startNewPathAndClipBox(xl) {
                this.clipBox = xl, this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = 0, this.maxY = 0;
              }
              getClippedPathBoundingBox(xl = ra.PathType.FILL, bl = null) {
                return ea.Util.intersect(this.clipBox, this.getPathBoundingBox(xl, bl));
              }
            }
            function Fs(Il, xl, bl = null) {
              if (typeof ImageData < "u" && xl instanceof ImageData) {
                Il.putImageData(xl, 0, 0);
                return;
              }
              const Pl = xl.height, Nl = xl.width, Bl = Pl % eo, Ol = (Pl - Bl) / eo, To = Bl === 0 ? Ol : Ol + 1, Os = Il.createImageData(Nl, eo);
              let $l = 0, _l;
              const Al = xl.data, Rl = Os.data;
              let Cl, ml, Tl, Ll, Vl, zl, Ul, Yl;
              if (bl)
                switch (bl.length) {
                  case 1:
                    Vl = bl[0], zl = bl[0], Ul = bl[0], Yl = bl[0];
                    break;
                  case 4:
                    Vl = bl[0], zl = bl[1], Ul = bl[2], Yl = bl[3];
                    break;
                }
              if (xl.kind === ea.ImageKind.GRAYSCALE_1BPP) {
                const Jl = Al.byteLength, Wl = new Uint32Array(Rl.buffer, 0, Rl.byteLength >> 2), rc = Wl.length, uc = Nl + 7 >> 3;
                let ac = 4294967295, zu = ea.FeatureTest.isLittleEndian ? 4278190080 : 255;
                for (Yl && Yl[0] === 255 && Yl[255] === 0 && ([ac, zu] = [zu, ac]), Cl = 0; Cl < To; Cl++) {
                  for (Tl = Cl < Ol ? eo : Bl, _l = 0, ml = 0; ml < Tl; ml++) {
                    const Xu = Jl - $l;
                    let ed = 0;
                    const td = Xu > uc ? Nl : Xu * 8 - 7, od = td & -8;
                    let ld = 0, sd = 0;
                    for (; ed < od; ed += 8)
                      sd = Al[$l++], Wl[_l++] = sd & 128 ? ac : zu, Wl[_l++] = sd & 64 ? ac : zu, Wl[_l++] = sd & 32 ? ac : zu, Wl[_l++] = sd & 16 ? ac : zu, Wl[_l++] = sd & 8 ? ac : zu, Wl[_l++] = sd & 4 ? ac : zu, Wl[_l++] = sd & 2 ? ac : zu, Wl[_l++] = sd & 1 ? ac : zu;
                    for (; ed < td; ed++)
                      ld === 0 && (sd = Al[$l++], ld = 128), Wl[_l++] = sd & ld ? ac : zu, ld >>= 1;
                  }
                  for (; _l < rc; )
                    Wl[_l++] = 0;
                  Il.putImageData(Os, 0, Cl * eo);
                }
              } else if (xl.kind === ea.ImageKind.RGBA_32BPP) {
                const Jl = !!(Vl || zl || Ul);
                for (ml = 0, Ll = Nl * eo * 4, Cl = 0; Cl < Ol; Cl++) {
                  if (Rl.set(Al.subarray($l, $l + Ll)), $l += Ll, Jl)
                    for (let Wl = 0; Wl < Ll; Wl += 4)
                      Vl && (Rl[Wl + 0] = Vl[Rl[Wl + 0]]), zl && (Rl[Wl + 1] = zl[Rl[Wl + 1]]), Ul && (Rl[Wl + 2] = Ul[Rl[Wl + 2]]);
                  Il.putImageData(Os, 0, ml), ml += eo;
                }
                if (Cl < To) {
                  if (Ll = Nl * Bl * 4, Rl.set(Al.subarray($l, $l + Ll)), Jl)
                    for (let Wl = 0; Wl < Ll; Wl += 4)
                      Vl && (Rl[Wl + 0] = Vl[Rl[Wl + 0]]), zl && (Rl[Wl + 1] = zl[Rl[Wl + 1]]), Ul && (Rl[Wl + 2] = Ul[Rl[Wl + 2]]);
                  Il.putImageData(Os, 0, ml);
                }
              } else if (xl.kind === ea.ImageKind.RGB_24BPP) {
                const Jl = !!(Vl || zl || Ul);
                for (Tl = eo, Ll = Nl * Tl, Cl = 0; Cl < To; Cl++) {
                  for (Cl >= Ol && (Tl = Bl, Ll = Nl * Tl), _l = 0, ml = Ll; ml--; )
                    Rl[_l++] = Al[$l++], Rl[_l++] = Al[$l++], Rl[_l++] = Al[$l++], Rl[_l++] = 255;
                  if (Jl)
                    for (let Wl = 0; Wl < _l; Wl += 4)
                      Vl && (Rl[Wl + 0] = Vl[Rl[Wl + 0]]), zl && (Rl[Wl + 1] = zl[Rl[Wl + 1]]), Ul && (Rl[Wl + 2] = Ul[Rl[Wl + 2]]);
                  Il.putImageData(Os, 0, Cl * eo);
                }
              } else
                throw new Error(`bad image kind: ${xl.kind}`);
            }
            function Do(Il, xl) {
              if (xl.bitmap) {
                Il.drawImage(xl.bitmap, 0, 0);
                return;
              }
              const bl = xl.height, Pl = xl.width, Nl = bl % eo, Bl = (bl - Nl) / eo, Ol = Nl === 0 ? Bl : Bl + 1, To = Il.createImageData(Pl, eo);
              let Os = 0;
              const $l = xl.data, _l = To.data;
              for (let Al = 0; Al < Ol; Al++) {
                const Rl = Al < Bl ? eo : Nl;
                ({
                  srcPos: Os
                } = (0, na.applyMaskImageData)({
                  src: $l,
                  srcPos: Os,
                  dest: _l,
                  width: Pl,
                  height: Rl
                })), Il.putImageData(To, 0, Al * eo);
              }
            }
            function ys(Il, xl) {
              const bl = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font"];
              for (let Pl = 0, Nl = bl.length; Pl < Nl; Pl++) {
                const Bl = bl[Pl];
                Il[Bl] !== void 0 && (xl[Bl] = Il[Bl]);
              }
              Il.setLineDash !== void 0 && (xl.setLineDash(Il.getLineDash()), xl.lineDashOffset = Il.lineDashOffset);
            }
            function Io(Il, xl) {
              Il.strokeStyle = Il.fillStyle = xl || "#000000", Il.fillRule = "nonzero", Il.globalAlpha = 1, Il.lineWidth = 1, Il.lineCap = "butt", Il.lineJoin = "miter", Il.miterLimit = 10, Il.globalCompositeOperation = "source-over", Il.font = "10px sans-serif", Il.setLineDash !== void 0 && (Il.setLineDash([]), Il.lineDashOffset = 0);
            }
            function so(Il, xl, bl, Pl) {
              const Nl = Il.length;
              for (let Bl = 3; Bl < Nl; Bl += 4) {
                const Ol = Il[Bl];
                if (Ol === 0)
                  Il[Bl - 3] = xl, Il[Bl - 2] = bl, Il[Bl - 1] = Pl;
                else if (Ol < 255) {
                  const To = 255 - Ol;
                  Il[Bl - 3] = Il[Bl - 3] * Ol + xl * To >> 8, Il[Bl - 2] = Il[Bl - 2] * Ol + bl * To >> 8, Il[Bl - 1] = Il[Bl - 1] * Ol + Pl * To >> 8;
                }
              }
            }
            function os(Il, xl, bl) {
              const Pl = Il.length, Nl = 1 / 255;
              for (let Bl = 3; Bl < Pl; Bl += 4) {
                const Ol = bl ? bl[Il[Bl]] : Il[Bl];
                xl[Bl] = xl[Bl] * Ol * Nl | 0;
              }
            }
            function Xs(Il, xl, bl) {
              const Pl = Il.length;
              for (let Nl = 3; Nl < Pl; Nl += 4) {
                const Bl = Il[Nl - 3] * 77 + Il[Nl - 2] * 152 + Il[Nl - 1] * 28;
                xl[Nl] = bl ? xl[Nl] * bl[Bl >> 8] >> 8 : xl[Nl] * Bl >> 16;
              }
            }
            function gl(Il, xl, bl, Pl, Nl, Bl, Ol, To, Os, $l, _l) {
              const Al = !!Bl, Rl = Al ? Bl[0] : 0, Cl = Al ? Bl[1] : 0, ml = Al ? Bl[2] : 0;
              let Tl;
              Nl === "Luminosity" ? Tl = Xs : Tl = os;
              const Vl = Math.min(Pl, Math.ceil(1048576 / bl));
              for (let zl = 0; zl < Pl; zl += Vl) {
                const Ul = Math.min(Vl, Pl - zl), Yl = Il.getImageData(To - $l, zl + (Os - _l), bl, Ul), Jl = xl.getImageData(To, zl + Os, bl, Ul);
                Al && so(Yl.data, Rl, Cl, ml), Tl(Yl.data, Jl.data, Ol), xl.putImageData(Jl, To, zl + Os);
              }
            }
            function Sl(Il, xl, bl, Pl) {
              const Nl = Pl[0], Bl = Pl[1], Ol = Pl[2] - Nl, To = Pl[3] - Bl;
              Ol === 0 || To === 0 || (gl(xl.context, bl, Ol, To, xl.subtype, xl.backdrop, xl.transferMap, Nl, Bl, xl.offsetX, xl.offsetY), Il.save(), Il.globalAlpha = 1, Il.globalCompositeOperation = "source-over", Il.setTransform(1, 0, 0, 1, 0, 0), Il.drawImage(bl.canvas, 0, 0), Il.restore());
            }
            function El(Il, xl) {
              const bl = ea.Util.singularValueDecompose2dScale(Il);
              bl[0] = Math.fround(bl[0]), bl[1] = Math.fround(bl[1]);
              const Pl = Math.fround((globalThis.devicePixelRatio || 1) * Qi.PixelsPerInch.PDF_TO_CSS_UNITS);
              return xl !== void 0 ? xl : bl[0] <= Pl || bl[1] <= Pl;
            }
            const wl = ["butt", "round", "square"], jl = ["miter", "round", "bevel"], kl = {}, Fl = {}, Zl = class Zl {
              constructor(xl, bl, Pl, Nl, Bl, Ol, To, Os) {
                oc(this, ql);
                this.ctx = xl, this.current = new qs(this.ctx.canvas.width, this.ctx.canvas.height), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = bl, this.objs = Pl, this.canvasFactory = Nl, this.imageLayer = Bl, this.groupStack = [], this.processingType3 = null, this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.suspendedCtx = null, this.contentVisible = !0, this.markedContentStack = [], this.optionalContentConfig = Ol, this.cachedCanvases = new io(this.canvasFactory), this.cachedPatterns = /* @__PURE__ */ new Map(), this.annotationCanvasMap = To, this.viewportScale = 1, this.outputScaleX = 1, this.outputScaleY = 1, this.backgroundColor = Os?.background || null, this.foregroundColor = Os?.foreground || null, this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null, this._cachedBitmapsMap = /* @__PURE__ */ new Map();
              }
              getObject(xl, bl = null) {
                return typeof xl == "string" ? xl.startsWith("g_") ? this.commonObjs.get(xl) : this.objs.get(xl) : bl;
              }
              beginDrawing({
                transform: xl,
                viewport: bl,
                transparency: Pl = !1,
                background: Nl = null
              }) {
                const Bl = this.ctx.canvas.width, Ol = this.ctx.canvas.height, To = Nl || "#ffffff";
                if (this.ctx.save(), this.foregroundColor && this.backgroundColor) {
                  this.ctx.fillStyle = this.foregroundColor;
                  const Os = this.foregroundColor = this.ctx.fillStyle;
                  this.ctx.fillStyle = this.backgroundColor;
                  const $l = this.backgroundColor = this.ctx.fillStyle;
                  let _l = !0, Al = To;
                  if (this.ctx.fillStyle = To, Al = this.ctx.fillStyle, _l = typeof Al == "string" && /^#[0-9A-Fa-f]{6}$/.test(Al), Os === "#000000" && $l === "#ffffff" || Os === $l || !_l)
                    this.foregroundColor = this.backgroundColor = null;
                  else {
                    const [Rl, Cl, ml] = (0, Qi.getRGB)(Al), Tl = (Vl) => (Vl /= 255, Vl <= 0.03928 ? Vl / 12.92 : ((Vl + 0.055) / 1.055) ** 2.4), Ll = Math.round(0.2126 * Tl(Rl) + 0.7152 * Tl(Cl) + 0.0722 * Tl(ml));
                    this.selectColor = (Vl, zl, Ul) => {
                      const Yl = 0.2126 * Tl(Vl) + 0.7152 * Tl(zl) + 0.0722 * Tl(Ul);
                      return Math.round(Yl) === Ll ? $l : Os;
                    };
                  }
                }
                if (this.ctx.fillStyle = this.backgroundColor || To, this.ctx.fillRect(0, 0, Bl, Ol), this.ctx.restore(), Pl) {
                  const Os = this.cachedCanvases.getCanvas("transparent", Bl, Ol);
                  this.compositeCtx = this.ctx, this.transparentCanvas = Os.canvas, this.ctx = Os.context, this.ctx.save(), this.ctx.transform(...(0, Qi.getCurrentTransform)(this.compositeCtx));
                }
                this.ctx.save(), Io(this.ctx, this.foregroundColor), xl && (this.ctx.transform(...xl), this.outputScaleX = xl[0], this.outputScaleY = xl[0]), this.ctx.transform(...bl.transform), this.viewportScale = bl.scale, this.baseTransform = (0, Qi.getCurrentTransform)(this.ctx), this.imageLayer && ((0, Qi.deprecated)("The `imageLayer` functionality will be removed in the future."), this.imageLayer.beginLayout());
              }
              executeOperatorList(xl, bl, Pl, Nl) {
                const Bl = xl.argsArray, Ol = xl.fnArray;
                let To = bl || 0;
                const Os = Bl.length;
                if (Os === To)
                  return To;
                const $l = Os - To > ro && typeof Pl == "function", _l = $l ? Date.now() + to : 0;
                let Al = 0;
                const Rl = this.commonObjs, Cl = this.objs;
                let ml;
                for (; ; ) {
                  if (Nl !== void 0 && To === Nl.nextBreakPoint)
                    return Nl.breakIt(To, Pl), To;
                  if (ml = Ol[To], ml !== ea.OPS.dependency)
                    this[ml].apply(this, Bl[To]);
                  else
                    for (const Tl of Bl[To]) {
                      const Ll = Tl.startsWith("g_") ? Rl : Cl;
                      if (!Ll.has(Tl))
                        return Ll.get(Tl, Pl), To;
                    }
                  if (To++, To === Os)
                    return To;
                  if ($l && ++Al > ro) {
                    if (Date.now() > _l)
                      return Pl(), To;
                    Al = 0;
                  }
                }
              }
              endDrawing() {
                nc(this, ql, uf).call(this), this.cachedCanvases.clear(), this.cachedPatterns.clear();
                for (const xl of this._cachedBitmapsMap.values()) {
                  for (const bl of xl.values())
                    typeof HTMLCanvasElement < "u" && bl instanceof HTMLCanvasElement && (bl.width = bl.height = 0);
                  xl.clear();
                }
                this._cachedBitmapsMap.clear(), this.imageLayer && this.imageLayer.endLayout();
              }
              _scaleImage(xl, bl) {
                const Pl = xl.width, Nl = xl.height;
                let Bl = Math.max(Math.hypot(bl[0], bl[1]), 1), Ol = Math.max(Math.hypot(bl[2], bl[3]), 1), To = Pl, Os = Nl, $l = "prescale1", _l, Al;
                for (; Bl > 2 && To > 1 || Ol > 2 && Os > 1; ) {
                  let Rl = To, Cl = Os;
                  Bl > 2 && To > 1 && (Rl = Math.ceil(To / 2), Bl /= To / Rl), Ol > 2 && Os > 1 && (Cl = Math.ceil(Os / 2), Ol /= Os / Cl), _l = this.cachedCanvases.getCanvas($l, Rl, Cl), Al = _l.context, Al.clearRect(0, 0, Rl, Cl), Al.drawImage(xl, 0, 0, To, Os, 0, 0, Rl, Cl), xl = _l.canvas, To = Rl, Os = Cl, $l = $l === "prescale1" ? "prescale2" : "prescale1";
                }
                return {
                  img: xl,
                  paintWidth: To,
                  paintHeight: Os
                };
              }
              _createMaskCanvas(xl) {
                const bl = this.ctx, {
                  width: Pl,
                  height: Nl
                } = xl, Bl = this.current.fillColor, Ol = this.current.patternFill, To = (0, Qi.getCurrentTransform)(bl);
                let Os, $l, _l, Al;
                if ((xl.bitmap || xl.data) && xl.count > 1) {
                  const rc = xl.bitmap || xl.data.buffer, uc = To.slice(0, 4);
                  $l = JSON.stringify(Ol ? uc : [uc, Bl]), Os = this._cachedBitmapsMap.get(rc), Os || (Os = /* @__PURE__ */ new Map(), this._cachedBitmapsMap.set(rc, Os));
                  const ac = Os.get($l);
                  if (ac && !Ol) {
                    const zu = Math.round(Math.min(To[0], To[2]) + To[4]), Xu = Math.round(Math.min(To[1], To[3]) + To[5]);
                    return {
                      canvas: ac,
                      offsetX: zu,
                      offsetY: Xu
                    };
                  }
                  _l = ac;
                }
                _l || (Al = this.cachedCanvases.getCanvas("maskCanvas", Pl, Nl), Do(Al.context, xl));
                let Rl = ea.Util.transform(To, [1 / Pl, 0, 0, -1 / Nl, 0, 0]);
                Rl = ea.Util.transform(Rl, [1, 0, 0, 1, 0, -Nl]);
                const Cl = ea.Util.applyTransform([0, 0], Rl), ml = ea.Util.applyTransform([Pl, Nl], Rl), Tl = ea.Util.normalizeRect([Cl[0], Cl[1], ml[0], ml[1]]), Ll = Math.round(Tl[2] - Tl[0]) || 1, Vl = Math.round(Tl[3] - Tl[1]) || 1, zl = this.cachedCanvases.getCanvas("fillCanvas", Ll, Vl), Ul = zl.context, Yl = Math.min(Cl[0], ml[0]), Jl = Math.min(Cl[1], ml[1]);
                Ul.translate(-Yl, -Jl), Ul.transform(...Rl), _l || (_l = this._scaleImage(Al.canvas, (0, Qi.getCurrentTransformInverse)(Ul)), _l = _l.img, Os && Ol && Os.set($l, _l)), Ul.imageSmoothingEnabled = El((0, Qi.getCurrentTransform)(Ul), xl.interpolate), xs(Ul, _l, 0, 0, _l.width, _l.height, 0, 0, Pl, Nl), Ul.globalCompositeOperation = "source-in";
                const Wl = ea.Util.transform((0, Qi.getCurrentTransformInverse)(Ul), [1, 0, 0, 1, -Yl, -Jl]);
                return Ul.fillStyle = Ol ? Bl.getPattern(bl, this, Wl, ra.PathType.FILL) : Bl, Ul.fillRect(0, 0, Pl, Nl), Os && !Ol && (this.cachedCanvases.delete("fillCanvas"), Os.set($l, zl.canvas)), {
                  canvas: zl.canvas,
                  offsetX: Math.round(Yl),
                  offsetY: Math.round(Jl)
                };
              }
              setLineWidth(xl) {
                xl !== this.current.lineWidth && (this._cachedScaleForStroking = null), this.current.lineWidth = xl, this.ctx.lineWidth = xl;
              }
              setLineCap(xl) {
                this.ctx.lineCap = wl[xl];
              }
              setLineJoin(xl) {
                this.ctx.lineJoin = jl[xl];
              }
              setMiterLimit(xl) {
                this.ctx.miterLimit = xl;
              }
              setDash(xl, bl) {
                const Pl = this.ctx;
                Pl.setLineDash !== void 0 && (Pl.setLineDash(xl), Pl.lineDashOffset = bl);
              }
              setRenderingIntent(xl) {
              }
              setFlatness(xl) {
              }
              setGState(xl) {
                for (let bl = 0, Pl = xl.length; bl < Pl; bl++) {
                  const Nl = xl[bl], Bl = Nl[0], Ol = Nl[1];
                  switch (Bl) {
                    case "LW":
                      this.setLineWidth(Ol);
                      break;
                    case "LC":
                      this.setLineCap(Ol);
                      break;
                    case "LJ":
                      this.setLineJoin(Ol);
                      break;
                    case "ML":
                      this.setMiterLimit(Ol);
                      break;
                    case "D":
                      this.setDash(Ol[0], Ol[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(Ol);
                      break;
                    case "FL":
                      this.setFlatness(Ol);
                      break;
                    case "Font":
                      this.setFont(Ol[0], Ol[1]);
                      break;
                    case "CA":
                      this.current.strokeAlpha = Nl[1];
                      break;
                    case "ca":
                      this.current.fillAlpha = Nl[1], this.ctx.globalAlpha = Nl[1];
                      break;
                    case "BM":
                      this.ctx.globalCompositeOperation = Ol;
                      break;
                    case "SMask":
                      this.current.activeSMask = Ol ? this.tempSMask : null, this.tempSMask = null, this.checkSMaskState();
                      break;
                    case "TR":
                      this.current.transferMaps = Ol;
                  }
                }
              }
              get inSMaskMode() {
                return !!this.suspendedCtx;
              }
              checkSMaskState() {
                const xl = this.inSMaskMode;
                this.current.activeSMask && !xl ? this.beginSMaskMode() : !this.current.activeSMask && xl && this.endSMaskMode();
              }
              beginSMaskMode() {
                if (this.inSMaskMode)
                  throw new Error("beginSMaskMode called while already in smask mode");
                const xl = this.ctx.canvas.width, bl = this.ctx.canvas.height, Pl = "smaskGroupAt" + this.groupLevel, Nl = this.cachedCanvases.getCanvas(Pl, xl, bl);
                this.suspendedCtx = this.ctx, this.ctx = Nl.context;
                const Bl = this.ctx;
                Bl.setTransform(...(0, Qi.getCurrentTransform)(this.suspendedCtx)), ys(this.suspendedCtx, Bl), ao(Bl, this.suspendedCtx), this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
              }
              endSMaskMode() {
                if (!this.inSMaskMode)
                  throw new Error("endSMaskMode called while not in smask mode");
                this.ctx._removeMirroring(), ys(this.ctx, this.suspendedCtx), this.ctx = this.suspendedCtx, this.suspendedCtx = null;
              }
              compose(xl) {
                if (!this.current.activeSMask)
                  return;
                xl ? (xl[0] = Math.floor(xl[0]), xl[1] = Math.floor(xl[1]), xl[2] = Math.ceil(xl[2]), xl[3] = Math.ceil(xl[3])) : xl = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
                const bl = this.current.activeSMask, Pl = this.suspendedCtx;
                Sl(Pl, bl, this.ctx, xl), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore();
              }
              save() {
                this.inSMaskMode ? (ys(this.ctx, this.suspendedCtx), this.suspendedCtx.save()) : this.ctx.save();
                const xl = this.current;
                this.stateStack.push(xl), this.current = xl.clone();
              }
              restore() {
                this.stateStack.length === 0 && this.inSMaskMode && this.endSMaskMode(), this.stateStack.length !== 0 && (this.current = this.stateStack.pop(), this.inSMaskMode ? (this.suspendedCtx.restore(), ys(this.suspendedCtx, this.ctx)) : this.ctx.restore(), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null);
              }
              transform(xl, bl, Pl, Nl, Bl, Ol) {
                this.ctx.transform(xl, bl, Pl, Nl, Bl, Ol), this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null;
              }
              constructPath(xl, bl, Pl) {
                const Nl = this.ctx, Bl = this.current;
                let Ol = Bl.x, To = Bl.y, Os, $l;
                const _l = (0, Qi.getCurrentTransform)(Nl), Al = _l[0] === 0 && _l[3] === 0 || _l[1] === 0 && _l[2] === 0, Rl = Al ? Pl.slice(0) : null;
                for (let Cl = 0, ml = 0, Tl = xl.length; Cl < Tl; Cl++)
                  switch (xl[Cl] | 0) {
                    case ea.OPS.rectangle:
                      Ol = bl[ml++], To = bl[ml++];
                      const Ll = bl[ml++], Vl = bl[ml++], zl = Ol + Ll, Ul = To + Vl;
                      Nl.moveTo(Ol, To), Ll === 0 || Vl === 0 ? Nl.lineTo(zl, Ul) : (Nl.lineTo(zl, To), Nl.lineTo(zl, Ul), Nl.lineTo(Ol, Ul)), Al || Bl.updateRectMinMax(_l, [Ol, To, zl, Ul]), Nl.closePath();
                      break;
                    case ea.OPS.moveTo:
                      Ol = bl[ml++], To = bl[ml++], Nl.moveTo(Ol, To), Al || Bl.updatePathMinMax(_l, Ol, To);
                      break;
                    case ea.OPS.lineTo:
                      Ol = bl[ml++], To = bl[ml++], Nl.lineTo(Ol, To), Al || Bl.updatePathMinMax(_l, Ol, To);
                      break;
                    case ea.OPS.curveTo:
                      Os = Ol, $l = To, Ol = bl[ml + 4], To = bl[ml + 5], Nl.bezierCurveTo(bl[ml], bl[ml + 1], bl[ml + 2], bl[ml + 3], Ol, To), Bl.updateCurvePathMinMax(_l, Os, $l, bl[ml], bl[ml + 1], bl[ml + 2], bl[ml + 3], Ol, To, Rl), ml += 6;
                      break;
                    case ea.OPS.curveTo2:
                      Os = Ol, $l = To, Nl.bezierCurveTo(Ol, To, bl[ml], bl[ml + 1], bl[ml + 2], bl[ml + 3]), Bl.updateCurvePathMinMax(_l, Os, $l, Ol, To, bl[ml], bl[ml + 1], bl[ml + 2], bl[ml + 3], Rl), Ol = bl[ml + 2], To = bl[ml + 3], ml += 4;
                      break;
                    case ea.OPS.curveTo3:
                      Os = Ol, $l = To, Ol = bl[ml + 2], To = bl[ml + 3], Nl.bezierCurveTo(bl[ml], bl[ml + 1], Ol, To, Ol, To), Bl.updateCurvePathMinMax(_l, Os, $l, bl[ml], bl[ml + 1], Ol, To, Ol, To, Rl), ml += 4;
                      break;
                    case ea.OPS.closePath:
                      Nl.closePath();
                      break;
                  }
                Al && Bl.updateScalingPathMinMax(_l, Rl), Bl.setCurrentPoint(Ol, To);
              }
              closePath() {
                this.ctx.closePath();
              }
              stroke(xl) {
                xl = typeof xl < "u" ? xl : !0;
                const bl = this.ctx, Pl = this.current.strokeColor;
                bl.globalAlpha = this.current.strokeAlpha, this.contentVisible && (typeof Pl == "object" && Pl?.getPattern ? (bl.save(), bl.strokeStyle = Pl.getPattern(bl, this, (0, Qi.getCurrentTransformInverse)(bl), ra.PathType.STROKE), this.rescaleAndStroke(!1), bl.restore()) : this.rescaleAndStroke(!0)), xl && this.consumePath(this.current.getClippedPathBoundingBox()), bl.globalAlpha = this.current.fillAlpha;
              }
              closeStroke() {
                this.closePath(), this.stroke();
              }
              fill(xl) {
                xl = typeof xl < "u" ? xl : !0;
                const bl = this.ctx, Pl = this.current.fillColor, Nl = this.current.patternFill;
                let Bl = !1;
                Nl && (bl.save(), bl.fillStyle = Pl.getPattern(bl, this, (0, Qi.getCurrentTransformInverse)(bl), ra.PathType.FILL), Bl = !0);
                const Ol = this.current.getClippedPathBoundingBox();
                this.contentVisible && Ol !== null && (this.pendingEOFill ? (bl.fill("evenodd"), this.pendingEOFill = !1) : bl.fill()), Bl && bl.restore(), xl && this.consumePath(Ol);
              }
              eoFill() {
                this.pendingEOFill = !0, this.fill();
              }
              fillStroke() {
                this.fill(!1), this.stroke(!1), this.consumePath();
              }
              eoFillStroke() {
                this.pendingEOFill = !0, this.fillStroke();
              }
              closeFillStroke() {
                this.closePath(), this.fillStroke();
              }
              closeEOFillStroke() {
                this.pendingEOFill = !0, this.closePath(), this.fillStroke();
              }
              endPath() {
                this.consumePath();
              }
              clip() {
                this.pendingClip = kl;
              }
              eoClip() {
                this.pendingClip = Fl;
              }
              beginText() {
                this.current.textMatrix = ea.IDENTITY_MATRIX, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              }
              endText() {
                const xl = this.pendingTextPaths, bl = this.ctx;
                if (xl === void 0) {
                  bl.beginPath();
                  return;
                }
                bl.save(), bl.beginPath();
                for (const Pl of xl)
                  bl.setTransform(...Pl.transform), bl.translate(Pl.x, Pl.y), Pl.addToPath(bl, Pl.fontSize);
                bl.restore(), bl.clip(), bl.beginPath(), delete this.pendingTextPaths;
              }
              setCharSpacing(xl) {
                this.current.charSpacing = xl;
              }
              setWordSpacing(xl) {
                this.current.wordSpacing = xl;
              }
              setHScale(xl) {
                this.current.textHScale = xl / 100;
              }
              setLeading(xl) {
                this.current.leading = -xl;
              }
              setFont(xl, bl) {
                const Pl = this.commonObjs.get(xl), Nl = this.current;
                if (!Pl)
                  throw new Error(`Can't find font for ${xl}`);
                if (Nl.fontMatrix = Pl.fontMatrix || ea.FONT_IDENTITY_MATRIX, (Nl.fontMatrix[0] === 0 || Nl.fontMatrix[3] === 0) && (0, ea.warn)("Invalid font matrix for font " + xl), bl < 0 ? (bl = -bl, Nl.fontDirection = -1) : Nl.fontDirection = 1, this.current.font = Pl, this.current.fontSize = bl, Pl.isType3Font)
                  return;
                const Bl = Pl.loadedName || "sans-serif";
                let Ol = "normal";
                Pl.black ? Ol = "900" : Pl.bold && (Ol = "bold");
                const To = Pl.italic ? "italic" : "normal", Os = `"${Bl}", ${Pl.fallbackName}`;
                let $l = bl;
                bl < fa ? $l = fa : bl > La && ($l = La), this.current.fontSizeScale = bl / $l, this.ctx.font = `${To} ${Ol} ${$l}px ${Os}`;
              }
              setTextRenderingMode(xl) {
                this.current.textRenderingMode = xl;
              }
              setTextRise(xl) {
                this.current.textRise = xl;
              }
              moveText(xl, bl) {
                this.current.x = this.current.lineX += xl, this.current.y = this.current.lineY += bl;
              }
              setLeadingMoveText(xl, bl) {
                this.setLeading(-bl), this.moveText(xl, bl);
              }
              setTextMatrix(xl, bl, Pl, Nl, Bl, Ol) {
                this.current.textMatrix = [xl, bl, Pl, Nl, Bl, Ol], this.current.textMatrixScale = Math.hypot(xl, bl), this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              paintChar(xl, bl, Pl, Nl) {
                const Bl = this.ctx, Ol = this.current, To = Ol.font, Os = Ol.textRenderingMode, $l = Ol.fontSize / Ol.fontSizeScale, _l = Os & ea.TextRenderingMode.FILL_STROKE_MASK, Al = !!(Os & ea.TextRenderingMode.ADD_TO_PATH_FLAG), Rl = Ol.patternFill && !To.missingFile;
                let Cl;
                (To.disableFontFace || Al || Rl) && (Cl = To.getPathGenerator(this.commonObjs, xl)), To.disableFontFace || Rl ? (Bl.save(), Bl.translate(bl, Pl), Bl.beginPath(), Cl(Bl, $l), Nl && Bl.setTransform(...Nl), (_l === ea.TextRenderingMode.FILL || _l === ea.TextRenderingMode.FILL_STROKE) && Bl.fill(), (_l === ea.TextRenderingMode.STROKE || _l === ea.TextRenderingMode.FILL_STROKE) && Bl.stroke(), Bl.restore()) : ((_l === ea.TextRenderingMode.FILL || _l === ea.TextRenderingMode.FILL_STROKE) && Bl.fillText(xl, bl, Pl), (_l === ea.TextRenderingMode.STROKE || _l === ea.TextRenderingMode.FILL_STROKE) && Bl.strokeText(xl, bl, Pl)), Al && (this.pendingTextPaths || (this.pendingTextPaths = [])).push({
                  transform: (0, Qi.getCurrentTransform)(Bl),
                  x: bl,
                  y: Pl,
                  fontSize: $l,
                  addToPath: Cl
                });
              }
              get isFontSubpixelAAEnabled() {
                const {
                  context: xl
                } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                xl.scale(1.5, 1), xl.fillText("I", 0, 10);
                const bl = xl.getImageData(0, 0, 10, 10).data;
                let Pl = !1;
                for (let Nl = 3; Nl < bl.length; Nl += 4)
                  if (bl[Nl] > 0 && bl[Nl] < 255) {
                    Pl = !0;
                    break;
                  }
                return (0, ea.shadow)(this, "isFontSubpixelAAEnabled", Pl);
              }
              showText(xl) {
                const bl = this.current, Pl = bl.font;
                if (Pl.isType3Font)
                  return this.showType3Text(xl);
                const Nl = bl.fontSize;
                if (Nl === 0)
                  return;
                const Bl = this.ctx, Ol = bl.fontSizeScale, To = bl.charSpacing, Os = bl.wordSpacing, $l = bl.fontDirection, _l = bl.textHScale * $l, Al = xl.length, Rl = Pl.vertical, Cl = Rl ? 1 : -1, ml = Pl.defaultVMetrics, Tl = Nl * bl.fontMatrix[0], Ll = bl.textRenderingMode === ea.TextRenderingMode.FILL && !Pl.disableFontFace && !bl.patternFill;
                Bl.save(), Bl.transform(...bl.textMatrix), Bl.translate(bl.x, bl.y + bl.textRise), $l > 0 ? Bl.scale(_l, -1) : Bl.scale(_l, 1);
                let Vl;
                if (bl.patternFill) {
                  Bl.save();
                  const Wl = bl.fillColor.getPattern(Bl, this, (0, Qi.getCurrentTransformInverse)(Bl), ra.PathType.FILL);
                  Vl = (0, Qi.getCurrentTransform)(Bl), Bl.restore(), Bl.fillStyle = Wl;
                }
                let zl = bl.lineWidth;
                const Ul = bl.textMatrixScale;
                if (Ul === 0 || zl === 0) {
                  const Wl = bl.textRenderingMode & ea.TextRenderingMode.FILL_STROKE_MASK;
                  (Wl === ea.TextRenderingMode.STROKE || Wl === ea.TextRenderingMode.FILL_STROKE) && (zl = this.getSinglePixelWidth());
                } else
                  zl /= Ul;
                Ol !== 1 && (Bl.scale(Ol, Ol), zl /= Ol), Bl.lineWidth = zl;
                let Yl = 0, Jl;
                for (Jl = 0; Jl < Al; ++Jl) {
                  const Wl = xl[Jl];
                  if (typeof Wl == "number") {
                    Yl += Cl * Wl * Nl / 1e3;
                    continue;
                  }
                  let rc = !1;
                  const uc = (Wl.isSpace ? Os : 0) + To, ac = Wl.fontChar, zu = Wl.accent;
                  let Xu, ed, td = Wl.width;
                  if (Rl) {
                    const ld = Wl.vmetric || ml, sd = -(Wl.vmetric ? ld[1] : td * 0.5) * Tl, bd = ld[2] * Tl;
                    td = ld ? -ld[0] : td, Xu = sd / Ol, ed = (Yl + bd) / Ol;
                  } else
                    Xu = Yl / Ol, ed = 0;
                  if (Pl.remeasure && td > 0) {
                    const ld = Bl.measureText(ac).width * 1e3 / Nl * Ol;
                    if (td < ld && this.isFontSubpixelAAEnabled) {
                      const sd = td / ld;
                      rc = !0, Bl.save(), Bl.scale(sd, 1), Xu /= sd;
                    } else td !== ld && (Xu += (td - ld) / 2e3 * Nl / Ol);
                  }
                  if (this.contentVisible && (Wl.isInFont || Pl.missingFile)) {
                    if (Ll && !zu)
                      Bl.fillText(ac, Xu, ed);
                    else if (this.paintChar(ac, Xu, ed, Vl), zu) {
                      const ld = Xu + Nl * zu.offset.x / Ol, sd = ed - Nl * zu.offset.y / Ol;
                      this.paintChar(zu.fontChar, ld, sd, Vl);
                    }
                  }
                  let od;
                  Rl ? od = td * Tl - uc * $l : od = td * Tl + uc * $l, Yl += od, rc && Bl.restore();
                }
                Rl ? bl.y -= Yl : bl.x += Yl * _l, Bl.restore(), this.compose();
              }
              showType3Text(xl) {
                const bl = this.ctx, Pl = this.current, Nl = Pl.font, Bl = Pl.fontSize, Ol = Pl.fontDirection, To = Nl.vertical ? 1 : -1, Os = Pl.charSpacing, $l = Pl.wordSpacing, _l = Pl.textHScale * Ol, Al = Pl.fontMatrix || ea.FONT_IDENTITY_MATRIX, Rl = xl.length, Cl = Pl.textRenderingMode === ea.TextRenderingMode.INVISIBLE;
                let ml, Tl, Ll, Vl;
                if (!(Cl || Bl === 0)) {
                  for (this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null, bl.save(), bl.transform(...Pl.textMatrix), bl.translate(Pl.x, Pl.y), bl.scale(_l, Ol), ml = 0; ml < Rl; ++ml) {
                    if (Tl = xl[ml], typeof Tl == "number") {
                      Vl = To * Tl * Bl / 1e3, this.ctx.translate(Vl, 0), Pl.x += Vl * _l;
                      continue;
                    }
                    const zl = (Tl.isSpace ? $l : 0) + Os, Ul = Nl.charProcOperatorList[Tl.operatorListId];
                    if (!Ul) {
                      (0, ea.warn)(`Type3 character "${Tl.operatorListId}" is not available.`);
                      continue;
                    }
                    this.contentVisible && (this.processingType3 = Tl, this.save(), bl.scale(Bl, Bl), bl.transform(...Al), this.executeOperatorList(Ul), this.restore()), Ll = ea.Util.applyTransform([Tl.width, 0], Al)[0] * Bl + zl, bl.translate(Ll, 0), Pl.x += Ll * _l;
                  }
                  bl.restore(), this.processingType3 = null;
                }
              }
              setCharWidth(xl, bl) {
              }
              setCharWidthAndBounds(xl, bl, Pl, Nl, Bl, Ol) {
                this.ctx.rect(Pl, Nl, Bl - Pl, Ol - Nl), this.ctx.clip(), this.endPath();
              }
              getColorN_Pattern(xl) {
                let bl;
                if (xl[0] === "TilingPattern") {
                  const Pl = xl[1], Nl = this.baseTransform || (0, Qi.getCurrentTransform)(this.ctx), Bl = {
                    createCanvasGraphics: (Ol) => new Zl(Ol, this.commonObjs, this.objs, this.canvasFactory)
                  };
                  bl = new ra.TilingPattern(xl, Pl, this.ctx, Bl, Nl);
                } else
                  bl = this._getPattern(xl[1], xl[2]);
                return bl;
              }
              setStrokeColorN() {
                this.current.strokeColor = this.getColorN_Pattern(arguments);
              }
              setFillColorN() {
                this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
              }
              setStrokeRGBColor(xl, bl, Pl) {
                const Nl = this.selectColor?.(xl, bl, Pl) || ea.Util.makeHexColor(xl, bl, Pl);
                this.ctx.strokeStyle = Nl, this.current.strokeColor = Nl;
              }
              setFillRGBColor(xl, bl, Pl) {
                const Nl = this.selectColor?.(xl, bl, Pl) || ea.Util.makeHexColor(xl, bl, Pl);
                this.ctx.fillStyle = Nl, this.current.fillColor = Nl, this.current.patternFill = !1;
              }
              _getPattern(xl, bl = null) {
                let Pl;
                return this.cachedPatterns.has(xl) ? Pl = this.cachedPatterns.get(xl) : (Pl = (0, ra.getShadingPattern)(this.objs.get(xl)), this.cachedPatterns.set(xl, Pl)), bl && (Pl.matrix = bl), Pl;
              }
              shadingFill(xl) {
                if (!this.contentVisible)
                  return;
                const bl = this.ctx;
                this.save();
                const Pl = this._getPattern(xl);
                bl.fillStyle = Pl.getPattern(bl, this, (0, Qi.getCurrentTransformInverse)(bl), ra.PathType.SHADING);
                const Nl = (0, Qi.getCurrentTransformInverse)(bl);
                if (Nl) {
                  const Bl = bl.canvas, Ol = Bl.width, To = Bl.height, Os = ea.Util.applyTransform([0, 0], Nl), $l = ea.Util.applyTransform([0, To], Nl), _l = ea.Util.applyTransform([Ol, 0], Nl), Al = ea.Util.applyTransform([Ol, To], Nl), Rl = Math.min(Os[0], $l[0], _l[0], Al[0]), Cl = Math.min(Os[1], $l[1], _l[1], Al[1]), ml = Math.max(Os[0], $l[0], _l[0], Al[0]), Tl = Math.max(Os[1], $l[1], _l[1], Al[1]);
                  this.ctx.fillRect(Rl, Cl, ml - Rl, Tl - Cl);
                } else
                  this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
                this.compose(this.current.getClippedPathBoundingBox()), this.restore();
              }
              beginInlineImage() {
                (0, ea.unreachable)("Should not call beginInlineImage");
              }
              beginImageData() {
                (0, ea.unreachable)("Should not call beginImageData");
              }
              paintFormXObjectBegin(xl, bl) {
                if (this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), Array.isArray(xl) && xl.length === 6 && this.transform(...xl), this.baseTransform = (0, Qi.getCurrentTransform)(this.ctx), bl)) {
                  const Pl = bl[2] - bl[0], Nl = bl[3] - bl[1];
                  this.ctx.rect(bl[0], bl[1], Pl, Nl), this.current.updateRectMinMax((0, Qi.getCurrentTransform)(this.ctx), bl), this.clip(), this.endPath();
                }
              }
              paintFormXObjectEnd() {
                this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
              }
              beginGroup(xl) {
                if (!this.contentVisible)
                  return;
                this.save(), this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
                const bl = this.ctx;
                xl.isolated || (0, ea.info)("TODO: Support non-isolated groups."), xl.knockout && (0, ea.warn)("Knockout groups not supported.");
                const Pl = (0, Qi.getCurrentTransform)(bl);
                if (xl.matrix && bl.transform(...xl.matrix), !xl.bbox)
                  throw new Error("Bounding box is required.");
                let Nl = ea.Util.getAxialAlignedBoundingBox(xl.bbox, (0, Qi.getCurrentTransform)(bl));
                const Bl = [0, 0, bl.canvas.width, bl.canvas.height];
                Nl = ea.Util.intersect(Nl, Bl) || [0, 0, 0, 0];
                const Ol = Math.floor(Nl[0]), To = Math.floor(Nl[1]);
                let Os = Math.max(Math.ceil(Nl[2]) - Ol, 1), $l = Math.max(Math.ceil(Nl[3]) - To, 1), _l = 1, Al = 1;
                Os > Va && (_l = Os / Va, Os = Va), $l > Va && (Al = $l / Va, $l = Va), this.current.startNewPathAndClipBox([0, 0, Os, $l]);
                let Rl = "groupAt" + this.groupLevel;
                xl.smask && (Rl += "_smask_" + this.smaskCounter++ % 2);
                const Cl = this.cachedCanvases.getCanvas(Rl, Os, $l), ml = Cl.context;
                ml.scale(1 / _l, 1 / Al), ml.translate(-Ol, -To), ml.transform(...Pl), xl.smask ? this.smaskStack.push({
                  canvas: Cl.canvas,
                  context: ml,
                  offsetX: Ol,
                  offsetY: To,
                  scaleX: _l,
                  scaleY: Al,
                  subtype: xl.smask.subtype,
                  backdrop: xl.smask.backdrop,
                  transferMap: xl.smask.transferMap || null,
                  startTransformInverse: null
                }) : (bl.setTransform(1, 0, 0, 1, 0, 0), bl.translate(Ol, To), bl.scale(_l, Al), bl.save()), ys(bl, ml), this.ctx = ml, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(bl), this.groupLevel++;
              }
              endGroup(xl) {
                if (!this.contentVisible)
                  return;
                this.groupLevel--;
                const bl = this.ctx, Pl = this.groupStack.pop();
                if (this.ctx = Pl, this.ctx.imageSmoothingEnabled = !1, xl.smask)
                  this.tempSMask = this.smaskStack.pop(), this.restore();
                else {
                  this.ctx.restore();
                  const Nl = (0, Qi.getCurrentTransform)(this.ctx);
                  this.restore(), this.ctx.save(), this.ctx.setTransform(...Nl);
                  const Bl = ea.Util.getAxialAlignedBoundingBox([0, 0, bl.canvas.width, bl.canvas.height], Nl);
                  this.ctx.drawImage(bl.canvas, 0, 0), this.ctx.restore(), this.compose(Bl);
                }
              }
              beginAnnotation(xl, bl, Pl, Nl, Bl) {
                if (nc(this, ql, uf).call(this), Io(this.ctx, this.foregroundColor), this.ctx.save(), this.save(), this.baseTransform && this.ctx.setTransform(...this.baseTransform), Array.isArray(bl) && bl.length === 4) {
                  const Ol = bl[2] - bl[0], To = bl[3] - bl[1];
                  if (Bl && this.annotationCanvasMap) {
                    Pl = Pl.slice(), Pl[4] -= bl[0], Pl[5] -= bl[1], bl = bl.slice(), bl[0] = bl[1] = 0, bl[2] = Ol, bl[3] = To;
                    const [Os, $l] = ea.Util.singularValueDecompose2dScale((0, Qi.getCurrentTransform)(this.ctx)), {
                      viewportScale: _l
                    } = this, Al = Math.ceil(Ol * this.outputScaleX * _l), Rl = Math.ceil(To * this.outputScaleY * _l);
                    this.annotationCanvas = this.canvasFactory.create(Al, Rl);
                    const {
                      canvas: Cl,
                      context: ml
                    } = this.annotationCanvas;
                    this.annotationCanvasMap.set(xl, Cl), this.annotationCanvas.savedCtx = this.ctx, this.ctx = ml, this.ctx.setTransform(Os, 0, 0, -$l, 0, To * $l), Io(this.ctx, this.foregroundColor);
                  } else
                    Io(this.ctx, this.foregroundColor), this.ctx.rect(bl[0], bl[1], Ol, To), this.ctx.clip(), this.endPath();
                }
                this.current = new qs(this.ctx.canvas.width, this.ctx.canvas.height), this.transform(...Pl), this.transform(...Nl);
              }
              endAnnotation() {
                this.annotationCanvas && (this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
              }
              paintImageMaskXObject(xl) {
                if (!this.contentVisible)
                  return;
                const bl = xl.count;
                xl = this.getObject(xl.data, xl), xl.count = bl;
                const Pl = this.ctx, Nl = this.processingType3;
                if (Nl && (Nl.compiled === void 0 && (Nl.compiled = Ts(xl)), Nl.compiled)) {
                  Nl.compiled(Pl);
                  return;
                }
                const Bl = this._createMaskCanvas(xl), Ol = Bl.canvas;
                Pl.save(), Pl.setTransform(1, 0, 0, 1, 0, 0), Pl.drawImage(Ol, Bl.offsetX, Bl.offsetY), Pl.restore(), this.compose();
              }
              paintImageMaskXObjectRepeat(xl, bl, Pl = 0, Nl = 0, Bl, Ol) {
                if (!this.contentVisible)
                  return;
                xl = this.getObject(xl.data, xl);
                const To = this.ctx;
                To.save();
                const Os = (0, Qi.getCurrentTransform)(To);
                To.transform(bl, Pl, Nl, Bl, 0, 0);
                const $l = this._createMaskCanvas(xl);
                To.setTransform(1, 0, 0, 1, 0, 0);
                for (let _l = 0, Al = Ol.length; _l < Al; _l += 2) {
                  const Rl = ea.Util.transform(Os, [bl, Pl, Nl, Bl, Ol[_l], Ol[_l + 1]]), [Cl, ml] = ea.Util.applyTransform([0, 0], Rl);
                  To.drawImage($l.canvas, Cl, ml);
                }
                To.restore(), this.compose();
              }
              paintImageMaskXObjectGroup(xl) {
                if (!this.contentVisible)
                  return;
                const bl = this.ctx, Pl = this.current.fillColor, Nl = this.current.patternFill;
                for (const Bl of xl) {
                  const {
                    data: Ol,
                    width: To,
                    height: Os,
                    transform: $l
                  } = Bl, _l = this.cachedCanvases.getCanvas("maskCanvas", To, Os), Al = _l.context;
                  Al.save();
                  const Rl = this.getObject(Ol, Bl);
                  Do(Al, Rl), Al.globalCompositeOperation = "source-in", Al.fillStyle = Nl ? Pl.getPattern(Al, this, (0, Qi.getCurrentTransformInverse)(bl), ra.PathType.FILL) : Pl, Al.fillRect(0, 0, To, Os), Al.restore(), bl.save(), bl.transform(...$l), bl.scale(1, -1), xs(bl, _l.canvas, 0, 0, To, Os, 0, -1, 1, 1), bl.restore();
                }
                this.compose();
              }
              paintImageXObject(xl) {
                if (!this.contentVisible)
                  return;
                const bl = this.getObject(xl);
                if (!bl) {
                  (0, ea.warn)("Dependent image isn't ready yet");
                  return;
                }
                this.paintInlineImageXObject(bl);
              }
              paintImageXObjectRepeat(xl, bl, Pl, Nl) {
                if (!this.contentVisible)
                  return;
                const Bl = this.getObject(xl);
                if (!Bl) {
                  (0, ea.warn)("Dependent image isn't ready yet");
                  return;
                }
                const Ol = Bl.width, To = Bl.height, Os = [];
                for (let $l = 0, _l = Nl.length; $l < _l; $l += 2)
                  Os.push({
                    transform: [bl, 0, 0, Pl, Nl[$l], Nl[$l + 1]],
                    x: 0,
                    y: 0,
                    w: Ol,
                    h: To
                  });
                this.paintInlineImageXObjectGroup(Bl, Os);
              }
              paintInlineImageXObject(xl) {
                if (!this.contentVisible)
                  return;
                const bl = xl.width, Pl = xl.height, Nl = this.ctx;
                this.save(), Nl.scale(1 / bl, -1 / Pl);
                let Bl;
                if (typeof HTMLElement == "function" && xl instanceof HTMLElement || !xl.data)
                  Bl = xl;
                else {
                  const $l = this.cachedCanvases.getCanvas("inlineImage", bl, Pl), _l = $l.context;
                  Fs(_l, xl, this.current.transferMaps), Bl = $l.canvas;
                }
                const Ol = this._scaleImage(Bl, (0, Qi.getCurrentTransformInverse)(Nl));
                Nl.imageSmoothingEnabled = El((0, Qi.getCurrentTransform)(Nl), xl.interpolate);
                const [To, Os] = xs(Nl, Ol.img, 0, 0, Ol.paintWidth, Ol.paintHeight, 0, -Pl, bl, Pl);
                if (this.imageLayer) {
                  const [$l, _l] = ea.Util.applyTransform([0, -Pl], (0, Qi.getCurrentTransform)(this.ctx));
                  this.imageLayer.appendImage({
                    imgData: xl,
                    left: $l,
                    top: _l,
                    width: To,
                    height: Os
                  });
                }
                this.compose(), this.restore();
              }
              paintInlineImageXObjectGroup(xl, bl) {
                if (!this.contentVisible)
                  return;
                const Pl = this.ctx, Nl = xl.width, Bl = xl.height, Ol = this.cachedCanvases.getCanvas("inlineImage", Nl, Bl), To = Ol.context;
                Fs(To, xl, this.current.transferMaps);
                for (const Os of bl) {
                  if (Pl.save(), Pl.transform(...Os.transform), Pl.scale(1, -1), xs(Pl, Ol.canvas, Os.x, Os.y, Os.w, Os.h, 0, -1, 1, 1), this.imageLayer) {
                    const [$l, _l] = ea.Util.applyTransform([Os.x, Os.y], (0, Qi.getCurrentTransform)(this.ctx));
                    this.imageLayer.appendImage({
                      imgData: xl,
                      left: $l,
                      top: _l,
                      width: Nl,
                      height: Bl
                    });
                  }
                  Pl.restore();
                }
                this.compose();
              }
              paintSolidColorImageMask() {
                this.contentVisible && (this.ctx.fillRect(0, 0, 1, 1), this.compose());
              }
              markPoint(xl) {
              }
              markPointProps(xl, bl) {
              }
              beginMarkedContent(xl) {
                this.markedContentStack.push({
                  visible: !0
                });
              }
              beginMarkedContentProps(xl, bl) {
                xl === "OC" ? this.markedContentStack.push({
                  visible: this.optionalContentConfig.isVisible(bl)
                }) : this.markedContentStack.push({
                  visible: !0
                }), this.contentVisible = this.isContentVisible();
              }
              endMarkedContent() {
                this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
              }
              beginCompat() {
              }
              endCompat() {
              }
              consumePath(xl) {
                const bl = this.current.isEmptyClip();
                this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(xl);
                const Pl = this.ctx;
                this.pendingClip && (bl || (this.pendingClip === Fl ? Pl.clip("evenodd") : Pl.clip()), this.pendingClip = null), this.current.startNewPathAndClipBox(this.current.clipBox), Pl.beginPath();
              }
              getSinglePixelWidth() {
                if (!this._cachedGetSinglePixelWidth) {
                  const xl = (0, Qi.getCurrentTransform)(this.ctx);
                  if (xl[1] === 0 && xl[2] === 0)
                    this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(xl[0]), Math.abs(xl[3]));
                  else {
                    const bl = Math.abs(xl[0] * xl[3] - xl[2] * xl[1]), Pl = Math.hypot(xl[0], xl[2]), Nl = Math.hypot(xl[1], xl[3]);
                    this._cachedGetSinglePixelWidth = Math.max(Pl, Nl) / bl;
                  }
                }
                return this._cachedGetSinglePixelWidth;
              }
              getScaleForStroking() {
                if (!this._cachedScaleForStroking) {
                  const {
                    lineWidth: xl
                  } = this.current, bl = (0, Qi.getCurrentTransform)(this.ctx);
                  let Pl, Nl;
                  if (bl[1] === 0 && bl[2] === 0) {
                    const Bl = Math.abs(bl[0]), Ol = Math.abs(bl[3]);
                    if (xl === 0)
                      Pl = 1 / Bl, Nl = 1 / Ol;
                    else {
                      const To = Bl * xl, Os = Ol * xl;
                      Pl = To < 1 ? 1 / To : 1, Nl = Os < 1 ? 1 / Os : 1;
                    }
                  } else {
                    const Bl = Math.abs(bl[0] * bl[3] - bl[2] * bl[1]), Ol = Math.hypot(bl[0], bl[1]), To = Math.hypot(bl[2], bl[3]);
                    if (xl === 0)
                      Pl = To / Bl, Nl = Ol / Bl;
                    else {
                      const Os = xl * Bl;
                      Pl = To > Os ? To / Os : 1, Nl = Ol > Os ? Ol / Os : 1;
                    }
                  }
                  this._cachedScaleForStroking = [Pl, Nl];
                }
                return this._cachedScaleForStroking;
              }
              rescaleAndStroke(xl) {
                const {
                  ctx: bl
                } = this, {
                  lineWidth: Pl
                } = this.current, [Nl, Bl] = this.getScaleForStroking();
                if (bl.lineWidth = Pl || 1, Nl === 1 && Bl === 1) {
                  bl.stroke();
                  return;
                }
                let Ol, To, Os;
                xl && (Ol = (0, Qi.getCurrentTransform)(bl), To = bl.getLineDash().slice(), Os = bl.lineDashOffset), bl.scale(Nl, Bl);
                const $l = Math.max(Nl, Bl);
                bl.setLineDash(bl.getLineDash().map((_l) => _l / $l)), bl.lineDashOffset /= $l, bl.stroke(), xl && (bl.setTransform(...Ol), bl.setLineDash(To), bl.lineDashOffset = Os);
              }
              isContentVisible() {
                for (let xl = this.markedContentStack.length - 1; xl >= 0; xl--)
                  if (!this.markedContentStack[xl].visible)
                    return !1;
                return !0;
              }
            };
            ql = new WeakSet(), uf = function() {
              for (; this.stateStack.length || this.inSMaskMode; )
                this.restore();
              this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
            };
            let Ml = Zl;
            e.CanvasGraphics = Ml;
            for (const Il in ea.OPS)
              Ml.prototype[Il] !== void 0 && (Ml.prototype[ea.OPS[Il]] = Ml.prototype[Il]);
          },
          /* 13 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.TilingPattern = e.PathType = void 0, e.getShadingPattern = eo;
            var Qi = Zi(1), ea = Zi(8), ra = Zi(3);
            const na = {
              FILL: "Fill",
              STROKE: "Stroke",
              SHADING: "Shading"
            };
            e.PathType = na;
            function ia(xs, Ts) {
              if (!Ts || ra.isNodeJS)
                return;
              const qs = Ts[2] - Ts[0], Fs = Ts[3] - Ts[1], Do = new Path2D();
              Do.rect(Ts[0], Ts[1], qs, Fs), xs.clip(Do);
            }
            class fa {
              constructor() {
                this.constructor === fa && (0, Qi.unreachable)("Cannot initialize BaseShadingPattern.");
              }
              getPattern() {
                (0, Qi.unreachable)("Abstract method `getPattern` called.");
              }
            }
            class La extends fa {
              constructor(Ts) {
                super(), this._type = Ts[1], this._bbox = Ts[2], this._colorStops = Ts[3], this._p0 = Ts[4], this._p1 = Ts[5], this._r0 = Ts[6], this._r1 = Ts[7], this.matrix = null;
              }
              _createGradient(Ts) {
                let qs;
                this._type === "axial" ? qs = Ts.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : this._type === "radial" && (qs = Ts.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
                for (const Fs of this._colorStops)
                  qs.addColorStop(Fs[0], Fs[1]);
                return qs;
              }
              getPattern(Ts, qs, Fs, Do) {
                let ys;
                if (Do === na.STROKE || Do === na.FILL) {
                  const Io = qs.current.getClippedPathBoundingBox(Do, (0, ea.getCurrentTransform)(Ts)) || [0, 0, 0, 0], so = Math.ceil(Io[2] - Io[0]) || 1, os = Math.ceil(Io[3] - Io[1]) || 1, Xs = qs.cachedCanvases.getCanvas("pattern", so, os, !0), gl = Xs.context;
                  gl.clearRect(0, 0, gl.canvas.width, gl.canvas.height), gl.beginPath(), gl.rect(0, 0, gl.canvas.width, gl.canvas.height), gl.translate(-Io[0], -Io[1]), Fs = Qi.Util.transform(Fs, [1, 0, 0, 1, Io[0], Io[1]]), gl.transform(...qs.baseTransform), this.matrix && gl.transform(...this.matrix), ia(gl, this._bbox), gl.fillStyle = this._createGradient(gl), gl.fill(), ys = Ts.createPattern(Xs.canvas, "no-repeat");
                  const Sl = new DOMMatrix(Fs);
                  try {
                    ys.setTransform(Sl);
                  } catch (El) {
                    (0, Qi.warn)(`RadialAxialShadingPattern.getPattern: "${El?.message}".`);
                  }
                } else
                  ia(Ts, this._bbox), ys = this._createGradient(Ts);
                return ys;
              }
            }
            function Va(xs, Ts, qs, Fs, Do, ys, Io, so) {
              const os = Ts.coords, Xs = Ts.colors, gl = xs.data, Sl = xs.width * 4;
              let El;
              os[qs + 1] > os[Fs + 1] && (El = qs, qs = Fs, Fs = El, El = ys, ys = Io, Io = El), os[Fs + 1] > os[Do + 1] && (El = Fs, Fs = Do, Do = El, El = Io, Io = so, so = El), os[qs + 1] > os[Fs + 1] && (El = qs, qs = Fs, Fs = El, El = ys, ys = Io, Io = El);
              const wl = (os[qs] + Ts.offsetX) * Ts.scaleX, jl = (os[qs + 1] + Ts.offsetY) * Ts.scaleY, kl = (os[Fs] + Ts.offsetX) * Ts.scaleX, Fl = (os[Fs + 1] + Ts.offsetY) * Ts.scaleY, Ml = (os[Do] + Ts.offsetX) * Ts.scaleX, ql = (os[Do + 1] + Ts.offsetY) * Ts.scaleY;
              if (jl >= ql)
                return;
              const Kl = Xs[ys], Zl = Xs[ys + 1], Il = Xs[ys + 2], xl = Xs[Io], bl = Xs[Io + 1], Pl = Xs[Io + 2], Nl = Xs[so], Bl = Xs[so + 1], Ol = Xs[so + 2], To = Math.round(jl), Os = Math.round(ql);
              let $l, _l, Al, Rl, Cl, ml, Tl, Ll;
              for (let Vl = To; Vl <= Os; Vl++) {
                if (Vl < Fl) {
                  let Wl;
                  Vl < jl ? Wl = 0 : Wl = (jl - Vl) / (jl - Fl), $l = wl - (wl - kl) * Wl, _l = Kl - (Kl - xl) * Wl, Al = Zl - (Zl - bl) * Wl, Rl = Il - (Il - Pl) * Wl;
                } else {
                  let Wl;
                  Vl > ql ? Wl = 1 : Fl === ql ? Wl = 0 : Wl = (Fl - Vl) / (Fl - ql), $l = kl - (kl - Ml) * Wl, _l = xl - (xl - Nl) * Wl, Al = bl - (bl - Bl) * Wl, Rl = Pl - (Pl - Ol) * Wl;
                }
                let zl;
                Vl < jl ? zl = 0 : Vl > ql ? zl = 1 : zl = (jl - Vl) / (jl - ql), Cl = wl - (wl - Ml) * zl, ml = Kl - (Kl - Nl) * zl, Tl = Zl - (Zl - Bl) * zl, Ll = Il - (Il - Ol) * zl;
                const Ul = Math.round(Math.min($l, Cl)), Yl = Math.round(Math.max($l, Cl));
                let Jl = Sl * Vl + Ul * 4;
                for (let Wl = Ul; Wl <= Yl; Wl++)
                  zl = ($l - Wl) / ($l - Cl), zl < 0 ? zl = 0 : zl > 1 && (zl = 1), gl[Jl++] = _l - (_l - ml) * zl | 0, gl[Jl++] = Al - (Al - Tl) * zl | 0, gl[Jl++] = Rl - (Rl - Ll) * zl | 0, gl[Jl++] = 255;
              }
            }
            function to(xs, Ts, qs) {
              const Fs = Ts.coords, Do = Ts.colors;
              let ys, Io;
              switch (Ts.type) {
                case "lattice":
                  const so = Ts.verticesPerRow, os = Math.floor(Fs.length / so) - 1, Xs = so - 1;
                  for (ys = 0; ys < os; ys++) {
                    let gl = ys * so;
                    for (let Sl = 0; Sl < Xs; Sl++, gl++)
                      Va(xs, qs, Fs[gl], Fs[gl + 1], Fs[gl + so], Do[gl], Do[gl + 1], Do[gl + so]), Va(xs, qs, Fs[gl + so + 1], Fs[gl + 1], Fs[gl + so], Do[gl + so + 1], Do[gl + 1], Do[gl + so]);
                  }
                  break;
                case "triangles":
                  for (ys = 0, Io = Fs.length; ys < Io; ys += 3)
                    Va(xs, qs, Fs[ys], Fs[ys + 1], Fs[ys + 2], Do[ys], Do[ys + 1], Do[ys + 2]);
                  break;
                default:
                  throw new Error("illegal figure");
              }
            }
            class ro extends fa {
              constructor(Ts) {
                super(), this._coords = Ts[2], this._colors = Ts[3], this._figures = Ts[4], this._bounds = Ts[5], this._bbox = Ts[7], this._background = Ts[8], this.matrix = null;
              }
              _createMeshCanvas(Ts, qs, Fs) {
                const so = Math.floor(this._bounds[0]), os = Math.floor(this._bounds[1]), Xs = Math.ceil(this._bounds[2]) - so, gl = Math.ceil(this._bounds[3]) - os, Sl = Math.min(Math.ceil(Math.abs(Xs * Ts[0] * 1.1)), 3e3), El = Math.min(Math.ceil(Math.abs(gl * Ts[1] * 1.1)), 3e3), wl = Xs / Sl, jl = gl / El, kl = {
                  coords: this._coords,
                  colors: this._colors,
                  offsetX: -so,
                  offsetY: -os,
                  scaleX: 1 / wl,
                  scaleY: 1 / jl
                }, Fl = Sl + 4, Ml = El + 4, ql = Fs.getCanvas("mesh", Fl, Ml, !1), Kl = ql.context, Zl = Kl.createImageData(Sl, El);
                if (qs) {
                  const xl = Zl.data;
                  for (let bl = 0, Pl = xl.length; bl < Pl; bl += 4)
                    xl[bl] = qs[0], xl[bl + 1] = qs[1], xl[bl + 2] = qs[2], xl[bl + 3] = 255;
                }
                for (const xl of this._figures)
                  to(Zl, xl, kl);
                return Kl.putImageData(Zl, 2, 2), {
                  canvas: ql.canvas,
                  offsetX: so - 2 * wl,
                  offsetY: os - 2 * jl,
                  scaleX: wl,
                  scaleY: jl
                };
              }
              getPattern(Ts, qs, Fs, Do) {
                ia(Ts, this._bbox);
                let ys;
                if (Do === na.SHADING)
                  ys = Qi.Util.singularValueDecompose2dScale((0, ea.getCurrentTransform)(Ts));
                else if (ys = Qi.Util.singularValueDecompose2dScale(qs.baseTransform), this.matrix) {
                  const so = Qi.Util.singularValueDecompose2dScale(this.matrix);
                  ys = [ys[0] * so[0], ys[1] * so[1]];
                }
                const Io = this._createMeshCanvas(ys, Do === na.SHADING ? null : this._background, qs.cachedCanvases);
                return Do !== na.SHADING && (Ts.setTransform(...qs.baseTransform), this.matrix && Ts.transform(...this.matrix)), Ts.translate(Io.offsetX, Io.offsetY), Ts.scale(Io.scaleX, Io.scaleY), Ts.createPattern(Io.canvas, "no-repeat");
              }
            }
            class no extends fa {
              getPattern() {
                return "hotpink";
              }
            }
            function eo(xs) {
              switch (xs[0]) {
                case "RadialAxial":
                  return new La(xs);
                case "Mesh":
                  return new ro(xs);
                case "Dummy":
                  return new no();
              }
              throw new Error(`Unknown IR type: ${xs[0]}`);
            }
            const ao = {
              COLORED: 1,
              UNCOLORED: 2
            };
            class io {
              static get MAX_PATTERN_SIZE() {
                return (0, Qi.shadow)(this, "MAX_PATTERN_SIZE", 3e3);
              }
              constructor(Ts, qs, Fs, Do, ys) {
                this.operatorList = Ts[2], this.matrix = Ts[3] || [1, 0, 0, 1, 0, 0], this.bbox = Ts[4], this.xstep = Ts[5], this.ystep = Ts[6], this.paintType = Ts[7], this.tilingType = Ts[8], this.color = qs, this.ctx = Fs, this.canvasGraphicsFactory = Do, this.baseTransform = ys;
              }
              createPatternCanvas(Ts) {
                const qs = this.operatorList, Fs = this.bbox, Do = this.xstep, ys = this.ystep, Io = this.paintType, so = this.tilingType, os = this.color, Xs = this.canvasGraphicsFactory;
                (0, Qi.info)("TilingType: " + so);
                const gl = Fs[0], Sl = Fs[1], El = Fs[2], wl = Fs[3], jl = Qi.Util.singularValueDecompose2dScale(this.matrix), kl = Qi.Util.singularValueDecompose2dScale(this.baseTransform), Fl = [jl[0] * kl[0], jl[1] * kl[1]], Ml = this.getSizeAndScale(Do, this.ctx.canvas.width, Fl[0]), ql = this.getSizeAndScale(ys, this.ctx.canvas.height, Fl[1]), Kl = Ts.cachedCanvases.getCanvas("pattern", Ml.size, ql.size, !0), Zl = Kl.context, Il = Xs.createCanvasGraphics(Zl);
                Il.groupLevel = Ts.groupLevel, this.setFillAndStrokeStyleToContext(Il, Io, os);
                let xl = gl, bl = Sl, Pl = El, Nl = wl;
                return gl < 0 && (xl = 0, Pl += Math.abs(gl)), Sl < 0 && (bl = 0, Nl += Math.abs(Sl)), Zl.translate(-(Ml.scale * xl), -(ql.scale * bl)), Il.transform(Ml.scale, 0, 0, ql.scale, 0, 0), Zl.save(), this.clipBbox(Il, xl, bl, Pl, Nl), Il.baseTransform = (0, ea.getCurrentTransform)(Il.ctx), Il.executeOperatorList(qs), Il.endDrawing(), {
                  canvas: Kl.canvas,
                  scaleX: Ml.scale,
                  scaleY: ql.scale,
                  offsetX: xl,
                  offsetY: bl
                };
              }
              getSizeAndScale(Ts, qs, Fs) {
                Ts = Math.abs(Ts);
                const Do = Math.max(io.MAX_PATTERN_SIZE, qs);
                let ys = Math.ceil(Ts * Fs);
                return ys >= Do ? ys = Do : Fs = ys / Ts, {
                  scale: Fs,
                  size: ys
                };
              }
              clipBbox(Ts, qs, Fs, Do, ys) {
                const Io = Do - qs, so = ys - Fs;
                Ts.ctx.rect(qs, Fs, Io, so), Ts.current.updateRectMinMax((0, ea.getCurrentTransform)(Ts.ctx), [qs, Fs, Do, ys]), Ts.clip(), Ts.endPath();
              }
              setFillAndStrokeStyleToContext(Ts, qs, Fs) {
                const Do = Ts.ctx, ys = Ts.current;
                switch (qs) {
                  case ao.COLORED:
                    const Io = this.ctx;
                    Do.fillStyle = Io.fillStyle, Do.strokeStyle = Io.strokeStyle, ys.fillColor = Io.fillStyle, ys.strokeColor = Io.strokeStyle;
                    break;
                  case ao.UNCOLORED:
                    const so = Qi.Util.makeHexColor(Fs[0], Fs[1], Fs[2]);
                    Do.fillStyle = so, Do.strokeStyle = so, ys.fillColor = so, ys.strokeColor = so;
                    break;
                  default:
                    throw new Qi.FormatError(`Unsupported paint type: ${qs}`);
                }
              }
              getPattern(Ts, qs, Fs, Do) {
                let ys = Fs;
                Do !== na.SHADING && (ys = Qi.Util.transform(ys, qs.baseTransform), this.matrix && (ys = Qi.Util.transform(ys, this.matrix)));
                const Io = this.createPatternCanvas(qs);
                let so = new DOMMatrix(ys);
                so = so.translate(Io.offsetX, Io.offsetY), so = so.scale(1 / Io.scaleX, 1 / Io.scaleY);
                const os = Ts.createPattern(Io.canvas, "repeat");
                try {
                  os.setTransform(so);
                } catch (Xs) {
                  (0, Qi.warn)(`TilingPattern.getPattern: "${Xs?.message}".`);
                }
                return os;
              }
            }
            e.TilingPattern = io;
          },
          /* 14 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.applyMaskImageData = ea;
            var Qi = Zi(1);
            function ea({
              src: ra,
              srcPos: na = 0,
              dest: ia,
              destPos: fa = 0,
              width: La,
              height: Va,
              inverseDecode: to = !1
            }) {
              const ro = Qi.FeatureTest.isLittleEndian ? 4278190080 : 255, [no, eo] = to ? [0, ro] : [ro, 0], ao = La >> 3, io = La & 7, xs = ra.length;
              ia = new Uint32Array(ia.buffer);
              for (let Ts = 0; Ts < Va; Ts++) {
                for (const Fs = na + ao; na < Fs; na++) {
                  const Do = na < xs ? ra[na] : 255;
                  ia[fa++] = Do & 128 ? eo : no, ia[fa++] = Do & 64 ? eo : no, ia[fa++] = Do & 32 ? eo : no, ia[fa++] = Do & 16 ? eo : no, ia[fa++] = Do & 8 ? eo : no, ia[fa++] = Do & 4 ? eo : no, ia[fa++] = Do & 2 ? eo : no, ia[fa++] = Do & 1 ? eo : no;
                }
                if (io === 0)
                  continue;
                const qs = na < xs ? ra[na++] : 255;
                for (let Fs = 0; Fs < io; Fs++)
                  ia[fa++] = qs & 1 << 7 - Fs ? eo : no;
              }
              return {
                srcPos: na,
                destPos: fa
              };
            }
          },
          /* 15 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.GlobalWorkerOptions = void 0;
            const Zi = /* @__PURE__ */ Object.create(null);
            e.GlobalWorkerOptions = Zi, Zi.workerPort = Zi.workerPort === void 0 ? null : Zi.workerPort, Zi.workerSrc = Zi.workerSrc === void 0 ? "" : Zi.workerSrc;
          },
          /* 16 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.MessageHandler = void 0;
            var Qi = Zi(1);
            const ea = {
              DATA: 1,
              ERROR: 2
            }, ra = {
              CANCEL: 1,
              CANCEL_COMPLETE: 2,
              CLOSE: 3,
              ENQUEUE: 4,
              ERROR: 5,
              PULL: 6,
              PULL_COMPLETE: 7,
              START_COMPLETE: 8
            };
            function na(fa) {
              switch (fa instanceof Error || typeof fa == "object" && fa !== null || (0, Qi.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), fa.name) {
                case "AbortException":
                  return new Qi.AbortException(fa.message);
                case "MissingPDFException":
                  return new Qi.MissingPDFException(fa.message);
                case "PasswordException":
                  return new Qi.PasswordException(fa.message, fa.code);
                case "UnexpectedResponseException":
                  return new Qi.UnexpectedResponseException(fa.message, fa.status);
                case "UnknownErrorException":
                  return new Qi.UnknownErrorException(fa.message, fa.details);
                default:
                  return new Qi.UnknownErrorException(fa.message, fa.toString());
              }
            }
            class ia {
              constructor(La, Va, to) {
                this.sourceName = La, this.targetName = Va, this.comObj = to, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (ro) => {
                  const no = ro.data;
                  if (no.targetName !== this.sourceName)
                    return;
                  if (no.stream) {
                    this._processStreamMessage(no);
                    return;
                  }
                  if (no.callback) {
                    const ao = no.callbackId, io = this.callbackCapabilities[ao];
                    if (!io)
                      throw new Error(`Cannot resolve callback ${ao}`);
                    if (delete this.callbackCapabilities[ao], no.callback === ea.DATA)
                      io.resolve(no.data);
                    else if (no.callback === ea.ERROR)
                      io.reject(na(no.reason));
                    else
                      throw new Error("Unexpected callback case");
                    return;
                  }
                  const eo = this.actionHandler[no.action];
                  if (!eo)
                    throw new Error(`Unknown action from worker: ${no.action}`);
                  if (no.callbackId) {
                    const ao = this.sourceName, io = no.sourceName;
                    new Promise(function(xs) {
                      xs(eo(no.data));
                    }).then(function(xs) {
                      to.postMessage({
                        sourceName: ao,
                        targetName: io,
                        callback: ea.DATA,
                        callbackId: no.callbackId,
                        data: xs
                      });
                    }, function(xs) {
                      to.postMessage({
                        sourceName: ao,
                        targetName: io,
                        callback: ea.ERROR,
                        callbackId: no.callbackId,
                        reason: na(xs)
                      });
                    });
                    return;
                  }
                  if (no.streamId) {
                    this._createStreamSink(no);
                    return;
                  }
                  eo(no.data);
                }, to.addEventListener("message", this._onComObjOnMessage);
              }
              on(La, Va) {
                const to = this.actionHandler;
                if (to[La])
                  throw new Error(`There is already an actionName called "${La}"`);
                to[La] = Va;
              }
              send(La, Va, to) {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: La,
                  data: Va
                }, to);
              }
              sendWithPromise(La, Va, to) {
                const ro = this.callbackId++, no = (0, Qi.createPromiseCapability)();
                this.callbackCapabilities[ro] = no;
                try {
                  this.comObj.postMessage({
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: La,
                    callbackId: ro,
                    data: Va
                  }, to);
                } catch (eo) {
                  no.reject(eo);
                }
                return no.promise;
              }
              sendWithStream(La, Va, to, ro) {
                const no = this.streamId++, eo = this.sourceName, ao = this.targetName, io = this.comObj;
                return new ReadableStream({
                  start: (xs) => {
                    const Ts = (0, Qi.createPromiseCapability)();
                    return this.streamControllers[no] = {
                      controller: xs,
                      startCall: Ts,
                      pullCall: null,
                      cancelCall: null,
                      isClosed: !1
                    }, io.postMessage({
                      sourceName: eo,
                      targetName: ao,
                      action: La,
                      streamId: no,
                      data: Va,
                      desiredSize: xs.desiredSize
                    }, ro), Ts.promise;
                  },
                  pull: (xs) => {
                    const Ts = (0, Qi.createPromiseCapability)();
                    return this.streamControllers[no].pullCall = Ts, io.postMessage({
                      sourceName: eo,
                      targetName: ao,
                      stream: ra.PULL,
                      streamId: no,
                      desiredSize: xs.desiredSize
                    }), Ts.promise;
                  },
                  cancel: (xs) => {
                    (0, Qi.assert)(xs instanceof Error, "cancel must have a valid reason");
                    const Ts = (0, Qi.createPromiseCapability)();
                    return this.streamControllers[no].cancelCall = Ts, this.streamControllers[no].isClosed = !0, io.postMessage({
                      sourceName: eo,
                      targetName: ao,
                      stream: ra.CANCEL,
                      streamId: no,
                      reason: na(xs)
                    }), Ts.promise;
                  }
                }, to);
              }
              _createStreamSink(La) {
                const Va = La.streamId, to = this.sourceName, ro = La.sourceName, no = this.comObj, eo = this, ao = this.actionHandler[La.action], io = {
                  enqueue(xs, Ts = 1, qs) {
                    if (this.isCancelled)
                      return;
                    const Fs = this.desiredSize;
                    this.desiredSize -= Ts, Fs > 0 && this.desiredSize <= 0 && (this.sinkCapability = (0, Qi.createPromiseCapability)(), this.ready = this.sinkCapability.promise), no.postMessage({
                      sourceName: to,
                      targetName: ro,
                      stream: ra.ENQUEUE,
                      streamId: Va,
                      chunk: xs
                    }, qs);
                  },
                  close() {
                    this.isCancelled || (this.isCancelled = !0, no.postMessage({
                      sourceName: to,
                      targetName: ro,
                      stream: ra.CLOSE,
                      streamId: Va
                    }), delete eo.streamSinks[Va]);
                  },
                  error(xs) {
                    (0, Qi.assert)(xs instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, no.postMessage({
                      sourceName: to,
                      targetName: ro,
                      stream: ra.ERROR,
                      streamId: Va,
                      reason: na(xs)
                    }));
                  },
                  sinkCapability: (0, Qi.createPromiseCapability)(),
                  onPull: null,
                  onCancel: null,
                  isCancelled: !1,
                  desiredSize: La.desiredSize,
                  ready: null
                };
                io.sinkCapability.resolve(), io.ready = io.sinkCapability.promise, this.streamSinks[Va] = io, new Promise(function(xs) {
                  xs(ao(La.data, io));
                }).then(function() {
                  no.postMessage({
                    sourceName: to,
                    targetName: ro,
                    stream: ra.START_COMPLETE,
                    streamId: Va,
                    success: !0
                  });
                }, function(xs) {
                  no.postMessage({
                    sourceName: to,
                    targetName: ro,
                    stream: ra.START_COMPLETE,
                    streamId: Va,
                    reason: na(xs)
                  });
                });
              }
              _processStreamMessage(La) {
                const Va = La.streamId, to = this.sourceName, ro = La.sourceName, no = this.comObj, eo = this.streamControllers[Va], ao = this.streamSinks[Va];
                switch (La.stream) {
                  case ra.START_COMPLETE:
                    La.success ? eo.startCall.resolve() : eo.startCall.reject(na(La.reason));
                    break;
                  case ra.PULL_COMPLETE:
                    La.success ? eo.pullCall.resolve() : eo.pullCall.reject(na(La.reason));
                    break;
                  case ra.PULL:
                    if (!ao) {
                      no.postMessage({
                        sourceName: to,
                        targetName: ro,
                        stream: ra.PULL_COMPLETE,
                        streamId: Va,
                        success: !0
                      });
                      break;
                    }
                    ao.desiredSize <= 0 && La.desiredSize > 0 && ao.sinkCapability.resolve(), ao.desiredSize = La.desiredSize, new Promise(function(io) {
                      io(ao.onPull && ao.onPull());
                    }).then(function() {
                      no.postMessage({
                        sourceName: to,
                        targetName: ro,
                        stream: ra.PULL_COMPLETE,
                        streamId: Va,
                        success: !0
                      });
                    }, function(io) {
                      no.postMessage({
                        sourceName: to,
                        targetName: ro,
                        stream: ra.PULL_COMPLETE,
                        streamId: Va,
                        reason: na(io)
                      });
                    });
                    break;
                  case ra.ENQUEUE:
                    if ((0, Qi.assert)(eo, "enqueue should have stream controller"), eo.isClosed)
                      break;
                    eo.controller.enqueue(La.chunk);
                    break;
                  case ra.CLOSE:
                    if ((0, Qi.assert)(eo, "close should have stream controller"), eo.isClosed)
                      break;
                    eo.isClosed = !0, eo.controller.close(), this._deleteStreamController(eo, Va);
                    break;
                  case ra.ERROR:
                    (0, Qi.assert)(eo, "error should have stream controller"), eo.controller.error(na(La.reason)), this._deleteStreamController(eo, Va);
                    break;
                  case ra.CANCEL_COMPLETE:
                    La.success ? eo.cancelCall.resolve() : eo.cancelCall.reject(na(La.reason)), this._deleteStreamController(eo, Va);
                    break;
                  case ra.CANCEL:
                    if (!ao)
                      break;
                    new Promise(function(io) {
                      io(ao.onCancel && ao.onCancel(na(La.reason)));
                    }).then(function() {
                      no.postMessage({
                        sourceName: to,
                        targetName: ro,
                        stream: ra.CANCEL_COMPLETE,
                        streamId: Va,
                        success: !0
                      });
                    }, function(io) {
                      no.postMessage({
                        sourceName: to,
                        targetName: ro,
                        stream: ra.CANCEL_COMPLETE,
                        streamId: Va,
                        reason: na(io)
                      });
                    }), ao.sinkCapability.reject(na(La.reason)), ao.isCancelled = !0, delete this.streamSinks[Va];
                    break;
                  default:
                    throw new Error("Unexpected stream case");
                }
              }
              async _deleteStreamController(La, Va) {
                await Promise.allSettled([La.startCall && La.startCall.promise, La.pullCall && La.pullCall.promise, La.cancelCall && La.cancelCall.promise]), delete this.streamControllers[Va];
              }
              destroy() {
                this.comObj.removeEventListener("message", this._onComObjOnMessage);
              }
            }
            e.MessageHandler = ia;
          },
          /* 17 */
          /***/
          (Bi, e, Zi) => {
            var ra, na;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.Metadata = void 0;
            var Qi = Zi(1);
            class ea {
              constructor({
                parsedData: fa,
                rawData: La
              }) {
                oc(this, ra);
                oc(this, na);
                sc(this, ra, fa), sc(this, na, La);
              }
              getRaw() {
                return Hl(this, na);
              }
              get(fa) {
                return Hl(this, ra).get(fa) ?? null;
              }
              getAll() {
                return (0, Qi.objectFromMap)(Hl(this, ra));
              }
              has(fa) {
                return Hl(this, ra).has(fa);
              }
            }
            ra = new WeakMap(), na = new WeakMap(), e.Metadata = ea;
          },
          /* 18 */
          /***/
          (Bi, e, Zi) => {
            var ia, fa, La, Va, to, ro, df;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.OptionalContentConfig = void 0;
            var Qi = Zi(1);
            const ea = Symbol("INTERNAL");
            class ra {
              constructor(ao, io) {
                oc(this, ia, !0);
                this.name = ao, this.intent = io;
              }
              get visible() {
                return Hl(this, ia);
              }
              _setVisible(ao, io) {
                ao !== ea && (0, Qi.unreachable)("Internal method `_setVisible` called."), sc(this, ia, io);
              }
            }
            ia = new WeakMap();
            class na {
              constructor(ao) {
                oc(this, ro);
                oc(this, fa, !0);
                oc(this, La, /* @__PURE__ */ new Map());
                oc(this, Va, null);
                oc(this, to, null);
                if (this.name = null, this.creator = null, ao !== null) {
                  this.name = ao.name, this.creator = ao.creator, sc(this, to, ao.order);
                  for (const io of ao.groups)
                    Hl(this, La).set(io.id, new ra(io.name, io.intent));
                  if (ao.baseState === "OFF")
                    for (const io of Hl(this, La).values())
                      io._setVisible(ea, !1);
                  for (const io of ao.on)
                    Hl(this, La).get(io)._setVisible(ea, !0);
                  for (const io of ao.off)
                    Hl(this, La).get(io)._setVisible(ea, !1);
                  sc(this, Va, /* @__PURE__ */ new Map());
                  for (const [io, xs] of Hl(this, La))
                    Hl(this, Va).set(io, xs.visible);
                }
              }
              isVisible(ao) {
                if (Hl(this, La).size === 0)
                  return !0;
                if (!ao)
                  return (0, Qi.warn)("Optional content group not defined."), !0;
                if (ao.type === "OCG")
                  return Hl(this, La).has(ao.id) ? Hl(this, La).get(ao.id).visible : ((0, Qi.warn)(`Optional content group not found: ${ao.id}`), !0);
                if (ao.type === "OCMD") {
                  if (ao.expression)
                    return nc(this, ro, df).call(this, ao.expression);
                  if (!ao.policy || ao.policy === "AnyOn") {
                    for (const io of ao.ids) {
                      if (!Hl(this, La).has(io))
                        return (0, Qi.warn)(`Optional content group not found: ${io}`), !0;
                      if (Hl(this, La).get(io).visible)
                        return !0;
                    }
                    return !1;
                  } else if (ao.policy === "AllOn") {
                    for (const io of ao.ids) {
                      if (!Hl(this, La).has(io))
                        return (0, Qi.warn)(`Optional content group not found: ${io}`), !0;
                      if (!Hl(this, La).get(io).visible)
                        return !1;
                    }
                    return !0;
                  } else if (ao.policy === "AnyOff") {
                    for (const io of ao.ids) {
                      if (!Hl(this, La).has(io))
                        return (0, Qi.warn)(`Optional content group not found: ${io}`), !0;
                      if (!Hl(this, La).get(io).visible)
                        return !0;
                    }
                    return !1;
                  } else if (ao.policy === "AllOff") {
                    for (const io of ao.ids) {
                      if (!Hl(this, La).has(io))
                        return (0, Qi.warn)(`Optional content group not found: ${io}`), !0;
                      if (Hl(this, La).get(io).visible)
                        return !1;
                    }
                    return !0;
                  }
                  return (0, Qi.warn)(`Unknown optional content policy ${ao.policy}.`), !0;
                }
                return (0, Qi.warn)(`Unknown group type ${ao.type}.`), !0;
              }
              setVisibility(ao, io = !0) {
                if (!Hl(this, La).has(ao)) {
                  (0, Qi.warn)(`Optional content group not found: ${ao}`);
                  return;
                }
                Hl(this, La).get(ao)._setVisible(ea, !!io), sc(this, fa, null);
              }
              get hasInitialVisibility() {
                if (Hl(this, fa) !== null)
                  return Hl(this, fa);
                for (const [ao, io] of Hl(this, La)) {
                  const xs = Hl(this, Va).get(ao);
                  if (io.visible !== xs)
                    return sc(this, fa, !1);
                }
                return sc(this, fa, !0);
              }
              getOrder() {
                return Hl(this, La).size ? Hl(this, to) ? Hl(this, to).slice() : [...Hl(this, La).keys()] : null;
              }
              getGroups() {
                return Hl(this, La).size > 0 ? (0, Qi.objectFromMap)(Hl(this, La)) : null;
              }
              getGroup(ao) {
                return Hl(this, La).get(ao) || null;
              }
            }
            fa = new WeakMap(), La = new WeakMap(), Va = new WeakMap(), to = new WeakMap(), ro = new WeakSet(), df = function(ao) {
              const io = ao.length;
              if (io < 2)
                return !0;
              const xs = ao[0];
              for (let Ts = 1; Ts < io; Ts++) {
                const qs = ao[Ts];
                let Fs;
                if (Array.isArray(qs))
                  Fs = nc(this, ro, df).call(this, qs);
                else if (Hl(this, La).has(qs))
                  Fs = Hl(this, La).get(qs).visible;
                else
                  return (0, Qi.warn)(`Optional content group not found: ${qs}`), !0;
                switch (xs) {
                  case "And":
                    if (!Fs)
                      return !1;
                    break;
                  case "Or":
                    if (Fs)
                      return !0;
                    break;
                  case "Not":
                    return !Fs;
                  default:
                    return !0;
                }
              }
              return xs === "And";
            }, e.OptionalContentConfig = na;
          },
          /* 19 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFDataTransportStream = void 0;
            var Qi = Zi(1), ea = Zi(8);
            class ra {
              constructor(La, Va) {
                (0, Qi.assert)(Va, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.'), this._queuedChunks = [], this._progressiveDone = La.progressiveDone || !1, this._contentDispositionFilename = La.contentDispositionFilename || null;
                const to = La.initialData;
                if (to?.length > 0) {
                  const ro = new Uint8Array(to).buffer;
                  this._queuedChunks.push(ro);
                }
                this._pdfDataRangeTransport = Va, this._isStreamingSupported = !La.disableStream, this._isRangeSupported = !La.disableRange, this._contentLength = La.length, this._fullRequestReader = null, this._rangeReaders = [], this._pdfDataRangeTransport.addRangeListener((ro, no) => {
                  this._onReceiveData({
                    begin: ro,
                    chunk: no
                  });
                }), this._pdfDataRangeTransport.addProgressListener((ro, no) => {
                  this._onProgress({
                    loaded: ro,
                    total: no
                  });
                }), this._pdfDataRangeTransport.addProgressiveReadListener((ro) => {
                  this._onReceiveData({
                    chunk: ro
                  });
                }), this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                  this._onProgressiveDone();
                }), this._pdfDataRangeTransport.transportReady();
              }
              _onReceiveData(La) {
                const Va = new Uint8Array(La.chunk).buffer;
                if (La.begin === void 0)
                  this._fullRequestReader ? this._fullRequestReader._enqueue(Va) : this._queuedChunks.push(Va);
                else {
                  const to = this._rangeReaders.some(function(ro) {
                    return ro._begin !== La.begin ? !1 : (ro._enqueue(Va), !0);
                  });
                  (0, Qi.assert)(to, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                }
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              _onProgress(La) {
                if (La.total === void 0) {
                  const Va = this._rangeReaders[0];
                  Va?.onProgress && Va.onProgress({
                    loaded: La.loaded
                  });
                } else {
                  const Va = this._fullRequestReader;
                  Va?.onProgress && Va.onProgress({
                    loaded: La.loaded,
                    total: La.total
                  });
                }
              }
              _onProgressiveDone() {
                this._fullRequestReader && this._fullRequestReader.progressiveDone(), this._progressiveDone = !0;
              }
              _removeRangeReader(La) {
                const Va = this._rangeReaders.indexOf(La);
                Va >= 0 && this._rangeReaders.splice(Va, 1);
              }
              getFullReader() {
                (0, Qi.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                const La = this._queuedChunks;
                return this._queuedChunks = null, new na(this, La, this._progressiveDone, this._contentDispositionFilename);
              }
              getRangeReader(La, Va) {
                if (Va <= this._progressiveDataLength)
                  return null;
                const to = new ia(this, La, Va);
                return this._pdfDataRangeTransport.requestDataRange(La, Va), this._rangeReaders.push(to), to;
              }
              cancelAllRequests(La) {
                this._fullRequestReader && this._fullRequestReader.cancel(La);
                for (const Va of this._rangeReaders.slice(0))
                  Va.cancel(La);
                this._pdfDataRangeTransport.abort();
              }
            }
            e.PDFDataTransportStream = ra;
            class na {
              constructor(La, Va, to = !1, ro = null) {
                this._stream = La, this._done = to || !1, this._filename = (0, ea.isPdfFile)(ro) ? ro : null, this._queuedChunks = Va || [], this._loaded = 0;
                for (const no of this._queuedChunks)
                  this._loaded += no.byteLength;
                this._requests = [], this._headersReady = Promise.resolve(), La._fullRequestReader = this, this.onProgress = null;
              }
              _enqueue(La) {
                this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
                  value: La,
                  done: !1
                }) : this._queuedChunks.push(La), this._loaded += La.byteLength);
              }
              get headersReady() {
                return this._headersReady;
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._stream._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._stream._isStreamingSupported;
              }
              get contentLength() {
                return this._stream._contentLength;
              }
              async read() {
                if (this._queuedChunks.length > 0)
                  return {
                    value: this._queuedChunks.shift(),
                    done: !1
                  };
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const La = (0, Qi.createPromiseCapability)();
                return this._requests.push(La), La.promise;
              }
              cancel(La) {
                this._done = !0;
                for (const Va of this._requests)
                  Va.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0;
              }
              progressiveDone() {
                this._done || (this._done = !0);
              }
            }
            class ia {
              constructor(La, Va, to) {
                this._stream = La, this._begin = Va, this._end = to, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
              }
              _enqueue(La) {
                if (!this._done) {
                  if (this._requests.length === 0)
                    this._queuedChunk = La;
                  else {
                    this._requests.shift().resolve({
                      value: La,
                      done: !1
                    });
                    for (const to of this._requests)
                      to.resolve({
                        value: void 0,
                        done: !0
                      });
                    this._requests.length = 0;
                  }
                  this._done = !0, this._stream._removeRangeReader(this);
                }
              }
              get isStreamingSupported() {
                return !1;
              }
              async read() {
                if (this._queuedChunk) {
                  const Va = this._queuedChunk;
                  return this._queuedChunk = null, {
                    value: Va,
                    done: !1
                  };
                }
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const La = (0, Qi.createPromiseCapability)();
                return this._requests.push(La), La.promise;
              }
              cancel(La) {
                this._done = !0;
                for (const Va of this._requests)
                  Va.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._stream._removeRangeReader(this);
              }
            }
          },
          /* 20 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.XfaText = void 0;
            class Zi {
              static textContent(ea) {
                const ra = [], na = {
                  items: ra,
                  styles: /* @__PURE__ */ Object.create(null)
                };
                function ia(fa) {
                  if (!fa)
                    return;
                  let La = null;
                  const Va = fa.name;
                  if (Va === "#text")
                    La = fa.value;
                  else if (Zi.shouldBuildText(Va))
                    fa?.attributes?.textContent ? La = fa.attributes.textContent : fa.value && (La = fa.value);
                  else return;
                  if (La !== null && ra.push({
                    str: La
                  }), !!fa.children)
                    for (const to of fa.children)
                      ia(to);
                }
                return ia(ea), na;
              }
              static shouldBuildText(ea) {
                return !(ea === "textarea" || ea === "input" || ea === "option" || ea === "select");
              }
            }
            e.XfaText = Zi;
          },
          /* 21 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.NodeStandardFontDataFactory = e.NodeCanvasFactory = e.NodeCMapReaderFactory = void 0;
            var Qi = Zi(9);
            const ea = function(fa) {
              return new Promise((La, Va) => {
                require$$5.readFile(fa, (ro, no) => {
                  if (ro || !no) {
                    Va(new Error(ro));
                    return;
                  }
                  La(new Uint8Array(no));
                });
              });
            };
            class ra extends Qi.BaseCanvasFactory {
              _createCanvas(La, Va) {
                return require$$5.createCanvas(La, Va);
              }
            }
            e.NodeCanvasFactory = ra;
            class na extends Qi.BaseCMapReaderFactory {
              _fetchData(La, Va) {
                return ea(La).then((to) => ({
                  cMapData: to,
                  compressionType: Va
                }));
              }
            }
            e.NodeCMapReaderFactory = na;
            class ia extends Qi.BaseStandardFontDataFactory {
              _fetchData(La) {
                return ea(La);
              }
            }
            e.NodeStandardFontDataFactory = ia;
          },
          /* 22 */
          /***/
          (Bi, e, Zi) => {
            var fa, La, Va, to, ro, no, eo, ao, io, ff, jf, pf, Nf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.AnnotationEditorLayer = void 0;
            var Qi = Zi(7), ea = Zi(1), ra = Zi(23), na = Zi(24);
            const Do = class Do {
              constructor(Io) {
                oc(this, io);
                oc(this, fa);
                oc(this, La, !1);
                oc(this, Va, this.pointerup.bind(this));
                oc(this, to, this.pointerdown.bind(this));
                oc(this, ro, /* @__PURE__ */ new Map());
                oc(this, no, !1);
                oc(this, eo, !1);
                oc(this, ao);
                Do._initialized || (Do._initialized = !0, ra.FreeTextEditor.initialize(Io.l10n), na.InkEditor.initialize(Io.l10n), Io.uiManager.registerEditorTypes([ra.FreeTextEditor, na.InkEditor])), sc(this, ao, Io.uiManager), this.annotationStorage = Io.annotationStorage, this.pageIndex = Io.pageIndex, this.div = Io.div, sc(this, fa, Io.accessibilityManager), Hl(this, ao).addLayer(this);
              }
              updateToolbar(Io) {
                Hl(this, ao).updateToolbar(Io);
              }
              updateMode(Io = Hl(this, ao).getMode()) {
                nc(this, io, Nf).call(this), Io === ea.AnnotationEditorType.INK ? (this.addInkEditorIfNeeded(!1), this.disableClick()) : this.enableClick(), Hl(this, ao).unselectAll();
              }
              addInkEditorIfNeeded(Io) {
                if (!Io && Hl(this, ao).getMode() !== ea.AnnotationEditorType.INK)
                  return;
                if (!Io) {
                  for (const os of Hl(this, ro).values())
                    if (os.isEmpty()) {
                      os.setInBackground();
                      return;
                    }
                }
                nc(this, io, pf).call(this, {
                  offsetX: 0,
                  offsetY: 0
                }).setInBackground();
              }
              setEditingState(Io) {
                Hl(this, ao).setEditingState(Io);
              }
              addCommands(Io) {
                Hl(this, ao).addCommands(Io);
              }
              enable() {
                this.div.style.pointerEvents = "auto";
                for (const Io of Hl(this, ro).values())
                  Io.enableEditing();
              }
              disable() {
                this.div.style.pointerEvents = "none";
                for (const Io of Hl(this, ro).values())
                  Io.disableEditing();
              }
              setActiveEditor(Io) {
                Hl(this, ao).getActive() !== Io && Hl(this, ao).setActiveEditor(Io);
              }
              enableClick() {
                this.div.addEventListener("pointerdown", Hl(this, to)), this.div.addEventListener("pointerup", Hl(this, Va));
              }
              disableClick() {
                this.div.removeEventListener("pointerdown", Hl(this, to)), this.div.removeEventListener("pointerup", Hl(this, Va));
              }
              attach(Io) {
                Hl(this, ro).set(Io.id, Io);
              }
              detach(Io) {
                Hl(this, ro).delete(Io.id), Hl(this, fa)?.removePointerInTextLayer(Io.contentDiv);
              }
              remove(Io) {
                Hl(this, ao).removeEditor(Io), this.detach(Io), this.annotationStorage.remove(Io.id), Io.div.style.display = "none", setTimeout(() => {
                  Io.div.style.display = "", Io.div.remove(), Io.isAttachedToDOM = !1, document.activeElement === document.body && Hl(this, ao).focusMainContainer();
                }, 0), Hl(this, eo) || this.addInkEditorIfNeeded(!1);
              }
              add(Io) {
                if (nc(this, io, ff).call(this, Io), Hl(this, ao).addEditor(Io), this.attach(Io), !Io.isAttachedToDOM) {
                  const so = Io.render();
                  this.div.append(so), Io.isAttachedToDOM = !0;
                }
                this.moveEditorInDOM(Io), Io.onceAdded(), this.addToAnnotationStorage(Io);
              }
              moveEditorInDOM(Io) {
                Hl(this, fa)?.moveElementInDOM(this.div, Io.div, Io.contentDiv, !0);
              }
              addToAnnotationStorage(Io) {
                !Io.isEmpty() && !this.annotationStorage.has(Io.id) && this.annotationStorage.setValue(Io.id, Io);
              }
              addOrRebuild(Io) {
                Io.needsToBeRebuilt() ? Io.rebuild() : this.add(Io);
              }
              addANewEditor(Io) {
                const so = () => {
                  this.addOrRebuild(Io);
                }, os = () => {
                  Io.remove();
                };
                this.addCommands({
                  cmd: so,
                  undo: os,
                  mustExec: !0
                });
              }
              addUndoableEditor(Io) {
                const so = () => {
                  this.addOrRebuild(Io);
                }, os = () => {
                  Io.remove();
                };
                this.addCommands({
                  cmd: so,
                  undo: os,
                  mustExec: !1
                });
              }
              getNextId() {
                return Hl(this, ao).getId();
              }
              deserialize(Io) {
                switch (Io.annotationType) {
                  case ea.AnnotationEditorType.FREETEXT:
                    return ra.FreeTextEditor.deserialize(Io, this);
                  case ea.AnnotationEditorType.INK:
                    return na.InkEditor.deserialize(Io, this);
                }
                return null;
              }
              setSelected(Io) {
                Hl(this, ao).setSelected(Io);
              }
              toggleSelected(Io) {
                Hl(this, ao).toggleSelected(Io);
              }
              isSelected(Io) {
                return Hl(this, ao).isSelected(Io);
              }
              unselect(Io) {
                Hl(this, ao).unselect(Io);
              }
              pointerup(Io) {
                const so = Qi.KeyboardManager.platform.isMac;
                if (!(Io.button !== 0 || Io.ctrlKey && so) && Io.target === this.div && Hl(this, no)) {
                  if (sc(this, no, !1), !Hl(this, La)) {
                    sc(this, La, !0);
                    return;
                  }
                  nc(this, io, pf).call(this, Io);
                }
              }
              pointerdown(Io) {
                const so = Qi.KeyboardManager.platform.isMac;
                if (Io.button !== 0 || Io.ctrlKey && so || Io.target !== this.div)
                  return;
                sc(this, no, !0);
                const os = Hl(this, ao).getActive();
                sc(this, La, !os || os.isEmpty());
              }
              drop(Io) {
                const so = Io.dataTransfer.getData("text/plain"), os = Hl(this, ao).getEditor(so);
                if (!os)
                  return;
                Io.preventDefault(), Io.dataTransfer.dropEffect = "move", nc(this, io, ff).call(this, os);
                const Xs = this.div.getBoundingClientRect(), gl = Io.clientX - Xs.x, Sl = Io.clientY - Xs.y;
                os.translate(gl - os.startX, Sl - os.startY), this.moveEditorInDOM(os), os.div.focus();
              }
              dragover(Io) {
                Io.preventDefault();
              }
              destroy() {
                Hl(this, ao).getActive()?.parent === this && Hl(this, ao).setActiveEditor(null);
                for (const Io of Hl(this, ro).values())
                  Hl(this, fa)?.removePointerInTextLayer(Io.contentDiv), Io.isAttachedToDOM = !1, Io.div.remove(), Io.parent = null;
                this.div = null, Hl(this, ro).clear(), Hl(this, ao).removeLayer(this);
              }
              render(Io) {
                this.viewport = Io.viewport, (0, Qi.bindEvents)(this, this.div, ["dragover", "drop"]), this.setDimensions();
                for (const so of Hl(this, ao).getEditors(this.pageIndex))
                  this.add(so);
                this.updateMode();
              }
              update(Io) {
                this.viewport = Io.viewport, this.setDimensions(), this.updateMode();
              }
              get scaleFactor() {
                return this.viewport.scale;
              }
              get pageDimensions() {
                const [Io, so, os, Xs] = this.viewport.viewBox, gl = os - Io, Sl = Xs - so;
                return [gl, Sl];
              }
              get viewportBaseDimensions() {
                const {
                  width: Io,
                  height: so,
                  rotation: os
                } = this.viewport;
                return os % 180 === 0 ? [Io, so] : [so, Io];
              }
              setDimensions() {
                const {
                  width: Io,
                  height: so,
                  rotation: os
                } = this.viewport, Xs = os % 180 !== 0, gl = Math.floor(Io) + "px", Sl = Math.floor(so) + "px";
                this.div.style.width = Xs ? Sl : gl, this.div.style.height = Xs ? gl : Sl, this.div.setAttribute("data-main-rotation", os);
              }
            };
            fa = new WeakMap(), La = new WeakMap(), Va = new WeakMap(), to = new WeakMap(), ro = new WeakMap(), no = new WeakMap(), eo = new WeakMap(), ao = new WeakMap(), io = new WeakSet(), ff = function(Io) {
              Io.parent !== this && (this.attach(Io), Io.pageIndex = this.pageIndex, Io.parent?.detach(Io), Io.parent = this, Io.div && Io.isAttachedToDOM && (Io.div.remove(), this.div.append(Io.div)));
            }, jf = function(Io) {
              switch (Hl(this, ao).getMode()) {
                case ea.AnnotationEditorType.FREETEXT:
                  return new ra.FreeTextEditor(Io);
                case ea.AnnotationEditorType.INK:
                  return new na.InkEditor(Io);
              }
              return null;
            }, pf = function(Io) {
              const so = this.getNextId(), os = nc(this, io, jf).call(this, {
                parent: this,
                id: so,
                x: Io.offsetX,
                y: Io.offsetY
              });
              return os && this.add(os), os;
            }, Nf = function() {
              sc(this, eo, !0);
              for (const Io of Hl(this, ro).values())
                Io.isEmpty() && Io.remove();
              sc(this, eo, !1);
            }, cd(Do, "_initialized", !1);
            let ia = Do;
            e.AnnotationEditorLayer = ia;
          },
          /* 23 */
          /***/
          (Bi, e, Zi) => {
            var ia, fa, La, Va, to, ro, no, eo, Lf, Vf, Bf, hf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.FreeTextEditor = void 0;
            var Qi = Zi(1), ea = Zi(7), ra = Zi(6);
            const qs = class qs extends ra.AnnotationEditor {
              constructor(ys) {
                super({
                  ...ys,
                  name: "freeTextEditor"
                });
                oc(this, eo);
                oc(this, ia, this.editorDivBlur.bind(this));
                oc(this, fa, this.editorDivFocus.bind(this));
                oc(this, La, this.editorDivKeydown.bind(this));
                oc(this, Va);
                oc(this, to, "");
                oc(this, ro, !1);
                oc(this, no);
                sc(this, Va, ys.color || qs._defaultColor || ra.AnnotationEditor._defaultLineColor), sc(this, no, ys.fontSize || qs._defaultFontSize);
              }
              static initialize(ys) {
                this._l10nPromise = new Map(["free_text_default_content", "editor_free_text_aria_label"].map((so) => [so, ys.get(so)]));
                const Io = getComputedStyle(document.documentElement);
                this._internalPadding = parseFloat(Io.getPropertyValue("--freetext-padding"));
              }
              static updateDefaultParams(ys, Io) {
                switch (ys) {
                  case Qi.AnnotationEditorParamsType.FREETEXT_SIZE:
                    qs._defaultFontSize = Io;
                    break;
                  case Qi.AnnotationEditorParamsType.FREETEXT_COLOR:
                    qs._defaultColor = Io;
                    break;
                }
              }
              updateParams(ys, Io) {
                switch (ys) {
                  case Qi.AnnotationEditorParamsType.FREETEXT_SIZE:
                    nc(this, eo, Lf).call(this, Io);
                    break;
                  case Qi.AnnotationEditorParamsType.FREETEXT_COLOR:
                    nc(this, eo, Vf).call(this, Io);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[Qi.AnnotationEditorParamsType.FREETEXT_SIZE, qs._defaultFontSize], [Qi.AnnotationEditorParamsType.FREETEXT_COLOR, qs._defaultColor || ra.AnnotationEditor._defaultLineColor]];
              }
              get propertiesToUpdate() {
                return [[Qi.AnnotationEditorParamsType.FREETEXT_SIZE, Hl(this, no)], [Qi.AnnotationEditorParamsType.FREETEXT_COLOR, Hl(this, Va)]];
              }
              getInitialTranslation() {
                return [-qs._internalPadding * this.parent.scaleFactor, -(qs._internalPadding + Hl(this, no)) * this.parent.scaleFactor];
              }
              rebuild() {
                super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this));
              }
              enableEditMode() {
                this.isInEditMode() || (this.parent.setEditingState(!1), this.parent.updateToolbar(Qi.AnnotationEditorType.FREETEXT), super.enableEditMode(), this.enableEditing(), this.overlayDiv.classList.remove("enabled"), this.editorDiv.contentEditable = !0, this.div.draggable = !1, this.editorDiv.addEventListener("keydown", Hl(this, La)), this.editorDiv.addEventListener("focus", Hl(this, fa)), this.editorDiv.addEventListener("blur", Hl(this, ia)));
              }
              disableEditMode() {
                this.isInEditMode() && (this.parent.setEditingState(!0), super.disableEditMode(), this.disableEditing(), this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.draggable = !0, this.editorDiv.removeEventListener("keydown", Hl(this, La)), this.editorDiv.removeEventListener("focus", Hl(this, fa)), this.editorDiv.removeEventListener("blur", Hl(this, ia)), this.div.focus(), this.isEditing = !1);
              }
              focusin(ys) {
                super.focusin(ys), ys.target !== this.editorDiv && this.editorDiv.focus();
              }
              onceAdded() {
                this.width || (this.enableEditMode(), this.editorDiv.focus());
              }
              isEmpty() {
                return !this.editorDiv || this.editorDiv.innerText.trim() === "";
              }
              remove() {
                this.isEditing = !1, this.parent.setEditingState(!0), super.remove();
              }
              commit() {
                super.commit(), Hl(this, ro) || (sc(this, ro, !0), this.parent.addUndoableEditor(this)), this.disableEditMode(), sc(this, to, nc(this, eo, Bf).call(this).trimEnd()), nc(this, eo, hf).call(this);
              }
              shouldGetKeyboardEvents() {
                return this.isInEditMode();
              }
              dblclick(ys) {
                this.enableEditMode(), this.editorDiv.focus();
              }
              keydown(ys) {
                ys.target === this.div && ys.key === "Enter" && (this.enableEditMode(), this.editorDiv.focus());
              }
              editorDivKeydown(ys) {
                qs._keyboardManager.exec(this, ys);
              }
              editorDivFocus(ys) {
                this.isEditing = !0;
              }
              editorDivBlur(ys) {
                this.isEditing = !1;
              }
              disableEditing() {
                this.editorDiv.setAttribute("role", "comment"), this.editorDiv.removeAttribute("aria-multiline");
              }
              enableEditing() {
                this.editorDiv.setAttribute("role", "textbox"), this.editorDiv.setAttribute("aria-multiline", !0);
              }
              render() {
                if (this.div)
                  return this.div;
                let ys, Io;
                this.width && (ys = this.x, Io = this.y), super.render(), this.editorDiv = document.createElement("div"), this.editorDiv.className = "internal", this.editorDiv.setAttribute("id", `${this.id}-editor`), this.enableEditing(), qs._l10nPromise.get("editor_free_text_aria_label").then((os) => this.editorDiv?.setAttribute("aria-label", os)), qs._l10nPromise.get("free_text_default_content").then((os) => this.editorDiv?.setAttribute("default-content", os)), this.editorDiv.contentEditable = !0;
                const {
                  style: so
                } = this.editorDiv;
                if (so.fontSize = `calc(${Hl(this, no)}px * var(--scale-factor))`, so.color = Hl(this, Va), this.div.append(this.editorDiv), this.overlayDiv = document.createElement("div"), this.overlayDiv.classList.add("overlay", "enabled"), this.div.append(this.overlayDiv), (0, ea.bindEvents)(this, this.div, ["dblclick", "keydown"]), this.width) {
                  const [os, Xs] = this.parent.viewportBaseDimensions;
                  this.setAt(ys * os, Io * Xs, this.width * os, this.height * Xs);
                  for (const gl of Hl(this, to).split(`
`)) {
                    const Sl = document.createElement("div");
                    Sl.append(gl ? document.createTextNode(gl) : document.createElement("br")), this.editorDiv.append(Sl);
                  }
                  this.div.draggable = !0, this.editorDiv.contentEditable = !1;
                } else
                  this.div.draggable = !1, this.editorDiv.contentEditable = !0;
                return this.div;
              }
              get contentDiv() {
                return this.editorDiv;
              }
              static deserialize(ys, Io) {
                const so = super.deserialize(ys, Io);
                return sc(so, no, ys.fontSize), sc(so, Va, Qi.Util.makeHexColor(...ys.color)), sc(so, to, ys.value), so;
              }
              serialize() {
                if (this.isEmpty())
                  return null;
                const ys = qs._internalPadding * this.parent.scaleFactor, Io = this.getRect(ys, ys), so = ra.AnnotationEditor._colorManager.convert(getComputedStyle(this.editorDiv).color);
                return {
                  annotationType: Qi.AnnotationEditorType.FREETEXT,
                  color: so,
                  fontSize: Hl(this, no),
                  value: Hl(this, to),
                  pageIndex: this.parent.pageIndex,
                  rect: Io,
                  rotation: this.rotation
                };
              }
            };
            ia = new WeakMap(), fa = new WeakMap(), La = new WeakMap(), Va = new WeakMap(), to = new WeakMap(), ro = new WeakMap(), no = new WeakMap(), eo = new WeakSet(), Lf = function(ys) {
              const Io = (os) => {
                this.editorDiv.style.fontSize = `calc(${os}px * var(--scale-factor))`, this.translate(0, -(os - Hl(this, no)) * this.parent.scaleFactor), sc(this, no, os), nc(this, eo, hf).call(this);
              }, so = Hl(this, no);
              this.parent.addCommands({
                cmd: () => {
                  Io(ys);
                },
                undo: () => {
                  Io(so);
                },
                mustExec: !0,
                type: Qi.AnnotationEditorParamsType.FREETEXT_SIZE,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Vf = function(ys) {
              const Io = Hl(this, Va);
              this.parent.addCommands({
                cmd: () => {
                  sc(this, Va, ys), this.editorDiv.style.color = ys;
                },
                undo: () => {
                  sc(this, Va, Io), this.editorDiv.style.color = Io;
                },
                mustExec: !0,
                type: Qi.AnnotationEditorParamsType.FREETEXT_COLOR,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Bf = function() {
              const ys = this.editorDiv.getElementsByTagName("div");
              if (ys.length === 0)
                return this.editorDiv.innerText;
              const Io = [];
              for (let so = 0, os = ys.length; so < os; so++) {
                const gl = ys[so].firstChild;
                gl?.nodeName === "#text" ? Io.push(gl.data) : Io.push("");
              }
              return Io.join(`
`);
            }, hf = function() {
              const [ys, Io] = this.parent.viewportBaseDimensions, so = this.div.getBoundingClientRect();
              this.width = so.width / ys, this.height = so.height / Io;
            }, cd(qs, "_freeTextDefaultContent", ""), cd(qs, "_l10nPromise"), cd(qs, "_internalPadding", 0), cd(qs, "_defaultColor", null), cd(qs, "_defaultFontSize", 10), cd(qs, "_keyboardManager", new ea.KeyboardManager([[["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], qs.prototype.commitOrRemove]])), cd(qs, "_type", "freetext");
            let na = qs;
            e.FreeTextEditor = na;
          },
          /* 24 */
          /***/
          (Bi, e, Zi) => {
            var La, Va, to, ro, no, eo, ao, io, xs, Ts, qs, Fs, Do, ys, Io, Uf, zf, Hf, Kf, mf, qf, Wf, Gf, Td, vf, Hd, Kd, Md, gf, qd, xl, bf, Yf, Zf, Xf, yf, Wd, Fd, $f;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.InkEditor = void 0, Object.defineProperty(e, "fitCurve", {
              enumerable: !0,
              get: function() {
                return ra.fitCurve;
              }
            });
            var Qi = Zi(1), ea = Zi(6), ra = Zi(25), na = Zi(7);
            const ia = 16, _l = class _l extends ea.AnnotationEditor {
              constructor(Cl) {
                super({
                  ...Cl,
                  name: "inkEditor"
                });
                oc(this, Io);
                oc(this, La, 0);
                oc(this, Va, 0);
                oc(this, to, 0);
                oc(this, ro, this.canvasPointermove.bind(this));
                oc(this, no, this.canvasPointerleave.bind(this));
                oc(this, eo, this.canvasPointerup.bind(this));
                oc(this, ao, this.canvasPointerdown.bind(this));
                oc(this, io, !1);
                oc(this, xs, !1);
                oc(this, Ts, null);
                oc(this, qs, null);
                oc(this, Fs, 0);
                oc(this, Do, 0);
                oc(this, ys, null);
                this.color = Cl.color || null, this.thickness = Cl.thickness || null, this.opacity = Cl.opacity || null, this.paths = [], this.bezierPath2D = [], this.currentPath = [], this.scaleFactor = 1, this.translationX = this.translationY = 0, this.x = 0, this.y = 0;
              }
              static initialize(Cl) {
                this._l10nPromise = new Map(["editor_ink_canvas_aria_label", "editor_ink_aria_label"].map((ml) => [ml, Cl.get(ml)]));
              }
              static updateDefaultParams(Cl, ml) {
                switch (Cl) {
                  case Qi.AnnotationEditorParamsType.INK_THICKNESS:
                    _l._defaultThickness = ml;
                    break;
                  case Qi.AnnotationEditorParamsType.INK_COLOR:
                    _l._defaultColor = ml;
                    break;
                  case Qi.AnnotationEditorParamsType.INK_OPACITY:
                    _l._defaultOpacity = ml / 100;
                    break;
                }
              }
              updateParams(Cl, ml) {
                switch (Cl) {
                  case Qi.AnnotationEditorParamsType.INK_THICKNESS:
                    nc(this, Io, Uf).call(this, ml);
                    break;
                  case Qi.AnnotationEditorParamsType.INK_COLOR:
                    nc(this, Io, zf).call(this, ml);
                    break;
                  case Qi.AnnotationEditorParamsType.INK_OPACITY:
                    nc(this, Io, Hf).call(this, ml);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[Qi.AnnotationEditorParamsType.INK_THICKNESS, _l._defaultThickness], [Qi.AnnotationEditorParamsType.INK_COLOR, _l._defaultColor || ea.AnnotationEditor._defaultLineColor], [Qi.AnnotationEditorParamsType.INK_OPACITY, Math.round(_l._defaultOpacity * 100)]];
              }
              get propertiesToUpdate() {
                return [[Qi.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || _l._defaultThickness], [Qi.AnnotationEditorParamsType.INK_COLOR, this.color || _l._defaultColor || ea.AnnotationEditor._defaultLineColor], [Qi.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? _l._defaultOpacity))]];
              }
              rebuild() {
                super.rebuild(), this.div !== null && (this.canvas || (nc(this, Io, Hd).call(this), nc(this, Io, Kd).call(this)), this.isAttachedToDOM || (this.parent.add(this), nc(this, Io, Md).call(this)), nc(this, Io, Fd).call(this));
              }
              remove() {
                this.canvas !== null && (this.isEmpty() || this.commit(), this.canvas.width = this.canvas.height = 0, this.canvas.remove(), this.canvas = null, Hl(this, qs).disconnect(), sc(this, qs, null), super.remove());
              }
              enableEditMode() {
                Hl(this, io) || this.canvas === null || (super.enableEditMode(), this.div.draggable = !1, this.canvas.addEventListener("pointerdown", Hl(this, ao)), this.canvas.addEventListener("pointerup", Hl(this, eo)));
              }
              disableEditMode() {
                !this.isInEditMode() || this.canvas === null || (super.disableEditMode(), this.div.draggable = !this.isEmpty(), this.div.classList.remove("editing"), this.canvas.removeEventListener("pointerdown", Hl(this, ao)), this.canvas.removeEventListener("pointerup", Hl(this, eo)));
              }
              onceAdded() {
                this.div.draggable = !this.isEmpty();
              }
              isEmpty() {
                return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
              }
              commit() {
                Hl(this, io) || (super.commit(), this.isEditing = !1, this.disableEditMode(), this.setInForeground(), sc(this, io, !0), this.div.classList.add("disabled"), nc(this, Io, Fd).call(this, !0), this.parent.addInkEditorIfNeeded(!0), this.parent.moveEditorInDOM(this), this.div.focus());
              }
              focusin(Cl) {
                super.focusin(Cl), this.enableEditMode();
              }
              canvasPointerdown(Cl) {
                Cl.button !== 0 || !this.isInEditMode() || Hl(this, io) || (this.setInForeground(), Cl.type !== "mouse" && this.div.focus(), Cl.stopPropagation(), this.canvas.addEventListener("pointerleave", Hl(this, no)), this.canvas.addEventListener("pointermove", Hl(this, ro)), nc(this, Io, qf).call(this, Cl.offsetX, Cl.offsetY));
              }
              canvasPointermove(Cl) {
                Cl.stopPropagation(), nc(this, Io, Wf).call(this, Cl.offsetX, Cl.offsetY);
              }
              canvasPointerup(Cl) {
                Cl.button === 0 && this.isInEditMode() && this.currentPath.length !== 0 && (Cl.stopPropagation(), nc(this, Io, vf).call(this, Cl), this.setInBackground());
              }
              canvasPointerleave(Cl) {
                nc(this, Io, vf).call(this, Cl), this.setInBackground();
              }
              render() {
                if (this.div)
                  return this.div;
                let Cl, ml;
                this.width && (Cl = this.x, ml = this.y), super.render(), _l._l10nPromise.get("editor_ink_aria_label").then((Ul) => this.div?.setAttribute("aria-label", Ul));
                const [Tl, Ll, Vl, zl] = nc(this, Io, Kf).call(this);
                if (this.setAt(Tl, Ll, 0, 0), this.setDims(Vl, zl), nc(this, Io, Hd).call(this), this.width) {
                  const [Ul, Yl] = this.parent.viewportBaseDimensions;
                  this.setAt(Cl * Ul, ml * Yl, this.width * Ul, this.height * Yl), sc(this, xs, !0), nc(this, Io, Md).call(this), this.setDims(this.width * Ul, this.height * Yl), nc(this, Io, Td).call(this), nc(this, Io, $f).call(this), this.div.classList.add("disabled");
                } else
                  this.div.classList.add("editing"), this.enableEditMode();
                return nc(this, Io, Kd).call(this), this.div;
              }
              setDimensions(Cl, ml) {
                const Tl = Math.round(Cl), Ll = Math.round(ml);
                if (Hl(this, Fs) === Tl && Hl(this, Do) === Ll)
                  return;
                sc(this, Fs, Tl), sc(this, Do, Ll), this.canvas.style.visibility = "hidden", Hl(this, La) && Math.abs(Hl(this, La) - Cl / ml) > 0.01 && (ml = Math.ceil(Cl / Hl(this, La)), this.setDims(Cl, ml));
                const [Vl, zl] = this.parent.viewportBaseDimensions;
                this.width = Cl / Vl, this.height = ml / zl, Hl(this, io) && nc(this, Io, gf).call(this, Cl, ml), nc(this, Io, Md).call(this), nc(this, Io, Td).call(this), this.canvas.style.visibility = "visible";
              }
              static deserialize(Cl, ml) {
                var rc, uc;
                const Tl = super.deserialize(Cl, ml);
                Tl.thickness = Cl.thickness, Tl.color = Qi.Util.makeHexColor(...Cl.color), Tl.opacity = Cl.opacity;
                const [Ll, Vl] = ml.pageDimensions, zl = Tl.width * Ll, Ul = Tl.height * Vl, Yl = ml.scaleFactor, Jl = Cl.thickness / 2;
                sc(Tl, La, zl / Ul), sc(Tl, io, !0), sc(Tl, Fs, Math.round(zl)), sc(Tl, Do, Math.round(Ul));
                for (const {
                  bezier: ac
                } of Cl.paths) {
                  const zu = [];
                  Tl.paths.push(zu);
                  let Xu = Yl * (ac[0] - Jl), ed = Yl * (Ul - ac[1] - Jl);
                  for (let od = 2, ld = ac.length; od < ld; od += 6) {
                    const sd = Yl * (ac[od] - Jl), bd = Yl * (Ul - ac[od + 1] - Jl), $d = Yl * (ac[od + 2] - Jl), _d = Yl * (Ul - ac[od + 3] - Jl), tc = Yl * (ac[od + 4] - Jl), Xl = Yl * (Ul - ac[od + 5] - Jl);
                    zu.push([[Xu, ed], [sd, bd], [$d, _d], [tc, Xl]]), Xu = tc, ed = Xl;
                  }
                  const td = nc(this, xl, bf).call(this, zu);
                  Tl.bezierPath2D.push(td);
                }
                const Wl = nc(rc = Tl, Io, yf).call(rc);
                return sc(Tl, to, Math.max(ia, Wl[2] - Wl[0])), sc(Tl, Va, Math.max(ia, Wl[3] - Wl[1])), nc(uc = Tl, Io, gf).call(uc, zl, Ul), Tl;
              }
              serialize() {
                if (this.isEmpty())
                  return null;
                const Cl = this.getRect(0, 0), ml = this.rotation % 180 === 0 ? Cl[3] - Cl[1] : Cl[2] - Cl[0], Tl = ea.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                return {
                  annotationType: Qi.AnnotationEditorType.INK,
                  color: Tl,
                  thickness: this.thickness,
                  opacity: this.opacity,
                  paths: nc(this, Io, Yf).call(this, this.scaleFactor / this.parent.scaleFactor, this.translationX, this.translationY, ml),
                  pageIndex: this.parent.pageIndex,
                  rect: Cl,
                  rotation: this.rotation
                };
              }
            };
            La = new WeakMap(), Va = new WeakMap(), to = new WeakMap(), ro = new WeakMap(), no = new WeakMap(), eo = new WeakMap(), ao = new WeakMap(), io = new WeakMap(), xs = new WeakMap(), Ts = new WeakMap(), qs = new WeakMap(), Fs = new WeakMap(), Do = new WeakMap(), ys = new WeakMap(), Io = new WeakSet(), Uf = function(Cl) {
              const ml = this.thickness;
              this.parent.addCommands({
                cmd: () => {
                  this.thickness = Cl, nc(this, Io, Fd).call(this);
                },
                undo: () => {
                  this.thickness = ml, nc(this, Io, Fd).call(this);
                },
                mustExec: !0,
                type: Qi.AnnotationEditorParamsType.INK_THICKNESS,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, zf = function(Cl) {
              const ml = this.color;
              this.parent.addCommands({
                cmd: () => {
                  this.color = Cl, nc(this, Io, Td).call(this);
                },
                undo: () => {
                  this.color = ml, nc(this, Io, Td).call(this);
                },
                mustExec: !0,
                type: Qi.AnnotationEditorParamsType.INK_COLOR,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Hf = function(Cl) {
              Cl /= 100;
              const ml = this.opacity;
              this.parent.addCommands({
                cmd: () => {
                  this.opacity = Cl, nc(this, Io, Td).call(this);
                },
                undo: () => {
                  this.opacity = ml, nc(this, Io, Td).call(this);
                },
                mustExec: !0,
                type: Qi.AnnotationEditorParamsType.INK_OPACITY,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Kf = function() {
              const {
                width: Cl,
                height: ml,
                rotation: Tl
              } = this.parent.viewport;
              switch (Tl) {
                case 90:
                  return [0, Cl, Cl, ml];
                case 180:
                  return [Cl, ml, Cl, ml];
                case 270:
                  return [ml, 0, Cl, ml];
                default:
                  return [0, 0, Cl, ml];
              }
            }, mf = function() {
              this.ctx.lineWidth = this.thickness * this.parent.scaleFactor / this.scaleFactor, this.ctx.lineCap = "round", this.ctx.lineJoin = "round", this.ctx.miterLimit = 10, this.ctx.strokeStyle = `${this.color}${(0, na.opacityToHex)(this.opacity)}`;
            }, qf = function(Cl, ml) {
              this.isEditing = !0, Hl(this, xs) || (sc(this, xs, !0), nc(this, Io, Md).call(this), this.thickness || (this.thickness = _l._defaultThickness), this.color || (this.color = _l._defaultColor || ea.AnnotationEditor._defaultLineColor), this.opacity ?? (this.opacity = _l._defaultOpacity)), this.currentPath.push([Cl, ml]), sc(this, Ts, null), nc(this, Io, mf).call(this), this.ctx.beginPath(), this.ctx.moveTo(Cl, ml), sc(this, ys, () => {
                Hl(this, ys) && (Hl(this, Ts) && (this.isEmpty() ? (this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)) : nc(this, Io, Td).call(this), this.ctx.lineTo(...Hl(this, Ts)), sc(this, Ts, null), this.ctx.stroke()), window.requestAnimationFrame(Hl(this, ys)));
              }), window.requestAnimationFrame(Hl(this, ys));
            }, Wf = function(Cl, ml) {
              const [Tl, Ll] = this.currentPath.at(-1);
              Cl === Tl && ml === Ll || (this.currentPath.push([Cl, ml]), sc(this, Ts, [Cl, ml]));
            }, Gf = function(Cl, ml) {
              var Jl;
              this.ctx.closePath(), sc(this, ys, null), Cl = Math.min(Math.max(Cl, 0), this.canvas.width), ml = Math.min(Math.max(ml, 0), this.canvas.height);
              const [Tl, Ll] = this.currentPath.at(-1);
              (Cl !== Tl || ml !== Ll) && this.currentPath.push([Cl, ml]);
              let Vl;
              if (this.currentPath.length !== 1)
                Vl = (0, ra.fitCurve)(this.currentPath, 30, null);
              else {
                const Wl = [Cl, ml];
                Vl = [[Wl, Wl.slice(), Wl.slice(), Wl]];
              }
              const zl = nc(Jl = _l, xl, bf).call(Jl, Vl);
              this.currentPath.length = 0;
              const Ul = () => {
                this.paths.push(Vl), this.bezierPath2D.push(zl), this.rebuild();
              }, Yl = () => {
                this.paths.pop(), this.bezierPath2D.pop(), this.paths.length === 0 ? this.remove() : (this.canvas || (nc(this, Io, Hd).call(this), nc(this, Io, Kd).call(this)), nc(this, Io, Fd).call(this));
              };
              this.parent.addCommands({
                cmd: Ul,
                undo: Yl,
                mustExec: !0
              });
            }, Td = function() {
              if (this.isEmpty()) {
                nc(this, Io, qd).call(this);
                return;
              }
              nc(this, Io, mf).call(this);
              const {
                canvas: Cl,
                ctx: ml
              } = this;
              ml.setTransform(1, 0, 0, 1, 0, 0), ml.clearRect(0, 0, Cl.width, Cl.height), nc(this, Io, qd).call(this);
              for (const Tl of this.bezierPath2D)
                ml.stroke(Tl);
            }, vf = function(Cl) {
              nc(this, Io, Gf).call(this, Cl.offsetX, Cl.offsetY), this.canvas.removeEventListener("pointerleave", Hl(this, no)), this.canvas.removeEventListener("pointermove", Hl(this, ro)), this.parent.addToAnnotationStorage(this);
            }, Hd = function() {
              this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = 0, this.canvas.className = "inkEditorCanvas", _l._l10nPromise.get("editor_ink_canvas_aria_label").then((Cl) => this.canvas?.setAttribute("aria-label", Cl)), this.div.append(this.canvas), this.ctx = this.canvas.getContext("2d");
            }, Kd = function() {
              sc(this, qs, new ResizeObserver((Cl) => {
                const ml = Cl[0].contentRect;
                ml.width && ml.height && this.setDimensions(ml.width, ml.height);
              })), Hl(this, qs).observe(this.div);
            }, Md = function() {
              if (!Hl(this, xs))
                return;
              const [Cl, ml] = this.parent.viewportBaseDimensions;
              this.canvas.width = Math.ceil(this.width * Cl), this.canvas.height = Math.ceil(this.height * ml), nc(this, Io, qd).call(this);
            }, gf = function(Cl, ml) {
              const Tl = nc(this, Io, Wd).call(this), Ll = (Cl - Tl) / Hl(this, to), Vl = (ml - Tl) / Hl(this, Va);
              this.scaleFactor = Math.min(Ll, Vl);
            }, qd = function() {
              const Cl = nc(this, Io, Wd).call(this) / 2;
              this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + Cl, this.translationY * this.scaleFactor + Cl);
            }, xl = new WeakSet(), bf = function(Cl) {
              const ml = new Path2D();
              for (let Tl = 0, Ll = Cl.length; Tl < Ll; Tl++) {
                const [Vl, zl, Ul, Yl] = Cl[Tl];
                Tl === 0 && ml.moveTo(...Vl), ml.bezierCurveTo(zl[0], zl[1], Ul[0], Ul[1], Yl[0], Yl[1]);
              }
              return ml;
            }, Yf = function(Cl, ml, Tl, Ll) {
              const zl = [], Ul = this.thickness / 2;
              let Yl, Jl;
              for (const Wl of this.paths) {
                Yl = [], Jl = [];
                for (let rc = 0, uc = Wl.length; rc < uc; rc++) {
                  const [ac, zu, Xu, ed] = Wl[rc], td = Cl * (ac[0] + ml) + Ul, od = Ll - Cl * (ac[1] + Tl) - Ul, ld = Cl * (zu[0] + ml) + Ul, sd = Ll - Cl * (zu[1] + Tl) - Ul, bd = Cl * (Xu[0] + ml) + Ul, $d = Ll - Cl * (Xu[1] + Tl) - Ul, _d = Cl * (ed[0] + ml) + Ul, tc = Ll - Cl * (ed[1] + Tl) - Ul;
                  rc === 0 && (Yl.push(td, od), Jl.push(td, od)), Yl.push(ld, sd, bd, $d, _d, tc), nc(this, Io, Zf).call(this, td, od, ld, sd, bd, $d, _d, tc, 4, Jl);
                }
                zl.push({
                  bezier: Yl,
                  points: Jl
                });
              }
              return zl;
            }, Zf = function(Cl, ml, Tl, Ll, Vl, zl, Ul, Yl, Jl, Wl) {
              if (nc(this, Io, Xf).call(this, Cl, ml, Tl, Ll, Vl, zl, Ul, Yl)) {
                Wl.push(Ul, Yl);
                return;
              }
              for (let rc = 1; rc < Jl - 1; rc++) {
                const uc = rc / Jl, ac = 1 - uc;
                let zu = uc * Cl + ac * Tl, Xu = uc * ml + ac * Ll, ed = uc * Tl + ac * Vl, td = uc * Ll + ac * zl;
                const od = uc * Vl + ac * Ul, ld = uc * zl + ac * Yl;
                zu = uc * zu + ac * ed, Xu = uc * Xu + ac * td, ed = uc * ed + ac * od, td = uc * td + ac * ld, zu = uc * zu + ac * ed, Xu = uc * Xu + ac * td, Wl.push(zu, Xu);
              }
              Wl.push(Ul, Yl);
            }, Xf = function(Cl, ml, Tl, Ll, Vl, zl, Ul, Yl) {
              const Wl = (3 * Tl - 2 * Cl - Ul) ** 2, rc = (3 * Ll - 2 * ml - Yl) ** 2, uc = (3 * Vl - Cl - 2 * Ul) ** 2, ac = (3 * zl - ml - 2 * Yl) ** 2;
              return Math.max(Wl, uc) + Math.max(rc, ac) <= 10;
            }, yf = function() {
              let Cl = 1 / 0, ml = -1 / 0, Tl = 1 / 0, Ll = -1 / 0;
              for (const Vl of this.paths)
                for (const [zl, Ul, Yl, Jl] of Vl) {
                  const Wl = Qi.Util.bezierBoundingBox(...zl, ...Ul, ...Yl, ...Jl);
                  Cl = Math.min(Cl, Wl[0]), Tl = Math.min(Tl, Wl[1]), ml = Math.max(ml, Wl[2]), Ll = Math.max(Ll, Wl[3]);
                }
              return [Cl, Tl, ml, Ll];
            }, Wd = function() {
              return Hl(this, io) ? Math.ceil(this.thickness * this.parent.scaleFactor) : 0;
            }, Fd = function(Cl = !1) {
              if (this.isEmpty())
                return;
              if (!Hl(this, io)) {
                nc(this, Io, Td).call(this);
                return;
              }
              const ml = nc(this, Io, yf).call(this), Tl = nc(this, Io, Wd).call(this);
              sc(this, to, Math.max(ia, ml[2] - ml[0])), sc(this, Va, Math.max(ia, ml[3] - ml[1]));
              const Ll = Math.ceil(Tl + Hl(this, to) * this.scaleFactor), Vl = Math.ceil(Tl + Hl(this, Va) * this.scaleFactor), [zl, Ul] = this.parent.viewportBaseDimensions;
              this.width = Ll / zl, this.height = Vl / Ul, sc(this, La, Ll / Vl), nc(this, Io, $f).call(this);
              const Yl = this.translationX, Jl = this.translationY;
              this.translationX = -ml[0], this.translationY = -ml[1], nc(this, Io, Md).call(this), nc(this, Io, Td).call(this), sc(this, Fs, Ll), sc(this, Do, Vl), this.setDims(Ll, Vl);
              const Wl = Cl ? Tl / this.scaleFactor / 2 : 0;
              this.translate(Yl - this.translationX - Wl, Jl - this.translationY - Wl);
            }, $f = function() {
              const {
                style: Cl
              } = this.div;
              Hl(this, La) >= 1 ? (Cl.minHeight = `${ia}px`, Cl.minWidth = `${Math.round(Hl(this, La) * ia)}px`) : (Cl.minWidth = `${ia}px`, Cl.minHeight = `${Math.round(ia / Hl(this, La))}px`);
            }, oc(_l, xl), cd(_l, "_defaultColor", null), cd(_l, "_defaultOpacity", 1), cd(_l, "_defaultThickness", 1), cd(_l, "_l10nPromise"), cd(_l, "_type", "ink");
            let fa = _l;
            e.InkEditor = fa;
          },
          /* 25 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.fitCurve = void 0;
            const Qi = Zi(26);
            e.fitCurve = Qi;
          },
          /* 26 */
          /***/
          (Bi) => {
            function e(eo, ao, io) {
              if (!Array.isArray(eo))
                throw new TypeError("First argument should be an array");
              if (eo.forEach((Fs) => {
                if (!Array.isArray(Fs) || Fs.some((Do) => typeof Do != "number") || Fs.length !== eo[0].length)
                  throw Error("Each point should be an array of numbers. Each point should have the same amount of numbers.");
              }), eo = eo.filter((Fs, Do) => Do === 0 || !Fs.every((ys, Io) => ys === eo[Do - 1][Io])), eo.length < 2)
                return [];
              const xs = eo.length, Ts = to(eo[1], eo[0]), qs = to(eo[xs - 2], eo[xs - 1]);
              return Zi(eo, Ts, qs, ao, io);
            }
            function Zi(eo, ao, io, xs, Ts) {
              var Fs, Do, ys, Io, so, os, Xs, gl, Sl, El, wl, jl, kl;
              if (eo.length === 2)
                return jl = ro.vectorLen(ro.subtract(eo[0], eo[1])) / 3, Fs = [eo[0], ro.addArrays(eo[0], ro.mulItems(ao, jl)), ro.addArrays(eo[1], ro.mulItems(io, jl)), eo[1]], [Fs];
              if (Do = ia(eo), [Fs, Io, os] = Qi(eo, Do, Do, ao, io, Ts), Io === 0 || Io < xs)
                return [Fs];
              if (Io < xs * xs)
                for (ys = Do, so = Io, Xs = os, kl = 0; kl < 20; kl++) {
                  if (ys = ra(Fs, eo, ys), [Fs, Io, os] = Qi(eo, Do, ys, ao, io, Ts), Io < xs)
                    return [Fs];
                  if (os === Xs) {
                    let Fl = Io / so;
                    if (Fl > 0.9999 && Fl < 1.0001)
                      break;
                  }
                  so = Io, Xs = os;
                }
              return wl = [], gl = ro.subtract(eo[os - 1], eo[os + 1]), gl.every((Fl) => Fl === 0) && (gl = ro.subtract(eo[os - 1], eo[os]), [gl[0], gl[1]] = [-gl[1], gl[0]]), Sl = ro.normalize(gl), El = ro.mulItems(Sl, -1), wl = wl.concat(Zi(eo.slice(0, os + 1), ao, Sl, xs, Ts)), wl = wl.concat(Zi(eo.slice(os), El, io, xs, Ts)), wl;
            }
            function Qi(eo, ao, io, xs, Ts, qs) {
              var Fs, Do, ys;
              return Fs = ea(eo, io, xs, Ts), [Do, ys] = fa(eo, Fs, ao), qs && qs({
                bez: Fs,
                points: eo,
                params: ao,
                maxErr: Do,
                maxPoint: ys
              }), [Fs, Do, ys];
            }
            function ea(eo, ao, io, xs) {
              var Ts, qs, Fs, Do, ys, Io, so, os, Xs, gl, Sl, El, wl, jl, kl, Fl, Ml, ql = eo[0], Kl = eo[eo.length - 1];
              for (Ts = [ql, null, null, Kl], qs = ro.zeros_Xx2x2(ao.length), wl = 0, jl = ao.length; wl < jl; wl++)
                Fl = ao[wl], Ml = 1 - Fl, Fs = qs[wl], Fs[0] = ro.mulItems(io, 3 * Fl * (Ml * Ml)), Fs[1] = ro.mulItems(xs, 3 * Ml * (Fl * Fl));
              for (Do = [[0, 0], [0, 0]], ys = [0, 0], wl = 0, jl = eo.length; wl < jl; wl++)
                Fl = ao[wl], Fs = qs[wl], Do[0][0] += ro.dot(Fs[0], Fs[0]), Do[0][1] += ro.dot(Fs[0], Fs[1]), Do[1][0] += ro.dot(Fs[0], Fs[1]), Do[1][1] += ro.dot(Fs[1], Fs[1]), kl = ro.subtract(eo[wl], no.q([ql, ql, Kl, Kl], Fl)), ys[0] += ro.dot(Fs[0], kl), ys[1] += ro.dot(Fs[1], kl);
              return Io = Do[0][0] * Do[1][1] - Do[1][0] * Do[0][1], so = Do[0][0] * ys[1] - Do[1][0] * ys[0], os = ys[0] * Do[1][1] - ys[1] * Do[0][1], Xs = Io === 0 ? 0 : os / Io, gl = Io === 0 ? 0 : so / Io, El = ro.vectorLen(ro.subtract(ql, Kl)), Sl = 1e-6 * El, Xs < Sl || gl < Sl ? (Ts[1] = ro.addArrays(ql, ro.mulItems(io, El / 3)), Ts[2] = ro.addArrays(Kl, ro.mulItems(xs, El / 3))) : (Ts[1] = ro.addArrays(ql, ro.mulItems(io, Xs)), Ts[2] = ro.addArrays(Kl, ro.mulItems(xs, gl))), Ts;
            }
            function ra(eo, ao, io) {
              return io.map((xs, Ts) => na(eo, ao[Ts], xs));
            }
            function na(eo, ao, io) {
              var xs = ro.subtract(no.q(eo, io), ao), Ts = no.qprime(eo, io), qs = ro.mulMatrix(xs, Ts), Fs = ro.sum(ro.squareItems(Ts)) + 2 * ro.mulMatrix(xs, no.qprimeprime(eo, io));
              return Fs === 0 ? io : io - qs / Fs;
            }
            function ia(eo) {
              var ao = [], io, xs, Ts;
              return eo.forEach((qs, Fs) => {
                io = Fs ? xs + ro.vectorLen(ro.subtract(qs, Ts)) : 0, ao.push(io), xs = io, Ts = qs;
              }), ao = ao.map((qs) => qs / xs), ao;
            }
            function fa(eo, ao, io) {
              var xs, Ts, qs, Fs, Do, ys, Io, so;
              Ts = 0, qs = Math.floor(eo.length / 2);
              const os = La(ao, 10);
              for (Do = 0, ys = eo.length; Do < ys; Do++)
                Io = eo[Do], so = Va(ao, io[Do], os, 10), Fs = ro.subtract(no.q(ao, so), Io), xs = Fs[0] * Fs[0] + Fs[1] * Fs[1], xs > Ts && (Ts = xs, qs = Do);
              return [Ts, qs];
            }
            var La = function(eo, ao) {
              for (var io, xs = [0], Ts = eo[0], qs = 0, Fs = 1; Fs <= ao; Fs++)
                io = no.q(eo, Fs / ao), qs += ro.vectorLen(ro.subtract(io, Ts)), xs.push(qs), Ts = io;
              return xs = xs.map((Do) => Do / qs), xs;
            };
            function Va(eo, ao, io, xs) {
              if (ao < 0)
                return 0;
              if (ao > 1)
                return 1;
              for (var Ts, qs, Fs, Do, ys, Io = 1; Io <= xs; Io++)
                if (ao <= io[Io]) {
                  Do = (Io - 1) / xs, Fs = Io / xs, qs = io[Io - 1], Ts = io[Io], ys = (ao - qs) / (Ts - qs) * (Fs - Do) + Do;
                  break;
                }
              return ys;
            }
            function to(eo, ao) {
              return ro.normalize(ro.subtract(eo, ao));
            }
            class ro {
              static zeros_Xx2x2(ao) {
                for (var io = []; ao--; )
                  io.push([0, 0]);
                return io;
              }
              static mulItems(ao, io) {
                return ao.map((xs) => xs * io);
              }
              static mulMatrix(ao, io) {
                return ao.reduce((xs, Ts, qs) => xs + Ts * io[qs], 0);
              }
              static subtract(ao, io) {
                return ao.map((xs, Ts) => xs - io[Ts]);
              }
              static addArrays(ao, io) {
                return ao.map((xs, Ts) => xs + io[Ts]);
              }
              static addItems(ao, io) {
                return ao.map((xs) => xs + io);
              }
              static sum(ao) {
                return ao.reduce((io, xs) => io + xs);
              }
              static dot(ao, io) {
                return ro.mulMatrix(ao, io);
              }
              static vectorLen(ao) {
                return Math.hypot(...ao);
              }
              static divItems(ao, io) {
                return ao.map((xs) => xs / io);
              }
              static squareItems(ao) {
                return ao.map((io) => io * io);
              }
              static normalize(ao) {
                return this.divItems(ao, this.vectorLen(ao));
              }
            }
            class no {
              static q(ao, io) {
                var xs = 1 - io, Ts = ro.mulItems(ao[0], xs * xs * xs), qs = ro.mulItems(ao[1], 3 * xs * xs * io), Fs = ro.mulItems(ao[2], 3 * xs * io * io), Do = ro.mulItems(ao[3], io * io * io);
                return ro.addArrays(ro.addArrays(Ts, qs), ro.addArrays(Fs, Do));
              }
              static qprime(ao, io) {
                var xs = 1 - io, Ts = ro.mulItems(ro.subtract(ao[1], ao[0]), 3 * xs * xs), qs = ro.mulItems(ro.subtract(ao[2], ao[1]), 6 * xs * io), Fs = ro.mulItems(ro.subtract(ao[3], ao[2]), 3 * io * io);
                return ro.addArrays(ro.addArrays(Ts, qs), Fs);
              }
              static qprimeprime(ao, io) {
                return ro.addArrays(ro.mulItems(ro.addArrays(ro.subtract(ao[2], ro.mulItems(ao[1], 2)), ao[0]), 6 * (1 - io)), ro.mulItems(ro.addArrays(ro.subtract(ao[3], ro.mulItems(ao[2], 2)), ao[1]), 6 * io));
              }
            }
            Bi.exports = e, Bi.exports.fitCubic = Zi, Bi.exports.createTangent = to;
          },
          /* 27 */
          /***/
          (Bi, e, Zi) => {
            var xl, _f, Ef, Sf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.AnnotationLayer = void 0;
            var Qi = Zi(1), ea = Zi(8), ra = Zi(5), na = Zi(28), ia = Zi(29);
            const fa = 1e3, La = 9, Va = /* @__PURE__ */ new WeakSet();
            function to(Ol) {
              return {
                width: Ol[2] - Ol[0],
                height: Ol[3] - Ol[1]
              };
            }
            class ro {
              static create(To) {
                switch (To.data.annotationType) {
                  case Qi.AnnotationType.LINK:
                    return new eo(To);
                  case Qi.AnnotationType.TEXT:
                    return new ao(To);
                  case Qi.AnnotationType.WIDGET:
                    switch (To.data.fieldType) {
                      case "Tx":
                        return new xs(To);
                      case "Btn":
                        return To.data.radioButton ? new qs(To) : To.data.checkBox ? new Ts(To) : new Fs(To);
                      case "Ch":
                        return new Do(To);
                    }
                    return new io(To);
                  case Qi.AnnotationType.POPUP:
                    return new ys(To);
                  case Qi.AnnotationType.FREETEXT:
                    return new so(To);
                  case Qi.AnnotationType.LINE:
                    return new os(To);
                  case Qi.AnnotationType.SQUARE:
                    return new Xs(To);
                  case Qi.AnnotationType.CIRCLE:
                    return new gl(To);
                  case Qi.AnnotationType.POLYLINE:
                    return new Sl(To);
                  case Qi.AnnotationType.CARET:
                    return new wl(To);
                  case Qi.AnnotationType.INK:
                    return new jl(To);
                  case Qi.AnnotationType.POLYGON:
                    return new El(To);
                  case Qi.AnnotationType.HIGHLIGHT:
                    return new kl(To);
                  case Qi.AnnotationType.UNDERLINE:
                    return new Fl(To);
                  case Qi.AnnotationType.SQUIGGLY:
                    return new Ml(To);
                  case Qi.AnnotationType.STRIKEOUT:
                    return new ql(To);
                  case Qi.AnnotationType.STAMP:
                    return new Kl(To);
                  case Qi.AnnotationType.FILEATTACHMENT:
                    return new Zl(To);
                  default:
                    return new no(To);
                }
              }
            }
            class no {
              constructor(To, {
                isRenderable: Os = !1,
                ignoreBorder: $l = !1,
                createQuadrilaterals: _l = !1
              } = {}) {
                this.isRenderable = Os, this.data = To.data, this.layer = To.layer, this.page = To.page, this.viewport = To.viewport, this.linkService = To.linkService, this.downloadManager = To.downloadManager, this.imageResourcesPath = To.imageResourcesPath, this.renderForms = To.renderForms, this.svgFactory = To.svgFactory, this.annotationStorage = To.annotationStorage, this.enableScripting = To.enableScripting, this.hasJSActions = To.hasJSActions, this._fieldObjects = To.fieldObjects, this._mouseState = To.mouseState, Os && (this.container = this._createContainer($l)), _l && (this.quadrilaterals = this._createQuadrilaterals($l));
              }
              _createContainer(To = !1) {
                const Os = this.data, $l = this.page, _l = this.viewport, Al = document.createElement("section"), {
                  width: Rl,
                  height: Cl
                } = to(Os.rect), [ml, Tl, Ll, Vl] = _l.viewBox, zl = Ll - ml, Ul = Vl - Tl;
                Al.setAttribute("data-annotation-id", Os.id);
                const Yl = Qi.Util.normalizeRect([Os.rect[0], $l.view[3] - Os.rect[1] + $l.view[1], Os.rect[2], $l.view[3] - Os.rect[3] + $l.view[1]]);
                if (!To && Os.borderStyle.width > 0) {
                  Al.style.borderWidth = `${Os.borderStyle.width}px`;
                  const Wl = Os.borderStyle.horizontalCornerRadius, rc = Os.borderStyle.verticalCornerRadius;
                  if (Wl > 0 || rc > 0) {
                    const ac = `calc(${Wl}px * var(--scale-factor)) / calc(${rc}px * var(--scale-factor))`;
                    Al.style.borderRadius = ac;
                  } else if (this instanceof qs) {
                    const ac = `calc(${Rl}px * var(--scale-factor)) / calc(${Cl}px * var(--scale-factor))`;
                    Al.style.borderRadius = ac;
                  }
                  switch (Os.borderStyle.style) {
                    case Qi.AnnotationBorderStyleType.SOLID:
                      Al.style.borderStyle = "solid";
                      break;
                    case Qi.AnnotationBorderStyleType.DASHED:
                      Al.style.borderStyle = "dashed";
                      break;
                    case Qi.AnnotationBorderStyleType.BEVELED:
                      (0, Qi.warn)("Unimplemented border style: beveled");
                      break;
                    case Qi.AnnotationBorderStyleType.INSET:
                      (0, Qi.warn)("Unimplemented border style: inset");
                      break;
                    case Qi.AnnotationBorderStyleType.UNDERLINE:
                      Al.style.borderBottomStyle = "solid";
                      break;
                  }
                  const uc = Os.borderColor || null;
                  uc ? Al.style.borderColor = Qi.Util.makeHexColor(uc[0] | 0, uc[1] | 0, uc[2] | 0) : Al.style.borderWidth = 0;
                }
                Al.style.left = `${100 * (Yl[0] - ml) / zl}%`, Al.style.top = `${100 * (Yl[1] - Tl) / Ul}%`;
                const {
                  rotation: Jl
                } = Os;
                return Os.hasOwnCanvas || Jl === 0 ? (Al.style.width = `${100 * Rl / zl}%`, Al.style.height = `${100 * Cl / Ul}%`) : this.setRotation(Jl, Al), Al;
              }
              setRotation(To, Os = this.container) {
                const [$l, _l, Al, Rl] = this.viewport.viewBox, Cl = Al - $l, ml = Rl - _l, {
                  width: Tl,
                  height: Ll
                } = to(this.data.rect);
                let Vl, zl;
                To % 180 === 0 ? (Vl = 100 * Tl / Cl, zl = 100 * Ll / ml) : (Vl = 100 * Ll / Cl, zl = 100 * Tl / ml), Os.style.width = `${Vl}%`, Os.style.height = `${zl}%`, Os.setAttribute("data-main-rotation", (360 - To) % 360);
              }
              get _commonActions() {
                const To = (Os, $l, _l) => {
                  const Al = _l.detail[Os];
                  _l.target.style[$l] = na.ColorConverters[`${Al[0]}_HTML`](Al.slice(1));
                };
                return (0, Qi.shadow)(this, "_commonActions", {
                  display: (Os) => {
                    const $l = Os.detail.display % 2 === 1;
                    this.container.style.visibility = $l ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                      hidden: $l,
                      print: Os.detail.display === 0 || Os.detail.display === 3
                    });
                  },
                  print: (Os) => {
                    this.annotationStorage.setValue(this.data.id, {
                      print: Os.detail.print
                    });
                  },
                  hidden: (Os) => {
                    this.container.style.visibility = Os.detail.hidden ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                      hidden: Os.detail.hidden
                    });
                  },
                  focus: (Os) => {
                    setTimeout(() => Os.target.focus({
                      preventScroll: !1
                    }), 0);
                  },
                  userName: (Os) => {
                    Os.target.title = Os.detail.userName;
                  },
                  readonly: (Os) => {
                    Os.detail.readonly ? Os.target.setAttribute("readonly", "") : Os.target.removeAttribute("readonly");
                  },
                  required: (Os) => {
                    this._setRequired(Os.target, Os.detail.required);
                  },
                  bgColor: (Os) => {
                    To("bgColor", "backgroundColor", Os);
                  },
                  fillColor: (Os) => {
                    To("fillColor", "backgroundColor", Os);
                  },
                  fgColor: (Os) => {
                    To("fgColor", "color", Os);
                  },
                  textColor: (Os) => {
                    To("textColor", "color", Os);
                  },
                  borderColor: (Os) => {
                    To("borderColor", "borderColor", Os);
                  },
                  strokeColor: (Os) => {
                    To("strokeColor", "borderColor", Os);
                  },
                  rotation: (Os) => {
                    const $l = Os.detail.rotation;
                    this.setRotation($l), this.annotationStorage.setValue(this.data.id, {
                      rotation: $l
                    });
                  }
                });
              }
              _dispatchEventFromSandbox(To, Os) {
                const $l = this._commonActions;
                for (const _l of Object.keys(Os.detail)) {
                  const Al = To[_l] || $l[_l];
                  Al && Al(Os);
                }
              }
              _setDefaultPropertiesFromJS(To) {
                if (!this.enableScripting)
                  return;
                const Os = this.annotationStorage.getRawValue(this.data.id);
                if (!Os)
                  return;
                const $l = this._commonActions;
                for (const [_l, Al] of Object.entries(Os)) {
                  const Rl = $l[_l];
                  if (Rl) {
                    const Cl = {
                      detail: {
                        [_l]: Al
                      },
                      target: To
                    };
                    Rl(Cl), delete Os[_l];
                  }
                }
              }
              _createQuadrilaterals(To = !1) {
                if (!this.data.quadPoints)
                  return null;
                const Os = [], $l = this.data.rect;
                for (const _l of this.data.quadPoints)
                  this.data.rect = [_l[2].x, _l[2].y, _l[1].x, _l[1].y], Os.push(this._createContainer(To));
                return this.data.rect = $l, Os;
              }
              _createPopup(To, Os) {
                let $l = this.container;
                this.quadrilaterals && (To = To || this.quadrilaterals, $l = this.quadrilaterals[0]), To || (To = document.createElement("div"), To.className = "popupTriggerArea", $l.append(To));
                const Al = new Io({
                  container: $l,
                  trigger: To,
                  color: Os.color,
                  titleObj: Os.titleObj,
                  modificationDate: Os.modificationDate,
                  contentsObj: Os.contentsObj,
                  richText: Os.richText,
                  hideWrapper: !0
                }).render();
                Al.style.left = "100%", $l.append(Al);
              }
              _renderQuadrilaterals(To) {
                for (const Os of this.quadrilaterals)
                  Os.className = To;
                return this.quadrilaterals;
              }
              render() {
                (0, Qi.unreachable)("Abstract method `AnnotationElement.render` called");
              }
              _getElementsByName(To, Os = null) {
                const $l = [];
                if (this._fieldObjects) {
                  const _l = this._fieldObjects[To];
                  if (_l)
                    for (const {
                      page: Al,
                      id: Rl,
                      exportValues: Cl
                    } of _l) {
                      if (Al === -1 || Rl === Os)
                        continue;
                      const ml = typeof Cl == "string" ? Cl : null, Tl = document.querySelector(`[data-element-id="${Rl}"]`);
                      if (Tl && !Va.has(Tl)) {
                        (0, Qi.warn)(`_getElementsByName - element not allowed: ${Rl}`);
                        continue;
                      }
                      $l.push({
                        id: Rl,
                        exportValue: ml,
                        domElement: Tl
                      });
                    }
                  return $l;
                }
                for (const _l of document.getElementsByName(To)) {
                  const {
                    id: Al,
                    exportValue: Rl
                  } = _l;
                  Al !== Os && Va.has(_l) && $l.push({
                    id: Al,
                    exportValue: Rl,
                    domElement: _l
                  });
                }
                return $l;
              }
              static get platform() {
                const To = typeof navigator < "u" ? navigator.platform : "";
                return (0, Qi.shadow)(this, "platform", {
                  isWin: To.includes("Win"),
                  isMac: To.includes("Mac")
                });
              }
            }
            class eo extends no {
              constructor(To, Os = null) {
                super(To, {
                  isRenderable: !0,
                  ignoreBorder: !!Os?.ignoreBorder,
                  createQuadrilaterals: !0
                }), this.isTooltipOnly = To.data.isTooltipOnly;
              }
              render() {
                const {
                  data: To,
                  linkService: Os
                } = this, $l = document.createElement("a");
                $l.setAttribute("data-element-id", To.id);
                let _l = !1;
                return To.url ? (Os.addLinkAttributes($l, To.url, To.newWindow), _l = !0) : To.action ? (this._bindNamedAction($l, To.action), _l = !0) : To.dest ? (this._bindLink($l, To.dest), _l = !0) : (To.actions && (To.actions.Action || To.actions["Mouse Up"] || To.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction($l, To), _l = !0), To.resetForm ? (this._bindResetFormAction($l, To.resetForm), _l = !0) : this.isTooltipOnly && !_l && (this._bindLink($l, ""), _l = !0)), this.quadrilaterals ? this._renderQuadrilaterals("linkAnnotation").map((Al, Rl) => {
                  const Cl = Rl === 0 ? $l : $l.cloneNode();
                  return Al.append(Cl), Al;
                }) : (this.container.className = "linkAnnotation", _l && this.container.append($l), this.container);
              }
              _bindLink(To, Os) {
                To.href = this.linkService.getDestinationHash(Os), To.onclick = () => (Os && this.linkService.goToDestination(Os), !1), (Os || Os === "") && (To.className = "internalLink");
              }
              _bindNamedAction(To, Os) {
                To.href = this.linkService.getAnchorUrl(""), To.onclick = () => (this.linkService.executeNamedAction(Os), !1), To.className = "internalLink";
              }
              _bindJSAction(To, Os) {
                To.href = this.linkService.getAnchorUrl("");
                const $l = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
                for (const _l of Object.keys(Os.actions)) {
                  const Al = $l.get(_l);
                  Al && (To[Al] = () => (this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: Os.id,
                      name: _l
                    }
                  }), !1));
                }
                To.onclick || (To.onclick = () => !1), To.className = "internalLink";
              }
              _bindResetFormAction(To, Os) {
                const $l = To.onclick;
                if ($l || (To.href = this.linkService.getAnchorUrl("")), To.className = "internalLink", !this._fieldObjects) {
                  (0, Qi.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), $l || (To.onclick = () => !1);
                  return;
                }
                To.onclick = () => {
                  $l && $l();
                  const {
                    fields: _l,
                    refs: Al,
                    include: Rl
                  } = Os, Cl = [];
                  if (_l.length !== 0 || Al.length !== 0) {
                    const Ll = new Set(Al);
                    for (const Vl of _l) {
                      const zl = this._fieldObjects[Vl] || [];
                      for (const {
                        id: Ul
                      } of zl)
                        Ll.add(Ul);
                    }
                    for (const Vl of Object.values(this._fieldObjects))
                      for (const zl of Vl)
                        Ll.has(zl.id) === Rl && Cl.push(zl);
                  } else
                    for (const Ll of Object.values(this._fieldObjects))
                      Cl.push(...Ll);
                  const ml = this.annotationStorage, Tl = [];
                  for (const Ll of Cl) {
                    const {
                      id: Vl
                    } = Ll;
                    switch (Tl.push(Vl), Ll.type) {
                      case "text": {
                        const Ul = Ll.defaultValue || "";
                        ml.setValue(Vl, {
                          value: Ul
                        });
                        break;
                      }
                      case "checkbox":
                      case "radiobutton": {
                        const Ul = Ll.defaultValue === Ll.exportValues;
                        ml.setValue(Vl, {
                          value: Ul
                        });
                        break;
                      }
                      case "combobox":
                      case "listbox": {
                        const Ul = Ll.defaultValue || "";
                        ml.setValue(Vl, {
                          value: Ul
                        });
                        break;
                      }
                      default:
                        continue;
                    }
                    const zl = document.querySelector(`[data-element-id="${Vl}"]`);
                    if (zl) {
                      if (!Va.has(zl)) {
                        (0, Qi.warn)(`_bindResetFormAction - element not allowed: ${Vl}`);
                        continue;
                      }
                    } else continue;
                    zl.dispatchEvent(new Event("resetform"));
                  }
                  return this.enableScripting && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: "app",
                      ids: Tl,
                      name: "ResetForm"
                    }
                  }), !1;
                };
              }
            }
            class ao extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os
                });
              }
              render() {
                this.container.className = "textAnnotation";
                const To = document.createElement("img");
                return To.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", To.alt = "[{{type}} Annotation]", To.dataset.l10nId = "text_annotation_type", To.dataset.l10nArgs = JSON.stringify({
                  type: this.data.name
                }), this.data.hasPopup || this._createPopup(To, this.data), this.container.append(To), this.container;
              }
            }
            class io extends no {
              render() {
                return this.data.alternativeText && (this.container.title = this.data.alternativeText), this.container;
              }
              _getKeyModifier(To) {
                const {
                  isWin: Os,
                  isMac: $l
                } = no.platform;
                return Os && To.ctrlKey || $l && To.metaKey;
              }
              _setEventListener(To, Os, $l, _l) {
                Os.includes("mouse") ? To.addEventListener(Os, (Al) => {
                  this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: $l,
                      value: _l(Al),
                      shift: Al.shiftKey,
                      modifier: this._getKeyModifier(Al)
                    }
                  });
                }) : To.addEventListener(Os, (Al) => {
                  this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: $l,
                      value: _l(Al)
                    }
                  });
                });
              }
              _setEventListeners(To, Os, $l) {
                for (const [_l, Al] of Os)
                  (Al === "Action" || this.data.actions?.[Al]) && this._setEventListener(To, _l, Al, $l);
              }
              _setBackgroundColor(To) {
                const Os = this.data.backgroundColor || null;
                To.style.backgroundColor = Os === null ? "transparent" : Qi.Util.makeHexColor(Os[0], Os[1], Os[2]);
              }
              _setTextStyle(To) {
                const Os = ["left", "center", "right"], {
                  fontColor: $l
                } = this.data.defaultAppearanceData, _l = this.data.defaultAppearanceData.fontSize || La, Al = To.style;
                let Rl;
                if (this.data.multiLine) {
                  const Cl = Math.abs(this.data.rect[3] - this.data.rect[1]), ml = Math.round(Cl / (Qi.LINE_FACTOR * _l)) || 1, Tl = Cl / ml;
                  Rl = Math.min(_l, Math.round(Tl / Qi.LINE_FACTOR));
                } else {
                  const Cl = Math.abs(this.data.rect[3] - this.data.rect[1]);
                  Rl = Math.min(_l, Math.round(Cl / Qi.LINE_FACTOR));
                }
                Al.fontSize = `calc(${Rl}px * var(--scale-factor))`, Al.color = Qi.Util.makeHexColor($l[0], $l[1], $l[2]), this.data.textAlignment !== null && (Al.textAlign = Os[this.data.textAlignment]);
              }
              _setRequired(To, Os) {
                Os ? To.setAttribute("required", !0) : To.removeAttribute("required"), To.setAttribute("aria-required", Os);
              }
            }
            class xs extends io {
              constructor(To) {
                const Os = To.renderForms || !To.data.hasAppearance && !!To.data.fieldValue;
                super(To, {
                  isRenderable: Os
                });
              }
              setPropertyOnSiblings(To, Os, $l, _l) {
                const Al = this.annotationStorage;
                for (const Rl of this._getElementsByName(To.name, To.id))
                  Rl.domElement && (Rl.domElement[Os] = $l), Al.setValue(Rl.id, {
                    [_l]: $l
                  });
              }
              render() {
                const To = this.annotationStorage, Os = this.data.id;
                this.container.className = "textWidgetAnnotation";
                let $l = null;
                if (this.renderForms) {
                  const _l = To.getValue(Os, {
                    value: this.data.fieldValue
                  });
                  let Al = _l.formattedValue || _l.value || "";
                  const Rl = To.getValue(Os, {
                    charLimit: this.data.maxLen
                  }).charLimit;
                  Rl && Al.length > Rl && (Al = Al.slice(0, Rl));
                  const Cl = {
                    userValue: Al,
                    formattedValue: null,
                    valueOnFocus: ""
                  };
                  this.data.multiLine ? ($l = document.createElement("textarea"), $l.textContent = Al, this.data.doNotScroll && ($l.style.overflowY = "hidden")) : ($l = document.createElement("input"), $l.type = "text", $l.setAttribute("value", Al), this.data.doNotScroll && ($l.style.overflowX = "hidden")), Va.add($l), $l.setAttribute("data-element-id", Os), $l.disabled = this.data.readOnly, $l.name = this.data.fieldName, $l.tabIndex = fa, this._setRequired($l, this.data.required), Rl && ($l.maxLength = Rl), $l.addEventListener("input", (Tl) => {
                    To.setValue(Os, {
                      value: Tl.target.value
                    }), this.setPropertyOnSiblings($l, "value", Tl.target.value, "value");
                  }), $l.addEventListener("resetform", (Tl) => {
                    const Ll = this.data.defaultFieldValue ?? "";
                    $l.value = Cl.userValue = Ll, Cl.formattedValue = null;
                  });
                  let ml = (Tl) => {
                    const {
                      formattedValue: Ll
                    } = Cl;
                    Ll != null && (Tl.target.value = Ll), Tl.target.scrollLeft = 0;
                  };
                  if (this.enableScripting && this.hasJSActions) {
                    $l.addEventListener("focus", (Ll) => {
                      Cl.userValue && (Ll.target.value = Cl.userValue), Cl.valueOnFocus = Ll.target.value;
                    }), $l.addEventListener("updatefromsandbox", (Ll) => {
                      const Vl = {
                        value(zl) {
                          Cl.userValue = zl.detail.value ?? "", To.setValue(Os, {
                            value: Cl.userValue.toString()
                          }), zl.target.value = Cl.userValue;
                        },
                        formattedValue(zl) {
                          const {
                            formattedValue: Ul
                          } = zl.detail;
                          Cl.formattedValue = Ul, Ul != null && zl.target !== document.activeElement && (zl.target.value = Ul), To.setValue(Os, {
                            formattedValue: Ul
                          });
                        },
                        selRange(zl) {
                          zl.target.setSelectionRange(...zl.detail.selRange);
                        },
                        charLimit: (zl) => {
                          const {
                            charLimit: Ul
                          } = zl.detail, {
                            target: Yl
                          } = zl;
                          if (Ul === 0) {
                            Yl.removeAttribute("maxLength");
                            return;
                          }
                          Yl.setAttribute("maxLength", Ul);
                          let Jl = Cl.userValue;
                          !Jl || Jl.length <= Ul || (Jl = Jl.slice(0, Ul), Yl.value = Cl.userValue = Jl, To.setValue(Os, {
                            value: Jl
                          }), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                            source: this,
                            detail: {
                              id: Os,
                              name: "Keystroke",
                              value: Jl,
                              willCommit: !0,
                              commitKey: 1,
                              selStart: Yl.selectionStart,
                              selEnd: Yl.selectionEnd
                            }
                          }));
                        }
                      };
                      this._dispatchEventFromSandbox(Vl, Ll);
                    }), $l.addEventListener("keydown", (Ll) => {
                      let Vl = -1;
                      if (Ll.key === "Escape" ? Vl = 0 : Ll.key === "Enter" ? Vl = 2 : Ll.key === "Tab" && (Vl = 3), Vl === -1)
                        return;
                      const {
                        value: zl
                      } = Ll.target;
                      Cl.valueOnFocus !== zl && (Cl.userValue = zl, this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: Os,
                          name: "Keystroke",
                          value: zl,
                          willCommit: !0,
                          commitKey: Vl,
                          selStart: Ll.target.selectionStart,
                          selEnd: Ll.target.selectionEnd
                        }
                      }));
                    });
                    const Tl = ml;
                    ml = null, $l.addEventListener("blur", (Ll) => {
                      const {
                        value: Vl
                      } = Ll.target;
                      Cl.userValue = Vl, this._mouseState.isDown && Cl.valueOnFocus !== Vl && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: Os,
                          name: "Keystroke",
                          value: Vl,
                          willCommit: !0,
                          commitKey: 1,
                          selStart: Ll.target.selectionStart,
                          selEnd: Ll.target.selectionEnd
                        }
                      }), Tl(Ll);
                    }), this.data.actions?.Keystroke && $l.addEventListener("beforeinput", (Ll) => {
                      const {
                        data: Vl,
                        target: zl
                      } = Ll, {
                        value: Ul,
                        selectionStart: Yl,
                        selectionEnd: Jl
                      } = zl;
                      let Wl = Yl, rc = Jl;
                      switch (Ll.inputType) {
                        case "deleteWordBackward": {
                          const uc = Ul.substring(0, Yl).match(/\w*[^\w]*$/);
                          uc && (Wl -= uc[0].length);
                          break;
                        }
                        case "deleteWordForward": {
                          const uc = Ul.substring(Yl).match(/^[^\w]*\w*/);
                          uc && (rc += uc[0].length);
                          break;
                        }
                        case "deleteContentBackward":
                          Yl === Jl && (Wl -= 1);
                          break;
                        case "deleteContentForward":
                          Yl === Jl && (rc += 1);
                          break;
                      }
                      Ll.preventDefault(), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: Os,
                          name: "Keystroke",
                          value: Ul,
                          change: Vl || "",
                          willCommit: !1,
                          selStart: Wl,
                          selEnd: rc
                        }
                      });
                    }), this._setEventListeners($l, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Ll) => Ll.target.value);
                  }
                  if (ml && $l.addEventListener("blur", ml), this.data.comb) {
                    const Ll = (this.data.rect[2] - this.data.rect[0]) / Rl;
                    $l.classList.add("comb"), $l.style.letterSpacing = `calc(${Ll}px * var(--scale-factor) - 1ch)`;
                  }
                } else
                  $l = document.createElement("div"), $l.textContent = this.data.fieldValue, $l.style.verticalAlign = "middle", $l.style.display = "table-cell";
                return this._setTextStyle($l), this._setBackgroundColor($l), this._setDefaultPropertiesFromJS($l), this.container.append($l), this.container;
              }
            }
            class Ts extends io {
              constructor(To) {
                super(To, {
                  isRenderable: To.renderForms
                });
              }
              render() {
                const To = this.annotationStorage, Os = this.data, $l = Os.id;
                let _l = To.getValue($l, {
                  value: Os.exportValue === Os.fieldValue
                }).value;
                typeof _l == "string" && (_l = _l !== "Off", To.setValue($l, {
                  value: _l
                })), this.container.className = "buttonWidgetAnnotation checkBox";
                const Al = document.createElement("input");
                return Va.add(Al), Al.setAttribute("data-element-id", $l), Al.disabled = Os.readOnly, this._setRequired(Al, this.data.required), Al.type = "checkbox", Al.name = Os.fieldName, _l && Al.setAttribute("checked", !0), Al.setAttribute("exportValue", Os.exportValue), Al.tabIndex = fa, Al.addEventListener("change", (Rl) => {
                  const {
                    name: Cl,
                    checked: ml
                  } = Rl.target;
                  for (const Tl of this._getElementsByName(Cl, $l)) {
                    const Ll = ml && Tl.exportValue === Os.exportValue;
                    Tl.domElement && (Tl.domElement.checked = Ll), To.setValue(Tl.id, {
                      value: Ll
                    });
                  }
                  To.setValue($l, {
                    value: ml
                  });
                }), Al.addEventListener("resetform", (Rl) => {
                  const Cl = Os.defaultFieldValue || "Off";
                  Rl.target.checked = Cl === Os.exportValue;
                }), this.enableScripting && this.hasJSActions && (Al.addEventListener("updatefromsandbox", (Rl) => {
                  const Cl = {
                    value(ml) {
                      ml.target.checked = ml.detail.value !== "Off", To.setValue($l, {
                        value: ml.target.checked
                      });
                    }
                  };
                  this._dispatchEventFromSandbox(Cl, Rl);
                }), this._setEventListeners(Al, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Rl) => Rl.target.checked)), this._setBackgroundColor(Al), this._setDefaultPropertiesFromJS(Al), this.container.append(Al), this.container;
              }
            }
            class qs extends io {
              constructor(To) {
                super(To, {
                  isRenderable: To.renderForms
                });
              }
              render() {
                this.container.className = "buttonWidgetAnnotation radioButton";
                const To = this.annotationStorage, Os = this.data, $l = Os.id;
                let _l = To.getValue($l, {
                  value: Os.fieldValue === Os.buttonValue
                }).value;
                typeof _l == "string" && (_l = _l !== Os.buttonValue, To.setValue($l, {
                  value: _l
                }));
                const Al = document.createElement("input");
                if (Va.add(Al), Al.setAttribute("data-element-id", $l), Al.disabled = Os.readOnly, this._setRequired(Al, this.data.required), Al.type = "radio", Al.name = Os.fieldName, _l && Al.setAttribute("checked", !0), Al.tabIndex = fa, Al.addEventListener("change", (Rl) => {
                  const {
                    name: Cl,
                    checked: ml
                  } = Rl.target;
                  for (const Tl of this._getElementsByName(Cl, $l))
                    To.setValue(Tl.id, {
                      value: !1
                    });
                  To.setValue($l, {
                    value: ml
                  });
                }), Al.addEventListener("resetform", (Rl) => {
                  const Cl = Os.defaultFieldValue;
                  Rl.target.checked = Cl != null && Cl === Os.buttonValue;
                }), this.enableScripting && this.hasJSActions) {
                  const Rl = Os.buttonValue;
                  Al.addEventListener("updatefromsandbox", (Cl) => {
                    const ml = {
                      value: (Tl) => {
                        const Ll = Rl === Tl.detail.value;
                        for (const Vl of this._getElementsByName(Tl.target.name)) {
                          const zl = Ll && Vl.id === $l;
                          Vl.domElement && (Vl.domElement.checked = zl), To.setValue(Vl.id, {
                            value: zl
                          });
                        }
                      }
                    };
                    this._dispatchEventFromSandbox(ml, Cl);
                  }), this._setEventListeners(Al, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Cl) => Cl.target.checked);
                }
                return this._setBackgroundColor(Al), this._setDefaultPropertiesFromJS(Al), this.container.append(Al), this.container;
              }
            }
            class Fs extends eo {
              constructor(To) {
                super(To, {
                  ignoreBorder: To.data.hasAppearance
                });
              }
              render() {
                const To = super.render();
                To.className = "buttonWidgetAnnotation pushButton", this.data.alternativeText && (To.title = this.data.alternativeText);
                const Os = To.lastChild;
                return this.enableScripting && this.hasJSActions && Os && (this._setDefaultPropertiesFromJS(Os), Os.addEventListener("updatefromsandbox", ($l) => {
                  this._dispatchEventFromSandbox({}, $l);
                })), To;
              }
            }
            class Do extends io {
              constructor(To) {
                super(To, {
                  isRenderable: To.renderForms
                });
              }
              render() {
                this.container.className = "choiceWidgetAnnotation";
                const To = this.annotationStorage, Os = this.data.id, $l = To.getValue(Os, {
                  value: this.data.fieldValue
                }), _l = document.createElement("select");
                Va.add(_l), _l.setAttribute("data-element-id", Os), _l.disabled = this.data.readOnly, this._setRequired(_l, this.data.required), _l.name = this.data.fieldName, _l.tabIndex = fa;
                let Al = this.data.combo && this.data.options.length > 0;
                this.data.combo || (_l.size = this.data.options.length, this.data.multiSelect && (_l.multiple = !0)), _l.addEventListener("resetform", (Tl) => {
                  const Ll = this.data.defaultFieldValue;
                  for (const Vl of _l.options)
                    Vl.selected = Vl.value === Ll;
                });
                for (const Tl of this.data.options) {
                  const Ll = document.createElement("option");
                  Ll.textContent = Tl.displayValue, Ll.value = Tl.exportValue, $l.value.includes(Tl.exportValue) && (Ll.setAttribute("selected", !0), Al = !1), _l.append(Ll);
                }
                let Rl = null;
                if (Al) {
                  const Tl = document.createElement("option");
                  Tl.value = " ", Tl.setAttribute("hidden", !0), Tl.setAttribute("selected", !0), _l.prepend(Tl), Rl = () => {
                    Tl.remove(), _l.removeEventListener("input", Rl), Rl = null;
                  }, _l.addEventListener("input", Rl);
                }
                const Cl = (Tl, Ll) => {
                  const Vl = Ll ? "value" : "textContent", zl = Tl.target.options;
                  return Tl.target.multiple ? Array.prototype.filter.call(zl, (Ul) => Ul.selected).map((Ul) => Ul[Vl]) : zl.selectedIndex === -1 ? null : zl[zl.selectedIndex][Vl];
                }, ml = (Tl) => {
                  const Ll = Tl.target.options;
                  return Array.prototype.map.call(Ll, (Vl) => ({
                    displayValue: Vl.textContent,
                    exportValue: Vl.value
                  }));
                };
                return this.enableScripting && this.hasJSActions ? (_l.addEventListener("updatefromsandbox", (Tl) => {
                  const Ll = {
                    value(Vl) {
                      Rl?.();
                      const zl = Vl.detail.value, Ul = new Set(Array.isArray(zl) ? zl : [zl]);
                      for (const Yl of _l.options)
                        Yl.selected = Ul.has(Yl.value);
                      To.setValue(Os, {
                        value: Cl(Vl, !0)
                      });
                    },
                    multipleSelection(Vl) {
                      _l.multiple = !0;
                    },
                    remove(Vl) {
                      const zl = _l.options, Ul = Vl.detail.remove;
                      zl[Ul].selected = !1, _l.remove(Ul), zl.length > 0 && Array.prototype.findIndex.call(zl, (Jl) => Jl.selected) === -1 && (zl[0].selected = !0), To.setValue(Os, {
                        value: Cl(Vl, !0),
                        items: ml(Vl)
                      });
                    },
                    clear(Vl) {
                      for (; _l.length !== 0; )
                        _l.remove(0);
                      To.setValue(Os, {
                        value: null,
                        items: []
                      });
                    },
                    insert(Vl) {
                      const {
                        index: zl,
                        displayValue: Ul,
                        exportValue: Yl
                      } = Vl.detail.insert, Jl = _l.children[zl], Wl = document.createElement("option");
                      Wl.textContent = Ul, Wl.value = Yl, Jl ? Jl.before(Wl) : _l.append(Wl), To.setValue(Os, {
                        value: Cl(Vl, !0),
                        items: ml(Vl)
                      });
                    },
                    items(Vl) {
                      const {
                        items: zl
                      } = Vl.detail;
                      for (; _l.length !== 0; )
                        _l.remove(0);
                      for (const Ul of zl) {
                        const {
                          displayValue: Yl,
                          exportValue: Jl
                        } = Ul, Wl = document.createElement("option");
                        Wl.textContent = Yl, Wl.value = Jl, _l.append(Wl);
                      }
                      _l.options.length > 0 && (_l.options[0].selected = !0), To.setValue(Os, {
                        value: Cl(Vl, !0),
                        items: ml(Vl)
                      });
                    },
                    indices(Vl) {
                      const zl = new Set(Vl.detail.indices);
                      for (const Ul of Vl.target.options)
                        Ul.selected = zl.has(Ul.index);
                      To.setValue(Os, {
                        value: Cl(Vl, !0)
                      });
                    },
                    editable(Vl) {
                      Vl.target.disabled = !Vl.detail.editable;
                    }
                  };
                  this._dispatchEventFromSandbox(Ll, Tl);
                }), _l.addEventListener("input", (Tl) => {
                  const Ll = Cl(Tl, !0), Vl = Cl(Tl, !1);
                  To.setValue(Os, {
                    value: Ll
                  }), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: Os,
                      name: "Keystroke",
                      value: Vl,
                      changeEx: Ll,
                      willCommit: !0,
                      commitKey: 1,
                      keyDown: !1
                    }
                  });
                }), this._setEventListeners(_l, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"]], (Tl) => Tl.target.checked)) : _l.addEventListener("input", function(Tl) {
                  To.setValue(Os, {
                    value: Cl(Tl, !0)
                  });
                }), this.data.combo && this._setTextStyle(_l), this._setBackgroundColor(_l), this._setDefaultPropertiesFromJS(_l), this.container.append(_l), this.container;
              }
            }
            class ys extends no {
              constructor(To) {
                const Os = !!(To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os
                });
              }
              render() {
                const To = ["Line", "Square", "Circle", "PolyLine", "Polygon", "Ink"];
                if (this.container.className = "popupAnnotation", To.includes(this.data.parentType))
                  return this.container;
                const Os = `[data-annotation-id="${this.data.parentId}"]`, $l = this.layer.querySelectorAll(Os);
                if ($l.length === 0)
                  return this.container;
                const _l = new Io({
                  container: this.container,
                  trigger: Array.from($l),
                  color: this.data.color,
                  titleObj: this.data.titleObj,
                  modificationDate: this.data.modificationDate,
                  contentsObj: this.data.contentsObj,
                  richText: this.data.richText
                }), Al = this.page, Rl = Qi.Util.normalizeRect([this.data.parentRect[0], Al.view[3] - this.data.parentRect[1] + Al.view[1], this.data.parentRect[2], Al.view[3] - this.data.parentRect[3] + Al.view[1]]), Cl = Rl[0] + this.data.parentRect[2] - this.data.parentRect[0], ml = Rl[1], [Tl, Ll, Vl, zl] = this.viewport.viewBox, Ul = Vl - Tl, Yl = zl - Ll;
                return this.container.style.left = `${100 * (Cl - Tl) / Ul}%`, this.container.style.top = `${100 * (ml - Ll) / Yl}%`, this.container.append(_l.render()), this.container;
              }
            }
            class Io {
              constructor(To) {
                this.container = To.container, this.trigger = To.trigger, this.color = To.color, this.titleObj = To.titleObj, this.modificationDate = To.modificationDate, this.contentsObj = To.contentsObj, this.richText = To.richText, this.hideWrapper = To.hideWrapper || !1, this.pinned = !1;
              }
              render() {
                const Os = document.createElement("div");
                Os.className = "popupWrapper", this.hideElement = this.hideWrapper ? Os : this.container, this.hideElement.hidden = !0;
                const $l = document.createElement("div");
                $l.className = "popup";
                const _l = this.color;
                if (_l) {
                  const Cl = 0.7 * (255 - _l[0]) + _l[0], ml = 0.7 * (255 - _l[1]) + _l[1], Tl = 0.7 * (255 - _l[2]) + _l[2];
                  $l.style.backgroundColor = Qi.Util.makeHexColor(Cl | 0, ml | 0, Tl | 0);
                }
                const Al = document.createElement("h1");
                Al.dir = this.titleObj.dir, Al.textContent = this.titleObj.str, $l.append(Al);
                const Rl = ea.PDFDateString.toDateObject(this.modificationDate);
                if (Rl) {
                  const Cl = document.createElement("span");
                  Cl.className = "popupDate", Cl.textContent = "{{date}}, {{time}}", Cl.dataset.l10nId = "annotation_date_string", Cl.dataset.l10nArgs = JSON.stringify({
                    date: Rl.toLocaleDateString(),
                    time: Rl.toLocaleTimeString()
                  }), $l.append(Cl);
                }
                if (this.richText?.str && (!this.contentsObj?.str || this.contentsObj.str === this.richText.str))
                  ia.XfaLayer.render({
                    xfaHtml: this.richText.html,
                    intent: "richText",
                    div: $l
                  }), $l.lastChild.className = "richText popupContent";
                else {
                  const Cl = this._formatContents(this.contentsObj);
                  $l.append(Cl);
                }
                Array.isArray(this.trigger) || (this.trigger = [this.trigger]);
                for (const Cl of this.trigger)
                  Cl.addEventListener("click", this._toggle.bind(this)), Cl.addEventListener("mouseover", this._show.bind(this, !1)), Cl.addEventListener("mouseout", this._hide.bind(this, !1));
                return $l.addEventListener("click", this._hide.bind(this, !0)), Os.append($l), Os;
              }
              _formatContents({
                str: To,
                dir: Os
              }) {
                const $l = document.createElement("p");
                $l.className = "popupContent", $l.dir = Os;
                const _l = To.split(/(?:\r\n?|\n)/);
                for (let Al = 0, Rl = _l.length; Al < Rl; ++Al) {
                  const Cl = _l[Al];
                  $l.append(document.createTextNode(Cl)), Al < Rl - 1 && $l.append(document.createElement("br"));
                }
                return $l;
              }
              _toggle() {
                this.pinned ? this._hide(!0) : this._show(!0);
              }
              _show(To = !1) {
                To && (this.pinned = !0), this.hideElement.hidden && (this.hideElement.hidden = !1, this.container.style.zIndex = parseInt(this.container.style.zIndex) + 1e3);
              }
              _hide(To = !0) {
                To && (this.pinned = !1), !this.hideElement.hidden && !this.pinned && (this.hideElement.hidden = !0, this.container.style.zIndex = parseInt(this.container.style.zIndex) - 1e3);
              }
            }
            class so extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0
                }), this.textContent = To.data.textContent;
              }
              render() {
                if (this.container.className = "freeTextAnnotation", this.textContent) {
                  const To = document.createElement("div");
                  To.className = "annotationTextContent", To.setAttribute("role", "comment");
                  for (const Os of this.textContent) {
                    const $l = document.createElement("span");
                    $l.textContent = Os, To.append($l);
                  }
                  this.container.append(To);
                }
                return this.data.hasPopup || this._createPopup(null, this.data), this.container;
              }
            }
            class os extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.className = "lineAnnotation";
                const To = this.data, {
                  width: Os,
                  height: $l
                } = to(To.rect), _l = this.svgFactory.create(Os, $l, !0), Al = this.svgFactory.createElement("svg:line");
                return Al.setAttribute("x1", To.rect[2] - To.lineCoordinates[0]), Al.setAttribute("y1", To.rect[3] - To.lineCoordinates[1]), Al.setAttribute("x2", To.rect[2] - To.lineCoordinates[2]), Al.setAttribute("y2", To.rect[3] - To.lineCoordinates[3]), Al.setAttribute("stroke-width", To.borderStyle.width || 1), Al.setAttribute("stroke", "transparent"), Al.setAttribute("fill", "transparent"), _l.append(Al), this.container.append(_l), this._createPopup(Al, To), this.container;
              }
            }
            class Xs extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.className = "squareAnnotation";
                const To = this.data, {
                  width: Os,
                  height: $l
                } = to(To.rect), _l = this.svgFactory.create(Os, $l, !0), Al = To.borderStyle.width, Rl = this.svgFactory.createElement("svg:rect");
                return Rl.setAttribute("x", Al / 2), Rl.setAttribute("y", Al / 2), Rl.setAttribute("width", Os - Al), Rl.setAttribute("height", $l - Al), Rl.setAttribute("stroke-width", Al || 1), Rl.setAttribute("stroke", "transparent"), Rl.setAttribute("fill", "transparent"), _l.append(Rl), this.container.append(_l), this._createPopup(Rl, To), this.container;
              }
            }
            class gl extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.className = "circleAnnotation";
                const To = this.data, {
                  width: Os,
                  height: $l
                } = to(To.rect), _l = this.svgFactory.create(Os, $l, !0), Al = To.borderStyle.width, Rl = this.svgFactory.createElement("svg:ellipse");
                return Rl.setAttribute("cx", Os / 2), Rl.setAttribute("cy", $l / 2), Rl.setAttribute("rx", Os / 2 - Al / 2), Rl.setAttribute("ry", $l / 2 - Al / 2), Rl.setAttribute("stroke-width", Al || 1), Rl.setAttribute("stroke", "transparent"), Rl.setAttribute("fill", "transparent"), _l.append(Rl), this.container.append(_l), this._createPopup(Rl, To), this.container;
              }
            }
            class Sl extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0
                }), this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
              }
              render() {
                this.container.className = this.containerClassName;
                const To = this.data, {
                  width: Os,
                  height: $l
                } = to(To.rect), _l = this.svgFactory.create(Os, $l, !0);
                let Al = [];
                for (const Cl of To.vertices) {
                  const ml = Cl.x - To.rect[0], Tl = To.rect[3] - Cl.y;
                  Al.push(ml + "," + Tl);
                }
                Al = Al.join(" ");
                const Rl = this.svgFactory.createElement(this.svgElementName);
                return Rl.setAttribute("points", Al), Rl.setAttribute("stroke-width", To.borderStyle.width || 1), Rl.setAttribute("stroke", "transparent"), Rl.setAttribute("fill", "transparent"), _l.append(Rl), this.container.append(_l), this._createPopup(Rl, To), this.container;
              }
            }
            class El extends Sl {
              constructor(To) {
                super(To), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
              }
            }
            class wl extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0
                });
              }
              render() {
                return this.container.className = "caretAnnotation", this.data.hasPopup || this._createPopup(null, this.data), this.container;
              }
            }
            class jl extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0
                }), this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline";
              }
              render() {
                this.container.className = this.containerClassName;
                const To = this.data, {
                  width: Os,
                  height: $l
                } = to(To.rect), _l = this.svgFactory.create(Os, $l, !0);
                for (const Al of To.inkLists) {
                  let Rl = [];
                  for (const ml of Al) {
                    const Tl = ml.x - To.rect[0], Ll = To.rect[3] - ml.y;
                    Rl.push(`${Tl},${Ll}`);
                  }
                  Rl = Rl.join(" ");
                  const Cl = this.svgFactory.createElement(this.svgElementName);
                  Cl.setAttribute("points", Rl), Cl.setAttribute("stroke-width", To.borderStyle.width || 1), Cl.setAttribute("stroke", "transparent"), Cl.setAttribute("fill", "transparent"), this._createPopup(Cl, To), _l.append(Cl);
                }
                return this.container.append(_l), this.container;
              }
            }
            class kl extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("highlightAnnotation") : (this.container.className = "highlightAnnotation", this.container);
              }
            }
            class Fl extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("underlineAnnotation") : (this.container.className = "underlineAnnotation", this.container);
              }
            }
            class Ml extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("squigglyAnnotation") : (this.container.className = "squigglyAnnotation", this.container);
              }
            }
            class ql extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("strikeoutAnnotation") : (this.container.className = "strikeoutAnnotation", this.container);
              }
            }
            class Kl extends no {
              constructor(To) {
                const Os = !!(To.data.hasPopup || To.data.titleObj?.str || To.data.contentsObj?.str || To.data.richText?.str);
                super(To, {
                  isRenderable: Os,
                  ignoreBorder: !0
                });
              }
              render() {
                return this.container.className = "stampAnnotation", this.data.hasPopup || this._createPopup(null, this.data), this.container;
              }
            }
            class Zl extends no {
              constructor(To) {
                super(To, {
                  isRenderable: !0
                });
                const {
                  filename: Os,
                  content: $l
                } = this.data.file;
                this.filename = (0, ea.getFilenameFromUrl)(Os), this.content = $l, this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                  source: this,
                  filename: Os,
                  content: $l
                });
              }
              render() {
                this.container.className = "fileAttachmentAnnotation";
                const To = document.createElement("div");
                return To.className = "popupTriggerArea", To.addEventListener("dblclick", this._download.bind(this)), !this.data.hasPopup && (this.data.titleObj?.str || this.data.contentsObj?.str || this.data.richText) && this._createPopup(To, this.data), this.container.append(To), this.container;
              }
              _download() {
                this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
              }
            }
            const Bl = class Bl {
              static render(To) {
                var Cl, ml;
                const {
                  annotations: Os,
                  div: $l,
                  viewport: _l,
                  accessibilityManager: Al
                } = To;
                nc(this, xl, Ef).call(this, $l, _l);
                let Rl = 0;
                for (const Tl of Os) {
                  if (Tl.annotationType !== Qi.AnnotationType.POPUP) {
                    const {
                      width: Vl,
                      height: zl
                    } = to(Tl.rect);
                    if (Vl <= 0 || zl <= 0)
                      continue;
                  }
                  const Ll = ro.create({
                    data: Tl,
                    layer: $l,
                    page: To.page,
                    viewport: _l,
                    linkService: To.linkService,
                    downloadManager: To.downloadManager,
                    imageResourcesPath: To.imageResourcesPath || "",
                    renderForms: To.renderForms !== !1,
                    svgFactory: new ea.DOMSVGFactory(),
                    annotationStorage: To.annotationStorage || new ra.AnnotationStorage(),
                    enableScripting: To.enableScripting,
                    hasJSActions: To.hasJSActions,
                    fieldObjects: To.fieldObjects,
                    mouseState: To.mouseState || {
                      isDown: !1
                    }
                  });
                  if (Ll.isRenderable) {
                    const Vl = Ll.render();
                    if (Tl.hidden && (Vl.style.visibility = "hidden"), Array.isArray(Vl))
                      for (const zl of Vl)
                        zl.style.zIndex = Rl++, nc(Cl = Bl, xl, _f).call(Cl, zl, Tl.id, $l, Al);
                    else
                      Vl.style.zIndex = Rl++, Ll instanceof ys ? $l.prepend(Vl) : nc(ml = Bl, xl, _f).call(ml, Vl, Tl.id, $l, Al);
                  }
                }
                nc(this, xl, Sf).call(this, $l, To.annotationCanvasMap);
              }
              static update(To) {
                const {
                  annotationCanvasMap: Os,
                  div: $l,
                  viewport: _l
                } = To;
                nc(this, xl, Ef).call(this, $l, _l), nc(this, xl, Sf).call(this, $l, Os), $l.hidden = !1;
              }
            };
            xl = new WeakSet(), _f = function(To, Os, $l, _l) {
              const Al = To.firstChild || To;
              Al.id = `${ea.AnnotationPrefix}${Os}`, $l.append(To), _l?.moveElementInDOM($l, To, Al, !1);
            }, Ef = function(To, {
              width: Os,
              height: $l,
              rotation: _l
            }) {
              const {
                style: Al
              } = To, Rl = _l % 180 !== 0, Cl = Math.floor(Os) + "px", ml = Math.floor($l) + "px";
              Al.width = Rl ? ml : Cl, Al.height = Rl ? Cl : ml, To.setAttribute("data-main-rotation", _l);
            }, Sf = function(To, Os) {
              if (Os) {
                for (const [$l, _l] of Os) {
                  const Al = To.querySelector(`[data-annotation-id="${$l}"]`);
                  if (!Al)
                    continue;
                  const {
                    firstChild: Rl
                  } = Al;
                  Rl ? Rl.nodeName === "CANVAS" ? Rl.replaceWith(_l) : Rl.before(_l) : Al.append(_l);
                }
                Os.clear();
              }
            }, oc(Bl, xl);
            let Il = Bl;
            e.AnnotationLayer = Il;
          },
          /* 28 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.ColorConverters = void 0;
            function Zi(ea) {
              return Math.floor(Math.max(0, Math.min(1, ea)) * 255).toString(16).padStart(2, "0");
            }
            class Qi {
              static CMYK_G([ra, na, ia, fa]) {
                return ["G", 1 - Math.min(1, 0.3 * ra + 0.59 * ia + 0.11 * na + fa)];
              }
              static G_CMYK([ra]) {
                return ["CMYK", 0, 0, 0, 1 - ra];
              }
              static G_RGB([ra]) {
                return ["RGB", ra, ra, ra];
              }
              static G_HTML([ra]) {
                const na = Zi(ra);
                return `#${na}${na}${na}`;
              }
              static RGB_G([ra, na, ia]) {
                return ["G", 0.3 * ra + 0.59 * na + 0.11 * ia];
              }
              static RGB_HTML([ra, na, ia]) {
                const fa = Zi(ra), La = Zi(na), Va = Zi(ia);
                return `#${fa}${La}${Va}`;
              }
              static T_HTML() {
                return "#00000000";
              }
              static CMYK_RGB([ra, na, ia, fa]) {
                return ["RGB", 1 - Math.min(1, ra + fa), 1 - Math.min(1, ia + fa), 1 - Math.min(1, na + fa)];
              }
              static CMYK_HTML(ra) {
                const na = this.CMYK_RGB(ra).slice(1);
                return this.RGB_HTML(na);
              }
              static RGB_CMYK([ra, na, ia]) {
                const fa = 1 - ra, La = 1 - na, Va = 1 - ia, to = Math.min(fa, La, Va);
                return ["CMYK", fa, La, Va, to];
              }
            }
            e.ColorConverters = Qi;
          },
          /* 29 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.XfaLayer = void 0;
            var Qi = Zi(20);
            class ea {
              static setupStorage(na, ia, fa, La, Va) {
                const to = La.getValue(ia, {
                  value: null
                });
                switch (fa.name) {
                  case "textarea":
                    if (to.value !== null && (na.textContent = to.value), Va === "print")
                      break;
                    na.addEventListener("input", (ro) => {
                      La.setValue(ia, {
                        value: ro.target.value
                      });
                    });
                    break;
                  case "input":
                    if (fa.attributes.type === "radio" || fa.attributes.type === "checkbox") {
                      if (to.value === fa.attributes.xfaOn ? na.setAttribute("checked", !0) : to.value === fa.attributes.xfaOff && na.removeAttribute("checked"), Va === "print")
                        break;
                      na.addEventListener("change", (ro) => {
                        La.setValue(ia, {
                          value: ro.target.checked ? ro.target.getAttribute("xfaOn") : ro.target.getAttribute("xfaOff")
                        });
                      });
                    } else {
                      if (to.value !== null && na.setAttribute("value", to.value), Va === "print")
                        break;
                      na.addEventListener("input", (ro) => {
                        La.setValue(ia, {
                          value: ro.target.value
                        });
                      });
                    }
                    break;
                  case "select":
                    if (to.value !== null)
                      for (const ro of fa.children)
                        ro.attributes.value === to.value && (ro.attributes.selected = !0);
                    na.addEventListener("input", (ro) => {
                      const no = ro.target.options, eo = no.selectedIndex === -1 ? "" : no[no.selectedIndex].value;
                      La.setValue(ia, {
                        value: eo
                      });
                    });
                    break;
                }
              }
              static setAttributes({
                html: na,
                element: ia,
                storage: fa = null,
                intent: La,
                linkService: Va
              }) {
                const {
                  attributes: to
                } = ia, ro = na instanceof HTMLAnchorElement;
                to.type === "radio" && (to.name = `${to.name}-${La}`);
                for (const [no, eo] of Object.entries(to))
                  if (eo != null)
                    switch (no) {
                      case "class":
                        eo.length && na.setAttribute(no, eo.join(" "));
                        break;
                      case "dataId":
                        break;
                      case "id":
                        na.setAttribute("data-element-id", eo);
                        break;
                      case "style":
                        Object.assign(na.style, eo);
                        break;
                      case "textContent":
                        na.textContent = eo;
                        break;
                      default:
                        (!ro || no !== "href" && no !== "newWindow") && na.setAttribute(no, eo);
                    }
                ro && Va.addLinkAttributes(na, to.href, to.newWindow), fa && to.dataId && this.setupStorage(na, to.dataId, ia, fa);
              }
              static render(na) {
                const ia = na.annotationStorage, fa = na.linkService, La = na.xfaHtml, Va = na.intent || "display", to = document.createElement(La.name);
                La.attributes && this.setAttributes({
                  html: to,
                  element: La,
                  intent: Va,
                  linkService: fa
                });
                const ro = [[La, -1, to]], no = na.div;
                if (no.append(to), na.viewport) {
                  const ao = `matrix(${na.viewport.transform.join(",")})`;
                  no.style.transform = ao;
                }
                Va !== "richText" && no.setAttribute("class", "xfaLayer xfaFont");
                const eo = [];
                for (; ro.length > 0; ) {
                  const [ao, io, xs] = ro.at(-1);
                  if (io + 1 === ao.children.length) {
                    ro.pop();
                    continue;
                  }
                  const Ts = ao.children[++ro.at(-1)[1]];
                  if (Ts === null)
                    continue;
                  const {
                    name: qs
                  } = Ts;
                  if (qs === "#text") {
                    const Do = document.createTextNode(Ts.value);
                    eo.push(Do), xs.append(Do);
                    continue;
                  }
                  let Fs;
                  if (Ts?.attributes?.xmlns ? Fs = document.createElementNS(Ts.attributes.xmlns, qs) : Fs = document.createElement(qs), xs.append(Fs), Ts.attributes && this.setAttributes({
                    html: Fs,
                    element: Ts,
                    storage: ia,
                    intent: Va,
                    linkService: fa
                  }), Ts.children && Ts.children.length > 0)
                    ro.push([Ts, -1, Fs]);
                  else if (Ts.value) {
                    const Do = document.createTextNode(Ts.value);
                    Qi.XfaText.shouldBuildText(qs) && eo.push(Do), Fs.append(Do);
                  }
                }
                for (const ao of no.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))
                  ao.setAttribute("readOnly", !0);
                return {
                  textDivs: eo
                };
              }
              static update(na) {
                const ia = `matrix(${na.viewport.transform.join(",")})`;
                na.div.style.transform = ia, na.div.hidden = !1;
              }
            }
            e.XfaLayer = ea;
          },
          /* 30 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.TextLayerRenderTask = void 0, e.renderTextLayer = Ts;
            var Qi = Zi(1), ea = Zi(8);
            const ra = 1e5, na = 30, ia = 0.8, fa = /* @__PURE__ */ new Map(), La = /^\s+$/g;
            function Va(qs, Fs) {
              const Do = fa.get(qs);
              if (Do)
                return Do;
              Fs.save(), Fs.font = `${na}px ${qs}`;
              const ys = Fs.measureText("");
              let Io = ys.fontBoundingBoxAscent, so = Math.abs(ys.fontBoundingBoxDescent);
              if (Io) {
                Fs.restore();
                const Xs = Io / (Io + so);
                return fa.set(qs, Xs), Xs;
              }
              Fs.strokeStyle = "red", Fs.clearRect(0, 0, na, na), Fs.strokeText("g", 0, 0);
              let os = Fs.getImageData(0, 0, na, na).data;
              so = 0;
              for (let Xs = os.length - 1 - 3; Xs >= 0; Xs -= 4)
                if (os[Xs] > 0) {
                  so = Math.ceil(Xs / 4 / na);
                  break;
                }
              Fs.clearRect(0, 0, na, na), Fs.strokeText("A", 0, na), os = Fs.getImageData(0, 0, na, na).data, Io = 0;
              for (let Xs = 0, gl = os.length; Xs < gl; Xs += 4)
                if (os[Xs] > 0) {
                  Io = na - Math.floor(Xs / 4 / na);
                  break;
                }
              if (Fs.restore(), Io) {
                const Xs = Io / (Io + so);
                return fa.set(qs, Xs), Xs;
              }
              return fa.set(qs, ia), ia;
            }
            function to(qs, Fs, Do, ys) {
              const Io = document.createElement("span"), so = qs._enhanceTextSelection ? {
                angle: 0,
                canvasWidth: 0,
                hasText: Fs.str !== "",
                hasEOL: Fs.hasEOL,
                originalTransform: null,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0,
                scale: 1,
                fontSize: 0
              } : {
                angle: 0,
                canvasWidth: 0,
                hasText: Fs.str !== "",
                hasEOL: Fs.hasEOL,
                fontSize: 0
              };
              qs._textDivs.push(Io);
              const os = Qi.Util.transform(qs._viewport.transform, Fs.transform);
              let Xs = Math.atan2(os[1], os[0]);
              const gl = Do[Fs.fontName];
              gl.vertical && (Xs += Math.PI / 2);
              const Sl = Math.hypot(os[2], os[3]), El = Sl * Va(gl.fontFamily, ys);
              let wl, jl;
              Xs === 0 ? (wl = os[4], jl = os[5] - El) : (wl = os[4] + El * Math.sin(Xs), jl = os[5] - El * Math.cos(Xs)), Io.style.left = `${wl}px`, Io.style.top = `${jl}px`, Io.style.fontSize = `${Sl}px`, Io.style.fontFamily = gl.fontFamily, so.fontSize = Sl, Io.setAttribute("role", "presentation"), Io.textContent = Fs.str, Io.dir = Fs.dir, qs._fontInspectorEnabled && (Io.dataset.fontName = Fs.fontName), Xs !== 0 && (so.angle = Xs * (180 / Math.PI));
              let kl = !1;
              if (Fs.str.length > 1 || qs._enhanceTextSelection && La.test(Fs.str))
                kl = !0;
              else if (Fs.str !== " " && Fs.transform[0] !== Fs.transform[3]) {
                const Fl = Math.abs(Fs.transform[0]), Ml = Math.abs(Fs.transform[3]);
                Fl !== Ml && Math.max(Fl, Ml) / Math.min(Fl, Ml) > 1.5 && (kl = !0);
              }
              if (kl && (gl.vertical ? so.canvasWidth = Fs.height * qs._viewport.scale : so.canvasWidth = Fs.width * qs._viewport.scale), qs._textDivProperties.set(Io, so), qs._textContentStream && qs._layoutText(Io), qs._enhanceTextSelection && so.hasText) {
                let Fl = 1, Ml = 0;
                Xs !== 0 && (Fl = Math.cos(Xs), Ml = Math.sin(Xs));
                const ql = (gl.vertical ? Fs.height : Fs.width) * qs._viewport.scale, Kl = Sl;
                let Zl, Il;
                Xs !== 0 ? (Zl = [Fl, Ml, -Ml, Fl, wl, jl], Il = Qi.Util.getAxialAlignedBoundingBox([0, 0, ql, Kl], Zl)) : Il = [wl, jl, wl + ql, jl + Kl], qs._bounds.push({
                  left: Il[0],
                  top: Il[1],
                  right: Il[2],
                  bottom: Il[3],
                  div: Io,
                  size: [ql, Kl],
                  m: Zl
                });
              }
            }
            function ro(qs) {
              if (qs._canceled)
                return;
              const Fs = qs._textDivs, Do = qs._capability, ys = Fs.length;
              if (ys > ra) {
                qs._renderingDone = !0, Do.resolve();
                return;
              }
              if (!qs._textContentStream)
                for (let Io = 0; Io < ys; Io++)
                  qs._layoutText(Fs[Io]);
              qs._renderingDone = !0, Do.resolve();
            }
            function no(qs, Fs, Do) {
              let ys = 0;
              for (let Io = 0; Io < Do; Io++) {
                const so = qs[Fs++];
                so > 0 && (ys = ys ? Math.min(so, ys) : so);
              }
              return ys;
            }
            function eo(qs) {
              const Fs = qs._bounds, Do = qs._viewport, ys = ao(Do.width, Do.height, Fs);
              for (let Io = 0; Io < ys.length; Io++) {
                const so = Fs[Io].div, os = qs._textDivProperties.get(so);
                if (os.angle === 0) {
                  os.paddingLeft = Fs[Io].left - ys[Io].left, os.paddingTop = Fs[Io].top - ys[Io].top, os.paddingRight = ys[Io].right - Fs[Io].right, os.paddingBottom = ys[Io].bottom - Fs[Io].bottom, qs._textDivProperties.set(so, os);
                  continue;
                }
                const Xs = ys[Io], gl = Fs[Io], Sl = gl.m, El = Sl[0], wl = Sl[1], jl = [[0, 0], [0, gl.size[1]], [gl.size[0], 0], gl.size], kl = new Float64Array(64);
                for (let Ml = 0, ql = jl.length; Ml < ql; Ml++) {
                  const Kl = Qi.Util.applyTransform(jl[Ml], Sl);
                  kl[Ml + 0] = El && (Xs.left - Kl[0]) / El, kl[Ml + 4] = wl && (Xs.top - Kl[1]) / wl, kl[Ml + 8] = El && (Xs.right - Kl[0]) / El, kl[Ml + 12] = wl && (Xs.bottom - Kl[1]) / wl, kl[Ml + 16] = wl && (Xs.left - Kl[0]) / -wl, kl[Ml + 20] = El && (Xs.top - Kl[1]) / El, kl[Ml + 24] = wl && (Xs.right - Kl[0]) / -wl, kl[Ml + 28] = El && (Xs.bottom - Kl[1]) / El, kl[Ml + 32] = El && (Xs.left - Kl[0]) / -El, kl[Ml + 36] = wl && (Xs.top - Kl[1]) / -wl, kl[Ml + 40] = El && (Xs.right - Kl[0]) / -El, kl[Ml + 44] = wl && (Xs.bottom - Kl[1]) / -wl, kl[Ml + 48] = wl && (Xs.left - Kl[0]) / wl, kl[Ml + 52] = El && (Xs.top - Kl[1]) / -El, kl[Ml + 56] = wl && (Xs.right - Kl[0]) / wl, kl[Ml + 60] = El && (Xs.bottom - Kl[1]) / -El;
                }
                const Fl = 1 + Math.min(Math.abs(El), Math.abs(wl));
                os.paddingLeft = no(kl, 32, 16) / Fl, os.paddingTop = no(kl, 48, 16) / Fl, os.paddingRight = no(kl, 0, 16) / Fl, os.paddingBottom = no(kl, 16, 16) / Fl, qs._textDivProperties.set(so, os);
              }
            }
            function ao(qs, Fs, Do) {
              const ys = Do.map(function(so, os) {
                return {
                  x1: so.left,
                  y1: so.top,
                  x2: so.right,
                  y2: so.bottom,
                  index: os,
                  x1New: void 0,
                  x2New: void 0
                };
              });
              io(qs, ys);
              const Io = new Array(Do.length);
              for (const so of ys) {
                const os = so.index;
                Io[os] = {
                  left: so.x1New,
                  top: 0,
                  right: so.x2New,
                  bottom: 0
                };
              }
              Do.map(function(so, os) {
                const Xs = Io[os], gl = ys[os];
                gl.x1 = so.top, gl.y1 = qs - Xs.right, gl.x2 = so.bottom, gl.y2 = qs - Xs.left, gl.index = os, gl.x1New = void 0, gl.x2New = void 0;
              }), io(Fs, ys);
              for (const so of ys) {
                const os = so.index;
                Io[os].top = so.x1New, Io[os].bottom = so.x2New;
              }
              return Io;
            }
            function io(qs, Fs) {
              Fs.sort(function(Io, so) {
                return Io.x1 - so.x1 || Io.index - so.index;
              });
              const ys = [{
                start: -1 / 0,
                end: 1 / 0,
                boundary: {
                  x1: -1 / 0,
                  y1: -1 / 0,
                  x2: 0,
                  y2: 1 / 0,
                  index: -1,
                  x1New: 0,
                  x2New: 0
                }
              }];
              for (const Io of Fs) {
                let so = 0;
                for (; so < ys.length && ys[so].end <= Io.y1; )
                  so++;
                let os = ys.length - 1;
                for (; os >= 0 && ys[os].start >= Io.y2; )
                  os--;
                let Xs, gl, Sl, El, wl = -1 / 0;
                for (Sl = so; Sl <= os; Sl++) {
                  Xs = ys[Sl], gl = Xs.boundary;
                  let Fl;
                  gl.x2 > Io.x1 ? Fl = gl.index > Io.index ? gl.x1New : Io.x1 : gl.x2New === void 0 ? Fl = (gl.x2 + Io.x1) / 2 : Fl = gl.x2New, Fl > wl && (wl = Fl);
                }
                for (Io.x1New = wl, Sl = so; Sl <= os; Sl++)
                  Xs = ys[Sl], gl = Xs.boundary, gl.x2New === void 0 ? gl.x2 > Io.x1 ? gl.index > Io.index && (gl.x2New = gl.x2) : gl.x2New = wl : gl.x2New > wl && (gl.x2New = Math.max(wl, gl.x2));
                const jl = [];
                let kl = null;
                for (Sl = so; Sl <= os; Sl++) {
                  Xs = ys[Sl], gl = Xs.boundary;
                  const Fl = gl.x2 > Io.x2 ? gl : Io;
                  kl === Fl ? jl.at(-1).end = Xs.end : (jl.push({
                    start: Xs.start,
                    end: Xs.end,
                    boundary: Fl
                  }), kl = Fl);
                }
                for (ys[so].start < Io.y1 && (jl[0].start = Io.y1, jl.unshift({
                  start: ys[so].start,
                  end: Io.y1,
                  boundary: ys[so].boundary
                })), Io.y2 < ys[os].end && (jl.at(-1).end = Io.y2, jl.push({
                  start: Io.y2,
                  end: ys[os].end,
                  boundary: ys[os].boundary
                })), Sl = so; Sl <= os; Sl++) {
                  if (Xs = ys[Sl], gl = Xs.boundary, gl.x2New !== void 0)
                    continue;
                  let Fl = !1;
                  for (El = so - 1; !Fl && El >= 0 && ys[El].start >= gl.y1; El--)
                    Fl = ys[El].boundary === gl;
                  for (El = os + 1; !Fl && El < ys.length && ys[El].end <= gl.y2; El++)
                    Fl = ys[El].boundary === gl;
                  for (El = 0; !Fl && El < jl.length; El++)
                    Fl = jl[El].boundary === gl;
                  Fl || (gl.x2New = wl);
                }
                Array.prototype.splice.apply(ys, [so, os - so + 1, ...jl]);
              }
              for (const Io of ys) {
                const so = Io.boundary;
                so.x2New === void 0 && (so.x2New = Math.max(qs, so.x2));
              }
            }
            class xs {
              constructor({
                textContent: Fs,
                textContentStream: Do,
                container: ys,
                viewport: Io,
                textDivs: so,
                textContentItemsStr: os,
                enhanceTextSelection: Xs
              }) {
                Xs && (0, ea.deprecated)("The `enhanceTextSelection` functionality will be removed in the future."), this._textContent = Fs, this._textContentStream = Do, this._container = ys, this._document = ys.ownerDocument, this._viewport = Io, this._textDivs = so || [], this._textContentItemsStr = os || [], this._enhanceTextSelection = !!Xs, this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled, this._reader = null, this._layoutTextLastFontSize = null, this._layoutTextLastFontFamily = null, this._layoutTextCtx = null, this._textDivProperties = /* @__PURE__ */ new WeakMap(), this._renderingDone = !1, this._canceled = !1, this._capability = (0, Qi.createPromiseCapability)(), this._renderTimer = null, this._bounds = [], this._devicePixelRatio = globalThis.devicePixelRatio || 1, this._capability.promise.finally(() => {
                  this._enhanceTextSelection || (this._textDivProperties = null), this._layoutTextCtx && (this._layoutTextCtx.canvas.width = 0, this._layoutTextCtx.canvas.height = 0, this._layoutTextCtx = null);
                }).catch(() => {
                });
              }
              get promise() {
                return this._capability.promise;
              }
              cancel() {
                this._canceled = !0, this._reader && (this._reader.cancel(new Qi.AbortException("TextLayer task cancelled.")).catch(() => {
                }), this._reader = null), this._renderTimer !== null && (clearTimeout(this._renderTimer), this._renderTimer = null), this._capability.reject(new Error("TextLayer task cancelled."));
              }
              _processItems(Fs, Do) {
                for (let ys = 0, Io = Fs.length; ys < Io; ys++) {
                  if (Fs[ys].str === void 0) {
                    if (Fs[ys].type === "beginMarkedContentProps" || Fs[ys].type === "beginMarkedContent") {
                      const so = this._container;
                      this._container = document.createElement("span"), this._container.classList.add("markedContent"), Fs[ys].id !== null && this._container.setAttribute("id", `${Fs[ys].id}`), so.append(this._container);
                    } else Fs[ys].type === "endMarkedContent" && (this._container = this._container.parentNode);
                    continue;
                  }
                  this._textContentItemsStr.push(Fs[ys].str), to(this, Fs[ys], Do, this._layoutTextCtx);
                }
              }
              _layoutText(Fs) {
                const Do = this._textDivProperties.get(Fs);
                let ys = "";
                if (Do.canvasWidth !== 0 && Do.hasText) {
                  const {
                    fontFamily: Io
                  } = Fs.style, {
                    fontSize: so
                  } = Do;
                  (so !== this._layoutTextLastFontSize || Io !== this._layoutTextLastFontFamily) && (this._layoutTextCtx.font = `${so * this._devicePixelRatio}px ${Io}`, this._layoutTextLastFontSize = so, this._layoutTextLastFontFamily = Io);
                  const {
                    width: os
                  } = this._layoutTextCtx.measureText(Fs.textContent);
                  if (os > 0) {
                    const Xs = this._devicePixelRatio * Do.canvasWidth / os;
                    this._enhanceTextSelection && (Do.scale = Xs), ys = `scaleX(${Xs})`;
                  }
                }
                if (Do.angle !== 0 && (ys = `rotate(${Do.angle}deg) ${ys}`), ys.length > 0 && (this._enhanceTextSelection && (Do.originalTransform = ys), Fs.style.transform = ys), Do.hasText && this._container.append(Fs), Do.hasEOL) {
                  const Io = document.createElement("br");
                  Io.setAttribute("role", "presentation"), this._container.append(Io);
                }
              }
              _render(Fs = 0) {
                const Do = (0, Qi.createPromiseCapability)();
                let ys = /* @__PURE__ */ Object.create(null);
                const Io = this._document.createElement("canvas");
                if (Io.height = Io.width = na, this._layoutTextCtx = Io.getContext("2d", {
                  alpha: !1
                }), this._textContent) {
                  const so = this._textContent.items, os = this._textContent.styles;
                  this._processItems(so, os), Do.resolve();
                } else if (this._textContentStream) {
                  const so = () => {
                    this._reader.read().then(({
                      value: os,
                      done: Xs
                    }) => {
                      if (Xs) {
                        Do.resolve();
                        return;
                      }
                      Object.assign(ys, os.styles), this._processItems(os.items, ys), so();
                    }, Do.reject);
                  };
                  this._reader = this._textContentStream.getReader(), so();
                } else
                  throw new Error('Neither "textContent" nor "textContentStream" parameters specified.');
                Do.promise.then(() => {
                  ys = null, Fs ? this._renderTimer = setTimeout(() => {
                    ro(this), this._renderTimer = null;
                  }, Fs) : ro(this);
                }, this._capability.reject);
              }
              expandTextDivs(Fs = !1) {
                if (!this._enhanceTextSelection || !this._renderingDone)
                  return;
                this._bounds !== null && (eo(this), this._bounds = null);
                const Do = [], ys = [];
                for (let Io = 0, so = this._textDivs.length; Io < so; Io++) {
                  const os = this._textDivs[Io], Xs = this._textDivProperties.get(os);
                  Xs.hasText && (Fs ? (Do.length = 0, ys.length = 0, Xs.originalTransform && Do.push(Xs.originalTransform), Xs.paddingTop > 0 ? (ys.push(`${Xs.paddingTop}px`), Do.push(`translateY(${-Xs.paddingTop}px)`)) : ys.push(0), Xs.paddingRight > 0 ? ys.push(`${Xs.paddingRight / Xs.scale}px`) : ys.push(0), Xs.paddingBottom > 0 ? ys.push(`${Xs.paddingBottom}px`) : ys.push(0), Xs.paddingLeft > 0 ? (ys.push(`${Xs.paddingLeft / Xs.scale}px`), Do.push(`translateX(${-Xs.paddingLeft / Xs.scale}px)`)) : ys.push(0), os.style.padding = ys.join(" "), Do.length && (os.style.transform = Do.join(" "))) : (os.style.padding = null, os.style.transform = Xs.originalTransform));
                }
              }
            }
            e.TextLayerRenderTask = xs;
            function Ts(qs) {
              const Fs = new xs({
                textContent: qs.textContent,
                textContentStream: qs.textContentStream,
                container: qs.container,
                viewport: qs.viewport,
                textDivs: qs.textDivs,
                textContentItemsStr: qs.textContentItemsStr,
                enhanceTextSelection: qs.enhanceTextSelection
              });
              return Fs._render(qs.timeout), Fs;
            }
          },
          /* 31 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.SVGGraphics = void 0;
            var Qi = Zi(8), ea = Zi(1), ra = Zi(3);
            let na = class {
              constructor() {
                (0, ea.unreachable)("Not implemented: SVGGraphics");
              }
            };
            e.SVGGraphics = na;
            {
              let ao = function(Do) {
                let ys = [];
                const Io = [];
                for (const so of Do) {
                  if (so.fn === "save") {
                    ys.push({
                      fnId: 92,
                      fn: "group",
                      items: []
                    }), Io.push(ys), ys = ys.at(-1).items;
                    continue;
                  }
                  so.fn === "restore" ? ys = Io.pop() : ys.push(so);
                }
                return ys;
              }, io = function(Do) {
                if (Number.isInteger(Do))
                  return Do.toString();
                const ys = Do.toFixed(10);
                let Io = ys.length - 1;
                if (ys[Io] !== "0")
                  return ys;
                do
                  Io--;
                while (ys[Io] === "0");
                return ys.substring(0, ys[Io] === "." ? Io : Io + 1);
              }, xs = function(Do) {
                if (Do[4] === 0 && Do[5] === 0) {
                  if (Do[1] === 0 && Do[2] === 0)
                    return Do[0] === 1 && Do[3] === 1 ? "" : `scale(${io(Do[0])} ${io(Do[3])})`;
                  if (Do[0] === Do[3] && Do[1] === -Do[2]) {
                    const ys = Math.acos(Do[0]) * 180 / Math.PI;
                    return `rotate(${io(ys)})`;
                  }
                } else if (Do[0] === 1 && Do[1] === 0 && Do[2] === 0 && Do[3] === 1)
                  return `translate(${io(Do[4])} ${io(Do[5])})`;
                return `matrix(${io(Do[0])} ${io(Do[1])} ${io(Do[2])} ${io(Do[3])} ${io(Do[4])} ${io(Do[5])})`;
              };
              const ia = {
                fontStyle: "normal",
                fontWeight: "normal",
                fillColor: "#000000"
              }, fa = "http://www.w3.org/XML/1998/namespace", La = "http://www.w3.org/1999/xlink", Va = ["butt", "round", "square"], to = ["miter", "round", "bevel"], ro = function(Do, ys = "", Io = !1) {
                if (URL.createObjectURL && typeof Blob < "u" && !Io)
                  return URL.createObjectURL(new Blob([Do], {
                    type: ys
                  }));
                const so = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                let os = `data:${ys};base64,`;
                for (let Xs = 0, gl = Do.length; Xs < gl; Xs += 3) {
                  const Sl = Do[Xs] & 255, El = Do[Xs + 1] & 255, wl = Do[Xs + 2] & 255, jl = Sl >> 2, kl = (Sl & 3) << 4 | El >> 4, Fl = Xs + 1 < gl ? (El & 15) << 2 | wl >> 6 : 64, Ml = Xs + 2 < gl ? wl & 63 : 64;
                  os += so[jl] + so[kl] + so[Fl] + so[Ml];
                }
                return os;
              }, no = function() {
                const Do = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]), ys = 12, Io = new Int32Array(256);
                for (let wl = 0; wl < 256; wl++) {
                  let jl = wl;
                  for (let kl = 0; kl < 8; kl++)
                    jl & 1 ? jl = 3988292384 ^ jl >> 1 & 2147483647 : jl = jl >> 1 & 2147483647;
                  Io[wl] = jl;
                }
                function so(wl, jl, kl) {
                  let Fl = -1;
                  for (let Ml = jl; Ml < kl; Ml++) {
                    const ql = (Fl ^ wl[Ml]) & 255, Kl = Io[ql];
                    Fl = Fl >>> 8 ^ Kl;
                  }
                  return Fl ^ -1;
                }
                function os(wl, jl, kl, Fl) {
                  let Ml = Fl;
                  const ql = jl.length;
                  kl[Ml] = ql >> 24 & 255, kl[Ml + 1] = ql >> 16 & 255, kl[Ml + 2] = ql >> 8 & 255, kl[Ml + 3] = ql & 255, Ml += 4, kl[Ml] = wl.charCodeAt(0) & 255, kl[Ml + 1] = wl.charCodeAt(1) & 255, kl[Ml + 2] = wl.charCodeAt(2) & 255, kl[Ml + 3] = wl.charCodeAt(3) & 255, Ml += 4, kl.set(jl, Ml), Ml += jl.length;
                  const Kl = so(kl, Fl + 4, Ml);
                  kl[Ml] = Kl >> 24 & 255, kl[Ml + 1] = Kl >> 16 & 255, kl[Ml + 2] = Kl >> 8 & 255, kl[Ml + 3] = Kl & 255;
                }
                function Xs(wl, jl, kl) {
                  let Fl = 1, Ml = 0;
                  for (let ql = jl; ql < kl; ++ql)
                    Fl = (Fl + (wl[ql] & 255)) % 65521, Ml = (Ml + Fl) % 65521;
                  return Ml << 16 | Fl;
                }
                function gl(wl) {
                  if (!ra.isNodeJS)
                    return Sl(wl);
                  try {
                    let jl;
                    parseInt(process.versions.node) >= 8 ? jl = wl : jl = Buffer.from(wl);
                    const kl = require$$5.deflateSync(jl, {
                      level: 9
                    });
                    return kl instanceof Uint8Array ? kl : new Uint8Array(kl);
                  } catch (jl) {
                    (0, ea.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + jl);
                  }
                  return Sl(wl);
                }
                function Sl(wl) {
                  let jl = wl.length;
                  const kl = 65535, Fl = Math.ceil(jl / kl), Ml = new Uint8Array(2 + jl + Fl * 5 + 4);
                  let ql = 0;
                  Ml[ql++] = 120, Ml[ql++] = 156;
                  let Kl = 0;
                  for (; jl > kl; )
                    Ml[ql++] = 0, Ml[ql++] = 255, Ml[ql++] = 255, Ml[ql++] = 0, Ml[ql++] = 0, Ml.set(wl.subarray(Kl, Kl + kl), ql), ql += kl, Kl += kl, jl -= kl;
                  Ml[ql++] = 1, Ml[ql++] = jl & 255, Ml[ql++] = jl >> 8 & 255, Ml[ql++] = ~jl & 65535 & 255, Ml[ql++] = (~jl & 65535) >> 8 & 255, Ml.set(wl.subarray(Kl), ql), ql += wl.length - Kl;
                  const Zl = Xs(wl, 0, wl.length);
                  return Ml[ql++] = Zl >> 24 & 255, Ml[ql++] = Zl >> 16 & 255, Ml[ql++] = Zl >> 8 & 255, Ml[ql++] = Zl & 255, Ml;
                }
                function El(wl, jl, kl, Fl) {
                  const Ml = wl.width, ql = wl.height;
                  let Kl, Zl, Il;
                  const xl = wl.data;
                  switch (jl) {
                    case ea.ImageKind.GRAYSCALE_1BPP:
                      Zl = 0, Kl = 1, Il = Ml + 7 >> 3;
                      break;
                    case ea.ImageKind.RGB_24BPP:
                      Zl = 2, Kl = 8, Il = Ml * 3;
                      break;
                    case ea.ImageKind.RGBA_32BPP:
                      Zl = 6, Kl = 8, Il = Ml * 4;
                      break;
                    default:
                      throw new Error("invalid format");
                  }
                  const bl = new Uint8Array((1 + Il) * ql);
                  let Pl = 0, Nl = 0;
                  for (let _l = 0; _l < ql; ++_l)
                    bl[Pl++] = 0, bl.set(xl.subarray(Nl, Nl + Il), Pl), Nl += Il, Pl += Il;
                  if (jl === ea.ImageKind.GRAYSCALE_1BPP && Fl) {
                    Pl = 0;
                    for (let _l = 0; _l < ql; _l++) {
                      Pl++;
                      for (let Al = 0; Al < Il; Al++)
                        bl[Pl++] ^= 255;
                    }
                  }
                  const Bl = new Uint8Array([Ml >> 24 & 255, Ml >> 16 & 255, Ml >> 8 & 255, Ml & 255, ql >> 24 & 255, ql >> 16 & 255, ql >> 8 & 255, ql & 255, Kl, Zl, 0, 0, 0]), Ol = gl(bl), To = Do.length + ys * 3 + Bl.length + Ol.length, Os = new Uint8Array(To);
                  let $l = 0;
                  return Os.set(Do, $l), $l += Do.length, os("IHDR", Bl, Os, $l), $l += ys + Bl.length, os("IDATA", Ol, Os, $l), $l += ys + Ol.length, os("IEND", new Uint8Array(0), Os, $l), ro(Os, "image/png", kl);
                }
                return function(jl, kl, Fl) {
                  const Ml = jl.kind === void 0 ? ea.ImageKind.GRAYSCALE_1BPP : jl.kind;
                  return El(jl, Ml, kl, Fl);
                };
              }();
              class eo {
                constructor() {
                  this.fontSizeScale = 1, this.fontWeight = ia.fontWeight, this.fontSize = 0, this.textMatrix = ea.IDENTITY_MATRIX, this.fontMatrix = ea.FONT_IDENTITY_MATRIX, this.leading = 0, this.textRenderingMode = ea.TextRenderingMode.FILL, this.textMatrixScale = 1, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRise = 0, this.fillColor = ia.fillColor, this.strokeColor = "#000000", this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.lineJoin = "", this.lineCap = "", this.miterLimit = 0, this.dashArray = [], this.dashPhase = 0, this.dependencies = [], this.activeClipUrl = null, this.clipGroup = null, this.maskId = "";
                }
                clone() {
                  return Object.create(this);
                }
                setCurrentPoint(ys, Io) {
                  this.x = ys, this.y = Io;
                }
              }
              let Ts = 0, qs = 0, Fs = 0;
              e.SVGGraphics = na = class {
                constructor(Do, ys, Io = !1) {
                  (0, Qi.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future."), this.svgFactory = new Qi.DOMSVGFactory(), this.current = new eo(), this.transformMatrix = ea.IDENTITY_MATRIX, this.transformStack = [], this.extraStack = [], this.commonObjs = Do, this.objs = ys, this.pendingClip = null, this.pendingEOFill = !1, this.embedFonts = !1, this.embeddedFonts = /* @__PURE__ */ Object.create(null), this.cssStyle = null, this.forceDataSchema = !!Io, this._operatorIdMapping = [];
                  for (const so in ea.OPS)
                    this._operatorIdMapping[ea.OPS[so]] = so;
                }
                save() {
                  this.transformStack.push(this.transformMatrix);
                  const Do = this.current;
                  this.extraStack.push(Do), this.current = Do.clone();
                }
                restore() {
                  this.transformMatrix = this.transformStack.pop(), this.current = this.extraStack.pop(), this.pendingClip = null, this.tgrp = null;
                }
                group(Do) {
                  this.save(), this.executeOpTree(Do), this.restore();
                }
                loadDependencies(Do) {
                  const ys = Do.fnArray, Io = Do.argsArray;
                  for (let so = 0, os = ys.length; so < os; so++)
                    if (ys[so] === ea.OPS.dependency)
                      for (const Xs of Io[so]) {
                        const gl = Xs.startsWith("g_") ? this.commonObjs : this.objs, Sl = new Promise((El) => {
                          gl.get(Xs, El);
                        });
                        this.current.dependencies.push(Sl);
                      }
                  return Promise.all(this.current.dependencies);
                }
                transform(Do, ys, Io, so, os, Xs) {
                  const gl = [Do, ys, Io, so, os, Xs];
                  this.transformMatrix = ea.Util.transform(this.transformMatrix, gl), this.tgrp = null;
                }
                getSVG(Do, ys) {
                  this.viewport = ys;
                  const Io = this._initialize(ys);
                  return this.loadDependencies(Do).then(() => (this.transformMatrix = ea.IDENTITY_MATRIX, this.executeOpTree(this.convertOpList(Do)), Io));
                }
                convertOpList(Do) {
                  const ys = this._operatorIdMapping, Io = Do.argsArray, so = Do.fnArray, os = [];
                  for (let Xs = 0, gl = so.length; Xs < gl; Xs++) {
                    const Sl = so[Xs];
                    os.push({
                      fnId: Sl,
                      fn: ys[Sl],
                      args: Io[Xs]
                    });
                  }
                  return ao(os);
                }
                executeOpTree(Do) {
                  for (const ys of Do) {
                    const Io = ys.fn, so = ys.fnId, os = ys.args;
                    switch (so | 0) {
                      case ea.OPS.beginText:
                        this.beginText();
                        break;
                      case ea.OPS.dependency:
                        break;
                      case ea.OPS.setLeading:
                        this.setLeading(os);
                        break;
                      case ea.OPS.setLeadingMoveText:
                        this.setLeadingMoveText(os[0], os[1]);
                        break;
                      case ea.OPS.setFont:
                        this.setFont(os);
                        break;
                      case ea.OPS.showText:
                        this.showText(os[0]);
                        break;
                      case ea.OPS.showSpacedText:
                        this.showText(os[0]);
                        break;
                      case ea.OPS.endText:
                        this.endText();
                        break;
                      case ea.OPS.moveText:
                        this.moveText(os[0], os[1]);
                        break;
                      case ea.OPS.setCharSpacing:
                        this.setCharSpacing(os[0]);
                        break;
                      case ea.OPS.setWordSpacing:
                        this.setWordSpacing(os[0]);
                        break;
                      case ea.OPS.setHScale:
                        this.setHScale(os[0]);
                        break;
                      case ea.OPS.setTextMatrix:
                        this.setTextMatrix(os[0], os[1], os[2], os[3], os[4], os[5]);
                        break;
                      case ea.OPS.setTextRise:
                        this.setTextRise(os[0]);
                        break;
                      case ea.OPS.setTextRenderingMode:
                        this.setTextRenderingMode(os[0]);
                        break;
                      case ea.OPS.setLineWidth:
                        this.setLineWidth(os[0]);
                        break;
                      case ea.OPS.setLineJoin:
                        this.setLineJoin(os[0]);
                        break;
                      case ea.OPS.setLineCap:
                        this.setLineCap(os[0]);
                        break;
                      case ea.OPS.setMiterLimit:
                        this.setMiterLimit(os[0]);
                        break;
                      case ea.OPS.setFillRGBColor:
                        this.setFillRGBColor(os[0], os[1], os[2]);
                        break;
                      case ea.OPS.setStrokeRGBColor:
                        this.setStrokeRGBColor(os[0], os[1], os[2]);
                        break;
                      case ea.OPS.setStrokeColorN:
                        this.setStrokeColorN(os);
                        break;
                      case ea.OPS.setFillColorN:
                        this.setFillColorN(os);
                        break;
                      case ea.OPS.shadingFill:
                        this.shadingFill(os[0]);
                        break;
                      case ea.OPS.setDash:
                        this.setDash(os[0], os[1]);
                        break;
                      case ea.OPS.setRenderingIntent:
                        this.setRenderingIntent(os[0]);
                        break;
                      case ea.OPS.setFlatness:
                        this.setFlatness(os[0]);
                        break;
                      case ea.OPS.setGState:
                        this.setGState(os[0]);
                        break;
                      case ea.OPS.fill:
                        this.fill();
                        break;
                      case ea.OPS.eoFill:
                        this.eoFill();
                        break;
                      case ea.OPS.stroke:
                        this.stroke();
                        break;
                      case ea.OPS.fillStroke:
                        this.fillStroke();
                        break;
                      case ea.OPS.eoFillStroke:
                        this.eoFillStroke();
                        break;
                      case ea.OPS.clip:
                        this.clip("nonzero");
                        break;
                      case ea.OPS.eoClip:
                        this.clip("evenodd");
                        break;
                      case ea.OPS.paintSolidColorImageMask:
                        this.paintSolidColorImageMask();
                        break;
                      case ea.OPS.paintImageXObject:
                        this.paintImageXObject(os[0]);
                        break;
                      case ea.OPS.paintInlineImageXObject:
                        this.paintInlineImageXObject(os[0]);
                        break;
                      case ea.OPS.paintImageMaskXObject:
                        this.paintImageMaskXObject(os[0]);
                        break;
                      case ea.OPS.paintFormXObjectBegin:
                        this.paintFormXObjectBegin(os[0], os[1]);
                        break;
                      case ea.OPS.paintFormXObjectEnd:
                        this.paintFormXObjectEnd();
                        break;
                      case ea.OPS.closePath:
                        this.closePath();
                        break;
                      case ea.OPS.closeStroke:
                        this.closeStroke();
                        break;
                      case ea.OPS.closeFillStroke:
                        this.closeFillStroke();
                        break;
                      case ea.OPS.closeEOFillStroke:
                        this.closeEOFillStroke();
                        break;
                      case ea.OPS.nextLine:
                        this.nextLine();
                        break;
                      case ea.OPS.transform:
                        this.transform(os[0], os[1], os[2], os[3], os[4], os[5]);
                        break;
                      case ea.OPS.constructPath:
                        this.constructPath(os[0], os[1]);
                        break;
                      case ea.OPS.endPath:
                        this.endPath();
                        break;
                      case 92:
                        this.group(ys.items);
                        break;
                      default:
                        (0, ea.warn)(`Unimplemented operator ${Io}`);
                        break;
                    }
                  }
                }
                setWordSpacing(Do) {
                  this.current.wordSpacing = Do;
                }
                setCharSpacing(Do) {
                  this.current.charSpacing = Do;
                }
                nextLine() {
                  this.moveText(0, this.current.leading);
                }
                setTextMatrix(Do, ys, Io, so, os, Xs) {
                  const gl = this.current;
                  gl.textMatrix = gl.lineMatrix = [Do, ys, Io, so, os, Xs], gl.textMatrixScale = Math.hypot(Do, ys), gl.x = gl.lineX = 0, gl.y = gl.lineY = 0, gl.xcoords = [], gl.ycoords = [], gl.tspan = this.svgFactory.createElement("svg:tspan"), gl.tspan.setAttributeNS(null, "font-family", gl.fontFamily), gl.tspan.setAttributeNS(null, "font-size", `${io(gl.fontSize)}px`), gl.tspan.setAttributeNS(null, "y", io(-gl.y)), gl.txtElement = this.svgFactory.createElement("svg:text"), gl.txtElement.append(gl.tspan);
                }
                beginText() {
                  const Do = this.current;
                  Do.x = Do.lineX = 0, Do.y = Do.lineY = 0, Do.textMatrix = ea.IDENTITY_MATRIX, Do.lineMatrix = ea.IDENTITY_MATRIX, Do.textMatrixScale = 1, Do.tspan = this.svgFactory.createElement("svg:tspan"), Do.txtElement = this.svgFactory.createElement("svg:text"), Do.txtgrp = this.svgFactory.createElement("svg:g"), Do.xcoords = [], Do.ycoords = [];
                }
                moveText(Do, ys) {
                  const Io = this.current;
                  Io.x = Io.lineX += Do, Io.y = Io.lineY += ys, Io.xcoords = [], Io.ycoords = [], Io.tspan = this.svgFactory.createElement("svg:tspan"), Io.tspan.setAttributeNS(null, "font-family", Io.fontFamily), Io.tspan.setAttributeNS(null, "font-size", `${io(Io.fontSize)}px`), Io.tspan.setAttributeNS(null, "y", io(-Io.y));
                }
                showText(Do) {
                  const ys = this.current, Io = ys.font, so = ys.fontSize;
                  if (so === 0)
                    return;
                  const os = ys.fontSizeScale, Xs = ys.charSpacing, gl = ys.wordSpacing, Sl = ys.fontDirection, El = ys.textHScale * Sl, wl = Io.vertical, jl = wl ? 1 : -1, kl = Io.defaultVMetrics, Fl = so * ys.fontMatrix[0];
                  let Ml = 0;
                  for (const Zl of Do) {
                    if (Zl === null) {
                      Ml += Sl * gl;
                      continue;
                    } else if (typeof Zl == "number") {
                      Ml += jl * Zl * so / 1e3;
                      continue;
                    }
                    const Il = (Zl.isSpace ? gl : 0) + Xs, xl = Zl.fontChar;
                    let bl, Pl, Nl = Zl.width;
                    if (wl) {
                      let Ol;
                      const To = Zl.vmetric || kl;
                      Ol = Zl.vmetric ? To[1] : Nl * 0.5, Ol = -Ol * Fl;
                      const Os = To[2] * Fl;
                      Nl = To ? -To[0] : Nl, bl = Ol / os, Pl = (Ml + Os) / os;
                    } else
                      bl = Ml / os, Pl = 0;
                    (Zl.isInFont || Io.missingFile) && (ys.xcoords.push(ys.x + bl), wl && ys.ycoords.push(-ys.y + Pl), ys.tspan.textContent += xl);
                    let Bl;
                    wl ? Bl = Nl * Fl - Il * Sl : Bl = Nl * Fl + Il * Sl, Ml += Bl;
                  }
                  ys.tspan.setAttributeNS(null, "x", ys.xcoords.map(io).join(" ")), wl ? ys.tspan.setAttributeNS(null, "y", ys.ycoords.map(io).join(" ")) : ys.tspan.setAttributeNS(null, "y", io(-ys.y)), wl ? ys.y -= Ml : ys.x += Ml * El, ys.tspan.setAttributeNS(null, "font-family", ys.fontFamily), ys.tspan.setAttributeNS(null, "font-size", `${io(ys.fontSize)}px`), ys.fontStyle !== ia.fontStyle && ys.tspan.setAttributeNS(null, "font-style", ys.fontStyle), ys.fontWeight !== ia.fontWeight && ys.tspan.setAttributeNS(null, "font-weight", ys.fontWeight);
                  const ql = ys.textRenderingMode & ea.TextRenderingMode.FILL_STROKE_MASK;
                  if (ql === ea.TextRenderingMode.FILL || ql === ea.TextRenderingMode.FILL_STROKE ? (ys.fillColor !== ia.fillColor && ys.tspan.setAttributeNS(null, "fill", ys.fillColor), ys.fillAlpha < 1 && ys.tspan.setAttributeNS(null, "fill-opacity", ys.fillAlpha)) : ys.textRenderingMode === ea.TextRenderingMode.ADD_TO_PATH ? ys.tspan.setAttributeNS(null, "fill", "transparent") : ys.tspan.setAttributeNS(null, "fill", "none"), ql === ea.TextRenderingMode.STROKE || ql === ea.TextRenderingMode.FILL_STROKE) {
                    const Zl = 1 / (ys.textMatrixScale || 1);
                    this._setStrokeAttributes(ys.tspan, Zl);
                  }
                  let Kl = ys.textMatrix;
                  ys.textRise !== 0 && (Kl = Kl.slice(), Kl[5] += ys.textRise), ys.txtElement.setAttributeNS(null, "transform", `${xs(Kl)} scale(${io(El)}, -1)`), ys.txtElement.setAttributeNS(fa, "xml:space", "preserve"), ys.txtElement.append(ys.tspan), ys.txtgrp.append(ys.txtElement), this._ensureTransformGroup().append(ys.txtElement);
                }
                setLeadingMoveText(Do, ys) {
                  this.setLeading(-ys), this.moveText(Do, ys);
                }
                addFontStyle(Do) {
                  if (!Do.data)
                    throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                  this.cssStyle || (this.cssStyle = this.svgFactory.createElement("svg:style"), this.cssStyle.setAttributeNS(null, "type", "text/css"), this.defs.append(this.cssStyle));
                  const ys = ro(Do.data, Do.mimetype, this.forceDataSchema);
                  this.cssStyle.textContent += `@font-face { font-family: "${Do.loadedName}"; src: url(${ys}); }
`;
                }
                setFont(Do) {
                  const ys = this.current, Io = this.commonObjs.get(Do[0]);
                  let so = Do[1];
                  ys.font = Io, this.embedFonts && !Io.missingFile && !this.embeddedFonts[Io.loadedName] && (this.addFontStyle(Io), this.embeddedFonts[Io.loadedName] = Io), ys.fontMatrix = Io.fontMatrix || ea.FONT_IDENTITY_MATRIX;
                  let os = "normal";
                  Io.black ? os = "900" : Io.bold && (os = "bold");
                  const Xs = Io.italic ? "italic" : "normal";
                  so < 0 ? (so = -so, ys.fontDirection = -1) : ys.fontDirection = 1, ys.fontSize = so, ys.fontFamily = Io.loadedName, ys.fontWeight = os, ys.fontStyle = Xs, ys.tspan = this.svgFactory.createElement("svg:tspan"), ys.tspan.setAttributeNS(null, "y", io(-ys.y)), ys.xcoords = [], ys.ycoords = [];
                }
                endText() {
                  const Do = this.current;
                  Do.textRenderingMode & ea.TextRenderingMode.ADD_TO_PATH_FLAG && Do.txtElement?.hasChildNodes() && (Do.element = Do.txtElement, this.clip("nonzero"), this.endPath());
                }
                setLineWidth(Do) {
                  Do > 0 && (this.current.lineWidth = Do);
                }
                setLineCap(Do) {
                  this.current.lineCap = Va[Do];
                }
                setLineJoin(Do) {
                  this.current.lineJoin = to[Do];
                }
                setMiterLimit(Do) {
                  this.current.miterLimit = Do;
                }
                setStrokeAlpha(Do) {
                  this.current.strokeAlpha = Do;
                }
                setStrokeRGBColor(Do, ys, Io) {
                  this.current.strokeColor = ea.Util.makeHexColor(Do, ys, Io);
                }
                setFillAlpha(Do) {
                  this.current.fillAlpha = Do;
                }
                setFillRGBColor(Do, ys, Io) {
                  this.current.fillColor = ea.Util.makeHexColor(Do, ys, Io), this.current.tspan = this.svgFactory.createElement("svg:tspan"), this.current.xcoords = [], this.current.ycoords = [];
                }
                setStrokeColorN(Do) {
                  this.current.strokeColor = this._makeColorN_Pattern(Do);
                }
                setFillColorN(Do) {
                  this.current.fillColor = this._makeColorN_Pattern(Do);
                }
                shadingFill(Do) {
                  const ys = this.viewport.width, Io = this.viewport.height, so = ea.Util.inverseTransform(this.transformMatrix), os = ea.Util.applyTransform([0, 0], so), Xs = ea.Util.applyTransform([0, Io], so), gl = ea.Util.applyTransform([ys, 0], so), Sl = ea.Util.applyTransform([ys, Io], so), El = Math.min(os[0], Xs[0], gl[0], Sl[0]), wl = Math.min(os[1], Xs[1], gl[1], Sl[1]), jl = Math.max(os[0], Xs[0], gl[0], Sl[0]), kl = Math.max(os[1], Xs[1], gl[1], Sl[1]), Fl = this.svgFactory.createElement("svg:rect");
                  Fl.setAttributeNS(null, "x", El), Fl.setAttributeNS(null, "y", wl), Fl.setAttributeNS(null, "width", jl - El), Fl.setAttributeNS(null, "height", kl - wl), Fl.setAttributeNS(null, "fill", this._makeShadingPattern(Do)), this.current.fillAlpha < 1 && Fl.setAttributeNS(null, "fill-opacity", this.current.fillAlpha), this._ensureTransformGroup().append(Fl);
                }
                _makeColorN_Pattern(Do) {
                  return Do[0] === "TilingPattern" ? this._makeTilingPattern(Do) : this._makeShadingPattern(Do);
                }
                _makeTilingPattern(Do) {
                  const ys = Do[1], Io = Do[2], so = Do[3] || ea.IDENTITY_MATRIX, [os, Xs, gl, Sl] = Do[4], El = Do[5], wl = Do[6], jl = Do[7], kl = `shading${Fs++}`, [Fl, Ml, ql, Kl] = ea.Util.normalizeRect([...ea.Util.applyTransform([os, Xs], so), ...ea.Util.applyTransform([gl, Sl], so)]), [Zl, Il] = ea.Util.singularValueDecompose2dScale(so), xl = El * Zl, bl = wl * Il, Pl = this.svgFactory.createElement("svg:pattern");
                  Pl.setAttributeNS(null, "id", kl), Pl.setAttributeNS(null, "patternUnits", "userSpaceOnUse"), Pl.setAttributeNS(null, "width", xl), Pl.setAttributeNS(null, "height", bl), Pl.setAttributeNS(null, "x", `${Fl}`), Pl.setAttributeNS(null, "y", `${Ml}`);
                  const Nl = this.svg, Bl = this.transformMatrix, Ol = this.current.fillColor, To = this.current.strokeColor, Os = this.svgFactory.create(ql - Fl, Kl - Ml);
                  if (this.svg = Os, this.transformMatrix = so, jl === 2) {
                    const $l = ea.Util.makeHexColor(...ys);
                    this.current.fillColor = $l, this.current.strokeColor = $l;
                  }
                  return this.executeOpTree(this.convertOpList(Io)), this.svg = Nl, this.transformMatrix = Bl, this.current.fillColor = Ol, this.current.strokeColor = To, Pl.append(Os.childNodes[0]), this.defs.append(Pl), `url(#${kl})`;
                }
                _makeShadingPattern(Do) {
                  switch (typeof Do == "string" && (Do = this.objs.get(Do)), Do[0]) {
                    case "RadialAxial":
                      const ys = `shading${Fs++}`, Io = Do[3];
                      let so;
                      switch (Do[1]) {
                        case "axial":
                          const os = Do[4], Xs = Do[5];
                          so = this.svgFactory.createElement("svg:linearGradient"), so.setAttributeNS(null, "id", ys), so.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), so.setAttributeNS(null, "x1", os[0]), so.setAttributeNS(null, "y1", os[1]), so.setAttributeNS(null, "x2", Xs[0]), so.setAttributeNS(null, "y2", Xs[1]);
                          break;
                        case "radial":
                          const gl = Do[4], Sl = Do[5], El = Do[6], wl = Do[7];
                          so = this.svgFactory.createElement("svg:radialGradient"), so.setAttributeNS(null, "id", ys), so.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), so.setAttributeNS(null, "cx", Sl[0]), so.setAttributeNS(null, "cy", Sl[1]), so.setAttributeNS(null, "r", wl), so.setAttributeNS(null, "fx", gl[0]), so.setAttributeNS(null, "fy", gl[1]), so.setAttributeNS(null, "fr", El);
                          break;
                        default:
                          throw new Error(`Unknown RadialAxial type: ${Do[1]}`);
                      }
                      for (const os of Io) {
                        const Xs = this.svgFactory.createElement("svg:stop");
                        Xs.setAttributeNS(null, "offset", os[0]), Xs.setAttributeNS(null, "stop-color", os[1]), so.append(Xs);
                      }
                      return this.defs.append(so), `url(#${ys})`;
                    case "Mesh":
                      return (0, ea.warn)("Unimplemented pattern Mesh"), null;
                    case "Dummy":
                      return "hotpink";
                    default:
                      throw new Error(`Unknown IR type: ${Do[0]}`);
                  }
                }
                setDash(Do, ys) {
                  this.current.dashArray = Do, this.current.dashPhase = ys;
                }
                constructPath(Do, ys) {
                  const Io = this.current;
                  let so = Io.x, os = Io.y, Xs = [], gl = 0;
                  for (const Sl of Do)
                    switch (Sl | 0) {
                      case ea.OPS.rectangle:
                        so = ys[gl++], os = ys[gl++];
                        const El = ys[gl++], wl = ys[gl++], jl = so + El, kl = os + wl;
                        Xs.push("M", io(so), io(os), "L", io(jl), io(os), "L", io(jl), io(kl), "L", io(so), io(kl), "Z");
                        break;
                      case ea.OPS.moveTo:
                        so = ys[gl++], os = ys[gl++], Xs.push("M", io(so), io(os));
                        break;
                      case ea.OPS.lineTo:
                        so = ys[gl++], os = ys[gl++], Xs.push("L", io(so), io(os));
                        break;
                      case ea.OPS.curveTo:
                        so = ys[gl + 4], os = ys[gl + 5], Xs.push("C", io(ys[gl]), io(ys[gl + 1]), io(ys[gl + 2]), io(ys[gl + 3]), io(so), io(os)), gl += 6;
                        break;
                      case ea.OPS.curveTo2:
                        Xs.push("C", io(so), io(os), io(ys[gl]), io(ys[gl + 1]), io(ys[gl + 2]), io(ys[gl + 3])), so = ys[gl + 2], os = ys[gl + 3], gl += 4;
                        break;
                      case ea.OPS.curveTo3:
                        so = ys[gl + 2], os = ys[gl + 3], Xs.push("C", io(ys[gl]), io(ys[gl + 1]), io(so), io(os), io(so), io(os)), gl += 4;
                        break;
                      case ea.OPS.closePath:
                        Xs.push("Z");
                        break;
                    }
                  Xs = Xs.join(" "), Io.path && Do.length > 0 && Do[0] !== ea.OPS.rectangle && Do[0] !== ea.OPS.moveTo ? Xs = Io.path.getAttributeNS(null, "d") + Xs : (Io.path = this.svgFactory.createElement("svg:path"), this._ensureTransformGroup().append(Io.path)), Io.path.setAttributeNS(null, "d", Xs), Io.path.setAttributeNS(null, "fill", "none"), Io.element = Io.path, Io.setCurrentPoint(so, os);
                }
                endPath() {
                  const Do = this.current;
                  if (Do.path = null, !this.pendingClip)
                    return;
                  if (!Do.element) {
                    this.pendingClip = null;
                    return;
                  }
                  const ys = `clippath${Ts++}`, Io = this.svgFactory.createElement("svg:clipPath");
                  Io.setAttributeNS(null, "id", ys), Io.setAttributeNS(null, "transform", xs(this.transformMatrix));
                  const so = Do.element.cloneNode(!0);
                  if (this.pendingClip === "evenodd" ? so.setAttributeNS(null, "clip-rule", "evenodd") : so.setAttributeNS(null, "clip-rule", "nonzero"), this.pendingClip = null, Io.append(so), this.defs.append(Io), Do.activeClipUrl) {
                    Do.clipGroup = null;
                    for (const os of this.extraStack)
                      os.clipGroup = null;
                    Io.setAttributeNS(null, "clip-path", Do.activeClipUrl);
                  }
                  Do.activeClipUrl = `url(#${ys})`, this.tgrp = null;
                }
                clip(Do) {
                  this.pendingClip = Do;
                }
                closePath() {
                  const Do = this.current;
                  if (Do.path) {
                    const ys = `${Do.path.getAttributeNS(null, "d")}Z`;
                    Do.path.setAttributeNS(null, "d", ys);
                  }
                }
                setLeading(Do) {
                  this.current.leading = -Do;
                }
                setTextRise(Do) {
                  this.current.textRise = Do;
                }
                setTextRenderingMode(Do) {
                  this.current.textRenderingMode = Do;
                }
                setHScale(Do) {
                  this.current.textHScale = Do / 100;
                }
                setRenderingIntent(Do) {
                }
                setFlatness(Do) {
                }
                setGState(Do) {
                  for (const [ys, Io] of Do)
                    switch (ys) {
                      case "LW":
                        this.setLineWidth(Io);
                        break;
                      case "LC":
                        this.setLineCap(Io);
                        break;
                      case "LJ":
                        this.setLineJoin(Io);
                        break;
                      case "ML":
                        this.setMiterLimit(Io);
                        break;
                      case "D":
                        this.setDash(Io[0], Io[1]);
                        break;
                      case "RI":
                        this.setRenderingIntent(Io);
                        break;
                      case "FL":
                        this.setFlatness(Io);
                        break;
                      case "Font":
                        this.setFont(Io);
                        break;
                      case "CA":
                        this.setStrokeAlpha(Io);
                        break;
                      case "ca":
                        this.setFillAlpha(Io);
                        break;
                      default:
                        (0, ea.warn)(`Unimplemented graphic state operator ${ys}`);
                        break;
                    }
                }
                fill() {
                  const Do = this.current;
                  Do.element && (Do.element.setAttributeNS(null, "fill", Do.fillColor), Do.element.setAttributeNS(null, "fill-opacity", Do.fillAlpha), this.endPath());
                }
                stroke() {
                  const Do = this.current;
                  Do.element && (this._setStrokeAttributes(Do.element), Do.element.setAttributeNS(null, "fill", "none"), this.endPath());
                }
                _setStrokeAttributes(Do, ys = 1) {
                  const Io = this.current;
                  let so = Io.dashArray;
                  ys !== 1 && so.length > 0 && (so = so.map(function(os) {
                    return ys * os;
                  })), Do.setAttributeNS(null, "stroke", Io.strokeColor), Do.setAttributeNS(null, "stroke-opacity", Io.strokeAlpha), Do.setAttributeNS(null, "stroke-miterlimit", io(Io.miterLimit)), Do.setAttributeNS(null, "stroke-linecap", Io.lineCap), Do.setAttributeNS(null, "stroke-linejoin", Io.lineJoin), Do.setAttributeNS(null, "stroke-width", io(ys * Io.lineWidth) + "px"), Do.setAttributeNS(null, "stroke-dasharray", so.map(io).join(" ")), Do.setAttributeNS(null, "stroke-dashoffset", io(ys * Io.dashPhase) + "px");
                }
                eoFill() {
                  this.current.element && this.current.element.setAttributeNS(null, "fill-rule", "evenodd"), this.fill();
                }
                fillStroke() {
                  this.stroke(), this.fill();
                }
                eoFillStroke() {
                  this.current.element && this.current.element.setAttributeNS(null, "fill-rule", "evenodd"), this.fillStroke();
                }
                closeStroke() {
                  this.closePath(), this.stroke();
                }
                closeFillStroke() {
                  this.closePath(), this.fillStroke();
                }
                closeEOFillStroke() {
                  this.closePath(), this.eoFillStroke();
                }
                paintSolidColorImageMask() {
                  const Do = this.svgFactory.createElement("svg:rect");
                  Do.setAttributeNS(null, "x", "0"), Do.setAttributeNS(null, "y", "0"), Do.setAttributeNS(null, "width", "1px"), Do.setAttributeNS(null, "height", "1px"), Do.setAttributeNS(null, "fill", this.current.fillColor), this._ensureTransformGroup().append(Do);
                }
                paintImageXObject(Do) {
                  const ys = Do.startsWith("g_") ? this.commonObjs.get(Do) : this.objs.get(Do);
                  if (!ys) {
                    (0, ea.warn)(`Dependent image with object ID ${Do} is not ready yet`);
                    return;
                  }
                  this.paintInlineImageXObject(ys);
                }
                paintInlineImageXObject(Do, ys) {
                  const Io = Do.width, so = Do.height, os = no(Do, this.forceDataSchema, !!ys), Xs = this.svgFactory.createElement("svg:rect");
                  Xs.setAttributeNS(null, "x", "0"), Xs.setAttributeNS(null, "y", "0"), Xs.setAttributeNS(null, "width", io(Io)), Xs.setAttributeNS(null, "height", io(so)), this.current.element = Xs, this.clip("nonzero");
                  const gl = this.svgFactory.createElement("svg:image");
                  gl.setAttributeNS(La, "xlink:href", os), gl.setAttributeNS(null, "x", "0"), gl.setAttributeNS(null, "y", io(-so)), gl.setAttributeNS(null, "width", io(Io) + "px"), gl.setAttributeNS(null, "height", io(so) + "px"), gl.setAttributeNS(null, "transform", `scale(${io(1 / Io)} ${io(-1 / so)})`), ys ? ys.append(gl) : this._ensureTransformGroup().append(gl);
                }
                paintImageMaskXObject(Do) {
                  const ys = this.current, Io = Do.width, so = Do.height, os = ys.fillColor;
                  ys.maskId = `mask${qs++}`;
                  const Xs = this.svgFactory.createElement("svg:mask");
                  Xs.setAttributeNS(null, "id", ys.maskId);
                  const gl = this.svgFactory.createElement("svg:rect");
                  gl.setAttributeNS(null, "x", "0"), gl.setAttributeNS(null, "y", "0"), gl.setAttributeNS(null, "width", io(Io)), gl.setAttributeNS(null, "height", io(so)), gl.setAttributeNS(null, "fill", os), gl.setAttributeNS(null, "mask", `url(#${ys.maskId})`), this.defs.append(Xs), this._ensureTransformGroup().append(gl), this.paintInlineImageXObject(Do, Xs);
                }
                paintFormXObjectBegin(Do, ys) {
                  if (Array.isArray(Do) && Do.length === 6 && this.transform(Do[0], Do[1], Do[2], Do[3], Do[4], Do[5]), ys) {
                    const Io = ys[2] - ys[0], so = ys[3] - ys[1], os = this.svgFactory.createElement("svg:rect");
                    os.setAttributeNS(null, "x", ys[0]), os.setAttributeNS(null, "y", ys[1]), os.setAttributeNS(null, "width", io(Io)), os.setAttributeNS(null, "height", io(so)), this.current.element = os, this.clip("nonzero"), this.endPath();
                  }
                }
                paintFormXObjectEnd() {
                }
                _initialize(Do) {
                  const ys = this.svgFactory.create(Do.width, Do.height), Io = this.svgFactory.createElement("svg:defs");
                  ys.append(Io), this.defs = Io;
                  const so = this.svgFactory.createElement("svg:g");
                  return so.setAttributeNS(null, "transform", xs(Do.transform)), ys.append(so), this.svg = so, ys;
                }
                _ensureClipGroup() {
                  if (!this.current.clipGroup) {
                    const Do = this.svgFactory.createElement("svg:g");
                    Do.setAttributeNS(null, "clip-path", this.current.activeClipUrl), this.svg.append(Do), this.current.clipGroup = Do;
                  }
                  return this.current.clipGroup;
                }
                _ensureTransformGroup() {
                  return this.tgrp || (this.tgrp = this.svgFactory.createElement("svg:g"), this.tgrp.setAttributeNS(null, "transform", xs(this.transformMatrix)), this.current.activeClipUrl ? this._ensureClipGroup().append(this.tgrp) : this.svg.append(this.tgrp)), this.tgrp;
                }
              };
            }
          },
          /* 32 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFNodeStream = void 0;
            var Qi = Zi(1), ea = Zi(33);
            const ra = require$$5, na = require$$5, ia = require$$5, fa = require$$5, La = /^file:\/\/\/[a-zA-Z]:\//;
            function Va(qs) {
              const Fs = fa.parse(qs);
              return Fs.protocol === "file:" || Fs.host ? Fs : /^[a-z]:[/\\]/i.test(qs) ? fa.parse(`file:///${qs}`) : (Fs.host || (Fs.protocol = "file:"), Fs);
            }
            class to {
              constructor(Fs) {
                this.source = Fs, this.url = Va(Fs.url), this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:", this.isFsUrl = this.url.protocol === "file:", this.httpHeaders = this.isHttp && Fs.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              getFullReader() {
                return (0, Qi.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = this.isFsUrl ? new xs(this) : new ao(this), this._fullRequestReader;
              }
              getRangeReader(Fs, Do) {
                if (Do <= this._progressiveDataLength)
                  return null;
                const ys = this.isFsUrl ? new Ts(this, Fs, Do) : new io(this, Fs, Do);
                return this._rangeRequestReaders.push(ys), ys;
              }
              cancelAllRequests(Fs) {
                this._fullRequestReader && this._fullRequestReader.cancel(Fs);
                for (const Do of this._rangeRequestReaders.slice(0))
                  Do.cancel(Fs);
              }
            }
            e.PDFNodeStream = to;
            class ro {
              constructor(Fs) {
                this._url = Fs.url, this._done = !1, this._storedError = null, this.onProgress = null;
                const Do = Fs.source;
                this._contentLength = Do.length, this._loaded = 0, this._filename = null, this._disableRange = Do.disableRange || !1, this._rangeChunkSize = Do.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !Do.disableStream, this._isRangeSupported = !Do.disableRange, this._readableStream = null, this._readCapability = (0, Qi.createPromiseCapability)(), this._headersCapability = (0, Qi.createPromiseCapability)();
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                if (await this._readCapability.promise, this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                if (this._storedError)
                  throw this._storedError;
                const Fs = this._readableStream.read();
                return Fs === null ? (this._readCapability = (0, Qi.createPromiseCapability)(), this.read()) : (this._loaded += Fs.length, this.onProgress && this.onProgress({
                  loaded: this._loaded,
                  total: this._contentLength
                }), {
                  value: new Uint8Array(Fs).buffer,
                  done: !1
                });
              }
              cancel(Fs) {
                if (!this._readableStream) {
                  this._error(Fs);
                  return;
                }
                this._readableStream.destroy(Fs);
              }
              _error(Fs) {
                this._storedError = Fs, this._readCapability.resolve();
              }
              _setReadableStream(Fs) {
                this._readableStream = Fs, Fs.on("readable", () => {
                  this._readCapability.resolve();
                }), Fs.on("end", () => {
                  Fs.destroy(), this._done = !0, this._readCapability.resolve();
                }), Fs.on("error", (Do) => {
                  this._error(Do);
                }), !this._isStreamingSupported && this._isRangeSupported && this._error(new Qi.AbortException("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
              }
            }
            class no {
              constructor(Fs) {
                this._url = Fs.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = (0, Qi.createPromiseCapability)();
                const Do = Fs.source;
                this._isStreamingSupported = !Do.disableStream;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                if (await this._readCapability.promise, this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                if (this._storedError)
                  throw this._storedError;
                const Fs = this._readableStream.read();
                return Fs === null ? (this._readCapability = (0, Qi.createPromiseCapability)(), this.read()) : (this._loaded += Fs.length, this.onProgress && this.onProgress({
                  loaded: this._loaded
                }), {
                  value: new Uint8Array(Fs).buffer,
                  done: !1
                });
              }
              cancel(Fs) {
                if (!this._readableStream) {
                  this._error(Fs);
                  return;
                }
                this._readableStream.destroy(Fs);
              }
              _error(Fs) {
                this._storedError = Fs, this._readCapability.resolve();
              }
              _setReadableStream(Fs) {
                this._readableStream = Fs, Fs.on("readable", () => {
                  this._readCapability.resolve();
                }), Fs.on("end", () => {
                  Fs.destroy(), this._done = !0, this._readCapability.resolve();
                }), Fs.on("error", (Do) => {
                  this._error(Do);
                }), this._storedError && this._readableStream.destroy(this._storedError);
              }
            }
            function eo(qs, Fs) {
              return {
                protocol: qs.protocol,
                auth: qs.auth,
                host: qs.hostname,
                port: qs.port,
                path: qs.path,
                method: "GET",
                headers: Fs
              };
            }
            class ao extends ro {
              constructor(Fs) {
                super(Fs);
                const Do = (ys) => {
                  if (ys.statusCode === 404) {
                    const Xs = new Qi.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = Xs, this._headersCapability.reject(Xs);
                    return;
                  }
                  this._headersCapability.resolve(), this._setReadableStream(ys);
                  const Io = (Xs) => this._readableStream.headers[Xs.toLowerCase()], {
                    allowRangeRequests: so,
                    suggestedLength: os
                  } = (0, ea.validateRangeRequestCapabilities)({
                    getResponseHeader: Io,
                    isHttp: Fs.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = so, this._contentLength = os || this._contentLength, this._filename = (0, ea.extractFilenameFromHeader)(Io);
                };
                this._request = null, this._url.protocol === "http:" ? this._request = na.request(eo(this._url, Fs.httpHeaders), Do) : this._request = ia.request(eo(this._url, Fs.httpHeaders), Do), this._request.on("error", (ys) => {
                  this._storedError = ys, this._headersCapability.reject(ys);
                }), this._request.end();
              }
            }
            class io extends no {
              constructor(Fs, Do, ys) {
                super(Fs), this._httpHeaders = {};
                for (const so in Fs.httpHeaders) {
                  const os = Fs.httpHeaders[so];
                  typeof os > "u" || (this._httpHeaders[so] = os);
                }
                this._httpHeaders.Range = `bytes=${Do}-${ys - 1}`;
                const Io = (so) => {
                  if (so.statusCode === 404) {
                    const os = new Qi.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = os;
                    return;
                  }
                  this._setReadableStream(so);
                };
                this._request = null, this._url.protocol === "http:" ? this._request = na.request(eo(this._url, this._httpHeaders), Io) : this._request = ia.request(eo(this._url, this._httpHeaders), Io), this._request.on("error", (so) => {
                  this._storedError = so;
                }), this._request.end();
              }
            }
            class xs extends ro {
              constructor(Fs) {
                super(Fs);
                let Do = decodeURIComponent(this._url.path);
                La.test(this._url.href) && (Do = Do.replace(/^\//, "")), ra.lstat(Do, (ys, Io) => {
                  if (ys) {
                    ys.code === "ENOENT" && (ys = new Qi.MissingPDFException(`Missing PDF "${Do}".`)), this._storedError = ys, this._headersCapability.reject(ys);
                    return;
                  }
                  this._contentLength = Io.size, this._setReadableStream(ra.createReadStream(Do)), this._headersCapability.resolve();
                });
              }
            }
            class Ts extends no {
              constructor(Fs, Do, ys) {
                super(Fs);
                let Io = decodeURIComponent(this._url.path);
                La.test(this._url.href) && (Io = Io.replace(/^\//, "")), this._setReadableStream(ra.createReadStream(Io, {
                  start: Do,
                  end: ys - 1
                }));
              }
            }
          },
          /* 33 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.createResponseStatusError = fa, e.extractFilenameFromHeader = ia, e.validateRangeRequestCapabilities = na, e.validateResponseStatus = La;
            var Qi = Zi(1), ea = Zi(34), ra = Zi(8);
            function na({
              getResponseHeader: Va,
              isHttp: to,
              rangeChunkSize: ro,
              disableRange: no
            }) {
              const eo = {
                allowRangeRequests: !1,
                suggestedLength: void 0
              }, ao = parseInt(Va("Content-Length"), 10);
              return !Number.isInteger(ao) || (eo.suggestedLength = ao, ao <= 2 * ro) || no || !to || Va("Accept-Ranges") !== "bytes" || (Va("Content-Encoding") || "identity") !== "identity" || (eo.allowRangeRequests = !0), eo;
            }
            function ia(Va) {
              const to = Va("Content-Disposition");
              if (to) {
                let ro = (0, ea.getFilenameFromContentDispositionHeader)(to);
                if (ro.includes("%"))
                  try {
                    ro = decodeURIComponent(ro);
                  } catch {
                  }
                if ((0, ra.isPdfFile)(ro))
                  return ro;
              }
              return null;
            }
            function fa(Va, to) {
              return Va === 404 || Va === 0 && to.startsWith("file:") ? new Qi.MissingPDFException('Missing PDF "' + to + '".') : new Qi.UnexpectedResponseException(`Unexpected server response (${Va}) while retrieving PDF "${to}".`, Va);
            }
            function La(Va) {
              return Va === 200 || Va === 206;
            }
          },
          /* 34 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.getFilenameFromContentDispositionHeader = ea;
            var Qi = Zi(1);
            function ea(ra) {
              let na = !0, ia = fa("filename\\*", "i").exec(ra);
              if (ia) {
                ia = ia[1];
                let ao = ro(ia);
                return ao = unescape(ao), ao = no(ao), ao = eo(ao), Va(ao);
              }
              if (ia = to(ra), ia) {
                const ao = eo(ia);
                return Va(ao);
              }
              if (ia = fa("filename", "i").exec(ra), ia) {
                ia = ia[1];
                let ao = ro(ia);
                return ao = eo(ao), Va(ao);
              }
              function fa(ao, io) {
                return new RegExp("(?:^|;)\\s*" + ao + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', io);
              }
              function La(ao, io) {
                if (ao) {
                  if (!/^[\x00-\xFF]+$/.test(io))
                    return io;
                  try {
                    const xs = new TextDecoder(ao, {
                      fatal: !0
                    }), Ts = (0, Qi.stringToBytes)(io);
                    io = xs.decode(Ts), na = !1;
                  } catch {
                  }
                }
                return io;
              }
              function Va(ao) {
                return na && /[\x80-\xff]/.test(ao) && (ao = La("utf-8", ao), na && (ao = La("iso-8859-1", ao))), ao;
              }
              function to(ao) {
                const io = [];
                let xs;
                const Ts = fa("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                for (; (xs = Ts.exec(ao)) !== null; ) {
                  let [, Fs, Do, ys] = xs;
                  if (Fs = parseInt(Fs, 10), Fs in io) {
                    if (Fs === 0)
                      break;
                    continue;
                  }
                  io[Fs] = [Do, ys];
                }
                const qs = [];
                for (let Fs = 0; Fs < io.length && Fs in io; ++Fs) {
                  let [Do, ys] = io[Fs];
                  ys = ro(ys), Do && (ys = unescape(ys), Fs === 0 && (ys = no(ys))), qs.push(ys);
                }
                return qs.join("");
              }
              function ro(ao) {
                if (ao.startsWith('"')) {
                  const io = ao.slice(1).split('\\"');
                  for (let xs = 0; xs < io.length; ++xs) {
                    const Ts = io[xs].indexOf('"');
                    Ts !== -1 && (io[xs] = io[xs].slice(0, Ts), io.length = xs + 1), io[xs] = io[xs].replace(/\\(.)/g, "$1");
                  }
                  ao = io.join('"');
                }
                return ao;
              }
              function no(ao) {
                const io = ao.indexOf("'");
                if (io === -1)
                  return ao;
                const xs = ao.slice(0, io), qs = ao.slice(io + 1).replace(/^[^']*'/, "");
                return La(xs, qs);
              }
              function eo(ao) {
                return !ao.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(ao) ? ao : ao.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(io, xs, Ts, qs) {
                  if (Ts === "q" || Ts === "Q")
                    return qs = qs.replace(/_/g, " "), qs = qs.replace(/=([0-9a-fA-F]{2})/g, function(Fs, Do) {
                      return String.fromCharCode(parseInt(Do, 16));
                    }), La(xs, qs);
                  try {
                    qs = atob(qs);
                  } catch {
                  }
                  return La(xs, qs);
                });
              }
              return "";
            }
          },
          /* 35 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFNetworkStream = void 0;
            var Qi = Zi(1), ea = Zi(33);
            const ra = 200, na = 206;
            function ia(ro) {
              const no = ro.response;
              return typeof no != "string" ? no : (0, Qi.stringToBytes)(no).buffer;
            }
            class fa {
              constructor(no, eo = {}) {
                this.url = no, this.isHttp = /^https?:/i.test(no), this.httpHeaders = this.isHttp && eo.httpHeaders || /* @__PURE__ */ Object.create(null), this.withCredentials = eo.withCredentials || !1, this.getXhr = eo.getXhr || function() {
                  return new XMLHttpRequest();
                }, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
              }
              requestRange(no, eo, ao) {
                const io = {
                  begin: no,
                  end: eo
                };
                for (const xs in ao)
                  io[xs] = ao[xs];
                return this.request(io);
              }
              requestFull(no) {
                return this.request(no);
              }
              request(no) {
                const eo = this.getXhr(), ao = this.currXhrId++, io = this.pendingRequests[ao] = {
                  xhr: eo
                };
                eo.open("GET", this.url), eo.withCredentials = this.withCredentials;
                for (const xs in this.httpHeaders) {
                  const Ts = this.httpHeaders[xs];
                  typeof Ts > "u" || eo.setRequestHeader(xs, Ts);
                }
                return this.isHttp && "begin" in no && "end" in no ? (eo.setRequestHeader("Range", `bytes=${no.begin}-${no.end - 1}`), io.expectedStatus = na) : io.expectedStatus = ra, eo.responseType = "arraybuffer", no.onError && (eo.onerror = function(xs) {
                  no.onError(eo.status);
                }), eo.onreadystatechange = this.onStateChange.bind(this, ao), eo.onprogress = this.onProgress.bind(this, ao), io.onHeadersReceived = no.onHeadersReceived, io.onDone = no.onDone, io.onError = no.onError, io.onProgress = no.onProgress, eo.send(null), ao;
              }
              onProgress(no, eo) {
                const ao = this.pendingRequests[no];
                ao && ao.onProgress?.(eo);
              }
              onStateChange(no, eo) {
                const ao = this.pendingRequests[no];
                if (!ao)
                  return;
                const io = ao.xhr;
                if (io.readyState >= 2 && ao.onHeadersReceived && (ao.onHeadersReceived(), delete ao.onHeadersReceived), io.readyState !== 4 || !(no in this.pendingRequests))
                  return;
                if (delete this.pendingRequests[no], io.status === 0 && this.isHttp) {
                  ao.onError?.(io.status);
                  return;
                }
                const xs = io.status || ra;
                if (!(xs === ra && ao.expectedStatus === na) && xs !== ao.expectedStatus) {
                  ao.onError?.(io.status);
                  return;
                }
                const qs = ia(io);
                if (xs === na) {
                  const Fs = io.getResponseHeader("Content-Range"), Do = /bytes (\d+)-(\d+)\/(\d+)/.exec(Fs);
                  ao.onDone({
                    begin: parseInt(Do[1], 10),
                    chunk: qs
                  });
                } else qs ? ao.onDone({
                  begin: 0,
                  chunk: qs
                }) : ao.onError?.(io.status);
              }
              getRequestXhr(no) {
                return this.pendingRequests[no].xhr;
              }
              isPendingRequest(no) {
                return no in this.pendingRequests;
              }
              abortRequest(no) {
                const eo = this.pendingRequests[no].xhr;
                delete this.pendingRequests[no], eo.abort();
              }
            }
            class La {
              constructor(no) {
                this._source = no, this._manager = new fa(no.url, {
                  httpHeaders: no.httpHeaders,
                  withCredentials: no.withCredentials
                }), this._rangeChunkSize = no.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              _onRangeRequestReaderClosed(no) {
                const eo = this._rangeRequestReaders.indexOf(no);
                eo >= 0 && this._rangeRequestReaders.splice(eo, 1);
              }
              getFullReader() {
                return (0, Qi.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new Va(this._manager, this._source), this._fullRequestReader;
              }
              getRangeReader(no, eo) {
                const ao = new to(this._manager, no, eo);
                return ao.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(ao), ao;
              }
              cancelAllRequests(no) {
                this._fullRequestReader?.cancel(no);
                for (const eo of this._rangeRequestReaders.slice(0))
                  eo.cancel(no);
              }
            }
            e.PDFNetworkStream = La;
            class Va {
              constructor(no, eo) {
                this._manager = no;
                const ao = {
                  onHeadersReceived: this._onHeadersReceived.bind(this),
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = eo.url, this._fullRequestId = no.requestFull(ao), this._headersReceivedCapability = (0, Qi.createPromiseCapability)(), this._disableRange = eo.disableRange || !1, this._contentLength = eo.length, this._rangeChunkSize = eo.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
              }
              _onHeadersReceived() {
                const no = this._fullRequestId, eo = this._manager.getRequestXhr(no), ao = (Ts) => eo.getResponseHeader(Ts), {
                  allowRangeRequests: io,
                  suggestedLength: xs
                } = (0, ea.validateRangeRequestCapabilities)({
                  getResponseHeader: ao,
                  isHttp: this._manager.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                io && (this._isRangeSupported = !0), this._contentLength = xs || this._contentLength, this._filename = (0, ea.extractFilenameFromHeader)(ao), this._isRangeSupported && this._manager.abortRequest(no), this._headersReceivedCapability.resolve();
              }
              _onDone(no) {
                if (no && (this._requests.length > 0 ? this._requests.shift().resolve({
                  value: no.chunk,
                  done: !1
                }) : this._cachedChunks.push(no.chunk)), this._done = !0, !(this._cachedChunks.length > 0)) {
                  for (const eo of this._requests)
                    eo.resolve({
                      value: void 0,
                      done: !0
                    });
                  this._requests.length = 0;
                }
              }
              _onError(no) {
                this._storedError = (0, ea.createResponseStatusError)(no, this._url), this._headersReceivedCapability.reject(this._storedError);
                for (const eo of this._requests)
                  eo.reject(this._storedError);
                this._requests.length = 0, this._cachedChunks.length = 0;
              }
              _onProgress(no) {
                this.onProgress?.({
                  loaded: no.loaded,
                  total: no.lengthComputable ? no.total : this._contentLength
                });
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              get contentLength() {
                return this._contentLength;
              }
              get headersReady() {
                return this._headersReceivedCapability.promise;
              }
              async read() {
                if (this._storedError)
                  throw this._storedError;
                if (this._cachedChunks.length > 0)
                  return {
                    value: this._cachedChunks.shift(),
                    done: !1
                  };
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const no = (0, Qi.createPromiseCapability)();
                return this._requests.push(no), no.promise;
              }
              cancel(no) {
                this._done = !0, this._headersReceivedCapability.reject(no);
                for (const eo of this._requests)
                  eo.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
              }
            }
            class to {
              constructor(no, eo, ao) {
                this._manager = no;
                const io = {
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = no.url, this._requestId = no.requestRange(eo, ao, io), this._requests = [], this._queuedChunk = null, this._done = !1, this._storedError = void 0, this.onProgress = null, this.onClosed = null;
              }
              _close() {
                this.onClosed?.(this);
              }
              _onDone(no) {
                const eo = no.chunk;
                this._requests.length > 0 ? this._requests.shift().resolve({
                  value: eo,
                  done: !1
                }) : this._queuedChunk = eo, this._done = !0;
                for (const ao of this._requests)
                  ao.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._close();
              }
              _onError(no) {
                this._storedError = (0, ea.createResponseStatusError)(no, this._url);
                for (const eo of this._requests)
                  eo.reject(this._storedError);
                this._requests.length = 0, this._queuedChunk = null;
              }
              _onProgress(no) {
                this.isStreamingSupported || this.onProgress?.({
                  loaded: no.loaded
                });
              }
              get isStreamingSupported() {
                return !1;
              }
              async read() {
                if (this._storedError)
                  throw this._storedError;
                if (this._queuedChunk !== null) {
                  const eo = this._queuedChunk;
                  return this._queuedChunk = null, {
                    value: eo,
                    done: !1
                  };
                }
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const no = (0, Qi.createPromiseCapability)();
                return this._requests.push(no), no.promise;
              }
              cancel(no) {
                this._done = !0;
                for (const eo of this._requests)
                  eo.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
              }
            }
          },
          /* 36 */
          /***/
          (Bi, e, Zi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFFetchStream = void 0;
            var Qi = Zi(1), ea = Zi(33);
            function ra(Va, to, ro) {
              return {
                method: "GET",
                headers: Va,
                signal: ro.signal,
                mode: "cors",
                credentials: to ? "include" : "same-origin",
                redirect: "follow"
              };
            }
            function na(Va) {
              const to = new Headers();
              for (const ro in Va) {
                const no = Va[ro];
                typeof no > "u" || to.append(ro, no);
              }
              return to;
            }
            class ia {
              constructor(to) {
                this.source = to, this.isHttp = /^https?:/i.test(to.url), this.httpHeaders = this.isHttp && to.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              getFullReader() {
                return (0, Qi.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new fa(this), this._fullRequestReader;
              }
              getRangeReader(to, ro) {
                if (ro <= this._progressiveDataLength)
                  return null;
                const no = new La(this, to, ro);
                return this._rangeRequestReaders.push(no), no;
              }
              cancelAllRequests(to) {
                this._fullRequestReader && this._fullRequestReader.cancel(to);
                for (const ro of this._rangeRequestReaders.slice(0))
                  ro.cancel(to);
              }
            }
            e.PDFFetchStream = ia;
            class fa {
              constructor(to) {
                this._stream = to, this._reader = null, this._loaded = 0, this._filename = null;
                const ro = to.source;
                this._withCredentials = ro.withCredentials || !1, this._contentLength = ro.length, this._headersCapability = (0, Qi.createPromiseCapability)(), this._disableRange = ro.disableRange || !1, this._rangeChunkSize = ro.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._abortController = new AbortController(), this._isStreamingSupported = !ro.disableStream, this._isRangeSupported = !ro.disableRange, this._headers = na(this._stream.httpHeaders);
                const no = ro.url;
                fetch(no, ra(this._headers, this._withCredentials, this._abortController)).then((eo) => {
                  if (!(0, ea.validateResponseStatus)(eo.status))
                    throw (0, ea.createResponseStatusError)(eo.status, no);
                  this._reader = eo.body.getReader(), this._headersCapability.resolve();
                  const ao = (Ts) => eo.headers.get(Ts), {
                    allowRangeRequests: io,
                    suggestedLength: xs
                  } = (0, ea.validateRangeRequestCapabilities)({
                    getResponseHeader: ao,
                    isHttp: this._stream.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = io, this._contentLength = xs || this._contentLength, this._filename = (0, ea.extractFilenameFromHeader)(ao), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new Qi.AbortException("Streaming is disabled."));
                }).catch(this._headersCapability.reject), this.onProgress = null;
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                await this._headersCapability.promise;
                const {
                  value: to,
                  done: ro
                } = await this._reader.read();
                return ro ? {
                  value: to,
                  done: ro
                } : (this._loaded += to.byteLength, this.onProgress && this.onProgress({
                  loaded: this._loaded,
                  total: this._contentLength
                }), {
                  value: new Uint8Array(to).buffer,
                  done: !1
                });
              }
              cancel(to) {
                this._reader && this._reader.cancel(to), this._abortController.abort();
              }
            }
            class La {
              constructor(to, ro, no) {
                this._stream = to, this._reader = null, this._loaded = 0;
                const eo = to.source;
                this._withCredentials = eo.withCredentials || !1, this._readCapability = (0, Qi.createPromiseCapability)(), this._isStreamingSupported = !eo.disableStream, this._abortController = new AbortController(), this._headers = na(this._stream.httpHeaders), this._headers.append("Range", `bytes=${ro}-${no - 1}`);
                const ao = eo.url;
                fetch(ao, ra(this._headers, this._withCredentials, this._abortController)).then((io) => {
                  if (!(0, ea.validateResponseStatus)(io.status))
                    throw (0, ea.createResponseStatusError)(io.status, ao);
                  this._readCapability.resolve(), this._reader = io.body.getReader();
                }).catch(this._readCapability.reject), this.onProgress = null;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                await this._readCapability.promise;
                const {
                  value: to,
                  done: ro
                } = await this._reader.read();
                return ro ? {
                  value: to,
                  done: ro
                } : (this._loaded += to.byteLength, this.onProgress && this.onProgress({
                  loaded: this._loaded
                }), {
                  value: new Uint8Array(to).buffer,
                  done: !1
                });
              }
              cancel(to) {
                this._reader && this._reader.cancel(to), this._abortController.abort();
              }
            }
          }
          /******/
        ], __webpack_module_cache__ = {};
        function __w_pdfjs_require__(Bi) {
          var e = __webpack_module_cache__[Bi];
          if (e !== void 0)
            return e.exports;
          var Zi = __webpack_module_cache__[Bi] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return __webpack_modules__[Bi](Zi, Zi.exports, __w_pdfjs_require__), Zi.exports;
        }
        var __webpack_exports__ = {};
        return (() => {
          var Bi = __webpack_exports__;
          Object.defineProperty(Bi, "__esModule", {
            value: !0
          }), Object.defineProperty(Bi, "AnnotationEditorLayer", {
            enumerable: !0,
            get: function() {
              return ea.AnnotationEditorLayer;
            }
          }), Object.defineProperty(Bi, "AnnotationEditorParamsType", {
            enumerable: !0,
            get: function() {
              return e.AnnotationEditorParamsType;
            }
          }), Object.defineProperty(Bi, "AnnotationEditorType", {
            enumerable: !0,
            get: function() {
              return e.AnnotationEditorType;
            }
          }), Object.defineProperty(Bi, "AnnotationEditorUIManager", {
            enumerable: !0,
            get: function() {
              return ra.AnnotationEditorUIManager;
            }
          }), Object.defineProperty(Bi, "AnnotationLayer", {
            enumerable: !0,
            get: function() {
              return na.AnnotationLayer;
            }
          }), Object.defineProperty(Bi, "AnnotationMode", {
            enumerable: !0,
            get: function() {
              return e.AnnotationMode;
            }
          }), Object.defineProperty(Bi, "CMapCompressionType", {
            enumerable: !0,
            get: function() {
              return e.CMapCompressionType;
            }
          }), Object.defineProperty(Bi, "GlobalWorkerOptions", {
            enumerable: !0,
            get: function() {
              return ia.GlobalWorkerOptions;
            }
          }), Object.defineProperty(Bi, "InvalidPDFException", {
            enumerable: !0,
            get: function() {
              return e.InvalidPDFException;
            }
          }), Object.defineProperty(Bi, "LoopbackPort", {
            enumerable: !0,
            get: function() {
              return Zi.LoopbackPort;
            }
          }), Object.defineProperty(Bi, "MissingPDFException", {
            enumerable: !0,
            get: function() {
              return e.MissingPDFException;
            }
          }), Object.defineProperty(Bi, "OPS", {
            enumerable: !0,
            get: function() {
              return e.OPS;
            }
          }), Object.defineProperty(Bi, "PDFDataRangeTransport", {
            enumerable: !0,
            get: function() {
              return Zi.PDFDataRangeTransport;
            }
          }), Object.defineProperty(Bi, "PDFDateString", {
            enumerable: !0,
            get: function() {
              return Qi.PDFDateString;
            }
          }), Object.defineProperty(Bi, "PDFWorker", {
            enumerable: !0,
            get: function() {
              return Zi.PDFWorker;
            }
          }), Object.defineProperty(Bi, "PasswordResponses", {
            enumerable: !0,
            get: function() {
              return e.PasswordResponses;
            }
          }), Object.defineProperty(Bi, "PermissionFlag", {
            enumerable: !0,
            get: function() {
              return e.PermissionFlag;
            }
          }), Object.defineProperty(Bi, "PixelsPerInch", {
            enumerable: !0,
            get: function() {
              return Qi.PixelsPerInch;
            }
          }), Object.defineProperty(Bi, "RenderingCancelledException", {
            enumerable: !0,
            get: function() {
              return Qi.RenderingCancelledException;
            }
          }), Object.defineProperty(Bi, "SVGGraphics", {
            enumerable: !0,
            get: function() {
              return Va.SVGGraphics;
            }
          }), Object.defineProperty(Bi, "UNSUPPORTED_FEATURES", {
            enumerable: !0,
            get: function() {
              return e.UNSUPPORTED_FEATURES;
            }
          }), Object.defineProperty(Bi, "UnexpectedResponseException", {
            enumerable: !0,
            get: function() {
              return e.UnexpectedResponseException;
            }
          }), Object.defineProperty(Bi, "Util", {
            enumerable: !0,
            get: function() {
              return e.Util;
            }
          }), Object.defineProperty(Bi, "VerbosityLevel", {
            enumerable: !0,
            get: function() {
              return e.VerbosityLevel;
            }
          }), Object.defineProperty(Bi, "XfaLayer", {
            enumerable: !0,
            get: function() {
              return to.XfaLayer;
            }
          }), Object.defineProperty(Bi, "build", {
            enumerable: !0,
            get: function() {
              return Zi.build;
            }
          }), Object.defineProperty(Bi, "createPromiseCapability", {
            enumerable: !0,
            get: function() {
              return e.createPromiseCapability;
            }
          }), Object.defineProperty(Bi, "createValidAbsoluteUrl", {
            enumerable: !0,
            get: function() {
              return e.createValidAbsoluteUrl;
            }
          }), Object.defineProperty(Bi, "getDocument", {
            enumerable: !0,
            get: function() {
              return Zi.getDocument;
            }
          }), Object.defineProperty(Bi, "getFilenameFromUrl", {
            enumerable: !0,
            get: function() {
              return Qi.getFilenameFromUrl;
            }
          }), Object.defineProperty(Bi, "getPdfFilenameFromUrl", {
            enumerable: !0,
            get: function() {
              return Qi.getPdfFilenameFromUrl;
            }
          }), Object.defineProperty(Bi, "getXfaPageViewport", {
            enumerable: !0,
            get: function() {
              return Qi.getXfaPageViewport;
            }
          }), Object.defineProperty(Bi, "isPdfFile", {
            enumerable: !0,
            get: function() {
              return Qi.isPdfFile;
            }
          }), Object.defineProperty(Bi, "loadScript", {
            enumerable: !0,
            get: function() {
              return Qi.loadScript;
            }
          }), Object.defineProperty(Bi, "renderTextLayer", {
            enumerable: !0,
            get: function() {
              return La.renderTextLayer;
            }
          }), Object.defineProperty(Bi, "shadow", {
            enumerable: !0,
            get: function() {
              return e.shadow;
            }
          }), Object.defineProperty(Bi, "version", {
            enumerable: !0,
            get: function() {
              return Zi.version;
            }
          });
          var e = __w_pdfjs_require__(1), Zi = __w_pdfjs_require__(4), Qi = __w_pdfjs_require__(8), ea = __w_pdfjs_require__(22), ra = __w_pdfjs_require__(7), na = __w_pdfjs_require__(27), ia = __w_pdfjs_require__(15), fa = __w_pdfjs_require__(3), La = __w_pdfjs_require__(30), Va = __w_pdfjs_require__(31), to = __w_pdfjs_require__(29);
          if (fa.isNodeJS) {
            const {
              PDFNodeStream: ro
            } = __w_pdfjs_require__(32);
            (0, Zi.setPDFNetworkStreamFactory)((no) => new ro(no));
          } else {
            const {
              PDFNetworkStream: ro
            } = __w_pdfjs_require__(35), {
              PDFFetchStream: no
            } = __w_pdfjs_require__(36);
            (0, Zi.setPDFNetworkStreamFactory)((eo) => (0, Qi.isValidFetchUrl)(eo.url) ? new no(eo) : new ro(eo));
          }
        })(), __webpack_exports__;
      })()
    ));
  }(pdf)), pdf.exports;
}
var pdfExports = requirePdf();
async function renderPage(Bi, e, Zi, Qi) {
  const ea = await Bi.getPage(Zi), ra = ea.getViewport({ scale: 5 });
  e.height = ra.height, e.width = ra.width;
  const na = e.getContext("2d");
  if (!na)
    return;
  const ia = {
    canvasContext: na,
    viewport: ra
  }, fa = ra.height * (Zi - 1);
  await ea.render(ia).promise, na.setTransform(1, 0, 0, 1, 0, 0), Qi.push({
    data: e.toDataURL(),
    offset: fa,
    page: Zi
  }), Zi + 1 <= Bi.numPages && await renderPage(Bi, e, Zi + 1, Qi);
}
const usePDF = ({ url: Bi, canvas: e }) => {
  const [Zi, Qi] = useState(null), [ea, ra] = useState([]), [na, ia] = useState(!1), fa = useCallback(
    async (La) => {
      if (!e || !Zi) return;
      const Va = { data: [] };
      await renderPage(Zi, e, La, Va.data), ra(Va.data), ia(!0);
    },
    [Zi, ia]
  );
  return useEffect(() => {
    fa(1);
  }, [Zi, fa]), useEffect(() => {
    pdfExports.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfExports.version}/pdf.worker.js`, pdfExports.getDocument({ url: Bi }).promise.then((Va) => {
      Qi(Va);
    });
  }, []), {
    ready: na,
    pageData: ea,
    totalPages: Zi?.numPages
  };
}, PDFPreview = ({ url: Bi }) => {
  const e = useRef(null), { ready: Zi, pageData: Qi } = usePDF({
    url: Bi,
    canvas: e.current
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    !Zi && /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { ref: e }),
    Qi.map(({ data: ea }, ra) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        className: "mb-2 max-w-xl",
        src: ea
      },
      `pdf-preview-${Bi}=${ra}`
    ))
  ] });
}, SVGPreview = ({ data: Bi }) => {
  const [e, Zi] = useState(null), Qi = async () => {
    const ea = await Bi.text();
    Zi(ea);
  };
  return useEffect(() => {
    Qi();
  }, [Bi]), e ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: e } }) }) : null;
};
var papaparse_min$1 = { exports: {} };
/* @license
Papa Parse
v5.3.2
https://github.com/mholt/PapaParse
License: MIT
*/
var papaparse_min = papaparse_min$1.exports, hasRequiredPapaparse_min;
function requirePapaparse_min() {
  return hasRequiredPapaparse_min || (hasRequiredPapaparse_min = 1, function(Bi, e) {
    (function(Zi, Qi) {
      Bi.exports = Qi();
    })(papaparse_min, function Zi() {
      var Qi = typeof self < "u" ? self : typeof window < "u" ? window : Qi !== void 0 ? Qi : {}, ea = !Qi.document && !!Qi.postMessage, ra = ea && /blob:/i.test((Qi.location || {}).protocol), na = {}, ia = 0, fa = { parse: function(so, os) {
        var Xs = (os = os || {}).dynamicTyping || !1;
        if (Io(Xs) && (os.dynamicTypingFunction = Xs, Xs = {}), os.dynamicTyping = Xs, os.transform = !!Io(os.transform) && os.transform, os.worker && fa.WORKERS_SUPPORTED) {
          var gl = function() {
            if (!fa.WORKERS_SUPPORTED) return !1;
            var El = (jl = Qi.URL || Qi.webkitURL || null, kl = Zi.toString(), fa.BLOB_URL || (fa.BLOB_URL = jl.createObjectURL(new Blob(["(", kl, ")();"], { type: "text/javascript" })))), wl = new Qi.Worker(El), jl, kl;
            return wl.onmessage = Ts, wl.id = ia++, na[wl.id] = wl;
          }();
          return gl.userStep = os.step, gl.userChunk = os.chunk, gl.userComplete = os.complete, gl.userError = os.error, os.step = Io(os.step), os.chunk = Io(os.chunk), os.complete = Io(os.complete), os.error = Io(os.error), delete os.worker, void gl.postMessage({ input: so, config: os, workerId: gl.id });
        }
        var Sl = null;
        return fa.NODE_STREAM_INPUT, typeof so == "string" ? Sl = os.download ? new to(os) : new no(os) : so.readable === !0 && Io(so.read) && Io(so.on) ? Sl = new eo(os) : (Qi.File && so instanceof File || so instanceof Object) && (Sl = new ro(os)), Sl.stream(so);
      }, unparse: function(so, os) {
        var Xs = !1, gl = !0, Sl = ",", El = `\r
`, wl = '"', jl = wl + wl, kl = !1, Fl = null, Ml = !1;
        (function() {
          if (typeof os == "object") {
            if (typeof os.delimiter != "string" || fa.BAD_DELIMITERS.filter(function(Il) {
              return os.delimiter.indexOf(Il) !== -1;
            }).length || (Sl = os.delimiter), (typeof os.quotes == "boolean" || typeof os.quotes == "function" || Array.isArray(os.quotes)) && (Xs = os.quotes), typeof os.skipEmptyLines != "boolean" && typeof os.skipEmptyLines != "string" || (kl = os.skipEmptyLines), typeof os.newline == "string" && (El = os.newline), typeof os.quoteChar == "string" && (wl = os.quoteChar), typeof os.header == "boolean" && (gl = os.header), Array.isArray(os.columns)) {
              if (os.columns.length === 0) throw new Error("Option columns is empty");
              Fl = os.columns;
            }
            os.escapeChar !== void 0 && (jl = os.escapeChar + wl), (typeof os.escapeFormulae == "boolean" || os.escapeFormulae instanceof RegExp) && (Ml = os.escapeFormulae instanceof RegExp ? os.escapeFormulae : /^[=+\-@\t\r].*$/);
          }
        })();
        var ql = new RegExp(io(wl), "g");
        if (typeof so == "string" && (so = JSON.parse(so)), Array.isArray(so)) {
          if (!so.length || Array.isArray(so[0])) return Kl(null, so, kl);
          if (typeof so[0] == "object") return Kl(Fl || Object.keys(so[0]), so, kl);
        } else if (typeof so == "object") return typeof so.data == "string" && (so.data = JSON.parse(so.data)), Array.isArray(so.data) && (so.fields || (so.fields = so.meta && so.meta.fields || Fl), so.fields || (so.fields = Array.isArray(so.data[0]) ? so.fields : typeof so.data[0] == "object" ? Object.keys(so.data[0]) : []), Array.isArray(so.data[0]) || typeof so.data[0] == "object" || (so.data = [so.data])), Kl(so.fields || [], so.data || [], kl);
        throw new Error("Unable to serialize unrecognized input");
        function Kl(Il, xl, bl) {
          var Pl = "";
          typeof Il == "string" && (Il = JSON.parse(Il)), typeof xl == "string" && (xl = JSON.parse(xl));
          var Nl = Array.isArray(Il) && 0 < Il.length, Bl = !Array.isArray(xl[0]);
          if (Nl && gl) {
            for (var Ol = 0; Ol < Il.length; Ol++) 0 < Ol && (Pl += Sl), Pl += Zl(Il[Ol], Ol);
            0 < xl.length && (Pl += El);
          }
          for (var To = 0; To < xl.length; To++) {
            var Os = Nl ? Il.length : xl[To].length, $l = !1, _l = Nl ? Object.keys(xl[To]).length === 0 : xl[To].length === 0;
            if (bl && !Nl && ($l = bl === "greedy" ? xl[To].join("").trim() === "" : xl[To].length === 1 && xl[To][0].length === 0), bl === "greedy" && Nl) {
              for (var Al = [], Rl = 0; Rl < Os; Rl++) {
                var Cl = Bl ? Il[Rl] : Rl;
                Al.push(xl[To][Cl]);
              }
              $l = Al.join("").trim() === "";
            }
            if (!$l) {
              for (var ml = 0; ml < Os; ml++) {
                0 < ml && !_l && (Pl += Sl);
                var Tl = Nl && Bl ? Il[ml] : ml;
                Pl += Zl(xl[To][Tl], ml);
              }
              To < xl.length - 1 && (!bl || 0 < Os && !_l) && (Pl += El);
            }
          }
          return Pl;
        }
        function Zl(Il, xl) {
          if (Il == null) return "";
          if (Il.constructor === Date) return JSON.stringify(Il).slice(1, 25);
          var bl = !1;
          Ml && typeof Il == "string" && Ml.test(Il) && (Il = "'" + Il, bl = !0);
          var Pl = Il.toString().replace(ql, jl);
          return (bl = bl || Xs === !0 || typeof Xs == "function" && Xs(Il, xl) || Array.isArray(Xs) && Xs[xl] || function(Nl, Bl) {
            for (var Ol = 0; Ol < Bl.length; Ol++) if (-1 < Nl.indexOf(Bl[Ol])) return !0;
            return !1;
          }(Pl, fa.BAD_DELIMITERS) || -1 < Pl.indexOf(Sl) || Pl.charAt(0) === " " || Pl.charAt(Pl.length - 1) === " ") ? wl + Pl + wl : Pl;
        }
      } };
      if (fa.RECORD_SEP = "", fa.UNIT_SEP = "", fa.BYTE_ORDER_MARK = "\uFEFF", fa.BAD_DELIMITERS = ["\r", `
`, '"', fa.BYTE_ORDER_MARK], fa.WORKERS_SUPPORTED = !ea && !!Qi.Worker, fa.NODE_STREAM_INPUT = 1, fa.LocalChunkSize = 10485760, fa.RemoteChunkSize = 5242880, fa.DefaultDelimiter = ",", fa.Parser = xs, fa.ParserHandle = ao, fa.NetworkStreamer = to, fa.FileStreamer = ro, fa.StringStreamer = no, fa.ReadableStreamStreamer = eo, Qi.jQuery) {
        var La = Qi.jQuery;
        La.fn.parse = function(so) {
          var os = so.config || {}, Xs = [];
          return this.each(function(El) {
            if (!(La(this).prop("tagName").toUpperCase() === "INPUT" && La(this).attr("type").toLowerCase() === "file" && Qi.FileReader) || !this.files || this.files.length === 0) return !0;
            for (var wl = 0; wl < this.files.length; wl++) Xs.push({ file: this.files[wl], inputElem: this, instanceConfig: La.extend({}, os) });
          }), gl(), this;
          function gl() {
            if (Xs.length !== 0) {
              var El, wl, jl, kl, Fl = Xs[0];
              if (Io(so.before)) {
                var Ml = so.before(Fl.file, Fl.inputElem);
                if (typeof Ml == "object") {
                  if (Ml.action === "abort") return El = "AbortError", wl = Fl.file, jl = Fl.inputElem, kl = Ml.reason, void (Io(so.error) && so.error({ name: El }, wl, jl, kl));
                  if (Ml.action === "skip") return void Sl();
                  typeof Ml.config == "object" && (Fl.instanceConfig = La.extend(Fl.instanceConfig, Ml.config));
                } else if (Ml === "skip") return void Sl();
              }
              var ql = Fl.instanceConfig.complete;
              Fl.instanceConfig.complete = function(Kl) {
                Io(ql) && ql(Kl, Fl.file, Fl.inputElem), Sl();
              }, fa.parse(Fl.file, Fl.instanceConfig);
            } else Io(so.complete) && so.complete();
          }
          function Sl() {
            Xs.splice(0, 1), gl();
          }
        };
      }
      function Va(so) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, function(os) {
          var Xs = Do(os);
          Xs.chunkSize = parseInt(Xs.chunkSize), os.step || os.chunk || (Xs.chunkSize = null), this._handle = new ao(Xs), (this._handle.streamer = this)._config = Xs;
        }.call(this, so), this.parseChunk = function(os, Xs) {
          if (this.isFirstChunk && Io(this._config.beforeFirstChunk)) {
            var gl = this._config.beforeFirstChunk(os);
            gl !== void 0 && (os = gl);
          }
          this.isFirstChunk = !1, this._halted = !1;
          var Sl = this._partialLine + os;
          this._partialLine = "";
          var El = this._handle.parse(Sl, this._baseIndex, !this._finished);
          if (!this._handle.paused() && !this._handle.aborted()) {
            var wl = El.meta.cursor;
            this._finished || (this._partialLine = Sl.substring(wl - this._baseIndex), this._baseIndex = wl), El && El.data && (this._rowCount += El.data.length);
            var jl = this._finished || this._config.preview && this._rowCount >= this._config.preview;
            if (ra) Qi.postMessage({ results: El, workerId: fa.WORKER_ID, finished: jl });
            else if (Io(this._config.chunk) && !Xs) {
              if (this._config.chunk(El, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
              El = void 0, this._completeResults = void 0;
            }
            return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(El.data), this._completeResults.errors = this._completeResults.errors.concat(El.errors), this._completeResults.meta = El.meta), this._completed || !jl || !Io(this._config.complete) || El && El.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), jl || El && El.meta.paused || this._nextChunk(), El;
          }
          this._halted = !0;
        }, this._sendError = function(os) {
          Io(this._config.error) ? this._config.error(os) : ra && this._config.error && Qi.postMessage({ workerId: fa.WORKER_ID, error: os, finished: !1 });
        };
      }
      function to(so) {
        var os;
        (so = so || {}).chunkSize || (so.chunkSize = fa.RemoteChunkSize), Va.call(this, so), this._nextChunk = ea ? function() {
          this._readChunk(), this._chunkLoaded();
        } : function() {
          this._readChunk();
        }, this.stream = function(Xs) {
          this._input = Xs, this._nextChunk();
        }, this._readChunk = function() {
          if (this._finished) this._chunkLoaded();
          else {
            if (os = new XMLHttpRequest(), this._config.withCredentials && (os.withCredentials = this._config.withCredentials), ea || (os.onload = ys(this._chunkLoaded, this), os.onerror = ys(this._chunkError, this)), os.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !ea), this._config.downloadRequestHeaders) {
              var Xs = this._config.downloadRequestHeaders;
              for (var gl in Xs) os.setRequestHeader(gl, Xs[gl]);
            }
            if (this._config.chunkSize) {
              var Sl = this._start + this._config.chunkSize - 1;
              os.setRequestHeader("Range", "bytes=" + this._start + "-" + Sl);
            }
            try {
              os.send(this._config.downloadRequestBody);
            } catch (El) {
              this._chunkError(El.message);
            }
            ea && os.status === 0 && this._chunkError();
          }
        }, this._chunkLoaded = function() {
          os.readyState === 4 && (os.status < 200 || 400 <= os.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : os.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(Xs) {
            var gl = Xs.getResponseHeader("Content-Range");
            return gl === null ? -1 : parseInt(gl.substring(gl.lastIndexOf("/") + 1));
          }(os), this.parseChunk(os.responseText)));
        }, this._chunkError = function(Xs) {
          var gl = os.statusText || Xs;
          this._sendError(new Error(gl));
        };
      }
      function ro(so) {
        var os, Xs;
        (so = so || {}).chunkSize || (so.chunkSize = fa.LocalChunkSize), Va.call(this, so);
        var gl = typeof FileReader < "u";
        this.stream = function(Sl) {
          this._input = Sl, Xs = Sl.slice || Sl.webkitSlice || Sl.mozSlice, gl ? ((os = new FileReader()).onload = ys(this._chunkLoaded, this), os.onerror = ys(this._chunkError, this)) : os = new FileReaderSync(), this._nextChunk();
        }, this._nextChunk = function() {
          this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
          var Sl = this._input;
          if (this._config.chunkSize) {
            var El = Math.min(this._start + this._config.chunkSize, this._input.size);
            Sl = Xs.call(Sl, this._start, El);
          }
          var wl = os.readAsText(Sl, this._config.encoding);
          gl || this._chunkLoaded({ target: { result: wl } });
        }, this._chunkLoaded = function(Sl) {
          this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(Sl.target.result);
        }, this._chunkError = function() {
          this._sendError(os.error);
        };
      }
      function no(so) {
        var os;
        Va.call(this, so = so || {}), this.stream = function(Xs) {
          return os = Xs, this._nextChunk();
        }, this._nextChunk = function() {
          if (!this._finished) {
            var Xs, gl = this._config.chunkSize;
            return gl ? (Xs = os.substring(0, gl), os = os.substring(gl)) : (Xs = os, os = ""), this._finished = !os, this.parseChunk(Xs);
          }
        };
      }
      function eo(so) {
        Va.call(this, so = so || {});
        var os = [], Xs = !0, gl = !1;
        this.pause = function() {
          Va.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
          Va.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(Sl) {
          this._input = Sl, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
          gl && os.length === 1 && (this._finished = !0);
        }, this._nextChunk = function() {
          this._checkIsFinished(), os.length ? this.parseChunk(os.shift()) : Xs = !0;
        }, this._streamData = ys(function(Sl) {
          try {
            os.push(typeof Sl == "string" ? Sl : Sl.toString(this._config.encoding)), Xs && (Xs = !1, this._checkIsFinished(), this.parseChunk(os.shift()));
          } catch (El) {
            this._streamError(El);
          }
        }, this), this._streamError = ys(function(Sl) {
          this._streamCleanUp(), this._sendError(Sl);
        }, this), this._streamEnd = ys(function() {
          this._streamCleanUp(), gl = !0, this._streamData("");
        }, this), this._streamCleanUp = ys(function() {
          this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
      }
      function ao(so) {
        var os, Xs, gl, Sl = Math.pow(2, 53), El = -Sl, wl = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, jl = /^(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))$/, kl = this, Fl = 0, Ml = 0, ql = !1, Kl = !1, Zl = [], Il = { data: [], errors: [], meta: {} };
        if (Io(so.step)) {
          var xl = so.step;
          so.step = function(To) {
            if (Il = To, Nl()) Pl();
            else {
              if (Pl(), Il.data.length === 0) return;
              Fl += To.data.length, so.preview && Fl > so.preview ? Xs.abort() : (Il.data = Il.data[0], xl(Il, kl));
            }
          };
        }
        function bl(To) {
          return so.skipEmptyLines === "greedy" ? To.join("").trim() === "" : To.length === 1 && To[0].length === 0;
        }
        function Pl() {
          return Il && gl && (Ol("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + fa.DefaultDelimiter + "'"), gl = !1), so.skipEmptyLines && (Il.data = Il.data.filter(function(To) {
            return !bl(To);
          })), Nl() && function() {
            if (!Il) return;
            function To($l, _l) {
              Io(so.transformHeader) && ($l = so.transformHeader($l, _l)), Zl.push($l);
            }
            if (Array.isArray(Il.data[0])) {
              for (var Os = 0; Nl() && Os < Il.data.length; Os++) Il.data[Os].forEach(To);
              Il.data.splice(0, 1);
            } else Il.data.forEach(To);
          }(), function() {
            if (!Il || !so.header && !so.dynamicTyping && !so.transform) return Il;
            function To($l, _l) {
              var Al, Rl = so.header ? {} : [];
              for (Al = 0; Al < $l.length; Al++) {
                var Cl = Al, ml = $l[Al];
                so.header && (Cl = Al >= Zl.length ? "__parsed_extra" : Zl[Al]), so.transform && (ml = so.transform(ml, Cl)), ml = Bl(Cl, ml), Cl === "__parsed_extra" ? (Rl[Cl] = Rl[Cl] || [], Rl[Cl].push(ml)) : Rl[Cl] = ml;
              }
              return so.header && (Al > Zl.length ? Ol("FieldMismatch", "TooManyFields", "Too many fields: expected " + Zl.length + " fields but parsed " + Al, Ml + _l) : Al < Zl.length && Ol("FieldMismatch", "TooFewFields", "Too few fields: expected " + Zl.length + " fields but parsed " + Al, Ml + _l)), Rl;
            }
            var Os = 1;
            return !Il.data.length || Array.isArray(Il.data[0]) ? (Il.data = Il.data.map(To), Os = Il.data.length) : Il.data = To(Il.data, 0), so.header && Il.meta && (Il.meta.fields = Zl), Ml += Os, Il;
          }();
        }
        function Nl() {
          return so.header && Zl.length === 0;
        }
        function Bl(To, Os) {
          return $l = To, so.dynamicTypingFunction && so.dynamicTyping[$l] === void 0 && (so.dynamicTyping[$l] = so.dynamicTypingFunction($l)), (so.dynamicTyping[$l] || so.dynamicTyping) === !0 ? Os === "true" || Os === "TRUE" || Os !== "false" && Os !== "FALSE" && (function(_l) {
            if (wl.test(_l)) {
              var Al = parseFloat(_l);
              if (El < Al && Al < Sl) return !0;
            }
            return !1;
          }(Os) ? parseFloat(Os) : jl.test(Os) ? new Date(Os) : Os === "" ? null : Os) : Os;
          var $l;
        }
        function Ol(To, Os, $l, _l) {
          var Al = { type: To, code: Os, message: $l };
          _l !== void 0 && (Al.row = _l), Il.errors.push(Al);
        }
        this.parse = function(To, Os, $l) {
          var _l = so.quoteChar || '"';
          if (so.newline || (so.newline = function(Cl, ml) {
            Cl = Cl.substring(0, 1048576);
            var Tl = new RegExp(io(ml) + "([^]*?)" + io(ml), "gm"), Ll = (Cl = Cl.replace(Tl, "")).split("\r"), Vl = Cl.split(`
`), zl = 1 < Vl.length && Vl[0].length < Ll[0].length;
            if (Ll.length === 1 || zl) return `
`;
            for (var Ul = 0, Yl = 0; Yl < Ll.length; Yl++) Ll[Yl][0] === `
` && Ul++;
            return Ul >= Ll.length / 2 ? `\r
` : "\r";
          }(To, _l)), gl = !1, so.delimiter) Io(so.delimiter) && (so.delimiter = so.delimiter(To), Il.meta.delimiter = so.delimiter);
          else {
            var Al = function(Cl, ml, Tl, Ll, Vl) {
              var zl, Ul, Yl, Jl;
              Vl = Vl || [",", "	", "|", ";", fa.RECORD_SEP, fa.UNIT_SEP];
              for (var Wl = 0; Wl < Vl.length; Wl++) {
                var rc = Vl[Wl], uc = 0, ac = 0, zu = 0;
                Yl = void 0;
                for (var Xu = new xs({ comments: Ll, delimiter: rc, newline: ml, preview: 10 }).parse(Cl), ed = 0; ed < Xu.data.length; ed++) if (Tl && bl(Xu.data[ed])) zu++;
                else {
                  var td = Xu.data[ed].length;
                  ac += td, Yl !== void 0 ? 0 < td && (uc += Math.abs(td - Yl), Yl = td) : Yl = td;
                }
                0 < Xu.data.length && (ac /= Xu.data.length - zu), (Ul === void 0 || uc <= Ul) && (Jl === void 0 || Jl < ac) && 1.99 < ac && (Ul = uc, zl = rc, Jl = ac);
              }
              return { successful: !!(so.delimiter = zl), bestDelimiter: zl };
            }(To, so.newline, so.skipEmptyLines, so.comments, so.delimitersToGuess);
            Al.successful ? so.delimiter = Al.bestDelimiter : (gl = !0, so.delimiter = fa.DefaultDelimiter), Il.meta.delimiter = so.delimiter;
          }
          var Rl = Do(so);
          return so.preview && so.header && Rl.preview++, os = To, Xs = new xs(Rl), Il = Xs.parse(os, Os, $l), Pl(), ql ? { meta: { paused: !0 } } : Il || { meta: { paused: !1 } };
        }, this.paused = function() {
          return ql;
        }, this.pause = function() {
          ql = !0, Xs.abort(), os = Io(so.chunk) ? "" : os.substring(Xs.getCharIndex());
        }, this.resume = function() {
          kl.streamer._halted ? (ql = !1, kl.streamer.parseChunk(os, !0)) : setTimeout(kl.resume, 3);
        }, this.aborted = function() {
          return Kl;
        }, this.abort = function() {
          Kl = !0, Xs.abort(), Il.meta.aborted = !0, Io(so.complete) && so.complete(Il), os = "";
        };
      }
      function io(so) {
        return so.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function xs(so) {
        var os, Xs = (so = so || {}).delimiter, gl = so.newline, Sl = so.comments, El = so.step, wl = so.preview, jl = so.fastMode, kl = os = so.quoteChar === void 0 || so.quoteChar === null ? '"' : so.quoteChar;
        if (so.escapeChar !== void 0 && (kl = so.escapeChar), (typeof Xs != "string" || -1 < fa.BAD_DELIMITERS.indexOf(Xs)) && (Xs = ","), Sl === Xs) throw new Error("Comment character same as delimiter");
        Sl === !0 ? Sl = "#" : (typeof Sl != "string" || -1 < fa.BAD_DELIMITERS.indexOf(Sl)) && (Sl = !1), gl !== `
` && gl !== "\r" && gl !== `\r
` && (gl = `
`);
        var Fl = 0, Ml = !1;
        this.parse = function(ql, Kl, Zl) {
          if (typeof ql != "string") throw new Error("Input must be a string");
          var Il = ql.length, xl = Xs.length, bl = gl.length, Pl = Sl.length, Nl = Io(El), Bl = [], Ol = [], To = [], Os = Fl = 0;
          if (!ql) return Jl();
          if (jl || jl !== !1 && ql.indexOf(os) === -1) {
            for (var $l = ql.split(gl), _l = 0; _l < $l.length; _l++) {
              if (To = $l[_l], Fl += To.length, _l !== $l.length - 1) Fl += gl.length;
              else if (Zl) return Jl();
              if (!Sl || To.substring(0, Pl) !== Sl) {
                if (Nl) {
                  if (Bl = [], Vl(To.split(Xs)), Wl(), Ml) return Jl();
                } else Vl(To.split(Xs));
                if (wl && wl <= _l) return Bl = Bl.slice(0, wl), Jl(!0);
              }
            }
            return Jl();
          }
          for (var Al = ql.indexOf(Xs, Fl), Rl = ql.indexOf(gl, Fl), Cl = new RegExp(io(kl) + io(os), "g"), ml = ql.indexOf(os, Fl); ; ) if (ql[Fl] !== os) if (Sl && To.length === 0 && ql.substring(Fl, Fl + Pl) === Sl) {
            if (Rl === -1) return Jl();
            Fl = Rl + bl, Rl = ql.indexOf(gl, Fl), Al = ql.indexOf(Xs, Fl);
          } else if (Al !== -1 && (Al < Rl || Rl === -1)) To.push(ql.substring(Fl, Al)), Fl = Al + xl, Al = ql.indexOf(Xs, Fl);
          else {
            if (Rl === -1) break;
            if (To.push(ql.substring(Fl, Rl)), Yl(Rl + bl), Nl && (Wl(), Ml)) return Jl();
            if (wl && Bl.length >= wl) return Jl(!0);
          }
          else for (ml = Fl, Fl++; ; ) {
            if ((ml = ql.indexOf(os, ml + 1)) === -1) return Zl || Ol.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: Bl.length, index: Fl }), Ul();
            if (ml === Il - 1) return Ul(ql.substring(Fl, ml).replace(Cl, os));
            if (os !== kl || ql[ml + 1] !== kl) {
              if (os === kl || ml === 0 || ql[ml - 1] !== kl) {
                Al !== -1 && Al < ml + 1 && (Al = ql.indexOf(Xs, ml + 1)), Rl !== -1 && Rl < ml + 1 && (Rl = ql.indexOf(gl, ml + 1));
                var Tl = zl(Rl === -1 ? Al : Math.min(Al, Rl));
                if (ql.substr(ml + 1 + Tl, xl) === Xs) {
                  To.push(ql.substring(Fl, ml).replace(Cl, os)), ql[Fl = ml + 1 + Tl + xl] !== os && (ml = ql.indexOf(os, Fl)), Al = ql.indexOf(Xs, Fl), Rl = ql.indexOf(gl, Fl);
                  break;
                }
                var Ll = zl(Rl);
                if (ql.substring(ml + 1 + Ll, ml + 1 + Ll + bl) === gl) {
                  if (To.push(ql.substring(Fl, ml).replace(Cl, os)), Yl(ml + 1 + Ll + bl), Al = ql.indexOf(Xs, Fl), ml = ql.indexOf(os, Fl), Nl && (Wl(), Ml)) return Jl();
                  if (wl && Bl.length >= wl) return Jl(!0);
                  break;
                }
                Ol.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: Bl.length, index: Fl }), ml++;
              }
            } else ml++;
          }
          return Ul();
          function Vl(rc) {
            Bl.push(rc), Os = Fl;
          }
          function zl(rc) {
            var uc = 0;
            if (rc !== -1) {
              var ac = ql.substring(ml + 1, rc);
              ac && ac.trim() === "" && (uc = ac.length);
            }
            return uc;
          }
          function Ul(rc) {
            return Zl || (rc === void 0 && (rc = ql.substring(Fl)), To.push(rc), Fl = Il, Vl(To), Nl && Wl()), Jl();
          }
          function Yl(rc) {
            Fl = rc, Vl(To), To = [], Rl = ql.indexOf(gl, Fl);
          }
          function Jl(rc) {
            return { data: Bl, errors: Ol, meta: { delimiter: Xs, linebreak: gl, aborted: Ml, truncated: !!rc, cursor: Os + (Kl || 0) } };
          }
          function Wl() {
            El(Jl()), Bl = [], Ol = [];
          }
        }, this.abort = function() {
          Ml = !0;
        }, this.getCharIndex = function() {
          return Fl;
        };
      }
      function Ts(so) {
        var os = so.data, Xs = na[os.workerId], gl = !1;
        if (os.error) Xs.userError(os.error, os.file);
        else if (os.results && os.results.data) {
          var Sl = { abort: function() {
            gl = !0, qs(os.workerId, { data: [], errors: [], meta: { aborted: !0 } });
          }, pause: Fs, resume: Fs };
          if (Io(Xs.userStep)) {
            for (var El = 0; El < os.results.data.length && (Xs.userStep({ data: os.results.data[El], errors: os.results.errors, meta: os.results.meta }, Sl), !gl); El++) ;
            delete os.results;
          } else Io(Xs.userChunk) && (Xs.userChunk(os.results, Sl, os.file), delete os.results);
        }
        os.finished && !gl && qs(os.workerId, os.results);
      }
      function qs(so, os) {
        var Xs = na[so];
        Io(Xs.userComplete) && Xs.userComplete(os), Xs.terminate(), delete na[so];
      }
      function Fs() {
        throw new Error("Not implemented.");
      }
      function Do(so) {
        if (typeof so != "object" || so === null) return so;
        var os = Array.isArray(so) ? [] : {};
        for (var Xs in so) os[Xs] = Do(so[Xs]);
        return os;
      }
      function ys(so, os) {
        return function() {
          so.apply(os, arguments);
        };
      }
      function Io(so) {
        return typeof so == "function";
      }
      return ra && (Qi.onmessage = function(so) {
        var os = so.data;
        if (fa.WORKER_ID === void 0 && os && (fa.WORKER_ID = os.workerId), typeof os.input == "string") Qi.postMessage({ workerId: fa.WORKER_ID, results: fa.parse(os.input, os.config), finished: !0 });
        else if (Qi.File && os.input instanceof File || os.input instanceof Object) {
          var Xs = fa.parse(os.input, os.config);
          Xs && Qi.postMessage({ workerId: fa.WORKER_ID, results: Xs, finished: !0 });
        }
      }), (to.prototype = Object.create(Va.prototype)).constructor = to, (ro.prototype = Object.create(Va.prototype)).constructor = ro, (no.prototype = Object.create(no.prototype)).constructor = no, (eo.prototype = Object.create(Va.prototype)).constructor = eo, fa;
    });
  }(papaparse_min$1)), papaparse_min$1.exports;
}
var papaparse_minExports = requirePapaparse_min();
const Table$1 = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "table",
  {
    className: "bg-neutral-200 mb-4 border-collapse rounded border-none",
    ...Bi
  }
), TablePreview = ({ data: Bi }) => {
  const [e, Zi] = useState(null), Qi = async () => {
    const ea = await Bi.text();
    papaparse_minExports.parse(ea, {
      complete: (ra) => Zi(ra.data)
    });
  };
  return useEffect(() => {
    Qi();
  }, [Bi]), e ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "p-4 rounded-md bg-neutral-200", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: e.map((ea, ra) => /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: Object.keys(ea).map((na, ia) => /* @__PURE__ */ jsxRuntimeExports.jsx("td", { children: ea[na] }, `cell-${ra * ia}`)) }, `row-${ra}`)) }) }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." }) });
}, fileLimitBytes = 5e3, Preview = ({ bucket: Bi, fileKey: e }) => {
  if (!Bi || !e)
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Invalid URL" });
  const Zi = e, Qi = Zi.endsWith(".pdf"), ea = Zi.split(".").pop(), ra = usePresignedDownloadUrlQuery({
    variables: { bucket: Bi, key: Zi, limit: Qi ? void 0 : fileLimitBytes }
  }), [na] = usePresignedDownloadUrlLazyQuery(), [ia, fa] = useState(null), La = Zi.split("/").pop() || Zi, Va = useCallback(
    async (ro) => {
      const eo = await (await fetch(ro, {
        headers: { Range: `bytes=0-${fileLimitBytes}` }
      })).blob();
      fa(eo);
    },
    [fa]
  );
  if (useEffect(() => {
    ra.data?.presignedDownloadUrl && Va(ra.data.presignedDownloadUrl);
  }, [ra.data?.presignedDownloadUrl, Va]), !ia)
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, {}) });
  let to;
  switch (ea) {
    case "svg":
      to = /* @__PURE__ */ jsxRuntimeExports.jsx(SVGPreview, { data: ia });
      break;
    case "csv":
    case "bed":
    case "fastq":
    case "tsv":
      to = /* @__PURE__ */ jsxRuntimeExports.jsx(TablePreview, { data: ia });
      break;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
    case "webp":
    case "tiff":
    case "tif":
    case "ico":
    case "jfif":
      to = /* @__PURE__ */ jsxRuntimeExports.jsx(ImagePreview, { data: ia });
      break;
    case "pdf":
      to = /* @__PURE__ */ jsxRuntimeExports.jsx(PDFPreview, { url: ra.data?.presignedDownloadUrl || "" });
      break;
    default:
      to = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Preview not available for this file type" });
      break;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col w-full h-full overflow-scroll", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { title: La, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        onClick: async () => {
          const no = (await na({ variables: { bucket: Bi, key: Zi } })).data?.presignedDownloadUrl;
          no && window.open(no);
        },
        variant: "gray",
        children: "Download"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex justify-around w-full", children: to })
  ] });
}, Protected = ({
  validate: Bi,
  children: e,
  onFailure: Zi
}) => {
  const [Qi, ea] = useState(!0), ra = useCallback(async () => {
    await Bi() ? ea(!1) : Zi();
  }, []);
  return useEffect(() => {
    ra();
  }, []), Qi ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: e });
};
function hasRole(Bi, e) {
  return e.some(
    (Zi) => Bi.some((Qi) => Qi.role === Zi)
  );
}
const RequireRoles = ({
  roles: Bi,
  children: e,
  loginUrl: Zi
}) => {
  const [Qi] = useMeLazyQuery({ fetchPolicy: "cache-first" });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Protected,
    {
      onFailure: () => {
        window.location.href = `${Zi}?redirect=${encodeURIComponent(
          window.location.href
        )}`;
      },
      validate: async () => {
        const ea = await Qi();
        return !(!ea.data?.me || !hasRole(ea.data.me.roles || [], Bi));
      },
      children: e
    }
  );
}, S3DownloadLink = ({
  path: Bi,
  className: e,
  children: Zi,
  endpoint: Qi
}) => {
  const ea = `${Qi}/download?bucket=${Bi}&key=${Bi}&isFolder=${Bi.isFolder ? 1 : 0}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: e, href: ea, download: "asfdkl", children: Zi });
};
var object_hash = { exports: {} }, hasRequiredObject_hash;
function requireObject_hash() {
  return hasRequiredObject_hash || (hasRequiredObject_hash = 1, function(Bi, e) {
    (function(Zi) {
      Bi.exports = Zi();
    })(function() {
      return function Zi(Qi, ea, ra) {
        function na(La, Va) {
          if (!ea[La]) {
            if (!Qi[La]) {
              var to = typeof commonjsRequire == "function" && commonjsRequire;
              if (!Va && to) return to(La, !0);
              if (ia) return ia(La, !0);
              throw new Error("Cannot find module '" + La + "'");
            }
            Va = ea[La] = { exports: {} }, Qi[La][0].call(Va.exports, function(ro) {
              var no = Qi[La][1][ro];
              return na(no || ro);
            }, Va, Va.exports, Zi, Qi, ea, ra);
          }
          return ea[La].exports;
        }
        for (var ia = typeof commonjsRequire == "function" && commonjsRequire, fa = 0; fa < ra.length; fa++) na(ra[fa]);
        return na;
      }({ 1: [function(Zi, Qi, ea) {
        (function(ra, na, ia, fa, La, Va, to, ro, no) {
          var eo = Zi("crypto");
          function ao(ys, Io) {
            Io = Ts(ys, Io);
            var so;
            return (so = Io.algorithm !== "passthrough" ? eo.createHash(Io.algorithm) : new Do()).write === void 0 && (so.write = so.update, so.end = so.update), Fs(Io, so).dispatch(ys), so.update || so.end(""), so.digest ? so.digest(Io.encoding === "buffer" ? void 0 : Io.encoding) : (ys = so.read(), Io.encoding !== "buffer" ? ys.toString(Io.encoding) : ys);
          }
          (ea = Qi.exports = ao).sha1 = function(ys) {
            return ao(ys);
          }, ea.keys = function(ys) {
            return ao(ys, { excludeValues: !0, algorithm: "sha1", encoding: "hex" });
          }, ea.MD5 = function(ys) {
            return ao(ys, { algorithm: "md5", encoding: "hex" });
          }, ea.keysMD5 = function(ys) {
            return ao(ys, { algorithm: "md5", encoding: "hex", excludeValues: !0 });
          };
          var io = eo.getHashes ? eo.getHashes().slice() : ["sha1", "md5"], xs = (io.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
          function Ts(ys, Io) {
            var so = {};
            if (so.algorithm = (Io = Io || {}).algorithm || "sha1", so.encoding = Io.encoding || "hex", so.excludeValues = !!Io.excludeValues, so.algorithm = so.algorithm.toLowerCase(), so.encoding = so.encoding.toLowerCase(), so.ignoreUnknown = Io.ignoreUnknown === !0, so.respectType = Io.respectType !== !1, so.respectFunctionNames = Io.respectFunctionNames !== !1, so.respectFunctionProperties = Io.respectFunctionProperties !== !1, so.unorderedArrays = Io.unorderedArrays === !0, so.unorderedSets = Io.unorderedSets !== !1, so.unorderedObjects = Io.unorderedObjects !== !1, so.replacer = Io.replacer || void 0, so.excludeKeys = Io.excludeKeys || void 0, ys === void 0) throw new Error("Object argument required.");
            for (var os = 0; os < io.length; ++os) io[os].toLowerCase() === so.algorithm.toLowerCase() && (so.algorithm = io[os]);
            if (io.indexOf(so.algorithm) === -1) throw new Error('Algorithm "' + so.algorithm + '"  not supported. supported values: ' + io.join(", "));
            if (xs.indexOf(so.encoding) === -1 && so.algorithm !== "passthrough") throw new Error('Encoding "' + so.encoding + '"  not supported. supported values: ' + xs.join(", "));
            return so;
          }
          function qs(ys) {
            if (typeof ys == "function") return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(ys)) != null;
          }
          function Fs(ys, Io, so) {
            so = so || [];
            function os(Xs) {
              return Io.update ? Io.update(Xs, "utf8") : Io.write(Xs, "utf8");
            }
            return { dispatch: function(Xs) {
              return this["_" + ((Xs = ys.replacer ? ys.replacer(Xs) : Xs) === null ? "null" : typeof Xs)](Xs);
            }, _object: function(Xs) {
              var gl, Sl = Object.prototype.toString.call(Xs), El = /\[object (.*)\]/i.exec(Sl);
              if (El = (El = El ? El[1] : "unknown:[" + Sl + "]").toLowerCase(), 0 <= (Sl = so.indexOf(Xs))) return this.dispatch("[CIRCULAR:" + Sl + "]");
              if (so.push(Xs), ia !== void 0 && ia.isBuffer && ia.isBuffer(Xs)) return os("buffer:"), os(Xs);
              if (El === "object" || El === "function" || El === "asyncfunction") return Sl = Object.keys(Xs), ys.unorderedObjects && (Sl = Sl.sort()), ys.respectType === !1 || qs(Xs) || Sl.splice(0, 0, "prototype", "__proto__", "constructor"), ys.excludeKeys && (Sl = Sl.filter(function(wl) {
                return !ys.excludeKeys(wl);
              })), os("object:" + Sl.length + ":"), gl = this, Sl.forEach(function(wl) {
                gl.dispatch(wl), os(":"), ys.excludeValues || gl.dispatch(Xs[wl]), os(",");
              });
              if (!this["_" + El]) {
                if (ys.ignoreUnknown) return os("[" + El + "]");
                throw new Error('Unknown object type "' + El + '"');
              }
              this["_" + El](Xs);
            }, _array: function(Xs, wl) {
              wl = wl !== void 0 ? wl : ys.unorderedArrays !== !1;
              var Sl = this;
              if (os("array:" + Xs.length + ":"), !wl || Xs.length <= 1) return Xs.forEach(function(jl) {
                return Sl.dispatch(jl);
              });
              var El = [], wl = Xs.map(function(jl) {
                var kl = new Do(), Fl = so.slice();
                return Fs(ys, kl, Fl).dispatch(jl), El = El.concat(Fl.slice(so.length)), kl.read().toString();
              });
              return so = so.concat(El), wl.sort(), this._array(wl, !1);
            }, _date: function(Xs) {
              return os("date:" + Xs.toJSON());
            }, _symbol: function(Xs) {
              return os("symbol:" + Xs.toString());
            }, _error: function(Xs) {
              return os("error:" + Xs.toString());
            }, _boolean: function(Xs) {
              return os("bool:" + Xs.toString());
            }, _string: function(Xs) {
              os("string:" + Xs.length + ":"), os(Xs.toString());
            }, _function: function(Xs) {
              os("fn:"), qs(Xs) ? this.dispatch("[native]") : this.dispatch(Xs.toString()), ys.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(Xs.name)), ys.respectFunctionProperties && this._object(Xs);
            }, _number: function(Xs) {
              return os("number:" + Xs.toString());
            }, _xml: function(Xs) {
              return os("xml:" + Xs.toString());
            }, _null: function() {
              return os("Null");
            }, _undefined: function() {
              return os("Undefined");
            }, _regexp: function(Xs) {
              return os("regex:" + Xs.toString());
            }, _uint8array: function(Xs) {
              return os("uint8array:"), this.dispatch(Array.prototype.slice.call(Xs));
            }, _uint8clampedarray: function(Xs) {
              return os("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(Xs));
            }, _int8array: function(Xs) {
              return os("int8array:"), this.dispatch(Array.prototype.slice.call(Xs));
            }, _uint16array: function(Xs) {
              return os("uint16array:"), this.dispatch(Array.prototype.slice.call(Xs));
            }, _int16array: function(Xs) {
              return os("int16array:"), this.dispatch(Array.prototype.slice.call(Xs));
            }, _uint32array: function(Xs) {
              return os("uint32array:"), this.dispatch(Array.prototype.slice.call(Xs));
            }, _int32array: function(Xs) {
              return os("int32array:"), this.dispatch(Array.prototype.slice.call(Xs));
            }, _float32array: function(Xs) {
              return os("float32array:"), this.dispatch(Array.prototype.slice.call(Xs));
            }, _float64array: function(Xs) {
              return os("float64array:"), this.dispatch(Array.prototype.slice.call(Xs));
            }, _arraybuffer: function(Xs) {
              return os("arraybuffer:"), this.dispatch(new Uint8Array(Xs));
            }, _url: function(Xs) {
              return os("url:" + Xs.toString());
            }, _map: function(Xs) {
              return os("map:"), Xs = Array.from(Xs), this._array(Xs, ys.unorderedSets !== !1);
            }, _set: function(Xs) {
              return os("set:"), Xs = Array.from(Xs), this._array(Xs, ys.unorderedSets !== !1);
            }, _file: function(Xs) {
              return os("file:"), this.dispatch([Xs.name, Xs.size, Xs.type, Xs.lastModfied]);
            }, _blob: function() {
              if (ys.ignoreUnknown) return os("[blob]");
              throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
            }, _domwindow: function() {
              return os("domwindow");
            }, _bigint: function(Xs) {
              return os("bigint:" + Xs.toString());
            }, _process: function() {
              return os("process");
            }, _timer: function() {
              return os("timer");
            }, _pipe: function() {
              return os("pipe");
            }, _tcp: function() {
              return os("tcp");
            }, _udp: function() {
              return os("udp");
            }, _tty: function() {
              return os("tty");
            }, _statwatcher: function() {
              return os("statwatcher");
            }, _securecontext: function() {
              return os("securecontext");
            }, _connection: function() {
              return os("connection");
            }, _zlib: function() {
              return os("zlib");
            }, _context: function() {
              return os("context");
            }, _nodescript: function() {
              return os("nodescript");
            }, _httpparser: function() {
              return os("httpparser");
            }, _dataview: function() {
              return os("dataview");
            }, _signal: function() {
              return os("signal");
            }, _fsevent: function() {
              return os("fsevent");
            }, _tlswrap: function() {
              return os("tlswrap");
            } };
          }
          function Do() {
            return { buf: "", write: function(ys) {
              this.buf += ys;
            }, end: function(ys) {
              this.buf += ys;
            }, read: function() {
              return this.buf;
            } };
          }
          ea.writeToStream = function(ys, Io, so) {
            return so === void 0 && (so = Io, Io = {}), Fs(Io = Ts(ys, Io), so).dispatch(ys);
          };
        }).call(this, Zi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Zi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
      }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(Zi, Qi, ea) {
        (function(ra, na, ia, fa, La, Va, to, ro, no) {
          (function(eo) {
            var ao = typeof Uint8Array < "u" ? Uint8Array : Array, io = 43, xs = 47, Ts = 48, qs = 97, Fs = 65, Do = 45, ys = 95;
            function Io(so) {
              return so = so.charCodeAt(0), so === io || so === Do ? 62 : so === xs || so === ys ? 63 : so < Ts ? -1 : so < Ts + 10 ? so - Ts + 26 + 26 : so < Fs + 26 ? so - Fs : so < qs + 26 ? so - qs + 26 : void 0;
            }
            eo.toByteArray = function(so) {
              var os, Xs;
              if (0 < so.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
              var gl = so.length, gl = so.charAt(gl - 2) === "=" ? 2 : so.charAt(gl - 1) === "=" ? 1 : 0, Sl = new ao(3 * so.length / 4 - gl), El = 0 < gl ? so.length - 4 : so.length, wl = 0;
              function jl(kl) {
                Sl[wl++] = kl;
              }
              for (os = 0; os < El; os += 4, 0) jl((16711680 & (Xs = Io(so.charAt(os)) << 18 | Io(so.charAt(os + 1)) << 12 | Io(so.charAt(os + 2)) << 6 | Io(so.charAt(os + 3)))) >> 16), jl((65280 & Xs) >> 8), jl(255 & Xs);
              return gl == 2 ? jl(255 & (Xs = Io(so.charAt(os)) << 2 | Io(so.charAt(os + 1)) >> 4)) : gl == 1 && (jl((Xs = Io(so.charAt(os)) << 10 | Io(so.charAt(os + 1)) << 4 | Io(so.charAt(os + 2)) >> 2) >> 8 & 255), jl(255 & Xs)), Sl;
            }, eo.fromByteArray = function(so) {
              var os, Xs, gl, Sl, El = so.length % 3, wl = "";
              function jl(kl) {
                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(kl);
              }
              for (os = 0, gl = so.length - El; os < gl; os += 3) Xs = (so[os] << 16) + (so[os + 1] << 8) + so[os + 2], wl += jl((Sl = Xs) >> 18 & 63) + jl(Sl >> 12 & 63) + jl(Sl >> 6 & 63) + jl(63 & Sl);
              switch (El) {
                case 1:
                  wl = (wl += jl((Xs = so[so.length - 1]) >> 2)) + jl(Xs << 4 & 63) + "==";
                  break;
                case 2:
                  wl = (wl = (wl += jl((Xs = (so[so.length - 2] << 8) + so[so.length - 1]) >> 10)) + jl(Xs >> 4 & 63)) + jl(Xs << 2 & 63) + "=";
              }
              return wl;
            };
          })(ea === void 0 ? this.base64js = {} : ea);
        }).call(this, Zi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Zi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
      }, { buffer: 3, lYpoI2: 11 }], 3: [function(Zi, Qi, ea) {
        (function(ra, na, io, fa, La, Va, to, ro, no) {
          var eo = Zi("base64-js"), ao = Zi("ieee754");
          function io(To, Os, $l) {
            if (!(this instanceof io)) return new io(To, Os, $l);
            var _l, Al, Rl, Cl, ml = typeof To;
            if (Os === "base64" && ml == "string") for (To = (Cl = To).trim ? Cl.trim() : Cl.replace(/^\s+|\s+$/g, ""); To.length % 4 != 0; ) To += "=";
            if (ml == "number") _l = Ml(To);
            else if (ml == "string") _l = io.byteLength(To, Os);
            else {
              if (ml != "object") throw new Error("First argument needs to be a number, array or string.");
              _l = Ml(To.length);
            }
            if (io._useTypedArrays ? Al = io._augment(new Uint8Array(_l)) : ((Al = this).length = _l, Al._isBuffer = !0), io._useTypedArrays && typeof To.byteLength == "number") Al._set(To);
            else if (ql(Cl = To) || io.isBuffer(Cl) || Cl && typeof Cl == "object" && typeof Cl.length == "number") for (Rl = 0; Rl < _l; Rl++) io.isBuffer(To) ? Al[Rl] = To.readUInt8(Rl) : Al[Rl] = To[Rl];
            else if (ml == "string") Al.write(To, 0, Os);
            else if (ml == "number" && !io._useTypedArrays && !$l) for (Rl = 0; Rl < _l; Rl++) Al[Rl] = 0;
            return Al;
          }
          function xs(To, Os, $l, _l) {
            return io._charsWritten = xl(function(Al) {
              for (var Rl = [], Cl = 0; Cl < Al.length; Cl++) Rl.push(255 & Al.charCodeAt(Cl));
              return Rl;
            }(Os), To, $l, _l);
          }
          function Ts(To, Os, $l, _l) {
            return io._charsWritten = xl(function(Al) {
              for (var Rl, Cl, ml = [], Tl = 0; Tl < Al.length; Tl++) Cl = Al.charCodeAt(Tl), Rl = Cl >> 8, Cl = Cl % 256, ml.push(Cl), ml.push(Rl);
              return ml;
            }(Os), To, $l, _l);
          }
          function qs(To, Os, $l) {
            var _l = "";
            $l = Math.min(To.length, $l);
            for (var Al = Os; Al < $l; Al++) _l += String.fromCharCode(To[Al]);
            return _l;
          }
          function Fs(To, Os, $l, Rl) {
            Rl || (Ol(typeof $l == "boolean", "missing or invalid endian"), Ol(Os != null, "missing offset"), Ol(Os + 1 < To.length, "Trying to read beyond buffer length"));
            var Al, Rl = To.length;
            if (!(Rl <= Os)) return $l ? (Al = To[Os], Os + 1 < Rl && (Al |= To[Os + 1] << 8)) : (Al = To[Os] << 8, Os + 1 < Rl && (Al |= To[Os + 1])), Al;
          }
          function Do(To, Os, $l, Rl) {
            Rl || (Ol(typeof $l == "boolean", "missing or invalid endian"), Ol(Os != null, "missing offset"), Ol(Os + 3 < To.length, "Trying to read beyond buffer length"));
            var Al, Rl = To.length;
            if (!(Rl <= Os)) return $l ? (Os + 2 < Rl && (Al = To[Os + 2] << 16), Os + 1 < Rl && (Al |= To[Os + 1] << 8), Al |= To[Os], Os + 3 < Rl && (Al += To[Os + 3] << 24 >>> 0)) : (Os + 1 < Rl && (Al = To[Os + 1] << 16), Os + 2 < Rl && (Al |= To[Os + 2] << 8), Os + 3 < Rl && (Al |= To[Os + 3]), Al += To[Os] << 24 >>> 0), Al;
          }
          function ys(To, Os, $l, _l) {
            if (_l || (Ol(typeof $l == "boolean", "missing or invalid endian"), Ol(Os != null, "missing offset"), Ol(Os + 1 < To.length, "Trying to read beyond buffer length")), !(To.length <= Os)) return _l = Fs(To, Os, $l, !0), 32768 & _l ? -1 * (65535 - _l + 1) : _l;
          }
          function Io(To, Os, $l, _l) {
            if (_l || (Ol(typeof $l == "boolean", "missing or invalid endian"), Ol(Os != null, "missing offset"), Ol(Os + 3 < To.length, "Trying to read beyond buffer length")), !(To.length <= Os)) return _l = Do(To, Os, $l, !0), 2147483648 & _l ? -1 * (4294967295 - _l + 1) : _l;
          }
          function so(To, Os, $l, _l) {
            return _l || (Ol(typeof $l == "boolean", "missing or invalid endian"), Ol(Os + 3 < To.length, "Trying to read beyond buffer length")), ao.read(To, Os, $l, 23, 4);
          }
          function os(To, Os, $l, _l) {
            return _l || (Ol(typeof $l == "boolean", "missing or invalid endian"), Ol(Os + 7 < To.length, "Trying to read beyond buffer length")), ao.read(To, Os, $l, 52, 8);
          }
          function Xs(To, Os, $l, _l, Al) {
            if (Al || (Ol(Os != null, "missing value"), Ol(typeof _l == "boolean", "missing or invalid endian"), Ol($l != null, "missing offset"), Ol($l + 1 < To.length, "trying to write beyond buffer length"), Pl(Os, 65535)), Al = To.length, !(Al <= $l)) for (var Rl = 0, Cl = Math.min(Al - $l, 2); Rl < Cl; Rl++) To[$l + Rl] = (Os & 255 << 8 * (_l ? Rl : 1 - Rl)) >>> 8 * (_l ? Rl : 1 - Rl);
          }
          function gl(To, Os, $l, _l, Al) {
            if (Al || (Ol(Os != null, "missing value"), Ol(typeof _l == "boolean", "missing or invalid endian"), Ol($l != null, "missing offset"), Ol($l + 3 < To.length, "trying to write beyond buffer length"), Pl(Os, 4294967295)), Al = To.length, !(Al <= $l)) for (var Rl = 0, Cl = Math.min(Al - $l, 4); Rl < Cl; Rl++) To[$l + Rl] = Os >>> 8 * (_l ? Rl : 3 - Rl) & 255;
          }
          function Sl(To, Os, $l, _l, Al) {
            Al || (Ol(Os != null, "missing value"), Ol(typeof _l == "boolean", "missing or invalid endian"), Ol($l != null, "missing offset"), Ol($l + 1 < To.length, "Trying to write beyond buffer length"), Nl(Os, 32767, -32768)), To.length <= $l || Xs(To, 0 <= Os ? Os : 65535 + Os + 1, $l, _l, Al);
          }
          function El(To, Os, $l, _l, Al) {
            Al || (Ol(Os != null, "missing value"), Ol(typeof _l == "boolean", "missing or invalid endian"), Ol($l != null, "missing offset"), Ol($l + 3 < To.length, "Trying to write beyond buffer length"), Nl(Os, 2147483647, -2147483648)), To.length <= $l || gl(To, 0 <= Os ? Os : 4294967295 + Os + 1, $l, _l, Al);
          }
          function wl(To, Os, $l, _l, Al) {
            Al || (Ol(Os != null, "missing value"), Ol(typeof _l == "boolean", "missing or invalid endian"), Ol($l != null, "missing offset"), Ol($l + 3 < To.length, "Trying to write beyond buffer length"), Bl(Os, 34028234663852886e22, -34028234663852886e22)), To.length <= $l || ao.write(To, Os, $l, _l, 23, 4);
          }
          function jl(To, Os, $l, _l, Al) {
            Al || (Ol(Os != null, "missing value"), Ol(typeof _l == "boolean", "missing or invalid endian"), Ol($l != null, "missing offset"), Ol($l + 7 < To.length, "Trying to write beyond buffer length"), Bl(Os, 17976931348623157e292, -17976931348623157e292)), To.length <= $l || ao.write(To, Os, $l, _l, 52, 8);
          }
          ea.Buffer = io, ea.SlowBuffer = io, ea.INSPECT_MAX_BYTES = 50, io.poolSize = 8192, io._useTypedArrays = function() {
            try {
              var To = new ArrayBuffer(0), Os = new Uint8Array(To);
              return Os.foo = function() {
                return 42;
              }, Os.foo() === 42 && typeof Os.subarray == "function";
            } catch {
              return !1;
            }
          }(), io.isEncoding = function(To) {
            switch (String(To).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "raw":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, io.isBuffer = function(To) {
            return !(To == null || !To._isBuffer);
          }, io.byteLength = function(To, Os) {
            var $l;
            switch (To += "", Os || "utf8") {
              case "hex":
                $l = To.length / 2;
                break;
              case "utf8":
              case "utf-8":
                $l = Zl(To).length;
                break;
              case "ascii":
              case "binary":
              case "raw":
                $l = To.length;
                break;
              case "base64":
                $l = Il(To).length;
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                $l = 2 * To.length;
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return $l;
          }, io.concat = function(To, Os) {
            if (Ol(ql(To), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), To.length === 0) return new io(0);
            if (To.length === 1) return To[0];
            if (typeof Os != "number") for (Al = Os = 0; Al < To.length; Al++) Os += To[Al].length;
            for (var $l = new io(Os), _l = 0, Al = 0; Al < To.length; Al++) {
              var Rl = To[Al];
              Rl.copy($l, _l), _l += Rl.length;
            }
            return $l;
          }, io.prototype.write = function(To, Os, $l, _l) {
            isFinite(Os) ? isFinite($l) || (_l = $l, $l = void 0) : (Tl = _l, _l = Os, Os = $l, $l = Tl), Os = Number(Os) || 0;
            var Al, Rl, Cl, ml, Tl = this.length - Os;
            switch ((!$l || Tl < ($l = Number($l))) && ($l = Tl), _l = String(_l || "utf8").toLowerCase()) {
              case "hex":
                Al = function(Ll, Vl, zl, Ul) {
                  zl = Number(zl) || 0;
                  var Yl = Ll.length - zl;
                  (!Ul || Yl < (Ul = Number(Ul))) && (Ul = Yl), Ol((Yl = Vl.length) % 2 == 0, "Invalid hex string"), Yl / 2 < Ul && (Ul = Yl / 2);
                  for (var Jl = 0; Jl < Ul; Jl++) {
                    var Wl = parseInt(Vl.substr(2 * Jl, 2), 16);
                    Ol(!isNaN(Wl), "Invalid hex string"), Ll[zl + Jl] = Wl;
                  }
                  return io._charsWritten = 2 * Jl, Jl;
                }(this, To, Os, $l);
                break;
              case "utf8":
              case "utf-8":
                Rl = this, Cl = Os, ml = $l, Al = io._charsWritten = xl(Zl(To), Rl, Cl, ml);
                break;
              case "ascii":
              case "binary":
                Al = xs(this, To, Os, $l);
                break;
              case "base64":
                Rl = this, Cl = Os, ml = $l, Al = io._charsWritten = xl(Il(To), Rl, Cl, ml);
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                Al = Ts(this, To, Os, $l);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return Al;
          }, io.prototype.toString = function(To, Os, $l) {
            var _l, Al, Rl, Cl, ml = this;
            if (To = String(To || "utf8").toLowerCase(), Os = Number(Os) || 0, ($l = $l !== void 0 ? Number($l) : ml.length) === Os) return "";
            switch (To) {
              case "hex":
                _l = function(Tl, Ll, Vl) {
                  var zl = Tl.length;
                  (!Ll || Ll < 0) && (Ll = 0), (!Vl || Vl < 0 || zl < Vl) && (Vl = zl);
                  for (var Ul = "", Yl = Ll; Yl < Vl; Yl++) Ul += Kl(Tl[Yl]);
                  return Ul;
                }(ml, Os, $l);
                break;
              case "utf8":
              case "utf-8":
                _l = function(Tl, Ll, Vl) {
                  var zl = "", Ul = "";
                  Vl = Math.min(Tl.length, Vl);
                  for (var Yl = Ll; Yl < Vl; Yl++) Tl[Yl] <= 127 ? (zl += bl(Ul) + String.fromCharCode(Tl[Yl]), Ul = "") : Ul += "%" + Tl[Yl].toString(16);
                  return zl + bl(Ul);
                }(ml, Os, $l);
                break;
              case "ascii":
              case "binary":
                _l = qs(ml, Os, $l);
                break;
              case "base64":
                Al = ml, Cl = $l, _l = (Rl = Os) === 0 && Cl === Al.length ? eo.fromByteArray(Al) : eo.fromByteArray(Al.slice(Rl, Cl));
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                _l = function(Tl, Ll, Vl) {
                  for (var zl = Tl.slice(Ll, Vl), Ul = "", Yl = 0; Yl < zl.length; Yl += 2) Ul += String.fromCharCode(zl[Yl] + 256 * zl[Yl + 1]);
                  return Ul;
                }(ml, Os, $l);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return _l;
          }, io.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          }, io.prototype.copy = function(To, Os, $l, _l) {
            if (Os = Os || 0, (_l = _l || _l === 0 ? _l : this.length) !== ($l = $l || 0) && To.length !== 0 && this.length !== 0) {
              Ol($l <= _l, "sourceEnd < sourceStart"), Ol(0 <= Os && Os < To.length, "targetStart out of bounds"), Ol(0 <= $l && $l < this.length, "sourceStart out of bounds"), Ol(0 <= _l && _l <= this.length, "sourceEnd out of bounds"), _l > this.length && (_l = this.length);
              var Al = (_l = To.length - Os < _l - $l ? To.length - Os + $l : _l) - $l;
              if (Al < 100 || !io._useTypedArrays) for (var Rl = 0; Rl < Al; Rl++) To[Rl + Os] = this[Rl + $l];
              else To._set(this.subarray($l, $l + Al), Os);
            }
          }, io.prototype.slice = function(To, Os) {
            var $l = this.length;
            if (To = Fl(To, $l, 0), Os = Fl(Os, $l, $l), io._useTypedArrays) return io._augment(this.subarray(To, Os));
            for (var _l = Os - To, Al = new io(_l, void 0, !0), Rl = 0; Rl < _l; Rl++) Al[Rl] = this[Rl + To];
            return Al;
          }, io.prototype.get = function(To) {
            return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(To);
          }, io.prototype.set = function(To, Os) {
            return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(To, Os);
          }, io.prototype.readUInt8 = function(To, Os) {
            if (Os || (Ol(To != null, "missing offset"), Ol(To < this.length, "Trying to read beyond buffer length")), !(To >= this.length)) return this[To];
          }, io.prototype.readUInt16LE = function(To, Os) {
            return Fs(this, To, !0, Os);
          }, io.prototype.readUInt16BE = function(To, Os) {
            return Fs(this, To, !1, Os);
          }, io.prototype.readUInt32LE = function(To, Os) {
            return Do(this, To, !0, Os);
          }, io.prototype.readUInt32BE = function(To, Os) {
            return Do(this, To, !1, Os);
          }, io.prototype.readInt8 = function(To, Os) {
            if (Os || (Ol(To != null, "missing offset"), Ol(To < this.length, "Trying to read beyond buffer length")), !(To >= this.length)) return 128 & this[To] ? -1 * (255 - this[To] + 1) : this[To];
          }, io.prototype.readInt16LE = function(To, Os) {
            return ys(this, To, !0, Os);
          }, io.prototype.readInt16BE = function(To, Os) {
            return ys(this, To, !1, Os);
          }, io.prototype.readInt32LE = function(To, Os) {
            return Io(this, To, !0, Os);
          }, io.prototype.readInt32BE = function(To, Os) {
            return Io(this, To, !1, Os);
          }, io.prototype.readFloatLE = function(To, Os) {
            return so(this, To, !0, Os);
          }, io.prototype.readFloatBE = function(To, Os) {
            return so(this, To, !1, Os);
          }, io.prototype.readDoubleLE = function(To, Os) {
            return os(this, To, !0, Os);
          }, io.prototype.readDoubleBE = function(To, Os) {
            return os(this, To, !1, Os);
          }, io.prototype.writeUInt8 = function(To, Os, $l) {
            $l || (Ol(To != null, "missing value"), Ol(Os != null, "missing offset"), Ol(Os < this.length, "trying to write beyond buffer length"), Pl(To, 255)), Os >= this.length || (this[Os] = To);
          }, io.prototype.writeUInt16LE = function(To, Os, $l) {
            Xs(this, To, Os, !0, $l);
          }, io.prototype.writeUInt16BE = function(To, Os, $l) {
            Xs(this, To, Os, !1, $l);
          }, io.prototype.writeUInt32LE = function(To, Os, $l) {
            gl(this, To, Os, !0, $l);
          }, io.prototype.writeUInt32BE = function(To, Os, $l) {
            gl(this, To, Os, !1, $l);
          }, io.prototype.writeInt8 = function(To, Os, $l) {
            $l || (Ol(To != null, "missing value"), Ol(Os != null, "missing offset"), Ol(Os < this.length, "Trying to write beyond buffer length"), Nl(To, 127, -128)), Os >= this.length || (0 <= To ? this.writeUInt8(To, Os, $l) : this.writeUInt8(255 + To + 1, Os, $l));
          }, io.prototype.writeInt16LE = function(To, Os, $l) {
            Sl(this, To, Os, !0, $l);
          }, io.prototype.writeInt16BE = function(To, Os, $l) {
            Sl(this, To, Os, !1, $l);
          }, io.prototype.writeInt32LE = function(To, Os, $l) {
            El(this, To, Os, !0, $l);
          }, io.prototype.writeInt32BE = function(To, Os, $l) {
            El(this, To, Os, !1, $l);
          }, io.prototype.writeFloatLE = function(To, Os, $l) {
            wl(this, To, Os, !0, $l);
          }, io.prototype.writeFloatBE = function(To, Os, $l) {
            wl(this, To, Os, !1, $l);
          }, io.prototype.writeDoubleLE = function(To, Os, $l) {
            jl(this, To, Os, !0, $l);
          }, io.prototype.writeDoubleBE = function(To, Os, $l) {
            jl(this, To, Os, !1, $l);
          }, io.prototype.fill = function(To, Os, $l) {
            if (Os = Os || 0, $l = $l || this.length, Ol(typeof (To = typeof (To = To || 0) == "string" ? To.charCodeAt(0) : To) == "number" && !isNaN(To), "value is not a number"), Ol(Os <= $l, "end < start"), $l !== Os && this.length !== 0) {
              Ol(0 <= Os && Os < this.length, "start out of bounds"), Ol(0 <= $l && $l <= this.length, "end out of bounds");
              for (var _l = Os; _l < $l; _l++) this[_l] = To;
            }
          }, io.prototype.inspect = function() {
            for (var To = [], Os = this.length, $l = 0; $l < Os; $l++) if (To[$l] = Kl(this[$l]), $l === ea.INSPECT_MAX_BYTES) {
              To[$l + 1] = "...";
              break;
            }
            return "<Buffer " + To.join(" ") + ">";
          }, io.prototype.toArrayBuffer = function() {
            if (typeof Uint8Array > "u") throw new Error("Buffer.toArrayBuffer not supported in this browser");
            if (io._useTypedArrays) return new io(this).buffer;
            for (var To = new Uint8Array(this.length), Os = 0, $l = To.length; Os < $l; Os += 1) To[Os] = this[Os];
            return To.buffer;
          };
          var kl = io.prototype;
          function Fl(To, Os, $l) {
            return typeof To != "number" ? $l : Os <= (To = ~~To) ? Os : 0 <= To || 0 <= (To += Os) ? To : 0;
          }
          function Ml(To) {
            return (To = ~~Math.ceil(+To)) < 0 ? 0 : To;
          }
          function ql(To) {
            return (Array.isArray || function(Os) {
              return Object.prototype.toString.call(Os) === "[object Array]";
            })(To);
          }
          function Kl(To) {
            return To < 16 ? "0" + To.toString(16) : To.toString(16);
          }
          function Zl(To) {
            for (var Os = [], $l = 0; $l < To.length; $l++) {
              var _l = To.charCodeAt($l);
              if (_l <= 127) Os.push(To.charCodeAt($l));
              else for (var Al = $l, Rl = (55296 <= _l && _l <= 57343 && $l++, encodeURIComponent(To.slice(Al, $l + 1)).substr(1).split("%")), Cl = 0; Cl < Rl.length; Cl++) Os.push(parseInt(Rl[Cl], 16));
            }
            return Os;
          }
          function Il(To) {
            return eo.toByteArray(To);
          }
          function xl(To, Os, $l, _l) {
            for (var Al = 0; Al < _l && !(Al + $l >= Os.length || Al >= To.length); Al++) Os[Al + $l] = To[Al];
            return Al;
          }
          function bl(To) {
            try {
              return decodeURIComponent(To);
            } catch {
              return "�";
            }
          }
          function Pl(To, Os) {
            Ol(typeof To == "number", "cannot write a non-number as a number"), Ol(0 <= To, "specified a negative value for writing an unsigned value"), Ol(To <= Os, "value is larger than maximum value for type"), Ol(Math.floor(To) === To, "value has a fractional component");
          }
          function Nl(To, Os, $l) {
            Ol(typeof To == "number", "cannot write a non-number as a number"), Ol(To <= Os, "value larger than maximum allowed value"), Ol($l <= To, "value smaller than minimum allowed value"), Ol(Math.floor(To) === To, "value has a fractional component");
          }
          function Bl(To, Os, $l) {
            Ol(typeof To == "number", "cannot write a non-number as a number"), Ol(To <= Os, "value larger than maximum allowed value"), Ol($l <= To, "value smaller than minimum allowed value");
          }
          function Ol(To, Os) {
            if (!To) throw new Error(Os || "Failed assertion");
          }
          io._augment = function(To) {
            return To._isBuffer = !0, To._get = To.get, To._set = To.set, To.get = kl.get, To.set = kl.set, To.write = kl.write, To.toString = kl.toString, To.toLocaleString = kl.toString, To.toJSON = kl.toJSON, To.copy = kl.copy, To.slice = kl.slice, To.readUInt8 = kl.readUInt8, To.readUInt16LE = kl.readUInt16LE, To.readUInt16BE = kl.readUInt16BE, To.readUInt32LE = kl.readUInt32LE, To.readUInt32BE = kl.readUInt32BE, To.readInt8 = kl.readInt8, To.readInt16LE = kl.readInt16LE, To.readInt16BE = kl.readInt16BE, To.readInt32LE = kl.readInt32LE, To.readInt32BE = kl.readInt32BE, To.readFloatLE = kl.readFloatLE, To.readFloatBE = kl.readFloatBE, To.readDoubleLE = kl.readDoubleLE, To.readDoubleBE = kl.readDoubleBE, To.writeUInt8 = kl.writeUInt8, To.writeUInt16LE = kl.writeUInt16LE, To.writeUInt16BE = kl.writeUInt16BE, To.writeUInt32LE = kl.writeUInt32LE, To.writeUInt32BE = kl.writeUInt32BE, To.writeInt8 = kl.writeInt8, To.writeInt16LE = kl.writeInt16LE, To.writeInt16BE = kl.writeInt16BE, To.writeInt32LE = kl.writeInt32LE, To.writeInt32BE = kl.writeInt32BE, To.writeFloatLE = kl.writeFloatLE, To.writeFloatBE = kl.writeFloatBE, To.writeDoubleLE = kl.writeDoubleLE, To.writeDoubleBE = kl.writeDoubleBE, To.fill = kl.fill, To.inspect = kl.inspect, To.toArrayBuffer = kl.toArrayBuffer, To;
          };
        }).call(this, Zi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Zi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
      }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(Zi, Qi, ea) {
        (function(ra, na, eo, fa, La, Va, to, ro, no) {
          var eo = Zi("buffer").Buffer, ao = 4, io = new eo(ao);
          io.fill(0), Qi.exports = { hash: function(xs, Ts, qs, Fs) {
            for (var Do = Ts(function(Xs, gl) {
              Xs.length % ao != 0 && (Sl = Xs.length + (ao - Xs.length % ao), Xs = eo.concat([Xs, io], Sl));
              for (var Sl, El = [], wl = gl ? Xs.readInt32BE : Xs.readInt32LE, jl = 0; jl < Xs.length; jl += ao) El.push(wl.call(Xs, jl));
              return El;
            }(xs = eo.isBuffer(xs) ? xs : new eo(xs), Fs), 8 * xs.length), Ts = Fs, ys = new eo(qs), Io = Ts ? ys.writeInt32BE : ys.writeInt32LE, so = 0; so < Do.length; so++) Io.call(ys, Do[so], 4 * so, !0);
            return ys;
          } };
        }).call(this, Zi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Zi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 5: [function(Zi, Qi, ea) {
        (function(ra, na, eo, fa, La, Va, to, ro, no) {
          var eo = Zi("buffer").Buffer, ao = Zi("./sha"), io = Zi("./sha256"), xs = Zi("./rng"), Ts = { sha1: ao, sha256: io, md5: Zi("./md5") }, qs = 64, Fs = new eo(qs);
          function Do(Xs, gl) {
            var Sl = Ts[Xs = Xs || "sha1"], El = [];
            return Sl || ys("algorithm:", Xs, "is not yet supported"), { update: function(wl) {
              return eo.isBuffer(wl) || (wl = new eo(wl)), El.push(wl), wl.length, this;
            }, digest: function(wl) {
              var jl = eo.concat(El), jl = gl ? function(kl, Fl, Ml) {
                eo.isBuffer(Fl) || (Fl = new eo(Fl)), eo.isBuffer(Ml) || (Ml = new eo(Ml)), Fl.length > qs ? Fl = kl(Fl) : Fl.length < qs && (Fl = eo.concat([Fl, Fs], qs));
                for (var ql = new eo(qs), Kl = new eo(qs), Zl = 0; Zl < qs; Zl++) ql[Zl] = 54 ^ Fl[Zl], Kl[Zl] = 92 ^ Fl[Zl];
                return Ml = kl(eo.concat([ql, Ml])), kl(eo.concat([Kl, Ml]));
              }(Sl, gl, jl) : Sl(jl);
              return El = null, wl ? jl.toString(wl) : jl;
            } };
          }
          function ys() {
            var Xs = [].slice.call(arguments).join(" ");
            throw new Error([Xs, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
          }
          Fs.fill(0), ea.createHash = function(Xs) {
            return Do(Xs);
          }, ea.createHmac = Do, ea.randomBytes = function(Xs, gl) {
            if (!gl || !gl.call) return new eo(xs(Xs));
            try {
              gl.call(this, void 0, new eo(xs(Xs)));
            } catch (Sl) {
              gl(Sl);
            }
          };
          var Io, so = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], os = function(Xs) {
            ea[Xs] = function() {
              ys("sorry,", Xs, "is not implemented yet");
            };
          };
          for (Io in so) os(so[Io]);
        }).call(this, Zi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Zi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(Zi, Qi, ea) {
        (function(ra, na, ia, fa, La, Va, to, ro, no) {
          var eo = Zi("./helpers");
          function ao(ys, Io) {
            ys[Io >> 5] |= 128 << Io % 32, ys[14 + (Io + 64 >>> 9 << 4)] = Io;
            for (var so = 1732584193, os = -271733879, Xs = -1732584194, gl = 271733878, Sl = 0; Sl < ys.length; Sl += 16) {
              var El = so, wl = os, jl = Xs, kl = gl, so = xs(so, os, Xs, gl, ys[Sl + 0], 7, -680876936), gl = xs(gl, so, os, Xs, ys[Sl + 1], 12, -389564586), Xs = xs(Xs, gl, so, os, ys[Sl + 2], 17, 606105819), os = xs(os, Xs, gl, so, ys[Sl + 3], 22, -1044525330);
              so = xs(so, os, Xs, gl, ys[Sl + 4], 7, -176418897), gl = xs(gl, so, os, Xs, ys[Sl + 5], 12, 1200080426), Xs = xs(Xs, gl, so, os, ys[Sl + 6], 17, -1473231341), os = xs(os, Xs, gl, so, ys[Sl + 7], 22, -45705983), so = xs(so, os, Xs, gl, ys[Sl + 8], 7, 1770035416), gl = xs(gl, so, os, Xs, ys[Sl + 9], 12, -1958414417), Xs = xs(Xs, gl, so, os, ys[Sl + 10], 17, -42063), os = xs(os, Xs, gl, so, ys[Sl + 11], 22, -1990404162), so = xs(so, os, Xs, gl, ys[Sl + 12], 7, 1804603682), gl = xs(gl, so, os, Xs, ys[Sl + 13], 12, -40341101), Xs = xs(Xs, gl, so, os, ys[Sl + 14], 17, -1502002290), so = Ts(so, os = xs(os, Xs, gl, so, ys[Sl + 15], 22, 1236535329), Xs, gl, ys[Sl + 1], 5, -165796510), gl = Ts(gl, so, os, Xs, ys[Sl + 6], 9, -1069501632), Xs = Ts(Xs, gl, so, os, ys[Sl + 11], 14, 643717713), os = Ts(os, Xs, gl, so, ys[Sl + 0], 20, -373897302), so = Ts(so, os, Xs, gl, ys[Sl + 5], 5, -701558691), gl = Ts(gl, so, os, Xs, ys[Sl + 10], 9, 38016083), Xs = Ts(Xs, gl, so, os, ys[Sl + 15], 14, -660478335), os = Ts(os, Xs, gl, so, ys[Sl + 4], 20, -405537848), so = Ts(so, os, Xs, gl, ys[Sl + 9], 5, 568446438), gl = Ts(gl, so, os, Xs, ys[Sl + 14], 9, -1019803690), Xs = Ts(Xs, gl, so, os, ys[Sl + 3], 14, -187363961), os = Ts(os, Xs, gl, so, ys[Sl + 8], 20, 1163531501), so = Ts(so, os, Xs, gl, ys[Sl + 13], 5, -1444681467), gl = Ts(gl, so, os, Xs, ys[Sl + 2], 9, -51403784), Xs = Ts(Xs, gl, so, os, ys[Sl + 7], 14, 1735328473), so = qs(so, os = Ts(os, Xs, gl, so, ys[Sl + 12], 20, -1926607734), Xs, gl, ys[Sl + 5], 4, -378558), gl = qs(gl, so, os, Xs, ys[Sl + 8], 11, -2022574463), Xs = qs(Xs, gl, so, os, ys[Sl + 11], 16, 1839030562), os = qs(os, Xs, gl, so, ys[Sl + 14], 23, -35309556), so = qs(so, os, Xs, gl, ys[Sl + 1], 4, -1530992060), gl = qs(gl, so, os, Xs, ys[Sl + 4], 11, 1272893353), Xs = qs(Xs, gl, so, os, ys[Sl + 7], 16, -155497632), os = qs(os, Xs, gl, so, ys[Sl + 10], 23, -1094730640), so = qs(so, os, Xs, gl, ys[Sl + 13], 4, 681279174), gl = qs(gl, so, os, Xs, ys[Sl + 0], 11, -358537222), Xs = qs(Xs, gl, so, os, ys[Sl + 3], 16, -722521979), os = qs(os, Xs, gl, so, ys[Sl + 6], 23, 76029189), so = qs(so, os, Xs, gl, ys[Sl + 9], 4, -640364487), gl = qs(gl, so, os, Xs, ys[Sl + 12], 11, -421815835), Xs = qs(Xs, gl, so, os, ys[Sl + 15], 16, 530742520), so = Fs(so, os = qs(os, Xs, gl, so, ys[Sl + 2], 23, -995338651), Xs, gl, ys[Sl + 0], 6, -198630844), gl = Fs(gl, so, os, Xs, ys[Sl + 7], 10, 1126891415), Xs = Fs(Xs, gl, so, os, ys[Sl + 14], 15, -1416354905), os = Fs(os, Xs, gl, so, ys[Sl + 5], 21, -57434055), so = Fs(so, os, Xs, gl, ys[Sl + 12], 6, 1700485571), gl = Fs(gl, so, os, Xs, ys[Sl + 3], 10, -1894986606), Xs = Fs(Xs, gl, so, os, ys[Sl + 10], 15, -1051523), os = Fs(os, Xs, gl, so, ys[Sl + 1], 21, -2054922799), so = Fs(so, os, Xs, gl, ys[Sl + 8], 6, 1873313359), gl = Fs(gl, so, os, Xs, ys[Sl + 15], 10, -30611744), Xs = Fs(Xs, gl, so, os, ys[Sl + 6], 15, -1560198380), os = Fs(os, Xs, gl, so, ys[Sl + 13], 21, 1309151649), so = Fs(so, os, Xs, gl, ys[Sl + 4], 6, -145523070), gl = Fs(gl, so, os, Xs, ys[Sl + 11], 10, -1120210379), Xs = Fs(Xs, gl, so, os, ys[Sl + 2], 15, 718787259), os = Fs(os, Xs, gl, so, ys[Sl + 9], 21, -343485551), so = Do(so, El), os = Do(os, wl), Xs = Do(Xs, jl), gl = Do(gl, kl);
            }
            return Array(so, os, Xs, gl);
          }
          function io(ys, Io, so, os, Xs, gl) {
            return Do((Io = Do(Do(Io, ys), Do(os, gl))) << Xs | Io >>> 32 - Xs, so);
          }
          function xs(ys, Io, so, os, Xs, gl, Sl) {
            return io(Io & so | ~Io & os, ys, Io, Xs, gl, Sl);
          }
          function Ts(ys, Io, so, os, Xs, gl, Sl) {
            return io(Io & os | so & ~os, ys, Io, Xs, gl, Sl);
          }
          function qs(ys, Io, so, os, Xs, gl, Sl) {
            return io(Io ^ so ^ os, ys, Io, Xs, gl, Sl);
          }
          function Fs(ys, Io, so, os, Xs, gl, Sl) {
            return io(so ^ (Io | ~os), ys, Io, Xs, gl, Sl);
          }
          function Do(ys, Io) {
            var so = (65535 & ys) + (65535 & Io);
            return (ys >> 16) + (Io >> 16) + (so >> 16) << 16 | 65535 & so;
          }
          Qi.exports = function(ys) {
            return eo.hash(ys, ao, 16);
          };
        }).call(this, Zi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Zi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(Zi, Qi, ea) {
        (function(ra, na, ia, fa, La, Va, to, ro, no) {
          Qi.exports = function(eo) {
            for (var ao, io = new Array(eo), xs = 0; xs < eo; xs++) (3 & xs) == 0 && (ao = 4294967296 * Math.random()), io[xs] = ao >>> ((3 & xs) << 3) & 255;
            return io;
          };
        }).call(this, Zi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Zi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 8: [function(Zi, Qi, ea) {
        (function(ra, na, ia, fa, La, Va, to, ro, no) {
          var eo = Zi("./helpers");
          function ao(Ts, qs) {
            Ts[qs >> 5] |= 128 << 24 - qs % 32, Ts[15 + (qs + 64 >> 9 << 4)] = qs;
            for (var Fs, Do, ys, Io = Array(80), so = 1732584193, os = -271733879, Xs = -1732584194, gl = 271733878, Sl = -1009589776, El = 0; El < Ts.length; El += 16) {
              for (var wl = so, jl = os, kl = Xs, Fl = gl, Ml = Sl, ql = 0; ql < 80; ql++) {
                Io[ql] = ql < 16 ? Ts[El + ql] : xs(Io[ql - 3] ^ Io[ql - 8] ^ Io[ql - 14] ^ Io[ql - 16], 1);
                var Kl = io(io(xs(so, 5), (Kl = os, Do = Xs, ys = gl, (Fs = ql) < 20 ? Kl & Do | ~Kl & ys : !(Fs < 40) && Fs < 60 ? Kl & Do | Kl & ys | Do & ys : Kl ^ Do ^ ys)), io(io(Sl, Io[ql]), (Fs = ql) < 20 ? 1518500249 : Fs < 40 ? 1859775393 : Fs < 60 ? -1894007588 : -899497514)), Sl = gl, gl = Xs, Xs = xs(os, 30), os = so, so = Kl;
              }
              so = io(so, wl), os = io(os, jl), Xs = io(Xs, kl), gl = io(gl, Fl), Sl = io(Sl, Ml);
            }
            return Array(so, os, Xs, gl, Sl);
          }
          function io(Ts, qs) {
            var Fs = (65535 & Ts) + (65535 & qs);
            return (Ts >> 16) + (qs >> 16) + (Fs >> 16) << 16 | 65535 & Fs;
          }
          function xs(Ts, qs) {
            return Ts << qs | Ts >>> 32 - qs;
          }
          Qi.exports = function(Ts) {
            return eo.hash(Ts, ao, 20, !0);
          };
        }).call(this, Zi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Zi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(Zi, Qi, ea) {
        (function(ra, na, ia, fa, La, Va, to, ro, no) {
          function eo(qs, Fs) {
            var Do = (65535 & qs) + (65535 & Fs);
            return (qs >> 16) + (Fs >> 16) + (Do >> 16) << 16 | 65535 & Do;
          }
          function ao(qs, Fs) {
            var Do, ys = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), Io = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), so = new Array(64);
            qs[Fs >> 5] |= 128 << 24 - Fs % 32, qs[15 + (Fs + 64 >> 9 << 4)] = Fs;
            for (var os, Xs, gl = 0; gl < qs.length; gl += 16) {
              for (var Sl = Io[0], El = Io[1], wl = Io[2], jl = Io[3], kl = Io[4], Fl = Io[5], Ml = Io[6], ql = Io[7], Kl = 0; Kl < 64; Kl++) so[Kl] = Kl < 16 ? qs[Kl + gl] : eo(eo(eo((Xs = so[Kl - 2], xs(Xs, 17) ^ xs(Xs, 19) ^ Ts(Xs, 10)), so[Kl - 7]), (Xs = so[Kl - 15], xs(Xs, 7) ^ xs(Xs, 18) ^ Ts(Xs, 3))), so[Kl - 16]), Do = eo(eo(eo(eo(ql, xs(Xs = kl, 6) ^ xs(Xs, 11) ^ xs(Xs, 25)), kl & Fl ^ ~kl & Ml), ys[Kl]), so[Kl]), os = eo(xs(os = Sl, 2) ^ xs(os, 13) ^ xs(os, 22), Sl & El ^ Sl & wl ^ El & wl), ql = Ml, Ml = Fl, Fl = kl, kl = eo(jl, Do), jl = wl, wl = El, El = Sl, Sl = eo(Do, os);
              Io[0] = eo(Sl, Io[0]), Io[1] = eo(El, Io[1]), Io[2] = eo(wl, Io[2]), Io[3] = eo(jl, Io[3]), Io[4] = eo(kl, Io[4]), Io[5] = eo(Fl, Io[5]), Io[6] = eo(Ml, Io[6]), Io[7] = eo(ql, Io[7]);
            }
            return Io;
          }
          var io = Zi("./helpers"), xs = function(qs, Fs) {
            return qs >>> Fs | qs << 32 - Fs;
          }, Ts = function(qs, Fs) {
            return qs >>> Fs;
          };
          Qi.exports = function(qs) {
            return io.hash(qs, ao, 32, !0);
          };
        }).call(this, Zi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Zi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(Zi, Qi, ea) {
        (function(ra, na, ia, fa, La, Va, to, ro, no) {
          ea.read = function(eo, ao, io, xs, gl) {
            var qs, Fs, Do = 8 * gl - xs - 1, ys = (1 << Do) - 1, Io = ys >> 1, so = -7, os = io ? gl - 1 : 0, Xs = io ? -1 : 1, gl = eo[ao + os];
            for (os += Xs, qs = gl & (1 << -so) - 1, gl >>= -so, so += Do; 0 < so; qs = 256 * qs + eo[ao + os], os += Xs, so -= 8) ;
            for (Fs = qs & (1 << -so) - 1, qs >>= -so, so += xs; 0 < so; Fs = 256 * Fs + eo[ao + os], os += Xs, so -= 8) ;
            if (qs === 0) qs = 1 - Io;
            else {
              if (qs === ys) return Fs ? NaN : 1 / 0 * (gl ? -1 : 1);
              Fs += Math.pow(2, xs), qs -= Io;
            }
            return (gl ? -1 : 1) * Fs * Math.pow(2, qs - xs);
          }, ea.write = function(eo, ao, io, xs, Ts, Sl) {
            var Fs, Do, ys = 8 * Sl - Ts - 1, Io = (1 << ys) - 1, so = Io >> 1, os = Ts === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Xs = xs ? 0 : Sl - 1, gl = xs ? 1 : -1, Sl = ao < 0 || ao === 0 && 1 / ao < 0 ? 1 : 0;
            for (ao = Math.abs(ao), isNaN(ao) || ao === 1 / 0 ? (Do = isNaN(ao) ? 1 : 0, Fs = Io) : (Fs = Math.floor(Math.log(ao) / Math.LN2), ao * (xs = Math.pow(2, -Fs)) < 1 && (Fs--, xs *= 2), 2 <= (ao += 1 <= Fs + so ? os / xs : os * Math.pow(2, 1 - so)) * xs && (Fs++, xs /= 2), Io <= Fs + so ? (Do = 0, Fs = Io) : 1 <= Fs + so ? (Do = (ao * xs - 1) * Math.pow(2, Ts), Fs += so) : (Do = ao * Math.pow(2, so - 1) * Math.pow(2, Ts), Fs = 0)); 8 <= Ts; eo[io + Xs] = 255 & Do, Xs += gl, Do /= 256, Ts -= 8) ;
            for (Fs = Fs << Ts | Do, ys += Ts; 0 < ys; eo[io + Xs] = 255 & Fs, Xs += gl, Fs /= 256, ys -= 8) ;
            eo[io + Xs - gl] |= 128 * Sl;
          };
        }).call(this, Zi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Zi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
      }, { buffer: 3, lYpoI2: 11 }], 11: [function(Zi, Qi, ea) {
        (function(ra, na, ia, fa, La, Va, to, ro, no) {
          var eo, ao, io;
          function xs() {
          }
          (ra = Qi.exports = {}).nextTick = (ao = typeof window < "u" && window.setImmediate, io = typeof window < "u" && window.postMessage && window.addEventListener, ao ? function(Ts) {
            return window.setImmediate(Ts);
          } : io ? (eo = [], window.addEventListener("message", function(Ts) {
            var qs = Ts.source;
            qs !== window && qs !== null || Ts.data !== "process-tick" || (Ts.stopPropagation(), 0 < eo.length && eo.shift()());
          }, !0), function(Ts) {
            eo.push(Ts), window.postMessage("process-tick", "*");
          }) : function(Ts) {
            setTimeout(Ts, 0);
          }), ra.title = "browser", ra.browser = !0, ra.env = {}, ra.argv = [], ra.on = xs, ra.addListener = xs, ra.once = xs, ra.off = xs, ra.removeListener = xs, ra.removeAllListeners = xs, ra.emit = xs, ra.binding = function(Ts) {
            throw new Error("process.binding is not supported");
          }, ra.cwd = function() {
            return "/";
          }, ra.chdir = function(Ts) {
            throw new Error("process.chdir is not supported");
          };
        }).call(this, Zi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, Zi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
      }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
    });
  }(object_hash)), object_hash.exports;
}
var object_hashExports = requireObject_hash();
const hash = /* @__PURE__ */ getDefaultExportFromCjs(object_hashExports), OptionsContainer = ({
  children: Bi,
  showMenu: e
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: `absolute left-0 right-0 z-50 overflow-scroll rounded max-h-40 ${e ? "block" : "hidden"}`,
    children: Bi
  }
);
function SelectionSearch({
  options: Bi,
  onSelect: e,
  displayKey: Zi
}) {
  const [Qi, ea] = useState(!1), ra = useRef(null), na = () => ea(!0), [ia, fa] = useState(""), La = useMemo(() => {
    if (!ia) return Bi;
    const Va = new RegExp(ia, "i");
    return Bi.filter((to) => Zi ? to[Zi].match(Va) : to.match(Va));
  }, [ia, Bi]);
  return vi$1(ra, () => ea(!1)), Si$1(
    {
      Escape: () => ea(!1)
    },
    [ea]
  ), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative", onFocus: na, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Field,
      {
        autoComplete: "off",
        ref: ra,
        type: "text",
        onChange: (Va) => fa(Va.target.value),
        value: ia
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(OptionsContainer, { showMenu: Qi, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      motion.ul,
      {
        className: "flex flex-col w-full h-full p-2 rounded shadow-lg bg-neutral-200",
        layout: !0,
        children: [
          La.length > 0 && La.map((Va) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "hover:text-blue-500", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => {
                e(Va), fa(
                  Zi ? Va[Zi] : Va
                );
              },
              children: Zi ? Va[Zi] : Va
            }
          ) }, hash(Va))),
          Qi && La.length === 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "italic", children: "No Results" })
        ]
      }
    ) })
  ] });
}
function Table({
  row: Bi,
  data: e,
  extras: Zi = [],
  hide: Qi,
  transform: ea,
  editable: ra = !1,
  onEdit: na,
  defaultSortKey: ia,
  className: fa = "",
  render: La,
  renderHeading: Va,
  cell: to
}) {
  const [ro, no] = useState(ia ?? ""), [eo, ao] = useState(
    "desc"
    /* Descending */
  ), [io, xs] = useState({
    key: "",
    newValue: "",
    value: "",
    hashedRow: ""
  }), Ts = useMemo(() => [...e], [e]), qs = useRef(null), Fs = useMemo(() => ro ? Ts.sort((Xs, gl) => {
    const Sl = Xs[ro] ?? "", El = gl[ro] ?? "";
    return Sl < El ? eo === "asc" ? -1 : 1 : Sl > El ? eo === "asc" ? 1 : -1 : 0;
  }) : Ts, [ro, Ts, eo]), Do = useMemo(() => Ts.length === 0 ? [] : Object.getOwnPropertyNames(Ts[0]).reduce(
    (gl, Sl) => {
      if (Qi?.[Sl])
        return gl;
      if (typeof Va == "boolean") {
        if (!Va)
          return [
            ...gl,
            {
              key: Sl,
              transformed: ""
            }
          ];
      } else if (Va?.[Sl])
        return [
          ...gl,
          {
            key: Sl,
            transformed: Va[Sl]()
          }
        ];
      return ea && isTransformMapFn(ea) ? [...gl, { key: Sl, transformed: ea[Sl](Sl) }] : ea && isTransformFnFn(ea) ? [...gl, { key: Sl, transformed: ea(Sl) }] : [
        ...gl,
        ea?.[Sl] ? { key: Sl, transformed: ea[Sl] } : { key: Sl, transformed: Sl }
      ];
    },
    []
  ), [Ts]), ys = useCallback(
    (Xs, gl) => La?.[Xs] ? La[Xs](gl) : Xs === io.key && hash(gl) === io.hashedRow && ra ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "form",
        {
          className: "absolute left-0 right-0 top-0 bottom-0",
          onSubmit: (Sl) => {
            Sl.preventDefault(), na && na({
              column: io.key,
              newValue: io.newValue,
              oldValue: io.value,
              rowData: gl
            }), xs({
              key: "",
              value: "",
              newValue: "",
              hashedRow: ""
            }), qs.current?.blur();
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "textarea",
            {
              className: "w-full h-full",
              onBlur: () => {
                na?.({
                  column: io.key,
                  newValue: io.newValue,
                  oldValue: io.value,
                  rowData: gl
                }), xs({
                  key: "",
                  value: "",
                  newValue: "",
                  hashedRow: ""
                });
              },
              ref: qs,
              autoFocus: !0,
              value: io.newValue,
              onChange: (Sl) => xs({
                key: Xs,
                value: gl[Xs],
                newValue: Sl.target.value,
                hashedRow: hash(gl)
              })
            },
            `${hash(gl)}}-${Xs}-${gl[Xs]}-input`
          )
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "invisible", children: gl[Xs] })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: gl[Xs] }),
    [io, La]
  ), Io = Bi ?? ((Xs) => /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { ...Xs }));
  let so = !0;
  isBoolean(Va) && (Va ? so = !0 : so = !1);
  const os = to ?? "td";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("table", { className: fa, children: [
    so && /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { children: [
      Do.map(
        ({ key: Xs, transformed: gl }) => !Qi?.[Xs] && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "th",
          {
            onClick: () => {
              ro == Xs ? ao(
                () => eo === "asc" ? "desc" : "asc"
                /* Ascending */
              ) : (no(Xs), ao(
                "asc"
                /* Ascending */
              ));
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-start items-center", children: [
              gl,
              Xs === ro && eo === "asc" && /* @__PURE__ */ jsxRuntimeExports.jsx(
                FontAwesomeIcon,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: faChevronUp
                }
              ),
              Xs === ro && eo === "desc" && /* @__PURE__ */ jsxRuntimeExports.jsx(
                FontAwesomeIcon,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: faChevronDown
                }
              )
            ] })
          },
          Xs
        )
      ),
      (Zi || []).map(({ key: Xs }, gl) => /* @__PURE__ */ jsxRuntimeExports.jsx("th", { children: Xs }, `extras-${Xs}-${gl}`))
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: Fs.map(
      (Xs) => Io(
        {
          key: hash(Xs),
          children: Object.entries(Xs).map(([gl, Sl]) => Qi?.[gl] ? null : !Qi?.[gl] && /* @__PURE__ */ jsxRuntimeExports.jsx(
            os,
            {
              title: Sl,
              onClick: () => {
                ra && !La?.[gl] && xs({
                  key: gl,
                  value: Sl,
                  newValue: Sl,
                  hashedRow: hash(Xs)
                });
              },
              children: ys(gl, Xs)
            },
            `${hash(Xs)}}-${gl}-${Sl}`
          ))
        },
        Xs
      )
    ) })
  ] });
}
function isBoolean(Bi) {
  return typeof Bi == "boolean";
}
function isTransformMapFn(Bi) {
  return Object.keys(Bi).length === 0 ? !1 : Object.values(Bi)[0] instanceof Function;
}
function isTransformFnFn(Bi) {
  return Bi instanceof Function;
}
const TabsContext = createContext(
  {}
);
function TabsProvider(Bi) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TabsContext.Provider, { value: Bi.value, children: Bi.children });
}
const useTabsContext = () => useContext(TabsContext);
function TabsList({ items: Bi }) {
  const { activeTab: e, setActiveTab: Zi } = useTabsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex w-full border-black border overflow-x-scroll self-baseline tabs-list overflow-y-hidden", children: Bi.map((Qi) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tab$1,
    {
      label: Qi.label,
      active: e === Qi.value,
      value: Qi.value,
      onClick: (ea) => {
        Zi(ea);
      }
    },
    `tab-${Qi.value}`
  )) });
}
const tabStyle = cva([
  "last:border-none",
  "border-r",
  "flex-shrink-0",
  "border-black",
  "px-4",
  "pb-4",
  "hover:bg-gray-200",
  "whitespace-nowrap",
  "overflow-hidden",
  "text-ellipsis",
  "self-baseline"
], {
  variants: {
    active: {
      true: "bg-black text-white",
      false: "bg-white text-black"
    }
  }
});
function Tab$1(Bi) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "button",
    {
      onClick: () => Bi.onClick(Bi.value),
      className: tabStyle({ active: Bi.active }),
      children: Bi.label
    }
  );
}
function TabContent({
  children: Bi,
  className: e,
  value: Zi
}) {
  const { activeTab: Qi, contentRef: ea } = useTabsContext();
  return Qi !== Zi || !ea ? null : createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `flex flex-col flex-grow h-full w-full ${e || ""} overflow-hidden`, children: Bi }),
    ea
  );
}
const Tabs = ({ children: Bi, defaultValue: e, items: Zi, onChange: Qi }) => {
  const [ea, ra] = useState(e), [na, ia] = useState(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TabsProvider,
    {
      value: {
        activeTab: ea,
        setActiveTab: (fa) => {
          ra(fa), Qi?.(fa);
        },
        contentRef: na
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col tabs h-full overflow-hidden", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TabsList, { items: Zi }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col flex-grow-[2] h-full w-full overflow-hidden", ref: ia, children: Bi })
      ] })
    }
  );
};
Tabs.Tab = TabContent;
const tabStyles = cva([
  "rounded",
  "px-4",
  "py-2",
  "bg-neutral-50",
  "mr-1",
  "hover:bg-neutral-100",
  "hover:text-black",
  "text-neutral-800"
], {
  variants: {
    active: {
      true: ["bg-black", "hover:bg-black", "text-white"],
      false: []
    }
  }
}), Tab = ({ value: Bi, children: e }) => {
  const { activeTab: Zi, setActiveTab: Qi } = useTabsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "button",
    {
      className: tabStyles({ active: Zi === Bi }),
      onClick: () => Qi(Bi),
      children: e
    }
  );
}, TaskQueueLogs = ({
  jobId: Bi,
  className: e = ""
}) => {
  const { data: Zi } = useTaskQueueLogsSubscription({ variables: { jobId: Bi } }), [Qi, ea] = useState([]);
  return useEffect(() => {
    Zi?.taskQueueLogs && ea((ra) => [...ra, Zi.taskQueueLogs]);
  }, [Zi]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: `${e} relative h-full p-4 overflow-y-scroll rounded bg-neutral-200 text-neutral-800`,
      children: Qi.map((ra, na) => /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { children: ra.message }, `task-queue-${Bi}-${ra.timestamp}-${na}`))
    }
  );
}, ThemeContext = createContext({}), useTheme = () => useContext(ThemeContext), useDarkModeState = (Bi = !1) => {
  const [e, Zi] = useState(Bi);
  return useEffect(() => {
    const Qi = localStorage.getItem("darkMode");
    try {
      const ea = JSON.parse(Qi || "");
      Zi(ea.darkMode);
    } catch {
      localStorage.setItem(
        "darkMode",
        JSON.stringify({ darkMode: Bi })
      );
    }
  }, [Zi]), useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify({ darkMode: e }));
  }, [e]), {
    darkMode: !1,
    // disable dark mode for now
    setDarkMode: (Qi) => {
      localStorage.setItem("darkMode", JSON.stringify({ darkMode: !Qi })), Zi(Qi);
    }
  };
}, ThemeProvider = ({ children: Bi }) => {
  const { darkMode: e, setDarkMode: Zi } = useDarkModeState();
  return useEffect(() => {
    const Qi = document.querySelector("body");
    Qi && Qi.classList.remove("dark");
  }, [e]), /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, { value: { darkMode: e, setDarkMode: Zi }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "", children: Bi }) });
}, Title = ({
  order: Bi,
  children: e,
  className: Zi = ""
}) => {
  function Qi(ea, ra) {
    switch (ea) {
      case 1:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: `${Zi} text-2xl text-brand-500`, children: ra });
      case 2:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: `${Zi} text-xl text-brand-600`, children: ra });
      case 3:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: `${Zi} text-brand-800`, children: ra });
      case 4:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { children: ra });
      case 5:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h5", { children: ra });
      default:
      case 6:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h6", { children: ra });
    }
  }
  return Qi(Bi, e);
};
function Toggle({ on: Bi, onChange: e, className: Zi = "" }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    motion.button,
    {
      layout: !0,
      onClick: () => e(!Bi),
      className: `
                w-12 h-4 p-1 items-center ${Zi} flex rounded transition-colors 
                ${Bi ? "justify-end bg-black" : "justify-start bg-neutral-100"}
            `,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.div,
        {
          layout: !0,
          className: `w-4 h-2 rounded-sm transition-colors ${Bi ? "bg-neutral-100" : "bg-neutral-800"}`
        }
      )
    }
  );
}
const Textarea = forwardRef(
  ({ className: Bi, ...e }, Zi) => /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", { ref: Zi, ...e, className: twMerge(
    "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
    Bi
  ) })
);
export {
  AppLayout,
  Button,
  CircleSpinner,
  CopyButton,
  Delete,
  Divider,
  Drawer,
  DrawerButton,
  Dropdown,
  DynamicFormInput,
  Ellipses,
  Error$1 as Error,
  ErrorBoundary,
  Field,
  FileBrowser,
  FileInput,
  FlexBox,
  FormikField,
  GridArea,
  ImagePreview,
  Input,
  Logo,
  Menu,
  MenuItem,
  MenuItemStyle,
  MenuStyle,
  Modal,
  ModalContainer,
  NotFound,
  Page,
  PageHeader,
  PageHeaderTitle,
  Preview,
  Protected,
  ReaderLayout,
  RequireRoles,
  S3DownloadLink,
  S3FileBrowser,
  SVGPreview,
  Select,
  SelectionSearch,
  Spacer,
  Spinner,
  Tab,
  TabContent,
  Table,
  TablePreview,
  Tabs,
  TabsList,
  TaskQueueLogs,
  Textarea,
  ThemeContext,
  ThemeProvider,
  Title,
  Toggle,
  UploadToast,
  fileListToArray,
  pageVariants,
  useModalContext,
  useTailwindBreakpoint,
  useTheme
};
//# sourceMappingURL=components.js.map
